'use strict';

angular.module('app', ['ui.router', 'ui.bootstrap', 'toastr','ngWebSocket','angular-click-outside','dndLists','ngFileUpload','chart.js','ngAnimate','angularjs-dropdown-multiselect','ngclipboard']);

angular.module('app').config(['toastrConfig',function(toastrConfig) {
  angular.extend(toastrConfig, {
    'positionClass': 'toast-top-full-width',
    'timeout':'7000'
  });
}]);

angular.module('app').config(['$qProvider',function ($qProvider) {
    $qProvider.errorOnUnhandledRejections(false);
}]);

angular.module('app').config(['$stateProvider', '$urlRouterProvider',function($stateProvider, $urlRouterProvider) {
  $stateProvider
    .state('home', {
      url: '/:lang/home',
      templateUrl: 'app/modules/users/home.html'
    })
    .state('passwordReset', {
      url: '/:lang/users/passwordReset?email&token',
      templateUrl: 'app/modules/users/passwordReset.html'
    })
    .state('usersUserList', {
      url: '/:lang/users/userList',
      templateUrl: 'app/modules/users/userList.html'
    })
    .state('usersMenuList', {
      url: '/:lang/users/menuList',
      templateUrl: 'app/modules/users/menuList.html'
    })
    .state('paramtablesParamList', {
      url: '/:lang/paramtables/paramList',
      templateUrl: 'app/modules/paramtables/paramList.html'
    })
    .state('paramtablesCombinationList', {
      url: '/:lang/paramtables/combinationList',
      templateUrl: 'app/modules/paramtables/combinationList.html'
    })
    .state('emailsEmailtemplates', {
      url: '/:lang/emails/emailtemplates',
      templateUrl: 'app/modules/emails/emailtemplates.html'
    })
    .state('rulesListRules', {
      url: '/:lang/rules/listRules',
      templateUrl: 'app/modules/rules/listRules.html'
    })
    .state('rulesWeekSchedules', {
      url: '/:lang/rules/weekSchedules',
      templateUrl: 'app/modules/rules/weekSchedules.html'
    })
    .state('activitiesCreateForEmp', {
      url: '/:lang/activities/createForEmp',
      params:{
        lang:null,
        settings:null
      },
      templateUrl: 'app/modules/activities/createForEmp.html'
    })
    .state('activitiesCreateForEmpWithFormSettings', {
      url: '/:lang/activities/createForEmp/:settings',
      templateUrl: 'app/modules/activities/createForEmp.html'
    })
    .state('activitiesCreateForHotton', {
      url: '/:lang/activities/createForHotton',
      templateUrl: 'app/modules/activities/createForHotton.html'
    })
    .state('activitiesCreateForTakeAway', {
      url: '/:lang/activities/createForTakeAway',
      templateUrl: 'app/modules/activities/createForTakeAway.html'
    })
    .state('activitiesCreateForGreenfields', {
      url: '/:lang/activities/createForGreenfields',
      templateUrl: 'app/modules/activities/createForGreenfields.html'
    })
    .state('activitiesCreateForLabyrinthe', {
      url: '/:lang/activities/createForLabyrinthe',
      templateUrl: 'app/modules/activities/createForLabyrinthe.html'
    })
    .state('activitiesRetrieveForEmp', {
      url: '/:lang/activities/retrieveForEmp/:id',
      params: {
        lang:null,
        id:null,
        settings:null
      },
      templateUrl: 'app/modules/activities/retrieveForEmp.html'
    })
    .state('accountingIncome', {
      url: '/:lang/accounting/income',
      templateUrl: 'app/modules/accounting/income.html'
    })
    .state('accountingDayIncome', {
      url: '/:lang/accounting/dayIncome',
      templateUrl: 'app/modules/accounting/dayIncome.html'
    })
    .state('accountingListPainfiles', {
      url: '/:lang/accounting/listPainfiles',
      templateUrl: 'app/modules/accounting/listPainfiles.html'
    })
    .state('activitiesAgenda', {
      url: '/:lang/activities/agenda',
      params: {
        lang: null,
        settings: null
      },
      settings: {
        acts: {
          labelen: 'Activities',
          labelnl: 'Activiteiten',
          labelfr: 'Activités',
          type:'paramArray',
          paramTbl: 'ACT',
          paramFilter: {'field4':'1'}
        }
      },
      templateUrl: 'app/modules/activities/agenda.html'
    })
    .state('activitiesActivityOverview', {
      url: '/:lang/activities/activityOverview',
      templateUrl: 'app/modules/activities/activityOverview.html'
    })
    .state('activitiesReservations', {
      url: '/:lang/activities/reservations',
      templateUrl: 'app/modules/activities/reservations.html'
    })
    // .state('activitiesCreateForPtn', {
    //   url: '/:lang/activities/createForPtn',
    //   templateUrl: 'app/modules/activities/createForPtn.html'
    // })
    .state('accountingBalances', {
      url: '/:lang/accounting/balances',
      templateUrl: 'app/modules/accounting/balances.html'
    })
    .state('accountingCashManagement', {
      url: '/:lang/accounting/cashManagement',
      templateUrl: 'app/modules/accounting/cashManagement.html'
    })
    .state('mealsAgenda', {
      url: '/:lang/meals/agenda',
      templateUrl: 'app/modules/meals/agenda.html'
    })
    .state('mealsTakeAway', {
      url: '/:lang/meals/takeAway',
      templateUrl: 'app/modules/meals/takeAway.html'
    })
    .state('accountingRefund', {
      url: '/:lang/accounting/refund',
      templateUrl: 'app/modules/accounting/refund.html'
    })
    .state('barBar', {
      url: '/:lang/bar/bar',
      templateUrl: 'app/modules/bar/bar.html'
    })
    .state('pricesPromotions', {
      url: '/:lang/prices/promotions',
      templateUrl: 'app/modules/prices/promotions.html'
    })
    .state('settingsShopForm', {
      url: '/:lang/settings/shopForm',
      templateUrl: 'app/modules/settings/shopForm.html'
    })
    .state('settingsCampaigns', {
      url: '/:lang/settings/campaigns',
      templateUrl: 'app/modules/settings/campaigns.html'
    })
    .state('settingsParams', {
      url: '/:lang/settings/params',
      templateUrl: 'app/modules/settings/params.html'
    })
    .state('accountingAchievements', {
      url: '/:lang/accounting/achievements',
      templateUrl: 'app/modules/accounting/achievements.html'
    })
    .state('accountingTaxcomponents', {
      url: '/:lang/accounting/taxcomponents',
      templateUrl: 'app/modules/accounting/taxcomponents.html'
    })
    .state('accountingDownPayments', {
      url: '/:lang/accounting/downPayments',
      templateUrl: 'app/modules/accounting/downPayments.html'
    })
    .state('emailsMarketingEmails', {
      url: '/:lang/emails/marketingEmails',
      templateUrl: 'app/modules/emails/marketingEmails.html'
    })
    .state('settingsListRules', {
      url: '/:lang/settings/listRules',
      templateUrl: 'app/modules/settings/listRules.html'
    })
    .state('activitiesStatistics', {
      url: '/:lang/activities/statistics',
      templateUrl: 'app/modules/activities/statistics.html'
    })
    .state('activitiesSearchReference', {
      url: '/:lang/activities/searchReference',
      templateUrl: 'app/modules/activities/searchReference.html'
    })
    .state('activitiesSearchReferenceWithReference', {
      url: '/:lang/activities/searchReference/:searchElement',
      templateUrl: 'app/modules/activities/searchReference.html'
    })
    .state('usersEmployeeCommunications', {
      url: '/:lang/users/employeeCommunications',
      templateUrl: 'app/modules/users/employeeCommunications.html'
    })
    .state('activitiesRoomOverview', {
      url: '/:lang/activities/roomOverview',
      params: {
        lang: null,
        settings: null
      },
      settings: {
        acts: {
          labelen: 'Room Type(s)',
          labelnl: 'Kamer Type(s)',
          labelfr: 'Type de Chambre(s)',
          type:'paramArray',
          paramTbl: 'ACT',
          paramFilter: {'field2':'1'}
        }
      },
      templateUrl: 'app/modules/activities/roomOverview.html'
    })
    .state('marketingEditTemplate', {
      url: '/:lang/marketing/editTemplate/:id',
      templateUrl: 'app/modules/marketing/editTemplate.html'
    })
    .state('marketingListTemplates', {
      url: '/:lang/marketing/listTemplates',
      templateUrl: 'app/modules/marketing/listTemplates.html'
    })
    .state('settingsPackets', {
      url: '/:lang/settings/packets',
      templateUrl: 'app/modules/settings/packets.html'
    })
    .state('exactLogin', {
      url: '/:lang/exact/login',
      templateUrl: 'app/modules/exact/login.html'
    })
     .state('testTest', {
       url: '/:lang/test/test',
       templateUrl: 'app/modules/test/test.html'
    })
     .state('vouchersVoucherList', {
       url: '/:lang/vouchers/voucherList',
       templateUrl: 'app/modules/vouchers/voucherList.html'
    })
     .state('accountingInvoices', {
       url: '/:lang/accounting/invoices',
       templateUrl: 'app/modules/accounting/invoices.html'
    })
     .state('hotelsMewsMessages', {
       url: '/:lang/hotels/mewsMessages',
       templateUrl: 'app/modules/hotels/mewsMessages.html'
    })
     .state('settingsFormbuttonList', {
       url: '/:lang/settings/formbuttonList',
       templateUrl: 'app/modules/settings/formbuttonList.html'
    })
     .state('settingsEditFormbutton', {
       url: '/:lang/settings/editFormbutton/:id',
       templateUrl: 'app/modules/settings/editFormbutton.html'
    })
     .state('accountingInvoicesList', {
       url: '/:lang/accounting/invoicesList',
       templateUrl: 'app/modules/accounting/invoicesList.html'
    })
     .state('activitiesPasserelle', {
       url: '/:lang/activities/passerelle',
       templateUrl: 'app/modules/activities/passerelle.html'
    })
    .state('activitiesSearchWithSearchElement', {
      url: '/:lang/activities/search/:searchElement',
      templateUrl: 'app/modules/activities/search.html'
    })
    .state('activitiesSearch', {
      url: '/:lang/activities/search',
      templateUrl: 'app/modules/activities/search.html'
    })
    .state('activitiesListVisit', {
      url: '/:lang/activities/listVisit',
      templateUrl: 'app/modules/activities/listVisit.html'
    })
    .state('quotationsCreateQuotation', {
      url: '/:lang/quotations/createQuotation',
      params: {
        lang: null,
        settings: null
      },
      settings: {
        vis: {
          labelen: 'Visit origin',
          labelnl: 'Bezoek oorsprong',
          labelfr: 'Origine de visite',
          type:'param',
          paramTbl: 'VIS'
        }
      },
      templateUrl: 'app/modules/quotations/createQuotation.html'
    })
    .state('quotationsListQuotations', {
      url: '/:lang/quotations/listQuotations',
      templateUrl: 'app/modules/quotations/listQuotations.html'
    })
    .state('operationsListManagers', {
      url: '/:lang/quotations/listOperationsManagers',
      templateUrl: 'app/modules/quotations/listOperationsManagers.html'
    })
    .state('invoicesListManagers', {
      url: '/:lang/quotations/listInvoicesManagers',
      templateUrl: 'app/modules/quotations/listInvoicesManagers.html'
    })
    .state('agendaReservations', {
      url: '/:lang/agenda/reservations',
      templateUrl: 'app/modules/agenda/reservations.html'
    })
    .state('hotelsMewsTest', {
      url: '/:lang/hotels/mewsTest',
      templateUrl: 'app/modules/hotels/mewsTest.html'
    })
    .state('hotelsTimeline', {
      url: '/:lang/hotels/timeline',
      params: {
        lang: null,
        settings: null
      },
      settings: {
        htl: {
          labelen: 'Hotel',
          labelnl: 'Hotel',
          labelfr: 'Hotel',
          type:'param',
          paramTbl: 'HTL'
        }
      },
      templateUrl: 'app/modules/hotels/timeline.html'
    })
    .state('mealsUpdates', {
      url: '/:lang/meals/updates',
      templateUrl: 'app/modules/meals/updates.html'
    })
    .state('quotationsSoldOverview', {
      url: '/:lang/quotations/soldOverview',
      templateUrl: 'app/modules/quotations/soldOverview.html'
    })
    .state('accountingMovementOverview', {
      url: '/:lang/accounting/movementOverview',
      templateUrl: 'app/modules/accounting/movementOverview.html'
    })
    .state('accountingKiosk', {
      url: '/:lang/accounting/kiosk',
      templateUrl: 'app/modules/accounting/kiosk.html'
    })
    .state('hotelsCombinations', {
      url: '/:lang/hotels/combinations',
      templateUrl: 'app/modules/hotels/combinations.html'
    })
    .state('settingsConsolidation', {
      url: '/:lang/settings/consolidation',
      templateUrl: 'app/modules/settings/consolidation.html'
    })
    .state('settingsConsolidationRights', {
      url: '/:lang/settings/consolidationRights',
      templateUrl: 'app/modules/settings/consolidationRights.html'
    })
    .state('accountingConsolidation', {
      url: '/:lang/accounting/consolidation',
      templateUrl: 'app/modules/accounting/consolidation.html'
    })
    .state('rfidRetrieveVisit', {
      url: '/:lang/rfid/retrieveVisit/:id/:page',
      templateUrl: 'app/modules/rfid/retrieveVisit.html'
    })
    .state('hotelsLobby', {
      url: '/:lang/hotels/lobby',
      params: {
        lang: null,
        settings: null
      },
      settings: {
        htl: {
          labelen: 'Hotel',
          labelnl: 'Hotel',
          labelfr: 'Hotel',
          type:'param',
          paramTbl: 'HTL'
        }
      },
      templateUrl: 'app/modules/hotels/lobby.html'
    })
    .state('contactsRetrieve', {
      url: '/:lang/contacts/retrieve/:id',
      templateUrl: 'app/modules/contacts/retrieve.html'
    })
    .state('marketingCampaignOverview', {
      url: '/:lang/marketing/campaignOverview',
      templateUrl: 'app/modules/marketing/campaignOverview.html'
    })
    .state('accountingIntercompanyList', {
      url: '/:lang/accounting/intercompanyList',
      templateUrl: 'app/modules/accounting/intercompanyList.html'
    })
    .state('restaurantUntillTest', {
      url: '/:lang/restaurant/untillTest',
      templateUrl: 'app/modules/restaurant/untillTest.html'
    })
    .state('adminListTransactions', {
      url: '/:lang/admin/listTransactions',
      templateUrl: 'app/modules/admin/listTransactions.html'
    })
    .state('adminSyncIntegrations', {
      url: '/:lang/admin/syncIntegrations',
      templateUrl: 'app/modules/admin/syncIntegrations.html'
    })
    .state('reportingBigcAccounting', {
      url: '/:lang/reporting/bigcAccounting',
      templateUrl: 'app/modules/reporting/bigcAccounting.html'
    })
    .state('reportingVisitorsReport', {
      url: '/:lang/reporting/visitorsReport',
      templateUrl: 'app/modules/reporting/visitorsReport.html'
    })
    .state('marketingToolsConfiguration', {
      url: '/:lang/marketing/toolsConfiguration',
      templateUrl: 'app/modules/marketing/toolsConfiguration.html'
    })
    .state('hotelsSplitBill', {
      url: '/:lang/hotels/splitBill/:id',
      templateUrl: 'app/modules/hotels/splitBill/splitBill.html'
    })
    .state('accountingIntegrationAdfinityErrors', {
      url: '/:lang/accountingIntegration/adfinity/errors',
      templateUrl: 'app/modules/accountingIntegration/adfinity/errors.html'
    })
    ;

  $urlRouterProvider.otherwise('/nl/home');
}]);

angular.module("app").controller("HotelsSplitBillSplitModalController",["$scope","tools","accountingService","errorlog","$uibModalInstance","model","visitElements","items",
                                                                function($scope,tools,accountingService,errorlog,$uibModalInstance,model,visitElements,items) {
  $scope.tools=tools;
  $scope.accountingService=accountingService;
  $scope.model=model;
  $scope.items=items;

  $scope.init = function() {
    var modes=[
      {'modelVar':'splitDistributionQuantity','itemProperty':'quantity'},
      {'modelVar':'splitDistributionNettopay','itemProperty':'nettopay'}
    ];
    for(var i in modes){
      $scope[modes[i].modelVar]=$scope.items.reduce(function(splitDistribution,item) {
        splitDistribution[item.id]=Math.min(1,item[modes[i].itemProperty]);
        return splitDistribution;
      },{});
    }
  };

  $scope.split = function(mode) {
    var splitDistribution=(mode==='quantity'?$scope.splitDistributionQuantity:$scope.splitDistributionNettopay);
    var sums=items.reduce(function(sums,item) {
      sums.right+=Math.abs(splitDistribution[item.id]);
      sums.left+=Math.abs(item[mode]-splitDistribution[item.id]);
      return sums;
    },{'left':0,'right':0});
    if(sums.right==0) {
      errorlog.error(tools.lang({'en':'Right column can not be zero','nl':'Rechterkolom mag niet nul zijn','fr':"Colonne droite ne peux pas etre zero"}));
    } else if(sums.left==0) {
      errorlog.error(tools.lang({'en':'Left column can not be zero','nl':'Linkerkolom mag niet nul zijn','fr':"Colonne gauche ne peux pas etre zero"}));
    } else {
      $uibModalInstance.close({
        'visitElements':visitElements,
        'mode':mode,
        'distribution':splitDistribution
      });
    }
  };

  $scope.cancel = function() {
    $uibModalInstance.dismiss();
  };

  $scope.init();
  
}]);
angular.module("app").controller("HotelsSplitBillController",["$scope","$stateParams","$uibModal","tools","modelstore","webservice","parameters","contactsService","splitBillService",
                                                                function($scope,$stateParams,$uibModal,tools,modelstore,webservice,parameters,contactsService,splitBillService) {
  var script='hotels/splitBill/splitBill';
  var model=modelstore.getModel(script);
  $scope.model=model;
  $scope.contactsService=contactsService;
  $scope.dummyVisitrelation={'isDummy':true};
  $scope.dummyHotelspaceassignment={'isDummy':true};
  $scope.clickStack=[];

  $scope.load = function() {
    modelstore.cleanModel(["contacts","visits","activities","participants","meals","dishes","products","hotelreservationcategories","hotelreservationproducts","hotelrates","hotelspaceassignments","hotelspaces","items",'movements','visitrelations'],model);
    var visitId=$stateParams.id.replace(/[^0-9]/g,"");
    var result=webservice.exclusiveCall("load",{"visitId":visitId},script,model).then(function() {
      var i,visitrelation;
      for(i in model.visitrelations) {
        visitrelation=model.visitrelations[i];
        visitrelation.isDummy=false;
        visitrelation.showCreateVisitrelation=false;
      }
      if(visitId in model.visits) {
        model.visit=model.visits[visitId];
      }
    });
  };

  $scope.getChildHeading = function(childVisit,hotelspace) {
    var result="";
    if(angular.isDefined(hotelspace) && hotelspace!==null) {
      result=parameters.HSC[hotelspace.hsc].field5+' '+hotelspace.spacenumber+' ';
    }
    if(angular.isDefined(childVisit) && childVisit!==null) {
      result+=contactsService.getName(model.contacts[childVisit.owningcontact]);
    }
    return result;
  };

  $scope.selectVisitrelation = function(event,visitrelation) {
    if(angular.isUndefined(visitrelation.isDummy) || !visitrelation.isDummy) {
      if(event.ctrlKey) {
        if(visitrelation.selected) {
          delete visitrelation.selected;
          var stackIndex=$scope.clickStack.indexOf(visitrelation);
          if(stackIndex>-1) {
            $scope.clickStack.splice(stackIndex,1);
          }
        } else {
          visitrelation.selected=true;
          $scope.clickStack.unshift(visitrelation);
        }
      } else if(event.shiftKey && $scope.clickStack.length>0) {
        var clickedCompareString=visitrelation.id;
        var previousCompareString=$scope.clickStack[0].id;
        var ascending=clickedCompareString>previousCompareString;
        var minCompareString=ascending?previousCompareString:clickedCompareString;
        var maxCompareString=ascending?clickedCompareString:previousCompareString;
        angular.forEach(tools.match(model.visitrelations,{'hotelspace':visitrelation.hotelspace}),function(visitrelation) {
          var compareString=visitrelation.id;
          if(compareString>minCompareString && compareString<maxCompareString) {
            visitrelation.selected=true;
          }
        });
        visitrelation.selected=true;
        $scope.clickStack.unshift(visitrelation);
      } else {
        var selectedVisitrelations=tools.match(model.visitrelations,{'selected':true});
        var becomesSelected=!(visitrelation.selected && selectedVisitrelations.length===1);
        angular.forEach(selectedVisitrelations,function(visitrelation) {
          delete visitrelation.selected;
        });
        $scope.clickStack=[];
        if(becomesSelected) {
          visitrelation.selected=true;
          $scope.clickStack.unshift(visitrelation);
        }
      }
      $scope.clearOtherVisitrelationSelection(visitrelation.hotelspace);
    }
  };

  $scope.clearOtherVisitrelationSelection = function(hotelspaceId) {
    var selectedVisitrelations=tools.match(tools.exclude(model.visitrelations,{'hotelspace':hotelspaceId,'selected':true}),{'selected':true});
    angular.forEach(selectedVisitrelations,function(visitrelation) {
      delete visitrelation.selected;
    });
  }

  $scope.transferItems = function(originatingVisit,targetVisit,hotelspaceassignment,visitElements) {
    var callPromise;
    if(angular.isDefined(targetVisit) && targetVisit!==null) {
      callPromise=webservice.call("transferItems",{
        'originatingVisitId':originatingVisit.id,
        'targetVisitId':targetVisit.id,
        'visitElements':visitElements
      },script,model);
    } else {
      callPromise=$uibModal.open({
        'templateUrl': 'app/modules/hotels/splitBill/contactModal.html',
        'controller': 'HotelsSplitBillContactModalController',
        'backdrop':'static',
        'windowClass':'app-modal-window-wide',
        'resolve': {
          'owningContact': function() {
            return model.contacts[originatingVisit.owningcontact];
          },
          'communicationContact': function() {
            return model.contacts[originatingVisit.communicationcontact];
          }
        }
      }).result.then(function(contactModalResult) {
        var wsParams={
          'parentVisitId':model.visit.id,
          'originatingVisitId':originatingVisit.id,
          'owningContact':contactModalResult.owningContact,
          'visitElements':visitElements
        };
        if(angular.isDefined(hotelspaceassignment)) {
          wsParams.hotelspaceassignmentId=hotelspaceassignment.id;
        }
        if(!contactModalResult.communicationContact.dummy) {
          wsParams.communicationContact=contactModalResult.communicationContact;
        }
        return webservice.call("createHotelspaceassignmentVisitAndTransferItems",wsParams,script,model);
      });
    }
    callPromise.then($scope.load);
  };

  $scope.$on('emitClearOtherVisitElementSelection',function(event,visitId) {
    $scope.$broadcast('broadcastClearOtherVisitElementSelection',visitId);
  });

  $scope.updateHotelspaceassignmentVisit = function(visitrelation,hotelspaceassignment) {
    var visitrelations;
    if(visitrelation.selected) {
      visitrelations=tools.match(model.visitrelations,{'hotelspace':visitrelation.hotelspace,'selected':true});
    } else {
      visitrelations=[visitrelation];
    }
    angular.forEach(visitrelations,function(visitrelation) {
      delete visitrelation.selected;
    });
    var wsParams={'visitrelationIds':visitrelations.map(tools.mapColumnFunction('id'))};
    if(angular.isDefined(hotelspaceassignment)) {
      wsParams.targetHotelspaceassignmentId=hotelspaceassignment.id;
    }
    webservice.exclusiveCall("updateHotelspaceassignmentVisitrelations",wsParams,script,model).then($scope.load);
  }

  $scope.deleteVisitrelation = function(visitrelation) {
    webservice.exclusiveCall("deleteVisitrelation",{'visitrelationId':visitrelation.id},script,model).then($scope.load);
  }

  $scope.onDragOver = function(index,external,type,hotelspace) {
    var result=true;
    if(type==='visitelement' && !external) {
      if(!hotelspace.showCreateVisitrelation) {
        hotelspace.showCreateVisitrelation=true;
        $scope.$apply();
      }
      result=false;
    } else if(type==='visitrelation' && !external) {
      result=tools.getLength(tools.match(model.hotelspaceassignments,{'assignedspace':hotelspace.id}))>0;
    }
    return result;
  }

  $scope.splitVisitElement = function(visitElement) {
    $uibModal.open({
      'templateUrl': 'app/modules/hotels/splitBill/splitModal.html',
      'controller': 'HotelsSplitBillSplitModalController',
      'backdrop':'static',
      'windowClass':'app-modal-window-wide',
      'resolve': {
        'model': function() {
          return model;
        },
        'visitElements': function() {
          var visitElements={};
          visitElements[visitElement.collection]=[visitElement.id];
          return visitElements;
        },
        'items': function() {
          return splitBillService.getVisitElementItems(visitElement,model);
        }
      }
    }).result.then(function(splitModalResult) {
      return webservice.call("splitVisitElement",splitModalResult,script,model).then($scope.load);
    });

  };

  webservice.afterLogin().then(function() {
    $scope.load();
  });
}]);

var splitBillService=function(tools) {
  this.tools=tools;
};

splitBillService.prototype.getVisitElementItems = function(visitElement,model) {
  var tools=this.tools;
  var items;
  switch(visitElement.collection) {
    case 'activities':
      items=tools.inverseJoin(tools.join(visitElement,'participants',model),'items','item',model);
      break;
    case 'meals':
      items=tools.inverseJoin(tools.join(visitElement,'dishes',model),'items','item',model);
      break;
    case 'hotelreservationcategories':
      items=[model.items[visitElement.item]];
      items=items.concat(tools.inverseJoin(tools.join(visitElement,'hotelreservationproducts',model),'items','item',model));
      break;
    case 'products':
      items=[model.items[visitElement.item]];
      break;
  }
  return tools.exclude(items,{'quantity':0});
};

angular.module("app").service("splitBillService",["tools",splitBillService]);

angular.module("app").component('splitBillItemsComponent',{
  templateUrl: 'app/modules/hotels/splitBill/itemsComponent.html',
  bindings: {
    visit:'<',
    hotelspaceassignment:'<',
    model:'<',
    transferItems:'<',
    splitVisitElement:'<'
  },
  controller:function($scope,$uibModal,tools,parameters,accountingService,webservice,splitBillService) {
    var ctrl=this;
    var script='hotels/splitBill';
    ctrl.tools=tools;
    ctrl.parameters=parameters;
    ctrl.accountingService=accountingService;
    ctrl.splitBillService=splitBillService;
    ctrl.clickStack=[];
    ctrl.ignoreNextSelect=false;

    ctrl.getVisitElements = function(visit) {
      visit=angular.isDefined(visit)?visit:ctrl.visit;
      if(angular.isDefined(visit) && visit!==null) {
        var activities=tools.join(visit,'activities',ctrl.model);
        var meals=tools.join(visit,'meals',ctrl.model);
        var hotelreservationcategories=tools.join(visit,'hotelreservationcategories',ctrl.model);
        var products=tools.join(visit,'products',ctrl.model);
        var visitElements=activities.concat(meals).concat(hotelreservationcategories).concat(products);
        if(visitElements.length>0 && !('collection' in visitElements[0])) {
          angular.forEach(activities,function(activity) {
            activity.collection='activities';
          });
          angular.forEach(meals,function(meal) {
            meal.collection='meals';
          });
          angular.forEach(hotelreservationcategories,function(hotelreservationcategory) {
            hotelreservationcategory.collection='hotelreservationcategories';
          });
          angular.forEach(products,function(product) {
            product.collection='products';
          });
          visitElements=activities.concat(meals).concat(hotelreservationcategories).concat(products);
        }
        return Object.values(visitElements.filter(function(record) {
          return splitBillService.getVisitElementItems(record,ctrl.model).length>0;
        }));
      } else {
        return [];
      }
    };

    ctrl.getItemCompareString = function(item) {
      return accountingService.getItemCompareString(item,ctrl.model);
    };

    ctrl.getVisitElementCompareString = function(visitElement) {
      return ctrl.getItemCompareString(splitBillService.getVisitElementItems(visitElement,ctrl.model)[0]);
    };

    ctrl.selectVisitElement = function(event,visitElement) {
      if(ctrl.ignoreNextSelect) {
        ctrl.ignoreNextSelect=false;
      } else {
        if(event.ctrlKey) {
          if(visitElement.selected) {
            delete visitElement.selected;
            var stackIndex=ctrl.clickStack.indexOf(visitElement);
            if(stackIndex>-1) {
              ctrl.clickStack.splice(stackIndex,1);
            }
          } else {
            visitElement.selected=true;
            ctrl.clickStack.unshift(visitElement);
          }
        } else if(event.shiftKey && ctrl.clickStack.length>0) {
          var clickedCompareString=ctrl.getVisitElementCompareString(visitElement);
          var previousCompareString=ctrl.getVisitElementCompareString(ctrl.clickStack[0]);
          var ascending=clickedCompareString>previousCompareString;
          var minCompareString=ascending?previousCompareString:clickedCompareString;
          var maxCompareString=ascending?clickedCompareString:previousCompareString;
          angular.forEach(ctrl.getVisitElements(),function(visitElementb) {
            var compareString=ctrl.getVisitElementCompareString(visitElementb);
            if(compareString>minCompareString && compareString<maxCompareString) {
              visitElementb.selected=true;
            }
          });
          visitElement.selected=true;
          ctrl.clickStack.unshift(visitElement);
        } else {
          var selectedVisitElements=tools.match(ctrl.getVisitElements(),{'selected':true});
          var becomesSelected=!(visitElement.selected && selectedVisitElements.length===1);
          angular.forEach(selectedVisitElements,function(visitElement) {
            delete visitElement.selected;
          });
          ctrl.clickStack=[];
          if(becomesSelected) {
            visitElement.selected=true;
            ctrl.clickStack.unshift(visitElement);
          }
        }
        $scope.$emit('emitClearOtherVisitElementSelection',ctrl.visit.id);
      }
    };

    $scope.$on('broadcastClearOtherVisitElementSelection',function(event,visitId) {
      if(angular.isDefined(ctrl.visit) && ctrl.visit!==null && visitId!==ctrl.visit.id) {
        var selectedVisitElements=tools.match(ctrl.getVisitElements(),{'selected':true});
        angular.forEach(selectedVisitElements,function(visitElement) {
          delete visitElement.selected;
        });
      }
    });

    ctrl.drop = function(visitElement) {
      var originatingVisit=ctrl.model.visits[visitElement.visit];
      var visitElements;
      if(visitElement.selected) {
        visitElements=tools.match(ctrl.getVisitElements(originatingVisit),{'selected':true});
      } else {
        visitElements=[visitElement];
      }
      angular.forEach(visitElements,function(visitElementb) {
        delete visitElementb.selected;
      });
      var mapIdFunction=tools.mapColumnFunction('id');
      ctrl.transferItems(originatingVisit,ctrl.visit,ctrl.hotelspaceassignment,{
        'activities':tools.match(visitElements,{'collection':'activities'}).map(mapIdFunction),
        'meals':tools.match(visitElements,{'collection':'meals'}).map(mapIdFunction),
        'hotelreservationcategories':tools.match(visitElements,{'collection':'hotelreservationcategories'}).map(mapIdFunction),
        'products':tools.match(visitElements,{'collection':'products'}).map(mapIdFunction)
      });
    };

    ctrl.splitVisitElementInItemsComponent = function(visitElement) {
      ctrl.ignoreNextSelect=true;
      ctrl.splitVisitElement(visitElement);
    };
  }
});
angular.module("app").controller("HotelsSplitBillContactModalController",["$scope","tools","contactsService","$uibModalInstance","owningContact","communicationContact",
                                                                function($scope,tools,contactsService,$uibModalInstance,owningContact,communicationContact) {
  $scope.tools=tools;
  var model={};
  $scope.model=model;

  $scope.init = function() {
    model.task='c';
    contactsService.initContacts(model,owningContact,communicationContact);
  };

  $scope.ok = function() {
    $uibModalInstance.close({
      "owningContact":model.owningContact,
      "communicationContact":model.communicationContact
    });
  };

  $scope.cancel = function() {
    $uibModalInstance.dismiss();
  };

  $scope.init();
  
}]);
angular.module("app").controller("AccountingIntegrationAdfinityErrorsController",["$scope","$sce","tools","errorlog","config","modelstore","parameters","webservice",
                                            function($scope,$sce,tools,errorlog,config,modelstore,parameters,webservice) {
  var script='accountingIntegration/adfinity/errors';
  var model=modelstore.getModel(script);
  $scope.model=model;
  $scope.errorMessage=null;

  $scope.load = function(scrollId) {
    $scope.errorMessage=null;
    var collections=["visits","invoices","movements","exactentries","exactmatchsets","exactmessages","exactbankentries","exactdeletes","intercompanies"];
    modelstore.cleanModel(collections,model);
    webservice.exclusiveCall("load",{},script,model).then(function() {
      var i,exactmessage,postContent,scrollParams,collection,collectionName,collectionId;
      for(i in model.exactmessages) {
        exactmessage=model.exactmessages[i];
        postContent=angular.fromJson(exactmessage.post).Content;
        if(postContent.Action.toLowerCase()=="delete") {
          model.exactdeletes[exactmessage.id]=exactmessage;
        } else if(postContent.Topic=="BankEntries") {
          model.exactbankentries[exactmessage.id]=exactmessage;
        }
      }
      if(angular.isDefined(scrollId)) {
        scrollParams=scrollId.split('_');
        collectionName=scrollParams[0];
        collectionId=tools.getLength(scrollParams)>1?scrollParams[1]:0;
        if(!(collectionName in model) && collectionId===0) {
          $scope.scrollTo(scrollId);
        } else {
          for(i=collections.indexOf(collectionName);i<tools.getLength(collections);i++) {
            collection=collections[i];
            if(collection in model && tools.getLength(model[collection])>0) {
              $scope.scrollTo(collection+(collectionName!==collection?'':'_'+Math.min(collectionId,tools.getLength(model[collection])-1)));
              break;
            }
          }
        }
      } else {
        $scope.scrollTo(null);
      }
    }).catch(function() {
      $scope.errorMessage=model.lastError;
    });
  };

  $scope.findIndexFromId = function(collection,id,sortBy) {
    return tools.orderBy(tools.toArray(collection),sortBy).findIndex(function(element) {
      return element.id===id;
    })
  }

  $scope.getErroneousInvoices = function() {
    return tools.match(model.invoices,{'exported':'0'});
  };

  $scope.getErroneousExactentries = function() {
    return tools.match(model.exactentries,{'externalid':''});
  };

  $scope.getErroneousIntercompanies = function() {
    return tools.match(model.intercompanies,{'salesexactnumber':''});
  };

  $scope.retryInvoice = function(invoice) {
    webservice.exclusiveCall("retryInvoice",{'invoiceId':invoice.id},script,model).then(function() {
      $scope.load('invoices_'+$scope.findIndexFromId(model.invoices,invoice.id,'created'));
    });
  };

  $scope.resetInvoice = function(invoiceId) {
    webservice.exclusiveCall("resetInvoice",{'invoiceId':invoiceId},script,model).then(function() {
      var invoiceId=model.invoiceId.replace(/[^0-9]/mg,'');
      if(angular.isDefined(model.invoices) && angular.isDefined(model.invoices[invoiceId]) && model.invoices[invoiceId].errorwording!=='') {
        $scope.errorMessage=model.invoices[invoiceId].errorwording;
        errorlog.error(tools.lang({'en':'Error: ','nl':'Fout: ','fr':'Erreur : '})+$scope.errorMessage);
        modelstore.removeRecord("invoices",invoiceId,model);
        $scope.scrollTo('resetInvoice');
      } else {
        model.invoiceId='';
        $scope.load('resetInvoice');
      }
    });
  };

  $scope.retryMovements = function(movement) {
    webservice.exclusiveCall("retryMovements",{'date':movement.created.substr(0,10)},script,model).then(function() {
      $scope.load('movements_'+$scope.findIndexFromId(model.movements,movement.id,'created'));
    });
  };

  $scope.retryExactentry = function(exactentry) {
    webservice.exclusiveCall("retryExactentry",{'exactentryId':exactentry.id},script,model).then(function() {
      $scope.load('exactentries_'+$scope.findIndexFromId(model.exactentries,exactentry.id,'date'));
    });
  };

  $scope.resetExactentry = function(exactentryId) {
    webservice.exclusiveCall("resetExactentry",{'exactentryId':exactentryId},script,model).then(function() {
      var exactentryId=model.exactentryId.replace(/[^0-9]/mg,'');
      if(angular.isDefined(model.exactentries) && angular.isDefined(model.exactentries[exactentryId]) && model.exactentries[exactentryId].errorwording!=='') {
        $scope.errorMessage=model.exactentries[exactentryId].errorwording;
        errorlog.error(tools.lang({'en':'Error: ','nl':'Fout: ','fr':'Erreur : '})+$scope.errorMessage);
        modelstore.removeRecord("exactentries",exactentryId,model);
        $scope.scrollTo('resetExactentry');
      } else {
        model.exactentryId='';
        $scope.load('resetExactentry');
      }
    });
  };
  
  $scope.retrySelectedExactentries = function(lastSelected) {
    if(tools.getLength(tools.match(model.exactentries,{'selected':true}))>0) {
      var exactentry=tools.first(tools.match(model.exactentries,{'selected':true}));
      webservice.exclusiveCall("retryExactentry",{"exactentryId":exactentry.id},script,model).then(function() {
        exactentry.selected=false;
        $scope.retrySelectedExactentries($scope.findIndexFromId(model.exactentries,exactentry.id,'date'));
      }).catch(function() {
        exactentry.selected=false;
        $scope.retrySelectedExactentries($scope.findIndexFromId(model.exactentries,exactentry.id,'date'));
      });
    } else {
      $scope.load('exactentries_'+lastSelected);
    }
  };

  $scope.retryExactmatchset = function(exactmatchset) {
    webservice.exclusiveCall("retryExactmatchsets",{'matchsetIds':[exactmatchset.id]},script,model).then(function() {
      $scope.load('exactmatchsets_'+$scope.findIndexFromId(model.exactmatchsets,exactmatchset.id,'updated'));
    });
  };

  $scope.retrySelectedExactmatchsets = function() {
    if(tools.getLength(tools.match(model.exactmatchsets,{'selected':true}))>0) {
      var matchsetIds=tools.getField(tools.orderBy(tools.match(model.exactmatchsets,{'selected':true}),'updated'),'id');
      webservice.exclusiveCall("retryExactmatchsets",{"matchsetIds":matchsetIds},script,model).then(function() {
        $scope.load('exactmatchsets_'+$scope.findIndexFromId(model.exactmatchsets,matchsetIds[tools.getLength(matchsetIds)-1],'updated'));
      })
    }
  }

  $scope.ignoreExactmatchset = function(exactmatchset) {
    webservice.exclusiveCall("ignoreExactmatchset",{'exactmatchsetId':exactmatchset.id},script,model).then(function() {
      $scope.load('exactmatchsets_'+$scope.findIndexFromId(model.exactmatchsets,exactmatchset.id,'updated'));
    });
  };

  $scope.ignoreSelectedExactmatchsets = function() {
    if(tools.getLength(tools.match(model.exactmatchsets,{'selected':true}))>0) {
      var exactmatchset=tools.first(tools.match(model.exactmatchsets,{'selected':true}));
      webservice.exclusiveCall("ignoreExactmatchset",{"exactmatchsetId":exactmatchset.id},script,model).then(function() {
        modelstore.removeRecord("exactmatchsets",exactmatchset.id,model);
        $scope.ignoreSelectedExactmatchsets();
      });
    } else {
      $scope.load('exactmatchsets');
    }
  };

  $scope.getExactmessageExactid = function(exactmessage) {
    return angular.fromJson(exactmessage.post).Content.Key;
  };

  $scope.getExactmessageTopic = function(exactmessage) {
    return angular.fromJson(exactmessage.post).Content.Topic;
  };

  $scope.getExactmessageDivision = function(exactmessage) {
    return angular.fromJson(exactmessage.post).Content.Division;
  };

  $scope.retryExactmessages = function() {
    webservice.exclusiveCall("retryExactmessages",{},script,model).then($scope.load);
  };
  
  $scope.retrySelectedExactmessages = function() {
    if(tools.getLength(tools.match(model.exactmessages,{'selected':true}))>0) {
      var exactmessage=tools.first(tools.match(model.exactmessages,{'selected':true}));
      webservice.exclusiveCall("retryExactmessage",{"exactmessageId":exactmessage.id},script,model).then(function() {
        modelstore.removeRecord("exactmessages",exactmessage.id,model);
        $scope.retrySelectedExactentries();
      });
    } else {
      $scope.load();
    }
  };

  $scope.retryExactmessage = function(exactmessage) {
    webservice.exclusiveCall("retryExactmessage",{'exactmessageId':exactmessage.id},script,model).then($scope.load);
  };

  $scope.deleteExactmessage = function(exactmessage) {
    webservice.exclusiveCall("deleteExactmessage",{'exactmessageId':exactmessage.id},script,model).then($scope.load);
  };

  $scope.deleteSelectedExactmessages = function() {
    if(tools.getLength(tools.match(model.exactmessages,{'selected':true}))>0) {
      var exactmessage=tools.first(tools.match(model.exactmessages,{'selected':true}));
      webservice.exclusiveCall("deleteExactmessage",{"exactmessageId":exactmessage.id},script,model).then(function() {
        modelstore.removeRecord("exactmessages",exactmessage.id,model);
        $scope.deleteSelectedExactmessages();
      });
    } else {
      $scope.load();
    }
  };

  $scope.retryIntercompany = function(intercompany) {
    webservice.exclusiveCall("retryIntercompany",{'intercompanyId':intercompany.id},script,model).then(function() {
      $scope.load('intercompanies_'+$scope.findIndexFromId(model.intercompanies,intercompany.id,'invoicedate'));
    });
  };

  $scope.resetIntercompany = function(intercompanyId) {
    webservice.exclusiveCall("resetIntercompany",{'intercompanyId':intercompanyId},script,model).then(function() {
      var intercompanyId=model.intercompanyId.replace(/[^0-9]/mg,'');
      if(angular.isDefined(model.intercompanies) && angular.isDefined(model.intercompanies[intercompanyId]) && model.intercompanies[intercompanyId].errorwording!=='') {
        $scope.errorMessage=model.intercompanies[intercompanyId].errorwording;
        errorlog.error(tools.lang({'en':'Error: ','nl':'Fout: ','fr':'Erreur : '})+$scope.errorMessage);
        modelstore.removeRecord("intercompanies",intercompanyId,model);
        $scope.scrollTo('resetIntercompany');
      } else {
        model.intercompanyId='';
        $scope.load('resetIntercompany');
      }
    });
  };

  $scope.retryIntercompanies = function() {
    webservice.exclusiveCall("retryIntercompanies",{},script,model).then(function() {
      $scope.load(intercompanies);
    });
  };

  $scope.getIntercompanyErrorStep = function(intercompany) {
    var result;
    if(intercompany.purchaseexactnumber=='') {
      result='purchase invoice';
    } else if(intercompany.salesexactnumber=='') {
      result='sales invoice';
    } else {
      result='';
    }
    return result;
  };

  $scope.getInvoiceWsParams = function(invoice) {
    var result="{}";
    if(invoice) {
      result=angular.toJson({
        "a":webservice.auth,
        "s":'activities/retrieveForEmp',
        "t":"printInvoice",
        "p":{"invoiceId":invoice.id}
      });
    }
    return result;
  };
  

  if(!("startdate" in model)) {
    tools.initDates(0,0,model);
  }
  tools.initAttributes(model,{
    'visits':{},
    'invoices':{},
    'movements':{},
    'exactentries':{},
    'exactmatchsets':{},
    'exactmessages':{},
    'exactbankentries':{},
    'exactdeletes':{},
    'exactentryId':'',
    'dateOptions':{
      maxDate: new Date(2099,11,31),
      minDate: new Date(2000,0,1),
      startingDay: 1
    },
    'startdateOpened':false,
    'enddateOpened':false,
    'scrollPosition':false,
    'action':$sce.trustAsResourceUrl(config.get('serviceUrl'))
  });
  webservice.afterLogin().then(function() {
    $scope.load();
  });

  
}]);
angular.module("app").controller("VouchersVoucherListController",["$scope","$sce","tools","modelstore","parameters","webservice","config","activitiesService","contactsService",
                                            function($scope,$sce,tools,modelstore,parameters,webservice,config,activitiesService,contactsService) {
  var script='vouchers/voucherList';
  var model=modelstore.getModel(script);
  $scope.model=model;
  $scope.activitiesService=activitiesService;
  
  $scope.load = function() {
    modelstore.cleanModel(["visits","items","products","usedVouchers"],model);
    webservice.exclusiveCall("load",{'startdate':tools.dateFromJava(model.startdate),'enddate':tools.dateFromJava(model.enddate),'origins':model.origins,'search':model.search,'searchMode':model.searchMode},script,model).then(function() {
      model.oldStartdate=model.startdate;
      var i,visit;
      for(i in model.visits) {
        visit=model.visits[i];
        visit.clientName=contactsService.getName(model.contacts[visit.owningcontact]);
        visit.voucherIds=$scope.getVoucherIds(visit);
        visit.amounts=tools.join(visit,'items',model).map(function(a){return tools.amountIn(a.nettopay);}).reduce(function(acc,cur){return (acc=='')?cur:acc+', '+cur;},'');
      }
      $scope.filterVisits();
    });
  };

  $scope.setVoucherAmountCounts = function() {
    var voucherAmountCounts={};
    var i,j,item,product,products,visit,isUsed;
    var limitOrderedVisits=tools.limitTo(tools.startFrom(model.orderedVisits,(model.page-1)*model.itemsPerPage),model.itemsPerPage);
    for(i in limitOrderedVisits) {
      visit=limitOrderedVisits[i];
      products=tools.join(visit,'products',model);
      for(j in products) {
        product=products[j];
        item=model.items[product.item];
        isUsed=tools.getLength(tools.match(model.usedVouchers,{'voucherid':product.voucherid}))>0;
        if(!(visit.id in voucherAmountCounts)) {
          voucherAmountCounts[visit.id]={'visit':visit.id,'voucherAmountCount':{}};
        }
        if(!(item.nettopay in voucherAmountCounts[visit.id].voucherAmountCount)) {
          voucherAmountCounts[visit.id].voucherAmountCount[item.nettopay]={'amount':item.nettopay,'count':1,'used':isUsed?1:0};
        } else {
          voucherAmountCounts[visit.id].voucherAmountCount[item.nettopay].count++;
          if(isUsed) {
            voucherAmountCounts[visit.id].voucherAmountCount[item.nettopay].used++;
          }
        }
      }
    }
    model.voucherAmountCounts=tools.toArray(voucherAmountCounts);
  };

  $scope.getVoucherAmountCounts = function(visit) {
    return tools.toArray(tools.first(tools.match(model.voucherAmountCounts,{'visit':visit.id})).voucherAmountCount);
  };


  $scope.getVoucherIds = function(visit) {
    return tools.join(visit,'products',model).map(function(a){return tools.voucheridOut(a.voucherid);}).reduce(function(acc,cur){return (acc=='')?cur:acc+', '+cur;},'');
  };

  $scope.editComment = function(visit) {
    model.backupVisits[visit.id]=tools.clone(visit);
    visit.editing=true;
  };

  $scope.selectOrigin = function(vis) {
    var index=model.origins.indexOf(vis);
    if(index<0) {
      model.origins.push(vis);
    } else {
      model.origins.splice(index,1);
    }
    $scope.load();
  };
  
  $scope.cancelComment = function(visit) {
    modelstore.addRecord("visits",model.backupVisits[visit.id],model);
  };
  
  $scope.updateComment = function(visit) {
    var id=visit.id;
    webservice.call("updateComment",{
      "visit":tools.whitelist(visit,['comment'])
    },script,model).then(function(response) {
      if(response) {
        model.visits[id].editing=false;
      }
    });
  };

  $scope.updatePages=function() {
    model.totalItems=tools.getLength(model.filteredVisits);
  };

  $scope.getVouchersWsParams = function(visit) {
    var result="{}";
    if(visit) {
      result=angular.toJson({
        "a":webservice.auth,
        "s":script,
        "t":'exportVoucherids',
        "p":{'visitId':visit.id}
      });
    }
    return result;
  };

  $scope.sortBy = function(propertyName,event) {
    var sortIndex=$scope.getSortIndex(propertyName);
    var hasSort=sortIndex>=0
    if(angular.isDefined(event.altKey) && event.altKey) {
      if(!hasSort) {
        model.sortings.push({'propertyName':propertyName,'reverse':false,'order':tools.getLength(model.sortings)+1});
      } else {
        var sort=model.sortings[sortIndex];
        sort.reverse=!sort.reverse;
      }
    } else if(angular.isDefined(event.ctrlKey) && event.ctrlKey) {
      if(hasSort) {
        model.sortings.splice(sortIndex,1);
      }
    } else {
      if(!hasSort) {
        model.sortings=[{'propertyName':propertyName,'reverse':false}];
      } else {
        model.sortings=[{'propertyName':propertyName,'reverse':!model.sortings[sortIndex].reverse}];
      }
    }
    $scope.sortVisits();
  };

  $scope.sortVisits = function() {
    var sortArray=[];
    var i,sort;
    for(i in model.sortings) {
      sort=model.sortings[i];
      sortArray.push((sort.reverse?'-':'+')+sort.propertyName);
    }
    model.orderedVisits=tools.orderBy(model.filteredVisits,sortArray);
    $scope.setVoucherAmountCounts();
  };

  $scope.getSortIndex = function(propertyName) {
    return model.sortings.findIndex(function(sort) {return sort.propertyName===propertyName});
  }

  $scope.addFilter = function(propertyName,formatFunction,comparator) {
    if(angular.isUndefined(model.filters[propertyName])) {
      model.filters[propertyName]={};
      model.filters[propertyName].propertyName=propertyName;
      model.filters[propertyName].pattern='';
      model.filters[propertyName].formatFunction=formatFunction;
    } else {
      delete model.filters[propertyName];
      $scope.filterVisits();
    }
  };
  
  $scope.filterVisits = function() {
    var filterObj={};
    var i,filter;
    for(i in model.filters) {
      filter=model.filters[i];
      if(angular.isDefined(filter.pattern) && filter.pattern!=='') {
        if(angular.isFunction(filter.formatFunction)) {
          filterObj[filter.propertyName]=filter.formatFunction(filter.pattern);
        } else {
          filterObj[filter.propertyName]=filter.pattern;
        }
      }
    }
    if(tools.getLength(filterObj)>0) {
      model.filteredVisits=tools.filter(tools.toArray(model.visits),filterObj);
    } else {
      model.filteredVisits=tools.toArray(model.visits);
    }
    $scope.updatePages();
    $scope.sortVisits();
  };

  if(!("startdate" in model)) {
    tools.initDates(-63,0,model);
  };
  tools.initAttributes(model,{
    'itemsPerPage':50,
    'totalItems':0,
    'page':1,
    'maxSize':5,
    'enddateOpened':false,
    'startdateOpened':false,
    'dateOptions':{
      maxDate: new Date(),
      minDate: new Date(2000,0,1),
      startingDay: 1
    },
    'backupVisits':{},
    'orderedVisits':[],
    'origins':[],
    'voucherAmounCounts':[],
    'action':$sce.trustAsResourceUrl(config.get('serviceUrl')),
    'filteredVisits':[],
    'filters': {},
    'sortings':[{propertyName:'created',reverse:true,order:1}],
    'oldStartdate':model.startdate,
    'search':'',
    'searchMode':'none',
    'searchModes':[
      {'id':'none','en':'-- none --','nl':'-- geen --','fr':'-- aucun --'},
      {'id':'voucherid','en':'voucher ID','nl':'geschenkbon ID','fr':'ID Ch\u00E8que cadeau'},
      {'id':'nettopay','en':'Amount','nl':'Bedrag','fr':'Montant'},
      {'id':'name','en':'Name','nl':'Naam','fr':'Nom'}]
  });

  webservice.afterLogin().then(function() {
    $scope.load();
  });
  
}]);
var visitsService=function(contactsService,tools,parameters,modelstore,user) {
  this.contactsService=contactsService;
  this.tools=tools;
  this.parameters=parameters;
  this.modelstore=modelstore;
  this.user=user;
};

visitsService.prototype.getName = function(contact,visit) {
  return this.contactsService.getName(contact);
};

visitsService.prototype.initVisit = function(model) {
  model.reductionMode=("defaultReductionMode" in model)?model.defaultReductionMode:'automatic';
  var defaultVis=("defaultVis" in model)?model.defaultVis:this.tools.first(this.tools.match(this.parameters.notDelArrayVIS,{'field3':'1'})).id;
  var possibleViss=this.parameters.combinationFilter(this.parameters.notDelVIS,'ROLVISA',this.user.role);
  if(!(defaultVis in possibleViss)) {
    defaultVis=this.tools.first(possibleViss).id;
  }
  var vis=this.parameters.notDelVIS[defaultVis];
  var defaultVisit=("defaultVisit" in model)?model.defaultVisit:{};
  model.visit={
    'isCreated':false,
    'id':this.tools.getMinIdMinusOne(model.visits),
    'vis':defaultVis,
    'dvs':this.user.dvs!=''?this.user.dvs:vis.field4,
    'tco':(vis.field5!=='' && angular.isDefined(this.parameters.notDelTCO[vis.field5]))?vis.field5:this.tools.first(this.tools.match(this.parameters.notDelArrayTCO,{'field1':'1'})).id,
    'lod':'XXX',
    'startdate':defaultVisit.startdate || this.tools.today(),
    'enddate':defaultVisit.enddate || this.tools.today(),
    'stat':("defaultStat" in model)?model.defaultStat:'2000',
    'owningcontact':model.owningContact.id,
    'communicationcontact':model.communicationContact.id,
    'automaticreduction':(model.reductionMode=='automatic')?'1':'0',
    'refundaccount':'',
    'reductionpro':'',
    'reductionamount':'0',
    'comment':'',
    'quotationparticipants':'0',
    'quotationpriceperperson':'1',
    'quotationdetailedprice':'0',
    'quotationcomment':'',
    'quotationnotincluded':'',
    'quotationmanager':(("rights" in this.user) && this.user.rights.indexOf("QUOT")>-1?this.user.id:'0'),
    'quotationoptions':'',
    'operationsmanager':'0',
    'invoicesmanager':'0',
    'hotelexternalreservation':'1',
    'isOpen':true,
    'editing':true,
    'advancedAttributes':false
  };
  this.modelstore.addRecord("visits",model.visit,model);
}

angular.module("app").service("visitsService",["contactsService","tools","parameters","modelstore","user",visitsService]);

angular.module("app").controller("MassEditVisitElementsModalController",["$scope","$sce","tools","parameters","user","modelstore","errorlog","$uibModalInstance","params","rights","activitiesService","contactsService","webservice",
                                                  function($scope,$sce,tools,parameters,user,modelstore,errorlog,$uibModalInstance,params,rights,activitiesService,contactsService,webservice) {
  $scope.tools=tools;
  $scope.parameters=parameters;
  $scope.user=user;
  $scope.modelstore=modelstore;
  $scope.activitiesService=activitiesService;
  $scope.contactsService=contactsService;

  var model={};
  $scope.model=model;
  $scope.model.rights=rights;
  $scope.params=params;

  $scope.init = function() {
    model.selectedVisitElementsWithDate=params.activities.concat(params.meals).concat(model.hotelreservationcategoriesForEditStartdate);
    model.startdateModeInfo=$sce.trustAsHtml(model.infoDateAbsoluteMode+'<br><br>'+model.infoStartdateRelatifMode);
    model.enddateModeInfo=$sce.trustAsHtml(model.infoDateAbsoluteMode+'<br><br>'+model.infoEnddateRelatifMode);
    model.quantityModeInfo=$sce.trustAsHtml(model.infoQuantityAbsoluteMode+'<br><br>'+model.infoQuantityRelatifMode);
    model.startdate=$scope.getMinDate();
    model.oldStartdate=model.startdate;
    model.startdateOptions.minDate=new Date(Math.min(new Date(),model.startdate));
    if(tools.getLength(model.hotelreservationcategoriesForEditEnddate)>0) {
      model.enddate=$scope.getMaxDate();
      model.oldEnddate=model.enddate;
      model.enddateOptions.minDate=tools.addDays(model.startdate,1);
    }
    var visitUndefined=!("visit" in model);
    if(visitUndefined) {
      model.defaultVisit=model.editVisit;
      model.previousStartdate=null;
      contactsService.initContacts(model);
      model.reductionMode=("defaultReductionMode" in model)?$scope.model.defaultReductionMode:'automatic';
      model.visit=tools.clone(model.editVisit);
      model.visit.isCreated=false;
      model.visit.id=tools.getMinIdMinusOne(model.visits);
      model.visit.stat='2000';
      model.visit.startdate=model.startdate || model.visit.startdate;
      model.visit.enddate=model.enddate || model.visit.enddate;
      model.visit.owningcontact=model.owningContact.id;
      model.visit.communicationcontact=model.communicationContact.id;
      model.visit.comment='';
      model.visit.quotationcomment='';
      model.visit.quotationnotincluded='';
      model.visit.quotationoptions='';
      model.visit.isOpen=true;
      model.visit.editing=true;
      model.visit.advancedAttributes=false;
      model.visit;
      modelstore.addRecord('visits',model.visit,model);
    }
    if(visitUndefined || model.transferVisit.id!='0') {
      var collections=['activities','participants','meals','dishes','products','hotelreservationcategories','hotelreservationproducts','hotelspaceassignments'];
      var i,j,collection,record,item,movement,hotelreservationcategory,hotelspaceassignmentsQuantity;
      for(i in collections) {
        collection=collections[i];
        for(j in model[collection]) {
          record=model[collection][j];
          if(angular.isDefined(record.visit)) {
            record.visit=model.visit.id;
          }
          record.skipGetAvailability=true;
          record.isCreated=true;
          record.isOpen=true;
          record.editing=true;
          record.selected=false;
          modelstore.addRecord(collection,record,model);
        }
      }
      for(i in model.items) {
        item=model.items[i];
        item.visit=model.visit.id;
        item.isCreated=true;
        item.quantity=tools.amountOut(tools.amountIn(item.quantity));
        item.planningquantity=tools.amountOut(tools.amountIn(item.planningquantity));
        if(visitUndefined) {
          item.initialQuantity=item.quantity;
        }
        item.oldQuantity=item.quantity;
        modelstore.addRecord('items',item,model);
      }
      for(i in model.movements) {
        movement=model.movements[i];
        movement.visit=model.visit.id;
        movement.oldAmount=movement.amount;
        modelstore.addRecord('movements',movement,model);
      }
      if(visitUndefined) {
        for(i in model.hotelreservationcategories) {
          hotelreservationcategory=model.hotelreservationcategories[i];
          item=model.items[hotelreservationcategory.item];
          hotelspaceassignmentsQuantity=tools.getLength(tools.match(model.hotelspaceassignments,{'reservationcategory':hotelreservationcategory.id}));
          if(hotelspaceassignmentsQuantity>0 && tools.amountIn(item.quantity)!==tools.amountIn(hotelspaceassignmentsQuantity)) {
            if(item.quantity==item.planningquantity || item.planningquantity>hotelspaceassignmentsQuantity) {
              item.planningquantity=tools.amountOut(hotelspaceassignmentsQuantity);
            }
            if(item.reductionpercent=='0') {
              item.reductionamount=item.reductionamount/item.quantity*hotelspaceassignmentsQuantity;
            }
            item.quantity=tools.amountOut(hotelspaceassignmentsQuantity);
            $scope.onQuantityChange(hotelreservationcategory);
          }
        }
      }
    }
  };

  $scope.onQuantityChange = function(record,parentrecord) {
    var item=model.items[record.item];
    var parentItem=angular.isDefined(parentrecord)?model.items[parentrecord.item]:false;
    if(tools.amountIn(item.planningquantity)===tools.amountIn(item.oldQuantity) || item.oldQuantity==='-') {
      item.planningquantity=item.quantity;
    }
    if(item.reductionpercent=='0') {
      if(Math.abs(item.oldQuantity)>0.005 && !parentItem) {
        item.unitreductionamount=item.reductionamount/item.oldQuantity;
      } else if(parentItem && Math.abs(parentItem.oldQuantity)>0.005 && Math.abs(item.oldQuantity)>0.005) {
        item.unitreductionamount=item.reductionamount/(item.oldQuantity*parentItem.oldQuantity)
      }
      if(parentItem) {
        item.reductionamount=(angular.isDefined(item.unitreductionamount)?item.unitreductionamount*parentItem.quantity*item.quantity:item.reductionamount);
      } else {
        item.reductionamount=(angular.isDefined(item.unitreductionamount)?item.unitreductionamount:item.reductionamount)*item.quantity;
      }
    }
    if(record.table=='hotelreservationcategories') {
      var hotelreservationproducts=tools.join(record,'hotelreservationproducts',model);
      for(var i in hotelreservationproducts) {
        $scope.onQuantityChange(hotelreservationproducts[i],record);
      }
    }
    if(record.table=='hotelreservationproducts') {
      var multiplier=$scope.getHotelreservationproductMultiplier(record,'quantity');
      if(!item.created || tools.amountIn(item.standardunitprice)==0.0) {
        item.standardunitprice=parameters.HPD[record.hpd].field3*multiplier;
      } else {
        var oldMultiplier=$scope.getHotelreservationproductMultiplier(record,'oldQuantity');
        item.standardunitprice=item.standardunitprice/oldMultiplier*multiplier;
      }
      if(!(("customprice" in item) && item.customprice=="1")) {
        item.grossunitprice=item.standardunitprice;
      }      
    }
    item.oldQuantity=item.quantity;
  };

  $scope.getHotelreservationproductMultiplier = function(hotelreservationproduct,field) {
    var multiplier=0;
    if(hotelreservationproduct) {
      var hotelreservationcategory=model.hotelreservationcategories[hotelreservationproduct.reservationcategory];
      if(hotelreservationcategory) {
        var item=model.items[hotelreservationcategory.item];
        var multiplier=tools.amountIn(item[field]);
        var hpd=parameters.HPD[hotelreservationproduct.hpd];
        if(hpd.field2=="PerTimeUnit" || hpd.field2=="PerPersonPerTimeUnit") {
          multiplier*=tools.dayDiff(hotelreservationcategory.startdate,hotelreservationcategory.enddate);
        }
        if(hpd.field2=="PerPersonPerTimeUnit" || hpd.field2=="PerPerson") {
          multiplier*=tools.amountIn(hotelreservationcategory.adultcount)+tools.amountIn(hotelreservationcategory.childcount);
        }
      }
    }
    return multiplier;
  };

  $scope.getMaxDate = function() {
    var maxDate;
    var visitElements=model.hotelreservationcategoriesForEditEnddate;
    var i,visitElement,day;
    for(i in visitElements) {
      visitElement=visitElements[i];
      day=visitElement.enddate;
      if(angular.isUndefined(maxDate) || maxDate===null) {
        maxDate=day
      } else if(day>maxDate) {
        maxDate=day;
      }
    }
    return maxDate;
  };

  $scope.getMinDate = function() {
    var minDate;
    var visitElements=model.selectedVisitElementsWithDate;
    if(tools.getLength(visitElements)===0) {
      visitElements=model.hotelreservationcategoriesForEditEnddate;
    }
    var i,visitElement,day;
    for(i in visitElements) {
      visitElement=visitElements[i];
      day=(visitElement.table=='hotelreservationcategories')?visitElement.startdate:visitElement.day;
      if(angular.isUndefined(minDate) || minDate===null) {
        minDate=day
      } else if(day<minDate) {
        minDate=day;
      }
    }
    return minDate;
  };

  $scope.selectTab = function(mode) {
    if(mode==='duplicate' && model.transferMode==='new') {
      model.task='d';
    } else {
      model.task='t';
    }
  };

  $scope.getSelectedAmount = function() {
    var i,item,gross;
    var amount=0.0;
    var selectedItems=tools.exclude(tools.match(tools.join(model.transferVisit,'items',model),{'replaced':'0','ignoreaccounting':'0'}),{'itm':'ZDOWNPAY'});
    for(var i in selectedItems) {
      item=selectedItems[i];
      gross=tools.amountIn(item.quantity)*(item.customprice=='0'?tools.amountIn(item.standardunitprice):tools.amountIn(item.grossunitprice));
      amount+=item.reductionpercent=='1'?gross*((100-tools.amountIn(item.reductionamount))/100):gross-tools.amountIn(item.reductionamount);
    }
    return amount;
  };

  $scope.whitelistVisit = function(visit) {
    var visitWhitelist=['vis','dvs','tco','lod','owningcontact','communicationcontact','automaticreduction','campaign','refundaccount','comment','quotationparticipants','quotationpriceperperson','quotationdetailedprice','quotationcomment','quotationnotincluded','quotationmanager','quotationoptions','attention','operationsmanager','invoicesmanager','hotelexternalreservation'];
    if(model.task!='c' || model.view=='createQuotation') {
      visitWhitelist.push('startdate','enddate');
    }
    return tools.whitelist(visit,visitWhitelist);
  };

  $scope.cleanParams = function(responseParams) {
    if("contacts" in responseParams) {
      responseParams.contacts=tools.whitelist(responseParams.contacts,["firstname","name","gsm","email","address1","postalcode","address2","lang","agreestomarketing","sal","iscompany","vatnumber","country"]);
    }
    if("visit" in responseParams) {
      responseParams.visit=$scope.whitelistVisit(responseParams.visit);
    }
    if("activities" in responseParams)
      responseParams.activities=tools.whitelist(responseParams.activities,['frm','day','hrs','comment','quotationtitle','quotationdescription','quotationhidefoto']);
    if("participants" in responseParams)
      responseParams.participants=tools.whitelist(responseParams.participants,['activity','item','unt']);
    if("meals" in responseParams)
      responseParams.meals=tools.whitelist(responseParams.meals,['day','hrs','res','delivery','comment','quotationhidefoto']);
    if("products" in responseParams)
      responseParams.products=tools.whitelist(responseParams.products,['item','prd','invoicewording','transferred','comment']);
    if("dishes" in responseParams)
      responseParams.dishes=tools.whitelist(responseParams.dishes,['meal','item','dsh','quotationtitle','quotationdescription']);
    if("hotelreservationcategories" in responseParams)
      responseParams.hotelreservationcategories=tools.whitelist(responseParams.hotelreservationcategories,['htl','startdate','starthrs','enddate','hra','quotationhidefoto','quotationparticipants','requestedhsc','adultcount','childcount','item','externalreleaseddate']);
    if("hotelreservationproducts" in responseParams)
      responseParams.hotelreservationproducts=tools.whitelist(responseParams.hotelreservationproducts,['reservationcategory','hpd','count','item']);
    if("items" in responseParams)
      responseParams.items=tools.whitelist(responseParams.items,['itm','quantity','planningquantity','customprice','grossunitprice','reductionpro','reductionpromotion','reductionamount','reductionpercent','invoice','cgr'])
    var i,j,k,collection,record,param;
    for(i in responseParams) {
      if(i==="visit") {
        collection=[responseParams.visit];
      } else {
        collection=responseParams[i];
      }
      for(j in collection) {
        record=collection[j];
        for(k in record) {
          if(angular.isDate(record[k])) {
            record[k]=tools.dateFromJava(record[k]);
          }
        }
      }
    }
    return responseParams;
  };
  
  $scope.ok = function() {
    var responseParams={
      'mode':model.mode
    };
    var validated=true;
    if(model.mode=='edit' || (model.mode=='duplicate' && model.transferVisit.id!='0')) {
      responseParams.editStartdate=model.editStartdate;
      responseParams.oldStartdate=model.oldStartdate;
      responseParams.startdate=model.startdate;
      responseParams.startdateOffsetMode=model.startdateOffsetMode;
      responseParams.editEnddate=model.editEnddate;
      responseParams.oldEnddate=model.oldEnddate;
      responseParams.enddate=model.enddate;
      responseParams.enddateOffsetMode=model.enddateOffsetMode;
      responseParams.setSelectedElementsToZero=model.setSelectedElementsToZero;
      responseParams.editParticipantcount=model.editParticipantcount;
      responseParams.participantcountOffsetMode=model.participantcountOffsetMode;
      responseParams.participantcount=model.participantcount;
      responseParams.editDishcount=model.editDishcount;
      responseParams.dishcountOffsetMode=model.dishcountOffsetMode;
      responseParams.dishcount=model.dishcount;
      responseParams.editRoomcount=model.editRoomcount;
      responseParams.roomcountOffsetMode=model.roomcountOffsetMode;
      responseParams.roomcount=model.roomcount;
      responseParams.editAdultcount=model.editAdultcount;
      responseParams.adultcountOffsetMode=model.adultcountOffsetMode;
      responseParams.adultcount=model.adultcount;
      responseParams.editChildcount=model.editChildcount;
      responseParams.childcountOffsetMode=model.childcountOffsetMode;
      responseParams.childcount=model.childcount;
      responseParams.editProductcount=model.editProductcount;
      responseParams.productcountOffsetMode=model.productcountOffsetMode;
      responseParams.productcount=model.productcount;
      responseParams.setVouchersToUsedAmount=model.setVouchersToUsedAmount;
    }
    if((model.mode=='transfer' || model.mode=='duplicate') && model.transferVisit.id=='0') {
      errorlog.warning(tools.lang({'en':'Assign a reservation','nl':'Voeg een reservatie toe','fr':'Attribuer une reservation'}));
      validated=false;
    }
    if((model.mode=='transfer' || model.mode=='duplicate') && model.transferVisit.id!='0') {
      responseParams.contacts=[];
      responseParams.visit=model.transferVisit;
      responseParams.activities=tools.join(model.transferVisit,'activities',model);
      responseParams.participants=[];
      responseParams.meals=tools.join(model.transferVisit,'meals',model);
      responseParams.dishes=[];
      responseParams.hotelreservationcategories=tools.join(model.transferVisit,'hotelreservationcategories',model);        
      responseParams.hotelreservationproducts=[];
      responseParams.hotelspaceassignments=[];
      responseParams.products=tools.join(model.transferVisit,'products',model);
      responseParams.movements=model.mode=='transfer'?tools.join(model.transferVisit,'movements',model):[];
      if(model.transferVisit.id<0) {
        if(model.transferVisit.owningcontact!='0') {
          responseParams.contacts.push(model.owningContact);
        } else {
          errorlog.warning(tools.lang({'en':'Assign a contact','nl':'Voeg een contactpersoon toe','fr':'Attribuer une personne de contact'}));
          validated=false;
        }
        if(model.transferVisit.communicationcontact!='0') {
          responseParams.contacts.push(model.communicationContact);
        }
      }
      var i,activity,item;
      for(i in responseParams.activities) {
        activity=responseParams.activities[i];
        responseParams.participants=responseParams.participants.concat(activitiesService.formulaFilter(tools.join(activity,'participants',model),'unt',activity.frm));
      }
      responseParams.dishes=tools.join(responseParams.meals,'dishes',model);
      responseParams.hotelreservationproducts=[];//tools.join(responseParams.hotelreservationcategories,'hotelreservationproducts',model);
      responseParams.hotelspaceassignments=tools.join(responseParams.hotelreservationcategories,'hotelspaceassignments',model);
      responseParams.items=tools.inverseJoin(responseParams.participants,'items','item',model).concat(
        tools.inverseJoin(responseParams.dishes,'items','item',model),
        tools.inverseJoin(responseParams.products,'items','item',model),
        tools.inverseJoin(responseParams.hotelreservationcategories,'items','item',model),
        tools.inverseJoin(responseParams.hotelreservationproducts,'items','item',model)
      );
      var cleanedParams=$scope.cleanParams(responseParams);
      cleanedParams['fromVisitId']=model.editVisit.id;
      if(model.mode==='transfer' && validated) {
        cleanedParams['movements']=tools.whitelist(responseParams.movements,['comment','amount']);
        webservice.exclusiveCall('transferVisitArticles',cleanedParams,'activities/retrieveForEmp',model).then(function(response) {
          if(angular.isDefined(response.id)) {
            response={
              'mode':model.mode,
              'visit':response
            }
            $uibModalInstance.close(response);
          }
        });
      }
    }
    if((model.mode=='edit' || model.mode=='duplicate') && validated) {
      $uibModalInstance.close(responseParams);
    }
  };

  $scope.cancel = function() {
    $uibModalInstance.dismiss();
  };

  $scope.onUpdateStartdate = function() {
    var canEditEnddate=model.editEnddate===false && model.enddate!==null;
    if(canEditEnddate && model.keepNightCount) {
      model.enddate=tools.addDays(model.oldEnddate,tools.dayDiff(model.oldStartdate,model.startdate));
    } else if(canEditEnddate && !model.keepNightCount) {
      model.enddate=(model.oldEnddate<model.startdate)?tools.addDays(model.startdate,1):model.oldEnddate;
    }
    model.enddateOptions.minDate=tools.addDays(model.startdate,1)
  }
  $scope.$watch('model.startdate',function() {
    $scope.onUpdateStartdate();
  },true);

  $scope.selectTransferType = function(transferType,value) {
    if(value) {
      if(transferType=='existing') {
        model.toCompany=false;
        model.toContact=false;
        model.defaultIsCompany=null;
        if(model.transferVisit.id!='0') {
          $scope.resetTransferVisit();
        }
      } else {
        model.toExistingVisit=false;
        if(transferType=='company') {
          model.toContact=false;
        } else if(transferType=='contact') {
          model.toCompany=false;
        }
        model.defaultIsCompany=model.toCompany?'1':'0';
        $scope.selectVisit('new');
      }
    }
  };

  $scope.setVisitReferences = function() {
    var collections=['activities','meals','products','hotelreservationcategories','items','movements'];
    var i,j,collection,record,item;
    for(i in collections) {
      collection=collections[i];
      for(j in model[collection]) {
        model[collection][j].visit=model.visit.id;
      }
    }
  };

  $scope.selectVisit = function(newOrExisting) {
    model.transferMode=newOrExisting;
    if(model.transferMode=='new') {
      if(model.toCompany && model.owningContact.iscompany=='0') {
        model.communicationContact=model.owningContact;
        model.existingCommunicationContact=tools.clone(model.communicationContact);
        model.existingOwningContact={'id':'0','iscompany':("defaultIsCompany" in model)?$scope.model.defaultIsCompany:'0'};
        model.owningContact=model.existingOwningContact;
      } else if(model.toContact && model.owningContact.iscompany=='1') {
        model.owningContact=model.communicationContact;
        model.existingOwningContact=tools.clone(model.owningContact);
        model.communicationContact=model.dummyCommunicationContact;
        model.existingCommunicationContact={'id':'0'};
      }
      model.visit.owningcontact=model.owningContact.id;
      model.visit.communicationcontact=model.communicationContact.id;
      if(model.visit.id>0) {
        model.visit.id=tools.getMinIdMinusOne(model.visits);
        $scope.setVisitReferences();
      }
      model.transferVisit=model.visit;
      if(model.mode==='duplicate') {
        model.task='d';
      } else {
        model.task='t';
      }
    } else if(model.transferMode=='existing' && model.transferVisit.id!='0') {
      model.visit.id=model.transferVisit.id;
      $scope.setVisitReferences();
      model.task='t';
    }
  };

  $scope.resetTransferVisit = function() {
    if(model.editVisit.id!=model.transferVisit.id) {
      modelstore.removeRecord("visits",model.transferVisit.id,model);
    }
    model.transferVisit={'id':'0'};
    model.task='t';
  };

  $scope.indexById = function(records) {
    return records.reduce(function(acc,cur) {acc[cur.id]=cur;return acc;},{})
  };

  $scope.modeIsDisabled = function(mode) {
    var result;
    if(mode==='edit') {
      result=model.transferVisit.id!='0';
    } else {
      result=model.setSelectedElementsToZero || model.editEnddate || model.editStartdate || model.editParticipantcount || model.editDishcount || model.editRoomcount || model.editAdultcount || model.editChildcount || model.editProductcount;
    }
    return result;
  };

  tools.initAttributes(model,{
    'mode':'edit',
    'modes':{
      'edit':{'id':'edit','sort':0,'en':'Edit','nl':'Bewerken','fr':'Editer'},
      'transfer':{'id':'transfer','sort':1,'en':'Transfer','nl':'Overzetten','fr':'Transferer'},
      'duplicate':{'id':'duplicate','sort':2,'en':'Duplicate','nl':'Dupliceer','fr':'Dupliquer'}
    },
    'transferMode':'existing',
    'transferVisit':{'id':'0'},
    'backupVisits':{},
    'backupContacts':{},
    'task':'t',
    'editVisit':params.visit,
    'contacts':$scope.indexById(tools.clone(params.contacts)),
    'activities':$scope.indexById(tools.clone(params.activities)),
    'participants':$scope.indexById(tools.clone(params.participants)),
    'meals':$scope.indexById(tools.clone(params.meals)),
    'dishes':$scope.indexById(tools.clone(params.dishes)),
    'hotelreservationcategories':$scope.indexById(tools.clone(params.hotelreservationcategories)),
    'hotelreservationproducts':$scope.indexById(tools.clone(params.hotelreservationproducts)),
    'hotelspaceassignments':$scope.indexById(tools.clone(params.hotelspaceassignments)),
    'hotelreservationcategoriesForEditStartdate':params.hotelreservationcategories.filter(function(hotelreservationcategory) {
      return hotelreservationcategory.updatePermissions.updateFields.startdate;
    }),
    'hotelreservationcategoriesForEditEnddate':params.hotelreservationcategories.filter(function(hotelreservationcategory) {
      return hotelreservationcategory.updatePermissions.updateFields.enddate;
    }),
    'hotelreservationcategoriesForEditRoomcount':params.hotelreservationcategories.filter(function(hotelreservationcategory) {
      return hotelreservationcategory.updatePermissions.allowItemUpdate;
    }),
    'hotelreservationcategoriesForEditAdultcount':params.hotelreservationcategories.filter(function(hotelreservationcategory) {
      return hotelreservationcategory.updatePermissions.updateFields.adultcount;
    }),
    'hotelreservationcategoriesForEditChildcount':params.hotelreservationcategories.filter(function(hotelreservationcategory) {
      return hotelreservationcategory.updatePermissions.updateFields.childcount;
    }),
    'products':$scope.indexById(tools.clone(params.products)),
    'items':$scope.indexById(tools.clone(params.items)),
    'movements':$scope.indexById(tools.clone(params.movements)),
    'accounts':$scope.indexById(tools.clone(params.accounts)),
    'startdateOffsetMode':'REL',
    'enddateOffsetMode':'REL',
    'participantcountOffsetMode':'ABS',
    'dishcountOffsetMode':'ABS',
    'roomcountOffsetMode':'ABS',
    'adultcountOffsetMode':'ABS',
    'childcountOffsetMode':'ABS',
    'productcountOffsetMode':'ABS',
    'offsetModes':[
      {'id':'REL','en':'Relatif','nl':'Relatief','fr':'Relative'},
      {'id':'ABS','en':'Absolute','nl':'Absoluut','fr':'Absolute'}
    ],
    'infoDateAbsoluteMode':tools.lang({
      'en':'Absolute\u003A Adjust the selected dates to the chosen date',
      'nl':'Absoluut\u003A Pas alle geselecteerde datums aan naar de gekozen datum',
      'fr':'Absolute\u003A Ajuster les dates s\u00E9lectionn\u00E9es \u00E0 la date choisie'
    }),
    'infoQuantityAbsoluteMode':tools.lang({
      'en':'Absolute\u003A Adjust the selected quantities to the chosen quantity',
      'nl':'Absoluut\u003A Pas alle geselecteerde aantallen aan naar het gekozen aantal',
      'fr':'Absolute\u003A Ajuster les quantit\u00E9s s\u00E9lectionn\u00E9es \u00E0 la quantit\u00E9 choisie'
    }),
    'infoQuantityRelatifMode':tools.lang({
      'en':'Relatif\u003A Add the chosen quantity from the selected quantities',
      'nl':'Relatief\u003A Voeg het gekozen aantal toe aan de geselecteerde aantallen',
      'fr':'Relative\u003A Ajouter la quantit\u00E9 choisie aux quantit\u00E9s s\u00E9lectionn\u00E9es'
    }),
    'infoStartdateRelatifMode':tools.lang({
      'en':'Relatif\u003A Adjust the earliest date of the selection to the chosen date, keeping the differences relative to this earliest date',
      'nl':'Relatief\u003A Pas de vroegste datum van de selectie aan naar de gekozen datum en behoud de verschillen relatief tegenover deze vroegste datum',
      'fr':'Relative\u003A Ajuster la plus ancienne date de la s\u00E9lection \u00E0 la date choisie, en conservant les \u00E9carts par rapport \u00E0 cette ancienne date'
    }),
    'infoEnddateRelatifMode':tools.lang({
      'en':'Relatif\u003A Adjust the latest departure date of the selection to the chosen date, keeping the differences relative to this latest departure date',
      'nl':'Relatief\u003A Pas de laatste vertrekdatum van de selectie aan naar de gekozen datum en behoud de verschillen relatief tegenover deze laatste vertekdatum',
      'fr':'Relative\u003A Ajuster la derni\u00E8re date de d\u00E9part de la s\u00E9lection \u00E0 la date choisie et conserver les \u00E9carts par rapport \u00E0 cette derni\u00E8re date de d\u00E9part'
    }),
    'startdate':null,
    'enddate':null,
    'editStartdateOpened':false,
    'editEnddateOpened':false,
    'startdateOptions':{
      'maxDate': new Date(2099,11,31),
      'minDate': new Date(),
      'startingDay': 1
    },
    'enddateOptions':{
      'maxDate': new Date(2099,11,31),
      'minDate': new Date(),
      'startingDay': 1
    },
    'keepNightCount':true,
    'editStartdate':false,
    'editEnddate':false,
    'editParticipantcount':false,
    'editDishcount':false,
    'editRoomcount':false,
    'editAdultcount':false,
    'editChildcount':false,
    'editProductcount':false,
    'setVouchersToUsedAmount':false,
    'setSelectedElementsToZero':false,
    'searchTerm':''
  });
  $scope.init();

}]);
angular.module("app").controller("FinishPacketModalController",["$scope","tools","parameters","$uibModalInstance","visit","packet",
                                                  function($scope,tools,parameters,$uibModalInstance,visit,packet) {
  $scope.parameters=parameters;
  $scope.tools=tools;
  $scope.model={
    'visit':visit,
    'packet':packet
  };
  $scope.packet=packet
  $scope.cgrs={};

  $scope.getPacketcomponents = function(packet) {
    return tools.join(packet,'packetcomponents',parameters);
  }

  $scope.init = function() {
    var packetcomponents=$scope.getPacketcomponents($scope.packet);
    for(var i in packetcomponents) {
      var packetcomponent=packetcomponents[i];
      var cgrId=packetcomponent.cgr;
      if(angular.isUndefined($scope.cgrs[cgrId])) {
        if(packetcomponent.param1!=='HTL' && cgrId!='XX') {
          var CGR=parameters.CGR[cgrId];
          $scope.cgrs[cgrId]={'cgr':cgrId,'labelen':cgr.labelen,'labelnl':cgr.labelnl,'labelfr':cgr.labelfr,'quantity':0};
        } else if(packetcomponent.param1==='HTL') {
          $scope.cgrs['RO']={'cgr':'RO','labelen':'Rooms','labelnl':'Kamers','labelfr':'Chambres','quantity':1};
        }
      }
    }
    if(tools.getLength(tools.exclude($scope.cgrs,{'cgr':'RO'}))===0) {
      $scope.cgrs['XX']={'cgr':'XX','labelen':'Participants','labelnl':'Deelnemers','labelfr':'Participant','quantity':1};
    }
  };

  $scope.ok = function(packet) {
    $uibModalInstance.close({'packet':$scope.packet,'cgrParticipantcount':$scope.cgrs,'startdate':$scope.startdate,'enddate':$scope.enddate});
  }

  $scope.cancel = function() {
    $uibModalInstance.dismiss();
  };

  $scope.init();

}]);

angular.module("app").controller("AddPacketModalController",["$scope","$window","tools","parameters","$uibModalInstance","visit","webservice","user",
                                                  function($scope,$window,tools,parameters,$uibModalInstance,visit,webservice,user) {
  $scope.parameters=parameters;
  $scope.tools=tools;
  $scope.user=user;
  var model={};
  $scope.model=model;

  $scope.getPacketcomponents = function(packet) {
    return tools.join(packet,'packetcomponents',parameters);
  };

  $scope.select = function(packet) {
    $uibModalInstance.close({'packet':packet,'participantcount':model.participantcount,'startdate':$scope.startdate});
  }

  $scope.isCreated = function() {
    return model.visit.isCreated || tools.numberIn(model.visit.id)>0;
  }

  $scope.cancel = function() {
    $uibModalInstance.dismiss();
  };

  $scope.navigateToFfo = function(ffoId) {
    $window.location=parameters.FFO[ffoId].field13+'/#!/'+($scope.isCreated()?'update':'create')+'ForEmp/'+user.lang+($scope.isCreated()?'/'+model.visit.id+'/'+model.token:'');
  };

  tools.initAttributes(model,{
    'visit':visit,
    'token':'',
    'participantcount':'1',
    'ffos':[],
    'filteredFfos':{},
    'ffoId':''
  });
  $scope.startdate=$scope.model.visit.startdate;
  $scope.startdateOptions={
    'maxDate': new Date(2099,11,31),
    'minDate': new Date(),
    'startingDay': 1
  };
  $scope.selectFfo={'id':'','labelen':'--- Select form ---','labelnl':'--- Selecteer formulier ---','labelfr':'--- S\u00E9lectionner un formulaire ---'};
  if(parameters.VIS[visit.vis].field1=='1') {
    $scope.packets=tools.match(parameters.packets,{'company':'1'});
  } else {
    $scope.packets=tools.match(parameters.packets,{'private':'1'});
  }
  for(var i in $scope.packets) {
    var packet=$scope.packets[i];
    var packetcomponents=$scope.getPacketcomponents(packet);
    if(tools.getLength(tools.exclude(packetcomponents,{'param2':'VOU'}))==0 && tools.getLength(tools.match(packetcomponents,{'param2':'VOU'}))==1) {
      packet.voucherValue=packetcomponents[0].attr1
    } else {
      packet.voucherValue=false;
    }
  }
  webservice.afterLogin().then(function() {
    webservice.exclusiveCall("load",{'visitId':model.visit.id},"visits/addPacketModal",model).then(function() {
      var i,ffoId
      for(i in model.ffos) {
        ffoId=model.ffos[i];
        model.filteredFfos[ffoId]=parameters.FFO[ffoId];
      }
    });
  });

}]);

angular.module("app").controller("AddArticleModalController",["$scope","$sce","tools","parameters","user","modelstore","errorlog","$uibModalInstance","activitiesService","contactsService","visitsService","webservice","day",
                                                  function($scope,$sce,tools,parameters,user,modelstore,errorlog,$uibModalInstance,activitiesService,contactsService,visitsService,webservice,day) {
  $scope.tools=tools;
  $scope.parameters=parameters;
  $scope.user=user;
  $scope.modelstore=modelstore;
  $scope.activitiesService=activitiesService;
  $scope.contactsService=contactsService;
  $scope.visitsService=visitsService;

  var model={};
  $scope.model=model;

  $scope.init = function() {
    var visitUndefined=!("visit" in model);
    if(visitUndefined) {
      model.previousStartdate=null;
      contactsService.initContacts(model);
      visitsService.initVisit(model);
      model.visit.startdate=day;
      model.visit.enddate=day;
    }
  };
  
  $scope.ok = function() {
    var responseParams={};
    var validated=true;
    if(model.transferVisit.id=='0') {
      errorlog.warning(tools.lang({'en':'Assign a reservation','nl':'Voeg een reservatie toe','fr':'Attribuer une reservation'}));
      validated=false;
    }
    if(model.transferVisit.id!='0') {
      responseParams.visit=model.transferVisit;
      responseParams.contacts=[];
      if(model.transferVisit.id<0) {
        if(model.transferVisit.owningcontact!='0' && angular.isDefined(model.contacts[model.transferVisit.owningcontact])) {
          responseParams.contacts.push(model.contacts[model.transferVisit.owningcontact]);
        }
        if(model.transferVisit.communicationcontact!='0' && angular.isDefined(model.contacts[model.transferVisit.communicationcontact])) {
          responseParams.contacts.push(model.contacts[model.transferVisit.communicationcontact]);
        }
      }
    }
    if(validated) {
      $uibModalInstance.close(responseParams);
    }
  };

  $scope.cancel = function() {
    $uibModalInstance.dismiss();
  };

  $scope.selectTransferType = function(transferType,value) {
    if(value) {
      if(transferType=='existing') {
        model.toCompany=false;
        model.toContact=false;
        model.defaultIsCompany=null;
        if(model.transferVisit.id!='0') {
          $scope.resetTransferVisit();
        }
      } else {
        model.toExistingVisit=false;
        if(transferType=='company') {
          model.toContact=false;
        } else if(transferType=='contact') {
          model.toCompany=false;
        }
        model.defaultIsCompany=model.toCompany?'1':'0';
        $scope.selectVisit('new');
      }
    }
  };

  $scope.setVisitReferences = function() {
    var collections=['activities','meals','products','hotelreservationcategories','items','movements'];
    var i,j,collection,record,item;
    for(i in collections) {
      collection=collections[i];
      for(j in model[collection]) {
        model[collection][j].visit=model.visit.id;
      }
    }
  };

  $scope.selectVisit = function(newOrExisting) {
    model.transferMode=newOrExisting;
    if(model.transferMode=='new') {
      if(model.toCompany && model.owningContact.iscompany=='0') {
        model.communicationContact=model.owningContact;
        model.existingCommunicationContact=tools.clone(model.communicationContact);
        model.existingOwningContact={'id':'0','iscompany':("defaultIsCompany" in model)?$scope.model.defaultIsCompany:'0'};
        model.owningContact=model.existingOwningContact;
      } else if(model.toContact && model.owningContact.iscompany=='1') {
        model.owningContact=model.communicationContact;
        model.existingOwningContact=tools.clone(model.owningContact);
        model.communicationContact=model.dummyCommunicationContact;
        model.existingCommunicationContact={'id':'0'};
      }
      model.visit.owningcontact=model.owningContact.id;
      model.visit.communicationcontact=model.communicationContact.id;
      if(model.visit.id>0) {
        model.visit.id=tools.getMinIdMinusOne(model.visits);
        $scope.setVisitReferences();
      }
      model.transferVisit=model.visit;
    } else if(model.transferMode=='existing' && model.transferVisit.id!='0') {
      model.visit.id=model.transferVisit.id;
      $scope.setVisitReferences();
    }
  };

  $scope.resetTransferVisit = function() {
    if(model.transferVisit.id!=='0') {
      modelstore.removeRecord("visits",model.transferVisit.id,model);
    }
    model.transferVisit={'id':'0'};
  };

  $scope.indexById = function(records) {
    return records.reduce(function(acc,cur) {acc[cur.id]=cur;return acc;},{})
  };

  tools.initAttributes(model,{
    'transferMode':'existing',
    'transferVisit':{'id':'0'},
    'backupVisits':{},
    'backupContacts':{},
    'task':'t',
    'visits':{},
    'contacts':{},
    'searchTerm':''
  });
  $scope.init();

}]);
angular.module("app").controller("UsersUserListController",["$scope","tools","user","errorlog","modelstore","parameters","config","webservice",function($scope,tools,user,errorlog,modelstore,parameters,config,webservice) {

  var script="users/userList";
  var model=modelstore.getModel(script);
  $scope.model=model;
  
  $scope.any={'id':'','shorten':'--All--','shortnl':'--Alle--','shortfr':'--Tout--','labelen':'--All--','labelnl':'--Alle--','labelfr':'--Tout--'};
  $scope.none={'id':'/empty/','shorten':'--none--','shortnl':'--geen--','shortfr':'--aucun--'};

  var minSearchLength=3;
  $scope.getUsers = function() {
    var result=[];
    if("users" in model) {
      if(model.searchUser.length<minSearchLength) {
        result=tools.match(model.users,{'deleted':'0'});
      } else {
        var searchLower=model.searchUser.toLowerCase();
        var lUser;
        for(var i in model.users) {
          lUser=model.users[i];
          if(lUser.deleted==="0" && (
              lUser.name.toLowerCase().indexOf(searchLower)!==-1 ||
              lUser.short.toLowerCase().indexOf(searchLower)!==-1 ||
              (lUser.email && lUser.email.toLowerCase().indexOf(searchLower)!==-1)
            )
          ) {
            result.push(lUser);
            if(result.length>=model.pageSize) {
              break;
            }
          }
        }
      }
    }
    model.filteredUsers=result;
    $scope.sortUsers();
    result=tools.orderBy(result,'name');
    return result;
  };

  $scope.addFilter = function(propertyName,formatFunction,defaultPattern) {
    if(angular.isUndefined(model.filters[propertyName])) {
      model.filters[propertyName]={};
      model.filters[propertyName].propertyName=propertyName;
      model.filters[propertyName].pattern=defaultPattern || '';
      model.filters[propertyName].formatFunction=formatFunction;
    } else {
      delete model.filters[propertyName];
      $scope.filterUsers();
    }
  };

  $scope.filterUsers = function() {
    var filterObj={};
    var matchObj={};
    var i,filter;
    for(i in model.filters) {
      filter=model.filters[i];
      if(angular.isDefined(filter.pattern) && filter.pattern!=='') {
        if(filter.pattern==='/empty/') {
          matchObj[filter.propertyName]='';
        } else if(angular.isFunction(filter.formatFunction)) {
          filterObj[filter.propertyName]=filter.formatFunction(filter.pattern);
        } else {
          filterObj[filter.propertyName]=filter.pattern;
        }
      }
    }
    if(tools.getLength(filterObj)>0) {
      model.filteredUsers=tools.filter(tools.toArray(model.users),filterObj);
    } else {
      model.filteredUsers=tools.toArray(model.users);
    }
    if(tools.getLength(matchObj)>0) {
      model.filteredUsers=tools.match(model.filteredUsers,matchObj);
    }
    $scope.updatePages();
    $scope.sortUsers();
  };

  $scope.sortUsers = function() {
    var sortArray=[];
    var i,sort;
    for(i in model.sortings) {
      sort=model.sortings[i];
      sortArray.push((sort.reverse?'-':'+')+sort.propertyName);
    }
    model.orderedUsers=tools.orderBy(model.filteredUsers,sortArray);
  };

  $scope.sortBy = function(propertyName,event) {
    var sortIndex=$scope.getSortIndex(propertyName);
    var hasSort=sortIndex>=0
    if(angular.isDefined(event.altKey) && event.altKey) {
      if(!hasSort) {
        model.sortings.push({'propertyName':propertyName,'reverse':false,'order':tools.getLength(model.sortings)+1});
      } else {
        var sort=model.sortings[sortIndex];
        sort.reverse=!sort.reverse;
      }
    } else if(angular.isDefined(event.ctrlKey) && event.ctrlKey) {
      if(hasSort) {
        model.sortings.splice(sortIndex,1);
      }
    } else {
      if(!hasSort) {
        model.sortings=[{'propertyName':propertyName,'reverse':false}];
      } else {
        model.sortings=[{'propertyName':propertyName,'reverse':!model.sortings[sortIndex].reverse}];
      }
    }
    $scope.sortUsers();
  };

  $scope.getSortIndex = function(propertyName) {
    return model.sortings.findIndex(function(sort) {return sort.propertyName===propertyName});
  }

  $scope.updatePages=function(){
    model.totalItems=tools.getLength(model.filteredUsers);
  };

  $scope.initUser = function() {
    model.user={
      'deleted':'0',
      'email':'',
      'name':'',
      'short':'',
      'gsm':'',
      'department':'',
      'dvs':'',
      'password':'',
      'confirmPassword':'',
      'role':null,
      'lang':user.lang,
      'active':'1',
      'templateimage':'0'
    };
  };

  $scope.newUser = function() {
    $scope.initUser();
    model.passwordReset='1';
    model.task='c';
  };

  $scope.editUser = function(lUser) {
    model.user=tools.clone(lUser);
    model.user.password='';
    model.user.confirmPassword='';
    model.passwordReset='0';
    model.task='u';
    model.right={'rgh':''};
  };

  $scope.replaceUser = function(lUser) {
    var whitelist=['deleted','email','name','gsm','department','dvs','password','role','lang','active','templateimage'];
    if("password "in lUser && lUser.password.length>0) {
      if(lUser.password!==lUser.confirmPassword) {
        errorlog.receiveError(tools.lang({'en':'Passwords do not match','nl':'Paswoorden zijn niet identiek','fr':'Les passwords ne sont pas egales'}));
        return;
      }
      whitelist.push('password');
    }
    webservice.call('replaceUser',{'user':tools.whitelist(lUser,whitelist),'activation':model.task==='c','mail':model.passwordReset},script,model).then(function(response) {
      if(response) {
        model.task="l";
        $scope.filterUsers();
      }
    });
  };

  $scope.deleteUser = function(user) {
    webservice.deleteConfirm(user.name,"deleteUser",user.id,script,model).then(function(response) {
      if(response) {
        $scope.filterUsers();
      }
    });
  };

  $scope.upload = function(file,invalidFiles) {
    if(file!==null) {
      webservice.exclusiveCall('upload',{'user':model.user},script,model,file).then(function() {
        $scope.load();
      });
    } else if(invalidFiles.length>0) {
      var error=invalidFiles[0].$error;
      if(error=='maxSize') {
        errorlog.error(tools.lang({'en':'Please use image editing software to reduce the size below 1MB','nl':'Gebruik beeldbewerkingssoftware om te verkleinen tot minder dan 1MB','fr':'Please use image editing software to reduce the size below 1MB'}));
      } else if(error=='pattern') {
        errorlog.error(tools.lang({'en':'Only images are allowed','nl':'Enkel afbeeldingen zijn toegestaan','fr':'Only images are allowed'}));
      } else {
        errorlog.error(error);
      }
    }
  };

  $scope.lockedClass = function(lUser) {
    var result='';
    if(lUser) {
      if(lUser.active==='0') {
        result='glyphicon-ban-circle';
      } else {
        result='glyphicon-play';
      }
    }
    return result;
  };

  $scope.createRight = function(rgh) {
    if(rgh) {
      model.right.user=model.user.id;
      model.right.rgh=rgh;
      webservice.call("createRight",{
        "right":tools.whitelist(model.right,["user","rgh"])
      },script,model).then(function(response) {
        if(response) {
          $scope.updateRights();
          model.right={'rgh':''};
        }
      });
    }
  };

  $scope.updateRights = function() {
    model.user.rights=model.users[model.user.id].rights;
  };

  $scope.deleteRight = function(right) {
    webservice.deleteConfirm(tools.label(parameters.RGH[right.rgh]),"deleteRight",right.id,script,model).then(function(response) {
      if(response) {
        $scope.updateRights();
      }
    });
  };

  $scope.load = function() {
    if(!model.calling) {
      model.calling=true;
      webservice.call("load",{},script,model).then(function() {
        model.calling=false;
        $scope.filterUsers();
      });
    }
  };

  tools.initAttributes(model,{
    "task":"l",
    "searchUser":"",
    "itemsPerPage":50,
    "totalItems":0,
    "page":1,
    'maxSize':5,
    "calling":false,
    "passwordReset":"0",
    'filteredUsers':[],
    'filters': {'name':{'propertyName':'name','pattern':user.name}},
    'orderedUsers':[],
    'sortings':[{propertyName:'name',reverse:false,order:1}]
  });
  $scope.load();

}]);

angular.module("app").controller("UsersPasswordResetController",["$scope","$stateParams","$timeout","tools","modelstore","parameters","webservice","errorlog",
                                                        function($scope,$stateParams,$timeout,tools,modelstore,parameters,webservice,errorlog) {
  
  var script='forgot';
  var model=modelstore.getModel(script);
  $scope.model=model;
  
  $scope.passwordReset = function() {
    if(model.password != model.confirmPassword) {
      errorlog.receiveError(tools.lang({'en':'Passwords do not match','nl':'Paswoorden zijn niet identiek','fr':'Les passwords ne sont pas egales'}));
    } else {
      if(!model.calling) {
        model.calling=true;
        var email=$stateParams.email;
        webservice.call("passwordReset",{
          "email":email,
          "token":$stateParams.token,
          "password":model.password
        },script,model).then(function(response) {
          model.calling=false;
          if(response) {
            webservice.setAuth(email,model.password);
            webservice.login().then(function() {
              tools.redirect($scope.buildHref("home"));
            });
          }
        });
      }
    }
  };
  
  tools.initAttributes(model,{
    "calling":false,
    "password":"",
    "confirmPassword":""
  });
  
  /*
  var id=navigation.getRouteId();
  var len=id.length;
  model.token=id.substr(len-26);
  model.email=id.substr(0,len-27);
  */
  
}]);
angular.module("app").controller("UsersMenuListController",["$scope","$state","tools","user","errorlog","modelstore","parameters","webservice",
                                                        function($scope,$state,tools,user,errorlog,modelstore,parameters,webservice) {
  
  var script="users/menuList";
  var model=modelstore.getModel(script);
  $scope.model=model;
  
  $scope.initMenuitem = function() {
    model.menuitem={
      "labelen":"",
      "labelnl":"",
      "labelfr":"",
      "parent":"0",
      "view":"",
      "hidden":"0",
      "param":""
    };
  };
  
  $scope.newMenuitem = function() {
    $scope.initMenuitem();
    model.task="c";
    $scope.calculateParents();
    $scope.calculateSettings();
  };
  
  $scope.editMenuitem = function(menuitem) {
    model.menuitem=tools.clone(menuitem);
    model.task="u";
    $scope.calculateParents();
    $scope.calculateSettings();
  };

  $scope.calculateSettings = function() {
    var state=$state.get(model.menuitem.view.replace('/',' ').replace(/\b\w/g, function(char) {
        return char.toUpperCase();
      }).replace(' ','').replace(/\b\w/g, function(char) {
        return char.toLowerCase();
      })
    );
    model.menuitem.showSettings=state!==null && 'settings' in state && angular.isDefined(state.params) && 'lang' in state.params && 'settings' in state.params && $scope.tools.getLength(state.params)===2;
    model.menuitem.stateSettings=null;
    model.menuitem.settings={};
    if(model.menuitem.showSettings) {
      model.menuitem.stateSettings=state.settings;
      var settings=Object.entries(state.settings).reduce(function(settings,setting) {
        settings[setting[0]]=state.settings[setting[0]].type==='paramArray'?[]:null;
        return settings;
      },{});
      model.menuitem.settings=model.menuitem.param.split('&').reduce(function(settings,viewParam) {
        var viewParamKeyAndValue=viewParam.split('=');
        if(viewParamKeyAndValue.length===2 && angular.isDefined(settings[viewParamKeyAndValue[0]])) {
          var key=viewParamKeyAndValue[0];
          var value=viewParamKeyAndValue[1];
          if(state.settings[key].type==='paramArray') {
            try {
              value=angular.fromJson(value);
            } catch(e) {
              value=[];
            }
            if(!angular.isArray(value) || $scope.tools.getLength(value)===0) {
              value=[];
            }
          }
          settings[key]=value;
        }
        return settings;
      },settings);
    }
  }
  
  $scope.replaceMenuitem = function() {
    model.menuitem.role=model.role;
    model.menuitem.param=Object.entries(model.menuitem.settings).reduce(function(param,setting) {
      var key=setting[0];
      var value=setting[1] || '';
      if(model.menuitem.stateSettings[key].type==='paramArray') {
        value=tools.getLength(value)===0?'':angular.toJson(value);
      }
      return param+(param==='' || value===''?'':'&')+(value===''?'':key+'='+value);
    },'');
    webservice.call("replaceMenuitem",{"menuitem":tools.whitelist(
      model.menuitem,
      ['labelen','labelnl','labelfr','role','parent','view','hidden','sort','param']
    )},script,model).then(function(response) {
      if(response) {
        model.task="l";
      }
    });
  };
  
  $scope.deleteMenuitem = function(menuitem) {
    webservice.deleteConfirm(tools.label(menuitem),"deleteMenuitem",menuitem.id,script,model);
  };
  
  $scope.sort =function(menuitem,direction) {
    webservice.call('sort',{"id":menuitem.id,"direction":direction},script,model);
  };

  $scope.calculateParents = function() {
    model.parents=tools.addElement(tools.exclude(tools.match(model.menuitems,{'role':model.role,'parent':'0'}),{'id':model.menuitem.id}),{'id':'0','labelen':'-- None --','labelnl':'-- Geen --','labelfr':'-- Aucun --','sort':0,'params':''});
  };

  $scope.load = function() {
    return webservice.call("load",{},script,model);
  };
  
  tools.initAttributes(model,{
    "role":"EMPADM",
    "task":"l",
    "parents":[]
  });
  $scope.load();
  
}]);
var app = angular.module('app');
angular.module('app').config(['ChartJsProvider', function (ChartJsProvider) {
  // Configure all charts
  ChartJsProvider.setOptions({
    responsive: true,
    maintainAspectRatio: false
  });
}]);

angular.module('app').controller('UsersHomeController', ['$scope', '$interval', 'tools', 'modelstore', 'parameters', 'webservice', 'config',
  function ($scope, $interval, tools, modelstore, parameters, webservice, config) {

    var script = 'users/home';
    var model = modelstore.getModel(script);
    $scope.model = model;

    $scope.load = function () {
      if (!model.calling) {
        model.calling = true;
        modelstore.cleanModel(['employeecommunications'], model);
        webservice.call('load', {}, script, model).then(function () {
          model.calling = false;
        });
      }
    };
    webservice.afterLogin().then(function () {
      $scope.load();
    });

    tools.initAttributes(model, {
      'calling': false,
    });
  }])


angular.module('app').controller('UsersEmployeeCommunicationsController',['$scope','tools','modelstore','parameters','webservice',
                                            function($scope,tools,modelstore,parameters,webservice) {

  var script='users/employeeCommunications';
  var model=modelstore.getModel(script);
  $scope.model=model;

  $scope.load = function() {
    if(!model.calling) {
      model.calling=true;
      modelstore.cleanModel(['employeecommunications'],model);
      webservice.call('load',{},script,model).then(function() {
        model.calling=false;
      });
    }
  };

  $scope.startCreate = function() {
    model.employeecommunication={
      'subject':'',
      'body':'',
      'expiry':''
    };
    model.task='c';
  };

  $scope.startUpdate = function(employeecommunication) {
    model.backupEmployeeCommunications[employeecommunication.id]=tools.clone(employeecommunication);
    model.employeecommunication=employeecommunication;
    model.task='u';
  };

  $scope.cancel = function() {
    if(model.employeecommunication.id in model.backupEmployeeCommunications) {
      modelstore.addRecord('employeecommunications', model.backupEmployeeCommunications[model.employeecommunication.id], model);
    }
    model.task='l';
  };

  $scope.getReplaceParams = function() {
    var employeecommunication=tools.clone(model.employeecommunication);
    employeecommunication.expiry=tools.dateFromJava(employeecommunication.expiry);
    return {'employeecommunication':tools.whitelist(employeecommunication, ['subject','body','expiry'])};
  };

  $scope.create = function() {
    if(!model.calling){
      model.calling=true;
      webservice.call('create',$scope.getReplaceParams(), script, model).then(function(response) {
        model.calling=false;
        if(response!==false) {
          model.task='l';
        }
      })
    }
  };

  $scope.delete = function(employeecommunication) {
    webservice.deleteConfirm(employeecommunication.subject, 'delete', employeecommunication.id, script, model);
  };


  $scope.update = function() {
    if(!model.calling){
      model.calling = true;
      webservice.call('update',$scope.getReplaceParams(),script,model).then(function(response) {
        model.calling=false;
        if(response!==false) {
          model.task='l';
        }
      });
    }
  };

  webservice.afterLogin().then(function() {
    $scope.load();
  });
  tools.initAttributes(model,{
    'calling':false,
    'task':'l',
    'backupEmployeeCommunications':{},
    'expiryOpened':false
  });

}]);

angular.module("app").controller("TestTestController",["$scope","$q","$log","$http","$websocket","$timeout","config","tools","parameters","modelstore","webservice","ctep",
                                            function($scope,$q,$log,$http,$websocket,$timeout,config,tools,parameters,modelstore,webservice,ctep) {
  var script="test/test";
  var model=modelstore.getModel(script);
  $scope.model=model;

  $scope.test = function(test) {
    webservice.call("test"+test,{},script,model);
  };

  $scope.sync = function(test,restartPoint) {
    webservice.exclusiveCall("sync"+test,{'restartPoint':angular.isDefined(restartPoint)?restartPoint:"","field":model.syncField},script,model).then(function(response) {
      if(response!==true && response!==false) {
        $scope.sync(test,response);
      }
    });
  };

  $scope.migrate = function(test) {
    webservice.exclusiveCall("migrate"+test,{"visitId":model.visitId},script,model).then(function(response) {
      if(response===true) {
        $timeout(function() {
          $scope.migrate(test);
        },2000);
      }
    });
  };

  tools.initAttributes(model,{
    "visitId":"",
    "syncField":""
  });
  
}]);

angular.module('app').controller('SettingsPacketsController',['$scope','tools','parameters','modelstore','webservice', 'activitiesService','hotelsService',
                                            function($scope,tools,parameters,modelstore,webservice,activitiesService,hotelsService) {

  var script='settings/packets';
  var model=modelstore.getModel();
  $scope.model=model;
  $scope.activitiesService=activitiesService;
  $scope.hotelsService=hotelsService;

  var packetFields=['label1','label2','label3','company','private'];
  var packetcomponentFields=['packet','param1','param2','day','hrs','attr1','attr2'];

  $scope.splitParam = function(){
    for (var i in model.packets) {
      var packetcomponents=tools.join(model.packets[i],'packetcomponents',model);
      var i,packetcomponent;
      for(i in packetcomponents) {
        packetcomponent=packetcomponents[i];
        packetcomponent.type=tools.substr(packetcomponent.param2,0,3);
      }
    }
  };

  $scope.resetAttributes = function(){
    model.backupPackets={};
    model.backupPacketcomponents={};
  };

  $scope.load = function() {
    webservice.exclusiveCall('load',{},script,model).then(function() {
      $scope.splitParam();
    });
  };

  $scope.createPacket = function() {
    webservice.exclusiveCall('createPacket',{},script,model).then(function(response) {
      $scope.editPacket(model.packets[response]);
    });
  };

  $scope.editPacket = function(packet) {
    model.backupPackets[packet.id]=tools.clone(packet);
    var packetcomponents=tools.join(packet,'packetcomponents',model);
    var i,packetcomponent;
    for(i in packetcomponents) {
      packetcomponent=packetcomponents[i];
      model.backupPacketcomponents[packetcomponent.id]=tools.clone(packetcomponent);
    }
    packet.editing=true;
  };

  $scope.cleanTemporaryPacketcomponents = function(packet) {
    var packetcomponents=tools.join(packet,'packetcomponents',model);
    var i,packetcomponent;
    for (i in packetcomponents) {
      packetcomponent=packetcomponents[i];
      if ("new" in packetcomponent){
        modelstore.removeRecord('packetcomponents',packetcomponent.id,model);
      }
    }
  };

  $scope.updatePacket = function(packet) {
    webservice.exclusiveCall('updatePacket',{
      'packet':tools.whitelist(packet,packetFields),
      'packetcomponents':tools.whitelist(tools.join(packet,'packetcomponents',model),packetcomponentFields)
    },script,model).then(function() {
      $scope.splitParam();
      $scope.cleanTemporaryPacketcomponents(packet);
      $scope.resetAttributes();
      packet.editing=false;
    });
  };

  $scope.cancelPacket = function(packet) {
    modelstore.addRecord('packets',model.backupPackets[packet.id],model);
    var packetcomponents=model.backupPacketcomponents;
    var i,packetcomponent;
    for (i in packetcomponents) {
      packetcomponent=packetcomponents[i];
      if(packetcomponent.packet==packet.id) {
        modelstore.addRecord('packetcomponents',model.backupPacketcomponents[packetcomponents[i].id],model);
      }
    }
    $scope.resetAttributes();
    $scope.cleanTemporaryPacketcomponents(packet);
    packet.editing=false;
  };

  $scope.deletePacket = function(packet) {
    webservice.deleteConfirm(tools.label(packet),'deletePacket',packet.id,script,model);
  };

  $scope.createPacketcomponent = function(packet) {
    modelstore.addRecord('packetcomponents',{
      'id':tools.getMinIdMinusOne(model.packetcomponents),
      'packet':packet.id,
      'type':'',
      'param1':'',
      'param2':'',
      'day':'1',
      'hrs':'',
      'attr1':'',
      'attr2':'',
      'new':true
    },model);
    $scope.splitParam();
  };

  $scope.deletePacketcomponent = function(packetcomponent) {
    modelstore.removeRecord('packetcomponents',packetcomponent.id,model);
  };

  tools.initAttributes(model,{
    'backupPackets':{},
    'backupPacketcomponents':{}
  });
  $scope.load();
  
}]);
angular.module("app").controller("SettingsListRulesController",["$scope","$uibModal","tools","modelstore","parameters","webservice",
                                            function($scope,$uibModal,tools,modelstore,parameters,webservice) {

  var script="settings/listRules";
  var model=modelstore.getModel(script);
  $scope.model=model;

  $scope.loadGroups = function() {
    modelstore.cleanModel(["rulegroups","rulemembers"],model);
    if(!model.calling) {
      model.calling=true;
      webservice.call("loadGroups",{'category':model.category.id,'subcategory':model.subcategory.id},script,model).then(function(response) {
        model.calling=false;
        if(response) {
          $scope.softCreateRulegroup();
        }
      });
    }
  };

  $scope.filterParameters = function(index,tbl) {
    var result;
    tbl=parameters['notDel'+tbl];
    if(index==0) {
      result=tbl;
    } else {
      result=[];
      var i,j,id,idSubstr;
      filterParametersILoop:
      for(i in tbl) {
        id=tbl[i].id;
        filterParametersJLoop:
        for(j=0;j<index;j++) {
          idSubstr=id.substr(j*3,3);
          if(!(idSubstr=='***' || idSubstr==model.params[j].substr(j*3,3))) {
            continue filterParametersILoop;
          }
        }
        result.push(tbl[i]);
      }
    }
    return result;
  };

  $scope.resetParameters = function(index) {
    var i;
    for(i=index;i<3;i++) {
      model.params[i]='';
    }
    model.param='';
    model.rulemember=null;
    model.rulegroup=null;
    if(model.subcategory!=null) {
      if(index==model.subcategory.tbls.length) {
        for(i=0;i<index;i++) {
          model.param+=model.params[i].substr(3*i,3);
        }
        $scope.softCreateRulegroup();
      }
    }
  };

  $scope.setCategory = function(category) {
    if(model.category.id!=category.id) {
      model.category=category;
      model.subcategory=null;
      $scope.resetParameters(0);
      modelstore.cleanModel(["rulegroups","rulemembers"],model);
      if(tools.getLength(model.category.subcategories)==1) {
        $scope.setSubcategory(tools.toArray(model.category.subcategories)[0]);
      }
    }
  };

  $scope.setSubcategory = function(subcategory) {
    if(model.subcategory==null || model.subcategory.id!=subcategory.id) {
      model.subcategory=subcategory;
      $scope.resetParameters(0);
      $scope.loadGroups();
    }
  };

  $scope.setParam = function(index,param) {
    model.params[index]=param.id;
    $scope.resetParameters(index+1);
  };

  $scope.softCreateRulegroup = function() {
    if((model.param!='' || model.subcategory.tbls.length==0) && tools.getLength(tools.match(model.rulemembers,{'param':model.param}))==0) {
      if(!model.calling) {
        model.calling=true;
        webservice.call("createDefaultRulegroup",{'category':model.category.id,'subcategory':model.subcategory.id,'param':model.param},script,model).then(function(response) {
          model.calling=false;
          if(response) {
            $scope.setRulemember();
          }
        });        
      }
    } else {
      $scope.setRulemember();
    }
  };

  $scope.setRulemember = function() {
    model.rulemember=tools.match(model.rulemembers,{'param':model.param})[0];
    model.rulegroup=model.rulegroups[model.rulemember.rulegroup];
  };

  $scope.togglePublishRulegroup = function() {
    if(!model.calling) {
      model.calling=true;
      webservice.call("togglePublishRulegroup",{'rulegroup':model.rulegroup.id},script,model).then(function(response) {
        model.calling=false;
        if(response) {
          $scope.setRulemember();
        }
      });
    }
  };

  $scope.paramToParams = function(param) {
    var result=['','',''];
    var i,j,k,tbl,compareParam,compareParamSubstr;
    var paramSubstrs=[];
    paramToParamsILoop:
    for(i in model.subcategory.tbls) {
      paramSubstrs.push(param.substr(i*3,3));
      tbl=parameters[model.subcategory.tbls[i]];
      paramToParamsJLoop:
      for(j in tbl) {
        compareParam=tbl[j].id;
        paramToParamsKLoop:
        for(k=0;k<=i;k++) {
          compareParamSubstr=compareParam.substr(k*3,3);
          if(!(compareParamSubstr=='***' || compareParamSubstr==paramSubstrs[k])) {
            continue paramToParamsJLoop;
          }
        }
        result[i]=compareParam;
        break paramToParamsJLoop;
      }
    }
    return result;
  };

  $scope.paramsToLabel = function(params) {
    var result="";
    for(var i in params) {
      if((model.subcategory.tbls[i] in parameters) && params[i]!='') {
        result+=' '+tools.short(parameters[model.subcategory.tbls[i]][params[i]]);
      }
    }
    return result.substr(1);
  };

  $scope.selectRulemember = function(param) {
    model.params=$scope.paramToParams(param);
    $scope.resetParameters(model.subcategory.tbls.length);
  };

  $scope.addToRulegroup = function(rulegroup) {
    if(tools.getLength(tools.join(model.rulegroup,'rulemembers',model))==1) {
      $uibModal.open({
        'template': '<div class="modal-body" id="modal-body">{{wording}}</div><div class="modal-footer"><button class="btn btn-primary" type="button" ng-click="ok()">OK</button><button class="btn btn-warning" type="button" ng-click="cancel()">Cancel</button></div>',
        'controller': 'ConfirmModalController',
        'resolve': {
          'wording': function() {
            return tools.lang({
              'en':'Adding '+$scope.paramsToLabel(model.params)+' to a group overwrites its current settings. Are you sure?',
              'nl':$scope.paramsToLabel(model.params)+' toevoegen aan een groep overschrijft de huidige instellingen. Bent u zeker?',
              'fr':'Ajouter '+$scope.paramsToLabel(model.params)+' \u00E0 un groupe \u00E9crase le r\u00E9glage actuel. Etes-vous sur?'
            });
          }
        }
      }).result.then(function(){
        $scope.confirmedAddToRulegroup(rulegroup);
      });
    } else {
      $scope.confirmedAddToRulegroup(rulegroup);
    }
  };

  $scope.confirmedAddToRulegroup = function(rulegroup) {
    if(!model.calling) {
      model.calling=true;
      webservice.call("addToRulegroup",{'rulemember':model.rulemember.id,'rulegroup':rulegroup.id},script,model).then(function(response) {
        model.calling=false;
        if(response) {
          $scope.setRulemember();
        }
      });
    }
  };

  $scope.removeFromRulegroup = function() {
    if(!model.calling) {
      model.calling=true;
      webservice.call("removeFromRulegroup",{'rulemember':model.rulemember.id},script,model).then(function(response) {
        model.calling=false;
        if(response) {
          $scope.setRulemember();
        }
      });
    }
  };

  $scope.getIntervals = function() {
    if(model.rulegroup!=null) {
      return tools.greaterEqual(tools.join(model.rulegroup,'ruleintervals',model),'enddate',model.startdate);
    }
  };

  $scope.getIntervalWidth = function(ruleinterval) {
    var startdate=new Date(Math.max.apply(null,[model.startdate,ruleinterval.startdate]));
    var enddate=new Date(Math.min.apply(null,[model.enddate,ruleinterval.enddate]));
    return ($scope.dayDiff(startdate,enddate)+1.0)/($scope.dayDiff(model.startdate,model.enddate)+1.0)*100.0;
  };

  $scope.dayDiff = function(first,second) {
    return Math.round(Math.abs((first.getTime()-second.getTime())/(24*60*60*1000)));
  };

  $scope.initCreateRuleinterval = function() {
    model.ruleinterval={
      'notCreated':true,
      'startdate':new Date(),
      'enddate':new Date(),
      'result':0,
      'startdateOpened':false,
      'enddateOpened':false
    };
    if(model.category.schedules) {
      model.ruleinterval.result='1';
    }
  };

  var categories={
    'SCH':{'id':'SCH','en':'Schedules','nl':'Openingsuren','fr':'Heures d\u0027ouverture','groups':true,'schedules':true,'subcategories':{
      'ACT':{'id':'ACT','en':'Activities','nl':'Activiteiten','fr':'Activit\u00E9s','tbls':['ACT','FRM']},
      'MEA':{'id':'MEA','en':'Meals','nl':'Maaltijden','fr':'Repas','tbls':['RES','DSH']}
    }},
    'CAP':{'id':'CAP','en':'Capacities','nl':'Capaciteiten','fr':'Capacit\u00E9s','groups':true,'schedules':false,'subcategories':{
      'ACT':{'id':'ACT','en':'Activities','nl':'Activiteiten','fr':'Activit\u00E9s','tbls':['ACT','FRM','UNT']},
      'MEA':{'id':'MEA','en':'Meals','nl':'Maaltijden','fr':'Repas','tbls':['RES','DSH']}
    }},
    'DIS':{'id':'DIS','en':'Discount schedules','nl':'Kortingperiodes','fr':'Periodes reduction','groups':false,'schedules':true,'subcategories':{
      'DEF':{'id':'DEF','en':'Discount schedules','nl':'Kortingperiodes','fr':'Periodes reduction','tbls':['PSC']}
    }}
  };
  var aYearFromNow=new Date();
  aYearFromNow.setFullYear(aYearFromNow.getFullYear() + 1);
  tools.initAttributes(model,{
    'calling':false,
    'categories':categories,
    'category':categories.SCH,
    'subcategory':categories.SCH.subcategories.ACT,
    'params':['KAY','KAYDUR',''],
    'param':'KAYDUR',
    'rulemember':null,
    'rulegroup':null,
    'startdate':new Date(),
    'enddate':aYearFromNow,
    'startdateOpened':false,
    'enddateOpened':false,
    'dateOptions':{
      'maxDate': new Date(2099,11,31),
      'minDate': new Date(),
      'startingDay': 1
    },
    'ruleinterval':null
  });
  webservice.afterLogin().then(function() {
    $scope.loadGroups();
  });
  
}]);
var formbuttonsService=function(parameters,tools) {
  this.parameters=parameters;
  this.tools=tools;
};

formbuttonsService.prototype.categories = {
  'wristband':{'id':'wristband','en':'Wristband','nl':'Bandje','fr':'Bracelet'},
  'activity':{'id':'activity','en':'Activity','nl':'Activiteit','fr':'Activit\u00E9'},
  'guide':{'id':'guide','en':'Guide','nl':'Gids','fr':'Guide'},
  'accom':{'id':'accom','en':'Stay overnight','nl':'Overnachting','fr':'S\u00E9journer'},
  'pack':{'id':'pack','en':'Packs','nl':'Packs','fr':'Packs'},
  'submenu':{'id':'submenu','en':'Submenu','nl':'Submenu','fr':'Submenu'}
};

formbuttonsService.prototype.getFormbuttonPredateselector = function(formbutton) {
  var result='';
  if(angular.isDefined(this.parameters.FIN[formbutton.fixeddateinterval])) {
    result=tools.label(this.parameters.FIN[formbutton.fixeddateinterval]);
  } else {
    var fixeddateinterval=formbutton.fixeddateinterval.replace('interval','');
    var ffo=formbutton.fca.substr(0,2);
    result=this.parameters.notDelArrayFIN.reduce(function(acc,fin) {
      if(fin.id.substr(0,2)===ffo && fixeddateinterval===fin.field3) {
        acc=tools.label(fin);
      }
      return acc;
    },result);
  }
  return '"'+result+'"';
};

angular.module("app").service("formbuttonsService",['parameters','tools',formbuttonsService]);

angular.module('app').controller('SettingsFormbuttonListController',['$scope','$sce','tools','parameters','modelstore','webservice',
                                            function($scope,$sce,tools,parameters,modelstore,webservice) {

  var script='settings/formbuttonList';
  var model=modelstore.getModel(script);
  $scope.model=model;

  $scope.selectFfo = function(ffo) {
    if(model.ffo!==ffo.id) {
      model.ffo=ffo.id;
      model.fca='';
      model.selectedFca={};
      model.dayduration=0;
      model.selectedDayduration={};
      model.fcas=$scope.getFilteredFca();
      model.daydurations=$scope.getFilteredDayduration();
    }
  };

  $scope.selectFca = function(fca) {
    model.fca=fca.id;
  };

  $scope.getFilteredFca = function() {
    var result={};
    if('notDelArrayFCA' in parameters) {
      result=parameters.notDelArrayFCA.reduce(function(acc,fca) {
        if(fca.id.substr(0,2)===model.ffo) {
          fca.label=tools.label(fca)+' ('+tools.getLength($scope.getFilteredFormbuttons(fca.id))+')';
          acc[fca.field1+fca.id]=fca;
        }
        return acc;
      },result);
    }
    result=Object.values(result);
    if(tools.getLength(result)===1) {
      var fca=tools.first(result);
      model.selectedFca={'id':fca.id};
      model.fca=fca.id;
    }
    return result;
  };

  $scope.selectDayduration = function(dayduration) {
    model.dayduration=dayduration.id;
    model.fcas=$scope.getFilteredFca();
  };

  $scope.getFilteredDayduration = function() {
    var result={0:{'id':0,'label':tools.lang({'en':'All','nl':'Alle','fr':'Tout'})}};
    var dayduration;
    if('formbuttons' in model) {
      result=tools.toArray(model.formbuttons).reduce(function(acc,formbutton) {
        if(formbutton.fca.substr(0,2)===model.ffo) {
          dayduration=formbutton.dayduration;
          if(dayduration>0) {
            result[dayduration]={'id':dayduration,'label':dayduration};
          } else {
            result[dayduration]={'id':dayduration,'label':tools.lang({'en':'All','nl':'Alle','fr':'Tout'})};
          }
        }
        return acc;
      },result);
    }
    result=Object.values(result);
    dayduration=tools.first(result).id;
    model.selectedDayduration={'id':dayduration};
    model.dayduration=dayduration;
    return result;
  };

  $scope.getFilteredFormbuttons = function(fca) {
    var result={};
    var formbuttons=tools.match(model.formbuttons,{'fca':fca});
    if(tools.numberIn(model.dayduration)===0) {
      result=formbuttons;
    } else {
      result=tools.match(formbuttons,{'dayduration':model.dayduration});
    }
    return result;
  }

  $scope.getFormbuttonPredateselector = function(formbutton) {
    var result='';
    if(angular.isDefined(parameters.FIN[formbutton.fixeddateinterval])) {
      result=tools.label(parameters.FIN[formbutton.fixeddateinterval]);
    } else {
      var fixeddateinterval=formbutton.fixeddateinterval.replace('interval','');
      result=parameters.notDelArrayFIN.reduce(function(acc,fin) {
        if(fin.id.substr(0,2)===model.ffo && fixeddateinterval===fin.field3) {
          acc=tools.label(fin);
        }
        return acc;
      },result);
    }
    return '"'+result+'"';
  }

  $scope.trustTemplates = function() {
    for(var i in model.templates) {
      if(angular.isString(model.templates[i].rendered)) {
        model.templates[i].trustedRendered=$sce.trustAsHtml(model.templates[i].rendered);
      }
    }
  };

  $scope.load = function() {
    modelstore.cleanModel(['formbuttons','templates'],model);
    webservice.call('load',{'date':tools.dateFromJava(model.date)},script,model).then($scope.trustTemplates);
  };

  $scope.createFormbutton = function() {
    webservice.exclusiveCall('createFormbutton',{
      'fca':model.fca,
      'dayduration':model.dayduration,
      'startdate':tools.dateFromJava(model.startdate),
      'enddate':tools.dateFromJava(model.enddate)
    },script,model);
  };

  $scope.sort = function(a) {
    return parseInt(a.sort);
  };

  $scope.isMin = function(formbutton) {
    var formbuttons=$scope.getFilteredFormbuttons(model.fca);
    for(var i in formbuttons) {
      if(parseInt(formbuttons[i].sort)<parseInt(formbutton.sort)) {
        return false;
      }
    }
    return true;
  };

  $scope.isMax = function(formbutton) {
    var formbuttons=$scope.getFilteredFormbuttons(model.fca);
    for(var i in formbuttons) {
      if(parseInt(formbuttons[i].sort)>parseInt(formbutton.sort)) {
        return false;
      }
    }
    return true;
  };

  $scope.updateSort = function(formbutton,direction) {
    webservice.call('updateSort',{'id':formbutton.id,'direction':direction,'date':tools.dateFromJava(model.date),'dayduration':model.dayduration},script,model);
  };
  
  $scope.deleteFormbutton = function(formbutton) {
    webservice.deleteConfirm(tools.lang({'en':'form button','nl':'formulier knop','fr':'form button'}),'deleteFormbutton',formbutton.id,script,model);
  };

  $scope.duplicate = function(formbutton) {
    webservice.call('duplicate',{'formbuttonId':formbutton.id},script,model).then($scope.trustTemplates);
  };

  $scope.dateOptions={
    maxDate: new Date(9999,11,31),
    minDate: new Date(1000,0,1),
    startingDay: 1
  };

  $scope.translations={
    'checkAll':tools.lang({'en':'Check all','nl':'Alles selecteren','fr':'S\u00E9llectioner tout'}),
    'uncheckAll':tools.lang({'en':'Uncheck all','nl':'Alles deselecteren','fr':'Des\u00E9llectioner tout'}),
    'selectionCount':tools.lang({'en':'checked','nl':'Geselecteerd','fr':'S\u00E9llectioner'}),
    'searchPlaceholder':tools.lang({'en':'Search...','nl':'Zoek...','fr':'Chercher...'}),
    'buttonDefaultText':tools.lang({'en':'Select','nl':'Selecteer','fr':'S\u00E9llectioner'}),
    'dynamicButtonTextSuffix':tools.lang({'en':'checked','nl':'Geselecteerd','fr':'S\u00E9llectioner'}),
    'selectGroup':tools.lang({'en':'Select All:','nl':'Selecteer Alles:','fr':'S\u00E9llectioner tout:'})
  };

  tools.initAttributes(model,{
    'selectedFfo':{},
    'selectedFca':{},
    'selectedDayduration':{'id':0},
    'ffo':'',
    'fca':'',
    'dayduration':0,
    'ffos':[],
    'fcas':[],
    'daydurations':[{'id':0,'label':tools.lang({'en':'All','nl':'Alle','fr':'Tout'})}],
    'startdate':tools.dateToJava('1000-01-01'),
    'startdateOpened':false,
    'enddate':tools.dateToJava('9999-12-31'),
    'enddateOpened':false,
    'date':new Date(),
    'dateOpened':false,
    'settings':{
      'scrollable':true,
      'scrollableHeight':'300px',
      'selectionLimit':1,
      'smartButtonMaxItems':1,
      'showCheckAll':false,
      'showUncheckAll':false,
      'enableSearch':true,
      'styleActive':true,
      'keyboardControls':true,
      'closeOnSelect':true,
      'buttonClasses':'btn btn-default js-dropdown'
    }
  });

  $scope.$watch('model.date.getTime()',function(newVal) {
    $scope.load();
  });

  webservice.afterLogin().then(function() {
    if(model.ffo==='') {
      model.ffos=tools.orderBy(parameters.notDelArrayFFO.reduce(function(acc,ffo) {
        ffo.label=tools.label(ffo);
        acc.push(ffo);
        return acc;
      },[]),tools.lang({'en':'labelen','nl':'labelnl','fr':'labelfr'}));
    }
    $scope.load();
  });
  
}]);
angular.module('app').controller('EditFormbuttonController',['$scope','$sce','$timeout','$stateParams','$uibModal','tools','parameters','user','modelstore','webservice','formbuttonsService','activitiesService','errorlog',
                                            function($scope,$sce,$timeout,$stateParams,$uibModal,tools,parameters,user,modelstore,webservice,formbuttonsService,activitiesService,errorlog) {

  var script='settings/editFormbutton';
  var model=modelstore.getModel(script);
  $scope.model=model;
  $scope.formbuttonsService=formbuttonsService;
  $scope.activitiesService=activitiesService;
  var initializing=true;

  $scope.initFormbuttoncomponent = function() {
    model.formbuttoncomponent={
      'param1':'AC',
      'param2':'',
      'param3':'',
      'pricing':'DEFAULT',
      'repetition':'ONCE',
      'dayoffset':'-1',
      'hrs':'',
      'quantitymultiplier':'PACKS',
      'quantity':'1',
      'adultcountbehaviour':'CHOICE',
      'adultcount':'0',
      'childcountbehaviour':'CHOICE',
      'childcount':'0',
      'act':'',
      'res':'',
      'htl':'',
      'unitprice':'0'
    };
  };

  $scope.filteredHra = function(formbuttoncomponent) {
    var result=[];
    if(formbuttoncomponent.param1==='HS' && formbuttoncomponent.param2!=='') {
      var htlId=formbuttoncomponent.param2.substr(0,3);
      var i,hra;
      for(i in parameters.notDelArrayHRA) {
        hra=parameters.notDelArrayHRA[i];
        if(hra.id.substr(0,3)===htlId && hra.field2==='1') {
          result.push(hra);
        }
      }
    }
    return result;
  };

  $scope.filteredFin = function(formbutton) {
    var result=[];
    if(angular.isDefined(formbutton.fca)) {
      var ffoId=formbutton.fca.substr(0,2);
      var i,fin;
      for(i in parameters.notDelArrayFIN) {
        fin=parameters.notDelArrayFIN[i];
        if(fin.id.substr(0,2)===ffoId || fin.id===formbutton.fixeddateinterval) {
          result.push(fin);
        }
      }
    }
    return result;
  };

  $scope.afterLoad = function() {
    model.formbutton.priceCat='ZE';
    model.formbutton.priceAct='';
    model.formbutton.priceFrm='';
    model.formbutton.priceUnt='';
    model.formbutton.priceRes='';
    model.formbutton.priceDshCat='Undefined';
    model.formbutton.priceDsh='';
    if(model.formbutton.pricekey!=='') {
      model.formbutton.priceCat=model.formbutton.pricekey.substr(0,2);
      if(model.formbutton.priceCat=='AC') {
        model.formbutton.priceAct=model.formbutton.pricekey.substr(2,3);
        model.formbutton.priceFrm=model.formbutton.pricekey.substr(2,6);
        model.formbutton.priceUnt=model.formbutton.priceAct+'***'+model.formbutton.pricekey.substr(8,2);
      } else if(model.formbutton.priceCat=='ME') {
        model.formbutton.priceRes=model.formbutton.pricekey.substr(2,3);
        model.formbutton.priceDsh=model.formbutton.pricekey.substr(2,6);
        model.formbutton.priceDshCat=(model.formbutton.priceDsh in model.parameters.DSH)?model.parameters.DSH[model.formbutton.priceDsh].field2:'Undefined';
      }
    }
    var i,formbuttoncomponent;
    for(i in model.formbuttoncomponents) {
      formbuttoncomponent=model.formbuttoncomponents[i];
      if(formbuttoncomponent.param1=='AC') {
        formbuttoncomponent.act=formbuttoncomponent.param2.substr(0,3);
      } else if(formbuttoncomponent.param1=='ME') {
        formbuttoncomponent.res=formbuttoncomponent.param2.substr(0,3);
      } else if(formbuttoncomponent.param1=='HS') {
        formbuttoncomponent.htl=formbuttoncomponent.param2.substr(0,3);
      }
    }
  };

  $scope.load = function() {
    initializing=true;
    modelstore.cleanModel(['formbuttons','templates','formbuttonrelations','formbuttoncomponents'],model);
    return webservice.exclusiveCall('load',{'id':$stateParams.id},script,model).then(function() {
      model.formbutton=model.formbuttons[$stateParams.id];
      for(var i in model.templates) {
        model.templates[i].trustedRendered=$sce.trustAsHtml(model.templates[i].rendered);
      }
      $scope.afterLoad();
      $timeout(function() { initializing = false; });
    });
  };

  $scope.updateFormbutton = function(scrollToId) {
    if(!initializing) {
      var formbutton=tools.clone(model.formbutton);
      formbutton.startdate=tools.dateFromJava(formbutton.startdate);
      formbutton.enddate=tools.dateFromJava(formbutton.enddate);
      formbutton.fixedstartdate=tools.dateFromJava(formbutton.fixedstartdate);
      formbutton.fixedenddate=tools.dateFromJava(formbutton.fixedenddate);
      var whitelist=['startdate','enddate','pricekey','clearbasket','singlequantity','labelen','labelnl','labelfr','hasfixeddate','fixedstartdate','fixedenddate','dayduration','fixeddateinterval','rawhtmlen','rawhtmlnl','rawhtmlfr','quantitylabelen','quantitylabelnl','quantitylabelfr','minpackquantity','adultcountbehaviour','adultcount','childcountbehaviour','childcount'];
      return webservice.exclusiveCall("updateFormbutton",{'formbutton':tools.whitelist(formbutton,whitelist)},script,model).then(function() {
        model.startdateOpened=false;
        model.enddateOpened=false;
        model.fixedstartdateOpened=false;
        model.fixedenddateOpened=false;
        $scope.scrollTo(scrollToId);
      });
    }
  };

  $scope.getDaydurations = function() {
    var result=[
      {'id':'0','labelen':'--Always--','labelnl':'--Altijd--','labelfr':'--Toujours--','order':0},
      {'id':'1','labelen':'1 day','labelnl':'1 dag','labelfr':'1 jour','order':1},
      {'id':'2','labelen':'2 days / 1 night','labelnl':'2 dagen / 1 nacht','labelfr':'2 jours / 1 nuit','order':2},
    ];
    for(var i=3;i<=31;i++) {
      result.push({'id':i.toString(),'labelen':i+' days / '+(i-1)+' nights','labelnl':i+' dagen / '+(i-1)+' nachten','labelfr':i+' jours / '+(i-1)+' nuits','order':i});
    }
    return result;
  }

  $scope.getOffsetOptions = function(repetition) {
    var result={};
    if(repetition==='ONCE') {
      result={
        '-1':{'id':'-1','labelen':'--Customer can choose--','labelnl':'--Klant kan kiezen--','labelfr':'--Client peut choisir--','order':-1}
      }
      for(var i=0;i<=31;i++) {
        result[i.toString()]={'id':i.toString(),'labelen':'Day '+(i+1),'labelnl':'Dag '+(i+1),'labelfr':'Jour '+(i+1),'order':i};
      }
    }
    return result; 
  }

  $scope.onDateChange = function(dateName,newVal) {
    if('startdate' in model.formbutton) {
      var dates={
        'startdate':model.formbutton.startdate,
        'enddate':model.formbutton.enddate,
        'fixedstartdate':model.formbutton.fixedstartdate,
        'fixedenddate':model.formbutton.fixedenddate
      };
      var newDate=new Date();
      newDate.setTime(newVal);
      dates[dateName]=newDate;
      Object.keys(dates).map(function(key) {
        dates[key]=tools.dateFromJava(dates[key]);
      });
      if(dates.startdate.length===10 && dates.enddate.length===10 && dates.fixedstartdate.length===10 && dates.fixedenddate.length===10) {
        $scope.updateFormbutton(dateName);
      }
    }
  };

  $scope.sort = function(a) {
    return parseInt(a.sort);
  };

  $scope.isMin = function(collection,record) {
    var records=model[collection];
    if(collection=='formbuttoncomponents') {
      records=tools.match(records,{'formbutton':record.formbutton});
    } else if(collection=="formbuttonrelations") {
      records=tools.match(records,{'parent':model.formbutton.id});
    }
    for(var i in records) {
      if(parseInt(records[i].sort)<parseInt(record.sort)) {
        return false;
      }
    }
    return true;
  };

  $scope.isMax = function(collection,record) {
    var records=model[collection];
    if(collection=='formbuttoncomponents') {
      records=tools.match(records,{'formbutton':record.formbutton});
    } else if(collection=="formbuttonrelations") {
      records=tools.match(records,{'parent':model.formbutton.id});
    }
    for(var i in records) {
      if(parseInt(records[i].sort)>parseInt(record.sort)) {
        return false;
      }
    }
    return true;
  };

  $scope.updateSort = function(collection,record,direction) {
    webservice.exclusiveCall('updateSort',{'collection':collection,'id':record.id,'direction':direction},script,model).then($scope.afterLoad);
  };

  $scope.fixFormbuttoncomponentParams = function(formbuttoncomponent) {
    if(formbuttoncomponent.param2=='') {
      if(formbuttoncomponent.param1=='AC') {
        formbuttoncomponent.param2=formbuttoncomponent.act+'***';
      } else if(formbuttoncomponent.param1=='ME') {
        formbuttoncomponent.param2=formbuttoncomponent.res+'***';
      } else if(formbuttoncomponent.param1=='HS') {
        formbuttoncomponent.param2=formbuttoncomponent.htl+'***';
      }
    }
  };

  $scope.createFormbuttoncomponent = function() {
    model.formbuttoncomponent.formbutton=model.formbutton.id;
    $scope.fixFormbuttoncomponentParams(model.formbuttoncomponent);
    webservice.exclusiveCall("createFormbuttoncomponent",{"formbuttoncomponent":model.formbuttoncomponent},script,model).then(function(response) {
      $scope.load().then(function() {
        $scope.editFormbuttoncomponent(model.formbuttoncomponents[response]);
      });
    });
  };

  $scope.editFormbuttoncomponent = function(formbuttoncomponent) {
    if(!formbuttoncomponent.editing) {
      $scope.cancelFormbuttoncomponent(formbuttoncomponent);
      model.backupFormbuttoncomponents[formbuttoncomponent.id]=tools.clone(formbuttoncomponent);
      formbuttoncomponent.unitprice=tools.amountOut(formbuttoncomponent.unitprice);
      formbuttoncomponent.editing=true;
    }
    model.editingFormbuttoncomponent=true;
  };

  $scope.cancelFormbuttoncomponent = function(formbuttoncomponent) {
    if(formbuttoncomponent.id in model.backupFormbuttoncomponents) {
      modelstore.addRecord("formbuttoncomponents",model.backupFormbuttoncomponents[formbuttoncomponent.id],model);
    }
    model.editingFormbuttoncomponent=false;
  };

  $scope.updateFormbuttoncomponent = function(formbuttoncomponent) {
    webservice.exclusiveCall("updateFormbuttoncomponent",{'formbuttoncomponent':formbuttoncomponent},script,model).then(function() {
      formbuttoncomponent.editing=false;
      model.editingFormbuttoncomponent=false;
      delete model.backupFormbuttoncomponents[formbuttoncomponent.id];
      $scope.afterLoad();
      $scope.scollTo('formbuttoncomponent_'+formbuttoncomponent.id);
    });
  };

  $scope.showRepetition = function() {
    return model.isHotelFFO || ('notDelArrayFIN' in parameters && parameters.notDelArrayFIN.reduce(function(isMultipledays,fin) {
      if(angular.isDefined(model.formbutton.fca)) {
        var ffo=model.formbutton.fca.substr(0,2);
        return isMultipledays || (ffo===fin.id.substr(0,2) && tools.numberIn(fin.field1)>0);
      } else {
        return isMultipledays;
      }
    },false));
  };

  $scope.showFormbuttonOffset = function(formbuttoncomponent) {
    return (model.formbutton.singlequantity=='1' || model.formbutton.hasfixeddate=='1') && tools.join(model.formbutton,'formbuttoncomponents',model).reduce(function(hasOffsetOptions,formbuttoncomponent) {
      return hasOffsetOptions || tools.getLength($scope.getOffsetOptions(formbuttoncomponent.repetition))>0;
    },false);
  }

  $scope.deleteFormbuttoncomponent = function(formbuttoncomponent) {
    webservice.deleteConfirm(tools.lang({'en':'component','nl':'component','fr':'component'}),'deleteFormbuttoncomponent',formbuttoncomponent.id,script,model);
  };

  $scope.calculatePackPrice = function() {
    var occupantcounts={
      'adultcount':tools.amountIn(model.formbutton.adultcount),
      'childcount':tools.amountIn(model.formbutton.childcount),
      'peoplecount':tools.amountIn(model.formbutton.adultcount)+tools.amountIn(model.formbutton.childcount)
    };
    if($scope.hasArticleType('HS')) {
      occupantcounts=tools.join(model.formbutton,'formbuttoncomponents',model).reduce(function(occupantcount,formbuttoncomponent) {
        if(formbuttoncomponent.param1==='HS') {
          if(formbuttoncomponent.adultcountbehaviour==='FIXED') {
            occupantcount.adultcount+=tools.amountIn(formbuttoncomponent.adultcount)*tools.amountIn(model.formbutton.minpackquantity);
          } else {
            occupantcount.adultcount+=tools.amountIn(parameters.HSC[formbuttoncomponent.param2].field3)*tools.amountIn(model.formbutton.minpackquantity);
          }
          if(formbuttoncomponent.childcountbehaviour==='FIXED') {
            occupantcount.childcount+=tools.amountIn(formbuttoncomponent.childcount)*tools.amountIn(model.formbutton.minpackquantity);
          } else {
            occupantcount.childcount+=tools.amountIn(parameters.HSC[formbuttoncomponent.param2].field4)*tools.amountIn(model.formbutton.minpackquantity);
          }
          occupantcount.peoplecount=occupantcount.adultcount+occupantcount.childcount;
        }
        return occupantcount;
      },{'adultcount':0,'childcount':0,'peoplecount':0});
    }
    return tools.join(model.formbutton,'formbuttoncomponents',model).reduce(function(price,formbuttoncomponent) {
      var multiplier=1;
      if(formbuttoncomponent.quantitymultiplier==='PEOPLE') {
        multiplier=occupantcounts.peoplecount;
      } else if(formbuttoncomponent.quantitymultiplier==='CHILDREN') {
        multiplier=occupantcounts.childcount;
      } else if(formbuttoncomponent.quantitymultiplier==='ADULTS') {
        multiplier=occupantcounts.adultcount;
      } else if(formbuttoncomponent.quantitymultiplier==='PACKS') {
        multiplier=tools.amountIn(model.formbutton.minpackquantity);
      }
      return price+multiplier*tools.amountIn(formbuttoncomponent.quantity)*tools.amountIn(formbuttoncomponent.unitprice);
    },0.0);
  };

  $scope.getFormbuttonrelations = function() {
    return tools.join(tools.lessEqual(tools.greaterEqual(tools.inverseJoin(tools.match(model.formbuttonrelations,{'parent':model.formbutton.id}),'formbuttons','child',model),'enddate',model.formbutton.startdate),'startdate',model.formbutton.enddate),'formbuttonrelations',model);
  };

  $scope.createFormbuttonrelation = function() {
    if($scope.formbuttonsModal!==null) {
      $scope.formbuttonsModal.dismiss();
    }
    $scope.formbuttonsModal=$uibModal.open({
      'templateUrl':'app/modules/settings/formbuttonsModal.html',
      'controller':function($scope,$uibModalInstance) {
        $scope.$uibModalInstance=$uibModalInstance;
        $scope.getSubmenuFormbuttons = function(fca) {
          var result=[];
          var parentFormbutton=$scope.model.formbutton;
          var i,formbutton;
          for(i in $scope.model.formbuttons) {
            formbutton=$scope.model.formbuttons[i];
            if(formbutton.fca===fca && parameters.FCA[formbutton.fca].field2!=='1' && formbutton.enddate>=parentFormbutton.startdate && formbutton.startdate<=parentFormbutton.enddate) {
              result.push(formbutton);
            }
          }
          return result;
        };
        $scope.getSubmenuFilteredFca = function() {
          var result=[];
          var parentFormbutton=$scope.model.formbutton;
          var ffo=parentFormbutton.fca.substr(0,2);
          if('notDelArrayFCA' in parameters) {
            result=parameters.notDelArrayFCA.reduce(function(acc,fca) {
              if(fca.id.substr(0,2)===ffo && fca.field2!=='1' && tools.getLength($scope.getSubmenuFormbuttons(fca.id))>0) {
                acc.push(fca);
              }
              return acc;
            },result);
          }
          return result;
        };
        $scope.getFormbuttonPredateselector = function(formbutton) {
          var result='';
          var parentFormbutton=$scope.model.formbutton;
          var ffo=parentFormbutton.fca.substr(0,2);
          if(angular.isDefined(parameters.FIN[formbutton.fixeddateinterval])) {
            result=tools.label(parameters.FIN[formbutton.fixeddateinterval]);
          } else {
            var fixeddateinterval=formbutton.fixeddateinterval.replace('interval','');
            result=parameters.notDelArrayFIN.reduce(function(acc,fin) {
              if(fin.id.substr(0,2)===ffo && fixeddateinterval===fin.field3) {
                acc=tools.label(fin);
              }
              return acc;
            },result);
          }
          return '"'+result+'"';
        };
      },
      'scope':$scope,
      'size':'lg'
    });
    $scope.formbuttonsModal.result.then(function(formbutton) {
      webservice.exclusiveCall("createFormbuttonrelation",{'parent':model.formbutton.id,'child':formbutton.id},script,model);
      $scope.formbuttonsModal=null;
    },function() {
      $scope.formbuttonsModal=null;
    });
  };
  
  $scope.deleteFormbuttonrelation = function(formbuttonrelation) {
    webservice.deleteConfirm(tools.lang({'en':'option','nl':'optie','fr':'option'}),'deleteFormbuttonrelation',formbuttonrelation.id,script,model);
  };

  $scope.updateFormbuttonPriceCat = function(catId) {
    if(model.formbutton.priceCat!=catId) {
      model.formbutton.priceCat=catId;
      model.formbutton.priceAct='';
      model.formbutton.priceFrm='';
      model.formbutton.priceUnt='';
      model.formbutton.pricekey='';
      model.formbutton.priceRes='';
      model.formbutton.priceDshCat='Undefined';
      model.formbutton.priceDsh='';
      model.formbutton.priceHtl='';
      model.formbutton.priceHsc='';
      model.formbutton.priceHra='';
      model.formbutton.priceCityTax='withCityTax';
      $scope.updateFormbutton();
    }
  };

  $scope.updateFormbuttonPriceAct = function() {
    model.formbutton.priceFrm='';
    model.formbutton.priceUnt='';
    model.formbutton.pricekey='';
    $scope.updateFormbutton();
  };

  $scope.updateFormbuttonPricekeyActivity = function() {
    if(model.formbutton.priceFrm!=='' && model.formbutton.priceUnt!=='') {
      model.formbutton.pricekey='AC'+model.formbutton.priceFrm+model.formbutton.priceUnt.substr(6,2);
    } else {
      model.formbutton.pricekey='';
    }
    $scope.updateFormbutton();
  };

  $scope.updateFormbuttonPriceRes = function() {
    model.formbutton.priceDshCat='Undefined';
    $scope.updateFormbuttonPriceDshCat();
  };

  $scope.getDishCategories = function() {
    return (("notDelArrayDSH" in parameters) && model.formbutton.priceRes!='')?Object.keys(parameters.notDelArrayDSH.filter(function(dsh){
      return dsh.id.substr(0,3)==model.formbutton.priceRes;
    }).reduce(function(acc,dsh) {
      if(dsh.field2==='') {
        acc['Undefined']=true;
      } else {
        acc[dsh.field2]=true;
      }
      return acc;
    },{'Undefined':true})):['Undefined'];
  };

  $scope.updateFormbuttonPriceDshCat = function() {
    model.formbutton.priceDsh='';
    model.formbutton.pricekey='';
    $scope.updateFormbutton();
  };

  $scope.getDishes = function() {
    return ("notDelArrayDSH" in parameters)?parameters.notDelArrayDSH.filter(function(dsh) {
      return dsh.id.substr(0,3)==model.formbutton.priceRes && dsh.field2===(model.formbutton.priceDshCat==='Undefined'?'':model.formbutton.priceDshCat);
    }):[];
  };

  $scope.getProducts = function() {
    var result=[];
    var i,prd,hasNoTaxcomponents;
    for(i in parameters.notDelArrayPRD) {
      prd=parameters.notDelArrayPRD[i];
      prd.en=prd.field3+': '+prd.labelen;
      prd.nl=prd.field3+': '+prd.labelnl;
      prd.fr=prd.field3+': '+prd.labelfr;
      result.push(prd);
    }
    return result;
  };

  $scope.updateFormbuttonPricekeyMeal = function() {
    if(model.formbutton.priceDsh!=='') {
      model.formbutton.pricekey='ME'+model.formbutton.priceDsh;
    } else {
      model.formbutton.pricekey='';
    }
    $scope.updateFormbutton();
  };

  $scope.updateFormbuttonPriceHtl = function() {
    model.formbutton.priceHsc='';
    model.formbutton.priceHra='';
    model.formbutton.priceCityTax='withCityTax';
    $scope.updateFormbutton();
  };

  $scope.updateFormbuttonPricekeyHotelstay = function() {
    if(model.formbutton.priceHtl!=='' && model.formbutton.priceHsc!=='') {
      model.formbutton.pricekey='HS'+model.formbutton.priceHtl+model.formbutton.priceHsc.substr(3,3)+model.formbutton.priceHra+model.formbutton.priceCityTax;
    } else {
      model.formbutton.pricekey='';
    }
    $scope.updateFormbutton();
  };

  $scope.getHotelspaces = function() {
    return ("notDelArrayHSC" in parameters)?parameters.notDelArrayHSC.filter(function(hsc) {
      return hsc.id.substr(0,3)==model.formbutton.priceHtl && tools.numberIn(hsc.field6)===1;
    }):[];
  };

  $scope.getHotelrates = function() {
    return ("notDelArrayHRA" in parameters)?parameters.notDelArrayHRA.filter(function(hra) {
      return hra.id.substr(0,3)==model.formbutton.priceHtl && tools.numberIn(hra.field2)===1;
    }):[];
  };

  $scope.getFormbuttoncomponentName = function(formbuttoncomponent) {
    var result;
    if(formbuttoncomponent.param1=='AC') {
      result=tools.label(parameters.ACT[formbuttoncomponent.act]);
      if(formbuttoncomponent.param2.substr(3,3)!='***') {
        result+=' '+tools.label(parameters.FRM[formbuttoncomponent.param2.substr(0,6)]);
      }
    } else if(formbuttoncomponent.param1=='ME') {
      result=tools.label(parameters.RES[formbuttoncomponent.res]);
      if(formbuttoncomponent.param2.substr(3,3)!='***') {
        result+=' '+tools.label(parameters.DSH[formbuttoncomponent.param2.substr(0,6)]);
      }
    } else if(formbuttoncomponent.param1=='PR') {
      result=tools.label(parameters.PRD[formbuttoncomponent.param2]);
    } else if(formbuttoncomponent.param1=='HS') {
      result=tools.label(parameters.HTL[formbuttoncomponent.htl]);
      if(formbuttoncomponent.param2.substr(3,3)!='***') {
        result+=' '+tools.label(parameters.HSC[formbuttoncomponent.param2.substr(0,6)]);
      }
    }
    return result;
  };

  $scope.hasPeopleQuantityMultiplier = function() {
    return tools.join(model.formbutton,'formbuttoncomponents',model).reduce(function(hasPeopleQuantityMultiplier,formbuttoncomponent) {
      return hasPeopleQuantityMultiplier || $scope.quantitymultiplierOptions[formbuttoncomponent.quantitymultiplier].isPeopleMultiplier;
    },false);
  };

  $scope.hasArticleType = function(articleType) {
    return tools.join(model.formbutton,'formbuttoncomponents',model).reduce(function(hasArticleType,formbuttoncomponent) {
      return hasArticleType || formbuttoncomponent.param1==articleType;
    },false);
  };

  $scope.plusCityTax = function() {
    return $scope.hasArticleType('HS')?'+ city tax':'';
  };

  $scope.getSellingMethodTooltip = function(sellingMethod) {
    var tooltip='';
    if(sellingMethod.isKioskMode) {
      tooltip+=tools.lang({'en':'Only for kiosk','nl':'Enkel voor kiosk','fr':'Seulement pour kiosk'})+'.\n';
      if(sellingMethod.isSpecific) {
        tooltip+=tools.lang({'en':'Never use this for online reservation','nl':'Gebruik dit nooit voor online reservatie','fr':'Ne jamais utilis\u00E9 pour la reservation en ligne'})+'!\n';
      }
    }
    if(sellingMethod.upsellingIsPossible) {
      tooltip+=tools.lang({'en':'Upselling is possible','nl':'Upselling is mogelijk','fr':'Upselling est possible'})+'.\n';
    } else {
      tooltip+=tools.lang({'en':'Upselling is not possible','nl':'Upselling is niet mogelijk','fr':"Upselling n'est pas possible"})+'!\n';
    }
    return tooltip;
  }

  $scope.addStateParamField = function(stateParamField,option) {
    if(angular.isDefined(model.stateParamFields[option.id][stateParamField.id])) {
      delete model.stateParamFields[option.id][stateParamField.id];
    } else {
      stateParamField.value='';
      model.stateParamFields[option.id][stateParamField.id]=stateParamField;
    }
  };

  $scope.getLink = function(lang) {
    var link=''
    if(angular.isDefined(model.formbutton.fca)) {
      var i,j,option,stateParam;
      var sellingMethod=$scope.sellingMethodOptions[model.sellingMethod];
      var hasPersonalizationFields=model.promo!=='' || model.lang;
      link=parameters.FFO[model.formbutton.fca.substr(0,2)].field13;
      for(i in model.stateParamFields) {
        hasPersonalizationFields=hasPersonalizationFields || tools.getLength(tools.exclude(model.stateParamFields[i],{'value':''}))>0;
      }
      if(sellingMethod.isKioskMode) {
        link+='/kiosk';
      }
      if(sellingMethod.isSpecific || hasPersonalizationFields) {
        link+='/#!/'+lang+'/filter/';
      }
      if(sellingMethod.isSpecific) {
        var isSelection=sellingMethod.id==='selection';
        link+=sellingMethod.id+'='+(isSelection?'[':'')+model.formbutton.id+(isSelection?']&':'&')
      }
      for(i in $scope.personalizationOptions) {
        option=$scope.personalizationOptions[i];
        if(option.type==='stateParamFields') {
          for(j in model.stateParamFields[option.id]) {
            stateParam=model.stateParamFields[option.id][j];
            if(stateParam.value!=='') {
              link+=stateParam.id+'='+stateParam.value+'&';
            }
          }
        } else if(model[option.id]!=='' && model[option.id]!==false) {
          link+=option.id+'='+(option.id==='lang'?lang:model[option.id])+'&';
        }
      }
      if(sellingMethod.isSpecific || hasPersonalizationFields) {
        link=link.substr(0,link.length-1);
      }
    }
    return link;
  }

  $scope.pricekeyCategories=[
    {'id':'ZE','labelen':'Zero','labelnl':'Nul','labelfr':'Zero'},
    {'id':'AC','labelen':'Act','labelnl':'Act','labelfr':'Act'},
    {'id':'ME','labelen':'Mea','labelnl':'Maa','labelfr':'Rep'},
    {'id':'HS','labelen':'Acc','labelnl':'Acc','labelfr':'Heb'}
  ];
  $scope.componentCategories=[
    {'id':'AC','labelen':'Activ','labelnl':'Activ','labelfr':'Activ'},
    {'id':'ME','labelen':'Meal','labelnl':'Maalt','labelfr':'Repas'},
    {'id':'PR','labelen':'Product','labelnl':'Product','labelfr':'Produit'},
    {'id':'HS','labelen':'Accom','labelnl':'Accom','labelfr':'H\u00E9berg'}
  ];
  $scope.cityTaxCategories=[
    {'id':'noCityTax','labelen':'noCityTax','labelnl':'noCityTax','labelfr':'noCityTax'},
    {'id':'withCityTax','labelen':'withCityTax','labelnl':'withCityTax','labelfr':'withCityTax'}
  ];
  $scope.customerChoice = {'id':'','labelen':'--Customer can choose--','labelnl':'--Klant kan kiezen--','labelfr':'--Client peut choisir--'};
  $scope.predateSelectorChoice = {'id':'','labelen':'--In predate selector--','labelnl':'--In predate selector--','labelfr':'--Dans le predate seletor--'};
  $scope.defaultChoice = {'id':'','labelen':'--Default--','labelnl':'--Standaard--','labelfr':'--D\u00E9faut--'};
  $scope.always = {'id':'','labelen':'--Always--','labelnl':'--Altijd--','labelfr':'--Toujours--','field3':''};
  $scope.any = {'id':'','labelen':'--Any--','labelnl':'--Elk--','labelfr':'--Tout--'};
  $scope.zero = {'id':'','labelen':'--Zero--','labelnl':'--Nul--','labelfr':'--Zero--'};
  $scope.empty = {'id':'','labelen':'None','labelnl':'Geen','labelfr':'Aucun','code':'','description':tools.label({'labelen':'None','labelnl':'Geen','labelfr':'Aucun'})};
  $scope.pricingOptions = [
    {'id':'DEFAULT','labelen':'Default','labelnl':'Standaard','labelfr':'Par d\u00E9faut'},
    {'id':'COMPONENT','labelen':'Fixed','labelnl':'Vast','labelfr':'Fix\u00E9'},
    {'id':'REDUCTION','labelen':'Reduction','labelnl':'Korting','labelfr':'R\u00E9duit'},
  ];
  $scope.quantitymultiplierOptions = {
    'PACKS':{'id':'PACKS','labelen':'Packs','labelnl':'Packs','labelfr':'Paquets','isPeopleMultiplier':false},
    'FIXED':{'id':'FIXED','labelen':'Fixed','labelnl':'Vast','labelfr':'Fix\u00E9','isPeopleMultiplier':false},
    'PEOPLE':{'id':'PEOPLE','labelen':'People','labelnl':'Personen','labelfr':'Personnes','isPeopleMultiplier':true},
    'ADULTS':{'id':'ADULTS','labelen':'Adults','labelnl':'Volwassen','labelfr':'Adultes','isPeopleMultiplier':true},
    'CHILDREN':{'id':'CHILDREN','labelen':'Children','labelnl':'Kinderen','labelfr':'Enfants','isPeopleMultiplier':true}
  };
  $scope.peopleMultipliers = {
    'ADULTS':{'id':'ADULTS','labelen':'Adults','labelnl':'Volwassen','labelfr':'Adultes','behaviour':'adultcountbehaviour','count':'adultcount'},
    'CHILDREN':{'id':'CHILDREN','labelen':'Children','labelnl':'Kinderen','labelfr':'Enfants','behaviour':'childcountbehaviour','count':'childcount'}
  }
  $scope.occupantcountbehaviourOptions = {
    'CHOICE':{'id':'CHOICE','labelen':'Choice','labelnl':'Keuze','labelfr':'Choix'},
    'FIXED':{'id':'FIXED','labelen':'Fixed','labelnl':'Vast','labelfr':'Fix\u00E9'}
  };
  $scope.formbuttonLabels = {
    'labelen':{'id':'labelen','placeholder':'English'},
    'labelnl':{'id':'labelnl','placeholder':'Nederlands'},
    'labelfr':{'id':'labelfr','placeholder':'Francais'}
  }
  $scope.repetitionOptions = {
    'ONCE':{'id':'ONCE','labelen':'Once','labelnl':'\u00C9\u00E9n','labelfr':'Une'},
    'NIGHTLY':{'id':'NIGHTLY','labelen':'Nightly','labelnl':'Nacht','labelfr':'Nuit'},
    'DAILY':{'id':'DAILY','labelen':'Daily','labelnl':'Dag','labelfr':'Jour'}
  };
  $scope.offsetOptions = {
    'ONCE':tools.toArray($scope.getOffsetOptions('ONCE')),
    'NIGHTLY':tools.toArray($scope.getOffsetOptions('NIGHTLY')),
    'DAILY':tools.toArray($scope.getOffsetOptions('DAILY'))
  }
  $scope.sellingMethodOptions = {
    '':{'id':'','labelen':'All formbuttons','labelnl':'Alle formulierknoppen','labelfr':'Tous les boutons','upsellingIsPossible':true,'isKioskMode':false,'isSpecific':false},
    'kiosk':{'id':'kiosk','labelen':'All formbuttons [kiosk]','labelnl':'Alle formulierknoppen [kiosk]','labelfr':'Tous les boutons [kiosk]','upsellingIsPossible':true,'isKioskMode':true,'isSpecific':false},
    'fb':{'id':'fb','labelen':'Specific formbutton','labelnl':'Specifieke formulierknop','labelfr':'Bouton specific','upsellingIsPossible':false,'isKioskMode':false,'isSpecific':true},
    'specific':{'id':'specific','labelen':'Specific formbutton [kiosk]','labelnl':'Specifieke formulierknop [kiosk]','labelfr':'Bouton specific [kiosk]','upsellingIsPossible':false,'isKioskMode':true,'isSpecific':true},
    'selection':{'id':'selection','labelen':'Selection page','labelnl':'Selectie pagina','labelfr':'Page de selection','upsellingIsPossible':true,'isKioskMode':false,'isSpecific':true}
  }
  $scope.personalizationOptions = {
    'promo':{'id':'promo','labelen':'Reduction code','labelnl':'Kortingscode','labelfr':'Code de reduction','type':'table','table':'campaigns','field':'code','nameField':'description'},
    'lang':{'id':'lang','labelen':'Override default browser language','labelnl':'Standaard browsertaal opheffen','labelfr':'Ignorer la langue par d\u00E9faut du navigateur','type':'checkbox'},
    'contact':{'id':'contact','labelen':'Communication contact','labelnl':'Communicatie contact','labelfr':'Contact de communication','type':'stateParamFields','stateParamFields':{
      'st':{'id':'st','labelen':'Street','labelnl':'Straat','labelfr':'Rue','type':'text'},
      'nr':{'id':'nr','labelen':'House number','labelnl':'Huisnummer','labelfr':'Num\u00E9ro de maison','type':'text'},
      'bn':{'id':'bn','labelen':'Box number','labelnl':'Busnummer','labelfr':'Num\u00E9ro de boîte','type':'text'},
      'ct':{'id':'ct','labelen':'Country','labelnl':'Land','labelfr':'Pays','type':'table','table':'countries','field':'id','nameField':'label'+user.lang},
      'pc':{'id':'pc','labelen':'Postal code','labelnl':'Postcode','labelfr':'Code postal','type':'text'},
      'gm':{'id':'gm','labelen':'City','labelnl':'Stad','labelfr':'Ville','type':'text'},
      'fn':{'id':'fn','labelen':'First name','labelnl':'Voornaam','labelfr':'Pr\u00E9nom','type':'text'},
      'ln':{'id':'ln','labelen':'Name','labelnl':'Naam','labelfr':'Nom','type':'text'},
      've':{'id':'ve','labelen':'Email','labelnl':'Email','labelfr':'Email','type':'text'},
      'tn':{'id':'tn','labelen':'GSM','labelnl':'GSM','labelfr':'GSM','type':'text'}
    }},
    'company':{'id':'company','labelen':'Billing details','labelnl':'Factureringsgegevens','labelfr':'Coordonn\u00E9es de facturation','type':'stateParamFields','stateParamFields':{
      'cst':{'id':'cst','labelen':'Street','labelnl':'Straat','labelfr':'Rue','type':'text'},
      'cnr':{'id':'cnr','labelen':'House number','labelnl':'Huisnummer','labelfr':'Num\u00E9ro de maison','type':'text'},
      'cbn':{'id':'cbn','labelen':'Box number','labelnl':'Busnummer','labelfr':'Num\u00E9ro de boîte','type':'text'},
      'cct':{'id':'cct','labelen':'Country','labelnl':'Land','labelfr':'Pays','type':'table','table':'countries','field':'id','nameField':'label'+user.lang},
      'cpc':{'id':'cpc','labelen':'Postal code','labelnl':'Postcode','labelfr':'Code postal','type':'text'},
      'cgm':{'id':'cgm','labelen':'City','labelnl':'Stad','labelfr':'Ville','type':'text'},
      'cn':{'id':'cn','labelen':'Company name','labelnl':'Bedrijfsnaam','labelfr':'Nom','type':'text'},
      'ce':{'id':'ce','labelen':'Email','labelnl':'Email','labelfr':'Email','type':'text'},
      'vat':{'id':'vat','labelen':'VAT nr','labelnl':'BTW nr','labelfr':'nr TVA','type':'text'}
    }},
    'externalid':{'id':'externalid','labelen':'Partner ID','labelnl':'Partner ID','labelfr':'Partner ID','type':'stateParamFields','stateParamFields':{
      'pt':{'id':'pt','labelen':'Partner','labelnl':'Partner','labelfr':'Partner','type':'param','paramTbl':'CPE'},
      'ex':{'id':'ex','labelen':'ID','labelnl':'ID','labelfr':'ID','type':'text'}
    }}
  }
  tools.initAttributes(model,{
    'formbutton':{},
    'formbuttonrelations':{},
    'backupFormbuttoncomponents':{},
    'editingFormbuttoncomponent':false,
    'isHotelFFO':false,
    'sellingMethod':'fb',
    'stateParamFields':{'contact':{},'company':{},'externalid':{}},
    'promo':'',
    'lang':false,
    'daydurations':$scope.getDaydurations()
  });
  model.startdateOpened=false;
  model.enddateOpened=false;
  model.fixedstartdateOpened=false;
  model.fixedenddateOpened=false;
  
  $scope.formbuttonsModal=null;
  $scope.initFormbuttoncomponent();
  $scope.$watch('model.formbutton.startdate.getTime()',function(newVal) {
    $scope.onDateChange('startdate',newVal);
  });
  $scope.$watch('model.formbutton.enddate.getTime()',function(newVal) {
    $scope.onDateChange('enddate',newVal);
  });
  $scope.$watch('model.formbutton.fixedstartdate.getTime()',function(newVal) {
    $scope.onDateChange('fixedstartdate',newVal);
  });
  $scope.$watch('model.formbutton.fixedenddate.getTime()',function(newVal) {
    $scope.onDateChange('fixedenddate',newVal);
  });
  webservice.afterLogin().then($scope.load);
  
}]);
angular.module("app").controller("SettingsConsolidationRightsController",["$scope","tools","modelstore","parameters","webservice",
                                                        function($scope,tools,modelstore,parameters,webservice) {
  
  var script="settings/consolidationRights";
  var model=modelstore.getModel(script);
  $scope.model=model;
  
  $scope.enterCell = function(rghId,consparamId) {
    $scope.clearHover(null,null);
    model.hoverCell=model.cells[rghId][consparamId];
    model.hoverCell.hover=true;
  };
  
  $scope.clearHover = function(rghId,consparamId) {
    if(model.hoverCell!==null && (rghId===null || model.cells[rghId][consparamId].hover)) {
      model.hoverCell.hover=false;
      model.hoverCell=null;
    }
  };
  
  $scope.create = function(rghId,consparamId) {
    webservice.exclusiveCall('create',{'consparam':consparamId,'rgh':rghId},script,model).then($scope.buildCells);
  };
  
  $scope.delete = function(rghId,consparamId) {
    webservice.exclusiveCall('delete',{'consparam':consparamId,'rgh':rghId},script,model).then($scope.buildCells);
  };

  $scope.buildCells = function() {
    var i,j,rgh,consparamright;
    if(Object.keys(model.cells).length===0) {
      for(i in model.rghArray) {
        rgh=model.rghArray[i];
        model.cells[rgh.id]={};
        for(j in model.consparamArray) {
          model.cells[rgh.id][model.consparamArray[j].id]={
            'exists':false,
            'hover':false
          };
        }
      }
    } else {
      for(i in model.rghArray) {
        rgh=model.rghArray[i];
        for(j in model.consparamArray) {
          model.cells[rgh.id][model.consparamArray[j].id].exists=false;
        }
      }
    }
    for(i in model.consparamrights) {
      consparamright=model.consparamrights[i];
      model.cells[consparamright.rgh][consparamright.consparam].exists=true;
    }
  };
  
  $scope.load = function() {
    webservice.call("load",{},script,model).then(function(response) {
      if(response) {
        model.consparamArray=tools.toArray(model.consparams).sort(function(a,b) {
          return parseInt(a.sort)-parseInt(b.sort);
        });
        model.rghArray=parameters.notDelArrayRGH.filter(function(rgh) {
          return rgh.id.substr(0,3)==='CON';
        });
        $scope.buildCells();
      }
    });
  };

  tools.initAttributes(model,{
    "consparams":{},
    "consparamrights":{},
    "consparamArray":[],
    'rghArray':[],
    'rpt':'',
    "hoverCell":null,
    "cells":{}
  });
  webservice.afterLogin().then(function() {
    model.rpt=tools.first(tools.match(parameters.notDelArrayRPT,{'field1':'1'})).id;
    $scope.load();
  });
  
}]);
angular.module('app').controller('SettingsConsolidationController',['$scope','$timeout','tools','parameters','modelstore','webservice','errorlog',
                                            function($scope,$timeout,tools,parameters,modelstore,webservice,errorlog) {

  var script='settings/consolidation';
  var model=modelstore.getModel(script);
  $scope.model=model;
  $scope.syncModes=[
//    {'id':'day','labelen':'Day','labelnl':'Dag','labelfr':'Jour'},
    {'id':'month','labelen':'Month','labelnl':'Maand','labelfr':'Mois'},
    {'id':'year','labelen':'Year','labelnl':'Jaar','labelfr':'Ann\u00E9e'}
  ];

  $scope.load = function() {
    modelstore.cleanModel(['consparams'],model);
    webservice.exclusiveCall('load',{'rpt':model.rpt},script,model).then(function() {
      $scope.setDateOptions();
    });
  };

  $scope.createConsparam = function(colrow,aggreg) {
    webservice.exclusiveCall('createConsparam',{'colrow':colrow,'aggreg':aggreg,'rpt':model.rpt},script,model).then(function(response) {
      $scope.editConsparam(model.consparams[response]);
    });
  };

  $scope.editConsparam = function(consparam) {
    model.backupConsparams[consparam.id]=tools.clone(consparam);
    consparam.editing=true;
  };

  $scope.cancelConsparam = function(consparam) {
    modelstore.addRecord('consparams',model.backupConsparams[consparam.id],model);
    consparam.editing=false;
  };

  $scope.updateConsparam = function(consparam) {
    webservice.exclusiveCall('updateConsparam',{
      'consparam':tools.whitelist(consparam,['parent','label','regexpr','invert','aglevel','agpercentage','colors','bold'])
    },script,model).then(function() {
      model.consparams[consparam.id].editing=false;
    });
  };

  $scope.swapConsparam = function(consparam,direction) {
    webservice.exclusiveCall('swapConsparam',{
      'id':consparam.id,
      'direction':direction
    },script,model);
  };

  $scope.deleteConsparam = function(consparam) {
    webservice.exclusiveCall('deleteConsparam',{'id':consparam.id},script,model);
  };

  $scope.selectTab = function(activeTab) {
    model.activeTab=activeTab;
  }

  $scope.confirmSyncEntrylines = function(syncParams) {
    var confirmLabel;
    if(syncParams===null) {
      var enddate=model.syncDate;
      switch (model.syncMode) {
        case 'day':
          break;
        case 'month':
          var enddate=new Date(enddate.getFullYear(),enddate.getMonth()+1,0);
          break;
        case 'year':
          var enddate=new Date(enddate.getFullYear()+1,0,0);
          break;
      }
      if($scope.today<enddate) {
        enddate=$scope.today;
      }
      var startdate=tools.dateFromJava(model.syncDate);
      enddate=tools.dateFromJava(enddate);
      syncParams={restartPoint:'',startdate:startdate,enddate:enddate,count:0};
      confirmLabel={
        'en':'This can take a wile! Are you sure to synchronise from '+startdate+' to '+enddate+'?',
        'nl':'Dit kan even duren! Bent u zeker te willen synchroniseren van '+startdate+' tot '+enddate+'?',
        'fr':'Ceci peux durer quelque temps! Vous êtes sur de vouloir synchroniser de '+startdate+' à '+enddate+' ?'
      }
    } else {
      confirmLabel={
        'en':'We have encoutered a problem, click ok to continue?',
        'nl':'We ondervonden een probleem, klik op ok om verder te gaan?',
        'fr':'Nous avons rencontré un problème, veuillez cliquer sur ok pour continuer?'
      }
    }
    webservice.confirmModal(tools.lang(confirmLabel)).then(function() {
      $scope.syncEntrylines(syncParams);
    });
  };

  $scope.syncEntrylines = function(syncParams) {
    webservice.exclusiveCall("syncEntrylines",syncParams,script,model).then(function(response) {
      if(response!==false) {
        model.synchronising=response.outOfTime;
        if(response.outOfTime===true && response.restartPoint!=='previous') {
          syncParams.restartPoint=response.restartPoint;
          syncParams.count=response.count;
          $scope.syncEntrylines(syncParams);
        } else if(response.restartPoint==='previous') {
          if(response.count<5) {
            model.synchronising=true;
            syncParams.count=response.count;
            tools.timeout(function(){$scope.syncEntrylines(syncParams);},Math.pow(5,response.count)*1000);
          } else {
            $scope.confirmSyncEntrylines(syncParams);
          }
        }
      } else {
        model.synchronising=false;
      }
    });
  };

  $scope.updateApprovedMonth = function() {
    if(model.approvedMonth && model.approvedMonth.length=='7' && /[0-9]{4}-[0-9]{2}/.test(model.approvedMonth)) {
      webservice.exclusiveCall('updateApprovedMonth',{'approvedMonth':model.approvedMonth},script,model).then(function() {
        $scope.setDateOptions();
      });
    }
  };

  $scope.setDateOptions = function() {
    model.dateOptions.minMode=model.syncMode;
    model.dateOptions.datepickerMode=model.syncMode;
    if(model.approvedMonth && model.approvedMonth.length=='7' && /[0-9]{4}-[0-9]{2}/.test(model.approvedMonth)) {
      var date=tools.dateToJava(model.approvedMonth+'-01');
      if(date<model.dateOptions.minDate) {
        model.dateOptions.minDate=new Date(date.getFullYear(),0,1);
      }
    }
    $scope.cleanSyncDate();
  }

  $scope.cleanSyncDateToDate = function() {
    var date=false;
    switch (model.syncMode) {
      case 'day':
        if(model.cleanSyncDate.length=='10' && /[0-9]{4}-[0-9]{2}-[0-9]{2}/.test(model.cleanSyncDate)) {
          date=tools.dateToJava(model.cleanSyncDate);
        }
        break;
      case 'month':
        if(model.cleanSyncDate.length=='7' && /[0-9]{4}-[0-9]{2}/.test(model.cleanSyncDate)) {
          date=tools.dateToJava(model.cleanSyncDate+'-01');
        }
        break;
      case 'year':
        if(model.cleanSyncDate.length=='4' && /[0-9]{4}/.test(model.cleanSyncDate)) {
          date=tools.dateToJava(model.cleanSyncDate+'-01-01');
        }
        break;
    }
    if(date>=model.dateOptions.minDate && date<=model.dateOptions.maxDate) {
      model.syncDate=date;
    } else if(date) {
      $scope.cleanSyncDate();
      errorlog.error(tools.lang({'en':'Please use the datepicker to select a valid date','nl':'Gebruik de datepicker om een geldige datum te kiezen','fr':"Veuillez utiliser le sélecteur de date pour sélectionner une date valide."}));
    }
  }

  $scope.cleanSyncDate = function() {
    var syncDateISO=tools.dateFromJava(model.syncDate);
    switch (model.syncMode) {
      case 'day':
        model.cleanSyncDate=syncDateISO.substr(0,10);
        return;
      case 'month':
        model.cleanSyncDate=syncDateISO.substr(0,7);
        model.syncDate=tools.dateToJava(model.cleanSyncDate+'-01');
        return;
      case 'year':
        model.cleanSyncDate=syncDateISO.substr(0,4);
        model.syncDate=tools.dateToJava(model.cleanSyncDate+'-01-01');
        return;
    }
  }

  $scope.today=new Date(tools.today());

  tools.initAttributes(model,{
    'approvedMonth':'',
    'rpt':'',
    'activeTab':'edit',
    'backupConsparams':{},
    'synchronising':false,
    'syncMode':'month',
    'syncDate':$scope.today,
    'cleanSyncDate':tools.dateFromJava($scope.today),
    'syncDateOpened':false,
    'dateOptions':{
      maxDate: $scope.today,
      minDate: new Date(tools.addDays($scope.today,-31).getFullYear(),0,1),
      startingDay: 1
    }
  });
  $scope.$watch("model.syncDate.getTime()",function(newVal,oldVal) {
    if(newVal!==oldVal) {
      $scope.cleanSyncDate();
    }
  });
  $scope.$watch("model.cleanSyncDate",function(newVal,oldVal) {
    if(newVal!==oldVal) {
      $scope.cleanSyncDateToDate();
    }
  });
  $scope.zeroOrOne=['0','1'];
  webservice.afterLogin().then(function() {
    model.rpt=tools.first(tools.match(parameters.notDelArrayRPT,{'field1':'1'})).id;
    $scope.$watch("model.rpt",function(newVal,oldVal) {
      if(newVal!==oldVal) {
        $scope.load();
      }
    });
    $scope.load();
  });
  
}]);
angular.module("app").controller("SettingsCampaignsController",["$scope","tools","parameters","modelstore","webservice","activitiesService",
                                            function($scope,tools,parameters,modelstore,webservice,activitiesService) {

  $scope.activitiesService=activitiesService;
  var script="settings/campaigns";
  var model=modelstore.getModel(script);
  $scope.model=model;
  
  $scope.createCampaign = function() {
    var campaign={
      "id":tools.getMinIdMinusOne(model.campaigns),
      "code":"",
      "suffix":"",
      "description":"",
      "startdate":tools.today(),
      "enddate":tools.today(),
      "amount":"",
      "percent":"1",
      "editing":true,
      "newRecord":true
    };
    modelstore.addRecord("campaigns",campaign,model);
  };

  $scope.editCampaign = function(campaign) {
    model.backupCampaigns[campaign.id]=tools.clone(campaign);
    campaign.editing=true;
  };
  
  $scope.cancelCampaign = function(campaign) {
    if("newRecord" in campaign && campaign.newRecord) {
      modelstore.removeRecord("campaigns",campaign.id,model);
    } else {
      model.campaigns[campaign.id]=model.backupCampaigns[campaign.id];
    }
  };
  
  $scope.replaceCampaign = function(campaign) {
    if("newRecord" in campaign && campaign.newRecord) {
      $scope.insertCampaign(campaign);
    } else {
      $scope.updateCampaign(campaign);
    }
  };
  
  var campaignWhitelist=["code","suffix","description","startdate","enddate"];
  
  $scope.insertCampaign = function(campaign) {
    webservice.call("insertCampaign",{
      "campaign":tools.whitelistNoId(campaign,campaignWhitelist)
    },script,model).then(function(response) {
      if(response) {
        modelstore.removeRecord("campaigns",campaign.id,model);
      }
    });
  };
  
  $scope.updateCampaign = function(campaign) {
    webservice.call("updateCampaign",{
      "campaign":tools.whitelist(campaign,campaignWhitelist)
    },script,model).then(function(response) {
      if(response) {
        campaign.editing=false;
      }
    });
  };
  
  $scope.deleteCampaign = function(campaign) {
    webservice.call("deleteCampaign",{"id":campaign.id},script,model);
  };

  tools.initAttributes(model,{
    "backupCampaigns":{}
  });
  webservice.afterLogin().then(function() {
    webservice.call("load",{},script,model);
  });
  
}]);
angular.module("app").controller("RulesWeekSchedulesController",["$scope","tools","modelstore","parameters","webservice",
                                            function($scope,tools,modelstore,parameters,webservice) {

  var script="rules/weekSchedules";
  var model=modelstore.getModel(script);
  $scope.model=model;

  $scope.sortWeekscheduleentries = function() {
    $scope.sortedWeekscheduleentries={};
    var i,j,weekscheduleentry;
    for(i in parameters.DAY) {
      $scope.sortedWeekscheduleentries[i]={};
      for(j in parameters.HRS) {
        $scope.sortedWeekscheduleentries[i][j]="";
      }
    }
    if("weekscheduleentries" in model) {
      for(i in model.weekscheduleentries) {
        weekscheduleentry=model.weekscheduleentries[i];
        $scope.sortedWeekscheduleentries[weekscheduleentry.weekday][weekscheduleentry.hrs]=weekscheduleentry.employee;
      }
    }
  };

  $scope.clearWeekscheduleentries = function() {
    for(var i in model.weekscheduleentries) {
      modelstore.removeRecord("weekscheduleentries",i,model);
    }
    $scope.sortWeekscheduleentries();
  };

  $scope.loadWeekscheduleentries = function() {
    if(model.weekschedule!==null) {
      model.weekschedule.editing=false;
    }
    $scope.clearWeekscheduleentries();
    if(model.weekschedule!=null) {
      webservice.call("loadWeekscheduleentries",{"id":model.weekschedule.id},script,model).then(function(response) {
        if(response) {
          $scope.sortWeekscheduleentries();
        }
      });
    }
  };

  $scope.createWeekschedule = function() {
    webservice.call("createWeekschedule",{},script,model).then(function(response) {
      if(response) {
        model.weekschedule=model.weekschedules[response];
        $scope.clearWeekscheduleentries();
        $scope.editWeekschedule();
      }
    });
  };

  $scope.editWeekschedule = function() {
    model.backupWeekschedules[model.weekschedule.id]=tools.clone(model.weekschedule);
    model.weekschedule.editing=true;
  };

  $scope.restoreWeekschedule = function() {
    model.weekschedule=model.backupWeekschedules[model.weekschedule.id];
  };

  $scope.deleteWeekschedule = function() {
    webservice.deleteConfirm(model.weekschedule.wording,"deleteWeekschedule",model.weekschedule.id,script,model).then(function(response) {
      if(response) {
        model.weekschedule=null;
        $scope.clearWeekscheduleentries();
      }
    });
  };

  var weekscheduleWhitelist=["wording","closedmessageprio","closedmessageen","closedmessagenl","closedmessagefr","showavailablefrom"];
  $scope.updateWeekschedule = function() {
    var id=model.weekschedule.id;
    var weekschedule=
    webservice.call("updateWeekschedule",{"weekschedule":tools.whitelist(model.weekschedule,weekscheduleWhitelist)},script,model).then(function(response) {
      if(response) {
        model.weekschedule=model.weekschedules[id];
        model.weekschedule.editing=false;
      }
    });
  };

  $scope.toggleWeekscheduleIntervalentry = function(maxCode,allIntervalCodesAreEqual,weekscheduleentriesToCreate,weekscheduleentriesToUpdate) {
    var employee,promise;
    if(allIntervalCodesAreEqual) {
      switch(maxCode) {
        case '0':
          employee='1';
          break;
        case '1':
          employee='';
          break;
        case '':
          employee='0';
          break;
        default:
          break;
      }
    } else {
      employee=maxCode;
    }
    if(employee!=='') {
      promise=webservice.call('createAndUpdateWeekscheduleentries',{
        'weekscheduleentriesToCreate':weekscheduleentriesToCreate,
        'weekscheduleentriesToUpdate':Object.values(weekscheduleentriesToUpdate),
        'employee':employee
      },script,model)
    } else {
      promise=webservice.call('deleteWeekscheduleentries',{'ids':Object.keys(weekscheduleentriesToUpdate)},script,model);
    }
    promise.then(function(response) {
      if(response) {
        $scope.sortWeekscheduleentries();
      }
    });
  }

  $scope.toggleWeekscheduleHrsentry = function(hrs) {
    var code,day,id,weekscheduleentry;
    var maxCode='';
    var weekscheduleentriesToCreate=[];
    var weekscheduleentriesToUpdate={};
    var i=0;
    for(day in $scope.sortedWeekscheduleentries) {
      code=$scope.sortedWeekscheduleentries[day][hrs];
      if(maxCode<code) {
        maxCode=code;
      }
      if(code==='') {
        weekscheduleentriesToCreate[i]={
          'weekschedule':model.weekschedule.id,
          'weekday':day,
          'hrs':hrs
        };
        i++;
      }
    }
    for(id in model.weekscheduleentries) {
      weekscheduleentry=model.weekscheduleentries[id];
      if(weekscheduleentry.hrs===hrs) {
        weekscheduleentriesToUpdate[id]=weekscheduleentry;
      }
    }
    var allHrsCodesAreEqual=Object.values($scope.sortedWeekscheduleentries).filter(function(hrsCode) {
      return hrsCode[hrs]!==maxCode;
    }).length===0;
    $scope.toggleWeekscheduleIntervalentry(maxCode,allHrsCodesAreEqual,weekscheduleentriesToCreate,weekscheduleentriesToUpdate)
  }

  $scope.toggleWeekscheduleDayentry = function(day) {
    var code,hrs,id,weekscheduleentry;
    var maxCode='';
    var weekscheduleentriesToCreate=[];
    var weekscheduleentriesToUpdate={};
    var i=0;
    for(hrs in $scope.sortedWeekscheduleentries[day]) {
      code=$scope.sortedWeekscheduleentries[day][hrs];
      if(maxCode<code) {
        maxCode=code;
      }
      if(code==='') {
        weekscheduleentriesToCreate[i]={
          'weekschedule':model.weekschedule.id,
          'weekday':day,
          'hrs':hrs
        };
        i++;
      }
    }
    for(id in model.weekscheduleentries) {
      weekscheduleentry=model.weekscheduleentries[id];
      if(weekscheduleentry.weekday===day) {
        weekscheduleentriesToUpdate[id]=weekscheduleentry;
      }
    }
    var allDayCodesAreEqual=Object.values($scope.sortedWeekscheduleentries[day]).filter(function(code) {
      return code!==maxCode;
    }).length===0;
    $scope.toggleWeekscheduleIntervalentry(maxCode,allDayCodesAreEqual,weekscheduleentriesToCreate,weekscheduleentriesToUpdate)
  }

  $scope.toggleWeekscheduleentry = function(day,hrs) {
    var code=$scope.sortedWeekscheduleentries[day][hrs];
    var promise;
    if(code==='') {
      promise=webservice.call('createAndUpdateWeekscheduleentries',{
        'weekscheduleentriesToCreate':[{
          'weekschedule':model.weekschedule.id,
          'weekday':day,
          'hrs':hrs
        }],
        'weekscheduleentriesToUpdate':[],
        'employee':'0'
      },script,model);
    } else {
      var id,weekscheduleentry;
      for(id in model.weekscheduleentries) {
        weekscheduleentry=model.weekscheduleentries[id];
        if(weekscheduleentry.weekday===day && weekscheduleentry.hrs===hrs) {
          break;
        }
      }
      if(code==='0') {
        promise=webservice.call('createAndUpdateWeekscheduleentries',{
          'weekscheduleentriesToCreate':[],
          'weekscheduleentriesToUpdate':[tools.whitelist(weekscheduleentry,['employee'])],
          'employee':'1'
        },script,model);
      } else {
        promise=webservice.call('deleteWeekscheduleentries',{'ids':[id]},script,model);
      }
    }
    promise.then(function(response) {
      if(response) {
        $scope.sortWeekscheduleentries();
      }
    });
  };

  tools.initAttributes(model,{
    "weekschedule":null,
    "backupWeekschedules":{},
    "hover":""
  });
  webservice.call("load",{},script,model);
  $scope.sortWeekscheduleentries();
  
}]);
angular.module("app").controller("RulesListRulesController",["$scope","tools","modelstore","parameters","user","webservice",
                                            function($scope,tools,modelstore,parameters,user,webservice) {

  var script="rules/listRules";
  var model=modelstore.getModel(script);
  $scope.model=model;

  $scope.any={'id':'','labelen':'--All--','labelnl':'--Alle--','labelfr':'--Tout--'};

  $scope.initRule = function() {
    model.rule={
      "act":"KAY",
      "frm":"",
      "unt":"",
      "free":"",
      "startdate":"",
      "enddate":"",
      "result":"0"
    };
    $scope.determineOptions();
  };

  $scope.determineOptions = function() {
    $scope.frmOptions=[];
    var i;
    for(i in parameters.FRM) {
      if(parameters.FRM[i].id.substr(0,3)===model.rule.act) {
        $scope.frmOptions.push(parameters.FRM[i]);
      }
    }
    $scope.untOptions=[];
    for(i in parameters.UNT) {
      if(parameters.UNT[i].id.substr(0,3)===model.rule.act && (model.rule.frm=='' || parameters.UNT[i].id.substr(3,3)=='***' || parameters.UNT[i].id.substr(3,3)==model.rule.frm.substr(3,3))) {
        $scope.untOptions.push(parameters.UNT[i]);
      }
    }
  };

  $scope.orderRules = function() {
    $scope.orderedRules={};
    if("rules" in model) {
      var i,rule,key;
      var filterIsActive=model.filter!='';
      for(i in model.rules) {
        rule=model.rules[i];
        if(!filterIsActive || (rule.frm!='' && rule.frm.substr(0,3)==model.filter) || (rule.free!='' && rule.free.substr(0,model.filter.length)==model.filter)) {
          key=rule.frm+rule.unt+rule.free;
          if(!(key in $scope.orderedRules)) {
            $scope.orderedRules[key]=[];
          }
          $scope.orderedRules[key].push(rule);
        }
      }
      for(i in $scope.orderedRules) {
        $scope.orderedRules[i].sort(function(a,b) {
          if(a.startdate===b.startdate) {
            if(a.enddate===b.enddate) {
              return 0;
            }
            if(a.enddate>b.enddate) {
              return -1;
            }
            return 1;
          }
          if(a.startdate>b.startdate) {
            return 1;
          }
          return -1;
        });
      }
      $scope.setRuleOptions();
      $scope.setTranslations();
    }
  };

  $scope.loadRules = function() {
    for(var i in model.rules) {
      modelstore.removeRecord("rules",i,model);
    }
    webservice.exclusiveCall("loadRules",{"rut":model.rut},script,model).then(function(response) {
      if(response) {
        $scope.orderRules();
      }
    });
  };

  $scope.createRule = function() {
    model.rule.rut=model.rut;
    webservice.call("createRule",{"rule":tools.whitelistNoId(model.rule,['rut','frm','unt','free','startdate','enddate','result'])},script,model).then(function(response) {
      if(response) {
        $scope.initRule();
        model.act={};
        model.frm={};
        model.unt={};
        model.free={};
        $scope.orderRules();
      }
    });
  };

  $scope.editRule = function(rule) {
    model.backupRules[rule.id]=tools.clone(rule);
    if(rule.rut==='PRI') {
      rule.value=tools.amountOut(rule.value);
    }
    rule.editing=true;
  };

  $scope.restoreRule = function(rule) {
    modelstore.addRecord("rules",model.backupRules[rule.id],model);
    $scope.orderRules();
  }

  $scope.updateRule = function(rule) {
    webservice.call("updateRule",{"rule":tools.whitelist(rule,['startdate','enddate','result'])},script,model).then(function(response) {
      if(response) {
        $scope.orderRules();
        rule.editing=false;
      }
    });
  };

  $scope.deleteRule = function(rule) {
    webservice.deleteConfirm("","deleteRule",rule.id,script,model).then(function(response) {
      if(response) {
        $scope.orderRules();
      }
    });
  };

  $scope.dateOut = function(date) {
    if(date=="1971-01-01 00:00:00") {
      return tools.lang({'en':'Default','nl':'Default','fr':'Default'})
    } else {
      return date;
    }
  };

  $scope.getFreeLabel = function(par) {
    var result='';
    if(model.rut!='' && angular.isDefined(par)) {
      result=tools.label(par);
      if(model.rut=='MPR') {
        result=tools.label(parameters.RES[par.id.substr(0,3)])+' '+result;
      }
      if(model.rut=='ISC') {
        result=tools.label(parameters.FFO[par.id.substr(0,2)])+' '+result;
      }
    }
    return result;
  };

  $scope.updateRuleAct = function() {
    if(angular.isDefined(model.act.id)) {
      model.rule.frm='';
      model.rule.unt='';
      model.rule.act=model.act.id;
      $scope.setRuleOptions();
    }
  };

  $scope.updateRuleFrm = function() {
    if(angular.isDefined(model.frm.id)) {
      model.rule.unt='';
      model.rule.frm=model.frm.id;
      $scope.setRuleOptions();
    }
  };

  $scope.updateRuleUnt = function() {
    if(angular.isDefined(model.unt.id)) {
      model.rule.unt=model.unt.id;
    }
  };

  $scope.updateRuleFree = function() {
    if(angular.isDefined(model.free.id)) {
      model.rule.free=model.free.id;
    }
  };

  $scope.setRuleOptions = function() {
    if(model.rut!='') {
      var i,param,ruleFilter;
      var actRuleOptions={};
      var freeRuleOptions={};
      var frmRuleOptions={};
      var untRuleOptions={};
      var rut=parameters.RUT[model.rut];
      if(rut.field1=='1' || rut.field2=='1') {
        for(i in parameters.notDelACT) {
          param=parameters.ACT[i];
          param.label=tools.label(param);
          actRuleOptions[param.id]=param;
        }
        model.actRuleOptions=actRuleOptions;
        model.actRuleOptionsArray=Object.values(model.actRuleOptions);
        if(rut.field1=='1') {
          for(i in parameters.notDelFRM) {
            if(parameters.FRM[i].id.substr(0,3)===model.rule.act) {
              param=parameters.FRM[i];
              param.label=tools.label(param);
              frmRuleOptions[param.id]=param;
            }
          }
          model.frmRuleOptions=frmRuleOptions;
          model.frmRuleOptionsArray=Object.values(model.frmRuleOptions);
        }
        if(rut.field2=='1') {
          for(i in parameters.notDelUNT) {
            if(parameters.UNT[i].id.substr(0,3)===model.rule.act && (model.rule.frm=='' || parameters.UNT[i].id.substr(3,3)=='***' || parameters.UNT[i].id.substr(3,3)==model.rule.frm.substr(3,3))) {
              param=parameters.UNT[i];
              param.label=tools.label(param);
              untRuleOptions[param.id]=param;
            }
          }
          model.untRuleOptions=untRuleOptions;
          model.untRuleOptionsArray=Object.values(model.untRuleOptions);
        }
      }
      if(rut.field3=='1') {
        for(i in parameters['notDel'+rut.field4]) {
          param=parameters[rut.field4][i];
          param.label=$scope.getFreeLabel(param);
          freeRuleOptions[param.id]=param;
        }
        model.freeRuleOptions=freeRuleOptions;
        model.freeRuleOptionsArray=Object.values(model.freeRuleOptions);
      }
    }
  }

  $scope.setTranslations = function() {
    model.translations={
      'checkAll':tools.lang({'en':'Check all','nl':'Alles selecteren','fr':'S\u00E9llectioner tout'}),
      'uncheckAll':tools.lang({'en':'Uncheck all','nl':'Alles deselecteren','fr':'Des\u00E9llectioner tout'}),
      'selectionCount':tools.lang({'en':'checked','nl':'Geselecteerd','fr':'S\u00E9llectioner'}),
      'searchPlaceholder':tools.lang({'en':'Search...','nl':'Zoek...','fr':'Chercher...'}),
      'buttonDefaultText':tools.lang({'en':'Select','nl':'Selecteer','fr':'S\u00E9llectioner'}),
      'dynamicButtonTextSuffix':tools.lang({'en':'checked','nl':'Geselecteerd','fr':'S\u00E9llectioner'}),
      'selectGroup':tools.lang({'en':'Select All:','nl':'Selecteer Alles:','fr':'S\u00E9llectioner tout:'})
    };
  }
  $scope.setTranslations();
  
  tools.initAttributes(model,{
    'rut':'',
    'free':{},
    'frm':{},
    'unt':{},
    'act':{},
    'backupRules':{},
    'freeRuleOptions':{},
    'frmRuleOptions':{},
    'untRuleOptions':{},
    'actRuleOptions':{},
    'ruleSettings':{
      'scrollable':true,
      'scrollableHeight':'300px',
      'selectionLimit':1,
      'showCheckAll':false,
      'showUncheckAll':false,
      'smartButtonMaxItems':1,
      'closeOnSelect':true,
      'enableSearch':true,
      'styleActive':true,
      'keyboardControls':true,
      'buttonClasses':'btn btn-group-justified btn-default'
    },
    'filter':''
  });
  webservice.afterLogin().then(function(){
    $scope.initRule();
  });
  if(model.rut!=='') {
    $scope.loadRules();
  }
  $scope.orderRules();
  
}]);
angular.module('app').controller('RfidRetrieveVisitController',['$scope','$stateParams','$uibModal','$q','tools','modelstore','parameters','webservice','lobbyProxy','errorlog','visionline','visionlineOutdoor',
                                            function($scope,$stateParams,$uibModal,$q,tools,modelstore,parameters,webservice,lobbyProxy,errorlog,visionline,visionlineOutdoor) {

  var script='rfid/retrieveVisit';
  var model=modelstore.getModel(script);
  $scope.model=model;
  $scope.lobbyProxy=lobbyProxy;

  $scope.load = function() {
    model.visit=null;
    modelstore.cleanModel(['visits','activities','participants','hotelreservationcategories','hotelspaceassignments','rfidcarriers','rfidactivityrights','rfidhotelspacerights','rfidproductrights','items'],model);
    webservice.exclusiveCall('load',{'visitId':$stateParams.id,'page':$stateParams.page},script,model).then(function() {
      model.visit=tools.first(model.visits);
      if(hotelreservationcategories.length>=1) {
        model.hotelreservationcategoryId=hotelreservationcategories[0].id;
        $scope.onChangeHotelreservationcategory();
      }
      if(model.hotelreservationcategoryId!=='' && !(model.hotelreservationcategoryId in model.hotelreservationcategories)) {
        model.hotelreservationcategoryId='';
        $scope.onChangeHotelreservationcategory();
      }
      visionline.hotelConfigs=model.hotelConfigs;
    });
  };

  $scope.onChangeHotelreservationcategory = function() {
    if(model.hotelreservationcategoryId in model.hotelreservationcategories) {
      var hotelspaceassignments=tools.join(model.hotelreservationcategories[model.hotelreservationcategoryId],'hotelspaceassignments',model).filter(function(hotelspaceassignment) {
        return model.hotelspaces[hotelspaceassignment.assignedspace].state==='Inspected';
      });
      if(hotelspaceassignments.length>=1) {
        model.hotelspaceassignmentId=hotelspaceassignments[0].id;
      }
      if(model.hotelspaceassignmentId!=='' && (!(model.hotelspaceassignmentId in model.hotelspaceassignments) || model.hotelspaces[model.hotelspaceassignments[model.hotelspaceassignmentId].assignedspace].state!=='Inspected')) {
        model.hotelspaceassignmentId='';
      }
    } else {
      model.hotelspaceassignmentId='';
    }
  };

  // $scope.syncSpaces = function() {
  //   webservice.call("syncSpaces",{'visitId':model.visit.id},script,model).then($scope.onChangeHotelreservationcategory);
  // };

  $scope.createHotelRfidcarrier = function() {
    if(model.hotelspaceassignmentId==='') {
      errorlog.error(tools.lang({'en':'Select the stay, room category and room number','nl':'Selecteer het verblijf, de categorie van de kamer en het kamernummer','fr':'Select the stay, room category and room number'}))
    } else {
      var hotelspaceassignment=model.hotelspaceassignments[model.hotelspaceassignmentId];
      var hotelspace=model.hotelspaces[hotelspaceassignment.assignedspace];
      model.rfidScanStatus='hotelspaceassignment';
      $scope.openEncodeModal().then(function() {},function() {
        visionline.post('encoders/'+model.hotelConfigs[model.hotelreservationcategories[model.hotelreservationcategoryId].htl].deskEncoder+'?action=abort',{});
        model.rfidScanStatus='idle';
      });
      var url='cards?action=encode&encoder='+model.hotelConfigs[model.hotelreservationcategories[model.hotelreservationcategoryId].htl].deskEncoder;
      var rfidcarriers=tools.inverseJoin(tools.join(hotelspaceassignment,'rfidhotelspacerights',model),'rfidcarriers','rfidcarrier',model)
      if(rfidcarriers.length===0) {
        url+='&override=true';
      } else {
        url+='&fields=joiners';
      }
      var visionlineParams={
        "cancelled":false,
        "expireTime":model.hotelreservationcategories[model.hotelreservationcategoryId].enddateISO.replace(/\D/g,'')+"T"+model.hotelreservationcategories[model.hotelreservationcategoryId].defaultCheckoutHour.replace(/\D/g,'').substr(0,4),
        "format": "rfid48",
        "doorOperations":[{"operation":"guest","doors":[hotelspace.spacenumber]}]
      };
      if(rfidcarriers.length>0) {
        visionlineParams.joiners=rfidcarriers.map(function(rfidcarrier) {
          return rfidcarrier.visionid;
        });
      }
      visionline.post(model.hotelreservationcategories[model.hotelreservationcategoryId].htl,url,visionlineParams).then(function(response) {
        if("serialNumbers" in response) {
          webservice.exclusiveCall('createRfidcarrier',{
            'uid':response.serialNumbers[0],
            'visitId':model.visit.id,
            'hotelspaceassignmentId':hotelspaceassignment.id,
            'visionid':response.id
          },script,model).then(function(response2) {
            if(response2===false) {
              visionline.post('cards/'+response.id,{
                "cancelled":true
              });
              return $q.reject();
            } else {
              model.lastScannedRfidcarrierId=response2;
              $scope.modal.close();
              $scope.modal=null;
              model.rfidScanStatus='idle';
              $scope.setStatuses();
              return $q.resolve();
            }
          });
        } else {
          return $q.reject(response.message);
        }
      }).then(function(){},function(message) {
        $scope.modal.close();
        $scope.modal=null;
        model.rfidScanStatus='idle';
        errorlog.error(tools.lang({
          'en':'Keycard or bracelet encoding failed. Please try again or consult a receptionist. '+message,
          'nl':'Keycard of armband encoderen is mislukt. Gelieve opnieuw te proberen of een receptionist te raadplegen. '+message,
          'fr':'Encodage du keycard ou bracelet a \u00E9chou\u00E9. Veullez r\u00E9essayer ou consulter une r\u00E9ceptionniste. '+message
        }));
      });
    }
  };

  $scope.createRfidcarrier = function() {
    model.rfidScanStatus='activity';
    $scope.openEncodeModal().then(function() {},function() {
      $scope.modal.close();
      $scope.modal=null;
      model.rfidScanStatus='idle';
    });
  };

  $scope.openEncodeModal = function() {
    $scope.modal=$uibModal.open({
      'templateUrl':'app/modules/rfid/encodeModal.html',
      'controller':'EncodeModalController',
      'scope':$scope,
      'size':'lg',
      'backdrop':'static',
      'keyboard':false
    });
    return $scope.modal.result;
  };

  $scope.onMessage = function(message) {
    if('read' in message) {
      var uid=message.read;
      var i,rfidcarrier;
      var foundExistingRfidcarrier=false;
      for(i in model.rfidcarriers) {
        rfidcarrier=model.rfidcarriers[i];
        if(rfidcarrier.uid===uid) {
          model.lastScannedRfidcarrierId=rfidcarrier.id;
          foundExistingRfidcarrier=true;
          break;
        }
      }
      if(!foundExistingRfidcarrier && model.rfidScanStatus==='activity') {
        var params={
          'uid':uid,
          'visitId':model.visit.id
        };
        // if(model.rfidScanStatus==='hotelspaceassignment') {
        //   params.hotelspaceassignmentId=model.rfidScanHotelspaceassignmentId;
        // }
        webservice.call('createRfidcarrier',params,script,model).then(function(response) {
          if($scope.modal!==null) {
            $scope.modal.close();
            $scope.modal=null;
          }
          model.rfidScanStatus='idle';
          if(response!==false) {
            model.lastScannedRfidcarrierId=response;
          }
          $scope.setStatuses();
        });
      }
    }
  };

  $scope.sortRfidcarriers = function(rfidcarrier) {
    var result='';
    var rfidhotelspacerights=tools.join(rfidcarrier,'rfidhotelspacerights',model);
    if(rfidhotelspacerights.length>0 && (0 in rfidhotelspacerights) && (rfidhotelspacerights[0].hotelspaceassignment in model.hotelspaceassignments)) {
      var hotelspaceassignment=model.hotelspaceassignments[rfidhotelspacerights[0].hotelspaceassignment];
      var hotelspace=model.hotelspaces[hotelspaceassignment.assignedspace];
      var hotelreservationcategory=model.hotelreservationcategories[hotelspaceassignment.reservationcategory];
      result+='0'+hotelreservationcategory.id.padStart(10,'0')+hotelspace.buildingnumber.padStart(3,'0')+hotelspace.floornumber.padStart(3,'0')+hotelspace.spacenumber.padStart(3,'0');
    } else {
      result+='1';
    }
    result+=rfidcarrier.sort;
    return result;
  };

  $scope.updateRfidcarrier = function(rfidcarrier) {
    webservice.call('updateRfidcarrier',{'rfidcarrier':rfidcarrier},script,model);
  };

  $scope.deleteRfidcarrier = function(rfidcarrier) {
    var cardIsCancelled;
    var rfidhotelspacerights=tools.join(rfidcarrier,'rfidhotelspacerights',model);
    if(rfidhotelspacerights.length>0) {
      var hotelspaceassignment=model.hotelspaceassignments[rfidhotelspacerights[0].hotelspaceassignment];
      var hotelspace=model.hotelspaces[hotelspaceassignment.assignedspace];
      var hotelreservationcategory=model.hotelreservationcategories[hotelspaceassignment.reservationcategory];
      cardIsCancelled=visionlineOutdoor.cancelCard(hotelreservationcategory.htl,rfidcarrier.visionid);
    } else {
      cardIsCancelled=$q.resolve();
    }
    cardIsCancelled.then(function() {
      webservice.call('deleteRfidcarrier',{'rfidcarrierId':rfidcarrier.id},script,model).then($scope.load);
    });
  };

  tools.initAttributes(model,{
    'hotelreservationcategories':{},
    'hotelspaceassignments':{},
    'rfidcarriers':{},
    'activityRfidcarriers':[],
    'enableCreateActivityRfidcarrier':false,
    'lastScannedRfidcarrierId':'',
    'rfidScanHotelspaceassignmentId':'',
    'visit':null,
    'hotelreservationcategoryId':'',
    'hotelspaceassignmentId':'',
    'rfidScanStatus':'idle',
    'modal':null
  });
  webservice.afterLogin().then(function() {
    $scope.load();
    lobbyProxy.initWebsocket();
    lobbyProxy.onMessage=$scope.onMessage;
  });
  
}]);
angular.module('app').controller('EncodeModalController',['$scope','$uibModalInstance',
                                            function($scope,$uibModalInstance) {

  $scope.cancel = function() {
    $uibModalInstance.dismiss();
  };

}]);

angular.module('app').component('restrictionsComponent', {
  templateUrl:'app/modules/restrictions/restrictionsComponent.html',
  bindings:{
    foreigntable:'@',
    getParent:'&',
    model:'=',
    getEditing:'&',
    getBehaviourFilter:'&'
  },
  controller:function($scope,tools,parameters,modelstore,activitiesService,user) {
    var ctrl=this;
    ctrl.tools=tools;
    ctrl.parameters=parameters;
    ctrl.activitiesService=activitiesService;
    ctrl.user=user;

    ctrl.$onInit = function() {
      ctrl.fixOrGroups();
    };

    ctrl.fixOrGroups = function() {
      var orgroups={};
      var parent=ctrl.getParent();
      var restrictions,restriction;
      if(parent===null || angular.isUndefined(parent)) {
        restrictions=[];
      } else {
        restrictions=tools.match(ctrl.model.restrictions,{'foreigntable':ctrl.foreigntable,'foreignkey':parent.id});
      }
      for(var i in restrictions) {
        restriction=restrictions[i];
        restriction.param1=ctrl.isArticleKey(restriction.behaviour,'param1')?ctrl.buildAtricleAttributesFromArticleKey(restriction.param1):restriction.param1;
        restriction.param2=ctrl.isArticleKey(restriction.behaviour,'param2')?ctrl.buildAtricleAttributesFromArticleKey(restriction.param2):restriction.param2;
        if(!(restriction.orgroup in orgroups)) {
          orgroups[restriction.orgroup]={'id':restriction.orgroup,'restrictions':[]};
        }
        orgroups[restriction.orgroup].restrictions.push(restriction);
      }
      ctrl.orgroups=tools.toArray(orgroups);
    }
    $scope.$on("fixOrGroups",ctrl.fixOrGroups);

    ctrl.isArticleKey = function(rst,param) {
      return angular.isDefined(parameters.restrictionBehaviours[rst]) && angular.isDefined(parameters.restrictionBehaviours[rst].params[param]) && parameters.restrictionBehaviours[rst].params[param].isArticleKey;
    }

    ctrl.buildAtricleAttributesFromArticleKey = function(articleKey) {
      var result;
      if(angular.isArray(articleKey)) {
        result=articleKey;
      } else {
        result=[null,null,null,null];
        if(angular.isDefined(articleKey) && articleKey.substr(0,2) in ctrl.articleTypes) {
          var articleType=articleKey.substr(0,2);
          var parentParam=articleKey.substr(2,3);
          var childParam=articleKey.substr(5,3)!=="***" && articleKey.substr(5,3)!==""?articleKey.substr(2,6):null;
          var unitParam=null;
          if(articleKey.substr(8,2)!=="**" && articleKey.substr(8,2)!=="") {
            if(articleType==='AC') {
              unitParam=parentParam+'***'+articleKey.substr(8,2);
            } else {
              unitParam=parentParam+articleKey.substr(8,3);
            }
          }
          result=[articleType,parentParam,childParam,unitParam];
        }
      }
      return result;
    }

    ctrl.filterArticles = function(paramTbl,field,param,currentValue) {
      if(paramTbl && param) {
        var matchingElement={};
        var input=parameters['notDel'+paramTbl];
        var parentParam=param.substr(0,3);
        var output=[];
        for(var i in input) {
          if(i in input && field in input[i] && input[i][field].substr(0,3)==parentParam) {
            output.push(input[i]);
          }
        }
        matchingElement[field]=currentValue;
        return tools.addMatchingElement(parameters[paramTbl],output,matchingElement);
      } else {
        return [];
      }
    };
  
    ctrl.sort = function(record) {
      return 10000-parseInt(record.id);
    };

    ctrl.onRestrictionChange = function(restriction) {
      restriction.param1=ctrl.isArticleKey(restriction.behaviour,'param1')?ctrl.buildAtricleAttributesFromArticleKey(restriction.param1):restriction.param1;
      restriction.param2=ctrl.isArticleKey(restriction.behaviour,'param2')?ctrl.buildAtricleAttributesFromArticleKey(restriction.param2):restriction.param2;
    }
  
    ctrl.createRestriction = function(orgroup) {
      var restriction={
        'id':tools.getMinIdMinusOne(ctrl.model.restrictions),
        'foreigntable':ctrl.foreigntable,
        'foreignkey':ctrl.getParent().id,
        'orgroup':angular.isDefined(orgroup)?orgroup:(Object.keys(ctrl.orgroups).length==0?0:Math.max.apply(null,Object.keys(ctrl.orgroups).map(function(nr) {return parseInt(nr);}))+1),
        'behaviour':'',
        'negation':'0',
        'param1':'',
        'param2':'',
        'packet':'0',
        'newRecord':true
      };
      modelstore.addRecord('restrictions',restriction,ctrl.model);
      ctrl.fixOrGroups();
    };
  
    ctrl.deleteRestriction = function(restriction) {
      modelstore.removeRecord('restrictions',restriction.id,ctrl.model);
      ctrl.$onInit();
    };

    $scope.$on("removeNewRestrictions",function() {
      var restriction;
      for(var i in ctrl.model.restrictions) {
        restriction=ctrl.model.restrictions[i];
        if('newRecord' in restriction) {
          modelstore.removeRecord("restrictions",restriction.id,ctrl.model);
        }
      }
    });

    ctrl.articleTypes={
      'AC':{'id':'AC','labelen':'Activity','labelnl':'Activiteit','labelfr':'Activit\u00E9'},
      'ME':{'id':'ME','labelen':'Meal','labelnl':'Maaltijd','labelfr':'Repas'},
      'PR':{'id':'PR','labelen':'Product','labelnl':'Product','labelfr':'Produit'},
      'HS':{'id':'HS','labelen':'Accommodation','labelnl':'Accommodatie','labelfr':'H\u00E9bergement'},
      'HP':{'id':'HP','labelen':'Accommodation product','labelnl':'Accommodatie product','labelfr':'Produit d\u0027h\u00E9bergement'}
    };
    ctrl.any={'id':null,'labelen':'--Any--','labelnl':'--Elk--','labelfr':'--Tout--'};

    ctrl.orgroups=[];
  }
});
angular.module('app').controller('ReportingVisitorsReportController', ["$scope", "$timeout", "tools","modelstore","webservice",
    function($scope, $timeout, tools,modelstore,webservice) {

  var script='reporting/visitorsReport';
  var model=modelstore.getModel(script);
  $scope.model=model;
  tools.initAttributes(model,{
    loading: false,
    loadingTrend: false,
    date: null,
    dateOffset: 364,
    graphDuration: 30,
    visitorData: null,
    trendData: null,
    chartInstance: null
  });

  // Initialize with yesterday's date
  function initializeDate() {
    var yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    $scope.model.date = yesterday;

    // Check if it's August 15th and adjust offset
    updateDateOffset();
  }

  // Increment offset by 1 day
  $scope.incrementOffset = function() {
    if ($scope.model.dateOffset < 1095) { // Max 3 years
      $scope.model.dateOffset++;
    }
  };

  // Decrement offset by 1 day
  $scope.decrementOffset = function() {
    if ($scope.model.dateOffset > 1) { // Min 1 day
      $scope.model.dateOffset--;
    }
  };

  // Set offset to a specific value
  $scope.setOffset = function(days) {
    $scope.model.dateOffset = days;
  };

  // Increment graph duration by 1 day
  $scope.incrementGraphDuration = function() {
    if ($scope.model.graphDuration < 365) { // Max 1 year
      $scope.model.graphDuration++;
    }
  };

  // Decrement graph duration by 1 day
  $scope.decrementGraphDuration = function() {
    if ($scope.model.graphDuration > 7) { // Min 7 days
      $scope.model.graphDuration--;
    }
  };

  // Update date offset based on selected date
  function updateDateOffset() {
    if ($scope.model.date) {
      var month = $scope.model.date.getMonth() + 1; // getMonth() is 0-based
      var day = $scope.model.date.getDate();

      if (month === 8 && day === 15) {
        $scope.model.dateOffset = 365; // 1 year for August 15th
      } else {
        $scope.model.dateOffset = 364; // 52 weeks otherwise
      }
    }
  }

  // Format date for display
  $scope.formatDate = function(dateString) {
    if (!dateString) return '';
    var date = new Date(dateString);
    return date.toLocaleDateString('nl-BE'); // DD/MM/YYYY format
  };

  // Format date for API
  function formatDateForAPI(date) {
    if (!date) return null;
    var year = date.getFullYear();
    var month = ('0' + (date.getMonth() + 1)).slice(-2);
    var day = ('0' + date.getDate()).slice(-2);
    return year + '-' + month + '-' + day;
  }

  // Load all data (visitor data and trend)
  $scope.load = function() {
    if (!$scope.model.date) return;

    $scope.model.loading = true;
    $scope.model.loadingTrend = true;

    var params = {
      date: formatDateForAPI($scope.model.date),
      dateOffset: $scope.model.dateOffset,
      graphDuration: $scope.model.graphDuration
    };

    webservice.call('load', params, script, $scope.model)
      .then(function(response) {
        if (response) {
          $scope.drawChart();
        }
      })
      .catch(function(error) {
        toastr.error('Error loading report data', 'Error');
      })
      .finally(function() {
        $scope.model.loading = false;
        $scope.model.loadingTrend = false;
      });
  };

  // Parse number from string (handles decimal strings like "262.00")
  $scope.parseNumber = function(value) {
    if (value === '' || value === null || angular.isUndefined(value)) return null;
    if (angular.isNumber(value)) return value;
    return parseFloat(value);
  };

  // Draw trend chart using Chart.js
  $scope.drawChart = function() {
    if (!$scope.model.trendData || !angular.isArray($scope.model.trendData)) {
      return;
    }

    // Destroy existing chart if any
    if ($scope.model.chartInstance) {
      $scope.model.chartInstance.destroy();
    }

    var ctx = document.getElementById('trendChart');
    if (!ctx) {
      // Retry with a longer delay if canvas not found
      $timeout($scope.drawChart, 200); // Wait for DOM
      return;
    }

    // Prepare data from the new format: [["date", reportValue, comparisonValue], ...]
    var data = $scope.model.trendData;

    // Extract dates and format them in Dutch format (DD/MM/YYYY)
    var labels = data.map(function(item) {
      var date = new Date(item[0]);
      var day = ('0' + date.getDate()).slice(-2);
      var month = ('0' + (date.getMonth() + 1)).slice(-2);
      var year = date.getFullYear();
      return day + '/' + month + '/' + year;
    });

    // Extract report date values (second element)
    var reportDateValues = data.map(function(item) {
      return item[1];
    });

    // Extract comparison date values (third element)
    var comparisonDateValues = data.map(function(item) {
      return item[2];
    });

    var chartData = {
      labels: labels,
      datasets: [{
        label: 'Report date',
        data: reportDateValues,
        borderColor: 'rgb(75, 192, 192)',
        backgroundColor: 'transparent',
        fill: false,
        tension: 0.1
      }, {
        label: 'Comparison date',
        data: comparisonDateValues,
        borderColor: 'rgb(255, 99, 132)',
        backgroundColor: 'transparent',
        fill: false,
        tension: 0.1
      }]
    };

    // Calculate indices for 5 evenly distributed labels
    var totalLabels = labels.length;
    var maxLabels = 5; // Show max 5 labels
    var labelIndices = [];
    if (totalLabels > 0) {
      if (totalLabels <= maxLabels) {
        // Show all labels if we have 5 or fewer
        for (var i = 0; i < totalLabels; i++) {
          labelIndices.push(i);
        }
      } else {
        // Calculate evenly distributed indices for 5 labels
        labelIndices.push(0); // First label
        var step = (totalLabels - 1) / (maxLabels - 1);
        for (var i = 1; i < maxLabels - 1; i++) {
          labelIndices.push(Math.round(i * step));
        }
        labelIndices.push(totalLabels - 1); // Last label
      }
    }

    var config = {
      type: 'line',
      data: chartData,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: 'top'
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: 'Number of Visitors'
            }
          }],
          xAxes: [{
            ticks: {
              autoSkip: false,
              maxRotation: 45,
              minRotation: 0,
              callback: function(value, index) {
                // Show only the selected label indices (max 5)
                if (labelIndices.indexOf(index) !== -1) {
                  return value;
                }
                return '';
              }
            }
          }]
        }
      }
    };

    $scope.model.chartInstance = new Chart(ctx, config);
  };

  // Watch for date changes
  $scope.$watch('model.date', function(newVal, oldVal) {
    if (newVal && newVal !== oldVal) {
      updateDateOffset();
      $scope.load();
    }
  });

  // Watch for offset changes
  $scope.$watch('model.dateOffset', function(newVal, oldVal) {
    if (newVal !== oldVal && $scope.model.date) {
      $scope.load();
    }
  });

  // Watch for graph duration changes
  $scope.$watch('model.graphDuration', function(newVal, oldVal) {
    if (newVal !== oldVal && $scope.model.date) {
      $scope.load();
    }
  });

  // Initialize
  initializeDate();
  $scope.load();
}]);
angular.module("app").controller("ReportingBigcAccountingController",["$scope","$sce","$window","config","tools","modelstore","parameters","webservice",
                                            function($scope,$sce,$window,config,tools,modelstore,parameters,webservice) {
  var script='reporting/bigcAccounting';
  var model=modelstore.getModel(script);
  $scope.model=model;

  $scope.dateOptions={
    maxDate: new Date(2099,11,31),
    minDate: new Date(2000,0,1),
    startingDay: 1
  };
  
  $scope.load = function() {
    model.dateValue=model.dateEditable;
    model.b2cLines=[];
    modelstore.cleanModel(["visits","contacts","movements","items","accounts","taxcomponents"],model);
    webservice.call("load",{"startdate":model.ISOStartdate,"enddate":model.ISOEnddate},script,model).then(function(response) {
      if(response) {
        // B2C
        model.mthIds=model.b2cLines.reduce(function(mthIds,line) {
          return mthIds.concat(Object.keys(line.mths));
        },[]).reduce(function(mthIds,mthId){
          if (mthIds.indexOf(mthId) < 0 ) mthIds.push(mthId);
          return mthIds;
        },[]);;
        model.mthIds.sort();
        model.totals=model.b2cLines.reduce(function(totals,line) {
          totals.base+=line.base;
          totals.vat+=line.vat;
          totals.paid+=line.paid;
          for(var mthId in line.mths) {
            if(!(mthId in totals.mths)) {
              totals.mths[mthId]=0.0
            }
            totals.mths[mthId]+=line.mths[mthId];
          }
          return totals;
        },{
          'base':0.0,
          'vat':0.0,
          'paid':0.0,
          'mths':[]
        });

        // B2B
                model.totalItems=0.0;
        model.totalMovements=0.0;
        model.totalVat=0.0;
        var components={};
        var methods={};
        //var sortedItms={};
        var sortedTaxcomponents={};
        var i,j,k,taxcomponent,sortfield,taxcomponents,item,itmId,visit,gross,base,vat,vatkey,movement,method;
        // for(i in model.itms) {
        //   itm=model.itms[i];
        //   if(!(itm.id in sortedItms)) {
        //     sortedItms[itm.id]=[];
        //   }
        //   itm.vatpercent=tools.amountIn(itm.vatpercent);
        //   sortedItms[itm.id].push(itm);
        // }
        for(i in model.taxcomponents) {
          taxcomponent=model.taxcomponents[i];
          taxcomponent.vat=tools.amountIn(parameters.VAT[taxcomponent.vat].field1);
          sortfield=tools.expandDigits(tools.round(taxcomponent.vat,0),2)+tools.expandDigits(taxcomponent.id,8);
          if(!(taxcomponent.itm in sortedTaxcomponents)) {
            taxcomponent.lastcomp='1';
            sortedTaxcomponents[taxcomponent.itm]={"maxValue":sortfield,'maxComponent':taxcomponent,'components':[]};
          } else {
            if(sortfield>sortedTaxcomponents[taxcomponent.itm].maxValue) {
              sortedTaxcomponents[taxcomponent.itm].maxComponent.lastcomp='0';
              taxcomponent.lastcomp='1';
              sortedTaxcomponents[taxcomponent.itm].maxValue=sortfield;
              sortedTaxcomponents[taxcomponent.itm].maxComponent=taxcomponent;
            } else {
              taxcomponent.lastcomp='0';
            }
          }
          sortedTaxcomponents[taxcomponent.itm].components.push(taxcomponent);
        }
        for(i in model.items) {
          item=model.items[i];
          visit=model.visits[item.visit];
          if(!("totalItems" in visit)) {
            visit.totalItems=0.0;
          }
          if(!("totalMovements" in visit)) {
            visit.totalMovements=0.0;
          }
          if(!("totalVat" in visit)) {
            visit.totalVat=0.0;
          }
          if(!("components" in visit)) {
            visit.components={};
          }
          if(!("methods" in visit)) {
            visit.methods={};
          }
          if(!(item.itm in sortedTaxcomponents)) {
            continue;
          } else {
            taxcomponents=sortedTaxcomponents[item.itm].components;
            for(j in taxcomponents) {
              taxcomponent=taxcomponents[j];
              if(taxcomponent.lastcomp=='1') {
                gross=item.deltatopay;
                for(k in taxcomponents) {
                  if(taxcomponents[k].lastcomp!='1') {
                    gross-=tools.round(tools.amountIn(taxcomponents[k].part)*item.deltatopay/100.0,2);
                  }
                }
              } else {
                gross=tools.round(tools.amountIn(taxcomponent.part)*item.deltatopay/100.0,2);
              }
              base=tools.round(100.0*gross/(100.0+taxcomponent.vat),2);
              vat=gross-base;
              itmId='YYYYYYYY';
              vatkey=itmId+Array(9-itmId.length).join(' ')+tools.expandDigits(tools.round(taxcomponent.vat,0),2)+taxcomponent.accountcode;
              if(!(vatkey in components)) {
                components[vatkey]={"code":vatkey,"base":0.0,"vat":0.0};
              }
              if(!(vatkey in visit.components)) {
                visit.components[vatkey]={"code":vatkey,"base":0.0,"vat":0.0};
              }
              model.totalItems+=gross;
              model.totalVat+=vat;
              components[vatkey].base+=base;
              components[vatkey].vat+=vat;
              visit.totalItems=tools.round(visit.totalItems+gross,2);
              visit.totalVat+=vat;
              visit.components[vatkey].base+=base;
              visit.components[vatkey].vat+=vat;
            }
          }
        }
        for(i in model.movements) {
          movement=model.movements[i];
          visit=model.visits[movement.visit];
          model.totalMovements+=movement.amount;
          method=model.accounts[movement.account].method;
          if(!("methods" in visit)) {
            visit.methods={};
          }
          if(!(method in methods)) {
            methods[method]={"mth":method,"amount":0.0};
          }
          if(!(method in visit.methods)) {
            visit.methods[method]=0.0;
          }
          visit.totalMovements=tools.round(visit.totalMovements+movement.amount,2);
          methods[method].amount+=movement.amount;
          visit.methods[method]+=movement.amount;
        }
        model.components=tools.toArray(components);
        model.methods=tools.toArray(methods);
      }
      model.totalItems=tools.round(model.totalItems,2);
      model.totalMovements=tools.round(model.totalMovements,2);
    });
  };

  $scope.selectCurrentFinishedWeek = function() {
    model.startdate=new Date();
    model.startdate.setDate(model.startdate.getDate()-((model.startdate.getDay()+6)%7+7));
    model.ISOStartdate=tools.dateFromJava(model.startdate);
    $scope.setEnddateToEndOfWeek();
  };

  $scope.setEnddateToEndOfWeek = function() {
    model.enddate=new Date();
    model.enddate.setDate(model.startdate.getDate()+6);
    model.ISOEnddate=tools.dateFromJava(model.enddate);
  }

  $scope.addWeeks = function(weeks) {
    model.startdate.setDate(model.startdate.getDate()+weeks*7);
    model.ISOStartdate=tools.dateFromJava(model.startdate);
    $scope.setEnddateToEndOfWeek();
  };

  $scope.selectCurrentFinishedMonth = function() {
    model.startdate=new Date();
    model.startdate.setDate(1);
    model.startdate.setMonth(model.startdate.getMonth()-1);
    model.ISOStartdate=tools.dateFromJava(model.startdate);
    $scope.setEnddateToEndOfMonth();
  };

  $scope.setEnddateToEndOfMonth = function() {
    model.enddate=new Date(model.startdate);
    model.enddate.setMonth(model.enddate.getMonth()+1);
    model.enddate.setDate(1);
    model.enddate.setHours(-1);
    model.ISOEnddate=tools.dateFromJava(model.enddate);
  };

  $scope.addMonths = function(months) {
    model.startdate.setDate(1);
    model.startdate.setMonth(model.startdate.getMonth()+months);
    model.ISOStartdate=tools.dateFromJava(model.startdate);
    $scope.setEnddateToEndOfMonth();
  };

  if(!('startdate' in model)) {
    $scope.selectCurrentFinishedWeek();
    model.ISOEnddate=tools.dateFromJava(model.enddate);
  }
  tools.initAttributes(model,{
    'startdateOpened':false,
    'enddateOpened':false,
    'b2cLines':[],
    'mthIds':[],
    'totals':{
      'base':0.0,
      'vat':0.0,
      'mths':[]
    },
    "components":[],
    "methods":[]
  });

  webservice.afterLogin().then(function() {
    $scope.load();
  });
  
}]);
angular.module("app").controller("QuotationsSoldOverviewController",["$scope","tools","modelstore","parameters","webservice",
                                            function($scope,tools,modelstore,parameters,webservice) {

  var script='quotations/soldOverview';
  var model=modelstore.getModel(script);
  $scope.model=model;

  $scope.load = function(companies,unpaid) {
    webservice.exclusiveCall("load",{
      'startdate':tools.dateFromJava(model.startdate),
      'enddate':tools.dateFromJava(model.enddate),
      'vatIncluded':model.vatIncluded,
      'groupMonths':model.groupMonths,
      'groupDvss':model.groupDvss
    },script,model).then(function() {
      model.showVatIncluded=model.vatIncluded;
      model.showGroupMonths=model.groupMonths;
      model.showGroupDvss=model.groupDvss;
    });
  };

  $scope.clickedMonths = function() {
    if(model.groupMonths) {
      model.groupDvss=false;
    }
  };

  $scope.clickedDvss = function() {
    if(model.groupDvss) {
      model.groupMonths=false;
    }
  };

  if(!("startdate" in model)) {
    tools.initDates(-365,-1,model);
  }
  tools.initAttributes(model,{
    'startdateOpened':false,
    'enddateOpened':false,
    'dateOptions':{
      maxDate: new Date(2099,11,31),
      minDate: new Date(2000,0,1),
      startingDay: 1
    },
    'vatIncluded':false,
    'groupMonths':true,
    'groupDvss':false,
    'showVatIncluded':true,
    'showGroupMonths':true,
    'showGroupDvss':false
  });
  webservice.afterLogin().then(function() {
    $scope.load();
  });
  
}]);
angular.module("app").controller("QuotationsListQuotationsController",["$scope","$uibModal","$log","tools","modelstore","parameters","webservice","emailbox","user",
                                            function($scope,$uibModal,$log,tools,modelstore,parameters,webservice,emailbox,user) {

  var script='quotations/listQuotations';
  var model=modelstore.getModel(script);
  $scope.model=model;

  $scope.anyUser={'id':'','name':tools.lang({'en':'--All--','nl':'--Alle--','fr':'--Tout--'})};

  $scope.structureMessages = function() {
    angular.forEach(model.emails,function(email) {
      email.table="emails";
      email.day=email.created.substr(0,10);
    });
    angular.forEach(model.quotationnotes,function(email) {
      email.table="quotationnotes";
    });
    angular.forEach(model.visits,function(visit) {
      visit.messages=tools.join(visit,'emails',model).concat(tools.join(visit,'quotationnotes',model));
      visit.messages.sort(function(a,b) {return tools.numberIn(a.day)-tools.numberIn(b.day);});
    });
  };

  $scope.calculateDiscounts = function() {
    var i,visit,items,j,item;
    for(i in model.visits) {
      visit=model.visits[i];
      visit.customDescription=false;
      visit.gross=0.0;
      visit.net=0.0;
      items=tools.join(visit,"items",model);
      for(j in items) {
        item=items[j];
        if(item.replaced=='0') {
          if(!visit.customDescription) {
            if(item.itm.substr(0,2)=='AC') {
              visit.customDescription=parameters.ACT[item.itm.substr(2,3)].field3!='0';
            } else if(item.itm.substr(0,2)=='ME') {
              visit.customDescription=parameters.DSH[item.itm.substr(2,6)].field1!='0';
            }
          }
          visit.gross+=item.quantity*tools.amountIn(item.standardunitprice);
          visit.net+=tools.amountIn(item.nettopay);
        }
      }
      visit.reduction=Math.round(100.0*(visit.gross-visit.net)/visit.gross);
    }
  };

  $scope.load = function() {
    modelstore.cleanModel(['visits','activities','participants','meals','dishes','products','items','quotationnotes','emails'],model);
    webservice.exclusiveCall("load",{
      'stv':model.stv,
      'dateMode':model.dateMode,
      'startdateQuotationStatus':tools.dateFromJava(model.startdateQuotationStatus),
      'startdate':tools.dateFromJava(model.startdate),
      'enddate':tools.dateFromJava(model.enddate),
      'quotationmanager':model.quotationmanager
    },script,model).then(function() {
      $scope.structureMessages();
      $scope.calculateDiscounts();
    });
  };

  $scope.getMaxPeople = function(visit) {
    var maxPeople=0;
    var i,participant;
    var participants=tools.join(tools.join(visit,"activities",model),"participants",model);
    for(i in participants) {
      participant=participants[i];
      maxPeople=Math.max(maxPeople,Math.max(1,tools.numberIn(parameters.UNT[participant.unt].field1))*tools.amountIn(model.items[participant.item].quantity));
    }
    var dishes=tools.join(tools.join(visit,"meals",model),"dishes",model);
    for(i in dishes) {
      maxPeople=Math.max(maxPeople,tools.amountIn(model.items[dishes[i].item].quantity));
    }
    if(maxPeople==0) {
      maxPeople="";
    }
    return maxPeople;
  };
  
  $scope.assignSoldQuotation = function(visit) {
    $uibModal.open({
      'templateUrl': 'app/modules/b2b/assignModal.html',
      'controller': 'AssignModalController',
      'resolve': {
        'visit': function() {
          return visit;
        },
        'contacts': function() {
          return model.contacts;
        },
        'users': function() {
          return model.users;
        },
        'rights': function() {
          return model.rights;
        },
        'script': function() {
          return script
        }
      }
    }).result.then(function() {
      $scope.load();
    });
  };
  
  $scope.cancel = function(visit) {
    webservice.deleteConfirm(model.contacts[visit.owningcontact].name,'cancel',visit.id,script,model).then(function() {
      $scope.load();
    });
  };

  $scope.startCreateQuotationnote = function(visit) {
    emailbox.openQuotationnoteModal(visit,{'day':tools.today(),'body':''}).then(function(quotationnote) {
      quotationnote.visit=visit.id;
      webservice.exclusiveCall('replaceQuotationnote',{'quotationnote':tools.whitelistNoId(quotationnote,['visit','day','body'])},script,model).then(function() {
        $scope.structureMessages();
      });
    });
  };

  $scope.openMessage = function(visit,message) {
    if(message.table=="emails") {
      var email=message;
      emailbox.showTemplate([email.frommail],[email.recipient],email.cc.split(';'),email.bcc.split(';'),email.subject,angular.fromJson(email.attachments).join('; '),email.body+'<br/><br/>'+email.attachmentcontent,true,{});
    } else if(message.table=="quotationnotes") {
      emailbox.openQuotationnoteModal(visit,message).then(function(quotationnote) {
        webservice.exclusiveCall('replaceQuotationnote',{'quotationnote':tools.whitelist(quotationnote,['visit','day','body'])},script,model).then(function() {
          $scope.structureMessages();
        });
      });
    }
  };

  $scope.changeOrdering = function(ordering) {
    if(model.ordering==ordering) {
      model.reverse=!model.reverse;
    } else {
      model.ordering=ordering;
      if(ordering=='created') {
        model.reverse=true;
      } else if(ordering=='startdate') {
        model.reverse=false;
      }
    }
  };

  $scope.restore = function(visit) {
    webservice.confirmModal(tools.lang({'en':'Restore','nl':'','fr':'Remettre'})+' '+visit.name+' '+tools.lang({'en':'as offer?','nl':'terugzetten als offerte?','fr':'comme offre?'})).then(function() {
      webservice.exclusiveCall('restore',{"id":visit.id},script,model).then(function() {
        $scope.load();
      });
    });
  };

  if(!("startdate" in model)) {
    tools.initDates(-31,0,model);
  }
  tools.initAttributes(model,{
    'stvs':[],
    'stv':'1210',
    'dateModes':[
      {'id':'created','labelen':'Created','labelnl':'Aangemaakt','labelfr':'Cr\u00E9\u00E9'},
      {'id':'startdate','labelen':'Visit','labelnl':'Bezoek','labelfr':'Visite'}
    ],
    'dateMode':'created',
    'startdateQuotationStatus':new Date(tools.today()),
    'startdateQuotationStatusOpened':false,
    'startdateOpened':false,
    'enddateOpened':false,
    'dateOptions':{
      maxDate: new Date(2099,11,31),
      minDate: new Date(2000,0,1),
      startingDay: 1
    },
    'quotationmanager':'',
    'reverse':true,
    'ordering':'created'
  });
  webservice.afterLogin().then(function() {
    if(model.stvs.length==0) {
      model.stvs=[parameters.STV['1210'],{'id':'2100','labelen':'Sold','labelnl':'Verkocht','labelfr':'Vendu'},parameters.STV['9100']];
      model.quotationmanager=user.id
    }
    $scope.load();
  });
  
}]);
angular.module("app").controller("OperationsListManagersController",["$filter","$scope","$uibModal","tools","modelstore","parameters","webservice","emailbox","user",
                                            function($filter,$scope,$uibModal,tools,modelstore,parameters,webservice,emailbox,user) {

  var script='quotations/listOperationsManagers';
  var model=modelstore.getModel(script);
  $scope.model=model;

  $scope.anyUser={'id':'','name':tools.lang({'en':'--All--','nl':'--Alle--','fr':'--Tout--'})};

  $scope.structureMessages = function() {
    angular.forEach(model.emails,function(email) {
      email.table="emails";
      email.day=email.created.substr(0,10);
    });
    angular.forEach(model.quotationnotes,function(email) {
      email.table="quotationnotes";
    });
    angular.forEach(model.visits,function(visit) {
      visit.messages=tools.join(visit,'emails',model).concat(tools.join(visit,'quotationnotes',model));
      visit.messages=visit.messages.sort(function(a,b) {return tools.numberIn(a.day)-tools.numberIn(b.day);}).filter(function(el) {return el;});
    });
  };

  $scope.load = function() {
    modelstore.cleanModel(['visits','activities','participants','meals','dishes','products','items','quotationnotes','emails'],model);
    webservice.exclusiveCall("load",{
      'startdate':tools.dateFromJava(model.startdate),
      'enddate':tools.dateFromJava(model.enddate),
      'operationsmanager':model.operationsmanager
    },script,model).then(function() {
      $scope.structureMessages();
      $scope.filterAndOrderVisits();
    });
  };

  $scope.getMaxPeople = function(visit) {
    var maxPeople=0;
    var i,participant;
    var participants=tools.join(tools.join(visit,"activities",model),"participants",model);
    for(i in participants) {
      participant=participants[i];
      maxPeople=Math.max(maxPeople,Math.max(1,tools.numberIn(parameters.UNT[participant.unt].field1))*tools.amountIn(model.items[participant.item].quantity));
    }
    var dishes=tools.join(tools.join(visit,"meals",model),"dishes",model);
    for(i in dishes) {
      maxPeople=Math.max(maxPeople,tools.amountIn(model.items[dishes[i].item].quantity));
    }
    if(maxPeople==0) {
      maxPeople="";
    }
    return maxPeople;
  };
  
  $scope.accept = function(visit) {
    webservice.exclusiveCall('prepareAssignmentEmail',{"id":visit.id,"visit":''},script,model).then(function(response) {
      response.body=response.body.replace(response.placeholders.quotationManagerInfo,'').replace(response.placeholders.operationsManagerInfo,'').replace(response.placeholders.invoicesManagerInfo,'').replace(/<br\/>/g,'\n');
      $uibModal.open({
        'templateUrl': 'app/modules/b2b/acceptAssignModal.html',
        'controller': 'AcceptAssignModalController',
        'resolve': {
          'visit': function() {
            return visit;
          },
          'contacts': function() {
            return model.contacts;
          },
          'users': function() {
            return model.users;
          },
          'rights': function() {
            return model.rights;
          },
          'quotationmanager': function() {
            return model.quotationmanager;
          },
          'preparedTemplate': function() {
            return response;
          },
          'readonly': function() {
            return true;
          },
          'script': function() {
            return script
          }
        }
      }).result.then(function() {
        $scope.load();
      });
    });
  };
  
  $scope.startCreateQuotationnote = function(visit) {
    emailbox.openQuotationnoteModal(visit,{'day':tools.today(),'body':''}).then(function(quotationnote) {
      quotationnote.visit=visit.id;
      webservice.exclusiveCall('replaceQuotationnote',{'quotationnote':tools.whitelistNoId(quotationnote,['visit','day','body'])},script,model).then(function() {
        $scope.structureMessages();
      });
    });
  };

  $scope.openMessage = function(visit,message) {
    if(message.table=="emails") {
      var email=message;
      emailbox.showTemplate([email.frommail],[email.recipient],email.cc.split(';'),email.bcc.split(';'),email.subject,angular.fromJson(email.attachments).join('; '),email.body+'<br/><br/>'+email.attachmentcontent,true,{});
    } else if(message.table=="quotationnotes") {
      emailbox.openQuotationnoteModal(visit,message).then(function(quotationnote) {
        webservice.exclusiveCall('replaceQuotationnote',{'quotationnote':tools.whitelist(quotationnote,['visit','day','body'])},script,model).then(function() {
          $scope.structureMessages();
        });
      });
    }
  };

  $scope.changeOrdering = function(ordering) {
    if(model.ordering==ordering) {
      model.reverse=!model.reverse;
    } else {
      model.ordering=ordering;
      if(ordering=='startdate') {
        model.reverse=true;
      }
    }
    $scope.load();
  };

  $scope.reassign = function(visit) {
    $uibModal.open({
      'templateUrl': 'app/modules/b2b/assignModal.html',
      'controller': 'AssignModalController',
      'resolve': {
        'visit': function() {
          return visit;
        },
        'contacts': function() {
          return model.contacts;
        },
        'users': function() {
          return model.users;
        },
        'rights': function() {
          return model.rights;
        },
        'quotationmanager': function() {
          return model.quotationmanager;
        },
        'script': function() {
          return script
        }
      }
    }).result.then(function() {
      $scope.load();
    });
  };

  $scope.filterAndOrderVisits = function() {
    var visitsArray,visit;
    visitsArray=tools.toArray(model.visits);
    model.unAssignedVisits=$filter('filter')(visitsArray,function(visit){
      if(visit.stat!='2200'&&visit.stat!='4000') {
        return true;
      } else {
        return false;
      }
    });
    model.assignedVisits=$filter('filter')(visitsArray,function(visit){
      if(visit.stat=='2200'||visit.stat=='4000') {
        return true;
      } else {
        return false;
      }
    });
    if(model.operationsmanager!='') {
      model.orderedUnAssignedVisits=$filter('orderBy')(model.unAssignedVisits,model.ordering,model.reverse);
      model.orderedAssignedVisits=$filter('orderBy')(model.assignedVisits,model.ordering,model.reverse);
      model.orderedVisits=model.orderedUnAssignedVisits.concat(model.orderedAssignedVisits);
    } else {
      model.orderedVisits=$filter('orderBy')(tools.toArray(model.visits),model.ordering,model.reverse);
    }
  }

  if(!("startdate" in model)) {
    tools.initDates(0,31,model);
  }
  tools.initAttributes(model,{
    'unAssignedVisits':[],
    'assignedVisits':[],
    'orderedUnAssignedVisits':[],
    'orderedAssignedVisits':[],
    'orderedVisits':[],
    'filterModes':[],
    'filterMode':'',
    'startdateOpened':false,
    'enddateOpened':false,
    'dateOptions':{
      maxDate: new Date(2099,11,31),
      minDate: new Date(2000,0,1),
      startingDay: 1
    },
    'operationsmanager':'',
    'reverse':false,
    'ordering':'startdate'
  });
  webservice.afterLogin().then(function() {
    if(model.filterModes.length==0) {
      model.filterModes=[
        {
          'id':'',
          'labelen':'All',
          'labelnl':'Alles',
          'labelfr':'Tous'
        }
      ];
      model.operationsmanager=user.id
    }
    $scope.load();
  });
}]);
angular.module("app").controller("InvoicesListManagersController",["$scope","$uibModal","$log","tools","modelstore","parameters","webservice","emailbox","user","contactsService",
                                            function($scope,$uibModal,$log,tools,modelstore,parameters,webservice,emailbox,user,contactsService) {

  var script='quotations/listInvoicesManagers';
  var model=modelstore.getModel(script);
  $scope.model=model;
  $scope.contactsService=contactsService;

  $scope.anyUser={'id':'','name':tools.lang({'en':'--Somebody--','nl':'--Iemand--','fr':'--Quelqu\u0027un--'})};
  $scope.nonUser={'id':'0','name':tools.lang({'en':'--Nobody--','nl':'--Niemand--','fr':'--Personne--'})};

  $scope.calculatePaymentAmounts = function() {
    var i,visit,balance;
    for(i in model.balances) {
      balance=model.balances[i];
      visit=model.visits[balance.visit];
      visit.uninvoicedAmount=balance.uninvoicedamount;
      visit.unpaidInvoiceAmount=balance.unpaidinvoiceamount;
      visit.paidAmount=balance.paidamount;
      visit.totalAmount=balance.totalamount;
    }
  };

  $scope.load = function() {
    modelstore.cleanModel(['visits','movements','items'],model);
    webservice.exclusiveCall("load",{
      'enddate':tools.dateFromJava(model.enddate),
      'invoicesmanager':model.invoicesmanager,
      'filtermode':model.filterMode,
      'dvs':model.dvs,
      'segment':model.segment
    },script,model).then(function() {
      $scope.calculatePaymentAmounts();
    });
  };

  $scope.changeOrdering = function(ordering) {
    if(model.ordering==ordering) {
      model.reverse=!model.reverse;
    } else {
      model.ordering=ordering;
      if(ordering=='startdate') {
        model.reverse=true;
      }
    }
  };

  $scope.recalculateMismatch = function() {
    webservice.exclusiveCall("recalculateMismatch",{'dvs':model.dvs},script,model).then(function() {
      $scope.load();
    })
  };

  $scope.getAccommodations = function(visit) {
    var i,htl,hotelreservationcategory;
    var result=[];
    var hotelreservationcategories=tools.join(visit,'hotelreservationcategories',model);
    for(i in hotelreservationcategories) {
      htl=hotelreservationcategories[i].htl;
      if(result.indexOf(htl)==-1) {
        result.push(htl);
      }
    }
    return result;
  }

  if(!("enddate" in model)) {
    tools.initDates(0,0,model);
  }
  tools.initAttributes(model,{
    'filterModes':[],
    'filterMode':'',
    'enddateOpened':false,
    'dateOptions':{
      maxDate: new Date(2099,11,31),
      minDate: new Date(2000,0,1),
      startingDay: 1
    },
    'invoicesmanager':'',
    'reverse':true,
    'ordering':'startdate',
    'dvs':'',
    'segment':'B2B'
  });
  webservice.afterLogin().then(function() {
    if(model.filterModes.length==0) {
      model.filterModes=[{
        'id':'',
        'labelen':'All',
        'labelnl':'Alles',
        'labelfr':'Tous'
      },{
        'id':'uninvoicedAmount',
        'labelen':'Uninvoiced',
        'labelnl':'Ongefactureerd',
        'labelfr':'Non-factur\u00E9'
      },{
        'id':'unpaidInvoiceAmount',
        'labelen':'Unpaid invoices',
        'labelnl':'Onbetaalde facturen',
        'labelfr':'Factures impay\u00E9'
      }];
      model.invoicesmanager=user.id
    }
    $scope.load();
  });
  $scope.$watch("model.enddate.getTime()",function(newVal,oldVal) {
    if(webservice.loggedIn) {
      $scope.load();
    }
  });
  
}]);
angular.module("app").controller("QuotationsCreateQuotationController",["$scope","$stateParams","modelstore",
                                            function($scope,$stateParams,modelstore) {

  var modelName='quotations/createQuotation';
  var parentmodel=modelstore.getModel(modelName);

  if($stateParams.settings!==null && 'vis' in $stateParams.settings && $stateParams.settings.vis!==null) {
    parentmodel.defaultVis=$stateParams.settings.vis;
  } else if(angular.isUndefined(parentmodel.defaultVis)) {
    parentmodel.defaultVis='COM';
  }
  var model=modelstore.getModel(modelName+'/'+parentmodel.defaultVis);
  $scope.model=model;

  model.defaultVis=parentmodel.defaultVis;
  model.defaultIsCompany='1';
  model.defaultStat='1210';
  model.defaultReductionMode='item';

}]);
angular.module('app').controller('PricesPromotionsController',['$scope','tools','modelstore','parameters','webservice','activitiesService','user','dictionary',
                                            function($scope,tools,modelstore,parameters,webservice,activitiesService,user,dictionary) {

  var script='prices/promotions';
  var model=modelstore.getModel(script);
  $scope.model=model;
  $scope.activitiesService=activitiesService;

  $scope.selectPromotion = function(promotion) {
    model.selectedPromotion=promotion===null?null:model.promotions[promotion.id];
    $scope.$broadcast("fixOrGroups");
  }
  
  $scope.editPromotion = function(promotion) {
    model.backupPromotions[promotion.id]=tools.clone(promotion);
    var restrictions=tools.join(promotion,'restrictions',model);
    var restriction;
    for(var i in restrictions) {
      restriction=restrictions[i];
      model.backupRestrictions[restriction.id]=tools.clone(restriction);
    }
    promotion.editing=true;
  };

  $scope.cancelPromotion = function(promotion) {
    if(promotion.newRecord) {
      $scope.deleteNewPromotion(promotion);
    } else {
      var i;
      var cancelRestrictions=tools.join(promotion,'restrictions',model);
      for(i in cancelRestrictions) {
        modelstore.removeRecord('restrictions',cancelRestrictions[i].id,model);
      }
      var backupRestrictions=model.backupPromotions[promotion.id].restrictions;
      modelstore.addRecord('promotions',model.backupPromotions[promotion.id],model);
      for(i in backupRestrictions) {
        modelstore.addRecord('restrictions',model.backupRestrictions[backupRestrictions[i]],model);
      }
      $scope.selectPromotion(model.promotions[promotion.id]);
      $scope.$broadcast("fixOrGroups");
    }
  };
  
  $scope.createPromotion = function() {
    var promotion={
      'id':tools.getMinIdMinusOne(model.promotions),
      'pro':'',
      'peritem':'0',
      'amount':'0',
      'percent':'1',
      'packet':'0',
      'active':'1',
      'editing':true,
      'newRecord':true
    };
    modelstore.addRecord('promotions',promotion,model);
    $scope.selectPromotion(promotion);
    $scope.refresh();
  };
  
  $scope.deleteNewPromotion = function(promotion) {
    var restrictions=tools.join(promotion,'restrictions',model);
    for(var i in restrictions) {
      if(restrictions[i].newRecord) {
        modelstore.removeRecord('restrictions',restrictions[i].id,model);
      }
    }
    if(promotion.newRecord) {
      modelstore.removeRecord('promotions',promotion.id,model);
    }
    $scope.selectPromotion(null);
    $scope.refresh();
  };
  
  $scope.replacePromotion = function(promotion) {
    if('newRecord' in promotion) {
      $scope.insertPromotion(promotion);
    } else {
      $scope.updatePromotion(promotion);
    }
  };
  
  var promotionWhitelist=['pro','peritem','amount','percent','packet','active'];
  
  $scope.insertPromotion = function(promotion) {
    webservice.call('insertPromotion',{
      'promotion':tools.whitelistNoId(promotion,promotionWhitelist),
      'restrictions':tools.whitelistNoId(tools.join(promotion,'restrictions',model),dictionary.whitelists.restrictions)
    },script,model).then(function(response) {
      if(response) {
        $scope.deleteNewPromotion(promotion);
        $scope.refresh();
        $scope.selectPromotion(response);
      }
    });
  };
  
  $scope.updatePromotion = function(promotion) {
    var restrictions=tools.join(promotion,'restrictions',model);
    var whitelistedRestrictions=[];
    var restriction;
    for(var i in restrictions) {
      restriction=restrictions[i];
      if('newRecord' in restriction) {
        restriction=tools.whitelistNoId(restriction,dictionary.whitelists.restrictions);
      } else {
        restriction=tools.whitelist(restriction,dictionary.whitelists.restrictions);
      }
      whitelistedRestrictions.push(restriction);
    }
    var promotionId=promotion.id;
    webservice.call('updatePromotion',{
      'promotion':tools.whitelist(promotion,promotionWhitelist),
      'restrictions':whitelistedRestrictions
    },script,model).then(function(response) {
      if(response) {
        promotion=model.promotions[promotionId];
        promotion.editing=false;
        $scope.$broadcast("removeNewRestrictions");
        $scope.selectPromotion(model.promotions[promotionId]);
        $scope.refresh();
      }
    });
  };
  
  $scope.deletePromotion = function(promotion) {
    webservice.call('deletePromotion',{'id':promotion.id},script,model).then(function(response) {
      if(response) {
        model.selectedPromotionId={};
        model.selectedPromotion=null;
        $scope.$broadcast("fixOrGroups");
        $scope.refresh();
      }
    });
  };
  
  $scope.sort = function(record) {
    return 10000-parseInt(record.id);
  };

  $scope.refresh = function() {
    model.activePromotions=tools.exclude(model.promotions,{'active':'0'});
    var i,promotion;
    for(i in model.activePromotions) {
      promotion=model.activePromotions[i];
      promotion.label=tools.label(parameters.PRO[promotion.pro])+' '+tools.amountOut(promotion.amount)+(promotion.percent=='1'?'%':'€');
      promotion.editing=promotion.editing || false;
    }
  };

  $scope.getParent = function() {
    return model.selectedPromotion;
  };

  $scope.getEditing = function() {
    return model.selectedPromotion?model.selectedPromotion.editing:false;
  };

  $scope.getBehaviourFilter = function() {
    return model.selectedPromotion?(model.selectedPromotion.peritem=='2'?'articles':'visit'):'visit';
  };

  $scope.multiselectPromotionSettings={
    'scrollable':true,
    'scrollableHeight':'300px',
    'selectionLimit':1,
    'smartButtonMaxItems':1,
    'showCheckAll':false,
    'showUncheckAll':false,
    'enableSearch':true,
    'styleActive':true,
    'keyboardControls':true,
    'closeOnSelect':true,
    'buttonClasses':'btn btn-default js-dropdown'
  };
  $scope.multiselectTranslations={
    'checkAll':tools.lang({'en':'Check all','nl':'Alles selecteren','fr':'S\u00E9llectioner tout'}),
    'uncheckAll':tools.lang({'en':'Uncheck all','nl':'Alles deselecteren','fr':'Des\u00E9llectioner tout'}),
    'selectionCount':tools.lang({'en':'checked','nl':'Geselecteerd','fr':'S\u00E9llectioner'}),
    'searchPlaceholder':tools.lang({'en':'Search...','nl':'Zoek...','fr':'Chercher...'}),
    'buttonDefaultText':tools.lang({'en':'Select promotion','nl':'Selecteer promotie','fr':'S\u00E9llectioner promotion'}),
    'dynamicButtonTextSuffix':tools.lang({'en':'checked','nl':'Geselecteerd','fr':'S\u00E9llectioner'}),
    'selectGroup':tools.lang({'en':'Select All:','nl':'Selecteer Alles:','fr':'S\u00E9llectioner tout:'})
  };
  $scope.reductionModes=[
    {'id':'0','glyphicon':'glyphicon-euro'},
    {'id':'1','glyphicon':'glyphicon-percent'},
    {'id':'2','glyphicon':'glyphicon-user'}/*,
    {'id':'3','labelen':'Fixed Price','labelnl':'Vaste Prijs','labelfr':'Prix Fixe'}*/
  ];
  $scope.promotionTypes={
    '0':{'id':'0','sort':'0','labelen':'on everything','labelnl':'op alles','labelfr':'sur tout'},
    '1':{'id':'1','sort':'1','labelen':'on all activities','labelnl':'op alle activiteiten','labelfr':'sur toutes les activit\u00E9s'},
    '2':{'id':'2','sort':'6','labelen':'per article','labelnl':'per artikel','labelfr':'par article'},
    '3':{'id':'3','sort':'2','labelen':'on all meals','labelnl':'op alle maaltijden','labelfr':'sur toutes les repas'},
    '4':{'id':'4','sort':'3','labelen':'on all accomodations','labelnl':'op alle accomodaties','labelfr':'sur toutes les h\u00E9bergements'},
    '5':{'id':'5','sort':'5','labelen':'on all products','labelnl':'op alle producten','labelfr':'sur toutes les produits'},
    '6':{'id':'6','sort':'4','labelen':'on all accomodation products','labelnl':'op alle hotelproducten','labelfr':'sur toutes les produits d\u0027h\u00E9bergements'}
  };
  
  tools.initAttributes(model,{
    'selectedPromotionId':{},
    'selectedPromotion':null,
    'backupPromotions':{},
    'backupRestrictions':{},
    'activePromotions':[],
    'restrictions':{}
  });
 
  webservice.afterLogin().then(function() {
    webservice.call('load',{},script,model).then(function(response) {
      if(response) {
        $scope.refresh();
      }
    });
  });
  
}]);
angular.module("app").controller("PartnersInvoicesController",["$scope","tools","modelstore","parameters","webservice",
                                            function($scope,tools,modelstore,parameters,webservice) {

  var script="partners/invoices";
  var model=modelstore.getModel(script);
  $scope.model=model;

  $scope.load = function() {
    if(!model.loading) {
      model.loading=true;
      model.startdateValue=tools.dateFromJava(model.startdate);
      model.enddateValue=tools.dateFromJava(model.enddate);
      model.mthValue=model.mth;
      modelstore.cleanModel(["accounts","balances","movements","visits","activities","participants","items"],model);
      webservice.call("load",{'startdate':tools.dateFromJava(model.startdate),'enddate':tools.dateFromJava(model.enddate),'mth':model.mth},script,model).then(function(response) {
        if(response) {
          model.account=model.accounts[response];
          model.balance=tools.max(tools.lessEqual(
            tools.join(model.account,'balances',model),
            'created',
            model.startdateValue+' 23:59:59'
          ),'created');
          model.loading=false;
        }
      });
    }
  };

  tools.initAttributes(model,{
    'loading':false,
    'retrieveAccountFormIsLoaded':$q.defer()
  });
  $q.all([webservice.afterLogin(),model.retrieveAccountFormIsLoaded.promise]).then(function() {
    $scope.load();
  });
  
}]);
angular.module("app").controller("ParamtablesParamListController",["$scope","tools","user","errorlog","modelstore","parameters","webservice",
                                                        function($scope,tools,user,errorlog,modelstore,parameters,webservice) {
  
  var script="paramtables/paramList";
  var model=modelstore.getModel(script);
  $scope.model=model;
  
  $scope.initParam = function() {
    model.param = {
      'id':'',
      'del':'0',
      'labelen':'',
      'labelnl':'',
      'labelfr':'',
      'shorten':'',
      'shortnl':'',
      'shortfr':'',
      'field1':'',
      'field2':'',
      'field3':'',
      'field4':'',
      'field5':'',
      'field6':'',
      'field7':'',
      'field8':'',
      'field9':'',
      'field10':'',
      'field11':'',
      'field12':'',
      'field13':'',
      'field14':'',
      'field15':'',
      'field16':''
    };
  };

  $scope.orderTbl = function(tbl) {
    return tools.label(tbl);
  };

  $scope.calculateRows = function() {
    model.rows = tools.toArray(tools.clone(parameters[model.tbl]));
    if(!model.showDeleted) {
      model.rows=tools.match(model.rows,{'del':'0'});
    }
    if(model.filter!=='none') {
      var result=[];
      var filters=tools.latinise(model.filterValue).split(" ");
      var i,j,matches,name,row,filter;
      for(i in model.rows) {
        row=model.rows[i];
        matches=true;
        filter=tools.latinise(row[model.filter]);
        for(j in filters) {
          if(!(filter.indexOf(filters[j])>-1)) {
            matches=false;
            break;
          }
        }
        if(matches) {
          result.push(row);
        }
      }
      model.rows=result;
    }
    $scope.updatePages();
  };

  $scope.changeFilter = function() {
    model.filterValue='';
  }
  
  $scope.changeTbl = function() {
    model.header = model.paramheaders[model.tbl];
    model.filterFields={'none':tools.lang({'en':'--none--','nl':'--geen--','fr':'--aucun--'}),'id':'Argument','labelen':'En name','labelnl':'Nl naam','labelfr':'Nom fr'};
    for(var key in model.header) {
      if(key.substr(0,5)==='field') {
        model.filterFields[key]=model.header[key];
      }
    }
    if(angular.isUndefined(model.filterFields[model.filter])) {
      model.filter='none';
      $scope.changeFilter();
    }
    if(!(model.tbl in parameters)) {
      parameters[model.tbl]={};
    }
    $scope.calculateRows();
    $scope.initParam();
  };

  $scope.whitelistParam = function(param) {
    return tools.whitelist(param,['tbl','del','labelen','labelnl','labelfr','shorten','shortnl','shortfr','field1','field2','field3','field4','field5','field6','field7','field8','field9','field10','field11','field12','field13','field14','field15','field16']);
  }
  
  $scope.paramCreate = function() {
    model.param.tbl=model.tbl;
    webservice.call("paramCreate",{"param":$scope.whitelistParam(model.param)},script,model).then(function(response) {
      if(response) {
        parameters.updateParamtable(model.param.tbl,$scope.whitelistParam([model.param]));
        delete model[model.param.tbl];
        $scope.calculateRows();
        $scope.initParam();
      }
    });
  };

  $scope.edit = function(param) {
    var id=param.id;
    $scope.calculateRows();
    for(var i in model.rows) {
      if(model.rows[i].id===id) {
        model.rows[i].editing=true;
      }
    }
  };
  
  $scope.paramUpdate = function(param) {
    param.tbl=model.tbl;
    webservice.call("paramUpdate",{"param":$scope.whitelistParam(param)},script,model).then(function(response) {
      if(response) {
        parameters.updateParamtable(param.tbl,$scope.whitelistParam([model[param.tbl][param.id]]));
        delete model[param.tbl][param.id];
        $scope.calculateRows();
      }
    });
  };

  $scope.updatePages=function() {
    model.totalItems=tools.getLength(model.rows);
  };
  
  webservice.call("loadParamheaders",{},script,model);
  if(!("param" in model)) {
    $scope.initParam();
  }
  tools.initAttributes(model,{
    "itemsPerPage":50,
    "totalItems":0,
    "page":1,
    "tbl":"",
    'showDeleted':false,
    'filter':'none'
  });
  
}]);
angular.module("app").controller("ParamtablesCombinationListController",["$scope","tools","user","errorlog","modelstore","parameters","webservice",
                                                        function($scope,tools,user,errorlog,modelstore,parameters,webservice) {
  
  var script="paramtables/combinationList";
  var model=modelstore.getModel(script);
  $scope.model=model;

  $scope.changeCombination = function() {
    model.editing1=null;
    model.editing2=null;
    model.filter1='';
    model.filter2='';
    model.id3='';
    $scope.buildValues();
  };
  
  $scope.buildValues = function() {
    if(model.combination) {
      model.paramNameY=model.combination.substr(0,3);
      model.paramNameX=model.combination.substr(3,3);
      model.isBoolean=model.combinations[model.combination].boolean;
      model.filter1Table=model.combinations[model.combination].filter1;
      model.hasSharedFilter=model.combinations[model.combination].sharedFilter;
      model.hasId3=model.combinations[model.combination].id3;
      model.paramNameZ=model.hasId3?model.combination.substr(6,3):"";

      model.editing1=null,
      model.editing2=null,
      model.editingValue="",
      model.paramsy=null;
      model.paramsx=null;
      model.values={};
      if((!model.hasSharedFilter || model.filter1!='') && (!model.hasId3 || model.id3!='')) {
        model.paramsy=tools.toArray(parameters['notDel'+model.paramNameY]);
        if(model.filter1!='') {
          model.paramsy=model.paramsy.filter(function(param) {
            return param.id.substr(0,3)==model.filter1 && (model.combination!='HSCHPDA' || param.field6=='1');
          });
        }
        model.paramsx=tools.toArray(parameters['notDel'+model.paramNameX]);
        if(model.hasSharedFilter && model.filter1!='') {
          model.paramsx=model.paramsx.filter(function(param) {
            return param.id.substr(0,3)==model.filter1 && (model.combination!='HSCHPDA' || param.field5=='1');
          });
        }
        model.values=model.paramsy.reduce(function(acc,param1) {
          acc[param1.id]=model.paramsx.reduce(function(acc,param2) {
            acc[param2.id]=model.isBoolean?false:"";
            return acc;
          },{});
          return acc;
        },{});

        if(model.combination in parameters && (!model.hasId3 || (model.id3 in parameters[model.combination]))) {
          var id1s;
          if(model.hasId3) {
            id1s=parameters[model.combination][model.id3].id1s;
          } else {
            id1s=parameters[model.combination];
          }
          var i,j,id2s,id2,id2key;
          for(i in id1s) {
            if((i in parameters[model.paramNameY]) && parameters[model.paramNameY][i].del=='0') {
              id2s=model.hasId3?id1s[i]:id1s[i].id2s;
              for(j in id2s) {
                id2=id2s[j];
                id2key=model.isBoolean?id2:j;
                if((id2key in parameters[model.paramNameX]) && parameters[model.paramNameX][id2key].del=='0') {
                  if((i in model.values) && (id2key in model.values[i])) {
                    model.values[i][id2key]=model.isBoolean?true:id2;
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  
  $scope.enterCell = function(id1,id2) {
    model.hover=id1+id2;
  };
  
  $scope.leaveCell = function() {
    model.hover="";
  };
  
  $scope.showButton = function(id1,id2,createButton) {
    return model.hover==id1+id2 && (model.values[id1][id2]?(!createButton):createButton);
  };
  
  $scope.replaceCombination = function(id1,id2,val) {
    val=angular.isUndefined(val)?'1':val;
    var params={'id':model.combination,'id1':id1,'id2':id2,'val':val};
    if(model.hasId3) {
      params.id3=model.id3;
    }
    webservice.call('replaceCombination',params,script,model).then(function(response) {
      if(response) {
        parameters[model.combination]=model[model.combination];
        $scope.buildValues();
      }
    });
  };
  
  $scope.deleteCombination = function(id1,id2) {
    var params={'id':model.combination,'id1':id1,'id2':id2};
    if(model.hasId3) {
      params.id3=model.id3;
    }
    model[model.combination]={};
    webservice.call('deleteCombination',params,script,model).then(function(response) {
      if(response) {
        parameters[model.combination]=model[model.combination];
        $scope.buildValues();
      }
    });
  };

  $scope.isEditing = function(id1,id2) {
    return model.editing1==id1 && model.editing2==id2;
  };

  $scope.startNonBooleanEdit = function(id1,id2) {
    model.selectedCell=id1+id2;
    if(!model.isBoolean && !$scope.isEditing(id1,id2)) {
      if(model.editing1!=null) {
        $scope.updateNonBoolean(model.editing1,model.editing2);
      }
      model.editing1=id1;
      model.editing2=id2;
      model.editingValue=model.values[id1][id2];
    }
  };

  $scope.updateNonBoolean = function(id1,id2) {
    if(model.editingValue!=model.values[id1][id2]) {
      if(model.editingValue=="") {
        $scope.deleteCombination(id1,id2);
      } else {
        $scope.replaceCombination(id1,id2,model.editingValue);
      }
    }
  };

  tools.initAttributes(model,{
    "paramNameY":"",
    "paramNameX":"",
    "paramNameZ":"",
    "isBoolean":true,
    "combination":"",
    "paramsx":null,
    "paramsy":null,
    "values":{},
    "hover":null,
    "editing1":null,
    "editing2":null,
    "editingValue":"",
    "selectedCell":null,
    "filter1":"",
    "filter2":"",
    "id3":"",
    "hasId3":false
  });
  webservice.afterLogin().then(function()  {
    webservice.call("loadCombinations",{},script,model);
  });

  
}]);
angular.module("app").controller("MealsUpdatesController",["$scope","tools","modelstore","parameters","activitiesService","webservice",
                                            function($scope,tools,modelstore,parameters,activitiesService,webservice) {

  $scope.activitiesService=activitiesService;
  var script='meals/updates';
  var model=modelstore.getModel(script);
  $scope.model=model;

  $scope.afterLoad = function() {
    $scope.setDates();
  };

  $scope.load = function() {
    if(tools.validateAndUpdateDates(model)) {
      model.showResLabel=model.ress.length!=1;
      model.dates=[];
      modelstore.cleanModel(["visits","meals","dishes","items"],model);
      webservice.exclusiveCall("load",{
        'ress':model.ress,
        'startdate':tools.dateFromJava(model.startdate),
        'enddate':tools.dateFromJava(model.enddate),
        'startMea':model.startMea,
        'endMea':model.endMea
      },script,model).then($scope.afterLoad);
    }
  };

  $scope.setDates = function() {
    var dates={};
    var i,meal,day;
    for(i in model.meals) {
      meal=model.meals[i];
      day=tools.dateFromJava(meal.day);
      if(!(day in dates)) {
        dates[day]={'id':day,'meals':[]};
      }
      dates[day].meals.push(meal);
    }
    model.dates=tools.toArray(dates);
  };

  $scope.selectRes = function(res) {
    var index=model.ress.indexOf(res);
    if(index<0) {
      model.ress.push(res);
    } else {
      model.ress.splice(index,1);
    }
    $scope.load();
  };

  $scope.getMeals = function(meals) {
    var result=meals;
    var i,meal;
    if(model.filter!='') {
      result=[];
      var filters=tools.latinise(model.filter).split(" ");
      var j,matches,name;
      for(i in meals) {
        meal=meals[i];
        matches=true;
        name=tools.latinise(model.visits[meal.visit].name);
        for(j in filters) {
          if(!(name.indexOf(filters[j])>-1)) {
            matches=false;
            break;
          }
        }
        if(matches) {
          result.push(meal);
        }
      }
    }
    return result;
  };

  $scope.getMaxUpdated = function(meal) {
    var records=tools.join(meal,'dishes',model).map(function(dish){
      var item=model.items[dish.item];
      return dish.updated>item.updated?dish:item;
    });
    var record=records.length>0?records.reduce(function(a,b){
      return a.updated>b.updated?a:b;
    }):null;
    return record!=null?(meal.updated>record.updated?meal:record):meal;
  }

  $scope.updateChecked = function(meal) {
    webservice.exclusiveCall('updateChecked',{'mealId':meal.id},script,model).then(function() {
      $scope.load();
    });
  };

  $scope.any={'id':'','labelen':'--All--','labelnl':'--Alle--','labelfr':'--Tout--'};

  if(!("startdate" in model)) {
    tools.initDates(0,0,model);
  }
  tools.initAttributes(model,{
    'filter':'',
    'dates':[],
    'showZero':false,
    'ress':['BOH','BRU','CAV'],
    'showResLabel':true,
    'roomUnts':[],
    'backupMeals':{}
  });
  webservice.afterLogin().then(function() {
    $scope.$watch("model.startdate.getTime()",function(newVal,oldVal) {
      if(oldVal==model.enddate.getTime()) {
        model.enddate=new Date();
        model.enddate.setTime(newVal);
      }
      $scope.load();
    });
    $scope.$watch('model.enddate.getTime()',function() {
      $scope.load();
    });
  });
  
  
}]);
angular.module("app").controller("MealsTakeAwayController",["$scope","$sce","config","tools","modelstore","parameters","activitiesService","webservice","contactsService",
                                            function($scope,$sce,config,tools,modelstore,parameters,activitiesService,webservice,contactsService) {

  $scope.activitiesService=activitiesService;
  $scope.contactsService=contactsService;
  var script='meals/takeAway';
  var model=modelstore.getModel(script);
  $scope.model=model;

  $scope.load = function() {
    if(tools.validateAndUpdateDates(model)) {
      model.showResLabel=model.ress.length!=1;
      modelstore.cleanModel(["visits","meals","dishes","items"],model);
      webservice.exclusiveCall("load",{
        'ress':model.ress,
        'areas':model.areas,
        'startdate':tools.dateFromJava(model.startdate),
        'enddate':tools.dateFromJava(model.enddate),
        'startHrs':model.startHrs,
        'endHrs':model.endHrs
      },script,model).then($scope.setDates);
    }
  };

  $scope.setDates = function() {
    var dates={};
    var i,j,meal,day,dishes,dish,dsh;
    for(i in model.meals) {
      meal=model.meals[i];
      day=tools.dateFromJava(meal.day);
      if(!(day in dates)) {
        dates[day]={'id':day,'meals':[],'dshs':{}};
      }
      dishes=tools.join(meal,"dishes",model);
      for(j in dishes) {
        dish=dishes[j];
        dsh=dish.dsh;
        if(!(dsh in dates[day].dshs)) {
          if(parameters.DSH[dsh].field1=='1') {
            dates[day].dshs[dsh+dish.id]={'id':dsh,'dishes':[],'planningquantity':0,'toPrepare':0};
            dsh=dsh+dish.id;
          } else {
            dates[day].dshs[dsh]={'id':dsh,'dishes':[],'planningquantity':0,'toPrepare':0};
          }
        }
        dates[day].dshs[dsh].dishes.push(dish);
        dates[day].dshs[dsh].planningquantity+=model.items[dish.item].planningquantity;
        if(dish.stat<4000) {
          dates[day].dshs[dsh].toPrepare+=model.items[dish.item].planningquantity;
        }
      }
      dates[day].meals.push(meal);
    }
    model.dates=tools.toArray(dates);
  };

  $scope.increaseDates = function(increment) {
    var newStartdate=new Date(model.startdate.getTime());
    newStartdate.setDate(newStartdate.getDate()+increment);
    model.startdate=newStartdate;
    var newEnddate=new Date(model.enddate.getTime());
    newEnddate.setDate(newEnddate.getDate()+increment);
    model.enddate=newEnddate;
    $scope.load();
  };

  $scope.selectRes = function(res) {
    var index=model.ress.indexOf(res);
    if(index<0) {
      model.ress.push(res);
    } else {
      model.ress.splice(index,1);
    }
    $scope.load();
  };

  $scope.selectArea = function(area) {
    var index=model.areas.indexOf(area);
    if(index<0) {
      model.areas.push(area);
    } else {
      model.areas.splice(index,1);
    }
    $scope.load();
  };

  $scope.getMeals = function(meals) {
    var result=[];
    var i,meal;
    for(i in meals) {
      meal=meals[i];
      if(model.showZero || tools.sum(tools.inverseJoin(tools.join(meal,'dishes',model),'items','item',model),'planningquantity')>0) {
        result.push(meal);
      }
    }
    if(model.filter!='') {
      meals=result;
      result=[];
      var filters=tools.latinise(model.filter).split(" ");
      var j,matches,name;
      for(i in meals) {
        meal=meals[i];
        matches=true;
        name=tools.latinise(model.visits[meal.visit].name);
        for(j in filters) {
          if(!(name.indexOf(filters[j])>-1)) {
            matches=false;
            break;
          }
        }
        if(matches) {
          result.push(meal);
        }
      }
    }
    return result;
  };

  $scope.updateDishStat = function(dishes,stat) {
    if(!tools.isArray(dishes)) {
      dishes=tools.makeArray(dishes);
    }
    webservice.exclusiveCall('updateDishStat',{'dishes':dishes,'stat':stat},script,model).then(function() {
      $scope.setDates();
    });
  };

  $scope.overallStat = function(recs) {
    var i,rec;
    var result=10000;
    for(i in recs) {
      rec=recs[i];
      if(rec.stat<result) {
        result=rec.stat;
      }
    }
    return result;
  }

  $scope.editComment = function(meal) {
    model.backupMeals[meal.id]=tools.clone(meal);
    meal.editing=true;
  }
  
  $scope.cancelComment = function(meal) {
    modelstore.addRecord("meals",model.backupMeals[meal.id],model);
    $scope.load();
  };
  
  $scope.updateComment = function(meal) {
    var id=meal.id;
    webservice.call("updateComment",{
      "meal":tools.whitelist(meal,['comment'])
    },script,model).then(function(response) {
      if(response) {
        model.meals[id].editing=false;
        $scope.load();
      }
    });
  };

  $scope.getDshsWsParams = function(dshs) {
    var result="{}";
    if(dshs) {
      result=angular.toJson({
        "a":webservice.auth,
        "s":script,
        "t":'printDishes',
        "p":{'dshs':dshs}
      });
    }
    return result;
  };

  $scope.getProformaWsParams = function(meal) {
    var meal;
    var result="{}";
    if(!tools.isArray(meal)) {
      meal=tools.makeArray(meal);
    }
    var mealId=[meal[0].id];
    if(mealId) {
      result=$scope.getPrintTicketsParams(mealId,model.areas,true);
    }
    return result;
  };

  $scope.getMealsWsParams = function(meals) {
    var i,meal;
    var result="{}";
    if(!tools.isArray(meals)) {
      meals=tools.makeArray(meals);
    }
    var j=0;
    var mealIds=[];
    for(i in meals) {
      meal=meals[i];
      if('id' in meal && meal.stat<4000) {
        mealIds[j]=meal.id;
        j++;
      }
    }
    if(mealIds) {
      result=$scope.getPrintTicketsParams(mealIds,model.areas,false);
    }
    return result;
  };

  $scope.getPrintTicketsParams = function(mealIds,areas,proforma) {
    return angular.toJson({
      "a":webservice.auth,
      "s":script,
      "t":'printTickets',
      "p":{'mealIds':mealIds,'areas':model.areas,'proforma':proforma}
    });
  }

  $scope.any={'id':'','labelen':'--All--','labelnl':'--Alle--','labelfr':'--Tout--'};

  if(!("startdate" in model)) {
    tools.initDates(0,0,model);
  }
  tools.initAttributes(model,{
    'startdateOpened':false,
    'enddateOpened':false,
    'dateOptions':{
      maxDate: new Date(2099,11,31),
      minDate: new Date(2000,0,1),
      startingDay: 1
    },
    'startHrs':'',
    'endHrs':'',
    'filter':'',
    'dates':[],
    'showZero':false,
    'ress':[],
    'showResLabel':true,
    'backupMeals':{},
    'action':$sce.trustAsResourceUrl(config.get('serviceUrl')),
    'areas':[]
  });
  webservice.afterLogin().then(function() {
    $scope.$watch("model.startdate.getTime()",function(newVal,oldVal) {
      if(oldVal==model.enddate.getTime()) {
        model.enddate=new Date();
        model.enddate.setTime(newVal);
      }
      $scope.load();
    });
    $scope.$watch('model.enddate.getTime()',function() {
      $scope.load();
    });
  });
  
  
}]);
angular.module("app").controller("MealsAgendaController",["$scope","$sce","tools","modelstore","parameters","activitiesService","webservice","contactsService",
                                            function($scope,$sce,tools,modelstore,parameters,activitiesService,webservice,contactsService) {

  $scope.activitiesService=activitiesService;
  $scope.contactsService=contactsService;
  var script='meals/agenda';
  var model=modelstore.getModel(script);
  $scope.model=model;

  $scope.afterLoad = function() {
    $scope.setDates();

    // room
    model.structuredVisits={};
    var i,j,k,l,x,visit,activities,activity,frm,day,startHrs,hrsJavascript,endHrs,hrsList,actHrsList,hrs,participants,participant,unt,last,cpg,load,maxLoad,loadLength,first,position;
    var previousLoad,distributedLoad,distributedElementLoad,isStartHour,maxDayCapacityLoad,maxDayUntLoad,loadDuration,loadElement,previousXLoadElement,previousHrsLoadElement,xLoadElement
    var maxHrs=Object.keys(parameters.HRS).reduce(function(acc,hrsId){
      return hrsId>acc?hrsId:acc;
    },"");
    maxHrs=maxHrs.substr(0,6)+'59';
    var untList=$scope.getUntList();
    for(day in model.hrsLists) {
      hrsList=model.hrsLists[day].hrss;
      actHrsList=model.hrsLists[day].actHrs;
      if(!(day in model.structuredVisits)) {
        model.structuredVisits[day]={'hrss':{},'maxUntLoads':{}};
        model.sumLoads[day]=0;
      }
      for(i in untList) {
        unt=untList[i];
        maxDayCapacityLoad=model.capacityLoads[day][unt.field4];
        maxDayUntLoad=$scope.getUntDayHrsLoad(unt,day,hrsList);
        maxLoad=Math.max(maxDayCapacityLoad,maxDayUntLoad,1);
        if(!(unt.id in model.structuredVisits[day].maxUntLoads)) {
          model.structuredVisits[day].maxUntLoads[unt.id]={'maxLoad':maxLoad,'overLoad':Math.max(0,maxDayUntLoad-maxDayCapacityLoad)};
        }
        first=true;
        for(j in hrsList) {
          previousLoad=model.sumLoads[day];
          distributedLoad=0;
          distributedElementLoad=0;
          hrs=hrsList[j];
          if(!(hrs in model.structuredVisits[day].hrss)) {
            model.structuredVisits[day].hrss[hrs]={'hrs':hrs,'loadElements':{}};
          }
          isStartHour=actHrsList[unt.id.substr(0,3)][hrs].available;
          participants=tools.match(tools.join(tools.match(model.activities,{'dayISO':day,'hrs':hrs}),'participants',model),{'unt':unt.id});
          for(k in participants) {
            participant=participants[k];
            load=tools.amountIn(model.items[participant.item].planningquantity);
            activity=model.activities[participant.activity];
            frm=parameters.FRM[activity.frm];
            visit=model.visits[activity.visit];
            if(load>0) {
              startHrs=activity.hrs;
              endHrs=$scope.getHour(activity.day,startHrs,activity.frm,false);
              for(l=j;angular.isDefined(hrsList[l]) && hrsList[l]<endHrs;l++) {
                loadDuration=l-j;
              }
              loadElement={
                'startHrs':startHrs,
                'endHrs':endHrs,
                'visit': visit,
                'stat':tools.numberIn(visit.stat),
                'load':load,
                'rowspan':loadDuration+1,
                'unt':unt,
                'info':
                    startHrs.substr(0,2)+model.hrsLabel+startHrs.substr(3,2)+'-'+endHrs.substr(0,2)+model.hrsLabel+endHrs.substr(3,2)+
                    '<br/>'+
                    contactsService.getName(model.contacts[visit.owningcontact])+
                    '<br/>'+
                    (frm.field3==='1'?tools.label(frm)+': ':'')+activitiesService.countParticipants(tools.join(tools.between(tools.match(tools.join(visit,'activities',model),{'frm':frm.id}),'hrs',startHrs,endHrs,true,false),'participants',model),model)+'p'+
                    '<br/>'+
                    activity.comment,
                'addReservation':false,
                'isStartHour':isStartHour,
                'previousKey':visit.id+'_'+activity.frm+'_'+hrs
              }
              distributedElementLoad=0;
              for(x=0;distributedElementLoad<load && x<maxLoad;x++) {
                position=x+previousLoad;
                if(angular.isUndefined(model.structuredVisits[day].hrss[hrs].loadElements[position])) {
                  previousHrsLoadElement=first?undefined:model.structuredVisits[day].hrss[hrsList[j-1]].loadElements[position];
                  previousXLoadElement=distributedElementLoad==0?null:model.structuredVisits[day].hrss[hrs].loadElements[position-1];
                  if(angular.isUndefined(previousHrsLoadElement) || previousHrsLoadElement.rowspan<=1) {
                    xLoadElement=tools.clone(loadElement);
                    xLoadElement.previousKey=loadElement.previousKey+'_'+position;
                    if(previousXLoadElement===null || previousXLoadElement.previousKey!==loadElement.previousKey+'_'+(position-1)) {
                      xLoadElement.colspan=1;
                      xLoadElement.firstPosition=position;
                      xLoadElement.first=true;
                    } else {
                      model.structuredVisits[day].hrss[hrs].loadElements[previousXLoadElement.firstPosition].colspan++;
                      xLoadElement.firstPosition=previousXLoadElement.firstPosition;
                      xLoadElement.first=false;
                    }
                    distributedElementLoad++;
                  } else {
                    xLoadElement=tools.clone(previousHrsLoadElement);
                    xLoadElement.rowspan--;
                    xLoadElement.first=false;
                  }
                  model.structuredVisits[day].hrss[hrs].loadElements[position]=xLoadElement;
                  $scope.trustInfoAsHtml(model.structuredVisits[day].hrss[hrs].loadElements[position]);
                }
              }
              distributedLoad+=distributedElementLoad;
            }
          }
          if(distributedLoad<maxLoad) {
            distributedElementLoad=0;
            loadDuration=0;
            // for(l=j;angular.isDefined(hrsList[l]);l++) {
            //   if(hrs===hrsList[l] || !actHrsList[unt.id.substr(0,3)][hrsList[l]].available) {
            //     loadDuration=l-j;
            //   } else {
            //     break;
            //   }
            // }
            loadElement={
              'startHrs':hrs,
              'endHrs':hrs,
              'visit':null,
              'stat':0,
              'load':1,
              'rowspan':loadDuration+1,
              'unt':unt,
              'info':'',
              'addReservation':true,
              'isStartHour':false,
              'previousKey':unt.id+'_'+hrs,
            };
            if(tools.numberIn(maxDayCapacityLoad)===0 && unt.field4!=='' && tools.numberIn(maxDayUntLoad)===0 && first) {
              for(l=j;angular.isDefined(hrsList[l]);l++) {
                loadDuration=l-j;
              }
              loadElement={
                'startHrs':hrs,
                'endHrs':maxHrs,
                'visit':{'id':'0','stat':'9000'},
                'stat':9000,
                'load':1,
                'rowspan':loadDuration+1,
                'unt':unt,
                'info':tools.lang({'en':'Closed','nl':'Gesloten','fr':'Ferm\u00E9e'}),
                'addReservation':false,
                'isStartHour':isStartHour,
                'previousKey':unt.id+'_'+hrs,
              };
            }
            for(x=0;distributedLoad<maxLoad && x<maxLoad;x++) {
              position=x+previousLoad;
              if(angular.isUndefined(model.structuredVisits[day].hrss[hrs].loadElements[position])) {
                previousHrsLoadElement=first?undefined:model.structuredVisits[day].hrss[hrsList[j-1]].loadElements[position];
                previousXLoadElement=distributedElementLoad==0?null:model.structuredVisits[day].hrss[hrs].loadElements[position-1];
                if(angular.isUndefined(previousHrsLoadElement) || previousHrsLoadElement.rowspan<=1) {
                  xLoadElement=tools.clone(loadElement);
                  xLoadElement.previousKey=loadElement.previousKey+'_'+position;
                  if(previousXLoadElement===null || previousXLoadElement.previousKey!==loadElement.previousKey+'_'+(position-1)) {
                    xLoadElement.colspan=1;
                    xLoadElement.firstPosition=position;
                    xLoadElement.first=true;
                  } else {
                    model.structuredVisits[day].hrss[hrs].loadElements[previousXLoadElement.firstPosition].colspan++;
                    xLoadElement.firstPosition=previousXLoadElement.firstPosition;
                    xLoadElement.first=false;
                  }
                  distributedLoad++;
                  distributedElementLoad++;
                } else {
                  xLoadElement=tools.clone(previousHrsLoadElement);
                  xLoadElement.rowspan--;
                  xLoadElement.first=false;
                }
                model.structuredVisits[day].hrss[hrs].loadElements[position]=xLoadElement;
                $scope.trustInfoAsHtml(model.structuredVisits[day].hrss[hrs].loadElements[position]);
              }
            }
          }
          first=false;
        }
        model.sumLoads[day]+=maxLoad;
      }
    }
  };

  $scope.getUntDayHrsLoad = function(unt,day,hrsList) {
    var i,j,participants,participant,unt,act,starthrs,endhrs,load,hrs;
    var result=0;
    for(i in hrsList) {
      hrs=hrsList[i];
      load=0;
      participants=tools.match(tools.join(tools.match(model.activities,{'dayISO':day}),'participants',model),{'unt':unt.id});
      for(j in participants) {
        participant=participants[j];
        act=model.activities[participant.activity];
        endhrs=$scope.getHour(act.day,act.hrs,act.frm,false);
        if(act.dayISO===day && hrs>act.hrs && hrs<endhrs) {
          load+=tools.amountIn(model.items[participant.item].planningquantity);
        }
      }
      result=Math.max(result,load);
    }
    return result;
  }

  $scope.getHour = function(day,hrs,frmId,negative) {
    var hour;
    var addHours=(negative?-1:1)*1000*60*60*tools.amountIn(parameters.FRM[frmId].field1);
    var time=new Date(tools.timestampToJava(tools.dateFromJava(day)+' '+hrs).valueOf()+addHours);
    var newDate=tools.dateToJava(tools.dateFromJava(time));
    if(day<newDate) {
      hour='23:59:59';
    } else if(day>newDate) {
      hour='00:00:00';
    } else {
      hour=tools.hourFromJava(time);
    }
    return hour;
  }

  $scope.trustInfoAsHtml = function(loadElement) {
    loadElement.trustedInfo=$sce.trustAsHtml(loadElement.info);
  }

  $scope.load = function() {
    if(tools.validateAndUpdateDates(model)) {
      model.showResLabel=model.ress.length!=1;
      modelstore.cleanModel(["visits","activities","participants","meals","dishes","items","hotelreservationcategories"],model);
      webservice.exclusiveCall("load",{
        'ress':model.ress,
        'startdate':tools.dateFromJava(model.startdate),
        'enddate':tools.dateFromJava(model.enddate),
        'startHrs':model.startHrs,
        'endHrs':model.endHrs
      },script,model).then($scope.afterLoad);
      $scope.setDishCategories();
    }
  };

  $scope.todayDate = function() {
    var today = tools.dateToJava(tools.today());
    model.startdate=today;
    model.enddate=today;
    $scope.load();
  }

  $scope.setDates = function() {
    var dates={};
    var dishQuantitySums={};
    var i,j,k,meal,day,dishes,dish,dsh,hotelreservationcategories,htl,dishCategory,dshKey;
    for(i in model.meals) {
      meal=model.meals[i];
      day=tools.dateFromJava(meal.day);
      if(!(day in dates)) {
        dates[day]={'id':day,'meals':[],'dishQuantitySums':{}};
      }
      meal.accomodations=[];
      hotelreservationcategories=tools.match(model.hotelreservationcategories,{'visit':meal.visit});
      for(k in hotelreservationcategories) {
        htl=hotelreservationcategories[k].htl;
        if(meal.accomodations.indexOf(htl)==-1) {
          meal.accomodations.push(htl);
        }
      }
      dishes=tools.join(meal,"dishes",model);
      for(j in dishes) {
        dish=dishes[j];
        dsh=dish.dsh;
        dshKey=parameters.DSH[dsh].field1=='1'?dsh+dish.id:dsh;
        if(!(dsh in dates[day].dishQuantitySums)) {
          dishCategory=$scope.getDishCategoryOrDefault(dsh);
          dates[day].dishQuantitySums[dshKey]={'id':dsh,'dishes':[],'planningquantity':0,'toPrepare':0,'category':dishCategory};
        }
        if(!(dsh in dishQuantitySums)) {
          dishCategory=$scope.getDishCategoryOrDefault(dsh);
          dishQuantitySums[dshKey]={'id':dsh,'dishes':[],'planningquantity':0,'toPrepare':0,'category':dishCategory};
        }
        dates[day].dishQuantitySums[dshKey].dishes.push(dish);
        dishQuantitySums[dshKey].dishes.push(dish);
        dates[day].dishQuantitySums[dshKey].planningquantity+=model.items[dish.item].planningquantity;
        dishQuantitySums[dshKey].planningquantity+=model.items[dish.item].planningquantity;
        if(dish.stat<4000) {
          dates[day].dishQuantitySums[dshKey].toPrepare+=model.items[dish.item].planningquantity;
          dishQuantitySums[dshKey].toPrepare+=model.items[dish.item].planningquantity;
        }
      }
      dates[day].meals.push(meal);
    }
    model.dates=tools.toArray(dates);
    model.dishQuantitySums=tools.toArray(dishQuantitySums);
  };

  $scope.increaseDates = function(increment) {
    var newStartdate=new Date(model.startdate.getTime());
    newStartdate.setDate(newStartdate.getDate()+increment);
    model.startdate=newStartdate;
    var newEnddate=new Date(model.enddate.getTime());
    newEnddate.setDate(newEnddate.getDate()+increment);
    model.enddate=newEnddate;
    $scope.load();
  };

  $scope.selectRes = function(res) {
    var index=model.ress.indexOf(res);
    if(index<0) {
      model.ress.push(res);
    } else {
      model.ress.splice(index,1);
    }
    $scope.load();
  };

  $scope.getSumOfDishesForCategory = function(dishCategory, meals) {
    var allDishes = tools.join(meals,'dishes',model);
    var filteredDishes = allDishes.filter(function (dish) {return $scope.getDishCategoryOrDefault(dish.dsh) === dishCategory && dish.isIncluded});
    var filteredItems = tools.inverseJoin(filteredDishes, 'items', 'item', model);
    var sum = tools.sum(filteredItems, 'planningquantity');
    return sum;
  }

  $scope.resetVisitOrigins = function() {
    parameters.notDelArrayVIS.forEach(function (vis) { vis.selected = false });
  }

  $scope.resetDishCategories = function() {
    model.filters.dishCategories.forEach(function (dishCategory) { dishCategory.selected = false });
  }

  $scope.getMeals = function(meals) {
    var result=[];
    var i,meal;
    for(i in meals) {
      meal=meals[i];
      if(model.showZero || tools.sum(tools.inverseJoin(tools.join(meal,'dishes',model),'items','item',model),'planningquantity')>0) {
        result.push(meal);
      }
    }

    if(model.filters.name!='') {
      meals=result;
      result=[];
      var filters=tools.latinise(model.filters.name).split(" ");
      var j,matches,name;
      for(i in meals) {
        meal=meals[i];
        matches=true;
        name=tools.latinise(model.visits[meal.visit].name);
        for(j in filters) {
          if(!(name.indexOf(filters[j])>-1)) {
            matches=false;
            break;
          }
        }
        if(matches) {
          result.push(meal);
        }
      }
    }

    if(model.filters.creationDate.startdate != '' || model.filters.creationDate.enddate != '') {
      meals=result;
      result=[];
      var startdate = model.filters.creationDate.startdate != '' ? model.filters.creationDate.startdate :  model.dateOptions.minDate;
      var enddate = model.filters.creationDate.enddate != '' ? model.filters.creationDate.enddate :  model.dateOptions.maxDate;
      if(startdate > enddate) {
        var temp = startdate;
        model.filters.creationDate.startdate = enddate;
        model.filters.creationDate.enddate = temp;
      }
      for(i in meals) {
        meal = meals[i];
        var visitCreationDate = tools.dateToJava(model.visits[meal.visit].created);
        if(visitCreationDate >= startdate && visitCreationDate <= enddate) {
          result.push(meal);
        }
      }
    }
    var allDishes;
    var selectedDishCategoriesNames = $scope.getSelectedDishCategories().map(function(dishCategory) { return dishCategory.name});
    var hasSelectedDishCategories = selectedDishCategoriesNames.length > 0;
    meals=result;
    result=[];
    for(i in meals) {
      meal = meals[i];
      allDishes = tools.join(meal,'dishes',model);
      for(var dishIndex in allDishes) {
        if(hasSelectedDishCategories) {
          allDishes[dishIndex].isIncluded = $scope.isIncludedInSelectedDishCategories(selectedDishCategoriesNames, allDishes[dishIndex].dsh);
        } else {
          allDishes[dishIndex].isIncluded = true;
        }
      }
      if(allDishes.some(function (dish) {return $scope.isIncludedInSelectedDishCategories(selectedDishCategoriesNames, dish.dsh)}) || !hasSelectedDishCategories) {
        result.push(meal);
      }
    }

    var selectedVis = parameters.notDelArrayVIS.filter(function(vis) {return vis.selected});
    if(selectedVis.length > 0) {
      meals=result;
      result=[];
      for(i in meals) {
        meal = meals[i];
        var visFound = selectedVis.find(function (vis) { return vis.id === model.visits[meal.visit].vis});
        if(angular.isDefined(visFound) && visFound.selected) {
          result.push(meal);
        }
      }
    }
    return result;
  };

  $scope.getSelectedDishCategories = function () {
    return model.filters.dishCategories.filter(function(dishCategory) {return dishCategory.selected});
  }

  $scope.isIncludedInSelectedDishCategories = function(selectedDishCategoriesNames, dsh) {
    var dishCategory = $scope.getDishCategoryOrDefault(dsh);
    return selectedDishCategoriesNames.includes(dishCategory);
  }

  $scope.getDishCategoryOrDefault = function(dsh) {
    return parameters.DSH[dsh].field2 === "" ? "Other" : tools.capitalize(parameters.DSH[dsh].field2);
  }

  $scope.getFormattedTotalQuantityForSelectedDishCategories = function(meals) {
    var selectedDishCategories = $scope.getSelectedDishCategories();
    var result = "";
    if(selectedDishCategories.length === 0) {
      result += tools.sum(tools.inverseJoin(tools.join(meals,'dishes',model),'items','item',model),'planningquantity');
    } else {
      result += selectedDishCategories.reduce(function(sum, dishCategory) {
        return sum + $scope.getSumOfDishesForCategory(dishCategory.name, meals);
      }, 0);
    }

    return "(" + result + ")";
  }

  $scope.getUntList = function() {
    var result=[];
    var ress;
    if('RES' in parameters) {
      if(model.ress.length==0) {
        ress=Object.keys(parameters.notDelRES);
      } else {
        ress=model.ress;
      }
      var acts={};
      var i,act,unt;
      for(i in ress) {
        act=parameters.RES[ress[i]].field1;
        if(act!='') {
          acts[act]=true;
        }
      }
      for(i in parameters.notDelUNT) {
        unt=parameters.notDelUNT[i];
        if(unt.field9=='1' && (unt.id.substr(0,3) in acts)) {
          result.push(unt);
        }
      }
    }
    return result;
  };

  $scope.setDishCategories = function() {
    var currentDishCategoryNames = model.filters.dishCategories.map(function (dishCategory) { return dishCategory.name });
    var newDistinctDishCategories = tools.toArray(parameters.DSH)
        .map(function(dsh) {return tools.capitalize(dsh.field2)})
        .filter(function (formattedDshName) {return !currentDishCategoryNames.includes(formattedDshName)})
        .filter(function(value, index, self) { return self.indexOf(value) === index});
    if(newDistinctDishCategories.length > 0) {
      if(newDistinctDishCategories.includes("")) {
        newDistinctDishCategories.splice(newDistinctDishCategories.indexOf(""),1);
        if(!currentDishCategoryNames.includes("Other")) {
          newDistinctDishCategories.push("Other");
        }
      }
      for(var i in newDistinctDishCategories) {
          model.filters.dishCategories.push({name: newDistinctDishCategories[i], selected: false});
      }
    }
  }

  $scope.hasAtLeastOneCorrespondingDish = function(dishCategoryName, meals) {
    return $scope.getSumOfDishesForCategory(dishCategoryName, meals) > 0;
  }

  $scope.updateMealStat = function(meal,stat) {
    webservice.exclusiveCall('updateMealStat',{'mealId':meal.id,'stat':stat},script,model).then(function() {
      $scope.setDates();
    });
  };

  $scope.editComment = function(meal) {
    model.backupMeals[meal.id]=tools.clone(meal);
    meal.editing=true;
  }

  $scope.cancelComment = function(meal) {
    modelstore.addRecord("meals",model.backupMeals[meal.id],model);
    $scope.afterLoad();
  };

  $scope.updateComment = function(meal) {
    var id=meal.id;
    webservice.call("updateComment",{
      "meal":tools.whitelist(meal,['comment'])
    },script,model).then(function(response) {
      if(response) {
        model.meals[id].editing=false;
        $scope.afterLoad();
      }
    });
  };

  $scope.any={'id':'','labelen':'--All--','labelnl':'--Alle--','labelfr':'--Tout--'};

  if(!("startdate" in model)) {
    tools.initDates(0,0,model);
  }
  tools.initAttributes(model,{
    'startdateOpened':false,
    'enddateOpened':false,
    'dateOptions':{
      maxDate: new Date(2099,11,31),
      minDate: new Date(2000,0,1),
      startingDay: 1
    },
    'startHrs':'',
    'endHrs':'',
    'filter':'',
    'dates':[],
    'unts':[],
    'showZero':false,
    'showTotals':false,
    'ress':[],
    'showResLabel':true,
    'dishQuantitySums':[],
    'structuredVisits':{},
    'sumLoads':{},
    'hrsLabel':tools.lang({'en':'h','nl':'u','fr':'h'}),
    'backupMeals':{},
    'filters': {
      name:'',
      creationDate:{
        startdateOpened:false,
        enddateOpened:false,
        startdate:'',
        enddate:''
      },
      isCollapsed: true,
      dishCategories:[]
    }
  });
  webservice.afterLogin().then(function() {
    $scope.$watch("model.startdate.getTime()",function(newVal,oldVal) {
      if(oldVal==model.enddate.getTime()) {
        model.enddate=new Date();
        model.enddate.setTime(newVal);
      }
      $scope.load();
    });
    $scope.$watch('model.enddate.getTime()',function() {
      $scope.load();
    });
  });


}]);

angular.module("app").controller("MarketingToolsConfigurationController", ["$scope", "modelstore", "parameters", "$sce",
  function ($scope, modelstore, parameters, $sce) {

    var script = 'marketing/toolsConfiguration';
    var model = modelstore.getModel(script);
    $scope.model = model;
    $scope.parameters = parameters;

    $scope.checkResource = function (value) {
      return $sce.trustAsResourceUrl(value);
    }

    $scope.options = Object.keys(parameters.FMT).map(function (key, index) {
      return parameters.FMT[key];
    });

    $scope.findDefaultOption = function (optionsList) {
      var defaultOption = '';
      for (var i = 0; i < optionsList.length; i++) {
        var elt = optionsList[i];
        if (elt.id === 'default') {
          defaultOption = elt;
          break;
        }
      } 
      return defaultOption;
    }

    $scope.selectedOption = $scope.findDefaultOption($scope.options);
  }
]);
var templatesService=function($sce,modelstore,parameters,tools) {
  this.$sce=$sce;
  this.modelstore=modelstore;
  this.parameters=parameters;
  this.tools=tools;
  this.offerCategories={
    'ACT':{'id':'ACT','labelen':'Activity','labelnl':'Activiteit','labelfr':'Activit\u00E9'},
    'MEA':{'id':'MEA','labelen':'Meal','labelnl':'Maaltijd','labelfr':'Repas'},
    'HTL':{'id':'HTL','labelen':'Accommodation','labelnl':'Accommodatie','labelfr':'H\u00E9bergement'},
    'PRD':{'id':'PRD','labelen':'Product','labelnl':'Product','labelfr':'Product'},
    'FFO':{'id':'FFO','labelen':'Form','labelnl':'Formulier','labelfr':'Formulaire'},
    'DAT':{'id':'DAT','labelen':'Agenda date header','labelnl':'Agenda datum header','labelfr':'Agenda date header'},
    'RGH':{'id':'RGH','labelen':'Rights','labelnl':'Rechten','labelfr':'Droits'},
    'DVS':{'id':'DVS','labelen':'Division','labelnl':'Afdeling','labelfr':'Division'}
  };
  this.managers={
    'INV':{'id':'INV','labelen':'Invoice manager','labelnl':'Facturatie verantwoordelijke','labelfr':'Responsable facturation'},
    'OPE':{'id':'OPE','labelen':'Operations manager','labelnl':'Uitvoerings verantwoordelijke','labelfr':'Responsable ex\u00E9cutif'},
    'QUO':{'id':'QUO','labelen':'Quotation manager','labelnl':'Offerte verantwoordelijke','labelfr':'Responsable offre'}
  };
};

templatesService.prototype.structureTemplates = function(model) {
  var ths=this;
  var tgc,matchingTemplateelements;
  angular.forEach(model.templatesections,function(templatesection) {
    templatesection.table='templatesections';
    tgc=ths.parameters.TGC[templatesection.tgc];
    model.templatesections[templatesection.id].gridcolumns=[tgc.field1,tgc.field2,tgc.field3,tgc.field4,tgc.field5,tgc.field6].filter(function(w){return w!='0';}).map(function(width){
      return {'width':width,'templateelements':[]};
    });
  });
  angular.forEach(['templatetexts','templateimages','templatespacings','templatebuttons'],function(table){
    angular.forEach(model[table],function(record){
      record.table=table;
      if(table==='templatetexts') {
        record.bodyen=ths.tools.decodeNumericEntities(record.bodyen);
        record.bodynl=ths.tools.decodeNumericEntities(record.bodynl);
        record.bodyfr=ths.tools.decodeNumericEntities(record.bodyfr);
        record.trustedBodyen=ths.isValidHTML(record.bodyen)?ths.$sce.trustAsHtml(record.bodyen):false;
        record.trustedBodynl=ths.isValidHTML(record.bodynl)?ths.$sce.trustAsHtml(record.bodynl):false;
        record.trustedBodyfr=ths.isValidHTML(record.bodyfr)?ths.$sce.trustAsHtml(record.bodyfr):false;
      }
      model.templatesections[record.templatesection].gridcolumns[parseInt(record.gridcolumn)].templateelements.push(record);
    });
  });
  angular.forEach(model.templates,function(template) {
    template.templatesectionsArray=ths.tools.join(template,'templatesections',model);
    template.templatesectionsArray.sort(function(a,b) {return ths.tools.numberIn(a.sort)-ths.tools.numberIn(b.sort);});
    angular.forEach(template.templatesectionsArray,function(templatesection) {
      angular.forEach(templatesection.gridcolumns,function(gridcolumn) {
        gridcolumn.templateelements.sort(function(a,b) {return ths.tools.numberIn(a.sort)-ths.tools.numberIn(b.sort);});
      });
    });
  });
};

templatesService.prototype.isValidHTML = function(input) {
  try {
    var doc=new DOMParser().parseFromString('<span>'+input+'</span>','application/xml');
    return !doc.querySelector('parsererror');
  } catch (e) {
    return false;
  }
};

templatesService.prototype.filterParams = function(paramTbl,field,param,currentValue) {
  if(paramTbl && param) {
    var matchingElement={};
    var input=this.parameters['notDel'+paramTbl];
    var parentParam=param.substr(0,3);
    var output=[];
    for(var i in input) {
      if(i in input && field in input[i] && input[i][field].substr(0,3)==parentParam && ((paramTbl=='HSC' && input[i].field6!=='0') || paramTbl!=='HSC')) {
        output.push(input[i]);
      }
    }
    matchingElement[field]=currentValue;
    return this.tools.addMatchingElement(this.parameters[paramTbl],output,matchingElement);
  } else {
    return [];
  }
};

templatesService.prototype.structurePurposes = function(purposes) {
  var ths=this;
  return {
    "mainPurposes":ths.tools.toArray(purposes).filter(function(p) {return p.isMain;}),
    "main":ths.tools.toArray(purposes).filter(function(p) {return p.isMain && p.main.available=='1';}),
    "component":ths.tools.toArray(purposes).filter(function(p) {return p.component.available=='1';}),
    "scheduled":ths.tools.toArray(purposes).filter(function(p) {return p.scheduled.available=='1';})
  };
};

templatesService.prototype.templateimageWidth = function(templateelement,gridcolumnWidth) {
  var ths=this;
  return templateelement.table==="templateimages"?Math.min(ths.tools.numberIn(gridcolumnWidth),templateelement.zoomwidth,templateelement.width):0;
};

templatesService.prototype.setElementBackground = function(element,type) {
  if(type==='hex') {
    element.background=element.backgroundColor.substr(-6);
  } else {
    element.background=element.background.replace(/#/g,'');
    element.backgroundColor='#'+element.background
  }
};

templatesService.prototype.getTemplateName = function(template,purposes) {
  var ths=this;
  var result="";
  if(angular.isDefined(template) && angular.isDefined(template.purpose)) {
    result=ths.tools.label(purposes[template.purpose]);
    if(template.templatetype=='component') {
      var param1=template.param1;
      var param2=template.param2;
      if(template.purpose=="OFFER" || template.purpose=="CONFIRM") {
        if(template.param1 in ths.offerCategories) {
          param1=ths.tools.label(ths.offerCategories[template.param1]);
          if(template.param1=='ACT') {
            if(template.param2.substr(0,3) in ths.parameters.ACT) {
              param2=ths.tools.label(ths.parameters.ACT[template.param2.substr(0,3)]);
              if(template.param2 in ths.parameters.FRM) {
                param2+=' '+ths.tools.label(ths.parameters.FRM[template.param2]);
              }
            }
          } else if(template.param1=='MEA') {
            if(template.param2.substr(0,3) in ths.parameters.RES) {
              param2=ths.tools.label(ths.parameters.RES[template.param2.substr(0,3)]);
              if(template.param2 in ths.parameters.DSH) {
                param2+=' '+ths.tools.label(ths.parameters.DSH[template.param2]);
              }
            }
          } else if(template.param1=='HTL') {
            if(template.param2.substr(0,3) in ths.parameters.HTL) {
              param2=ths.tools.label(ths.parameters.HTL[template.param2.substr(0,3)]);
              if(template.param2 in ths.parameters.HSC) {
                param2+=' '+ths.tools.label(ths.parameters.HSC[template.param2]);
              }
            }
          } else if(template.param1=='PRD') {
            if(template.param2 in ths.parameters.PRD) {
              param2=ths.tools.label(ths.parameters.PRD[template.param2]);
            }
          }
        }
      } else if(template.purpose=='MANAGER') {
        if(template.param1 in ths.managers) {
          param1=ths.tools.label(ths.managers[template.param1]);
        }
      } else if(template.purpose=='BANNER') {
        if(template.param1 in ths.offerCategories) {
          param1=ths.tools.label(ths.offerCategories[template.param1]);
          if(template.param2 in ths.parameters.FFO) {
            param2=ths.tools.label(ths.parameters.FFO[template.param2]);
          }
        }
      } 
      result+=' '+param1+' '+param2;
    } else {
      var subjectLabel=ths.tools.lang({'en':'subjecten','nl':'subjectnl','fr':'subjectfr'});
      result+=template[subjectLabel]!==''?' - '+template[subjectLabel]:'';
    }
  }
  return result;
}

angular.module('app').service('templatesService',['$sce','modelstore','parameters','tools',templatesService]);


angular.module("app").controller("MarketingListTemplatesController",["$scope","$sce","tools","modelstore","parameters","webservice","templatesService","dictionary","activitiesService","hotelsService",
                                            function($scope,$sce,tools,modelstore,parameters,webservice,templatesService,dictionary,activitiesService,hotelsService) {
  
  var script='marketing/listTemplates';
  var model=modelstore.getModel(script);
  $scope.model=model;
  $scope.templatesService=templatesService;
  $scope.activitiesService=activitiesService;
  $scope.hotelsService=hotelsService;
  $scope.all={'id':'','labelen':'--All--','labelnl':'--Alle--','labelfr':'--Tout--'};
  $scope.datetablefields=[
    {'id':'visits.startdate','labelen':'Visit arrival','labelnl':'Bezoek aankomst','labelfr':'Visite arriv\u00E9e'},
    {'id':'visits.enddate','labelen':'Visit finish','labelnl':'Bezoek einde','labelfr':'Visite fin'},
    {'id':'activities.day','labelen':'Activity day','labelnl':'Activiteit dag','labelfr':'Activit\u00E9 jour'},
    {'id':'meals.day','labelen':'Meal day','labelnl':'Maaltijd dag','labelfr':'Repas jour'},
    {'id':'hotelreservationcategories.startdate','labelen':'Hotel stay arrival','labelnl':'Overnachting aankomst','labelfr':'S\u00E9jour arriv\u00E9e'},
    {'id':'hotelreservationcategories.enddate','labelen':'Hotel stay departure','labelnl':'Overnachting vertrek','labelfr':'S\u00E9jour d\u00E9part'}
  ];

  $scope.filterTemplates = function() {
    model.filteredTemplates=tools.toArray(model.templates).filter(function(t) {
      var result=false;
      var regex,prefix,suffix;
      var paramPattern='[A-Z0-9a-z]*';
      if(t.templatetype==model.templatetype) {
        if(model.templatetype=='main') {
          prefix=model.mainPurpose.prefix!==''?'^'+model.mainPurpose.prefix:'';
          suffix=model.mainPurpose.suffix!==''?model.mainPurpose.suffix+'$':'';
          regex=new RegExp(prefix+paramPattern+suffix);
          result=regex.test(t.purpose) && model.purpose=='';
        }
        if(t.purpose==model.purpose) {
          prefix=model.prm!==''?'^'+model.prm:'';
          regex=new RegExp(prefix+paramPattern);
          result=(t.param1==model.param1 || model.param1=='') && (t.param2==model.param2 || model.prm=='' || (model.prm!=='' && regex.test(t.param2))) && (t.datetablefield==model.datetablefield || model.datetablefield=='');
        }
      }
      return result;
    });
  };

  $scope.selectFilter = function(filter,value) {
    var filters={
      'mainPurposeId':['templatetype','purpose','param1','prm','param2','datetablefield'],
      'templatetype':['purpose','param1','prm','param2','datetablefield'],
      'purpose':['param1','prm','param2','datetablefield'],
      'param1':['prm','param2','datetablefield'],
      'prm':['param2','datetablefield'],
      'datetablefield':['purpose','param1','prm','param2']
    }
    if(angular.isDefined(value) && value!==null) {
      var oldFilter='old'+filter.charAt(0).toUpperCase()+filter.slice(1);
      if(model[oldFilter]!==value) {
        var resetFilters=filters[filter];
        for(var i in resetFilters) {
          model[resetFilters[i]]='';
        }
        model[oldFilter]=value;
      }
      model[filter]=value;
      if(filter=='mainPurposeId') {
        model.mainPurpose=model.purposes[model.mainPurposeId];
      }
      if(angular.isDefined(model.mainPurpose) && model.mainPurpose!==null && model.mainPurpose!=='') {
        var templatetypes=model.mainPurpose.templatetypes;
        if(tools.getLength(templatetypes)===1 || (model.templatetype=='' && !('main' in templatetypes))) {
          model.templatetype=tools.first(templatetypes).id;
        } else if(model.templatetype=='' && 'main' in templatetypes) {
          model.templatetype='main';
        }
        if(angular.isDefined(model.templatetype) && model.templatetype!=='') {
          if(model.templatetype!=='scheduled') {
            var tPurposes=templatetypes[model.templatetype].purposes;
            if(tools.getLength(tPurposes)===1) {
              model.purpose=tools.first(tPurposes);
            }
            if(angular.isDefined(model.purpose) && model.purpose!=='') {
              var categories=model.purposes[model.purpose][model.templatetype].categories;
              if(tools.getLength(categories)===1) {
                model.param1=tools.first(categories).id;
              }
              if(angular.isDefined(model.param1) && model.param1!=='' && categories[model.param1].param2===false && angular.isDefined(model.prm) && model.prm!=='') {
                model.param2=model.prm;
              }
            }
          } else {
            model.purpose='SCHEDULED';
            if(model.datetablefield=='') {
              model.datetablefield=tools.first($scope.datetablefields).id;
            }
          }
        }
      }
      $scope.filterTemplates();
    }
  }

  $scope.load = function() {
    model.filteredTemplates=[];
    modelstore.cleanModel(['templates','templatesections','templateelements','templatetexts','templateimages','templatespacings','templatebuttons','restrictions'],model);
    webservice.exclusiveCall('load',{},script,model).then(function() {
      var i,template,key;
      for(i in model.templates) {
        template=model.templates[i];
        template.backgroundColor='#'+template.background;
        template.trustedRendered=$sce.trustAsHtml(model.templates[i].rendered);
        template.created=true;
        model.extendPreview[template.id]=false;
        key=[template.templatetype,template.purpose,template.param1,template.param2].join('_');
      }
      $scope.filterTemplates();
      model.structuredPurposes=templatesService.structurePurposes(model.purposes);
    });
  };

  $scope.init = function() {
    model.template={
      'id':'-1',
      'created':false,
      'templatetype':model.templatetype,
      'mainPurpose':model.templatetype==='component' && model.purpose!==''?model.purposes[model.purpose]:model.mainPurpose,
      'purpose':model.purpose,
      'param1':model.param1,
      'prm':model.prm,
      'param2':model.param2,
      'subjecten':'',
      'subjectnl':'',
      'subjectfr':'',
      'background':'ffffff',
      'backgroundColor':'#ffffff',
      'tly':'AFU',
      'datetablefield':model.datetablefield,
      'dateoffset':0,
      'filteredTemplates':[]
    };
    modelstore.addRecord('templates',model.template,model);
  }

  $scope.create = function() {
    webservice.exclusiveCall("create",{
      'template':tools.whitelistNoId(model.template,dictionary.whitelists.templates),
      'restrictions':tools.whitelistNoId(tools.join(model.template,'restrictions',model),dictionary.whitelists.restrictions)
    },script,model).then(function(response) {
      tools.redirect($scope.buildHref('marketing','editTemplate',response));
    });
  };

  $scope.delete = function(template) {
    var name=templatesService.getTemplateName(template,model.purposes);
    if(template.created) {
      webservice.deleteConfirm(name,'delete',template.id,script,model).then(function(response) {
        if(response) {
          $scope.load();
        }
      });
    } else {
      modelstore.removeRecord('templates',template.id,model);
    }
  };

  $scope.templateIsActive = function(template) {
    var result=false;
    if(model.purpose==='SCHEDULED') {
      result=tools.getLength(tools.match(model.restrictions,{'foreignkey':template.id}))>0;
    } else if(model.purpose!=='FBUTTON') {
      result=tools.minInt(tools.match(model.filteredTemplates,{'templatetype':template.templatetype,'purpose':template.purpose,'param1':template.param1,'param2':template.param2}),'id').id===template.id;
    }
    return result;
  }

  $scope.duplicate = function(template) {
    webservice.exclusiveCall("duplicate",{'id':template.id},script,model).then(function() {
      $scope.load();
    });
  }

  $scope.getTemplatewidth = function(template) {
    return angular.element(document.getElementById('template'+template.id)).width()/600.0;
  };

  tools.initAttributes(model,{
    templatetype:'',
    mainPurpose:'',
    mainPurposeId:'',
    oldMainPurposeId:'',
    purpose:'',
    oldPurpose:'',
    param1:'',
    oldParam1:'',
    prm:'',
    oldPrm:'',
    param2:'',
    oldParam2:'',
    datetablefield:'',
    oldDatetablefield:'',
    filteredTemplates:[],
    templates:{},
    extendPreview:{},
    actifTemplates:{}
  });
  webservice.afterLogin().then(function() {
    $scope.load();
    model.task='l';
  });

}]);


angular.module('app').controller('MarketingEditTemplateHeaderController',['$scope','tools','activitiesService','hotelsService',
                                            function($scope,tools,activitiesService,hotelsService) {
  $scope.activitiesService=activitiesService;
  $scope.hotelsService=hotelsService;
  $scope.all={'id':'','labelen':'--All--','labelnl':'--Alle--','labelfr':'--Tout--'};
  $scope.datetablefields=[
    {'id':'visits.startdate','labelen':'Visit arrival','labelnl':'Bezoek aankomst','labelfr':'Visite arriv\u00E9e'},
    {'id':'visits.enddate','labelen':'Visit finish','labelnl':'Bezoek einde','labelfr':'Visite fin'},
    {'id':'activities.day','labelen':'Activity day','labelnl':'Activiteit dag','labelfr':'Activit\u00E9 jour'},
    {'id':'meals.day','labelen':'Meal day','labelnl':'Maaltijd dag','labelfr':'Repas jour'},
    {'id':'hotelreservationcategories.startdate','labelen':'Hotel stay arrival','labelnl':'Overnachting aankomst','labelfr':'S\u00E9jour arriv\u00E9e'},
    {'id':'hotelreservationcategories.enddate','labelen':'Hotel stay departure','labelnl':'Overnachting vertrek','labelfr':'S\u00E9jour d\u00E9part'}
  ];

  $scope.getParent = function() {
    return $scope.$parent.model.template;
  };

  $scope.getEditing = function() {
    return true;
  };

  $scope.getBehaviourFilter = function() {
    return 'visit';
  };

  tools.initAttributes($scope.$parent.model,{
    'restrictions':{}
  });

}]);


angular.module('app').controller('MarketingEditTemplateController',['$sce','$scope','$stateParams','$window','tools','modelstore','parameters','webservice','errorlog','templatesService','dictionary','activitiesService','user',
                                            function($sce,$scope,$stateParams,$window,tools,modelstore,parameters,webservice,errorlog,templatesService,dictionary,activitiesService,user) {
  
  var script='marketing/editTemplate';
  var model=modelstore.getModel(script);
  $scope.model=model;
  $scope.templatesService=templatesService;

  $scope.aligns = [
    {id:'left',glyphicon:'glyphicon-align-left'},
    {id:'center',glyphicon:'glyphicon-align-center'},
    {id:'right',glyphicon:'glyphicon-align-right'},
    {id:'justify',glyphicon:'glyphicon-align-justify'}
  ];

  $scope.structureTemplate = function() {
    templatesService.structureTemplates(model);
    if(model.selected!==null) {
      $scope.select(model[model.selected.table][model.selected.id]);
    }
    if(model.template.purpose) {
      model.placeholders=model.purposes[model.template.purpose][model.template.templatetype].placeholders;
    } else {
      model.placeholders=[];
    }
  };

  $scope.load = function() {
    modelstore.cleanModel(['templates','templatesections','templateelements','templatetexts','templateimages','templatespacings','templatebuttons','template'],model);
    webservice.exclusiveCall('load',{'id':$stateParams.id},script,model).then(function() {
      model.template=tools.first(model.templates);
      model.template.editing=false;
      model.template.name=templatesService.getTemplateName(model.template,model.purposes);
      $scope.structureTemplate();
      model.structuredPurposes=templatesService.structurePurposes(model.purposes);
      $scope.$broadcast("fixOrGroups");
    });
  };

  $scope.startUpdateTemplate = function() {
    model.template.backgroundColor='#'+model.template.background;
    model.template.mainPurpose='';
    if(model.template.purpose!=='') {
      if(model.template.templatetype==='component') {
        model.template.mainPurpose=model.purposes[model.template.purpose];
      } else if(model.template.templatetype==='main') {
        if(angular.isDefined(model.purposes[model.template.purpose]) && model.purposes[model.template.purpose].isMain) {
          model.template.mainPurpose=model.purposes[model.template.purpose];
        } else if(model.purposes[model.template.purpose].prefix!=='' && angular.isDefined(model.purposes[model.purposes[model.template.purpose].prefix])) {
          model.template.mainPurpose=model.purposes[model.purposes[model.template.purpose].prefix];
        } else if(model.purposes[model.template.purpose].suffix!=='' && angular.isDefined(model.purposes[model.purposes[model.template.purpose].suffix])) {
          model.template.mainPurpose=model.purposes[model.purposes[model.template.purpose].suffix];
        }
      }
    }
    model.template.prm=model.template.param2!==''?model.template.param2.substr(0,3):'';
    model.template.editing=true;
  };

  $scope.updateTemplate = function() {
    var restrictions=tools.join(model.template,'restrictions',model);
    var whitelistedRestrictions=[];
    var restriction;
    for(var i in restrictions) {
      restriction=restrictions[i];
      if('newRecord' in restriction) {
        restriction=tools.whitelistNoId(restriction,dictionary.whitelists.restrictions);
      } else {
        restriction=tools.whitelist(restriction,dictionary.whitelists.restrictions);
      }
      whitelistedRestrictions.push(restriction);
    }
    webservice.exclusiveCall('updateTemplate',{
      'template':tools.whitelist(model.template,dictionary.whitelists.templates),
      'restrictions':whitelistedRestrictions
    },script,model).then(function() {
      model.template=tools.first(model.templates);
      model.template.editing=false;
      model.template.name=templatesService.getTemplateName(model.template,model.purposes);
      $scope.$broadcast("removeNewRestrictions");
      $scope.structureTemplate();
      $scope.$broadcast("fixOrGroups");
    });
  };

  $scope.deleteTemplate = function() {
    var name=templatesService.getTemplateName(model.template,model.purposes);
    webservice.deleteConfirm(name,'deleteTemplate',model.template.id,script,model).then(function(response) {
      if(response) {
        tools.redirect($scope.buildHref('marketing','listTemplates'));
      }
    });
  };

  $scope.cancelUpdateTemplate = function() {
    $scope.load();
  };

  $scope.select = function(element) {
    $scope.closeTgcPicker();
    if(model.selected!==null && !(element!==null && element.table==model.selected.table && model.selected.id==element.id)) {
      if(model.selected.table=='templatetexts') {
        model.selected.bodyen=model.templatetexts[model.selected.id].bodyen;
        model.selected.bodynl=model.templatetexts[model.selected.id].bodynl;
        model.selected.bodyfr=model.templatetexts[model.selected.id].bodyfr;
        $scope.updateTemplatetext(model.selected);
      } else if(model.selected.table=='templatesections') {
        $scope.updateTemplatesection(model.selected);
      } else if(model.selected.table=='templateimages') {
        $scope.updateTemplateimage(model.selected);
      } else if(model.selected.table=='templatespacings') {
        $scope.updateTemplatespacing(model.selected);
      }
    }
    if(element===null) {
      model.selected=null;
    } else {
      model.selected=tools.clone(element);
      if(element.table=='templateimages') {
        model.currentTemplateimage=element;
      }
      if(element.table=='templatesections') {
        model.selected.backgroundColor='#'+model.templatesections[model.selected.id].background;
      }
    }
  };

  $scope.isSelected = function(element) {
    return angular.isDefined(element) && model.selected!==null && model.selected.table===element.table && model.selected.id===element.id;
  };

  $scope.createTemplatesection = function(tgcId,index) {
    var sort=null;
    if(angular.isDefined(index)) {
      sort=$scope.calculateSort({},model.template.templatesectionsArray,index);
    }
    webservice.exclusiveCall('createTemplatesection',{'templatesection':{
      'parenttemplate':model.template.id,
      'tgc':tgcId,
      'sort':sort
    }},script,model).then(function(response) {
      $scope.closeTgcPicker();
      $scope.structureTemplate();
      $scope.select(model.templatesections[response],'templatesections');
    });
  };

  $scope.updateTemplatesection = function(templatesection) {
    var clonedTemplatesection=tools.clone(templatesection);
    if(templatesection.background.length!=6) {
      clonedTemplatesection.background=model.templatesections[templatesection.id].background;
    }
    webservice.exclusiveCall('updateTemplatesection',{
      'templatesection':tools.whitelist(clonedTemplatesection,['background','tly','bottomspacing','pagebreak','border','editable'])
    },script,model).then(function() {
      $scope.structureTemplate();
    });
  };

  $scope.updateTemplatesectionBackground = function(templatesection,type) {
    templatesService.setElementBackground(templatesection,type);
    if(templatesection.background.length==6) {
      $scope.updateTemplatesection(templatesection);
    }
  };

  $scope.calculateSort = function(element,collection,index) {
    var result;
    var length=tools.getLength(collection);
    if(index<length) {
      result=collection[index].sort;
    } else {
      if(length>0) {
        result=(tools.numberIn(tools.maxInt(collection,'sort').sort)+1).toString();
      } else {
        result='0';
      }
    }
    return result
  };

  $scope.dropTemplatesection = function(dropEffect,templatesection,index) {
    templatesection.sort=$scope.calculateSort(templatesection,model.template.templatesectionsArray,index);
    if(dropEffect=='copy') {
      webservice.exclusiveCall('createTemplatesection',{
        'templatesection':tools.whitelistNoId(templatesection,['parenttemplate','tgc','sort','background','tly','bottomspacing','border','editable'])
      },script,model).then(function(response) {
        $scope.structureTemplate();
        $scope.select(model.templatesections[response],'templatesections');
      });
    } else if(dropEffect=='move'){
      webservice.exclusiveCall('moveTemplatesection',{
        'templatesection':tools.whitelist(templatesection,['sort'])
      },script,model).then(function() {
        $scope.structureTemplate();
      });
    }
    return true;
  };

  $scope.openTgcPicker = function(index, where, $event) {
    model.tgcPicker.open=true;
    model.tgcPicker.index=index;
    model.tgcPicker.where=where;
    $event.stopPropagation();
  };

  $scope.closeTgcPicker = function() {
    model.tgcPicker.open=false;
    model.tgcPicker.index=null;
    model.tgcPicker.where=null;
  };

  $scope.tgcPickerIsOpen = function(index,where) {
    return model.tgcPicker.open && model.tgcPicker.index===index && model.tgcPicker.where==where;
  }

  $scope.pickTgc = function(tgcId) {
    if (model.tgcPicker.open && model.tgcPicker.index!=null) {
      index=model.tgcPicker.where==='above'?model.tgcPicker.index:model.tgcPicker.index+1;
      $scope.createTemplatesection(tgcId,index);
    }
    $scope.closeTgcPicker();
  };

  $scope.dropTemplateelement = function(dropEffect,templatesection,gridcolumn,templateelement,index) {
    gridcolumn=gridcolumn.toString();
    templateelement.templatesection=templatesection.id;
    templateelement.gridcolumn=gridcolumn;
    templateelement.sort=$scope.calculateSort(templateelement,templatesection.gridcolumns[gridcolumn].templateelements,index);
    var task;
    var whitelist=['table','templatesection','gridcolumn','sort'];
    if(dropEffect=='copy') {
      task='createTemplateelement';
      if(templateelement.table=='templateplaceholders') {
        templateelement.table='templatetexts';
        templateelement.placeholder=model.placeholders[0];
      }
      if(templateelement.table=='templatetexts') {
        whitelist.push('tts','align','bodyen','bodynl','bodyfr','placeholder','spacingtop','spacingbottom');
      } else if(templateelement.table=='templateimages') {
        whitelist.push('zoomwidth','align','linken','linknl','linkfr','linktexten','linktextnl','linktextfr');
      } else if(templateelement.table=='templatesections') {
        whitelist.push('height');
      }
      templateelement=tools.whitelist(templateelement,whitelist);
    } else if(dropEffect=='move') {
      task='moveTemplateelement';
      templateelement=tools.whitelist(templateelement,whitelist);
    }
    webservice.exclusiveCall(task,{'templateelement':templateelement},script,model).then(function(response) {
      $scope.structureTemplate();
      if(dropEffect=='copy') {
        $scope.select(model[response.table][response.id],response.table);
      }
    });
    return true;
  };

  $scope.delete = function(element,type) {
    if(type==='templatesection') {
      webservice.exclusiveCall('deleteTemplatesection',{'id':element.id},script,model).then(function() {
        $scope.structureTemplate();
      });
    } else if(type==='templateelement') {
      webservice.exclusiveCall('deleteTemplateelement',{'table':element.table,'id':element.id},script,model).then(function() {
        $scope.structureTemplate();
      });
    }
  };

  $scope.isValidHTML = function(input) {
    try {
      var doc=new DOMParser().parseFromString('<span>'+input+'</span>','application/xml');
      return !doc.querySelector('parsererror');
    } catch (e) {
      return false;
    }
  };

  $scope.updateTemplatetext = function(templatetext) {
    webservice.exclusiveCall('updateTemplatetext',{
      'templatetext':tools.whitelist(templatetext,['tts','align','bodyen','bodynl','bodyfr','placeholder','spacingtop','spacingbottom'])
    },script,model).then(function() {
      $scope.structureTemplate();
    });
  };

  $scope.updateTemplateimageWidth = function(templateimage) {
    if(templateimage.zoomwidth!=='' && templateimage.zoomwidth!==null) {
      $scope.updateTemplateimage(templateimage);
    }
  };

  $scope.updateTemplateimage = function(templateimage) {
    return webservice.exclusiveCall('updateTemplateimage',{
      'templateimage':tools.whitelist(templateimage,['zoomwidth','align','linken','linknl','linkfr','linktexten','linktextnl','linktextfr'])
    },script,model).then(function() {
      $scope.structureTemplate();
    });
  };

  $scope.updateTemplatespacing = function(templatespacing) {
    return webservice.exclusiveCall('updateTemplatespacing',{
      'templatespacing':tools.whitelist(templatespacing,['height'])
    },script,model).then(function() {
      $scope.structureTemplate();
    });
  };

  $scope.upload = function(file,invalidFiles) {
    if(file!==null) {
      webservice.exclusiveCall('upload',{'templateimageId':model.currentTemplateimage.id},script,model,file).then(function() {
        $scope.structureTemplate();
        if(model.selected===null) {
          $scope.select(model.templateimages[model.currentTemplateimage.id],'templateimages');
        }
      });
    } else if(invalidFiles.length>0) {
      var error=invalidFiles[0].$error;
      if(error=='maxSize') {
        errorlog.error(tools.lang({'en':'Please use image editing software to reduce the size below 1MB','nl':'Gebruik beeldbewerkingssoftware om te verkleinen tot minder dan 1MB','fr':'Please use image editing software to reduce the size below 1MB'}));
      } else if(error=='pattern') {
        errorlog.error(tools.lang({'en':'Only images are allowed','nl':'Enkel afbeeldingen zijn toegestaan','fr':'Only images are allowed'}));
      } else {
        errorlog.error(error);
      }
    }
  };

  $scope.getTemplatetextSpacingtop = function(templatetext,$first) {
    var result='0';
    if($first) {
      result=(4+parseInt(templatetext.spacingtop)).toString()+'px';
    }
    return result;
  };

  $scope.getTemplatetextSpacingbottom = function(templatetext,$last) {
    var result=parseInt(templatetext.spacingbottom);
    if($last) {
      result+=4;
    }
    return result.toString()+'px';
  };

  $scope.updatePricePlaceholderPriceCat = function(catId) {
    if(model.pricePlaceholder.priceCat!=catId) {
      model.pricePlaceholder.priceCat=catId;
      model.pricePlaceholder.priceAct='';
      model.pricePlaceholder.priceFrm='';
      model.pricePlaceholder.priceUnt='';
      model.pricePlaceholder.pricekey=catId==='PA'?catId:'';
      model.pricePlaceholder.priceRes='';
      model.pricePlaceholder.priceDshCat='Undefined';
      model.pricePlaceholder.priceDsh='';
      model.pricePlaceholder.priceHtl='';
      model.pricePlaceholder.priceHsc='';
      model.pricePlaceholder.priceHra='';
      model.pricePlaceholder.priceCityTax='withCityTax';
      model.pricePlaceholder.pricePrd='';
    }
  };

  $scope.updatePricePlaceholderPriceAct = function() {
    model.pricePlaceholder.priceFrm='';
    model.pricePlaceholder.priceUnt='';
    model.pricePlaceholder.pricekey='';
  };

  $scope.updatePricePlaceholderPricekeyActivity = function() {
    if(model.pricePlaceholder.priceFrm!=='' && model.pricePlaceholder.priceUnt!=='') {
      model.pricePlaceholder.pricekey='AC'+model.pricePlaceholder.priceFrm+model.pricePlaceholder.priceUnt.substr(6,2);
    } else {
      model.pricePlaceholder.pricekey='';
    }
  };

  $scope.activityFilter = function(input,field,formula) {
    if(input && formula) {
      var activity_type=formula.substr(0,3);
      var output=[];
      for(var i in input) {
        if(i in input && field in input[i] && input[i][field].substr(0,3)==activity_type) {
          output.push(input[i]);
        }
      }
      return output;
    } else {
      return [];
    }
  };

  $scope.updatePricePlaceholderPriceRes = function() {
    model.pricePlaceholder.priceDshCat='Undefined';
  };

  $scope.getDishCategories = function() {
    return (("notDelArrayDSH" in parameters) && model.pricePlaceholder.priceRes!='')?Object.keys(parameters.notDelArrayDSH.filter(function(dsh){
      return dsh.id.substr(0,3)==model.pricePlaceholder.priceRes;
    }).reduce(function(acc,dsh) {
      if(dsh.field2==='') {
        acc['Undefined']=true;
      } else {
        acc[dsh.field2]=true;
      }
      return acc;
    },{'Undefined':true})):['Undefined'];
  };

  $scope.updatePricePlaceholderPriceDshCat = function() {
    model.pricePlaceholder.priceDsh='';
    model.pricePlaceholder.pricekey='';
  };

  $scope.getDishes = function() {
    return ("notDelArrayDSH" in parameters)?parameters.notDelArrayDSH.filter(function(dsh) {
      return dsh.id.substr(0,3)==model.pricePlaceholder.priceRes && dsh.field2===(model.pricePlaceholder.priceDshCat==='Undefined'?'':model.pricePlaceholder.priceDshCat);
    }):[];
  };

  $scope.updatePricePlaceholderPricekeyMeal = function() {
    if(model.pricePlaceholder.priceDsh!=='') {
      model.pricePlaceholder.pricekey='ME'+model.pricePlaceholder.priceDsh;
    } else {
      model.pricePlaceholder.pricekey='';
    }
  };

  $scope.updatePricePlaceholderPriceHtl = function() {
    model.pricePlaceholder.priceHsc='';
    model.pricePlaceholder.priceHra='';
    model.pricePlaceholder.priceCityTax='withCityTax';
  };

  $scope.updatePricePlaceholderPricekeyHotelstay = function() {
    if(model.pricePlaceholder.priceHtl!=='' && model.pricePlaceholder.priceHsc!=='') {
      model.pricePlaceholder.pricekey='HS'+model.pricePlaceholder.priceHtl+model.pricePlaceholder.priceHsc.substr(3,3)+model.pricePlaceholder.priceHra+model.pricePlaceholder.priceCityTax;
    } else {
      model.pricePlaceholder.pricekey='';
    }
  };

  $scope.getHotelspaces = function() {
    return ("notDelArrayHSC" in parameters)?parameters.notDelArrayHSC.filter(function(hsc) {
      return hsc.id.substr(0,3)==model.pricePlaceholder.priceHtl && tools.numberIn(hsc.field6)===1;
    }):[];
  };

  $scope.getHotelrates = function() {
    return ("notDelArrayHRA" in parameters)?parameters.notDelArrayHRA.filter(function(hra) {
      return hra.id.substr(0,3)==model.pricePlaceholder.priceHtl && tools.numberIn(hra.field2)===1;
    }):[];
  };

  $scope.updatePricePlaceholderPricePrd = function() {
    model.pricePlaceholder.pricekey='PRDCT'+model.pricePlaceholder.pricePrd;
  }

  $scope.pricekeyCategories=[
    {'id':'AC','labelen':'Activity','labelnl':'Activiteit','labelfr':'Activit\u00E9'},
    {'id':'ME','labelen':'Meal','labelnl':'Maaltijd','labelfr':'Repas'},
    {'id':'PR','labelen':'Product','labelnl':'Product','labelfr':'Produit'},
    {'id':'HS','labelen':'Accom','labelnl':'Accom','labelfr':'H\u00E9berg'},
    {'id':'PA','labelen':'Pack','labelnl':'Pack','labelfr':'Pack'}
  ];
  $scope.cityTaxCategories=[
    {'id':'noCityTax','labelen':'noCityTax','labelnl':'noCityTax','labelfr':'noCityTax'},
    {'id':'withCityTax','labelen':'withCityTax','labelnl':'withCityTax','labelfr':'withCityTax'}
  ];
  $scope.zero = {'id':'','labelen':'--Zero--','labelnl':'--Nul--','labelfr':'--Zero--'};

  angular.element($window).on('resize',function() {
    model.windowHeight=Math.max(200,($window.innerHeight-100))+'px';
    $scope.$apply();
  });

  tools.initAttributes(model,{
    'showCreateTemplatesection':false,
    'tgcPicker':{
      'open':false,
      'index':null,
      'where':null
    },
    'windowHeight':($window.innerHeight-100)+'px',
    'templatesections':{},
    'templatesectionsArray':[],
    'templateelements':{},
    'currentTemplateimage':null,
    'placeholders':[],
    'pricePlaceholder':{'pricekey':''}
  });
  model.selected=null;
  webservice.afterLogin().then(function() {
    $scope.load();
  });

}]);

angular.module("app").controller("campaignOverviewController", ["$scope", "tools", "modelstore", "parameters", "webservice",
  function ($scope, tools, modelstore, parameters, webservice) {
    var script = 'marketing/campaignOverview';
    var model = modelstore.getModel(script);
    $scope.model = model;

    $scope.load = function() {
      model.filteredCampaigns=[];
      webservice.exclusiveCall('load',{
        'startdate':tools.dateFromJava(model.startdate),
        'enddate':tools.dateFromJava(model.enddate),
        'actId':model.actId,
        'proId':model.proId
      },script,model).then(function() {
        $scope.filterCampaigns();
      })
    };

    $scope.filterCampaigns = function() {
      var filteredCampaigns=[];
      var i,campaign;
      for(i in model.campaigns) {
        campaign=model.campaigns[i];
        if((campaign.pro===model.proId || model.proId==='') && (campaign.act===model.actId || model.actId==='')) {
          filteredCampaigns.push(campaign);
        }
      }
      model.filteredCampaigns=filteredCampaigns;
    }

    if(!('startdate' in model)) {
      tools.initDates(0,1,model);
    }

    $scope.any={'id':'','labelen':'--All--','labelnl':'--Alle--','labelfr':'--Tout--'};

    tools.initAttributes(model, {
      'enddateOpened':false,
      'startdateOpened':false,
      'dateOptions':{
        startingDay: 1
      },
      'actId': '',
      'proId': '',
      'campaigns': [],
      'filteredCampaigns':[],
      'startdate':'',
      'enddate':''
    });

    webservice.afterLogin().then(function () {
      $scope.load();
    });

  }]);

angular.module("app").controller("HotelsTimelineController",["$scope","$stateParams","$window","user","tools","modelstore","parameters","webservice","contactsService",
                                            function($scope,$stateParams,$window,user,tools,modelstore,parameters,webservice,contactsService) {
  
  var script="hotels/timeline";
  var model=modelstore.getModel(script);
  $scope.contactsService=contactsService;
  $scope.model=model;

  $scope.load = function() {
    if(tools.validateAndUpdateDates(model) && model.htl!=='') {
      modelstore.cleanModel(["contacts","visits","tickets","hotelreservationcategories","hotelspaceassignments","hotelspaces","items","visitrelations"],model);
      webservice.exclusiveCall("load",{
        'startdate':tools.dateFromJava(model.startdate),
        'enddate':tools.dateFromJava(model.enddate),
        'htl':model.htl
      },script,model).then(function() {
        var start=new Date(model.startdate);
        var i,j,k,date,monthKey,dayKey,month,hscId,hsc;
        model.lines={'months':{},'dates':{}};
        while(start<=model.enddate) {
          date=new Date(start);
          monthKey=tools.dateFromJava(date).substr(0,7);
          if(angular.isUndefined(model.lines.months[monthKey])) {
            model.lines.months[monthKey]=tools.months[date.getMonth()];
            model.lines.months[monthKey]['dates']=[];
            model.lines.months[monthKey]['year']=date.getFullYear();
          }
          model.lines.months[monthKey]['dates'].push(date);
          model.lines['dates'][tools.dateFromJava(date)]={'date':date};
          start.setDate(start.getDate()+1);
        }
        var hotelspacesArray=[];
        model.sumLoad=$scope
        for(i in model.hotelspaces) {
          hotelspace=model.hotelspaces[i];
          hsc=parameters.HSC[hotelspace.hsc];
          hotelspaceassignments=tools.match(model.hotelspaceassignments,{'assignedspace':hotelspace.id});
          loadElements=[];
          for(j in hotelspaceassignments) {
            hotelspaceassignment=hotelspaceassignments[j];
            hotelreservationcategory=model.hotelreservationcategories[hotelspaceassignment.reservationcategory];
            visit=model.visits[hotelreservationcategory.visit];
            startHrs=hotelreservationcategory.starthrs;
            startTime=new Date(hotelreservationcategory.startdate);
            startTime.setHours(tools.amountIn(startHrs.substr(0,2)),0,0,0);
            endHrs=hotelreservationcategory.checkoutHrs;
            endTime=new Date(hotelreservationcategory.enddate);
            endTime.setHours(tools.amountIn(endHrs.substr(0,2)),0,0,0);
            loadElement={
              'startTime':startTime,
              'endTime':endTime,
              'visit':visit,
              'state':hotelspaceassignment.state,
              'rowspan':1,
              'colspan':$scope.getHrsDiff(new Date(Math.max(startTime,model.startdate)),new Date(Math.min(endTime,model.enddate))),
              'hotelreservationcategory':hotelreservationcategory,
              'addReservation':false
            };
            loadElements.push(loadElement);
          }
          loadElements=tools.orderBy(loadElements,'+startTime');
          hotelspace.rowspan=1;
          dummyLoadElement={
            'startTime':null,
            'endTime':null,
            'visit':null,
            'state':'Available',
            'rowspan':1,
            'colspan':1,
            'hotelreservationcategory':null,
            'addReservation':true
          };
          numberLoadElements=tools.getLength(loadElements);
          for(k=0;k<numberLoadElements;k++) {
            xLoadElement=loadElements[k];
            previousElement=k===0?undefined:loadElements[k-1];
            nextElement=k+1<numberLoadElements?loadElements[k+1]:undefined;
            previousEndTime=angular.isUndefined(previousElement)?model.startdate:previousElement.endTime;
            nextStartTime=angular.isUndefined(nextElement)?model.enddate:nextElement.startTime;
            if(previousEndTime<xLoadElement.startTime) {
              while(previousEndTime<xLoadElement.startTime) {
                newStartTime=new Date(previousEndTime);
                newStartTime.setHours(15,0,0,0);
                previousEndTime=new Date(newStartTime);
                previousEndTime.setTime(Math.min(previousEndTime.getTime()+1000*60*60*24,xLoadElement.startTime.getTime()));
                newEndTime=new Date(previousEndTime);
                newEndTime.setHours(10,0,0,0);
                if(newEndTime>newStartTime) {
                  loadElement=tools.clone(dummyLoadElement);
                  loadElement.startTime=newStartTime;
                  loadElement.endTime=newEndTime;
                  loadElement.colspan=Math.round($scope.getHrsDiff(loadElement.startTime,loadElement.endTime));
                  loadElement.addReservation=loadElement.colspan>6;
                  loadElements.push(loadElement);
                }
              }
            }
            if(angular.isUndefined(nextElement) && xLoadElement.endTime<nextStartTime) {
              while(nextStartTime<xLoadElement.endTime) {
                newStartTime=new Date(nextStartTime);
                newStartTime.setHours(15,0,0,0);
                nextStartTime=new Date(xLoadElement.endTime);
                nextStartTime.setTime(Math.min(nextStartTime.getTime()+1000*60*60*24,xLoadElement.endTime.getTime()));
                newEndTime=new Date(nextStartTime);
                newEndTime.setHours(10,0,0,0);
                if(newEndTime>newStartTime) {
                  loadElement=tools.clone(dummyLoadElement);
                  loadElement.startTime=newStartTime;
                  loadElement.endTime=newEndTime;
                  loadElement.colspan=Math.round($scope.getHrsDiff(loadElement.startTime,loadElement.endTime));
                  loadElement.addReservation=loadElement.colspan>6;
                  loadElements.push(loadElement);
                }
              }
              loadElement=tools.clone(dummyLoadElement);
              loadElement.startTime=xLoadElement.endTime;
              loadElement.endTime=nextStartTime;
              loadElement.colspan=$scope.getHrsDiff(loadElement.startTime,loadElement.endTime);
              loadElements.push(loadElement);
            }
          }
          if(hsc.field6==='1') {
            hotelspace.hscLabel=tools.label(hsc);
            hotelspace.hscShort=tools.short(hsc);
            hotelspace.ordering=hsc.field2;
            hotelspace.loadElements=tools.orderBy(loadElements,'+startTime');
            hotelspacesArray.push(hotelspace);
          }
        }
        model.orderedHotelspaces=tools.orderBy(hotelspacesArray,[$scope.orderHotelspaces,'+spacenumber']);
        $scope.setWindowHeight(false);
      });
    }
  };

  $scope.dayIndex = function(date) {
    var datesArray=tools.toArray(model.lines.dates);
    if(!date || tools.getLength(datesArray)===0) {
      return 0;
    }
    var t=new Date(date);
    t.setHours(0,0,0,0);
    for(var i=0;i<tools.getLength(datesArray);i++) {
      var d=new Date(datesArray[i].date);
      d.setHours(0,0,0,0);
      if (d.getTime()===t.getTime()) {
        return i;
      }
    }
    // Out of range => clamp to edges
    if (t<datesArray[0].date) {
      return 0;
    }
    return tools.getLength(datesArray)-1;
  };

  $scope.daysSpanDays = function(start, end) {
    var s = new Date(start); 
    s.setHours(0,0,0,0);
    var e = new Date(end);   
    e.setHours(0,0,0,0);
    return Math.max(1, $scope.dayIndex(e) - $scope.dayIndex(s));
  };

  // Hours from midnight (decimal, with minutes)
  $scope.startHourInDay = function(dt) {
    var d = new Date(dt);
    return d.getHours() + d.getMinutes() / 60;
  };

  $scope.endHourInDay = function(dt) {
    var d = new Date(dt);
    return d.getHours() + d.getMinutes() / 60;
  };

  $scope.getHrsDiff = function(startTime,endTime) {
    return (endTime.getTime()-startTime.getTime())/(1000*60*60);
  }

  $scope.orderHotelspaces = function(hotelspace) {
    return tools.amountIn(hotelspace.ordering);
  }

  angular.element($window).on('resize',function() {
    $scope.setWindowHeight(true);
  });

  $scope.setWindowHeight = function(apply) {
    model.windowHeight=Math.max(200,($window.outerHeight-425))+'px';
    var dayW = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--timeline-day-width')
    );
    $scope.pxPerHour = (isNaN(dayW) ? 110 : dayW) / 24;
    if(apply) {
      $scope.$apply();
    }
  }

  $scope.todayDate = function() {
    var newStartdate=new Date();
    newStartdate.setDate(newStartdate.getDate()-2);
    model.startdate=newStartdate;
    var newEnddate=new Date();
    newEnddate.setDate(newEnddate.getDate()+28);
    model.enddate=newEnddate;
    $scope.load();
  }

  $scope.increaseDates = function(increment) {
    var newStartdate=new Date(model.startdate.getTime());
    newStartdate.setDate(newStartdate.getDate()+increment);
    model.startdate=newStartdate;
    var newEnddate=new Date(model.enddate.getTime());
    newEnddate.setDate(newEnddate.getDate()+increment);
    model.enddate=newEnddate;
    $scope.load();
  };

  $scope.days=[
    {'id':'0','en':'Monday','nl':'Maandag','fr':'Lundi'},
    {'id':'1','en':'Tuesday','nl':'Dinsdag','fr':'Mardi'},
    {'id':'2','en':'Wednesday','nl':'Woensdag','fr':'Mercredi'},
    {'id':'3','en':'Thursday','nl':'Donderdag','fr':'Jeudi'},
    {'id':'4','en':'Friday','nl':'Vrijdag','fr':'Vendredi'},
    {'id':'5','en':'Saturday','nl':'Zaterdag','fr':'Samedi'},
    {'id':'6','en':'Sunday','nl':'Zondag','fr':'Dimanche'}
  ];
  $scope.hotelspaceassignmentStates={
    'Enquired':{
      'checkin':{'labelen':'Enquired','labelnl':'In aanvraag','labelfr':"Hors d'usage",'color':'#00000','backgroundcolor':'#fcf6e3'},
      'checkout':{'labelen':'Enquired','labelnl':'In aanvraag','labelfr':"Hors d'usage",'color':'#00000','backgroundcolor':'#fcf6e3'}
    },
    'Optional':{
      'checkin':{'labelen':'Optional','labelnl':'Optie','labelfr':'Option','color':'#00000','backgroundcolor':'#fcefe9'},
      'checkout':{'labelen':'Optional','labelnl':'Optie','labelfr':'Option','color':'#00000','backgroundcolor':'#fcefe9'}
    },
    'Confirmed':{
      'checkin':{'labelen':'To check in','labelnl':'In te checken','labelfr':'Effectuer le check-in','color':'#4287f4','backgroundcolor':'#e4eefd'},
      'checkout':{'labelen':'Check-in missed','labelnl':'Gemiste check-in','labelfr':'Check-in manqu\u00E9','color':'#00000','backgroundcolor':'#fcefe9'}
    },
    'Started':{
      'checkin':{'labelen':'Check-in done','labelnl':'Check-in uitgevoerd','labelfr':'Check-in effectuer','color':'#00000','backgroundcolor':'#f6f6f9'},
      'checkout':{'labelen':'To check-out','labelnl':'Uit te checken','labelfr':'Effectuer le check-out','color':'#4287f4','backgroundcolor':'#e4eefd'}
    },
    'Processed':{
      'checkout':{'labelen':'Check-out done','labelnl':'Check-out uitgevoerd','labelfr':'Check-out effectuer','color':'#00000','backgroundcolor':'#f6f6f9'},
      'checkin':{'labelen':'Past','labelnl':'Verleden','labelfr':'Pass\u00E9','color':'#000000','backgroundcolor':'#f6f6f9'}
    },
    'Canceled':{
      'checkin':{'labelen':'Canceled','labelnl':'Geannuleerd','labelfr':"Annuler",'color':'#bc1a2a','backgroundcolor':'#faeaed'},
      'checkout':{'labelen':'Canceled','labelnl':'Geannuleerd','labelfr':"Annuler",'color':'#bc1a2a','backgroundcolor':'#faeaed'}
    }
  }
  if(!("startdate" in model)) {
    tools.initDates(-2,28,model);
    model.startdate.setHours(0,0,0,0);
    model.enddate.setHours(23,59,59,999);
  }

  tools.initAttributes(model,{
    'htl':'',
    'startdateOpened':false,
    'enddateOpened':false,
    'dateOptions':{
      maxDate: new Date(2099,11,31),
      minDate: new Date(2000,0,1),
      startingDay: 1
    },
    'windowHeight':($window.outerHeight-425)+'px',
    'lines':[],
    'orderedHotelspaces':[]
  });

  webservice.afterLogin().then(function() {
    if(model.htl==='') {
      if($stateParams.settings!==null && 'htl' in $stateParams.settings && $stateParams.settings.htl!==null) {
        model.htl=$stateParams.settings.htl;
      } else {
        model.htl=tools.first(parameters.notDelHTL).id;
      }
    }
    $scope.load();
  });
}]);
angular.module("app").controller("HotelsMewsTestController",["$scope","tools","modelstore","user","parameters","webservice",
                                            function($scope,tools,modelstore,user,parameters,webservice) {
  
  var script="hotels/mewsTest";
  var model=modelstore.getModel(script);
  $scope.model=model;

  $scope.test = function(index) {
    webservice.call("test"+index,{},script,model);
  };

//  tools.initAttributes(model,{});

//  webservice.afterLogin().then(function() {});
}]);
angular.module("app").controller("MewsMessagesController",["$scope","tools","modelstore","parameters","webservice",
                                            function($scope,tools,modelstore,parameters,webservice) {
  var script='hotels/mewsMessages';
  var model=modelstore.getModel(script);
  $scope.model=model;
  
  $scope.load = function() {
    modelstore.cleanModel(["mewsmessages"],model);
    webservice.exclusiveCall("load",{},script,model).then(function() {
      var i,mewsmessage;
      for(var i in model.mewsmessages) {
        mewsmessage=model.mewsmessages[i];
        mewsmessage.errorArray=mewsmessage.errorwording.split(/<br\s*\/?>/mg).map(function(error,index) {
          return {'id':index,'error':error,'show':index===0};
        });
      }
    });
  };

  $scope.getMewsmessageHotelid = function(mewsmessage) {
    return angular.fromJson(mewsmessage.post).hotel;
  };

  $scope.getMewsmessageEvent = function(mewsmessage) {
    return angular.fromJson(mewsmessage.post).data;
  };

  $scope.retryMewsmessage = function(mewsmessage) {
    webservice.call("retryMewsmessage",{'mewsmessageId':mewsmessage.id},script,model);
  };

  $scope.deleteMewsmessage = function(mewsmessage) {
    webservice.call("deleteMewsmessage",{'mewsmessageId':mewsmessage.id},script,model);
  };

  $scope.showAll = function(mewsmessage) {
    for(var i in mewsmessage.errorArray) {
      mewsmessage.errorArray[i].show=true;
    }
  };
  $scope.hideAll = function(mewsmessage) {
    for(var i in mewsmessage.errorArray) {
      mewsmessage.errorArray[i].show=i==0;
    }
  };

  $scope.relaunchAll = function() {
    webservice.exclusiveCall("relaunchAll",{},script,model).then(function(response) {
      if(("continue" in response) && response.continue) {
        $scope.relaunchAll();
      }
    });
  };

  tools.initAttributes(model,{
    'mewsmessages':{},
  });
  webservice.afterLogin().then(function() {
    $scope.load();
  });

  
}]);
angular.module('app').controller('HotelsLobbyController',['$scope','$stateParams','$interval','$uibModal','$q','tools','modelstore','parameters','webservice','config','activitiesService','contactsService',
                                                 function ($scope,$stateParams,$interval,$uibModal,$q,tools,modelstore,parameters,webservice,config,activitiesService,contactsService) {
  $scope.activitiesService=activitiesService;
  $scope.contactsService=contactsService
  var script = 'hotels/lobby';
  var model = modelstore.getModel(script);
  $scope.model = model;

  $scope.load = function() {
    if(model.htl!=='') {
      var date=tools.dateFromJava(model.date);
      var htl=model.htl;
      var syncSpaces=model.syncSpaces;
      model.syncSpaces=false;
      modelstore.cleanModel(["contacts","visits","tickets","hotelreservationcategories","hotelspaceassignments","hotelspaces","items","visitrelations"],model);
      if(tools.dateFromJava(model.oldDate)!=date || model.oldHtl!=htl) {
        model.filteredVisits=[];
        model.filteredHotelspaceassignments=[];
        model.oldDate=model.date;
        model.oldHtl=model.htl;
        model.loading=true;
      }
      webservice.call("load",{'htl':model.htl,'syncSpaces':syncSpaces,'date':date},script,model).then(function() {
        if(tools.dateFromJava(model.oldDate)==date && model.oldHtl==htl) {
          model.loading=false;
          var i,j,visit,hotelreservationcategory,ticket,hotelspaceassignment;
          for(i in model.visits) {
            visit=model.visits[i];
            visit.isCheckin=false;
            visit.isCheckout=false;
            visit.starthrs=null;
            visit.checkoutHrs=null;
            visit.newCheckinHotelreservationcategories=[];
            visit.newCheckoutHotelreservationcategories=[];
            visit.newCheckinSpacenumbers=[];
            visit.newCheckoutSpacenumbers=[];
            ticket=$scope.getLatestTicket(visit);
            visit.ticketnr=(angular.isDefined(ticket) && tools.getLength(ticket)>0)?ticket.ticketnr:'';
            visit.clientName=contactsService.getName(model.contacts[visit.owningcontact]);
          }
          for(i in model.hotelreservationcategories) {
            hotelreservationcategory=model.hotelreservationcategories[i];
            visit=model.visits[hotelreservationcategory.visit];
            hotelreservationcategory.isCheckin=tools.dateFromJava(hotelreservationcategory.startdate)==tools.dateFromJava(model.date);
            if(hotelreservationcategory.isCheckin) {
              visit.isCheckin=true;
              visit.starthrs=visit.starthrs==null||visit.starthrs>hotelreservationcategory.starthrs?hotelreservationcategory.starthrs:visit.starthrs;
            }
            hotelreservationcategory.isCheckout=tools.dateFromJava(hotelreservationcategory.enddate)==tools.dateFromJava(model.date);
            if(hotelreservationcategory.isCheckout) {
              visit.isCheckout=true;
              visit.checkoutHrs=visit.checkoutHrs==null||visit.checkoutHrs<hotelreservationcategory.checkoutHrs?hotelreservationcategory.checkoutHrs:visit.checkoutHrs;
            }
            hotelreservationcategory.roomquantity=model.items[hotelreservationcategory.item].quantity;
            hotelreservationcategory.hotelspaces=tools.inverseJoin(tools.join(hotelreservationcategory,'hotelspaceassignments',model),'hotelspaces','assignedspace',model);
            if(hotelreservationcategory.isCheckin) {
              for(j in hotelreservationcategory.hotelspaces) {
                visit.newCheckinSpacenumbers.push(hotelreservationcategory.hotelspaces[j].spacenumber);
              }
              visit.newCheckinHotelreservationcategories.push(hotelreservationcategory);
            } 
            if(hotelreservationcategory.isCheckout) {
              for(j in hotelreservationcategory.hotelspaces) {
                visit.newCheckoutSpacenumbers.push(hotelreservationcategory.hotelspaces[j].spacenumber);
              }
              visit.newCheckoutHotelreservationcategories.push(hotelreservationcategory);              
            }
          }
          $scope.calculateFilteredVisits();
          $scope.calculateFilteredHotelspaceassignments();
        }
      });
    }

    // if (!model.calling) {
    //   model.calling = true;
    //   webservice.call('load', {}, script, model).then(function () {
    //     webservice.call('loadActivityFeed', {'limit':model.limit, 'htl':model.htl}, script, model).then(function () {
    //       webservice.call('loadInOutEvents', {
    //         'htl':model.htl,
            
    //       }, script, model).then(function () {
    //         model.calling = false;
    //         $scope.initializeInOutEvents();
    //       });
    //     });
    //   });
    // }
  };

  // $scope.initializeInOutEvents = function() {
  //   var today = new Date();
  //   today.setHours(0, 0, 0, 0);
  //   var now = tools.hourFromJava(today);
  //   for(var id in model.inOutEvents) {
  //     var event = model.inOutEvents[id];
  //     var date = tools.dateToJava(event.date);
  //     if(date.getTime() > today.getTime() || (date.getTime() == today.getTime() && event.starthrs > now)) {
  //       event.eventType = "checkin";
  //       event.checkTime = event.starthrs;
  //     } else {
  //       event.eventType = "checkout";
  //       event.checkTime = event.defaultCheckoutHour;
  //     }
  //     if(angular.isDefined(event.contactFirstname) || angular.isDefined(event.contactName)) {
  //       event.clientName = tools.getCompleteName(event.contactFirstname, event.contactName);
  //     } else {
  //       event.clientName = tools.getCompleteName(event.visitFirstname, event.visitName);
  //     }
  //   }
  //   model.events.sort($scope.compareInOutEvents);
  // }

  $scope.increaseDays = function(increment) {
    var newDate=new Date(model.date.getTime());
    newDate.setDate(newDate.getDate()+increment);
    model.date=newDate;
    $scope.load();
  };

  $scope.setToday = function() {
    model.date=new Date();
    $scope.load();
  };

  // $scope.compareInOutEvents = function(a, b) {
  //   var javadateTimeA = (a.eventType == 'checkin' ? a.date : a.enddate).getTime();
  //   var javadateTimeB = (b.eventType == 'checkin' ? b.date : b.enddate).getTime();

  //   if(javadateTimeA < javadateTimeB) {
  //     return -1;
  //   } 
  //   if(javadateTimeA == javadateTimeB) {
  //     if(a.checkTime == b.checkTime) {
  //       return 0;
  //     }
  //     if(a.checkTime > b.checkTime) {
  //       return 0;
  //     }
  //     if(a.checkTime < b.checkTime) {
  //       return -1;
  //     }
  //   } 
  //   return 1;
  // };

  $scope.calculateFilteredHotelspaceassignments = function() {
    model.filteredHotelspaceassignments=[];
    model.counts={'checkins':0,'checkedin':0,'checkouts':0,'checkedout':0,'checkinClients':0,'checkoutClients':0};
    var i,j,visit,visitrelations,visitrelation,ticket,hasValidTicket,hotelspaceassignment,hotelreservationcategory,hotelspace,isCheckedin,isCheckedout,checkinHotelspaceassignment,checkoutHotelspaceassignment;
    for(i in model.hotelspaceassignments) {
      hotelspaceassignment=model.hotelspaceassignments[i];
      hotelreservationcategory=model.hotelreservationcategories[hotelspaceassignment.reservationcategory];
      hotelspace=model.hotelspaces[hotelspaceassignment.assignedspace];
      visit=model.visits[hotelreservationcategory.visit];
      visitrelations=tools.match(model.visitrelations,{'visita':visit.id,'hotelspace':hotelspace.id});
      if(hotelreservationcategory.isCheckin) {
        model.counts.checkins++;
        model.counts.checkinClients+=tools.amountIn(hotelreservationcategory.adultcount)+tools.amountIn(hotelreservationcategory.childcount);
      }
      isCheckedin=hotelspaceassignment.state=='Started';
      if(isCheckedin) {
        model.counts.checkedin++;
      }
      if(model.filters.showCheckin && hotelreservationcategory.isCheckin) {
        checkinHotelspaceassignment=tools.clone(hotelspaceassignment);
        checkinHotelspaceassignment.hrs=hotelreservationcategory.starthrs;
        checkinHotelspaceassignment.clientName=visit.clientName;
        checkinHotelspaceassignment.isCheckout=false;
        checkinHotelspaceassignment.isCheckin=true;
        checkinHotelspaceassignment.isCheckedin=isCheckedin;
        checkinHotelspaceassignment.hotelreservationcategory=hotelreservationcategory;
        checkinHotelspaceassignment.hotelspace=hotelspace;
        checkinHotelspaceassignment.spacenumber=hotelspace.spacenumber;
        checkinHotelspaceassignment.visitrelations=visitrelations;
        checkinHotelspaceassignment.visits={};
        checkinHotelspaceassignment.visits[visit.id]=visit;
        for(j in visitrelations) {
          visitrelation=visitrelations[j];
          checkinHotelspaceassignment.visits[visitrelation.visitb]=model.visits[visitrelation.visitb];
        }
        if(model.filters.spacenumber=='' || hotelspace.spacenumber.indexOf(model.filters.spacenumber)>=0) {
          if(model.filters.showCheckedin || !checkinHotelspaceassignment.isCheckedin) {
            model.filteredHotelspaceassignments.push(checkinHotelspaceassignment);
          }
        }
      }
      if(hotelreservationcategory.isCheckout) {
        model.counts.checkouts++;
        model.counts.checkoutClients+=tools.amountIn(hotelreservationcategory.adultcount)+tools.amountIn(hotelreservationcategory.childcount);
      }
      isCheckedout=hotelspaceassignment.state=='Processed';
      if(isCheckedout) {
        model.counts.checkedout++;
      }
      if(model.filters.showCheckout && hotelreservationcategory.isCheckout) {
        checkoutHotelspaceassignment=tools.clone(hotelspaceassignment);
        checkoutHotelspaceassignment.hrs=hotelreservationcategory.checkoutHrs;
        checkoutHotelspaceassignment.clientName=visit.clientName;
        checkoutHotelspaceassignment.isCheckout=true;
        checkoutHotelspaceassignment.isCheckin=false;
        checkoutHotelspaceassignment.isCheckedout=isCheckedout;
        checkoutHotelspaceassignment.hotelreservationcategory=hotelreservationcategory;
        checkoutHotelspaceassignment.hotelspace=hotelspace;
        checkoutHotelspaceassignment.spacenumber=hotelspace.spacenumber;
        checkoutHotelspaceassignment.visitrelations=visitrelations;
        checkoutHotelspaceassignment.visits={};
        checkoutHotelspaceassignment.visits[visit.id]=visit;
        for(j in visitrelations) {
          visitrelation=visitrelations[j];
          checkoutHotelspaceassignment.visits[visitrelation.visitb]=model.visits[visitrelation.visitb];
        }
        if(model.filters.spacenumber=='' || hotelspace.spacenumber.indexOf(model.filters.spacenumber)>=0) {
          ticket=$scope.getLatestTicket(visit);
          hasValidTicket=angular.isDefined(ticket) && tools.getLength(ticket)>0 && ticket.del=='0';
          if(model.filters.showCheckedout || !checkoutHotelspaceassignment.isCheckedout || !hasValidTicket) {
            model.filteredHotelspaceassignments.push(checkoutHotelspaceassignment);
          }
        }
      }
    }
  }

  $scope.calculateFilteredVisits = function() {
    model.filteredVisits=[];
    var i,j,visit,ticket,hasValidTicket,checkinVisit,checkoutVisit;
    for(i in model.visits) {
      visit=model.visits[i];
      if(model.filters.showCheckin && visit.isCheckin) {
        checkinVisit=tools.clone(visit);
        checkinVisit.hrs=visit.starthrs;
        checkinVisit.isCheckout=false;
        checkinVisit.hotelreservationcategories=visit.newCheckinHotelreservationcategories;
        checkinVisit.spacenumbers=visit.newCheckinSpacenumbers;
        if(model.filters.spacenumber=='' || checkinVisit.spacenumbers.find(function(spacenumber) {return spacenumber.indexOf(model.filters.spacenumber)>=0})) {
          if(model.filters.showCheckedin || !$scope.visitIsCheckedin(checkinVisit)) {
            model.filteredVisits.push(checkinVisit);
          }
        }
      }
      if(model.filters.showCheckout && visit.isCheckout) {
        checkoutVisit=tools.clone(visit);
        checkoutVisit.hrs=visit.checkoutHrs;
        checkoutVisit.isCheckin=false;
        checkoutVisit.hotelreservationcategories=visit.newCheckoutHotelreservationcategories;
        checkoutVisit.spacenumbers=visit.newCheckoutSpacenumbers;
        if(model.filters.spacenumber=='' || checkoutVisit.spacenumbers.find(function(spacenumber) {return spacenumber.indexOf(model.filters.spacenumber)>=0})) {
          ticket=$scope.getLatestTicket(visit);
          hasValidTicket=angular.isDefined(ticket) && tools.getLength(ticket)>0 && ticket.del=='0';
          if(model.filters.showCheckedout || !$scope.visitIsCheckedout(checkoutVisit) || !hasValidTicket) {
            model.filteredVisits.push(checkoutVisit);
          }
        }
      }
    }


    // var filteredInOutEvents = [];
    // for(var i in inOutEvents) {
    //   var inOutEvent = inOutEvents[i];
    //   if(model.filters.showZero || (!model.filters.showZero && inOutEvent.quantity > 0)) {
    //     if(model.filters.showCheckin && inOutEvent.eventType === 'checkin') {
    //       filteredInOutEvents.push(inOutEvent);
    //     } else if(model.filters.showCheckout && inOutEvent.eventType === 'checkout') {
    //       filteredInOutEvents.push(inOutEvent);
    //     }
    //   }
    // }

    // if(model.filters.name!='') {
    //   inOutEvents = filteredInOutEvents;
    //   filteredInOutEvents = [];
    //   var filters=tools.latinise(model.filters.name).split(" ");
    //   var matches,name;
    //   for(var i in inOutEvents) {
    //     inOutEvent = inOutEvents[i];
    //     matches = true;
    //     name = tools.latinise(inOutEvent.clientName);
    //     for(var j in filters) {
    //       if(!(name.indexOf(filters[j])>-1)) {
    //         matches=false;
    //         break;
    //       }
    //     }
    //     if(matches) {
    //       filteredInOutEvents.push(inOutEvent);
    //     }
    //   }
    // }

    // return filteredInOutEvents;
  }

  $scope.sortBy = function(propertyName) {
    if(model.sorting.propertyName===propertyName) {
      model.sorting.reverse=!model.sorting.reverse;
    } else {
      model.sorting.propertyName=propertyName;
      model.sorting.reverse=false;
    }
  }

  $scope.getLatestTicket = function(visit) {
    var tickets=tools.join(visit,"tickets",model);
    var notDelTickets=tools.match(tickets,{'del':'0'});
    tickets=notDelTickets.length>0?notDelTickets:tickets;
    return tools.maxInt(tickets,'id');
  }

  $scope.getNotCheckedInSpaceassignments = function(visit) {
    return tools.join(visit.hotelreservationcategories,"hotelspaceassignments",model).filter(function(hotelspaceassignment) {
      return hotelspaceassignment.state!="Started" && hotelspaceassignment.state!="Processed" && hotelspaceassignment.state!="Canceled";
    });
  };

  $scope.getNotCheckedOutSpaceassignments = function(visit) {
    return tools.join(visit.hotelreservationcategories,"hotelspaceassignments",model).filter(function(hotelspaceassignment) {
      return hotelspaceassignment.state!="Processed" && hotelspaceassignment.state!="Canceled";
    });
  };

  $scope.visitIsCheckedin = function(visit) {
    return tools.getLength($scope.getNotCheckedInSpaceassignments(visit))==0;
  };

  $scope.visitIsCheckedout = function(visit) {
    return tools.getLength($scope.getNotCheckedOutSpaceassignments(visit))==0;
  };

  $scope.selectHotelspaceassignments = function(visit,hotelspaceassignments) {
    var hotelspaceassignmentsAreSelected;
    if(tools.getLength(hotelspaceassignments)>1) {
      hotelspaceassignmentsAreSelected=$uibModal.open({
        'templateUrl': 'app/modules/hotels/checkinModal.html',
        'controller': 'CheckinModalController',
        'resolve': {
          'params': function() {
            return {
              'hotelspaceassignments':hotelspaceassignments,
              'hotelspaces':model.hotelspaces,
              'visit':visit
            };
          }
        }
      }).result;
    } else {
      hotelspaceassignmentsAreSelected=$q.resolve([tools.first(hotelspaceassignments).id]);
    }
    return hotelspaceassignmentsAreSelected;
  }

  $scope.visitCheckin = function(visit) {
    $scope.selectHotelspaceassignments(visit,$scope.getNotCheckedInSpaceassignments(visit)).then(function(hotelspaceassignmentIds) {
      $scope.checkin(hotelspaceassignmentIds);
    });
  };

  $scope.checkin = function(hotelspaceassignmentIds) {
    webservice.exclusiveCall("checkin",{'hotelspaceassignmentIds':hotelspaceassignmentIds},script,model);
  };

  $scope.visitCheckout = function(visit) {
    $scope.selectHotelspaceassignments(visit,$scope.getNotCheckedOutSpaceassignments(visit)).then(function(hotelspaceassignmentIds) {
      $scope.checkout(hotelspaceassignmentIds);
    });
  };

  $scope.checkout = function(hotelspaceassignmentIds) {
    webservice.exclusiveCall("checkout",{'hotelspaceassignmentIds':hotelspaceassignmentIds},script,model);
  };

  $scope.syncHotelreservationcategory = function(hotelreservationcategory) {
    webservice.exclusiveCall('syncHotelreservationcategory',{'hotelreservationcategoryId':hotelreservationcategory.id},'activities/retrieveForEmp',model).then(function() {
      $scope.load();
    })
  }

  tools.initAttributes(model, {
    'htl':'',
    'oldHtl':'',
    'syncSpaces':true,
    'date':new Date(),
    'oldDate':new Date(),
    'dateOpened':false,
    'loading':true,
    'view':'list',
    'filteredVisits':[],
    'filteredHotelspaceassignments':[],
    'filters': {
      showCheckin:true,
      showCheckout:true,
      showCheckedin:false,
      showCheckedout:false,
      name:'',
      spacenumber:'',
      spacenumberIsActive:false,
      showZero:false
    },
    'sorting' : {
      propertyName:'hrs',
      reverse:false,
      comparator:undefined
    },
    'sortingProperties':{
      'hrs':{'id':'hrs','labelen':'Arrival/departure','labelnl':'Aankomst/vertrek','labelfr':'Arrivée/depart'},
      'clientName':{'id':'clientName','labelen':'Name','labelnl':'Naam','labelfr':'Nom'},
      'spacenumber':{'id':'spacenumber','labelen':'Rooms','labelnl':'Kamers','labelfr':'Chambre'}
    }
  });

  $scope.hotelspaceStates={
    'Inspected':{'labelen':'Inspected','labelnl':'Geinspecteerd','labelfr':'Inspect\u00E9','color':'#0f5712','backgroundcolor':'#e4f1e6'},
    'Clean':{'labelen':'Clean','labelnl':'Proper','labelfr':'Propre','color':'#4287f4','backgroundcolor':'#e4eefd'},
    'Dirty':{'labelen':'Dirty','labelnl':'Vuil','labelfr':'Sale','color':'#00000','backgroundcolor':'#fcefe9'},
    'OutOfOrder':{'labelen':'Out of order','labelnl':'Buiten gebruik','labelfr':"Hors d'usage",'color':'#00000','backgroundcolor':'#fcf6e3'},
    'OutOfService':{'labelen':'Out of service','labelnl':'Buiten dienst','labelfr':"Hors service",'color':'#bc1a2a','backgroundcolor':'#faeaed'}
  }
  $scope.hotelspaceassignmentStates={
    'Enquired':{
      'checkin':{'labelen':'Enquired','labelnl':'In aanvraag','labelfr':"Hors d'usage",'color':'#00000','backgroundcolor':'#fcf6e3'},
      'checkout':{'labelen':'Enquired','labelnl':'In aanvraag','labelfr':"Hors d'usage",'color':'#00000','backgroundcolor':'#fcf6e3'}
    },
    'Optional':{
      'checkin':{'labelen':'Optional','labelnl':'Optie','labelfr':'Option','color':'#00000','backgroundcolor':'#fcefe9'},
      'checkout':{'labelen':'Optional','labelnl':'Optie','labelfr':'Option','color':'#00000','backgroundcolor':'#fcefe9'}
    },
    'Confirmed':{
      'checkin':{'labelen':'To check in','labelnl':'In te checken','labelfr':'Effectuer le check-in','color':'#4287f4','backgroundcolor':'#e4eefd'},
      'checkout':{'labelen':'Check-in missed','labelnl':'Gemiste check-in','labelfr':'Check-in manqu\u00E9','color':'#00000','backgroundcolor':'#fcefe9'}
    },
    'Started':{
      'checkin':{'labelen':'Check-in done','labelnl':'Check-in uitgevoerd','labelfr':'Check-in effectuer','color':'#00000','backgroundcolor':'#f6f6f9'},
      'checkout':{'labelen':'To check-out','labelnl':'Uit te checken','labelfr':'Effectuer le check-out','color':'#4287f4','backgroundcolor':'#e4eefd'}
    },
    'Processed':{
      'checkout':{'labelen':'Check-out done','labelnl':'Check-out uitgevoerd','labelfr':'Check-out effectuer','color':'#00000','backgroundcolor':'#f6f6f9'},
      'checkin':{'labelen':'Past','labelnl':'Verleden','labelfr':'Pass\u00E9','color':'#000000','backgroundcolor':'#f6f6f9'}
    },
    'Canceled':{
      'checkin':{'labelen':'Canceled','labelnl':'Geannuleerd','labelfr':"Annuler",'color':'#bc1a2a','backgroundcolor':'#faeaed'},
      'checkout':{'labelen':'Canceled','labelnl':'Geannuleerd','labelfr':"Annuler",'color':'#bc1a2a','backgroundcolor':'#faeaed'}
    }
  }

  webservice.afterLogin().then(function () {
    if(model.htl==='') {
      if($stateParams.settings!==null && 'htl' in $stateParams.settings && $stateParams.settings.htl!==null) {
        model.htl=$stateParams.settings.htl;
      } else {
        model.htl=tools.first(parameters.notDelHTL).id;
      }
    }
    $scope.load();
    model.refreshInterval = $interval(function() {
      $scope.load();
    }, 60000);
  });

  $scope.$on('$destroy', function() {
    if(angular.isDefined(model.refreshInterval)) {
      $interval.cancel(model.refreshInterval);
    }
  })
}]);

angular.module("app").controller("CheckinModalController",["$scope","tools","parameters","$uibModalInstance","params",
                                                  function($scope,tools,parameters,$uibModalInstance,params) {
  $scope.parameters=parameters;
  $scope.tools=tools;
  $scope.model={
    'hotelspaceassignments':params.hotelspaceassignments,
    'hotelspaces':params.hotelspaces,
    'visit':params.visit,
    'selectAll':false
  };
  var model=$scope.model;

  $scope.selectAll = function() {
    for(var i in model.hotelspaceassignments) {
      model.hotelspaceassignments[i].selected=model.selectAll;
    }
  }

  $scope.checkinDisabled = function() {
    return tools.getLength(tools.match(model.hotelspaceassignments,{'selected':true}))<1;
  };

  $scope.checkin = function() {
    $uibModalInstance.close(params.hotelspaceassignments.filter(function(hotelspaceassignment) {
      return hotelspaceassignment.selected;
    }).map(function(hotelspaceassignment) {
      return hotelspaceassignment.id;
    }));
  }

  $scope.cancel = function() {
    $uibModalInstance.dismiss();
  };

  for(var i in model.hotelspaceassignments) {
    model.hotelspaceassignments[i].selected=false;
  }

}]);

var hotelsService=function(tools,parameters) {
  this.tools=tools;
  this.parameters=parameters;
};

hotelsService.prototype.getAllRoomsForHotel = function(htlId) {
  var result;
  if(htlId && ('notDelArrayHSC' in this.parameters)) {
    result=this.parameters.notDelArrayHSC.filter(function(hsc) {
      return hsc.id.substr(0,3)===htlId && hsc.field6=='1';
    });
  } else {
    result=[];
  }
  return result;
};

hotelsService.prototype.getAvailableRatesForHotel = function(htlId) {
  var result;
  if(htlId && ('notDelArrayHRA' in this.parameters)) {
    result=this.parameters.notDelArrayHRA.filter(function(hra) {
      return hra.id.substr(0,3)===htlId && hra.field2=='1';
    });
  } else {
    result=[];
  }
  return result;
};

hotelsService.prototype.getProductsForHotel = function(htlId) {
  var result;
  if(htlId && ('notDelArrayHPD' in this.parameters)) {
    result=this.parameters.notDelArrayHPD.filter(function(hpd) {
      return hpd.id.substr(0,3)===htlId && hpd.field5=='1';
    });
  } else {
    result=[];
  }
  return result;
};

hotelsService.prototype.setHotelreservationcategoryUpdatePermissions = function(visit,hotelreservationcategory,hotelspaceassignments) {
  var updatePermissions={'updateFields':{},'allowItemUpdate':false,'allowProductCreation':false,'allowProductsUpdate':false,'allowDeletion':false,'allowOverbookedCapacity':false};
  if(visit.stat<3000) {
    updatePermissions.updateFields=Object.assign(updatePermissions.updateFields,{'quotationhidefoto':true,'quotationparticipants':true});
    if(visit.hotelexternalreservation=="0" || new Date(hotelreservationcategory.enddate)<new Date(this.tools.today())) {
      updatePermissions.updateFields=Object.assign(updatePermissions.updateFields,{'startdate':true,'starthrs':true,'enddate':true,'adultcount':true,'childcount':true});
      updatePermissions.allowItemUpdate=true;
      updatePermissions.allowProductsUpdate=true;
      updatePermissions.allowDeletion=true;
      updatePermissions.allowOverbookedCapacity=true;
    } else {
      var hotelreservationcategoryStates=hotelspaceassignments.reduce(function(states,hotelspaceassignment) {
        states.checkedOut=states.checkedOut || hotelspaceassignment.state==='Processed';
        states.checkedIn=states.checkedIn || hotelspaceassignment.state==='Started' || states.checkedOut;
        return states;
      },{'checkedIn':false,'checkedOut':false});
      if(!hotelreservationcategoryStates.checkedIn) {
        updatePermissions.updateFields=Object.assign(updatePermissions.updateFields,{'startdate':true,'starthrs':true,'enddate':true,'adultcount':true,'childcount':true});
        updatePermissions.allowItemUpdate=true;
        updatePermissions.allowProductCreation=true;
      } else if(!hotelreservationcategoryStates.checkedOut && new Date(hotelreservationcategory.enddate)>=new Date(this.tools.today())) {
        updatePermissions.updateFields=Object.assign(updatePermissions.updateFields,{'enddate':true,'adultcount':true,'childcount':true});
        updatePermissions.allowItemUpdate=true;
      } else {
        updatePermissions.updateFields=Object.assign(updatePermissions.updateFields,{'startdate':true,'starthrs':true,'enddate':true,'adultcount':true,'childcount':true});
        updatePermissions.allowItemUpdate=true;
        updatePermissions.allowProductsUpdate=true;
        updatePermissions.allowDeletion=true;
        updatePermissions.allowOverbookedCapacity=true;
      }
    }
    updatePermissions.allowProductCreation=updatePermissions.allowProductCreation || updatePermissions.allowProductsUpdate;
  }
  hotelreservationcategory.updatePermissions=updatePermissions;
};

angular.module('app').service('hotelsService',['tools','parameters',hotelsService]);

angular.module('app').controller('HotelsCombinationsController',['$scope','tools','user','errorlog','modelstore','parameters','webservice',
                                                        function($scope,tools,user,errorlog,modelstore,parameters,webservice) {
  
  var script='hotels/combinations';
  var model=modelstore.getModel(script);
  $scope.model=model;
  
  $scope.filterChanged = function() {
    if(model.combinationType!='' && model.filter!='') {
      model.params1=parameters['notDelArray'+model.combinationType.substr(0,3)].filter(function(param) {
        return param.id.substr(0,3)==model.filter && param.field6=='1';
      });
      model.params2=parameters['notDelArray'+model.combinationType.substr(3,3)].filter(function(param) {
        return param.id.substr(0,3)==model.filter && param.field5=='1';
      });
    }
  };
  
  $scope.enterCell = function(id1,id2) {
    model.hover=id1+id2;
  };
  
  $scope.leaveCell = function() {
    model.hover='';
  };
  
  $scope.showButton = function(id1,id2,createButton) {
    if(model.hover==id1+id2) {
      var combinationExists=model.structuredCombinations[id1][id2];
      return (createButton && !combinationExists) || (!createButton && combinationExists);
    } else {
      return false;
    }
  };
  
  $scope.createCombination = function(id1,id2) {
    model.combinations=[];
    webservice.exclusiveCall('createCombination',{'id':model.combinationType,'id1':id1,'id2':id2},script,model).then(function(response) {
      $scope.buildStructuredCombinations();
    });
  };
  
  $scope.deleteCombination = function(id1,id2) {
    model.combinations=[];
    webservice.exclusiveCall('deleteCombination',{'id':model.combinationType,'id1':id1,'id2':id2},script,model).then(function(response) {
      $scope.buildStructuredCombinations();
    });
  };

  $scope.buildStructuredCombinations = function() {
    if(model.combinationType!=='') {
      model.structuredCombinations=model.combinations.reduce(function(acc,combination) {
        acc[combination.id1][combination.id2]=true;
        return acc;
      },parameters['notDelArray'+model.combinationType.substr(0,3)].reduce(function(acc,param1) {
        acc[param1.id]=parameters['notDelArray'+model.combinationType.substr(3,3)].reduce(function(acc,param2) {
          acc[param2.id]=false;
          return acc;
        },{});
        return acc;
      },{}));
    }
  };

  webservice.afterLogin().then(function()  {
    webservice.call('loadCombinationTypes',{},script,model).then(function() {
      if(model.combinationTypes.length==1) {
        model.combinationType=model.combinationTypes[0].id;
        $scope.filterChanged();
        webservice.call('loadCombinations',{'id':model.combinationType},script,model).then($scope.buildStructuredCombinations);
      }
    });
  });
  tools.initAttributes(model,{
    'combinationType':'',
    'filter':'',
    'combinations':[],
    'structuredCombinations':{},
    'params1':[],
    'params2':[],
    'hover':null
  });
  
}]);
angular.module("app").controller("ExactLoginController",["$scope","$window","tools","modelstore","user","parameters","webservice",
                                            function($scope,$window,tools,modelstore,user,parameters,webservice) {
  
  var script="exact/login";
  var model=modelstore.getModel(script);
  $scope.model=model;
  
  $scope.canLogin = function() {
    return "exactVars" in model
      && "host" in model.exactVars && model.exactVars.host!=''
      && "clientId" in model.exactVars && model.exactVars.clientId!=''
      && "redirectUri" in model.exactVars && model.exactVars.redirectUri!='';
  };
  
  $scope.login = function() {
    $window.location=model.exactVars.host+"/api/oauth2/auth?"
      +"client_id="+encodeURIComponent(model.exactVars.clientId)
      +"&redirect_uri="+encodeURIComponent(model.exactVars.redirectUri)
      +"&response_type=code";
  };
  
  $scope.canRefreshToken = function() {
    return "exactVars" in model
      && "refreshtoken" in model.exactVars && model.exactVars.refreshtoken!='';
  };

  $scope.refreshToken = function() {
    webservice.call("refreshToken",{},script,model).then();
  }

  $scope.postWebhooks = function() {
    webservice.call("postWebhooks",{},script,model).then();
  }
  
  $scope.test = function(index) {
    webservice.call("test"+index,{},script,model);
  };
  
  $scope.get = function() {
    webservice.call("get",{'guid':$scope.guid},script,model);
  };
  
  $scope.syncInvoices = function() {
    webservice.call("syncInvoices",{});
  };

  $scope.load = function() {
    webservice.exclusiveCall("load",{},script,model).then();
  };

  tools.initAttributes(model,{
  });

  webservice.afterLogin().then(function() {
    $scope.load();
  });

  $scope.guid="";
}]);
angular.module('app').controller('EmailsMarketingEmailsController',['$scope','$sce','config','tools','modelstore','parameters','webservice',
                                            function($scope,$sce,config,tools,modelstore,parameters,webservice) {

  var script='emails/marketingEmails';
  var model=modelstore.getModel(script);
  $scope.model=model;

  $scope.getParams = function() {
    var stringEnddate=tools.dateFromJava(model.enddate);
    if(angular.isUndefined(stringEnddate)) {
      stringEnddate='';
    }
    return {'startdate':tools.dateFromJava(model.startdate),'enddate':stringEnddate,'lang':model.lang,'agreestomarketing':model.agreestomarketing};
  };

  $scope.load = function() {
    if(!model.calling) {
      model.calling=true;
      modelstore.cleanModel(['visits'],model);
      
      webservice.call('load',$scope.getParams(),script,model).then(function() {
        model.calling=false;
      });
    }
  };

  $scope.getExportWsParams = function() {
    return angular.toJson({
      "a":webservice.auth,
      "s":script,
      "t":"export",
      "p":$scope.getParams()
    });
  };

  webservice.afterLogin().then(function() {
    $scope.load();
  });

  tools.initAttributes(model,{
    'startdate':new Date(),
    'enddate':null,
    'startdateOpened':false,
    'enddateOpened':false,
    'dateOptions':{
      'maxDate': new Date(2099,11,31),
      'minDate': new Date(2000,0,1),
      'startingDay': 1
    },
    'agreestomarketing':'1',
    'lang':'any',
    'calling':false,
    'action':$sce.trustAsResourceUrl(config.get('serviceUrl'))
  });

  $scope.$watch('model.startdate',$scope.load);
  $scope.$watch('model.enddate',$scope.load);

}]);

'use strict';

angular.module("app").controller("ContactsSearchContactsComponentController",["$scope","tools","parameters","config","user","modelstore","webservice","contactsService",
                                            function($scope,tools,parameters,config,user,modelstore,webservice,contactsService) {
  $scope.tools=tools;
  $scope.parameters=parameters;
  $scope.config=config;
  $scope.user=user;
  $scope.searchTerm='';
  $scope.calling=false;
  $scope.focus=false;
  $scope.isOpen=false;
  var model={};
  $scope.model=model;
  var parentModel=$scope.parentModel;
  var selectedName=$scope.selectedName;

  $scope.getCustomClass = function() {
    var result='';
    if(angular.isDefined($scope.customClass)) {
      result=' '+($scope.customClass.trim());
    }
    return result;
  };

  $scope.buildHref = function(route1,route2,id,page) {
    var href = user.lang+"/"+route1;
    if(angular.isDefined(route2)) {
      href += "/"+route2;
      if(angular.isDefined(id)) {
        href += "/"+id;
        if(angular.isDefined(page)) {
          href += "/"+page;
        }
      }
    }
    return href;
  };

  $scope.setIsOpen = function() {
    $scope.isOpen=!$scope.calling && angular.isDefined($scope.searchTerm) && $scope.searchTerm==model.previousSearchTerm && $scope.searchTerm!=='' && $scope.focus;
  };

  $scope.onSelection = function(ele,collection) {
    parentModel.previousSearchTerm=model.previousSearchTerm;
    if($scope.task=='c') {
      if(collection==='visits') {
        parentModel.backupVisits[selectedName]=tools.clone(parentModel[selectedName+'Visit']);
        parentModel[selectedName+'Visit']=ele;
        modelstore.addRecord("visits",parentModel[selectedName+'Visit'],parentModel);
      } else if(collection==='contacts') {
        parentModel.backupContacts[selectedName]=tools.clone(parentModel[selectedName+'Contact']);
        parentModel[selectedName+'Contact']=ele;
        modelstore.addRecord("contacts",parentModel[selectedName+'Contact'],parentModel);
      }
      $scope.onUpdateSelection();
    } else if($scope.task=='r') {
      if(collection==='visits') {
        tools.redirect($scope.buildHref('activities','retrieveForEmp','V'+ele.id));
      } else if(collection==='contacts') {
        tools.redirect($scope.buildHref('contacts','retrieve','C'+ele.id));
      }
    } else if($scope.task=='s') {
      if(collection==='visits') {
        parentModel[selectedName+'Visit']=ele;
        modelstore.addRecord("visits",parentModel[selectedName+'Visit'],parentModel);
      } else if(collection==='contacts') {
        parentModel[selectedName+'Contact']=ele;
        modelstore.addRecord("contacts",parentModel[selectedName+'Contact'],parentModel);
      }
      $scope.onUpdateSelection();
    }
    $scope.searchTerm=undefined;
    $scope.setIsOpen();
  };

  $scope.addSearchResults = function(limit,search) {
    model[limit]=model[limit]+10;
    model[search]=true;
    $scope.search(false);
  };

  $scope.init = function() {
    model.companySearchLimit=10;
    model.contactSearchLimit=10;
    model.visitSearchLimit=10;
    model.searchCompanies=true;
    model.searchContacts=true;
    model.searchVisits=true;
    modelstore.cleanModel(['visits','contacts'],model);
    model.filteredCompanies=[];
    model.filteredContacts=[];
  }

  $scope.search = function(cleanModel) {
    $scope.focus=true;
    if(angular.isDefined($scope.searchTerm) && $scope.searchTerm!='') {
      if(cleanModel) {
        $scope.init();
      }
      $scope.calling=true;
      webservice.call('search',{
        'searchTerm':$scope.searchTerm,
        'searchCompanies':model.searchCompanies && $scope.searchCompanies,
        'companySearchLimit':model.companySearchLimit,
        'searchContacts': model.searchContacts && $scope.searchContacts,
        'contactSearchLimit':model.contactSearchLimit,
        'searchVisits':model.searchVisits && $scope.searchVisits,
        'visitSearchLimit':model.visitSearchLimit
      },'contacts/searchContactsComponent',model).then(function(response) {
        $scope.calling=false;
        model.filteredContacts=tools.match(model.contacts,{'iscompany':'0'});
        model.filteredCompanies=tools.match(model.contacts,{'iscompany':'1'});
        model.previousSearchTerm=$scope.searchTerm;
        model.searchCompanies=false;
        model.searchContacts=false;
        model.searchVisits=false;
        $scope.setIsOpen();
      });
    }
  };

  tools.initAttributes(model,{
    'previousSearchTerm':'',
    'searchOptions':{
      'companies':{
        'id':'companies',
        'titleWording':{'en':'Company','nl':'Bedrijf','fr':'Entreprise'},
        'newWording':{'en':'New company','nl':'Nieuw bedrijf','fr':'Nouveau entreprise'},
        'notFoundWording':{'en':'No companies found','nl':'Geen bedrijven gevonden','fr':'Aucune entreprise trouv\u00E9e'},
        'onClickNew':function() {
          parentModel.previousSearchTerm=model.previousSearchTerm;
          $scope.onCreateCompany();
        },
        'searchResultName':'filteredCompanies',
        'table':'contacts',
        'limit':'companySearchLimit',
        'search':$scope.searchCompanies,
        'searchModel':'searchCompanies',
        'first':2
      },
      'contacts':{
        'id':'contacts',
        'titleWording':{'en':'Client','nl':'Klant','fr':'Client'},
        'newWording':{'en':'New client','nl':'Nieuwe klant','fr':'Nouveau client'},
        'notFoundWording':{'en':'No clients found','nl':'Geen klanten gevonden','fr':'Aucune client trouv\u00E9e'},
        'onClickNew':function() {
          parentModel.previousSearchTerm=model.previousSearchTerm;
          $scope.onCreateContact();
        },
        'searchResultName':'filteredContacts',
        'table':'contacts',
        'limit':'contactSearchLimit',
        'search':$scope.searchContacts,
        'searchModel':'searchContacts',
        'first':1
      },
      'visits':{
        'id':'visits',
        'titleWording':{'en':'Reservation','nl':'Reservatie','fr':'Reservation'},
        'newWording':{'en':'New reservation','nl':'Nieuwe reservatie','fr':'Nouveau reservation'},
        'notFoundWording':{'en':'No reservations found','nl':'Geen bedrijven gevonden','fr':'Aucune reservation trouv\u00E9'},
        'onClickNew':function() {
          parentModel.previousSearchTerm=model.previousSearchTerm;
          $scope.onCreateVisit();
        },
        'searchResultName':'visits',
        'table':'visits',
        'limit':'visitSearchLimit',
        'search':$scope.searchVisits,
        'searchModel':'searchVisits',
        'first':3
      },
    }
  });
  webservice.afterLogin().then(function() {
    $scope.init();
    model.searchOptions[(angular.isDefined(parentModel[selectedName+'Contact']) && parentModel[selectedName+'Contact'].iscompany=='1')?'companies':'contacts'].first=0;
  });

}]);

angular.module("app").directive('outdoorSearchContacts',function () {
  return {
    replace: true,
    scope: {
      parentModel:'=',
      selectedName:'<',
      onUpdateSelection:'&',
      onCreateContact:'&',
      onCreateCompany:'&',
      onCreateVisit:'&',
      task:'<',
      searchCompanies:'<',
      searchContacts:'<',
      searchVisits:'<',
      customClass:'<'
    },
    templateUrl: 'app/modules/contacts/searchContactsComponent.html',
    controller: 'ContactsSearchContactsComponentController'
  };
});

angular.module("app").controller("ContactsRetrieveController",["$scope","$window","$stateParams","$timeout","$document","tools","modelstore","parameters","activitiesService","contactsService","webservice","errorlog","user",
                                            function($scope,$window,$stateParams,$timeout,$document,tools,modelstore,parameters,activitiesService,contactsService,webservice,errorlog,user) {

  $scope.contactsService=contactsService;
  $scope.tools=tools;
  var script='contacts/retrieve';
  var model=modelstore.getModel(script);
  $scope.model=model;

  $scope.load = function() {
    modelstore.cleanModel(["contacts","contactcreditcards","contactexternalids","visits"],model);
    var contactId=$stateParams.id.replace(/[^0-9]/g,"");
    webservice.exclusiveCall("load",{"contactId":contactId},script,model).then(function(response) {
      if(response) {
        model.retrieveContact=model.contacts[contactId];
        var countryCallingCodeRegex=/^\+((1-)?[0-9]{1,3})\(0\)([\s\S]*)/;
        var contactcountryCallingCodeMatches=model.retrieveContact.gsm.match(countryCallingCodeRegex);
        model.retrieveContact.countryCallingCode='';
        model.retrieveContact.number=model.retrieveContact.gsm;
        model.retrieveContact.prettyGsm=model.retrieveContact.number;
        if(contactcountryCallingCodeMatches!==null) {
          if(angular.isDefined(contactcountryCallingCodeMatches[1])) {
            model.retrieveContact.countryCallingCode=contactcountryCallingCodeMatches[1];
            if(Number(model.retrieveContact.countryCallingCode)!==NaN) {
              model.retrieveContact.countryCallingCode=Number(model.retrieveContact.countryCallingCode);
            }
          }
          if(angular.isDefined(contactcountryCallingCodeMatches[3])) {
            model.retrieveContact.number=contactcountryCallingCodeMatches[3];
          }
        }
        if(model.retrieveContact.country!=='' && model.retrieveContact.countryCallingCode==='') {
          model.retrieveContact.countryCallingCode=tools.first(parameters.countries[model.retrieveContact.country].countryCallingCodes);
        }
        if(model.retrieveContact.countryCallingCode!=='') {
          model.retrieveContact.prettyGsm='+'+model.retrieveContact.countryCallingCode+model.retrieveContact.number;
        }
        model.retrieveContact.created=true;
        model.task='r';
        model.contactcreditcard={'unencryptedCardnumber':''}
        for(var i in model.contactcreditcards) {
          model.contactcreditcards[i].show=false;
        }
        model.mergeContact={'id':'0'};
      } else {
        model.retrieveContact={};
        model.mergeContact={};
      }
    });
  };

  $scope.userCanViewCreditcardnumbers = function() {
    return user.hasRight('CNTCC');
  };

  $scope.update = function() {
    webservice.exclusiveCall('updateContact',{'contact':model.contact},'contacts/contactComponent',model).then(function(response) {
      $scope.load();
    });
  };

  $scope.resetMergeContact = function() {
    if(model.retrieveContact.id!=model.mergeContact.id) {
      modelstore.removeRecord("contacts",model.mergeContact.id,model);
    }
    model.mergeContact={'id':'0'};
  };

  $scope.mergeContacts = function() {
    if(model.mergeContact.id==='0' || model.retrieveContact.id==='0') {
      errorlog.error(tools.lang({'en':'Please add a client for merge.','nl':'Voeg een klant toe om samen te voegen.','fr':'Ajoutez un client pour fusionner.'}))
    } else {
      webservice.confirmModal(tools.lang({'en':'Are you sure to merge these profiles? This action can\u0027t be cancelled.','nl':'Ben je zeker om deze profielen samen te voegen? Deze actie kan niet geanulleerd worden.','fr':'Voulez-vous vraiment fusionner ces profils ? Cette action ne peut pas \u00EAtre annul\u00E9e.'})).then(function() {
        webservice.exclusiveCall('mergeContacts',{'sourceContactId':model.retrieveContact.id,'targetContactId':model.mergeContact.id},'contacts/retrieve',model).then(function(response) {
          if(response) {
            $scope.contactRetrieve(model.mergeContact.id);
          } else {
            $scope.load();
          }
        });
      });
    }
  };

  $scope.contactHasAccountingExternalids = function() {
    var result=false;
    if(angular.isDefined(model.retrieveContact)) {
      result=tools.match(model.contactexternalids,{'contact':model.retrieveContact.id}).reduce(function(acc,contactexternalid) {
        return acc || contactexternalid.partner.substr(0,3)=='ACC';
      },false);
    }
    return result;
  };

  $scope.getCreditcardYears = function() {
    var result=[];
    var currentYear=new Date().getFullYear();
    for(var i=0;i<20;i++) {
      result.push(String(currentYear+i));
    }
    return result;
  };

  $scope.getCreditCardType = function(creditCardNumber) { 
    var result="unknown";
    if(/^5[1-5]|^222[1-9]|^22[3-9]|^2[3-6]|^27[01]|^2720/.test(creditCardNumber)) {
      result="mastercard";
    } else if(/^4/.test(creditCardNumber)) {
      result="visa";
    } else if(/^3[47]/.test(creditCardNumber)) {
      result="amex";
    }
    return result;
  }

  $scope.getMaskType = function(cardType) {
    var masks={
      'mastercard':{'gaps':[4,8,12,16]},
      'visa':{'gaps':[4,8,12,16,19]},
      'amex':{'gaps':[4,10,15]},
      'unknown':{'gaps':[4,8,12,16]}
    };
    return masks[cardType];
  }

  $scope.formatCreditCard = function() {
    if(angular.isDefined(model.contactcreditcard.unencryptedCardnumber) && model.contactcreditcard.unencryptedCardnumber!=='') {
      var cardnumber=model.contactcreditcard.unencryptedCardnumber.replace(/[^\d]/g,'');
      var cardType=$scope.getCreditCardType(cardnumber);
      var gapPossitions=$scope.getMaskType(cardType).gaps.filter(function(gap) {
        return gap<tools.getLength(cardnumber);
      },[]);
      var i,regex;
      for(i=0;i<tools.getLength(gapPossitions);i++) {
        regex=new RegExp('(.{'+(gapPossitions[i]+i)+'})');
        cardnumber=cardnumber.replace(regex,'$1 ');
      }
      model.contactcreditcard.unencryptedCardnumber=cardnumber;
    }
  }

  $scope.addContactcreditcard = function() {
    var contactcreditcard=tools.clone(model.contactcreditcard);
    contactcreditcard.contact=model.retrieveContact.id;
    contactcreditcard.expirydate=tools.dateFromJava(new Date(model.contactcreditcard.expiryyear,model.contactcreditcard.expirymonth),0);
    webservice.exclusiveCall('updateContact',{'contact':model.retrieveContact,'contactcreditcards':[contactcreditcard]},'contacts/contactComponent',model).then(function(response) {
      $scope.load();
    });
  }

  $scope.tempShow = function(creditcard,fieldName) {
    creditcard[fieldName]=true;
    $timeout(function() {
      creditcard[fieldName]=false;
    },15000);
  };

  $scope.copyToClipboard = function(text) {
    var copyElement = document.createElement("span");
    copyElement.appendChild(document.createTextNode(text));
    copyElement.id = 'tempCopyToClipboard';
    angular.element(document.body.append(copyElement));
    var range = document.createRange();
    range.selectNode(copyElement);
    $window.getSelection().removeAllRanges();
    $window.getSelection().addRange(range);
    document.execCommand('copy');
    $window.getSelection().removeAllRanges();
    copyElement.remove();
  };

  tools.initAttributes(model,{
    'retrieveContact':{},
    'mergeContact':{'id':'0'},
    'searchTerm':''
  });

  webservice.afterLogin().then(function() {
    $scope.load();
  });
  
}]);
angular.module("app").component('reservationsComponent',{
  templateUrl: 'app/modules/contacts/reservationsComponent.html',
  bindings: {
    visits:'<',
    visitRetrieve:'<',
    contacts:'<',
    contactRetrieve:'<',
    task:'<'
  },
  controller:function(tools,parameters,contactsService) {
    var ctrl=this;
    ctrl.tools=tools;
    ctrl.parameters=parameters;
    ctrl.contactsService=contactsService;

    ctrl.getReservations = function() {
      var result=[];
      for(var i in ctrl.visits) {
        var visit=ctrl.visits[i];
        if((visit.enddate>=tools.dateToJava(tools.today()) && ctrl.task=='future') || (visit.enddate<tools.dateToJava(tools.today()) && ctrl.task=='past')) {
          result.push(visit);
        }
      }
      return result;
    }
  }
});
var contactsService=function(tools,modelstore,user) {
  this.tools=tools;
  this.modelstore=modelstore;
  this.user=user;
};

contactsService.prototype.getName = function(contact) {
  return contact?(contact.firstname!==''?contact.firstname+' ':'')+contact.name:'';
};

contactsService.prototype.initContacts = function(model,owningContact,communicationContact) {
  model.visit=('visit' in model)?model.visit:{};
  var defaultVisit=('defaultVisit' in model)?model.defaultVisit:model.visit;
  var defaultIsCompany=('defaultIsCompany' in model)?model.defaultIsCompany:'0';
  model.newOwningContact={
    'id':this.tools.getMinIdMinusOne(model.contacts),
    'firstname':'',
    'name':'',
    'gsm':'',
    'email':'',
    'country':'BE',
    'countryCallingCode':32,
    'number':'',
    'address1':'',
    'postalcode':'',
    'address2':'',
    'lang':this.user.lang,
    'agreestomarketing':'0',
    'sal':'',
    'iscompany':defaultIsCompany,
    'vatnumber':'',
    'isOpen':true,
    'editing':true,
    'advancedAttributes':false,
    'hasNoInvoicesOrMovements':true
  };
  this.modelstore.addRecord("contacts",model.newOwningContact,model);
  if(angular.isDefined(owningContact)) {
    this.modelstore.addRecord("contacts",owningContact,model);
    model.existingOwningContact=owningContact;
    model.owningContact=model.existingOwningContact;
  } else if('owningcontact' in defaultVisit && angular.isDefined(model.contacts[defaultVisit.owningcontact])) {
    model.existingOwningContact=model.contacts[defaultVisit.owningcontact];
    model.owningContact=model.existingOwningContact;
  } else {
    model.existingOwningContact={'id':'0','iscompany':defaultIsCompany};
    model.owningContact=model.existingOwningContact;
  }
  model.newCommunicationContact={
    'id':this.tools.getMinIdMinusOne(model.contacts),
    'firstname':'',
    'name':'',
    'gsm':'',
    'email':'',
    'country':'BE',
    'countryCallingCode':32,
    'number':'',
    'address1':'',
    'postalcode':'',
    'address2':'',
    'lang':this.user.lang,
    'agreestomarketing':'0',
    'sal':'',
    'iscompany':'0',
    'isOpen':true,
    'editing':true,
    'advancedAttributes':false,
    'hasNoInvoicesOrMovements':true
  };
  this.modelstore.addRecord("contacts",model.newCommunicationContact,model);
  model.dummyCommunicationContact={'id':'0','dummy':true};
  if(angular.isDefined(communicationContact)) {
    this.modelstore.addRecord("contacts",communicationContact,model);
    model.existingCommunicationContact=this.tools.clone(communicationContact);
  } else if('communicationcontact' in defaultVisit && angular.isDefined(model.contacts[defaultVisit.communicationcontact])) {
    model.existingCommunicationContact=this.tools.clone(model.contacts[defaultVisit.communicationcontact]);
  } else {
    model.existingCommunicationContact={'id':'0'};
  }
  model.communicationContact=model.owningContact.iscompany=='0'?model.dummyCommunicationContact:model.existingCommunicationContact;
};

angular.module("app").service("contactsService",['tools','modelstore','user',contactsService]);

'use strict';

angular.module("app").controller("ContactsContactComponentController",["$scope","tools","parameters","config","user","modelstore","webservice","contactsService",
                                            function($scope,tools,parameters,config,user,modelstore,webservice,contactsService) {
  $scope.tools=tools;
  $scope.parameters=parameters;
  $scope.config=config;
  $scope.user=user;
  $scope.contactsService=contactsService;
  var model=$scope.model;
  var contactName=$scope.contactName;

  $scope.empty = {'id':'','labelen':'Undefined','labelnl':'Ongedefinieerd','labelfr':'Indefini'};

  $scope.selectContact = function(newOrExisting,isCompany) {
    if(angular.isDefined(model[contactName+'Contact']) && angular.isUndefined(model[contactName+'Contact'].dummy) && angular.isDefined(model[newOrExisting+contactName.charAt(0).toUpperCase()+contactName.slice(1)+'Contact'])) {
      var contact;
      if(newOrExisting=='new') {
        model[contactName+'Contact']=model[newOrExisting+contactName.charAt(0).toUpperCase()+contactName.slice(1)+'Contact'];
        contact=model[contactName+'Contact'];
        contact.name=model.previousSearchTerm.charAt(0).toUpperCase()+model.previousSearchTerm.slice(1);
        contact.advancedAttributes=isCompany;
        contact.iscompany=isCompany?'1':'0';
      } else {
        contact=model[contactName+'Contact'];
        if(angular.isUndefined(contact.hasNoInvoicesOrMovements) && contact.id!=='0') {
          webservice.call('contactHasNoInvoicesOrMovements',{'contact':model[contactName+'Contact']},'contacts/contactComponent',model).then(function(response) {
            contact.hasNoInvoicesOrMovements=response;
          });
        }
        contact.advancedAttributes=contact.address1!='' || contact.address2!='' || contact.iscompany!='0';
        var countryCallingCodeRegex=/^\+((1-)?[0-9]{1,3})\(0\)([\s\S]*)/;
        var contactcountryCallingCodeMatches=contact.gsm.match(countryCallingCodeRegex);
        contact.countryCallingCode='';
        contact.number=contact.gsm;
        contact.prettyGsm=contact.number;
        if(contactcountryCallingCodeMatches!==null) {
          if(angular.isDefined(contactcountryCallingCodeMatches[1])) {
            contact.countryCallingCode=contactcountryCallingCodeMatches[1];
            if(Number(contact.countryCallingCode)!==NaN) {
              contact.countryCallingCode=Number(contact.countryCallingCode);
            }
          }
          if(angular.isDefined(contactcountryCallingCodeMatches[3])) {
            contact.number=contactcountryCallingCodeMatches[3];
          }
        }
        $scope.setContactGsmAndCountry();
        if(model.task==='u') {
          $scope.onUpdate();
        }
      }
      $scope.changeIscompany();
      model.visit[contactName+'contact']=contact.id;
    }
  };

  $scope.changeIscompany = function() {
    if(contactName=='owning') {
      if(model.owningContact.iscompany=='0') {
        model.communicationContact=model.dummyCommunicationContact;
      } else {
        model.communicationContact=model.existingCommunicationContact;
        model.owningContact.firstname="";
      }
      model.visit.owningcontact=model.owningContact.id;
      model.visit.communicationcontact=model.communicationContact.id;
    }
  };

  $scope.setContactGsmAndCountry = function() {
    var contact=model[contactName+'Contact'];
    if(tools.getLength(tools.match(parameters.countryCallingCodes,{'countryCallingCode':contact.countryCallingCode}))===1 && contact.country==='') {
      contact.country=tools.first(tools.match(parameters.countryCallingCodes,{'countryCallingCode':contact.countryCallingCode})).id;
    }
    if(angular.isDefined(parameters.countryCallingCodes[contact.country]) && contact.countryCallingCode=='') {

    }
    if(contact.countryCallingCode==='') {
      contact.gsm=contact.number;
      contact.prettyGsm=contact.number;
    } else {
      contact.gsm=(contact.number==='')?'':('+'+contact.countryCallingCode+'(0)'+contact.number);
      contact.prettyGsm='+'+contact.countryCallingCode+contact.number;
    }
  };

  $scope.startContactEdit = function() {
    var contact=model[contactName+'Contact'];
    model.backupContacts[contactName]=tools.clone(contact);
    if(!contact.isOpen) {
      contact.isOpen=true;
    }
    contact.editing=true;
    model.task='u';
    contact.advancedAttributes=contact.address1!='' || contact.address2!='' || contact.iscompany!='0';
  }

  $scope.deleteContact = function() {
    var contact=model[contactName+'Contact'];
    model.backupContacts[contactName]=tools.clone(contact);
    modelstore.removeRecord("contacts",contact.id,model);
    model[contactName+'Contact']={'id':'0','iscompany':(contactName=='owning' && 'defaultIsCompany' in model)?$scope.model.defaultIsCompany:'0'};
    $scope.changeIscompany();
    if(model.task!='c' && model.task!='t') {
      model.task='u';
    }
  }

  $scope.cancelContactEdit = function() {
    modelstore.removeRecord("contacts",model[contactName+'Contact'].id,model);
    model[contactName+'Contact']=model.backupContacts[contactName];
    modelstore.addRecord("contacts",model[contactName+'Contact'],model);
    model.task='r';
  };

  $scope.updateContact = function() {
    webservice.exclusiveCall('updateContact',{'contact':model[contactName+'Contact']},'contacts/contactComponent',model).then(function(response) {
      model.task='r';
      if(response) {
        model[contactName+'Contact']=response
        var contact=model[contactName+'Contact'];
        contact.editing=false;
        contact.isOpen=false;
        $scope.onUpdate();
      }
    });
  };

  $scope.selectAnonymousContact = function() {
    webservice.exclusiveCall('getAnonymousContact',{},'contacts/contactComponent',model).then(function(response) {
      if(response) {
        model[contactName+'Contact']=response;
        $scope.selectContact('existing');
      }
    });
  };

  tools.initAttributes(model,{
    'backupContacts':{}
  });

}]);

angular.module("app").directive('outdoorContact',function () {
  return {
    replace: true,
    scope: {
      model:'=',
      contactName:'@',
      contactWording:'<',
      contactReadonly:'<',
      contactIsEditable:'<',
      onUpdate:'&',
      contactIsChangeable:'<',
      contactRetrieve:'<'
    },
    templateUrl: 'app/modules/contacts/contactComponent.html',
    controller: 'ContactsContactComponentController'
  };
});

'use strict';
var cashlessWrapper = function($q,$timeout,parameters,webservice,tools,errorlog) {
  this.$q=$q;
  this.$timeout=$timeout;
  this.parameters=parameters;
  this.webservice=webservice;
  this.tools=tools;
  this.errorlog=errorlog;
  this.script='cashless/cashless';
  this.claimedMachine=null;
  this.status='idle';
  this.setstatusPromise=null;
  this.verifyPromise=null;
  this.saleModel=null;
  this.cashlesspayment=null;
  this.saleDeferred=null;
};

cashlessWrapper.prototype.selectSingleMachine = function() {
  if(this.claimedMachine==null && ('cashlessMachines' in this.parameters) && this.parameters.cashlessMachines.length==1) {
    this.claimedMachine=this.parameters.cashlessMachines[0];
  }
};

cashlessWrapper.prototype.start = function(visitId,amount,saleModel) {
  var cashless=this;
  cashless.setstatus('starting');
  cashless.saleModel=saleModel;
  var paymentIsStarted=cashless.$q.defer();
  cashless.webservice.exclusiveCall(
    'start',
    {'visitId':visitId,'amount':amount,'machineId':cashless.claimedMachine.id},
    cashless.script,
    saleModel
  ).then(function(response) {
    if(response.hasPendingTransactions) {
      cashless.webservice.confirmModal(cashless.tools.lang({
        'en':'This machine has pending transactions. Do you wish to cancel them?',
        'nl':'Deze machine heeft lopende transacties. Wil je ze annuleren?',
        'fr':'Cette machine a des transactions en traitement. Voulez vous les annuler?'
      }),cashless.tools.lang({'en':'Yes','nl':'Ja','fr':'Oui'}),cashless.tools.lang({'en':'No','nl':'Nee','fr':'Non'})).then(function() {
        cashless.webservice.exclusiveCall(
          'cancelAndStart',
          {'visitId':visitId,'amount':amount,'machineId':cashless.claimedMachine.id},
          cashless.script,
          saleModel
        ).then(function(response) {
          paymentIsStarted.resolve(response);
        });
      },function() {
        cashless.setstatus('idle');
        paymentIsStarted.reject();
      });
    } else {
      paymentIsStarted.resolve(response);
    }
  }, function() {
    cashless.setstatus('idle');
    paymentIsStarted.reject();
  });
  return paymentIsStarted.promise.then(function(response) {
    return cashless.trackPayment(saleModel,response.cashlesspaymentId);
  });
};

cashlessWrapper.prototype.trackPayment = function(saleModel,cashlesspaymentId) {
  var cashless=this;
  cashless.saleModel=saleModel;
  cashless.cashlesspayment=cashless.saleModel.cashlesspayments[cashlesspaymentId];
  cashless.setstatus('verifying',6000000);
  cashless.saleDeferred=cashless.$q.defer();
  cashless.verify();
  return cashless.saleDeferred.promise;
};

cashlessWrapper.prototype.verify = function() {
  var cashless=this;
  if(cashless.verifyPromise!==null) {
    cashless.$timeout.cancel(cashless.verifyPromise);
    cashless.verifyPromise=null;
  }
  if(cashless.status==='verifying') {
    cashless.webservice.call('verify',{'cashlesspaymentId':cashless.cashlesspayment.id},cashless.script,cashless.saleModel).then(function(response) {
      if(response!==false) {
        cashless.cashlesspayment=cashless.saleModel.cashlesspayments[response.cashlesspaymentId];
        if(cashless.cashlesspayment.stat==9000) {
          cashless.setstatus('idle');
          cashless.saleDeferred.resolve();
        } else if(cashless.cashlesspayment.stat==9100) {
          if(cashless.status==='verifying') {
            cashless.errorlog.error(cashless.tools.lang({'en':'Payment cancelled','nl':'Betaling geannuleerd','fr':'Paiement annul\u00E9'}));
          }
          cashless.setstatus('idle');
        }
      }
      if(cashless.verifyPromise!==null) {
        cashless.$timeout.cancel(cashless.verifyPromise);
        cashless.verifyPromise=null;
      }
      if(cashless.status==='verifying') {
        cashless.verifyPromise=cashless.$timeout(function() {
          cashless.verify();
        },2000);
      } else if(cashless.status==='cancelling') {
        cashless._cancel();
      }
    });
  } else if(cashless.status==='cancelling') {
    cashless._cancel();
  }
};

cashlessWrapper.prototype.singleVerify = function(saleModel) {
  var cashless=this;
  cashless.saleModel=saleModel;
  cashless.setstatus('singleVerify',10000);
  return cashless.webservice.call('singleVerify',{},cashless.script,cashless.saleModel).then(function(response) {
    cashless.setstatus('idle');
    return response;
  });
};

cashlessWrapper.prototype.cancel = function() {
  var cashless=this;
  cashless.setstatus('cancelling',7000);
};

cashlessWrapper.prototype._cancel = function() {
  var cashless=this;
  cashless.webservice.call(
    'cancel',
    {'cashlesspaymentId':cashless.cashlesspayment.id},
    cashless.script,
    cashless.saleModel
  ).then(function(response) {
    cashless.setstatus('idle');
  });
};

cashlessWrapper.prototype.setstatus = function(status,time) {
  var cashless=this;
  if(angular.isUndefined(time)) {
    time=45000;
  }
  if(cashless.setstatusPromise!==null) {
    cashless.$timeout.cancel(cashless.setstatusPromise);
    cashless.setstatusPromise=null;
  }
  cashless.status=status;
  if(status!=='idle') {
    cashless.setstatusPromise=cashless.$timeout(function() {
      cashless.setstatus('idle');
    },time);
  }
};

angular.module('app').service('cashless',['$q','$timeout','parameters','webservice','tools','errorlog',cashlessWrapper]);

angular.module("app").controller("BarBarController",["$scope","tools","modelstore","user","parameters","webservice",
                                            function($scope,tools,modelstore,user,parameters,webservice) {

  var script="bar/bar";
  var model=modelstore.getModel(script);
  $scope.model=model;
  
  $scope.initOrder = function() {
    model.orderStd={};
    model.orderFree={};
  };
  
  $scope.initFreeLine = function() {
    model.freeLine={
      "name":tools.lang({'en':'Other','nl':'Diverse','fr':'Divers'}),
      "amount":"1"
    };
  };
  
  $scope.consumptionFilter = function(con) {
    var result=[];
    if(con) {
      for(var i in parameters.notDelBAR) {
        if(i.substr(0,3)==con.id) {
          result.push(parameters.BAR[i]);
        }
      }
    }
    return result;
  };
  
  $scope.addToOrderStd = function(bar){
    if(bar.id in model.orderStd) {
      var orderStd=model.orderStd[bar.id];
      orderStd.number=tools.numberIn(orderStd.number)+1;
    } else {
      model.orderStd[bar.id]={
        "consumption":bar.id,
        "number":1
      };
    }
  };
  
  $scope.removeFromOrderStd = function(orderRow) {
    delete model.orderStd[orderRow.consumption];
  };
  
  $scope.addToOrderFree = function() {
    model.freeLine.id=tools.getMinIdMinusOne(model.orderFree);
    model.orderFree[model.freeLine.id]=model.freeLine;
    $scope.initFreeLine();
  };
  
  $scope.removeFromOrderFree = function(orderFree) {
    delete model.orderFree[orderFree.id];
  };
  
  $scope.createOrderMovement = function() {
    $scope.createOrderOrTabMovement(model.orderStd,model.orderFree).then(function(response) {
      if(response) {
        $scope.initOrder();
      }
    });
  };
  
  $scope.settleTab = function(tab) {
    var tabstdlines=tools.join(tab,'tabstdlines',model);
    var tabfreelines=tools.join(tab,'tabfreelines',model);
    webservice.call("settleTab",{
      "amount":$scope.calculateOrderSum(tabstdlines,tabfreelines),
      "comment":$scope.buildComment(tabstdlines, tabfreelines),
      "tabId":tab.id
    },script,model);
  };
  
  $scope.calculateOrderSum = function(orderStd, orderFree) {
    var amount=tools.sum(orderFree,'amount');
    for(var i in orderStd) {
      if(orderStd[i].consumption in parameters.BAR) {
        amount+=orderStd[i].number*tools.amountIn(parameters.BAR[orderStd[i].consumption].field1);
      }
    }
    return tools.amountOut(amount);
  };
  
  $scope.buildComment = function(orderStd, orderFree) {
    var comment="";
    var i;
    for(i in orderStd) {
      comment+=" "+orderStd[i].number+" "+tools.label(parameters.BAR[orderStd[i].consumption]);
    }
    for(i in orderFree) {
      comment+=" "+orderFree[i].name;
      break;
    }
    comment=comment.substr(1);
    return comment;
  };
  
  $scope.createOrderOrTabMovement = function(orderStd, orderFree) {
    return webservice.call('movementCreate',{
      "amount":$scope.calculateOrderSum(orderStd, orderFree),
      "comment":$scope.buildComment(orderStd, orderFree)
    },script,model);
  };
  
  $scope.createTab = function() {
    webservice.call('createTab',{
      'tab':tools.whitelist(model.newtab,['name']),
      'tabstdlines':tools.whitelist(tools.toArray(model.orderStd),['consumption','number']),
      'tabfreelines':tools.whitelist(tools.toArray(model.orderFree),['name','amount'])
    },script,model).then(function(response) {
      if(response) {
        $scope.initOrder();
      }
    });
  };
  
  $scope.addToTab = function(tab) {
    webservice.call('addToTab',{
      'tabId':tab.id,
      'tabstdlines':tools.whitelist(tools.toArray(model.orderStd),['consumption','number']),
      'tabfreelines':tools.whitelist(tools.toArray(model.orderFree),['name','amount'])
    },script,model).then(function(response) {
      if(response) {
        $scope.initOrder();
      }
    });
  };
  
  /*
  labelstore.add({
    'other':,
    'settle':,
    'newTab':,
    'addToTab':,
    'settleTab':,
    'total':
  });
  */
  
  $scope.load = function() {
    webservice.call("load",{},script,model);
  }

  tools.initAttributes(model,{
    "newtab":{"name":""},
    'incrementButtons':[1,2,5,10]
  });
  if(!("orderStd" in model)) {
    $scope.initOrder();
  }
  if(!("freeLine" in model)) {
    $scope.initFreeLine();
  }
  webservice.afterLogin().then(function() {
    $scope.load();
  });
  
}]);
angular.module("app").controller("AssignModalController",["$scope","$uibModalInstance","$sce","errorlog","tools","visit","contacts","rights","users","script","webservice",
                                                function($scope,$uibModalInstance,$sce,errorlog,tools,visit,contacts,rights,users,script,webservice) {

  $scope.tools=tools;
  $scope.visit=visit;
  $scope.contacts=contacts;
  var script=script;
  var model={};
  $scope.model=model;
  model.users=users;
  model.rights=rights;
  if (visit.operationsmanager === '0') {
    model.operationsmanager='0';
  } else {
    model.operationsmanager=visit.operationsmanager;
  }
  if (visit.invoicesmanager === '0') {
    model.invoicesmanager='0';
  } else {
    model.invoicesmanager=visit.invoicesmanager;
  }

  $scope.selectedOperationsManager = function() {
    visit.operationsmanager=model.operationsmanager;
  };

  $scope.selectedInvoicesManager = function() {
    visit.invoicesmanager=model.invoicesmanager;
  };

  $scope.ok = function() {
    if(visit.operationsmanager==='0' && model.operationsmanager!==visit.quotationmanager) {
      errorlog.warning(tools.lang({'en':'The operationsmanager is not set','nl':'Geen dossier verantwoordelijke toegewezen','fr':'Pas attribuer responsable dossier'}));
    } else if(visit.invoicesmanager==='0' && model.invoicesmanager!==visit.quotationmanager) {
      errorlog.warning(tools.lang({'en':'The invoicesmanager is not set','nl':'Geen facturatie verantwoordelijke toegewezen','fr':'Pas attribuer responsable facturation'}));      
    } else {
      webservice.exclusiveCall('validateAssignment',{
        'visit':$scope.visit
      },script,model).then(function() {
      $uibModalInstance.close();
    });
    }
  };

  $scope.cancel = function() {
    $uibModalInstance.dismiss();
  };

}]);

angular.module("app").controller("AcceptAssignModalController",["$scope","$uibModalInstance","$sce","errorlog","tools","visit","contacts","readonly","quotationmanager","rights","users","script","preparedTemplate","webservice",
                                                function($scope,$uibModalInstance,$sce,errorlog,tools,visit,contacts,readonly,quotationmanager,rights,users,script,preparedTemplate,webservice) {

  $scope.fromMailOptions=preparedTemplate.fromMailOptions;
  $scope.fromMail=preparedTemplate.fromMailOptions[0];
  $scope.recipient=preparedTemplate.recipient;
  $scope.subject=preparedTemplate.subject;
  $scope.readonly=!readonly;
  $scope.cc=[];
  $scope.addCc='';
  $scope.showCc=!readonly && $scope.cc!=tools.getLength($scope.cc)>0;
  $scope.bcc=[];
  $scope.addBcc='';
  $scope.showBcc=!readonly && $scope.bcc!=tools.getLength($scope.cc)>0;
  $scope.quotationManagerInfo=preparedTemplate.placeholders.quotationManagerInfo;
  $scope.operationsManagerInfo=preparedTemplate.placeholders.operationsManagerInfo;
  $scope.invoicesManagerInfo=preparedTemplate.placeholders.invoicesManagerInfo;
  $scope.tools=tools;
  $scope.visit=visit;
  $scope.contacts=contacts;
  var script=script;
  var model={};
  $scope.model=model;
  model.users=users;
  model.rights=rights;
  model.sendMail=readonly;
  model.body=preparedTemplate.body;
  model.quotationmanager=quotationmanager;
  if (visit.operationsmanager === '0') {
    model.operationsmanager='0';
  } else {
    model.operationsmanager=visit.operationsmanager;
  }
  if (visit.invoicesmanager === '0') {
    model.invoicesmanager='0';
  } else {
    model.invoicesmanager=visit.invoicesmanager;
  }

  $scope.renderHtml = function(html_code) {
    return $sce.trustAsHtml(html_code);
  };

  $scope.hasSelectedMail = function() {
    $scope.sendMail=model.sendMail;
    $scope.readonly=!model.sendMail;
  }

  $scope.addMail = function(mail,recipientType,to,showError) {
    if(angular.isDefined(mail) && mail!=='' && to.indexOf(mail)<0) {
      to[to.length]=mail;
      $scope['add'+recipientType]='';
    } else if(showError) {
      if(mail==='') {
        errorlog.warning(tools.lang({'en':'Please enter an email address','nl':'Geef een emailadres in','fr':'Ajouter une adresse mail'}));
      } else if(angular.isUndefined(mail)) {
        errorlog.error(tools.lang({'en':'Invalid email address','nl':'Ongeldig emailadres','fr':'Adresse mail invalide'}));
      } else {
        errorlog.error(tools.lang({'en':'Already added this email address','nl':'Emailadres alreeds toegevoegd','fr':'Adresse mail d\u00E9j\u00E0 ajouter'}));
      }
    }
  }

  $scope.deleteMail = function(mail,from) {
    if(from.indexOf(mail)>=0) {
      from.splice(from.indexOf(mail),1);
    }
  }

  $scope.ok = function() {
    $scope.addMail($scope.addCc,'Cc',$scope.cc,false);
    $scope.addMail($scope.addBcc,'Bcc',$scope.bcc,false);
    if(visit.operationsmanager==='0' && model.operationsmanager!==visit.quotationmanager) {
      errorlog.warning(tools.lang({'en':'The operationsmanager is not set','nl':'Geen dossier verantwoordelijke toegewezen','fr':'Pas attribuer responsable dossier'}));
    } else if(visit.invoicesmanager==='0' && model.invoicesmanager!==visit.quotationmanager) {
      errorlog.warning(tools.lang({'en':'The invoicesmanager is not set','nl':'Geen facturatie verantwoordelijke toegewezen','fr':'Pas attribuer responsable facturation'}));      
    } else {
      var body=model.body.trim().replace(/\r?\n/g, '<br />')+'<br />'+$scope.operationsManagerInfo+$scope.quotationManagerInfo;
      webservice.exclusiveCall('sendAssignmentMail',{
        'visit':$scope.visit,
        'sendMail':model.sendMail,        
        'fromMail':$scope.fromMail,
        'recipient':$scope.recipient,
        'cc':$scope.cc,
        'bcc':$scope.bcc,
        'subject':$scope.subject,
        'body':body
      },script,model).then(function() {
      $uibModalInstance.close();
    });
    }
  };

  $scope.cancel = function() {
    $uibModalInstance.dismiss();
  };

}]);

angular.module("app").controller("AgendaReservationsController",["$scope","tools","modelstore","parameters","activitiesService","webservice",
                                            function($scope,tools,modelstore,parameters,activitiesService,webservice) {

  $scope.activitiesService=activitiesService;
  var script='agenda/reservations';
  var model=modelstore.getModel(script);
  $scope.model=model;

  $scope.load = function() {
    if(tools.validateAndUpdateDates(model)) {
      modelstore.cleanModel(["visits","activities","participants","meals","dishes","items"],model);
      model.lines=[];
      webservice.exclusiveCall("load",{
        'startdate':tools.dateFromJava(model.startdate),
        'enddate':tools.dateFromJava(model.enddate),
        'createdStart':tools.dateFromJava(model.filters.creationDate.startdate),
        'createdEnd':tools.dateFromJava(model.filters.creationDate.enddate),
        'viss':tools.getField(model.viss,'id'),
        'showActivities':model.showActivities,
        'frms':tools.getField(model.frms,'id'),
        'showMeals':model.showMeals,
        'ress':tools.getField(model.ress,'id'),
        'showAccomodations':model.showAccomodations,
        'htls':tools.getField(model.htls,'id'),
        'showProducts':model.showProducts,
        'prds':tools.getField(model.prds,'id'),
        'showPrivate':model.showPrivate
      },script,model).then(function() {
        var i,line,j,slts,k,listItems,l,listItem,m,entry;
        for(i in model.lines) {
          line=model.lines[i];
          for(j in line) {
            slts=line[j].slts;
            for(k in slts) {
              listItems=slts[k].listItems;
              for(l in listItems) {
                listItem=listItems[l];
                listItem.name=listItem.name.replace(/\w\S*/g, function(txt){
                    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                }).trim();
                for(m in listItem.entries) {
                  entry=listItem.entries[m];
                  if(entry.cat=='AC') {
                    entry.frm=entry.par;
                  } else if(entry.cat=='ME') {
                    entry.dsh=entry.par;
                  } else if(entry.cat=='HS') {
                    entry.hsc=entry.par;
                  } else if(entry.cat=='PR') {
                    entry.prd=entry.par;
                  }
                }
              }
            }
          }
        }
      });
    }
  };

  $scope.getDayListItems = function(slts) {
    var result=[];
    var i,j,slt,filterdListItems;
    for(i in slts) {
      slt=slts[i];
      filterdListItems=$scope.filterListItems(slt.listItems);
      for(j in filterdListItems) {
        result.push(filterdListItems[j]);
      }
    }
    return result;
  }

  $scope.filterListItems = function(listItems) {
    var result=[];
    var i,j,listItem,entry;
    for(i in listItems) {
      listItem=listItems[i];
      for(j in listItem.entries) {
        entry=listItem.entries[j];
        if(entry.planningquantity>0) {
          result.push(listItem);
          break;
        }
      }
    }
    if(model.filters.name!='') {
      listItems=result;
      result=[];
      var filters=tools.latinise(model.filters.name).split(" ");
      var j,matches,name;
      for(i in listItems) {
        listItem=listItems[i];
        matches=true;
        name=tools.latinise(listItem.name);
        for(j in filters) {
          if(!(name.indexOf(filters[j])>-1)) {
            matches=false;
            break;
          }
        }
        if(matches) {
          result.push(listItem);
        }
      }
    }
    return result;
  };

  $scope.nextFourWeeks = function() {
    model.startdate=tools.dateToJava(tools.today());
    model.enddate=tools.dateToJava(tools.today());
    model.enddate.setDate(model.enddate.getDate()+28);
    $scope.load();
  }

  $scope.increaseWeeks = function(increment) {
    model.startdate=new Date(model.startdate.getTime());
    model.startdate.setDate(model.startdate.getDate()+increment*7);
    var newEnddate=new Date(model.enddate.getTime());
    newEnddate.setDate(newEnddate.getDate()+increment*7);
    model.enddate=newEnddate;
    $scope.load();
  };

  $scope.toggleShowActivities = function() {
    model.showActivities=!model.showActivities;
    //model.showMeals=model.showMeals || !model.showActivities;
  };

  $scope.toggleShowMeals = function() {
    model.showMeals=!model.showMeals;
    //model.showActivities=model.showActivities || !model.showMeals;
  };

  $scope.toggleShowAccomodations = function() {
    model.showAccomodations=!model.showAccomodations;
  };

  $scope.toggleShowProducts = function() {
    model.showProducts=!model.showProducts;
  };

  $scope.clickListItem = function(listItem) {
    if(listItem.id!='P') {
      $scope.visitRetrieve(listItem.id)
    }
  };

  $scope.getLabelCategory = function(category) {
    switch (category) {
      case 'AC':
        return tools.lang({'en':'Activity','nl':'Activiteit','fr':'Activit\u00E9s'});
      case 'ME':
        return tools.lang({'en':'Meal','nl':'Maaltijd','fr':'Repas'});
      case 'HS':
        return tools.lang({'en':'Accomodation','nl':'Accomodatie','fr':'H\u00E9bergement'});
      case 'PR':
        return tools.lang({'en':'Product','nl':'Product','fr':'Produit'});
      default:
        return;
    }
  }

  $scope.days=[
    {'id':'0','en':'Monday','nl':'Maandag','fr':'Lundi'},
    {'id':'1','en':'Tuesday','nl':'Dinsdag','fr':'Mardi'},
    {'id':'2','en':'Wednesday','nl':'Woensdag','fr':'Mercredi'},
    {'id':'3','en':'Thursday','nl':'Donderdag','fr':'Jeudi'},
    {'id':'4','en':'Friday','nl':'Vrijdag','fr':'Vendredi'},
    {'id':'5','en':'Saturday','nl':'Zaterdag','fr':'Samedi'},
    {'id':'6','en':'Sunday','nl':'Zondag','fr':'Dimanche'}
  ];
  if(!("startdate" in model)) {
    tools.initDates(0,28,model);
  }
  tools.initAttributes(model,{
    'startdateOpened':false,
    'enddateOpened':false,
    'dateOptions':{
      maxDate: new Date(2099,11,31),
      minDate: new Date(2000,0,1),
      startingDay: 1
    },
    'lines':[],
    'showActivities':true,
    'viss':[],
    'visOptions':{},
    'visSettings':{
      'scrollable':true,
      'showCheckAll':false,
      'scrollableHeight':'300px',
      'smartButtonMaxItems':2,
      'enableSearch':true,
      'styleActive':true,
      'keyboardControls':true,
      'displayProp':tools.lang({'en':'labelen','nl':'labelnl','fr':'labelfr'})
    },
    'frms':[],
    'frmOptions':{},
    'frmSettings':{
      'scrollable':true,
      'showCheckAll':true,
      'scrollableHeight':'300px',
      'smartButtonMaxItems':2,
      'enableSearch':true,
      'styleActive':true,
      'keyboardControls':true,
      'displayProp':tools.lang({'en':'labelen','nl':'labelnl','fr':'labelfr'}),
      'groupByTextProvider': function(groupValue) {
        var groupKeys=groupValue.split('_');
        return (groupKeys[1]==1?tools.lang({'en':'Deleted ','nl':'Verwijderd ','fr':''}):'')+tools.label(parameters.ACT[groupKeys[0]])+(groupKeys[1]==1?tools.lang({'en':'','nl':'','fr':' supprim\u00E9'}):'');
      }
    },
    'showMeals':false,
    'ress':[],
    'resOptions':{},
    'resSettings':{
      'scrollable':true,
      'showCheckAll':true,
      'scrollableHeight':'300px',
      'smartButtonMaxItems':2,
      'enableSearch':true,
      'styleActive':true,
      'keyboardControls':true,
      'displayProp':tools.lang({'en':'labelen','nl':'labelnl','fr':'labelfr'})
    },
    'showAccomodations':false,
    'htls':[],
    'htlOptions':{},
    'htlSettings':{
      'scrollable':true,
      'showCheckAll':true,
      'scrollableHeight':'300px',
      'smartButtonMaxItems':2,
      'enableSearch':true,
      'styleActive':true,
      'keyboardControls':true,
      'displayProp':tools.lang({'en':'labelen','nl':'labelnl','fr':'labelfr'})
    },
    'showProducts':false,
    'prds':[],
    'prdOptions':{},
    'prdSettings':{
      'scrollable':true,
      'showCheckAll':true,
      'scrollableHeight':'300px',
      'smartButtonMaxItems':2,
      'enableSearch':true,
      'styleActive':true,
      'keyboardControls':true,
      'displayProp':tools.lang({'en':'labelen','nl':'labelnl','fr':'labelfr'})
    },
    'showPrivate':true,
    'displayAgendaMode':true,
    'displayListMode':false,
    'translations':{
      'checkAll':tools.lang({'en':'Check all','nl':'Alles selecteren','fr':'S\u00E9llectioner tout'}),
      'uncheckAll':tools.lang({'en':'Uncheck all','nl':'Alles deselecteren','fr':'D\u00E9s\u00E9llectioner tout'}),
      'selectionCount':tools.lang({'en':'checked','nl':'Geselecteerd','fr':'S\u00E9llectioner'}),
      'searchPlaceholder':tools.lang({'en':'Search...','nl':'Zoek...','fr':'Chercher...'}),
      'buttonDefaultText':tools.lang({'en':'Select','nl':'Selecteer','fr':'S\u00E9llectioner'}),
      'dynamicButtonTextSuffix':tools.lang({'en':'checked','nl':'Geselecteerd','fr':'S\u00E9llectioner'}),
      'selectGroup':tools.lang({'en':'Select All:','nl':'Selecteer Alles:','fr':'S\u00E9llectioner tout:'})
    },
    'filters': {
      'name':'',
      'creationDate':{
        'startdateOpened':false,
        'enddateOpened':false,
        'startdate':'',
        'enddate':''
      },
      'isCollapsed': true,
    }
  });

  webservice.afterLogin().then(function() {
    $scope.load();
    model.visOptions=tools.toArray(parameters.notDelVIS);
    model.frmOptions=parameters.arrayFRM.filter(function(frm) {
      return angular.isDefined(parameters.ACT[frm.id.substr(0,3)]);
    }).map(function(frm) {
      var act=parameters.ACT[frm.id.substr(0,3)];
      var deleted=Math.max(act.del,frm.del)===1;
      frm['actlabelen']=act.labelen+(deleted?' deleted':'');
      frm['actlabelnl']=act.labelnl+(deleted?' verwijderd':'');
      frm['actlabelfr']=act.labelfr+(deleted?' supprim\u00E9':'');
      frm['groupKey']=act.id+'_'+(deleted?'1':'0');
      return frm;
    });
    $scope.model.resOptions=tools.toArray(parameters.notDelRES);
    $scope.model.htlOptions=tools.toArray(parameters.notDelHTL);
    $scope.model.prdOptions=tools.toArray(parameters.notDelPRD);
  });

}]);

angular.module("app").controller("AdminSyncIntegrationsController",["$scope","tools","modelstore","user","parameters","webservice",
                                            function($scope,tools,modelstore,user,parameters,webservice) {
  
  var script="admin/syncIntegrations";
  var model=modelstore.getModel(script);
  $scope.model=model;

  $scope.refreshMewsHotelParams = function(htlId) {
    webservice.call("refreshMewsHotelParams",{'htlId':htlId},script,model).then(function(response) {
      if(response) {
        var i,paramTable;
        var paramTables=['HSC','HRA','HPD'];
        for(i in paramTables) {
          paramTable=paramTables[i];
          parameters.updateParamtable(paramTable,model[paramTable]);
        }
      }
    });
  };
  
  $scope.refreshUntillRsa = function(posId) {
    webservice.call("refreshUntillRsa",{'posId':posId},script,model);
  };

  $scope.syncAllArticles = function(posId) {
    webservice.call("syncAllArticles",{'posId':posId},script,model);
  };

  $scope.init = function() {
    webservice.exclusiveCall("loadUntillPos",{},script,model);
  };

//  tools.initAttributes(model,{});

  webservice.afterLogin().then(function() {
    $scope.init();
  });
}]);
angular.module("app").controller("AdminListTransactionsController",["$scope","tools","modelstore","parameters","webservice",
                                            function($scope,tools,modelstore,parameters,webservice) {
  var script='admin/listTransactions';
  var model=modelstore.getModel(script);
  $scope.model=model;
  $scope.errorMessage=null;

  $scope.load = function() {
    $scope.errorMessage=null;
    model.indexedByTypeTransactions={};
    modelstore.cleanModel(["transactions"],model);
    webservice.exclusiveCall("load",{},script,model).then(function() {
      var transactiontypes={};
      var i,transaction,type;
      for(i in model.transactions) {
        transaction=model.transactions[i];
        transaction.selected=false;
        type=transaction.transactiontype;
        if(!(type in model.indexedByTypeTransactions)) {
          model.indexedByTypeTransactions[transaction.transactiontype]=[];
        }
        if(!(type in model)) {
          model[type]=false;
        }
        model.indexedByTypeTransactions[transaction.transactiontype].push(transaction);
      }
    }).catch(function() {
      $scope.errorMessage=model.lastError;
    });
  };

  $scope.deleteTransaction = function(transaction) {
    return webservice.exclusiveCall("deleteTransaction",{"id":transaction.id},script,model).then($scope.load);
  }

  $scope.relaunchTransaction = function(transaction) {
    return webservice.exclusiveCall("relaunchTransaction",{"id":transaction.id},script,model).then(function(response) {
      if(response==='busy') {
        $scope.relaunchTransaction(transaction);
      } else {
        $scope.load();
      }
    }).catch(function() {
      $scope.load();
    });
  };

  $scope.relaunchSelectedTransactions = function(transactiontype) {
    if(tools.getLength(tools.match(model.transactions,{'selected':true,'transactiontype':transactiontype}))>0) {
      var transaction=tools.first(tools.match(model.transactions,{'selected':true,'transactiontype':transactiontype}));
      webservice.exclusiveCall("relaunchTransaction",{"id":transaction.id},script,model).then(function() {
        modelstore.removeRecord("transactions",transaction.id,model);
        $scope.relaunchSelectedTransactions(transactiontype);
      }).catch(function() {
        $scope.load();
      });
    } else {
      $scope.load();
    }
  };

  $scope.deleteSelectedTransactions = function(transactiontype) {
    if(tools.getLength(tools.match(model.transactions,{'selected':true,'transactiontype':transactiontype}))>0) {
      var transaction=tools.first(tools.match(model.transactions,{'selected':true,'transactiontype':transactiontype}));
      webservice.exclusiveCall("deleteTransaction",{"id":transaction.id},script,model).then(function() {
        modelstore.removeRecord("transactions",transaction.id,model);
        $scope.deleteSelectedTransactions(transactiontype);
      }).catch(function() {
        $scope.load();
      });
    } else {
      $scope.load();
    }
  };

  tools.initAttributes(model,{
    'indexedByTypeTransactions':{},
    'transactions':{}
  });

  webservice.afterLogin().then(function() {
    $scope.load();
  });

  
}]);
angular.module("app").controller("ActivitiesStatisticsController",["$scope","tools","modelstore","user","parameters","webservice",
                                            function($scope,tools,modelstore,user,parameters,webservice) {

  var script="activities/statistics"
  var model=modelstore.getModel(script);
  $scope.model=model;
  
  $scope.load = function() {
    model.loading=true;
    webservice.call("load",{"start":tools.dateFromJava(model.startdate),"end":tools.dateFromJava(model.enddate)},script,model).then(function() {
      model.loading=false;
    });
  };

  if(!("startdateValue" in model)) {
    tools.initDates(-2,0,model);
  }
  tools.initAttributes(model,{
    "loading":false,
    'startdateOpened':false,
    'enddateOpened':false,
    'dateOptions':{
      maxDate: new Date(2099,11,31),
      minDate: new Date(2000,0,1),
      startingDay: 1
    }
  });
  webservice.afterLogin().then(function() {
    $scope.load();
  });
  
}]);
angular.module("app").controller("ActivitiesSearchReferenceController",["$scope","$stateParams","tools","modelstore","parameters","webservice",
                                            function($scope,$stateParams,tools,modelstore,parameters,webservice) {

  var script='activities/searchReference';
  var model=modelstore.getModel(script);
  $scope.model=model;

  $scope.init = function() {
    model.reference='';
    model.exactnumber='';
    model.ogm='';
    model.hasNoResult = false;
  };

  $scope.retrieve = function() {
    webservice.exclusiveCall("search",{'reference':model.reference,'exactnumber':model.exactnumber,'ogm':model.ogm},script,model).then(function(response) {
      if(response!==true) {
        $scope.init();
        if(response.visit) {
          $scope.visitRetrieve(response.visit);
        } else {
          $scope.contactRetrieve(response.contact);
        }
        model.hasNoResult = false;
      } else {
        model.hasNoResult = true;
      }
    });
  };
  $scope.init();

  webservice.afterLogin().then(function() {
    if(angular.isDefined($stateParams.searchElement)) {
      var searchElement=$stateParams.searchElement;
      preg_match('/^\d{3}\.\d{3}$/',$searchString)>0
      $dvsId=preg_replace("/[0-9]/","",$searchString);
      } else if(isset($DVS[$dvsId]) && preg_match('/^\d+$/',substr($searchString,strlen($dvsId)))>0) {
      if(/^\d{3}\.\d{3}$/.test(searchElement) || /^V\d+$/.test(searchElement) || /^C\d+$/.test(searchElement)) {
        model.reference=searchElement;
      } else if(/^\d{12}$|^\+{3}\d{3}\/\d{4}\/\d{5}\+{3}$/.test(searchElement)) {
        model.ogm=searchElement;
      } else if(/^\d+$/.test(searchElement)) {
        model.reference='V'+searchElement;
      } else {
        model.exactnumber=searchElement;
      }
      $scope.retrieve();
    }
  });
  
}]);
angular.module("app").controller("activitiesSearchController",["$scope","$stateParams","tools","modelstore","parameters","webservice","user","activitiesService","contactsService",
                                            function($scope,$stateParams,tools,modelstore,parameters,webservice,user,activitiesService,contactsService) {

  $scope.activitiesService=activitiesService;
  $scope.contactsService=contactsService;
  var script = "activities/search";
  var model=modelstore.getModel(script);
  $scope.model=model;

  $scope.search = function() {
    modelstore.cleanModel(["visits","activities","participants","meals","dishes","hotelreservationcategories","items","elementsWithDate"],model);
    model.elementsWithDate=[];
    var i,j,typeOption,optionViss,optionVis;
    var viss={};
    if(model.anyOriginIsActive) {
      if(model.enablePartners && model.partner!=='') {
        viss[model.partner]=parameters.VIS[model.partner];
      } else {
        var viss={};
        for(i in model.typeOptions) {
          typeOption=model.typeOptions[i];
          if(typeOption.active) {
            optionViss=tools.match(parameters.arrayVIS,typeOption.filter);
            for(j in optionViss) {
              optionVis=optionViss[j];
              viss[optionVis.id]=optionVis;
            }
          }
        }
      }
      if(model.enableOrigin) {
        viss=tools.match(viss,model.originOptions[model.origin].filter);
      }
      viss=Object.values(viss).map(function(vis) {
        return vis.id;
      });
    } else {
      viss=model.viss;
    }
    webservice.exclusiveCall("search",{
      'searchTerm':model.searchTerm,
      'exactMatch':model.exactMatch,
      'viss':viss,
      'createdByUser':model.originOptions[model.origin].createdByUser,
      'startdate':model.startdate!==null?tools.dateFromJava(model.startdate):'',
      'enddate':model.enddate!==null?tools.dateFromJava(model.enddate):'',
      'createdstart':model.createdstart!==null?tools.dateFromJava(model.createdstart):'',
      'createdend':model.createdend!==null?tools.dateFromJava(model.createdend):'',
      'getActivities':model.getActivities,
      'getMeals':model.getMeals,
      'getAccomodations':model.getAccomodations
    },script,model).then(function() {
      var i,j,k,collection,record,peopleCount,quantityCount,participants,participant,dishes,dish,dsh,hotelreservationcategories,hotelreservationcategory;
      var collections=["activities","meals","hotelreservationcategories"];
      var visitsArray=tools.toArray(model.visits).map(function(visit) {
          return visit.id;
      });
      for(i in collections) {
        collection=collections[i];
        for(j in model[collection]) {
          record=model[collection][j];
          record.relevance=visitsArray.indexOf(record.visit);
          record.created=model.visits[record.visit].created;
          if(collection==="activities") {
            record.name=activitiesService.activityDescription(record);
            peopleCount=0;
            quantityCount=0;
            participants=tools.join(record,'participants',model);
            for(k in participants) {
              participant=participants[k];
              peopleCount+=parseInt(parameters.UNT[participant.unt].field1)*parseInt(model.items[participant.item].planningquantity);
              quantityCount+=parseInt(model.items[participant.item].planningquantity);
            }
            record.quantities=(peopleCount===0?quantityCount:peopleCount)+'';
          } else if(collection==="meals") {
            record.name=tools.label(parameters.RES[record.res]);
            record.quantities='';
            dishes=tools.join(record,'dishes',model);
            for(k in dishes) {
              dish=dishes[k];
              if(dish.dsh in parameters.DSH) {
                dsh=parameters.DSH[dish.dsh];
                if(dsh.field1=='1') {
                  record.quantities+=' '+dish.quotationtitle;
                } else {
                  record.quantities+=' '+tools.label(parameters.DSH[dish.dsh]);
                }
                record.quantities+=' '+model.items[dish.item].planningquantity;
              }
            }
          } else if(collection==="hotelreservationcategories") {
            record.day=record.startdate;
            record.hrs=record.starthrs;
            record.name=tools.label(parameters.HTL[record.htl]);
            record.quantities=tools.short(parameters.HSC[record.requestedhsc])+' '+model.items[record.item].quantity;
            record.comment='';
          }
          model.elementsWithDate.push(record);
        }
      }
    });
  };

  $scope.clearTypes = function() {
    for(var i in model.typeOptions) {
      model.typeOptions[i].active=false;
    }
    model.anyTypeIsActive=true;
    model.enableOrigin=true;
    model.enablePartners=false;
    $scope.setOriginFilteredOptions();
  };

  $scope.clickType = function(typeOption) {
    typeOption.active=!typeOption.active;
    model.anyTypeIsActive=model.typeOptionsArray.reduce(function(acc,cur) {
      return acc && !cur.active;
    },true);
    model.enableOrigin=model.anyTypeIsActive || !model.typeOptions.P.active;
    model.enablePartners=model.typeOptions.P.active && model.typeOptionsArray.filter(function(typeOption) {
      return typeOption.active;
    }).length===1;
    $scope.setOriginFilteredOptions();
  }

  $scope.clearOrigins = function() {
    for(var i in model.originFilteredOptions) {
      model.originFilteredOptions[i].active=false;
    }
    model.anyOriginIsActive=true;
    model.viss=[];
  };

  $scope.clickOrigin = function(origin) {
    origin.active=!origin.active;
    model.anyOriginIsActive=model.originFilteredOptionsArray.reduce(function(acc,cur) {
      return acc && !cur.active;
    },true);
    if(model.anyOriginIsActive) {
      model.viss=[];
    } else {
      model.viss=model.originFilteredOptionsArray.filter(function(originFilteredOption) {
        return originFilteredOption.active
      }).map(function(vis) {
          return vis.id;
      });
    }
  }

  $scope.setOriginFilteredOptions = function() {
    var i,j,typeOption,optionViss,optionVis,vis,index;
    var viss={};
    if(model.anyTypeIsActive) {
      viss=parameters.notDelArrayVIS;
    } else {
      for(i in model.typeOptions) {
        typeOption=model.typeOptions[i];
        if(typeOption.active) {
          optionViss=tools.match(parameters.arrayVIS,typeOption.filter);
          for(j in optionViss) {
            optionVis=optionViss[j];
            viss[optionVis.id]=optionVis;
          }
        }
      }
    }
    model.originFilteredOptions=tools.match(viss,model.originOptions[model.origin].filter);
    model.originFilteredOptionsArray=Object.values(model.originFilteredOptions);
    if(model.anyOriginIsActive) {
      model.viss=[];
    } else {
      model.viss=model.originFilteredOptionsArray.filter(function(originFilteredOption) {
        return originFilteredOption.active
      }).map(function(vis) {
          return vis.id;
      });
    }
    if(tools.getLength(model.viss)===0) {
      $scope.clearOrigins();
    }
  }

  $scope.any = {'id':'','filter':{},'createdByUser':false,'showOrigin':true,'labelen':'--Any--','labelnl':'--Alle--','labelfr':'--Tout--'};
  tools.initAttributes(model,{
    'searchTerm':'',
    'exactMatch':false,
    'moreOptions':false,
    'anyTypeIsActive':true,
    'enableOrigin':true,
    'anyOriginIsActive':true,
    'enablePartners':false,
    'typeOptions':{
      'D':{'id':'D','active':false,'filter':{'field1':'0','field3':'0'},'labelen':'Private','labelnl':'Particulier','labelfr':'Priv\u00E9','onlineOption':true},
      'O':{'id':'O','active':false,'filter':{'field1':'1'},'labelen':'Organisation','labelnl':'Organisatie','labelfr':'Organisation','onlineOption':true},
      'P':{'id':'P','active':false,'filter':{'field3':'1'},'labelen':'Partner','labelnl':'Partner','labelfr':'Partenaire','onlineOption':false}
    },
    'originOptions':{},
    'originOptionsArray':[],
    'originFilteredOptions':{},
    'originFilteredOptions':[],
    'partnerOptions':{},
    'origin':'',
    'partner':'',
    'startdate':null,
    'enddate':null,
    'createdstart':null,
    'createdend':null,
    'startdateOpened':false,
    'enddateOpened':false,
    'createdstartOpened':false,
    'createdendOpened':false,
    'dateOptions':{
      maxDate: new Date(2099,11,31),
      minDate: new Date(2000,0,1),
      startingDay: 1
    },
    'elementsWithDate':[],
    'vis':'',
    'getActivities':true,
    'getMeals':true,
    'getAccomodations':true
  });
  tools.initAttributes(model,{
    'typeOptionsArray':Object.values(model.typeOptions)
  });

  webservice.afterLogin().then(function() {
    $scope.model.originOptions={
      '':$scope.any,
      'EMP':{'id':'EMP','filter':{'field2':'0'},'createdByUser':false,'showOrigin':false,'labelen':'Any user','labelnl':'Een gebruiker','labelfr':'Un utilisateur'},
      'FRM':{'id':'FRM','filter':{'field2':'1'},'createdByUser':false,'showOrigin':true,'labelen':'Website form','labelnl':'Website formulier','labelfr':'Formulaire site web'},
      'KIO':{'id':'KIO','filter':{'id':'KIO'},'createdByUser':false,'showOrigin':false,'labelen':'Kiosk','labelnl':'Kiosk','labelfr':'Kiosk'},
      'USR':{'id':'USR','filter':{'field2':'0'},'createdByUser':true,'showOrigin':false,'labelen':user.name,'labelnl':user.name,'labelfr':user.name}
    };
    $scope.model.originOptionsArray=Object.values($scope.model.originOptions);
    $scope.model.partnerOptions=[$scope.any].concat(tools.match(parameters.VIS,{'field3':'1','del':'0'}));
    if(angular.isDefined($stateParams.searchElement)) {
      var searchElement=$stateParams.searchElement;
      if(/^["'][\S\w]+["']$/.test(searchElement)) {
        model.exactMatch=true;
        model.searchTerm=searchElement.replace(/^["']|["']$/g,'');
      } else {
        model.exactMatch=false;
        model.searchTerm=searchElement;
      }
    }
    $scope.setOriginFilteredOptions();
    $scope.model.originFilteredOptionsArray=Object.values($scope.model.originFilteredOptions);
    $scope.search();
  });

  
}]);
angular.module("app").controller("ActivitiesRoomOverviewController",["$scope","$sce","$stateParams","$uibModal","$window","$state","tools","modelstore","errorlog","user","parameters","activitiesService","webservice","contactsService","visitsService",
                                            function($scope,$sce,$stateParams,$uibModal,$window,$state,tools,modelstore,errorlog,user,parameters,activitiesService,webservice,contactsService,visitsService) {

  $scope.activitiesService=activitiesService;
  $scope.contactsService=contactsService;
  var script='activities/roomOverview';
  var parentmodel=modelstore.getModel(script);

  if($stateParams.settings!==null && 'acts' in $stateParams.settings && $stateParams.settings.acts!==null) {
    parentmodel.acts=$stateParams.settings.acts;
  } else if(angular.isUndefined(parentmodel.acts)) {
    parentmodel.acts=['ESC'];
  }
  var model=modelstore.getModel(script+'/'+angular.toJson(parentmodel.acts));
  $scope.model=model;

  $scope.getMaxRowspanParentHrss = function(parentHrss) {
    var result=0;
    for(var i in parentHrss) {
      result=Math.max(result,parentHrss[i].rowspan);
    }
    return result;
  }

  $scope.load = function() {
    if(tools.validateAndUpdateDates(model) && tools.getLength(model.acts)>0) {
      modelstore.cleanModel(["visits","activities","participants","items"],model);
      webservice.exclusiveCall("load", {
        'startdate':tools.dateFromJava(model.startdate),
        'acts':model.acts
      },script,model).then(function() {
        $scope.structureVisits();
      });
    }
  };

  $scope.structureVisits = function() {
    model.structuredVisits={};
    var i,j,k,l,x,visit,activities,activity,frm,day,startHrs,hrsJavascript,endHrs,hrsList,actHrsList,hrs,participants,participant,unt,last,cpg,load,maxLoad,loadLength,first,position,parentHrs;
    var previousLoad,distributedLoad,distributedElementLoad,isStartHour,maxDayCapacityLoad,maxDayUntLoad,loadDuration,loadElement,previousXLoadElement,previousHrsLoadElement,xLoadElement,isFirstParent;
    var maxHrs=Object.keys(parameters.HRS).reduce(function(acc,hrsId){
      return hrsId>acc?hrsId:acc;
    },"");
    maxHrs=maxHrs.substr(0,6)+'59';
    var untList=$scope.getUntList();
    for(day in model.hrsLists) {
      hrsList=model.hrsLists[day].hrss;
      actHrsList=model.hrsLists[day].actHrs;
      if(!(day in model.structuredVisits)) {
        model.structuredVisits[day]={'parentHrss':{},'hrss':{},'maxUntLoads':{}};
        model.sumLoads[day]=0;
      }
      for(i in untList) {
        unt=untList[i];
        maxDayCapacityLoad=model.capacityLoads[day][unt.field4];
        maxDayUntLoad=$scope.getUntDayHrsLoad(unt,day,hrsList);
        maxLoad=Math.max(maxDayCapacityLoad,maxDayUntLoad,1);
        if(!(unt.id in model.structuredVisits[day].maxUntLoads)) {
          model.structuredVisits[day].maxUntLoads[unt.id]={'maxLoad':maxLoad,'overLoad':Math.max(0,maxDayUntLoad-maxDayCapacityLoad)};
        }
        first=true;
        for(j in hrsList) {
          previousLoad=model.sumLoads[day];
          distributedLoad=0;
          distributedElementLoad=0;
          hrs=hrsList[j];
          parentHrs=hrs.substr(0,2);
          isFirstParent=!(parentHrs in model.structuredVisits[day].parentHrss);
          if(!(hrs in model.structuredVisits[day].hrss)) {
            model.structuredVisits[day].hrss[hrs]={'hrs':hrs,'loadElements':{},'firstParent':isFirstParent};
          }
          if(isFirstParent) {
            model.structuredVisits[day].parentHrss[parentHrs]={'parentHrs':parentHrs.substr(0,1)=='0'?parentHrs.substr(1,1):parentHrs,'hrss':{},'rowspan':0};
          }
          if(!(hrs in model.structuredVisits[day].parentHrss[parentHrs].hrss)) {
            model.structuredVisits[day].parentHrss[parentHrs].hrss[hrs]=true;
            model.structuredVisits[day].parentHrss[parentHrs].rowspan++;
          }
          isStartHour=actHrsList[unt.id.substr(0,3)][hrs].available;
          participants=tools.match(tools.join(tools.match(model.activities,{'dayISO':day,'hrs':hrs}),'participants',model),{'unt':unt.id});
          for(k in participants) {
            participant=participants[k];
            load=tools.amountIn(model.items[participant.item].planningquantity);
            activity=model.activities[participant.activity];
            frm=parameters.FRM[activity.frm];
            visit=model.visits[activity.visit];
            if(load>0) {
              startHrs=activity.hrs;
              endHrs=$scope.getHour(activity.day,startHrs,activity.frm,false);
              for(l=j;angular.isDefined(hrsList[l]) && hrsList[l]<endHrs;l++) {
                loadDuration=l-j;
              }
              loadElement={
                'startHrs':startHrs,
                'endHrs':endHrs,
                'visit': visit,
                'stat':tools.numberIn(visit.stat),
                'load':load,
                'rowspan':loadDuration+1,
                'unt':unt,
                'activity':activity,
                'info':
                    startHrs.substr(0,2)+model.hrsLabel+startHrs.substr(3,2)+'-'+endHrs.substr(0,2)+model.hrsLabel+endHrs.substr(3,2)+
                    '<br/>'+
                    contactsService.getName(model.contacts[visit.owningcontact])+
                    '<br/>'+
                    (frm.field3==='1'?tools.label(frm)+': ':'')+activitiesService.countParticipants(tools.join(tools.between(tools.match(tools.join(visit,'activities',model),{'frm':frm.id}),'hrs',startHrs,endHrs,true,false),'participants',model),model)+'p'+
                    '<br/>'+
                    activity.comment,
                'addReservation':false,
                'isStartHour':isStartHour,
                'previousKey':visit.id+'_'+activity.frm+'_'+hrs
              }
              distributedElementLoad=0;
              for(x=0;distributedElementLoad<load && x<maxLoad;x++) {
                position=x+previousLoad;
                if(angular.isUndefined(model.structuredVisits[day].hrss[hrs].loadElements[position])) {
                  previousHrsLoadElement=first?undefined:model.structuredVisits[day].hrss[hrsList[j-1]].loadElements[position];
                  previousXLoadElement=distributedElementLoad==0?null:model.structuredVisits[day].hrss[hrs].loadElements[position-1];
                  if(angular.isUndefined(previousHrsLoadElement) || previousHrsLoadElement.rowspan<=1) {
                    xLoadElement=tools.clone(loadElement);
                    xLoadElement.previousKey=loadElement.previousKey+'_'+position;
                    if(previousXLoadElement===null || previousXLoadElement.previousKey!==loadElement.previousKey+'_'+(position-1)) {
                      xLoadElement.colspan=1;
                      xLoadElement.firstPosition=position;
                      xLoadElement.first=true;
                    } else {
                      model.structuredVisits[day].hrss[hrs].loadElements[previousXLoadElement.firstPosition].colspan++;
                      xLoadElement.firstPosition=previousXLoadElement.firstPosition;
                      xLoadElement.first=false;
                    }
                    distributedElementLoad++;
                  } else {
                    xLoadElement=tools.clone(previousHrsLoadElement);
                    xLoadElement.rowspan--;
                    xLoadElement.first=false;
                  }
                  model.structuredVisits[day].hrss[hrs].loadElements[position]=xLoadElement;
                  $scope.trustInfoAsHtml(model.structuredVisits[day].hrss[hrs].loadElements[position]);
                }
              }
              distributedLoad+=distributedElementLoad;
            }
          }
          if(distributedLoad<maxLoad) {
            distributedElementLoad=0;
            loadDuration=0;
            // for(l=j;angular.isDefined(hrsList[l]);l++) {
            //   if(hrs===hrsList[l] || !actHrsList[unt.id.substr(0,3)][hrsList[l]].available) {
            //     loadDuration=l-j;
            //   } else {
            //     break;
            //   }
            // }
            loadElement={
              'startHrs':hrs,
              'endHrs':hrs,
              'visit':null,
              'stat':0,
              'load':1,
              'rowspan':loadDuration+1,
              'unt':unt,
              'activity':null,
              'info':'',
              'addReservation':true,
              'isStartHour':isStartHour,
              'previousKey':unt.id+'_'+hrs,
            };
            if(tools.numberIn(maxDayCapacityLoad)===0 && unt.field4!=='' && tools.numberIn(maxDayUntLoad)===0 && first) {
              for(l=j;angular.isDefined(hrsList[l]);l++) {
                loadDuration=l-j;
              }
              loadElement={
                'startHrs':hrs,
                'endHrs':maxHrs,
                'visit':{'id':'0','stat':'9000'},
                'stat':9100,
                'load':1,
                'rowspan':loadDuration+1,
                'unt':unt,
                'activity':null,
                'info':tools.lang({'en':'Closed','nl':'Gesloten','fr':'Ferm\u00E9e'}),
                'addReservation':false,
                'isStartHour':isStartHour,
                'previousKey':unt.id+'_'+hrs,
              };
            }
            for(x=0;distributedLoad<maxLoad && x<maxLoad;x++) {
              position=x+previousLoad;
              if(angular.isUndefined(model.structuredVisits[day].hrss[hrs].loadElements[position])) {
                previousHrsLoadElement=first?undefined:model.structuredVisits[day].hrss[hrsList[j-1]].loadElements[position];
                previousXLoadElement=distributedElementLoad==0?null:model.structuredVisits[day].hrss[hrs].loadElements[position-1];
                if(angular.isUndefined(previousHrsLoadElement) || previousHrsLoadElement.rowspan<=1) {
                  xLoadElement=tools.clone(loadElement);
                  xLoadElement.previousKey=loadElement.previousKey+'_'+position;
                  if(previousXLoadElement===null || previousXLoadElement.previousKey!==loadElement.previousKey+'_'+(position-1)) {
                    xLoadElement.colspan=1;
                    xLoadElement.firstPosition=position;
                    xLoadElement.first=true;
                  } else {
                    model.structuredVisits[day].hrss[hrs].loadElements[previousXLoadElement.firstPosition].colspan++;
                    xLoadElement.firstPosition=previousXLoadElement.firstPosition;
                    xLoadElement.first=false;
                  }
                  distributedLoad++;
                  distributedElementLoad++;
                } else {
                  xLoadElement=tools.clone(previousHrsLoadElement);
                  xLoadElement.rowspan--;
                  xLoadElement.first=false;
                }
                model.structuredVisits[day].hrss[hrs].loadElements[position]=xLoadElement;
                $scope.trustInfoAsHtml(model.structuredVisits[day].hrss[hrs].loadElements[position]);
              }
            }
          }
          first=false;
        }
        model.sumLoads[day]+=maxLoad;
      }
    }
  };

  $scope.getUntDayHrsLoad = function(unt,day,hrsList) {
    var i,j,participants,participant,unt,act,starthrs,endhrs,load,hrs;
    var result=0;
    for(i in hrsList) {
      hrs=hrsList[i];
      load=0;
      participants=tools.match(tools.join(tools.match(model.activities,{'dayISO':day}),'participants',model),{'unt':unt.id});
      for(j in participants) {
        participant=participants[j];
        act=model.activities[participant.activity];
        endhrs=$scope.getHour(act.day,act.hrs,act.frm,false);
        if(act.dayISO===day && hrs>act.hrs && hrs<endhrs) {
          load+=tools.amountIn(model.items[participant.item].planningquantity);
        }
      }
      result=Math.max(result,load);
    }
    return result;
  }

  $scope.trustInfoAsHtml = function(loadElement) {
    loadElement.trustedInfo=$sce.trustAsHtml(loadElement.info);
  }

  $scope.getHour = function(day,hrs,frmId,negative) {
    var hour;
    var addHours=(negative?-1:1)*1000*60*60*tools.amountIn(parameters.FRM[frmId].field1);
    var time=new Date(tools.timestampToJava(tools.dateFromJava(day)+' '+hrs).valueOf()+addHours);
    var newDate=tools.dateToJava(tools.dateFromJava(time));
    if(day<newDate) {
      hour='23:59:59';
    } else if(day>newDate) {
      hour='00:00:00';
    } else {
      hour=tools.hourFromJava(time);
    }
    return hour;
  }

  angular.element($window).on('resize',function() {
    model.windowHeight=Math.max(200,($window.outerHeight-425))+'px';
    $scope.$apply();
  });

  $scope.todayDate = function() {
    var today = tools.dateToJava(tools.today());
    model.startdate=today;
    model.enddate=today;
    $scope.load();
  }

  $scope.increaseDates = function(increment) {
    var newStartdate=new Date(model.startdate.getTime());
    newStartdate.setDate(newStartdate.getDate()+increment);
    model.startdate=newStartdate;
    var newEnddate=new Date(model.enddate.getTime());
    newEnddate.setDate(newEnddate.getDate()+increment);
    model.enddate=newEnddate;
    $scope.load();
  };

  $scope.getUntList = function() {
    var result=[];
    var i,j,unts;
    for(i in model.acts) {
      unts=tools.exclude(activitiesService.activityFilter(parameters.notDelUNT,'id',model.acts[i]),{'field9':'0'});
      for(j in unts) {
        result.push(unts[j]);
      }
    }
    return result;
  }

  $scope.selectAct = function(act) {
    var index=model.acts.indexOf(act);
    if(index<0) {
      model.acts.push(act);
    } else {
      model.acts.splice(index,1);
    }
    $scope.load();
  }

  $scope.getActTitle = function() {
    var result='';
    if(tools.getLength(model.acts)>0) {
      result=[];
      for(var i in model.acts) {
        result.push(parameters.ACT[model.acts[i]]['label'+user.lang]);
      }
      result=result.join(' + ');
    }
    return result;
  }

  $scope.createActivity = function(unt,day,hrs,createModel,visitId) {
    var act=unt.substring(0,3);
    var frms=tools.exclude(activitiesService.getFormulas(act),{'del':'1'});
    var frm=null;
    var i,frm;
    if(tools.getLength(tools.match(frms,{'field2':'1'}))>0) {
      frm=tools.first(tools.match(frms,{'field2':'1'})).id;
    } else {
      frm=tools.first(frms).id;
    }
    var activity={
      'table':'activities',
      'isCreated':false,
      'createdDate':new Date(),
      'id':tools.getMinIdMinusOne(createModel.activities),
      'visit':visitId,
      'stat':'1000',
      'frm':frm,
      'act':act,
      'day':tools.dateToJava(day),
      'dayOpened':false,
      'hrs':hrs,
      'comment':'',
      'quotationtitle':'',
      'quotationdescription':'',
      'quotationhidefoto':'0',
      'availabilities':{},
      'skipGetAvailability':false,
      'isOpen':true,
      'editing':true,
      'selected':false
    };
    modelstore.addRecord("activities",activity,createModel);
    $scope.fillParticipants(activity,unt,createModel,visitId);
    return activity;
  };

  $scope.fillParticipants = function(activity,unt,createModel,visitId) {
    var untId,participants,participant,quantity;
    participants=tools.join(activity,'participants',createModel);
    for(untId in parameters.notDelUNT) {
      if(activitiesService.matchesFormula(untId,activity.frm)) {
        if(tools.getLength(tools.match(participants,{'unt':untId}))==0) {
          if(parameters.UNT[untId].field2=="1" || untId==unt) {
            quantity='1';
          } else {
            quantity='0';
          }
          participant={
            'isCreated':false,
            "id":tools.getMinIdMinusOne(createModel.participants),
            "activity":activity.id,
            "item":$scope.createItem(quantity,parameters.UNT[untId].field8,createModel,visitId),
            "unt":untId
          };
          modelstore.addRecord("participants",participant,createModel);
        }
      }
    }
  };

  $scope.createItem = function(quantity,cgr,createModel,visitId) {
    var item={
      'isCreated':false,
      'id':tools.getMinIdMinusOne(createModel.items),
      'visit':visitId,
      'reductionpromotion':'0',
      'reductionpro':'',
      'reductionamount':'0',
      'reductionpercent':'1',
      'quantity': quantity,
      'customprice':'0',
      'grossunitprice':'0',
      'deltatopay':'0',
      'invoice':'0',
      'cgr':cgr,
      'advancedAttributes':false
    };
    item.planningquantity=item.quantity;
    item.oldQuantity=item.quantity;
    item.initialQuantity=item.quantity;
    modelstore.addRecord("items",item,createModel);
    return item.id;
  };

  $scope.addReservation = function(unt,day,hrs) {
    var collections={};
    tools.initAttributes(collections,{
      'visits':{},
      'contacts':{},
      'activities':{},
      'participants':{},
      'meals':{},
      'dishes':{},
      'hotelreservationcategories':{},
      'hotelreservationproducts':{},
      'products':{},
      'items':{}
    })
    modelstore.cleanModel(['visits','activities','participants','items'],collections);
    $uibModal.open({
      'templateUrl': 'app/modules/visits/addArticleModal.html',
      'controller': 'AddArticleModalController',
      'backdrop':'static',
      'windowClass':'app-modal-window-wide',
      'resolve':{
        'day':function() {
          return tools.dateToJava(day);
        }
      }
    }).result.then(function(response) {
      if(response.visit) {
        var isNewVisit=tools.numberIn(response.visit.id)<=0;
        modelstore.addRecords("contacts",response.contacts,collections);
        modelstore.addRecord("visits",response.visit,collections);
        $scope.createActivity(unt.id,day,hrs,collections,response.visit.id);
        var settings={'settings':{'collections':collections,'resetCollections':['activities','participants','meals','dishes','hotelreservationcategories','hotelreservationproducts','products','items']},'lang':user.lang};
        if(isNewVisit) {
          settings.settings.resetCollections.push('visits');
          settings.settings.resetCollections.push('contacts');
          $state.go('activitiesCreateForEmp',settings);
        } else {
          settings['id']='V'+response.visit.id;
          $state.go('activitiesRetrieveForEmp',settings);
        }
      }
    });
  }

  $scope.updateActivityStat = function(activity,stat) {
    webservice.exclusiveCall('updateActivityStat',{'activityId':activity.id,'stat':stat},script,model).then($scope.structureVisits);
  };


  tools.initAttributes(model,{
    'startdate':new Date(),
    'enddate':new Date(),
    'startdateOpened':false,
    'enddateOpened':false,
    'dateOptions':{
      maxDate: new Date(2099,11,31),
      minDate: new Date(2000,0,1),
      startingDay: 1
    },
    'acts':parentmodel.acts,
    'structuredVisits':{},
    'windowHeight':($window.outerHeight-425)+'px',
    'sumLoads':{},
    'hrsLabel':tools.lang({'en':'h','nl':'u','fr':'h'})
  });

  webservice.afterLogin().then(function() {
    $scope.$watch("model.startdate.getTime()",function(newVal,oldVal) {
      if(oldVal==model.enddate.getTime()) {
        model.enddate=new Date();
        model.enddate.setTime(newVal);
      }
      $scope.load();
    });
    $scope.$watch('model.enddate.getTime()',function() {
      $scope.load();
    });
  });
  
}]);
angular.module("app").controller("ActivitiesRetrieveForEmpController",["$scope","$sce","$stateParams","$window","$q","$timeout","$uibModal","config","tools","modelstore","webservice","activitiesService","errorlog","emailbox","ctep","cashless","user","parameters","hotelsService","contactsService",
                                                                 function($scope,$sce,$stateParams,$window,$q,$timeout,$uibModal,config,tools,modelstore,webservice,activitiesService,errorlog,emailbox,ctep,cashless,user,parameters,hotelsService,contactsService) {

  var retrieveForEmpScript='activities/retrieveForEmp';
  var listQoutationsScript='quotations/listQuotations';
  var model=modelstore.getModel('activities/retrieveForEmp');
  $scope.model=model;
  $scope.activitiesService=activitiesService;
  $scope.contactsService=contactsService;
  $scope.user=user;
  $scope.initialize=true;

  $scope.purposes=['PROFORMA','B2CTURNO','ARTICLELIST'];

  $scope.structureMessages = function() {
    angular.forEach(model.emails,function(email) {
      email.table="emails";
      email.day=email.created.substr(0,10);
    });
    angular.forEach(model.quotationnotes,function(email) {
      email.table="quotationnotes";
    });
    angular.forEach(model.visits,function(visit) {
      visit.messages=tools.join(visit,'emails',model).concat(tools.join(visit,'quotationnotes',model));
      visit.messages.sort(function(a,b) {return tools.numberIn(a.day)-tools.numberIn(b.day);});
    });
  };

  $scope.init = function() {
    modelstore.cleanModel(["contacts","visits","activities","participants","meals","dishes","products","hotelreservationcategories","hotelreservationproducts","hotelrates","hotelspaceassignments","hotelspaces","items",'emails','quotationnotes','cashlesspayments','movements','visitrelations'],model);
    cashless.setstatus('idle');
    var visitId=$stateParams.id.replace(/[^0-9]/g,"");
    var result=webservice.exclusiveCall("load",{"visitId":visitId},retrieveForEmpScript,model).then(function() {
      if(tools.getLength(model.visits)>0) {
        $window.previousSearchElement=visitId;
        $scope.structureMessages();
        model.visit=model.visits[visitId];
        model.visit.isCreated=true;
        model.visit.isOpen=false;
        model.visit.editing=false;
        model.reductionMode=(model.visit.automaticreduction=='1')?'automatic':'item';
        model.owningContact=model.contacts[model.visit.owningcontact];
        $scope.setContactCountryCallingCodeAndNumber(model.owningContact);
        model.newCommunicationContact={
          'id':tools.getMinIdMinusOne(model.contacts),
          'firstname':'',
          'name':'',
          'gsm':'',
          'email':'',
          'country':'BE',
          'countryCallingCode':32,
          'number':'',
          'address1':'',
          'postalcode':'',
          'address2':'',
          'lang':user.lang,
          'agreestomarketing':'0',
          'sal':'',
          'iscompany':'0',
          'isOpen':true,
          'editing':true,
          'advancedAttributes':false,
          'hasNoInvoicesOrMovements':true
        };
        modelstore.addRecord("contacts",model.newCommunicationContact,model);
        model.dummyCommunicationContact={'id':'0','dummy':true}
        if(model.visit.communicationcontact=='0') {
          model.communicationContact=model.dummyCommunicationContact;
          model.existingCommunicationContact={'id':'0'};
        } else {
          model.communicationContact=model.contacts[model.visit.communicationcontact];
          $scope.setContactCountryCallingCodeAndNumber(model.communicationContact);
          model.existingCommunicationContact=tools.clone(model.communicationContact);
        }
        var collections=['activities','participants','meals','dishes','products','hotelreservationcategories','hotelreservationproducts','hotelspaceassignments'];
        var i,j,k,collection,collectionName,record,item,isNew,tickets;
        if('settings' in $stateParams && $stateParams.settings!==null) {
          var settings=$stateParams.settings;
          if('collections' in settings && 'visits' in settings.collections && tools.getLength(settings.collections.visits)==1) {
            if(tools.first(settings.collections.visits).id===model.visit.id) {
              var settingsCollections=settings.collections;
              for(i in collections) {
                collectionName=collections[i];
                if(collectionName in settingsCollections) {
                  collection=settingsCollections[collectionName];
                  for(j in collection) {
                    record=collection[j];
                    modelstore.addRecord(collectionName,record,model);
                  }
                }
              }
              if('items' in settingsCollections) {
                collection=settingsCollections['items'];
                for(j in collection) {
                  record=collection[j];
                  modelstore.addRecord('items',record,model);
                }
              }
            }
          }
          $stateParams.settings=null;
        }
        for(i in collections) {
          collectionName=collections[i];
          collection=model[collectionName];
          for(j in collection) {
            record=collection[j];
            isNew=tools.numberIn(record.id)<0;
            record.skipGetAvailability=!isNew;
            record.isCreated=!isNew;
            record.isOpen=isNew;
            record.editing=isNew;
            record.selected=$scope.selectedElements.indexOf(record.id+collectionName)>=0;
            if(record.table='meals') {
              record.oldPeoplecount=record.peoplecount;
            }
            if(isNew && model.task!=='u') {
              model.task='u';
              tickets=tools.match(tools.join(model.visit,'tickets',model),{'del':'0'});;
              if(tools.getLength(tickets)>0) {
                for(k in tickets) {
                  $scope.deleteTicket(tickets[k]);
                }
              }
            }
          }
        }
        for(i in model.items) {
          item=model.items[i];
          item.isCreated=tools.numberIn(record.id)>=0;
          item.quantity=tools.amountOut(item.quantity);
          item.planningquantity=tools.amountOut(item.planningquantity);
          item.initialQuantity=item.quantity;
          item.oldQuantity=item.quantity;
        }
        if(tools.getLength(tools.match(tools.join(tools.join(model.visit,'hotelreservationcategories',model),'hotelspaceassignments',model),{'assignedspace':'0'}))>0) {
          errorlog.warning(tools.lang({
            'en':'A reservation has not been assigned a room. Please check your property management system.',
            'nl':'Een reservatie heeft geen toegekende kamer. Gelieve uw property management systeem te raadplegen.',
            'fr':'Une reservation n\u0020a pas \u00E9t\u00E9 attribu\u00E9e une chambre. Veuillez v\u00E9rifier votre property management system.'
          }));
        }
        var hotelreservationcategory,hotelspaceassignments;
        for(i in model.hotelreservationcategories) {
          hotelreservationcategory=model.hotelreservationcategories[i];
          hotelsService.setHotelreservationcategoryUpdatePermissions(model.visits[hotelreservationcategory.visit],hotelreservationcategory,tools.join(hotelreservationcategory,'hotelspaceassignments',model));
          hotelreservationcategory.externalreleaseddateOpened=false;
        }
        var unfinishedcashlesspayments=tools.match(model.cashlesspayments,{'stat':2000});
        if(unfinishedcashlesspayments.length>0) {
          cashless.trackPayment(model,unfinishedcashlesspayments[0].id).then(function() {
            $scope.init();
          });
        }
        var movement;
        for(i in model.movements) {
          movement=model.movements[i];
          movement.method=model.accounts[movement.account].method;
          movement.selected=$scope.selectedElements.indexOf(movement.id+'movements')>=0;
        }
        $scope.itemListOptions={'editing':false,'description':'','compacted':'0','visit':model.visit.id};
        for(i in $scope.purposes) {
          $scope.itemListOptions[$scope.purposes[i]]={'editing':false,'description':'','compacted':'0','visit':model.visit.id};
        }
        var invoice;
        for(i in model.invoices) {
          invoice=model.invoices[i];
          invoice.isInError=invoice.errorwording!='' && model.accountingIntegration!=='';
        }
        $scope.$broadcast("watchAll");
        $scope.$broadcast("updateToPay");
        $scope.$broadcast("afterLoad");
      } else {
        model.visit={};
        model.visits={};
        model.activities={};
        model.participant={};
        model.meals={};
        model.dishes={};
        model.hotelreservationcategories={};
        model.hotelreservationproducts={};
        model.items={};
        model.visitElementsWithDate=[];
        model.movements={};
        model.contacts={};
        model.owningContact={};
        model.communicationContact={};
      }
    });
    $scope.initialize=false;
    model.downpaymentAmount='';
    model.invoiceDescription='';
    $scope.$broadcast("updateToPay");
    return result;
  };

  $scope.setContactCountryCallingCodeAndNumber = function(contact) {
    if(contact.id!=='0') {
      var contactCountryCallingCodeMatches=contact.gsm.match(/^\+((1-)?[0-9]{1,3})\(0\)([\s\S]*)/);
      contact.countryCallingCode='';
      contact.number=contact.gsm;
      contact.prettyGsm=contact.number;
      if(contactCountryCallingCodeMatches!==null) {
        if(angular.isDefined(contactCountryCallingCodeMatches[1])) {
          contact.countryCallingCode=contactCountryCallingCodeMatches[1];
          if(Number(contact.countryCallingCode)!==NaN) {
            contact.countryCallingCode=Number(contact.countryCallingCode);
          }
        }
        if(angular.isDefined(contactCountryCallingCodeMatches[3])) {
          contact.number=contactCountryCallingCodeMatches[3];
        }
      }
      if(contact.country!=='' && contact.countryCallingCode==='') {
        contact.countryCallingCode=tools.first(parameters.countries[contact.country].countryCallingCodes);
      }
      if(contact.countryCallingCode!=='') {
        contact.prettyGsm='+'+contact.countryCallingCode+contact.number;
      }
    }
  }
  
  $scope.getVisitElementsChildList = function(visitElements) {
    var result=[];
    if(!webservice.calling) {
      var i,visitElement,hasChildElements;
      for(var i in visitElements) {
        visitElement=visitElements[i];
        hasChildElements=true;
        if(visitElement.table=="activities") {
          result=result.concat(visitElement.joinedParticipants);
        } else if(visitElement.table=="meals") {
          result=result.concat(tools.join(visitElement,'dishes',model));
        } else if(visitElement.table=="hotelreservationcategories" && tools.getLength(tools.join(visitElement,'hotelspaceassignments',model))>0) {
          result=result.concat(tools.join(visitElement,'hotelspaceassignments',model));
        } else {
          hasChildElements=false;
        }
        if(tools.getLength(visitElements)>1 || !hasChildElements) {
          result=result.concat(visitElement);
        }
      }
    }
    return result;
  }

  $scope.selectedElements=[];
  $scope.setSelectedElements = function() {
    var i,j,collection,collectionName,record,key,index;
    var collections=['activities','participants','meals','dishes','products','hotelreservationcategories','hotelspaceassignments','movements'];
    for(i in collections) {
      collectionName=collections[i];
      collection=model[collectionName];
      for(j in collection) {
        record=collection[j];
        key=record.id+collectionName;
        index=$scope.selectedElements.indexOf(key);
        if(index<0 && record.selected) {
          $scope.selectedElements.push(key);
        } else if(index>=0 && !record.selected) {
          $scope.selectedElements.splice(index,1);
        }
      }
    }
    model.selectionCount=tools.getLength($scope.selectedElements);
  };
  $scope.getTicketWsParams = function(ticket) {
    var result="{}";
    if("visit" in model) {
      result=angular.toJson({
        "a":webservice.auth,
        "s":retrieveForEmpScript,
        "t":"printTicket",
        "p":{"id":ticket.id}
      });
    }
    return result;
  };

  $scope.printTicket = function() {
    webservice.call('getTicket',{'visitId':model.visit.id},'public/reservationC',model).then(function(response) {
      if(response!==false) {
        var binary=atob(response.ticket);
        var len=binary.length;
        var buffer=new ArrayBuffer(len);
        var view=new Uint8Array(buffer);
        for(var i=0;i<len;i++) {
          view[i]=binary.charCodeAt(i);
        }
        var blob=new Blob([view],{'type':'application/pdf'});
        var iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = URL.createObjectURL(blob);
        document.body.appendChild(iframe);
        iframe.contentWindow.print();
      }
    });

  }

  $scope.validateEmail = function() {
    var result=true;
    var communicationContact=model.visit.communicationcontact=='0'?model.owningContact:model.communicationContact;
    if(!communicationContact.email || communicationContact.email.length<=0) {
      errorlog.receiveError(tools.lang({'en':'Invalid email','nl':'Ongeldige email','fr':'Email non valide'}));
      result=false;
    }
    return result;
  };

  $scope.sendConfirmationEmail = function() {
    if($scope.validateEmail()) {
      webservice.call("generateConfirmationEmail",{"id":model.visit.id},retrieveForEmpScript,model).then(function(response) {
        if(response) {
          emailbox.showTemplate(response.fromMailOptions,[response.recipient],response.cc,response.bcc,response.subject,response.attachment,response.body,false,{}).then(function(result) {
            webservice.call('sendConfirmationEmail',{
              'id':model.visit.id,
              'mai':response.mai,
              'fromMail':result.fromMail,
              'recipient':result.recipient,
              'cc':result.cc,
              'bcc':result.bcc,
              'subject':result.subject,
              'body':result.body
            },retrieveForEmpScript,model).then($scope.structureMessages);
          });
        }
      });
    }
  };

  $scope.getQuotationWsParams = function() {
    var result="{}";
    if(("visit" in model) && model.visit && ("id" in model.visit)) {
      result=angular.toJson({
        "a":webservice.auth,
        "s":retrieveForEmpScript,
        "t":"printQuotation",
        "p":{"visitId":model.visit.id}
      });
    }
    return result;
  };

  var quotationLabel={"en":"Quotation","nl":"Offerte","fr":"Offre"}
  $scope.sendQuotation = function() {
    if($scope.validateEmail()) {
      webservice.exclusiveCall("generateEmailSignature",{'visitId':model.visit.id,'purpose':'TCO'+model.visit.tco},retrieveForEmpScript,model).then(function(response) {
        var communicationContact=model.visit.communicationcontact=='0'?model.owningContact:model.communicationContact;
        var recipientOptions=[communicationContact.email];
        if(model.owningContact.email!=='' && model.owningContact.email!=communicationContact.email) {
          recipientOptions.push(model.owningContact.email);
        }
        emailbox.showTemplate(model.fromMailOptions,recipientOptions,[],[],response.subject,tools.label(parameters.DVS[model.visit.dvs]).replaceAll(' ','_')+'_'+quotationLabel[communicationContact.lang]+"_V"+model.visit.id+".pdf",'<div class="editable"></div>',false,response.signatures).then(function(result) {
          webservice.call('sendQuotation',{
            'visitId':model.visit.id,
            'fromMail':result.fromMail,
            'recipient':result.recipient,
            'cc':result.cc,
            'bcc':result.bcc,
            'subject':result.subject,
            'body':result.body
          },retrieveForEmpScript,model).then($scope.structureMessages);
        });
      });
    }
  };

  $scope.getInvoiceWsParams = function(invoice) {
    var result="{}";
    if("visit" in model) {
      result=angular.toJson({
        "a":webservice.auth,
        "s":retrieveForEmpScript,
        "t":"printInvoice",
        "p":{"invoiceId":invoice.id}
      });
    }
    return result;
  };
  
  $scope.createPayment = function() {
    webservice.exclusiveCall('createPayment',{
      'visitId':model.visit.id,
      'payment':tools.whitelist(model.payment,['amount','method','voucherid'])
    },retrieveForEmpScript,model).then(function() {
      model.payment.method="CSH";
      model.payment.voucherid="";
      $scope.init();
    });
  };

  $scope.startCtepPayment = function(amount) {
    ctep.startPayment(model.visit,amount,model).then(function(response) {
      if(response) {
        $scope.init();
      }
    });
  };

  $scope.deleteTicket = function(ticket) {
    var result=webservice.call('deleteTicket',{'id':ticket.id},retrieveForEmpScript,model).then(function(response) {
      if(response) {
        model.visit=model.visits[$stateParams.id.replace(/[^0-9]/g,"")];
        $scope.$broadcast("updateToPay");
      }
    });
    return result;
  };

  $scope.freeTicket = function() {
    webservice.exclusiveCall('freeTicket',{'visitId':model.visit.id},retrieveForEmpScript,model).then($scope.init);
  };

  $scope.restore = function() {
    webservice.confirmModal(tools.lang({'en':'Restore','nl':'','fr':'Remettre'})+' '+(model.owningContact.firstname==''?'':model.owningContact.firstname+' ')+model.owningContact.name+' '+tools.lang({'en':'as ','nl':'terugzetten als ','fr':'comme '})+tools.label(parameters.VIS[model.visit.vis].field1=='1'?parameters.STV['1210']:parameters.STV['2000'])).then(function() {
      webservice.exclusiveCall('restore',{"id":model.visit.id},retrieveForEmpScript,model).then(function() {
        $scope.init();
      });
    });
  };

  $scope.openMessage = function(message) {
    if(message.table=="emails") {
      var email=message;
      emailbox.showTemplate([email.frommail],[email.recipient],email.cc.split(';'),email.bcc.split(';'),email.subject,angular.fromJson(email.attachments).join('; '),email.body+'<br/><br/>'+email.attachmentcontent,true,{});
    } else if(message.table=="quotationnotes") {
      emailbox.openQuotationnoteModal(model.visit,message).then(function(quotationnote) {
        webservice.exclusiveCall('replaceQuotationnote',{'quotationnote':tools.whitelist(quotationnote,['visit','day','body'])},retrieveForEmpScript,model).then(function() {
          $scope.structureMessages();
        });
      });
    }
  };

  $scope.startCreateQuotationnote = function() {
    emailbox.openQuotationnoteModal(model.visit,{'day':tools.today(),'body':''}).then(function(quotationnote) {
      quotationnote.visit=model.visit.id;
      webservice.exclusiveCall('replaceQuotationnote',{'quotationnote':tools.whitelistNoId(quotationnote,['visit','day','body'])},retrieveForEmpScript,model).then(function() {
        $scope.structureMessages();
      });
    });
  };

  $scope.deleteQuotationnote = function(message) {
    webservice.deleteConfirm(message.body.substr(0,50),'deleteQuotationnote',message.id,retrieveForEmpScript,model).then(function() {
      $scope.structureMessages();
    });
  };

  $scope.showAgenda = function() {
    return tools.getLength(tools.join(model.visit,'activities',model))+tools.getLength(tools.join(model.visit,'meals',model))>1;
  };

  $scope.canCreateInvoice = function() {
    var result=false;
    if("visit" in model && model.visit) {
      result=!webservice.calling && model.visit.stat>=2000 && model.visit.stat<9000
        && (tools.getLength(tools.exclude(tools.match(tools.join(model.visit,'items',model),{'invoice':'0'}),{'deltatopay':0.0}))>0 ||
        tools.getLength(tools.exclude(Object.values(tools.join(model.visit,'items',model).filter(function(item) {
          return item.replaced=='0' && item.itm.substr(0,5)=='ZDOWN';
        })),{'quantity':'0'}))>0)
        && (parameters.VIS[model.visit.vis].field1=='1' || model.owningContact.iscompany=='1' || user.hasRight('MANINV'));
    }
    return result;
  };

  $scope.canRenderItemlist = function(purpose) {
    var result=false;
    if(("visit" in model) && model.visit && ("id" in model.visit)) {
      if(purpose=="ARTICLELIST") {
        result=true;
      } else {
        var nonZeroItems=tools.exclude(tools.join(model.visit,'items',model),{'deltatopay':0.0});
        var hasNonInvoicedItems=tools.getLength(tools.match(nonZeroItems,{'invoice':'0'}))>0;
        var hasB2CTurnoverItems=tools.getLength(nonZeroItems.filter(function(item) {
          return item.invoice!=='0' && (!(item.invoice in model.invoices) || model.invoices[item.invoice].visit==='0');
        }));
        var hasOpenDownpayment=tools.getLength(tools.exclude(Object.values(tools.join(model.visit,'items',model).filter(function(item) {
          return item.replaced=='0' && item.itm.substr(0,5)=='ZDOWN';
        })),{'quantity':'0'}))>0
        result=(!webservice.calling) && (model.visit.stat>=2000) && (model.visit.stat<=9000)
          && (((purpose=="PROFORMA" || purpose=="ANY") && (hasNonInvoicedItems || hasOpenDownpayment))
            || ((purpose=="B2CTURNO" || purpose=="ANY") && hasB2CTurnoverItems));
      }
    }
    return result;
  };

  $scope.getItemListWsParams = function(purpose) {
    var result="{}";
    if(angular.isDefined($scope.itemListOptions) && ("visit" in model) && model.visit && ("id" in model.visit)) {
      result=angular.toJson({
        "a":webservice.auth,
        "s":retrieveForEmpScript,
        "t":"printItemList",
        "p":{"visitId":$scope.itemListOptions.visit,"description":$scope.itemListOptions.description,"compacted":$scope.itemListOptions.compacted,'purpose':purpose}
      });
    }
    return result;
  };

  $scope.sendItemListEmail = function(purpose) {
    if($scope.validateEmail()) {
      webservice.exclusiveCall("generateEmailSignature",{"visitId":model.visit.id,"purpose":purpose},retrieveForEmpScript,model).then(function(response) {
        var communicationContact=model.visit.communicationcontact=='0'?model.owningContact:model.communicationContact;
        var toMailOptions=[communicationContact.email];
        if(communicationContact.email!==model.owningContact.email && model.owningContact.email!=='') {
          toMailOptions.unshift(model.owningContact.email);
        }
        var ccMails=[];
        if(tools.getLength(toMailOptions)>1) {
          for(var i=1;i<tools.getLength(toMailOptions);i++) {
            ccMails.push(toMailOptions[i]);
          }
        }
        var label=purpose=='PROFORMA'?{"en":"Proforma_Invoice","nl":"Proforma_Faktuur","fr":"Facture_Proforma"}:{"en":"Bill","nl":"Rekening","fr":"Compte"};
        emailbox.showTemplate(model.fromMailOptions,toMailOptions,ccMails,[],response.subject,tools.label(parameters.DVS[model.visit.dvs]).replaceAll(' ','_')+'_'+label[communicationContact.lang]+"_V"+model.visit.id+".pdf",'<div class="editable"></div>',false,response.signatures).then(function(result) {
          webservice.exclusiveCall('sendItemListEmail',{
            'visitId':$scope.itemListOptions.visit,
            'description':$scope.itemListOptions.description,
            'compacted':$scope.itemListOptions.compacted,
            'fromMail':result.fromMail,
            'recipient':result.recipient,
            'cc':result.cc,
            'bcc':result.bcc,
            'subject':result.subject,
            'body':result.body,
            'purpose':purpose
          },retrieveForEmpScript,model).then($scope.init);
        });
      });
    }
  };

  $scope.createDownpaymentInvoice = function() {
    webservice.exclusiveCall("createDownpaymentInvoice",{'visitId':model.visit.id,'amount':model.downpaymentAmount},retrieveForEmpScript,model).then($scope.init);
  };

  $scope.createInvoice = function() {
    webservice.confirmModal(tools.lang({'en':'Confirm create balance invoice','nl':'Bevestig saldo factuur maken','fr':'Confirme cr\u00E9er facture solde'})).then(function() {
      webservice.exclusiveCall("createInvoice",{'visitId':model.visit.id,'description':model.invoiceDescription},retrieveForEmpScript,model).then($scope.init);
    });
  };

  $scope.startMovementEdit = function(movement) {
    model.backupMovements[movement.id]=tools.clone(movement);
    movement.editing=true;
  }

  $scope.cancelMovementEdit = function(movement) {
    model.movements[movement.id]=model.backupMovements[movement.id];
  }

  $scope.updateMovement = function(movement) {
    webservice.exclusiveCall("updateMovement",{'movement':movement},retrieveForEmpScript,model).then($scope.init);
  };

  $scope.deleteMovement = function(movement) {
    webservice.confirmModal(tools.lang({'en':'Delete ','nl':'Verwijder ','fr':'Supprimer '})+tools.amountOut(movement.amount)+'€ '+tools.label(parameters.MTH[model.accounts[movement.account].method])).then(function() {
      webservice.exclusiveCall("deleteMovement",{'movement':movement},retrieveForEmpScript,model).then($scope.init);
    });
  };

  $scope.updateInvoice = function(invoice) {
    webservice.exclusiveCall("updateInvoice",{'invoice':invoice},retrieveForEmpScript,model).then($scope.init);
  };

  var invoiceLabel={"en":"Invoice","nl":"Faktuur","fr":"Facture"};
  $scope.sendInvoiceEmail = function(invoice) {
    if($scope.validateEmail()) {
      webservice.exclusiveCall('loadInvoiceAccountingEntryId',{
        'invoiceId':invoice.id
      },retrieveForEmpScript,model).then(function() {
        webservice.exclusiveCall("generateEmailSignature",{"visitId":model.visit.id,"purpose":'INVOICE'},retrieveForEmpScript,model).then(function(response) {
          var updatedInvoice=tools.join(model.visit,'invoices',model).find(function(inv) { return inv.id === invoice.id; });
          var communicationContact=model.visit.communicationcontact=='0'?model.owningContact:model.communicationContact;
          var toMailOptions=[communicationContact.email];
          if(communicationContact.email!==model.owningContact.email && model.owningContact.email!=='') {
            toMailOptions.unshift(model.owningContact.email);
          }
          var ccMails=[];
          if(tools.getLength(toMailOptions)>1) {
            for(var i=1;i<tools.getLength(toMailOptions);i++) {
              ccMails.push(toMailOptions[i]);
            }
          }
          emailbox.showTemplate(model.fromMailOptions,toMailOptions,ccMails,[],response.subject,tools.label(parameters.DVS[updatedInvoice.dvs]).replaceAll(' ','_')+'_'+invoiceLabel[communicationContact.lang]+"_"+updatedInvoice.dvs+updatedInvoice.accountingentryid+".pdf",'<div class="editable"></div>',false,response.signatures).then(function(result) {
            webservice.exclusiveCall('sendInvoiceEmail',{
              'invoiceId':updatedInvoice.id,
              'fromMail':result.fromMail,
              'recipient':result.recipient,
              'cc':result.cc,
              'bcc':result.bcc,
              'subject':result.subject,
              'body':result.body
            },retrieveForEmpScript,model).then($scope.init);
          });
        });
      });
    }
  };

  $scope.loadInvoiceAccountingEntryId = function(invoice) {
    webservice.call('loadInvoiceAccountingEntryId',{
      'invoiceId':invoice.id
    },retrieveForEmpScript,model).then($scope.init);
  };

  $scope.assignSoldQuotation = function() {
    $uibModal.open({
      'templateUrl': 'app/modules/b2b/assignModal.html',
      'controller': 'AssignModalController',
      'resolve': {
        'visit': function() {
          return model.visit;
        },
        'contacts': function() {
          return model.contacts;
        },
        'users': function() {
          return model.users;
        },
        'rights': function() {
          return model.rights;
        },
        'script': function() {
          return listQoutationsScript
        }
      }
    }).result.then(function() {
      $scope.init();
    });
  };

  $scope.cancelVisit = function() {
    webservice.deleteConfirm(model.contacts[model.visit.owningcontact].name,'cancel',model.visit.id,listQoutationsScript,model).then(function() {
      $scope.init();
    });
  };

  $scope.migrateVisit = function() {
    webservice.exclusiveCall('migrateVisit',{'visitId':model.visit.id},retrieveForEmpScript,model).then(function(response) {
      $scope.init();
    });
  }

  model.task="r";
  tools.initAttributes(model,{
    'calling':false,
    'action':$sce.trustAsResourceUrl(config.get('serviceUrl')),
    'days':{},
    'downpaymentAmount':'',
    'invoiceDescription':'',
    'backupMovements':{},
    'showCorrectedMovements':false
  });

}]);

angular.module('app').controller('ActivitiesReservationsController',['$scope','tools','modelstore','parameters','activitiesService','webservice','errorlog','emailbox',
                                            function($scope,tools,modelstore,parameters,activitiesService,webservice,errorlog,emailbox) {

  var script='activities/reservations';
  var model=modelstore.getModel(script);
  $scope.model=model;
  $scope.activitiesService=activitiesService;

  $scope.load = function() {
    modelstore.cleanModel(['contacts','visits','activities','participants','meals','dishes','hotelreservationcategories','hotelreservationproducts','items'],model);
    webservice.exclusiveCall('load',{},script,model).then(function() {
      var i,j,eventCollectionName,collection,event;
      for(i in model.meals) {
        event=model.meals[i];
        event.hrs=event.mea;
      }
      for(i in model.hotelreservationcategories) {
        event=model.hotelreservationcategories[i];
        event.day=event.startdate;
        event.hrs=event.starthrs;
      }
      model.events={};
      var eventCollectionNames=['activities','meals','hotelreservationcategories'];
      for(i in eventCollectionNames) {
        eventCollectionName=eventCollectionNames[i];
        collection=model[eventCollectionName];
        for(j in collection) {
          event=collection[j];
          event.table=eventCollectionName;
          if(!(event.visit in model.events)) {
            model.events[event.visit]=[];
          }
          model.events[event.visit].push(event);
        }
      }
    });
  };
  
  $scope.validate = function(visit) {
    var communicationContact=visit.communicationcontact=='0'?model.contacts[visit.owningcontact]:model.contacts[visit.communicationcontact];
    if(!communicationContact.email || communicationContact.email.length<=0) {
      errorlog.receiveError('Invalid email');
      return;
    }
    webservice.call('generateEmail',{'id':visit.id},script,model).then(function(response) {
      if(response) {
        emailbox.showTemplate(response.fromMailOptions,[response.recipient],response.cc,response.bcc,response.subject,response.attachment,response.body,false,{}).then(function(result) {
          webservice.exclusiveCall('emailAndValidate',{
            'id':visit.id,
            'fromMail':result.fromMail,
            'recipient':result.recipient,
            'cc':result.cc,
            'bcc':result.bcc,
            'subject':result.subject,
            'body':result.body,
            'mai':response.mai
          },script,model).then(function() {
            $scope.load();
          });
        });
      }
    });
  };
  
  $scope.cancel = function(visit) {
    webservice.deleteConfirm(model.contacts[visit.owningcontact].name,'cancel',visit.id,script,model).then(function() {
      $scope.load();
    });
  };

  tools.initAttributes(model,{
    'events':{}
  });
  webservice.afterLogin().then(function() {
    $scope.load();
  });
  
}]);
angular.module("app").controller("ActivitiesPasserelleController",["$scope","tools","modelstore","parameters","webservice","config",
                                            function($scope,tools,modelstore,parameters,webservice,config) {

  var script='activities/passerelle';
  var model=modelstore.getModel(script);
  $scope.model=model;

  $scope.load = function() {
    if(tools.validateAndUpdateDates(model)) {
      webservice.exclusiveCall("load",{
        'startdate':tools.dateFromJava(model.startdate),
        'enddate':tools.dateFromJava(model.enddate)
      },script,model);
    }
  };

  if(!("startdate" in model)) {
    tools.initDates(0,0,model);
  }
  tools.initAttributes(model,{
    'startdateOpened':false,
    'enddateOpened':false,
    'dateOptions':{
      maxDate: new Date(2099,11,31),
      minDate: new Date(2000,0,1),
      startingDay: 1
    },
    "frms":['KAYBNO','KAYCHO']
  });
  webservice.afterLogin().then(function() {
    $scope.load();
  });
  $scope.$watch("model.startdate.getTime()",function(newVal,oldVal) {
    if(oldVal==model.enddate.getTime()) {
      model.enddate=new Date();
      model.enddate.setTime(newVal);
    }
    $scope.load();
  });
  $scope.$watch("model.enddate.getTime()",$scope.load);
  
}]);
angular.module("app").controller("ActivitiesMovementsController",["$scope","$sce","$stateParams","$q","$timeout","config","tools","modelstore","webservice","errorlog","emailbox","user","ctep","cashless",
                                                                 function($scope,$sce,$stateParams,$q,$timeout,config,tools,modelstore,webservice,errorlog,emailbox,user,ctep,cashless) {

  var model=$scope.model;
  $scope.ctep=ctep;
  $scope.cashless=cashless;

  $scope.startCashlessPayment = function(amount) {
    cashless.start(model.visit.id,amount,model).then(function() {
      $scope.init();
    });
  };

  $scope.singleCashlessVerify = function() {
    cashless.singleVerify().then(function() {
      $scope.init();
    });
  };
  
  $scope.updateToPay = function() {
    if(!("payment" in model)) {
      model.payment={
        'amount':0,
        'method':'CSH',
        'voucherid':''
      };
    }
    model.totalAmount=0.0;
    model.toPay=0.0;
    if("visit" in model) {
      var params={
        'participants':tools.join(tools.join(model.visit,'activities',model),'participants',model),
        'dishes':tools.join(tools.join(model.visit,'meals',model),'dishes',model),
        'hotelreservationcategories':tools.join(model.visit,'hotelreservationcategories',model),
        'products':tools.join(model.visit,'products',model)
      };
      params.hotelreservationproducts=tools.join(params.hotelreservationcategories,'hotelreservationproducts',model);
      params.items=tools.inverseJoin(params.participants,'items','item',model).concat(
        tools.inverseJoin(params.dishes,'items','item',model),
        tools.inverseJoin(params.products,'items','item',model),
        tools.inverseJoin(params.hotelreservationcategories,'items','item',model),
        tools.inverseJoin(params.hotelreservationproducts,'items','item',model)
      );
      model.totalAmount=Math.round((tools.sum(Object.values(tools.match(params.items,{'replaced':'0','ignoreaccounting':'0'}).filter(function(item) {
        return item.itm.substr(0,5)!='ZDOWN';
      })),'nettopay'))*100)/100;
      model.toPay=Math.round((model.totalAmount-tools.sum(tools.join(model.visit,'movements',model),'amount'))*100)/100;
    }
    model.payment.amount=tools.amountOut(model.toPay);
  };
  $scope.$on("updateToPay",$scope.updateToPay);

  tools.initAttributes(model,{
  });
  webservice.afterLogin().then(function() {
    cashless.selectSingleMachine();
  });
  
}]);

angular.module("app").controller("ListVisitController",["$scope","$uibModal","$log","tools","modelstore","parameters","webservice","emailbox","user",
                                            function($scope,$uibModal,$log,tools,modelstore,parameters,webservice,emailbox,user) {

  var script='activities/listVisit';
  var model=modelstore.getModel(script);
  $scope.model=model;

  $scope.anyUser={'id':'','name':tools.lang({'en':'--All--','nl':'--Alle--','fr':'--Tout--'})};

  $scope.calculatePaymentAmounts = function() {
    var i,j,visit,message,balance,items,item;
    for(i in model.balances) {
      balance=model.balances[i];
      visit=model.visits[balance.visit];
      visit.paidAmount=balance.paidamount;
      visit.creditvoucher=balance.creditvoucher;
      visit.voucher=false;
      visit.messages=tools.join(visit,'emails',model);
      for(j in visit.messages) {
        message=visit.messages[j];
        if(message.mai=='VOUCHER') {
          visit.voucher=true;
          break;
        }
      }
      if(visit.voucher && tools.amountIn(visit.creditvoucher)==tools.amountIn(visit.paidAmount)) {
        delete model.visits[balance.visit];
      }
    }
  };

  $scope.load = function() {
    modelstore.cleanModel(['visits','movements','items'],model);
    webservice.exclusiveCall("load",{
      'startdate':tools.dateFromJava(model.startdate),
      'enddate':tools.dateFromJava(model.enddate),
      'typeOption':model.typeOption,
      'quotationmanager':model.quotationmanager
    },script,model).then(function() {
      $scope.calculatePaymentAmounts();
    });
  };

  $scope.changeOrdering = function(ordering) {
    if(model.ordering==ordering) {
      model.reverse=!model.reverse;
    } else {
      model.ordering=ordering;
      if(ordering=='startdate') {
        model.reverse=true;
      }
    }
  };

  if(!("startdate" in model)) {
    tools.initDates(0,1,model);
  }
  tools.initAttributes(model,{
    'enddateOpened':false,
    'startdateOpened':false,
    'dateOptions':{
      maxDate: new Date(2020,10,19),
      minDate: new Date(2020,9,23),
      startingDay: 1
    },
    'quotationmanager':'',
    'reverse':false,
    'ordering':'startdate',
    'typeOptions':[],
    'typeOption':'P'
  });
  webservice.afterLogin().then(function() {
    if(model.typeOptions.length==0) {
      model.typeOptions=[
        {'id':'P','labelen':'Private','labelnl':'Particulier','labelfr':'Priv\u00E9'},
        {'id':'O','labelen':'Organisation','labelnl':'Organisatie','labelfr':'Organisation'}
      ];
      model.quotationmanager=user.id
    }
    $scope.load();
  });
  
}]);
angular.module("app").component('itemComponent',{
  templateUrl: 'app/modules/activities/itemComponent.html',
  bindings: {
    parentRecord:'=',
    item:'=',
    task:'<',
    editing:'<',
    canModifyQuantity:'<',
    canEditItemReduction:'<',
    canModifyPrice:'<',
    maxQuantity:'<',
    availableCapacity:'<',
    visit:'<',
    showDelete:'<',
    onDelete:'&',
    indent:'<',
    onQuantityChange:'&'
  },
  controller:function(tools,parameters,accountingService) {
    var ctrl=this;
    ctrl.tools=tools;
    ctrl.parameters=parameters;
    ctrl.accountingService=accountingService;

    ctrl.getQuantityLabel = function() {
      var result;
      if(ctrl.parentRecord.table=='participants') {
        result=tools.label(parameters.UNT[ctrl.parentRecord.unt]);
      } else if(ctrl.parentRecord.table=='dishes') {
        if(ctrl.parentRecord.dsh in parameters.DSH) {
          if(parameters.DSH[ctrl.parentRecord.dsh].field1=='1') {
            result=ctrl.parentRecord.quotationtitle;
          } else {
            result=tools.label(parameters.DSH[ctrl.parentRecord.dsh]);
          }
        } else {
          result="";
        }
      } else if(ctrl.parentRecord.table=='hotelreservationcategories') {
        if(ctrl.parentRecord.requestedhsc!='') {
          result=tools.label(parameters.HSC[ctrl.parentRecord.requestedhsc])
        } else {
          result=tools.lang({'en':'Rooms','nl':'Kamers','fr':'Chambres'});
        }
      } else if(ctrl.parentRecord.table=='hotelreservationproducts') {
        result=tools.label(parameters.HPD[ctrl.parentRecord.hpd]);
      } else {
        result="";
      }
      return result;
    };

    ctrl.getPriceBeforeReduction = function() {
      var result;
      if("item" in ctrl && ctrl.item) {
        result=tools.amountIn(ctrl.item.grossunitprice)*tools.amountIn(ctrl.item.quantity);
      } else {
        result=0.0;
      }
      return result;
    };

    ctrl.getPriceAfterReduction = function() {
      var result;
      if("item" in ctrl && ctrl.item) {
        if(ctrl.item.reductionpercent=='1') {
          result=(100.0-tools.amountIn(ctrl.item.reductionamount))*ctrl.getPriceBeforeReduction()/100.0;
        } else {
          result=ctrl.getPriceBeforeReduction()-tools.amountIn(ctrl.item.reductionamount);
        }
      } else {
        result=0.0;
      }
      return result;
    };

    ctrl.isFixedPrice = function() {
      return ctrl.item && ctrl.item.pricecalc===accountingService.ITEM_PRICECALC_REVERSE;
    };

    ctrl.$onInit = function() {
      if("item" in ctrl && ctrl.item) {
        ctrl.item.oldQuantity=ctrl.item.quantity;
      }
    };

  }
});

angular.module("app").controller("ActivitiesEditController",["$scope","$stateParams","$state","$location","$uibModal","$q","$timeout","$sce","$log","config","tools","modelstore","user","parameters","activitiesService","hotelsService","webservice","ctep","errorlog",
                                                         function($scope,$stateParams,$state,$location,$uibModal,$q,$timeout,$sce,$log,config,tools,modelstore,user,parameters,activitiesService,hotelsService,webservice,ctep,errorlog) {
  $scope.editScript="activities/edit";
  $scope.createScript="activities/createForEmp";
  $scope.retrieveScript='activities/retrieveForEmp';
  var model=$scope.model;
  $scope.config=config;
  $scope.activitiesService=activitiesService;
  $scope.hotelsService=hotelsService;
  $scope.ctep=ctep;

  $scope.empty = {'id':'','labelen':'undefined','labelnl':'ongedefinieerd','labelfr':'indefini'};

  $scope.watchActivity = function(activity) {
    var activityId=activity.id;
    if($scope.watchedActivityIds.indexOf(activityId)<=-1) {
      $scope.watchedActivityIds.push(activityId);
      $scope.$watch("model.activities["+activityId+"].day",function() {
        $scope.updateActivityDetails(model.activities[activityId]);
      },true);
    }
  };

  $scope.addContact = function() {
    model.backupContacts['communication']=tools.clone(model.communicationContact);
    model.communicationContact=model.existingCommunicationContact;
    model.task='u';
  };

  $scope.getMaxDate = function() {
    var maxDate=model.visit.startdate;
    var visitElements=Object.values(model.activities).concat(Object.values(model.meals)).concat(Object.values(model.hotelreservationcategories));
    var i,visitElement,day;
    for(i in visitElements) {
      visitElement=visitElements[i];
      day=(visitElement.table=='hotelreservationcategories')?visitElement.startdate:visitElement.day;
      if(day>maxDate) {
        maxDate=day;
      }
    }
    return tools.dateFromJava(maxDate);
  };

  $scope.getWarningMessage = function() {
    return tools.lang({
      'en':'WARNING: Departure time is not publicly available',
      'nl':'OPGELET: Vertrektijd is niet publiek beschikbaar',
      'fr':'ATTENTION: D\u00E9part n\u0027est pas publiquement disponible'
    });
  }

  $scope.initActivity = function(activity) {
    tools.initAttributes(activity,{
      'table':'activities',
      'isCreated':false,
      'createdDate':new Date(),
      'visit':model.visit.id,
      'stat':'1000',
      'day':$scope.getMaxDate(),
      'dayOpened':false,
      'act':activity.frm.substr(0,3),
      'hrs':'',
      'comment':'',
      'quotationtitle':'',
      'quotationdescription':'',
      'quotationhidefoto':'0',
      'availabilities':{},
      'skipGetAvailability':false,
      'isOpen':true,
      'editing':true,
      'selected':false
    });
  }

  $scope.createActivity = function() {
    var frm=parameters.VIS[model.visit.vis].field6;
    if(angular.isUndefined(parameters.notDelFRM[frm])) {
      frm=tools.first(parameters.notDelFRM).id;
    }
    var activity={
      'id':tools.getMinIdMinusOne(model.activities),
      'frm':frm,
      'act':frm.substring(0,3),
    }
    $scope.initActivity(activity);
    modelstore.addRecord("activities",activity,model);
    $scope.fillParticipants(activity);
    $scope.watchActivity(activity);
    return activity;
  };
  $scope.$on("createActivity",$scope.createActivity);

  $scope.createVisitElement = function() {
    if(model.task=='r') {
      model.task='u';
      model.validated=model.visit.stat>=3000;
    }
  };

// TODO als er een invoice bestaat, dan deleteElement op alles, als er geen invoice bestaaat dan call naar deleteVisit
  // $scope.startDeleteAll = function() {
  //   var i;
  //   var visitElements=tools.join(model.visit,'activities',model).concat(tools.join(model.visit,'meals',model),tools.join(model.visit,'products',model),tools.join(model.visit,'hotelreservationcategories',model));
  //   var len=tools.getLength(visitElements);
  //   webservice.confirmModal(webservice.deleteConfirmLabel[webservice.user.lang]+' '+tools.lang({'en':'all elements','nl':'alle elementen','fr':'tous les \u00E9l\u00E9ments'})+'?').then(function() {  
  //     for(i=0;i<len;i++) {
  //       if(i+1===len) {
  //         $scope.deleteInvoicedItems(tools.join(model.visit,'items',model));
  //       } else {
  //         $scope.deleteElement(visitElements[i]);
  //       }
  //     }
  //     $scope.updateVisit();
  //   });      
  // };

  $scope.deleteElement = function(element) {
    if(element.table=='activities') {
      $scope.deleteActivity(element);
    } else if(element.table=='meals') {
      $scope.deleteMeal(element);
    } else if(element.table=='products') {
      $scope.deleteProduct(element);
    } else if(element.table=='hotelreservationcategories') {
      $scope.deleteHotelreservationcategory(element);
    }
  };

  $scope.deleteVisitElement = function(visitElement) {
    // if(model.validated) {
    //   errorlog.error(tools.lang({'en':'Cannot delete an item from a validated visit','nl':'Kan een element van een gevalideerd bezoek niet verwijderen','fr':"Impossible de supprimer un élément d'une visite validée"}));
    //   return;
    // } else if(model.itemCount <= 1) {
    //   errorlog.error(tools.lang({'en':'Cannot delete the last item of a visit','nl':'Kan het laatste element van een bezoek niet verwijderen','fr':"Impossible de supprimer le dernier élément d'une visite"}));
    //   return;
    // } else if(!visitElement.hasNoInvoice) {
    //   errorlog.error(tools.lang({'en':'Cannot delete an item from an invoiced visit','nl':'Kan een item van een gefactureerd bezoek niet verwijderen','fr':"Impossible de supprimer un élément d'une visite facturée"}));
    //   return;
    // }
    var confirmed;
    if(visitElement.isCreated) {
      confirmed=webservice.confirmModal(webservice.deleteConfirmLabel[webservice.user.lang]+' '+visitElement.name+'?');
    } else {
      confirmed=$q.resolve();
    }
    confirmed.then(function() {
      // TODO delete visit als het de laatste is
      $scope.deleteElement(visitElement);
      if(visitElement.isCreated) {
        $scope.updateVisitRecords();
      } else {
        $scope.sortVisitElements();
        if(model.editingCount==0 && model.task=='u') {
          model.task='r';
        }
      }
    });
  };
  
  $scope.deleteActivity = function(activity) {
    var participants=tools.join(activity,"participants",model);
    var i,participant;
    if(activity.hasNoInvoice || !activity.isCreated) {
      for(i in participants) {
        participant=participants[i];
        modelstore.removeRecord("participants",participant.id,model);
        modelstore.removeRecord("items",participant.item,model);
      }
      modelstore.removeRecord("activities",activity.id,model);
    } else {
      $scope.deleteInvoicedItems(tools.inverseJoin(participants,'items','item',model));
    }
  };

  $scope.getAct = function(activity) {
    if(model.task=='r' && ('frm' in activity)) {
      return activity.frm.substr(0,3);
    } else {
      return activity.act;
    }
  };

  $scope.getAvailableActs = function() {
    var result=tools.toArray(parameters.combinationFilter(parameters.notDelACT,'VISACTA',model.visit.vis));
    return result;
  };

  $scope.watchMeal = function(meal) {
    var mealId=meal.id;
    if($scope.watchedMealIds.indexOf(mealId)<=-1) {
      $scope.watchedMealIds.push(mealId);
      $scope.$watch("model.meals["+mealId+"].day",function() {
        $scope.updateMealDetails(model.meals[mealId]);
      },true);
    }
  };

  $scope.initMeal = function(meal) {
    tools.initAttributes(meal,{
      'table':'meals',
      'isCreated':false,
      'createdDate':new Date(),
      'visit':model.visit.id,
      'stat':'1000',
      'day':$scope.getMaxDate(),
      'dayOpened':false,
      'hrs':'',
      'res':'',
      'delivery':'0',
      'comment':'',
      'quotationhidefoto':'0',
      'peoplecount':Math.max(1,model.visit.quotationparticipants),
      'oldPeoplecount':Math.max(1,model.visit.quotationparticipants),
      'availabilities':{},
      'skipGetAvailability':false,
      'isOpen':true,
      'editing':true,
      'selected':false,
      'categories':[]
    })
  }

  $scope.createMeal = function(createDish) {
    var meal={
      'id':tools.getMinIdMinusOne(model.meals),
    };
    $scope.initMeal(meal);
    modelstore.addRecord("meals",meal,model);
    $scope.watchMeal(meal);
    if(createDish) {
      $scope.createDish(meal);
    }
    $scope.sortVisitElements();
    return meal;
  };

  $scope.deleteMeal = function(meal) {
    var dishes=tools.join(meal,"dishes",model);
    if(meal.hasNoInvoice || !meal.isCreated) {
      for(var i in dishes) {
        $scope.deleteDish(dishes[i]);
      }
      modelstore.removeRecord("meals",meal.id,model);
    } else {
      $scope.deleteInvoicedItems(tools.inverseJoin(dishes,'items','item',model));
    }
  };

  $scope.initItem = function(item) {
    tools.initAttributes(item,{
      'isCreated':false,
      'visit':model.visit.id,
      'reductionpromotion':'0',
      'reductionpro':'',
      'reductionamount':'0',
      'reductionpercent':'1',
      'quantity': 0,
      'customprice':'0',
      'grossunitprice':'0',
      'deltatopay':'0',
      'invoice':'0',
      'cgr':'XX',
      'advancedAttributes':model.visit.automaticreduction!='1'
    });
  }

  $scope.createItem = function(quantity,cgr) {
    var item={
      'id':tools.getMinIdMinusOne(model.items),
      'quantity':quantity,
      'cgr':cgr
    };
    $scope.initItem(item);
    item.quantity=quantity;
    item.cgr=cgr;
    item.planningquantity=item.quantity;
    item.oldQuantity=item.quantity;
    item.initialQuantity=item.quantity;
    modelstore.addRecord("items",item,model);
    $scope.syncReductions();
    return item.id;
  };

  $scope.deleteInvoicedItems = function(items) {
    var i,item;
    for(i in items) {
      item=items[i];
      item.quantity='0';
      item.planningquantity='0';
      item.oldQuantity='0';
    }
  };

  $scope.initDish = function(dish) {
    tools.initAttributes(dish,{
      'isCreated':false,
      'category':'Undefined',
      'dshs':[],
      'dsh':'',
      'quotationtitle':'',
      'quotationdescription':''
    });
  }

  $scope.createDish = function(meal) {
    var dish={
      'id':tools.getMinIdMinusOne(model.dishes),
      'meal':meal.id,
      'item':$scope.createItem(Math.max(1,model.visit.quotationparticipants,meal.peoplecount),'XX'),
    }
    $scope.initDish(dish);
    modelstore.addRecord("dishes",dish,model);
    return dish;
  };

  $scope.deleteDish = function(dish) {
    var dishItem=tools.inverseJoin([dish],'items','item',model);
    var dishHasInvoicedItems=tools.exclude(dishItem.concat(tools.inverseJoin(dishItem,'items','replaces',model)),{'invoice':'0'}).length==0;
    if(dishHasInvoicedItems || !dish.isCreated) {
      modelstore.removeRecord("items",dish.item,model);
      modelstore.removeRecord("dishes",dish.id,model);
    } else {
      $scope.deleteInvoicedItems(dishItem);
    }
  };

  $scope.initProduct = function(product) {
    tools.initAttributes(product,{
      'isCreated':false,
      'visit':model.visit.id,
      'category':'Undefined',
      'prds':[],
      'stat':'1000',
      'prd':'',
      'invoicewording':'',
      'transferred':'0',
      'isOpen':true,
      'editing':true,
      'selected':false,
      'skipGetAvailability':false
    })
  }

  $scope.createProduct = function() {
    var product={
      'id':tools.getMinIdMinusOne(model.products),
      'item':$scope.createItem('1','XX'),
    };
    $scope.initProduct(product);
    modelstore.addRecord("products",product,model);
    $scope.updateProductDetails(product);
    $scope.sortVisitElements();
    return product;
  };

  $scope.deleteProduct = function(product) {
    if(product.hasNoInvoice || !product.isCreated) {
      modelstore.removeRecord("items",product.item,model);
      modelstore.removeRecord("products",product.id,model);
    } else {
      $scope.deleteInvoicedItems(tools.inverseJoin([product],'items','item',model));
    }
  };

  $scope.initParticipant = function(participant) {
    tools.initAttributes(participant,{
      'table':'participants',
      'isCreated':false
    })
  }
  
  $scope.fillParticipants = function(activity) {
    tools.initAttribute("participants",{},model);
    var untId,participants,participant,quantity;
    participants=tools.join(activity,'participants',model);
    for(untId in parameters.notDelUNT) {
      if(activitiesService.matchesFormula(untId,activity.frm)) {
        if(tools.getLength(tools.match(participants,{'unt':untId}))==0) {
          if(parameters.UNT[untId].field2=="1") {
            if(parameters.UNT[untId].field1!="0") {
              quantity=Math.max(1,Math.ceil(model.visit.quotationparticipants/parameters.UNT[untId].field1));
            } else {
              quantity='1';
            }
          } else {
            quantity='0';
          }
          participant={
            "id":tools.getMinIdMinusOne(model.participants),
            "activity":activity.id,
            "item":$scope.createItem(quantity,parameters.UNT[untId].field8),
            "unt":untId
          };
          $scope.initParticipant(participant);
          modelstore.addRecord("participants",participant,model);
        }
      }
    }
  };

  $scope.setMealCategories = function(meal) {
    meal.categories=(("notDelArrayDSH" in parameters) && meal.res!='')?Object.keys(parameters.notDelArrayDSH.filter(function(dsh){
      return dsh.id.substr(0,3)==meal.res;
    }).reduce(function(acc,dsh) {
      if(dsh.field2==='') {
        acc['Undefined']=true;
      } else {
        acc[dsh.field2]=true;
      }
      return acc;
    },{})):[];
    var dishes=tools.join(meal,'dishes',model);
    for(var i in dishes) {
      $scope.onUpdateDishCategory(dishes[i]);
    }
  };
  $scope.$on("setMealCategories",function(event,args) {
    $scope.setMealCategories(args);
  });

  $scope.onUpdateDishCategory = function(dish) {
    var meal=model.meals[dish.meal];
    if(meal.categories.indexOf(dish.category)<0 && dish.dsh in parameters.DSH) {
      dish.category=(parameters.DSH[dish.dsh].del==='1' && parameters.DSH[dish.dsh].field2!=='')?parameters.DSH[dish.dsh].field2:'Undefined';
      if(meal.categories.indexOf(dish.category)<0) {
        meal.categories.push(dish.category);
      }
    }
    if(dish.category==='Undefined' && meal.categories.length===1) {
      dish.category=meal.categories[0];
    }
    dish.dshs=("notDelArrayDSH" in parameters)?parameters.notDelArrayDSH.filter(function(dsh) {
      return dsh.id.substr(0,3)==meal.res && dsh.field2===(dish.category==='Undefined'?'':dish.category);
    }):[];
    if((dish.dsh in parameters.DSH) && parameters.DSH[dish.dsh].field2!==(dish.category==='Undefined'?'':dish.category)) {
      dish.dsh='';
      $scope.updateMealDetails(meal);
    }
  };
  $scope.$on("onUpdateDishCategory",function(event,args) {
    $scope.onUpdateDishCategory(args);
  });

  $scope.setProductCategories = function(product) {
    product.categories=("notDelArrayPRD" in parameters)?Object.keys(parameters.notDelArrayPRD.reduce(function(acc,prd) {
      if(prd.field3==='') {
        acc['Undefined']=true;
      } else {
        acc[prd.field3]=true;
      }
      return acc;
    },{})):[];
    $scope.onUpdateProductCategory(product);
  };

  $scope.onUpdateProductCategory = function(product) {
    if(product.categories.indexOf(product.category)<0) {
      product.category=((product.prd in parameters.PRD) && parameters.PRD[product.prd].del===1 && parameters.PRD[product.prd].field3!=='')?parameters.PRD[product.prd].field3:'Undefined';
    }
    if(product.category==='Undefined' && product.categories.length===1) {
      product.category=product.categories[0];
    }
    product.prds=("notDelArrayPRD" in parameters)?parameters.notDelArrayPRD.filter(function(prd) {
      return prd.field3===(product.category==='Undefined'?'':product.category);
    }):[];
    if((product.prd in parameters.PRD) && parameters.PRD[product.prd].field3!==(product.category==='Undefined'?'':product.category)) {
      product.prd='';
      $scope.updateProductDetails(product);
    }
  };

  $scope.orderItems = function(item) {
    var result=parseInt(item.id);
    if(!item.isCreated) {
      result=1000000000-result;
    }
    return result;
  }

  $scope.selectAct = function(activity,act) {
    if(activity.frm.substr(0,3)!==act.id) {
      var possibleFrms=activitiesService.activityFilter(parameters.notDelFRM,'id',act.id);
      activity.frm="";
      if(tools.getLength(possibleFrms)>1) {
        var defaultFrms=tools.exclude(possibleFrms,{'field2':'0'});
        if(tools.getLength(defaultFrms)===1) {
          activity.frm=tools.first(defaultFrms).id;
        }
      } else if(tools.getLength(possibleFrms)===1) {
        activity.frm=tools.first(possibleFrms).id;
      }
      if(activity.frm!="") {
        $scope.fillParticipants(activity);
      }
    }
    activity.act=act.id;
    $scope.syncReductions();
    $scope.updateActivityDetails(activity);
  };

  $scope.updateActivityDetails = function(activity) {
    var result=null;
    if(activity) {
      if(activity.skipGetAvailability) {
        activity.skipGetAvailability=false;
      } else {
        var day=tools.dateFromJava(activity.day);
        if(day.length===10 && activity.frm.length===6) {
          activity.availabilities=[];
          result=webservice.call("updateActivityDetails",{'day':day,'frm':activity.frm,'visit':model.task=='c'?'':activity.visit},$scope.editScript,model).then(function(response) {
            if(response!==false) {
              activity=model.activities[activity.id];
              if(response.availabilities.available) {
                activity.availabilities=response.availabilities.hrs;
              }
              activity.prices=response.prices;
              if(activity.hrs=='') {
                var i,availableHrs;
                var now=tools.now();
                for(i in activity.availabilities) {
                  availableHrs=activity.availabilities[i];
                  if(availableHrs.available && availableHrs.hrs>now && (activity.hrs=='' || availableHrs.hrs<activity.hrs)) {
                    activity.hrs=availableHrs.hrs;
                  }
                }
              }
              $scope.sortVisitElements();
              $scope.calculatePrices();
            }
          });
        }
      }
    }
    return result;
  };
  $scope.$on("updateActivityDetails",function(event,args) {
    $scope.updateActivityDetails(args.activity);
  });

  $scope.getActivityHrsLoad = function(activity,hrs) {
    var i,participant,unt,act,starthrs,endhrs,duration;
    var load=hrs.load;
    for(i in model.participants) {
      participant=model.participants[i];
      act=model.activities[participant.activity];
      duration=tools.amountIn(parameters.FRM[act.frm].field1);
      starthrs=$scope.getHour(act.day,act.hrs,duration,true);
      endhrs=$scope.getHour(act.day,act.hrs,duration,false);
      unt=parameters.UNT[participant.unt];
      if(activity.id!==participant.activity && activity.frm.substring(0,3)===unt.id.substring(0,3) && tools.dateFromJava(act.day)===tools.dateFromJava(activity.day) && unt.field4!=='' && hrs.hrs>starthrs && hrs.hrs<endhrs) {
        load+=tools.amountIn(model.items[participant.item].planningquantity)*Math.max(1,unt.field1);
      }
    }
    return Math.min(load,hrs.cap);
  }

  $scope.getActivityAvailableCapacity = function(activity,participant) {
    var i,part,act,actEndhrs,capacityLeft,duration;
    if(activity.hrs!=='' && activity.frm!=='' && angular.isDefined(activity.availabilities)) {
      duration=tools.amountIn(parameters.FRM[activity.frm].field1);
      var activityEndhrs=$scope.getHour(activity.day,activity.hrs,duration,false);
      var cpgId=parameters.UNT[participant.unt].field4;
      if(activity.frm.substring(0,3)===participant.unt.substring(0,3) && cpgId!=='' && angular.isDefined(activity.availabilities[activity.hrs])) {
        capacityLeft=activity.availabilities[activity.hrs].left[participant.unt];
        for(i in model.participants) {
          part=model.participants[i];
          act=model.activities[part.activity];
          duration=tools.amountIn(parameters.FRM[act.frm].field1);
          actEndhrs=$scope.getHour(act.day,act.hrs,duration,false);
          if(part.id!==participant.id && parameters.UNT[part.unt].field4===cpgId && tools.dateFromJava(act.day)===tools.dateFromJava(activity.day) && (act.hrs>=activity.hrs && act.hrs<activityEndhrs || actEndhrs>activity.hrs && actEndhrs<=activityEndhrs)) {
            capacityLeft-=tools.amountIn(model.items[part.item].planningquantity);
          }
        }
        capacityLeft=Math.max(capacityLeft,0);
      }
    }
    return capacityLeft;
  }

  $scope.getHour = function(day,hrs,duration,negative) {
    var hour;
    var addHours=(negative?-1:1)*1000*60*60*duration;
    var time=new Date(tools.timestampToJava(tools.dateFromJava(day)+' '+hrs).valueOf()+addHours);
    var newDate=tools.dateToJava(tools.dateFromJava(time));
    if(day<newDate) {
      hour='23:59:59';
    } else if(day>newDate) {
      hour='00:00:00';
    } else {
      hour=tools.hourFromJava(time);
    }
    return hour;
  }

  $scope.updateMealDetails = function(meal) {
    if(meal) {
      if(meal.skipGetAvailability) {
        meal.skipGetAvailability=false;
      } else {
        var day=tools.dateFromJava(meal.day);
        if(day.length===10 && meal.res!=='') {
          meal.prices={};
          var dshs=[];
          var dishes=tools.join(meal,"dishes",model);
          for(var i in dishes) {
            if(dishes[i].dsh.length===6) {
              dshs.push(dishes[i].dsh);
            }
          }
          webservice.call("updateMealDetails",{'day':day,'dshs':dshs,'res':meal.res,'visit':model.task=='c'?'':meal.visit},$scope.editScript,model).then(function(response) {
            if(response!==false) {
              meal=model.meals[meal.id];
              if(response.availabilities.available) {
                meal.availabilities=response.availabilities.hrs;
              }
              meal.prices=response.prices;
              if(meal.hrs=='') {
                var i,availableHrs;
                var now=tools.now();
                for(i in meal.availabilities) {
                  availableHrs=meal.availabilities[i];
                  if(availableHrs.available && availableHrs.hrs>now && (meal.hrs=='' || availableHrs.hrs<meal.hrs)) {
                    meal.hrs=availableHrs.hrs;
                  }
                }
              }
              $scope.sortVisitElements();
              $scope.calculatePrices();
            }
          });
        }
      }
    }
  };
  $scope.$on("updateMealDetails",function(event,args) {
    $scope.updateMealDetails(args.meal);
  });

  $scope.getMealHrsLoad = function(meal,hrs) {
    var i,res,mea,starthrs,endhrs,duration;
    var load=hrs.load;
    for(i in model.meals) {
      mea=model.meals[i];
      if(mea.res!=='' && mea.hrs!=='') {
        res=parameters.RES[mea.res];
        duration=tools.amountIn(res.field4);
        starthrs=$scope.getHour(mea.day,mea.hrs,duration,true);
        endhrs=$scope.getHour(mea.day,mea.hrs,duration,false);
        if(meal.id!==mea.id && meal.res===res.id && tools.dateFromJava(meal.day)===tools.dateFromJava(mea.day) && res.field5!=='' && hrs.hrs>starthrs && hrs.hrs<endhrs) {
          load+=tools.amountIn(mea.peoplecount);
        }
      }
    }
    return Math.min(load,hrs.cap);
  }

  $scope.getMealAvailableCapacity = function(meal) {
    var i,res,duration,mea,meaEndhrs,capacityLeft,duration;
    if(meal.hrs!=='' && meal.res!=='' && angular.isDefined(meal.availabilities)) {
      res=parameters.RES[meal.res];
      duration=tools.amountIn(res.field4);
      var mealEndhrs=$scope.getHour(meal.day,meal.hrs,duration,false);
      var cpgId=res.field5;
      if(cpgId!=='' && angular.isDefined(meal.availabilities[meal.hrs])) {
        capacityLeft=meal.availabilities[meal.hrs].left[meal.res];
        for(i in model.meals) {
          mea=model.meals[i];
          if(mea.res!=='' && mea.hrs!=='') {
            res=parameters.RES[mea.res];
            duration=tools.amountIn(res.field4)
            meaEndhrs=$scope.getHour(mea.day,mea.hrs,duration,false);
            if(mea.id!==meal.id && res.field5===cpgId && tools.dateFromJava(mea.day)===tools.dateFromJava(meal.day) && (mea.hrs>=meal.hrs && mea.hrs<mealEndhrs || meaEndhrs>meal.hrs && meaEndhrs<=mealEndhrs)) {
              capacityLeft-=tools.amountIn(mea.peoplecount);
            }
          }
        }
        capacityLeft=Math.max(capacityLeft,0);
      }
    }
    return capacityLeft;
  }

  $scope.updateProductDetails = function(product) {
    if(product) {
      if(product.skipGetAvailability) {
        product.skipGetAvailability=false;
      } else {
        if(product.prd.length===3) {
          webservice.call("updateProductDetails",{'prd':product.prd},$scope.editScript,model).then(function(response) {
            if(response!==false) {
              var item=model.items[product.item];
              item.standardunitprice=tools.amountIn(response);
              if(item.customprice=="0") {
                item.grossunitprice=item.standardunitprice
              }
              $scope.syncReductions();
            }
          });
        }
      }
    }
  };
  $scope.$on("updateProductDetails",function(event,args) {
    $scope.updateProductDetails(args.product);
  });

  $scope.duplicateHotelreservationcategory = function(hotelreservationcategory) {
    var duplicateFields=['table','visit','htl','startdate','starthrs','enddate','oldEnddate','oldDaydiff','hra','quotationhidefoto','quotationparticipants'];
    var duplicateHotelreservationcategory={
      'isCreated':false,
      'createdDate':new Date(),
      'id':tools.getMinIdMinusOne(model.hotelreservationcategories),
      'startdateOpened':false,
      'enddateOpened':false,
      'isOpen':true,
      'editing':true,
      'selected':false,
      'skipGetAvailability':false,
      'pricings':{},
      'checkedIn':false,
      'checkedOut':false,
      'spacetype':'',
      'requestedhsc':'',
      'adultcount':'2',
      'childcount':'0',
      'item':$scope.createItem('1','XX'),
      'spacetypes':[],
      'updatePermissions':{'updateFields':{'startdate':false,'enddate':false,'starthrs':false,'childcount':false,'adultcount':false}},
      'hscs':[],
      'hpdOptions':{}
    };
    duplicateHotelreservationcategory=tools.copyFields(hotelreservationcategory,duplicateHotelreservationcategory,duplicateFields);
    modelstore.addRecord("hotelreservationcategories",duplicateHotelreservationcategory,model);
    $scope.watchHotelreservationcategory(duplicateHotelreservationcategory);
    $scope.onUpdateUnitcounts(duplicateHotelreservationcategory);
    $scope.updateHotelreservationcategoryAvailabilities(duplicateHotelreservationcategory);
    $scope.sortVisitElements();
    return duplicateHotelreservationcategory;
  }

  $scope.initHotelreservationcategory = function(hotelreservationcategory) {
    tools.initAttributes(hotelreservationcategory,{
      'table':'hotelreservationcategories',
      'isCreated':false,
      'createdDate':new Date(),
      'visit':model.visit.id,
      'htl':'',
      'startdate':$scope.getMaxDate(),
      'startdateOpened':false,
      'starthrs':'15:00:00',
      'enddate':tools.addDays($scope.getMaxDate(),1),
      'enddateOpened':false,
      'oldEnddate':tools.addDays($scope.getMaxDate(),1),
      'oldDaydiff':1,
      'hra':'',
      'quotationhidefoto':'0',
      'quotationparticipants':'1',
      'isOpen':true,
      'editing':true,
      'selected':false,
      'skipGetAvailability':false,
      'pricings':{},
      'spacetype':'',
      'requestedhsc':'',
      'adultcount':'2',
      'childcount':'0',
      'spacetypes':[],
      'hscs':[],
      'updatePermissions':{'updateFields':{'startdate':true,'enddate':true,'starthrs':true,'childcount':true,'adultcount':true}},
      'hpdOptions':{}
    })
  }

  $scope.createHotelreservationcategory = function() {
    var nextMonth=new Date();
    nextMonth.setMonth(nextMonth.getMonth()+1);
    var maxDate=$scope.getMaxDate();
    var enddate=tools.dateToJava(maxDate);
    enddate.setDate(enddate.getDate()+1);
    var starthrs='15:00:00';
    var filteredStarthrs=$scope.getFilteredStarthrs({'startdate':tools.dateToJava(maxDate)});
    if(tools.getLength(filteredStarthrs)>0 && !(filteredStarthrs.reduce(function(match,filteredStarthr) {return match || filteredStarthr.id===starthrs;},false))) {
      filteredStarthrs.shift();
      starthrs=tools.first(filteredStarthrs).id;
    }
    var hotelreservationcategory={
      'id':tools.getMinIdMinusOne(model.hotelreservationcategories),
      'item':$scope.createItem('1','XX')
    };
    $scope.initHotelreservationcategory(hotelreservationcategory);
    modelstore.addRecord("hotelreservationcategories",hotelreservationcategory,model);
    $scope.watchHotelreservationcategory(hotelreservationcategory);
    $scope.onUpdateUnitcounts(hotelreservationcategory);
    $scope.sortVisitElements();
    return hotelreservationcategory;
  };

  $scope.deleteHotelreservationcategory = function(hotelreservationcategory) {
    var i,hotelreservationproducts,hotelreservationproductItems,hotelreservationproductItem,hotelreservationproduct;
    hotelreservationproducts=tools.join(hotelreservationcategory,"hotelreservationproducts",model);
    if((hotelreservationcategory.hasNoInvoice || !hotelreservationcategory.isCreated) && !hotelreservationcategory.checkedIn && !hotelreservationcategory.checkedOut) {
      for(i in hotelreservationproducts) {
        hotelreservationproduct=hotelreservationproducts[i];
        modelstore.removeRecord("items",hotelreservationproduct.item,model);
        modelstore.removeRecord("hotelreservationproducts",hotelreservationproduct.id,model);
      }
      modelstore.removeRecord("items",hotelreservationcategory.item,model);
      modelstore.removeRecord("hotelreservationcategories",hotelreservationcategory.id,model);
    } else {
      $scope.deleteInvoicedItems(tools.inverseJoin([hotelreservationcategory],'items','item',model));
      hotelreservationproductItems=tools.inverseJoin(hotelreservationproducts,'items','item',model);
      for(i in hotelreservationproductItems) {
        hotelreservationproductItem=hotelreservationproductItems[i];
        hotelreservationproductItem.standardunitprice=0;
        if(!(("customprice" in hotelreservationproductItem) && hotelreservationproductItem.customprice=="1")) {
          hotelreservationproductItem.grossunitprice=hotelreservationproductItem.standardunitprice;
        }
      }
    }
  };

  $scope.selectHtl = function(hotelreservationcategory,hotel) {
    if(hotelreservationcategory.htl!=hotel.id) {
      hotelreservationcategory.hra=parameters.notDelArrayHRA.reduce(function(acc,hra) {
        return hra.id.substr(0,3)==hotel.id && hra.field3==='1'?hra.id:acc;
      },'');
      hotelreservationcategory.spacetype='';
      hotelreservationcategory.requestedhsc='';
      hotelreservationcategory.spacetypes=[];
      hotelreservationcategory.hscs=[];
      hotelreservationcategory.htl=hotel.id;
      $scope.setHotelreservationcategoryDateAndHpdOptions(hotelreservationcategory);
    }
  };

  $scope.watchHotelreservationcategory = function(hotelreservationcategory) {
    var hotelreservationcategoryId=hotelreservationcategory.id;
    if($scope.watchedHotelreservationcategoryIds.indexOf(hotelreservationcategoryId)<=-1) {
      $scope.watchedHotelreservationcategoryIds.push(hotelreservationcategoryId);
      $scope.$watch("model.hotelreservationcategories["+hotelreservationcategoryId+"].startdate",function(newVal,oldVal) {
        if(newVal!=oldVal && angular.isDefined(oldVal)) {
          var oldValidated=model.validated;
          model.validated=false;
          $scope.updateHotelreservationcategoryAvailabilities(model.hotelreservationcategories[hotelreservationcategoryId]).then(function() {
            model.validated=model.validated;
            $scope.sortVisitElements();
          });
        }
      },true);
      $scope.$watch("model.hotelreservationcategories["+hotelreservationcategoryId+"].enddate",function(newVal,oldVal) {
        if(newVal!=oldVal && angular.isDefined(oldVal)) {
          var oldValidated=model.validated;
          model.validated=false;
          $scope.updateHotelreservationcategoryAvailabilities(model.hotelreservationcategories[hotelreservationcategoryId]).then(function() {
            model.validated=model.validated;
            $scope.sortVisitElements();
          });
        }
      },true);
      $scope.$watch("model.hotelreservationcategories["+hotelreservationcategoryId+"].hra",function(newVal,oldVal) {
        if(newVal!=oldVal && angular.isDefined(oldVal)) {
          var oldValidated=model.validated;
          model.validated=false;
          $scope.updateHotelreservationcategoryAvailabilities(model.hotelreservationcategories[hotelreservationcategoryId]).then(function() {
            model.validated=model.validated;
          });
        }
      },true);
    }
  };

  $scope.closeHotelreservationcategoryDates = function(hotelreservationcategory) {
    $timeout(function() {
      hotelreservationcategory.startdateOpened=false;
      hotelreservationcategory.enddateOpened=false;
    },0);
  };

  $scope.updateHotelreservationcategoryAvailabilities = function(hotelreservationcategory) {
    var result=$q.reject();
    if(hotelreservationcategory) {
      $scope.closeHotelreservationcategoryDates(hotelreservationcategory);
      if(hotelreservationcategory.oldDaydiff===1 && hotelreservationcategory.enddate && hotelreservationcategory.oldEnddate.getTime()===hotelreservationcategory.enddate.getTime()) {
        hotelreservationcategory.enddate=tools.addDays(hotelreservationcategory.startdate,1);
      }
      hotelreservationcategory.oldDaydiff=tools.dayDiff(hotelreservationcategory.startdate,hotelreservationcategory.enddate);
      hotelreservationcategory.oldEnddate=tools.clone(hotelreservationcategory.enddate);
      if(!model.validated && hotelreservationcategory.htl!=='' && hotelreservationcategory.startdateISO && hotelreservationcategory.startdateISO!=='' && hotelreservationcategory.enddateISO && hotelreservationcategory.enddateISO!=='') {
        if(hotelreservationcategory.enddate<hotelreservationcategory.startdate) {
          //errorlog.error(tools.lang({'en':'Departure date must be after arrival date','nl':'Vertrekdatum moet na aankomstdatum komen','fr':'Date de d\u00E9part doit etre apres Date d\u0027arriv\u00E9e'}));
        } else {
          hotelreservationcategory=tools.clone(hotelreservationcategory);
          hotelreservationcategory.startdate=tools.dateFromJava(hotelreservationcategory.startdate);
          hotelreservationcategory.enddate=tools.dateFromJava(hotelreservationcategory.enddate);
          result=webservice.call('updateHotelreservationcategoryAvailabilities',{'hotelreservationcategory':tools.whitelist(hotelreservationcategory,['htl','startdate','starthrs','enddate','hra','visit','requestedhsc'])},$scope.editScript,model).then(function(response) {
            var hotelreservationcategory2=model.hotelreservationcategories[response.hotelreservationcategoryId];
            hotelsService.setHotelreservationcategoryUpdatePermissions(model.visits[hotelreservationcategory2.visit],hotelreservationcategory2,tools.join(hotelreservationcategory2,'hotelspaceassignments',model));
            $scope.closeHotelreservationcategoryDates(hotelreservationcategory2);
            hotelreservationcategory2.availableRooms=response.availabilities;
            if("pricings" in response) {
              hotelreservationcategory2.pricings=response.pricings
            }
            $scope.onUpdateUnitcounts(hotelreservationcategory2);
          });
        }
      }
    }
    return result;
  };

  $scope.validateReservationcategoryQuantity = function(hotelreservationcategory,field) {
    var maxQuantity=false;
    var isCreated=hotelreservationcategory.isCreated;
    var hsc,label;
    if(field==='adultcount') {
      label={'en':'"Adults per room"','nl':'"Volwassenen per kamer"','fr':'"Adultes par chambre"'};
      if(isCreated && angular.isDefined(parameters.HSC[hotelreservationcategory.requestedhsc])) {
        hsc=parameters.HSC[hotelreservationcategory.requestedhsc];
        maxQuantity=tools.amountIn(hsc.field3)+tools.amountIn(hsc.field4)-tools.amountIn(hotelreservationcategory.childcount);
      }
    } else if(field==='childcount') {
      label={'en':'"Children per room"','nl':'"Kinderen per kamer"','fr':'"Enfants par chambre"'};
      if(isCreated && angular.isDefined(parameters.HSC[hotelreservationcategory.requestedhsc])) {
        hsc=parameters.HSC[hotelreservationcategory.requestedhsc];
        maxQuantity=tools.amountIn(hsc.field3)+tools.amountIn(hsc.field4)-tools.amountIn(hotelreservationcategory.adultcount);
      }
    }
    $scope.validateQuantity(hotelreservationcategory,0,maxQuantity,label,field);
  }

  $scope.validateQuantity = function(item,min,max,label,field) {
    if(angular.isUndefined(field)) {
      field='quantity';
    }
    var isQuantity=field==='quantity';
    // if(angular.isUndefined(label)) {
    //   label={'en':field,'nl':field,'fr':field};
    // }
    if(min!==false && tools.amountIn(item[field])<tools.amountIn(min)) {
      item[field]=tools.amountIn(min);
      errorlog.error(tools.lang({'en':'Minimum value reached for ','nl':'Minimum aantal bereikt voor ','fr':'Nombre minimum atteint pour '})+tools.lang(label));
    }
    if(max!==false && tools.amountIn(item[field])>tools.amountIn(max)) {
      item[field]=tools.amountIn(max);
      if(isQuantity) {
        item.oldQuantity=tools.amountIn(max);
        item.planningquantity=tools.amountIn(max);
      }
      errorlog.error(tools.lang({'en':'Maximum value reached for ','nl':'Maximun aantal bereikt voor ','fr':'Nombre maximum atteint pour '})+tools.lang(label));
    }
    if(isQuantity) {
      item.oldQuantity=item[field];
      item.planningquantity=item[field];
    }
  }

  $scope.getAllValidHscs = function(hotelreservationcategory) {
    var result;
    if("availableRooms" in hotelreservationcategory) {
      var availableRooms=hotelreservationcategory.availableRooms;
      result=Object.keys(availableRooms).filter(function(hscId) {
        var hsc=parameters.HSC[hscId];
        return hsc.del!=="1" && hsc.field5!=="" && hsc.field6==="1" && Math.min.apply(null,availableRooms[hscId])>0
          && parseInt(hsc.field3,10)>=parseInt(hotelreservationcategory.adultcount,10)
          && parseInt(hsc.field3,10)+parseInt(hsc.field4,10)>=parseInt(hotelreservationcategory.adultcount,10)+parseInt(hotelreservationcategory.childcount,10);
      });
    } else {
      result=[];
    }
    return result;
  };

  $scope.filterHscs = function(hotelreservationcategory,hscs) {
    var result=[];
    var reservationcategory=tools.clone(hotelreservationcategory);
    var i,hscAdditionalInfo,capacity;
    for(i in hscs) {
      hscAdditionalInfo=hscs[i];
      reservationcategory.requestedhsc=hscAdditionalInfo.hscId;
      capacity=$scope.getReservationcategoryCapacity(reservationcategory);
      if(capacity?capacity>0:true) {
        result.push(hscAdditionalInfo);
      }
    }
    return result;
  }

  $scope.onUpdateUnitcounts = function(hotelreservationcategory) {
    $scope.validateReservationcategoryQuantity(hotelreservationcategory,'adultcount');
    $scope.validateReservationcategoryQuantity(hotelreservationcategory,'childcount');
    hotelreservationcategory.spacetypes=Object.keys($scope.getAllValidHscs(hotelreservationcategory).reduce(function(spacetypes,hscId) {
      spacetypes[parameters.HSC[hscId].field5]=true;
      return spacetypes;
    },{}));
    if(hotelreservationcategory.spacetypes.indexOf(hotelreservationcategory.spacetype)<0) {
      hotelreservationcategory.spacetype='';
    }
    if(hotelreservationcategory.spacetype==='') {
      if(hotelreservationcategory.spacetypes.length===1) {
        hotelreservationcategory.spacetype=hotelreservationcategory.spacetypes[0];
      } else if(hotelreservationcategory.spacetypes.indexOf('Room')>=0) {
        hotelreservationcategory.spacetype='Room';
      }
    }
    $scope.onUpdateSpacetype(hotelreservationcategory);
  };

  $scope.onUpdateSpacetype = function(hotelreservationcategory) {
    if("availableRooms" in hotelreservationcategory) {
      var availableRooms=hotelreservationcategory.availableRooms;
      hotelreservationcategory.hscs=$scope.getAllValidHscs(hotelreservationcategory).filter(function(hscId) {
        return parameters.HSC[hscId].field5===hotelreservationcategory.spacetype;
      }).map(function(hscId) {
        return {'hscId':hscId,'hsc':parameters.HSC[hscId],'capacity':availableRooms[hscId]};
      }).sort(function(a,b) {
        return ('' + a.hsc.field2).localeCompare(b.hsc.field2);
      });
    } else {
      hotelreservationcategory.hscs=[];
    }
    if(!hotelreservationcategory.isCreated && tools.match(hotelreservationcategory.hscs,{'hscId':hotelreservationcategory.requestedhsc}).length===0) {
      hotelreservationcategory.requestedhsc='';
    }
    if(hotelreservationcategory.requestedhsc==='' && hotelreservationcategory.hscs.length===1) {
      hotelreservationcategory.requestedhsc=hotelreservationcategory.hscs[0].hscId;
    }
    $scope.onUpdateRequestedhsc(hotelreservationcategory);
  };

  $scope.fetchHotelreservationcategoryPricings = function(hotelreservationcategory) {
    webservice.exclusiveCall('fetchHotelreservationcategoryPricings',$scope.cleanParams({'hotelreservationcategories':[hotelreservationcategory]}),$scope.editScript,model).then(function(response) {
      var hotelreservationcategory2=model.hotelreservationcategories[response[0].hotelreservationcategoryId];
      hotelreservationcategory2.pricings=response[0].pricings;
      $scope.onUpdateRequestedhsc(hotelreservationcategory2);
    });
  };

  $scope.getReservationcategoryCapacity = function(hotelreservationcategory,requestedhsc) {
    var capacity=false;
    if(hotelreservationcategory.requestedhsc!=="" && angular.isUndefined(requestedhsc)) {
      requestedhsc=hotelreservationcategory.requestedhsc;
    }
    var extraRoomQuantity=tools.sum(tools.inverseJoin(tools.exclude(tools.match(model.hotelreservationcategories,{'requestedhsc':requestedhsc,'isCreated':false}),{'item':hotelreservationcategory.item}),'items','item',model),'quantity');
    if(tools.match(hotelreservationcategory.hscs,{'hscId':requestedhsc}).length===1 && !hotelreservationcategory.updatePermissions.allowOverbookedCapacity) {
      capacity=Math.min.apply(Math,tools.match(hotelreservationcategory.hscs,{'hscId':requestedhsc})[0].capacity)-extraRoomQuantity;
    }
    return capacity;
  }

  $scope.onUpdateRequestedhsc = function(hotelreservationcategory) {
    var item,hscItem,hotelreservationproduct,multiplier,oldMultiplier,capacity,maxQuantity;
    if(hotelreservationcategory) {
      hscItem=model.items[hotelreservationcategory.item];
      capacity=$scope.getReservationcategoryCapacity(hotelreservationcategory);
      if(capacity || (angular.isDefined(hotelreservationcategory.updatePermissions) && hotelreservationcategory.updatePermissions.allowOverbookedCapacity)) {
        maxQuantity=capacity;
      } else {
        maxQuantity=1;
      }
      $scope.validateQuantity(hscItem,0,maxQuantity,{'en':'"Room quantity"','nl':'"Kamer aantal"','fr':'"Nombres des chambres"'});
      if(angular.isDefined(hotelreservationcategory.pricings) && hotelreservationcategory.requestedhsc in hotelreservationcategory.pricings) {
        hscItem.standardunitprice=hotelreservationcategory.pricings[hotelreservationcategory.requestedhsc];
      } else {
        hscItem.standardunitprice=0;
      }
      if(!(("customprice" in hscItem) && hscItem.customprice=="1")) {
        hscItem.grossunitprice=hscItem.standardunitprice;
      }
      var hotelreservationproducts=tools.join(hotelreservationcategory,'hotelreservationproducts',model);
      for(var i in hotelreservationproducts) {
        hotelreservationproduct=hotelreservationproducts[i];
        item=model.items[hotelreservationproduct.item];
        multiplier=$scope.getHotelreservationproductMultiplier(hotelreservationproduct,'quantity');
        if(!item.created || tools.amountIn(item.standardunitprice)==0.0) {
          item.standardunitprice=parameters.HPD[hotelreservationproduct.hpd].field3*multiplier;
        }
        if(!(("customprice" in item) && item.customprice=="1")) {
          item.grossunitprice=item.standardunitprice;
        }      
      }
      $scope.syncReductions();
    }
  };

  $scope.onPeoplecountChange = function(meal) {
    var dishes=tools.join(meal,'dishes',model);
    var dish,item;
    for(var i in dishes) {
      dish=dishes[i];
      item=model.items[dish.item];
      if(tools.amountIn(item.quantity)===tools.amountIn(meal.oldPeoplecount)) {
        item.quantity=meal.peoplecount;
        $scope.onQuantityChange(dish,meal);
      }
    }
    meal.oldPeoplecount=meal.peoplecount;
  }

  $scope.onQuantityChange = function(record,parentrecord) {
    var item=model.items[record.item];
    var parentItem=angular.isDefined(parentrecord)?model.items[parentrecord.item]:false;
    if(tools.amountIn(item.planningquantity)===tools.amountIn(item.oldQuantity) || item.oldQuantity==='-') {
      item.planningquantity=item.quantity;
    }
    if(item.reductionpercent=='0') {
      if(Math.abs(item.oldQuantity)>0.005 && !parentItem) {
        item.unitreductionamount=item.reductionamount/item.oldQuantity;
      } else if(parentItem && Math.abs(parentItem.oldQuantity)>0.005 && Math.abs(item.oldQuantity)>0.005) {
        item.unitreductionamount=item.reductionamount/(item.oldQuantity*parentItem.oldQuantity)
      }
      if(parentItem) {
        item.reductionamount=(angular.isDefined(item.unitreductionamount)?item.unitreductionamount*parentItem.quantity*item.quantity:item.reductionamount);
      } else {
        item.reductionamount=(angular.isDefined(item.unitreductionamount)?item.unitreductionamount:item.reductionamount)*item.quantity;
      }
    }
    if(record.table=='hotelreservationcategories') {
      var hotelreservationproducts=tools.join(record,'hotelreservationproducts',model);
      for(var i in hotelreservationproducts) {
        $scope.onQuantityChange(hotelreservationproducts[i],record);
      }
    }
    if(record.table=='hotelreservationproducts') {
      var multiplier=$scope.getHotelreservationproductMultiplier(record,'quantity');
      if(!item.created || tools.amountIn(item.standardunitprice)==0.0) {
        item.standardunitprice=parameters.HPD[record.hpd].field3*multiplier;
      } else {
        var oldMultiplier=$scope.getHotelreservationproductMultiplier(record,'oldQuantity');
        item.standardunitprice=item.standardunitprice/oldMultiplier*multiplier;
      }
      if(!(("customprice" in item) && item.customprice=="1")) {
        item.grossunitprice=item.standardunitprice;
      }      
    }
    item.oldQuantity=item.quantity;
  };

  $scope.initHotelreservationproduct = function(hotelreservationproduct) {
    tools.initAttributes(hotelreservationproduct,{
      'table':'hotelreservationproducts',
      'isCreated':false
    })
  }

  $scope.createHotelreservationproduct = function(hotelreservationcategory) {
    if(angular.isDefined(hotelreservationcategory) && angular.isDefined(model.hpd) && angular.isDefined(model.hpd.id)) {
      var hotelreservationproduct={
        'id':tools.getMinIdMinusOne(model.hotelreservationproducts),
        'reservationcategory':hotelreservationcategory.id,
        'hpd':model.hpd.id,
        'item':$scope.createItem('1','XX')
      };
      model.hpd={};
      modelstore.addRecord("hotelreservationproducts",hotelreservationproduct,model);
      $scope.sortVisitElements();
      $scope.calculatePrices();
      $scope.syncReductions();
      return hotelreservationproduct;
    }
  };

  $scope.deleteHotelreservationproduct = function(hotelreservationproduct) {
    if(!hotelreservationproduct.isCreated) {
      modelstore.removeRecord("items",hotelreservationproduct.item,model);
      modelstore.removeRecord("hotelreservationproducts",hotelreservationproduct.id,model);
    } else {
      if(model.hotelreservationcategories[hotelreservationproduct.reservationcategory].updatePermissions.allowProductsUpdate) {
        $scope.deleteInvoicedItems(tools.inverseJoin([hotelreservationproduct],'items','item',model));
      } else {
        errorlog.error(tools.lang({
          'en':'The Mews API does not allow deleting hotel products',
          'nl':'De Mews API laat niet toe om hotel producten te verwijderen',
          'fr':'The Mews API does not allow deleting hotel products'
        }));
      }
    }
  };

  $scope.syncReductions = function() {
    if(model.task=='c' && model.reductionMode=='global') {
      var items=tools.join(model.visit,'items',model);
      var i,j,item,hotelreservationproduct,hpdId,product,prdId;
      for(i in items) {
        item=items[i];
        item.reductionpro=model.visit.reductionpro;
        item.reductionamount=tools.round(model.visit.reductionamount,2);
        item.reductionpercent='1';
      }
      var hotelreservationproducts=tools.join(tools.join(model.visit,'hotelreservationcategories',model),'hotelreservationproducts',model);
      for(i in hotelreservationproducts) {
        hotelreservationproduct=hotelreservationproducts[i];
        if(parameters.HPD[hotelreservationproduct.hpd].labelen=='City Tax') {
          item=model.items[hotelreservationproduct.item];
          item.reductionpro='';
          item.reductionamount='0';
        }
      }
      var products=tools.join(model.visit,'products',model);
      for(i in products) {
        product=products[i];
        if(parameters.PRD[product.prd].field2!=='1') {
          item=model.items[product.item];
          item.reductionpro='';
          item.reductionamount='0';
        }
      }      
    }
  };

  $scope.calculatePrices = function() {
    if("visit" in model && (model.task=='c' || (model.task=='u' && model.visit.stat<3000))) {
      var i,j,activity,meal,dishes,dish,hasValidDish,hotelreservationcategory,hotelreservationproducts,product;
      var params={
        'visit':model.visit,
        'activities':[],
        'participants':[],
        'meals':[],
        'dishes':[],
        'hotelreservationcategories':[],
        'hotelreservationproducts':[],
        'products':[]
      };
      var activities=tools.join(model.visit,'activities',model);
      for(i in activities) {
        activity=activities[i];
        if(activity.frm!=='') {
          if(activity.hrs==='') {
            activity=tools.clone(activity);
            activity.hrs=tools.first(activity.availabilities).hrs;
          }
          params.activities.push(activity);
          params.participants=params.participants.concat(activitiesService.formulaFilter(tools.join(activity,'participants',model),'unt',activity.frm));
        }
      }
      var meals=tools.join(model.visit,'meals',model);
      for(i in meals) {
        meal=meals[i];
        if(meal.res!=='') {
          if(meal.hrs==='') {
            meal=tools.clone(meal);
            meal.hrs=tools.first(parameters.notDelArrayHRS).id;
          }
          dishes=tools.join(meal,'dishes',model);
          hasValidDish=false;
          for(j in dishes) {
            dish=dishes[j];
            if(dish.dsh!='' && dish.dsh.substr(0,3)==meal.res) {
              params.dishes.push(dish);
              hasValidDish=true;
            }
          }
          if(hasValidDish) {
            params.meals.push(meal);
          }
        }
      }
      var hotelreservationcategories=tools.join(model.visit,'hotelreservationcategories',model);
      for(i in hotelreservationcategories) {
        hotelreservationcategory=hotelreservationcategories[i];
        if(hotelreservationcategory.htl!=='') {
          hotelreservationproducts=tools.join(hotelreservationcategory,'hotelreservationproducts',model);
          if(hotelreservationproducts.length>0) {
            params.hotelreservationproducts=params.hotelreservationproducts.concat(hotelreservationproducts);
          }
          params.hotelreservationcategories.push(hotelreservationcategory);
        }
      }
      var products=tools.join(model.visit,'products',model);
      for(i in products) {
        product=products[i];
        if(product.prd!=='') {
          params.products.push(product);
        }
      }
      params.items=tools.inverseJoin(params.participants,'items','item',model).concat(
        tools.inverseJoin(params.dishes,'items','item',model),
        tools.inverseJoin(params.products,'items','item',model),
        tools.inverseJoin(params.hotelreservationcategories,'items','item',model),
        tools.inverseJoin(params.hotelreservationproducts,'items','item',model)
      );
      var responseModel={};
      webservice.call("calculatePrices",$scope.cleanParams(params),"public/public",responseModel).then(function() {
        var itemFieldsToCopy=['standardunitprice'];
        if(model.visit.automaticreduction=='1') {
          itemFieldsToCopy=itemFieldsToCopy.concat(['reductionpro','reductionpromotion','reductionamount','reductionpercent']);
        }
        var k,l,responseItem,localItem,itemFieldToCopy;
        for(k in responseModel.items) {
          responseItem=responseModel.items[k];
          localItem=tools.copyFields(responseItem,model.items[responseItem.id],itemFieldsToCopy);
          if(localItem.customprice!='1' && ('standardunitprice' in localItem)) {
            localItem.grossunitprice=localItem.standardunitprice;
          }
        }
        if("updateToPay" in $scope) {
          $scope.updateToPay();
        }
        $scope.sortVisitElements();
      });
    }
  };

  $scope.startVisitEdit = function() {
    //$scope.edit();
    var collections=['activities','meals','hotelreservationcategories','products'];
    var i,j,collection,record;
    for(i in collections) {
      collection=collections[i];
      for(j in model[collection]) {
        record=model[collection][j];
        record.skipGetAvailability=true;
      }
    }
    model.backupVisit = tools.clone(model.visit);
    $scope.toggleAll(false);
    if(!model.visit.isOpen) {
      model.visit.isOpen=true;
    }
    model.visit.editing=true;
    model.task='u';
    model.advancedVisitAttributes=model.visit.vis!='DAD' || model.visit.lod!='XXX' || model.visit.address1!='' || model.visit.postalcode!='' || model.visit.address2!='' || model.visit.vatnumber!='';
    $scope.sortVisitElements();
  };

  $scope.cancelVisitEdit = function() {
    modelstore.cleanModel(["visits"],model);
    model.visit=model.backupVisit;
    modelstore.addRecord("visits",model.visit,model);
    model.visit.startdateISO=tools.dateFromJava(model.visit.startdate);
    model.visit.enddateISO=tools.dateFromJava(model.visit.enddate);
    model.task='r';
    $scope.sortVisitElements();
  };

  $scope.startVisitElementEdit = function(visitElement) {
    var i,j,collections,collection,record,advancedAttributes,recordsWithItem,item,hotelreservationcategories,hotelreservationproducts;
    if(visitElement.table=='activities') {
      recordsWithItem=tools.join(visitElement,'participants',model);
      collections={
        'activities':[visitElement],
        'participants':recordsWithItem,
        'items':tools.inverseJoin(recordsWithItem,'items','item',model)
      };
      visitElement.act=visitElement.frm.substr(0,3);
    } else if(visitElement.table=='meals') {
      recordsWithItem=tools.join(visitElement,'dishes',model);
      collections={
        'meals':[visitElement],
        'dishes':recordsWithItem,
        'items':tools.inverseJoin(recordsWithItem,'items','item',model)
      };
    } else if(visitElement.table=='hotelreservationcategories') {
      hotelreservationproducts=tools.join(visitElement,'hotelreservationproducts',model);
      recordsWithItem=[visitElement].concat(hotelreservationproducts);
      collections={
        'hotelreservationcategories':[visitElement],
        'hotelreservationproducts':hotelreservationproducts,
        'items':[model.items[visitElement.item]].concat(tools.inverseJoin(hotelreservationproducts,'items','item',model))
      };
    } else if(visitElement.table=='products') {
      recordsWithItem=[visitElement];
      collections={
        'products':recordsWithItem,
        'items':tools.inverseJoin([visitElement],'items','item',model)
      };
    }
    model.backupCollections={};
    for(i in collections) {
      collection=collections[i];
      model.backupCollections[i]={};
      for(j in collection) {
        record=collection[j];
        model.backupCollections[i][record.id]=tools.clone(record);
      }
    }
    var preparationIsDone;
    if(visitElement.table=='hotelreservationcategories') {
      var oldValidated=model.validated;
      model.validated=false;
      preparationIsDone=$scope.updateHotelreservationcategoryAvailabilities(visitElement).then(function() {
        model.validated=oldValidated;
      });
    } else {
      preparationIsDone=$q.resolve();
    }
    preparationIsDone.then(function() {
      $scope.toggleAll(false);
      visitElement.isOpen=true;
      visitElement.editing=true;
      model.task='u';
      for(i in recordsWithItem) {
        record=recordsWithItem[i];
        item=model.items[record.item];
        item.advancedAttributes=item.customprice=='1' || item.quantity!=item.planningquantity || model.visit.automaticreduction!='1';
        item.grossunitprice=tools.amountOut(item.grossunitprice);
      }
      $scope.sortVisitElements();
    });
  };

  $scope.cancelVisitElementEdit = function(visitElement) {
    if(visitElement.isCreated) {
      var i,j,collections,collectionName,collection,selected;
      if(visitElement.table=='activities') {
        collections=['activities','participants','items'];
      } else if(visitElement.table=='meals') {
        var dishes=tools.join(visitElement,'dishes',model);
        for(i in dishes) {
          modelstore.removeRecord("dishes",dishes[i].id,model);
        }
        collections=['meals','dishes','items'];
      } else if(visitElement.table=='products') {
        collections=['products','items'];
      } else if(visitElement.table=='hotelreservationcategories') {
        collections=['hotelreservationcategories','hotelreservationproducts','items'];
        var hotelreservationproducts=tools.join(visitElement,'hotelreservationproducts',model);
        for(i in hotelreservationproducts) {
          modelstore.removeRecord("hotelreservationproducts",hotelreservationproducts[i].id,model);
        }
      }
      for(i in collections) {
        collectionName=collections[i];
        collection=model.backupCollections[collectionName];
        for(j in collection) {
          selected=collection[j].selected;
          modelstore.addRecord(collectionName,collection[j],model);
          model[collectionName][j].selected=selected;
        }
        model.backupCollections[collectionName]={};
      }
    } else {
      $scope.deleteVisitElement(visitElement)
    }
    model.task='r';
    $scope.sortVisitElements();
  };

  $scope.startEditAll = function() {
    $scope.backupAllVisitElements();
    model.visit.isOpen=false;
    model.task='u';
    var collections=['activities','meals','products','hotelreservationcategories'];
    var i,j,collection,record,oldValidated;
    var allPreparationsAreDone=[];
    var oldValidated=model.validated;
    model.validated=false;
    for(i in collections) {
      collection=model[collections[i]];
      for(j in collection) {
        record=collection[j];
        if(record.table=='hotelreservationcategories') {
          allPreparationsAreDone.push($scope.updateHotelreservationcategoryAvailabilities(record));
        } else {
          allPreparationsAreDone.push($q.resolve());
        }
      }
    }
    return $q.all(allPreparationsAreDone).then(function() {
      model.validated=oldValidated;
      for(i in collections) {
        collection=model[collections[i]];
        for(j in collection) {
          record=collection[j];
          record.isOpen=(model.showVisitElementsWithZeroQuantity)?true:record.hasQuantity;
          record.editing=(model.showVisitElementsWithZeroQuantity)?true:record.hasQuantity;
        }
      }
      $scope.sortVisitElements();
    });
  };

  $scope.backupAllVisitElements = function() {
    var collections=['activities','participants','meals','dishes','hotelreservationcategories','hotelreservationproducts','products','items'];
    var i,j,collectionName,collection,record,item;
    model.backupCollections={};
    for(i in collections) {
      collectionName=collections[i];
      model.backupCollections[collectionName]={};
      collection=model[collectionName];
      for(j in collection) {
        record=collection[j];
        model.backupCollections[collectionName][record.id]=tools.clone(record);
      }
    }
    for(i in model.items) {
      item=model.items[i];
      item.advancedAttributes=item.customprice=='1' || item.quantity!=item.planningquantity || model.visit.automaticreduction!='1';
      item.grossunitprice=tools.amountOut(item.grossunitprice);
    }
  };

  $scope.cancelAllVisitElements = function() {
    var collections=['activities','participants','meals','dishes','hotelreservationcategories','hotelreservationproducts','products','items'];
    var i,j,collectionName,collection,record,selected;
    modelstore.cleanModel(collections,model);
    for(i in collections) {
      collectionName=collections[i];
      collection=model.backupCollections[collectionName];
      for(j in collection) {
        selected=collection[j].selected;
        modelstore.addRecord(collectionName,collection[j],model);
        model[collectionName][j].selected=selected;
      }
      model.backupCollections[collectionName]={};
    }
    model.task='r';
    $scope.sortVisitElements();
  }

  $scope.cancelAllContactEdits = function() {
    var contactNames=['owning','communication'];
    for(var i in contactNames) {
      var contactName=contactNames[i];
      modelstore.removeRecord("contacts",model[contactName+'Contact'].id,model);
      model[contactName+'Contact']=model.backupContacts[contactName];
      modelstore.addRecord("contacts",model[contactName+'Contact'],model);
    }
    model.task='r';
  };

  $scope.submit = function() {
    if(model.task=='c') {
      $scope.createVisit();
    } else if(model.task=="u") {
      $scope.updateVisitRecords();
    }
  };

  $scope.whitelistVisit = function(visit) {
    var visitWhitelist=['vis','dvs','tco','lod','owningcontact','communicationcontact','automaticreduction','campaign','refundaccount','comment','quotationparticipants','quotationpriceperperson','quotationdetailedprice','quotationcomment','quotationnotincluded','quotationmanager','quotationoptions','attention','operationsmanager','invoicesmanager','hotelexternalreservation'];
    if(model.task!='c' || model.view=='createQuotation') {
      visitWhitelist.push('startdate','enddate');
    }
    return tools.whitelist(visit,visitWhitelist);
  }

  $scope.whitelistContacts = function(contacts) {
    return tools.whitelist(contacts,["firstname","name","gsm","email","address1","postalcode","address2","lang","agreestomarketing","sal","iscompany","vatnumber","country"]);
  }

  $scope.cleanParams = function(params) {
    if("contacts" in params) {
      params.contacts=$scope.whitelistContacts(params.contacts);
    }
    if("visit" in params) {
      params.visit=$scope.whitelistVisit(params.visit);
    }
    if("activities" in params)
      params.activities=tools.whitelist(params.activities,['frm','day','hrs','comment','quotationtitle','quotationdescription','quotationhidefoto']);
    if("participants" in params)
      params.participants=tools.whitelist(params.participants,['activity','item','unt']);
    if("meals" in params)
      params.meals=tools.whitelist(params.meals,['day','hrs','res','delivery','comment','quotationhidefoto','peoplecount']);
    if("products" in params)
      params.products=tools.whitelist(params.products,['item','prd','invoicewording','transferred','comment']);
    if("dishes" in params)
      params.dishes=tools.whitelist(params.dishes,['meal','item','dsh','quotationtitle','quotationdescription']);
    if("hotelreservationcategories" in params)
      params.hotelreservationcategories=tools.whitelist(params.hotelreservationcategories,['htl','startdate','starthrs','enddate','hra','quotationhidefoto','quotationparticipants','requestedhsc','adultcount','childcount','item','externalreleaseddate']);
    if("hotelreservationproducts" in params)
      params.hotelreservationproducts=tools.whitelist(params.hotelreservationproducts,['reservationcategory','hpd','count','item']);
    if("items" in params)
      params.items=tools.whitelist(params.items,['itm','quantity','planningquantity','customprice','grossunitprice','reductionpro','reductionpromotion','reductionamount','reductionpercent','invoice','cgr'])
    var i,j,k,collection,record,param;
    for(i in params) {
      if(i==="visit") {
        collection=[params.visit];
      } else {
        collection=params[i];
      }
      for(j in collection) {
        record=collection[j];
        for(k in record) {
          if(angular.isDate(record[k])) {
            record[k]=tools.dateFromJava(record[k]);
          }
        }
      }
    }
    return params;
  };

  $scope.replaceParams = function() {
    var params={
      'contacts':[model.owningContact],
      'visit':model.visit,
      'activities':tools.join(model.visit,'activities',model),
      'participants':[],
      'meals':tools.join(model.visit,'meals',model),
      'hotelreservationcategories':tools.join(model.visit,'hotelreservationcategories',model),
      'products':tools.join(model.visit,'products',model)
    };
    if(model.visit.communicationcontact!='0') {
      params.contacts.push(model.communicationContact);
    }
    var i,activity,item;
    for(i in params.activities) {
      activity=params.activities[i];
      params.participants=params.participants.concat(activitiesService.formulaFilter(tools.join(activity,'participants',model),'unt',activity.frm));
    }
    params.dishes=tools.join(params.meals,'dishes',model);
    params.hotelreservationproducts=tools.join(params.hotelreservationcategories,'hotelreservationproducts',model);
    params.items=tools.inverseJoin(params.participants,'items','item',model).concat(
      tools.inverseJoin(params.dishes,'items','item',model),
      tools.inverseJoin(params.products,'items','item',model),
      tools.inverseJoin(params.hotelreservationcategories,'items','item',model),
      tools.inverseJoin(params.hotelreservationproducts,'items','item',model)
    );
    for(i in params.items) {
      item=params.items[i];
      if(tools.amountIn(item.reductionamount)==0) {
        item.reductionpercent='1';
        item.reductionpromotion='0';
        item.reductionpro='';
      } else {
        item.reductionamount=tools.amountIn(item.reductionamount);
      }
    }
    return $scope.cleanParams(params);
  };
  $scope.$on("replaceParamsForCreateVisitManual",function() {
    $scope.createVisitManualWithParams($scope.replaceParams());
  });
  $scope.$on("replaceParamsForCreateVisitCtep",function() {
    $scope.createVisitCtepWithParams($scope.replaceParams());
  });
  
  $scope.createVisit = function() {
    webservice.exclusiveCall('createVisit',$scope.replaceParams(),$scope.createScript,model).then(function(response) {
      model.visit.isCreated=true;
      model.visit={};
      $scope.init();
      $scope.sortVisitElements();
      $scope.visitRetrieve(response);
    });
  };

  $scope.updateVisitAndContacts = function() {
    var visit=tools.clone(model.visit);
    visit.startdate=tools.dateFromJava(visit.startdate);
    visit.enddate=tools.dateFromJava(visit.enddate);
    var contacts=[model.owningContact];
    if(model.communicationContact.id!=='0') {
      contacts.push(model.communicationContact);
    }
    webservice.exclusiveCall('updateVisitAndContacts',{'visit':$scope.whitelistVisit(visit),'contacts':$scope.whitelistContacts(contacts)},$scope.retrieveScript,model).then(function(response) {
      model.task='r';
      $scope.init();
    });
  };

  $scope.updateVisit = function() {
    var visit=tools.clone(model.visit);
    visit.startdate=tools.dateFromJava(visit.startdate);
    visit.enddate=tools.dateFromJava(visit.enddate);
    webservice.exclusiveCall('updateVisit',{'visit':$scope.whitelistVisit(visit)},$scope.retrieveScript,model).then(function(response) {
      if(response===true) {
        model.task='r';
        $scope.init();
      } else if(response==="U_DVS_HAS_INVOICED_ITEMS") {
        // todo: confirm to transfer all nonzero articles to a new visit with a different DVS
        errorlog.error(tools.lang({
          'en':'Modification of division is not allowed when there are invoiced items',
          'nl':'Wijziging van afdeling is niet toegestaan als er reeds gefactureerde items zijn',
          'fr':'Modification de la division n\u0027est pas autoris\u00E9e s\u0027il y a des articles factur\u00E9es'
        }));
        // webservice.confirmModal(tools.lang({
        //   '',
        //   '',
        //   ''
        // })).then(function() {
        //   var params={
        //     'mode':model.mode,
        //     'contacts':[],
        //     'visit':model.transferVisit,
        //     'activities':tools.join(model.transferVisit,'activities',model),
        //     'participants':[],
        //     'meals':tools.join(model.transferVisit,'meals',model),
        //     'dishes':[],
        //     'hotelreservationcategories':tools.join(model.transferVisit,'hotelreservationcategories',model),
        //     'hotelreservationproducts':[],
        //     'products':tools.join(model.transferVisit,'products',model)
        //   };
        //   if(model.transferVisit.id<0) {
        //     if(model.transferVisit.owningcontact!='0') {
        //       params.contacts.push(model.owningContact);
        //     }
        //     if(model.transferVisit.communicationcontact!='0') {
        //       params.contacts.push(model.communicationContact);
        //     }
        //   }
        //   var i,activity,item;
        //   for(i in params.activities) {
        //     activity=params.activities[i];
        //     params.participants=params.participants.concat(activitiesService.formulaFilter(tools.join(activity,'participants',model),'unt',activity.frm));
        //   }
        //   params.dishes=tools.join(params.meals,'dishes',model);
        //   params.hotelreservationproducts=tools.join(params.hotelreservationcategories,'hotelreservationproducts',model);
        //   params.items=tools.inverseJoin(params.participants,'items','item',model).concat(
        //     tools.inverseJoin(params.dishes,'items','item',model),
        //     tools.inverseJoin(params.products,'items','item',model),
        //     tools.inverseJoin(params.hotelreservationcategories,'items','item',model),
        //     tools.inverseJoin(params.hotelreservationproducts,'items','item',model)
        //   );

        //   var cleanedParams=$scope.cleanParams(params);
        //   cleanedParams['fromVisitId']=model.visit.id;
        //   webservice.exclusiveCall('transferVisitArticles',cleanedParams,$scope.retrieveScript,model).then(function(response2) {
        //     if(angular.isDefined(response2.id)) {
        //       $scope.visitRetrieve(response2.id);
        //     }
        //   });
        // });
      }
    });
  };

  $scope.updateVisitRecords = function() {
    webservice.exclusiveCall('updateVisitRecords',$scope.replaceParams(),$scope.retrieveScript,model).then(function(response) {
      model.task='r';
      $scope.init();
    });
  };

  $scope.migrateVisit = function() {
    webservice.exclusiveCall('migrateVisit',{'visitId':model.visit.id},$scope.retrieveScript,model).then(function(response) {
      model.task='r';
      $scope.init();
    });
  }

  $scope.canEditItemReduction = function() {
    return ((model.task=='c' && model.reductionMode=='item') || (model.task=='u' && model.visit.stat<3000)) && model.visit.automaticreduction!='1';
  };

  $scope.watchAll = function() {
    var activities=tools.join(model.visit,'activities',model);
    var i,activity;
    for(i in activities) {
      activity=activities[i];
      activity.dayOpened=false;
      $scope.watchActivity(activity);
    }
    var meals=tools.join(model.visit,'meals',model);
    for(i in meals) {
      $scope.watchMeal(meals[i]);
    }
    var hotelreservationcategories=tools.join(model.visit,'hotelreservationcategories',model);
    for(i in hotelreservationcategories) {
      $scope.watchHotelreservationcategory(hotelreservationcategories[i]);
    }
  };

  $scope.syncHotelreservationcategory = function(hotelreservationcategory) {
    webservice.exclusiveCall('syncHotelreservationcategory',{'hotelreservationcategoryId':hotelreservationcategory.id},$scope.retrieveScript,model).then(function() {
      $scope.init();
    });
  };

  $scope.getHotelreservationproductMultiplier = function(hotelreservationproduct,field) {
    var multiplier=0;
    if(hotelreservationproduct) {
      var hotelreservationcategory=model.hotelreservationcategories[hotelreservationproduct.reservationcategory];
      if(hotelreservationcategory) {
        var item=model.items[hotelreservationcategory.item];
        var multiplier=tools.amountIn(item[field]);
        var hpd=parameters.HPD[hotelreservationproduct.hpd];
        if(hpd.field2=="PerTimeUnit" || hpd.field2=="PerPersonPerTimeUnit") {
          multiplier*=tools.dayDiff(hotelreservationcategory.startdate,hotelreservationcategory.enddate);
        }
        if(hpd.field2=="PerPersonPerTimeUnit" || hpd.field2=="PerPerson") {
          multiplier*=tools.amountIn(hotelreservationcategory.adultcount)+tools.amountIn(hotelreservationcategory.childcount);
        }
      }
    }
    return multiplier;
  };

  $scope.sortVisitElements = function() {

    model.validated=model.task=='r' || (model.task=='u' && model.visit.stat>=3000);
    model.editingCount=model.visit.editing?1:0;

    var i,j,k,day,activity,activityItems,meal,mealItems,product,prd,productItem,record,slts,sltKeys,count,participants,participant,dishes,dish,dsh,firstSlt,peopleCount,quantityCount,loopdate,slt,hotelreservationcategory,hotelreservationcategoryItems,hotelreservationproducts,hotelreservationproduct;
    var daySlts=[];
    var activities=tools.join(model.visit,'activities',model);
    for(i in activities) {
      activity=activities[i];
      activity.table='activities';
      activity.name=activitiesService.activityDescription(activity);
      peopleCount=0;
      quantityCount=0;
      participants=tools.join(activity,'participants',model);
      for(j in participants) {
        participant=participants[j];
        peopleCount+=parseInt(parameters.UNT[participant.unt].field1)*parseInt(model.items[participant.item].planningquantity);
        quantityCount+=parseInt(model.items[participant.item].planningquantity);
      }
      activity.quantities=(peopleCount===0?quantityCount:peopleCount)+'';
      activity.joinedParticipants=[];
      participants=activitiesService.formulaFilter(participants,'unt',activity.frm);
      for(j in participants) {
        participant=participants[j];
        participant.table='participants';
        if(!model.validated || tools.amountIn(model.items[participant.item].quantity)+tools.amountIn(model.items[participant.item].planningquantity)!=0) {
          activity.joinedParticipants.push(participant);
        }
      }
      if(tools.getLength(activity.joinedParticipants)===0) {
        for(j in participants) {
          participant=participants[j];
          if(parameters.UNT[participant.unt].field2==1) {
            activity.joinedParticipants.push(participant);
          }
        }
      }
      activityItems=tools.inverseJoin(participants,'items','item',model);
      activity.hasNoInvoice=tools.exclude(activityItems.concat(tools.inverseJoin(activityItems,'items','replaces',model)),{'invoice':'0'}).length==0;
      activity.hasQuantity=tools.exclude(tools.exclude(activityItems,{'quantity':'0'}),{'quantity':0}).length!==0;
    }
    var meals=tools.join(model.visit,'meals',model);
    for(i in meals) {
      meal=meals[i];
      meal.table='meals';
      meal.name=tools.label(parameters.RES[meal.res]);
      meal.quantities='';
      dishes=tools.join(meal,'dishes',model);
      for(j in dishes) {
        dish=dishes[j];
        dish.table='dishes';
        if(dish.dsh in parameters.DSH) {
          dsh=parameters.DSH[dish.dsh];
          if(dsh.field1=='1') {
            meal.quantities+=' '+dish.quotationtitle;
          } else {
            meal.quantities+=' '+tools.label(parameters.DSH[dish.dsh]);
          }
          meal.quantities+=' '+model.items[dish.item].planningquantity;
          dish.category=dsh.field2==''?'Undefined':dsh.field2;
        } else {
          dish.category='Undefined';
        }
      }
      $scope.setMealCategories(meal);
      mealItems=tools.inverseJoin(dishes,'items','item',model);
      meal.hasNoInvoice=tools.exclude(mealItems.concat(tools.inverseJoin(mealItems,'items','replaces',model)),{'invoice':'0'}).length==0;
      meal.hasQuantity=tools.exclude(tools.exclude(mealItems,{'quantity':'0'}),{'quantity':0}).length!==0;
    }
    var hotelreservationcategories=tools.join(model.visit,'hotelreservationcategories',model);
    for(i in hotelreservationcategories) {
      hotelreservationcategory=hotelreservationcategories[i];
      hotelreservationcategory.table='hotelreservationcategories';
      hotelreservationcategory.day=hotelreservationcategory.startdate;
      hotelreservationcategory.hrs=hotelreservationcategory.starthrs;
      hotelreservationcategory.name=tools.label(parameters.HTL[hotelreservationcategory.htl]);
      hotelreservationcategory.quantities='';
      $scope.setHotelreservationcategoryDateAndHpdOptions(hotelreservationcategory);
      if(hotelreservationcategory.requestedhsc in parameters.HSC) {
        hotelreservationcategory.quantities+=' '+tools.short(parameters.HSC[hotelreservationcategory.requestedhsc])+' '+model.items[hotelreservationcategory.item].quantity;
      }
      hotelreservationproducts=tools.join(hotelreservationcategory,'hotelreservationproducts',model);
      for(k in hotelreservationproducts) {
        hotelreservationproduct=hotelreservationproducts[k];
        hotelreservationproduct.table='hotelreservationproducts';
      }
      hotelreservationcategoryItems=[model.items[hotelreservationcategory.item]].concat(tools.inverseJoin(tools.join(hotelreservationcategories,'hotelreservationproducts',model),'items','item',model));
      hotelreservationcategory.hasNoInvoice=tools.exclude(hotelreservationcategoryItems.concat(tools.inverseJoin(hotelreservationcategoryItems,'items','replaces',model)),{'invoice':'0'}).length==0;
    }
    var products=tools.join(model.visit,'products',model);
    for(i in products) {
      product=products[i];
      product.table='products';
      product.name=tools.label(parameters.PRD[product.prd]);
      product.quantities=model.items[product.item].planningquantity+'';
      if(product.prd in parameters.PRD) {
        prd=parameters.PRD[product.prd];
        product.category=prd.field3==''?'Undefined':prd.field3;
      } else {
        product.category='Undefined';
      }
      $scope.setProductCategories(product);
      productItem=tools.inverseJoin([product],'items','item',model);
      product.hasNoInvoice=tools.exclude(productItem.concat(tools.inverseJoin(productItem,'items','replaces',model)),{'invoice':'0'}).length==0;
      product.hasQuantity=tools.exclude(productItem,{'quantity':'0'}).length!==0;
      model.editingCount+=product.editing?1:0;
    }
    var visitElementsWithDate=activities.concat(meals).concat(hotelreservationcategories);
    if(!model.showVisitElementsWithZeroQuantity) {
      visitElementsWithDate=tools.exclude(visitElementsWithDate,{'hasQuantity':false,'editing':false})
    }
    if(visitElementsWithDate.length>0) {
      var startdate='2999-12-31';
      var enddate='1971-01-01';
      var notCreatedExists=false;
      for(i in visitElementsWithDate) {
        record=visitElementsWithDate[i];
        model.editingCount+=record.editing?1:0;
        day=tools.dateFromJava(record.day);
        if(day!='') {
          startdate=day<startdate?day:startdate;
          enddate=day>enddate?day:enddate;
        }
        notCreatedExists=notCreatedExists || !record.isCreated;
      }
      startdate=tools.dateToJava(startdate);
      enddate=tools.dateToJava(enddate);
      if(startdate!='2999-12-31') {
        var days={};
        if(notCreatedExists) {
          days['2999-12-31']={'day':'2999-12-31','slts':{}};
        }
        for(loopdate=new Date(startdate.getTime());loopdate<=enddate;loopdate.setDate(loopdate.getDate()+1)) {
          day=tools.dateFromJava(loopdate);
          days[day]={'day':day,'slts':{}};
        }
        for(i in visitElementsWithDate) {
          record=visitElementsWithDate[i];
          if(record.isCreated) {
            day=tools.dateFromJava(record.day);
          } else {
            day='2999-12-31';
          }
          if((record.hrs in parameters.HRS) && record.isCreated) {
            slt=parameters.HRS[record.hrs].field2;
          } else {
            slt='ZZ';
          }
          if(!(slt in days[day].slts)) {
            days[day].slts[slt]=[];
          }
          days[day].slts[slt].push(record);
        }
        var dayKeys=Object.keys(days).sort();
        for(i in dayKeys) {
          day=dayKeys[i];
          slts=days[day].slts;
          sltKeys=Object.keys(slts).sort();
          if(sltKeys.length>0) {
            firstSlt=true;
            for(j in sltKeys) {
              slt=sltKeys[j];
              daySlts.push({'day':day,'slt':slt,'firstSlt':firstSlt,'visitElementsWithDate':slts[slt].sort(function(x,y) {
                var result;
                if(x.isCreated && y.isCreated) {
                  result=(x.hrs==y.hrs)?(((x.id==y.id)?0:((x.id>y.id)?1:-1))):((x.hrs>y.hrs)?1:-1);
                } else if(x.isCreated || y.isCreated) {
                  result=x.isCreated?-1:1;
                } else {
                  result=x.createdDate-y.createdDate;
                }
                return result;
              })});
              firstSlt=false;
            }
          } else {
            daySlts.push({'day':day,'slt':'ZZ','firstSlt':true,'visitElementsWithDate':[]});
          }
        }
      } else {
        daySlts.push({'day':'','slt':'ZZ','firstSlt':true,'visitElementsWithDate':visitElementsWithDate});
      }
    }
    model.visitElementsWithDate=[];
    var isFirst;
    var previousLast=null;
    for(i in daySlts) {
      isFirst=true;
      if(previousLast!==null) {
        previousLast.lastInSlt=true;
      }
      visitElementsWithDate=daySlts[i].visitElementsWithDate;
      for(j in visitElementsWithDate) {
        record=visitElementsWithDate[j];
        record.firstInDay=isFirst && daySlts[i].firstSlt;
        isFirst=false;
        record.lastInSlt=false;
        previousLast=record;
        model.visitElementsWithDate.push(record);
      }
    }
    if(previousLast!==null) {
      previousLast.lastInSlt=true;
    }
    var visitElementsWithoutDate=products;
    if(!model.showVisitElementsWithZeroQuantity) {
      visitElementsWithoutDate=tools.exclude(visitElementsWithoutDate,{'hasQuantity':false,'editing':false})
    }
    model.visitElements=model.visitElementsWithDate.concat(visitElementsWithoutDate);

    var visitElements=tools.join(model.visit,'activities',model).concat(tools.join(model.visit,'meals',model)).concat(tools.join(model.visit,'products',model)).concat(tools.join(model.visit,'hotelreservationcategories',model));
    model.itemCountWithZeroQuantity=tools.getLength(visitElements);
    model.itemCountWithoutZeroQuantity=tools.getLength(tools.exclude(visitElements,{'hasQuantity':false}));
    model.selectAllVisitElements=model.selectionCount===model.itemCountWithoutZeroQuantity && model.selectionCount>0;
  };

  $scope.$on("afterLoad",$scope.sortVisitElements);
  $scope.$on("sortVisitElements",$scope.sortVisitElements);
  $scope.$on("startVisitElementEdit", function (event, params) {
    var visitElement = model.visitElements.find(function(visitElement) {
      return visitElement.table == params.table && visitElement.id == params.visitElementId;
    })
    $scope.startVisitElementEdit(visitElement);
  });
  $scope.$on("deleteVisitElement", function (event, params) {
    var visitElement = model.visitElements.find(function(visitElement) {
      return visitElement.table == params.table && visitElement.id == params.visitElementId;
    })
    $scope.startVisitElementEdit(visitElement);
    $scope.deleteVisitElement(visitElement);
  });
  
  $scope.toggleAll = function(isOpen) {
    var i,j,collection,record;
    var collections=['contacts','visits','activities','meals','products','hotelreservationcategories'];
    for(i in collections) {
      collection=model[collections[i]];
      for(j in collection) {
        record=collection[j]
        record.isOpen=(model.showVisitElementsWithZeroQuantity)?isOpen:isOpen && (record.hasQuantity || collections[i]=='visits');
      }
    }
  };

  $scope.setHotelreservationcategoryDateAndHpdOptions = function(hotelreservationcategory) {
    var dateOptions=tools.clone(model.dateOptions);
    if(angular.isDefined(hotelreservationcategory) && hotelreservationcategory.isCreated) {
      dateOptions.minDate=new Date(Math.min(hotelreservationcategory.startdate,new Date()));
    }
    hotelreservationcategory.dateOptions=dateOptions;
    hotelreservationcategory.hpdOptions=hotelsService.getProductsForHotel(hotelreservationcategory.htl);
  };

  $scope.getFilteredStarthrs = function(hotelreservationcategory) {
    var result;
    if(angular.isDefined(hotelreservationcategory.startdate) && tools.today()===tools.dateFromJava(hotelreservationcategory.startdate) && !hotelreservationcategory.checkedIn) {
      var now=tools.now();
      result=parameters.notDelArrayHRS.filter(function(hrs) {
        return hrs.id>now || (hrs.id==hotelreservationcategory.starthrs && model.task!='c');
      });
    } else {
      result=parameters.notDelArrayHRS;
    }
    return result;
  };

  $scope.indexById = function(records) {
    return records.reduce(function(acc,cur) {acc[cur.id]=cur;return acc;},{})
  };

  $scope.massEditVisitElementsModal = function() {
    var params={
      'contacts':[model.owningContact],
      'visit':model.visit,
      'participants':tools.exclude(tools.join(tools.join(model.visit,'activities',model),'participants',model),{'selected':false}),
      'dishes':tools.exclude(tools.join(tools.join(model.visit,'meals',model),'dishes',model),{'selected':false}),
      'hotelspaceassignments':tools.exclude(tools.join(tools.join(model.visit,'hotelreservationcategories',model),'hotelspaceassignments',model),{'selected':false}),
      'hotelreservationcategories':tools.exclude(tools.match(tools.join(model.visit,'hotelreservationcategories',model),{'id':function(reservationcategory) {
        return tools.getLength(tools.match(model.hotelspaceassignments,{'reservationcategory':reservationcategory}))==0;
      }}),{'selected':false}),
      'products':tools.exclude(tools.join(model.visit,'products',model),{'selected':false}),
      'movements':tools.exclude(tools.join(model.visit,'movements',model),{'selected':false})
    };
    if(model.visit.communicationcontact!='0') {
      params.contacts.push(model.communicationContact);
    }
    params.accounts=tools.inverseJoin(params.movements,'accounts','account',model);
    params.activities=tools.inverseJoin(params.participants,'activities','activity',model);
    params.meals=tools.inverseJoin(params.dishes,'meals','meal',model);
    params.hotelreservationcategories=params.hotelreservationcategories.concat(tools.inverseJoin(params.hotelspaceassignments,'hotelreservationcategories','reservationcategory',model));
    params.hotelreservationproducts=tools.join(params.hotelreservationcategories,'hotelreservationproducts',model);
    params.items=tools.inverseJoin(params.participants,'items','item',model).concat(
      tools.inverseJoin(params.dishes,'items','item',model),
      tools.inverseJoin(params.products,'items','item',model),
      tools.inverseJoin(params.hotelreservationcategories,'items','item',model),
      tools.inverseJoin(params.hotelreservationproducts,'items','item',model)
    );
    var hotelreservationcategory;
    var allPreparationsAreDone=[];
    var oldValidated=model.validated;
    model.validated=false;
    for(var i in params.hotelreservationcategories) {
      hotelreservationcategory=params.hotelreservationcategories[i];
      allPreparationsAreDone.push($scope.updateHotelreservationcategoryAvailabilities(hotelreservationcategory));
    }
    $q.all(allPreparationsAreDone).then(function() {
      model.validated=oldValidated;        
      $uibModal.open({
        'templateUrl': 'app/modules/visits/massEditVisitElementsModal.html',
        'controller': 'MassEditVisitElementsModalController',
        'backdrop':'static',
        'windowClass':'app-modal-window-wide',
        'resolve': {
          'params': function() {
            return params;
          },
          'rights': function() {
            return model.rights;
          }
        }
      }).result.then(function(response) {
        if(response.mode=='edit' || response.mode=='duplicate') {
          $scope.backupAllVisitElements();
          var i,j,record,dayOffset,recordsWithoutZeroQuantity,activity,participant,participants,meal,dish,dishes,hotelreservationcategory,hotelreservationproducts,hotelreservationproduct,oldAdultcount,oldChildcount,product,item,indexedItems,recordsWithEnddate,recordsWithDate,records;
          if(response.mode=='edit') {
            recordsWithEnddate=params.hotelreservationcategories.filter(function(hotelreservationcategory) {
              return hotelreservationcategory.updatePermissions.updateFields.enddate;
            });
            recordsWithDate=params.activities.concat(params.meals).concat(params.hotelreservationcategories.filter(function(hotelreservationcategory) {
              return hotelreservationcategory.updatePermissions.updateFields.startdate;
            }));
            records=params.activities.concat(params.meals).concat(params.products).concat(params.hotelreservationcategories.filter(function(hotelreservationcategory) {
              return hotelreservationcategory.updatePermissions.allowItemUpdate;
            }));
            indexedItems=model.items;
          } else {
            var oldIdIndexedItems=Object.values(response.items).reduce(function(oldIdIndexedItems,item) {
              oldIdIndexedItems[item.id]=item;
              return oldIdIndexedItems;
            },{});
            for(i in oldIdIndexedItems) {
              item=oldIdIndexedItems[i];
              item.isCreated=false;
              item.id=tools.getMinIdMinusOne(response.items);
              item.visit=response.visit.id;
              item.invoice="0";
              item.advancedAttributes=response.visit.automaticreduction!='1';
              item.planningquantity=item.quantity;
              item.oldQuantity=item.quantity;
              item.initialQuantity=item.quantity;
            }
            indexedItems=$scope.indexById(response.items);
            for(i in response.activities) {
              activity=response.activities[i];
              participants=Object.values(response.participants).filter(function(participant) {
                return participant.activity==activity.id;
              });
              activity.isCreated=false;
              activity.createdDate=new Date();
              activity.id=tools.getMinIdMinusOne(response.activities);
              activity.visit=response.visit.id;
              activity.stat='1000';
              activity.act=activity.frm.substr(0,3);
              activity.dayOpened=false;
              activity.availabilities={};
              activity.skipGetAvailability=false;
              $scope.setOpenEditingSelected(activity);
              for(j in participants) {
                participant=participants[j];
                participant.isCreated=false;
                participant.id=tools.getMinIdMinusOne(response.participants);
                participant.activity=activity.id;
                participant.item=oldIdIndexedItems[participant.item].id;
              }
            }
            for(i in response.meals) {
              meal=response.meals[i];
              dishes=Object.values(response.dishes).filter(function(dish) {
                return dish.meal==meal.id;
              });
              meal.isCreated=false;
              meal.createdDate=new Date();
              meal.id=tools.getMinIdMinusOne(response.meals);
              meal.visit=response.visit.id;
              meal.stat="1000";
              meal.dayOpened=false;
              meal.skipGetAvailability=false;
              $scope.setOpenEditingSelected(meal);
              for(j in dishes) {
                dish=dishes[j];
                dish.isCreated=false;
                dish.id=tools.getMinIdMinusOne(response.dishes);
                dish.meal=meal.id;
                dish.item=oldIdIndexedItems[dish.item].id;
                dish.category=parameters.DSH[dish.dsh].field2;
              }
            }
            for(i in response.hotelreservationcategories) {
              hotelreservationcategory=response.hotelreservationcategories[i];
              hotelreservationproducts=Object.values(response.hotelreservationproducts).filter(function(hotelreservationproduct) {
                return hotelreservationproduct.reservationcategory==hotelreservationcategory.id;
              });
              hotelreservationcategory.isCreated=false;
              hotelreservationcategory.createdDate=new Date();
              hotelreservationcategory.id=tools.getMinIdMinusOne(response.hotelreservationcategories);
              hotelreservationcategory.visit=response.visit.id;
              hotelreservationcategory.startdate=tools.dateToJava(hotelreservationcategory.startdate);
              hotelreservationcategory.startdateOpened=false;
              hotelreservationcategory.enddate=tools.dateToJava(hotelreservationcategory.enddate);
              hotelreservationcategory.enddateOpened=false;
              hotelreservationcategory.oldEnddate=hotelreservationcategory.enddate;
              hotelreservationcategory.oldDaydiff=tools.dayDiff(hotelreservationcategory.startdate,hotelreservationcategory.enddate);
              $scope.setOpenEditingSelected(hotelreservationcategory);
              hotelreservationcategory.skipGetAvailability=false;
              hotelreservationcategory.pricings={};
              hotelreservationcategory.spacetype=parameters.HSC[hotelreservationcategory.requestedhsc].field5;
              hotelreservationcategory.item=oldIdIndexedItems[hotelreservationcategory.item].id;
              hotelreservationcategory.spacetypes=[];
              hotelreservationcategory.hscs=[];
              hotelreservationcategory.updatePermissions={'updateFields':{'startdate':true,'enddate':true,'starthrs':true,'childcount':true,'adultcount':true}};
              hotelreservationcategory.hpdOptions={};
              $scope.initHotelreservationcategory(hotelreservationcategory);
              for(j in hotelreservationproducts) {
                hotelreservationproduct=hotelreservationproducts[j];
                hotelreservationproduct.isCreated=false;
                hotelreservationproduct.id=tools.getMinIdMinusOne(response.hotelreservationproducts);
                hotelreservationproduct.hotelreservationcategory=hotelreservationcategory.id;
                hotelreservationproduct.item=oldIdIndexedItems[hotelreservationproduct.item].id;
                $scope.initHotelreservationproduct(hotelreservationproduct);
              }
            }
            for(i in response.products) {
              product=response.products[i];
              product.isCreated=false;
              product.id=tools.getMinIdMinusOne(response.products);
              product.visit=response.visit.id;
              product.item=oldIdIndexedItems[product.item].id;
              product.category=parameters.PRD[product.prd].field3;
              product.prds=[];
              product.stat="1000";
              $scope.setOpenEditingSelected(product);
              product.skipGetAvailability=false;
            }
            recordsWithEnddate=response.hotelreservationcategories.filter(function(hotelreservationcategory) {
              return hotelreservationcategory.updatePermissions.updateFields.enddate;
            });
            recordsWithDate=response.activities.concat(response.meals).concat(response.hotelreservationcategories.filter(function(hotelreservationcategory) {
              return hotelreservationcategory.updatePermissions.updateFields.startdate;
            }));
            records=response.activities.concat(response.meals).concat(response.products).concat(response.hotelreservationcategories.filter(function(hotelreservationcategory) {
              return hotelreservationcategory.updatePermissions.allowItemUpdate;
            }));
          }
          if(response.editStartdate) {
            if(response.startdateOffsetMode==='REL') {
              dayOffset=tools.dayDiff(response.oldStartdate,response.startdate);
              for(i in recordsWithDate) {
                record=recordsWithDate[i];
                if(record.table=='hotelreservationcategories') {
                  record.startdate=tools.addDays(record.startdate,dayOffset);
                  if(!response.editEnddate) {
                    record.enddate=tools.addDays(record.enddate,dayOffset);
                  }
                } else {
                  record.day=tools.addDays(record.day,dayOffset);
                }
                record.isOpen=true;
                record.editing=true;
              }
            } else if(response.startdateOffsetMode==='ABS') {
              for(i in recordsWithDate) {
                record=recordsWithDate[i];
                if(record.table=='hotelreservationcategories') {
                  record.startdate=response.startdate;
                  record.enddate=(record.enddate<response.startdate)?tools.addDays(response.startdate,1):record.enddate;
                } else {
                  record.day=response.startdate;
                }
                record.isOpen=true;
                record.editing=true;
              }
            }
          }
          if(response.editEnddate) {
            if(response.enddateOffsetMode==='REL') {
              dayOffset=tools.dayDiff(response.oldEnddate,response.enddate);
              for(i in recordsWithEnddate) {
                record=recordsWithEnddate[i];
                record.enddate=tools.addDays(record.enddate,dayOffset);
                record.isOpen=true;
                record.editing=true;
              }
            } else if(response.enddateOffsetMode==='ABS') {
              for(i in recordsWithEnddate) {
                record=recordsWithEnddate[i];
                record.enddate=response.enddate;
                record.isOpen=true;
                record.editing=true;
              }
            }
          }
          if(response.setSelectedElementsToZero && response.mode=='edit') {
            recordsWithoutZeroQuantity=tools.exclude(records,{'hasQuantity':false});
            for(i in recordsWithoutZeroQuantity) {
              record=recordsWithoutZeroQuantity[i];
              record.isOpen=true;
              record.editing=true;
            }
            $scope.deleteInvoicedItems(params.items);
          }
          if(response.editParticipantcount) {
            participants=response.mode=='edit'?params.participants:response.participants;
            for(i in participants) {
              participant=participants[i];
              item=indexedItems[participant.item];
              if(response.participantcountOffsetMode==='ABS') {
                item.quantity=(tools.amountIn(response.participantcount)>=0?tools.amountIn(response.participantcount):0);
              } else if(response.participantcountOffsetMode==='REL') {
                item.quantity=(tools.amountIn(item.quantity)+tools.amountIn(response.participantcount)>=0?tools.amountIn(item.quantity)+tools.amountIn(response.participantcount):0);
              }
              if(item.quantity!==item.oldQuantity && response.mode=='edit') {
                $scope.onQuantityChange(participant);
                activity=model.activities[participant.activity];
                activity.isOpen=true;
                activity.editing=true;
              }
            }          
          }
  /*      if(response.editParticipantcount) {
            for(i in params.activities) {
              activity=params.activities[i];
              peopleMatrix=[];
              quantityMatrix=[]
              cgrUnts={};
              peopleCount=0;
              quantityCount=0;
              counter=0;
              participants=tools.join(activity,'participants',params);
              for(j in participants) {
                participant=participants[j];
                unt=parameters.UNT[participant.unt];
                item=model.items[participant.item];
                peopleQuantity=parseInt(unt.field1)*parseInt(item.planningquantity);
                quantity=parseInt(item.planningquantity);
                if(!(unt.field8 in cgrUnts)) {
                  cgrUnts[unt.field8]={'unts':[],'participants':[],'items':[],'isDefaultCgr':false,'peopleCount':0,'quantityCount':0}
                }
                cgrUnts[unt.field8].participants.push(participant);
                cgrUnts[unt.field8].items.push(item);
                cgrUnts[unt.field8].unts.push(unt);
                if(unt.field2=='1') {
                  cgrUnts[unt.field8].isDefaultCgr=true;
                }
                cgrUnts[unt.field8].peopleCount+=peopleQuantity;
                cgrUnts[unt.field8].quantityCount+=quantity;
                peopleCount+=peopleQuantity;
                quantityCount+=quantity;
              }
              cgrUnts=Object.values(cgrUnts);
              if(peopleCount>0) {
                participants=tools.first(tools.exclude(cgrUnts,{'isDefaultCgr':false,'peopleCount':0}))
              } else {

              }
              quantities=(peopleCount===0?quantityCount:peopleCount);
              participants=activitiesService.formulaFilter(participants,'unt',activity.frm);
              for(j in participants) {
                participant=participants[j];
                untId=particpant.unt;
                if(parameters.UNT[untId].field2=="1") {
                  if (parameters.UNT[untId].field1!="0"){
                    quantity=Math.max(1,Math.ceil(model.visit.quotationparticipants/parameters.UNT[untId].field1));
                  } else {
                    quantity='1';
                  }
                } else {
                  quantity='0';
                }

                participant.table='participants';
                if(!model.validated || tools.amountIn(model.items[participant.item].quantity)+tools.amountIn(model.items[participant.item].planningquantity)!=0) {
                  activity.joinedParticipants.push(participant);
                }
              }
              activityItems=tools.inverseJoin(participants,'items','item',model);
              activity.hasNoInvoice=tools.exclude(activityItems.concat(tools.inverseJoin(activityItems,'items','replaces',model)),{'invoice':'0'}).length==0;
              activity.hasQuantity=tools.exclude(tools.exclude(activityItems,{'quantity':'0'}),{'quantity':0}).length!==0;
              activity.selected=$scope.selectedElements.indexOf(activity.id+activity.table)>=0;
            }
          }*/
          if(response.editDishcount) {
            dishes=response.mode=='edit'?params.dishes:response.dishes;
            for(i in dishes) {
              dish=dishes[i];
              item=indexedItems[dish.item];
              if(response.dishcountOffsetMode==='ABS') {
                item.quantity=(tools.amountIn(response.dishcount)>=0?tools.amountIn(response.dishcount):0);
              } else if(response.dishcountOffsetMode==='REL') {
                item.quantity=(tools.amountIn(item.quantity)+tools.amountIn(response.dishcount)>=0?tools.amountIn(item.quantity)+tools.amountIn(response.dishcount):0);
              }
              if(item.quantity!==item.oldQuantity && response.mode=='edit') {
                $scope.onQuantityChange(dish);
                meal=model.meals[dish.meal];
                meal.isOpen=true;
                meal.editing=true;
              }
            }
          }
          if(response.editRoomcount || response.editAdultcount || response.editChildcount) {
            for(i in params.hotelreservationcategories) {
              hotelreservationcategory=params.hotelreservationcategories[i];
              item=indexedItems[hotelreservationcategory.item];
              oldItemquantity=item.oldQuantity;
              oldAdultcount=hotelreservationcategory.adultcount;
              oldChildcount=hotelreservationcategory.childcount;
              if(response.editRoomcount && hotelreservationcategory.updatePermissions.allowItemUpdate) {
                if(response.roomcountOffsetMode==='ABS') {
                  item.quantity=(tools.amountIn(response.roomcount)>=0?tools.amountIn(response.roomcount):0);
                } else if(response.roomcountOffsetMode==='REL') {
                  item.quantity=(tools.amountIn(item.quantity)+tools.amountIn(response.roomcount)>=0?tools.amountIn(item.quantity)+tools.amountIn(response.roomcount):0);
                }
                if(item.oldQuantity!==item.quantity && response.mode=='edit') {
                  $scope.onQuantityChange(hotelreservationcategory);
                }
              }
              if(response.editAdultcount && hotelreservationcategory.updatePermissions.updateFields.adultcount) {
                if(response.adultcountOffsetMode==='ABS') {
                  hotelreservationcategory.adultcount=tools.amountIn(response.adultcount);
                } else if(response.adultcountOffsetMode==='REL') {
                  hotelreservationcategory.adultcount=tools.amountIn(hotelreservationcategory.adultcount)+tools.amountIn(response.adultcount);
                }
                if(oldAdultcount!==hotelreservationcategory.adultcount && response.mode=='edit') {
                  $scope.onUpdateUnitcounts(hotelreservationcategory);
                }
              }
              if(response.editChildcount && hotelreservationcategory.updatePermissions.updateFields.childcount) {
                if(response.childcountOffsetMode==='ABS') {
                  hotelreservationcategory.childcount=tools.amountIn(response.childcount);
                } else if(response.childcountOffsetMode==='REL') {
                  hotelreservationcategory.childcount=tools.amountIn(hotelreservationcategory.childcount)+tools.amountIn(response.childcount);
                }
                if(oldChildcount!==hotelreservationcategory.childcount && response.mode=='edit') {
                  $scope.onUpdateUnitcounts(hotelreservationcategory);
                }
              }
              if(oldItemquantity!==item.quantity || oldAdultcount!==hotelreservationcategory.adultcount || oldChildcount!==hotelreservationcategory.childcount) {
                hotelreservationcategory.isOpen=true;
                hotelreservationcategory.editing=true;            
              }
            }
          }
          if(response.editProductcount) {
            for(i in params.products) {
              product=params.products[i];
              item=indexedItems[product.item];
              if(response.productcountOffsetMode==='ABS') {
                item.quantity=(tools.amountIn(response.productcount)>=0 || product.prd==='VOU'?tools.amountIn(response.productcount):0);
              } else if(response.productcountOffsetMode==='REL') {
                item.quantity=(tools.amountIn(item.quantity)+tools.amountIn(response.productcount)>=0 || product.prd==='VOU'?tools.amountIn(item.quantity)+tools.amountIn(response.productcount):0);
              }
              if(item.quantity!==item.oldQuantity && response.mode=='edit') {
                $scope.onQuantityChange(product);
                product.isOpen=true;
                product.editing=true;
              }
            }
          }
          if(response.setVouchersToUsedAmount) {
            for(i in params.products) {
              product=params.products[i];
              item=indexedItems[product.item];
              if(product.prd==='VOU' && product.availableAmount>0 && item.nettopay>0) {
                item.quantity=item.nettopay-product.availableAmount;
                if(tools.amountIn(item.standardunitprice)!==1) {
                  item.customprice='1';
                  item.grossunitprice=1;
                } else {
                  item.customprice='0';
                  item.grossunitprice=item.standardunitprice
                }
              }
              if(item.quantity!==item.oldQuantity && response.mode=='edit') {
                $scope.onQuantityChange(product);
                product.isOpen=true;
                product.editing=true;
              }
            }
          }
          if(response.mode=='edit' && (response.setSelectedElementsToZero || response.setVouchersToUsedAmount || response.editEnddate || response.editStartdate || response.editParticipantcount || response.editDishcount || response.editRoomcount || response.editAdultcount || response.editChildcount || response.editProductcount)) {
            model.visit.isOpen=false;
            model.task='u';
            $scope.sortVisitElements();
          } else if(response.mode=='duplicate') {
            for(i in response.activities) {
              activity=response.activities[i];
              var untId;
              participants=Object.values(response.participants).filter(function(participant) {
                return participant.activity==activity.id;
              });
              for(untId in parameters.notDelUNT) {
                if(activitiesService.matchesFormula(untId,activity.frm)) {
                  if(tools.getLength(tools.match(participants,{'unt':untId}))==0) {
                    item={
                      'isCreated':false,
                      'id':tools.getMinIdMinusOne(response.items),
                      'visit':response.visit.id,
                      'invoice':'0',
                      'advancedAttributes':response.visit.automaticreduction!='1',
                      'quantity':'0',
                      'planningquantity':'0',
                      'oldQuantity':'0',
                      'initialQuantity':'0'
                    }
                    participant={
                      'isCreated':false,
                      "id":tools.getMinIdMinusOne(response.participants),
                      "activity":activity.id,
                      "item":item.id,
                      "unt":untId
                    };
                    response.participants.push(participant);
                    response.items.push(item);
                  }
                }
              }
            }
            var collections=['contacts','visits','activities','participants','meals','dishes','hotelreservationcategories','hotelreservationproducts','products','items'];
            response.visits=[response.visit];
            if(tools.numberIn(response.visit.id)<0) {
              $state.go('activitiesCreateForEmp',{'settings':{'collections':$scope.indexCollections(collections,response)},'lang':user.lang});
            } else {
              $state.go('activitiesRetrieveForEmp',{'id':'V'+response.visit.id,'settings':{'collections':$scope.indexCollections(collections,response)},'lang':user.lang});
            }
          }
        } else if(response.mode=='transfer') {
          if(response.visit.id!='0') {
            $scope.visitRetrieve(response.visit.id);
          }
        }
      });
    });
  };

  $scope.indexCollections = function(collectionNames,collections) {
    var indexedCollections={};
    var i,collectionName;
    for(i in collectionNames) {
      collectionName=collectionNames[i];
      indexedCollections[collectionName]=$scope.indexById(collections[collectionName]);
    }
    return indexedCollections;
  }

  $scope.openPacketModal = function() {
    $uibModal.open({
      'templateUrl': 'app/modules/visits/addPacketModal.html',
      'controller': 'AddPacketModalController',
      'resolve': {
        'visit': function() {
          return model.visit;
        }
      }
    }).result.then(function(response) {
      if("packet" in response) {
        var packet=response.packet;
        var participantcount=response.participantcount;
        var startdate=response.startdate;
        $scope.backupAllVisitElements();
        var packetcomponents=tools.join(packet,'packetcomponents',parameters);
        var groupedDishes = {};
        var i,j,packetcomponent,day,newActivity,newParticipants,newParticipant,unt,key,first,newProduct,newMeal,newDish,enddate,newHotelreservationcategory,item;
        for(i in packetcomponents) {
          packetcomponent=packetcomponents[i];
          day=new Date(startdate);
          day.setDate(day.getDate()+(parseInt(packetcomponent.day)-1));
          if(packetcomponent.param1==='ACT') {
            newActivity=$scope.createActivity();
            newActivity.act=tools.substr(packetcomponent.param2,0,3);
            newActivity.frm=packetcomponent.param2;
            newActivity.day=day;
            newActivity.hrs=packetcomponent.hrs;
            $scope.fillParticipants(newActivity);
            newParticipants=tools.join(newActivity,'participants',model);
            for(j in newParticipants) {
              newParticipant=newParticipants[j];
              unt=parameters.UNT[newParticipant.unt];
              if(unt.field1=='1' && unt.field2=='1') {
                model.items[newParticipant.item].quantity=participantcount;
                model.items[newParticipant.item].planningquantity=participantcount;
              }
            }
          } else if (packetcomponent.param1==='MEA') {
            key = packetcomponent.param2.substr(0,3)+tools.expandDigits(packetcomponent.day,2)+packetcomponent.hrs;
            if (!(key in groupedDishes)) {
              groupedDishes[key]=[];
            }
            groupedDishes[key].push(packetcomponent);
          } else if (packetcomponent.param1==='HTL') {
            newHotelreservationcategory=$scope.createHotelreservationcategory();
            newHotelreservationcategory.startdate=day;
            newHotelreservationcategory.starthrs=packetcomponent.hrs;
            enddate=new Date(startdate);
            enddate.setDate(enddate.getDate()+(parseInt(packetcomponent.day)+parseInt(packetcomponent.attr1)-1));
            newHotelreservationcategory.enddate=enddate;
            $scope.selectHtl(newHotelreservationcategory,parameters.HTL[tools.substr(packetcomponent.param2,0,3)]);
            newHotelreservationcategory.hra=packetcomponent.attr2;
            newHotelreservationcategory.spacetype=parameters.HSC[packetcomponent.param2].field5;
            $scope.onUpdateSpacetype(newHotelreservationcategory);
            var oldValidated=model.validated;
            model.validated=false;
            $scope.updateHotelreservationcategoryAvailabilities(model.hotelreservationcategories[hotelreservationcategoryId]).then(function() {
              model.validated=model.validated;
            });
            newHotelreservationcategory.requestedhsc=packetcomponent.param2;
          } else if (packetcomponent.param1==='PRD' && packetcomponent.param2!='VOU') {
            newProduct=$scope.createProduct();
            newProduct.prd=packetcomponent.param2;
            model.items[newProduct.item].quantity=participantcount;
            model.items[newProduct.item].planningquantity=participantcount;
          } else if (packetcomponent.param1==='PRD' && packetcomponent.param2=='VOU') {
            for (i=0;i<participantcount;i++) {
              newProduct=$scope.createProduct();
              newProduct.prd=packetcomponent.param2;
              item=model.items[newProduct.item];
              item.customprice="1";
              item.grossunitprice="1";
              if(packet.voucherValue) {
                item.quantity=packet.voucherValue;
              } else {
                item.quantity=packetcomponent.attr1;
              }
              item.planningquantity=item.quantity;
            }
          }
        }
        for(i in groupedDishes) {
          first=groupedDishes[i]['0'];
          day=new Date(startdate);
          day.setDate(day.getDate()+(parseInt(first.day)-1));
          newMeal=$scope.createMeal(false);
          newMeal.day=day;
          newMeal.hrs=first.hrs;
          newMeal.res=tools.substr(first.param2,0,3);
          for(j in groupedDishes[i]) {
            newDish=$scope.createDish(newMeal);
            newDish.dsh=groupedDishes[i][j].param2;
            model.items[newDish.item].quantity=participantcount;
            model.items[newDish.item].planningquantity=participantcount;
          }
        }
        if(model.task=='r') {
          model.task='u';
        }
        $scope.sortVisitElements();
      }
    });
  };

  $scope.updateHotelspaceassignmentComment = function(hotelspaceassignment) {
    var comment=hotelspaceassignment.editComment;
    webservice.call("updateHotelspaceassignmentComment",{"hotelspaceassignment":{"id":hotelspaceassignment.id,"comment":comment}},$scope.editScript,{}).then(function(response) {
      hotelspaceassignment.comment=comment;
    });
  };

  $scope.hotelreservationcategoryFieldEditingIsDisabled = function(hotelreservationcategory,field) {
    return !hotelreservationcategory || (hotelreservationcategory.htl!=='' && !hotelreservationcategory.updatePermissions.updateFields[field] && model.visit.hotelexternalreservation=='1') || model.task=='t' || model.validated || webservice.calling;
  };

  $scope.hotelreservationcategoryEditingIsDisabled = function(hotelreservationcategory) {
    return !hotelreservationcategory || ((hotelreservationcategory.checkedIn && !hotelreservationcategory.checkedOut) && model.visit.hotelexternalreservation=='1') || model.validated || webservice.calling;
  };

  $scope.duplicateVisit = function() {
    tools.redirect($scope.buildHref("activities","duplicateVisit",model.visit.id));
  };

  $scope.openCreateChildVisitModal = function(hotelspaceassignment) {
    $uibModal.open({
      'templateUrl': 'app/modules/hotels/createChildVisitModal.html',
      'controller': 'CreateChildVisitModalController',
      'resolve': {
        'parentOwningcontact':function() {
          return model.owningContact;
        },
        'parentCommunicationcontact':function() {
          return (model.visit.communicationcontact in model.contacts)?model.contacts[model.visit.communicationcontact]:{'id':'0','dummy':true};
        },
        'hotelspaceassignment': function() {
          return hotelspaceassignment;
        },
        'clonedVisit': function() {
          return tools.clone(model.visit);
        },
        'parentScope': function() {
          return $scope;
        }
      }
    }).result.then(function(response) {});
  };

  $scope.deleteChildVisit = function(hotelspaceassignment) {
    webservice.call("deleteChildVisit",{"hotelspaceassignmentId":hotelspaceassignment.id},$scope.editScript,model);
  }

  $scope.$on("afterLoadForDuplicate",function() {
    $scope.syncReductions();
    var allPreparationsAreDone=[];
    for(var i in model.hotelreservationcategories) {
      allPreparationsAreDone.push($scope.updateHotelreservationcategoryAvailabilities(model.hotelreservationcategories[i]));
    }
    $q.all(allPreparationsAreDone).then(function() {
      $scope.sortVisitElements();
      $scope.watchAll();
    });
  });

  tools.initAttributes(model,{
    'advancedVisitAttributes':false,
    'isClean':false,
    'startdateOpened':false,
    'enddateOpened':false,
    'dateOptions':{
      maxDate: new Date(2099,11,31),
      minDate: new Date(2000,0,1),
      startingDay: 1
    },
    'contacts':{},
    'owningContact':{},
    'communicationContact':{},
    'visits':{},
    'visit':{},
    'activities':{},
    'participants':{},
    'meals':{},
    'dishes':{},
    'products':{},
    'hotelreservationcategories':{},
    'hotelreservationproducts':{},
    'hotelspaceassignments':{},
    'items':{},
    'invoices':{},
    'cashlesspayments':{},
    'reductionMode':'automatic',
    'toPay':0,
    'view':'',
    'showVisitElementsWithZeroQuantity':true,
    'visitElementsWithDate':[],
    'visitElements':[],
    'itemCountWithoutZeroQuantity':0,
    'itemCountWithZeroQuantity':0,
    'selectAllVisitElements':false,
    'hpd':{},
    'hotelreservationproductSettings':{
      'scrollable':true,
      'scrollableHeight':'300px',
      'template':tools.lang({'en':"{{option.labelen",'nl':"{{option.labelnl",'fr':"{{option.labelfr"})+"+' '+option.field3+'€'}}",
      'selectionLimit':1,
      'showCheckAll':false,
      'showUncheckAll':false,
      'smartButtonMaxItems':1,
      'closeOnSelect':true,
      'enableSearch':true,
      'styleActive':true,
      'keyboardControls':true,
      'buttonClasses':'btn btn-group-justified btn-default'
    },
    'hotelreservationproductTranslations':{},
    'startVisitEdit':$scope.startVisitEdit
  },'edit');
  model.view=$location.path().split("/")[3];
  $scope.watchedActivityIds=[];
  $scope.watchedMealIds=[];
  $scope.watchedHotelreservationcategoryIds=[];
  webservice.afterLogin().then(function() {
    model.hotelreservationproductTranslations={
      'checkAll':tools.lang({'en':'Check all','nl':'Alles selecteren','fr':'S\u00E9llectioner tout'}),
      'uncheckAll':tools.lang({'en':'Uncheck all','nl':'Alles deselecteren','fr':'Des\u00E9llectioner tout'}),
      'selectionCount':tools.lang({'en':'Checked','nl':'Geselecteerd','fr':'S\u00E9llectioner'}),
      'searchPlaceholder':tools.lang({'en':'Search...','nl':'Zoek...','fr':'Chercher...'}),
      'buttonDefaultText':tools.lang({'en':'Select','nl':'Selecteer','fr':'S\u00E9llectioner'}),
      'dynamicButtonTextSuffix':tools.lang({'en':'Checked','nl':'Geselecteerd','fr':'S\u00E9llectioner'}),
      'selectGroup':tools.lang({'en':'Select All:','nl':'Selecteer Alles:','fr':'S\u00E9llectioner tout:'})
    };
    $scope.initStateparams();
    if(model.task=='t' || model.task=='d') {
      $scope.sortVisitElements();
    }

    // if(model.task=='c' && ("isCreated" in model.visit) && !model.visit.isCreated && model.itemCountWithZeroQuantity==0) {
    //   $scope.debug();
    // }
  });
  var stateparamFields={
    'collections':{
      'format':'record',
      'resetRecordTables':["contacts","visits","activities","participants","meals","dishes","products","hotelreservationcategories","hotelreservationproducts","hotelrates","hotelspaceassignments","hotelspaces","items",'emails','quotationnotes','cashlesspayments','movements'],
      'addRecordTables':['activities','participants','meals','dishes','hotelreservationcategories','hotelreservationproducts','products','items'],
    }
  };

  $scope.setOpenEditingSelected = function(record) {
    record.isOpen=true;
    record.editing=true;
    record.selected=false;
  };

  $scope.initStateparams = function() {
    if('settings' in $stateParams && $stateParams.settings!==null) {
      var i,records,collection,recordId,record;
      var settings=$stateParams.settings;
      if(angular.isString(settings)) {
        try {
          settings=angular.fromJson(decodeURIComponent($stateParams.settings));
        } catch(e) {
          $log.error('malformed json structure for selection');
          settings=null;
        }
      }
      if('collections' in settings && 'visits' in settings.collections && tools.getLength(settings.collections.visits)==1) {
        var stateParam=stateparamFields.collections;
        var collections=settings.collections;
        if('id' in $stateParams) {
          $scope.init().then(function() {
            $scope.$broadcast("afterLoadForDuplicate");
          });
        } else {
          modelstore.cleanModel(stateParam.resetRecordTables,model);
          model.visit={};
          model.isClean=true;
          model.defaultVisit=tools.first(settings.collections.visits);
          if('contacts' in collections) {
            modelstore.addRecords('contacts',collections.contacts,model);
          }
          $scope.init();
          for(i in stateParam.addRecordTables) {
            collection=stateParam.addRecordTables[i];
            if(collection in collections) {
              records=collections[collection];
              for(recordId in records) {
                record=records[recordId];
                if(collection=='activities') {
                  $scope.initActivity(record);
                } else if(collection=='participants') {
                  $scope.initParticipant(record);
                } else if(collection=='meals') {
                  $scope.initMeal(record);
                } else if(collection=='dishes') {
                  $scope.initDish(record);
                } else if(collection=='hotelreservationcategories') {
                  $scope.initHotelreservationcategory(record);
                } else if(collection=='hotelreservationproducts') {
                  $scope.initHotelreservationproduct(record);
                } else if(collection=='products') {
                  $scope.initProduct(record);
                } else if(collection=='items') {
                  $scope.initItem(record);
                }
                $scope.setOpenEditingSelected(record);
                modelstore.addRecord(collection,record,model)
              }
            }
          }
          $scope.$broadcast("afterLoadForDuplicate");
        }
      } else {
        model.isClean=false;
        delete model.defaultVisit;
        $scope.init();
      }
    } else {
      model.isClean=false;
      delete model.defaultVisit;
      $scope.init();
    }
  }
  $scope.watchAll();

  $scope.debug = function() {
    $scope.createHotelreservationcategory(true);
    var hotelreservationcategory=tools.first(model.hotelreservationcategories);
    hotelreservationcategory.startdate=tools.dateToJava("2019-03-06");
    hotelreservationcategory.enddate=tools.dateToJava("2019-03-08");
    $scope.selectHtl(hotelreservationcategory,parameters.HTL.CON);
  };
  
}]);

angular.module("app").controller("ActivitiesCreateForTakeAwayController",["$scope","modelstore",
                                            function($scope,modelstore) {

  $scope.model=modelstore.getModel('activities/createForTakeAway');
  $scope.model.defaultVis='TAK';
  
}]);
angular.module("app").controller("ActivitiesCreateForLabyrintheController",["$scope","modelstore",
                                            function($scope,modelstore) {

  $scope.model=modelstore.getModel('activities/createForLabyrinthe');
  $scope.model.defaultVis='LAB';
  
}]);
angular.module("app").controller("ActivitiesCreateForHottonController",["$scope","modelstore",
                                            function($scope,modelstore) {

  $scope.model=modelstore.getModel('activities/createForHotton');
  $scope.model.defaultVis='HOT';
  
}]);
angular.module("app").controller("ActivitiesCreateForGreenfieldsController",["$scope","modelstore",
                                            function($scope,modelstore) {

  $scope.model=modelstore.getModel('activities/createForGreenfields');
  $scope.model.defaultVis='TML';
  
}]);
angular.module("app").controller("ActivitiesCreateForEmpController",["$scope","$stateParams","tools","modelstore","parameters","user","webservice","contactsService","visitsService",
                                            function($scope,$stateParams,tools,modelstore,parameters,user,webservice,contactsService,visitsService) {
  
  $scope.createScript="activities/createForEmp";
  var model;
  if("model" in $scope) {
    model=$scope.model;
  } else {
    model=modelstore.getModel($scope.createScript);
    $scope.model=model;
  }
  
  $scope.selectedElements=[];
  $scope.init = function() {
    if(!("visit" in model) || !("isCreated" in model.visit) || !('id' in model.visit) || model.visit.isCreated) {
      if(!('isClean' in model) || !model.isClean) {
        modelstore.cleanModel(["contacts","visits","activities","participants","meals","dishes","products","items"],model);
      }
      model.previousStartdate=null;
      contactsService.initContacts(model);
      visitsService.initVisit(model);
      $scope.$broadcast("sortVisitElements");
    }
  };

  $scope.setOpenEditingSelected = function(record) {
    record.isOpen=true;
    record.editing=true;
    record.selected=false;
  };

  $scope.$watch("model.visit.startdate",function() {
    if("visit" in model) {
      if(model.previousStartdate!=null
          && model.previousStartdate!=tools.dateFromJava(model.visit.startdate)
          && model.previousStartdate==tools.dateFromJava(model.visit.enddate)) {
        model.visit.enddate=tools.clone(model.visit.startdate);
      }
      model.previousStartdate=tools.dateFromJava(model.visit.startdate);
    }
  },true);
  
  model.task="c";
  model.previousStartdate=null;

  webservice.afterLogin().then(function() {
    webservice.call('load',{},$scope.createScript,model).then(function() {
      if(("rights" in user) && user.rights.indexOf("QUOT")>-1 && model.visit.quotationmanager=='0') {
        model.visit.quotationmanager=user.id;
      }
    });
  });
  
}]);
angular.module("app").controller("ActivitiesAgendaController",["$scope","$stateParams","tools","modelstore","parameters","activitiesService","webservice","contactsService",
                                            function($scope,$stateParams,tools,modelstore,parameters,activitiesService,webservice,contactsService) {

  $scope.activitiesService=activitiesService;
  $scope.contactsService=contactsService;
  var script='activities/agenda';
  var model=modelstore.getModel(script);
  $scope.model=model;

  $scope.afterLoad = function() {
    var dates={};
    var unts={};
    var i,j,k,activity,day,slt,participants,unt,hotelreservationcategories,htl;
    var acts={};
    for(j in model.frms) {
      acts[model.frms[j].substr(0,3)]=true;
    }
    var act='';
    if(Object.keys(acts).length===1) {
      act=Object.keys(acts)[0];
    }
    for(i in model.activities) {
      activity=model.activities[i];
      day=tools.dateFromJava(activity.day);
      if(!(day in dates)) {
        dates[day]={'id':day,'slts':{}};
      }
      slt=parameters.HRS[activity.hrs].field2;
      if(!(slt in dates[day].slts)) {
        dates[day].slts[slt]={'id':slt,'activities':[]}
      }
      activity.accomodations=[];
      hotelreservationcategories=tools.match(model.hotelreservationcategories,{'visit':activity.visit});
      for(k in hotelreservationcategories) {
        htl=hotelreservationcategories[k].htl;
        if(activity.accomodations.indexOf(htl)==-1) {
          activity.accomodations.push(htl);
        }
      }
      dates[day].slts[slt].activities.push(activity);
      participants=tools.join(activity,'participants',model);
      for(j in participants) {
        unt=participants[j].unt;
        if(!(unt in unts) && (act==='' || unt.substr(0,3)==act)) {
          unts[unt]=parameters.UNT[unt];
        }
      }
    }
    for(i in dates) {
      dates[i].slts=tools.toArray(dates[i].slts);
    }
    model.dates=tools.toArray(dates);
    if(act!=='' || Object.keys(unts).length<=6) {
      model.unts=tools.toArray(unts);
    } else {
      model.unts=[];
    }
  };

  $scope.load = function(companies,unpaid) {
    if(tools.validateAndUpdateDates(model)) {
      modelstore.cleanModel(["visits","activities","participants","items","hotelreservationcategories"],model);
      webservice.exclusiveCall("load",{
        'startdate':tools.dateFromJava(model.startdate),
        'enddate':tools.dateFromJava(model.enddate),
        'startHrs':model.startHrs,
        'endHrs':model.endHrs,
        'frms':model.frms,
        'companies':model.companies,
        'unpaid':model.unpaid,
        'ticketNr':model.ticketNr
      },script,model).then(function() {
        model.ticketNr='';
        $scope.afterLoad();
      });
    }
  };

  $scope.todayDate = function() {
    var today = tools.dateToJava(tools.today());
    model.startdate=today;
    model.enddate=today;
    $scope.load();
  }

  $scope.increaseDates = function(increment) {
    var newStartdate=new Date(model.startdate.getTime());
    newStartdate.setDate(newStartdate.getDate()+increment);
    model.startdate=newStartdate;
    var newEnddate=new Date(model.enddate.getTime());
    newEnddate.setDate(newEnddate.getDate()+increment);
    model.enddate=newEnddate;
    $scope.load();
  };

  $scope.oneIsActive = function(act) {
    var frms=activitiesService.activityFilter(parameters.notDelFRM,'id',act);
    var result=false;
    for(var i in frms) {
      if(model.frms.indexOf(frms[i].id)>=0) {
        result=true;
        break;
      }
    }
    return result;
  };

  $scope.selectFrm = function(frm) {
    var index=model.frms.indexOf(frm);
    if(index<0) {
      model.frms.push(frm);
    } else {
      model.frms.splice(index,1);
    }
  };

  $scope.swapAll = function(add) {
    var frms=activitiesService.activityFilter(parameters.notDelFRM,'id',model.act);
    var i,id;
    for(i in frms) {
      id=frms[i].id;
      if(tools.xor(model.frms.indexOf(id)>=0,add)) {
        $scope.selectFrm(id);
      }
    }
  };

  $scope.selectAct = function() {
    if(!$scope.oneIsActive(model.act)) {
      $scope.swapAll(true);
    }
  };

  $scope.getActivities = function(activities) {
    var result=[];
    var i,activity;
    for(i in activities) {
      activity=activities[i];
      if(model.showZero || tools.sum(tools.inverseJoin(tools.join(activity,'participants',model),'items','item',model),'planningquantity')>0) {
        result.push(activity);
      }
    }
    if(model.filters.name!='') {
      activities=result;
      result=[];
      var filters=tools.latinise(model.filters.name).split(" ");
      var j,matches,name;
      for(i in activities) {
        activity=activities[i];
        matches=true;
        name=tools.latinise(model.visits[activity.visit].name);
        for(j in filters) {
          if(!(name.indexOf(filters[j])>-1)) {
            matches=false;
            break;
          }
        }
        if(matches) {
          result.push(activity);
        }
      }
    }
    if(model.filters.creationDate.startdate != '' || model.filters.creationDate.enddate != '') {
      activities=result;
      result=[];
      var startdate = model.filters.creationDate.startdate != '' ? model.filters.creationDate.startdate :  model.dateOptions.minDate;
      var enddate = model.filters.creationDate.enddate != '' ? model.filters.creationDate.enddate :  model.dateOptions.maxDate;
      if(startdate > enddate) {
        var temp = startdate;
        model.filters.creationDate.startdate = enddate;
        model.filters.creationDate.enddate = temp;
      }
      for(i in activities) {
        activity = activities[i];
        var visitCreationDate = tools.dateToJava(model.visits[activity.visit].created);
        if(visitCreationDate >= startdate && visitCreationDate <= enddate) {
          result.push(activity);
        }
      }
    }
    var selectedVis = parameters.notDelArrayVIS.filter(function(vis) {return vis.selected});
    if(selectedVis.length > 0) {
      activities=result;
      result=[];
      for(i in activities) {
        activity = activities[i];
        var visFound = selectedVis.find(function (vis) { return vis.id === model.visits[activity.visit].vis});
        if(angular.isDefined(visFound) && visFound.selected) {
          result.push(activity);
        }
      }
    }

    return result;
  };

  $scope.resetVisitOrigins = function() {
    parameters.notDelArrayVIS.forEach(function (vis) { vis.selected = false });
  }

  $scope.editComment = function(activity) {
    model.backupActivities[activity.id]=tools.clone(activity);
    activity.editing=true;
  }

  $scope.cancelComment = function(activity) {
    modelstore.addRecord("activities",model.backupActivities[activity.id],model);
    $scope.afterLoad();
  };

  $scope.updateComment = function(activity) {
    var id=activity.id;
    webservice.call("updateComment",{
      "activity":tools.whitelist(activity,['comment'])
    },script,model).then(function(response) {
      if(response) {
        model.activities[id].editing=false;
        $scope.afterLoad();
      }
    });
  };

  $scope.updateActivityStat = function(activity,stat) {
    webservice.exclusiveCall('updateActivityStat',{'activityId':activity.id,'stat':stat},script,model).then(activity.stat=stat);
  };

  $scope.any={'id':'','labelen':'--All--','labelnl':'--Alle--','labelfr':'--Tout--'};

  if(!("startdate" in model)) {
    tools.initDates(0,0,model);
  }
  tools.initAttributes(model,{
    'startdateOpened':false,
    'enddateOpened':false,
    'dateOptions':{
      maxDate: new Date(2099,11,31),
      minDate: new Date(2000,0,1),
      startingDay: 1
    },
    'startHrs':'',
    'endHrs':'',
    'act':'',
    'frms':[],
    'showZero':false,
    'filter':'',
    'dates':[],
    'unts':[],
    'companies':false,
    'unpaid':false,
    'backupActivities':{},
    'ticketNr':'',
    'filters': {
      name:'',
      creationDate:{
        startdateOpened:false,
        enddateOpened:false,
        startdate:'',
        enddate:''
      },
      isCollapsed: true
    }
  });

  webservice.afterLogin().then(function() {
    if(model.act==='' && $stateParams.settings!==null && 'acts' in $stateParams.settings && $stateParams.settings.acts!==null) {
      for(var i in $stateParams.settings.acts) {
        model.act=$stateParams.settings.acts[i];
        $scope.selectAct();
      }
    }
    $scope.load();
  });
  $scope.$watch("model.startdate.getTime()",function(newVal,oldVal) {
    if(oldVal==model.enddate.getTime()) {
      model.enddate=new Date();
      model.enddate.setTime(newVal);
      if(webservice.loggedIn) {
        $scope.load();
      }
    }
  });

}]);

angular.module("app").controller("ActivitiesActivityOverviewController",["$scope","tools","modelstore","parameters","activitiesService","webservice",
                                            function($scope,tools,modelstore,parameters,activitiesService,webservice) {

  $scope.activitiesService=activitiesService;
  var script='activities/activityOverview';
  var model=modelstore.getModel(script);
  $scope.model=model;

  $scope.load = function(companies,unpaid) {
    if(tools.validateAndUpdateDates(model)) {
      model.actValue=model.actEditable;
      model.frmValue=model.frmEditable;
      modelstore.cleanModel(["visits","activities","participants","items"],model);
      webservice.exclusiveCall("load",{
        'startdate':tools.dateFromJava(model.startdate),
        'enddate':tools.dateFromJava(model.enddate),
        'startHrs':model.startHrs,
        'endHrs':model.endHrs,
        'act':model.act,
        'companies':model.companies,
        'unpaid':model.unpaid
      },script,model).then(function() {
        var dates={};
        var unts={};
        var i,j,activity,day,slt,participants,unt;
        for(i in model.activities) {
          activity=model.activities[i];
          day=tools.dateFromJava(activity.day);
          if(!(day in dates)) {
            dates[day]={'id':day,'slts':{}};
          }
          slt=parameters.HRS[activity.hrs].field2;
          if(!(slt in dates[day].slts)) {
            dates[day].slts[slt]={'id':slt,'activities':[]}
          }
          dates[day].slts[slt].activities.push(activity);
          participants=tools.join(activity,'participants',model);
          for(j in participants) {
            unt=participants[j].unt;
            if(!(unt in unts) && unt.substr(0,3)==model.act) {
              unts[unt]=parameters.UNT[unt];
            }
          }
        }
        for(i in dates) {
          dates[i].slts=tools.toArray(dates[i].slts);
        }
        model.dates=tools.toArray(dates);
        model.unts=tools.toArray(unts);
      });
    }
  };

  $scope.todayDate = function() {
    var today = tools.dateToJava(tools.today());
    model.startdate=today;
    model.enddate=today;
    $scope.load();
  }

  $scope.increaseDates = function(increment) {
    var newStartdate=new Date(model.startdate.getTime());
    newStartdate.setDate(newStartdate.getDate()+increment);
    model.startdate=newStartdate;
    var newEnddate=new Date(model.enddate.getTime());
    newEnddate.setDate(newEnddate.getDate()+increment);
    model.enddate=newEnddate;
    $scope.load();
  };

  $scope.getActivities = function(activities) {
    var result=[];
    var i,activity;
    for(i in activities) {
      activity=activities[i];
      if(model.showZero || tools.sum(tools.inverseJoin(tools.join(activity,'participants',model),'items','item',model),'quantity')>0) {
        result.push(activity);
      }
    }
    if(model.filter!='') {
      activities=result;
      result=[];
      var filters=tools.latinise(model.filter).split(" ");
      var j,matches,name;
      for(i in activities) {
        activity=activities[i];
        matches=true;
        name=tools.latinise(model.visits[activity.visit].name);
        for(j in filters) {
          if(!(name.indexOf(filters[j])>-1)) {
            matches=false;
            break;
          }
        }
        if(matches) {
          result.push(activity);
        }
      }
    }
    return result;
  };

  $scope.any={'id':'','labelen':'--All--','labelnl':'--Alle--','labelfr':'--Tout--'};

  if(!("startdate" in model)) {
    tools.initDates(0,0,model);
  }
  tools.initAttributes(model,{
    'startdateOpened':false,
    'enddateOpened':false,
    'dateOptions':{
      maxDate: new Date(2099,11,31),
      minDate: new Date(2000,0,1),
      startingDay: 1
    },
    'startHrs':'',
    'endHrs':'',
    'act':'VTT',
    'showZero':false,
    'filter':'',
    'dates':[],
    'unts':[],
    'companies':false,
    'unpaid':false
  });
  webservice.afterLogin().then(function() {
    $scope.load();
  });
  $scope.$watch("model.startdate.getTime()",function(newVal,oldVal) {
    if(oldVal==model.enddate.getTime()) {
      model.enddate=new Date();
      model.enddate.setTime(newVal);
      $scope.load();
    }
  });
  
}]);
var activitiesService=function(user,tools,parameters,modelstore,webservice) {
  this.user=user;
  this.tools=tools;
  this.parameters=parameters;
  this.modelstore=modelstore;
  this.webservice=webservice;
};

activitiesService.prototype.activityFilter = function(input,field,formula) {
  if(input && formula) {
    var activity_type=formula.substr(0,3);
    var output=[];
    for(var i in input) {
      if(i in input && field in input[i] && input[i][field].substr(0,3)==activity_type) {
        output.push(input[i]);
      }
    }
    return output;
  } else {
    return [];
  }
};

activitiesService.prototype.formulaFilter= function(input,fld,frm) {
  var output=[];
  if(frm) {
    var activity_type=frm.substr(0,3);
    var formula=frm.substr(0,6);
    var field;
    for(var i in input) {
      if(i in input && fld in input[i]) {
        field=input[i][fld];
        if(field.substr(0,3)==activity_type &&
            (field.substr(0,6)==formula || field.substr(3,3)=='***')) {
          output.push(input[i]);
        }
      }
    }
  }
  return output;
};

activitiesService.prototype.matchesFormula = function(unit,formula) {
  if(unit && formula) {
    return (unit.substr(0,3)==formula.substr(0,3) &&
        (unit.substr(0,6)==formula.substr(0,6) || unit.substr(3,3)=='***'));
  } else {
    return false;
  }
};

activitiesService.prototype.ticketOut = function(ticketnr) {
  if(ticketnr) {
    ticketnr=ticketnr.toString();
    return ticketnr.substr(0,3)+'.'+ticketnr.substr(3);
  }
}

activitiesService.prototype.getNotDelFormulas = function(act) {
  return this.activityFilter(this.parameters.notDelFRM,'id',act);
};

activitiesService.prototype.getFormulas = function(act) {
  return this.activityFilter(this.parameters.FRM,'id',act);
};

activitiesService.prototype.defaultFormula = function(act) {
  return this.tools.first(this.getFormulas(act)).id;
};

activitiesService.prototype.percentToSymbol = function(percent) {
  var result="";
  switch(percent) {
  case '1':
    result='%';
    break;
  case '0':
    result='\u20AC';
    break;
  }
  return result;
};

activitiesService.prototype.countParticipants = function(participants,model) {
  var sum=0;
  if(this.parameters.UNT) {
    var participant;
    for(var i in participants) {
      participant=participants[i];
      if(participant.unt in this.parameters.UNT) {
        if(participant.item in model.items) {
          sum+=model.items[participant.item].planningquantity*this.parameters.UNT[participant.unt].field1;
        }
      }
    }
  }
  return sum;
};

activitiesService.prototype.filterZeroParticipants = function(occurences) {
  var output=[];
  if(occurences) {
    var occurence;
    for(var i in occurences) {
      occurence=occurences[i];
      if(this.countParticipants(this.tools.join(occurence,'participants'))>0) {
        output.push(occurence);
      }
    }
  }
  return output;
};

activitiesService.prototype.longOcc = function(occurence) {
  var model=this.modelstore.getModel();
  var formula=model.activities[occurence.activity].formula;
  var result=this.tools.label(this.parameters.ACT[formula.substr(0,3)]);
  var frm=this.parameters.FRM[formula];
  if(frm.field3=="1") {
    result+=" "+this.tools.label(frm);
  }
  return result;
};

activitiesService.prototype.getArrival = function(activity,occurence) {
  var activitiesService=this;
  if(occurence && occurence.hour!='00:00:00') {
    var fDuration=activitiesService.tools.amountIn(activitiesService.parameters.FRM[activity.formula].field1);
    var durationHours=Math.floor(fDuration);
    var duration=activitiesService.tools.expandDigits(durationHours,2)+":"+activitiesService.tools.expandDigits(Math.round((fDuration-durationHours)*60),2)+":00";
    var sum=this.tools.hoursAdd(occurence.departurehour==='00:00:00'?occurence.hour:occurence.departurehour,duration);
    var hours=parseInt(sum.substr(0,2));
    if(hours<6) {
      sum=(hours+24).toString()+sum.substr(2);
    }
    return sum;
  }
  return "";
};

activitiesService.prototype.frmOut = function(frm) {
  if(frm) {
    return this.tools.label(this.parameters.ACT[frm.substr(0,3)])+' '+this.tools.short(this.parameters.FRM[frm]);
  }
};

activitiesService.prototype.convertStat = function(visStat,actStat) {
  if(visStat) {
    if(visStat==3000 && actStat>1000) {
      return this.parameters.STO[this.tools.expandDigits(actStat,4)];
    } else {
      return this.parameters.STV[this.tools.expandDigits(visStat,4)];
    }
  }
};

activitiesService.prototype.getColour = function(activity) {
  var act='';
  var frm='';
  var result="";
  if("frm" in activity && activity.frm!='') {
    frm=activity.frm;
    act=frm.substr(0,3);
  } else if("act" in activity && activity.act!='') {
    act=activity.act;
  }
  if(frm!='' && frm in this.parameters.FRM) {
    result=this.parameters.FRM[frm].field10;
  }
  if(result=='' && act!='' && act in this.parameters.ACT) {
    result=this.parameters.ACT[act].field1;
  }
  if(result!='') {
    result='#'+result;
  }
  return result;
};

activitiesService.prototype.formulaOut = function(activity,long) {
  var result="";
  if('frm' in activity && activity.frm in this.parameters.FRM) {
    result+=this.tools.label(this.parameters.ACT[this.tools.substr(activity.frm,0,3)]);
    var frm=this.parameters.FRM[activity.frm];
    if(frm.field3=='1') {
      if(long) {
        result+=' '+this.tools.label(this.parameters.FRM[activity.frm]);
      } else {
        result+=' '+this.tools.short(this.parameters.FRM[activity.frm]);
      }
    }
  }
  return result;
};

activitiesService.prototype.activityDescription = function(activity,long) {
  var result;
  if('frm' in activity && activity.frm!=='') {
    if(this.parameters.ACT[activity.frm.substr(0,3)].field3=='1' && activity.quotationtitle!='') {
      result=activity.quotationtitle;
    } else {
      result=this.formulaOut(activity,long);
    }
  } else {
    result='';
  }
  return result;
};

angular.module("app").service("activitiesService",["user","tools","parameters","modelstore","webservice",activitiesService]);

angular.module('app').controller('AccountingTaxcomponentsController',['$scope','tools','parameters','modelstore','webservice','activitiesService',
                                            function($scope,tools,parameters,modelstore,webservice,activitiesService) {

  var script='accounting/taxcomponents';
  var model=modelstore.getModel(script);
  $scope.model=model;

  $scope.initTaxcomponent = function() {
    model.taxcomponent = {
      'supplierdvs':'',
      'vat':'VAT4',
      'part':'100',
      'accountcode':'',
      'costcenter':'',
      'costunit':'',
      'productcode':''
    };
  };

  var all={'id':'','labelen':'--All--','labelnl':'--Alle--','labelfr':'--Tout--'};
  $scope.getActivities = function() {
    var result=[];
    var i,j,act,frm;
    if(model.hasNoTaxcomponents) {
      for(i in parameters.ACT) {
        act=parameters.ACT[i];
        if(act.field5!='1' && (tools.getLength(tools.match(model.taxcomponents,{'itm':'AC'+act.id}))<=0 || act.id==model.act)) {
          result.push(act);
        } else {
          for(j in parameters.FRM) {
            frm=parameters.FRM[j];
            if(frm.id.substr(0,3==act.id) && (tools.getLength(tools.match(model.taxcomponents,{'itm':'AC'+frm.id}))<=0 || frm.id==model.itm)) {
              result.push(act);
              break;
            }
          }
        }
      }
    } else {
      result=parameters.notDelArrayACT;
    }
    return result;
  }

  $scope.getFormulas = function() {
    var result=[];
    var i,frm;
    if('ACT' in parameters && model.act in parameters.ACT && parameters.ACT[model.act].field5=='1') {
      var frms=activitiesService.getFormulas(model.act);
      if(model.hasNoTaxcomponents) {
        for(i in frms) {
          frm=frms[i];
          if(tools.getLength(tools.match(model.taxcomponents,{'itm':'AC'+frm.id}))<=0) {
            result.push(frm);
          }
        }
      } else {
        result=frms;
      }
    } else if(model.act!='') {
      result.push(all);
    }
    return result;
  };

  $scope.getRestaurants = function() {
    var result=[];
    var i,j,res,dsh;
    if(model.hasNoTaxcomponents) {
      for(i in parameters.notDelArrayRES) {
        res=parameters.notDelArrayRES[i];
        for(j in parameters.notDelArrayDSH) {
          dsh=parameters.notDelArrayDSH[j];
          if(dsh.id.substr(0,3)==res.id && tools.getLength(tools.match(model.taxcomponents,{'itm':'ME'+dsh.id}))<=0) {
            result.push(res);
            break;
          }
        }
      }
    } else {
      result=parameters.notDelArrayRES;
    }
    return result;
  }

  $scope.getMeals = function() {
    var result=[];
    var i,dsh,hasNoTaxcomponents;
    for(i in parameters.notDelArrayDSH) {
      dsh=parameters.notDelArrayDSH[i];
      hasNoTaxcomponents=tools.getLength(tools.match(model.taxcomponents,{'itm':'ME'+dsh.id}))<=0;
      if(dsh.id.substr(0,3)==model.res && ((model.hasNoTaxcomponents && hasNoTaxcomponents) || !model.hasNoTaxcomponents || dsh.id==model.itm)) {
        result.push(dsh);
      }
    }
    return result;
  };

  $scope.getProducts = function() {
    var result=[];
    var i,prd,hasNoTaxcomponents;
    for(i in parameters.notDelArrayPRD) {
      prd=parameters.notDelArrayPRD[i];
      hasNoTaxcomponents=tools.getLength(tools.match(model.taxcomponents,{'itm':'PRDCT'+prd.id}))<=0;
      if((model.hasNoTaxcomponents && hasNoTaxcomponents) || !model.hasNoTaxcomponents || prd.id==model.itm) {
        prd.en=prd.field3+': '+prd.labelen;
        prd.nl=prd.field3+': '+prd.labelnl;
        prd.fr=prd.field3+': '+prd.labelfr;
        result.push(prd);
      }
    }
    return result;
  };

  $scope.getHotels = function() {
    var result=[];
    var i,j,htl,hsc,hpd;
    if(model.hasNoTaxcomponents) {
      for(i in parameters.notDelArrayHTL) {
        htl=parameters.notDelArrayHTL[i];
        if(model.category=='HS') {
          for(j in parameters.notDelArrayHSC) {
            hsc=parameters.notDelArrayHSC[j];
            if(hsc.id.substr(0,3)==htl.id && tools.getLength(tools.match(model.taxcomponents,{'itm':'HS'+hsc.id}))<=0) {
              result.push(htl);
              break;
            }
          }
        } else if(model.category=='HP') {
          for(j in parameters.notDelArrayHPD) {
            hpd=parameters.notDelArrayHPD[j];
            if(hpd.id.substr(0,3)==htl.id && tools.getLength(tools.match(model.taxcomponents,{'itm':'HP'+hpd.id}))<=0) {
              result.push(htl);
              break;
            }
          }
        }
      }
    } else {
      result=parameters.notDelArrayHTL;
    }
    return result;
  }

  $scope.getHotelspacecategories = function() {
    var result=[];
    var i,hsc,hasNoTaxcomponents;
    for(i in parameters.notDelArrayHSC) {
      hsc=parameters.notDelArrayHSC[i];
      hasNoTaxcomponents=tools.getLength(tools.match(model.taxcomponents,{'itm':'HS'+hsc.id}))<=0;
      if(hsc.id.substr(0,3)==model.htl && ((model.hasNoTaxcomponents && hasNoTaxcomponents) || !model.hasNoTaxcomponents || hsc.id==model.itm)) {
        result.push(hsc);
      }
    }
    return result;
  };

  $scope.getHotelproducts = function() {
    var result=[];
    var i,hpd,hasNoTaxcomponents;
    for(i in parameters.notDelArrayHPD) {
      hpd=parameters.notDelArrayHPD[i];
      hasNoTaxcomponents=tools.getLength(tools.match(model.taxcomponents,{'itm':'HP'+hpd.id}))<=0;
      if(hpd.id.substr(0,3)==model.htl && ((model.hasNoTaxcomponents && hasNoTaxcomponents) || !model.hasNoTaxcomponents || hpd.id==model.itm)) {
        result.push(hpd);
      }
    }
    return result;
  };

  var taxcomponentWhitelist=['supplierdvs','itm','vat','part','accountcode','costcenter','costunit','productcode'];

  $scope.getItm = function() {
    var result='';
    if(model.category=='AC') {
      if(model.act!='' && model.act in parameters.ACT) {
        if(parameters.ACT[model.act].field5=='1') {
          if(model.itm!='') {
            result=model.category+model.itm;
          }
        } else {
          result=model.category+model.act;
        }
      }
    } else if(model.category=='ME' || model.category=='PRDCT' || model.category=='HS' || model.category=='HP') {
      if(model.itm!='') {
        result=model.category+model.itm;
      }
    } else if(model.category=='') {
      if(model.itm!='') {
        result=model.itm;
      }
    }
    return result;
  };
  
  $scope.createTaxcomponent = function() {
    model.taxcomponent.itm=$scope.getItm();
    webservice.call('createTaxcomponent',{'taxcomponent':tools.whitelistNoId(model.taxcomponent,taxcomponentWhitelist)},script,model).then(function(response) {
      if(response) {
        $scope.initTaxcomponent();
      }
    });
  };
  
  $scope.editTaxcomponent = function(taxcomponent) {
    model.backupTaxcomponents[taxcomponent.id]=tools.clone(taxcomponent);
    taxcomponent.part=tools.amountOut(taxcomponent.part);
    taxcomponent.editing=true;
  };
  
  $scope.cancelTaxcomponent = function(taxcomponent) {
    modelstore.addRecord('taxcomponents',model.backupTaxcomponents[taxcomponent.id],model);
  };
  
  $scope.updateTaxcomponent = function(taxcomponent) {
    var id=taxcomponent.id;
    webservice.call('updateTaxcomponent',{
      'taxcomponent':tools.whitelist(taxcomponent,taxcomponentWhitelist)
    },script,model).then(function(response) {
      if(response) {
        model.taxcomponents[id].editing=false;
      }
    });
  };
  
  $scope.deleteTaxcomponent = function(taxcomponent) {
    webservice.deleteConfirm('taxcomponent','deleteTaxcomponent',taxcomponent.id,script,model);
  };
  
  tools.initAttributes(model,{
    'category':'ACTIV',
    'itm':'',
    'act':'',
    'res':'',
    'htl':'',
    'backupTaxcomponents':{}
  });
  if(!('taxcomponent' in model)) {
    $scope.initTaxcomponent();
  }
  webservice.afterLogin().then(function() {
    webservice.call('load',{},script,model);
  });

  $scope.default={'id':'','labelen':'--Default--','labelnl':'--Default--','labelfr':'--Default--'};
  $scope.none={'id':'','labelen':'--None--','labelnl':'--Geen--','labelfr':'--Aucun--'};
  
}]);
angular.module("app").controller("AccountingRetrieveAccountFormController",["$scope","$q","tools","modelstore","user","parameters","webservice","activitiesService",
                                            function($scope,$q,tools,modelstore,user,parameters,webservice,activitiesService) {

  $scope.activitiesService=activitiesService;
  var model=modelstore.getModel("accounting/retrieveAccount");
  $scope.model=model;

  tools.initAttributes(model,{
    'accounttype':'USR',
    'startdateOpened':false,
    'enddateOpened':false,
    'dateOptions':{
      maxDate: new Date(2099,11,31),
      minDate: new Date(2000,0,1),
      startingDay: 1
    },
    'startdate':new Date(),
    'enddate':new Date(),
    'mth':'CSH',
    'startdateValue':tools.today(),
    'enddateValue':tools.today(),
    'mthValue':'CSH',
    'account':null,
    'balance':null,
    'retrieveAccountFormIsLoaded':$q.defer()
  });
  model.retrieveAccountFormIsLoaded.resolve();
  
$scope.debug = function() {
  model.startdate=new Date(2017,0,1);
}
//$scope.debug();

  
}]);
angular.module("app").controller("AccountingRetrieveAccountController",["$scope","$q","tools","modelstore","user","parameters","webservice","activitiesService",
                                            function($scope,$q,tools,modelstore,user,parameters,webservice,activitiesService) {

  $scope.activitiesService=activitiesService;
  var model=modelstore.getModel("accounting/retrieveAccount");
  $scope.model=model;

  $scope.filterReductionItems = function(items) {
    var result=[];
    if(model.account!=null) {
      var i,item;
      for(i in items) {
        item=items[i];
        if(model.visits[item.visit].automaticreduction=='0'
            && item.updater==model.account.user
            && item.quantity>0
            && item.grossunitprice>0
            && item.reductionamount>0
            && item.updated>=model.startdateValue+" 00:00:00"
            && item.updated<=model.enddateValue+" 23:59:59") {
          result.push(item);
        }
      }
    }
    return result;
  };

  $scope.showBalance = function() {
    return model.account!=null && ((model.account.accounttype=='USR' && model.mthValue=='CSH') || model.account.accounttype=='PTN');
  };
  
}]);
angular.module("app").controller("AccountingRefundController",["$scope","$sce","$timeout","tools","modelstore","parameters","webservice","config","contactsService",
  function ($scope,$sce,$timeout,tools,modelstore,parameters,webservice,config,contactsService) {
    $scope.contactsService=contactsService;
    var script='accounting/refund';
    var model=modelstore.getModel(script);
    $scope.model=model;
    $scope.load = function() {
      modelstore.cleanModel(["visits","items","products"],model);
      webservice.exclusiveCall("load",{},script,model).then(function() {
        $scope.buildVisitContent();
      });
    };

    $scope.pay = function(visit) {
      webservice.confirmModal(tools.lang({'en':'Are you sure you want to perform this action for the visit : ','nl':'Weet u zeker dat u deze actie wilt uitvoeren voor het bezoek : ',
      'fr':'Êtes-vous certain de vouloir effectuer cette action pour la visite : '})+' '+model.contacts[visit.owningcontact].name+' ?').then(function() {
        webservice.exclusiveCall("pay",{'visitId':visit.id},script,model).then(function() {
          modelstore.removeRecord("visits",visit.id,model);
          delete model.visitIdsToExport[visit.id];
          $scope.buildVisitContent();
        });
      });
    }

    $scope.hasDifferenceBetweenMovementsMismatchAndRefundAmount = function(visit) {
      return tools.amountOut(visit.movementsmismatch) != tools.amountOut(visit.refundAmount);
    }

    $scope.getWarningMessage = function(visit) {
      return tools.lang({
        'en': "The refund amount given is different from that expected.\nGiven : "+visit.movementsmismatch+"\nExpected : -"+visit.refundAmount,
        'nl': "Het gegeven terugbetalingsbedrag verschilt van het verwachte bedrag.\nGegeven : "+visit.movementsmismatch + "\nVerwachte : -"+visit.refundAmount,
        'fr': "Le montant de remboursement donné est différent de celui attendu.\nDonnée : "+visit.movementsmismatch + "\nAttendu : -"+visit.refundAmount
      });
    }

    $scope.buildVisitContent = function() {
      var cashlessCreditContent=[];
      var reservationContent=[];
      var visitWithoutAccNumberContent=[];

      for (var visitId in model.visits) {
        if(!(visitId in model.visitIdsToExport)) {
          model.visitIdsToExport[visitId] = false;
        }
        var visit = model.visits[visitId];
        if (!visit.refundaccount) {
          visitWithoutAccNumberContent.push(visit);
        } else {
          if (tools.join(visit,"items",model).length > 0) {
            if (tools.join(visit,"products",model).length > 0) {
              cashlessCreditContent.push(visit);
            } else {
              reservationContent.push(visit);
            }
          }
        }
      }

      model.cashlessCreditContent = cashlessCreditContent;
      model.reservationContent = reservationContent;
      model.visitWithoutAccNumberContent = visitWithoutAccNumberContent;
    }

    $scope.changeAllStatus = function(visits,checkStatus) {
      for(var visitId in visits) {
        model.visitIdsToExport[visits[visitId].id] = checkStatus;
      }
    }

    $scope.changeIfAllSelected = function(visits,selector) {
      model.selectAllCheckboxesValues[selector] = visits.every(function(visit) {return model.visitIdsToExport[visit.id]});
    }

    $scope.createAndDownloadPainfile = function() {
      var visitIdsToExport = Object.keys(model.visitIdsToExport).filter(function(visitId){return model.visitIdsToExport[visitId]})
      if(visitIdsToExport.length == 0) return;

      return angular.toJson({
        "a":webservice.auth,
        "s":script,
        "t":"createAndDownloadPainfile",
        "p":{"visitIds":visitIdsToExport}
      });
    }

    $scope.reloadVisitsAfterTimeout = function() {
      $timeout(function() {
        var visitIdsToExport = Object.keys(model.visitIdsToExport).filter(function(visitId){return model.visitIdsToExport[visitId]})
        for(var visitId in visitIdsToExport) {
          modelstore.removeRecord("visits",visitIdsToExport[visitId],model);
          delete model.visitIdsToExport[visitIdsToExport[visitId]];
        }
        $scope.load();
      }, 1000);
    }

    $scope.hasVisitToExport = function() {
      return Object.values(model.visitIdsToExport).some(function(isToBeExported) {return isToBeExported;});
    }

    tools.initAttributes(model,{
      'selectAllCheckboxesValues':{
        'selectAllReservation':false,
        'selectAllCashless':false
      },
      'cashlessCreditContent':[],
      'reservationContent':[],
      'visitWithoutAccNumberContent':[],
      'action':$sce.trustAsResourceUrl(config.get('serviceUrl')),
      'visitIdsToExport':{},
    });

    webservice.afterLogin().then(function() {
      $scope.load();
    });
  }]);
angular.module("app").controller("AccountingMovementOverviewController",["$scope","tools","modelstore","parameters","webservice","user","contactsService",
                                            function($scope,tools,modelstore,parameters,webservice,user,contactsService) {

  var script='accounting/movementOverview';
  var model=modelstore.getModel(script);
  $scope.model=model;

  $scope.clean = function() {
    modelstore.cleanModel(["movements","accounts","visits","users","untillVisitExternalids"],model);
    model.sums=[];
    model.lines=[];
  };

  $scope.loadUsers = function() {
    if(Date.now()-model.currentCall>=1000 && angular.isDefined(model.startdate) && model.startdate!==null && angular.isDefined(model.enddate) && model.enddate!==null) {
      model.currentCall=Date.now();
      $scope.clean();
      model.users={'0':{'id':'0','name':tools.lang({'en':'Automatic payments','nl':'Automatische betalingen','fr':'Paiement automatique'}),'dvs':''}};
      webservice.call('loadUsers',{'startdate':tools.timestampFromJava(model.startdate),'enddate':tools.timestampFromJava(model.enddate)},script,model).then(function() {
        model.usrsArray=Object.values(model.users);
        for(var i in model.usrsArray) {
          model.usrsArray[i].active=model.usrs.indexOf(model.usrsArray[i].id)>=0;
        }
      });
    }
  };

  //RSA | Terminal ID | Cashless Machine ID

  $scope.load = function() {
    $scope.clean();
    if(tools.getLength(model.usrs)>0) {
      webservice.exclusiveCall("load",{
        'startdate':tools.timestampFromJava(model.startdate),
        'enddate':tools.timestampFromJava(model.enddate),
        'users':model.usrs
      },script,model).then(function() {
        $scope.calculateSums();
      });
    }
  };

  $scope.calculateSums = function() {
    var sums={};
    var i,movement,visit,account,key,dvs,mth,rsaId,resId,cashlessMachineId,groupKey,groupName;
    for(i in model.movements) {
      movement=model.movements[i];
      visit=model.visits[movement.visit];
      movement.contactName=contactsService.getName(model.contacts[visit.owningcontact]);
      dvs=visit.dvs;
      account=model.accounts[movement.account];
      mth=parameters.MTH[account.method];
      groupKey='00000000';
      groupName='';
      if(mth.field6==="RES" && (angular.isDefined(model.untillVisitExternalids[movement.visit]) || visit.comment.match(/^Untill sync ([A-Z0-9]*)$/)) && !model.groupByMethod) {
        rsaId=angular.isDefined(model.untillVisitExternalids[movement.visit])?model.untillVisitExternalids[movement.visit].externalid.split('_')[1]:visit.comment.match(/^Untill sync ([A-Z0-9]*)$/)[1];
        if(angular.isDefined(parameters.RSA[rsaId]) && angular.isDefined(parameters.RES[parameters.RSA[rsaId].field2])) {
          resId=parameters.RSA[rsaId].field2;
          groupKey=tools.expandDigits(resId,8);
          groupName=tools.label(parameters.RES[resId]);
        }
      } else if(angular.isDefined(model.movementIndexedCashlesspayments[movement.id]) && !model.groupByMethod) {
        cashlessMachineId=model.movementIndexedCashlesspayments[movement.id].machine;
        groupKey=tools.expandDigits(cashlessMachineId,8);
        groupName=angular.isDefined(parameters.cashlessMachines[cashlessMachineId])?parameters.cashlessMachines[cashlessMachineId].name:cashlessMachineId;
      } else if(account.terminalid!=='' && !model.groupByMethod) {
        groupKey=account.terminalid;
        groupName=account.terminalid;
      }
      key=groupKey+mth.id+dvs;
      if(!(key in sums)) {
        sums[key]={"key":key,"mthId":mth.id,"dvsId":dvs,"groupName":groupName,"sum":0.0,"movements":[],"selected":mth.id!="CSH"};
      }
      sums[key].sum+=movement.amount;
      sums[key].movements.push(movement);
    }
    model.sums=Object.values(sums);
    model.sums.sort(function(a,b) {
      return a.key.localeCompare(b.key);
    });
    $scope.calculateLines()
  }

  $scope.calculateLines = function() {
    var lines=[];
    var i,j,movements;
    var dvsFilterdSums=tools.match(model.sums,{"dvsId":model.dvs});

    for(i in dvsFilterdSums) {
      movements=dvsFilterdSums[i].movements;
      movements.sort(function(a,b) {
        return a.created.localeCompare(b.created);
      });
      for(j in movements) {
        if(lines.length<=j) {
          lines.push(dvsFilterdSums.map(function(sum) {
            return null;
          }));
        }
        lines[j][i]=movements[j];
      }
    }
    model.lines=lines;
  }

  $scope.totalOfSelected = function(dvsId) {
    return model.sums.filter(function(current) {
      return current.selected && current.dvsId==dvsId;
    }).reduce(function(total,current) {
      return total+current.sum;
    },0.0)
  }

  $scope.selectUsers = function(usrs) {
    var mode=tools.getLength(usrs)!==tools.getLength(tools.match(usrs,{'active':true}));
    for(var i in usrs) {
      usrs[i].active=mode;
    }
    model.usrs=model.usrsArray.filter(function(usr) {
      return usr.active
    }).map(function(usr) {
        return usr.id;
    });

  }

  if(!("startdate" in model)) {
    tools.initDates(0,0,model);
    model.startdate.setHours(0);
    model.startdate.setMinutes(0);
    model.startdate.setSeconds(0);
    model.enddate.setHours(23);
    model.enddate.setMinutes(59);
    model.enddate.setSeconds(59);
  }
  tools.initAttributes(model,{
    'startdateOpened':false,
    'enddateOpened':false,
    'dateOptions':{
      maxDate: tools.addDays((tools.today()),1),
      minDate: new Date(2000,0,1),
      startingDay: 1
    },
    'users':{},
    'untillVisitExternalids':{},
    'usrs':[],
    'sums':[],
    'lines':[],
    'dvs':'',
    'groupByMethod':true,
    'currentCall':Date.now()
  });
  var hrstime=60*60*1000;
  var daytime=24*hrstime;
  var debounce=1000;
  $scope.$watch("model.startdate.getTime()",function(newVal,oldVal) {
    if(newVal!==oldVal) {
      var deltaDaytime=oldVal-newVal;
      var absDeltaDaytime=Math.abs(deltaDaytime);
      if(absDeltaDaytime>=daytime-hrstime && absDeltaDaytime<daytime-1000) {
        model.startdate=new Date(newVal+(daytime*deltaDaytime/absDeltaDaytime));
      }
      if(Math.abs(oldVal-model.enddate.getTime())<=daytime && absDeltaDaytime!==hrstime && (absDeltaDaytime%daytime===0 || absDeltaDaytime%daytime===60*60*1000)) {
        model.enddate=new Date(model.enddate.getTime()-deltaDaytime);
      } else if(newVal>model.enddate.getTime()) {
        model.enddate=tools.timestampToJava(tools.dateFromJava(model.startdate)+' '+tools.hourFromJava(model.enddate));
      }
      model.currentCall=Date.now();
      tools.timeout($scope.loadUsers,debounce);
    }
  },true);
  $scope.$watch("model.enddate.getTime()",function(newVal,oldVal) {
    if(newVal!==oldVal) {
      var deltaDaytime=oldVal-newVal;
      var absDeltaDaytime=Math.abs(deltaDaytime);
      if(absDeltaDaytime>=daytime-hrstime && absDeltaDaytime<daytime-1000) {
        newVal=newVal+(daytime*deltaDaytime/absDeltaDaytime);
        model.enddate=new Date(newVal);
      }
      if(newVal<model.startdate.getTime()) {
        model.startdate=tools.timestampToJava(tools.dateFromJava(model.enddate)+' '+tools.hourFromJava(model.startdate));
      }
      model.currentCall=Date.now();
      tools.timeout($scope.loadUsers,debounce);
    }
  },true);
  $scope.$watch("model.dvs",function() {
    $scope.calculateLines();
  },true);
  $scope.$watch("model.groupByMethod",function() {
    $scope.calculateSums();
  },true);
  webservice.afterLogin().then(function() {
    model.currentCall=Date.now();
    model.dateOptions.maxDate=tools.addDays((tools.today()),1);
    if(model.dvs==='' && tools.getLength(tools.match(parameters.arrayDVS,{'field4':'1'}))>=1) {
      model.dvs=tools.first(tools.match(parameters.arrayDVS,{'field4':'1'})).id;
    }
    tools.timeout($scope.loadUsers,debounce);
  });
  
}]);
angular.module("app").controller("AccountingListPainfilesController",["$scope","$sce","tools","modelstore","parameters","webservice","config",
  function ($scope,$sce,tools,modelstore,parameters,webservice,config) {
    var script='accounting/listPainfiles';
    var model=modelstore.getModel(script);
    $scope.model=model;
    $scope.load = function() {
      modelstore.cleanModel(["painfiles","painlines","movements","visits"],model);
      webservice.exclusiveCall("load",{},script,model);
    };

    $scope.downloadPainfile = function(painfile) {
      return angular.toJson({
        "a":webservice.auth,
        "s":script,
        "t":"downloadPainfile",
        "p":{
          "painfileId":painfile.id
        }
      });
    }

    $scope.getPainlineStatWording = function(stat) {
      switch (stat) {
        case 1000:
          return tools.lang({'en':'Ongoing ','nl':'Lopende','fr':'En cours'});
        case 9000:
          return tools.lang({'en':'Confirmed','nl':'Bevestigd','fr':'Confirmé'});
      }
    }

    $scope.toggleAll = function(isOpen) {
      for(var id in model.painfiles) {
        model.expanded[id] = isOpen;
      }
    };

    tools.initAttributes(model,{
      'action':$sce.trustAsResourceUrl(config.get('serviceUrl')),
      'expanded':{}
    });

    webservice.afterLogin().then(function() {
      $scope.load();
    });
  }]);
angular.module("app").controller("AccountingKioskController",["$scope","tools","modelstore","parameters","webservice",
                                            function($scope,tools,modelstore,parameters,webservice) {

  var script='accounting/kiosk';
  var model=modelstore.getModel(script);
  $scope.model=model;

  $scope.clean = function() {
    modelstore.cleanModel(["movements"],model);
    model.sum=0.0;
    model.mthSums=[];
  };

  $scope.loadAccounts = function() {
    $scope.clean();
    model.terminalids=[];
    return webservice.call('loadAccounts',{'startdate':tools.dateFromJava(model.startdate),'enddate':tools.dateFromJava(model.enddate)},script,model).then(function(response) {
      model.terminalids=Object.keys(Object.values(model.accounts).reduce(function(terminalids,account) {
        terminalids[account.terminalid]=true;
        return terminalids;
      },{'--All--':true}));
    });
  };

  $scope.load = function() {
    $scope.clean();
    if(model.terminalid!=="") {
      webservice.exclusiveCall("load",{
        'startdate':tools.dateFromJava(model.startdate),
        'enddate':tools.dateFromJava(model.enddate),
        'terminalid':model.terminalid=='--All--'?'':model.terminalid
      },script,model).then(function() {
        var mthSums={};
        var i,j,movement,account;
        for(i in model.movements) {
          movement=model.movements[i];
          model.sum+=movement.amount;
          account=model.accounts[movement.account];
          if(!(account.method in mthSums)) {
            mthSums[account.method]=0.0;
          }
          mthSums[account.method]+=movement.amount;
        }
        for(i in mthSums) {
          model.mthSums.push({'mth':i,'amount':mthSums[i]});
        }
      });
    }
  };

  if(!("startdate" in model)) {
    tools.initDates(0,0,model);
  }
  tools.initAttributes(model,{
    'startdateOpened':false,
    'enddateOpened':false,
    'dateOptions':{
      maxDate: new Date(2099,11,31),
      minDate: new Date(2000,0,1),
      startingDay: 1
    },
    'terminalids':[],
    'terminalid':'',
    'sum':0.0,
    'mthSums':[]
  });
  var init=true;
  $scope.$watch("model.startdate",function() {
    if(!init) {
      $scope.loadAccounts().then($scope.load);
    }
  },true);
  $scope.$watch("model.enddate",function() {
    if(!init) {
      $scope.loadAccounts().then($scope.load);
    }
  },true);
  init=false;
  webservice.afterLogin().then(function() {
    $scope.loadAccounts();
  });
  
}]);
angular.module("app").controller("AccountingInvoicesListController",["$scope","$sce","tools","modelstore","parameters","webservice","config","contactsService",
                                            function($scope,$sce,tools,modelstore,parameters,webservice,config,contactsService) {
  $scope.contactsService=contactsService;
  var script='accounting/invoicesList';
  var model=modelstore.getModel(script);
  $scope.model=model;

  $scope.load = function() {
    if(tools.validateAndUpdateDates(model)) {
      modelstore.cleanModel(["visits","invoices",'users'],model);
      webservice.exclusiveCall("load",{
        'startdate':tools.dateFromJava(model.startdate),
        'enddate':tools.dateFromJava(model.enddate)
      },script,model);
    }
  };

  $scope.getInvoiceWsParams = function(invoice) {
    return angular.toJson({
      "a":webservice.auth,
      "s":script,
      "t":"printInvoice",
      "p":{"invoiceId":invoice.id}
    });
  };

  if(!("startdate" in model)) {
    tools.initDates(-31,0,model);
  }
  tools.initAttributes(model,{
    'startdateOpened':false,
    'enddateOpened':false,
    'dateOptions':{
      maxDate: new Date(2099,11,31),
      minDate: new Date(2000,0,1),
      startingDay: 1
    },
    'action':$sce.trustAsResourceUrl(config.get('serviceUrl'))
  });
  webservice.afterLogin().then(function() {
    $scope.load();
  });
  $scope.$watch("model.startdate.getTime()",function(newVal,oldVal) {
    if(oldVal==model.enddate.getTime()) {
      model.enddate=new Date();
      model.enddate.setTime(newVal);
    }
    $scope.load();
  });
  $scope.$watch("model.enddate.getTime()",$scope.load);
  
}]);
angular.module("app").controller("AccountingInvoicesController",["$scope","$sce","tools","config","modelstore","parameters","webservice",
                                            function($scope,$sce,tools,config,modelstore,parameters,webservice) {
  var script='accounting/invoices';
  var model=modelstore.getModel(script);
  $scope.model=model;
  
  $scope.load = function() {
    modelstore.cleanModel(["visits","invoices","movements","exactentries","exactmatchsets","exactmessages","exactbankentries","exactdeletes","intercompanies"],model);
    webservice.exclusiveCall("load",{},script,model).then(function() {
      var i,exactmessage,postContent;
      for(i in model.exactmessages) {
        exactmessage=model.exactmessages[i];
        postContent=angular.fromJson(exactmessage.post).Content;
        if(postContent.Action.toLowerCase()=="delete") {
          model.exactdeletes[exactmessage.id]=exactmessage;
        } else if(postContent.Topic=="BankEntries") {
          model.exactbankentries[exactmessage.id]=exactmessage;
        }
      }
    });
  };

  $scope.getErroneousInvoices = function() {
    return tools.match(model.invoices,{'exactnumber':''});
  };

  $scope.retryInvoice = function(invoice) {
    webservice.exclusiveCall("retryInvoice",{'invoiceId':invoice.id},script,model).then($scope.load);
  };

  $scope.retryMovements = function(movement) {
    webservice.exclusiveCall("retryMovements",{'date':movement.created.substr(0,10)},script,model).then($scope.load);
  }

  $scope.retryExactentry = function(exactentry) {
    webservice.exclusiveCall("retryExactentry",{'exactentryId':exactentry.id},script,model).then($scope.load);
  };
  
  $scope.retrySelectedExactentries = function() {
    if(tools.getLength(tools.match(model.exactentries,{'selected':true}))>0) {
      var exactentry=tools.first(tools.match(model.exactentries,{'selected':true}));
      webservice.exclusiveCall("retryExactentry",{"exactentryId":exactentry.id},script,model).then(function() {
        modelstore.removeRecord("exactentries",exactentry.id,model);
        $scope.retrySelectedExactentries();
      });
    } else {
      $scope.load();
    }
  };

  $scope.retryExactmatchsets = function() {
    webservice.exclusiveCall("retryExactmatchsets",{},script,model).then($scope.load);
  };

  $scope.ignoreExactmatchset = function(exactmatchset) {
    webservice.exclusiveCall("ignoreExactmatchset",{'exactmatchsetId':exactmatchset.id},script,model).then($scope.load);
  };

  $scope.ignoreSelectedExactmatchsets = function() {
    if(tools.getLength(tools.match(model.exactmatchsets,{'selected':true}))>0) {
      var exactmatchset=tools.first(tools.match(model.exactmatchsets,{'selected':true}));
      webservice.exclusiveCall("ignoreExactmatchset",{"exactmatchsetId":exactmatchset.id},script,model).then(function() {
        modelstore.removeRecord("exactmatchsets",exactmatchset.id,model);
        $scope.ignoreSelectedExactmatchsets();
      });
    } else {
      $scope.load();
    }
  };

  $scope.getExactmessageExactid = function(exactmessage) {
    return angular.fromJson(exactmessage.post).Content.Key;
  };

  $scope.getExactmessageTopic = function(exactmessage) {
    return angular.fromJson(exactmessage.post).Content.Topic;
  };

  $scope.getExactmessageDivision = function(exactmessage) {
    return angular.fromJson(exactmessage.post).Content.Division;
  };

  $scope.retryExactmessages = function() {
    webservice.exclusiveCall("retryExactmessages",{},script,model).then($scope.load);
  };
  
  $scope.retrySelectedExactmessages = function() {
    if(tools.getLength(tools.match(model.exactmessages,{'selected':true}))>0) {
      var exactmessage=tools.first(tools.match(model.exactmessages,{'selected':true}));
      webservice.exclusiveCall("retryExactmessage",{"exactmessageId":exactmessage.id},script,model).then(function() {
        modelstore.removeRecord("exactmessages",exactmessage.id,model);
        $scope.retrySelectedExactentries();
      });
    } else {
      $scope.load();
    }
  };

  $scope.retryExactmessage = function(exactmessage) {
    webservice.exclusiveCall("retryExactmessage",{'exactmessageId':exactmessage.id},script,model).then($scope.load);
  };

  $scope.deleteExactmessage = function(exactmessage) {
    webservice.exclusiveCall("deleteExactmessage",{'exactmessageId':exactmessage.id},script,model).then($scope.load);
  };

  $scope.deleteSelectedExactmessages = function() {
    if(tools.getLength(tools.match(model.exactmessages,{'selected':true}))>0) {
      var exactmessage=tools.first(tools.match(model.exactmessages,{'selected':true}));
      webservice.exclusiveCall("deleteExactmessage",{"exactmessageId":exactmessage.id},script,model).then(function() {
        modelstore.removeRecord("exactmessages",exactmessage.id,model);
        $scope.deleteSelectedExactmessages();
      });
    } else {
      $scope.load();
    }
  };

  $scope.retryIntercompany = function(intercompany) {
    webservice.exclusiveCall("retryIntercompany",{'intercompanyId':intercompany.id},script,model).then($scope.load);
  };

  $scope.retryIntercompanies = function() {
    webservice.exclusiveCall("retryIntercompanies",{},script,model).then($scope.load);
  };

  $scope.getIntercompanyErrorStep = function(intercompany) {
    var result;
    if(intercompany.purchaseexactnumber=='') {
      result='purchase invoice';
    } else if(intercompany.salesexactnumber=='') {
      result='sales invoice';
    } else {
      result='';
    }
    return result;
  };

  $scope.getInvoiceWsParams = function(invoice) {
    var result="{}";
    if(invoice) {
      result=angular.toJson({
        "a":webservice.auth,
        "s":'activities/retrieveForEmp',
        "t":"printInvoice",
        "p":{"invoiceId":invoice.id}
      });
    }
    return result;
  };

  if(!("startdate" in model)) {
    tools.initDates(0,0,model);
  }
  tools.initAttributes(model,{
    'visits':{},
    'invoices':{},
    'movements':{},
    'exactentries':{},
    'exactmatchsets':{},
    'exactmessages':{},
    'exactbankentries':{},
    'exactdeletes':{},
    'dateOptions':{
      maxDate: new Date(2099,11,31),
      minDate: new Date(2000,0,1),
      startingDay: 1
    },
    'startdateOpened':false,
    'enddateOpened':false,
    'action':$sce.trustAsResourceUrl(config.get('serviceUrl'))
  });
  webservice.afterLogin().then(function() {
    $scope.load();
  });

  
}]);
angular.module('app').controller('IntercompanyListController',['$scope','tools','modelstore','parameters','webservice',
                                            function($scope,tools,modelstore,parameters,webservice) {

  var script='accounting/intercompanyList';
  var model=modelstore.getModel('accounting/intercompanyList');
  $scope.model=model;

  $scope.load = function() {
    modelstore.cleanModel(['intercompanies','intercompanyitems','items'],model);
    webservice.exclusiveCall('load',{'unpaid':model.unpaid,'startdate':tools.dateFromJava(model.startdate),'enddate':tools.dateFromJava(model.enddate)},script,model).then(function(response) {
      model.dates=Array.from(new Set(tools.toArray(model.intercompanies).map(function(intercompany) {return intercompany.invoicedate;})));
      model.dates.sort();
    });
  };

  $scope.setIntercompanyPaid = function(intercompany,paid) {
    webservice.exclusiveCall('setIntercompanyPaid',{'intercompanyId':intercompany.id,'paid':paid},script,model);
  }

  if(!('startdate' in model)) {
    tools.initDates(-7,0,model);
  }
  tools.initAttributes(model,{
    'filterOpened':false,
    'unpaid':true,
    'startdateOpened':false,
    'enddateOpened':false,
    'dateOptions':{
      maxDate: new Date(2099,11,31),
      minDate: new Date(2000,0,1),
      startingDay: 1
    },
    'dates':[],
    'showUndo':false
  });

  webservice.afterLogin().then($scope.load);
  
}]);
angular.module("app").controller("AccountingIncomeController",["$scope","tools","modelstore","user","parameters","webservice","errorlog",
                                            function($scope,tools,modelstore,user,parameters,webservice,errorlog) {
  var script='accounting/income';
  var model=modelstore.getModel(script);
  $scope.model=model;
  
  $scope.load = function() {
    if(!model.loading) {
      model.loading=true;
      webservice.call('load',{
        'start':tools.dateFromJava(new Date(model.startyear,model.startperiod-1,1)),
        'end':tools.dateFromJava(new Date(model.endyear,model.endperiod,0)),
        'visitStartdateMode':model.visitStartdateMode,
        'visitStartdate':tools.dateFromJava(model.visitStartdate),
        'orderMode':model.orderMode,
        'origins':$scope.getField(model.origins,'id'),
        'itms':$scope.getField(model.itms,'id')
      },script,model).then(function(response) {
        if(response) {
          model.loading=false;
          $scope.afterLoad();
        }
      });
    }
  };

  $scope.afterLoad = function() {
    var componentList={};
    var accounts={};
    var i,taxcomponent,itmId,account;
    itmId='YYYYYYYY';
    for(i in model.taxcomponents) {
      taxcomponent=model.taxcomponents[i];
      account=taxcomponent.accountcode;
      accounts[taxcomponent.accountcode]={'id':account,'label':account};
      if(tools.getLength(model.selectedAccounts)===0 || model.selectedAccounts.findIndex(function(sAccount) {return sAccount.id===account;})>=0) {
        componentList[itmId+Array(9-itmId.length).join(' ')+tools.expandDigits(parameters.VAT[taxcomponent.vat].field1,2)+account]=true;
      }
    }
    model.componentList=Object.keys(componentList).sort();
    model.accounts=Object.values(accounts);
    $scope.setItmOptions();
  }

  $scope.setItmOptions = function() {
    var i,j,account,taxcomponents,taxcomponent,itm,itemType,param;
    var itmOptions={};
    var itemTypes={};
    var selectedAccounts={};
    if(tools.getLength(model.selectedAccounts)>0) {
      selectedAccounts=$scope.getField(tools.toArray(model.selectedAccounts),'id');
    } else {
      selectedAccounts=$scope.getField(tools.toArray(model.taxcomponents),'accountcode');
    }
    for(i in selectedAccounts) {
      account=selectedAccounts[i];
      taxcomponents=tools.match(model.taxcomponents,{'accountcode':account});
      for(j in taxcomponents) {
        taxcomponent=taxcomponents[j];
        itm=taxcomponent.itm;
        itemType=itm.substr(0,2);
        if(itemType==='AC' && itm.length===5) {
          param=parameters.ACT[itm.substr(2,3)];
        } else if(itemType==='AC' && itm.length==8) {
          param=parameters.FRM[itm.substr(2,6)];
        } else if(itemType==='ME') {
          param=parameters.DSH[itm.substr(2,6)];
        } else if(itemType==='HP') {
          param=parameters.HPD[itm.substr(2,6)];
        } else if(itemType==='HS') {
          param=parameters.HSC[itm.substr(2,6)];
        } else if(itemType==='PR') {
          param=parameters.PRD[itm.substr(5,3)];
        }
        if(angular.isUndefined(param)) {
          param={'labelen':itm,'labelnl':itm,'labelfr':itm};
        }
        param.id=itm;
        param.itemType=itemType;
        itmOptions[param.id]=param;
        itemTypes[itemType]=true;
      }
    }
    model.itmSettings.selectByGroups=Object.keys(itemTypes);
    model.itmOptions=itmOptions;
    model.itmOptionsArray=Object.values(model.itmOptions);
  }

  $scope.getTotalAmount = function(field) {
    var sum=0.0;
    for(var i in model.lines) {
      sum+=$scope.getTotalLineAmount(field,model.lines[i],1);
    }
    return sum;
  };
  $scope.getTotalLineAmount = function(field,line,total) {
    var selectedAccounts=$scope.getField(model.selectedAccounts,'id');
    var sum=0.0;
    for(var account in line[field]) {
      if(selectedAccounts.includes(account.substr(10))) {
        sum+=line[field][account];
      }
    }
    return sum;
  }

  $scope.showAccount = function(component) {
    return tools.getLength($scope.getField($scope.getField(model.lines,'vats'),component).filter(function(el) {return angular.isDefined(el) && el!==0;}))>0 &&
    tools.getLength($scope.getField($scope.getField(model.lines,'components'),component).filter(function(el) {return angular.isDefined(el) && el!==0;}))>0;
  }

  $scope.getField = function(array,field) {
    var result=[];
    if(tools.isArray(array) && field) {
      result=array.map(function(arr) {return arr[field];});
    }
    return result;
  };

  $scope.percentIn = function(percent) {
    return percent.replace(/^0/, '');
  };

  var previousMonth=new Date();
  previousMonth.setMonth(previousMonth.getMonth() - 1);
  previousMonth.setDate(1);
  tools.initAttributes(model,{
    'startyear':previousMonth.getFullYear()+'',
    'startperiod':(previousMonth.getMonth()+1)+'',
    'endyear':previousMonth.getFullYear()+'',
    'endperiod':(previousMonth.getMonth()+1)+'',
    'visitStartdate':previousMonth,
    'visitStartdateMode':'AFT',
    'visitStartdateModes':[
      {'id':'BEF','labelen':'Before','labelnl':'Voor','labelfr':'Avant'},
      {'id':'AFT','labelen':'After','labelnl':'Na','labelfr':'Après'}
    ],
    'visitStartdateOpened':false,
    'dateOptions':{
      startingDay: 1
    },
    'loading':false,
    'accounts':{},
    'accountSettings':{
      'scrollable':true,
      'scrollableHeight':'300px',
      'smartButtonMaxItems':5,
      'enableSearch':true,
      'styleActive':true,
      'keyboardControls':true
    },
    'selectedAccounts':[
      {'id':'700050','label':'700050'},
      {'id':'700052','label':'700052'},
      {'id':'700150','label':'700150'},
      {'id':'700151','label':'700151'},
      {'id':'700152','label':'700152'},
      {'id':'700200','label':'700200'},
      {'id':'700250','label':'700250'},
      {'id':'700350','label':'700350'},
      {'id':'700452','label':'700452'},
      {'id':'700550','label':'700550'},
      {'id':'700450','label':'700450'},
      {'id':'700800','label':'700800'},
      {'id':'700801','label':'700801'},
      {'id':'700802','label':'700802'},
      {'id':'700852','label':'700852'},
      {'id':'700900','label':'700900'}
    ],
    'componentList':[],
    'showMovements':false,
    'orderMode':'invoice',
    'orderModes':[
      {'id':'invoice','labelen':'Invoice Date','labelnl':'Factuur Datum','labelfr':'Date de Facturation'},
      {'id':'planning','labelen':'Planning Date','labelnl':'Planning Datum','labelfr':'Date de Planning'}
    ],
    'origins':[{'id':'CER'}],
    'originOptions':{},
    'originSettings':{
      'scrollable':true,
      'scrollableHeight':'300px',
      'smartButtonMaxItems':5,
      'enableSearch':true,
      'styleActive':true,
      'keyboardControls':true,
      'displayProp':tools.lang({'en':'labelen','nl':'labelnl','fr':'labelfr'})
    },
    'itms':[],
    'itmOptions':{},
    'itmSettings':{
      'scrollable':true,
      'scrollableHeight':'300px',
      'displayProp':tools.lang({'en':'labelen','nl':'labelnl','fr':'labelfr'}),
      'smartButtonMaxItems':5,
      'enableSearch':true,
      'styleActive':true,
      'keyboardControls':true,
      'groupByTextProvider': function(groupValue) {
        switch (groupValue) {
          case 'AC':
            return tools.lang({'en':'Activities','nl':'Activiteiten','fr':'Activit\u00E9s'});
          case 'ME':
            return tools.lang({'en':'Meals','nl':'Maaltijden','fr':'Repas'});
          case 'HS':
            return tools.lang({'en':'Accomodations','nl':'Accomodaties','fr':'H\u00E9bergements'});
          case 'HP':
            return tools.lang({'en':'Hotel products','nl':'Hotel producten','fr':'Produit hotel'});
          case 'PR':
            return tools.lang({'en':'Products','nl':'Producten','fr':'Produit'});
        }
      }
    },
    'translations':{
      'checkAll':tools.lang({'en':'Check all','nl':'Alles selecteren','fr':'S\u00E9llectioner tout'}),
      'uncheckAll':tools.lang({'en':'Uncheck all','nl':'Alles deselecteren','fr':'Des\u00E9llectioner tout'}),
      'selectionCount':tools.lang({'en':'checked','nl':'Geselecteerd','fr':'S\u00E9llectioner'}),
      'searchPlaceholder':tools.lang({'en':'Search...','nl':'Zoek...','fr':'Chercher...'}),
      'buttonDefaultText':tools.lang({'en':'Select','nl':'Selecteer','fr':'S\u00E9llectioner'}),
      'dynamicButtonTextSuffix':tools.lang({'en':'checked','nl':'Geselecteerd','fr':'S\u00E9llectioner'}),
      'selectGroup':tools.lang({'en':'Select All:','nl':'Selecteer Alles:','fr':'S\u00E9llectioner tout:'})
    }
  });
  webservice.afterLogin().then(function() {
    $scope.load();
    $scope.model.originOptions=tools.exclude(parameters.notDelVIS,{field3:'1'});
  });

  $scope.getMth = function() {
    var result=[];
    var i,mth;
    for(i in parameters.notDelMTH) {
      mth=parameters.notDelMTH[i];
      if(mth.id!='MIX') {
        result.push(mth);
      }
    }
    return result;
  };
  
}]);
angular.module("app").controller("AccountingDownPaymentsController",["$scope","tools","modelstore","parameters","webservice",
                                            function($scope,tools,modelstore,parameters,webservice) {
  var script='accounting/downPayments';
  var model=modelstore.getModel(script);
  $scope.model=model;
  
  $scope.load = function() {
    modelstore.cleanModel(["visits"],model);
    webservice.exclusiveCall("load",{},script,model);
  };

  webservice.afterLogin().then(function() {
    $scope.load();
  });

  $scope.getVoucherAmount = function(visit) {
    return -tools.sum(tools.less(tools.match(tools.join(visit,"items",model),{'itm':'PRDCTVOU'}),'quantity',0),'deltatopay');
  };

  $scope.paid = function(visit) {
    return tools.amountIn(visit.movementsamount)+$scope.getVoucherAmount(visit);
  };

  $scope.topay = function(visit) {
    return tools.amountIn(visit.turnover)+$scope.getVoucherAmount(visit);
  };

  $scope.argumentation = function(visit) {
    var result="";
    if(visit.vatnumber!=="") {
      result=tools.lang({'en':'VAT','nl':'BTW','fr':'TVA'})+visit.vatnumber;
    } else if(parameters.VIS[visit.vis].field1=="1") {
      result=tools.label(parameters.VIS[visit.vis])+" "+tools.lang({'en':'by','nl':'door','fr':'par'})+" "+visit.creator_name;
    } else if($scope.getVoucherAmount(visit)>0.0) {
      result=tools.lang({'en':'Voucher','nl':'Geschenkbon','fr':'Cheque cadeau'})+' '+tools.amountOut($scope.getVoucherAmount(visit))+' €';
    }
    return result;
  };
  
}]);
angular.module("app").controller("AccountingDayIncomeController",["$scope","$sce","$window","config","tools","modelstore","parameters","webservice",
                                            function($scope,$sce,$window,config,tools,modelstore,parameters,webservice) {
  var script='accounting/dayIncome';
  var model=modelstore.getModel(script);
  $scope.model=model;
  
  $scope.load = function() {
    model.dateValue=model.dateEditable;
    modelstore.cleanModel(["visits","movements","items"],model);
    webservice.call("load",{"date":tools.dateFromJava(model.date),"dvs":model.dvs},script,model).then(function(response) {
      if(response) {
        model.totalItems=0.0;
        model.totalMovements=0.0;
        model.totalVat=0.0;
        var components={};
        var methods={};
        //var sortedItms={};
        var sortedTaxcomponents={};
        var i,j,k,taxcomponent,sortfield,taxcomponents,item,itmId,visit,gross,base,vat,vatkey,movement,method;
        // for(i in model.itms) {
        //   itm=model.itms[i];
        //   if(!(itm.id in sortedItms)) {
        //     sortedItms[itm.id]=[];
        //   }
        //   itm.vatpercent=tools.amountIn(itm.vatpercent);
        //   sortedItms[itm.id].push(itm);
        // }
        for(i in model.taxcomponents) {
          taxcomponent=model.taxcomponents[i];
          taxcomponent.vat=tools.amountIn(parameters.VAT[taxcomponent.vat].field1);
          sortfield=tools.expandDigits(tools.round(taxcomponent.vat,0),2)+tools.expandDigits(taxcomponent.id,8);
          if(!(taxcomponent.itm in sortedTaxcomponents)) {
            taxcomponent.lastcomp='1';
            sortedTaxcomponents[taxcomponent.itm]={"maxValue":sortfield,'maxComponent':taxcomponent,'components':[]};
          } else {
            if(sortfield>sortedTaxcomponents[taxcomponent.itm].maxValue) {
              sortedTaxcomponents[taxcomponent.itm].maxComponent.lastcomp='0';
              taxcomponent.lastcomp='1';
              sortedTaxcomponents[taxcomponent.itm].maxValue=sortfield;
              sortedTaxcomponents[taxcomponent.itm].maxComponent=taxcomponent;
            } else {
              taxcomponent.lastcomp='0';
            }
          }
          sortedTaxcomponents[taxcomponent.itm].components.push(taxcomponent);
        }
        for(i in model.items) {
          item=model.items[i];
          visit=model.visits[item.visit];
          if(!("totalItems" in visit)) {
            visit.totalItems=0.0;
          }
          if(!("totalMovements" in visit)) {
            visit.totalMovements=0.0;
          }
          if(!("totalVat" in visit)) {
            visit.totalVat=0.0;
          }
          if(!("components" in visit)) {
            visit.components={};
          }
          if(!("methods" in visit)) {
            visit.methods={};
          }
          if(!(item.itm in sortedTaxcomponents)) {
            continue;
          } else {
            taxcomponents=sortedTaxcomponents[item.itm].components;
            for(j in taxcomponents) {
              taxcomponent=taxcomponents[j];
              if(taxcomponent.lastcomp=='1') {
                gross=item.deltatopay;
                for(k in taxcomponents) {
                  if(taxcomponents[k].lastcomp!='1') {
                    gross-=tools.round(tools.amountIn(taxcomponents[k].part)*item.deltatopay/100.0,2);
                  }
                }
              } else {
                gross=tools.round(tools.amountIn(taxcomponent.part)*item.deltatopay/100.0,2);
              }
              base=tools.round(100.0*gross/(100.0+taxcomponent.vat),2);
              vat=gross-base;
              itmId='YYYYYYYY';
              vatkey=itmId+Array(9-itmId.length).join(' ')+tools.expandDigits(tools.round(taxcomponent.vat,0),2)+taxcomponent.accountcode;
              if(!(vatkey in components)) {
                components[vatkey]={"code":vatkey,"base":0.0,"vat":0.0};
              }
              if(!(vatkey in visit.components)) {
                visit.components[vatkey]={"code":vatkey,"base":0.0,"vat":0.0};
              }
              model.totalItems+=gross;
              model.totalVat+=vat;
              components[vatkey].base+=base;
              components[vatkey].vat+=vat;
              visit.totalItems=tools.round(visit.totalItems+gross,2);
              visit.totalVat+=vat;
              visit.components[vatkey].base+=base;
              visit.components[vatkey].vat+=vat;
            }

            // itms=sortedItms[item.itm];
            // for(j in itms) {
            //   itm=itms[j];
            //   if(itm.lastcomp=='1') {
            //     gross=item.deltatopay-tools.round(tools.amountIn(itm.fielda)*item.deltatopay/100.0,2)-tools.round(tools.amountIn(itm.fieldb)*item.deltatopay/100.0,2)-tools.round(tools.amountIn(itm.fieldc)*item.deltatopay/100.0,2);
            //   } else {
            //     gross=tools.round(itm.vatcomp*item.deltatopay/100.0,2);
            //   }
            //   base=tools.round(100.0*gross/(100.0+itm.vatpercent),2);
            //   vat=gross-base;
            //   itmId=itm.id;
            //   if(itm.groupup=='1') {
            //     itmId='YYYYYYYY';
            //   }
            //   vatkey=itmId+tools.expandDigits(tools.round(itm.vatpercent,0),2)+itm.vatcode;
            //   if(!(vatkey in components)) {
            //     components[vatkey]={"code":vatkey,"base":0.0,"vat":0.0};
            //   }
            //   if(!(vatkey in visit.components)) {
            //     visit.components[vatkey]={"code":vatkey,"base":0.0,"vat":0.0};
            //   }
            //   model.totalItems+=gross;
            //   model.totalVat+=vat;
            //   components[vatkey].base+=base;
            //   components[vatkey].vat+=vat;
            //   visit.totalItems=tools.round(visit.totalItems+gross,2);
            //   visit.totalVat+=vat;
            //   visit.components[vatkey].base+=base;
            //   visit.components[vatkey].vat+=vat;
            // }
          }
        }
        for(i in model.movements) {
          movement=model.movements[i];
          visit=model.visits[movement.visit];
          model.totalMovements+=movement.amount;
          method=model.accounts[movement.account].method;
          if(!("methods" in visit)) {
            visit.methods={};
          }
          if(!(method in methods)) {
            methods[method]={"mth":method,"amount":0.0};
          }
          if(!(method in visit.methods)) {
            visit.methods[method]=0.0;
          }
          visit.totalMovements=tools.round(visit.totalMovements+movement.amount,2);
          methods[method].amount+=movement.amount;
          visit.methods[method]+=movement.amount;
        }
        model.components=tools.toArray(components);
        model.methods=tools.toArray(methods);
      }
      model.totalItems=tools.round(model.totalItems,2);
      model.totalMovements=tools.round(model.totalMovements,2);
    });
  };

  $scope.percentIn = function(percent) {
    return percent.replace(/^0/, '');
  };

  $scope.any={'id':'','labelen':'--All--','labelnl':'--Alle--','labelfr':'--Tout--'};

  tools.initAttributes(model,{
    'dateOpened':false,
    'date':new Date(),
    'dateOptions':{
      maxDate: new Date(2099,11,31),
      minDate: new Date(2000,0,1),
      startingDay: 1
    },
    "dvs":"",
    "components":[],
    "methods":[]
  });

  $scope.watching=false;
  webservice.afterLogin().then(function() {
    if(!$scope.watching) {
      $scope.watching=true;
      $scope.$watch('model.date',function() {
        $scope.load();
      });
    } else {
      $scope.load();
    }
  });
  
}]);
angular.module("app").controller("AccountingConsolidationController",["$scope","$sce","tools","modelstore","parameters","webservice","config",
                                            function($scope,$sce,tools,modelstore,parameters,webservice,config) {

  var script="accounting/consolidation";
  var model=modelstore.getModel(script);
  $scope.model=model;

  $scope._buildColsOrRows = function(colrow) {
    return tools.match(model.consparams,{'colrow':colrow}).filter(function(consparam) {
      return model.compare==='0' || model.compareMode=='side' || consparam.agpercentage==='0';
    }).sort(function(a,b) {
      return parseInt(a.sort)-parseInt(b.sort);
    });
  };

  $scope._getMatchingGlaccountData = function(row,subdata) {
    return Object.keys(subdata).reduce(function(acc,glaccount){
      if(row.matches[glaccount]) {
        var dataRow=subdata[glaccount];
        acc=Object.keys(dataRow).reduce(function(acc2,costcenter) {
          if(!(costcenter in acc2)) {
            acc2[costcenter]=0.0;
          }
          acc2[costcenter]=Math.round((acc2[costcenter]+(row.invert==='1'?-1:1)*dataRow[costcenter])*100.0)/100.0;
          return acc2;
        },acc);
      }
      return acc;
    },{});
  };

  $scope._getMatchingCostcenterValue = function(col,subdata) {
    return Math.round(Object.keys(subdata).reduce(function(acc,costcenter) {
      if(col.matches[costcenter]) {
        acc+=subdata[costcenter];
      }
      return acc;
    },0.0)*100.0)/100.0;
  };

  var colorClasses=['warning','success','info'];

  $scope.structureData = function() {
    var i,j,consparam,parentName,regex,row,matchingGlaccountNewData,matchingGlaccountOldData,structuredRow,sideRow,col,filterOptions,sum,sum2,sum3,previousRow,structuredCell;

    // build table rows and columns
    var allCols=$scope._buildColsOrRows('0');
    model.rows=$scope._buildColsOrRows('1');
    if(model.level1FilterOptions.length===0) {
      var colsLength=allCols.length;
      var nextLevel2Header=null;
      var nextLevel3Header=null;
      var level1FilterOptions={};
      var level2FilterOptions={};
      for(i=colsLength-1;i>=0;i--) {
        consparam=allCols[i];
        parentName=consparam.parent;
        if(consparam.aggreg==='1' && parseInt(consparam.aglevel)>='2') {
          level2FilterOptions[parentName]={
            'label':parentName,
            'level3Header':consparam.aglevel==='2'?nextLevel3Header:null,
            'state':true,
            'bold':consparam.bold,
            'colors':consparam.colors,
            'sort':i
          };
          nextLevel2Header=level2FilterOptions[parentName];
          if(consparam.aglevel!=='2') {
            nextLevel3Header=level2FilterOptions[parentName];
          }
        } else {
          if(!(parentName in level1FilterOptions)) {
            level1FilterOptions[parentName]={
              'label':parentName,
              'level2Header':nextLevel2Header,
              'state':true,
              'bold':consparam.bold,
              'colors':consparam.colors,
              'sort':i
            };
          }
        }
      }
      model.level1FilterOptions=Object.values(level1FilterOptions).sort(function(a,b) {
        return parseInt(a.sort)-parseInt(b.sort);
      });
      model.level2FilterOptions=Object.values(level2FilterOptions).sort(function(a,b) {
        return parseInt(a.sort)-parseInt(b.sort);
      });
    }
    model.cols=[];
    model.headers=[];
    var header=null;
    var headerColorCounter=2;
    for(i in allCols) {
      col=allCols[i];
      if(col.aggreg==='1' && parseInt(col.aglevel)>='2') {
        filterOptions=model.level2FilterOptions;
      } else {
        filterOptions=model.level1FilterOptions;
      }
      if(tools.getLength(tools.match(filterOptions,{'label':col.parent,'state':true}))>0) {
        model.cols.push(col);
        if(header===null || header.label!==col.parent) {
          if(!(col.aggreg==='1' && parseInt(col.aglevel)>='2')) {
            headerColorCounter=(headerColorCounter+1)%3;
          }
          header={'label':col.parent,'colspan':1,'color':colorClasses[headerColorCounter]};
          model.headers.push(header);
        } else {
          header.colspan+=1;
        }
        col.color=colorClasses[headerColorCounter];
        if(col.aggreg==='1' && parseInt(col.aglevel)>='2') {
          header.color='active';
          col.color='active';
        }
      }
    }

    // build regexp matches
    var allGlaccounts=Object.keys(Object.keys(model.newData).concat(model.compare==='1'?Object.keys(model.oldData):[]).reduce(function(acc,cur){
      acc[cur]=true;
      return acc;
    },{}));
    var allCostcenters=Object.keys(Object.values(model.newData).concat(model.compare==='1'?Object.values(model.oldData):[]).reduce(function(acc,row) {
      for(i in row) {
        acc[i]=true;
      }
      return acc;
    },{}));
    for(i in model.consparams) {
      consparam=model.consparams[i];
      if(consparam.aggreg==='0') {
        regex=new RegExp(consparam.regexpr);
        consparam.matches=(consparam.colrow==='0'?allCostcenters:allGlaccounts).reduce(function(acc,code){
          acc[code]=regex.test(code);
          return acc;
        },{});
      }
    }

    model.structuredData={};
    // build non aggregate structuredData
    for(i in model.rows) {
      row=model.rows[i];
      structuredRow={};
      if(row.aggreg==='0') {
        matchingGlaccountNewData=$scope._getMatchingGlaccountData(row,model.newData);
        if(model.compare==='1') {
          matchingGlaccountOldData=$scope._getMatchingGlaccountData(row,model.oldData);
        }
        for(j in model.cols) {
          col=model.cols[j];
          if(col.aggreg==='0') {
            structuredRow[col.id]=[$scope._getMatchingCostcenterValue(col,matchingGlaccountNewData),0.0];
            if(model.compare==='1') {
              structuredRow[col.id][1]=$scope._getMatchingCostcenterValue(col,matchingGlaccountOldData);
            }
          }
        }
      }
      model.structuredData[row.id]=structuredRow;
    }

    // build aggregate structuredData
    model.totals={};
    for(i in model.rows) {
      row=model.rows[i];
      structuredRow=model.structuredData[row.id];
      sum=[0.0,0.0];
      sum2=[0.0,0.0];
      sum3=[0.0,0.0];
      if(row.aggreg==='0') {
        model.totals[row.id]=[0.0,0.0];
        for(j in model.cols) {
          col=model.cols[j];
          if(col.aggreg==='0') {
            structuredCell=structuredRow[col.id];
            sum[0]=Math.round((sum[0]+structuredCell[0])*100.0)/100.0;
            sum2[0]=Math.round((sum2[0]+structuredCell[0])*100.0)/100.0;
            sum3[0]=Math.round((sum3[0]+structuredCell[0])*100.0)/100.0;
            model.totals[row.id][0]=Math.round((model.totals[row.id][0]+structuredCell[0])*100.0)/100.0;
            if(model.compare==='1') {
              sum[1]=Math.round((sum[1]+structuredCell[1])*100.0)/100.0;
              sum2[1]=Math.round((sum2[1]+structuredCell[1])*100.0)/100.0;
              sum3[1]=Math.round((sum3[1]+structuredCell[1])*100.0)/100.0;
              model.totals[row.id][1]=Math.round((model.totals[row.id][1]+structuredCell[1])*100.0)/100.0;
            }
          } else {
            if(col.aglevel==='1') {
              structuredRow[col.id]=sum;
              sum=[0.0,0.0];
            } else if(col.aglevel==='2') {
              structuredRow[col.id]=sum2;
              sum=[0.0,0.0];
              sum2=[0.0,0.0];
            } else if(col.aglevel==='3') {
              structuredRow[col.id]=sum3;
              sum=[0.0,0.0];
              sum2=[0.0,0.0];
              sum3=[0.0,0.0];
            }
          }
        }
      }
    }
    for(j in model.cols) {
      col=model.cols[j];
      sum=[0.0,0.0];
      sum2=[0.0,0.0];
      sum3=[0.0,0.0];
      for(i in model.rows) {
        previousRow=row;
        row=model.rows[i];
        if(row.aggreg==='0') {
          sum[0]=Math.round((sum[0]+model.structuredData[row.id][col.id][0])*100.0)/100.0;
          sum2[0]=Math.round((sum2[0]+model.structuredData[row.id][col.id][0])*100.0)/100.0;
          sum3[0]=Math.round((sum3[0]+model.structuredData[row.id][col.id][0])*100.0)/100.0;
          if(model.compare==='1') {
            sum[1]=Math.round((sum[1]+model.structuredData[row.id][col.id][1])*100.0)/100.0;
            sum2[1]=Math.round((sum2[1]+model.structuredData[row.id][col.id][1])*100.0)/100.0;
            sum3[1]=Math.round((sum3[1]+model.structuredData[row.id][col.id][1])*100.0)/100.0;
          }
        } else {
          if(row.aglevel==='0') {
            if(row.agpercentage==='0') {
              model.structuredData[row.id][col.id]=[model.structuredData[previousRow.id][col.id][0],0.0];
              if(model.compare==='1') {
                model.structuredData[row.id][col.id][1]=model.structuredData[previousRow.id][col.id][1];
              }
            } else {
              if(row.invert==='0') {
                model.structuredData[row.id][col.id]=[model.structuredData[model.rows[0].id][col.id][0]!=0?Math.round(model.structuredData[previousRow.id][col.id][0]*100.0/model.structuredData[model.rows[0].id][col.id][0]):0,0.0];
                if(model.compareMode==='side') {
                  model.structuredData[row.id][col.id][1]=model.structuredData[model.rows[0].id][col.id][1]!=0?Math.round(model.structuredData[previousRow.id][col.id][1]*100.0/model.structuredData[model.rows[0].id][col.id][1]):0;
                }
              } else {
                model.structuredData[row.id][col.id]=[model.structuredData[model.rows[0].id][col.id][0]!=0?Math.round((model.structuredData[model.rows[0].id][col.id][0]-model.structuredData[previousRow.id][col.id][0])*100.0/model.structuredData[model.rows[0].id][col.id][0]):0,0.0];
                if(model.compareMode==='side') {
                  model.structuredData[row.id][col.id][1]=model.structuredData[model.rows[0].id][col.id][1]!=0?Math.round((model.structuredData[model.rows[0].id][col.id][1]-model.structuredData[previousRow.id][col.id][1])*100.0/model.structuredData[model.rows[0].id][col.id][1]):0;
                }
              }
            }
          } else {
            if(row.aglevel==='1') {
              model.structuredData[row.id][col.id]=[sum[0],0.0];;
              if(model.compare==='1') {
                model.structuredData[row.id][col.id][1]=sum[1];
              }
            } else if(row.aglevel==='2') {
              model.structuredData[row.id][col.id]=[sum2[0],0.0];;
              if(model.compare==='1') {
                model.structuredData[row.id][col.id][1]=sum2[1];
              }
              sum=[0.0,0.0];
            } else if(row.aglevel==='3') {
              model.structuredData[row.id][col.id]=[sum3[0],0.0];;
              if(model.compare==='1') {
                model.structuredData[row.id][col.id][1]=sum3[1];
              }
              sum=[0.0,0.0];
              sum2=[0.0,0.0];
            }            
          }
        }
      }
    }

    // totals column
    sum=[0.0,0.0];
    sum2=[0.0,0.0];
    sum3=[0.0,0.0];
    for(i in model.rows) {
      previousRow=row;
      row=model.rows[i];
      if(row.aggreg==='0') {
        sum=[Math.round((sum[0]+model.totals[row.id][0])*100.0)/100.0,Math.round((sum[1]+model.totals[row.id][1])*100.0)/100.0];
        sum2=[Math.round((sum2[0]+model.totals[row.id][0])*100.0)/100.0,Math.round((sum2[1]+model.totals[row.id][1])*100.0)/100.0];
        sum3=[Math.round((sum3[0]+model.totals[row.id][0])*100.0)/100.0,Math.round((sum3[1]+model.totals[row.id][1])*100.0)/100.0];
      } else {
        if(row.aglevel==='0') {
          if(row.agpercentage==='0') {
            model.totals[row.id]=tools.clone(model.totals[previousRow.id]);
          } else {
            if(row.invert==='0') {
              model.totals[row.id]=[
                model.totals[model.rows[0].id][0]!=0?Math.round(model.totals[previousRow.id][0]*100.0/model.totals[model.rows[0].id][0]):0,
                model.totals[model.rows[0].id][1]!=0?Math.round(model.totals[previousRow.id][1]*100.0/model.totals[model.rows[0].id][1]):0];
            } else {
              model.totals[row.id]=[
                model.totals[model.rows[0].id][0]!=0?Math.round((model.totals[model.rows[0].id][0]-model.totals[previousRow.id][0])*100.0/model.totals[model.rows[0].id][0]):0,
                model.totals[model.rows[0].id][1]!=0?Math.round((model.totals[model.rows[0].id][1]-model.totals[previousRow.id][1])*100.0/model.totals[model.rows[0].id][1]):0];
            }
          }
        } else {
          if(row.aglevel==='1') {
            model.totals[row.id]=tools.clone(sum);
          } else if(row.aglevel==='2') {
            model.totals[row.id]=tools.clone(sum2);
            sum=[0.0,0.0];
          } else if(row.aglevel==='3') {
            model.totals[row.id]=tools.clone(sum3);
            sum=[0.0,0.0];
            sum2=[0.0,0.0];
          }            
        }
      }
    }

    // combine new and old data
    for(i in model.rows) {
      row=model.rows[i];
      structuredRow=model.structuredData[row.id];
      sideRow={};
      for(j in model.cols) {
        col=model.cols[j];
        if(model.compare==='0' || model.compareMode==='side') {
          if(model.compareMode==='side') {
            sideRow[col.id]=row.agpercentage==='0'?tools.financialAmountOut(structuredRow[col.id][1]):tools.amountOut(structuredRow[col.id][1])+'%';
          }
          structuredRow[col.id]=row.agpercentage==='0'?tools.financialAmountOut(structuredRow[col.id][0]):tools.amountOut(structuredRow[col.id][0])+'%';
        } else {
          if(row.agpercentage==='0') {
            if(model.compareMode==='diff') {
              structuredRow[col.id]=tools.financialAmountOut(Math.round((structuredRow[col.id][0]-structuredRow[col.id][1])*100.0)/100.0);
            } else if(model.compareMode==='ratio') {
              structuredRow[col.id]=structuredRow[col.id][1]!=0.0?Math.round((structuredRow[col.id][0]/structuredRow[col.id][1])*100.0)+'%':(structuredRow[col.id][0]==0.0?'':'\u221E');
            }
          }
        }
        model.sideData[row.id]=sideRow;
      }
      if(model.compare==='0' || model.compareMode==='side') {
        if(model.compareMode==='side') {
          model.sideTotals[row.id]=row.agpercentage==='0'?tools.financialAmountOut(model.totals[row.id][1]):tools.amountOut(model.totals[row.id][1])+'%';
        }
        model.totals[row.id]=row.agpercentage==='0'?tools.financialAmountOut(model.totals[row.id][0]):tools.amountOut(model.totals[row.id][0])+'%';
      } else {
        if(row.agpercentage==='0') {
          if(model.compareMode==='diff') {
            model.totals[row.id]=tools.financialAmountOut(Math.round((model.totals[row.id][0]-model.totals[row.id][1])*100.0)/100.0);
          } else if(model.compareMode==='ratio') {
            model.totals[row.id]=model.totals[row.id][1]!=0.0?Math.round((model.totals[row.id][0]/model.totals[row.id][1])*100.0):(model.totals[row.id][0]==0.0?0:'\u221E');
          }
        }
      }
    }

  };

  $scope.changeLevel2FilterOption = function(level2FilterOption) {
    level2FilterOption.state=!level2FilterOption.state;
    var i,filterOption;
    for(i in model.level2FilterOptions) {
      filterOption=model.level2FilterOptions[i];
      if(filterOption.level3Header!==null && filterOption.level3Header.label===level2FilterOption.label) {
        $scope.changeLevel2FilterOption(filterOption);
      }
    }
    for(i in model.level1FilterOptions) {
      filterOption=model.level1FilterOptions[i];
      if(filterOption.level2Header.label===level2FilterOption.label) {
        filterOption.state=level2FilterOption.state;
      }
    }
  };

  $scope.getCellStyle = function(amount,row,col) {
    var result={'color':'black','font-weight':'normal'};
    amount=tools.amountIn(amount);
    if((angular.isDefined(row) && row.colors=='1') || (angular.isDefined(col) && col.colors=='1')) {
      result.color=amount>=0?'green':'red';
    }
    if((angular.isDefined(row) && row.bold=='1') || (angular.isDefined(col) && (col.bold=='1' || col.aglevel==='2'))) {
      result['font-weight']='bold';
    }
    return result;
  };
  
  $scope.load = function() {
    model.newData={};
    model.oldData={};
    webservice.exclusiveCall("load",{
      'startyear':model.startyear,
      'startperiod':model.startperiod,
      'endyear':model.endyear,
      'endperiod':model.endperiod,
      'compare':model.compare,
      'comparemonths':model.comparemonths,
      'rpt':model.rpt
    },script,model).then($scope.structureData);
  };

  $scope.getExactentrylinesWsParams = function() {
    var result="{}";
    if("startyear" in model) {
      result=angular.toJson({
        "a":webservice.auth,
        "s":script,
        "t":"exportEntrylines",
        "p":{"startyear":model.startyear,"startperiod":model.startperiod,"endyear":model.endyear,"endperiod":model.endperiod}
      });
    }
    return result;
  };

  var previousMonth=new Date();
  previousMonth.setMonth(previousMonth.getMonth() - 1);
  tools.initAttributes(model,{
    'startyear':previousMonth.getFullYear()+'',
    'startperiod':(previousMonth.getMonth()+1)+'',
    'endyear':previousMonth.getFullYear()+'',
    'endperiod':(previousMonth.getMonth()+1)+'',
    'compare':'0',
    'comparemonths':'12',
    'compareMode':'side',
    'headers':[],
    'rpt':'',
    'cols':[],
    'rows':[],
    'level1FilterOptions':[],
    'level2FilterOptions':[],
    'structuredData':{},
    'sideData':{},
    'totals':{},
    'sideTotals':{},
    'action':$sce.trustAsResourceUrl(config.get('serviceUrl')),
    'filteredCols':[]
  });
  webservice.afterLogin().then(function() {
    model.rpt=tools.first(tools.match(parameters.notDelArrayRPT,{'field1':'1'})).id;
    $scope.$watch("model.rpt",function(newVal,oldVal) {
      if(newVal!==oldVal) {
        modelstore.cleanModel(['consparams'],model);
        model.level1FilterOptions=[];
        model.level2FilterOptions=[];
        $scope.load();
      }
    });
    $scope.load();
  });
  
}]);
angular.module("app").controller("AccountingCashManagementController",["$scope","$q","tools","modelstore","user","parameters","webservice","activitiesService",
                                            function($scope,$q,tools,modelstore,user,parameters,webservice,activitiesService) {

  $scope.activitiesService=activitiesService;
  var script="accounting/cashManagement";
  var model=modelstore.getModel("accounting/retrieveAccount");
  $scope.model=model;

  $scope.initAccountAndBalance = function(accountId) {
    model.accountId=accountId;
    model.account=model.accounts[accountId];
    model.balance=tools.max(tools.lessEqual(
      tools.join(model.account,'balances',model),
      'created',
      model.startdateValue+' 23:59:59'
    ),'created');
    model.calling=false;
  }

  $scope.load = function() {
    model.startdateValue=tools.dateFromJava(model.startdate);
    model.enddateValue=tools.dateFromJava(model.enddate);
    model.mthValue=model.mth;
    modelstore.cleanModel(["balances","movements","visits","activities","participants","items"],model);
    webservice.exclusiveCall("load",{'accountId':model.accountId,'startdate':tools.dateFromJava(model.startdate),'enddate':tools.dateFromJava(model.enddate),'mth':model.mth},script,model).then(function(response) {
      $scope.initAccountAndBalance(response);
    });
  };

  $scope.collect = function() {
    webservice.exclusiveCall("collect",{'debtor':model.account.id,'creditor':model.creditor,'amount':model.amount},script,model).then($scope.load);
  };

  tools.initAttributes(model,{
    'accountId':'',
    'amount':'',
    'creditor':'USR',
    'calling':false,
    'retrieveAccountFormIsLoaded':$q.defer()
  });
  $q.all([webservice.afterLogin(),model.retrieveAccountFormIsLoaded.promise]).then(function() {
    webservice.call("loadAccounts",{},script,model);
    if(model.accountId!='') {
      $scope.load();
    }
  });
  
}]);
angular.module("app").controller("AccountingBalancesController",["$scope","$q","tools","modelstore","user","parameters","webservice","activitiesService",
                                            function($scope,$q,tools,modelstore,user,parameters,webservice,activitiesService) {

  $scope.activitiesService=activitiesService;
  var script="accounting/balances";
  var model=modelstore.getModel("accounting/retrieveAccount");
  $scope.model=model;

  $scope.load = function() {
    model.startdateValue=tools.dateFromJava(model.startdate);
    model.enddateValue=tools.dateFromJava(model.enddate);
    model.mthValue=model.mth;
    modelstore.cleanModel(["accounts","balances","movements","visits","activities","participants","items"],model);
    webservice.exclusiveCall("load",{'startdate':tools.dateFromJava(model.startdate),'enddate':tools.dateFromJava(model.enddate),'mth':model.mth},script,model).then(function(response) {
      model.account=model.accounts[response];
      model.balance=tools.max(tools.lessEqual(
        tools.join(model.account,'balances',model),
        'created',
        model.startdateValue+' 23:59:59'
      ),'created');
    });
  };

  tools.initAttributes(model,{
    'loading':false,
    'retrieveAccountFormIsLoaded':$q.defer()
  });
  $q.all([webservice.afterLogin(),model.retrieveAccountFormIsLoaded.promise]).then(function() {
    $scope.load();
  });
  
}]);
angular.module("app").controller("AccountingAchievementsController",["$scope","$sce","tools","modelstore","user","parameters","webservice","config",
                                            function($scope,$sce,tools,modelstore,user,parameters,webservice,config) {

  var script="accounting/achievements";
  var model=modelstore.getModel(script);
  $scope.model=model;
  $scope.groupDateModes=[
    {'id':'day','labelen':'Day','labelnl':'Dag','labelfr':'Jour'},
    {'id':'month','labelen':'Month','labelnl':'Maand','labelfr':'Mois'},
    {'id':'year','labelen':'Year','labelnl':'Jaar','labelfr':'Ann\u00E9e'}
  ];
  $scope.dateParams={
    'startdate':{'cleanDate':'cleanStartdate','date':'startdate','defaultDay':'first','defaultMonth':'-01'},
    'enddate':{'cleanDate':'cleanEnddate','date':'enddate','defaultDay':'last','defaultMonth':'-12'}
  };

  $scope.setDateOptions = function() {
    model.dateOptions.minMode=model.groupDateMode;
    model.dateOptions.datepickerMode=model.groupDateMode;
    for(var i in $scope.dateParams) {
      $scope.cleanDate($scope.dateParams[i]);
    }
  };

  $scope.cleanDateToDate = function(dateParam) {
    var sDate=false;
    var cleanDate=model[dateParam.cleanDate];
    switch (model.groupDateMode) {
      case 'day':
        if(cleanDate.length=='10' && /[0-9]{4}-[0-9]{2}-[0-9]{2}/.test(cleanDate)) {
          sDate=tools.dateToJava(cleanDate);
        }
        break;
      case 'month':
        if(cleanDate.length=='7' && /[0-9]{4}-[0-9]{2}/.test(cleanDate)) {
          if(dateParam.defaultDay=='first') {
            cleanDate=cleanDate+'-01';            
          } else {
            cleanDate=cleanDate.substr(0,5)+tools.expandDigits(tools.numberIn(cleanDate.substr(5,2))+1)+'-00'
          }
          sDate=tools.dateToJava(cleanDate);
        }
        break;
      case 'year':
        if(cleanDate.length=='4' && /[0-9]{4}/.test(cleanDate)) {
          if(dateParam.defaultDay=='first') {
            cleanDate=cleanDate+dateParam.defaultMonth+'-01';            
          } else {
            cleanDate=cleanDate+'-'+tools.expandDigits(tools.numberIn(dateParam.defaultMonth.substr(1,2))+1)+'-00'
          }
          sDate=tools.dateToJava(cleanDate);
        }
        break;
    }
    if(sDate>=model.dateOptions.minDate && sDate<=model.dateOptions.maxDate) {
      model[dateParam.date]=sDate;
    } else if(sDate) {
      $scope.cleanDate(dateParam);
      errorlog.error(tools.lang({'en':'Please use the datepicker to select a valid date','nl':'Gebruik de datepicker om een geldige datum te kiezen','fr':"Veuillez utiliser le sélecteur de date pour sélectionner une date valide."}));
    }
  };

  $scope.cleanDate = function(dateParam) {
    var dateISO=tools.dateFromJava(model[dateParam.date]);
    var cleanDate;
    switch (model.groupDateMode) {
      case 'day':
        model[dateParam.cleanDate]=dateISO.substr(0,10);
        return;
      case 'month':
        cleanDate=model[dateParam.cleanDate]=dateISO.substr(0,7);
        if(dateParam.defaultDay=='first') {
          cleanDate=cleanDate+'-01';            
        } else {
          cleanDate=cleanDate.substr(0,5)+tools.expandDigits(tools.numberIn(cleanDate.substr(5,2))+1)+'-00'
        }
        model[dateParam.date]=tools.dateToJava(cleanDate);
        return;
      case 'year':
        cleanDate=model[dateParam.cleanDate]=dateISO.substr(0,4);
        if(dateParam.defaultDay=='first') {
          cleanDate=cleanDate+dateParam.defaultMonth+'-01';            
        } else {
          cleanDate=cleanDate+'-'+tools.expandDigits(tools.numberIn(dateParam.defaultMonth.substr(1,2))+1)+'-00'
        }
        model[dateParam.date]=tools.dateToJava(cleanDate);
        return;
    }
  };

  $scope.processData = function(data,threshold) {
    var result=[];
    var beforeMax=true;
    var rest=0.0;
    var i;
    data=data.map(function(a){return {'x':a.x,'y':parseFloat(a.y)};});
    var max=data.map(function(a){return a.y;}).reduce(function(acc,cur){return Math.max(acc,cur);});
    for(i in data) {
      if((beforeMax||data[i].y>max/threshold) && rest==0.0) {
        beforeMax=beforeMax && data[i].y!=max;
        result.push(data[i]);
      } else {
        rest+=data[i].y;
      }
    }
    result.push({'x':'meer','y':rest});
    return result;
  };
  
  $scope.load = function() {
    var graphStartdate,graphEnddate;
    if(model.showGraphDates) {
      graphStartdate=tools.dateFromJava(model.graphStartdate);
      graphEnddate=tools.dateFromJava(model.graphEnddate);
    } else {
      graphStartdate=tools.dateFromJava(model.startdate);
      graphEnddate=tools.dateFromJava(model.enddate);
    }
    model.calling=true;
    model.achievementsLoading=true;
    webservice.call("loadAchievements",{
      "start":tools.dateFromJava(model.startdate),
      "end":tools.dateFromJava(model.enddate),
      "createdBefore":model.createBefore!==''?tools.dateFromJava(model.createdBefore):'',
      "showOnlyB2B":model.showOnlyB2B,
      "showUnpaid":model.showUnpaid,
      "vatIncluded":model.vatIncluded,
      "groupDateMode":model.groupDateMode,
      "dvss":model.dvss
    },script,model).then(function() {
      var i,j,line,lineAchievements,lineParticipants,lineRooms;
      model.achievementsLinesTotal={'achievementTotal':0.0,'achievements':{},'participants':{},'rooms':{}};
      for(i in model.achievementsLines) {
        line=model.achievementsLines[i];
        model.achievementsLinesTotal.achievementTotal+=line.achievementTotal;
        lineAchievements=line.achievements;
        for(j in lineAchievements) {
          if(!(j in model.achievementsLinesTotal.achievements)) {
            model.achievementsLinesTotal.achievements[j]=0.0;
          }
          model.achievementsLinesTotal.achievements[j]+=lineAchievements[j];
        }
        lineParticipants=line.participants;
        for(j in lineParticipants) {
          if(!(j in model.achievementsLinesTotal.participants)) {
            model.achievementsLinesTotal.participants[j]=0;
          }
          model.achievementsLinesTotal.participants[j]+=lineParticipants[j];
        }
        lineRooms=line.rooms;
        for(j in lineRooms) {
          if(!(j in model.achievementsLinesTotal.rooms)) {
            model.achievementsLinesTotal.rooms[j]=0;
          }
          model.achievementsLinesTotal.rooms[j]+=lineRooms[j];
        }
      }
      model.achievementsLoading=false;
      if(!model.achievementsLoading && !model.incomeLoading && !model.graphsLoading) {
        model.calling=false;
      }
    }).catch(function() {
      model.achievementsLoading=false;
      if(!model.achievementsLoading && !model.incomeLoading && !model.graphsLoading) {
        model.calling=false;
      }
    });

    model.incomeLoading=true;
    webservice.call("loadIncome",{
      "start":tools.dateFromJava(model.startdate),
      "end":tools.dateFromJava(model.enddate),
      "createdBefore":model.createBefore!==''?tools.dateFromJava(model.createdBefore):'',
      "showOnlyB2B":model.showOnlyB2B,
      "showUnpaid":model.showUnpaid,
      "vatIncluded":model.vatIncluded,
      "groupDateMode":model.groupDateMode
    },script,model).then(function() {
      var i,j,line,lineIncomes;
      model.incomeLinesTotal={'incomeTotal':0.0,'incomes':{}};
      for(i in model.incomeLines) {
        line=model.incomeLines[i];
        model.incomeLinesTotal.incomeTotal+=line.incomeTotal;
        lineIncomes=line.incomes;
        for(j in lineIncomes) {
          if(!(j in model.incomeLinesTotal.incomes)) {
            model.incomeLinesTotal.incomes[j]=0.0;
          }
          model.incomeLinesTotal.incomes[j]+=lineIncomes[j];
        }
      }
      model.incomeLoading=false;
      if(!model.achievementsLoading && !model.incomeLoading && !model.graphsLoading) {
        model.calling=false;
      }
    }).catch(function() {
      model.incomeLoading=false;
      if(!model.achievementsLoading && !model.incomeLoading && !model.graphsLoading) {
        model.calling=false;
      }
    });

    model.graphsLoading=true;
    webservice.call("loadGraphs",{
      "start":tools.dateFromJava(model.startdate),
      "end":tools.dateFromJava(model.enddate),
      "createdBefore":model.createBefore!==''?tools.dateFromJava(model.createdBefore):'',
      "showOnlyB2B":model.showOnlyB2B,
      "graphStart":graphStartdate,
      "graphEnd":graphEnddate,
      "diff":((model.daysOrWeeks=='days')?(model.diff):(model.diff*7)),
      "showUnpaid":model.showUnpaid,
      "vatIncluded":model.vatIncluded,
      "groupDateMode":model.groupDateMode
    },script,model).then(function() {
      var i,j,point;
      model.achievementData={};
      model.achievementLabels={};
      for(i in model.achievementGraphA) {
        point=model.achievementGraphA[i];
        model.achievementData[point.itm]=["0",point.amount];
      }
      for(i in model.achievementGraphB) {
        point=model.achievementGraphB[i];
        if(!(point.itm in model.achievementData)) {
          model.achievementData[point.itm]=[point.amount,"0"];
        } else {
          model.achievementData[point.itm][0]=point.amount;
        }
      }
      model.achievementLabels=Object.keys(model.achievementData);
      model.achievementData=Object.values(model.achievementData);
      model.achievementData=[model.achievementData.map(function(duplet) {
        return duplet[0];
      }),model.achievementData.map(function(duplet) {
        return duplet[1];
      })]
      var processedData=$scope.processData(model.budgetBins,50.0);
      model.budgetLabels=processedData.map(function(a){
        //return a.x=='meer'?a.x:(a.x+'-'+(parseInt(a.x)+19).toString());
        var result=a.x;
        if(a.x!='meer') {
          var lowerBound=a.x=='0'?0.01:Math.pow(2,parseInt(a.x)-1)*20+0.01;
          var upperBound=(Math.pow(2,parseInt(a.x)))*20;
          if(lowerBound>=upperBound) {
            result=upperBound.toString();
          } else {
            result=tools.amountOut(lowerBound)+' tot '+upperBound.toString();
          }
        }
        return result;
      });
      model.budgetData=processedData.map(function(a){return a.y;});
      processedData=$scope.processData(model.turnoverPerMaxpeople,50.0);
      model.groupLabels=processedData.map(function(a){
        var result=a.x;
        if(a.x!='meer') {
          var lowerBound=Math.pow(2,parseInt(a.x)-1)+1;
          var upperBound=Math.pow(2,parseInt(a.x));
          if(lowerBound>=upperBound) {
            result=upperBound.toString();
          } else {
            result=lowerBound.toString()+'-'+upperBound.toString();
          }
        }
        return result;
      });
      model.groupData=processedData.map(function(a){return a.y;});
      var channelLabelMap={
        'COM':'Offerte',
        'DEF':'Kassa',
        'ONL':'Online',
        'KIO':'Kiosk',
        'PTN':'Partner',
        'TML':'Greenfields',
        'TAK':'Take Away'
      };

      var turnoverPerChannel=model.turnoverPerLanguageAndChannel.reduce(function(acc,line){
        if(!(line.channel in acc)) {
          acc[line.channel]=0.0;
        }
        acc[line.channel]+=parseFloat(line.turnover);
        return acc;
      },{});
      var channels=Object.keys(turnoverPerChannel);
      model.channelLabels=channels.map(function(a){return channelLabelMap[a];});
      model.channelData=Object.values(turnoverPerChannel);

      model.languageLabels=model.channelLabels;
      model.languageSeries=["English","Nederlands","Francais"];
      var emptyChannelArray=channels.reduce(function(acc,channel) {
        acc[channel]=0.0;
        return acc;
      },{});
      model.languageData=model.turnoverPerLanguageAndChannel.reduce(function(acc,line){
        if(!(line.lang in acc)) {
          acc[line.lang]=tools.clone(emptyChannelArray);
        }
        acc[line.lang][line.channel]+=parseFloat(line.turnover)*100.0/turnoverPerChannel[line.channel];
        return acc;
      },{});
      model.languageData=[Object.values(model.languageData.en),Object.values(model.languageData.nl),Object.values(model.languageData.fr)];
      model.languageOptions={
        scales: {
          xAxes: [{
            stacked: true,
          }],
          yAxes: [{
            stacked: true
          }]
        }
      };
      model.graphsLoading=false;
      if(!model.achievementsLoading && !model.incomeLoading && !model.graphsLoading) {
        model.calling=false;
      }
    }).catch(function() {
      model.graphsLoading=false;
      if(!model.achievementsLoading && !model.incomeLoading && !model.graphsLoading) {
        model.calling=false;
      }
    });
  };

  $scope.selectDays = function() {
    model.daysOrWeeks='days';
    model.diff=parseInt(model.diff)*7+'';
  };

  $scope.selectWeeks = function() {
    model.daysOrWeeks='weeks';
    model.diff=Math.round(parseInt(model.diff)/7)+'';
  };

  $scope.getAchievementsWsParams = function() {
    var result="{}";
    if("startdate" in model) {
      result=angular.toJson({
        "a":webservice.auth,
        "s":script,
        "t":"exportAchievements",
        "p":{"start":tools.dateFromJava(model.startdate),"end":tools.dateFromJava(model.enddate),"showUnpaid":model.showUnpaid,"vatIncluded":model.vatIncluded}
      });
    }
    return result;
  };

  $scope.selectDvs = function(dvs) {
    var index=model.dvss.indexOf(dvs);
    if(index<0) {
      model.dvss.push(dvs);
    } else {
      model.dvss.splice(index,1);
    }
  };

  if(!('startdate' in model)) {
    tools.initDates(-7,0,model);
    model.graphStartdate=new Date();
    model.graphStartdate.setMonth(model.graphStartdate.getMonth()-12);
    model.graphEnddate=new Date();
  }
  tools.initAttributes(model,{
    'loading':false,
    'cleanStartdate':tools.dateFromJava(model.startdate),
    'startdateOpened':false,
    'cleanEnddate':tools.dateFromJava(model.enddate),
    'enddateOpened':false,
    'createdBefore':'',
    'createdBeforeOpened':false,
    'showOnlyB2B':false,
    'dateOptions':{
      maxDate: new Date(2099,11,31),
      minDate: new Date(2000,0,1),
      startingDay: 1
    },
    'diff':'365',
    'daysOrWeeks':'days',
    'groupDateMode':'day',
    'graphStartdateOpened':false,
    'graphEnddateOpened':false,
    'showGraphDates':false,
    'showUnpaid':false,
    'vatIncluded':false,
    'action':$sce.trustAsResourceUrl(config.get('serviceUrl')),
    'budgetLabels':[],
    'budgetData':[],
    'achievementsLinesTotal':{},
    'incomeLinesTotal':{},
    'graphsLoading':false,
    'achievementsLoading':false,
    'incomeLoading':false,
    'calling':false,
    'dvss':[]
  });
  $scope.$watch("model.cleanStartdate.getTime()",function(newVal,oldVal) {
    if(newVal!==oldVal) {
      $scope.cleanDateToDate($scope.dateParams.startdate);
    }
  });
  $scope.$watch("model.cleanEnddate.getTime()",function(newVal,oldVal) {
    if(newVal!==oldVal) {
      $scope.cleanDateToDate($scope.dateParams.enddate);
    }
  });
  webservice.afterLogin().then(function() {
    if(user.dvs!=='' && tools.getLength(model.dvss)===0) {
      model.dvss.push(user.dvs);
    }
    $scope.load();
  });
  
}]);
var accountingService=function(tools,parameters) {
  this.tools=tools;
  this.parameters=parameters;
  this.GET_ITEM_PROPERTY_COMPARE_STRING=0;
  this.GET_ITEM_PROPERTY_DESCRIPTION_DATETIME=1;
  this.GET_ITEM_PROPERTY_DESCRIPTION_WORDING=2;
  this.ITEM_PRICECALC_DEFAULT="0";
  this.ITEM_PRICECALC_FORMBUTTONCOMPONENT="1";
  this.ITEM_PRICECALC_FORMBUTTONCOMPONENT_REDUCTION="2";
  this.ITEM_PRICECALC_REVERSE="3";
};

accountingService.prototype.getItemProperty = function(item,model,property) {
  var tools=this.tools;
  var parameters=this.parameters;
  var result;
  switch(item.itm.substr(0,2)) {
    case 'AC':
      var participant=tools.join(item,'participants',model)[0];
      if(participant) {
        var activity=model.activities[participant.activity];
        if(property===this.GET_ITEM_PROPERTY_COMPARE_STRING) {
          result=activity.dayISO+activity.hrs+'ACT'+tools.expandDigits(activity.id,10)+tools.expandDigits(participant.unt,10);
        } else if(property===this.GET_ITEM_PROPERTY_DESCRIPTION_DATETIME) {
          result=tools.dateOut(activity.day)+' '+parameters.label('HRS',activity.hrs);
        } else if(property===this.GET_ITEM_PROPERTY_DESCRIPTION_WORDING) {
          var act=parameters.ACT[activity.frm.substr(0,3)];
          if(act.field3==='1') {
            result=activity.quotationtitle;
          } else {
            result=tools.label(act);
            var frm=parameters.FRM[activity.frm];
            if(tools.amountIn(frm.field3)>0) {
              result+=" "+tools.label(frm);
            }
            var unt=parameters.UNT[participant.unt];
            if(tools.amountIn(unt.field3)>0) {
              result+=" "+tools.label(unt);
            }
          }
        }
      }
      break;
    case 'ME':
      var dish=tools.join(item,'dishes',model)[0];
      if(dish) {
        var meal=model.meals[dish.meal];
        if(property===this.GET_ITEM_PROPERTY_COMPARE_STRING) {
          result=meal.dayISO+meal.hrs+'MEA'+tools.expandDigits(meal.id,10)+tools.expandDigits(dish.id,10);
        } else if(property===this.GET_ITEM_PROPERTY_DESCRIPTION_DATETIME) {
          result=tools.dateOut(meal.day)+' '+parameters.label('HRS',meal.hrs);
        } else if(property===this.GET_ITEM_PROPERTY_DESCRIPTION_WORDING) {
          result=parameters.label('RES',meal.res)+' ';
          var dsh=parameters.DSH[dish.dsh];
          if(dsh.field1==='1') {
            result+=dish.quotationtitle;
          } else {
            result+=tools.label(dsh);
          }
        }
      }
      break;
    case 'HS':
      var hotelreservationcategory=tools.join(item,'hotelreservationcategories',model)[0];
      if(hotelreservationcategory) {
        if(property===this.GET_ITEM_PROPERTY_COMPARE_STRING) {
          result=hotelreservationcategory.startdateISO+hotelreservationcategory.starthrs+'HOT'+tools.expandDigits(hotelreservationcategory.id,10)+tools.expandDigits("0",10);
        } else if(property===this.GET_ITEM_PROPERTY_DESCRIPTION_DATETIME) {
          result=tools.dateOut(hotelreservationcategory.startdate)+' - '+tools.dateOut(hotelreservationcategory.enddate);
        } else if(property===this.GET_ITEM_PROPERTY_DESCRIPTION_WORDING) {
          result=parameters.label('HTL',hotelreservationcategory.htl)+' '+parameters.label('HSC',hotelreservationcategory.requestedhsc);
          var hotelspaceassignments=tools.join(hotelreservationcategory,'hotelspaceassignments',model);
          angular.forEach(hotelspaceassignments,function(hotelspaceassignment) {
            result+=" "+model.hotelspaces[hotelspaceassignment.assignedspace].spacenumber;
          });
        }
      }
      break;
    case 'HP':
      var hotelreservationproduct=tools.join(item,'hotelreservationproducts',model)[0];
      if(hotelreservationproduct) {
        var hotelreservationcategory=model.hotelreservationcategories[hotelreservationproduct.reservationcategory];
        if(property===this.GET_ITEM_PROPERTY_COMPARE_STRING) {
          result=hotelreservationcategory.startdateISO+hotelreservationcategory.starthrs+'HOT'+tools.expandDigits(hotelreservationproduct.id,10)+tools.expandDigits("0",10);
        } else if(property===this.GET_ITEM_PROPERTY_DESCRIPTION_DATETIME) {
          result='';
        } else if(property===this.GET_ITEM_PROPERTY_DESCRIPTION_WORDING) {
          result=parameters.label('HPD',hotelreservationproduct.hpd);
        }
      }
      break;
    case 'PR':
      var product=tools.join(item,'products',model)[0];
      if(product) {
        if(property===this.GET_ITEM_PROPERTY_COMPARE_STRING) {
          result="9999-12-31"+"23:59:59"+"PRD"+tools.expandDigits(product.id,10)+tools.expandDigits("0",10);
        } else if(property===this.GET_ITEM_PROPERTY_DESCRIPTION_DATETIME) {
          result="";
        } else if(property===this.GET_ITEM_PROPERTY_DESCRIPTION_WORDING) {
          result=parameters.label('PRD',product.prd);
        }
      }
      break;
  }
  return result;
};

accountingService.prototype.getItemCompareString = function(item,model) {
  return this.getItemProperty(item,model,this.GET_ITEM_PROPERTY_COMPARE_STRING);
};

accountingService.prototype.getItemDescriptionDatetime = function(item,model) {
  return this.getItemProperty(item,model,this.GET_ITEM_PROPERTY_DESCRIPTION_DATETIME);
};

accountingService.prototype.getItemDescriptionWording = function(item,model) {
  return this.getItemProperty(item,model,this.GET_ITEM_PROPERTY_DESCRIPTION_WORDING);
};

angular.module("app").service("accountingService",["tools","parameters",accountingService]);

var visionlineOutdoor = function($q,tools,visionline) {
  this.$q=$q;
  this.tools=tools;
  this.visionline=visionline;
};
visionlineOutdoor.prototype.createCard = function(encoder,hotelreservationcategory,hotelspace,existingRfidcarriers) {
  var visionlineOutdoor=this;
  var url='cards?action=encode&encoder='+encoder;
  if(existingRfidcarriers.length===0) {
    url+='&override=true';
  } else {
    url+='&fields=joiners';
  }
  var visionlineParams={
    "cancelled":false,
    "expireTime": visionlineOutdoor.tools.dateFromJava(hotelreservationcategory.enddate).replace(/\D/g,'')+"T"+hotelreservationcategory.defaultCheckoutHour.replace(/\D/g,'').substr(0,4),
    "format": "rfid48",
    "doorOperations":[{"operation":"guest","doors":[hotelspace.spacenumber]}]
  };
  if(existingRfidcarriers.length>0) {
    visionlineParams.joiners=existingRfidcarriers.map(function(rfidcarrier) {
      return rfidcarrier.visionid;
    });
  }
  return visionlineOutdoor.visionline.post(url,visionlineParams);
};
visionlineOutdoor.prototype.cancelCard = function(htlId,visionid) {
  var visionlineOutdoor=this;
  return visionlineOutdoor.visionline.post(htlId,'cards/'+visionid,{
    "cancelled":true
  });
};
angular.module('app').service('visionlineOutdoor',['$q','tools','visionline',visionlineOutdoor]);
var visionline = function($q,$log,config,errorlog,lobbyProxy) {
  this.$q=$q;
  this.$log=$log;
  this.config=config;
  this.errorlog=errorlog;
  this.lobbyProxy=lobbyProxy;
  this.hotelConfigs=null;
  this.urlPrefix='/api/v1/';
  this.sessionHtl='';
  this.sessionId=null; //13d60667e64e43b087984d2164d64837
  this.accessKey=null; //8e127e05a225415a956a33c73683f644
};
visionline.prototype.rawCall = function(resource,method,params) {
  var visionline=this;
  params={
    'host':visionline.hotelConfigs[visionline.sessionHtl].visionlineHost,
    'path':visionline.urlPrefix+resource,
    'method':method,
    'data':params
  };
  if(resource!=='sessions') {
    params.sessionId=visionline.sessionId;
    params.accessKey=visionline.accessKey;
    params.resource=visionline.urlPrefix+resource;
  }
  return this.lobbyProxy.http(params);
};
visionline.prototype.startSession = function(htlId) {
  var visionline=this;
  visionline.sessionHtl=htlId;
  visionline.sessionId=null;
  visionline.accessKey=null;
  return visionline.rawCall('sessions','POST',{
    'username':visionline.hotelConfigs[htlId].username,
    'password':visionline.hotelConfigs[htlId].password
  }).then(function(response){
    var result;
    if(angular.isObject(response) && ('id' in response) && ('accessKey' in response)) {
      visionline.sessionId=response.id;
      visionline.accessKey=response.accessKey;
      result=visionline.$q.resolve();
    } else {
      result=visionline.$q.reject('visionline login failed');
    }
    return result;
  });
};
visionline.prototype.call = function(htlId,resource,method,params) {
  var visionline=this;
  var haveSession;
  if(visionline.sessionHtl!==htlId) {
    haveSession=visionline.startSession(htlId);
  } else {
    haveSession=visionline.$q.resolve();
  }
  return haveSession.then(function() {
    visionline.$log.log('visionline '+method+' '+resource+' '+angular.toJson(params));
    return visionline.rawCall(resource,method,params).then(function(response) {
      var result;
      if(response.code===40103) {
        result=visionline.startSession(htlId).then(function() {
          return visionline.rawCall(resource,method,params);
        });
      } else {
        result=visionline.$q.resolve(response);
      }
      return result.then(function(response2) {
        visionline.$log.log('visionline received '+angular.toJson(response2));
        return response2;
      });
    });
  });
};
visionline.prototype.post = function(htlId,resource,params) {
  var visionline=this;
  // if(visionline.config.getHostname()==='localhost' && resource.substr(0,5)==='cards') {
  //   var uid='f'+(Math.floor(Math.random()*999999999999999).toString().padStart(15,'0'));
  //   return visionline.$q.resolve({"cancelled":false,"cardHolder":"Guest","created":"20200813T122814","discarded":false,"doorOperations":[{"doorGroups":[],"doors":["101"],"operation":"guest"}],"expireTime":"20200814T1000","expired":false,"format":"TLCode","id":"100037","notIssued":false,"numberOfIssuedCards":1,"overridden":false,"overwritten":false,"pendingAutoUpdate":false,"serialNumbers":[uid],"startTime":"20200813T122814"});
  // } else {
    return visionline.call(htlId,resource,'POST',params);
  // }
};
visionline.prototype.get = function(resource,params) {
  return this.call(resource,'GET',params);
};
angular.module('app').service('visionline',['$q','$log','config','errorlog','lobbyProxy',visionline]);
'use strict';

var services={};

/*
 * formatting
 */
services.formatting = function() {};
services.formatting.prototype.numberIn = function(number) {
  if(!angular.isString(number)) {
    return number;
  }
  number=number.replace(/^0+/g,'');
  if(number.length===0) {
    return 0;
  }
  return parseInt(number,10);
};
services.formatting.prototype.amountIn=function(amount) {
  var result=0.0;
  if(amount) {
    result=parseFloat(amount.toString().replace(',','.'));
  }
  return result;
};
services.formatting.prototype.dateIn=function(input) {
  if(input) {
    if(angular.isDate(input)) {
      return input;
    } else if(angular.isString(input)) {
      return new Date(
        parseInt(input.substr(0,4),10),
        parseInt(input.substr(5,2),10)-1,
        parseInt(input.substr(8,2),10)
      );
    }
  }
};
angular.module('app').service('formatting',[services.formatting]);

/*
 * modelstore
 */
services.modelstore = function($log,dictionary,formatting) {
  this.$log=$log;
  this.dictionary=dictionary;
  this.formatting=formatting;
  this.models={};
  this.missingRecords={};
};
services.modelstore.prototype.getModel = function(name) {
  if(!(name in this.models)) {
    this.models[name]={'modelName':name};
  }
  return this.models[name];
};
services.modelstore.prototype.removeRecord = function(collection,id,model) {
  if((collection in model) && (id in model[collection])) {
    var foreignkeys=this.dictionary.foreignkeys;
    if(collection in foreignkeys && 'out' in foreignkeys[collection]) {
      var record=model[collection][id];
      var outkeys=foreignkeys[collection].out;
      var field,val,index;
      for(var refCol in outkeys) {
        field=outkeys[refCol];
        if(field in record) {
          val=record[field];
          if(refCol in model && val in model[refCol] && collection in model[refCol][val]) {
            index=model[refCol][val][collection].indexOf(id);
            if(index>-1) {
              model[refCol][val][collection].splice(index,1);
            }
          }
        }
      }
    }
    delete model[collection][id];
  }
};
services.modelstore.prototype.addRecord = function(collection,record,model) {
  if(record && 'id' in record) {
    record.selected=false;
    if(!(collection in model)) {
      model[collection]={};
    }
    var foreignkeys=this.dictionary.foreignkeys;
    if(record.id in model[collection]) {
      var existingRecord=model[collection][record.id];
      if(collection in foreignkeys && 'in' in foreignkeys[collection]) {
        var inkeys=foreignkeys[collection].in;
        for(var inkeyCollection in inkeys) {
          if(inkeyCollection in existingRecord) {
            record[inkeyCollection]=existingRecord[inkeyCollection];
          }
        }
      }
      this.removeRecord(collection,record.id,model);
    } else if((collection in this.missingRecords) && (record.id in this.missingRecords[collection])) {
      var missingRecord=this.missingRecords[collection][record.id];
      for(var missingRecordAttr in missingRecord) {
        record[missingRecordAttr]=missingRecord[missingRecordAttr];
      }
    }
    var formatFields=this.dictionary.formatFields;
    if(collection in formatFields) {
      var fields=formatFields[collection];
      var formatter;
      for(var field in fields) {
        formatter=fields[field];
        if(field in record) {
          if(formatter===this.formatting.dateIn) {
            record[field+'ISO']=record[field];
          }
          record[field]=formatter(record[field]);
        } else {
          this.$log.log('WARNING: formatting on '+collection+'.'+field+' failed '+angular.toJson(record));
        }
      }
    }
    model[collection][record.id]=record;
    if(collection in foreignkeys && 'out' in foreignkeys[collection]) {
      var outkeys=foreignkeys[collection].out;
      var foreignField,foreignId,foreignRecord;
      for(var outkeyCollection in outkeys) {
        foreignField=outkeys[outkeyCollection];
        if(foreignField in record) {
          foreignId=record[foreignField];
          if(!(outkeyCollection in model)) {
            model[outkeyCollection]={};
          }
          if(foreignId in model[outkeyCollection]) {
            foreignRecord=model[outkeyCollection][foreignId];
          } else {
            if(!(outkeyCollection in this.missingRecords)) {
              this.missingRecords[outkeyCollection]=[];
            }
            if(!(foreignId in this.missingRecords[outkeyCollection])) {
              this.missingRecords[outkeyCollection][foreignId]={};
            }
            foreignRecord=this.missingRecords[outkeyCollection][foreignId];
          }
          if(!(collection in foreignRecord)) {
            foreignRecord[collection]=[];
          }
          if(foreignRecord[collection].indexOf(record.id)<=-1) {
            foreignRecord[collection].push(record.id);
          }
        }
      }
    }
  }
};
services.modelstore.prototype.addRecords = function(collection,records,model) {
  for(var i in records) {
    this.addRecord(collection,records[i],model);
  }
};
services.modelstore.prototype.cleanModel = function(collections,model) {
  var i,j,collectionName,collection;
  for(i in collections) {
    collectionName=collections[i];
    collection=model[collectionName];
    for(j in collection) {
      this.removeRecord(collectionName,j,model);
    }
  }
};
angular.module('app').service('modelstore',['$log','dictionary','formatting',services.modelstore]);

/*
 * user
 */
services.user = function() {
  this.lang='en';
  this.rights=[];
};
services.user.prototype.hasRight = function(rgh) {
  return this.rights.indexOf(rgh)>-1;
};
angular.module('app').service('user',[services.user]);

/*
 * errorlog
 */
services.errorlog = function(toastr) {
  this.toastr=toastr;
};
services.errorlog.prototype.receive = function(type,message) {
  this.toastr[type](message);
};
services.errorlog.prototype.receiveError = function(error) {
  this.error(error);
};
services.errorlog.prototype.error = function(error) {
  this.receive('error',error);
};
services.errorlog.prototype.warning = function(warning) {
  this.receive('warning',warning);
};
services.errorlog.prototype.success = function(success) {
  this.receive('success',success);
};
services.errorlog.prototype.info = function(info) {
  this.receive('info',info);
};
angular.module('app').service('errorlog',['toastr',services.errorlog]);

/*
 * tools
 */
services.tools = function($window,$location,$timeout,$filter,formatting,user,modelstore,errorlog) {
  this.$window=$window;
  this.$location=$location;
  this.$timeout=$timeout;
  this.$filter=$filter;
  this.formatting=formatting;
  this.user=user;
  this.modelstore=modelstore;
  this.errorlog=errorlog;
  this.numberIn=formatting.numberIn;
  this.amountIn=formatting.amountIn;
};
services.tools.prototype.isArray=function(obj) {
  return angular.isArray(obj);
};
services.tools.prototype.capitalize=function(string) {
   return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};
services.tools.prototype.makeArray=function(obj) {
  var result=obj;
  if(!this.isArray(obj)) {
    result=[obj];
  }
  return result;
};
services.tools.prototype.toString=function(obj) {
  return obj.toString();
};

services.tools.prototype.amountOut=function(amount) {
  var result='0';
  if(amount) {
    result=(Math.floor(100*parseFloat(amount)+0.5)/100.0).toString().replace('.',',');
  }
  return result;
};

services.tools.prototype.financialAmountOut=function(amount) {
  var result=this.amountOut(amount);
  var splittedAmount=result.split(',');
  if(splittedAmount.length>0) {
    var numbers=splittedAmount[0];
    numbers=numbers.replace(/\B(?=(\d{3})+(?!\d))/g,' ');
    result=numbers+',00';
    if(splittedAmount.length==2) {
      var decimals=splittedAmount[1];
      while(decimals.length<2) {
        decimals=decimals+'0';
      }
      result=numbers+','+decimals;
    }
  }
  return result;
}

var latiniseMap={
  '\u00E0':'a',
  '\u00E1':'a',
  '\u00E2':'a',
  '\u00E4':'a',
  '\u00E8':'e',
  '\u00E9':'e',
  '\u00EA':'e',
  '\u00EB':'e',
  '\u00EC':'i',
  '\u00ED':'i',
  '\u00EE':'i',
  '\u00EF':'i',
  '\u00F2':'o',
  '\u00F3':'o',
  '\u00F4':'o',
  '\u00F6':'o',
  '\u00F9':'u',
  '\u00FA':'u',
  '\u00FB':'u',
  '\u00FC':'u'
};
services.tools.prototype.latinise = function(string) {
  return string.toLowerCase().replace(/[\u00E0-\u00E2\u00E4\u00E8-\u00EF\u00F2-\u00F4\u00F6\u00F9-\u00FC]/g, function(match) {
    return latiniseMap[match];
  });
};

services.tools.prototype.dateToWeekdayCode=function(input) {
  if(input && input!=='0000-00-00') {
    input=input.substr(0,10);
    var dateJava=this.dateToJava(input);
    return (dateJava.getDay()+6)%7+1;
  }
  return '';
};

services.tools.prototype.days={
  '1':{'en':'Monday','nl':'Maandag','fr':'Lundi'},
  '2':{'en':'Tuesday','nl':'Dinsdag','fr':'Mardi'},
  '3':{'en':'Wednesday','nl':'Woensdag','fr':'Mercredi'},
  '4':{'en':'Thursday','nl':'Donderdag','fr':'Jeudi'},
  '5':{'en':'Friday','nl':'Vrijdag','fr':'Vendredi'},
  '6':{'en':'Saturday','nl':'Zaterdag','fr':'Samedi'},
  '7':{'en':'Sunday','nl':'Zondag','fr':'Dimanche'}
};

services.tools.prototype.dateToWeekdayLang=function(input,lang) {
  if(input && input!=='0000-00-00') {
    return this.days[this.dateToWeekdayCode(input)][lang];
  }
  return '';
};

services.tools.prototype.dateToWeekday=function(input) {
  return this.dateToWeekdayLang(input,this.user.lang);
};

services.tools.prototype.dateToWeekdayShortLang=function(input,lang) {
  var long=this.dateToWeekdayLang(input,lang);
  if(long) {
    return long.substr(0,2);
  }
  return '';
};

services.tools.prototype.dateToWeekdayShort=function(input) {
  return this.dateToWeekdayShortLang(input,this.user.lang);
};

services.tools.prototype.months={
  '0': {'en':'January','nl':'Januari','fr':'Janvier'},
  '1': {'en':'February','nl':'Februari','fr':'Fevrier'},
  '2': {'en':'March','nl':'Maart','fr':'Mars'},
  '3': {'en':'April','nl':'April','fr':'Avril'},
  '4': {'en':'May','nl':'Mei','fr':'Mai'},
  '5': {'en':'June','nl':'Juni','fr':'Jun'},
  '6': {'en':'July','nl':'Juli','fr':'Jul'},
  '7': {'en':'August','nl':'Augustus','fr':'Aout'},
  '8': {'en':'September','nl':'September','fr':'Septembre'},
  '9': {'en':'October','nl':'Oktober','fr':'Octobre'},
  '10':{'en':'November','nl':'November','fr':'Novembre'},
  '11':{'en':'December','nl':'December','fr':'Decembre'}
};

services.tools.prototype.dateToMonthLongLang=function(input,lang) {
  if(input) {
    input=input.substr(0,10);
    if(input!=='0000-00-00') {
      var dateJava=this.dateToJava(input);
      return this.months[dateJava.getMonth()][lang];
    }
  }
  return '';
};

services.tools.prototype.dateToMonthLong=function(input) {
  return this.dateToMonthLongLang(input,this.user.lang);
};

services.tools.prototype.dateToMonthLang=function(input,lang) {
  if(input) {
    input=input.substr(0,10);
    if(input!=='0000-00-00') {
      return this.dateToMonthLongLang(input,lang).substr(0,3);
    }
  }
  return '';
};

services.tools.prototype.dateToMonth=function(input) {
  return this.dateToMonthLang(input,this.user.lang);
};

services.tools.prototype.hourOut=function(input) {
  if(input) {
    if(input.length>8) {
      input=input.substr(11);
    }
    if(input!=='00:00:00') {
      var result=input.substr(0,2)+'h';
      var minutes=input.substr(3,2);
      if(minutes!=='00') {
        result+=minutes;
      }
      return result;
    }
  }
  return '';
};

services.tools.prototype.dateOutLongLang=function(date,lang) {
  if(date) {
    date=date.substr(0,10);
    if(date!=='0000-00-00') {
      var day=date.substr(8,2);
      if(day.substr(0,1)==='0') {
        day=day.substr(1,1);
      }
      return this.dateToWeekdayLang(date,lang)+
        ' '+day+
        ' '+this.dateToMonthLongLang(date,lang);
    }
  }
  return '';
};

services.tools.prototype.dateOutLong=function(date) {
  return this.dateOutLongLang(date,this.user.lang);
};

services.tools.prototype.dateOutLang=function(date,lang) {
  if(date) {
    if(angular.isDate(date)) {
      date=this.dateFromJava(date);
    }
    date=date.substr(0,10);
    if(date!=='0000-00-00') {
      var day=date.substr(8,2);
      if(day.substr(0,1)==='0') {
        day=day.substr(1,1);
      }
      var today=this.today();
      var year='';
      if(today.substr(0,4)>date.substr(0,4)) {
        year='\u0027'+date.substr(2,2)
      }
      return this.dateToWeekdayShortLang(date,lang)+
        ' '+day+
        ' '+this.dateToMonthLang(date,lang)+
        ' '+year;
    }
  }
  return '';
};

services.tools.prototype.dateOut=function(date) {
  return this.dateOutLang(date,this.user.lang);
};

services.tools.prototype.birthDateOutLang=function(date,lang) {
  if(date) {
    date=date.substr(0,10);
    if(date!=='0000-00-00') {
      return this.dateOutLang(date, lang)+' '+date.substr(0,4);
    }
  }
  return '';
};

services.tools.prototype.birthDateOut=function(date) {
  return this.birthDateOutLang(date,this.user.lang);
};

services.tools.prototype.expandDigits=function(nnum,to) {
  nnum=nnum||0;
  var num=nnum.toString();
  while(num.length<to) {
    num='0'+num;
  }
  return num;
};

services.tools.prototype.dateToJava=function(input) {
  if(input) {
    var numberIn=this.numberIn;
    return new Date(
      numberIn(input.substr(0,4)),
      numberIn(input.substr(5,2))-1,
      numberIn(input.substr(8,2))
    );
  }
};

services.tools.prototype.dateWithHoursToJava=function(input) {
  if(input) {
    var date = this.dateToJava(input);
    date.setHours(input.substr(11,2), input.substr(14,2), input.substr(17,2))
    return date;
  }
};

services.tools.prototype.padTwoDigits=function(n) {
  var result=n;
  if(n<10) {
    result='0'+n;
  }
  return result;
};

services.tools.prototype.dateFromJava=function(input) {
  var result='';
  if(input) {
    result=input.getFullYear()+'-'+
      this.padTwoDigits(input.getMonth()+1)+'-'+
      this.padTwoDigits(input.getDate());
  }
  return result;
};

services.tools.prototype.dotFormattedDateFromJava = function(input) {
  var result = '';
  if(input) {
    result = this.padTwoDigits(input.getDate()) + '.' + 
      this.padTwoDigits(input.getMonth()+1) + '.' +
      input.getFullYear().toString().substr(-2);
  }
  return result;
}

services.tools.prototype.timestampToJava=function(input) {
  if(input) {
    var numberIn=this.numberIn;
    return new Date(
      numberIn(input.substr(0,4)),
      numberIn(input.substr(5,2))-1,
      numberIn(input.substr(8,2)),
      numberIn(input.substr(11,2)),
      numberIn(input.substr(14,2)),
      numberIn(input.substr(17,2)),
      0
    );
  }
};

services.tools.prototype.timestampFromJava=function(input) {
  if(input) {
    var pad=this.padTwoDigits;
    return input.getFullYear()+
      '-'+pad(input.getMonth()+1)+
      '-'+pad(input.getDate())+
      ' '+pad(input.getHours())+
      ':'+pad(input.getMinutes())+
      ':'+pad(input.getSeconds());
  }
};

services.tools.prototype.dayDiff=function(startdate,enddate) {
  var result;
  if(startdate && enddate) {
    result=Math.round((enddate.getTime()-startdate.getTime())/(24*60*60*1000));
  }
  return result;
};

services.tools.prototype.addDays=function(date,days) {
  var result=new Date(date);
  result.setDate(result.getDate()+days);
  return result;
};

services.tools.prototype.today=function() {
  return this.dateFromJava(new Date());
};

services.tools.prototype.hourFromJava=function(input) {
  if(input) {
    var pad=this.padTwoDigits;
    return pad(input.getHours())+':'+
      pad(input.getMinutes())+':'+
      pad(input.getSeconds());
  }
};

services.tools.prototype.now=function() {
  return this.hourFromJava(new Date());
};

services.tools.prototype.hoursAdd=function(a,b) {
  if(a && b) {
    var numberIn=this.numberIn;
    return this.hourFromJava(new Date(1970,0,1,
      numberIn(a.substr(0,2))+numberIn(b.substr(0,2)),
      numberIn(a.substr(3,2))+numberIn(b.substr(3,2)),
      numberIn(a.substr(6,2))+numberIn(b.substr(6,2)),0));
  }
};

services.tools.prototype.notZero=function(input) {
  var result='';
  if(parseFloat(input)!==0.0) {
    result=input;
  }
  return result;
};

services.tools.prototype.shortSplit=function(short,index) {
  if(short) {
    var split=short.split(' ');
    if(index<split.length) {
      return split[index].substr(0,3);
    }
  }
};

services.tools.prototype.sepaOgmOut=function(ogm) {
  if(ogm) {
    return ogm.substr(0,4)+' '+ogm.substr(4,4)+' '+ogm.substr(8);
  }
};

services.tools.prototype.ogmOut=function(ogm) {
  if(ogm) {
    return '+++'+ogm.substr(0,3)+'/'+ogm.substr(3,4)+'/'+ogm.substr(7)+'+++';
  }
};

services.tools.prototype.substr = function(str,start,length) {
  var result='';
  if(str) {
    result=str.substr(start,length);
  }
  return result;
};

services.tools.prototype.previous = function() {
  history.go(-1);
};

services.tools.prototype.redirect = function(path) {
  this.$location.path(path);
};

services.tools.prototype._whitelist=function(input,list) {
  var output={};
  var len=list.length;
  for(var i=0;i<len;i++) {
    if(list[i] in input) {
      output[list[i]]=input[list[i]];
    }
  }
  return output;
};

services.tools.prototype.whitelistNoId = function(input,list) {
  var result=null;
  if(this.isArray(input)) {
    result=[];
    for(var i in input) {
      result.push(this._whitelist(input[i],list));
    }
  } else {
    result=this._whitelist(input,list);
  }
  return result;
};

services.tools.prototype.whitelist = function(input,list) {
  list=this.clone(list);
  list.push('id');
  return this.whitelistNoId(input,list);
};

services.tools.prototype.getLength = function(input) {
  var result=0;
  if(this.isArray(input)) {
    result=input.length;
  } else if(input) {
    result=Object.keys(input).length;
  }
  return result;
};

services.tools.prototype.voucheridOut=function(voucherid) {
  if(angular.isDefined(voucherid)) {
    var shortVoucherid=voucherid.replace(/[^0-9]/g,''); 
    var gapPossitions=[4,8].filter(function(gap) {
      return gap<shortVoucherid.length;
    },[]);
    var i,regex;
    for(i=0;i<gapPossitions.length;i++) {
      regex=new RegExp('(.{'+(gapPossitions[i]+i)+'})');
      shortVoucherid=shortVoucherid.replace(regex,'$1 ');
    }
    voucherid=shortVoucherid;
  }
  return voucherid;
};

services.tools.prototype.match = function(input,template) {
  var output=[];
  if(input && template) {
    var match;
    for(var id in input) {
      match=true;
      for(var key in template) {
        if(!(key in input[id]) || !(input[id][key]===template[key] || (angular.isFunction(template[key]) && template[key](input[id][key])))) {
          match=false;
          break;
        }
      }
      if(match) {
        output.push(input[id]);
      }
    }
  }
  return output;
};

services.tools.prototype.matchForObject = function(input,template) {
  var output={};
  if(input && template) {
    var match;
    for(var id in input) {
      match=true;
      for(var key in template) {
        if(!(key in input[id]) || !(input[id][key]===template[key] || (angular.isFunction(template[key]) && template[key](input[id][key])))) {
          match=false;
          break;
        }
      }
      if(match) {
        output[id]=input[id];
      }
    }
  }
  return output;
};

services.tools.prototype.exclude = function(input,template) {
  var output=[];
  if(template) {
    var match;
    for(var id in input) {
      match=true;
      for(var key in template) {
        if(!(key in input[id]) || !(input[id][key]===template[key] || (angular.isFunction(template[key]) && template[key](input[id][key])))) {
          match=false;
          break;
        }
      }
      if(!match && input[id]) {
        output.push(input[id]);
      }
    }
  }
  return output;
};

services.tools.prototype.toArray = function(obj) {
  return angular.isArray(obj)?obj:(angular.isObject(obj)?Object.values(obj):[]);
};

services.tools.prototype.copyArray = function(input) {
  if(!this.isArray(input)) {
    return this.toArray(input);
  }
  var output=[];
  for(var i=0,len=input.length;i<len;i++) {
    output.push(input[i]);
  }
  return output;
};

services.tools.prototype.getField = function(array,field) {
  var result=[];
  if(this.isArray(array) && field) {
    result=array.map(function(arr) {return arr[field];});
  }
  return result;
};

services.tools.prototype.clone = function(obj) {
  if (obj===null || !angular.isObject(obj)) {
    return obj;
  }
  var copy=null;
  if (obj instanceof Date) {
    copy = new Date();
    copy.setTime(obj.getTime());
  } else if (obj instanceof Array) {
    copy = [];
    for (var i = 0, len = obj.length; i < len; i++) {
      copy[i] = this.clone(obj[i]);
    }
  } else if (obj instanceof Object) {
    copy = {};
    for (var attr in obj) {
      if (obj.hasOwnProperty(attr)) {
        copy[attr] = this.clone(obj[attr]);
      }
    }
  }
  return copy;
};

services.tools.prototype.concat = function(a,b) {
  return this.toArray(a).concat(this.toArray(b));
};

services.tools.prototype.first = function(input) {
  var result=null;
  if(!this.isArray(input)) {
    input=this.toArray(input);
  }
  if(input && input.length>0) {
    result=input[0];
  }
  return result;
};

services.tools.prototype.sum = function(input,field) {
  var sum=0.0;
  if(input) {
    for(var i in input) {
      sum+=this.amountIn(input[i][field]);
    }
  }
  return sum;
};

services.tools.prototype.greater = function(input,field,val) {
  var result=input;
  if(angular.isDefined(input) && angular.isDefined(val)) {
    result=[];
    for(var i in input) {
      if(input[i][field]>val) {
        result.push(input[i]);
      }
    }
  }
  return result;
};

services.tools.prototype.greaterInt = function(input,field,val) {
  var result=input;
  if(angular.isDefined(input) && angular.isDefined(val)) {
    val=parseInt(val);
    result=[];
    for(var i in input) {
      if(parseInt(input[i][field])>val) {
        result.push(input[i]);
      }
    }
  }
  return result;
};

services.tools.prototype.between = function(input,field,leftborderValue,rightborderValue,leftborderIncluded,rightborderIncluded) {
  var result=input;
  if(angular.isDefined(input) && angular.isDefined(leftborderValue) && angular.isDefined(rightborderValue) && angular.isDefined(leftborderIncluded) && angular.isDefined(rightborderIncluded)) {
    result=[];
    for(var i in input) {
      if((leftborderIncluded?(input[i][field]>=leftborderValue):(input[i][field]>leftborderValue)) && (rightborderIncluded?(input[i][field]<=rightborderValue):(input[i][field]<rightborderValue))) {
        result.push(input[i]);
      }
    }
  }
  return result;
};

services.tools.prototype.greaterEqual = function(input,field,val) {
  var result=input;
  if(angular.isDefined(input) && angular.isDefined(val)) {
    result=[];
    for(var i in input) {
      if(input[i][field]>=val) {
        result.push(input[i]);
      }
    }
  }
  return result;
};

services.tools.prototype.less = function(input,field,val) {
  var result=input;
  if(angular.isDefined(input) && angular.isDefined(val)) {
    result=[];
    for(var i in input) {
      if(input[i][field]<val) {
        result.push(input[i]);
      }
    }
  }
  return result;
};

services.tools.prototype.lessInt = function(input,field,val) {
  var result=input;
  if(angular.isDefined(input) && angular.isDefined(val)) {
    val=parseInt(val);
    result=[];
    for(var i in input) {
      if(parseInt(input[i][field])<val) {
        result.push(input[i]);
      }
    }
  }
  return result;
};

services.tools.prototype.lessEqual = function(input,field,val) {
  var result=input;
  if(angular.isDefined(input) && angular.isDefined(val)) {
    result=[];
    for(var i in input) {
      if(input[i][field]<=val) {
        result.push(input[i]);
      }
    }
  }
  return result;
};

services.tools.prototype.max = function(input,field) {
  if(input) {
    return this.toArray(input).reduce(function(acc,cur) {
      return (acc===null || cur[field]>acc[field])?cur:acc;
    },null);
  }
};

services.tools.prototype.maxInt = function(input,field) {
  if(input) {
    return this.toArray(input).reduce(function(acc,cur) {
      return (acc===null || parseInt(cur[field])>parseInt(acc[field]))?cur:acc;
    },null);
  }
};

services.tools.prototype.min = function(input,field) {
  if(input) {
    return this.toArray(input).reduce(function(acc,cur) {
      return (acc===null || cur[field]<acc[field])?cur:acc;
    },null);
  }
};

services.tools.prototype.minInt = function(input,field) {
  if(input) {
    return this.toArray(input).reduce(function(acc,cur) {
      return (acc===null || parseInt(cur[field])<parseInt(acc[field]))?cur:acc;
    },null);
  }
};

services.tools.prototype.addElement = function(input,ele) {
  if(input) {
    var output=this.copyArray(input);
    output.push(ele);
    return output;
  }
};

services.tools.prototype.timestampOutLang = function(timestamp,lang) {
  if(timestamp) {
    var result=this.dateOutLang(timestamp,lang);
    if(timestamp.length>10) {
      result+=' '+this.hourOut(timestamp);
    }
    return result;
  }
  return '';
};

services.tools.prototype.timestampOut = function(timestamp) {
  return this.timestampOutLang(timestamp,this.user.lang);
};

services.tools.prototype.byLabel={'en':'by','nl':'door','fr':'par'};
services.tools.prototype.doneByLang = function(timestamp,name,lang) {
  var result='';
  if(timestamp) {
    var timestampOut=this.timestampOutLang(timestamp,lang);
    if(name) {
      result=timestampOut+' '+this.byLabel[lang]+' '+name;
    } else {
      result=timestampOut;
    }
  }
  return result;
};

services.tools.prototype.doneBy = function(timestamp,name) {
  return this.doneByLang(timestamp,name,this.user.lang);
};
services.tools.prototype.shortDoneByLang = function(date,name,lang) {
  var result='';
  if(date) {
    var dateOut=this.dateOutLang(date,lang);
    if(name) {
      result=dateOut+' '+this.byLabel[lang]+' '+name;
    } else {
      result=dateOut;
    }
  }
  return result;
};

services.tools.prototype.shortDoneBy = function(date,name) {
  return this.shortDoneByLang(date,name,this.user.lang);
};

services.tools.prototype.getMinIdMinusOne = function(collection) {
  var minId=0;
  if(collection) {
    collection=this.toArray(collection);
    var id;
    for(var i=0;i<collection.length;i++) {
      id=parseInt(collection[i].id,10);
      if(id<minId) {
        minId=id;
      }
    }
  }
  minId-=1;
  return minId.toString();
};

services.tools.prototype.timeout = function(f,duration) {
  this.$timeout(f,duration);
};

services.tools.prototype.startFrom = function(input, start) {
  if(input) {
    if(!this.isArray(input)) {
      input=this.toArray(input);
    }
    start = Number(start);
    return input.slice(start);
  }
};

services.tools.prototype.orderBy = function(input,field) {
  return this.$filter('orderBy')(input,field);
};

services.tools.prototype.limitTo = function(input,limit) {
  return this.$filter('limitTo')(input,limit);
};

services.tools.prototype.filter = function(array,expression) {
  return this.$filter('filter')(array,expression);
};

services.tools.prototype._joinRecord=function(result,record,collectionName,returnArray,model) {
  if(angular.isDefined(record) && (collectionName in model) && (collectionName in record)) {
    var collection=model[collectionName];
    var ids=record[collectionName];
    for(var i in ids) {
      if(collection[ids[i]]) {
        if(returnArray) {
          result.push(collection[ids[i]]);
        } else {
          result[i]=collection[ids[i]];
        }
      }
    }
  }
  return result;
};

services.tools.prototype._joinRecords=function(records,collectionName,returnArray,model) {
  var result=[];
  if(this.isArray(records)) {
    for(var i in records) {
      result=this._joinRecord(result,records[i],collectionName,returnArray,model);
    }
  } else {
    result=this._joinRecord(result,records,collectionName,returnArray,model);
  }
  return result;
};

services.tools.prototype.join = function(records,collectionName,model) {
  return this._joinRecords(records,collectionName,true,model);
};

services.tools.prototype.objectJoin = function(records,collectionName,model) {
  return this._joinRecords(records,collectionName,false,model);
};

services.tools.prototype.inverseJoin = function(records,collectionName,foreignkey,model) {
  var outRecords=[];
  if(records && (collectionName in model)) {
    var collection=model[collectionName];
    var id;
    var outIds=[];
    for(var i in records) {
      id=records[i][foreignkey];
      if(id in collection && outIds.indexOf(id)<=-1) {
        outRecords.push(collection[id]);
        outIds.push(id);
      }
    }
  }
  return outRecords;
};

services.tools.prototype.initDates = function(startDiff,endDiff,model) {
  var startdate = new Date();
  if(startDiff!==0) {
    startdate.setDate(startdate.getDate()+startDiff);
  }
  model.startdate=startdate;
  var enddate = new Date();
  if(endDiff!==0) {
    enddate.setDate(enddate.getDate()+endDiff);
  }
  model.enddate=enddate;
};

services.tools.prototype.validateAndUpdateDates = function(model) {
  var result=false;
  if('startdate' in model && 'enddate' in model) {
    if(Math.round((model.enddate.getTime() - model.startdate.getTime()) / (1000 * 3600 * 24))<=31) {
      result=true;
    } else {
      this.errorlog.receiveError('Interval too wide. The maximum is 31 days.');
    }
  }
  return result;
};

services.tools.prototype.filterDates = function(model) {
  model=model||this.modelstore.getModel();
  var output=[];
  if(('dates' in model) && ('startdateValue' in model) && ('enddateValue' in model)) {
    for(var id in model.dates) {
      if(id>=model.startdateValue && id<=model.enddateValue) {
        output.push(model.dates[id]);
      }
    }
  }
  return output;
};

services.tools.prototype.initAttribute = function(key,value,model) {
  if(!(key in model)) {
    model[key]=value;
  }
};
services.tools.prototype.initAttributes = function(model,obj,place) {
  angular.forEach(obj,function(value,key) {
    if(!(key in model)) {
      model[key]=value;
    }
  });
};
services.tools.prototype.utf8Encode = function(string) {
  string = string.replace(/\r\n/g,'\n');
  var utftext = '';
  for (var n = 0; n < string.length; n++) {
    var c = string.charCodeAt(n);
    if (c < 128) {
      utftext += String.fromCharCode(c);
    } else if((c > 127) && (c < 2048)) {
      utftext += String.fromCharCode((c >> 6) | 192);
      utftext += String.fromCharCode((c & 63) | 128);
    } else {
      utftext += String.fromCharCode((c >> 12) | 224);
      utftext += String.fromCharCode(((c >> 6) & 63) | 128);
      utftext += String.fromCharCode((c & 63) | 128);
    }
  }
  return utftext;
};
services.tools.prototype.decodeNumericEntities = function(str) {
  return str.replace(/&#(x?[0-9a-fA-F]+);/g, function(full, code) {
    var cp = code[0].toLowerCase() === 'x' ? parseInt(code.slice(1), 16) : parseInt(code, 10);
    try { return String.fromCodePoint(cp); } catch (e) { return full; }
  });
};
services.tools.prototype._keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
services.tools.prototype.encode64=function(input) {
  var output = '';
  var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
  var i = 0;
  input = this.utf8Encode(input);
  while (i < input.length) {
    chr1 = input.charCodeAt(i++);
    chr2 = input.charCodeAt(i++);
    chr3 = input.charCodeAt(i++);
    enc1 = chr1 >> 2;
    enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
    enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
    enc4 = chr3 & 63;
    if (isNaN(chr2)) {
      enc3 = enc4 = 64;
    } else if (isNaN(chr3)) {
      enc4 = 64;
    }
    output = output +
    this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) +
    this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);
  }
  return output;
};
services.tools.prototype.hash = function(e) {
  var hash = 0;
  var len=e.length;
  if (len === 0) {
    return hash;
  }
  var c;
  for(var i = 0; i < len; i++) {
    c = e.charCodeAt(i);
    hash = ((hash<<5)-hash)+c;
    hash &= hash;
  }
  return hash;
};
services.tools.prototype.label = function(label) {
  var result='';
  if(label && ('label'+this.user.lang in label)) {
    result=label['label'+this.user.lang];
  }
  return result;
};
services.tools.prototype.short = function(label) {
  var result='';
  if(label && ('short'+this.user.lang in label)) {
    result=label['short'+this.user.lang];
  }
  return result;
};
services.tools.prototype.lang = function(label) {
  var result='';
  if(label && (this.user.lang in label)) {
    result=label[this.user.lang];
  }
  return result;
};
services.tools.prototype.emailClass = function(value) {
  var result='required';
  if(value) {
    var re = /^(([^<>()[\]\\.,;:\s@\']+(\.[^<>()[\]\\.,;:\s@\']+)*)|(\'.+\'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if(re.test(value)) {
      result='valid';
    } else {
      result='error';
    }
  }
  return result;
};
services.tools.prototype.dateClass = function(value) {
  var result='required';
  if(value) {
    var re = /^(\d{4})(\/|-)(\d{1,2})(\/|-)(\d{1,2})$/;
    if(re.test(value)) {
      result='valid';
    } else {
      result='error';
    }
  }
  return result;
};
services.tools.prototype.requiredClass = function(value) {
  var result='required';
  if(value) {
    result='valid';
  }
  return result;
};
services.tools.prototype.passwordClass = function(value) {
  var result='required';
  if(value) {
    if(value.length>=8) {
      result='valid';
    } else {
      result='error';
    }
  }
  return result;
};
services.tools.prototype.confirmPasswordClass = function(password,confirmPassword) {
  var result='required';
  if(confirmPassword) {
    if(password===confirmPassword) {
      result='valid';
    } else {
      result='error';
    }
  }
  return result;
};
services.tools.prototype.xor = function(a,b) {
  return (!a && b) || (a && !b);
};
services.tools.prototype.sortId = function(a) {
  return parseInt(a.id,10);
};
services.tools.prototype.coalesce = function(value,def) {
  var result;
  if(angular.isUndefined(value) || value===null || value==='') {
    result=def;
  } else {
    result=value;
  }
  return result;
};
services.tools.prototype.round = function(value,decimals) {
  var pow=Math.pow(10.0,decimals);
  return Math.round(this.amountIn(value+Number.EPSILON)*pow)/pow;
};
services.tools.prototype.push = function(parent,name,record) {
  if(!(name in parent)) {
    parent[name]=[];
  }
  parent[name].push(record);
};
services.tools.prototype.filterUserOnRight = function(model,rgh) {
  return this.inverseJoin(this.match(model.rights,{'rgh':rgh}),'users','user',model);
};
services.tools.prototype.copyFields = function(from,to,fields) {
  var field,i;
  if(this.isArray(fields)) {
    for(i in fields) {
      field=fields[i];
      if(field in from) {
        to[field]=from[field];
      }
    }
  } else {
    to[fields]=from[fields];
  }
  return to;
};
services.tools.prototype.copyToClipboard = function(text) {
  var copyElement = document.createElement("span");
  copyElement.appendChild(document.createTextNode(text));
  copyElement.id = 'tempCopyToClipboard';
  angular.element(document.body.append(copyElement));
  var range = document.createRange();
  range.selectNode(copyElement);
  this.$window.getSelection().removeAllRanges();
  this.$window.getSelection().addRange(range);
  document.execCommand('copy');
  this.$window.getSelection().removeAllRanges();
  copyElement.remove();
};
services.tools.prototype.addMatchingElement = function(input,result,matchingElementTemplate) {
  if(this.getLength(this.match(input,matchingElementTemplate))>0 && this.getLength(this.match(result,matchingElementTemplate))==0) {
    result=this.addElement(result,this.first(this.match(input,matchingElementTemplate)));
  }
  return result;
}
services.tools.prototype.mapColumnFunction = function(fieldName) {
  return function(record) {
    return record[fieldName];
  };
};
angular.module('app').service('tools',['$window','$location','$timeout','$filter','formatting','user','modelstore','errorlog',services.tools]);

/*
 * parameters
 */
services.parameters = function(user,tools) {
  this.user=user;
  this.tools=tools;
};
services.parameters.prototype.combinationFilter = function(id2s,comb,id1) {
  var result={};
  if(id1 && (comb in this) && (id1 in this[comb])) {
    var combinations=this[comb][id1].id2s;
    var combination;
    for(var i = 0, len = combinations.length; i < len; i++) {
      combination=combinations[i];
      if(combination in id2s) {
        result[combination]=id2s[combination];
      }
    }
  }
  return result;
};
services.parameters.prototype.inverseCombinationFilter = function(id1s,comb,id2) {
  var result={};
  if(id1s && (comb in this) && id2) {
    for(var i in id1s) {
      if(i in this[comb] && id2 in this[comb][i].id2s) {
        result[i]=id1s[i];
      }
    }
  }
  return result;
};
services.parameters.prototype.checkCombination = function(comb,id1,id2) {
  return (comb in this) && (id1 in this[comb]) && (this[comb][id1].id2s.indexOf(id2.toString())>-1);
};
services.parameters.prototype.combinationCompare = function(comb,id1s,id2s) {
  var len2=id2s.length;
  if(len2===0) {
    return true;
  }
  if(!(comb in this)) {
    return false;
  }
  var i,j,id1,sub;
  var len1=id1s.length;
  for(i=0;i<len1;i++) {
    id1=id1s[i];
    if(!(id1 in this[comb])) {
      return false;
    }
    sub=this[comb][id1].id2s;
    for(j=0;j<len2;j++) {
      if(sub.indexOf(id2s[j])<=-1) {
        return false;
      }
    }
  }
  return true;
};
services.parameters.prototype.updateParamtable = function(tableName,values) {
  var parameters=this;
  var i,value;
  if(angular.isUndefined(parameters[tableName])) {
    parameters[tableName]={};
  }
  for(i in values) {
    value=values[i];
    parameters[tableName][value.id]=value;
  }
  parameters['notDel'+tableName]=parameters.tools.matchForObject(parameters[tableName],{'del':'0'});
  parameters['array'+tableName]=parameters.tools.toArray(parameters[tableName]);
  parameters['notDelArray'+tableName]=parameters.tools.toArray(parameters['notDel'+tableName]);
};
services.parameters.prototype.label = function(tableName,id) {
  return this.tools.label(this[tableName][id]);
};
angular.module('app').service('parameters',['user','tools',services.parameters]);

/*
 * webservice
 */
services.webservice = function($log,$q,$window,$location,$http,$uibModal,$sce,Upload,config,localStorageService,user,tools,parameters,modelstore,errorlog,navTreeService) {
  this.$log=$log;
  this.$q=$q;
  this.$window=$window;
  this.$location=$location;
  this.$http=$http;
  this.$uibModal=$uibModal;
  this.$sce=$sce;
  this.Upload=Upload;
  this.config=config;
  this.localStorageService=localStorageService;
  this.user=user;
  this.tools=tools;
  this.parameters=parameters;
  this.modelstore=modelstore;
  this.errorlog=errorlog;
  this.navTreeService=navTreeService;
  this.email='';
  this.password='';
  this.showLog=false;
  this.loggedIn=false;
  this.auth='';
  this.loginDeferred=null;
  this.technicalErrorMessage='Technical error. Please contact your supplier.';
  this.calling=false;
};
services.webservice.prototype.setAuth = function(email,password) {
  if(email===null && password===null) {
    this.email=null;
    this.password=null;
    this.auth=null;
  } else {
    if(email!==null) {
      this.email=email;
    }
    if(password!==null) {
      this.password=password;
    }
    this.auth=this.tools.encode64(this.email+':'+this.password);
  }
};

services.webservice.prototype.handleResponse = function(type,data,model) {
  var result=null;
  var webservice=this;
  if(webservice.tools.isArray(data)) {
    var response=null;
    var len=data.length;
    if(len===0) {
      webservice.$log.log('ERROR: empty response');
    }
    var collection,j;
    for(var i=0; i<len; i++) {
      webservice.$log.log(type+' received: '+angular.toJson(data[i]));
      if('res' in data[i]) {
        response=data[i].res;
      } else if('err' in data[i]) {
        webservice.errorlog.receiveError(data[i].err);
        model.lastError=data[i].err;
      } else if('war' in data[i]) {
        webservice.errorlog.receiveWarning(data[i].war);
      } else if('del' in data[i]) {
        collection=data[i].del;
        var ids=data[i].val;
        for(j in ids) {
          webservice.modelstore.removeRecord(collection,ids[j],model);
        }
      } else if('par' in data[i]) {
        model[data[i].par]=data[i].val;
      } else if('col' in data[i]) {
        collection=data[i].col;
        var records=data[i].val;
        if(!webservice.tools.isArray(records)) {
          webservice.errorlog.receiveError(webservice.technicalErrorMessage);
          webservice.$log.log('ERROR: received collection that is not an array: '+collection);
          continue;
        }
        if(records.length===0) {
          continue;
        }
        if(collection==='deleted') {
          webservice.errorlog.receiveError(webservice.technicalErrorMessage);
          webservice.$log.log('ERROR: received the deleted collection');
        }
        for(j in records) {
          webservice.modelstore.addRecord(collection,records[j],model);
        }
      }
    }
    result=webservice.$q.resolve(response);
  } else {
    webservice.errorlog.receiveError(webservice.technicalErrorMessage);
    webservice.$log.log('ERROR: data is not an array '+angular.toJson(data));
    result=webservice.$q.reject(false);
  }
  return result;
};
services.webservice.prototype.http = function(method,url,data,model,file) {
  var webservice=this;
  var httpOrUpload;
  var protocol;
  if(angular.isDefined(file)) {
    httpOrUpload=webservice.Upload.upload({url:url,method:method,file:file,data:data});
    protocol='Upload';
  } else {
    httpOrUpload=webservice.$http({url:url,method:method,data:angular.toJson(data)});
    protocol='HTTP';
  }
  return httpOrUpload.then(function(data,status) {
    var result=null;
    if(angular.isObject(data) && 'status' in data) {
      status=data.status;
      data=data.data;
    }
    status=parseInt(status,10);
    if(status===200) {
      result=webservice.handleResponse(protocol,data,model);
    } else {
      if(status===401) {
        if(webservice.auth) {
          webservice.logout();
        }
      } else {
        webservice.errorlog.receiveError('Technical error '+data.status+'. Please contact your supplier.');
      }
      result=webservice.$q.reject(false);
    }
    return result;
  },function() {
    return webservice.$q.reject(false);
  });
};

services.webservice.prototype.call = function(task,params,script,model,file) {
  var webservice=this;
  var protocol;
  if(angular.isDefined(file)) {
    protocol='Upload';
  } else {
    protocol='HTTP';
  }
  if(webservice.showLog) {
    params.showLog=webservice.showLog;
  }
  this.$log.log(protocol+' calling: '+task+' '+script+' '+angular.toJson(params));
  var data={
    's':script,
    't':task,
    'p':params
  };
  if(this.auth) {
    data.a=this.auth;
  }
  var webservice=this;
  return this.http('POST',this.config.get('serviceUrl'),data,model,file).then(function (response) {
    if(response) {
      webservice.$log.log(protocol+' resolving: '+task+' '+script+' '+angular.toJson(params));
    }
    return response;
  });
};

services.webservice.prototype.exclusiveCall = function(task,params,script,model,file) {
  var result;
  var webservice=this;
  if(webservice.calling) {
    result=webservice.$q.reject();
  } else {
    webservice.calling=true;
    result=webservice.call(task,params,script,model,file).then(function(response) {
      var result;
      webservice.calling=false;
      if(response===false) {
        result=webservice.$q.reject();
      } else {
        result=response;
      }
      return result;
    },function(reason) {
      webservice.calling=false;
      return webservice.$q.reject(reason);
    });
  }
  return result;
};

services.webservice.prototype.login = function(email,password,remember) {
  var defered=this.$q.defer();
  var rememberTerm=new Date();
  rememberTerm.setDate(rememberTerm.getDate() + 1);
  rememberTerm.setHours(4,0,0);
  var expiry=this.localStorageService.get('expiry');
  if(expiry) {
    expiry=this.tools.timestampToJava(expiry);
    var now=new Date();
    if(expiry>now && expiry<=rememberTerm) {
      this.setAuth(this.localStorageService.get('email'), this.localStorageService.get('password'));
    } else {
      this.localStorageService.clear();
    }
  }
  var setLocalStorage=false;
  if(!this.auth) {
    if(email && password) {
      this.setAuth(email, password);
      setLocalStorage=remember;
    }
  }
  if(this.auth) {
    var model={};
    var webservice=this;
    this.call('initParams',{},'shared',model).then(function(response) {
      if(response) {
        if(setLocalStorage) {
          webservice.localStorageService.set('expiry',webservice.tools.timestampFromJava(rememberTerm));
          webservice.localStorageService.set('email',webservice.email);
          webservice.localStorageService.set('password',webservice.password);
        }
        webservice.loggedIn=true;
        var i,j,value,country,countryCallingCode,countryKey;
        for(var key in model) {
          value=model[key];
          if(key==='navTree') {
            webservice.navTreeService.navTree=value;
          } else if(key==='user') {
            webservice.user.id=value.id;
            webservice.user.name=value.name;
            webservice.user.lang=value.lang;
            webservice.user.role=value.role;
            webservice.user.rights=value.rights;
            webservice.user.dvs=value.dvs;
          } else if(key==='packets') {
            webservice.parameters.packets=value;
          } else if(key==='packetcomponents') {
            webservice.parameters.packetcomponents=value;
          } else if(key==='cashlessMachines') {
            webservice.parameters.cashlessMachines=value;
          } else if(key==='countries') {
            webservice.parameters.countryCallingCodes={};
            webservice.parameters.countries=value;
            for(i in value) {
              country=value[i];
              for(j=0;j<country.countryCallingCodes.length;j++) {
                countryCallingCode=country.countryCallingCodes[j];
                countryKey=country.id+countryCallingCode;
                webservice.parameters.countryCallingCodes[countryKey]=webservice.tools.clone(country);
                webservice.parameters.countryCallingCodes[countryKey].countryCallingCode=countryCallingCode;
              }
            }
          } else if(key==='languages') {
            webservice.parameters.languages=value;
          } else if(key==='campaigns') {
            webservice.parameters.campaigns=value;
          } else if(key==='restrictionBehaviours') {
            webservice.parameters.restrictionBehaviours=value;
          } else if(key==='divisionLogos') {
            webservice.parameters.divisionLogos={};
            for(i in value) {
              webservice.parameters.divisionLogos[i]=webservice.$sce.trustAsHtml(value[i]);
            }
          } else if(key===key.toUpperCase()) {
            webservice.parameters.updateParamtable(key,value);
          }
        }
        webservice.callCron();
        if(webservice.loginDeferred!==null) {
          webservice.loginDeferred.resolve();
        }
        defered.resolve();
      } else {
        webservice.localStorageService.clear();
        webservice.setAuth(null, null);
        defered.reject();
      }
    });
  } else {
    defered.reject();
  }
  return defered.promise;
};

services.webservice.prototype.afterLogin = function() {
  var result=null;
  if(this.loggedIn) {
    result=this.$q.resolve();
  } else {
    if(this.loginDeferred===null) {
      this.loginDeferred=this.$q.defer();
    }
    result=this.loginDeferred.promise;
  }
  return result;
};

services.webservice.prototype.callCron = function() {
  var webservice=this;
  this.call('cron',{},'shared',{}).then(function(response) {
    if(response==='busy') {
      webservice.callCron();
    }
  });
};

services.webservice.prototype.logout=function() {
  this.localStorageService.clear();
  this.tools.redirect(this.user.lang+'/home');
  this.$window.location.href=this.$location.absUrl();
  this.$window.location.reload();
};

services.webservice.prototype.verifyPassword = function(password) {
  return this.password===password;
};

services.webservice.prototype.deleteConfirmLabel={'en':'Delete','nl':'Verwijder','fr':'Supprimer'};
services.webservice.prototype.confirmModal = function(name,okWording,cancelWording) {
  return this.$uibModal.open({
    'template': '<div class="modal-body" id="modal-body">{{wording}}</div><div class="modal-footer"><button class="btn btn-primary" type="button" ng-click="ok()"">{{okWording}}</button><button class="btn btn-warning" type="button" ng-click="cancel()"">{{cancelWording}}</button></div>',
    'controller': 'ConfirmModalController',
    'resolve': {
      'wording': function() {
        return name;
      },
      'okWording': function() {
        return angular.isDefined(okWording)?okWording:'Ok';
      },
      'cancelWording': function() {
        return angular.isDefined(cancelWording)?cancelWording:'Cancel';
      }
    }
  }).result;
};
services.webservice.prototype.deleteConfirm = function(name,method,id,script,model) {
  var webservice=this;
  return this.confirmModal(webservice.deleteConfirmLabel[webservice.user.lang]+' '+name+'?').then(function() {
    return webservice.call(method,{'id':id},script,model);
  });
};
angular.module('app').service('webservice',['$log','$q','$window','$location','$http','$uibModal','$sce','Upload','config','localStorageService','user','tools','parameters','modelstore','errorlog','navTreeService',services.webservice]);

/*
 * emailbox
 */
services.emailbox = function($uibModal,tools,errorlog) {
  this.$uibModal=$uibModal;
  this.tools=tools;
  this.errorlog=errorlog
  /*
  this.show=false;
  this.recipient='';
  this.subject='';
  this.attachment='';
  this.body='';
  this.send=null;
  */
};
services.emailbox.prototype.showTemplate = function(fromMailOptionsA,recipientOptionsA,ccA,bccA,subjectA,attachmentA,bodyA,readonly,signatures) {
  var tools=this.tools;
  var errorlog=this.errorlog;
  if(angular.isUndefined(readonly)) {
    readonly=false;
  }
  var textareas={};
  var textareaIndex=0;

  var body=bodyA.replace(/(<div[^>]*class=\"editable\">)(.*?)(<\/div>)/g,function(match,p1,p2,p3) {
    textareaIndex+=1;
    textareas['i'+textareaIndex.toString()]=tools.decodeNumericEntities(p2.trim().replace(/<br\/>/g,'\n'));
    return p1+'<textarea class="form-control" rows="11" ng-model="textareas.i'+textareaIndex.toString()+'"'+(readonly?' readonly':'')+' ></textarea>'+p3;
  }).replace(/(<div[^>]*style=\")(width)(:[0-9]*px;[^>]*\")(>.*?<\/div>)/g,function(match,p1,p2,p3,p4) {
    return p1+'max-width'+p3+' widthfix '+p4;
  })/*.replace(/(<td[^>]*style=\")(width)(:[0-9]*px;[^>]*\")(>.*?<\/td>)/g,function(match,p1,p2,p3,p4) {
    return p1+'max-width'+p3+' widthfix '+p4;
  })*/;

  return this.$uibModal.open({
    'template':
      '<div class="modal-header">'+
      '  <h4 class="col-xs-10">'+
      (readonly?'{{subject}}':'{{lang({\'en\':\'New message\',\'nl\':\'Nieuw bericht\',\'fr\':\'Nouveau message\'})}}')+
      '  </h4>'+
      '  <div style="text-align:right">'+
      '    <button class="btn btn-sm btn-danger" style="height:10px;padding:13px 10px;" type="button" ng-click="cancel()">×</button>'+
      '  </div>'+
      '</div>'+
      '<div class="modal-body">'+
      '  <form class="form-horizontal">'+
      '    <div class="form-group">'+
      '      <label for="fromMail" class="col-sm-2 control-label">{{lang({\'en\':\'From\',\'nl\':\'Van\',\'fr\':\'De\'})}}</label>'+
      '      <div class="col-sm-10">'+
      '        <input ng-show="getLength(fromMailOptions)==1" type="text" id="fromMail" class="form-control" ng-model="fromMail" readonly />'+
      '        <select ng-show="getLength(fromMailOptions)>1" class="form-control" ng-model="fromMail" ng-options="fromMailElement for fromMailElement in fromMailOptions"'+
      '                '+(readonly?' readonly':'')+'></select>'+
      '      </div>'+
      '    </div>'+
      '    <div class="form-group">'+
      '      <label for="recipient" class="col-sm-2 control-label">{{lang({\'en\':\'To\',\'nl\':\'Aan\',\'fr\':\'À\'})}}</label>'+
      '      <div class="col-sm-10">'+
      '        <div ng-class="{\'input-group\': getLength(cc)==0 || getLength(bcc)==0}">'+
      '          <input ng-show="getLength(recipientOptions)==1" type="text" id="recipient" class="form-control" ng-model="recipient" readonly />'+
      '          <select ng-show="getLength(recipientOptions)>1" class="form-control" ng-model="recipient" ng-options="recipientElement for recipientElement in recipientOptions"'+
      '                '+(readonly?' readonly':'')+'></select>'+
      '          <div class="input-group-btn">'+
      (readonly?'':'<button type="button" class="btn btn-default" ng-hide="getLength(cc)>0" ng-click="showCc=!showCc">Cc</button>')+
      (readonly?'':'<button type="button" class="btn btn-default" ng-hide="getLength(bcc)>0" ng-click="showBcc=!showBcc">Bcc</button>')+
      '          </div>'+
      '        </div>'+
      '      </div>'+
      '    </div>'+
      '    <div class="form-group" ng-show="showCc && !'+readonly+'">'+
      '      <label for="cc" class="col-sm-2 control-label">Cc</label>'+
      '        <div class="col-sm-10">'+
      '          <button class="btn btn-default" ng-repeat="adress in '+(readonly?'tools.toArray(cc)':'cc')+'">'+
      '            <span>{{adress}}&nbsp;</span>'+
      '            <span class="glyphicon glyphicon-remove" ng-click="deleteMail(adress,cc)"></span>'+
      '          </button>'+
      '          <div class="input-group">'+
      '            <input type="email" id="cc" class="form-control" ng-model="addCc" ng-mailseperator="addMail(addCc,\'Cc\',cc,true)" />'+
      '            <div class="input-group-btn">'+
      '              <button class="btn btn-default" type="button" ng-click="addMail(addCc,\'Cc\',cc,true)">'+
      '                <span class="glyphicon glyphicon-plus"></span>'+
      '              </button>'+
      '            </div>'+
      '          </div>'+
      '        </div>'+
      '      <label>'+
      '    </div>'+
      '    <div class="form-group" ng-show="showCc && '+readonly+'">'+
      '      <label for="cc" class="col-sm-2 control-label">Cc</label>'+
      '      <div class="col-sm-10">'+
      '        <input type="text" id="cc" class="form-control" ng-model="cc"'+(readonly?' readonly':'')+' />'+
      '      </div>'+
      '    </div>'+
      '    <div class="form-group" ng-show="showBcc && !'+readonly+'">'+
      '      <label for="bcc" class="col-sm-2 control-label">Bcc</label>'+
      '        <div class="col-sm-10">'+
      '          <button class="btn btn-default" ng-repeat="adress in '+(readonly?'tools.toArray(bcc)':'bcc')+'">'+
      '            <span>{{adress}}&nbsp;</span>'+
      '            <span class="glyphicon glyphicon-remove" ng-click="deleteMail(adress,bcc)"></span>'+
      '          </button>'+
      '          <div class="input-group">'+
      '            <input type="email" id="bcc" class="form-control" ng-model="addBcc" ng-mailseperator="addMail(addBcc,\'Bcc\',bcc,true)" />'+
      '            <div class="input-group-btn">'+
      '              <button class="btn btn-default" type="button" ng-click="addMail(addBcc,\'Bcc\',bcc,true)">'+
      '                <span class="glyphicon glyphicon-plus"></span>'+
      '              </button>'+
      '            </div>'+
      '          </div>'+
      '        </div>'+
      '      <label>'+
      '    </div>'+
      '    <div class="form-group" ng-show="showBcc && '+readonly+'">'+
      '      <label for="bcc" class="col-sm-2 control-label">Bcc</label>'+
      '      <div class="col-sm-10">'+
      '        <input type="text" id="bcc" class="form-control" ng-model="bcc"'+(readonly?' readonly':'')+' />'+
      '      </div>'+
      '    </div>'+
      '    <div class="form-group">'+
      '      <label for="subject" class="col-sm-2 control-label">Subject</label>'+
      '      <div class="col-sm-10">'+
      '        <input type="text" id="subject" class="form-control" ng-model="subject"'+(readonly?' readonly':'')+' />'+
      '      </div>'+
      '    </div>'+
      '    <div class="form-group" ng-show="attachment!=\'\'">'+
      '      <label for="attachment" class="col-sm-2 control-label">Attachment</label>'+
      '      <div class="col-sm-10">'+
      '        <input type="text" id="attachment" class="form-control" ng-model="attachment" readonly />'+
      '      </div>'+
      '    </div>'+
      '    <div class="mail">'+body+'</div>'+
      '    <div ng-bind-html="renderHtml(signaturesB[fromMail])" ng-if="signaturesB[fromMail]"></div>'+
      '  </form>'+
      '</div>'+
      '<div class="modal-footer">'+
      (readonly?'':'  <button class="btn btn-primary" type="button" ng-click="ok()">OK</button>')+
      '  <button class="btn btn-warning" type="button" ng-click="cancel()">Cancel</button>'+
      '</div>',
    'controller': ["$scope","$uibModalInstance","$sce","fromMailOptionsB","recipientOptionsB","ccB","bccB","subjectB","attachmentB","bodyB","textareasB","readonlyB","signaturesB","tools","errorlog",
                   function($scope,$uibModalInstance,$sce,fromMailOptionsB,recipientOptionsB,ccB,bccB,subjectB,attachmentB,bodyB,textareasB,readonlyB,signaturesB,tools,errorlog) {
      $scope.fromMailOptions=fromMailOptionsB;
      $scope.fromMail=fromMailOptionsB[0];
      $scope.recipientOptions=recipientOptionsB;
      $scope.recipient=recipientOptionsB[0];
      $scope.cc=ccB;
      $scope.showCc=ccB!="";
      $scope.addCc='';
      $scope.bcc=bccB;
      $scope.showBcc=bccB!="";
      $scope.addBcc='';
      $scope.subject=subjectB;
      $scope.attachment=attachmentB;
      $scope.body=bodyB;
      $scope.textareas=textareasB;
      $scope.signaturesB=signaturesB;

      $scope.addMail = function(mail,recipientType,to,showError) {
        if(angular.isDefined(mail) && mail!=='' && to.indexOf(mail)<0) {
          to[to.length]=mail;
          $scope['add'+recipientType]='';
        } else if(showError) {
          if(mail==='') {
            errorlog.warning(tools.lang({'en':'Please enter an email address','nl':'Geef een emailadres in','fr':'Ajouter une adresse mail'}));
          } else if(angular.isUndefined(mail)) {
            errorlog.error(tools.lang({'en':'Invalid email address','nl':'Ongeldig emailadres','fr':'Adresse mail invalide'}));
          } else {
            errorlog.error(tools.lang({'en':'Already added this email address','nl':'Emailadres alreeds toegevoegd','fr':'Adresse mail d\u00E9j\u00E0 ajouter'}));
          }
        }
      }

      $scope.renderHtml = function(html_code) {
        return $sce.trustAsHtml(html_code);
      };

      $scope.getLength = function(x) {
        return tools.getLength(x);
      }

      $scope.lang = function(x) {
        return tools.lang(x);
      }

      $scope.deleteMail = function(mail,from) {
        if(from.indexOf(mail)>=0) {
          from.splice(from.indexOf(mail),1);
        }
      }

      $scope.ok = function() {
        var textareaIndex=0;
        $scope.addMail($scope.addCc,'Cc',$scope.cc,false);
        $scope.addMail($scope.addBcc,'Bcc',$scope.bcc,false);
        $uibModalInstance.close({
          'fromMail':$scope.fromMail,
          'recipient':$scope.recipient,
          'cc':$scope.cc,
          'bcc':$scope.bcc,
          'subject':$scope.subject,
          'attachment':$scope.attachment,
          'body':bodyB.replace(/(<div[^>]*class=\"editable\">)(.*?)(<\/div>)/g,function(match,p1,p2,p3) {
            textareaIndex+=1;
            return p1+$scope.textareas['i'+textareaIndex.toString()]
              .replace(/&/g, "&amp;")
              .replace(/</g, "&lt;")
              .replace(/>/g, "&gt;")
              .replace(/"/g, "&quot;")
              .replace(/'/g, "&#039;")
              .replace(/(?:\r\n|\r|\n)/g,'<br/>')+p3;
          }).replace(/(<div[^>]*style=\")(max-width)(:[0-9]*px;[^>]*\")( widthfix )(>.*?<\/div>)/g,function(match,p1,p2,p3,p4,p5) {
            return p1+'width'+p3+p5;
          }).replace(/(<td[^>]*style=\")(max-width)(:[0-9]*px;[^>]*\")( widthfix )(>.*?<\/td>)/g,function(match,p1,p2,p3,p4,p5) {
            return p1+'width'+p3+p5;
          })+'<br/>'+(angular.isDefined($scope.signaturesB[$scope.fromMail])?$scope.signaturesB[$scope.fromMail]:'')
        });
      };

      $scope.cancel = function() {
        $uibModalInstance.dismiss();
      };

    }],
    'backdrop':'static',
    'windowClass':'app-modal-window',
    'resolve': {
      'fromMailOptionsB': function() {
        return fromMailOptionsA;
      },
      'recipientOptionsB': function() {
        return recipientOptionsA;
      },
      'ccB': function() {
        return ccA;
      },
      'bccB': function() {
        return bccA;
      },
      'subjectB': function() {
        return tools.decodeNumericEntities(subjectA);
      },
      'attachmentB': function() {
        return attachmentA;
      },
      'bodyB': function() {
        return bodyA;
      },
      'textareasB':function() {
        return textareas;
      },
      'readonlyB':function() {
        return readonly;
      },
      'signaturesB':function() {
        return signatures;
      },
      'tools':function() {
        return tools;
      },
      'errorlog':function() {
        return errorlog;
      }
    }
  }).result;
};
services.emailbox.prototype.openQuotationnoteModal = function(visit,quotationnote) {
  var ths=this;
  return ths.$uibModal.open({
    'template':
      '<div class="modal-body">'+
      '  <form class="form-horizontal">'+
      '    <div class="form-group">'+
      '      <label for="day" class="col-sm-2 control-label">'+ths.tools.lang({'en':'Day','nl':'Dag','fr':'Jour'})+'</label>'+
      '      <div class="col-sm-10">'+
      '        <input type="text" id="day" class="form-control" ng-model="quotationnote.day" />'+
      '      </div>'+
      '    </div>'+
      '    <textarea class="form-control" rows="11" ng-model="quotationnote.body" ></textarea>'+
      '  </form>'+
      '</div>'+
      '<div class="modal-footer">'+
      '  <button class="btn btn-primary" type="button" ng-click="ok()">OK</button>'+
      '  <button class="btn btn-warning" type="button" ng-click="cancel()">Cancel</button>'+
      '</div>',
    'controller': 'QuotationnoteModalController',
    'resolve': {
      'visit': function() {
        return visit;
      },
      'quotationnote': function() {
        return quotationnote;
      }
    }
  }).result;
};
angular.module('app').service('emailbox',['$uibModal','tools','errorlog',services.emailbox]);

'use strict';
var navTreeService = function() {
  this.navTree={};
  this.menuitemParam=null;
};
angular.module("app").service("navTreeService",[navTreeService]);

'use strict';
var localStorageWrapper = function($window) {
  this.$window=$window;
};
localStorageWrapper.prototype.isSupported = function() {
  try {
    return ('localStorage' in this.$window && this.$window.localStorage !== null);
  } catch (e) {
    return false;
  }
};
localStorageWrapper.prototype.set = function(key,value) {
  if (!this.isSupported()) {
    return;
  }
  if (angular.isUndefined(value)) {
    value = null;
  }
  if (angular.isObject(value) || angular.isArray(value)) {
    value = angular.toJson(value);
  }
  localStorage.setItem(key, value);
};
localStorageWrapper.prototype.get = function(key) {
  if (!this.isSupported()) {
    return null;
  }
  var value = localStorage.getItem(key);
  if(!value) {
    return null;
  }
  if (value.charAt(0) === "{" || value.charAt(0) === "[") {
    return angular.formJson(value);
  }
  return value;
};
localStorageWrapper.prototype.clear = function() {
  if (!this.isSupported()) {
    return;
  }
  for (var key in localStorage) {
    localStorage.removeItem(key);
  }
};
localStorageWrapper.prototype.bind = function($scope,pathInScope,nameInLocalStorage,defaultValue) {
  var localStorageService=this;
  var value=localStorageService.get(nameInLocalStorage);
  if(value===null) {
    value=defaultValue;
  }
  var scopeObject=$scope;
  var nameInScope="";
  var pathInScopeLength=pathInScope.length;
  for(var i=0;i<pathInScopeLength;i++) {
    if(i<pathInScopeLength-1) {
      scopeObject=scopeObject[pathInScope[i]];
    } else {
      scopeObject[pathInScope[i]]=value;
    }
    nameInScope+="."+pathInScope[i];
  }
  nameInScope=nameInScope.substr(1);
  $scope.$watch(nameInScope,function(newValue) {
    localStorageService.set(nameInLocalStorage,newValue);
  },true);
};
angular.module("app").service("localStorageService",["$window",localStorageWrapper]);

'use strict';
var lobbyProxyService = function($q,$http,$log,$websocket,tools,errorlog) {
  this.$q=$q;
  this.$http=$http;
  this.$log=$log;
  this.$websocket=$websocket;
  this.tools=tools;
  this.errorlog=errorlog;
  this.host='outdoorlobbyproxy';
  this.httpPort='11775';
  this.wsPort='11775';
  this.socket=null;
  this.onSocketOpen=null;
  this.onMessage=null;
};
lobbyProxyService.prototype.http = function(params) {
  var lobbyProxy=this;
  return lobbyProxy.$http({
    'url':'https://'+lobbyProxy.host+':'+lobbyProxy.httpPort,
    'method':'POST',
    'data':angular.toJson(params)
  }).then(function(data,status) {
    var result=null;
    if(angular.isObject(data) && 'status' in data) {
      status=data.status;
      data=data.data;
    }
    status=parseInt(status,10);
    if(status===200) {
      result=data;
    } else {
      lobbyProxy.errorlog.receiveError('Technical error '+data.status+'. Please contact your supplier.');
      result=lobbyProxy.$q.reject(false);
    }
    return result;
  },function() {
    return lobbyProxy.$q.reject(false);
  });
};
lobbyProxyService.prototype.get=function(url) {
  return this.http('GET',url,'');
};
lobbyProxyService.prototype.post=function(url,params) {
  return this.http('POST',url,params);
};

lobbyProxyService.prototype.initWebsocket=function() {
  var lobbyProxy=this;
  if(lobbyProxy.socket===null) {
    lobbyProxy.socket=lobbyProxy.$websocket('wss://outdoorlobbyproxy:'+lobbyProxy.wsPort);
    lobbyProxy.socket.onOpen(function() {
      if(lobbyProxy.onSocketOpen!==null) {
        lobbyProxy.onSocketOpen();
      }
    });
    lobbyProxy.socket.onClose(function() {
      lobbyProxy.socket=null;
    });
    lobbyProxy.socket.onMessage(function(message) {
      message=message.data;
      lobbyProxy.$log.log('lobbyProxy WS resolving '+message);
      if(lobbyProxy.onMessage!==null) {
        lobbyProxy.onMessage(angular.fromJson(message));
      }
    });
  }
};

lobbyProxyService.prototype.send=function(params) {
  var lobbyProxy=this;
  lobbyProxy.initWebsocket();
  if(lobbyProxy.socket!==null) {
    lobbyProxy.$log.log('lobbyProxy WS sending '+angular.toJson(params));
    lobbyProxy.socket.send(angular.toJson(params));
  } else {
    lobbyProxy.errorlog.receiveError('Technical error lobbyProxy websocket not initialised');
  }
};

angular.module('app').service('lobbyProxy',['$q','$http','$log','$websocket','tools','errorlog',lobbyProxyService]);

angular.module('app').service('dictionary', ['formatting',function(formatting) {
  this.formatting=formatting;
  var numberIn=formatting.numberIn;
  var amountIn=formatting.amountIn;
  var dateIn=formatting.dateIn;
  this.formatFields={
    'menuitems':{'sort':numberIn},
    'visits':{
      'stat':numberIn,
      'startdate':dateIn,
      'enddate':dateIn,
      'quotationparticipants':numberIn
    },
    'activities':{'stat':numberIn,'day':dateIn},
    'items':{'quantity':amountIn,'planningquantity':amountIn,'grossunitprice':amountIn,'reductionamount':amountIn,'deltatopay':amountIn},
    'movements':{'amount':amountIn},
    'balances':{'amount':amountIn},
    'promotions':{'amount':amountIn},
    'activityvats':{'vatrate':amountIn},
    'meals':{'stat':numberIn,'day':dateIn,'peoplecount':amountIn},
    'ruleintervals':{'startdate':dateIn,'enddate':dateIn},
    'employeecommunications':{'expiry':dateIn},
    'templateimages':{'zoomwidth':numberIn,'height':numberIn},
    'templatespacings':{'height':numberIn},
    'formbuttons':{'startdate':dateIn,'enddate':dateIn,'fixedstartdate':dateIn,'fixedenddate':dateIn,'minpackquantity':amountIn},
    'formbuttoncomponents':{'quantity':amountIn,'adultcount':numberIn,'childcount':numberIn},
    'hotelreservationcategories':{'startdate':dateIn,'enddate':dateIn},
    'consparams':{'sort':numberIn},
    'painlines':{'stat':numberIn},
    'painfiles':{'amount':amountIn},
    'contactcreditcards':{'expirydate':dateIn},
    'cashlesspayments':{'amount':amountIn,'received':amountIn,'returned':amountIn,'stat':numberIn}
  };
  this.foreignkeys={
    'visits':{
      'out':{'users':'creator'},
      'in':{
        'reductions':'visit',
        'activities':'visit',
        'movements':'visit',
        'tickets':'visit',
        'invoices':'visit',
        'invoicerows':'visit',
        'items':'visit',
        'meals':'visit',
        'products':'visit',
        'emails':'visit',
        'quotationnotes':'visit',
        'hotelreservationcategories':'visit',
        'rfidcarriers':'visit'
      }
    },
    'painlines':{
      'out':{'movements':'visit','painfiles':'painfile'},
    },
    'painfiles':{
      'in':{'painlines':'painfile'}
    },
    'reductions':{
      'out':{'visits':'visit'}
    },
    'activities':{
      'out':{'visits':'visit'},
      'in':{'participants':'activity','activityvats':'activity'}
    },
    'participants':{
      'out':{'activities':'activity','items':'item'}
    },
    'items':{
      'out':{'visits':'visit'},
      'in':{'participants':'item','dishes':'item','hotelreservationcategories':'item','hotelreservationproducts':'item','products':'item','intercompanyitems':'item'}
    },
    'movements':{
      'out':{'movements':'counter','accounts':'account','visits':'visit'},
      'in':{'painlines':'movement','movements':'counter','cashlesspayments':'movement'}
    },
    'accounts': {
      'out':{'users':'user'},
      'in':{'movements':'account','balances':'account'}
    },
    'tickets': {
      'out':{'visits':'visit'}
    },
    'balances': {
      'out':{'accounts':'account'}
    },
    'users': {
      'in':{'accounts':'user','visits':'creator','assignments':'user','rights':'user'}
    },
    'intercompanies': {
      'in': {'intercompanyitems':'intercompany'}
    },
    'intercompanyitems': {
      'out': {'intercompanies':'intercompany','items':'item'}
    },
    'invoices': {
      'out': {'visits':'visit'}
    },
    'invoicerows': {
      'out': {'visits':'visit'}
    },
    'tabs': {
      'in':{'tabstdlines':'tab','tabfreelines':'tab'}
    },
    'tabstdlines':{
      'out':{'tabs':'tab'}
    },
    'tabfreelines':{
      'out':{'tabs':'tab'}
    },
    'rights':{
      'out':{'users':'user'}
    },
    'promotions':{
      'in':{'restrictions':'foreignkey'}
    },
    'restrictions':{
      'out':{'promotions':'foreignkey','templates':'foreignkey'}
    },
    'packets':{
      'in':{'packetcomponents':'packet'}
    },
    'packetcomponents':{
      'out':{'packets':'packet'}
    },
    'weekschedules':{
      'in':{'weekscheduleentries':'weekschedule'}
    },
    'weekscheduleentries':{
      'out':{'weekschedules':'weekschedule'}
    },
    'meals':{
      'out':{'visits':'visit'},
      'in':{'dishes':'meal'}
    },
    'dishes':{
      'out':{'meals':'meal','items':'item'}
    },
    'products':{
      'out':{'visits':'visit','items':'item'}
    },
    'emails':{
      'out':{'visits':'visit'}
    },
    'rulegroups':{
      'in':{'rulemembers':'rulegroup','ruleintervals':'rulegroup'}
    },
    'rulemembers':{
      'out':{'rulegroups':'rulegroup'}
    },
    'ruleintervals':{
      'out':{'rulegroups':'rulegroup'}
    },
    'templates':{
      'in':{'templatesections':'parenttemplate','restrictions':'foreignkey'}
    },
    'templatesections':{
      'in':{'templatetexts':'templatesection','templateimages':'templatesection','templatebuttons':'templatesection'},
      'out':{'templates':'parenttemplate'}
    },
    'templatetexts':{
      'out':{'templatesections':'templatesection'}
    },
    'templateimages':{
      'out':{'templatesections':'templatesection'}
    },
    'templatebuttons':{
      'out':{'templatesections':'templatesection'}
    },
    'quotationnotes':{
      'out':{'visits':'visit'}
    },
    'formbuttons':{
      'in':{'formbuttoncomponents':'formbutton','formbuttonrelations':'child'}
    },
    'formbuttonrelations':{
      'out':{'formbuttons':'child'}
    },
    'formbuttoncomponents':{
      'out':{'formbuttons':'formbutton'}
    },
    'hotelreservationcategories':{
      'out':{'visits':'visit','items':'item'},
      'in':{'hotelspaceassignments':'reservationcategory','hotelreservationproducts':'reservationcategory'}
    },
    'hotelspaceassignments':{
      'out':{'hotelreservationcategories':'reservationcategory','items':'item','hotelspaces':'assignedspace'},
      'in':{'rfidhotelspacerights':'spaceassignment'}
    },
    'hotelspaces':{
      'in':{'hotelspaceassignments':'assignedspace','visitrelations':'hotelspace'}
    },
    'hotelreservationproducts': {
      'out':{'hotelreservationcategories':'reservationcategory','items':'item'}
    },
    'rfidcarriers': {
      'out':{'visits':'visit'},
      'in':{'rfidhotelspacerights':'rfidcarrier'}
    },
    'rfidhotelspacerights': {
      'out':{'rfidcarriers':'rfidcarrier','hotelspaceassignments':'hotelspaceassignment'}
    },
    'cashlesspayments': {
      'out':{'movements':'movement'}
    },
    'visitrelations': {
      'out':{'hotelspaces':'hotelspace','visits':'visita'}
    }
  };
  this.whitelists={
    'templates':['templatetype','purpose','param1','param2','subjecten','subjectnl','subjectfr','background','tly','datetablefield','dateoffset'],
    'restrictions':['foreigntable','foreignkey','orgroup','behaviour','negation','param1','param2']
  }
}]);

'use strict';
var ctepWrapper = function($q,$log,$websocket,$timeout,config,modelstore,parameters,webservice,tools,user,errorlog,toastr) {
  this.$q=$q;
  this.$log=$log;
  this.$websocket=$websocket;
  this.$timeout=$timeout;
  this.config=config;
  this.modelstore=modelstore;
  this.parameters=parameters;
  this.webservice=webservice;
  this.tools=tools;
  this.user=user;
  this.errorlog=errorlog;
  this.toastr=toastr;
  this.script='CtepForBrowser';
  this.httpPort='11773';
  this.wsPort='11774';
  this.sockets={};
  this.availableTerminalidAndIPs={};
  this.ctepterminals={};
  this.availableCtepterminals={};
  this.myIp='';
  this.claimFirstTerminalIsActive=false;
  this.onTerminalIsClaimed=null;
  this.onTerminalIsUnavailable=null;
  this.onSocketClose=null;
  this.claimedCtepterminal=null;
  this.backupCtepterminals={};
  this.status='idle';
  this.refreshing=false;
  this.cancelerror=false;
  this.setstatusPromise=null;
  this.verifying=false;
  this.saleVisit=null;
  this.saleModel={};
  this.saleDeferred=null;
};
ctepWrapper.prototype.getServerIp = function() {
  var ctep=this;
  return ctep.availableTerminalidAndIPs[ctep.claimedCtepterminal.terminalid].ip;
};
ctepWrapper.prototype.http = function(method,url,params) {
  var ctep=this;
  ctep.$log.log('ctep HTTP calling '+method+' '+url+' '+angular.toJson(params));
  return ctep.webservice.http(method,ctep.config.get('ctepHttpProtocol')+'://'+ctep.getServerIp()+':'+ctep.httpPort+url,angular.toJson(params),{}).then(function(response) {
    if(response) {
      ctep.$log.log('ctep HTTP resolving '+method+' '+url+' '+angular.toJson(params));
    }
    return response;
  });
};
ctepWrapper.prototype.get=function(url) {
  return this.http('GET',url,'');
};
ctepWrapper.prototype.post=function(url,params) {
  return this.http('POST',url,params);
};
ctepWrapper.prototype.send=function(params) {
  var ctep=this;
  ctep.$log.log('service WS sending '+angular.toJson(params));
  ctep.sockets[ctep.getServerIp()].send(angular.toJson(params));
};
ctepWrapper.prototype.updateCtepterminals = function() {
  var ctep=this;
  var i,ctepterminal;
  ctep.availableCtepterminals={};
  for(i in ctep.ctepterminals) {
    ctepterminal=ctep.ctepterminals[i];
    if(ctepterminal.terminalid in ctep.availableTerminalidAndIPs) {
      ctep.availableCtepterminals[ctepterminal.id]=ctepterminal;
    }
  }
  var terminalWasClaimed=ctep.claimedCtepterminal!==null;
  ctep.claimedCtepterminal=null;
  if(ctep.claimFirstTerminalIsActive) {
    if(ctep.tools.getLength(ctep.availableCtepterminals)>=1) {
      ctep.claimedCtepterminal=ctep.tools.first(ctep.availableCtepterminals);
      if(angular.isFunction(ctep.onTerminalIsClaimed) && !terminalWasClaimed) {
        ctep.onTerminalIsClaimed();
      }
    }
  }
  if(angular.isFunction(ctep.onTerminalIsUnavailable) && terminalWasClaimed && ctep.claimedCtepterminal===null) {
    ctep.onTerminalIsUnavailable();
  }
};
ctepWrapper.prototype.handleMessageCtepterminals = function(ip,availableTerminalids) {
  var ctep=this;
  var i,availableTerminalid,matchingCtepterminals;
  for(i in ctep.availableCtepterminals) {
    if(ctep.availableTerminalidAndIPs[ctep.availableCtepterminals[i].terminalid].ip===ip) {
      delete ctep.availableCtepterminals[i];
    }
  }
  for(i in ctep.availableTerminalidAndIPs) {
    if(ctep.availableTerminalidAndIPs[i].ip===ip) {
      delete ctep.availableTerminalidAndIPs[i];
    }
  }
  for(i in availableTerminalids) {
    availableTerminalid=availableTerminalids[i];
    ctep.availableTerminalidAndIPs[availableTerminalid]={'ip':ip,'terminalid':availableTerminalid};
    ctep.webservice.call('createCtepterminal',{'ctepterminal':{'terminalid':availableTerminalid}},ctep.script,ctep).then(function(response) {
      if(response) {
        ctep.updateCtepterminals();
      }
    });
  }
};

ctepWrapper.prototype.handleMessageCtepsaleresult = function(ip,ctepsaleresult) {
  var ctep=this;
  ctepsaleresult.sender='browser';
  var errorWording='';
  ctep.webservice.call('createCtepsaleresult',{'ctepsaleresult':ctepsaleresult},ctep.script,ctep.saleModel).then(function(response) {
    if(ctep.verifying) {
      ctep.$timeout(function() {
        ctep.verifying=false;
      },1000);
    }
    if('cause' in ctepsaleresult && ctepsaleresult.cause==='status') {
      var triedGettingVisitAndContact;
      if(ctepsaleresult.ctepsale!=='' && ctepsaleresult.ctepsale!=='0') {
        triedGettingVisitAndContact=ctep.webservice.call('getVisitAndContact',{'ctepsale':ctepsaleresult.ctepsale},ctep.script,ctep);
      } else {
        triedGettingVisitAndContact=ctep.$q.resolve(false);
      }
      triedGettingVisitAndContact.then(function(response) {
        if(ctepsaleresult.action==='success' && parseFloat(ctepsaleresult.authorizedamount)>0.0) {
          var visit=response.visit;
          var amountString=ctep.tools.amountOut(ctep.tools.amountIn(ctepsaleresult.authorizedamount))+'€';
          if(visit) {
            amountString+=' '+ctep.tools.lang({'en':'for','nl':'voor','fr':'pour'})+' '+response.contact.name;
          }
          if(visit && ctep.saleVisit!==null && visit.id===ctep.saleVisit.id) {
            ctep.toastr.success(amountString);
          } else {
            ctep.toastr.warning(ctep.tools.lang({
              'en':'Successful previous payment does not match the last payment command.',
              'nl':'Succesvolle vorige betaling komt niet overeen met het laatste betalingscommando.',
              'fr':'Paiement r\u00E9ussi ne correspond pas a la demande de paiement pr\u00E9c\u00E9dente.'
            })+' '+amountString);
          }
        } else {
          errorWording=ctepsaleresult.errorcode+' '+ctepsaleresult.errordescription;
          if(errorWording===' ') {
            ctep.toastr.error(ctep.tools.lang({'en':'Invalid previous payment','nl':'Ongeldige vorige betaling','fr':'Paiement pr\u00E9c\u00E9dent non valable'}));
          } else {
            ctep.toastr.error(errorWording);
          }
        }
      });
    } else {
      if(ctepsaleresult.action==='success') {
        ctep.setstatus('idle');
      } else {
        errorWording=ctepsaleresult.errordescription;
        if(ctepsaleresult.errorcode==='1803') {
          errorWording='Timeout expiration';
        } else if(ctepsaleresult.errorcode==='2629') {
          errorWording='User cancellation';
        } else if(ctepsaleresult.errorcode==='1802') {
          errorWording='Unexpected message, terminal busy';
        } else if(ctepsaleresult.errorcode==='2630') {
          errorWording='Device cancellation';
        }
        ctep.toastr.error(errorWording);
        ctep.setstatus('cancelling',6000);
      }
      ctep.saleDeferred.resolve(response);
    }
  });
};

ctepWrapper.prototype.handleMessageCancelretailerror = function() {
  var ctep=this;
  if(ctep.status==='cancelling') {
    ctep.setstatus('cancelerror');
  }
};
// ctepWrapper.prototype.refresh=function() {
//   var ctep=this;
//   if(!ctep.refreshing) {
//     ctep.refreshing=true;
//     ctep.webservice.call('getServicesAndTerminals',{},ctep.script,ctep).then(function(response) {
//       if(response) {
//         ctep.updateCtepterminals();
//         var promises=[];
//         for(var i in response) {
//           promises.push(ctep.queryCtepServer(response[i].ip));
//         }
//         ctep.$q.all(promises).then(function() {
//           ctep.refreshing=false;
//         });
//       }
//     });
//   }
// };

ctepWrapper.prototype.claimMyTerminal = function() {
  var ctep=this;
  ctep.claimFirstTerminalIsActive=true;
  if(!ctep.refreshing) {
    ctep.refreshing=true;
    ctep.queryCtepServer('outdoorctep').then(function() {
      ctep.refreshing=false;
    });
  }
};

ctepWrapper.prototype.queryCtepServer = function(ip) {
  var ctep=this;
  if(false) { // debug
    ctep.handleMessageCtepterminals('mock',['01234567']);
  } else {
    return ctep.webservice.http('GET',ctep.config.get('ctepHttpProtocol')+'://'+ip+':'+ctep.httpPort+'/running').then((function() {
      return function(response) {
        var result;
        if(response) {
          if(!(ip in ctep.sockets)) {
            var socket=ctep.$websocket(ctep.config.get('ctepWsProtocol')+'://'+ip+':'+ctep.wsPort);
            socket.onClose(function() {
              ctep.delistSocket(ip);
            });
            socket.onMessage(function(message) {
              ctep.webservice.handleResponse('ctep WS',angular.fromJson(message.data),{}).then(function(response) {
                ctep.$log.log('ctep WS resolving '+angular.toJson(response));
                for(var i in response) {
                  var messageHandler='handleMessage'+i.charAt(0).toUpperCase() + i.slice(1);
                  if(angular.isFunction(ctep[messageHandler])) {
                    ctep[messageHandler](ip,response[i]);
                  }
                }
              });
            });
            ctep.sockets[ip]=socket;
          }
          result=true;
        } else {
          result=false;
        }
        return ctep.$q.resolve(result);
      };
    })(),function() {
      return ctep.$q.resolve(false);
    });
  }
};

ctepWrapper.prototype.delistSocket = function(ip) {
  var ctep=this;
  delete ctep.sockets[ip];
  ctep.invalidateServer(ip);
  if(angular.isFunction(ctep.onSocketClose)) {
    ctep.onSocketClose();
  }
};

ctepWrapper.prototype.editCtepterminal = function(ctepterminal) {
  var ctep=this;
  ctep.backupCtepterminals[ctepterminal.id]=ctep.tools.clone(ctepterminal);
  ctepterminal.editing=true;
};

ctepWrapper.prototype.updateCtepterminal = function(ctepterminal) {
  var ctep=this;
  ctep.webservice.call('updateCtepterminal',{'ctepterminal':ctepterminal},ctep.script,ctep).then(function(response) {
    if(response) {
      ctep.updateCtepterminals();
    }
  });
};

ctepWrapper.prototype.cancelCtepterminal = function(ctepterminal) {
  var ctep=this;
  ctep.modelstore.addRecord('ctepterminals',ctep.backupCtepterminals[ctepterminal.id],ctep);
  ctep.updateCtepterminals();
};

// ctepWrapper.prototype.claimCtepterminal = function(ctepterminal) {
//   var ctep=this;
//   ctep.webservice.call('claimCtepterminal',{'id':ctepterminal.id},ctep.script,ctep).then(function(response) {
//     if(response) {
//       ctep.updateCtepterminals();
//     }
//   });
// };

// ctepWrapper.prototype.unclaimCtepterminal = function() {
//   var ctep=this;
//   ctep.webservice.call('unclaimCtepterminal',{},ctep.script,ctep).then(function(response) {
//     if(response) {
//       ctep.updateCtepterminals();
//     }
//   });
// };

ctepWrapper.prototype.invalidateServer = function(ip) {
  var ctep=this;
  ip=ip||ctep.getServerIp();
  for(var i in ctep.availableTerminalidAndIPs) {
    if(ctep.availableTerminalidAndIPs[i].ip===ip) {
      delete ctep.availableTerminalidAndIPs[i];
    }
  }
  ctep.updateCtepterminals();
};

ctepWrapper.prototype.ctepMessage = function(message,params,model) {
  var ctep=this;
  if(angular.isUndefined(model)) {
    model=ctep;
  }
  return ctep.post('/ctepterminals/'+ctep.claimedCtepterminal.terminalid+'/nonces',{}).then(function(response) {
    var result1;
    if(response) {
      params.nonce=response;
      result1=ctep.webservice.call(message,params,ctep.script,model).then(function(response) {
        var result2;
        if(response) {
          result2=ctep.send(response);
        } else {
          result2=ctep.$q.reject();
        }
        return result2;
      });
    } else {
      ctep.invalidateServer();
      result1=ctep.$q.reject();
    }
    return result1;
  },function() {
    ctep.invalidateServer();
    return ctep.$q.reject();
  });
};

ctepWrapper.prototype.startPayment = function(visit,amount,saleModel) {
  var ctep=this;
  if(visit.dvs==ctep.claimedCtepterminal.dvs) {
    ctep.setstatus('paymentStarted');
    return ctep.ctepMessage('signStartPayment',{'visitId':visit.id,'amount':amount,'terminalid':ctep.claimedCtepterminal.terminalid,'printtickets':ctep.claimedCtepterminal.printtickets},saleModel).then(function() {
      ctep.setstatus('paymentStarted');
      ctep.saleVisit=visit;
      ctep.saleModel=saleModel;
      ctep.saleDeferred=ctep.$q.defer();
      return ctep.saleDeferred.promise;
    },function() {
      ctep.setstatus('idle');
      return ctep.$q.reject();
    });
  } else {
    var terminalDvsLabel=ctep.tools.label(ctep.parameters.DVS[ctep.claimedCtepterminal.dvs]);
    var visitDvsLabel=ctep.tools.label(ctep.parameters.DVS[visit.dvs]);
    ctep.errorlog.error(ctep.tools.lang({
      'en':'This card payment terminal should only be used for '+terminalDvsLabel+'. Please redirect the customer to the '+visitDvsLabel+' desk.',
      'nl':'Deze betaalkaart terminal mag enkel gebruikt worden voor '+terminalDvsLabel+'. Gelieve de klant te verwijzen naar het onthaal van '+visitDvsLabel+'.',
      'fr':'Terminal des payments de carte ne peut que etre utilis\u00E9 pour '+terminalDvsLabel+'. Veuillez rediriger le client vers la r\u00E9ception de '+visitDvsLabel+'.'
    }));
    return ctep.$q.reject();
  }
};

ctepWrapper.prototype.cancelPayment = function() {
  var ctep=this;
  ctep.setstatus('cancelling',7000);
  ctep.ctepMessage('signCancelRetailTransaction',{'terminalid':ctep.claimedCtepterminal.terminalid}).then(function() {},function() {
    ctep.setstatus('idle');
  });
};

ctepWrapper.prototype.lastTransaction = function() {
  var ctep=this;
  ctep.verifying=true;
  ctep.ctepMessage('signLastTransactionStatus',{'terminalid':ctep.claimedCtepterminal.terminalid}).then(function() {},function() {
    ctep.verifying=false;
  });
};

ctepWrapper.prototype.setstatus = function(status,time) {
  var ctep=this;
  if(angular.isUndefined(time)) {
    time=45000;
  }
  if(ctep.setstatusPromise!==null) {
    ctep.$timeout.cancel(ctep.setstatusPromise);
    ctep.setstatusPromise=null;
  }
  ctep.status=status;
  if(status!=='idle') {
    ctep.setstatusPromise=ctep.$timeout(function() {
      ctep.setstatus('idle');
    },time);
  }
};

angular.module('app').service('ctep',['$q','$log','$websocket','$timeout','config','modelstore','parameters','webservice','tools','user','errorlog','toastr',ctepWrapper]);

'use strict';
var config = function($window,$log) {
  this.$window=$window;
  this.$log=$log;
  this._isDockerEnv = null; // Cache the detection result
  this.hosts={
    'localhost': {
      'serviceUrl': this.getBackendUrl('/outdoor/src/services/index.php'),
      'imageService': this.getBackendUrl('/outdoor/src/services/templateimage.php'),
      'services': this.getBackendUrl('/outdoor/src/services/'),
      'icon':'logo-lpm.svg',
      'favicon': this.getBackendUrl('/outdoor/src/assets/images/logo.ico'),
      'ctepHttpProtocol':'https',
      'ctepWsProtocol':'wss',
      'showPaymentCompany':true,
      'showQuickSell':true
    },
    'outdoor.lapetitemerveille.be': {
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'services':'https://outdoor.lapetitemerveille.be/services/',
      'icon':'logo-lpm.svg',
      'favicon':'https://outdoor.lapetitemerveille.be/assets/images/logo.ico',
      'ctepHttpProtocol':'https',
      'ctepWsProtocol':'wss',
      'showPaymentCompany':true,
      'showQuickSell':false
    },
    'outdoor.sda.be': {
      'serviceUrl':'https://outdoor.api.sda.be/services/index.php',
      'imageService':'https://outdoor.api.sda.be/services/templateimage.php',
      'services':'https://outdoor.api.sda.be/services/',
      'icon':'logo-lpm.svg',
      'favicon':'https://outdoor.sda.be/assets/images/logo.ico',
      'ctepHttpProtocol':'https',
      'ctepWsProtocol':'wss',
      'showPaymentCompany':true,
      'showQuickSell':false
    }
  };
  this.hostname=null;
  this.host=null;
  this.langs=['en','nl','fr'];
};
config.prototype.get = function(key) {
  var result='';
  if(this.host===null) {
    var hostname=this.getHostname();
    if(hostname in this.hosts) {
      this.host=this.hosts[hostname];
    } else {
      this.$log.log('ERROR: domain <'+hostname+'> is not configured');
    }
  }
  if(this.host!==null) {
    if(key in this.host) {
      result=this.host[key];
    } else {
      this.$log.log('ERROR: key <'+key+'> is not configured for <'+this.getHostname()+'>');
    }
  }
  return result;
};
config.prototype.exists = function(key) {
  var hostname=this.getHostname();
  var host={};
  if(hostname in this.hosts) {
    host=this.hosts[hostname];
  }
  return host.hasOwnProperty(key);
};
config.prototype.getHostname = function() {
  if(this.hostname===null) {
    this.hostname=this.$window.location.hostname;
    if(this.hostname.match(/^www\./)) {
      this.hostname=hostname.substr(4);
    }
  }
  return this.hostname;
};
config.prototype.getBackendUrl = function(path) {
  return this.isDockerEnvironment() ? 'http://localhost:8080' + path : 'http://localhost' + path;
};
config.prototype.isDockerEnvironment = function() {
  if (this._isDockerEnv !== null) {
    return this._isDockerEnv;
  }
  
  // Strategy: Try to detect Docker by making a synchronous head request to the Docker port
  // If it responds, we're in Docker. If it fails, we're in WAMP.
  try {
    var xhr = new XMLHttpRequest();
    xhr.open('HEAD', 'http://localhost:8080/outdoor/src/services/', false); // synchronous, no timeout allowed
    xhr.send();
    this._isDockerEnv = (xhr.status >= 200 && xhr.status < 500); // Any HTTP response means server exists
    this.$log.log('Docker detection: HTTP ' + xhr.status + ' - using Docker backend');
  } catch (e) {
    this._isDockerEnv = false; // Connection failed = no Docker
    this.$log.log('Docker detection failed: ' + e.message + ' - using WAMP backend');
  }
  
  return this._isDockerEnv;
};
angular.module('app').service('config',['$window','$log',config]);

'use strict';

/* Directives */

/*
angular.module("app").directive('jquiDatepicker', ["$parse", function ($parse) {
  return function (scope, element, attrs) {
    var ngModel = $parse(attrs.ngModel);
    $(function(){
      element.datepicker({
        changeYear:true,
        changeMonth:true,
        dateFormat:'yy-mm-dd',
        yearRange: '-0:+1',
        onSelect:function (dateText) {
          scope.$apply(function(scope){
            ngModel.assign(scope, dateText);
          });
        }
      });
    });
  };
}]);

angular.module("app").directive('jquiBirthpicker', ["$parse", function ($parse) {
  return function (scope, element, attrs) {
    var ngModel = $parse(attrs.ngModel);
    $(function(){
      element.datepicker({
        changeYear:true,
        changeMonth:true,
        dateFormat:'yy-mm-dd',
        yearRange: '-18:-4',
        onSelect:function (dateText) {
          scope.$apply(function(scope){
            ngModel.assign(scope, dateText);
          });
        }
      });
    });
  };
}]);
*/

angular.module("app").directive('ngEnter', function() {
  return function(scope, element, attrs) {
    element.bind("keydown keypress", function(event) {
      if (event.which === 13) {
        scope.$apply(function() {
          scope.$eval(attrs.ngEnter);
        });
        event.preventDefault();
      }
    });
  };
});

angular.module("app").directive('ngMailseperator', function() {
  return function(scope, element, attrs) {
    element.bind("keydown keypress", function(event) {
      var mailseperators={13:'Enter',59:';',44:','};
      if (angular.isDefined(mailseperators[event.which])) {
        scope.$apply(function() {
          scope.$eval(attrs.ngMailseperator);
        });
        event.preventDefault();
      }
    });
  };
});

angular.module("app").directive('focusBool',['$timeout', function($timeout) { 
  return function(scope, element, attrs) {
    scope.$watch(attrs.focusBool, function(value) {
      if (value) $timeout(function() {element.focus();});
    });
  }
}]);
/*
angular.module("app").directive('myDownload', function($compile) {
  return {
    restrict : 'E',
    scope : {
      data : '=',
      mime : '=',
      filename : '=',
      label: "="
    },
    link : function(scope, elm, attrs) {
      function getUrl() {
        return URL.createObjectURL(new Blob([ scope.data ], {
          type : scope.mime
        }));
      }
      elm.append($compile(
          '<a class="btn" download="'+scope.filename+'" href="' + getUrl() + '">'
              + scope.label + '</a>')(scope));
      scope.$watch(scope.data, function() {
        elm.children()[0].href = getUrl();
      });
    }
  };
});
*/
angular.module("app").directive('editable',function () {
  return {
    replace: true,
    transclude: true,
    scope: {editing:'@', retrieving:'@'},
    template: '<span><span ng-hide="editing">{{retrieving}}</span><span ng-show="editing" ng-transclude></span></span>'
  };
});

angular.module("app").directive('create',function () {
  return {
    replace: true,
    template: '<button type="button" class="btn btn-default"><span class="glyphicon glyphicon-plus-sign"></span></button>'
  };
});

angular.module("app").directive('retrieve',function () {
  return {
    replace: true,
    template: '<button type="button" class="btn btn-default"><span class="glyphicon glyphicon-search"></span></button>'
  };
});

angular.module("app").directive('update',function () {
  return {
    replace: true,
    template: '<button type="button" class="btn btn-default"><span class="glyphicon glyphicon-ok"></span></button>'
  };
});

angular.module("app").directive('delete',function () {
  return {
    replace: true,
    template: '<button type="button" class="btn btn-delete"><span class="glyphicon glyphicon-trash"></span></button>'
  };
});

angular.module("app").directive('cancel',function () {
  return {
    replace: true,
    template: '<button type="button" class="btn btn-default"><span class="glyphicon glyphicon-remove"></span></button>'
  };
});

angular.module("app").directive('edit',function () {
  return {
    replace: true,
    template: '<button type="button" class="btn btn-default"><span class="glyphicon glyphicon-pencil"></span></button>'
  };
});

angular.module("app").directive('arrowleft',function () {
  return {
    replace: true,
    template: '<button type="button" class="btn btn-default"><span class="glyphicon glyphicon-arrow-left"></span></button>'
  };
});

angular.module("app").directive('arrowright',function () {
  return {
    replace: true,
    template: '<button type="button" class="btn btn-default"><span class="glyphicon glyphicon-arrow-right"></span></button>'
  };
});

angular.module("app").directive('arrowup',function () {
  return {
    replace: true,
    template: '<button type="button" class="btn btn-default"><span class="glyphicon glyphicon-arrow-up"></span></button>'
  };
});

angular.module("app").directive('arrowdown',function () {
  return {
    replace: true,
    template: '<button type="button" class="btn btn-default"><span class="glyphicon glyphicon-arrow-down"></span></button>'
  };
});

angular.module("app").directive('print',function () {
  return {
    replace: true,
    template: '<button type="button" class="btn btn-default"><span class="glyphicon glyphicon-print"></span></button>'
  };
});

angular.module("app").directive('refresh',function () {
  return {
    replace: true,
    template: '<button type="button" class="btn btn-default"><span class="glyphicon glyphicon-refresh"></span></button>'
  };
});

angular.module("app").directive('switch',function () {
  return {
    replace: true,
    template: '<button type="button" class="btn btn-default"><span class="glyphicon glyphicon-random"></span></button>'
  };
});

angular.module("app").directive('download',function () {
  return {
    replace: true,
    scope: {
      title: '@'
    },
    template: '<button type="submit" class="btn btn-default"><span class="glyphicon glyphicon-download-alt"> {{title}} </span></button>'
  };
});

angular.module("app").directive('tooltip', function(){
  return {
    restrict: 'A',
    link: function(scope, element, attrs){
      element.hover(function(){
        // on mouseenter
        element.tooltip('show');
      }, function(){
        // on mouseleave
        element.tooltip('hide');
      });
    }
  };
});

angular.module("app").directive('checkboxAll', function() {
  return {
    scope: true,
    require: 'ngModel',
    link: function(scope,element,attrs,modelCtrl) {
        var childList=attrs.childList;
        var property=attrs.property;
        var onChange=attrs.onChange;
      
      // Bind the onChange event to update children
      element.bind('change', function() {
        scope.$apply(function() {
          var isChecked=element.prop('checked');
          // Set each child's selected property to the checkbox's checked property
          angular.forEach(scope.$eval(childList), function(child) {
            child[property]=isChecked;
            scope.$eval(onChange);
          });
        });
      });
      
      // Watch the children for changes
      scope.$watch(childList, function(newValue) {
        var hasChecked=false;
        var hasUnchecked=false;
        
        // Loop through the children
        angular.forEach(newValue, function(child) {
          if(child[property]) {
            hasChecked=true;
          } else {
            hasUnchecked=true;
          }
        });
        
        // Determine which state to put the checkbox in
        if(hasChecked && hasUnchecked) {
          element.prop('checked', false);
          element.prop('indeterminate', true);
          if(modelCtrl) {
            modelCtrl.$setViewValue(false);
          }
        } else {
          element.prop('checked', hasChecked);
          element.prop('indeterminate', false);
          if (modelCtrl) {
            modelCtrl.$setViewValue(hasChecked);
          }
        }
      }, true);
    }
  };
});

angular.module("app").directive('resize', function($window) {
  return function(scope,element,attrs) {
    var w=angular.element($window);
    w.bind('resize', function() {
      scope.$apply(update);
    });
    update();
    function update() {
      var offsetHeight=attrs.offsetHeight;
      var maxHeight=attrs.maxHeight;
      var maxWidth=attrs.maxWidth;
      var height=w.height();
      var width=w.width();
      scope.windowHeight=height;
      scope.windowWidth=width;
      scope.style=function() {
        return {
          'max-height':Math.min(height-offsetHeight,maxHeight)+'px',
          'max-width':Math.min(width,maxWidth)+'px',
          'inset':offsetHeight+'px auto auto '+(width-Math.min(width,maxWidth))+'px'
        };
      };
    }   
  }
})
'use strict';

angular.module("app").controller("GlobalController",["$scope","$location","$timeout","$sce","$q","$window","$log","$transitions","navTreeService","tools","webservice","parameters","user","config","ctep","visitsService",
                                            function($scope,$location,$timeout,$sce,$q,$window,$log,$transitions,navTreeService,tools,webservice,parameters,user,config,ctep,visitsService) {
  $scope.navTreeService=navTreeService;
  $scope.tools = tools;
  $scope.webservice=webservice;
  $scope.parameters = parameters;
  $scope.user=user;
  $scope.config=config;
  $scope.visitsService=visitsService;

  var model={};
  $scope.model=model;

  tools.initAttributes(model,{
    "searchTerm":""
  });

  $scope.getFavicon = function() {
    return config.exists('favicon')?$sce.trustAsResourceUrl(config.get('favicon')):null;
  };

  $scope.scrollTo = function(elementId) {
    $timeout(function() {
      if(angular.isDefined(elementId)) {
        var element=document.querySelector("#"+elementId);
        if(element) {
          element.scrollIntoView({behavior:"instant",block:"center",inline:"nearest"});
        }
      } else {
        $location.hash(null);
      }
    });
  };

  $scope.buildHref = function(route1,route2,id,page) {
    var href = user.lang+"/"+route1;
    if(angular.isDefined(route2)) {
      href += "/"+route2;
      if(angular.isDefined(id)) {
        href += "/"+id;
        if(angular.isDefined(page)) {
          href += "/"+page;
        }
      }
    }
    return href;
  };

  $scope.setDvs = function(dvs) {
    webservice.call("setDvs",{'dvs':dvs.id},'shared',{}).then(function(response) {
      if(response) {
        user.dvs=dvs.id;
      }
    });
  };

  $scope.setLang = function(lang) {
    webservice.call("setLang",{'lang':lang},'shared',{}).then(function(response) {
      if(response) {
        user.lang=lang;
        var path=$location.path().split("/");
        var href=lang+'/'+path[2];
        if(path.length>=4) {
          href+="/"+path[3];
        }
        if(path.length>=5) {
          href+="/"+path[4];
        }
        tools.redirect(href);
      }
    })
  };

  $scope.visitRetrieve = function(visitId) {
    tools.redirect($scope.buildHref('activities','retrieveForEmp','V'+visitId));
  };

  $scope.contactRetrieve = function(contactId) {
    tools.redirect($scope.buildHref('contacts','retrieve','C'+contactId));
  }

  $scope.showView = function() {
    var path=$location.path().split("/");
    return webservice.loggedIn || (path[2]==="users" && path[3]=="passwordReset");
  };

  $scope.$on('$locationChangeStart',function() {
    var path=$location.path().split("/");
    if(path.length>=2 && ['en','nl','fr'].indexOf(path[1])>-1) {
      user.lang=path[1];
    }
  });

  webservice.afterLogin().then(function() {
    var url=$location.absUrl();
    var questionIndex=url.indexOf("?");
    if(questionIndex>=0) {
      var getParameters={};
      url=url.substr(questionIndex+1);
      var hashbangIndex=url.indexOf("#!/");
      if(hashbangIndex>=0) {
        url=url.substr(0,hashbangIndex);
      }
      var vars=url.split("&");
      var i,pair;
      for(i in vars) {
        pair=vars[i].split("=");
        getParameters[pair[0]] = decodeURIComponent(pair[1]);
      }

      if("code" in getParameters) {
        webservice.call("requestToken",{
          "code":getParameters.code
        },"exact/login",{}).then(function(response) {
          if(response) {
            var url=$location.absUrl();
            $window.location=url.substring(0,Math.min(url.indexOf("?"),url.indexOf("#!/")))+'#!/nl/exact/login';
          }
        });
      }
    }
    ctep.claimMyTerminal();
  });


  // deprecated
  $scope.toggleFilters = function(element) {
    var target = document.getElementById(element);
    target.classList.toggle("is-open");
  };

  $scope.toggleNavtreeSubElements = function(nav1Row) {
    if(!(nav1Row.open)) {
      for(var i in navTreeService.navTree) {
        navTreeService.navTree[i].open=false;
      }
    }
    nav1Row.open=!nav1Row.open;
  }

  $scope.getAvatar = function(name) {
    var result='';
    if(angular.isDefined(name)) {
      result=name.split(' ').reduce(function(acc,cur) {return acc+cur.charAt(0).toUpperCase()},'').substr(0,2);
    }
    return result; 
  };

  $scope.hasView = function(view) {
    var result=false;
    var i,navTreeElement;
    for(i in navTreeService.navTree) {
      navTreeElement=navTreeService.navTree[i];
      result=result || (navTreeElement.view===view && navTreeElement.hidden==='0') || (tools.getLength(navTreeElement.sub)>0 && tools.getLength(tools.match(navTreeElement.sub,{'view':view,'hidden':'0'}))>0);
    }
    return result;
  }

  if(!webservice.loggedIn) {
    webservice.login();
  }

}]);

angular.module("app").controller("NavigationController",["$scope","$state","navTreeService",function($scope,$state,navTreeService) {
  $scope.navTreeService=navTreeService;
  $scope.collapsed={};

  $scope.goToNavTreeElement = function(navTreeElement) {
    var state=$state.get(navTreeElement.state);
    if(navTreeElement.param!=='' && state!==null && angular.isDefined(state.params) && 'lang' in state.params && 'settings' in state.params && $scope.tools.getLength(state.params)===2) {
      state.params.lang=$scope.user.lang;
      state.params.settings=navTreeElement.param.split('&').reduce(function(settings,viewParam) {
        var viewParamKeyAndValue=viewParam.split('=');
        if(viewParamKeyAndValue.length===2) {
          var key=viewParamKeyAndValue[0]
          var value=viewParamKeyAndValue[1];
          if(state.settings[key].type==='paramArray') {
            try {
              value=angular.fromJson(value);
            } catch(e) {
              value=null;
            }
            if(!angular.isArray(value) || $scope.tools.getLength(value)===0) {
              value=null;
            }
          }
          if(value!==null) {
            settings[key]=value;
          }
        }
        return settings;
      },{});
      $state.go(navTreeElement.state,state.params);
    } else {
      $scope.tools.redirect($scope.buildHref(navTreeElement.view));
    }
  }
}]);

angular.module("app").controller("ErrorController",["$scope","errorlog",function($scope,errorlog) {
  $scope.errors=errorlog.errors;
}]);

angular.module("app").controller("LoginController",["$scope","$location","user","webservice","tools",function($scope,$location,user,webservice,tools) {

  var model={};
  $scope.model=model;

  $scope.login = function() {
    model.calling=true;
    webservice.login(model.email,model.password,model.remember).then(function() {
      var newPath=user.lang+'/home';
      if($location.path===newPath) {
        tools.redirect(newPath);
      }
      model.calling=false;
    }).catch(function() {
      model.email="";
      model.password="";
      model.remember=false;
      model.calling=false;
    });
  };

  $scope.emailToken = function() {
    if(model.forgotEmail!=="") {
      webservice.call("emailToken",{"email":model.forgotEmail},"forgot",model).then(function(response) {
        if(response) {
          model.confirmForgot=true;
        }
      });
    }
  };

  tools.initAttributes(model,{
    "email":"",
    "password":"",
    "remember":false,
    "forgot":false,
    "forgotEmail":"",
    "confirmForgot":false,
    "calling":false,
  });

}]);

angular.module("app").controller("ConfirmModalController",["$scope","$uibModalInstance","wording","okWording","cancelWording",function($scope,$uibModalInstance,wording,okWording,cancelWording) {

  $scope.wording=wording;
  $scope.okWording=okWording;
  $scope.cancelWording=cancelWording;

  $scope.ok = function() {
    $uibModalInstance.close();
  };

  $scope.cancel = function() {
    $uibModalInstance.dismiss();
  };

}]);

angular.module("app").controller("EmailboxModalController",["$scope","$uibModalInstance","fromMailOptions","recipient","subject","attachment","body",
                                                  function($scope,$uibModalInstance,fromMailOptions,recipient,subject,attachment,body) {

  $scope.fromMailOptions=fromMailOptions;
  $scope.fromMail=fromMailOptions[0];
  $scope.recipient=recipient;
  $scope.subject=subject;
  $scope.attachment=attachment;
  $scope.body=body;

  $scope.ok = function() {
    $uibModalInstance.close({
      'fromMail':$scope.fromMail,
      'recipient':$scope.recipient,
      'subject':$scope.subject,
      'attachment':$scope.attachment,
      'body':$scope.body
    });
  };

  $scope.cancel = function() {
    $uibModalInstance.dismiss();
  };

}]);

angular.module("app").controller("EmailboxHybridModalController",["$scope","$uibModalInstance","fromMailOptions","recipient","subject","attachment","textBody","htmlBody",
                                                  function($scope,$uibModalInstance,fromMailOptions,recipient,subject,attachment,textBody,htmlBody) {

  $scope.fromMailOptions=fromMailOptions;
  $scope.fromMail=fromMailOptions[0];
  $scope.recipient=recipient;
  $scope.subject=subject;
  $scope.attachment=attachment;
  $scope.textBody=textBody;
  $scope.htmlBody=htmlBody;

  $scope.ok = function() {
    $uibModalInstance.close({
      'fromMail':$scope.fromMail,
      'recipient':$scope.recipient,
      'subject':$scope.subject,
      'attachment':$scope.attachment,
      'textBody':$scope.textBody,
      'htmlBody':$scope.htmlBody
    });
  };

  $scope.cancel = function() {
    $uibModalInstance.dismiss();
  };

}]);

angular.module("app").controller("QuotationnoteModalController",["$scope","$uibModalInstance","visit","quotationnote",
                                                  function($scope,$uibModalInstance,visit,quotationnote) {
  $scope.visit=visit;
  $scope.quotationnote=quotationnote;

  $scope.ok = function() {
    $uibModalInstance.close($scope.quotationnote);
  };

  $scope.cancel = function() {
    $uibModalInstance.dismiss();
  };

}]);

angular.module("app").controller("PacketModalController",["$scope","tools","parameters","$uibModalInstance","visit",
                                                  function($scope,tools,parameters,$uibModalInstance,visit) {
  $scope.parameters=parameters;
  $scope.tools=tools;
  $scope.model={
    'visit':visit
  };
  $scope.participantcount="1";
  $scope.startdate=$scope.model.visit.startdate;
  $scope.startdateOptions={
    'maxDate': new Date(2099,11,31),
    'minDate': new Date(),
    'startingDay': 1
  };

  if(parameters.VIS[visit.vis].field1=='1') {
    $scope.packets=tools.match(parameters.packets,{'company':'1'});
  } else {
    $scope.packets=tools.match(parameters.packets,{'private':'1'});
  }

  $scope.getPacketcomponents = function(packet) {
    return tools.join(packet,'packetcomponents',parameters);
  }

  for(var i in $scope.packets) {
    var packet=$scope.packets[i];
    var packetcomponents=$scope.getPacketcomponents(packet);
    if(tools.getLength(tools.exclude(packetcomponents,{'param2':'VOU'}))==0 && tools.getLength(tools.match(packetcomponents,{'param2':'VOU'}))==1) {
      packet.voucherValue=packetcomponents[0].attr1
    } else {
      packet.voucherValue=false;
    }
  }

  $scope.select = function(packet) {
    $uibModalInstance.close({'packet':packet,'participantcount':$scope.participantcount,'startdate':$scope.startdate});
  }

  $scope.cancel = function() {
    $uibModalInstance.dismiss();
  };

}]);

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/modules/accounting/achievements.html","<div ng-controller=AccountingAchievementsController class=\"page page-accounting-achievements page--tables\"><aside id=filters class=\"page__sidebar sidebar\"><div class=sidebar__header><h4 class=title>{{tools.lang({\'en\': \'Filters\', \'nl\': \'Filters\', \'fr\': \'Filtres\'})}}</h4><button class=\"btn btn-default btn-rounded\"><span class=material-icons ng-click=\"toggleFilters(\'filters\')\">close</span></button></div><div class=sidebar__content><form class=form-horizontal><div class=\"form-group clearfix\"><label class=\"col-xs-2 control-label\">{{tools.lang({\'en\':\'Group by\',\'nl\':\'Groepeer per\',\'fr\':\'Grouper par\'})}}</label><div class=col-xs-4><select class=form-control ng-model=model.groupDateMode ng-change=setDateOptions() ng-options=\"groupDateMode.id as tools.label(groupDateMode) for groupDateMode in groupDateModes\"></select></div></div><div class=\"form-group clearfix\"><label class=\"col-xs-2 control-label\" ng-click=\"model.startdateOpened=!model.startdateOpened\">{{tools.lang({\'en\':\'From\',\'nl\':\'Vanaf\',\'fr\':\'De\'})}}</label><div class=col-xs-4><p class=input-group><span class=input-group-btn uib-datepicker-popup ng-model=model.startdate is-open=model.startdateOpened datepicker-options=model.dateOptions ng-change=cleanDate(dateParams.startdate)><button type=button class=\"btn btn-default\" ng-click=\"model.startdateOpened=!model.startdateOpened\"><i class=\"glyphicon glyphicon-calendar\"></i></button> </span><input type=text class=form-control ng-model=model.cleanStartdate ng-update=model.cleanDateToDate(dateParams.startdate) ng-click=\"model.startdateOpened=!model.startdateOpened\"></p></div></div><div class=\"form-group clearfix\"><label class=\"col-xs-2 control-label\" ng-click=\"model.enddateOpened=!model.enddateOpened\">{{tools.lang({\'en\':\'To\',\'nl\':\'Tot\',\'fr\':\'À\'})}}</label><div class=col-xs-4><p class=input-group><span class=input-group-btn uib-datepicker-popup ng-model=model.enddate is-open=model.enddateOpened datepicker-options=model.dateOptions ng-change=cleanDate(dateParams.enddate)><button type=button class=\"btn btn-default\" ng-click=\"model.enddateOpened=!model.enddateOpened\"><i class=\"glyphicon glyphicon-calendar\"></i></button> </span><input type=text class=form-control ng-model=model.cleanEnddate ng-update=model.cleanDateToDate(dateParams.enddate) ng-click=\"model.enddateOpened=!model.enddateOpened\"></p></div></div><div ng-show=model.showGraphDates><div class=\"form-group clearfix\"><label class=\"col-xs-2 control-label\" ng-click=\"model.graphStartdateOpened=!model.graphStartdateOpened\">{{tools.lang({\'en\':\'Graph from\',\'nl\':\'Grafiek vanaf\',\'fr\':\'Graph de\'})}}</label><div class=col-xs-4><p class=input-group><input type=text autocomplete=off class=form-control uib-datepicker-popup ng-model=model.graphStartdate is-open=model.graphStartdateOpened datepicker-options=model.dateOptions ng-click=\"model.graphStartdateOpened=!model.graphStartdateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.graphStartdateOpened=!model.graphStartdateOpened\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=form-group><label class=\"col-xs-2 control-label\" ng-click=\"model.graphEnddateOpened=!model.graphEnddateOpened\">{{tools.lang({\'en\':\'Graph to\',\'nl\':\'Grafiek tot\',\'fr\':\'Graph à\'})}}</label><div class=col-xs-4><p class=input-group><input type=text autocomplete=off class=form-control uib-datepicker-popup ng-model=model.graphEnddate is-open=model.graphEnddateOpened datepicker-options=model.dateOptions ng-click=\"model.graphEnddateOpened=!model.graphEnddateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.graphEnddateOpened=!model.graphEnddateOpened\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div><div class=\"form-group clearfix\"><label class=\"col-xs-2 control-label\" ng-click=\"model.createdBeforeOpened=!model.createdBeforeOpened\">{{tools.lang({\'en\':\'Created before\',\'nl\':\'Aangemaakt voor\',\'fr\':\'Cr\\u00E9\\u00E9 avant\'})}}</label><div class=col-xs-4><p class=input-group><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.createdBeforeOpened=!model.createdBeforeOpened\"><i class=\"glyphicon glyphicon-calendar\"></i></button> </span><input type=text class=form-control uib-datepicker-popup ng-model=model.createdBefore ng-click=\"model.createdBeforeOpened=!model.createdBeforeOpened\" is-open=model.createdBeforeOpened datepicker-options=model.dateOptions></p></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-12 control-label\"><span>{{tools.lang({\'en\':\'Division\',\'nl\':\'Afdeling\',\'fr\':\'Division\'})}}</span></label><div class=col-sm-12><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"dvs in parameters.notDelArrayDVS | orderBy:\'short\'+user.lang\" ng-click=selectDvs(dvs.id) ng-class=\"{\'active\':model.dvss.indexOf(dvs.id)>=0}\">{{tools.short(dvs)}}</button></div></div></div><div class=\"form-group clearfix\"><label class=\"col-xs-2 control-label\" ng-click=\"model.graphStartdateOpened=!model.graphStartdateOpened\">{{tools.lang({\'en\':\'Compare\',\'nl\':\'Vergelijk\',\'fr\':\'Comparer\'})}}</label><div class=col-xs-10><p class=input-group><input type=text autocomplete=off class=form-control ng-model=model.diff> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=selectDays(); ng-class=\"{\'active\':model.daysOrWeeks==\'days\'}\">{{tools.lang({\'en\':\'Days\',\'nl\':\'Dagen\',\'fr\':\'Jours\'})}}</button> <button type=button class=\"btn btn-default\" ng-click=selectWeeks(); ng-class=\"{\'active\':model.daysOrWeeks==\'weeks\'}\">{{tools.lang({\'en\':\'Weeks\',\'nl\':\'Weken\',\'fr\':\'Semaines\'})}}</button></span></p></div></div><div class=\"form-group clearfix\"><div class=col-xs-2><div class=checkbox><label><input type=checkbox ng-model=model.showGraphDates> {{tools.lang({\'en\':\'Graphs longer then 31 days\',\'nl\':\'Grafieken langer dan 31 dagen\',\'fr\':\'Graphs plus que 31 jours\'})}}</label></div></div><div class=col-xs-2><div class=checkbox><label><input type=checkbox ng-model=model.showUnpaid> {{tools.lang({\'en\':\'Add missed reservations\',\'nl\':\'Voeg gemiste reservaties toe\',\'fr\':\'Ajouter les r\\u00E9servations manqu\\u00E9es\'})}} <i class=\"glyphicon glyphicon-info-sign\" tooltip-placement=bottom tooltip-popup-delay=250 tooltip-class=info tooltip-append-to-body=true uib-tooltip=\"{{tools.lang({\n                      \'en\':\'When checking this option all past unpaid reservations are added. With this option you can see what could be the added value for that day if all previous made reservations will be paid. This is only applicable for visits in the past (visit enddate before today). For visits in the future, the unpaid reservations are counted in the results.\',\n                      \'nl\':\'Door deze keuze aan te vinken voegt je alle gemaakte reservaties in het verleden toe. Met deze optie kan je zien wat de toegevoegde waarde is voor die dag als alle gemaakte reservaties zouden betaald worden. Dit is enkel toepasbaar voor bezoeken in het verleden (bezoek einddatum voor vandaag). Voor bezoeken in de toekomst worden de onbetaalde reservaties altijd toegevoegd.\',\n                      \'fr\':\'Lorsque vous cochez cette option, toutes les r\\u00E9servations pass\\u00E9es non pay\\u00E9es sont ajout\\u00E9es. Cette option vous permet de voir quelle serait la valeur ajout\\u00E9e pour ce jour si toutes les r\\u00E9servations pr\\u00E9c\\u00E9dentes \\u00E9taient pay\\u00E9es. Cette option ne s\\u0027applique qu\\u0027aux visites pass\\u00E9es (date de fin de visite ant\\u00E9rieure \\u00E0 aujourd\\u0027hui). Pour les visites futures, les r\\u00E9servations non pay\\u00E9es sont prises en compte dans les r\\u00E9sultats.\'})}}\"></i></label></div></div><div class=col-xs-2><div class=checkbox><label><input type=checkbox ng-model=model.vatIncluded> {{tools.lang({\'en\':\'VAT included\',\'nl\':\'Inclusief BTW\',\'fr\':\'TVA Inclus\'})}}</label></div></div><div class=col-xs-2><div class=checkbox><label><input type=checkbox ng-model=model.showOnlyB2B> {{tools.lang({\'en\':\'Show only B2B\',\'nl\':\'Toon enkel B2B\',\'fr\':\'Montrer uniquement B2B\'})}}</label></div></div></div></form></div><div class=sidebar__footer><button type=submit class=\"btn btn-primary\" ng-click=\"load(); toggleFilters(\'filters\');\">{{tools.lang({\'en\': \'Done\', \'nl\': \'Done\', \'fr\': \'Appliquer\'})}}</button></div></aside><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\': \'Accounting achievements\', \'nl\': \'Accounting achievements\', \'fr\': \'Accounting achievements\'})}}</h1><div class=header__actions><button class=\"btn btn-default btn-filters\" ng-click=\"toggleFilters(\'filters\')\"><i class=material-icons>filter_list</i> <span class=\"btn__text hidden-xs hidden-sm\">{{tools.lang({ \'en\': \'Filters\', \'nl\': \'Filters\', \'fr\': \'Filtres\' })}}</span></button></div></section><div class=content><div class=\"content__item c-table-view\" ng-hide=model.calling><div class=c-table-view__item><div class=c-table-view__item__content><h4 class=c-table-view__title>{{tools.lang({\'en\':\'Achievements\',\'nl\':\'Prestaties\',\'fr\':\'Prestations\'})}}&nbsp;<form action={{model.action}} name=achievements autocomplete=off method=post target=_blank><input type=hidden name=params value={{getAchievementsWsParams()}}> <input download></form></h4><p>{{tools.lang({\'en\':\'Sorted by planning.\',\'nl\':\'Gesorteerd volgens de planning.\',\'fr\':\'Tri\\u00E9s par planning.\'})}}</p><div class=table-responsive-wrapper><table class=\"table table-striped\"><thead><tr><th class=\"table__col col--sticky\"><span class=th__content>{{tools.lang({\'en\':\'Date\',\'nl\':\'Datum\',\'fr\':\'Date\'})}}</span></th><th><span class=\"th__content text-right\">{{tools.lang({\'en\':\'Total\',\'nl\':\'Total\',\'fr\':\'Total\'})}}</span></th><th ng-repeat=\"itm in model.planningItms\"><span class=\"th__content text-right\">{{itm}}</span></th></tr></thead><tbody><tr ng-repeat=\"line in model.achievementsLines | orderBy:\'date\'\"><td class=\"table__col col--sticky\">{{line.date}}</td><td class=text-right>{{tools.financialAmountOut(line.achievementTotal)}}€</td><td ng-repeat=\"itm in model.planningItms\" class=text-right>{{tools.financialAmountOut(line.achievements[itm])}}€</td></tr><tr><td class=\"table__col col--sticky\"></td><td class=text-right><b>{{tools.financialAmountOut(model.achievementsLinesTotal.achievementTotal)}}€</b></td><td ng-repeat=\"itm in model.planningItms\" class=text-right><b>{{tools.financialAmountOut(model.achievementsLinesTotal.achievements[itm])}}€</b></td></tr></tbody></table></div></div><div class=c-table-view__item__content><h4 class=c-table-view__title>{{tools.lang({\'en\':\'Participants times activities\',\'nl\':\'Deelnemers maal activiteiten\',\'fr\':\'Participants fois activit\\u00E9s\'})}}</h4><p>{{tools.lang({\'en\':\'Sorted by planning. A participant who does two activities is counted twice.\',\'nl\':\'Gesorteerd volgens de planning. Een deelnemer die twee activiteiten doet telt dubbel.\',\'fr\':\'Tri\\u00E9s par planning. Un participant qui fait deux activit\\u00E9s compte deux fois.\'})}}</p><div class=table-responsive-wrapper><table class=\"table table-striped\"><thead><tr><th class=\"table__col col--sticky\"><span class=th__content>{{tools.lang({\'en\':\'Date\',\'nl\':\'Datum\',\'fr\':\'Date\'})}}</span></th><th ng-repeat=\"itm in model.participantItms\"><span class=th__content>{{itm}}</span></th></tr></thead><tbody><tr ng-repeat=\"line in model.achievementsLines | orderBy:\'date\'\"><td class=\"table__col col--sticky\">{{line.date}}</td><td ng-repeat=\"itm in model.participantItms\">{{tools.coalesce(line.participants[itm],\'0\')}}</td></tr><tr><td class=\"table__col col--sticky\"></td><td ng-repeat=\"itm in model.participantItms\"><b>{{tools.coalesce(model.achievementsLinesTotal.participants[itm],\'0\')}}</b></td></tr></tbody></table></div></div><div class=c-table-view__item__content ng-show=\"tools.getLength(parameters.notDelArrayHTL)>0\"><h4 class=c-table-view__title>{{tools.lang({\'en\':\'Rooms par hotel\',\'nl\':\'Kamers per hotel\',\'fr\':\'Chambres par h\\u00E9bergement\'})}}</h4><p>{{tools.lang({\'en\':\'Arrivals and staying rooms.\',\'nl\':\'Aankomsten en overnachtende kamers\',\'fr\':\'Arriv\\u00E9e et recouches\'})}}</p><div class=table-responsive-wrapper><table class=\"table table-striped\"><thead><tr><th class=\"table__col col--sticky\"><span class=th__content>{{tools.lang({\'en\':\'Date\',\'nl\':\'Datum\',\'fr\':\'Date\'})}}</span></th><th ng-repeat=\"itm in model.hotelItms\"><span class=th__content>{{itm}}</span></th></tr></thead><tbody><tr ng-repeat=\"line in model.achievementsLines | orderBy:\'date\'\"><td class=\"table__col col--sticky\">{{line.date}}</td><td ng-repeat=\"itm in model.hotelItms\">{{tools.coalesce(line.rooms[itm],\'0\')}}</td></tr><tr><td class=\"table__col col--sticky\"></td><td ng-repeat=\"itm in model.hotelItms\"><b>{{tools.coalesce(model.achievementsLinesTotal.rooms[itm],\'0\')}}</b></td></tr></tbody></table></div></div><div class=c-table-view__item__content><h4 class=c-table-view__title>{{tools.lang({\'en\':\'Dishes par restaurant\',\'nl\':\'Gerechten per restaurant\',\'fr\':\'Couverts par restaurant\'})}}</h4><p>{{tools.lang({\'en\':\'Sorted by planning.\',\'nl\':\'Gesorteerd volgens de planning.\',\'fr\':\'Tri\\u00E9s par planning.\'})}}</p><div class=table-responsive-wrapper><table class=\"table table-striped\"><thead><tr><th class=\"table__col col--sticky\"><span class=th__content>{{tools.lang({\'en\':\'Date\',\'nl\':\'Datum\',\'fr\':\'Date\'})}}</span></th><th ng-repeat=\"itm in model.restaurantItms\"><span class=th__content>{{itm}}</span></th></tr></thead><tbody><tr ng-repeat=\"line in model.achievementsLines | orderBy:\'date\'\"><td class=\"table__col col--sticky\">{{line.date}}</td><td ng-repeat=\"itm in model.restaurantItms\">{{tools.coalesce(line.participants[itm],\'0\')}}</td></tr><tr><td class=\"table__col col--sticky\"></td><td ng-repeat=\"itm in model.restaurantItms\"><b>{{tools.coalesce(model.achievementsLinesTotal.participants[itm],\'0\')}}</b></td></tr></tbody></table></div></div><div class=c-table-view__item__content><h4 class=c-table-view__title>{{tools.lang({\'en\':\'Income\',\'nl\':\'Inkomsten\',\'fr\':\'Revenu\'})}}</h4><p>{{tools.lang({\'en\':\'Sorted by day of the invoice.\',\'nl\':\'Gesorteerd volgens factuurdatum.\',\'fr\':\'Tri\\u00E9s par jour de la facture.\'})}}</p><div class=table-responsive-wrapper><table class=\"table table-striped\"><thead><tr><th class=\"table__col col--sticky\"><span class=th__content>{{tools.lang({\'en\':\'Date\',\'nl\':\'Datum\',\'fr\':\'Date\'})}}</span></th><th><span class=\"th__content text-right\">{{tools.lang({\'en\':\'Total\',\'nl\':\'Total\',\'fr\':\'Total\'})}}</span></th><th ng-repeat=\"itm in model.incomeItms\"><span class=\"th__content text-right\">{{itm}}</span></th></tr></thead><tbody><tr ng-repeat=\"line in model.incomeLines | orderBy:\'date\'\"><td class=\"table__col col--sticky\">{{line.date}}</td><td class=text-right>{{tools.financialAmountOut(line.incomeTotal)}}€</td><td ng-repeat=\"itm in model.incomeItms\" class=text-right>{{tools.financialAmountOut(line.incomes[itm])}}€</td></tr><tr><td class=\"table__col col--sticky\"></td><td class=text-right><b>{{tools.financialAmountOut(model.incomeLinesTotal.incomeTotal)}}€</b></td><td ng-repeat=\"itm in model.incomeItms\" class=text-right><b>{{tools.financialAmountOut(model.incomeLinesTotal.incomes[itm])}}€</b></td></tr></tbody></table></div></div></div></div><div class=\"content__item c-chart-view\" ng-hide=model.calling><div class=row><div class=col-sm-12><div class=\"panel panel-default\"><div class=panel-body><canvas class=\"chart chart-bar\" chart-data=model.achievementData chart-labels=model.achievementLabels></canvas></div></div></div><div class=col-sm-6><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>Omzet per uitgaven deelnemer</h3></div><div class=panel-body><canvas class=\"chart chart-bar\" chart-data=model.budgetData chart-labels=model.budgetLabels></canvas></div><div class=panel-footer><div>x-as: uitgaven per deelnemer (euro)<br>y-as: omzet (euro)</div></div></div></div><div class=col-sm-6><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>Omzet per grootte van de groep</h3></div><div class=panel-body><canvas class=\"chart chart-bar\" chart-data=model.groupData chart-labels=model.groupLabels></canvas></div><div class=panel-footer><div>x-as: grootte van de groep (personen)<br>y-as: omzet (euro)</div></div></div></div><div class=col-sm-6><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>Omzet per verkoopskanaal</h3></div><div class=panel-body><canvas class=\"chart chart-bar\" chart-data=model.channelData chart-labels=model.channelLabels></canvas></div><div class=panel-footer><div>x-as: verkoopskanaal<br>y-as: omzet (euro)</div></div></div></div><div class=col-sm-6><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>Talen</h3></div><div class=panel-body><canvas class=\"chart chart-horizontal-bar\" chart-labels=model.languageLabels chart-series=model.languageSeries chart-data=model.languageData chart-options=model.languageOptions></canvas></div><div class=panel-footer><div>English - Nederlands - Francais<br>Gewogen met de omzet</div></div></div></div></div></div><div class=\"content__item page__loader\" ng-show=model.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div></div></main></div>");
$templateCache.put("app/modules/accounting/balances.html","<div ng-controller=AccountingBalancesController class=\"page page-accounting-balances page--tables\"><aside id=filters class=\"page__sidebar sidebar\"><div class=sidebar__header><h4 class=title>{{tools.lang({\'en\': \'Filters\', \'nl\': \'Filters\', \'fr\': \'Filtres\'})}}</h4><button class=\"btn btn-default btn-rounded\"><span class=material-icons ng-click=\"toggleFilters(\'filters\')\">close</span></button></div><div class=sidebar__content><div ng-include=\"\'app/modules/accounting/retrieveAccountForm.html\'\"></div></div><div class=sidebar__footer><button type=submit class=\"btn btn-primary\" ng-click=\"load(); toggleFilters(\'filters\');\">{{tools.lang({\'en\': \'Done\', \'nl\': \'Done\', \'fr\': \'Appliquer\'})}}</button></div></aside><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\': \'Balances\', \'nl\': \'Balances\', \'fr\': \'Balances\'})}}</h1><div class=header__actions><button class=\"btn btn-default btn-filters\" ng-click=\"toggleFilters(\'filters\')\"><i class=material-icons>filter_list</i> <span class=\"btn__text hidden-xs hidden-sm\">{{tools.lang({ \'en\': \'Filters\', \'nl\': \'Filters\', \'fr\': \'Filtres\' })}}</span></button></div></section><div class=content><div class=\"content__item c-table-view\" ng-hide=webservice.calling><div class=c-table-view__item><div ng-include=\"\'app/modules/accounting/retrieveAccount.html\'\"></div></div></div><div class=\"content__item page__loader\" ng-show=webservice.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div></div></main></div>");
$templateCache.put("app/modules/accounting/cashManagement.html","<div ng-controller=AccountingCashManagementController class=\"page page-accounting-cash-anagement page--tables\"><aside id=filters class=\"page__sidebar sidebar\"><div class=sidebar__header><h4 class=title>{{tools.lang({\'en\': \'Filters\', \'nl\': \'Filters\', \'fr\': \'Filtres\'})}}</h4><button class=\"btn btn-default btn-rounded\"><span class=material-icons ng-click=\"toggleFilters(\'filters\')\">close</span></button></div><div class=sidebar__content><form class=form-horizontal><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Type\',\'nl\':\'Type\',\'fr\':\'Type\'})}}</label><div class=col-sm-10><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"acc in parameters.notDelArrayACC | orderBy:\'id\'\" ng-class=\"{\'active\':model.accounttype==acc.id}\" ng-click=\"model.accounttype=acc.id;model.accountId=tools.first(tools.match(model.accounts,{\'accounttype\':acc.id})).id;\">{{tools.label(acc)}}</button></div></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Account\',\'nl\':\'Rekening\',\'fr\':\'Compte\'})}}</label><div class=col-sm-10><select class=form-control ng-model=model.accountId ng-options=\"account.id as account.name+\' \'+tools.amountOut(account.balanceAmount)+\'\\u20AC\' for account in tools.match(model.accounts,{\'accounttype\':model.accounttype}) | orderBy:[\'-balanceAmount\',\'name\']\"></select></div></div></form><div ng-include=\"\'app/modules/accounting/retrieveAccountForm.html\'\"></div></div><div class=sidebar__footer><button type=submit class=\"btn btn-primary\" ng-click=\"load(); toggleFilters(\'filters\');\">{{tools.lang({\'en\': \'Done\', \'nl\': \'Done\', \'fr\': \'Appliquer\'})}}</button></div></aside><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\': \'Cash management\', \'nl\': \'Cash management\', \'fr\': \'Cash management\'})}}</h1><div class=header__actions><button class=\"btn btn-default btn-filters\" ng-click=\"toggleFilters(\'filters\')\"><i class=material-icons>filter_list</i> <span class=\"btn__text hidden-xs hidden-sm\">{{tools.lang({ \'en\': \'Filters\', \'nl\': \'Filters\', \'fr\': \'Filtres\' })}}</span></button></div></section><div class=content><div class=\"content__item c-table-view\" ng-hide=webservice.calling><div class=c-table-view__item ng-show=\"model.account!=null && model.account.id==model.accountId\"><form class=\"form-horizontal border-bottom pb-4 mb-4\"><div class=\"form-group clearfix\"><label class=\"col-sm-3 control-label\">{{tools.lang({\'en\':\'Amount\',\'nl\':\'Bedrag\',\'fr\':\'Montant\'})}}</label><div class=col-sm-9><input class=form-control type=text ng-model=model.amount></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-3 control-label\">{{tools.lang({\'en\':\'Creditor\',\'nl\':\'Creditor\',\'fr\':\'Crediteur\'})}}</label><div class=col-sm-9><div class=btn-group><button type=button class=\"btn btn-default\" ng-click=\"model.creditor=\'USR\'\" ng-class=\"{\'active\':model.creditor==\'USR\'}\">{{user.name}}</button> <button type=button class=\"btn btn-default\" ng-click=\"model.creditor=\'BNK\'\" ng-class=\"{\'active\':model.creditor==\'BNK\'}\">{{tools.lang({\'en\':\'Bank\',\'nl\':\'Bank\',\'fr\':\'Banque\'})}}</button></div></div></div><div class=\"form-group clearfix\"><div class=\"col-sm-offset-3 col-sm-9\"><span ng-hide=webservice.calling><button type=submit class=\"btn btn-primary\" ng-click=collect();>{{tools.lang({\'en\':\'Collect\',\'nl\':\'Innen\',\'fr\':\'Encaisser\'})}}</button> </span><span ng-show=webservice.calling>calling...</span></div></div></form><div ng-include=\"\'app/modules/accounting/retrieveAccount.html\'\"></div></div></div><div class=\"content__item page__loader\" ng-show=webservice.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div></div></main></div>");
$templateCache.put("app/modules/accounting/consolidation.html","<div ng-controller=AccountingConsolidationController class=\"page page-accounting-consolidation page--tables\"><aside id=filters class=\"page__sidebar sidebar\"><div class=sidebar__header><h4 class=title>{{tools.lang({\'en\': \'Filters\', \'nl\': \'Filters\', \'fr\': \'Filtres\'})}}</h4><button class=\"btn btn-default btn-rounded\"><span class=material-icons ng-click=\"toggleFilters(\'filters\')\">close</span></button></div><div class=sidebar__content><form class=form-horizontal class=form-horizontal><div class=\"form-group clearfix\"><label class=\"col-xs-12 col-sm-2 control-label\">{{tools.lang({\'en\':\'From\',\'nl\':\'Vanaf\',\'fr\':\'De\'})}}</label><div class=inline-flex><input type=text autocomplete=off class=form-control ng-model=model.startyear> <input type=text autocomplete=off class=form-control ng-model=model.startperiod></div></div><div class=form-group><label class=control-label ng-click=\"model.enddateOpened=!model.enddateOpened\">{{tools.lang({\'en\':\'To\',\'nl\':\'Tot\',\'fr\':\'À\'})}}</label><div class=inline-flex><input type=text autocomplete=off class=form-control ng-model=model.endyear> <input type=text autocomplete=off class=form-control ng-model=model.endperiod></div></div><div class=\"form-group clearfix\"><div class=\"col-xs-12 col-sm-2\"><div class=checkbox><label><input type=checkbox ng-model=model.compare ng-change=load(); ng-false-value=\"\'0\'\" ng-true-value=\"\'1\'\"> {{tools.lang({\'en\':\'Compare\',\'nl\':\'Vergelijk\',\'fr\':\'Comparer\'})}}</label></div></div></div><div class=form-group><div class=\"col-xs-6 col-sm-5\" ng-show=\"model.compare==\'1\'\"><input type=text autocomplete=off class=form-control ng-model=model.comparemonths></div></div><div class=form-group ng-show=\"model.compare==\'1\'\"><div class=\"col-xs-12 col-sm-5\"><div class=btn-group><button type=button class=\"btn btn-default\" ng-click=\"model.compareMode=\'side\';structureData();\" ng-class=\"{\'active\':model.compareMode==\'side\'}\">{{tools.lang({\'en\':\'Both\',\'nl\':\'Beide\',\'fr\':\'Deux\'})}}</button> <button type=button class=\"btn btn-default\" ng-click=\"model.compareMode=\'diff\';structureData();\" ng-class=\"{\'active\':model.compareMode==\'diff\'}\">{{tools.lang({\'en\':\'Difference\',\'nl\':\'Verschil\',\'fr\':\'Difference\'})}}</button> <button type=button class=\"btn btn-default\" ng-click=\"model.compareMode=\'ratio\';structureData();\" ng-class=\"{\'active\':model.compareMode==\'ratio\'}\">{{tools.lang({\'en\':\'Ratio\',\'nl\':\'Verhouding\',\'fr\':\'Rapport\'})}}</button></div></div></div><div class=\"form-group clearfix\"><label class=\"col-xs-12 col-sm-2 control-label\">{{tools.lang({\'en\':\'Report\',\'nl\':\'Rapport\',\'fr\':\'Rapport\'})}}</label><div class=col-sm-10><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"rpt in parameters.notDelArrayRPT\" ng-click=\"model.rpt=rpt.id;\" ng-class=\"{\'active\':model.rpt==rpt.id}\">{{tools.label(rpt)}}</button></div></div></div><div class=\"form-group clearfix\"><label class=\"col-xs-2 control-label\">{{tools.lang({\'en\':\'Filter\',\'nl\':\'Filter\',\'fr\':\'Filtrer\'})}}</label><div class=col-xs-10><div class=\"btn-group mb-2\"><button type=button class=\"btn btn-default\" ng-repeat=\"level2FilterOption in model.level2FilterOptions | orderBy:\'sort\'\" ng-click=changeLevel2FilterOption(level2FilterOption);structureData(); ng-class=\"{\'active text-left\':level2FilterOption.state}\"><span class=\"material-icons color-primary\" ng-show=level2FilterOption.state>close</span> <span class=btn__tex>{{level2FilterOption.label}}</span></button></div><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"level1FilterOption in model.level1FilterOptions | orderBy:\'sort\'\" ng-click=\"level1FilterOption.state=!level1FilterOption.state;structureData()\" ng-class=\"{\'active text-left\':level1FilterOption.state}\"><span class=\"material-icons color-primary\" ng-show=level1FilterOption.state>close</span> <span class=btn__label>{{level1FilterOption.label}}</span></button></div></div></div></form></div><div class=sidebar__footer><button type=submit class=\"btn btn-primary\" ng-click=\"load(); toggleFilters(\'filters\');;\">{{tools.lang({\'en\': \'Done\', \'nl\': \'Done\', \'fr\': \'Appliquer\'})}}</button></div></aside><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\': \'Accounting consolidation\', \'nl\': \'Accounting consolidation\', \'fr\': \'Accounting consolidation\'})}}&nbsp;<form action={{model.action}} name=exactentrylines autocomplete=off method=post target=_blank><input type=hidden name=params value={{getExactentrylinesWsParams()}}> <input download></form></h1><div class=header__actions><button class=\"btn btn-default btn-filters\" ng-click=\"toggleFilters(\'filters\')\"><i class=material-icons>filter_list</i> <span class=\"btn__text hidden-xs hidden-sm\">{{tools.lang({ \'en\': \'Filters\', \'nl\': \'Filters\', \'fr\': \'Filtres\' })}}</span></button></div></section><div class=content><div class=\"content__item c-table-view\" ng-hide=webservice.calling><div class=c-table-view__item><div class=table-responsive-wrapper><table class=\"table table-striped table-condensed\"><thead><tr><th colspan=2><span class=th__content></span></th><th ng-repeat=\"header in model.headers\" colspan={{header.colspan}} class=text-center ng-class=header.color><span class=th__content>{{header.label}}</span></th></tr><tr><th class=\"table__col col--sticky\"><span class=th__content></span></th><th class=text-right><span class=th__content>{{tools.lang({\'en\':\'Tot\',\'nl\':\'Tot\',\'fr\':\'Tot\'})}}</span></th><th ng-repeat=\"col in model.cols\" class=text-right ng-class=col.color><span class=th__content>{{col.label}}</span></th></tr></thead><tbody><tr ng-repeat=\"row in model.rows\"><td class=\"text-right table__col col--sticky text-right\">{{row.label}}</td><td class=text-right><span ng-style=\"getCellStyle(model.totals[row.id],row,{\'color\':\'0\',\'bold\':\'1\'})\"><span ng-style=\"getCellStyle(model.sideTotals[row.id],row,{\'color\':\'0\',\'bold\':\'1\'})\" ng-show=\"model.compare===\'1\' && model.compareMode===\'side\'\">{{model.sideTotals[row.id]}}</span> {{model.totals[row.id]}}</span></td><td ng-repeat=\"col in model.cols\" class=text-right><span ng-style=getCellStyle(model.structuredData[row.id][col.id],row,col)><span ng-style=getCellStyle(model.sideData[row.id][col.id],row,col) ng-show=\"model.compare===\'1\' && model.compareMode===\'side\'\">{{model.sideData[row.id][col.id]}}</span> {{model.structuredData[row.id][col.id]}}</span></td></tr></tbody></table></div></div></div><div class=\"content__item page__loader\" ng-show=webservice.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div></div></main></div>");
$templateCache.put("app/modules/accounting/dayIncome.html","<div ng-controller=AccountingDayIncomeController class=\"page page-accounting-daily-income\"><aside id=filters class=\"page__sidebar sidebar\"><div class=sidebar__header><h4 class=title>{{tools.lang({\'en\': \'Filters\', \'nl\': \'Filters\', \'fr\': \'Filtres\'})}}</h4><button class=\"btn btn-default btn-rounded\"><span class=material-icons ng-click=\"toggleFilters(\'filters\')\">close</span></button></div><div class=sidebar__content><form class=form-horizontal><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\" ng-click=\"model.dateOpened=!model.dateOpened\">{{tools.lang({\'en\':\'Date\',\'nl\':\'Datum\',\'fr\':\'Date\'})}}</label><div class=col-sm-10><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.date is-open=model.dateOpened datepicker-options=model.dateOptions ng-click=\"model.dateOpened=!model.dateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.dateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Division\',\'nl\':\'Afdeling\',\'fr\':\'Date\'})}}</label><div class=col-sm-10><select class=form-control ng-model=model.dvs ng-options=\"dvs.id as tools.label(dvs) for dvs in tools.addElement(parameters.notDelArrayDVS,any)\"></select></div></div></form></div><div class=sidebar__footer><button type=submit class=\"btn btn-primary\" ng-click=\"load(); toggleFilters(\'filters\');\">{{tools.lang({\'en\': \'Done\', \'nl\': \'Done\', \'fr\': \'Appliquer\'})}}</button></div></aside><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\': \'Daly income\', \'nl\': \'Daly income\', \'fr\': \'Comptabilité du jour\'})}}</h1><div class=header__actions><button class=\"btn btn-default btn-filters\" ng-click=\"toggleFilters(\'filters\')\"><i class=material-icons>filter_list</i> <span class=\"btn__text hidden-xs hidden-sm\">{{tools.lang({ \'en\': \'Filters\', \'nl\': \'Filters\', \'fr\': \'Filtres\' })}}</span></button></div></section><div class=content><div class=\"content__item c-table-view\" ng-hide=webservice.calling><div class=c-table-view__item><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><thead><tr><th class=\"table__col col--sticky\"><span class=th__content>{{tools.lang({\'en\':\'Name\',\'nl\':\'Naam\',\'fr\':\'Nom\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Total\',\'nl\':\'Total\',\'fr\':\'Total\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Vat\',\'nl\':\'Btw\',\'fr\':\'Tva\'})}}</span></th><th colspan=2 ng-repeat=\"component in model.components | orderBy:\'code\'\"><span class=th__content><span ng-show=\"tools.substr(tools.substr(component.code,0,8))!=\'YYYYYYYY\'\">{{tools.substr(tools.short(parameters.ITM[tools.substr(component.code,0,8).trim()]),0,10)}} </span>{{percentIn(tools.substr(component.code,8,2))}}%<br>{{tools.substr(component.code,10)}}</span></th><th ng-repeat=\"method in model.methods | orderBy:\'mth\'\"><span class=th__content>{{tools.short(parameters.MTH[method.mth])}}</span></th></tr></thead><tbody><tr><td class=\"table__col col--sticky\"></td><td ng-click=visitRetrieve(visit.id);><b>{{tools.amountOut(model.totalItems)}}</b></td><td ng-click=visitRetrieve(visit.id);><b>{{tools.amountOut(model.totalVat)}}</b></td><td ng-click=visitRetrieve(visit.id); ng-repeat-start=\"component in model.components | orderBy:\'code\'\"><b>{{tools.amountOut(component.base)}}</b></td><td ng-click=visitRetrieve(visit.id); ng-repeat-end ng-class=\"{\'borderright\':$last}\"><b>{{tools.amountOut(component.vat)}}</b></td><td ng-click=visitRetrieve(visit.id); ng-repeat=\"method in model.methods | orderBy:\'mth\'\"><b>{{tools.amountOut(method.amount)}}</b></td></tr><tr ng-repeat=\"visit in tools.toArray(model.visits) | orderBy:\'created\'\"><td class=\"table__col col--sticky\" ng-click=visitRetrieve(visit.id);>{{model.contacts[visit.owningcontact].name}}</td><td ng-click=visitRetrieve(visit.id);>{{tools.amountOut(visit.totalItems)}}</td><td ng-click=visitRetrieve(visit.id);>{{tools.amountOut(visit.totalVat)}}</td><td ng-click=visitRetrieve(visit.id); ng-repeat-start=\"component in model.components | orderBy:\'code\'\">{{tools.amountOut(visit.components[component.code].base)}}</td><td ng-click=visitRetrieve(visit.id); ng-repeat-end>{{tools.amountOut(visit.components[component.code].vat)}}</td><td ng-click=visitRetrieve(visit.id); ng-repeat=\"method in model.methods | orderBy:\'mth\'\">{{tools.amountOut(visit.methods[method.mth])}}</td></tr></tbody></table></div></div></div><div class=\"content__item page__loader\" ng-show=webservice.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div></div></main></div>");
$templateCache.put("app/modules/accounting/downPayments.html","<div ng-controller=AccountingDownPaymentsController class=\"page page-accounting-downpayments page--tables\"><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\':\'Advance\',\'nl\':\'Voorschot\',\'fr\':\'Acomptes\'})}}</h1><div class=header__actions><input refresh ng-hide=model.loading ng-click=load();></div></section><div class=content><div class=\"content__item c-table-view\" ng-hide=webservice.calling><div class=c-table-view__item><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><thead><tr><th><span class=th__content>{{tools.lang({\'en\':\'Name\',\'nl\':\'Naam\',\'fr\':\'Nom\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Created\',\'nl\':\'Aangemaakt\',\'fr\':\'Cr\\u00E9\\u00E9\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Arrival\',\'nl\':\'Aankomst\',\'fr\':\'Arriv\\u00E9e\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Advance\',\'nl\':\'Voorschot\',\'fr\':\'Acompte\'})}}</span></th><th><span class=th__content></span></th></tr></thead><tbody><tr ng-repeat=\"visit in tools.toArray(model.visits) | orderBy:\'startdate\'\"><td ng-click=visitRetrieve(visit.id);>{{model.contacts[visit.owningcontact].name}}</td><td ng-click=visitRetrieve(visit.id);>{{tools.substr(visit.created,0,10)}}</td><td ng-click=visitRetrieve(visit.id);>{{tools.dateFromJava(visit.startdate)}}</td><td ng-click=visitRetrieve(visit.id);>{{tools.amountOut(paid(visit))+\'€ / \'+tools.amountOut(topay(visit))+\'€\'}}</td><td ng-click=visitRetrieve(visit.id);>{{argumentation(visit)}}</td></tr></tbody></table></div></div></div><div class=\"content__item page__loader\" ng-show=webservice.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div></div></main></div>");
$templateCache.put("app/modules/accounting/income.html","<div ng-controller=AccountingIncomeController class=\"page page-accounting-income page--tables\"><aside id=filters class=\"page__sidebar sidebar\"><div class=sidebar__header><h4 class=title>{{tools.lang({\'en\': \'Filters\', \'nl\': \'Filters\', \'fr\': \'Filtres\'})}}</h4><button class=\"btn btn-default btn-rounded\"><span class=material-icons ng-click=\"toggleFilters(\'filters\')\">close</span></button></div><div class=sidebar__content><form class=form-horizontal><div class=\"form-group clearfix\"><label class=\"col-xs-12 col-sm-2 control-label\">{{tools.lang({\'en\':\'Invoices from\',\'nl\':\'Facturen vanaf\',\'fr\':\'Factures de\'})}}</label><div class=inline-flex><input type=text autocomplete=off class=form-control ng-model=model.startyear> <input type=text autocomplete=off class=form-control ng-model=model.startperiod></div></div><div class=\"form-group clearfix\"><label class=\"col-xs-12 col-sm-2 control-label\">{{tools.lang({\'en\':\'Invoices to\',\'nl\':\'Facturen tot\',\'fr\':\'Factures jusqu\\u0027à\'})}}</label><div class=inline-flex><input type=text autocomplete=off class=form-control ng-model=model.endyear> <input type=text autocomplete=off class=form-control ng-model=model.endperiod></div></div><div class=\"form-group clearfix\"><label class=\"col-xs-12 col-sm-2 control-label\">{{tools.lang({\'en\':\'Visit date\',\'nl\':\'Bezoek datum\',\'fr\':\'Date de visite\'})}}</label><div class=col-sm-10><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"par in model.visitStartdateModes\" ng-click=\"model.visitStartdateMode=par.id;\" ng-class=\"{\'active\':model.visitStartdateMode==par.id}\">{{tools.label(par)}}</button></div></div><div class=col-xs-12><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.visitStartdate is-open=model.visitStartdateOpened datepicker-options=model.dateOptions ng-click=\"model.visitStartdateOpened=!model.visitStartdateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.visitStartdateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"form-group clearfix\"><label class=\"col-xs-12 col-sm-2 control-label\">{{tools.lang({\'en\':\'VAT Component\',\'nl\':\'BTW Component\',\'fr\':\'Composant TVA\'})}}</label><div class=col-sm-12><div ng-dropdown-multiselect=\"\" options=model.accounts selected-model=model.selectedAccounts extra-settings=model.accountSettings translation-texts=model.translations></div></div></div><div class=\"form-group clearfix\"><label class=\"col-xs-12 col-sm-2 control-label\">{{tools.lang({\'en\':\'Origin\',\'nl\':\'Origine\',\'fr\':\'Origine\'})}}</label><div class=col-sm-12><div ng-dropdown-multiselect=\"\" options=model.originOptions selected-model=model.origins extra-settings=model.originSettings translation-texts=model.translations></div></div></div><div class=\"form-group clearfix\"><label class=\"col-xs-12 col-sm-2 control-label\">{{tools.lang({\'en\':\'Articles\',\'nl\':\'Artikels\',\'fr\':\'Articles\'})}}</label><div class=col-sm-12><div ng-dropdown-multiselect=\"\" options=model.itmOptionsArray selected-model=model.itms extra-settings=model.itmSettings group-by=itemType translation-texts=model.translations></div></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-12 control-label\">{{tools.lang({\'en\':\'Selected\',\'nl\':\'Geselecteerd\',\'fr\':\'S\\u00E9lectionn\\u00E9\'})}}</label><div class=col-sm-1><p class=form-control-static ng-hide=\"tools.getLength(model.selectedAccounts)>0\">{{tools.lang({\'en\':\'All accounts\',\'nl\':\'Alle accounts\',\'fr\':\'Tous les account\'})}}</p><div ng-show=\"tools.getLength(model.selectedAccounts)>0\"><div class=btn-group><button type=button class=\"btn btn-default active\" ng-repeat=\"account in model.selectedAccounts | orderBy:\'toString()\'\" ng-click=selectedAccounts(account)>{{account.id}}</button></div><button type=button class=\"btn btn-primary\" style=\"margin-top: 16px\" ng-click=\"model.selectedAccounts=[];load()\">{{tools.lang({\'en\':\'All accounts\',\'nl\':\'Alle accounts\',\'fr\':\'Tous les account\'})}}</button></div></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Ordered by\',\'nl\':\'Geordend op\',\'fr\':\'Tri\\u00E9 par\'})}}</label><div class=col-sm-10><div class=pull-left><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"par in model.orderModes\" ng-click=\"model.orderMode=par.id;\" ng-class=\"{\'active\':model.orderMode==par.id}\">{{tools.label(par)}}</button></div></div></div></div><div class=\"form-group clearfix\"><label class=\"control-label col-sm-12\"><input type=checkbox ng-model=model.showMovements> {{tools.lang({\'en\':\'Show movements\',\'nl\':\'Toon betalingen\',\'fr\':\'Montrer paiements\'})}}</label></div></form></div><div class=sidebar__footer><button type=submit class=\"btn btn-primary\" ng-click=\"load(); toggleFilters(\'filters\');\">{{tools.lang({\'en\': \'Done\', \'nl\': \'Done\', \'fr\': \'Appliquer\'})}}</button></div></aside><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\': \'Accounting income\', \'nl\': \'Accounting income\', \'fr\': \'Comptabilité\'})}}</h1><div class=header__actions><button class=\"btn btn-default btn-filters\" ng-click=\"toggleFilters(\'filters\')\"><i class=material-icons>filter_list</i> <span class=\"btn__text hidden-xs hidden-sm\">{{tools.lang({ \'en\': \'Filters\', \'nl\': \'Filters\', \'fr\': \'Filtres\' })}}</span></button></div></section><div class=content><div class=\"content__item c-table-view\" ng-hide=model.loading><div class=c-table-view__item><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><thead><tr><th class=\"table__col col--sticky\"><span class=\"th__content text-right\"></span></th><th><span class=\"th__content text-right\">{{tools.lang({\'en\':\'Total (excl.&nbspVAT)\',\'nl\':\'Total (excl.&nbspBTW)\',\'fr\':\'Total (excl.&nbspTVA)\'})}}</span></th><th><span class=\"th__content text-right\">{{tools.lang({\'en\':\'VAT\',\'nl\':\'BTW\',\'fr\':\'TVA\'})}}</span></th><th colspan=2 ng-repeat=\"component in model.componentList\" ng-show=showAccount(component)><span class=\"th__content text-right\"><br>{{percentIn(tools.substr(component,8,2))}}%<br>{{tools.substr(component,10)}}</span></th><th ng-show=model.showMovements ng-repeat=\"mth in getMth()\" ng-class=\"{\'right\':$last}\"><span class=\"th__content text-right\">{{tools.short(mth)}}</span></th></tr><tr><th class=\"table__col col--sticky\"><span class=\"th__content text-right\">{{tools.lang({\'en\':\'Total\',\'nl\':\'Totaal\',\'fr\':\'Total\'})}}</span></th><th class=border-right><span class=\"th__content text-right\">{{tools.amountOut(getTotalAmount(\'components\'))}}</span></th><th class=\"border-right no-border-left\"><span class=\"th__content text-right\">{{tools.amountOut(getTotalAmount(\'vats\'))}}</span></th><th ng-repeat-start=\"component in model.componentList\" class=no-border-left ng-show=showAccount(component)><span class=\"th__content text-right\">{{tools.amountOut(tools.sum(getField(model.lines,\'components\'),component))}}</span></th><th ng-repeat-end class=\"border-right no-border-left\" ng-show=showAccount(component)><span class=\"th__content text-right\">{{tools.amountOut(tools.sum(getField(model.lines,\'vats\'),component))}}</span></th><th ng-show=model.showMovements ng-repeat=\"mth in getMth()\"><span class=\"th__content text-right\">{{tools.amountOut(tools.sum(getField(model.lines,\'MTH\'),mth.id))}}</span></th></tr></thead><tbody><tr ng-repeat=\"line in model.lines | orderBy:\'date\'\"><td class=\"text-right border-right table__col col--sticky\">{{line.date}}</td><td class=\"text-right border-right\">{{tools.amountOut(getTotalLineAmount(\'components\',line))}}</td><td class=\"border-right text-right\">{{tools.amountOut(getTotalLineAmount(\'vats\',line))}}</td><td class=text-right ng-repeat-start=\"component in model.componentList\" ng-show=showAccount(component)>{{tools.amountOut(line.components[component])}}</td><td ng-repeat-end class=\"no-border-left border-right text-right\" ng-show=showAccount(component)>{{tools.amountOut(line.vats[component])}}</td><td class=\"text-right border-right\" ng-show=model.showMovements ng-repeat=\"mth in getMth()\">{{tools.amountOut(line.MTH[mth.id])}}</td></tr></tbody></table></div></div></div><div class=\"content__item page__loader\" ng-show=model.loading><div class=lds-ring><div></div><div></div><div></div><div></div></div></div></div></main></div>");
$templateCache.put("app/modules/accounting/intercompanyList.html","<div ng-controller=IntercompanyListController class=\"page page--tables\"><aside class=\"page__sidebar sidebar\" ng-class=\"{\'is-open\':filterOpened}\"><div class=sidebar__header><h4 class=title>{{tools.lang({\'en\':\'Filters\',\'nl\':\'Filters\',\'fr\':\'Filtres\'})}}</h4><button class=\"btn btn-default btn-rounded\"><span class=material-icons ng-click=\"filterOpened=false;load();\">close</span></button></div><div class=sidebar__content><form class=form-horizontal><div class=\"form-group clearfix\"><div class=col-sm-12><div ng-hide=webservice.calling><div class=row style=\"margin-bottom: 16px\"><div class=col-sm-12><label><input type=checkbox ng-model=model.unpaid> {{tools.lang({\'en\':\'Show unpaid intercompanies\',\'nl\':\'Toon onbetaalde intercompanies\',\'fr\':\'Montrer intercompanies impay\\u00e9\'})}}</label></div></div></div></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-12 control-label\" ng-click=\"model.startdateOpened=!model.startdateOpened\">{{tools.lang({\'en\':\'Start\',\'nl\':\'Start\',\'fr\':\'D\\u00E9but\'})}}</label><div class=col-sm-12><p class=input-group><input type=text class=form-control ng-disabled=model.unpaid uib-datepicker-popup ng-model=model.startdate is-open=model.startdateOpened datepicker-options=model.dateOptions ng-click=\"model.startdateOpened=!model.startdateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.startdateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><label class=\"col-sm-12 control-label\" ng-click=\"model.enddateOpened=!model.enddateOpened\">{{tools.lang({\'en\':\'End\',\'nl\':\'Einde\',\'fr\':\'Fin\'})}}</label><div class=col-sm-12><p class=input-group><input type=text class=form-control ng-disabled=model.unpaid uib-datepicker-popup ng-model=model.enddate is-open=model.enddateOpened datepicker-options=model.dateOptions ng-click=\"model.enddateOpened=!model.enddateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.enddateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"form-group clearfix\"><div class=col-sm-12><div ng-hide=webservice.calling><div class=row style=\"margin-bottom: 16px\"><div class=col-sm-12><label><input type=checkbox ng-model=model.showUndo> {{tools.lang({\'en\':\'Show undo button\',\'nl\':\'Toon undo knop\',\'fr\':\'Montrer bouton undo\'})}}</label></div></div></div></div></div></form></div><div class=sidebar__footer><button type=submit class=\"btn btn-primary\" ng-click=\"filterOpened=false;load();\">{{tools.lang({\'en\':\'Done\',\'nl\':\'Done\',\'fr\':\'Appliquer\'})}}</button></div></aside><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\':\'Intercompanies\',\'nl\':\'Intercompanies\',\'fr\':\'Intercompanies\'})}}</h1><div class=header__actions><input refresh ng-disabled=webservice.calling ng-click=load();> <button class=\"btn btn-default btn-filters\" ng-click=\"filterOpened=!filterOpened\"><i class=material-icons>filter_list</i> <span class=\"btn__text hidden-xs hidden-sm\">{{tools.lang({\'en\':\'Filters\',\'nl\':\'Filters\',\'fr\':\'Filtres\'})}}</span></button></div></section><div class=content><div class=\"content__item c-table-view\" ng-hide=webservice.calling><div class=c-table-view__item ng-repeat=\"date in model.dates\"><h4 class=c-table-view__title>{{date+\' \'+tools.dateToWeekday(date)}}</h4><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><thead><tr><th><span class=th__content>{{tools.lang({\'en\':\'Customer\',\'nl\':\'Klant\',\'fr\':\'Client\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Supplier\',\'nl\':\'Leverancier\',\'fr\':\'Fournisseur\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'OGM\',\'nl\':\'OGM\',\'fr\':\'OGM\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Amount\',\'nl\':\'Bedrag\',\'fr\':\'Montant\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Purchase number\',\'nl\':\'Aankoop nummer\',\'fr\':\'Numero achat\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Sales number\',\'nl\':\'Verkoop nummer\',\'fr\':\'Numero \'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Paid\',\'nl\':\'Betaald\',\'fr\':\'Pay\\u00E9\'})}}</span></th></tr></thead><tbody><tr ng-repeat=\"intercompany in tools.match(model.intercompanies,{\'invoicedate\':date}) | orderBy:[\'customerdvs\',\'supplierdvs\']\" ng-class=\"{\'danger\':intercompany.salesexactnumber==\'\'}\"><td>{{tools.label(parameters.DVS[intercompany.customerdvs])}}</td><td>{{tools.label(parameters.DVS[intercompany.supplierdvs])}}</td><td>{{tools.ogmOut(intercompany.ogm)}}</td><td>{{tools.amountOut(intercompany.sumdeltatopay)}}</td><td>{{intercompany.purchaseexactnumber}}</td><td><span ng-show=\"intercompany.salesexactnumber!=\'\'\">{{intercompany.salesexactnumber}}</span> <span ng-show=\"intercompany.salesexactnumber==\'\'\"><span class=\"glyphicon glyphicon-exclamation-sign\"></span> {{tools.lang({\'en\':\'Not sent to Exact\',\'nl\':\'Niet verstuurd naar Exact\',\'fr\':\'Pas envoy\\u00E9 a Exact\'})}} <button class=\"btn btn-default\" ng-click=\"tools.redirect(buildHref(\'accounting\',\'invoices\'))\">{{tools.lang({\'en\':\'Exact errors\',\'nl\':\'Exact fouten\',\'fr\':\'Erreurs Exact\'})}}</button></span></td><td><span ng-show=\"intercompany.paid==\'1\'\"><span class=\"glyphicon glyphicon-ok\"></span> <button ng-show=model.showUndo class=\"btn btn-default\" ng-click=\"setIntercompanyPaid(intercompany,\'0\')\">{{tools.lang({\'en\':\'Undo\',\'nl\':\'Undo\',\'fr\':\'Undo\'})}}</button> </span><span ng-show=\"intercompany.paid==\'0\'\"><button class=\"btn btn-default\" ng-click=\"setIntercompanyPaid(intercompany,\'1\')\">{{tools.lang({\'en\':\'Paid\',\'nl\':\'Betaald\',\'fr\':\'Pay\\u00E9\'})}}</button></span></td></tr></tbody></table></div></div></div></div><div class=\"content__item page__loader\" ng-show=webservice.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div></main></div>");
$templateCache.put("app/modules/accounting/invoices.html","<div ng-controller=AccountingInvoicesController class=\"page page-accountin-invoices page--tables\"><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\':\'Errors\',\'nl\':\'Fouten\',\'fr\':\'Erreurs\'})}}</h1><div class=header__actions><input refresh ng-hide=model.loading ng-click=load();></div></section><div class=content><div class=\"content__item c-table-view\" ng-hide=\"webservice.calling || (tools.getLength(getErroneousInvoices())==0 && tools.getLength(model.movements)==0 && tools.getLength(model.exactentries)==0 && tools.getLength(model.exactmatchsets)==0 && tools.getLength(model.exactmessages)==0 && tools.getLength(model.intercompanies)==0)\"><div class=c-table-view__item><div class=c-table-view__item__content ng-show=\"tools.getLength(getErroneousInvoices())>0\"><h4 class=c-table-view__title>{{tools.lang({\'en\':\'Invoices\',\'nl\':\'Facturen\',\'fr\':\'Factures\'})}}</h4><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><thead><tr><th><span class=th__content></span></th><th><span class=th__content>{{tools.lang({\'en\':\'Name\',\'nl\':\'Naam\',\'fr\':\'Nom\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Origin\',\'nl\':\'Oorsprong\',\'fr\':\'Cause\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Created\',\'nl\':\'Aangemaakt\',\'fr\':\'Cr\\u00E9\\u00E9\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Amount\',\'nl\':\'Bedrag\',\'fr\':\'Montant\'})}}</span></th><th colspan=2><span class=th__content>{{tools.lang({\'en\':\'Error\',\'nl\':\'Fout\',\'fr\':\'Erreur\'})}}</span></th></tr></thead><tbody><tr ng-repeat=\"invoice in getErroneousInvoices() | orderBy:\'created\'\"><td><form action={{model.action}} name=\"{{\'invoice\'+invoice.id}}\" autocomplete=off method=post target=_blank class=form-horizontal><input type=hidden name=params value={{getInvoiceWsParams(invoice)}}> <button type=submit class=\"btn btn-default\"><span class=\"glyphicon glyphicon-print\"></span></button> <button ng-show=\"invoice.visit!=0\" retrieve ng-click=visitRetrieve(model.visits[invoice.visit].id);></button></form></td><td><span ng-show=\"invoice.visit!=\'0\'\">{{visitsService.getName(model.contacts[model.visits[invoice.visit].owningcontact],model.visits[invoice.visit])}}</span> <span ng-show=\"invoice.visit==\'0\'\">{{tools.label(parameters.DVS[invoice.dvs])}}</span></td><td>{{invoice.inv}}</td><td>{{tools.dateOut(invoice.created)}}</td><td>{{tools.amountOut(invoice.amount)}}</td><td>{{invoice.errorwording}}</td><td><button refresh ng-click=retryInvoice(invoice)></button></td></tr></tbody></table></div></div><div class=c-table-view__item__content ng-show=\"tools.getLength(model.movements)>0\"><h4 class=c-table-view__title>{{tools.lang({\'en\':\'Payments\',\'nl\':\'Betalingen\',\'fr\':\'Paiements\'})}}</h4><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><thead><tr><th><span class=th__content></span></th><th><span class=th__content>{{tools.lang({\'en\':\'Name\',\'nl\':\'Naam\',\'fr\':\'Nom\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Created\',\'nl\':\'Aangemaakt\',\'fr\':\'Cr\\u00E9\\u00E9\'})}}</span></th><th colspan=2><span class=th__content>{{tools.lang({\'en\':\'Amount\',\'nl\':\'Bedrag\',\'fr\':\'Montant\'})}}</span></th></tr></thead><tbody><tr ng-repeat=\"movement in tools.toArray(model.movements) | orderBy:\'created\'\"><td><button retrieve ng-click=visitRetrieve(model.visits[movement.visit].id);></button></td><td>{{visitsService.getName(model.contacts[model.visits[movement.visit].owningcontact],model.visits[movement.visit])}}</td><td>{{tools.dateOut(movement.created)}}</td><td>{{tools.amountOut(movement.amount)}}</td><td><button class=\"btn btn-default\" ng-click=retryMovements(movement)>{{tools.lang({\'en\':\'Retry date \',\'nl\':\'Opnieuw datum \',\'fr\':\'R\\u00E9essayer date \'})+\' \'+tools.dateOut(movement.created)}}</button></td></tr></tbody></table></div></div><div class=c-table-view__item__content ng-show=\"tools.getLength(model.exactentries)>0\"><h4 class=c-table-view__title>{{tools.lang({\'en\':\'General entries\',\'nl\':\'Algemene operaties\',\'fr\':\'Operations diversives\'})}}</h4><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><thead><tr><th><span class=th__content style=\"justify-content: center\"><input type=checkbox ng-model=model.selectedAllExactentries checkbox-all child-list=model.exactentries property=selected></span></th><th><span class=th__content>{{tools.lang({\'en\':\'Date\',\'nl\':\'Datum\',\'fr\':\'Date\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Payment method\',\'nl\':\'Betaalmethode\',\'fr\':\'Moyen de paiement\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Error\',\'nl\':\'Fout\',\'fr\':\'Erreur\'})}}</span></th><th><span class=th__content><span ng-show=\"tools.getLength(tools.match(model.exactentries,{\'selected\':true}))>0\">{{tools.lang({\'en\':\'Selection\',\'nl\':\'Selectie\',\'fr\':\'S\\u00E9lection\'})}}&nbsp; <button refresh class=\"btn btn-default\" ng-click=retrySelectedExactentries()></button></span></span></th></tr></thead><tbody><tr ng-repeat=\"exactentry in tools.toArray(model.exactentries) | orderBy:\'date\'\"><td class=text-center><input type=checkbox ng-model=exactentry.selected></td><td>{{tools.dateOut(exactentry.date)}}</td><td><span ng-show=\"exactentry.mth==\'TERMINAL\'\">{{tools.lang({\'en\':\'Terminal\',\'nl\':\'Terminal\',\'fr\':\'Terminal\'})}}</span> <span ng-hide=\"exactentry.mth==\'TERMINAL\'\">{{tools.label(parameters.MTH[exactentry.mth])}}</span></td><td>{{exactentry.errorwording}}</td><td><button refresh ng-click=retryExactentry(exactentry)></button></td></tr></tbody></table></div></div><div class=c-table-view__item__content ng-show=\"tools.getLength(model.exactmatchsets)>0\"><h4 class=c-table-view__title>Matchsets&nbsp; <button refresh ng-click=retryExactmatchsets()></button></h4><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><thead><tr><th><span class=th__content style=\"justify-content: center\"><input type=checkbox ng-model=model.selectedAllExactmatchsets checkbox-all child-list=model.exactmatchsets property=selected></span></th><th><span class=th__content>{{tools.lang({\'en\':\'Name\',\'nl\':\'Naam\',\'fr\':\'Nom\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Error\',\'nl\':\'Fout\',\'fr\':\'Erreur\'})}}</span></th><th><span class=th__content><span ng-show=\"tools.getLength(tools.match(model.exactmatchsets,{\'selected\':true}))>0\">{{tools.lang({\'en\':\'Selection\',\'nl\':\'Selectie\',\'fr\':\'S\\u00E9lection\'})}}&nbsp; <button delete class=\"btn btn-danger\" ng-click=ignoreSelectedExactmatchsets()></button></span></span></th></tr></thead><tbody><tr ng-repeat=\"exactmatchset in tools.toArray(model.exactmatchsets) | orderBy:\'updated\'\"><td class=text-center><input type=checkbox ng-model=exactmatchset.selected> <button retrieve ng-click=visitRetrieve(model.visits[exactmatchset.visit].id);></button></td><td>{{visitsService.getName(model.contacts[model.visits[exactmatchset.visit].owningcontact],model.visits[exactmatchset.visit])}}</td><td>{{exactmatchset.errorwording}}</td><td><button delete class=\"btn btn-danger\" ng-click=ignoreExactmatchset(exactmatchset)></button></td></tr></tbody></table></div></div><div class=c-table-view__item__content ng-show=\"tools.getLength(model.exactmessages)>0\"><h4 class=c-table-view__title>Bank&nbsp; <button refresh ng-click=retryExactmessages()></button></h4><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><thead><tr><th><span class=th__content style=\"justify-content: center\"><input type=checkbox ng-model=model.selectedAllExactmessages checkbox-all child-list=model.exactmessages property=selected></span></th><th><span class=th__content>{{tools.lang({\'en\':\'Code\',\'nl\':\'Code\',\'fr\':\'Code\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Topic\',\'nl\':\'Topic\',\'fr\':\'Topic\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Division\',\'nl\':\'Afdeling\',\'fr\':\'Division\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Error\',\'nl\':\'Fout\',\'fr\':\'Erreur\'})}}</span></th><th><span class=th__content><span ng-show=\"tools.getLength(tools.match(model.exactmessages,{\'selected\':true}))>0\">{{tools.lang({\'en\':\'Selection\',\'nl\':\'Selectie\',\'fr\':\'S\\u00E9lection\'})}}&nbsp; <button refresh ng-click=retrySelectedExactmessages()></button> <button delete class=\"btn btn-danger\" ng-click=deleteSelectedExactmessages()></button></span></span></th></tr></thead><tbody><tr ng-repeat=\"exactmessage in tools.toArray(model.exactmessages) | orderBy:\'updated\'\"><td class=text-center><input type=checkbox ng-model=exactmessage.selected> <button retrieve ng-click=visitRetrieve(model.visits[exactmatchset.visit].id);></button></td><td>{{getExactmessageExactid(exactmessage)}}</td><td>{{getExactmessageTopic(exactmessage)}}</td><td>{{getExactmessageDivision(exactmessage)}}</td><td>{{exactmessage.errorwording}}</td><td><button refresh ng-click=retryExactmessage(exactmessage)></button> <button delete class=\"btn btn-danger\" ng-click=deleteExactmessage(exactmessage)></button></td></tr></tbody></table></div></div><div class=c-table-view__item__content ng-show=\"tools.getLength(model.intercompanies)>0\"><h4 class=c-table-view__title>Intercompany <button refresh ng-click=retryIntercompanies()></button></h4><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><thead><tr><th><span class=th__content>{{tools.lang({\'en\':\'Date\',\'nl\':\'Datum\',\'fr\':\'Date\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Buyer\',\'nl\':\'Koper\',\'fr\':\'Acheteur\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Supplier\',\'nl\':\'Leverancier\',\'fr\':\'Fournisseur\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Step\',\'nl\':\'Stap\',\'fr\':\'Etape\'})}}</span></th><th colspan=2><span class=th__content>{{tools.lang({\'en\':\'Error\',\'nl\':\'Fout\',\'fr\':\'Erreur\'})}}</span></th></tr></thead><tbody><tr ng-repeat=\"intercompany in tools.toArray(model.intercompanies) | orderBy:\'invoicedate\'\"><td>{{intercompany.invoicedate}}</td><td>{{tools.label(parameters.DVS[intercompany.customerdvs])}}</td><td>{{tools.label(parameters.DVS[intercompany.supplierdvs])}}</td><td>{{getIntercompanyErrorStep(intercompany)}}</td><td>{{intercompany.errorwording}}</td><td><button refresh ng-click=retryIntercompany(intercompany)></button></td></tr></tbody></table></div></div></div></div><div class=\"content__item page__loader\" ng-show=webservice.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div><div class=content__noresult ng-show=\"!webservice.calling && tools.getLength(getErroneousInvoices())==0 && tools.getLength(model.movements)==0 && tools.getLength(model.exactentries)==0 && tools.getLength(model.exactmatchsets)==0 && tools.getLength(model.exactmessages)==0 && tools.getLength(model.intercompanies)==0\"><div class=\"alert alert-info\" role=alert><p>{{tools.lang({\'en\':\'No errors. Everything is sent to Exact\',\'nl\':\'Geen fouten. Alles is verstuurd naar Exact\',\'fr\':\'Aucune erreur. Tout est envoy\\u00E9 vers Exact.\'})}}</p></div></div></div></main></div>");
$templateCache.put("app/modules/accounting/invoicesList.html","<div ng-controller=AccountingInvoicesListController class=\"page page-accounting-invoices-list page--tables\"><aside id=filters class=\"page__sidebar sidebar\"><div class=sidebar__header><h4 class=title>{{tools.lang({\'en\': \'Filters\', \'nl\': \'Filters\', \'fr\': \'Filtres\'})}}</h4><button class=\"btn btn-default btn-rounded\"><span class=material-icons ng-click=\"toggleFilters(\'filters\')\">close</span></button></div><div class=sidebar__content><form class=form-horizontal><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\" ng-click=\"model.startdateOpened=!model.startdateOpened\">{{tools.lang({\'en\':\'Start\',\'nl\':\'Start\',\'fr\':\'D\\u00E9but\'})}}</label><div class=col-sm-4><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.startdate is-open=model.startdateOpened datepicker-options=model.dateOptions ng-click=\"model.startdateOpened=!model.startdateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.startdateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><label class=\"col-sm-2 control-label\" ng-click=\"model.enddateOpened=!model.enddateOpened\">{{tools.lang({\'en\':\'End\',\'nl\':\'Einde\',\'fr\':\'Fin\'})}}</label><div class=col-sm-4><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.enddate is-open=model.enddateOpened datepicker-options=model.dateOptions ng-click=\"model.enddateOpened=!model.enddateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.enddateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></form></div><div class=sidebar__footer><button type=submit class=\"btn btn-primary\" ng-click=\"load(); toggleFilters(\'filters\');\">{{tools.lang({\'en\': \'Done\', \'nl\': \'Done\', \'fr\': \'Appliquer\'})}}</button></div></aside><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\': \'Invoices list\', \'nl\': \'Invoices list\', \'fr\': \'Factures\'})}}</h1><div class=header__actions><button class=\"btn btn-default btn-filters\" ng-click=\"toggleFilters(\'filters\')\"><i class=material-icons>filter_list</i> <span class=\"btn__text hidden-xs hidden-sm\">{{tools.lang({ \'en\': \'Filters\', \'nl\': \'Filters\', \'fr\': \'Filtres\' })}}</span></button> <input refresh ng-hide=model.loading ng-click=load();></div></section><div class=content><div class=\"content__item c-table-view\" ng-hide=webservice.calling><div class=c-table-view__item><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><thead><tr><th><span class=th__content>{{tools.lang({\'en\': \'Print\', \'nl\': \'Print\', \'fr\': \'Imprimer\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Nr\',\'nl\':\'Nr\',\'fr\':\'no\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Created\',\'nl\':\'Aangemaakt\',\'fr\':\'Cr\\u00E9\\u00E9\'})}}</span></th><th><span class=\"th__content text-right\">{{tools.lang({\'en\':\'Amount\',\'nl\':\'Bedrag\',\'fr\':\'Montant\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Paid\',\'nl\':\'Betaald\',\'fr\':\'Pay\\u00E9\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Name\',\'nl\':\'Naam\',\'fr\':\'Nom\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Visit\',\'nl\':\'Bezoek\',\'fr\':\'Visite\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Created\',\'nl\':\'Aangemaakt\',\'fr\':\'Cr\\u00E9\\u00E9\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Manager\',\'nl\':\'Manager\',\'fr\':\'Manager\'})}}</span></th></tr></thead><tbody><tr ng-repeat=\"invoice in tools.toArray(model.invoices) | orderBy:\'created\':true\"><td><form action={{model.action}} name=\"{{\'invoice\'+invoice.id}}\" autocomplete=off method=post target=_blank><input type=hidden name=params value={{getInvoiceWsParams(invoice)}}> <button retrieve ng-click=visitRetrieve(invoice.visit)></button> <button type=submit class=\"btn btn-default\"><span class=\"glyphicon glyphicon-print\"></span></button></form></td><td>{{invoice.dvs+(model.accountingIntegration!=\'\'?invoice.accountingentryid:invoice.id)}}</td><td>{{tools.substr(invoice.created,0,10)}}</td><td class=text-right>&euro;&nbsp;{{tools.amountOut(invoice.amount)}}</td><td>{{tools.amountOut(tools.sum(tools.join(model.visits[invoice.visit],\'movements\',model),\'amount\'))}}€</td><td>{{contactsService.getName(model.contacts[model.visits[invoice.visit].owningcontact])}}</td><td ng-click=visitRetrieve(invoice.visit)>{{tools.dateFromJava(model.visits[invoice.visit].startdate)}} <span ng-show=\"tools.dateFromJava(model.visits[invoice.visit].startdate)!=tools.dateFromJava(model.visits[invoice.visit].enddate)\">- {{tools.dateFromJava(model.visits[invoice.visit].enddate)}}</span></td><td>{{tools.doneBy(model.visits[invoice.visit].created,model.visits[invoice.visit].creator_name)}}</td><td>{{model.users[model.visits[invoice.visit].quotationmanager].short}}</td></tr></tbody></table></div></div></div><div class=\"content__item page__loader\" ng-show=webservice.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div></div></main></div>");
$templateCache.put("app/modules/accounting/kiosk.html","<div ng-controller=AccountingKioskController class=\"page page-accounting-kiosk page--tables\"><aside id=filters class=\"page__sidebar sidebar\"><div class=sidebar__header><h4 class=title>{{tools.lang({\'en\': \'Filters\', \'nl\': \'Filters\', \'fr\': \'Filtres\'})}}</h4><button class=\"btn btn-default btn-rounded\"><span class=material-icons ng-click=\"toggleFilters(\'filters\')\">close</span></button></div><div class=sidebar__content><form class=form-horizontal><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\" ng-click=\"model.startdateOpened=!model.startdateOpened\">{{tools.lang({\'en\':\'Start\',\'nl\':\'Start\',\'fr\':\'D\\u00E9but\'})}}</label><div class=col-sm-4><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.startdate is-open=model.startdateOpened datepicker-options=model.dateOptions ng-click=\"model.startdateOpened=!model.startdateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.startdateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><label class=\"col-sm-2 control-label\" ng-click=\"model.enddateOpened=!model.enddateOpened\">{{tools.lang({\'en\':\'End\',\'nl\':\'Einde\',\'fr\':\'Fin\'})}}</label><div class=col-sm-4><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.enddate is-open=model.enddateOpened datepicker-options=model.dateOptions ng-click=\"model.enddateOpened=!model.enddateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.enddateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"form-group clearfix\"><label class=\"col-xs-2 control-label\">{{tools.lang({\'en\':\'Terminal\',\'nl\':\'Terminal\',\'fr\':\'Terminal\'})}}</label><div class=col-xs-10><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"terminalid in model.terminalids\" ng-click=\"model.terminalid=terminalid;load();\" ng-class=\"{\'active\':model.terminalid==terminalid}\">{{terminalid}}</button></div></div></div></form></div><div class=sidebar__footer><button type=submit class=\"btn btn-primary\" ng-click=\"load(); toggleFilters(\'filters\');\">{{tools.lang({\'en\': \'Done\', \'nl\': \'Done\', \'fr\': \'Appliquer\'})}}</button></div></aside><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\': \'Kiosk\', \'nl\': \'Kiosk\', \'fr\': \'Kiosk\'})}}</h1><div class=header__actions><button class=\"btn btn-default btn-filters\" ng-click=\"toggleFilters(\'filters\')\"><i class=material-icons>filter_list</i> <span class=\"btn__text hidden-xs hidden-sm\">{{tools.lang({ \'en\': \'Filters\', \'nl\': \'Filters\', \'fr\': \'Filtres\' })}}</span></button></div></section><div class=content><div class=\"content__item c-table-view\" ng-hide=webservice.calling><div class=c-table-view__item><div class=c-table-view__item__content><table class=\"table table-striped\"><thead><tr><th><span class=th__content>{{tools.lang({\'en\':\'Total\',\'nl\':\'Total\',\'fr\':\'Total\'})}}</span></th><th ng-repeat=\"mthSum in model.mthSums\"><span class=th__content>{{tools.short(parameters.MTH[mthSum.mth])}}</span></th></tr></thead><tbody><tr><td><b>{{tools.amountOut(model.sum)}}</b></td><td ng-repeat=\"mthSum in model.mthSums\">{{tools.amountOut(mthSum.amount)}}</td></tr></tbody></table></div><div class=c-table-view__item__content><table class=\"table table-striped\"><thead><tr><th ng-show=\"tools.dateFromJava(model.startdate)!=tools.dateFromJava(model.enddate)\"><span class=th__content>{{tools.lang({\'en\':\'Day\',\'nl\':\'Dag\',\'fr\':\'Dag\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Hour\',\'nl\':\'Uur\',\'fr\':\'Heure\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Amount\',\'nl\':\'Bedrag\',\'fr\':\'Montant\'})}}</span></th><th ng-show=\"model.terminalid==\'--All--\'\"><span class=th__content>{{tools.lang({\'en\':\'Terminal\',\'nl\':\'Terminal\',\'fr\':\'Terminal\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Payment method\',\'nl\':\'Payment method\',\'fr\':\'Moyen de paiement\'})}}</span></th></tr></thead><tbody><tr ng-repeat=\"movement in tools.toArray(model.movements) | orderBy:\'created\'\"><td ng-show=\"tools.dateFromJava(model.startdate)!=tools.dateFromJava(model.enddate)\">{{movement.created.substr(0,10)}}</td><td>{{movement.created.substr(11)}}</td><td>{{tools.amountOut(movement.amount)}} €</td><td ng-show=\"model.terminalid==\'--All--\'\">{{model.accounts[movement.account].terminalid}}</td><td>{{tools.label(parameters.MTH[model.accounts[movement.account].method])}}</td></tr></tbody></table></div></div></div><div class=\"content__item page__loader\" ng-show=webservice.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div></div></main></div>");
$templateCache.put("app/modules/accounting/listPainfiles.html","<div ng-controller=AccountingListPainfilesController class=\"page page-accounting-list-painfiles page--tables\"><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\':\'Painfiles list\',\'nl\':\'Painfiles lijst\',\'fr\':\'Liste des painfiles\'})}}</h1><div class=header__actions><input refresh ng-disabled=webservice.calling ng-click=load();> <button class=\"btn btn-default\" ng-click=toggleAll(true)>{{tools.lang({\'en\':\'Show all\',\'nl\':\'Show all\',\'fr\':\'Tout d\\u00E9plier\'})}} &nbsp; <span class=\"glyphicon glyphicon-chevron-down\"></span></button> <button class=\"btn btn-default\" ng-click=toggleAll(false)>{{tools.lang({\'en\':\'Collapse all\',\'nl\':\'Collapse all\',\'fr\':\'Tout masquer\'})}} &nbsp; <span class=\"glyphicon glyphicon-chevron-up\"></span></button></div></section><div class=content><div ng-show=\"tools.toArray(model.painfiles).length===0 && !webservice.calling\"><h3>{{tools.lang({\'en\':\'No payment instruction file\',\'nl\':\'Geen Betaalinstructie bestand\',\'fr\':\'Aucun fichier d\\\'instructions de paiement\'})}}</h3><span>{{tools.lang({\'en\':\'To export payment instruction file, go to the page : \', \'nl\':\'Voor het exporteren van betaalinstructie bestand gaat u naar de pagina \', \'fr\':\'Pour exporter des fichier d\\\'instructions de paiement, allez sur la page \'})}} <a ng-href=\"#!/{{buildHref(\'accounting\',\'refund\')}}\">{{tools.lang({\'en\':\'Refund\',\'nl\':\'Terugbetalen\',\'fr\':\'Rembourser\'})}}</a></span></div><div class=\"content__item c-table-view\" ng-hide=webservice.calling><div class=c-table-view__item><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><caption><h1>{{tools.lang({\'en\':\'Payment instruction files being processed\',\'nl\':\'Betaalinstructie bestanden in verwerking\',\'fr\':\'Fichiers d\\\'instructions de paiement en cours de traitement\'})}}</h1></caption><thead><tr><th><span class=th__content></span></th><th><span class=th__content>{{tools.lang({\'en\':\'Id\',\'nl\':\'Id\',\'fr\':\'Id\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Created\',\'nl\':\'Aangemaakt\',\'fr\':\'Cr\\u00E9\\u00E9\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Amount\',\'nl\':\'Bedrag\',\'fr\':\'Montant\'})}}</span></th><th><span class=th__content></span></th><th><span class=th__content></span></th></tr></thead><tbody><tr ng-repeat-start=\"painfile in tools.toArray(model.painfiles) | orderBy:\'created\'\"><td><button type=button class=\"btn btn-default\" ng-click=\"model.expanded[painfile.id] = !model.expanded[painfile.id]\"><span class=glyphicon ng-class=\"{\'glyphicon-chevron-up\':model.expanded[painfile.id],\'glyphicon-chevron-down\':!model.expanded[painfile.id]}\"></span></button></td><td>{{painfile.id}}</td><td>{{tools.doneBy(painfile.created,painfilecreator_name)}}</td><td>{{-painfile.amount | currency:value=\"€\"}}</td><td><form action={{model.action}} name=visit autocomplete=off method=post target=_blank><input type=hidden name=params value={{downloadPainfile(painfile)}}> <input download></form></td><td></td></tr><tr class=sub-header ng-show=model.expanded[painfile.id]><th><span class=th__content></span></th><th><span class=th__content>{{tools.lang({\'en\':\'Id\',\'nl\':\'Id\',\'fr\':\'Id\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Visit\',\'nl\':\'Bezoek\',\'fr\':\'Visite\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Account\',\'nl\':\'Rekening\',\'fr\':\'Compte\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Amount\',\'nl\':\'Bedrag\',\'fr\':\'Montant\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Status\',\'nl\':\'Status\',\'fr\':\'Status\'})}}</span></th></tr><tr ng-class=\"{\'ongoing-stat\': painline.stat==1000, \'confirmed-stat\': painline.stat==9000}\" ng-show=model.expanded[painfile.id] ng-repeat-end ng-repeat=\"painline in tools.join(painfile,\'painlines\',model)\"><td><input retrieve ng-click=visitRetrieve(model.visits[model.movements[painline.movement].visit].id);></td><td>{{painline.id}}</td><td>{{model.visits[model.movements[painline.movement].visit].id}}</td><td>{{model.visits[model.movements[painline.movement].visit].refundaccount}}</td><td>{{-model.movements[painline.movement].amount | currency:value=\"€\"}}</td><td>{{getPainlineStatWording(painline.stat)}}</td></tr></tbody></table><div ng-show=\"tools.toArray(model.painfiles).length === 0\" class=\"alert alert-warning text-center mt-1\">{{tools.lang({\'en\':\'Nothing to show\',\'nl\':\'Niets te zien\',\'fr\':\"Rien à montrer\"})}}</div></div></div></div></div></main></div>");
$templateCache.put("app/modules/accounting/movementOverview.html","<div ng-controller=AccountingMovementOverviewController class=\"page page-accounting-movement-overview page--content\"><form class=form-horizontal><div class=\"form-group clearfix\"><label class=col-sm-2 ng-click=\"model.startdateOpened=!model.startdateOpened\">{{tools.lang({\'en\':\'Start\',\'nl\':\'Start\',\'fr\':\'D\\u00E9but\'})}}</label><div class=\"col-sm-2 hidden-print\"><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.startdate is-open=model.startdateOpened datepicker-options=model.dateOptions ng-click=\"model.startdateOpened=!model.startdateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.startdateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-sm-2 hidden-print\"><uib-timepicker ng-model=model.startdate minute-step=1 show-meridian=false show-spinners=false></uib-timepicker></div><div class=\"col-sm-4 visible-print\">{{tools.timestampFromJava(model.startdate)}}</div><label class=col-sm-2 ng-click=\"model.enddateOpened=!model.enddateOpened\">{{tools.lang({\'en\':\'End\',\'nl\':\'Einde\',\'fr\':\'Fin\'})}}</label><div class=\"col-sm-2 hidden-print\"><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.enddate is-open=model.enddateOpened datepicker-options=model.dateOptions ng-click=\"model.enddateOpened=!model.enddateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.enddateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-sm-2 hidden-print\"><uib-timepicker ng-model=model.enddate minute-step=1 show-meridian=false show-spinners=false></uib-timepicker></div><div class=\"col-sm-4 visible-print\">{{tools.timestampFromJava(model.enddate)}}</div></div><div class=\"form-group clearfix\"><label class=col-sm-2>{{tools.lang({\'en\':\'Division\',\'nl\':\'Afdeling\',\'fr\':\'Division\'})}}</label><div class=\"col-sm-10 hidden-print\"><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"dvs in tools.match(parameters.notDelArrayDVS,{\'field5\':\'1\'}) | orderBy:\'label\'+user.lang\" ng-click=\"model.dvs=dvs.id;\" ng-class=\"{\'active\':model.dvs==dvs.id}\">{{tools.short(dvs)}}</button></div></div><div class=\"col-sm-10 visible-print\">{{tools.short(parameters.DVS[model.dvs])}}</div></div><div class=\"form-group clearfix hidden-print\">{{globalUsrs=tools.match(model.usrsArray,{\'dvs\':\'\'});\"\";}}<label class=col-sm-2>{{tools.lang({\'en\':\'Global Users\',\'nl\':\'Algemene Gebruikers\',\'fr\':\'Utilisateurs g\\u00E9n\\u00E9ral\'})}}</label><div class=\"col-sm-10 hidden-print\"><div class=btn-group><button type=button class=\"btn btn-default\" ng-show=\"tools.getLength(globalUsrs)>1\" ng-click=selectUsers(globalUsrs) ng-class=\"{\'active\':tools.getLength(globalUsrs)===tools.getLength(tools.match(globalUsrs,{\'active\':true}))}\">{{tools.lang({\'en\':\'-- All --\',\'nl\':\'-- Alle --\',\'fr\':\'-- Tous --\'})}}</button> <button type=button class=\"btn btn-default\" ng-repeat=\"usr in globalUsrs | orderBy:\'name\'\" ng-click=selectUsers([usr]) ng-class=\"{\'active\':model.usrs.indexOf(usr.id)>=0}\">{{usr.name}}</button></div></div></div><div class=\"form-group clearfix hidden-print\">{{divisionUsrs=tools.match(tools.exclude(model.usrsArray,{\'dvs\':\'\'}),{\'dvs\':model.dvs});\"\";}}<label class=col-sm-2>{{tools.lang({\'en\':\'Division users\',\'nl\':\'Afdeling gebruikers\',\'fr\':\'Utilisateurs division\'})}}</label><div class=col-sm-10><div class=btn-group><button type=button class=\"btn btn-default\" ng-show=\"tools.getLength(divisionUsrs)>1\" ng-click=selectUsers(divisionUsrs) ng-class=\"{\'active\':tools.getLength(divisionUsrs)===tools.getLength(tools.match(divisionUsrs,{\'active\':true}))}\">{{tools.lang({\'en\':\'-- All --\',\'nl\':\'-- Alle --\',\'fr\':\'-- Tous --\'})}}</button> <button type=button class=\"btn btn-default\" ng-repeat=\"usr in divisionUsrs | orderBy:\'name\'\" ng-click=selectUsers([usr]) ng-class=\"{\'active\':model.usrs.indexOf(usr.id)>=0}\">{{usr.name}}</button></div></div></div><div class=\"form-group clearfix hidden-print\">{{otherUsrs=tools.exclude(tools.exclude(model.usrsArray,{\'dvs\':model.dvs}),{\'dvs\':\'\'});\"\";}}<label class=col-sm-2>{{tools.lang({\'en\':\'Other users\',\'nl\':\'Andere gebruikers\',\'fr\':\'Autres utilisateurs\'})}}</label><div class=col-sm-10><div class=btn-group><button type=button class=\"btn btn-default\" ng-show=\"tools.getLength(otherUsrs)>1\" ng-click=selectUsers(otherUsrs) ng-class=\"{\'active\':tools.getLength(otherUsrs)===tools.getLength(tools.match(otherUsrs,{\'active\':true}))}\">{{tools.lang({\'en\':\'-- All --\',\'nl\':\'-- Alle --\',\'fr\':\'-- Tous --\'})}}</button> <button type=button class=\"btn btn-default\" ng-repeat=\"usr in otherUsrs | orderBy:\'name\'\" ng-click=selectUsers([usr]) ng-class=\"{\'active\':model.usrs.indexOf(usr.id)>=0}\">{{usr.name}}</button></div></div></div><div class=\"form-group clearfix visible-print\"><label class=col-sm-2>{{tools.lang({\'en\':\'Selected users\',\'nl\':\'Geselecteerde gebruikers\',\'fr\':\'Utilisateurs s\\u00E9lectionn\\u00E9s\'})}}</label><div class=col-sm-10><span ng-repeat=\"usrId in model.usrs track by $index\">{{tools.first(tools.match(model.usrsArray,{\'id\':usrId})).name}}<span ng-hide=$last>,</span></span></div></div><div class=\"form-group clearfix hidden-print\"><div class=col-sm-3><label><input type=checkbox ng-model=model.groupByMethod> {{tools.lang({\'en\':\'Group payment methods\',\'nl\':\'Groepeer betaal methodes\',\'fr\':\'Grouper moyen de paiements\'})}}</label></div><div class=col-sm-9><span ng-hide=webservice.calling><button type=submit class=\"btn btn-primary\" ng-click=load();>{{tools.lang({\'en\':\'Show\',\'nl\':\'Tonen\',\'fr\':\'Montrer\'})}}</button> </span><span ng-show=webservice.calling>Loading...</span></div></div></form><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\" ng-show=\"tools.match(model.sums,{\'dvsId\':model.dvs}).length>0\"><thead><tr><th></th><th ng-repeat-start=\"sum in tools.match(model.sums,{\'dvsId\':model.dvs})\"></th><th><div>{{tools.label(parameters.MTH[sum.mthId])}}</div><div>{{sum.groupName}}</div></th><th ng-repeat-end></th></tr></thead><tbody><tr><td>{{tools.amountOut(totalOfSelected(model.dvs))}}€</td><td ng-repeat-start=\"sum in tools.match(model.sums,{\'dvsId\':model.dvs})\"></td><td><input type=checkbox ng-model=sum.selected> <b>{{tools.amountOut(sum.sum)}}€</b></td><td ng-repeat-end></td></tr><tr ng-repeat=\"line in model.lines\"><td></td><td ng-repeat-start=\"sum in tools.match(model.sums,{\'dvsId\':model.dvs})\" class=text-right>{{tools.hourOut(line[$index].created)}}</td><td><span ng-show=line[$index]>{{tools.amountOut(line[$index].amount)}}€</span> <span class=\"glyphicon glyphicon-info-sign\" ng-if=\"line[$index] && line[$index].comment!=\'\'\" uib-tooltip={{line[$index].comment}} tooltip-placement=bottom tooltip-popup-delay=150 tooltip-class=info></span></td><td ng-repeat-end><span ng-show=line[$index] class=hidden-print><input retrieve ng-click=visitRetrieve(line[$index].visit) uib-tooltip=\"{{line[$index].contactName+\' - \' +\'V\'+line[$index].visit}}\" tooltip-placement=bottom tooltip-popup-delay=150 tooltip-class=info></span></td></tr></tbody></table></div></div>");
$templateCache.put("app/modules/accounting/refund.html","<div ng-controller=AccountingRefundController class=\"page page-accounting-refund page--tables\"><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\':\'Refund\',\'nl\':\'Terugbetaling\',\'fr\':\'Rembourser\'})}}</h1><div class=header__actions><input refresh ng-disabled=webservice.calling ng-click=load();><form action={{model.action}} name=visit autocomplete=off method=post target=_blank><input type=hidden name=params value={{createAndDownloadPainfile();}}> <input download title=\"{{tools.lang({\'en\':\'Export\',\'nl\':\'Exporteren\',\'fr\':\'Exporter\'})}}\" class=col-sm-offset-2 ng-disabled=!hasVisitToExport() ng-click=reloadVisitsAfterTimeout();></form></div></section><div class=content><div class=\"content__item c-table-view\" ng-hide=webservice.calling><!--         <div class=\"c-table-view__item\">\n          <div class=\"table-responsive-wrapper\">\n            <table class=\"table table-striped table-hover\">\n              <caption>\n                <h1>\n                  {{tools.lang({\'en\':\'Cashless credit to refund\',\'nl\':\'Cashless krediet terugbetalen\',\'fr\':\'Cr\\u00E9dit cashless à rembourser\'})}}\n                </h1>\n              </caption>\n              <thead>\n                <tr>\n                  <th>\n                    <span class=\"th__content\">\n                      <input ng-model=\"model.selectAllCheckboxesValues[\'selectedAllCashless\']\" type=\"checkbox\" \n                        ng-click=\"changeAllStatus(model.cashlessCreditContent, !model.selectAllCheckboxesValues[\'selectedAllCashless\'])\" />\n                    </span>\n                  </th>\n                  <th><span class=\"th__content\">{{tools.lang({\'en\':\'Name\',\'nl\':\'Naam\',\'fr\':\'Nom\'})}}</span></th>\n                  <th><span class=\"th__content\">{{tools.lang({\'en\':\'Visit\',\'nl\':\'Bezoek\',\'fr\':\'Visite\'})}}</span></th>\n                  <th><span class=\"th__content\">{{tools.lang({\'en\':\'Modified\',\'nl\':\'Gewijzigd\',\'fr\':\'Modifié\'})}}</span></th>\n                  <th><span class=\"th__content\">{{tools.lang({\'en\':\'Amount\',\'nl\':\'Bedrag\',\'fr\':\'Montant\'})}}</span></th>\n                  <th><span class=\"th__content\">{{tools.lang({\'en\':\'Account\',\'nl\':\'Rekening\',\'fr\':\'Compte\'})}}</span></th>\n                  <th><span class=\"th__content\">{{tools.lang({\'en\':\'Structured message\',\'nl\':\'Gestructureerde mededeling\',\'fr\':\'Message structur\\u00E9\'})}}</span></th>\n                  <th><span class=\"th__content\"></span></th>\n                  <th><span class=\"th__content\"></span></th>\n                </tr>\n              </thead>\n              <tbody>\n                <tr ng-class=\"{warningAmount: hasDifferenceBetweenMovementsMismatchAndRefundAmount(visit)}\" ng-repeat=\"visit in model.cashlessCreditContent | orderBy:\'created\'\">\n                  <td ng-click=\"visitRetrieve(visit.id);\"><input type=\"checkbox\" ng-model=\"model.visitIdsToExport[visit.id]\" ng-change=\"changeIfAllSelected(model.cashlessCreditContent, \'selectedAllCashless\')\" /></td>\n                  <td ng-click=\"visitRetrieve(visit.id);\">{{contactsService.getName(model.contacts[visit.owningcontact]))}}</td>\n                  <td ng-click=\"visitRetrieve(visit.id);\">{{visit.id}}</td>\n                  <td ng-click=\"visitRetrieve(visit.id);\">\n                    {{tools.doneBy(tools.max(tools.join(visit,\'items\',model),\'updated\').updated,tools.max(tools.join(visit,\'items\',model),\'updated\').updater_name)}}\n                  </td>\n                  <td ng-click=\"visitRetrieve(visit.id);\">{{tools.amountOut(visit.movementsmismatch)}}</td>\n                  <td ng-click=\"visitRetrieve(visit.id);\">{{visit.refundaccount}}</td>\n                  <td ng-click=\"visitRetrieve(visit.id);\">{{visit.ogm}}</td>\n                  <td>\n                    <button class=\"btn btn-default\"ng-click=\"pay(visit)\">\n                      {{tools.lang({\'en\':\'Paid manually\',\'nl\':\'Handmatig betaald\',\'fr\':\'Payé manuellement\'})}}\n                    </button>\n                  </td>\n                  <td><span class=\"glyphicon glyphicon-warning-sign\" ng-show=\"hasDifferenceBetweenMovementsMismatchAndRefundAmount(visit)\" title=\"{{getWarningMessage(visit)}}\"></span></td>\n                </tr>\n              </tbody>\n            </table>\n            <div ng-show=\"model.cashlessCreditContent.length == 0\" class=\"alert alert-warning text-center mt-1\">{{tools.lang({\'en\':\'Nothing to show\',\'nl\':\'Niets te zien\',\'fr\':\"Rien à montrer\"})}}</div>\n          </div>\n        </div> --><div class=c-table-view__item><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><caption><h1>{{tools.lang({\'en\':\'Reservations to refund\',\'nl\':\'Reservaties terugbetalen\',\'fr\':\'R\\u00E9servations à rembourser\'})}}</h1></caption><thead><tr><th><span class=th__content><input ng-model=\"model.selectAllCheckboxesValues[\'selectedAllReservation\']\" type=checkbox ng-click=\"changeAllStatus(model.reservationContent, !model.selectAllCheckboxesValues[\'selectedAllReservation\'])\"></span></th><th><span class=th__content>{{tools.lang({\'en\':\'Name\',\'nl\':\'Naam\',\'fr\':\'Nom\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Visit\',\'nl\':\'Bezoek\',\'fr\':\'Visite\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Modified\',\'nl\':\'Gewijzigd\',\'fr\':\'Modifie\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Amount\',\'nl\':\'Bedrag\',\'fr\':\'Montant\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Account\',\'nl\':\'Rekening\',\'fr\':\'Compte\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Structured message\',\'nl\':\'Gestructureerde mededeling\',\'fr\':\'Message structur\\u00E9\'})}}</span></th><th><span class=th__content></span></th><th><span class=th__content></span></th></tr></thead><tbody><tr ng-class=\"{warningAmount: hasDifferenceBetweenMovementsMismatchAndRefundAmount(visit)}\" ng-repeat=\"visit in model.reservationContent | orderBy:\'created\'\"><td><input type=checkbox ng-model=model.visitIdsToExport[visit.id] ng-change=\"changeIfAllSelected(model.reservationContent, \'selectedAllReservation\')\"></td><td ng-click=visitRetrieve(visit.id);>{{contactsService.getName(model.contacts[visit.owningcontact])}}</td><td ng-click=visitRetrieve(visit.id);>{{visit.id}}</td><td ng-click=visitRetrieve(visit.id);>{{tools.doneBy(tools.max(tools.join(visit,\'items\',model),\'updated\').updated,tools.max(tools.join(visit,\'items\',model),\'updated\').updater_name)}}</td><td ng-click=visitRetrieve(visit.id);>{{tools.amountOut(visit.movementsmismatch)}}</td><td ng-click=visitRetrieve(visit.id);>{{visit.refundaccount}}</td><td ng-click=visitRetrieve(visit.id);>{{visit.ogm}}</td><td><button class=\"btn btn-default\" ng-click=pay(visit)>{{tools.lang({\'en\':\'Paid manually\',\'nl\':\'Handmatig betaald\',\'fr\':\'Payé manuellement\'})}}</button></td><td><span class=\"glyphicon glyphicon-warning-sign\" ng-show=hasDifferenceBetweenMovementsMismatchAndRefundAmount(visit) title={{getWarningMessage(visit)}}></span></td></tr></tbody></table><div ng-show=\"model.reservationContent.length == 0\" class=\"alert alert-warning text-center mt-1\">{{tools.lang({\'en\':\'Nothing to show\',\'nl\':\'Niets te zien\',\'fr\':\"Rien à montrer\"})}}</div></div></div><div class=c-table-view__item><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><caption><h1>{{tools.lang({\'en\':\'Visits without account number\',\'nl\':\'Bezoeken zonder rekeningnummer\',\'fr\':\'Visites sans num\\u00E9ro de compte\'})}}</h1></caption><thead><tr><th><span class=th__content>{{tools.lang({\'en\':\'Name\',\'nl\':\'Naam\',\'fr\':\'Nom\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Visit\',\'nl\':\'Bezoek\',\'fr\':\'Visite\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Modified\',\'nl\':\'Gewijzigd\',\'fr\':\'Modifie\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Amount\',\'nl\':\'Bedrag\',\'fr\':\'Montant\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Structured message\',\'nl\':\'Gestructureerde mededeling\',\'fr\':\'Message structur\\u00E9\'})}}</span></th><th><span class=th__content></span></th><th><span class=th__content></span></th></tr></thead><tbody><tr ng-class=\"{warningAmount: hasDifferenceBetweenMovementsMismatchAndRefundAmount(visit)}\" ng-repeat=\"visit in model.visitWithoutAccNumberContent | orderBy:\'created\'\"><td ng-click=visitRetrieve(visit.id);>{{contactsService.getName(model.contacts[visit.owningcontact])}}</td><td ng-click=visitRetrieve(visit.id);>{{visit.id}}</td><td ng-click=visitRetrieve(visit.id);>{{tools.doneBy(tools.max(tools.join(visit,\'items\',model),\'updated\').updated,tools.max(tools.join(visit,\'items\',model),\'updated\').updater_name)}}</td><td ng-click=visitRetrieve(visit.id);>{{tools.amountOut(visit.movementsmismatch)}}</td><td ng-click=visitRetrieve(visit.id);>{{visit.ogm}}</td><td><button class=\"btn btn-default\" ng-click=pay(visit)>{{tools.lang({\'en\':\'Paid manually\',\'nl\':\'Handmatig betaald\',\'fr\':\'Payé manuellement\'})}}</button></td><td><span class=\"glyphicon glyphicon-warning-sign\" ng-show=hasDifferenceBetweenMovementsMismatchAndRefundAmount(visit) title={{getWarningMessage(visit)}}></span></td></tr></tbody></table><div ng-show=\"model.visitWithoutAccNumberContent.length == 0\" class=\"alert alert-warning text-center mt-1\">{{tools.lang({\'en\':\'Nothing to show\',\'nl\':\'Niets te zien\',\'fr\':\"Rien à montrer\"})}}</div></div></div></div><div class=\"content__item page__loader\" ng-show=webservice.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div></div></main></div>");
$templateCache.put("app/modules/accounting/retrieveAccount.html","<div ng-controller=AccountingRetrieveAccountController class=\"component c-retrieve-account c--include\"><div ng-show=\"model.account!=null\"><h4 ng-show=\"model.account.accounttype==\'USR\'\">{{model.account.name}}</h4><ul class=list-group><li class=\"list-group-item row\" ng-show=showBalance()><div class=\"col-xs-6 text-right\">{{tools.lang({\'en\':\'Balance before\',\'nl\':\'Balans vóór\',\'fr\':\'Balance avant\'})+\' \'+tools.dateOut(model.startdateValue)}}</div><div class=col-xs-6>{{tools.amountOut(model.balance.amount+tools.sum(tools.less(tools.greaterEqual(tools.join(model.account,\'movements\',model),\'created\',model.balance.created),\'created\',model.startdateValue),\'amount\'))}}</div></li><li class=\"list-group-item row\" ng-repeat=\"movement in tools.toArray(tools.greaterEqual(model.movements,\'created\',model.startdateValue+\' 00:00:00\')) | orderBy:\'created\'\"><div class=\"col-xs-6 text-right\"><span ng-show=\"movement.origin==\'ACT\'\"><input retrieve ng-click=visitRetrieve(movement.visit)> {{model.visits[movement.visit].name}} </span><span ng-hide=\"movement.origin==\'ACT\'\">{{tools.label(parameters.ORI[movement.origin])}} </span>{{tools.dateOut(movement.created)}}</div><div class=col-xs-6>{{tools.amountOut(movement.amount)}}</div></li><li class=\"list-group-item row\" ng-show=showBalance()><div class=\"col-xs-6 text-right\">{{tools.lang({\'en\':\'Balance after\',\'nl\':\'Balans na\',\'fr\':\'Balance apres\'})+\' \'+tools.dateOut(model.enddateValue)}}</div><div class=col-xs-6>{{tools.amountOut(model.balance.amount+tools.sum(tools.less(tools.greaterEqual(tools.join(model.account,\'movements\',model),\'created\',model.balance.created),\'created\',model.enddateValue+\' 23:00:00\'),\'amount\'))}}</div></li></ul><div ng-show=\"model.account.accounttype==\'USR\'\"><h4>{{tools.lang({\'en\':\'Reductions\',\'nl\':\'Kortingen\',\'fr\':\'Reductions\'})}}</h4><ul class=list-group><li class=\"list-group-item row\" ng-repeat=\"visit in tools.inverseJoin(filterReductionItems(model.items),\'visits\',\'visit\',model)\"><div class=\"col-xs-6 text-right\"><input retrieve ng-click=visitRetrieve(visit.id)> {{visit.name}}</div><div class=col-xs-6><div ng-repeat=\"item in filterReductionItems(tools.join(visit,\'items\',model))\">{{tools.amountOut(item.reductionamount)+activitiesService.percentToSymbol(item.reductionpercent)}} <span ng-show=\"item.reductionpercent==\'1\'\">{{tools.amountOut(item.quantity*item.grossunitprice*item.reductionamount/100.0)+\'\\u20AC\'}}</span> {{tools.label(parameters.ITM[item.itm])}} <span ng-show=\"tools.substr(item.itm,0,3)==\'ACT\' && parameters.UNT[tools.first(tools.join(item,\'participants\',model)).unt].field3==\'1\'\">{{tools.label(parameters.UNT[tools.first(tools.join(item,\'participants\',model)).unt])}} </span><span ng-show=\"tools.substr(item.itm,0,3)==\'MEA\'\">{{tools.label(parameters.DSH[tools.first(tools.join(item,\'dishes\',model)).dsh])}} </span>{{tools.dateOut(item.updated)}}</div></div></li></ul></div></div><!--\n  <table>\n    <tr>\n      <td>{{tools.lang({\'en\':\'Previous balance\',\'nl\':\'Vorig saldo\',\'fr\':\'Solde pr\\u00E9c\\u00E9dent\'})}}:</td>\n      <td>\n        <span>{{tools.amountOut(previousAmount())}}</span>\n        &euro;\n      </td>\n    </tr>\n    <tr>\n      <td>{{tools.lang({\'en\':\'Expenses\',\'nl\':\'Uitgaven\',\'fr\':\'D\\u00E9penses\'})}}:</td>\n      <td>{{tools.amountOut(tools.sum(tools.less(tools.greater(tools.join(model.accounts[model.accountValue],\'movements\'),\'created\',model.sinceValue),\'amount\',0),\'amount\'))}} &euro;</td>\n    </tr>\n    <tr>\n      <td>{{tools.lang({\'en\':\'Income\',\'nl\':\'Inkomsten\',\'fr\':\'Revenu\'})}}:</td>\n      <td>{{tools.amountOut(tools.sum(tools.greater(tools.greater(tools.join(model.accounts[model.accountValue],\'movements\'),\'created\',model.sinceValue),\'amount\',0),\'amount\'))}} &euro;</td>\n    </tr>\n    <tr>\n      <td>{{tools.lang({\'en\':\'Current balance\',\'nl\':\'Huidig saldo\',\'fr\':\'Solde courant\'})}}:</td>\n      <td>{{tools.amountOut(previousAmount()+tools.sum(tools.greater(tools.join(model.accounts[model.accountValue],\'movements\'),\'created\',model.sinceValue),\'amount\'))}} &euro;</td>\n    </tr>\n  </table>\n  <div ng-show=\"model.account.accounttype==\'USR\' && tools.getLength(getReductionVisits())>0\">\n    <h3>{{tools.lang({\'en\':\'Discount\',\'nl\':\'Korting\',\'fr\':\'Reduction\'})}}</h3>\n    <table class=\"list\">\n      <tr class=\"head\">\n        <td class=\"left\"></td>\n        <td></td>\n        <td>{{tools.lang({\'en\':\'Activity\',\'nl\':\'Activiteit\',\'fr\':\'Activit\\u00E9\'})}}</td>\n        <td>{{tools.lang({\'en\':\'Name\',\'nl\':\'Naam\',\'fr\':\'Nom\'})}}</td>\n        <td>{{tools.lang({\'en\':\'Comment\',\'nl\':\'Opmerking\',\'fr\':\'Remarque\'})}}</td>\n        <td class=\"right\"></td>\n      </tr>\n      <tr ng-repeat=\"visit in getReductionVisits()\"\n          ng-class=\"{\'last\':$last}\" class=\"row\" ng-class-even=\"\'even\'\" ng-class-odd=\"\'odd\'\">\n        <td><input retrieve ng-click=\"visitRetrieve(visit.id);\"/></td>\n        <td>\n          {{tools.amountOut(tools.sum(tools.match(tools.join(visit,\'reductions\'),{\'automatic\':\'0\',\'percent\':\'1\'}),\'amount\'))}}%\n          +\n          {{tools.amountOut(tools.sum(tools.match(tools.join(visit,\'reductions\'),{\'automatic\':\'0\',\'percent\':\'0\'}),\'amount\'))}}&euro;\n        </td>\n        <td>{{activities.formulaOut(tools.first(tools.join(visit,\'activities\')).formula)}}</td>\n        <td>{{visit.name}}</td>\n        <td>{{tools.first(tools.join(tools.first(tools.join(visit,\'activities\')),\'occurences\')).comment}}</td>\n        <td>{{tools.doneBy(visit.created,visit.creator_name)}}</td>\n      </tr>\n    </table>\n  </div>\n  --></div>");
$templateCache.put("app/modules/accounting/retrieveAccountForm.html","<div ng-controller=AccountingRetrieveAccountFormController><form class=form-horizontal><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\" ng-click=\"model.startdateOpened=!model.startdateOpened\">{{tools.lang({\'en\':\'From\',\'nl\':\'Vanaf\',\'fr\':\'De\'})}}</label><div class=col-sm-10><p class=input-group><input type=text autocomplete=off class=form-control uib-datepicker-popup ng-model=model.startdate is-open=model.startdateOpened datepicker-options=model.dateOptions ng-click=\"model.startdateOpened=!model.startdateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.startdateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\" ng-click=\"model.enddateOpened=!model.enddateOpened\">{{tools.lang({\'en\':\'Until\',\'nl\':\'Tot\',\'fr\':\'À\'})}}</label><div class=col-sm-10><p class=input-group><input type=text autocomplete=off class=form-control uib-datepicker-popup ng-model=model.enddate is-open=model.enddateOpened datepicker-options=model.dateOptions ng-click=\"model.enddateOpened=!model.enddateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.enddateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Method\',\'nl\':\'Middel\',\'fr\':\'Moyen\'})}}</label><div class=col-sm-10><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"mth in tools.exclude(parameters.notDelMTH,{\'id\':\'MIX\'}) | orderBy:\'id\'\" ng-click=\"model.mth=mth.id\" ng-class=\"{\'active\':model.mth==mth.id}\" ng-show=\"model.accounttype==\'USR\'\">{{tools.label(mth)}}</button></div></div></div></form></div>");
$templateCache.put("app/modules/accounting/taxcomponents.html","<div ng-controller=AccountingTaxcomponentsController class=\"page page-accounting-taxcomponents page--no-tables\"><aside id=filters class=\"page__sidebar sidebar\"><div class=sidebar__header><h4 class=title>{{tools.lang({\'en\': \'Filters\', \'nl\': \'Filters\', \'fr\': \'Filtres\'})}}</h4><button class=\"btn btn-default btn-rounded\"><span class=material-icons ng-click=\"toggleFilters(\'filters\')\">close</span></button></div><div class=sidebar__content><form class=form-horizontal><div class=\"form-group clearfix\"><label class=\"control-label col-sm-12\"><input type=checkbox ng-model=model.hasNoTaxcomponents> {{tools.lang({\'en\':\'Only show not parametrised articles\',\'nl\':\'Enkel niet geparametreerde artikelen tonen\',\'fr\':\'Montrer juste article non-parametre\'})}}</label></div></form></div><div class=sidebar__footer><button type=submit class=\"btn btn-primary\" ng-click=\"toggleFilters(\'filters\');\">{{tools.lang({\'en\': \'Done\', \'nl\': \'Done\', \'fr\': \'Appliquer\'})}}</button></div></aside><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\': \'VAT components\', \'nl\': \'VAT components\', \'fr\': \'Composants TVA\'})}}</h1><div class=header__actions><button class=\"btn btn-default btn-filters\" ng-click=\"toggleFilters(\'filters\')\"><i class=material-icons>filter_list</i> <span class=\"btn__text hidden-xs hidden-sm\">{{tools.lang({ \'en\': \'Filters\', \'nl\': \'Filters\', \'fr\': \'Filtres\' })}}</span></button></div></section><div class=content><div class=content__item ng-hide=webservice.calling><form class=form-horizontal><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Category\',\'nl\':\'Categorie\',\'fr\':\'Cat\\u00E9gorie\'})}}</label><div class=col-sm-10><select class=form-control ng-model=model.category ng-change=\"model.itm=\'\'\"><option value=AC>{{tools.lang({\'en\':\'Activity\',\'nl\':\'Activiteit\',\'fr\':\'Activit\\u00E9\'})}}</option><option value=ME>{{tools.lang({\'en\':\'Meal\',\'nl\':\'Maaltijd\',\'fr\':\'Repas\'})}}</option><option value=PRDCT>{{tools.lang({\'en\':\'Product\',\'nl\':\'Product\',\'fr\':\'Produit\'})}}</option><option value=HS>{{tools.lang({\'en\':\'Accommodation\',\'nl\':\'Accommodatie\',\'fr\':\'H\\u00E9bergement\'})}}</option><option value=HP>{{tools.lang({\'en\':\'Accommodation product\',\'nl\':\'Accommodatie product\',\'fr\':\'H\\u00E9bergement produit\'})}}</option><option value=\"\">{{tools.lang({\'en\':\'Other\',\'nl\':\'Andere\',\'fr\':\'Autre\'})}}</option></select></div></div><div ng-if=\"model.category==\'AC\'\"><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Activity\',\'nl\':\'Activiteit\',\'fr\':\'Activit\\u00E9\'})}}</label><div class=col-sm-10><select class=form-control ng-model=model.act ng-change=\"model.itm=\'\'\" ng-options=\"row.id as tools.label(row) for row in getActivities() | orderBy:\'label\'+user.lang\"></select></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Formula\',\'nl\':\'Formule\',\'fr\':\'Formule\'})}}</label><div class=col-sm-10><select class=form-control ng-model=model.itm ng-options=\"row.id as tools.label(row) for row in getFormulas() | orderBy:\'label\'+user.lang\"></select></div></div></div><div ng-if=\"model.category==\'ME\'\"><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Restaurant\',\'nl\':\'Restaurant\',\'fr\':\'Restaurant\'})}}</label><div class=col-sm-10><select class=form-control ng-model=model.res ng-change=\"model.itm=\'\'\" ng-options=\"row.id as tools.label(row) for row in getRestaurants() | orderBy:\'label\'+user.lang\"></select></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Meal\',\'nl\':\'Maaltijd\',\'fr\':\'Repas\'})}}</label><div class=col-sm-10><select class=form-control ng-model=model.itm ng-options=\"row.id as tools.label(row) for row in getMeals(model.res) | orderBy:\'label\'+user.lang\"></select></div></div></div><div class=\"form-group clearfix\" ng-if=\"model.category==\'PRDCT\'\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Product\',\'nl\':\'Product\',\'fr\':\'Produit\'})}}</label><div class=col-sm-10><select class=form-control ng-model=model.itm ng-options=\"row.id as tools.lang(row) for row in getProducts() | orderBy:user.lang\"></select></div></div><div ng-if=\"model.category==\'HS\'\"><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Hotel\',\'nl\':\'Hotel\',\'fr\':\'Hotel\'})}}</label><div class=col-sm-10><select class=form-control ng-model=model.htl ng-change=\"model.itm=\'\'\" ng-options=\"row.id as tools.label(row) for row in getHotels() | orderBy:\'label\'+user.lang\"></select></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Type\',\'nl\':\'Type\',\'fr\':\'Type\'})}}</label><div class=col-sm-10><select class=form-control ng-model=model.itm ng-options=\"row.id as tools.label(row) for row in getHotelspacecategories() | orderBy:\'label\'+user.lang\"></select></div></div></div><div ng-if=\"model.category==\'HP\'\"><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Hotel\',\'nl\':\'Hotel\',\'fr\':\'Hotel\'})}}</label><div class=col-sm-10><select class=form-control ng-model=model.htl ng-change=\"model.itm=\'\'\" ng-options=\"row.id as tools.label(row) for row in getHotels() | orderBy:\'label\'+user.lang\"></select></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Product\',\'nl\':\'Product\',\'fr\':\'Produit\'})}}</label><div class=col-sm-10><select class=form-control ng-model=model.itm ng-options=\"row.id as tools.label(row) for row in getHotelproducts() | orderBy:\'label\'+user.lang\"></select></div></div></div><div class=\"form-group clearfix\" ng-if=\"model.category==\'\'\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Other\',\'nl\':\'Andere\',\'fr\':\'Autre\'})}}</label><div class=col-sm-10><select class=form-control ng-model=model.itm ng-options=\"row.id as tools.label(row) for row in [{\'id\':\'ZDOWNPAY\',\'labelen\':\'Down payment\',\'labelnl\':\'Voorschot\',\'labelfr\':\'Acompte\'},{\'id\':\'ZDOWNSPL\',\'labelen\':\'Down payment split bill\',\'labelnl\':\'Voorschot split bill\',\'labelfr\':\'Acompte split bill\'}]\"></select></div></div></form><ul class=list-group><li class=list-group-item ng-repeat=\"taxcomponent in tools.match(model.taxcomponents,{\'itm\':model.category+(model.category==\'AC\' && parameters.ACT[model.act].field5!=\'1\'?model.act:model.itm)}) | orderBy:\'itm\'\"><input edit ng-hide=taxcomponent.editing ng-click=editTaxcomponent(taxcomponent)> <span><span ng-show=taxcomponent.editing>{{tools.lang({\'en\':\'Supplier division\',\'nl\':\'Leverancier divisie\',\'fr\':\'Fournisseur division\'})}}:<select ng-model=taxcomponent.supplierdvs ng-options=\"row.id as tools.label(row) for row in parameters.notDelArrayDVS | orderBy:\'id\'\"></select></span><span ng-hide=taxcomponent.editing>{{tools.label(parameters.DVS[taxcomponent.supplierdvs])}} </span></span><span><span ng-show=taxcomponent.editing>{{tools.lang({\'en\':\'VAT\',\'nl\':\'BTW\',\'fr\':\'TVA\'})}}:<select ng-model=taxcomponent.vat ng-options=\"row.id as row.field1+\'%\' for row in parameters.notDelArrayVAT | orderBy:\'id\'\"></select></span><span ng-hide=taxcomponent.editing>{{parameters.VAT[taxcomponent.vat].field1}}% </span></span><span><span ng-show=taxcomponent.editing>{{tools.lang({\'en\':\'Part\',\'nl\':\'Aandeel\',\'fr\':\'Part\'})}}: <input type=text ng-model=taxcomponent.part size=8> </span><span ng-hide=taxcomponent.editing>{{tools.amountOut(taxcomponent.part)+\'/\'+tools.amountOut(tools.sum(tools.match(model.taxcomponents,{\'itm\':model.category+(model.category==\'AC\' && parameters.ACT[model.act].field5!=\'1\'?model.act:model.itm)}),\'part\'))}} </span></span><span><span ng-show=taxcomponent.editing>{{tools.lang({\'en\':\'Account\',\'nl\':\'Rekening\',\'fr\':\'Compte\'})}}: <input type=text ng-model=taxcomponent.accountcode size=8> </span><span ng-hide=taxcomponent.editing>{{taxcomponent.accountcode}} </span></span><span><span ng-show=taxcomponent.editing>{{tools.lang({\'en\':\'Cost center\',\'nl\':\'Cost center\',\'fr\':\'Cost center\'})}}: <input type=text ng-model=taxcomponent.costcenter size=6> </span><span ng-hide=taxcomponent.editing>{{taxcomponent.costcenter}} </span></span><span><span ng-show=taxcomponent.editing>{{tools.lang({\'en\':\'Cost unit\',\'nl\':\'Cost unit\',\'fr\':\'Cost unit\'})}}: <input type=text ng-model=taxcomponent.costunit size=6> </span><span ng-hide=taxcomponent.editing>{{taxcomponent.costunit}} </span></span><span><span ng-show=taxcomponent.editing>{{tools.lang({\'en\':\'Product code\',\'nl\':\'Product code\',\'fr\':\'Code produit\'})}}: <input type=text ng-model=taxcomponent.productcode size=12> </span><span ng-hide=taxcomponent.editing>{{taxcomponent.productcode}} </span></span><input class=\"btn btn-danger\" delete ng-hide=taxcomponent.editing ng-click=deleteTaxcomponent(taxcomponent)> <span ng-show=taxcomponent.editing><input class=\"btn btn-success\" update ng-click=updateTaxcomponent(taxcomponent)> <input class=\"btn btn-warning\" cancel ng-click=cancelTaxcomponent(taxcomponent)></span></li><li class=list-group-item ng-show=\"getItm()!=\'\'\">{{tools.lang({\'en\':\'Supplier division\',\'nl\':\'Leverancier divisie\',\'fr\':\'Fournisseur division\'})}}:<select ng-model=model.taxcomponent.supplierdvs ng-options=\"row.id as tools.label(row) for row in parameters.notDelArrayDVS | orderBy:\'id\'\"></select>{{tools.lang({\'en\':\'VAT\',\'nl\':\'BTW\',\'fr\':\'TVA\'})}}:<select ng-model=model.taxcomponent.vat ng-options=\"row.id as row.field1+\'%\' for row in parameters.notDelArrayVAT | orderBy:\'id\'\"></select>{{tools.lang({\'en\':\'Part\',\'nl\':\'Aandeel\',\'fr\':\'Part\'})}}: <input type=text ng-model=model.taxcomponent.part size=8> {{tools.lang({\'en\':\'Account\',\'nl\':\'Rekening\',\'fr\':\'Compte\'})}}: <input type=text ng-model=model.taxcomponent.accountcode size=6> {{tools.lang({\'en\':\'Cost center\',\'nl\':\'Cost center\',\'fr\':\'Cost center\'})}}: <input type=text ng-model=model.taxcomponent.costcenter size=8> {{tools.lang({\'en\':\'Cost unit\',\'nl\':\'Cost unit\',\'fr\':\'Cost unit\'})}}: <input type=text ng-model=model.taxcomponent.costunit size=6> {{tools.lang({\'en\':\'Product code\',\'nl\':\'Product code\',\'fr\':\'Code produit\'})}}: <input type=text ng-model=model.taxcomponent.productcode size=12> <input create ng-click=createTaxcomponent();></li></ul></div><div class=\"content__item page__loader\" ng-show=webservice.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div></div></main></div>");
$templateCache.put("app/modules/activities/activityOverview.html","<div ng-controller=ActivitiesActivityOverviewController class=\"page page-activities-overview page--tables\"><aside id=filters class=\"page__sidebar sidebar\"><div class=sidebar__header><h4 class=title>{{tools.lang({\'en\': \'Filters\', \'nl\': \'Filters\', \'fr\': \'Filtres\'})}}</h4><button class=\"btn btn-default btn-rounded\"><span class=material-icons ng-click=\"toggleFilters(\'filters\')\">close</span></button></div><div class=sidebar__content><form class=form-horizontal><div class=\"form-group clearfix\"><div class=col-xs-6><label class=control-label ng-click=\"model.startdateOpened=!model.startdateOpened\">{{tools.lang({\'en\':\'Date start\',\'nl\':\'Start\',\'fr\':\'Date de d\\u00E9but\'})}}</label><div class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.startdate is-open=model.startdateOpened datepicker-options=model.dateOptions ng-click=\"model.startdateOpened=!model.startdateOpened\"><div class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.startdateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></div></div></div><div class=col-xs-6><label class=control-label ng-click=\"model.enddateOpened=!model.enddateOpened\">{{tools.lang({\'en\':\'Date end\',\'nl\':\'Einde\',\'fr\':\'Date de fin\'})}}</label><div class=\"input-group col-sm-12\"><input type=text class=form-control uib-datepicker-popup ng-model=model.enddate is-open=model.enddateOpened datepicker-options=model.dateOptions ng-click=\"model.enddateOpened=!model.enddateOpened\"><div class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.enddateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></div></div></div></div><div class=\"form-group clearfix\"><div class=col-xs-6><label class=control-label>{{tools.lang({\'en\':\'Hour from\',\'nl\':\'Uur\',\'fr\':\'Heure début\'})}}</label><select class=form-control ng-model=model.startHrs ng-options=\"hrs.id as tools.label(hrs) for hrs in tools.addElement(parameters.HRS,any)\"></select></div><div class=col-xs-6><label class=control-label>{{tools.lang({\'en\':\'Hour to\',\'nl\':\'Tot\',\'fr\':\'Heure fin\'})}}</label><select class=form-control ng-model=model.endHrs ng-options=\"hrs.id as tools.label(hrs) for hrs in tools.addElement(parameters.HRS,any)\"></select><div class=btn-group></div></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-12 control-label\">{{tools.lang({\'en\':\'Activity\',\'nl\':\'Activiteit\',\'fr\':\'Activit\\u00E9\'})}}</label><div class=col-sm-12><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"act in tools.match(parameters.notDelArrayACT,{\'field4\':\'1\'}) | orderBy:\'id\'\" ng-click=\"model.act=act.id;load();\" ng-class=\"{\'active\':model.act==act.id}\">{{tools.short(act)}}</button></div></div></div><div class=\"form-group clearfix\"><div class=col-sm-12><label class=control-label>{{tools.lang({\'en\':\'Filters\',\'nl\':\'Day\',\'fr\':\'Filtres\'})}}</label><input style=\"margin-bottom: 16px\" type=text placeholder=\"{{tools.lang({\'en\':\'Search\',\'nl\':\'Search\',\'fr\':\'Rechercher\'})}}\" class=form-control ng-model=model.filter><div class=btn-group><button type=button class=\"btn btn-default\" ng-click=todayDate()>{{tools.lang({\'en\':\'Today\',\'nl\':\'Vandaag\',\'fr\':\'Aujourd\\u0027hui\'})}}</button> <button type=button class=\"btn btn-default\" ng-click=increaseDates(-1);>{{tools.lang({\'en\':\'Day earlier\',\'nl\':\'Dag vroeger\',\'fr\':\'Jour avant\'})}}</button> <button type=button class=\"btn btn-default\" ng-click=increaseDates(1);>{{tools.lang({\'en\':\'Day later\',\'nl\':\'Dag later\',\'fr\':\'Jour apres\'})}}</button></div></div></div><div class=\"form-group clearfix\"><div class=col-sm-12><div ng-hide=webservice.calling><div class=checkbox><label><input type=checkbox ng-model=model.unpaid> {{tools.lang({\'en\':\'Unpaid\',\'nl\':\'Onbetaald\',\'fr\':\'Impay\\u00e9\'})}}</label></div><div class=checkbox><label><input type=checkbox ng-model=model.companies> {{tools.lang({\'en\':\'Only companies\',\'nl\':\'Enkel bedrijven\',\'fr\':\'Seulement entreprises\'})}}</label></div><div class=checkbox><label><input type=checkbox ng-model=model.showZero> {{tools.lang({\'en\':\'Show zero participants\',\'nl\':\'Toon nul deelnemers\',\'fr\':\'Montrer zero participants\'})}}</label></div></div></div></div></form></div><div class=sidebar__footer><button type=submit class=\"btn btn-primary\" ng-click=\"load(); toggleFilters(\'filters\');\">{{tools.lang({\'en\': \'Done\', \'nl\': \'Done\', \'fr\': \'Appliquer\'})}}</button></div></aside><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\':\'Activities\',\'nl\':\'Activities\',\'fr\':\'Activités\'})}}</h1><div class=header__actions><div class=\"page__actions hidden-xs hidden-sm\"><button type=button class=\"btn btn-default\" ng-click=increaseDates(-1);><span class=material-icons>chevron_left</span></button> <span class=h5>{{tools.lang({\'en\': \'Day\', \'nl\': \'Day\', \'fr\': \'Jour\'})}}</span> <button type=button class=\"btn btn-default\" ng-click=increaseDates(1);><span class=material-icons>chevron_right</span></button></div><button class=\"btn btn-default btn-filters\" ng-click=\"toggleFilters(\'filters\')\"><i class=material-icons>filter_list</i> <span class=\"btn__text hidden-xs hidden-sm\">{{tools.lang({ \'en\': \'Filters\', \'nl\': \'Filters\', \'fr\': \'Filtres\' })}}</span></button></div></section><div class=content><div class=\"content__item c-table-view\" ng-hide=webservice.calling><div class=c-table-view__item ng-repeat=\"date in model.dates | orderBy:\'id\':false\"><div class=c-table-view__item__content ng-repeat=\"slt in date.slts | orderBy:\'id\'\"><h4 class=c-table-view__title>{{date.id+\' \'+tools.dateToWeekday(date.id)+\' \'+tools.label(parameters.SLT[slt.id])}}</h4><div class=table-responsive-wrapper><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><thead><tr><th><span class=th__content>{{tools.lang({\'en\':\'Activity\',\'nl\':\'Activiteit\',\'fr\':\'Activit\\u00E9\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Quantity\',\'nl\':\'Quantity\',\'fr\':\'Quantit\\u00E9\'})}}</span></th><th ng-repeat=\"unt in model.unts | orderBy:\'id\'\"><span class=th__content>{{tools.short(unt)}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Name\',\'nl\':\'Naam\',\'fr\':\'Nom\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Accommodation\',\'nl\':\'Accommodation\',\'fr\':\'Logement\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Departure\',\'nl\':\'Vertrek\',\'fr\':\'D\\u00E9part\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Comment\',\'nl\':\'Opmerking\',\'fr\':\'Remarque\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Status\',\'nl\':\'Status\',\'fr\':\'Statut\'})}}</span></th></tr></thead><tbody><tr ng-show=\"model.filter==\'\'\"><td ng-click=visitRetrieve(activity.visit) colspan=2></td><td ng-click=visitRetrieve(activity.visit)><b>{{activitiesService.countParticipants(tools.join(slt.activities,\'participants\',model),model)}}</b></td><td ng-click=visitRetrieve(activity.visit) ng-repeat=\"unt in model.unts | orderBy:\'id\'\"><b>{{tools.notZero(tools.sum(tools.inverseJoin(tools.match(tools.join(slt.activities,\'participants\',model),{\'unt\':unt.id}),\'items\',\'item\',model),\'quantity\'))}}</b></td><td ng-click=visitRetrieve(activity.visit) colspan=5></td></tr><tr ng-repeat=\"activity in getActivities(slt.activities) | orderBy:\'hrs\'\" ng-class=\"{\'info\':model.visits[activity.visit].vis==\'COM\',\'warning\':tools.sum(tools.inverseJoin(tools.match(tools.join(activity,\'participants\',model),{\'unt\':\'VTT***EM\'}),\'items\',\'item\',model),\'quantity\')>0}\"><td ng-click=visitRetrieve(activity.visit)><div class=colored><span class=colored ng-style=\"{\'background-color\':activitiesService.getColour(activity)}\"><span ng-hide=\"parameters.ACT[activity.frm.substr(0,3)].field3==\'1\'\">{{activitiesService.formulaOut(activity)}} </span><span ng-show=\"parameters.ACT[activity.frm.substr(0,3)].field3==\'1\'\">{{activity.quotationtitle}}</span></span></div></td><td ng-click=visitRetrieve(activity.visit)>{{activitiesService.countParticipants(tools.join(activity,\'participants\',model),model)}}</td><td ng-click=visitRetrieve(activity.visit) ng-repeat=\"unt in model.unts | orderBy:\'id\'\">{{tools.notZero(tools.sum(tools.inverseJoin(tools.match(tools.join(activity,\'participants\',model),{\'unt\':unt.id}),\'items\',\'item\',model),\'quantity\'))}}</td><td ng-click=visitRetrieve(activity.visit)>{{model.visits[activity.visit].name}}</td><td ng-click=visitRetrieve(activity.visit)>{{tools.short(parameters.LOD[model.visits[activity.visit].lod])}}</td><td ng-click=visitRetrieve(activity.visit)>{{tools.hourOut(activity.hrs)}}</td><td ng-click=visitRetrieve(activity.visit)><span class=\"glyphicon glyphicon-file color-primary\" ng-show=\"model.visits[activity.visit].comment!=\'\'\" title={{model.visits[activity.visit].comment}} data-toggle=tooltip data-placement=left tooltip></span>{{activity.comment}}</td><td ng-click=visitRetrieve(activity.visit)>{{tools.label(activitiesService.convertStat(model.visits[activity.visit].stat,activity.stat))}}</td></tr></tbody></table></div></div></div></div></div><div class=\"content__item page__loader\" ng-show=webservice.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div></div><div class=page__actions><button type=button class=\"btn btn-default\" ng-click=increaseDates(-1);><span class=material-icons>chevron_left</span></button> <span class=h5>{{tools.lang({\'en\': \'Day\', \'nl\': \'Day\', \'fr\': \'Jour\'})}}</span> <button type=button class=\"btn btn-default\" ng-click=increaseDates(1);><span class=material-icons>chevron_right</span></button></div></main></div>");
$templateCache.put("app/modules/activities/agenda.html","<div ng-controller=ActivitiesAgendaController class=\"page page-activities-agenda page--tables\"><aside id=filters class=\"page__sidebar sidebar\"><div class=sidebar__header><h4 class=title>{{tools.lang({\'en\':\'Filters\',\'nl\':\'Filters\',\'fr\':\'Filtres\'})}}</h4><button class=\"btn btn-default btn-rounded\"><span class=material-icons ng-click=\"toggleFilters(\'filters\')\">close</span></button></div><div class=sidebar__content><form class=form-horizontal><div class=\"form-group clearfix\"><label class=\"col-sm-12 control-label\" ng-click=\"model.startdateOpened=!model.startdateOpened\">{{tools.lang({\'en\':\'Start\',\'nl\':\'Start\',\'fr\':\'D\\u00E9but\'})}}</label><div class=col-sm-12><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.startdate is-open=model.startdateOpened datepicker-options=model.dateOptions ng-click=\"model.startdateOpened=!model.startdateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.startdateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><label class=\"col-sm-12 control-label\" ng-click=\"model.enddateOpened=!model.enddateOpened\">{{tools.lang({\'en\':\'End\',\'nl\':\'Einde\',\'fr\':\'Fin\'})}}</label><div class=col-sm-12><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.enddate is-open=model.enddateOpened datepicker-options=model.dateOptions ng-click=\"model.enddateOpened=!model.enddateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.enddateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-12 control-label\">{{tools.lang({\'en\':\'From\',\'nl\':\'Van\',\'fr\':\'De\'})}}</label><div class=col-sm-12><select class=form-control ng-model=model.startHrs ng-options=\"hrs.id as tools.label(hrs) for hrs in tools.addElement(parameters.HRS,any)\"></select></div><label class=\"col-sm-12 control-label\">{{tools.lang({\'en\':\'To\',\'nl\':\'Tot\',\'fr\':\'À\'})}}</label><div class=col-sm-12><select class=form-control ng-model=model.endHrs ng-options=\"hrs.id as tools.label(hrs) for hrs in tools.addElement(parameters.HRS,any)\"></select><div class=btn-group></div></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-12 control-label\">{{tools.lang({\'en\':\'Activity\',\'nl\':\'Activiteit\',\'fr\':\'Activit\\u00E9\'})}}</label><div class=col-sm-12><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"act in tools.match(parameters.notDelArrayACT,{\'field4\':\'1\'}) | orderBy:\'id\'\" ng-click=\"model.act=act.id;selectAct();\" ng-class=\"{\'active\':model.act==act.id || oneIsActive(act.id)}\" uib-tooltip={{tools.label(act)}} tooltip-placement=bottom tooltip-popup-delay=150 tooltip-class=info>{{tools.short(act)}}</button></div></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-12 control-label\"><span ng-show=\"model.act==\'\'\">{{tools.lang({\'en\':\'Formula\',\'nl\':\'Formule\',\'fr\':\'Formule\'})}}</span> <span ng-hide=\"model.act==\'\'\">{{tools.label(parameters.ACT[model.act])}}</span></label><div class=col-sm-12 ng-show=\"model.act!=\'\'\"><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"frm in activitiesService.activityFilter(parameters.notDelFRM,\'id\',model.act) | orderBy:\'id\'\" ng-click=selectFrm(frm.id) ng-class=\"{\'active\':model.frms.indexOf(frm.id)>=0}\">{{tools.short(frm)}}</button></div><div style=\"margin-top: 16px\" ng-show=\"tools.getLength(activitiesService.activityFilter(parameters.notDelFRM,\'id\',model.act))>1\"><button type=button class=\"btn btn-default\" ng-click=swapAll(false)><span class=\"glyphicon glyphicon-minus\"></span></button> <button type=button class=\"btn btn-default\" ng-click=swapAll(true)><span class=\"glyphicon glyphicon-plus\"></span></button></div></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-12 control-label\">{{tools.lang({\'en\':\'Selected\',\'nl\':\'Geselecteerd\',\'fr\':\'S\\u00E9lectionn\\u00E9\'})}}</label><div class=col-sm-12><p class=form-control-static ng-hide=\"tools.getLength(model.frms)>0\">{{tools.lang({\'en\':\'All activities\',\'nl\':\'Alle activiteiten\',\'fr\':\'Toutes les activit\\u00E9s\'})}}</p><div ng-show=\"tools.getLength(model.frms)>0\"><div class=btn-group><button type=button class=\"btn btn-default active\" ng-repeat=\"frm in model.frms | orderBy:\'toString()\'\" ng-click=selectFrm(frm)>{{tools.short(parameters.ACT[tools.substr(frm,0,3)])+\' \'+tools.short(parameters.FRM[frm])}}</button></div><button type=button class=\"btn btn-primary\" style=\"margin-top: 16px\" ng-click=\"model.frms=[];model.act=\'\'\">{{tools.lang({\'en\':\'All activities\',\'nl\':\'Alle activiteiten\',\'fr\':\'Toutes les activit\\u00E9s\'})}}</button></div></div></div><div class=\"form-group clearfix\"><div class=col-sm-12><div ng-hide=webservice.calling><div class=row style=\"margin-bottom: 16px\"><div class=col-sm-12><label><input type=checkbox ng-model=model.unpaid> {{tools.lang({\'en\':\'Unpaid\',\'nl\':\'Onbetaald\',\'fr\':\'Impay\\u00e9\'})}}</label><label style=\"margin-left: 16px\"><input type=checkbox ng-model=model.companies> {{tools.lang({\'en\':\'Only companies\',\'nl\':\'Enkel bedrijven\',\'fr\':\'Seulement entreprises\'})}}</label></div></div></div></div></div><div class=\"form-group clearfix\"><div class=col-sm-12><div class=col-sm-12><div class=\"form-group clearfix\"><label>{{tools.lang({\'en\':\'Name\',\'nl\':\'Naam\',\'fr\':\'Nom\'})}} :</label><input type=text class=form-control ng-model=model.filters.name></div><div class=\"form-group clearfix\"><label>{{tools.lang({\'en\':\'Creation date of visit\',\'nl\':\'Aanmaakdatum van het bezoek\',\'fr\':\'Date de cr\\u00E9ation de la visite\'})}} :</label><div class=\"form-group clearfix\"><label class=\"col-sm-12 control-label\" ng-click=\"model.filters.creationDate.startdateOpened=!model.filters.creationDate.startdateOpened\">{{tools.lang({\'en\':\'Start\',\'nl\':\'Start\',\'fr\':\'D\\u00E9but\'})}}</label><div class=col-sm-12><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.filters.creationDate.startdate is-open=model.filters.creationDate.startdateOpened datepicker-options=model.dateOptions ng-click=\"model.filters.creationDate.startdateOpened=!model.filters.creationDate.startdateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.filters.creationDate.startdateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><label class=\"col-sm-12 control-label\" ng-click=\"model.filters.creationDate.enddateOpened=!model.filters.creationDate.enddateOpened\">{{tools.lang({\'en\':\'End\',\'nl\':\'Einde\',\'fr\':\'Fin\'})}}</label><div class=col-sm-12><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.filters.creationDate.enddate is-open=model.filters.creationDate.enddateOpened datepicker-options=model.dateOptions ng-click=\"model.filters.creationDate.enddateOpened=!model.filters.creationDate.enddateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.filters.creationDate.enddateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div><div class=\"form-group clearfix\"><label>{{tools.lang({\'en\':\'Origin of the visit\',\'nl\':\'Oorsprong van het bezoek\',\'fr\':\'Origine de la visite\'})}}</label><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"vis in parameters.notDelArrayVIS | orderBy:\'tools.label(vis)\'\" ng-click=\"vis.selected =! vis.selected\" ng-class=\"{\'active\':vis.selected}\">{{tools.label(vis)}}</button></div><button type=button class=\"btn btn-default\" ng-click=resetVisitOrigins()>{{tools.lang({\'en\':\'All origins\',\'nl\':\'Alle origins\',\'fr\':\'Toutes les origines\'})}}</button></div><div class=\"form-group clearfix\"><label><input type=checkbox ng-model=model.showZero> {{tools.lang({\'en\':\'Show zero participants\',\'nl\':\'Toon nul deelnemers\',\'fr\':\'Montrer zero participants\'})}}</label></div></div></div></div></form></div><div class=sidebar__footer><button type=submit class=\"btn btn-primary\" ng-click=\"load(); toggleFilters(\'filters\');\">{{tools.lang({\'en\':\'Done\',\'nl\':\'Done\',\'fr\':\'Appliquer\'})}}</button></div></aside><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\':\'Activities agenda\',\'nl\':\'Activities agenda\',\'fr\':\'Activités\'})}}</h1><div class=header__actions><div class=search-wrapper style=margin-right:10px><span style=\"cursor: pointer\" class=material-icons ng-click=load()>qr_code_scanner</span> <input type=text class=\"form-control search__input input input--search\" ng-model=model.ticketNr ng-enter=load(); placeholder=\"{{tools.lang({\'en\':\'Scan\',\'nl\':\'Scan\',\'fr\':\'Scan\'})}}\"></div><div class=\"page__actions hidden-xs hidden-sm\"><button type=button class=\"btn btn-default\" ng-click=increaseDates(-1);><span class=material-icons>chevron_left</span></button> <button type=button class=\"btn btn-default\" style=\"width: auto\" ng-click=todayDate()>{{tools.lang({\'en\':\'Today\',\'nl\':\'Vandaag\',\'fr\':\'Aujourd\\u0027hui\'})}}</button> <button type=button class=\"btn btn-default\" ng-click=increaseDates(1);><span class=material-icons>chevron_right</span></button></div><button class=\"btn btn-default btn-filters\" ng-click=\"toggleFilters(\'filters\')\"><i class=material-icons>filter_list</i> <span class=\"btn__text hidden-xs hidden-sm\">{{tools.lang({\'en\':\'Filters\',\'nl\':\'Filters\',\'fr\':\'Filtres\'})}}</span></button></div></section><div class=content><div class=\"content__item c-table-view\" ng-hide=webservice.calling><div class=c-table-view__item ng-repeat=\"date in model.dates | orderBy:\'id\':false\"><div class=c-table-view__item__content ng-repeat=\"slt in date.slts | orderBy:\'id\'\"><h4 class=c-table-view__title>{{date.id+\' \'+tools.dateToWeekday(date.id)+\' \'+tools.label(parameters.SLT[slt.id])}}</h4><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><thead><tr><th><span class=th__content></span></th><th><span class=th__content>{{tools.lang({\'en\':\'Activity\',\'nl\':\'Activiteit\',\'fr\':\'Activit\\u00E9\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Quantity\',\'nl\':\'Quantity\',\'fr\':\'Quantité\'})}}</span></th><th ng-repeat=\"unt in model.unts | orderBy:\'id\'\">{{tools.short(unt)}}<span class=th__content></span></th><th><span class=th__content>{{tools.lang({\'en\':\'Name\',\'nl\':\'Naam\',\'fr\':\'Nom\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Accommodation\',\'nl\':\'Accommodation\',\'fr\':\'Logement\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Departure\',\'nl\':\'Vertrek\',\'fr\':\'D\\u00E9part\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Comment\',\'nl\':\'Opmerking\',\'fr\':\'Remarque\'})}}</span></th><th colspan=2><span class=th__content>{{tools.lang({\'en\':\'Status\',\'nl\':\'Status\',\'fr\':\'Statut\'})}}</span></th></tr></thead><tbody><tr ng-show=\"model.filters.name==\'\'\"><td colspan=2></td><td><b>{{activitiesService.countParticipants(tools.join(slt.activities,\'participants\',model),model)}}</b></td><td ng-repeat=\"unt in model.unts | orderBy:\'id\'\"><b>{{tools.notZero(tools.sum(tools.inverseJoin(tools.match(tools.join(slt.activities,\'participants\',model),{\'unt\':unt.id}),\'items\',\'item\',model),\'planningquantity\'))}}</b></td><td colspan=5></td></tr><tr ng-repeat=\"activity in getActivities(slt.activities) | orderBy:\'hrs\'\" ng-class=\"{\'info\':model.visits[activity.visit].vis==\'COM\' && model.visits[activity.visit].attention!=\'1\',\'danger\':model.visits[activity.visit].attention==\'1\'}\"><td><button retrieve ng-click=visitRetrieve(activity.visit);></button></td><td><div class=colored><span class=colored ng-style=\"{\'background-color\':activitiesService.getColour(activity)}\"><span ng-hide=\"parameters.ACT[activity.frm.substr(0,3)].field3==\'1\' && activity.quotationtitle!=\'\'\">{{activitiesService.formulaOut(activity)}} </span><span ng-show=\"parameters.ACT[activity.frm.substr(0,3)].field3==\'1\' && activity.quotationtitle!=\'\'\">{{activity.quotationtitle}}</span></span></div></td><td>{{activitiesService.countParticipants(tools.join(activity,\'participants\',model),model)}}</td><td ng-repeat=\"unt in model.unts | orderBy:\'id\'\">{{tools.notZero(tools.sum(tools.inverseJoin(tools.match(tools.join(activity,\'participants\',model),{\'unt\':unt.id}),\'items\',\'item\',model),\'planningquantity\'))}}</td><td>{{contactsService.getName(model.contacts[model.visits[activity.visit].owningcontact])}}</td><td><span ng-repeat=\"htl in activity.accomodations\">{{tools.short(parameters.HTL[htl])}}</span></td><td>{{tools.hourOut(activity.hrs)}}</td><td><span class=\"glyphicon glyphicon-file color-primary\" ng-show=\"model.visits[activity.visit].comment!=\'\'\" title={{model.visits[activity.visit].comment}} data-toggle=tooltip data-placement=left tooltip></span> <span ng-hide=activity.editing>{{activity.comment}} <input edit class=\"btn btn-default btn-rounded\" ng-click=editComment(activity)> </span><span ng-show=activity.editing><form><input type=text class=form-control ng-model=activity.comment> <input class=\"btn btn-success\" update ng-click=updateComment(activity)> <input class=\"btn btn-warning\" cancel ng-click=cancelComment(activity)></form></span></td><td>{{tools.label(activitiesService.convertStat(model.visits[activity.visit].stat,activity.stat))}}</td><td><div ng-show=\"activity.stat==1000\"><button type=button class=\"btn btn-success\" ng-click=\"updateActivityStat(activity,\'3000\')\"><span class=btn__text>{{tools.lang({\'en\':\'Started\',\'nl\':\'Gestart\',\'fr\':\'Commenc\\u00E9\'})}}</span></button></div><div ng-hide=\"activity.stat==1000\">{{tools.label(parameters.STO[this.tools.expandDigits(activity.stat,4)])}} <button type=button class=\"btn btn-warning\" ng-click=\"updateActivityStat(activity,\'1000\')\"><span class=btn__text>{{tools.lang({\'en\':\'Reset\',\'nl\':\'Reset\',\'fr\':\'Réinitialiser\'})}}</span></button></div></td></tr></tbody></table></div></div></div></div><div class=\"content__item page__loader\" ng-show=webservice.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div></div><div class=page__actions><button type=button class=\"btn btn-default\" ng-click=increaseDates(-1);><span class=material-icons>chevron_left</span></button> <button type=button class=\"btn btn-default\" style=\"width: auto\" ng-click=todayDate()>{{tools.lang({\'en\':\'Today\',\'nl\':\'Vandaag\',\'fr\':\'Aujourd\\u0027hui\'})}}</button> <button type=button class=\"btn btn-default\" ng-click=increaseDates(1);><span class=material-icons>chevron_right</span></button></div></main></div>");
$templateCache.put("app/modules/activities/createForEmp.html","<div ng-controller=ActivitiesCreateForEmpController class=\"page page-activities-create-for-employees page--content\"><div ng-include=\"\'app/modules/activities/edit.html\'\"></div></div>");
$templateCache.put("app/modules/activities/createForGreenfields.html","<div ng-controller=ActivitiesCreateForGreenfieldsController class=\"page-activity-create-greenfields page--content\"><section class=page__heading><h1>{{tools.lang({\'en\':\'Create for Greenfields\',\'nl\':\'Create for Greenfields\',\'fr\':\'Créer pour Greenfields\'})}}</h1></section><section class=\"alert alert-info\">{{tools.lang({\'en\':\'This screen is for Greenfields reservations. If you are not taking a Greenfields reservation you should use the screen\',\'nl\':\'Dit scherm is voor Greenfields reservaties. Als je geen reservatie voor Greenfields aan het reserveren bent, dan moet je het volgende scherm gebruiken\',\'fr\':\'Cet ecran est pour des reservations Greenfields. Si tu n\\u0027es pas entrain de prendre une reservation pour Greenfields c\\u0027est important d\\u0027utiliser l\\u0027ecran\'})}}: <a ng-href=\"#!/{{buildHref(\'activities\',\'createForEmp\')}}\">{{tools.lang({\'en\':\'Create\',\'nl\':\'Aanmaken\',\'fr\':\'Cr\\u00E9er\'})}}</a></section><div ng-include=\"\'app/modules/activities/createForEmp.html\'\"></div></div>");
$templateCache.put("app/modules/activities/createForHotton.html","<div ng-controller=ActivitiesCreateForHottonController class=\"page-activity-create-hotton page--content\"><section class=page__heading><h1>{{tools.lang({\'en\':\'Create for Hotton\',\'nl\':\'Create for Hotton\',\'fr\':\'Créer pour Hotton\'})}}</h1></section><section class=\"alert alert-info\">{{tools.lang({\'en\':\'This screen is for Hotton. If you are not working in Hotton you should use the screen\',\'nl\':\'Dit scherm is voor Hotton. Als je niet in Hotton werkt, dan moet je het volgende scherm gebruiken\',\'fr\':\'Cet ecran est pour Hotton. Si tu n\\u0027es pas stationn\\u00E9 \\u00E0 Hotton c\\u0027est important d\\u0027utiliser l\\u0027ecran\'})}}: <a ng-href=\"#!/{{buildHref(\'activities\',\'createForEmp\')}}\">{{tools.lang({\'en\':\'Create\',\'nl\':\'Aanmaken\',\'fr\':\'Cr\\u00E9er\'})}}</a></section><div ng-include=\"\'app/modules/activities/createForEmp.html\'\"></div></div>");
$templateCache.put("app/modules/activities/createForLabyrinthe.html","<div ng-controller=ActivitiesCreateForLabyrintheController class=\"page-activity-create-greenfields page--content\"><section class=page__heading><h1>{{tools.lang({\'en\':\'Create for Labyrinthe\',\'nl\':\'Create for Labyrinthe\',\'fr\':\'Créer pour Labyrinthe\'})}}</h1></section><section class=\"alert alert-info\">{{tools.lang({\'en\':\'This screen is for Labyrinthe reservations. If you are not taking a Labyrinthe reservation you should use the screen\',\'nl\':\'Dit scherm is voor Labyrinthe reservaties. Als je geen reservatie voor Labyrinthe aan het reserveren bent, dan moet je het volgende scherm gebruiken\',\'fr\':\'Cet ecran est pour des reservations Labyrinthe. Si tu n\\u0027es pas entrain de prendre une reservation pour Labyrinthe c\\u0027est important d\\u0027utiliser l\\u0027ecran\'})}}: <a ng-href=\"#!/{{buildHref(\'activities\',\'createForEmp\')}}\">{{tools.lang({\'en\':\'Create\',\'nl\':\'Aanmaken\',\'fr\':\'Cr\\u00E9er\'})}}</a></section><div ng-include=\"\'app/modules/activities/createForEmp.html\'\"></div></div>");
$templateCache.put("app/modules/activities/createForTakeAway.html","<div ng-controller=ActivitiesCreateForTakeAwayController class=\"page-activity-create-takeAway page--content\"><div ng-controller=ActivitiesCreateForEmpController><section class=page__heading><h1>{{tools.lang({\'en\':\'Create for Take-Away\',\'nl\':\'Create for Take-Away\',\'fr\':\'Créer pour Take-Away\'})}}</h1></section><section class=\"alert alert-info\">{{tools.lang({\'en\':\'This screen is for Take-Away reservations. If you are not taking a Take-Away reservation you should use the screen\',\'nl\':\'Dit scherm is voor Take-Away reservaties. Als je geen reservatie voor de Take-Away aan het opnemen bent, dan moet je het volgende scherm gebruiken\',\'fr\':\'Cet ecran est pour des reservations Take-Away. Si tu n\\u0027es pas entrain de prendre une reservation pour le Take-Away c\\u0027est important d\\u0027utiliser l\\u0027ecran\'})}}: <a ng-href=\"#!/{{buildHref(\'activities\',\'createForEmp\')}}\">{{tools.lang({\'en\':\'Create\',\'nl\':\'Aanmaken\',\'fr\':\'Cr\\u00E9er\'})}}</a></section><div ng-include=\"\'app/modules/activities/edit.html\'\"></div></div></div>");
$templateCache.put("app/modules/activities/edit.html","<div ng-controller=ActivitiesEditController class=\"page-activity-create page page-activities-edit page--content\"><section class=\"sticky-bar-bottom clearfix\" ng-if=\"model.task!=\'t\' && model.task!=\'d\'\"><div class=row><div class=col-sm-7><div class=\"form-group clearfix\"><div class=col-xs-12><div class=create-buttons ng-show=\"model.task==\'c\' || (model.task==\'r\' && model.visit.stat<3000)\"><button type=button class=\"btn btn-default\" ng-click=createActivity();createVisitElement();><span class=\"glyphicon glyphicon-plus-sign\"></span> {{tools.lang({\'en\':\'Activity\',\'nl\':\'Activiteit\',\'fr\':\'Activit\\u00E9\'})}}</button> <button type=button class=\"btn btn-default\" ng-click=createMeal(true);createVisitElement();><span class=\"glyphicon glyphicon-plus-sign\"></span> {{tools.lang({\'en\':\'Meal\',\'nl\':\'Maaltijd\',\'fr\':\'Repas\'})}}</button> <button type=button class=\"btn btn-default\" ng-click=createHotelreservationcategory();createVisitElement();><span class=\"glyphicon glyphicon-plus-sign\"></span> {{tools.lang({\'en\':\'Accommodation\',\'nl\':\'Overnachting\',\'fr\':\'H\\u00E9bergement\'})}}</button> <button type=button class=\"btn btn-default\" ng-click=createProduct();createVisitElement();><span class=\"glyphicon glyphicon-plus-sign\"></span> {{tools.lang({\'en\':\'Product\',\'nl\':\'Product\',\'fr\':\'Produit\'})}}</button> <button type=button class=\"btn btn-default\" ng-click=openPacketModal()><span class=\"glyphicon glyphicon-plus-sign\"></span> {{tools.lang({\'en\':\'Packet\',\'nl\':\'Pakket\',\'fr\':\'Paquet\'})}}</button> <button type=button class=\"btn btn-default\" ng-show=\"model.owningContact.iscompany==\'1\' && model.communicationContact.id==\'0\' && model.communicationContact.dummy && model.task==\'r\'\" ng-click=addContact();><span class=\"glyphicon glyphicon-plus-sign\"></span>{{tools.lang({\'en\':\'Contact\',\'nl\':\'Contactpersoon\',\'fr\':\'Contact\'})}}</button></div></div></div></div><div class=col-sm-5><div ng-show=\"model.task==\'r\'\" class=\"text-right collapse-buttons\"><button class=\"btn btn-default\" ng-click=toggleAll(true)>{{tools.lang({\'en\':\'Show all\',\'nl\':\'Show all\',\'fr\':\'Tout d\\u00E9plier\'})}} <span class=\"glyphicon glyphicon-chevron-down\"></span></button> <button class=\"btn btn-default\" ng-click=toggleAll(false)>{{tools.lang({\'en\':\'Collapse all\',\'nl\':\'Collapse all\',\'fr\':\'Tout masquer\'})}} <span class=\"glyphicon glyphicon-chevron-up\"></span></button> <button type=button class=\"btn btn-default\" ng-show=\"(model.itemCountWithZeroQuantity>1 && model.showVisitElementsWithZeroQuantity) || model.itemCountWithoutZeroQuantity>1\" ng-click=startEditAll()><span class=\"glyphicon glyphicon-pencil\"></span> {{tools.lang({\'en\':\'All\',\'nl\':\'Alles\',\'fr\':\'Tout\'})}}</button><!-- \n          <button type=\"button\" class=\"btn btn-danger\" ng-show=\"model.itemCountWithoutZeroQuantity>1 && model.visit.stat<3000\"\n            ng-click=\"startDeleteAll()\">\n            <span class=\"glyphicon glyphicon-trash\"></span>\n            {{tools.lang({\'en\':\'All\',\'nl\':\'Alles\',\'fr\':\'Tout\'})}}\n          </button>\n --> <button type=button class=\"btn btn-default\" ng-show=\"tools.getLength(selectedElements)>0 && model.visit.stat<3000\" ng-click=massEditVisitElementsModal()><span class=\"glyphicon glyphicon-wrench\"></span> {{tools.lang({\'en\':\'Selection\',\'nl\':\'Selectie\',\'fr\':\'Selection\'})}}</button><!-- Don\'t use this button until everybody knows about it! \n          <div class=\"checkbox\" ng-show=\"(model.itemCountWithZeroQuantity-model.itemCountWithoutZeroQuantity)>0\">\n            <label>\n              <input type=\"checkbox\" ng-model=\"model.showVisitElementsWithZeroQuantity\" ng-change=\"sortVisitElements()\"/>\n              {{tools.lang({\'en\':\'Show zero participants\',\'nl\':\'Toon nul deelnemers\',\'fr\':\'Afficher zero participants\'})}}\n            </label>\n          </div>\n--></div><div class=\"form-group clearfix\" ng-show=!webservice.calling><div class=col-sm-12><div class=text-right><div ng-show=\"model.task==\'u\' && model.editingCount>1\"><button type=button class=\"btn btn-default\" ng-click=cancelAllVisitElements();>{{tools.lang({\'en\':\'Cancel\',\'nl\':\'Annuleer\',\'fr\':\'Annuler\'})}}</button> <button type=button class=\"btn btn-primary\" ng-click=updateVisitRecords();>{{tools.lang({\'en\':\'Confirm\',\'nl\':\'Bevestig\',\'fr\':\'Confirmer\'})}}</button></div><div ng-show=\"model.task==\'u\' && model.owningContact.editing && (model.communicationContact.editing || (model.communicationContact.id==\'0\' && model.existingCommunicationContact.id!==\'0\'))\"><button type=button class=\"btn btn-default\" ng-click=cancelAllContactEdits();>{{tools.lang({\'en\':\'Cancel\',\'nl\':\'Annuleer\',\'fr\':\'Annuler\'})}}</button> <button type=button class=\"btn btn-primary\" ng-click=updateVisitAndContacts();>{{tools.lang({\'en\':\'Confirm\',\'nl\':\'Bevestig\',\'fr\':\'Confirmer\'})}}</button></div><button ng-show=\"model.task==\'c\'\" type=submit class=\"btn btn-success\" ng-click=createVisit();>{{tools.lang({\'en\':\'Create\',\'nl\':\'Aanmaken\',\'fr\':\'Cr\\u00E9er\'})}}</button></div></div></div><div class=\"form-group clearfix\" ng-show=webservice.calling><div class=col-sm-12><div ng-show=webservice.calling>Loading...</div></div></div></div></div></section><section class=page__filters ng-if=\"!(model.task==\'t\' && model.visit.id>0)\" style=\"min-width: 100%\"><!-- owningContact --><div outdoor-contact model=model contact-name=owning contact-wording=\"tools.lang({\'en\':\'Client *\',\'nl\':\'Klant *\',\'fr\':\'Client *\'})\" on-update=\"model.visit.owningcontact=model.owningContact.id;updateVisit();\" contact-readonly=\"ctep.status!=\'idle\'\" contact-is-editable=false contact-is-changeable=\"model.task===\'c\' || model.task===\'t\' || model.task===\'d\'\" contact-retrieve=contactRetrieve></div><!-- communicationContact --><div outdoor-contact model=model contact-name=communication contact-wording=\"tools.lang({\'en\':\'Contact\',\'nl\':\'Contactpersoon\',\'fr\':\'Contact\'})\" on-update=\"model.visit.communicationcontact=model.communicationContact.id;updateVisit();\" contact-readonly=\"ctep.status!=\'idle\'\" contact-is-editable=false contact-is-changeable=\"model.task===\'c\' || model.task===\'t\' || model.task===\'d\' || tools.xor(model.owningContact.editing,(model.communicationContact.editing || (model.communicationContact.id!==\'0\' && model.existingCommunicationContact.id!==\'0\')))\" contact-retrieve=contactRetrieve></div><!-- visit --><form class=form-horizontal><div class=\"panel panel-default\"><div class=panel-heading ng-show=\"model.task==\'r\' || model.task==\'t\' || !model.visit.editing\"><div class=row><div class=col-xs-8 ng-click=\"model.visit.isOpen=tools.xor(model.visit.created && model.task==\'r\',model.visit.isOpen);\"><h3 class=panel__title><span ng-show=\"model.visit.startdateISO!=model.visit.enddateISO\">{{tools.lang({\'en\':\'From\',\'nl\':\'Van\',\'fr\':\'De\'})}}</span> {{tools.dateOut(model.visit.startdate)}} <span ng-show=\"model.visit.startdateISO!=model.visit.enddateISO\">{{tools.lang({\'en\':\'until\',\'nl\':\'tot\',\'fr\':\'a\'})+\' \'+tools.dateOut(model.visit.enddate)}}</span> <span class=glyphicon ng-show=\"model.visit.created && model.task==\'r\'\" ng-class=\"{\'glyphicon-chevron-up\': model.visit.isOpen, \'glyphicon-chevron-down\': !model.visit.isOpen}\"></span></h3></div><div class=\"col-xs-4 text-right\" ng-show=\"model.task==\'r\'\"><button edit ng-click=startVisitEdit()></button></div></div></div><div uib-collapse=!model.visit.isOpen><div class=panel-body><div class=\"form-group clearfix\" ng-show=\"model.task!=\'r\' && model.view!=\'createQuotation\'\"><div class=col-xs-12><div class=checkbox><label><input type=checkbox ng-model=model.visit.advancedAttributes> {{tools.lang({\'en\':\'More fields for visit\',\'nl\':\'Meer velden voor bezoek\',\'fr\':\'Plus de champs pour visite\'})}}</label></div></div></div><div class=\"form-group clearfix\" ng-show=\"model.task!=\'r\' || model.visit.startdateISO!=model.visit.enddateISO\"><!-- visit.startdate --><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Arrival date\',\'nl\':\'Aankomstdatum\',\'fr\':\'Date d\\u0027arriv\\u00E9e\'})}}</label><div class=col-md-4><div class=input-group ng-show=\"model.task==\'c\' || model.task==\'d\' || model.view==\'createQuotation\' || model.task==\'u\'\"><input type=text autocomplete=off class=form-control uib-datepicker-popup ng-model=model.visit.startdate is-open=model.startdateOpened datepicker-options=model.dateOptions ng-click=\"model.startdateOpened=tools.xor(model.task==\'c\' || model.task==\'d\' || model.view==\'createQuotation\' || model.task==\'u\',model.startdateOpened)\"> <span class=input-group-btn ng-click=\"model.startdateOpened=tools.xor(model.task==\'c\' || model.task==\'d\' || model.view==\'createQuotation\' || model.task==\'u\',model.startdateOpened)\"><button type=button class=\"btn btn-default\"><span class=\"glyphicon glyphicon-calendar\"></span></button></span></div><input ng-hide=\"model.task==\'c\' || model.task==\'d\' || model.view==\'createQuotation\' || model.task==\'u\'\" type=text autocomplete=off class=form-control readonly value={{tools.dateFromJava(model.visit.startdate)}}></div><!-- visit.enddate --><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Departure date\',\'nl\':\'Vertrekdatum\',\'fr\':\'Date de d\\u00E9part\'})}}</label><div class=col-md-4><div class=input-group ng-show=\"model.task==\'c\' || model.task==\'d\' || model.view==\'createQuotation\' || model.task==\'u\'\"><input type=text autocomplete=off class=form-control uib-datepicker-popup ng-model=model.visit.enddate is-open=model.enddateOpened datepicker-options=model.dateOptions ng-click=\"model.enddateOpened=tools.xor(model.task==\'c\' || model.task==\'d\' || model.view==\'createQuotation\' || model.task==\'u\',model.enddateOpened)\"> <span class=input-group-btn ng-click=\"model.enddateOpened=tools.xor(model.task==\'c\' || model.task==\'d\' || model.view==\'createQuotation\' || model.task==\'u\',model.enddateOpened)\"><button type=button class=\"btn btn-default\"><span class=\"glyphicon glyphicon-calendar\"></span></button></span></div><input ng-hide=\"model.task==\'c\' || model.task==\'d\' || model.view==\'createQuotation\' || model.task==\'u\'\" type=text autocomplete=off class=form-control readonly value={{tools.dateFromJava(model.visit.enddate)}}></div></div><!-- visit.dvs  --><div class=\"form-group clearfix\" ng-show=\"model.task!=\'r\' || parameters.DVS[model.visit.dvs].field4!=\'1\'\"><div class=col-sm-12><label class=control-label>{{tools.lang({\'en\':\'Company\',\'nl\':\'Bedrijf\',\'fr\':\'Entreprise\'})}}</label><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"row in tools.addMatchingElement(parameters.DVS,tools.toArray(parameters.combinationFilter(parameters.notDelDVS,\'ROLDVSA\',user.role)),{\'id\':model.visit.dvs}) | orderBy:\'short\'+user.lang\" ng-click=\"model.visit.dvs=row.id\" ng-class=\"{\'active\':model.visit.dvs==row.id}\" ng-show=\"model.task!=\'r\' || model.visit.dvs==row.id\" ng-disabled=\"model.task==\'r\'\">{{tools.short(row)}}</button></div></div></div><div uib-collapse=\"!((model.visit.advancedAttributes || model.task==\'r\') || parameters.VIS[model.visit.vis].field1==\'1\')\"><!-- visit.tco  --><div class=\"form-group clearfix\" ng-show=\"model.task!=\'r\' || parameters.TCO[model.visit.tco].field5!=\'1\'\"><div class=col-sm-12><label class=control-label>{{tools.lang({\'en\':\'Brand template\',\'nl\':\'Merk template\',\'fr\':\'Marque template\'})}}</label><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"row in tools.addMatchingElement(parameters.TCO,parameters.notDelArrayTCO,{\'id\':model.visit.tco}) | orderBy:\'id\'\" ng-click=\"model.visit.tco=row.id\" ng-class=\"{\'active\':model.visit.tco==row.id}\" ng-show=\"model.task!=\'r\' || model.visit.tco==row.id\" ng-disabled=\"model.task==\'r\'\">{{tools.label(row)}}</button></div></div></div><div class=\"form-group clearfix\" ng-show=\"parameters.VIS[model.visit.vis].field1==\'1\'\"><div class=col-xs-12><label for=visitQuotationparticipants class=control-label>{{tools.lang({\'en\':\'Participants\',\'nl\':\'Deelnemers\',\'fr\':\'Participants\'})}}</label><input type=number autocomplete=off id=visitQuotationparticipants class=form-control ng-readonly=\"model.task==\'r\'\" ng-model=model.visit.quotationparticipants placeholder=\"{{tools.lang({\'en\':\'Participants\',\'nl\':\'Deelnemers\',\'fr\':\'Participants\'})}}\"></div></div><div class=\"form-group clearfix\" ng-show=\"parameters.VIS[model.visit.vis].field1==\'1\'\"><div class=col-xs-12><div class=checkbox><label><input type=checkbox ng-model=model.visit.quotationpriceperperson ng-false-value=\"\'0\'\" ng-true-value=\"\'1\'\" ng-disabled=\"model.task==\'r\'\"> {{tools.lang({\'en\':\'Price per person\',\'nl\':\'Prijs per persoon\',\'fr\':\'Prix par personne\'})}}</label></div></div></div><div class=\"form-group clearfix\" ng-show=\"parameters.VIS[model.visit.vis].field1==\'1\'\"><div class=col-xs-12><div class=checkbox><label><input type=checkbox ng-model=model.visit.quotationdetailedprice ng-false-value=\"\'0\'\" ng-true-value=\"\'1\'\" ng-disabled=\"model.task==\'r\'\"> {{tools.lang({\'en\':\'Detailed price\',\'nl\':\'Gedetailleerde prijs\',\'fr\':\'Prix detaill\\u00E9\'})}}</label></div></div></div><div class=\"form-group clearfix\" ng-show=\"model.task!=\'r\' || model.visit.comment!=\'\'\"><div class=col-xs-12><label for=visitComment class=control-label><span>{{tools.lang({\'en\':\'Comment for\',\'nl\':\'Opmerking\',\'fr\':\'Remarque\'})}} </span><span>{{tools.lang({\'en\':\'employees\',\'nl\':\'werknemers\',\'fr\':\'employees\'})}}</span></label><textarea id=visitComment class=form-control ng-model=model.visit.comment rows=3 ng-disabled=\"model.task==\'r\'\"></textarea></div></div><div class=\"form-group clearfix\" ng-show=\"parameters.VIS[model.visit.vis].field1==\'1\' && model.visit.stat<3000\"><div class=col-xs-12><label for=visitQuotationcomment class=control-label><span>{{tools.lang({\'en\':\'Comment for\',\'nl\':\'Opmerking\',\'fr\':\'Remarque\'})}} </span><span>{{tools.lang({\'en\':\'the client\',\'nl\':\'voor de klant\',\'fr\':\'pour le client\'})}}</span></label><textarea id=visitQuotationcomment class=form-control ng-model=model.visit.quotationcomment rows=3 ng-disabled=\"model.task==\'r\'\"></textarea></div></div><div class=\"form-group clearfix\" ng-show=\"parameters.VIS[model.visit.vis].field1==\'1\' && model.visit.stat<3000\"><div class=col-xs-12><label for=visitQuotationnotincluded class=control-label>{{tools.lang({\'en\':\'Not included\',\'nl\':\'Niet inbegrepen\',\'fr\':\'Pas inclus\'})}}</label><textarea id=visitQuotationnotincluded class=form-control ng-model=model.visit.quotationnotincluded rows=3 ng-disabled=\"model.task==\'r\'\"></textarea></div></div><div class=\"form-group clearfix\" ng-show=\"parameters.VIS[model.visit.vis].field1==\'1\' && model.visit.stat<3000\"><div class=col-xs-12><label for=visitQuotationoptions class=control-label>{{tools.lang({\'en\':\'Up selling options\',\'nl\':\'Up selling options\',\'fr\':\'Up selling options\'})}}</label><textarea id=visitQuotationoptions class=form-control ng-model=model.visit.quotationoptions rows=3 ng-disabled=\"model.task==\'r\'\"></textarea></div></div><!-- visit.quotationmanager --><div class=\"form-group clearfix\" ng-show=\"parameters.VIS[model.visit.vis].field1==\'1\'\"><div class=col-xs-12><label class=control-label><span>{{tools.lang({\'en\':\'Manager\',\'nl\':\'Manager\',\'fr\':\'Manager\'})}}</span></label><select id=quotationmanager class=form-control ng-model=model.visit.quotationmanager ng-disabled=\"model.task==\'r\'\" ng-options=\"right.user as right.user_name for right in tools.match(model.rights,{\'rgh\':\'QUOT\'})\"></select></div></div><!-- visit.operationsmanager --><div class=\"form-group clearfix\" ng-show=\"parameters.VIS[model.visit.vis].field1==\'1\'\"><div class=col-xs-12><label class=control-label><span>{{tools.lang({\'en\':\'Operations Manager\',\'nl\':\'Uitvoerings Verantwoordelijke\',\'fr\':\'Responsable Exc\\u00E9cution\'})}}</span></label><select id=operationsmanager class=form-control ng-model=model.visit.operationsmanager ng-disabled=\"model.task==\'r\'\" ng-options=\"right.user as right.user_name for right in tools.match(model.rights,{\'rgh\':\'OPEM\'})\"></select></div></div><!-- visit.invoicesmanager --><div class=\"form-group clearfix\" ng-show=\"parameters.VIS[model.visit.vis].field1==\'1\'\"><div class=col-xs-12><label class=control-label><span>{{tools.lang({\'en\':\'Invoices Manager\',\'nl\':\'Facturatie Verantwoordelijke\',\'fr\':\'Responsable Facturation\'})}}</span></label><select id=invoicesmanager class=form-control ng-model=model.visit.invoicesmanager ng-disabled=\"model.task==\'r\'\" ng-options=\"right.user as right.user_name for right in tools.match(model.rights,{\'rgh\':\'INVM\'})\"></select></div></div><div class=\"form-group clearfix\" ng-show=\"parameters.VIS[model.visit.vis].field1==\'1\'\"><div class=col-xs-12><div class=checkbox><label><input type=checkbox ng-model=model.visit.attention ng-false-value=\"\'0\'\" ng-true-value=\"\'1\'\" ng-disabled=\"model.task==\'r\'\"> {{tools.lang({\'en\':\'Increased attention\',\'nl\':\'Verhoogde aandacht\',\'fr\':\'Attention accrue\'})}}</label></div></div></div></div><div class=\"form-group clearfix\" ng-show=\"parameters.VIS[model.visit.vis].field1==\'1\' && model.visit.stat<2000\"><div class=col-xs-12><div class=checkbox><label><input type=checkbox ng-model=model.visit.hotelexternalreservation ng-false-value=\"\'0\'\" ng-true-value=\"\'1\'\" ng-disabled=\"!model.visit.editing || model.validated || webservice.calling\"> {{tools.lang({\'en\':\'Reserve rooms\',\'nl\':\'Kamers reserveren\',\'fr\':\'R\\u00E9server chambres\'})}}</label></div></div></div><!-- advancedVisitAttributes --><div class=\"form-group clearfix\" ng-show=\"model.task!=\'r\' && model.view==\'createQuotation\'\"><div class=col-xs-12><div class=checkbox><label><input type=checkbox ng-model=model.visit.advancedAttributes> {{tools.lang({\'en\':\'More fields for visit\',\'nl\':\'Meer velden voor bezoek\',\'fr\':\'Plus de champs pour visite\'})}}</label></div></div></div><div ng-show=\"model.visit.advancedAttributes || model.task==\'r\'\"><!-- visit.vis  --><div class=\"form-group clearfix\" ng-hide=\"model.task==\'r\' && model.visit.vis==\'DAD\'\"><div class=col-xs-12><label for=visitVis class=control-label>{{tools.lang({\'en\':\'Origin\',\'nl\':\'Oorsprong\',\'fr\':\'Origine\'})}}</label><select ng-hide=model.visit.isCreated id=visitVis class=form-control ng-model=model.visit.vis ng-options=\"vis.id as tools.label(vis) for vis in tools.toArray(parameters.combinationFilter(parameters.notDelVIS,\'ROLVISA\',user.role)) | orderBy:\'id\'\"></select><p ng-show=model.visit.isCreated class=form-control-static>{{tools.label(parameters.VIS[model.visit.vis])}}</p></div></div><!-- visit.lod --><div class=\"form-group clearfix\" ng-show=\"model.task!=\'r\' || model.visit.lod!=\'XXX\'\"><div class=col-xs-12><label for=visitLod class=control-label>{{tools.lang({\'en\':\'Lodging\',\'nl\':\'Verblijf\',\'fr\':\'Logement\'})}}</label><select ng-show=\"model.task!=\'r\'\" id=visitLod class=form-control ng-model=model.visit.lod ng-options=\"lod.id as tools.label(lod) for lod in parameters.notDelArrayLOD | orderBy:\'id\'\"></select><input ng-hide=\"model.task!=\'r\'\" type=text autocomplete=off class=form-control value={{tools.label(parameters.LOD[model.visit.lod])}} readonly></div></div></div><!-- visit.refundaccount --><div class=\"form-group clearfix\" ng-show=\"model.task!=\'c\' && model.task!=\'t\' && model.task!=\'d\' && (model.visit.refundaccount!=\'\' || model.toPay<0)\"><div class=col-xs-12><label for=visitRefundaccount class=control-label>{{tools.lang({\'en\':\'Account\',\'nl\':\'Rekening\',\'fr\':\'Compte\'})}}</label><input type=text autocomplete=off id=visitRefundaccount class=form-control ng-readonly=\"model.task==\'r\' || model.visit.stat>=3000\" ng-model=model.visit.refundaccount></div></div><!-- reductionMode --><div class=\"form-group clearfix\" ng-show=\"!model.validated && model.task!=\'t\'\"><div class=col-xs-12><label class=radio-inline><input type=radio ng-model=model.reductionMode value=automatic ng-change=\"model.visit.automaticreduction=\'1\';model.visit.reductionpro=\'FREE\';model.visit.reductionamount=\'0\';model.visit.reductionpercent=\'1\';calculatePrices();\"> {{tools.lang({\'en\':\'Automatic reduction\',\'nl\':\'Automatische korting\',\'fr\':\'Reduction automatique\'})}}</label><label class=radio-inline ng-show=\"model.task==\'c\'\"><input type=radio ng-model=model.reductionMode value=global ng-change=\"model.visit.automaticreduction=\'0\';syncReductions();\"> {{tools.lang({\'en\':\'Manual global reduction\',\'nl\':\'Manuele globale korting\',\'fr\':\'Reduction manuelle globale\'})}}</label><label class=radio-inline><input type=radio ng-model=model.reductionMode value=item ng-change=\"model.visit.automaticreduction=\'0\'\"> {{tools.lang({\'en\':\'Manual reduction per item\',\'nl\':\'Manuele korting per item\',\'fr\':\'Reduction manuelle par article\'})}}</label></div><div class=col-xs-12 ng-show=\"model.task==\'c\' && model.reductionMode==\'global\'\"><!-- visit.reductionpro --><div class=\"form-group clearfix\"><div class=col-xs-12><label for=visitReductionpro class=control-label>{{tools.lang({\'en\':\'Reduction type\',\'nl\':\'Type korting\',\'fr\':\'Type de reduction\'})}}</label><select id=visitReductionpro class=form-control ng-model=model.visit.reductionpro ng-change=syncReductions() ng-options=\"row.id as tools.label(row) for row in parameters.notDelArrayPRO | orderBy:\'id\'\"></select></div></div><!-- visit.reductionamount --><div class=\"form-group clearfix\"><div class=col-xs-12><label for=visitReductionamount class=control-label>{{tools.lang({\'en\':\'Reduction quantity\',\'nl\':\'Hoeveelheid korting\',\'fr\':\'Quantit\\u00E9 de reduction\'})}}</label><div class=input-group><input type=text autocomplete=off id=visitReductionamount class=form-control ng-model=model.visit.reductionamount ng-change=syncReductions()> <span class=input-group-addon>%</span></div></div></div></div><div class=col-xs-12 ng-show=\"model.task!==\'r\' && model.reductionMode==\'automatic\'\"><!-- visit.campaign --><div class=\"form-group clearfix\"><div class=col-xs-12><label for=visitCampaign class=control-label>{{tools.lang({\'en\':\'Discount code\',\'nl\':\'Kortingscode\',\'fr\':\'Code de r\\u00E9duction\'})}}</label><select id=visitCampaign class=form-control ng-model=model.visit.campaign ng-change=syncReductions() ng-options=\"row.code as row.description for row in tools.toArray(model.campaigns) | orderBy:\'description\'\"></select></div></div></div></div><!-- visit.stat --><div class=\"form-group clearfix\" ng-show=\"model.task!=\'c\' && model.task!=\'t\' && model.task!=\'d\'\"><div class=col-xs-12><label class=control-label>{{tools.lang({\'en\':\'Status\',\'nl\':\'Status\',\'fr\':\'Statut\'})}}</label><p class=form-control-static>{{tools.label(parameters.STV[model.visit.stat])}}</p></div></div><div class=\"form-group clearfix\" ng-show=\"model.task==\'u\' && model.visit.editing && model.editingCount==1\"><div class=\"col-md-offset-2 col-md-10\"><div ng-show=!webservice.calling><button type=submit class=\"btn btn-primary\" ng-click=updateVisit();>{{tools.lang({\'en\':\'Confirm\',\'nl\':\'Bevestig\',\'fr\':\'Confirmer\'})}}</button> <button type=button class=\"btn btn-default\" ng-click=cancelVisitEdit();>{{tools.lang({\'en\':\'Cancel\',\'nl\':\'Annuleer\',\'fr\':\'Annuler\'})}}</button></div><div ng-show=webservice.calling>Loading...</div></div></div><div ng-show=\"model.task==\'r\'\">{{tools.lang({\'en\':\'Created\',\'nl\':\'Aangemaakt\',\'fr\':\'Cr\\u00E9\\u00E9\'})}} <i>{{tools.doneBy(model.visit.created,model.visit.creator_name)}}</i></div></div></div></div></form><!-- end visit --></section><form class=form-horizontal ng-show=\"model.task==\'t\' && tools.getLength(model.visitElements)>0 && model.mode==\'transfer\'\"><div class=\"form-group clearfix\"><div class=col-xs-12><b>{{tools.lang({\'en\':\'Selected amount:\',\'nl\':\'Geselecteerd bedrag:\',\'fr\':\'Montant select\\u00E9:\'})}}</b> {{tools.amountOut(getSelectedAmount())+\'€\'}}&nbsp;<small><i ng-show=\"model.visit.automaticreduction==\'1\'\">{{tools.lang({\'en\':\'This is an estimated amount, reductions can be recalculated afterwards\',\'nl\':\'Dit is een ingeschat bedrag, kortingen kunnen herberekend worden achteraf\',\'fr\':\'Ceci est une valeur estimer, r\\u00E9ductions peuvent \\u00EAtre recalculer apr\\u00E8s\'})}}</i></small></div><div class=col-xs-12><div class=checkbox><label><input type=checkbox ng-model=model.visit.editQuantities> {{tools.lang({\'en\':\'Adjust quantities for the articles to be transfered\',\'nl\':\'Aantallen aanpassen voor de over te zetten artikelen\',\'fr\':\'Ajuster les quantit\\u00E9s des articles \\u00E0 transf\\u00E9rer\'})}}</label></div></div></div></form><main ng-show=\"((model.task!=\'t\' && model.task!=\'d\') || (model.task==\'t\' && model.visit.editQuantities)) && tools.getLength(model.visitElements)>0\" role=main class=content style=\"min-width: 100%\"><div class=table-responsive-wrapper><table class=\"table table-create\" style=\"margin-top: 30px\"><thead ng-hide=\"tools.getLength(tools.match(model.visitElements,{\'editing\':true}))>0 || model.task===\'c\'\"><th class=text-center><input type=checkbox ng-model=model.selectAllVisitElements on-change=setSelectedElements() ng-hide=\"model.task!==\'r\' || model.visit.stat>=3000\" checkbox-all child-list=getVisitElementsChildList(model.visitElements) property=selected></th><th class=text-center><span class=glyphicon></span></th><th>{{tools.lang({\'en\':\'Date\',\'nl\':\'Date\',\'fr\':\'Date\'})}}</th><th class=text-center>{{tools.lang({\'en\':\'Hour\',\'nl\':\'Hour\',\'fr\':\'Heure\'})}}</th><th>{{tools.lang({\'en\':\'Location / Activity\',\'nl\':\'Location / Activity\',\'fr\':\'Lieu / Activit\\u00E9\'})}}</th><th>{{tools.lang({\'en\':\'Details\',\'nl\':\'Details\',\'fr\':\'D\\u00E9tails\'})}}</th><th>{{tools.lang({\'en\':\'Remarq\',\'nl\':\'Opmerking\',\'fr\':\'Remarque\'})}}</th><th></th></thead><tbody><!-- visitElements --><tr ng-repeat-start=\"visitElement in model.visitElements\" ng-class=\"{\'danger\':visitElement.table==\'hotelreservationcategories\' && tools.getLength(tools.match(tools.join(visitElement,\'hotelspaceassignments\',model),{\'assignedspace\':\'0\'}))>0}\"><td class=text-center><input type=checkbox ng-model=visitElement.selected on-change=setSelectedElements() ng-hide=\"model.task!==\'r\' || model.visit.stat>=3000\" checkbox-all child-list=getVisitElementsChildList([visitElement]) property=selected></td><td class=text-center><span class=glyphicon ng-show=\"!visitElement.editing && model.task==\'r\'\" ng-click=\"visitElement.isOpen=tools.xor(model.task==\'r\',visitElement.isOpen);\" ng-class=\"{\'glyphicon-chevron-up\':visitElement.isOpen,\'glyphicon-chevron-down\':!visitElement.isOpen}\"></span></td><td ng-click=\"visitElement.isOpen=tools.xor(model.task==\'r\',visitElement.isOpen);\"><div ng-show=\"!visitElement.editing && visitElement.table!==\'products\' && visitElement.firstInDay\">{{tools.birthDateOut(tools.dateFromJava(visitElement.day))}}</div><h3 ng-show=!visitElement.isCreated><span ng-show=\"visitElement.table==\'activities\'\">{{tools.lang({\'en\':\'Activity\',\'nl\':\'Activiteit\',\'fr\':\'Activit\\u00E9\'})}}</span> <span ng-show=\"visitElement.table==\'meals\'\">{{tools.lang({\'en\':\'Meal\',\'nl\':\'Maaltijd\',\'fr\':\'Repas\'})}}</span> <span ng-show=\"visitElement.table==\'hotelreservationcategories\'\">{{tools.lang({\'en\':\'Accommodation\',\'nl\':\'Overnachting\',\'fr\':\'H\\u00E9bergement\'})}}</span> <span ng-show=\"visitElement.table==\'products\'\">{{tools.lang({\'en\':\'Product\',\'nl\':\'Product\',\'fr\':\'Produit\'})}}</span></h3></td><td ng-click=\"visitElement.isOpen=tools.xor(model.task==\'r\',visitElement.isOpen);\" class=text-center><div ng-hide=\"visitElement.editing || visitElement.table==\'products\'\">{{visitElement.hrs.substr(0,5)}}</div></td><td ng-click=\"visitElement.isOpen=tools.xor(model.task==\'r\',visitElement.isOpen);\"><span ng-show=\"visitElement.isCreated && !(visitElement.table==\'activities\' && visitElement.editing && !model.validated && parameters.ACT[visitElement.act].field3==\'1\')\">{{visitElement.name}}</span></td><td ng-click=\"visitElement.isOpen=tools.xor(model.task==\'r\',visitElement.isOpen);\"><span ng-show=\"visitElement.isCreated && !(visitElement.table==\'activities\' && visitElement.editing && !model.validated && parameters.ACT[visitElement.act].field3==\'1\')\"><span ng-hide=visitElement.editing>{{visitElement.quantities}}</span> </span><input type=text autocomplete=off class=form-control ng-model=visitElement.quotationtitle placeholder=\"{{tools.lang({\'en\':\'Title of the activity\',\'nl\':\'Titel van de activiteit\',\'fr\':\'Titre de l\\u0027activit\\u00E9\'})}}\" ng-show=\"visitElement.table==\'activities\' && visitElement.editing && !model.validated && parameters.ACT[visitElement.act].field3==\'1\'\"></td><td ng-click=\"visitElement.isOpen=tools.xor(model.task==\'r\',visitElement.isOpen);\"><!-- activity.comment --><div class=comment-readonly ng-show=\"(visitElement.table==\'activities\' || visitElement.table==\'meals\' || visitElement.table==\'products\') && (model.task!=\'r\' || visitElement.comment!=\'\')\"><p>{{ visitElement.comment }}</p></div></td><td><div style=\"text-align: right\"><button delete class=\"btn btn-danger\" ng-show=\"visitElement.editing && !model.validated && model.itemCount>1 && visitElement.hasNoInvoice && (visitElement.table!=\'hotelreservationcategories\' || visitElement.updatePermissions.allowDeletion)\" ng-click=deleteVisitElement(visitElement);></button><div ng-show=\"model.task==\'r\'\"><button edit ng-click=startVisitElementEdit(visitElement) ng-disabled=webservice.calling></button> <button refresh ng-show=\"visitElement.isCreated && visitElement.table==\'hotelreservationcategories\' && visitElement.externalid!==\'\' && model.visit.hotelexternalreservation!==0\" ng-disabled=\"webservice.calling || visitElement.disablesync==\'1\'\" ng-click=syncHotelreservationcategory(visitElement);></button> <button type=button class=\"btn btn-default\" ng-show=\"visitElement.isCreated && visitElement.table==\'hotelreservationcategories\'\" ng-click=startVisitElementEdit(duplicateHotelreservationcategory(visitElement));sortVisitElements(); ng-disabled=webservice.calling><span class=\"glyphicon glyphicon-duplicate\"></span></button></div><button delete class=\"btn btn-danger\" ng-show=\"(visitElement.hasQuantity || visitElement.hasNoInvoice) && visitElement.editing && !model.validated && model.task!=\'t\'\" ng-click=deleteVisitElement(visitElement);></button></div></td></tr><tr ng-if=\"model.validated && visitElement.table==\'hotelreservationcategories\' && (tools.getLength(tools.join(visitElement,\'hotelspaceassignments\',model))<=4 || tools.getLength(tools.match(tools.exclude(tools.join(visitElement,\'hotelspaceassignments\',model),{\'childvisit\':\'0\'}),{\'childvisitIsDeletable\':false}))>0 || visitElement.isOpen)\" ng-repeat=\"hotelspaceassignment in tools.join(visitElement,\'hotelspaceassignments\',model)\" ng-class=\"{\'danger\':visitElement.table==\'hotelreservationcategories\' && tools.getLength(tools.match(tools.join(visitElement,\'hotelspaceassignments\',model),{\'assignedspace\':\'0\'}))>0,\'warning\':hotelspaceassignment.childvisitStat<3000 && hotelspaceassignment.childvisit!==\'0\' && !hotelspaceassignment.childvisitIsDeletable}\"><td colspan=4 style=border-top:none></td><td style=border-top:none><input type=checkbox ng-model=hotelspaceassignment.selected ng-change=setSelectedElements() ng-hide=\"model.task!==\'r\' || model.visit.stat>=3000 || 1>=tools.getLength(tools.join(visitElement,\'hotelspaceassignments\',model))\"></td><td style=border-top:none>{{parameters.HSC[visitElement.requestedhsc].field5+\' \'+model.hotelspaces[hotelspaceassignment.assignedspace].spacenumber}}</td><td style=border-top:none><span ng-show=!hotelspaceassignment.editing>{{hotelspaceassignment.comment}}</span><textarea ng-show=hotelspaceassignment.editing class=form-control ng-model=hotelspaceassignment.editComment ng-change=updateHotelspaceassignmentComment(hotelspaceassignment);>\n              </textarea><button ng-show=!hotelspaceassignment.editing class=\"btn btn-default\" ng-click=\"hotelspaceassignment.editComment=hotelspaceassignment.comment;hotelspaceassignment.editing=true;\"><span class=\"glyphicon glyphicon-comment\"></span></button> <button ng-show=hotelspaceassignment.editing update ng-click=\"updateHotelspaceassignmentComment(hotelspaceassignment);hotelspaceassignment.editing=false;\"></button></td><td style=border-top:none></td></tr><tr ng-repeat-end ng-class=\"{\'danger\':visitElement.table==\'hotelreservationcategories\' && tools.getLength(tools.match(tools.join(visitElement,\'hotelspaceassignments\',model),{\'assignedspace\':\'0\'}))>0}\"><td colspan=8><div uib-collapse=!visitElement.isOpen><span ng-if=visitElement.isOpen><div ng-show=\"visitElement.table==\'hotelreservationcategories\' && tools.getLength(tools.match(tools.join(tools.join(visitElement,\'hotelreservationcategories\',model),\'hotelspaceassignments\',model),{\'assignedspace\':\'0\'}))>0\" class=\"row text-large\"><div class=\"col-md-offset-3 col-md-9\"><strong>{{tools.lang({\'en\':\'A reservation has not been assigned a room. Please check your property management system.\',\'nl\':\'Een reservatie heeft geen toegekende kamer. Gelieve uw property management systeem te raadplegen.\',\'fr\':\'Une reservation n\\u0020a pas \\u00E9t\\u00E9 attribu\\u00E9e une chambre. Veuillez v\\u00E9rifier votre property management system.\'})}}</strong></div></div><div ng-show=\"visitElement.table==\'hotelreservationcategories\' && visitElement.checkedIn\" class=\"row text-large\"><div class=\"col-md-offset-3 col-md-9\"><strong>{{tools.lang({\'en\':\'Please undo check-in in Mews for updating this reservation:\',\'nl\':\'Gelieve de check-in ongedaan te maken in Mews om deze reservatie aan te passen:\',\'fr\':\'Voulez-vous defaire le check-in dans Mews pour adapter cette reservation:\'})}}</strong> <a ng-href=\"{{\'https://\'+(visitElement.htl!=\'CON\'?\'www\':\'demo\')+\'.mews.li/Commander/Reservation/GroupDetail/\'+visitElement.externalid}}\" target=_blank>{{tools.lang({\'en\':\'Undo check-in\',\'nl\':\'Check-in ongedaan maken\',\'fr\':\'Defaire check-in\'})}}</a></div></div><div><!-- activity --><div ng-if=\"visitElement.table==\'activities\'\">{{activity=visitElement;\"\"}}<div ng-show=!activity.isCreated><!-- activity.act --><div class=\"form-group clearfix\"><div class=col-xs-12><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"act in getAvailableActs() | orderBy:\'id\'\" ng-click=selectAct(activity,act); ng-class=\"{\'active\':activity.act==act.id}\" uib-tooltip={{tools.label(act)}} tooltip-placement=bottom tooltip-popup-delay=150 tooltip-class=info>{{tools.short(act)}}</button></div><p class=\"h4 mt16\">{{tools.label(parameters.ACT[activity.act])}}</p></div></div><!-- activity.frm --><div class=\"form-group clearfix\" ng-show=\"tools.getLength(activitiesService.activityFilter(parameters.notDelFRM,\'id\',activity.act))>1\"><div class=col-xs-12><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"frm in activitiesService.activityFilter(parameters.notDelFRM,\'id\',activity.act) | orderBy:\'id\'\" ng-click=\"activity.frm=frm.id;fillParticipants(activity);updateActivityDetails(activity);\" ng-class=\"{\'active\':activity.frm==frm.id}\">{{tools.short(frm)}}</button></div><p class=\"h4 mt16\">{{tools.label(parameters.FRM[activity.frm])}}</p></div></div></div><!-- activity.quotationdescription --><div class=\"form-group clearfix\" ng-show=\"parameters.VIS[model.visit.vis].field1==\'1\' && parameters.ACT[getAct(activity)].field3==\'1\'\"><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Description\',\'nl\':\'Omschrijving\',\'fr\':\'Description\'})}}</label><div class=col-md-10><input type=text class=form-control ng-model=activity.quotationdescription ng-readonly=\"!(activity.editing && !model.validated)\" placeholder=\"{{tools.lang({\'en\':\'Description of the activity for the offer\',\'nl\':\'Omschrijving van de activitieit voor de offerte\',\'fr\':\'Description de l\\u0027activit\\u00E9 pour l\\u0027offre\'})}}\"></div></div><!-- activity.day --><div class=\"form-group clearfix\" ng-show=\"activity.editing && !model.validated\"><label class=\"col-md-2 control-label\" ng-click=\"model.task!=\'t\'?activity.dayOpened=!activity.dayOpened:null;\">{{tools.lang({\'en\':\'Date\',\'nl\':\'Datum\',\'fr\':\'Date\'})}}</label><div class=col-md-10><p ng-class=\"{\'input-group\':model.task!=\'t\'}\"><input type=text autocomplete=off class=form-control uib-datepicker-popup ng-model=activity.day is-open=activity.dayOpened datepicker-options=model.dateOptions ng-click=\"model.task!=\'t\'?activity.dayOpened=!activity.dayOpened:null;\" ng-readonly=\"model.task==\'t\'\"> <span class=input-group-btn ng-show=\"model.task!=\'t\'\"><button type=button class=\"btn btn-default\" ng-click=\"model.task!=\'t\'?activity.dayOpened=!activity.dayOpened:null;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><!-- activity.hrs --><div class=\"form-group clearfix\" ng-if=\"activity.editing && !model.validated\"><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Departure\',\'nl\':\'Vertrek\',\'fr\':\'D\\u00E9part\'})}}</label><div class=col-md-10><span ng-if=\"model.task!=\'t\'\"><div class=btn-group><button type=button ng-class=\"{\'btn btn-default\':activity.availabilities[hrs.hrs].employee!==\'1\',\'btn btn-warning\':activity.availabilities[hrs.hrs].employee==\'1\',\'active\':activity.hrs==hrs.hrs}\" ng-repeat=\"hrs in tools.toArray(activity.availabilities) | orderBy:\'hrs\'\" ng-click=\"activity.hrs=hrs.hrs;\"><div>{{tools.label(parameters.HRS[hrs.hrs])}}</div>&nbsp;<div ng-if=\"hrs.cap>0 && activity.frm!==\'\'\">{{getActivityHrsLoad(activity,hrs)+\'/\'+hrs.cap}}</div>&nbsp;<div class=\"glyphicon glyphicon-warning-sign\" ng-show=\"activity.availabilities[hrs.hrs].employee==\'1\'\" title={{getWarningMessage()}}></div></button></div><div ng-show=\"tools.getLength(activity.availabilities)==0\">{{tools.lang({\'en\':\'No available departure hour. Please change the date.\',\'nl\':\'Geen vertrekuur beschikbaar. Selecteer een andere datum.\',\'fr\':\'Pas de heures de d\\u00E9part disponible. S\\u00E9lectionnez une autre date.\'})}}</div></span><div ng-show=\"model.task==\'t\'\">{{tools.label(parameters.HRS[activity.hrs])}}</div></div></div><!-- participants --><div class=\"form-group clearfix\" ng-repeat=\"participant in activity.joinedParticipants | orderBy:\'unt\'\">{{hideCheckbox=model.task!==\'r\' || model.visit.stat>=3000 || 1>=tools.getLength(activity.joinedParticipants);item=model.items[participant.item];\'\';}}<div class=col-xs-1 ng-hide=hideCheckbox><input type=checkbox ng-model=participant.selected ng-change=setSelectedElements()></div><div ng-class=\"{\'col-xs-12\':hideCheckbox,\'col-xs-11\':!hideCheckbox}\"><item-component visit=model.visit parent-record=participant item=item max-quantity=\"parameters.UNT[participant.unt].field10!=\'\'?(\'max \'+parameters.UNT[participant.unt].field10+\'p\'):\'\'\" available-capacity=\"model.task==\'t\'?item.initialQuantity:getActivityAvailableCapacity(activity,participant)\" can-modify-quantity=true editing=\"!model.validated && activity.editing\" task=model.task can-edit-item-reduction=canEditItemReduction indent=0 can-modify-price=true show-delete=false on-quantity-change=onQuantityChange(participant)></item-component></div></div><!-- activity.comment --><div class=\"form-group clearfix\" ng-show=\"model.task!=\'r\' || activity.comment!=\'\'\"><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Comment\',\'nl\':\'Opmerking\',\'fr\':\'Remarque\'})}}</label><div class=col-md-10><input type=text autocomplete=off class=form-control ng-readonly=\"model.task==\'r\'\" ng-model=activity.comment placeholder=\"{{tools.lang({\'en\':\'Comment\',\'nl\':\'Opmerking\',\'fr\':\'Remarque\'})}}\"></div></div><!-- activity.quotationhidefoto --><div class=\"form-group clearfix\" ng-show=\"parameters.VIS[model.visit.vis].field1==\'1\' && (model.task!=\'r\' || activity.quotationhidefoto==\'1\')\"><div class=\"col-md-offset-2 col-md-10\"><div class=checkbox><label><input type=checkbox ng-model=activity.quotationhidefoto ng-false-value=\"\'0\'\" ng-true-value=\"\'1\'\" ng-disabled=\"model.task==\'r\'\"> {{tools.lang({\'en\':\'Hide foto in offer\',\'nl\':\'Foto verbergen in offerte\',\'fr\':\'Cacher photo dans offre\'})}}</label></div></div></div></div><!-- end of activity --><!-- meal --><div ng-if=\"visitElement.table==\'meals\'\">{{meal=visitElement;\'\';}}<!-- meal.day --><div class=\"form-group clearfix\" ng-show=\"meal.editing && !model.validated\"><label class=\"col-md-2 control-label\" ng-click=\"model.task!=\'t\'?meal.dayOpened=!meal.dayOpened:null;\">{{tools.lang({\'en\':\'Date\',\'nl\':\'Datum\',\'fr\':\'Date\'})}}</label><div class=col-md-10><p ng-class=\"{\'input-group\':model.task!=\'t\'}\"><input type=text autocomplete=off class=form-control uib-datepicker-popup ng-model=meal.day is-open=meal.dayOpened datepicker-options=model.dateOptions ng-click=\"model.task!=\'t\'?meal.dayOpened=!meal.dayOpened:null;\" ng-readonly=\"model.task==\'t\'\"> <span class=input-group-btn ng-show=\"model.task!=\'t\'\"><button type=button class=\"btn btn-default\" ng-click=\"model.task!=\'t\'?meal.dayOpened=!meal.dayOpened:null;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><!-- meal.res --><div class=\"form-group clearfix\" ng-hide=meal.isCreated><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Restaurant\',\'nl\':\'Restaurant\',\'fr\':\'Restaurant\'})}}</label><div class=col-md-10><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"res in parameters.notDelArrayRES | orderBy:\'id\'\" ng-click=\"meal.res=res.id;setMealCategories(meal);updateMealDetails(meal);\" ng-class=\"{\'active\':meal.res==res.id}\">{{tools.short(res)}}</button></div></div></div><!-- meal.hrs --><div class=\"form-group clearfix\" ng-show=\"meal.editing && !model.validated\"><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Arrival time\',\'nl\':\'Aankomsttijd\',\'fr\':\"Heure d\'arriv\\u00E9e\"})}}</label><div class=col-md-10><span ng-if=\"model.task!=\'t\'\"><div class=btn-group><button type=button ng-class=\"{\'btn btn-default\':meal.availabilities[hrs.hrs].employee!==\'1\',\'btn btn-warning\':meal.availabilities[hrs.hrs].employee==\'1\',\'active\':meal.hrs==hrs.hrs}\" ng-repeat=\"hrs in tools.toArray(meal.availabilities) | orderBy:\'hrs\'\" ng-click=\"meal.hrs=hrs.hrs;\"><div>{{tools.label(parameters.HRS[hrs.hrs])}}</div>&nbsp;<div ng-if=\"hrs.cap>0 && meal.res!==\'\'\">{{getMealHrsLoad(meal,hrs)+\'/\'+hrs.cap}}</div>&nbsp;<div class=\"glyphicon glyphicon-warning-sign\" ng-show=\"meal.availabilities[hrs.hrs].employee==\'1\'\" title={{getWarningMessage()}}></div></button></div><div ng-show=\"tools.getLength(meal.availabilities)==0\">{{tools.lang({\'en\':\'No available arrival time. Please change the date.\',\'nl\':\'Geen aankomsttijd beschikbaar. Gelieve de datum te wijzigen.\',\'fr\':\"Aucune heure d\'arriv\\u00E9e disponible. Veuillez changer la date.\"})}}</div></span><div ng-show=\"model.task==\'t\'\">{{tools.label(parameters.HRS[meal.hrs])}}</div></div></div><div class=\"form-group clearfix\"><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Number of people\',\'nl\':\'Aantal personen\',\'fr\':\'Nombre de personnes\'})}}</label><div class=col-md-6><div class=input-group><div class=input-group-btn><button class=\"btn btn-default\" type=button ng-disabled=\"model.validated && !meal.editing\" ng-click=\"meal.peoplecount=tools.amountIn(meal.peoplecount)-1;onPeoplecountChange(meal);\">-</button></div><input type=text autocomplete=off class=form-control ng-model=meal.peoplecount ng-disabled=\"model.validated && !meal.editing\" ng-change=onPeoplecountChange(meal);><div class=input-group-btn><button class=\"btn btn-default\" type=button ng-disabled=\"model.validated && !meal.editing\" ng-click=\"meal.peoplecount=tools.amountIn(meal.peoplecount)+1;onPeoplecountChange(meal);\">+</button> <button class=\"btn btn-default\" type=button disabled ng-show=\"model.task==\'t\'?meal.peoplecount:getMealAvailableCapacity(meal)>=0\">/{{model.task==\'t\'?meal.peoplecount:getMealAvailableCapacity(meal)}}</button></div></div></div></div><div class=\"form-group clearfix\" ng-show=\"model.task==\'r\' && tools.getLength(tools.join(meal,\'dishes\',model))>1\"><label class=\"col-xs-offset-4 col-xs-2 control-label\">{{tools.lang({\'en\':\'Total price\',\'nl\':\'Totaal prijs\',\'fr\':\'Prix total\'})}}</label><div class=col-xs-6>{{tools.amountOut(tools.sum(tools.inverseJoin(tools.join(meal,\'dishes\',model),\'items\',\'item\',model),\'nettopay\'))+\'€\'}}</div></div><div ng-repeat=\"dish in tools.join(meal,\'dishes\',model) | orderBy:orderItems\">{{item=model.items[dish.item];dishItems=tools.inverseJoin([dish],\'items\',\'item\',model);\'\';}}<div ng-show=\"meal.editing && !model.validated\"><div class=\"form-group clearfix\" ng-show=\"meal.categories.length>1\"><label class=\"col-md-2 control-label\"><button class=\"btn btn-default\" ng-click=deleteDish(dish);sortVisitElements(); ng-show=\"tools.getLength(tools.join(meal,\'dishes\',model))>1 && (tools.exclude(dishItems.concat(tools.inverseJoin(dishItems,\'items\',\'replaces\',model)),{\'invoice\':\'0\'}).length==0 || !dish.isCreated)\"><span class=\"glyphicon glyphicon-trash\"></span></button> {{tools.lang({\'en\':\'Category\',\'nl\':\'Categorie\',\'fr\':\'Cat\\u00E9gorie\'})}}</label><div class=col-md-10><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"category in meal.categories\" ng-click=\"dish.category=category;onUpdateDishCategory(dish);\" ng-class=\"{\'active\':dish.category==category}\" ng-show=\"!dish.isCreated || dish.category==category\" ng-disabled=dish.isCreated>{{category}}</button></div></div></div><!-- dish.dsh --><div class=\"form-group clearfix\"><label class=\"col-md-2 control-label\"><button class=\"btn btn-default\" ng-click=deleteDish(dish);sortVisitElements(); ng-show=\"tools.getLength(tools.join(meal,\'dishes\',model))>1 && model.items[dish.item].invoice==\'0\' && meal.categories.length<=1\"><span class=\"glyphicon glyphicon-trash\"></span></button> {{tools.lang({\'en\':\'Dish\',\'nl\':\'Gerecht\',\'fr\':\'Plat\'})}}</label><div class=col-md-10><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"dsh in dish.dshs\" ng-click=\"dish.dsh=dsh.id;updateMealDetails(meal);\" ng-class=\"{\'active\':dish.dsh==dsh.id}\" ng-show=\"!dish.isCreated || dish.dsh==dsh.id\" ng-disabled=dish.isCreated>{{tools.label(dsh)}}</button></div></div></div></div><!-- item.quantity --><div class=\"form-group clearfix\">{{hideCheckbox=model.task!==\'r\' || model.visit.stat>=3000 || 1>=tools.getLength(tools.join(meal,\'dishes\',model));\'\';}}<div class=col-xs-1 ng-hide=hideCheckbox><input type=checkbox ng-model=dish.selected ng-change=setSelectedElements()></div><div ng-class=\"{\'col-xs-12\':hideCheckbox,\'col-xs-11\':!hideCheckbox}\"><item-component visit=model.visit parent-record=dish item=item max-quantity=\"\'\'\" available-capacity=\"model.task==\'t\'?item.initialQuantity:-1\" indent=0 editing=\"!model.validated && meal.editing\" can-modify-quantity=true task=model.task can-edit-item-reduction=canEditItemReduction can-modify-price=true show-delete=false on-quantity-change=onQuantityChange(dish)></item-component></div></div></div><div class=\"form-group clearfix\" ng-show=\"model.task!=\'t\' && meal.editing && !model.validated\"><div class=\"col-md-offset-2 col-md-10\"><button type=button class=\"btn btn-default\" ng-click=createDish(meal);sortVisitElements();><span class=\"glyphicon glyphicon-plus-sign\"></span>&nbsp; {{tools.lang({\'en\':\'Additional dish\',\'nl\':\'Extra gerecht\',\'fr\':\'Plat suppl\\u00E9mentaire\'})}}</button></div></div><!-- meal.delivery --><div class=\"form-group clearfix\" ng-show=\"(model.task!=\'r\' && model.task!=\'t\') || meal.delivery!=\'0\'\"><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Delivery\',\'nl\':\'Levering\',\'fr\':\'Livraison\'})}}</label><div class=col-md-10><label class=radio-inline><input type=radio ng-model=meal.delivery value=0 ng-readonly=\"model.task==\'r\'\"> <span>{{tools.lang({\'en\':\'No\',\'nl\':\'Nee\',\'fr\':\'Non\'})}}</span></label><label class=radio-inline><input type=radio ng-model=meal.delivery value=1 ng-readonly=\"model.task==\'r\'\"> <span>{{tools.lang({\'en\':\'Yes\',\'nl\':\'Ja\',\'fr\':\'Oui\'})}}</span></label></div></div><!-- meal.comment --><div class=\"form-group clearfix\" ng-show=\"model.task!=\'r\' || meal.comment!=\'\'\"><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Comment\',\'nl\':\'Opmerking\',\'fr\':\'Remarque\'})}}</label><div class=col-md-10><input type=text autocomplete=off class=form-control ng-readonly=\"model.task==\'r\'\" ng-model=meal.comment placeholder=\"{{tools.lang({\'en\':\'Comment\',\'nl\':\'Opmerking\',\'fr\':\'Remarque\'})}}\"></div></div><!-- meal.quotationhidefoto --><div class=\"form-group clearfix\" ng-show=\"parameters.VIS[model.visit.vis].field1==\'1\' && (model.task!=\'r\' || meal.quotationhidefoto==\'1\')\"><div class=\"col-md-offset-2 col-md-10\"><div class=checkbox><label><input type=checkbox ng-model=meal.quotationhidefoto ng-false-value=\"\'0\'\" ng-true-value=\"\'1\'\" ng-disabled=\"model.task==\'r\'\"> {{tools.lang({\'en\':\'Hide foto in offer\',\'nl\':\'Foto verbergen in offerte\',\'fr\':\'Cacher photo dans offre\'})}}</label></div></div></div></div><!-- end of meal --><!-- hotelreservation --><div ng-if=\"visitElement.table==\'hotelreservationcategories\'\">{{hotelreservationcategory=visitElement;item=model.items[hotelreservationcategory.item];\"\"}}<div class=\"form-group clearfix\" ng-show=\"model.visit.stat<2000 && (!item.isCreated || item.initialQuantity<item.quantity || model.task==\'c\') && model.task!=\'t\'\"><label class=\"col-xs-2 control-label col-xs-offset-4\">{{tools.lang({\'en\':\'Release rooms\',\'nl\':\'Kamers vrijgeven\',\'fr\':\'Lib\\u00E9rer chambres\'})}}</label><div class=col-xs-3><div class=input-group><input type=text autocomplete=off class=form-control uib-datepicker-popup ng-model=hotelreservationcategory.externalreleaseddate is-open=hotelreservationcategory.externalreleaseddateOpened datepicker-options=model.dateOptions ng-disabled=\"!(!webservice.calling && (!item.isCreated || item.initialQuantity<item.quantity || model.task==\'c\') && model.visit.hotelexternalreservation==\'1\')\" ng-click=\"hotelreservationcategory.externalreleaseddateOpened=tools.xor(!webservice.calling && (item.initialQuantity<item.quantity || model.task==\'c\') && model.visit.hotelexternalreservation==\'1\',hotelreservationcategory.externalreleaseddateOpened);\"> <span class=input-group-btn ng-click=\"hotelreservationcategory.externalreleaseddateOpened=tools.xor(!webservice.calling && (item.initialQuantity<item.quantity || model.task==\'c\') && model.visit.hotelexternalreservation==\'1\',hotelreservationcategory.externalreleaseddateOpened);\"><button type=button class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"form-group clearfix\"><!-- hotelreservationcategory.startdate --><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Arrival\',\'nl\':\'Aankomst\',\'fr\':\'Arriv\\u00E9e\'})}}</label><div class=col-md-3><div ng-class=\"{\'input-group\':model.task!=\'t\'}\"><input type=text autocomplete=off class=form-control uib-datepicker-popup ng-model=hotelreservationcategory.startdate is-open=hotelreservationcategory.startdateOpened datepicker-options=hotelreservationcategory.dateOptions ng-disabled=\"hotelreservationcategoryFieldEditingIsDisabled(hotelreservationcategory,\'startdate\')\" ng-click=\"hotelreservationcategory.startdateOpened=tools.xor(hotelreservationcategory.editing && model.task!=\'t\' && !model.validated && !webservice.calling,hotelreservationcategory.startdateOpened);\"> <span class=input-group-btn ng-show=\"model.task!=\'t\'\" ng-click=\"hotelreservationcategory.startdateOpened=tools.xor(hotelreservationcategory.editing && model.task!=\'t\' && !model.validated && !webservice.calling,hotelreservationcategory.startdateOpened);\"><button type=button class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=col-md-2><select class=form-control ng-model=hotelreservationcategory.starthrs ng-disabled=\"hotelreservationcategoryFieldEditingIsDisabled(hotelreservationcategory,\'starthrs\')\" ng-options=\"row.id as tools.label(row) for row in getFilteredStarthrs(hotelreservationcategory)\"></select></div><!-- hotelreservationcategory.enddate --><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Departure date\',\'nl\':\'Vertrekdatum\',\'fr\':\'Date de d\\u00E9part\'})}}</label><div class=col-md-3><div ng-class=\"{\'input-group\':model.task!=\'t\'}\"><input type=text autocomplete=off class=form-control uib-datepicker-popup ng-model=hotelreservationcategory.enddate is-open=hotelreservationcategory.enddateOpened datepicker-options=model.dateOptions ng-disabled=\"hotelreservationcategoryFieldEditingIsDisabled(hotelreservationcategory,\'enddate\')\" ng-click=\"hotelreservationcategory.enddateOpened=tools.xor(hotelreservationcategory.editing && model.task!=\'t\' && !model.validated && !webservice.calling,hotelreservationcategory.enddateOpened)\"> <span class=input-group-btn ng-show=\"model.task!=\'t\'\" ng-click=\"hotelreservationcategory.enddateOpened=tools.xor(hotelreservationcategory.editing && model.task!=\'t\' && !model.validated && !webservice.calling,hotelreservationcategory.enddateOpened)\"><button type=button class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><!-- hotelreservationcategory.htl --><div class=\"form-group clearfix\" ng-hide=hotelreservationcategory.isCreated><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Hotel\',\'nl\':\'Hotel\',\'fr\':\'Hotel\'})}}</label><div class=col-md-10><div class=btn-group ng-show=\"model.task!=\'t\'\"><button type=button class=\"btn btn-default\" ng-repeat=\"htl in parameters.notDelArrayHTL\" ng-disabled=webservice.calling ng-click=selectHtl(hotelreservationcategory,htl); ng-class=\"{\'active\':hotelreservationcategory.htl==htl.id}\">{{tools.label(htl)}}</button></div><span ng-show=\"model.task==\'t\'\">{{tools.label(parameters.HTL[hotelreservationcategory.htl])}}</span></div></div><div class=\"form-group clearfix\"><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Rate\',\'nl\':\'Prijs\',\'fr\':\'Prix\'})}}</label><div class=col-md-10><div class=btn-group ng-show=\"model.task!=\'t\'\"><button type=button class=\"btn btn-default\" ng-repeat=\"hra in hotelsService.getAvailableRatesForHotel(hotelreservationcategory.htl)\" ng-show=\"!hotelreservationcategory.isCreated || hotelreservationcategory.hra==hra.id\" ng-disabled=\"hotelreservationcategory.isCreated || webservice.calling\" ng-click=\"hotelreservationcategory.hra=hra.id;fetchhotelreservationcategoryPricings(hotelreservationcategory);\" ng-class=\"{\'active\':hotelreservationcategory.hra==hra.id}\"><div>{{tools.label(hra)}}</div></button></div><span ng-show=\"model.task==\'t\'\">{{tools.label(parameters.HRA[hotelreservationcategory.hra])}}</span></div></div><div class=\"form-group clearfix\"><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Adults per room\',\'nl\':\'Volwassenen per kamer\',\'fr\':\'Adultes par chambre\'})}}</label><div class=col-md-4><div class=input-group><div class=input-group-btn ng-show=\"model.task!=\'t\'\"><button class=\"btn btn-default\" type=button ng-disabled=\"hotelreservationcategoryFieldEditingIsDisabled(hotelreservationcategory,\'adultcount\')\" ng-click=\"hotelreservationcategory.adultcount=tools.amountIn(hotelreservationcategory.adultcount)-1;onUpdateUnitcounts(hotelreservationcategory);\">-</button></div><input type=text autocomplete=off class=form-control ng-readonly=\"hotelreservationcategoryFieldEditingIsDisabled(hotelreservationcategory,\'adultcount\')\" ng-model=hotelreservationcategory.adultcount ng-disabled=\"model.task==\'t\'\" ng-change=onUpdateUnitcounts(hotelreservationcategory);><div class=input-group-btn ng-show=\"model.task!=\'t\'\"><button class=\"btn btn-default\" type=button ng-disabled=\"hotelreservationcategoryFieldEditingIsDisabled(hotelreservationcategory,\'adultcount\')\" ng-click=\"hotelreservationcategory.adultcount=tools.amountIn(hotelreservationcategory.adultcount)+1;onUpdateUnitcounts(hotelreservationcategory);\">+</button></div></div></div><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Children per room\',\'nl\':\'Kinderen per kamer\',\'fr\':\'Enfants par chambre\'})}}</label><div class=col-md-4><div class=input-group><div class=input-group-btn ng-show=\"model.task!=\'t\'\"><button class=\"btn btn-default\" type=button ng-disabled=\"model.validated || !hotelreservationcategory.editing || !hotelreservationcategory.updatePermissions.updateFields.childcount\" ng-click=\"hotelreservationcategory.childcount=tools.amountIn(hotelreservationcategory.childcount)-1;onUpdateUnitcounts(hotelreservationcategory);\">-</button></div><input type=text autocomplete=off class=form-control ng-readonly=\"model.validated || !hotelreservationcategory.editing || !hotelreservationcategory.updatePermissions.updateFields.childcount\" ng-model=hotelreservationcategory.childcount ng-disabled=\"model.task==\'t\'\" ng-change=onUpdateUnitcounts(hotelreservationcategory);><div class=input-group-btn ng-show=\"model.task!=\'t\'\"><button class=\"btn btn-default\" type=button ng-disabled=\"model.validated || !hotelreservationcategory.editing || !hotelreservationcategory.updatePermissions.updateFields.childcount\" ng-click=\"hotelreservationcategory.childcount=tools.amountIn(hotelreservationcategory.childcount)+1;\n                                      onUpdateUnitcounts(hotelreservationcategory);\">+</button></div></div></div></div><div class=\"form-group clearfix\" ng-show=\"(!hotelreservationcategory.isCreated || hotelreservationcategory.requestedhsc===\'\') && hotelreservationcategory.spacetypes.length>1\"><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Category\',\'nl\':\'Categorie\',\'fr\':\'Cat\\u00E9gorie\'})}}</label><div class=col-md-10><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"spacetype in hotelreservationcategory.spacetypes\" ng-disabled=webservice.calling ng-click=\"hotelreservationcategory.spacetype=spacetype;onUpdateSpacetype(hotelreservationcategory);\" ng-class=\"{\'active\':hotelreservationcategory.spacetype==spacetype}\">{{spacetype}}</button></div></div></div><div class=\"form-group clearfix\" ng-show=\"!hotelreservationcategory.isCreated || hotelreservationcategory.requestedhsc===\'\'\"><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Type\',\'nl\':\'Type\',\'fr\':\'Type\'})}}</label><div class=col-md-10><div ng-show=\"hotelreservationcategory.htl!=\'\' && hotelreservationcategory.startdate && hotelreservationcategory.startdate!==\'\' && hotelreservationcategory.enddate && hotelreservationcategory.enddate!==\'\' && !webservice.calling\"><div class=btn-group ng-show=\"hotelreservationcategory.hscs.length>0\"><button type=button class=\"btn btn-default\" ng-repeat=\"hscAdditionalInfo in filterHscs(hotelreservationcategory,hotelreservationcategory.hscs)\" ng-disabled=webservice.calling ng-click=\"hotelreservationcategory.requestedhsc=hscAdditionalInfo.hscId;onUpdateRequestedhsc(hotelreservationcategory);\" ng-class=\"{\'active\':hotelreservationcategory.requestedhsc==hscAdditionalInfo.hscId}\"><span>{{((tools.short(hscAdditionalInfo.hsc)!==\'\')?tools.short(hscAdditionalInfo.hsc):tools.label(hscAdditionalInfo.hsc))+\" \"+tools.amountOut(hotelreservationcategory.pricings[hscAdditionalInfo.hscId])+\'€\'+(getReservationcategoryCapacity(hotelreservationcategory,hscAdditionalInfo.hscId)?\" \"+getReservationcategoryCapacity(hotelreservationcategory,hscAdditionalInfo.hscId):\"\")}}</span></button></div><p ng-show=\"(hotelreservationcategory.spacetypes.length==0 || hotelreservationcategory.spacetype!=\'\') && !(hotelreservationcategory.hscs.length>0)\">{{tools.lang({\'en\':\'No availability\',\'nl\':\'Geen beschikbaarheid\',\'fr\':\'Pas de disponibilit\\u00E9\'})}}</p></div><p class=form-control-static ng-show=webservice.calling>Loading...</p></div></div>{{capacity=getReservationcategoryCapacity(hotelreservationcategory);\"\";}}<item-component parent-record=hotelreservationcategory item=item task=model.task editing=\"!model.validated && hotelreservationcategory.editing\" can-modify-quantity=\"!hotelreservationcategory.isCreated || hotelreservationcategory.updatePermissions.allowItemUpdate\" can-edit-item-reduction=canEditItemReduction can-modify-price=\"!hotelreservationcategory.isCreated || hotelreservationcategory.updatePermissions.allowItemUpdate\" max-quantity=\"\'\'\" available-capacity=\"model.task==\'t\'?item.initialQuantity:(capacity?capacity:-1);\" visit=model.visit show-delete=false indent=0 on-quantity-change=onQuantityChange(hotelreservationcategory);></item-component><div ng-repeat=\"hotelreservationproduct in tools.join(hotelreservationcategory,\'hotelreservationproducts\',model)\"><item-component parent-record=hotelreservationproduct item=model.items[hotelreservationproduct.item] task=model.task can-edit-item-reduction=canEditItemReduction can-modify-price=\"(!hotelreservationproduct.isCreated || hotelreservationcategory.updatePermissions.allowProductsUpdate) && model.task!=\'t\'\" editing=\"!model.validated && hotelreservationcategory.editing\" can-modify-quantity=\"(!hotelreservationproduct.isCreated || hotelreservationcategory.updatePermissions.allowProductsUpdate) && model.task!=\'t\'\" max-quantity=\"\'\'\" available-capacity=-1 visit=model.visit show-delete=\"(!hotelreservationproduct.isCreated || (hotelreservationcategory.updatePermissions.allowProductsUpdate && model.task!=\'r\')) && model.task!=\'t\'\" on-delete=deleteHotelreservationproduct(hotelreservationproduct) indent=1 on-quantity-change=onQuantityChange(hotelreservationproduct,hotelreservationcategory);></item-component></div><div class=\"form-group clearfix\" ng-show=\"hotelreservationcategory.editing && hotelreservationcategory.updatePermissions.allowProductCreation && model.task!=\'t\'\"><label class=\"col-md-2 control-label\"><span class=\"glyphicon glyphicon-plus-sign\"></span>&nbsp;{{tools.lang({\'en\':\'Hotel product\',\'nl\':\'Hotel product\',\'fr\':\'Produit hotel\'})}}</label><div class=col-md-4><div ng-dropdown-multiselect=\"\" options=hotelreservationcategory.hpdOptions selected-model=model.hpd extra-settings=model.hotelreservationproductSettings translation-texts=model.hotelreservationproductTranslations ng-click=createHotelreservationproduct(hotelreservationcategory); ng-disabled=webservice.calling></div></div></div><!-- hotelreservationcategory.quotationhidefoto --><div class=\"form-group clearfix\" ng-show=\"parameters.VIS[model.visit.vis].field1==\'1\'\"><div class=\"col-xs-offset-2 col-xs-4\" ng-show=\"model.task!=\'r\' || hotelreservationcategory.quotationhidefoto==\'1\'\"><div class=checkbox><label><input type=checkbox ng-model=hotelreservationcategory.quotationhidefoto ng-false-value=\"\'0\'\" ng-true-value=\"\'1\'\" ng-disabled=\"model.task==\'r\'\"> {{tools.lang({\'en\':\'Hide foto in offer\',\'nl\':\'Foto verbergen in offerte\',\'fr\':\'Cacher photo dans offre\'})}}</label></div></div><label class=\"col-xs-2 control-label\" ng-show=\"model.visit.quotationpriceperperson==\'1\' && model.items[hotelreservationcategory.item].cgr!=\'XX\'\"><div>{{tools.lang({\'en\':\'Number of people\',\'nl\':\'Aantal personen\',\'fr\':\'Nombre de personnes\'})}}</div><div>{{tools.lang({\'en\':\'for price per person\',\'nl\':\'voor prijs per persoon\',\'fr\':\'pour prix par personne\'})}}</div></label><div class=col-xs-4 ng-show=\"model.visit.quotationpriceperperson==\'1\' && model.items[hotelreservationcategory.item].cgr!=\'XX\'\"><div class=input-group><div class=input-group-btn><button class=\"btn btn-default\" type=button ng-disabled=\"model.task==\'r\'\" ng-click=\"hotelreservationcategory.quotationparticipants=tools.amountIn(hotelreservationcategory.quotationparticipants)-1;\">-</button></div><input type=text autocomplete=off class=form-control ng-readonly=\"model.task==\'r\'\" ng-model=hotelreservationcategory.quotationparticipants><div class=input-group-btn><button class=\"btn btn-default\" type=button ng-disabled=\"model.task==\'r\'\" ng-click=\"hotelreservationcategory.quotationparticipants=tools.amountIn(hotelreservationcategory.quotationparticipants)+1;\">+</button></div></div></div></div><div class=\"form-group clearfix\" ng-show=\"hotelreservationcategory.editing && !hotelreservationcategory.validated && hotelreservationcategory.htl!==\'\' && hotelreservationcategory.startdateISO && hotelreservationcategory.startdateISO!==\'\' && hotelreservationcategory.enddateISO && hotelreservationcategory.enddateISO!==\'\' && model.task!=\'t\'\"><div class=\"col-md-offset-2 col-md-10\"><button type=button class=\"btn btn-default\" ng-click=duplicateHotelreservationcategory(hotelreservationcategory);sortVisitElements(); ng-disabled=webservice.calling><span class=\"glyphicon glyphicon-duplicate\"></span> {{tools.lang({\'en\':\'Duplicate reservation\',\'nl\':\'Dupliceer reservatie\',\'fr\':\'Chambres suppl\\u00E9mentaire\'})}}</button></div></div></div><!-- end of hotelreservation --><!-- products --><div ng-if=\"visitElement.table==\'products\'\">{{product=visitElement;item=model.items[product.item];\'\';}}<div class=\"form-group clearfix\" ng-show=\"product.categories.length>1\"><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Category\',\'nl\':\'Categorie\',\'fr\':\'Cat\\u00E9gorie\'})}}</label><div class=col-md-10><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"category in product.categories\" ng-click=\"product.category=category;onUpdateProductCategory(product);\" ng-class=\"{\'active\':product.category==category}\" ng-show=\"!product.isCreated || product.category==category\" ng-disabled=product.isCreated>{{category}}</button></div></div></div><!-- product.prd --><div class=\"form-group clearfix\" ng-hide=product.isCreated><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Item\',\'nl\':\'Item\',\'fr\':\'Article\'})}}</label><div class=col-md-10><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"prd in product.prds\" ng-click=\"product.prd=prd.id;updateProductDetails(product);\" ng-class=\"{\'active\':product.prd==prd.id}\" ng-show=\"!product.isCreated || product.category==category\" ng-disabled=product.isCreated>{{tools.short(prd)}}</button></div></div></div><!-- product.voucherid--><div class=\"form-group clearfix\" ng-show=\"product.prd==\'VOU\' && model.task==\'r\'\"><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Voucher ID\',\'nl\':\'Geschenkbon ID\',\'fr\':\'ID cheque cadeau\'})}}</label><div class=col-md-10><p class=form-control-static>{{tools.voucheridOut(product.voucherid)}}</p></div></div><!-- item.quantity --><item-component visit=model.visit parent-record=product item=item max-quantity=\"\'\'\" available-capacity=\"model.task==\'t\'?item.initialQuantity:-1\" indent=0 can-modify-price=true editing=\"!model.validated && product.editing\" can-modify-quantity=true task=model.task can-edit-item-reduction=canEditItemReduction show-delete=false on-quantity-change=onQuantityChange(product)></item-component><!-- product.comment --><div class=\"form-group clearfix\" ng-show=\"model.task!=\'r\' || product.comment!=\'\'\"><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Comment\',\'nl\':\'Opmerking\',\'fr\':\'Remarque\'})}}</label><div class=col-md-10><input type=text autocomplete=off class=form-control ng-readonly=\"model.task==\'r\'\" ng-model=product.comment placeholder=\"{{tools.lang({\'en\':\'Comment\',\'nl\':\'Opmerking\',\'fr\':\'Remarque\'})}}\"></div></div></div><!-- end of products --><div class=\"form-group clearfix\" ng-show=\"model.task==\'u\' && visitElement.editing && model.editingCount==1\"><div class=\"col-md-offset-2 col-md-10\"><div ng-show=!webservice.calling><button type=submit class=\"btn btn-primary\" ng-click=updateVisitRecords(); ng-disabled=webservice.calling>{{tools.lang({\'en\':\'Confirm\',\'nl\':\'Bevestig\',\'fr\':\'Confirmer\'})}}</button> <button type=button class=\"btn btn-default\" ng-click=cancelVisitElementEdit(visitElement); ng-disabled=webservice.calling>{{tools.lang({\'en\':\'Cancel\',\'nl\':\'Annuleer\',\'fr\':\'Annuler\'})}}</button></div><div ng-show=webservice.calling>Loading...</div></div></div></div></span></div></td></tr></tbody></table></div></main></div>");
$templateCache.put("app/modules/activities/itemComponent.html","<!-- item.quantity --><div class=\"form-group clearfix\"><label class=\"col-md-2 control-label\" ng-class=\"$ctrl.indent!=0?\'col-md-offset-\'+$ctrl.indent:\'\'\"><span ng-show=\"($ctrl.editing && $ctrl.item.advancedAttributes && $ctrl.task!=\'c\') || (!$ctrl.editing && $ctrl.item.quantity!=$ctrl.item.planningquantity)\">{{$ctrl.tools.lang({\'en\':\'Paying\',\'nl\':\'Betalend\',\'fr\':\'\'})}} </span>{{$ctrl.getQuantityLabel()}} <span ng-show=\"($ctrl.editing && $ctrl.item.advancedAttributes && $ctrl.task!=\'c\') || (!$ctrl.editing && $ctrl.item.quantity!=$ctrl.item.planningquantity)\">{{$ctrl.tools.lang({\'en\':\'\',\'nl\':\'\',\'fr\':\'Payant\'})}}</span></label><div ng-class=\"\'col-md-\'+(7-$ctrl.indent-($ctrl.showDelete?2:0))\"><div class=input-group><div class=input-group-btn><button class=\"btn btn-default\" type=button ng-disabled=\"!($ctrl.editing && $ctrl.canModifyQuantity && !$ctrl.isFixedPrice())\" ng-click=\"$ctrl.item.quantity=$ctrl.tools.amountIn($ctrl.item.quantity)-1;$ctrl.onQuantityChange();\">-</button></div><input type=text autocomplete=off class=form-control ng-readonly=\"!($ctrl.editing && $ctrl.canModifyQuantity && !$ctrl.isFixedPrice())\" ng-model=$ctrl.item.quantity ng-change=$ctrl.onQuantityChange();><div class=input-group-btn><button class=\"btn btn-default\" type=button ng-disabled=\"!($ctrl.editing && $ctrl.canModifyQuantity && !$ctrl.isFixedPrice())\" ng-click=\"$ctrl.item.quantity=$ctrl.tools.amountIn($ctrl.item.quantity)+1;$ctrl.onQuantityChange();\">+</button> <button class=\"btn btn-default\" type=button disabled ng-show=\"$ctrl.editing && $ctrl.availableCapacity>=0\">/{{$ctrl.availableCapacity}}</button> <button class=\"btn btn-default\" type=button disabled ng-show=\"$ctrl.maxQuantity!==\'\'\">{{$ctrl.maxQuantity}}</button> <button class=\"btn btn-default\" type=button disabled><span ng-style=\"{\'text-decoration\':($ctrl.tools.amountIn($ctrl.item.reductionamount)!=0 && $ctrl.getPriceBeforeReduction()>0 && (!$ctrl.editing || $ctrl.visit.automaticreduction==\'0\'))?\'line-through\':\'none\'}\">{{$ctrl.tools.amountOut($ctrl.getPriceBeforeReduction())}}€ </span><span ng-show=\"$ctrl.tools.amountIn($ctrl.item.reductionamount)!=0 && $ctrl.getPriceBeforeReduction()>0 && (!$ctrl.editing || $ctrl.visit.automaticreduction==\'0\')\">&nbsp; {{$ctrl.tools.amountOut($ctrl.getPriceAfterReduction())}}€</span></button></div></div></div><div class=col-md-3 ng-show=$ctrl.editing><div class=checkbox><label><input type=checkbox ng-model=$ctrl.item.advancedAttributes> {{$ctrl.tools.lang({\'en\':\'More fields\',\'nl\':\'Meer velden\',\'fr\':\'Plus de champs\'})}}</label></div></div><div ng-show=$ctrl.showDelete class=col-xs-2><button delete class=\"btn btn-danger\" ng-click=$ctrl.onDelete();></button></div></div><div class=\"form-group clearfix\" ng-show=\"$ctrl.editing && $ctrl.parentRecord.table==\'dishes\' && $ctrl.parameters.DSH[$ctrl.parentRecord.dsh].field1==\'1\'\"><label class=\"col-md-2 control-label\">{{$ctrl.tools.lang({\'en\':\'Title of the dish\',\'nl\':\'Titel van het gerecht\',\'fr\':\'Titre du plat\'})}}</label><div class=col-md-10><input type=text autocomplete=off class=form-control ng-model=$ctrl.parentRecord.quotationtitle placeholder=\"{{$ctrl.tools.lang({\'en\':\'Title of the dish\',\'nl\':\'Titel van het gerecht\',\'fr\':\'Titre du plat\'})}}\"></div></div><div uib-collapse=\"!($ctrl.item.advancedAttributes || !$ctrl.editing)\"><div class=\"form-group clearfix\" ng-show=\"($ctrl.editing && $ctrl.item.advancedAttributes && $ctrl.task!=\'c\') || (!$ctrl.editing && $ctrl.item.quantity!=$ctrl.item.planningquantity)\"><label class=\"col-md-offset-2 col-md-2 control-label\">{{$ctrl.tools.lang({\'en\':\'Agenda \',\'nl\':\'Agenda \',\'fr\':\'\'})+$ctrl.getQuantityLabel()+$ctrl.tools.lang({\'en\':\'\',\'nl\':\'\',\'fr\':\' Agenda\'})}}</label><div class=col-md-4><div class=input-group><div class=input-group-btn><button class=\"btn btn-default\" type=button ng-disabled=!$ctrl.editing ng-click=\"$ctrl.item.planningquantity=$ctrl.tools.amountIn($ctrl.item.planningquantity)-1;$ctrl.onPlanningquantityChange();\">-</button></div><input type=text autocomplete=off class=form-control ng-readonly=!$ctrl.editing ng-model=$ctrl.item.planningquantity><div class=input-group-btn><button class=\"btn btn-default\" type=button ng-disabled=!$ctrl.editing ng-click=\"$ctrl.item.planningquantity=$ctrl.tools.amountIn($ctrl.item.planningquantity)+1;$ctrl.onPlanningquantityChange();\">+</button></div></div></div><div class=col-md-4 ng-show=$ctrl.editing><p class=form-control-static>{{$ctrl.tools.lang({\'en\':\'Modify this field in case you want to avoid an automatic credit note\',\'nl\':\'Wijzig dit veld indien je een automatische credit nota wil vermijden\',\'fr\':\'Modifiez ce champ si vous voulez eviter une note de credit automatique\'})}}</p></div></div><div class=\"form-group clearfix\" ng-show=\"(($ctrl.editing && $ctrl.item.advancedAttributes && $ctrl.canModifyPrice && !$ctrl.isFixedPrice()) || (!$ctrl.editing && $ctrl.item.customprice==\'1\'))\"><label class=\"col-md-offset-2 col-md-2 control-label\">{{$ctrl.tools.lang({\'en\':\'Unit price\',\'nl\':\'Eenheidsprijs\',\'fr\':\'Prix unitaire\'})}}</label><div class=col-md-4><p ng-show=\"$ctrl.item.customprice==\'0\'\">{{$ctrl.tools.amountOut($ctrl.item.standardunitprice)}}€</p><div ng-show=\"$ctrl.item.customprice==\'1\'\"><p ng-hide=$ctrl.editing>{{$ctrl.tools.amountOut($ctrl.item.grossunitprice)}}€</p><div class=input-group ng-show=$ctrl.editing><input type=text autocomplete=off class=form-control ng-model=$ctrl.item.grossunitprice><div class=input-group-btn><button class=\"btn btn-default\" type=button disabled>€</button></div></div></div></div><div class=col-md-4 ng-show=$ctrl.editing><div class=btn-group><button class=\"btn btn-default\" ng-class=\"{\'active\':$ctrl.item.customprice==\'0\'}\" ng-click=\"$ctrl.item.customprice=\'0\';$ctrl.item.grossunitprice=$ctrl.tools.amountOut($ctrl.item.standardunitprice);\" ng-disabled=!$ctrl.editing>{{$ctrl.tools.lang({\'en\':\'Standard\',\'nl\':\'Standaard\',\'fr\':\'Standard\'})}}</button> <button class=\"btn btn-default\" ng-class=\"{\'active\':$ctrl.item.customprice==\'1\'}\" ng-click=\"$ctrl.item.customprice=\'1\';\" ng-disabled=!$ctrl.editing>{{$ctrl.tools.lang({\'en\':\'Customised\',\'nl\':\'Op maat\',\'fr\':\'Sur mesure\'})}}</button></div><p class=form-control-static ng-show=\"$ctrl.item.customprice==\'1\' && $ctrl.parentRecord.table==\'hotelreservationcategories\'\">{{$ctrl.tools.lang({\'en\':\'Price for 1 room during the entire stay \',\'nl\':\'Prijs voor 1 kamer gedurende het volledige verblijf\',\'fr\':\'Prix pour 1 chambre pendant tout le s\\u00E9jour\'})}}</p></div></div><div ng-show=\"($ctrl.editing && $ctrl.item.advancedAttributes && $ctrl.canEditItemReduction() && $ctrl.canModifyPrice && !$ctrl.isFixedPrice()) || (!$ctrl.editing && $ctrl.tools.amountIn($ctrl.item.reductionamount)!==0 && $ctrl.getPriceBeforeReduction()>0)\"><!-- item.reductionpro --><div class=\"form-group clearfix\" ng-show=$ctrl.editing><label class=\"col-md-offset-2 col-md-2 control-label\">{{$ctrl.tools.lang({\'en\':\'Reduction type\',\'nl\':\'Type korting\',\'fr\':\'Type de reduction\'})}}</label><div class=col-md-8><select class=form-control ng-model=$ctrl.item.reductionpro ng-options=\"row.id as $ctrl.tools.label(row) for row in $ctrl.parameters.notDelArrayPRO | orderBy:\'id\'\"></select></div></div><!-- item.reductionamount --><div class=\"form-group clearfix\"><label class=\"col-md-offset-2 col-md-2 control-label\"><span ng-show=$ctrl.editing>{{$ctrl.tools.lang({\'en\':\'Reduction quantity\',\'nl\':\'Hoeveelheid korting\',\'fr\':\'Quantit\\u00E9 de reduction\'})}} </span><span ng-hide=$ctrl.editing>{{$ctrl.tools.label($ctrl.parameters.PRO[$ctrl.item.reductionpro])}}</span></label><div class=col-md-8><div class=input-group><input type=text autocomplete=off class=form-control ng-readonly=!$ctrl.editing ng-model=$ctrl.item.reductionamount placeholder=\"{{$ctrl.tools.lang({\'en\':\'Reduction quantity\',\'nl\':\'Hoeveelheid korting\',\'fr\':\'Quantit\\u00E9 de reduction\'})}}\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-class=\"{\'active\':$ctrl.item.reductionpercent==\'1\'}\" ng-show=\"$ctrl.editing || $ctrl.item.reductionpercent==\'1\'\" ng-click=\"$ctrl.item.reductionpercent=\'1\';\" ng-disabled=!$ctrl.editing>%</button> <button type=button class=\"btn btn-default\" ng-class=\"{\'active\':$ctrl.item.reductionpercent==\'0\'}\" ng-show=\"$ctrl.editing || $ctrl.item.reductionpercent==\'0\'\" ng-click=\"$ctrl.item.reductionpercent=\'0\';\" ng-disabled=!$ctrl.editing>€</button></span></div></div></div></div><div class=\"form-group clearfix\" ng-show=\"$ctrl.parameters.VIS[$ctrl.visit.vis].field1==\'1\' && (($ctrl.editing && $ctrl.item.advancedAttributes) || (!$ctrl.editing && $ctrl.item.cgr!=\'XX\'))\"><label class=\"col-md-offset-2 col-md-2 control-label\">{{$ctrl.tools.lang({\'en\':\'Group\',\'nl\':\'Groep\',\'fr\':\'Groupe\'})}}</label><div class=col-md-8><div class=btn-group><button type=button class=\"btn btn-default\" ng-class=\"{\'active\':$ctrl.item.cgr==cgr.id}\" ng-disabled=!$ctrl.editing ng-repeat=\"cgr in $ctrl.parameters.notDelArrayCGR\" ng-show=\"$ctrl.editing || $ctrl.item.cgr==cgr.id\" ng-click=\"$ctrl.item.cgr=cgr.id\">{{$ctrl.tools.label(cgr)}}</button></div></div></div></div>");
$templateCache.put("app/modules/activities/listVisit.html","<div ng-controller=ListVisitController class=\"page page-activities-list-visit page--tables\"><aside id=filters class=\"page__sidebar sidebar\"><div class=sidebar__header><h4 class=title>{{tools.lang({\'en\':\'Filters\',\'nl\':\'Filters\',\'fr\':\'Filtres\'})}}</h4><button class=\"btn btn-default btn-rounded\"><span class=material-icons ng-click=\"toggleFilters(\'filters\')\">close</span></button></div><div class=sidebar__content><form class=form-horizontal><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Client type\',\'nl\':\'Klanttype\',\'fr\':\'Type client\'})}}</label><div class=col-sm-4><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"par in model.typeOptions | orderBy:\'id\'\" ng-click=\"model.typeOption=par.id;load();\" ng-class=\"{\'active\':model.typeOption==par.id}\">{{tools.label(par)}}</button></div></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-1 control-label\" ng-click=\"model.startdateOpened=!model.startdateOpened\">{{tools.lang({\'en\':\'From\',\'nl\':\'Vanaf\',\'fr\':\'De\'})}}</label><div class=col-sm-4><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.startdate is-open=model.startdateOpened datepicker-options=model.dateOptions ng-click=\"model.startdateOpened=!model.startdateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.startdateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><label class=\"col-sm-1 control-label\" ng-click=\"model.enddateOpened=!model.enddateOpened\">{{tools.lang({\'en\':\'Until\',\'nl\':\'Tot\',\'fr\':\'\\u00C0\'})}}</label><div class=col-sm-4><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.enddate is-open=model.enddateOpened datepicker-options=model.dateOptions ng-click=\"model.enddateOpened=!model.enddateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.enddateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"form-group clearfix\"><span ng-show=\"model.typeOption!=\'P\'\"><label for=quotationmanager class=\"col-xs-12 col-sm-2 control-label\">{{tools.lang({\'en\':\'Assigned to\',\'nl\':\'Toegewezen aan\',\'fr\':\'Attribu\\u00E9 à\'})}}</label><div class=\"col-xs-4 col-sm-2\"><button class=\"btn btn-default btn-100\" ng-click=\"model.quotationmanager=user.id;load();\" ng-class=\"{\'active\':model.quotationmanager==user.id}\">{{user.name}}</button></div><div class=\"col-xs-6 col-sm-6\"><select id=quotationmanager class=form-control ng-model=model.quotationmanager ng-options=\"user.id as user.name for user in tools.addElement(tools.filterUserOnRight(model,\'QUOT\'),anyUser) | orderBy:\'id\'\" ng-change=load();></select></div></span></div></form></div><div class=sidebar__footer><button type=submit class=\"btn btn-primary\" ng-click=\"load(); toggleFilters(\'filters\');\">{{tools.lang({\'en\':\'Done\',\'nl\':\'Done\',\'fr\':\'Appliquer\'})}}</button></div></aside><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\':\'Activities visit\',\'nl\':\'Activities visit\',\'fr\':\'Activities visit\'})}}</h1><div class=header__actions><button class=\"btn btn-default btn-filters\" ng-click=\"toggleFilters(\'filters\')\"><i class=material-icons>filter_list</i> <span class=\"btn__text hidden-xs hidden-sm\">{{tools.lang({\'en\':\'Filters\',\'nl\':\'Filters\',\'fr\':\'Filtres\'})}}</span></button> <input refresh ng-disabled=webservice.calling ng-click=load();></div></section><div class=content><div class=\"content__item c-table-view\" ng-hide=webservice.calling><div class=c-table-view__item><div class=table-responsive-wrapper><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\" ng-hide=webservice.calling><thead><tr><th><span class=th__content>{{tools.lang({\'en\':\'Group\',\'nl\':\'Groep\',\'fr\':\'Groupe\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Language\',\'nl\':\'Taal\',\'fr\':\'Langue\'})}}</span></th><th><span class=th__content><button class=\"btn btn-default\" ng-class=\"{\'active\':model.ordering==\'startdate\'}\" ng-click=\"changeOrdering(\'startdate\')\">{{tools.lang({\'en\':\'Visit\',\'nl\':\'Bezoek\',\'fr\':\'Visite\'})}} <span ng-show=\"model.ordering==\'startdate\'\"><span ng-show=model.reverse class=\"glyphicon glyphicon-chevron-up\"></span> <span ng-hide=model.reverse class=\"glyphicon glyphicon-chevron-down\"></span></span></button></span></th><th><span class=th__content>{{\'Voucher\'}}</span></th><th><span class=\"th__content text-right\">{{tools.lang({\'en\':\'Payed amount\',\'nl\':\'Betaald bedrag\',\'fr\':\'Montant pay\\u00E9\'})}}</span></th><th><span class=\"th__content text-right\">{{tools.lang({\'en\':\'Voucher amount\',\'nl\':\'Waardebon bedrag\',\'fr\':\'Montant coupon\'})}}</span></th></tr></thead><tbody><tr ng-repeat=\"visit in tools.toArray(model.visits) | orderBy:model.ordering:model.reverse\" ng-class=\"{\'warning\':tools.getLength(tools.greater(visit.messages,\'created\',visit.created))==0}\"><td ng-click=visitRetrieve(visit.id);>{{model.contacts[visit.owningcontact].name}}</td><td ng-click=visitRetrieve(visit.id);>{{model.contacts[visit.owningcontact].lang}}</td><td ng-click=visitRetrieve(visit.id);>{{tools.dateOut(tools.dateFromJava(visit.startdate))}} <span ng-show=\"tools.dateFromJava(visit.enddate)!=tools.dateFromJava(visit.startdate)\">- {{tools.dateOut(tools.dateFromJava(visit.enddate))}}</span></td><td ng-click=visitRetrieve(visit.id);>{{visit.voucher?\'V\':\'\'}}</td><td style=\"text-align: right\" ng-click=visitRetrieve(visit.id);>{{tools.amountOut(visit.paidAmount)+\'€\'}}</td><td style=\"text-align: right\" ng-click=visitRetrieve(visit.id);>{{tools.amountOut(visit.creditvoucher)+\'€\'}}</td></tr></tbody></table></div></div></div></div><div class=\"content__item page__loader\" ng-show=webservice.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div></div></main></div>");
$templateCache.put("app/modules/activities/movements.html","<div ng-controller=ActivitiesMovementsController><form class=form-horizontal ng-hide=webservice.calling><div class=\"form-group clearfix\" ng-show=\"(model.payment.method!=\'VOU\')\"><label for=paymentAmount class=\"col-xs-2 control-label\">{{tools.lang({\'en\':\'Amount\',\'nl\':\'Bedrag\',\'fr\':\'Montant\'})}}</label><div class=col-xs-10><input type=text autocomplete=off id=paymentAmount class=form-control ng-model=model.payment.amount placeholder=\"{{tools.lang({\'en\':\'Amount\',\'nl\':\'Bedrag\',\'fr\':\'Montant\'})}}\" ng-readonly=\"ctep.status!=\'idle\' || cashless.status!=\'idle\'\"></div></div><div class=\"form-group clearfix\" ng-show=\"(model.payment.method===\'VOU\')\"><label for=voucherId class=\"col-xs-2 control-label\">{{tools.lang({\'en\':\'Voucher ID\',\'nl\':\'Geschenkbon ID\',\'fr\':\'ID cheque cadeau\'})}}</label><div class=col-xs-10><input type=text autocomplete=off id=voucherId class=form-control ng-model=model.payment.voucherid placeholder=\"{{tools.lang({\'en\':\'Voucher ID\',\'nl\':\'Geschenkbon ID\',\'fr\':\'ID cheque cadeau\'})}}\" ng-readonly=\"ctep.status!=\'idle\' || cashless.status!=\'idle\'\"></div></div><div class=\"form-group clearfix\"><label class=\"col-xs-2 control-label\">{{tools.lang({\'en\':\'Method\',\'nl\':\'Betaalmiddel\',\'fr\':\'Moyen\'})}}</label><div class=col-xs-10><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"mth in tools.match(parameters.notDelMTH,{\'field1\':\'1\'}) | orderBy:\'id\'\" ng-click=\"model.payment.method=mth.id;\" ng-class=\"{\'active\':model.payment.method==mth.id}\" ng-disabled=\"ctep.status!=\'idle\' || cashless.status!=\'idle\'\">{{tools.short(mth)}}</button></div><button type=button class=\"btn btn-primary\" ng-click=createPayment(); ng-disabled=\"ctep.status!=\'idle\' || cashless.status!=\'idle\'\">{{tools.label(parameters.MTH[model.payment.method])+\' \'+tools.lang({\'en\':\'Payment\',\'nl\':\'Betaling\',\'fr\':\'Payment\'})}}</button></div></div><div class=\"form-group clearfix\"><label class=\"col-xs-2 control-label\"><span ng-show=\"ctep.claimedCtepterminal==null\">{{tools.lang({\'en\':\'Terminal\',\'nl\':\'Terminal\',\'fr\':\'Terminal\'})}} </span><span ng-hide=\"ctep.claimedCtepterminal==null\"><span ng-show=\"ctep.claimedCtepterminal.label==\'\'\">{{ctep.claimedCtepterminal.terminalid}} </span><span ng-hide=\"ctep.claimedCtepterminal.label==\'\'\">{{ctep.claimedCtepterminal.label}}</span></span></label><div class=col-xs-10><div ng-show=\"ctep.claimedCtepterminal==null\"><ul class=list-group ng-show=\"tools.getLength(ctep.availableCtepterminals)>0\"><li class=list-group-item ng-repeat=\"ctepterminal in tools.toArray(ctep.availableCtepterminals) | orderBy:\'terminalid\'\"><div ng-hide=ctepterminal.editing><span ng-show=\"ctepterminal.label==\'\'\">{{ctepterminal.terminalid}} </span>{{ctepterminal.label+\' \'+ctepterminal.user_name}} <button class=\"btn btn-default\" ng-click=ctep.claimCtepterminal(ctepterminal)>{{tools.lang({\'en\':\'Link\',\'nl\':\'Koppel\',\'fr\':\'Lier\'})}}</button></div><div class=input-group ng-show=ctepterminal.editing><span class=input-group-addon>{{ctepterminal.terminalid}}</span> <input type=text autocomplete=off class=form-control ng-model=ctepterminal.label> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=ctep.updateCtepterminal(ctepterminal)><span class=\"glyphicon glyphicon-ok\"></span></button> <button class=\"btn btn-default\" ng-click=ctep.cancelCtepterminal(ctepterminal)><span class=\"glyphicon glyphicon-remove\"></span></button></span></div></li></ul><div><button type=button class=\"btn btn-default\" ng-disabled=\"ctep.refreshing || ctep.status!=\'idle\' || cashless.status!=\'idle\'\" ng-click=ctep.claimMyTerminal()><span class=\"glyphicon glyphicon-refresh\"></span> {{tools.lang({\'en\':\'Refresh\',\'nl\':\'Refresh\',\'fr\':\'Refresh\'})}}</button></div></div><div ng-hide=\"ctep.claimedCtepterminal==null\"><div ng-show=\"ctep.status==\'idle\'\"><div><button type=button class=\"btn btn-primary\" ng-click=startCtepPayment(model.payment.amount);>{{tools.lang({\'en\':\'Card Payment\',\'nl\':\'Kaart Betaling\',\'fr\':\'Payment Carte\'})}}</button></div></div><button type=button ng-show=\"ctep.status==\'paymentStarted\'\" class=\"btn btn-default\" ng-click=ctep.cancelPayment();>{{tools.lang({\'en\':\'Cancel Payment\',\'nl\':\'Annuleer Betaling\',\'fr\':\'Annuler Payment\'})}}</button><p class=form-control-static ng-show=\"ctep.status==\'cancelling\'\">{{tools.lang({\'en\':\'Cancelling...\',\'nl\':\'Annulatie...\',\'fr\':\'Annulation...\'})}}</p><p class=form-control-static ng-show=\"ctep.status==\'cancelerror\'\">{{tools.lang({\'en\':\'Cancel failed because a card is inserted. Please request the client to press STOP.\',\'nl\':\'Annuleren mislukt omdat een kaart insteekt. Gelieve de klant te vragen STOP te duwen.\',\'fr\':\'Annuler a \\u00E9chou\\u00E9 car une carte est ins\\u00E9r\\u00E9e. Veuillez demander au client d\\u0027appuyer STOP\'})}}</p></div></div></div><div class=\"form-group clearfix\" ng-show=\"ctep.claimedCtepterminal!=null && ctep.status==\'idle\'\"><div class=\"col-xs-offset-2 col-xs-10\">{{tools.lang({\'en\':\'Verify the last transaction on terminal\',\'nl\':\'Verifieer de laatste transactie op terminal\',\'fr\':\'Verifier la derniere transaction sur terminal\'})}} <span ng-show=\"ctep.claimedCtepterminal.label==\'\'\">{{ctep.claimedCtepterminal.terminalid+\':\'}} </span><span ng-hide=\"ctep.claimedCtepterminal.label==\'\'\">{{ctep.claimedCtepterminal.label+\':\'}} </span><button type=button class=\"btn btn-default\" ng-click=ctep.lastTransaction(); ng-disabled=model.verifying><span class=\"glyphicon glyphicon-question-sign\"></span></button></div></div><div class=\"form-group clearfix\" ng-show=\"user.role.substr(0,3)==\'EMP\' && tools.getLength(parameters.cashlessMachines)>0\"><label class=\"col-xs-2 control-label\"><span ng-show=\"cashless.claimedMachine==null\">{{tools.lang({\'en\':\'Cash handler\',\'nl\':\'Cash verwerker\',\'fr\':\'Cash handler\'})}} </span><span ng-hide=\"cashless.claimedMachine==null\">{{cashless.claimedMachine.name}}</span></label><div class=col-xs-10><div class=btn-group ng-show=\"cashless.claimedMachine==null\"><button type=button class=\"btn btn-default\" ng-repeat=\"machine in parameters.cashlessMachines\" ng-click=\"cashless.claimedMachine=machine;\" ng-class=\"{\'active\':cashless.claimedMachine.id==machine.id}\">{{machine.name}}</button></div><div ng-hide=\"cashless.claimedMachine==null\"><div ng-show=\"cashless.status==\'idle\'\"><button type=button class=\"btn btn-primary\" ng-click=startCashlessPayment(model.payment.amount);>{{tools.lang({\'en\':\'Cash handler payment\',\'nl\':\'Cash verwerker betaling\',\'fr\':\'Paiement cash handler\'})}}</button> <button type=button class=\"btn btn-default\" ng-show=\"parameters.cashlessMachines.length>1\" ng-click=\"cashless.claimedMachine=null;\">{{tools.lang({\'en\':\'Switch machine\',\'nl\':\'Verander machine\',\'fr\':\'Modifier machine\'})}}</button> <button type=button class=\"btn btn-default\" ng-click=singleCashlessVerify()><span class=\"glyphicon glyphicon-refresh\"></span> {{tools.lang({\'en\':\'Verify transactions\',\'nl\':\'Verifieer transacties\',\'fr\':\'Verifier transactions\'})}}</button></div><div ng-show=\"cashless.status==\'verifying\'\"><div class=row><label class=\"col-xs-3 control-label\">{{tools.lang({\'en\':\'Received\',\'nl\':\'Ontvangen\',\'fr\':\'Recu\'})}}</label><div class=col-xs-9><p class=form-control-static>{{tools.amountOut(cashless.cashlesspayment.received)}}€</p></div></div><div class=row><label class=\"col-xs-3 control-label\">{{tools.lang({\'en\':\'Returned\',\'nl\':\'Teruggegeven\',\'fr\':\'Rendu\'})}}</label><div class=col-xs-9><p class=form-control-static>{{tools.amountOut(cashless.cashlesspayment.returned)}}€</p></div></div><div><button type=button class=\"btn btn-default\" ng-click=cashless.cancel();>{{tools.lang({\'en\':\'Cancel Payment\',\'nl\':\'Annuleer betaling\',\'fr\':\'Annuler paiement\'})}}</button></div></div><p class=form-control-static ng-show=\"cashless.status==\'cancelling\'\">{{tools.lang({\'en\':\'Cancelling...\',\'nl\':\'Annulatie...\',\'fr\':\'Annulation...\'})}}</p><p class=form-control-static ng-show=\"cashless.status==\'singleVerify\'\">{{tools.lang({\'en\':\'Verifying...\',\'nl\':\'Verificatie...\',\'fr\':\'Verifier...\'})}}</p></div></div></div></form><div ng-show=webservice.calling><div>{{tools.lang({\'en\':\'Busy...\',\'nl\':\'Bezig...\',\'fr\':\'Occup\\u00E9...\'})}}</div></div></div>");
$templateCache.put("app/modules/activities/passerelle.html","<div ng-controller=ActivitiesPasserelleController class=\"page page-activities-passerelle page--content\"><form class=form-horizontal><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\" ng-click=\"model.startdateOpened=!model.startdateOpened\">{{tools.lang({\'en\':\'Start\',\'nl\':\'Start\',\'fr\':\'D\\u00E9but\'})}}</label><div class=col-sm-4><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.startdate is-open=model.startdateOpened datepicker-options=model.dateOptions ng-click=\"model.startdateOpened=!model.startdateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.startdateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><label class=\"col-sm-2 control-label\" ng-click=\"model.enddateOpened=!model.enddateOpened\">{{tools.lang({\'en\':\'End\',\'nl\':\'Einde\',\'fr\':\'Fin\'})}}</label><div class=col-sm-4><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.enddate is-open=model.enddateOpened datepicker-options=model.dateOptions ng-click=\"model.enddateOpened=!model.enddateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.enddateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"form-group clearfix\"><div class=\"col-sm-offset-2 col-sm-10\"><input refresh ng-hide=model.loading ng-click=load();> <span ng-show=model.loading>Loading...</span></div></div></form><table class=\"table table-striped table-hover\"><thead><tr><th><span class=th__content>{{tools.lang({\'en\':\'Date\',\'nl\':\'Datum\',\'fr\':\'Date\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Hour\',\'nl\':\'Uur\',\'fr\':\'Heure\'})}}</span></th><th ng-repeat=\"frm in model.frms\">{{tools.short(parameters.FRM[frm])}}</th></tr></thead><tbody><tr ng-repeat=\"line in model.lines | orderBy:\'date\'\"><td>{{line.day}}</td><td>{{line.hrs}}</td><td ng-repeat=\"frm in model.frms\">{{line[frm]}}</td></tr></tbody></table></div>");
$templateCache.put("app/modules/activities/reservations.html","<section ng-controller=ActivitiesReservationsController class=\"page page-activities-reservations page--content\"><main role=main class=page__content><section class=\"content__header header\"><h1>{{tools.lang({\'en\':\'Confirmations\',\'nl\':\'Bevestigingen\',\'fr\':\'Confirmations\'})}}</h1><div class=header__actions><input refresh ng-disabled=webservice.calling ng-click=load();></div></section><div class=content__noresult ng-show=\"!webservice.calling && !tools.getLength(model.visits)>0\"><div class=\"alert alert-info\" role=alert><p>{{tools.lang({\'en\':\'No confirmations\',\'nl\':\'Geen bevestigingen\',\'fr\':\'Aucun confirmation\'})}}</p></div></div><div class=table-responsive-wrapper ng-hide=\"webservice.calling || tools.getLength(model.visits)==0\"><table class=\"table table-striped table-hover\"><thead><tr><th><span class=th__content></span></th><th><span class=th__content>{{tools.lang({\'en\':\'Name\',\'nl\':\'Naam\',\'fr\':\'Nom\'})}}</span></th><th>{{tools.lang({\'en\':\'GSM\',\'nl\':\'GSM\',\'fr\':\'GSM\'})}}</th><th>{{tools.lang({\'en\':\'Email\',\'nl\':\'Email\',\'fr\':\'Email\'})}}</th><th><span class=th__content>{{tools.lang({\'en\':\'Created\',\'nl\':\'Aangemaakt\',\'fr\':\'Cr\\u00E9\\u00E9\'})}}</span></th><th><span class=th__content></span></th><th><span class=th__content>{{tools.lang({\'en\':\'Departure\',\'nl\':\'Vertrek\',\'fr\':\'D\\u00E9part\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Quantity\',\'nl\':\'Quantity\',\'fr\':\'Quantit\\u00E9\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Comment\',\'nl\':\'Opmerking\',\'fr\':\'Remarque\'})}}</span></th><th></th></tr></thead><tbody ng-repeat=\"visit in tools.toArray(model.visits) | orderBy:\'startdate\'\"><tr ng-repeat=\"event in model.events[visit.id]\"><td><span ng-show=$first><input retrieve ng-click=visitRetrieve(event.visit);></span></td><td><span ng-show=$first>{{model.contacts[visit.owningcontact].name}}</span></td><td><span ng-show=$first>{{model.contacts[visit.owningcontact].gsm}}</span></td><td><span ng-show=$first>{{model.contacts[visit.owningcontact].email}}</span></td><td><span ng-show=$first>{{tools.timestampOut(visit.created)}}</span></td><td><div ng-show=\"event.table==\'activities\'\"><div class=colored><span class=colored ng-style=\"{\'background-color\':activitiesService.getColour(event)}\">{{activitiesService.formulaOut(event)}}</span></div></div><div ng-show=\"event.table==\'meals\'\">{{tools.label(parameters.RES[event.res])}} <span ng-repeat=\"dish in tools.join(event,\'dishes\',model)\">{{tools.label(parameters.DSH[dish.dsh])}}</span></div><div ng-show=\"event.table==\'hotelreservationcategories\'\">{{tools.label(parameters.HTL[event.htl])}} <span>{{tools.label(parameters.HSC[event.requestedhsc])}}</span></div></td><td>{{tools.dateOut(tools.dateFromJava(event.day))+\' \'+tools.label(parameters.HRS[event.hrs])}}</td><td><div ng-show=\"event.table==\'activities\'\">{{activitiesService.countParticipants(tools.join(event,\'participants\',model),model)}}</div><div ng-show=\"event.table==\'meals\'\"><span ng-repeat=\"dish in tools.join(event,\'dishes\',model)\">{{model.items[dish.item].quantity}}</span></div><div ng-show=\"event.table==\'hotelreservationcategories\'\"><span>{{model.items[event.item].quantity}}</span></div></td><td><div ng-show=\"event.table==\'activities\' || event.table==\'meals\'\">{{event.comment}}</div></td><td><span ng-show=$first><input class=\"btn btn-success\" update ng-click=validate(visit)> <input class=\"btn btn-danger\" delete ng-click=cancel(visit)></span></td></tr></tbody></table></div><div class=\"content__item page__loader\" ng-show=webservice.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div></main></section>");
$templateCache.put("app/modules/activities/retrieveForEmp.html","<section ng-controller=ActivitiesRetrieveForEmpController class=\"page-activity-client-details page page-activities-retrieve-for-employee page--content\"><div class=content__noresult ng-show=\"!webservice.calling && !tools.getLength(model.visit)>0 && !tools.getLength(model.contacts)>0 && !initialize\"><div class=\"alert alert-info\" role=alert><p>{{tools.lang({\'en\':\'Visit not found\',\'nl\':\'Bezoeker niet gevonden\',\'fr\':\'Visiteur non trouv\\u00E9\'})}}</p></div></div><div class=content__noresult ng-show=\"!webservice.calling && tools.getLength(model.visit)>0 && !tools.getLength(model.contacts)>0 && !initialize\"><div class=\"alert alert-info\" role=alert><p>{{tools.lang({\'en\':\'Old visit found, do you want to try to migrate?\',\'nl\':\'Oude bezoeker gevonden, wil je deze proberen te migreren?\',\'fr\':\'Vieux visiteur trouv\\u00E9, veuillez vous essayer de le migrer ?\'})}} <button class=\"btn btn-default\" ng-show=\"model.visit.owningcontact==\'0\'\" ng-click=migrateVisit()>{{tools.lang({\'en\':\'Yes\',\'nl\':\'Ja\',\'fr\':\'Oui\'})}}</button></p></div></div><div class=\"content__item page__loader\" ng-show=\"webservice.calling || initialize\"><div class=lds-ring><div></div><div></div><div></div><div></div></div></div><div ng-show=\"!webservice.calling && tools.getLength(model.visit)>0 && tools.getLength(model.contacts)>0 && !initialize\" ng-include=\"\'app/modules/activities/edit.html\'\" class=main></div><div class=sidebar ng-show=\"!webservice.calling && tools.getLength(model.visit)>0 && tools.getLength(model.contacts)>0 && !initialize\"><ul class=list-group><li class=list-group-item ng-repeat=\"message in model.visit.messages | orderBy:[\'day\',\'created\']\"><button class=\"btn btn-default\" ng-click=openMessage(message) title=\"{{message.table==\'quotationnotes\'?message.body:\'\'}}\" ng-disabled=\"model.task!=\'r\'\"><span ng-show=\"message.table==\'emails\'\" class=\"glyphicon glyphicon-envelope\"></span> <span ng-show=\"message.table==\'quotationnotes\'\" class=\"glyphicon glyphicon-comment\"></span></button> <span ng-show=\"message.table==\'emails\'\">{{tools.label(parameters.MAI[message.mai])+\' \'+tools.doneBy(message.created,message.creator_name)}} </span><span ng-show=\"message.table==\'quotationnotes\'\">{{tools.lang({\'en\':\'Note\',\'nl\':\'Notitie\',\'fr\':\'Note\'})+\' \'+tools.dateOut(message.day)+\': \'+tools.substr(message.body,0,50)+(message.body.length>50?\'...\':\'\')}} </span><button ng-show=\"message.table==\'quotationnotes\'\" class=\"btn btn-danger\" delete ng-click=deleteQuotationnote(message)></button></li><li class=list-group-item ng-show=\"model.visit.stat==2000 || model.visit.stat==2100 || model.visit.stat==2200\"><button type=button class=\"btn btn-default\" ng-click=sendConfirmationEmail() ng-disabled=\"model.task!=\'r\'\"><span class=\"glyphicon glyphicon-send\"></span> {{tools.lang({\'en\':\'Send\',\'nl\':\'Verstuur\',\'fr\':\'Envoyer\'})+\' \'+tools.label(parameters.MAI.RESV)}}</button></li><li class=list-group-item><button class=\"btn btn-default\" ng-click=startCreateQuotationnote(); ng-disabled=\"model.task!=\'r\'\"><span class=\"glyphicon glyphicon-comment\"></span> {{tools.lang({\'en\':\'Create note\',\'nl\':\'Maak notitie\',\'fr\':\'Cr\\u00E9er note\'})}}</button></li><li class=list-group-item ng-show=\"parameters.VIS[model.visit.vis].field1==\'1\'\"><form action={{model.action}} name=quotation autocomplete=off method=post target=_blank><input type=hidden name=params value={{getQuotationWsParams()}}> <button type=submit class=\"btn btn-default\" ng-disabled=\"model.task!=\'r\' || (model.owningContact.iscompany==\'0\' && model.owningContact.sal==\'\') || (model.owningContact.iscompany==\'1\' && (model.communicationContact.sal==\'\' || model.communicationContact.sal==undefined)) || model.visit.quotationmanager==\'0\'\"><span class=\"glyphicon glyphicon-print\"></span> {{tools.label(parameters.MAI.OFFER)+\' PDF\'}}</button> <button type=button class=\"btn btn-default\" ng-click=sendQuotation() ng-disabled=\"model.task!=\'r\' || (model.owningContact.iscompany==\'0\' && model.owningContact.sal==\'\') || (model.owningContact.iscompany==\'1\' && (model.communicationContact.sal==\'\' || model.communicationContact.sal==undefined)) || model.visit.quotationmanager==\'0\'\"><span class=\"glyphicon glyphicon-send\"></span> {{tools.lang({\'en\':\'Send\',\'nl\':\'Verstuur\',\'fr\':\'Envoyer\'})+\' \'+tools.label(parameters.MAI.OFFER)}}</button> <span ng-show=\"(model.owningContact.iscompany==\'0\' && model.owningContact.sal==\'\') || (model.owningContact.iscompany==\'1\' && model.communicationContact.sal==\'\')\">{{tools.lang({\'en\':\'Invalid salutation\',\'nl\':\'Ongeldige aanspreking\',\'fr\':\'Salutation invalide\'})}} </span><span ng-show=\"model.owningContact.iscompany==\'1\' && model.communicationContact.sal==undefined\">{{tools.lang({\'en\':\'Invalid contact, please add contact\',\'nl\':\'Ongeldige contactpersoon, gelieve een contactpersoon toe te voegen\',\'fr\':\'Contact invalide, ajouter une personne de contact\'})}} </span><span ng-show=\"model.visit.quotationmanager==\'0\'\">{{tools.lang({\'en\':\'Invalid quotation manager\',\'nl\':\'Ongeldige offerte manager\',\'fr\':\'Salutation invalide\'})}}</span></form></li></ul><form class=form-horizontal ng-show=\"model.totalAmount>0\"><div class=\"alert alert-info clearfix\" style=\"display: flex; justify-content: space-between; align-items: center\"><strong style=\"flex: 1 1 auto\">{{tools.lang({\'en\':\'Total:\',\'nl\':\'Totaal:\',\'fr\':\'Total:\'})}}</strong><p class=form-control-static><strong>{{tools.amountOut(model.totalAmount)}}€</strong></p></div></form><ul class=list-group><li class=\"alert alert-warning clearfix\" style=\"list-style: none !important; margin-bottom: -1px; display: flex; justify-content: space-between; align-items: center\" ng-show=\"model.totalAmount>0 && model.toPay>0 && model.task==\'r\' && model.visit.stat>=2000 && model.visit.stat<9000 && config.get(\'showPaymentCompany\')\"><strong style=\"flex: 1 1 auto\">{{tools.lang({\'en\':\'Pay at:\',\'nl\':\'Betalen te:\',\'fr\':\'A payer à:\'})}}</strong><p class=form-control-static><strong>{{tools.short(parameters.DVS[model.visit.dvs])}}</strong></p></li><li class=list-group-item ng-show=\"tools.getLength(tools.match(tools.join(model.visit,\'movements\',model),{\'corrected\':\'1\'}))>0\"><form class=form-horizontal><div class=\"form-group clearfix\"><div class=col-xs-12><div class=checkbox><label><input type=checkbox ng-model=model.showCorrectedMovements> {{tools.lang({\'en\':\'Show corrections\',\'nl\':\'Toon aanpassingen\',\'fr\':\'Montrer les corrections\'})}}</label></div></div></div></form></li><li class=list-group-item ng-repeat=\"movement in tools.exclude(tools.join(model.visit,\'movements\',model),{\'corrected\':\'1\'}).concat(model.showCorrectedMovements?tools.match(tools.join(model.visit,\'movements\',model),{\'corrected\':\'1\'}):[]) | orderBy:\'created\'\"><form class=form-horizontal><div class=\"form-group clearfix\"><div class=col-xs-12><button type=button class=\"btn btn-default\" ng-hide=\"movement.editing || movement.corrected==\'1\'\" ng-click=startMovementEdit(movement); ng-disabled=\"model.task!=\'r\'\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <input type=checkbox ng-model=movement.selected on-change=setSelectedElements() ng-hide=\"model.task!==\'r\' || model.visit.stat>=3000 || movement.corrected==\'1\'\" checkbox-all child-list=getVisitElementsChildList([movement]) property=selected> {{tools.amountOut(movement.amount)+\'€\'}} <span ng-show=model.accounts[movement.account]>{{tools.label(parameters.MTH[model.accounts[movement.account].method])}} </span>{{tools.doneBy(movement.created,movement.creator_name)}} <span class=\"glyphicon glyphicon-info-sign\" ng-if=\"movement.comment!=\'\'\" uib-tooltip={{movement.comment}} tooltip-placement=bottom tooltip-popup-delay=150 tooltip-class=info></span> <button ng-show=\"!movement.editing && user.hasRight(\'NEGPAY\') && movement.corrected==\'0\'\" class=\"btn btn-danger\" delete ng-click=deleteMovement(movement)></button></div><div ng-show=\"tools.join(movement,\'cashlesspayments\',model).length>0\">{{cashlesspayment=tools.first(tools.join(movement,\'cashlesspayments\',model));\"\";}} <span ng-class=\"{\'bg-danger\':cashlesspayment.amount-cashlesspayment.received+cashlesspayment.returned!=0.0}\">{{tools.amountOut(cashlesspayment.received)+\'€ \'+tools.lang({\'en\':\'received\',\'nl\':\'ontvangen\',\'fr\':\'recu\'})+\' - \'+tools.amountOut(cashlesspayment.returned)+\'€ \'+tools.lang({\'en\':\'returned\',\'nl\':\'teruggegeven\',\'fr\':\'rendu\'});}}</span></div></div><div ng-show=movement.editing><div class=\"form-group clearfix\"><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Extra info\',\'nl\':\'Extra info\',\'fr\':\'Extra info\'})}}</label><div class=col-md-10><textarea class=form-control ng-model=movement.comment placeholder=\"{{tools.lang({\'en\':\'Extra info\',\'nl\':\'Extra info\',\'fr\':\'Extra info\'})}}\" ng-disabled=\"model.task!=\'r\'\"></textarea></div></div><div class=\"form-group clearfix\" ng-show=\"(movement.exactentry==\'0\' && parameters.MTH[movement.method].field5!=\'1\' && movement.amount>0) || user.hasRight(\'NEGPAY\')\"><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Change method\',\'nl\':\'Verander betaalmiddel\',\'fr\':\'Addapté moyen de paiement\'})}}</label><div class=col-md-10><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"mth in tools.match(parameters.notDelMTH,{\'field1\':\'1\'}) | orderBy:\'id\'\" ng-click=\"movement.method=mth.id;\" ng-class=\"{\'active\':movement.method==mth.id}\">{{tools.short(mth)}}</button></div></div></div><div class=\"form-group clearfix\"><div class=col-xs-12><button type=button class=\"btn btn-success\" ng-click=updateMovement(movement); ng-disabled=\"model.task!=\'r\'\"><span class=\"glyphicon glyphicon-ok\"></span></button> <button type=button class=\"btn btn-default\" ng-click=cancelMovementEdit(movement); ng-disabled=\"model.task!=\'r\'\"><span class=\"glyphicon glyphicon-remove\"></span></button></div></div></div></form></li><li class=list-group-item ng-show=\"model.toPay<0\"><span ng-show=\"model.task==\'r\'\"><button edit ng-click=model.startVisitEdit()></button> </span><span ng-show=\"model.visit.refundaccount==\'\'\">{{tools.lang({\'en\':\'Enter an account in order to refund\',\'nl\':\'Vul een rekening in om terug te betalen\',\'fr\':\'Remplissez un compte pour rembourser\'})}} </span><span ng-hide=\"model.visit.refundaccount==\'\'\">{{tools.amountOut(-model.toPay)+\'€ \'+tools.lang({\'en\':\'will be refunded on\',\'nl\':\'zal terugbetaald worden op\',\'fr\':\'sera rembours\\u00E9 sur\'})+\' \'+model.visit.refundaccount}}</span></li><li class=list-group-item ng-show=\"model.toPay>0 && model.task==\'r\' && model.visit.stat>=2000 && model.visit.stat<9000\"><div ng-include=\"\'app/modules/activities/movements.html\'\"></div></li><li class=list-group-item ng-show=\"model.task==\'r\' && ((model.visit.stat>=1210 && (tools.getLength(tools.match(model.visitrelations,{\'visitb\':model.visit.id}))>0 || tools.getLength(tools.match(model.visitrelations,{\'visita\':model.visit.id}))>0)) || model.visit.stat>=2000) && model.visit.stat<9000\"><div ng-if=\"tools.getLength(tools.match(model.visitrelations,{\'visitb\':model.visit.id}))>0\">{{relation=tools.first(tools.match(model.visitrelations,{\'visitb\':model.visit.id}));\"\";}} {{parentVisit=model.visits[relation.visita];\"\";}} {{parentContact=model.contacts[parentVisit.owningcontact];\"\";}}<form class=form-horizontal><div class=\"form-group clearfix\"><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Parent visit\',\'nl\':\'Is deel van\',\'fr\':\'Fait partie de\'})}}:</label><div class=col-md-10><button retrieve ng-click=visitRetrieve(relation.visita);></button> {{\'V\'+relation.visita+\' \'+contactsService.getName(parentContact)}} <span ng-if=\"parentVisit.movementsmismatch!=0\"><strong>- {{tools.amountOut(-parentVisit.movementsmismatch)}}€ {{tools.lang({\'en\':\'to pay\',\'nl\':\'te betalen\',\'fr\':\'à payer\'})}}</strong></span></div></div></form></div><div ng-if=\"tools.getLength(tools.match(model.visitrelations,{\'visita\':model.visit.id}))>0\"><form class=form-horizontal><div class=\"form-group clearfix\"><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Child visits\',\'nl\':\'Deeldossiers\',\'fr\':\'Dossiers enfants\'})}}:</label><div class=col-md-10><div ng-repeat=\"relation in tools.match(model.visitrelations,{\'visita\':model.visit.id})\">{{childVisit=model.visits[relation.visitb];\"\";}} {{childContact=model.contacts[childVisit.owningcontact];\"\";}} <button retrieve ng-click=visitRetrieve(relation.visitb);></button> {{\'V\'+relation.visitb+\' \'+contactsService.getName(childContact)}} <span ng-if=\"relation.hotelspace!=\'0\'\">- {{parameters.HSC[model.hotelspaces[relation.hotelspace].hsc].field5}} {{model.hotelspaces[relation.hotelspace].spacenumber}} </span><span ng-if=\"childVisit.movementsmismatch!=0\"><strong>- {{tools.amountOut(-childVisit.movementsmismatch)}}€ {{tools.lang({\'en\':\'to pay\',\'nl\':\'te betalen\',\'fr\':\'à payer\'})}}</strong></span></div></div></div></form></div><div class=row ng-show=\"model.visit.stat>=2000\"><div class=\"col-xs-10 col-xs-offset-2\"><button class=\"btn btn-default\" ng-click=\"tools.redirect(buildHref(\'hotels\',\'splitBill\',\'V\'+model.visit.id));\">{{tools.lang({\'en\':\'Split bill\',\'nl\':\'Split bill\',\'fr\':\'Split bill\'})}}</button></div></div></li><li class=\"alert alert-danger clearfix\" style=\"list-style: none !important; margin-bottom: -1px; display: flex; justify-content: space-between; align-items: center\" ng-show=\"model.visit.stat>=9000\"><b style=\"flex: 1 1 auto\">{{tools.label(parameters.STV[model.visit.stat])}}</b> <button class=\"btn btn-default\" ng-show=\"tools.getLength(model.hotelreservationcategories)==0 && user.hasRight(\'RESTORE\')\" ng-click=restore();>{{tools.lang({\'en\':\'Restore\',\'nl\':\'Terugzetten\',\'fr\':\'Remettre\'})}}</button></li><li class=\"alert alert-warning clearfix\" style=\"list-style: none !important; margin-bottom: -1px; display: flex; justify-content: space-between; align-items: center\" ng-show=\"model.visit.stat<2000\"><b style=\"flex: 1 1 auto\">{{tools.label(parameters.STV[model.visit.stat])}}</b> <span ng-show=\"model.visit.stat==\'1210\' && user.hasRight(\'QUOT\')\"><input class=\"btn btn-success\" update ng-click=assignSoldQuotation()> <input class=\"btn btn-danger\" delete ng-click=cancelVisit()></span></li></ul><ul class=list-group ng-show=\"tools.getLength(tools.join(model.visit,\'invoices\',model))>0 || canCreateInvoice() || canRenderItemlist(\'ANY\')\"><li ng-class=\"{\'alert alert-danger\':invoice.isInError,\'list-group-item\':!invoice.isInError}\" style=\"list-style: none !important; margin-bottom: -1px\" ng-repeat=\"invoice in tools.join(model.visit,\'invoices\',model) | orderBy:\'created\'\"><form action={{model.action}} name=\"{{\'invoice\'+invoice.id}}\" autocomplete=off method=post target=_blank class=form-horizontal><div class=\"form-group clearfix\"><div class=col-xs-12><input type=hidden name=params value={{getInvoiceWsParams(invoice)}}> <button type=button class=\"btn btn-default\" ng-hide=invoice.editing ng-click=\"invoice.editing=true;\" ng-disabled=\"model.task!=\'r\'\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <b ng-click=loadInvoiceAccountingEntryId(invoice)>{{tools.lang({\'en\':\'Invoice\',\'nl\':\'Factuur\',\'fr\':\'Facture\'})+\' \'+invoice.dvs+(model.accountingIntegration!=\'\'?invoice.accountingentryid:invoice.id)}}</b> <span ng-hide=invoice.editing><button type=submit class=\"btn btn-default\" ng-disabled=\"model.task!=\'r\' || (invoice.isInError && user.role!==\'EMPADM\')\"><span class=\"glyphicon glyphicon-print\"></span></button> <button type=button class=\"btn btn-default\" ng-click=sendInvoiceEmail(invoice) ng-disabled=\"model.task!=\'r\' || (invoice.errorwording!=\'\' && user.role!==\'EMPADM\')\"><span class=\"glyphicon glyphicon-envelope\"></span></button> {{tools.amountOut(invoice.amount)+\'€ \'+tools.doneBy(invoice.created,invoice.creator_name)}} <span ng-show=\"invoice.isInError && !invoice.errorwording.includes(\'taxcomponent\')\"><br>{{\'Technical error. Please contact your supplier.\'}}</span> <span ng-show=\"invoice.isInError && invoice.errorwording.includes(\'taxcomponent\')\"><br>{{invoice.errorwording[0].toUpperCase()+invoice.errorwording.substring(1)+\'. Please contact your accounting.\'}}</span></span></div></div><div ng-show=invoice.editing><div class=\"form-group clearfix\"><div class=col-xs-12><textarea class=form-control ng-model=invoice.description placeholder=\"{{tools.lang({\'en\':\'Comment\',\'nl\':\'Opmerking\',\'fr\':\'Remarque\'})}}\" ng-disabled=\"model.task!=\'r\'\"></textarea></div></div><div class=\"form-group clearfix\"><div class=col-xs-12><div class=checkbox><label><input type=checkbox ng-model=invoice.compacted ng-false-value=\"\'0\'\" ng-true-value=\"\'1\'\"> {{tools.lang({\'en\':\'Group lines per category\',\'nl\':\'Groepeer lijnen per categorie\',\'fr\':\'Grouper lignes par categorie\'})}}</label></div></div></div><div class=\"form-group clearfix\"><div class=col-xs-12><button type=button class=\"btn btn-success\" ng-click=updateInvoice(invoice) ng-disabled=\"model.task!=\'r\'\"><span class=\"glyphicon glyphicon-ok\"></span></button> <button type=button class=\"btn btn-default\" ng-click=\"invoice.editing=false;\" ng-disabled=\"model.task!=\'r\'\"><span class=\"glyphicon glyphicon-remove\"></span></button></div></div></div></form></li><li class=list-group-item ng-repeat=\"purpose in purposes\" ng-show=canRenderItemlist(purpose)><form class=form-horizontal action={{model.action}} name=\"{{\'visit\'+model.visit.id}}\" autocomplete=off method=post target=_blank><div class=\"form-group clearfix\"><div class=col-xs-12><input type=hidden name=params value={{getItemListWsParams(purpose)}}> <button type=button class=\"btn btn-default\" ng-hide=itemListOptions[purpose].editing ng-click=\"itemListOptions[purpose].editing=true;\" ng-disabled=\"model.task!=\'r\'\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <b ng-show=\"purpose==\'PROFORMA\'\">{{tools.lang({\'en\':\'Proforma Invoice\',\'nl\':\'Proforma Factuur\',\'fr\':\'Facture Proforma\'})}}</b> <b ng-show=\"purpose==\'B2CTURNO\'\">{{tools.lang({\'en\':\'Overview B2C turnover\',\'nl\':\'Overzicht B2C omzet\',\'fr\':\'Apercu chiffre d\\u0027affaires B2C\'})}}</b> <b ng-show=\"purpose==\'ARTICLELIST\'\">{{tools.lang({\'en\':\'Overview all articles\',\'nl\':\'Overzicht alle artikels\',\'fr\':\'Apercu tout les articles\'})}}</b> <span ng-hide=itemListOptions[purpose].editing><button type=submit class=\"btn btn-default\" ng-disabled=\"model.task!=\'r\'\"><span class=\"glyphicon glyphicon-print\"></span></button> <button type=button class=\"btn btn-default\" ng-click=sendItemListEmail(purpose) ng-disabled=\"model.task!=\'r\'\"><span class=\"glyphicon glyphicon-envelope\"></span></button> <i>{{tools.lang({\'en\':\'This is not a VAT invoice.\',\'nl\':\'Dit is geen BTW factuur.\',\'fr\':\'Ceci n\\u0027est pas une facture TVA.\'})}}</i></span></div></div><div ng-show=itemListOptions[purpose].editing><div class=\"form-group clearfix\"><div class=col-xs-12><textarea class=form-control ng-model=itemListOptions.description placeholder=\"{{tools.lang({\'en\':\'Comment\',\'nl\':\'Opmerking\',\'fr\':\'Remarque\'})}}\" ng-disabled=\"model.task!=\'r\'\"></textarea></div></div><div class=\"form-group clearfix\"><div class=col-xs-12><div class=checkbox><label><input type=checkbox ng-model=itemListOptions.compacted ng-false-value=\"\'0\'\" ng-true-value=\"\'1\'\"> {{tools.lang({\'en\':\'Group lines per category\',\'nl\':\'Groupeer lijnen per categorie\',\'fr\':\'Grouper lignes par categorie\'})}}</label></div></div></div><div class=\"form-group clearfix\"><div class=col-xs-12><button type=button class=\"btn btn-success\" ng-click=\"itemListOptions[purpose].editing=false;\" ng-disabled=\"model.task!=\'r\'\"><span class=\"glyphicon glyphicon-ok\"></span></button> <button type=button class=\"btn btn-default\" ng-click=\"itemListOptions[purpose].editing=false;itemListOptions.description=\'\';itemListOptions.compacted=\'0\';\" ng-disabled=\"model.task!=\'r\'\"><span class=\"glyphicon glyphicon-remove\"></span></button></div></div></div></form></li><li class=list-group-item ng-show=canCreateInvoice()><form class=form-horizontal><div class=\"form-group clearfix\"><div class=col-xs-6><input type=text autocomplete=off class=form-control placeholder=\"{{tools.lang({\'en\':\'Downpayment amount\',\'nl\':\'Voorschot bedrag\',\'fr\':\'Montant acompte\'})}}\" ng-model=model.downpaymentAmount ng-disabled=\"model.task!=\'r\'\"></div><div class=col-xs-6><button type=button class=\"btn btn-default\" ng-click=createDownpaymentInvoice() ng-disabled=\"model.task!=\'r\'\">{{tools.lang({\'en\':\'Create downpayment invoice\',\'nl\':\'Voorschotfactuur maken\',\'fr\':\'Cr\\u00E9er facture acompte\'})}}</button></div></div><div class=\"form-group clearfix\"><div class=\"col-xs-offset-6 col-xs-6\"><button type=button class=\"btn btn-default\" ng-click=createInvoice() ng-disabled=\"model.task!=\'r\'\">{{tools.lang({\'en\':\'Create balance invoice\',\'nl\':\'Saldo factuur maken\',\'fr\':\'Cr\\u00E9er facture solde\'})}}</button></div></div></form></li></ul><ul class=list-group ng-show=\"tools.getLength(tools.join(model.visit,\'tickets\',model))>0 || (user.hasRight(\'TICK\') && model.totalAmount==0 && model.visit.stat<\'3000\' && model.visit.stat!=\'1210\')\"><li class=list-group-item ng-repeat=\"ticket in tools.join(model.visit,\'tickets\',model) | orderBy:\'id\'\"><b ng-class=\"{\'linethrough\':ticket.del!=\'0\'}\">{{tools.lang({\'en\':\'Ticket\',\'nl\':\'Ticket\',\'fr\':\'Ticket\'})+\' \'+activitiesService.ticketOut(ticket.ticketnr)}} </b><button class=\"btn btn-default\" ng-disabled=\"!(ticket.del==\'0\' && (tools.getLength(tools.join(model.visit,\'activities\',model))>0 || tools.getLength(tools.join(model.visit,\'meals\',model))>0 || tools.getLength(tools.join(model.visit,\'hotelreservationcategories\',model))>0 || tools.getLength(tools.join(model.visit,\'products\',model))>0)) || model.task!=\'r\'\" ng-click=printTicket()><span class=\"glyphicon glyphicon-print\"></span></button> <button class=\"btn btn-default\" ng-disabled=\"!(ticket.del==\'0\' && (tools.getLength(tools.join(model.visit,\'activities\',model))>0 || tools.getLength(tools.join(model.visit,\'meals\',model))>0 || tools.getLength(tools.join(model.visit,\'hotelreservationcategories\',model))>0 || tools.getLength(tools.join(model.visit,\'products\',model))>0)) || model.task!=\'r\'\" ng-click=sendConfirmationEmail()><span class=\"glyphicon glyphicon-envelope\"></span></button> &nbsp; {{tools.doneBy(ticket.created,ticket.updater_name)}} <button type=button class=\"btn btn-default\" ng-show=\"ticket.del==\'0\'\" ng-click=deleteTicket(ticket) ng-disabled=\"model.task!=\'r\'\">{{tools.lang({\'en\':\'Invalidate\',\'nl\':\'Ongeldig maken\',\'fr\':\'Invalider\'})}}<!--  && tools.getLength(tools.greaterEqual(tools.join(model.visit,\'activities\',model),\'stat\',3000))==0 --></button></li><li class=list-group-item ng-show=\"user.hasRight(\'TICK\') && model.totalAmount==0 && model.visit.stat<\'3000\' && model.visit.stat!=\'1210\'\"><button type=button class=\"btn btn-default\" ng-click=freeTicket() ng-disabled=\"model.task!=\'r\'\">{{tools.lang({\'en\':\'Free ticket\',\'nl\':\'Gratis ticket\',\'fr\':\'Ticket gratuit\'})}}</button></li></ul><ul class=list-group ng-show=\"model.rfidcarrierCount>0 || (model.visit.stat>2100 && model.visit.stat<9000 && user.role.substr(0,3)!=\'PTN\')\"><li class=list-group-item><button type=button class=\"btn btn-default\" ng-click=\"tools.redirect(buildHref(\'rfid\',\'retrieveVisit\',model.visit.id,\'0\'));\"><span class=\"glyphicon glyphicon-search\"></span></button> {{model.rfidcarrierCount+\' \'+tools.lang({\'en\':\'passes\',\'nl\':\'passen\',\'fr\':\'pass\'})}}</li></ul></div></section>");
$templateCache.put("app/modules/activities/roomOverview.html","<div ng-controller=ActivitiesRoomOverviewController class=\"page page-activities-room-overview page--tables\"><aside id=filters class=\"page__sidebar sidebar\"><div class=sidebar__header><h4 class=title>{{tools.lang({\'en\':\'Filters\',\'nl\':\'Filters\',\'fr\':\'Filtres\'})}}</h4><button class=\"btn btn-default btn-rounded\"><span class=material-icons ng-click=\"toggleFilters(\'filters\')\">close</span></button></div><div class=sidebar__content><form class=form-horizontal><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\" ng-click=\"model.startdateOpened=!model.startdateOpened\">{{tools.lang({\'en\':\'Start\',\'nl\':\'Start\',\'fr\':\'D\\u00E9but\'})}}</label><div class=col-sm-10><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.startdate is-open=model.startdateOpened datepicker-options=model.dateOptions ng-click=\"model.startdateOpened=!model.startdateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.startdateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"form-group clearfix\"><div class=\"col-sm-offset-2 col-sm-10\"><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"act in tools.match(parameters.notDelACT,{\'field2\':\'1\'})\" ng-click=selectAct(act.id); ng-class=\"{\'active\':model.acts.indexOf(act.id)>=0}\">{{tools.label(act)}}</button></div></div></div></form></div><div class=sidebar__footer><button type=submit class=\"btn btn-primary\" ng-click=\"load(); toggleFilters(\'filters\');\">{{tools.lang({\'en\':\'Done\',\'nl\':\'Done\',\'fr\':\'Appliquer\'})}}</button></div></aside><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\':\'Room overview\',\'nl\':\'Room overview\',\'fr\':\'Room overview\'})}}</h1><div class=header__actions><div class=\"page__actions hidden-xs\"><button type=button class=\"btn btn-default\" ng-click=increaseDates(-1);><span class=material-icons>chevron_left</span></button> <button type=button style=\"width: auto\" class=\"btn btn-default\" ng-click=todayDate()>{{tools.lang({\'en\':\'Today\',\'nl\':\'Vandaag\',\'fr\':\'Aujourd\\u0027hui\'})}}</button> <button type=button class=\"btn btn-default\" ng-click=increaseDates(1);><span class=material-icons>chevron_right</span></button></div><button class=\"btn btn-default btn-filters\" ng-click=\"toggleFilters(\'filters\')\"><i class=material-icons>filter_list</i> <span class=\"btn__text hidden-xs hidden-sm\">{{tools.lang({\'en\':\'Filters\',\'nl\':\'Filters\',\'fr\':\'Filtres\'})}}</span></button></div></section><div class=content><div class=\"content__item c-table-view\" ng-hide=webservice.calling><div class=c-table-view__item ng-repeat=\"hrsList in tools.toArray(model.hrsLists) | orderBy:\'date\'\"><h4 class=c-table-view__title>{{hrsList.date+\' \'+tools.dateToWeekday(hrsList.date)+\' - \'+getActTitle()}}</h4><ul class=table-legend><li class=table-legend__item><span class=\"item__circle color-success\"></span> <span class=item__text>{{tools.lang({\'en\':\'Confirmed\',\'nl\':\'Bevestigd\',\'fr\':\'Confirm\\u00E9\'})}}</span></li><li class=table-legend__item><span class=\"item__circle color-info\"></span> <span class=item__text>{{tools.lang({\'en\':\'Unpaid\',\'nl\':\'Onbetaald\',\'fr\':\'Impay\\u00E9\'})}}</span></li><li class=table-legend__item><span class=\"item__circle color-warning\"></span> <span class=item__text>{{tools.lang({\'en\':\'Option\',\'nl\':\'Optie\',\'fr\':\'Option\'})}}</span></li></ul><div class=table-responsive-wrapper ng-style=\"{\'overflow\': \'auto\',\'max-height\': model.windowHeight}\"><table class=\"table table-striped\" style=\"width: 100%; border-collapse: collapse\"><thead style=\"position: sticky;top: 0;left: 0;z-index: 999\"><tr style=\"position: sticky;top: 0;left: 0;z-index: 999;width: 100%\"><th class=\"table__col col--hours\" colspan=2 style=\"position: sticky;top: 0;left: 0;z-index: 999;width: 80px\"><span class=th__content></span></th><th colspan={{model.structuredVisits[hrsList.date].maxUntLoads[unt.id].maxLoad}} ng-repeat=\"unt in getUntList()\" ng-style=\"{\'width\':(model.structuredVisits[hrsList.date].maxUntLoads[unt.id].maxLoad/model.sumLoads[hrsList.date]*100)+\'%\'}\" style=\"position: sticky;top: 0;left: 0;z-index: 999\"><span class=th__content>{{tools.label(unt)}}</span></th></tr></thead><tbody>{{structuredVisits=model.structuredVisits[hrsList.date];\"\";}}<tr ng-repeat=\"hrs in model.structuredVisits[hrsList.date].hrss\" style=width:100%><td ng-show=hrs.firstParent rowspan={{model.structuredVisits[hrsList.date].parentHrss[hrs.hrs.substr(0,2)].rowspan}} class=\"table__col col--hours col--sticky\" style=\"width:40px;padding: 4px 4px;height: 30px !important;vertical-align: top !important;text-align: right !important\" ng-style=\"{\'font-size\': getMaxRowspanParentHrss(structuredVisits.parentHrss)>1?\'18px\':\'default\'}\">{{model.structuredVisits[hrsList.date].parentHrss[hrs.hrs.substr(0,2)].parentHrs}}</td><td class=\"table__col col--hours col--sticky\" style=\"width:40px;padding: 4px 1px;height: 30px !important;vertical-align: top !important;font-size: 12px\">{{hrs.hrs.substr(3,2)}}</td><td ng-repeat-start=\"loadElement in hrs.loadElements\" ng-show=loadElement.first colspan={{loadElement.colspan}} rowspan={{loadElement.rowspan}} ng-style=\"{\'width\':(loadElement.colspan/model.sumLoads[hrsList.date]*100)+\'%\'}\" style=\"padding: 1px;height: 30px !important\" ng-mouseenter=\"hover=true;\" ng-mouseleave=\"hover=false\" class=hidden-print>{{visit=loadElement.visit;activity=loadElement.activity;colorClass=parameters.STV[loadElement.stat].field2;\"\";}} <button ng-if=!loadElement.addReservation class=btn style=\"text-align: left;height: 100%; width:100%;justify-content: space-between; align-items: flex-start; overflow-wrap: break-word;white-space: normal;font-size: 12px\" ng-class=\"{\'btn-danger\':colorClass===\'error\',\'btn-success\':colorClass===\'default\',\'btn-info\':colorClass===\'info\',\'btn-warning\':colorClass===\'warning\'}\" uib-tooltip-html=loadElement.trustedInfo ng-style=\"{\'border-left\':activity.stat==3000?\'6px solid green\':(activity.stat==8000?\'6px solid red\':\'default\')}\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=750 tooltip-class=info><div ng-bind-html=loadElement.trustedInfo ng-click=\"visit.id!==\'0\'?visitRetrieve(visit.id):\'\';\"></div><div><span ng-show=\"activity.stat==1000\" class=\"btn btn-default\" ng-click=\"updateActivityStat(activity,\'3000\')\"><span class=\"glyphicon glyphicon-import\"></span> </span><span ng-show=\"activity.stat==3000\" class=\"btn btn-default\" ng-click=\"updateActivityStat(activity,\'8000\')\"><span class=\"glyphicon glyphicon-export\"></span> </span><span ng-hide=\"activity==null || activity.stat==1000\" class=\"btn btn-warning\" ng-click=\"updateActivityStat(activity,\'1000\')\"><span class=\"glyphicon glyphicon-repeat\"></span></span></div></button> <button ng-if=\"loadElement.addReservation && loadElement.isStartHour && hover\" class=\"btn btn-default hidden-print\" style=\"height: 100%; text-align: center; width:100%;padding: 0px 4px\" ng-click=addReservation(loadElement.unt,hrsList.date,hrs.hrs)><span class=material-icons>add</span></button></td><td ng-repeat-end ng-show=loadElement.first colspan={{loadElement.colspan}} rowspan={{loadElement.rowspan}} ng-style=\"{\'width\':(loadElement.colspan/model.sumLoads[hrsList.date]*100)+\'%\',\'border-style\':\'solid\',\'border-width\':loadElement.addReservation?\'0 0 1px 0\':\'1px\',\'border-color\':loadElement.addReservation?\'#dfe5e8\':(loadElement.stat<2000?\'black\':(loadElement.stat<3000?\'lightblue\':(loadElement.stat<9000?\'lightgreen\':\'red\')))}\" style=\"padding: 1px 15px;height: 45px\" class=visible-print><div ng-if=!loadElement.addReservation style=\"text-align: left;height: 100%; width:100%;justify-content: flex-start; align-items: flex-start; overflow-wrap: break-word;white-space: normal;font-size: 12px\" ng-bind-html=loadElement.trustedInfo></div></td></tr></tbody></table></div></div></div><div class=\"content__item page__loader\" ng-show=webservice.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div></div><div class=\"page__actions hidden-sm hidden-md hidden-lg\"><button type=button class=\"btn btn-default\" ng-click=increaseDates(-1);><span class=material-icons>chevron_left</span></button> <button type=button style=\"width: auto\" class=\"btn btn-default\" ng-click=todayDate()>{{tools.lang({\'en\':\'Today\',\'nl\':\'Vandaag\',\'fr\':\'Aujourd\\u0027hui\'})}}</button> <button type=button class=\"btn btn-default\" ng-click=increaseDates(1);><span class=material-icons>chevron_right</span></button></div></main></div>");
$templateCache.put("app/modules/activities/search.html","<section ng-controller=activitiesSearchController class=\"page page-activities-search page--tables\"><aside id=filters class=\"page__sidebar sidebar\"><div class=sidebar__header><h4 class=title>{{tools.lang({\'en\':\'Filters\',\'nl\':\'Filters\',\'fr\':\'Filtres\'})}}</h4><button class=\"btn btn-default btn-rounded\"><span class=material-icons ng-click=\"toggleFilters(\'filters\')\">close</span></button></div><div class=sidebar__content><form class=form-horizontal><div class=\"form-group clearfix\"><div class=col-sm-12><label class=control-label>{{tools.lang({\'en\':\'Search in\',\'nl\':\'Zoek in\',\'fr\':\'Chercher dans\'})}}</label></div><div class=col-sm-12><div class=checkbox><label><input type=checkbox ng-model=model.getActivities> {{tools.lang({\'en\':\'Activities\',\'nl\':\'Activiteiten\',\'fr\':\'Activit\\u00E9\'})}}</label></div></div><div class=col-sm-12><div class=checkbox><label><input type=checkbox ng-model=model.getMeals> {{tools.lang({\'en\':\'Meals\',\'nl\':\'Maaltijden\',\'fr\':\'Repas\'})}}</label></div></div><div class=col-sm-12><div class=checkbox><label><input type=checkbox ng-model=model.getAccomodations> {{tools.lang({\'en\':\'Accomodations\',\'nl\':\'Accomodaties\',\'fr\':\'H\\u00E9bergements\'})}}</label></div></div></div><div class=\"form-group clearfix\"><div class=col-sm-12><label class=control-label>{{tools.lang({\'en\':\'Client type\',\'nl\':\'Klanttype\',\'fr\':\'Type client\'})}}</label><div class=btn-group><button type=button class=\"btn btn-default\" ng-click=clearTypes() ng-class=\"{\'active\':model.anyTypeIsActive}\">{{tools.label(any)}}</button> <button type=button class=\"btn btn-default\" ng-repeat=\"typeOption in tools.toArray(model.typeOptions)\" ng-click=clickType(typeOption) ng-class=\"{\'active\':typeOption.active}\">{{tools.label(typeOption)}}</button></div></div></div><div class=\"form-group clearfix\" ng-show=model.enableOrigin><div class=col-sm-12><label class=control-label>{{tools.lang({\'en\':\'Created by\',\'nl\':\'Aangemaakt door\',\'fr\':\'Cr\\u00E9\\u00E9 par\'})}}</label><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"originOption in model.originOptionsArray\" ng-click=\"model.origin=originOption.id;setOriginFilteredOptions();\" ng-class=\"{\'active\':model.origin==originOption.id}\">{{tools.label(originOption)}}</button></div></div></div><div class=\"form-group clearfix\" ng-show=model.enablePartners><div class=col-sm-12><label class=control-label>{{tools.lang({\'en\':\'Partner\',\'nl\':\'Partner\',\'fr\':\'Partner\'})}}</label><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"partnerOption in model.partnerOptions\" ng-click=\"model.partner=partnerOption.id\" ng-class=\"{\'active\':model.partner==partnerOption.id}\">{{tools.label(partnerOption)}}</button></div></div></div><div class=\"form-group clearfix\"><div class=col-sm-12><label class=control-label ng-click=\"model.startdateOpened=!model.startdateOpened\">{{tools.lang({\'en\':\'Visit Start\',\'nl\':\'Bezoek Start\',\'fr\':\'D\\u00E9but visite\'})}}</label><div class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.startdate is-open=model.startdateOpened datepicker-options=model.dateOptions ng-click=\"model.startdateOpened=!model.startdateOpened\"><div class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.startdateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></div></div></div></div><div class=\"form-group clearfix\"><div class=col-sm-12><label class=control-label ng-click=\"model.enddateOpened=!model.enddateOpened\">{{tools.lang({\'en\':\'Visit End\',\'nl\':\'Bezoek Einde\',\'fr\':\'Fin visite\'})}}</label><div class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.enddate is-open=model.enddateOpened datepicker-options=model.dateOptions ng-click=\"model.enddateOpened=!model.enddateOpened\"><div class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.enddateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></div></div></div></div><div class=\"form-group clearfix\" ng-show=\"model.enableOrigin && model.originOptions[model.origin].showOrigin\"><div class=col-sm-12><label class=control-label>{{tools.lang({\'en\':\'Client origin\',\'nl\':\'Klant origine\',\'fr\':\'Origine client\'})}}</label><div class=btn-group><button type=button class=\"btn btn-default\" ng-click=clearOrigins() ng-class=\"{\'active\':model.anyOriginIsActive}\">{{tools.label(any)}}</button> <button type=button class=\"btn btn-default\" ng-repeat=\"vis in tools.toArray(model.originFilteredOptions)\" ng-click=clickOrigin(vis) ng-class=\"{\'active\':vis.active}\">{{tools.label(vis)}}</button></div></div></div><div class=\"form-group clearfix\"><div class=col-sm-12><label class=control-label ng-click=\"model.startdateOpened=!model.startdateOpened\">{{tools.lang({\'en\':\'Created from\',\'nl\':\'Gemaakt vanaf\',\'fr\':\'Cr\\u00E9\\u00E9 de\'})}}</label><div class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.createdstart is-open=model.createdstartOpened datepicker-options=model.dateOptions ng-click=\"model.createdstartOpened=!model.createdstartOpened\"><div class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.createdstartOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></div></div></div><div class=col-sm-12><label class=control-label ng-click=\"model.createdendOpened=!model.createdendOpened\">{{tools.lang({\'en\':\'Created until\',\'nl\':\'Gemaakt tot\',\'fr\':\'Cr\\u00E9\\u00E9 a\'})}}</label><div class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.createdend is-open=model.createdendOpened datepicker-options=model.dateOptions ng-click=\"model.createdendOpened=!model.createdendOpened\"><div class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.createdendOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></div></div></div></div></form></div><div class=sidebar__footer><button type=submit class=\"btn btn-primary\" ng-click=search();>{{tools.lang({\'en\':\'Done\',\'nl\':\'Done\',\'fr\':\'Appliquer\'})}}</button></div></aside><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\':\'Search by name\',\'nl\':\'Zoek op naam\',\'fr\':\'Chercher par nom\'})}}</h1><div class=header__filters><div class=search-wrapper><span class=material-icons ng-click=search();>search</span> <input type=text class=\"form-control search__input input input--search\" ng-model=model.searchTerm ng-enter=search(); placeholder=\"{{tools.lang({\'en\':\'Search\',\'nl\':\'Search\',\'fr\':\'Chercher\'})}}\"></div>&nbsp;<div class=checkbox><label><input type=checkbox ng-model=model.exactMatch> {{tools.lang({\'en\':\'Exact match\',\'nl\':\'Exacte overeenkomst\',\'fr\':\'Correspondance exacte\'})}}</label></div></div><div class=header__actions><button class=\"btn btn-default btn-filters\" ng-click=\"toggleFilters(\'filters\')\"><i class=material-icons>filter_list</i> <span class=\"btn__text hidden-xs hidden-sm\">{{tools.lang({ \'en\': \'Filters\', \'nl\': \'Filters\', \'fr\': \'Filtres\' })}}</span></button></div></section><div class=content><div class=\"content__item c-table-view\" ng-show=\"!webservice.calling && (tools.getLength(model.activities)>0 || tools.getLength(model.meals)>0 || tools.getLength(model.hotelreservationcategories)>0)\"><div class=c-table-view__item><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><thead><tr><th><span class=th__content></span></th><th><span class=th__content>{{tools.lang({\'en\':\'Date\',\'nl\':\'Datum\',\'fr\':\'Date\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Hour\',\'nl\':\'Hour\',\'fr\':\'Heure\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Name\',\'nl\':\'Naam\',\'fr\':\'Nom\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Location/Activity\',\'nl\':\'Location/Activity\',\'fr\':\"Lieu/Activit\\u00E9\"})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Details\',\'nl\':\'Details\',\'fr\':\'D\\u00E9tails\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Comment\',\'nl\':\'Opmerking\',\'fr\':\'Remarque\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Status\',\'nl\':\'Status\',\'fr\':\'Statut\'})}}</span></th></tr></thead><tbody><tr ng-repeat=\"elementWithDate in model.elementsWithDate | orderBy:[\'-created\',\'relevance\',\'day\',\'hrs\']\" ng-class=\"{\'info\':model.visits[elementWithDate.visit].vis==\'COM\'}\"><td><input retrieve ng-click=visitRetrieve(elementWithDate.visit)></td><td>{{tools.dateOut(tools.dateFromJava(elementWithDate.day))}}</td><td>{{tools.hourOut(elementWithDate.hrs)}}</td><td>{{contactsService.getName(model.contacts[model.visits[elementWithDate.visit].owningcontact])}}</td><td>{{elementWithDate.name}}</td><td class=ellipsis>{{elementWithDate.quantities}}</td><td><span class=\"glyphicon glyphicon-file\" ng-show=\"model.visits[elementWithDate.visit].comment!=\'\'\"></span>{{elementWithDate.comment}}</td><td>{{tools.label(parameters.STV[model.visits[elementWithDate.visit].stat])}}</td></tr></tbody></table></div></div></div><div class=content__noresult><div class=\"alert alert-info\" role=alert ng-show=\"!webservice.calling && !(tools.getLength(model.activities)>0 || tools.getLength(model.meals)>0 || tools.getLength(model.hotelreservationcategories)>0)\"><p>{{tools.lang({\'en\':\'No result - Change filters\',\'nl\':\'No result - Change filters\',\'fr\':\'Aucun résultat - Affinez votre recherche\'})}}</p></div></div><div class=\"content__item page__loader\" ng-show=webservice.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div></div></main></section>");
$templateCache.put("app/modules/activities/searchReference.html","<div ng-controller=ActivitiesSearchReferenceController class=\"page page-activities-search-reference page--content\"><form class=form-horizontal><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Reference or ticket\',\'nl\':\'Referentie of ticket\',\'fr\':\'Reference ou ticket\'})}}</label><div class=col-sm-4><input type=text class=form-control ng-model=model.reference ng-enter=retrieve();></div><div class=col-sm-6><p>{{tools.lang({\'en\':\'The reference of a visit is a number shown on an offer or in the URL of your browser when viewing the visit.\',\'nl\':\'De referentie van een bezoek wordt getoond op een offerte of in de URL van uw browser wanneer u het bezoek raadpleegt.\',\'fr\':\'La reference d\\u0027une visite est visible sur une offre ou dans le URL de ton browser quand vous consultez la visite.\'})}}</p><p>{{tools.lang({\'en\':\'A ticket number is attributed to a visit when it is paid. Separate the digits by a point to search for a ticket. For example 123.456\',\'nl\':\'Een ticketnummer wordt toegewezen aan een bezoek als het betaald is. Scheid de cijfers met een punt om een ticket te zoeken. Bijvoorbeeld 123.456\',\'fr\':\'Le numero de ticket est attribu\\u00E9 a une visite quand c\\u0027est pay\\u00E9. Separez les chiffres avec un point pour chercher un ticket. Par example 123.456\'})}}</p></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Invoice\',\'nl\':\'Factuur\',\'fr\':\'Facture\'})}}</label><div class=col-sm-10><input type=text class=form-control ng-model=model.exactnumber ng-enter=retrieve();></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Structured message\',\'nl\':\'Gestructureerde mededeling\',\'fr\':\'Message structur\\u00E9\'})}}</label><div class=col-sm-10><input type=text class=form-control ng-model=model.ogm ng-enter=retrieve();></div></div><div class=\"form-group clearfix\"><div class=\"col-sm-offset-2 col-sm-10\"><button type=submit class=\"btn btn-primary\" ng-click=retrieve();>{{tools.lang({\'en\':\'Search reference\',\'nl\':\'Zoek referentie\',\'fr\':\'Chercher reference\'})}}</button></div></div><div class=content__noresult><div class=\"alert alert-info\" role=alert ng-show=\"!webservice.calling && model.hasNoResult\"><p>{{tools.lang({\'en\':\'No result\',\'nl\':\'No result\',\'fr\':\'Aucun résultat\'})}}</p></div></div></form></div>");
$templateCache.put("app/modules/activities/statistics.html","<section ng-controller=ActivitiesStatisticsController class=\"page page-activities-statistics page--tables\"><aside id=filters class=\"page__sidebar sidebar hidden-md hidden-lg\"><div class=sidebar__header><h4 class=title>{{tools.lang({\'en\':\'Filters\',\'nl\':\'Filters\',\'fr\':\'Filtres\'})}}</h4><button class=\"btn btn-default btn-rounded\"><span class=material-icons ng-click=\"toggleFilters(\'filters\')\">close</span></button></div><div class=sidebar__content><form><div class=form-group><label class=control-label ng-click=\"model.startdateOpened=!model.startdateOpened\">{{tools.lang({\'en\':\'Start\',\'nl\':\'Start\',\'fr\':\'D\\u00E9but\'})}}</label><div class=input-group><input type=text autocomplete=off class=form-control uib-datepicker-popup ng-model=model.startdate is-open=model.startdateOpened datepicker-options=model.dateOptions ng-click=\"model.startdateOpened=!model.startdateOpened\"><div class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.startdateOpened=!model.startdateOpened\"><i class=\"glyphicon glyphicon-calendar\"></i></button></div></div></div><div class=form-group><label class=control-label ng-click=\"model.enddateOpened=!model.enddateOpened\">{{tools.lang({\'en\':\'To\',\'nl\':\'Tot\',\'fr\':\'Fin\'})}}</label><div class=input-group><input type=text autocomplete=off class=form-control uib-datepicker-popup ng-model=model.enddate is-open=model.enddateOpened datepicker-options=model.dateOptions ng-click=\"model.enddateOpened=!model.enddateOpened\"><div class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.enddateOpened=!model.enddateOpened\"><i class=\"glyphicon glyphicon-calendar\"></i></button></div></div></div></form></div><div class=sidebar__footer><button type=submit class=\"btn btn-primary\" ng-click=\"load(); toggleFilters(\'filters\');\">{{tools.lang({\'en\':\'Done\',\'nl\':\'Done\',\'fr\':\'Appliquer\'})}}</button></div></aside><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\':\'Activity statistics\',\'nl\':\'Activity statistics\',\'fr\':\'Statistiques des activités\'})}}</h1><div class=header__actions><form class=\"hidden-xs hidden-sm\"><div class=\"form-group inline-flex\"><label class=control-label ng-click=\"model.startdateOpened=!model.startdateOpened\">{{tools.lang({\'en\':\'Start\',\'nl\':\'Start\',\'fr\':\'D\\u00E9but\'})}}</label><div class=input-group><input type=text autocomplete=off class=form-control uib-datepicker-popup ng-model=model.startdate is-open=model.startdateOpened datepicker-options=model.dateOptions ng-click=\"model.startdateOpened=!model.startdateOpened\"><div class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.startdateOpened=!model.startdateOpened\"><i class=\"glyphicon glyphicon-calendar\"></i></button></div></div></div><div class=\"form-group inline-flex\"><label class=control-label ng-click=\"model.enddateOpened=!model.enddateOpened\">{{tools.lang({\'en\':\'To\',\'nl\':\'Tot\',\'fr\':\'Fin\'})}}</label><div class=input-group><input type=text autocomplete=off class=form-control uib-datepicker-popup ng-model=model.enddate is-open=model.enddateOpened datepicker-options=model.dateOptions ng-click=\"model.enddateOpened=!model.enddateOpened\"><div class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.enddateOpened=!model.enddateOpened\"><i class=\"glyphicon glyphicon-calendar\"></i></button></div></div></div><div class=form-group><button class=\"btn btn-primary\" ng-click=load();>{{tools.lang({\'en\':\'Search\',\'nl\':\'Tonen\',\'fr\':\'Rechercher\'})}}</button></div></form><button class=\"btn btn-default btn-filters hidden-md hidden-lg\" ng-click=\"toggleFilters(\'filters\')\"><i class=material-icons>filter_list</i> <span class=\"btn__text hidden-xs hidden-sm\">{{tools.lang({\'en\':\'Filters\',\'nl\':\'Filters\',\'fr\':\'Filtres\'})}}</span></button></div></section><div class=content><div class=\"alert alert-info\"><p>{{tools.lang({\'en\':\'Please note that this data is not representative because employees tend to enter their own language instead that of the client. A less biased statistic suggests 5% english, 56% dutch and 39% french speaking\',\'nl\':\'Deze data is niet representatief omdat werknemers de neiging hebben om hun eigen taal in te vullen in plaats van die van de klant. Een objectievere statistiek suggereert 5% engels, 56% nederlands en 39% franstalig.\',\'fr\':\'Ces donn\\u00E9es ne sont pas representatives parce que les employees mettent leur propre langue au lieu de la langue du client. Une statistique plus objectif sugg\\u00E8re 5% anglais, 56% n\\u00E9erlandais et 39% francophone.\'})}}</p></div><div class=\"content__item c-table-view\" ng-hide=model.calling><div class=c-table-view__item><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><thead><tr><th><span class=th__content>{{tools.lang({\'en\':\'Activity\',\'nl\':\'Activiteit\',\'fr\':\'Activit\\u00E9\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Month\',\'nl\':\'Maand\',\'fr\':\'Mois\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Language\',\'nl\':\'Taal\',\'fr\':\'Langue\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'People\',\'nl\':\'Personen\',\'fr\':\'Personnes\'})}}</span></th></tr></thead><tbody><tr ng-repeat=\"line in model.lines | orderBy:\'date\'\"><td>{{tools.label(parameters.ACT[line.act])}}</td><td>{{line.month}}</td><td>{{line.lang}}</td><td>{{line.ppl}}</td></tr></tbody></table></div></div></div><div class=\"content__item page__loader\" ng-show=model.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div></div></main></section>");
$templateCache.put("app/modules/admin/listTransactions.html","<div ng-controller=AdminListTransactionsController class=\"page page--tables\"><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\':\'Errors\',\'nl\':\'Fouten\',\'fr\':\'Erreurs\'})}}</h1><div class=header__actions><input refresh ng-hide=webservice.calling ng-click=load();></div></section><div class=content><div class=\"content__item c-table-view\" ng-hide=\"webservice.calling || tools.getLength(model.transactions)==0\"><div class=c-table-view__item><div class=c-table-view__item__content ng-repeat=\"(transactiontype,transactions) in model.indexedByTypeTransactions\"><h4 class=c-table-view__title>{{transactiontype}}</h4><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><thead><tr><th><span class=th__content style=\"justify-content: center\"><input type=checkbox ng-model=model[transactiontype] checkbox-all child-list=model.indexedByTypeTransactions[transactiontype] property=selected></span></th><th><span class=th__content>Key</span></th><th><span class=th__content>Stat</span></th><th><span class=th__content>Error</span></th><th><span class=th__content><span ng-show=\"tools.getLength(tools.match(model.indexedByTypeTransactions[transactiontype],{\'selected\':true}))>0\">{{tools.lang({\'en\':\'Selection\',\'nl\':\'Selectie\',\'fr\':\'S\\u00E9lection\'})}}&nbsp; <button refresh class=\"btn btn-default\" ng-click=relaunchSelectedTransactions(transactiontype)></button> <button delete class=\"btn btn-danger\" ng-click=deleteSelectedTransactions(transactiontype)></button></span></span></th></tr></thead><tbody><tr ng-repeat=\"transaction in transactions | orderBy:\'transactionkey\'\"><td class=text-center><input type=checkbox ng-model=transaction.selected></td><td>{{transaction.transactionkey}}</td><td>{{transaction.statvalue+\' \'+transaction.statwording}}</td><td>{{transaction.errorwording}}</td><td><button refresh class=\"btn btn-default\" ng-click=relaunchTransaction(transaction)></button> <button delete class=\"btn btn-danger\" ng-click=deleteTransaction(transaction)></button></td></tr></tbody></table></div></div></div></div><div class=\"content__item page__loader\" ng-show=webservice.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div><div class=content__noresult ng-show=\"!webservice.calling && tools.getLength(model.transactions)==0\"><div ng-show=\"errorMessage===null\" class=\"alert alert-info\" role=alert><p>{{tools.lang({\'en\':\'No errors.\',\'nl\':\'Geen fouten.\',\'fr\':\'Aucune erreur.\'})}}</p></div><div ng-hide=\"errorMessage===null\" class=\"alert alert-danger\" role=alert><p>{{errorMessage}}</p></div></div></div></main></div>");
$templateCache.put("app/modules/admin/syncIntegrations.html","<div ng-controller=AdminSyncIntegrationsController class=\"page page-admin-sync-integrations page--tables\"><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\':\'Sync Integrations\',\'nl\':\'Sync Integrations\',\'fr\':\'Sync Integrations\'})}}</h1></section><div class=content><div class=\"content__item c-table-view\" ng-hide=webservice.calling><div class=c-table-view__item><div class=c-table-view__item__content ng-show=\"tools.getLength(parameters.notDelHTL)>0\"><h4 class=c-table-view__title>{{tools.lang({\'en\':\'Mews\',\'nl\':\'Mews\',\'fr\':\'Mews\'})}}</h4><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><thead><tr><th><span class=th__content>{{tools.lang({\'en\':\'Hotel\',\'nl\':\'Hotel\',\'fr\':\'Hotel\'})}}</span></th><th colspan=2><span class=th__content>{{tools.lang({\'en\':\'Mews ID\',\'nl\':\'Mews ID\',\'fr\':\'Mews ID\'})}}</span></th></tr></thead><tbody><tr ng-repeat=\"htl in parameters.notDelHTL\"><td>{{tools.label(htl)}}</td><td>{{htl.field1}}</td><td><button refresh ng-click=refreshMewsHotelParams(htl.id);></button></td></tr></tbody></table></div></div><div class=c-table-view__item__content ng-show=\"tools.getLength(model.POS)>0\"><h4 class=c-table-view__title>{{tools.lang({\'en\':\'Untill\',\'nl\':\'Untill\',\'fr\':\'Untill\'})}}</h4><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><thead><tr><th><span class=th__content>{{tools.lang({\'en\':\'POS\',\'nl\':\'POS\',\'fr\':\'POS\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Host\',\'nl\':\'Host\',\'fr\':\'Host\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Sales areas\',\'nl\':\'Verkoopszones\',\'fr\':\'Zones de vente\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Articles\',\'nl\':\'Artikelen\',\'fr\':\'Articles\'})}}</span></th></tr></thead><tbody><tr ng-repeat=\"pos in model.POS\"><td>{{tools.label(pos)}}</td><td><span ng-style=\"{\'color\':pos.online?\'green\':\'red\'}\">●</span>&nbsp;{{pos.host}}</td><td><button refresh ng-click=refreshUntillRsa(pos.id);></button></td><td><button refresh ng-click=syncAllArticles(pos.id);></button></td></tr></tbody></table></div></div></div></div><div class=\"content__item page__loader\" ng-show=webservice.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div></div></main></div>");
$templateCache.put("app/modules/agenda/reservations.html","<div ng-controller=AgendaReservationsController class=\"page page--tables\"><aside id=filters class=\"page__sidebar sidebar\"><div class=sidebar__header><h4 class=title>{{tools.lang({\'en\':\'Filters\',\'nl\':\'Filters\',\'fr\':\'Filtres\'})}}</h4><button class=\"btn btn-default btn-rounded\"><span class=material-icons ng-click=\"toggleFilters(\'filters\')\">close</span></button></div><div class=sidebar__content><form class=form-horizontal><div class=\"form-group clearfix\"><div class=col-sm-12><div class=btn-group><button type=button class=\"btn btn-default\" ng-click=toggleShowActivities(); ng-class=\"{\'active\':model.showActivities}\">{{tools.lang({\'en\':\'Activities\',\'nl\':\'Activiteiten\',\'fr\':\'Activit\\u00E9s\'})}}</button> <button type=button class=\"btn btn-default\" ng-click=toggleShowMeals(); ng-class=\"{\'active\':model.showMeals}\">{{tools.lang({\'en\':\'Meals\',\'nl\':\'Maaltijden\',\'fr\':\'Repas\'})}}</button> <button type=button class=\"btn btn-default\" ng-click=toggleShowAccomodations(); ng-class=\"{\'active\':model.showAccomodations}\">{{tools.lang({\'en\':\'Accomodations\',\'nl\':\'Accomodatie\',\'fr\':\'H\\u00E9bergement\'})}}</button> <button type=button class=\"btn btn-default\" ng-click=toggleShowProducts(); ng-class=\"{\'active\':model.showProducts}\">{{tools.lang({\'en\':\'Products\',\'nl\':\'Producten\',\'fr\':\'Produits\'})}}</button></div><div class=btn-group><button type=button class=\"btn btn-default\" style=\"margin-top: 16px\" ng-click=\"model.showPrivate=!model.showPrivate\" ng-class=\"{\'active\':model.showPrivate}\">{{tools.lang({\'en\':\'Show private\',\'nl\':\'Toon particulieren\',\'fr\':\'Montrer particuliers\'})}}</button></div></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-12 control-label\" ng-click=\"model.startdateOpened=!model.startdateOpened\">{{tools.lang({\'en\':\'Start\',\'nl\':\'Start\',\'fr\':\'D\\u00E9but\'})}}</label><div class=col-sm-12><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.startdate is-open=model.startdateOpened datepicker-options=model.dateOptions ng-click=\"model.startdateOpened=!model.startdateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.startdateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><label class=\"col-sm-12 control-label\" ng-click=\"model.enddateOpened=!model.enddateOpened\">{{tools.lang({\'en\':\'End\',\'nl\':\'Einde\',\'fr\':\'Fin\'})}}</label><div class=col-sm-12><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.enddate is-open=model.enddateOpened datepicker-options=model.dateOptions ng-click=\"model.enddateOpened=!model.enddateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.enddateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"form-group clearfix\"><div class=col-sm-12><div class=col-sm-12><div class=\"form-group clearfix\"><label>{{tools.lang({\'en\':\'Name\',\'nl\':\'Naam\',\'fr\':\'Nom\'})}} :</label><input type=text class=form-control ng-model=model.filters.name></div><div class=\"form-group clearfix\"><label>{{tools.lang({\'en\':\'Creation date of visit\',\'nl\':\'Aanmaakdatum van het bezoek\',\'fr\':\'Date de cr\\u00E9ation de la visite\'})}} :</label><div class=\"form-group clearfix\"><label class=\"col-sm-12 control-label\" ng-click=\"model.filters.creationDate.startdateOpened=!model.filters.creationDate.startdateOpened\">{{tools.lang({\'en\':\'After\',\'nl\':\'Na\',\'fr\':\'Apr\\u00E8s\'})}}</label><div class=col-sm-12><p class=input-group><span class=input-group-btn><button refresh ng-click=\"model.filters.creationDate.startdate = \'\'\"></button></span> <input type=text class=form-control uib-datepicker-popup ng-model=model.filters.creationDate.startdate is-open=model.filters.creationDate.startdateOpened datepicker-options=model.dateOptions ng-click=\"model.filters.creationDate.startdateOpened=!model.filters.creationDate.startdateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.filters.creationDate.startdateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><label class=\"col-sm-12 control-label\" ng-click=\"model.filters.creationDate.enddateOpened=!model.filters.creationDate.enddateOpened\">{{tools.lang({\'en\':\'Before\',\'nl\':\'Voor\',\'fr\':\'Avant\'})}}</label><div class=col-sm-12><p class=input-group><span class=input-group-btn><button refresh ng-click=\"model.filters.creationDate.enddate = \'\'\"></button></span> <input type=text class=form-control uib-datepicker-popup ng-model=model.filters.creationDate.enddate is-open=model.filters.creationDate.enddateOpened datepicker-options=model.dateOptions ng-click=\"model.filters.creationDate.enddateOpened=!model.filters.creationDate.enddateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.filters.creationDate.enddateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div><div class=\"form-group clearfix\" ng-show=model.showActivities><label class=\"col-xs-12 col-sm-2 control-label\">{{tools.lang({\'en\':\'Activities\',\'nl\':\'Activiteiten\',\'fr\':\'Activit\\u00E9\'})}}</label><div class=col-sm-12 ng-if=tools.isArray(model.frmOptions)><div ng-dropdown-multiselect=\"\" options=model.frmOptions selected-model=model.frms extra-settings=model.frmSettings group-by=groupKey translation-texts=model.translations></div></div></div><div class=\"form-group clearfix\" ng-show=model.showMeals><label class=\"col-xs-12 col-sm-2 control-label\">{{tools.lang({\'en\':\'Restaurant\',\'nl\':\'Restaurant\',\'fr\':\'Restaurant\'})}}</label><div class=col-sm-12><div ng-dropdown-multiselect=\"\" options=model.resOptions selected-model=model.ress extra-settings=model.resSettings translation-texts=model.translations></div></div></div><div class=\"form-group clearfix\" ng-show=model.showAccomodations><label class=\"col-xs-12 col-sm-2 control-label\">{{tools.lang({\'en\':\'Hotel\',\'nl\':\'Hotel\',\'fr\':\'Hotel\'})}}</label><div class=col-sm-12><div ng-dropdown-multiselect=\"\" options=model.htlOptions selected-model=model.htls extra-settings=model.htlSettings translation-texts=model.translations></div></div></div><div class=\"form-group clearfix\" ng-show=model.showProducts><label class=\"col-xs-12 col-sm-2 control-label\">{{tools.lang({\'en\':\'Product\',\'nl\':\'Product\',\'fr\':\'Produit\'})}}</label><div class=col-sm-12><div ng-dropdown-multiselect=\"\" options=model.prdOptions selected-model=model.prds extra-settings=model.prdSettings translation-texts=model.translations></div></div></div><div class=\"form-group clearfix\"><label class=\"col-xs-12 col-sm-2 control-label\">{{tools.lang({\'en\':\'Origin of the visit\',\'nl\':\'Oorsprong van het bezoek\',\'fr\':\'Origine de la visite\'})}}</label><div class=col-sm-12><div ng-dropdown-multiselect=\"\" options=model.visOptions selected-model=model.viss extra-settings=model.visSettings translation-texts=model.translations></div></div></div></div></div></div></form></div><div class=sidebar__footer><button type=submit class=\"btn btn-primary\" ng-click=\"load(); toggleFilters(\'filters\');\">{{tools.lang({\'en\':\'Done\',\'nl\':\'Done\',\'fr\':\'Appliquer\'})}}</button></div></aside><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\':\'Booking\',\'nl\':\'Booking\',\'fr\':\'Réservations\'})}}</h1><div class=header__actions><div class=\"page__actions hidden-xs hidden-sm\"><button type=button class=\"btn btn-default\" ng-click=increaseWeeks(-4);>-4</button> <button type=button class=\"btn btn-default\" ng-click=increaseWeeks(-1);><span class=material-icons>chevron_left</span></button> <button type=button class=\"btn btn-default\" style=\"width: auto\" ng-click=nextFourWeeks();>{{tools.lang({\'en\':\'Week\',\'nl\':\'Week\',\'fr\':\'Semaine\'})}}</button> <button type=button class=\"btn btn-default\" ng-click=increaseWeeks(1);><span class=material-icons>chevron_right</span></button> <button type=button class=\"btn btn-default\" ng-click=increaseWeeks(4);>+4</button></div><button type=button class=\"btn btn-default btn-fixed\" ng-click=\"model.displayAgendaMode=true;model.displayListMode=false\" ng-class=\"{\'active\':model.displayAgendaMode}\"><span class=\"glyphicon glyphicon-calendar\"></span></button> <button type=button class=\"btn btn-default btn-fixed\" ng-click=\"model.displayListMode=true;model.displayAgendaMode=false\" ng-class=\"{\'active\':model.displayListMode}\"><span class=\"glyphicon glyphicon-list\"></span></button> <button class=\"btn btn-default btn-filters\" ng-click=\"toggleFilters(\'filters\')\"><i class=material-icons>filter_list</i> <span class=\"btn__text hidden-xs hidden-sm\">{{tools.lang({\'en\':\'Filters\',\'nl\':\'Filters\',\'fr\':\'Filtres\'})}}</span></button></div></section><div class=content><div class=\"content__item c-table-view\"><div class=c-table-view__item><ul class=table-legend><li class=table-legend__item><span class=\"item__circle color-default\"></span> <span class=item__text>{{tools.lang({\'en\':\'Confirmed\',\'nl\':\'Bevestigd\',\'fr\':\'Confirm\\u00E9\'})}}</span></li><li class=table-legend__item><span class=\"item__circle color-info\"></span> <span class=item__text>{{tools.lang({\'en\':\'Unpaid\',\'nl\':\'Onbetaald\',\'fr\':\'Impay\\u00E9\'})}}</span></li><li class=table-legend__item><span class=\"item__circle color-warning\"></span> <span class=item__text>{{tools.lang({\'en\':\'Option\',\'nl\':\'Optie\',\'fr\':\'Option\'})}}</span></li></ul></div></div><div class=\"content__item page__loader\" ng-show=webservice.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div><div class=calendar ng-show=\"model.displayAgendaMode && !webservice.calling\"><div class=\"row calendar__row seven-cols\" ng-repeat=\"line in model.lines\"><div class=\"col-md-1 calendar__col\" ng-repeat=\"day in days\"><div class=calendar__col__header><h4>{{tools.lang(day)}}</h4><h5>{{line[\'w\'+day.id].day}}</h5></div><div class=calendar__col__content><div ng-repeat=\"slt in tools.toArray(line[\'w\'+day.id].slts)\"><h4>{{tools.label(parameters.SLT[slt.slt])}}</h4><div class=list-group><button ng-repeat=\"listItem in filterListItems(slt.listItems) | orderBy:\'name\'\" class=\"list-group-item post-short-meta-container\" ng-class=\"{\'color-error\':listItem.colorClass===\'\',\'{{\'color-\'+listItem.colorClass}}\':listItem.colorClass!==\'\'}\" ng-click=clickListItem(listItem)><span ng-hide=\"listItem.id==\'P\'\"><strong>{{listItem.name}}</strong></span> <span ng-show=\"listItem.id==\'P\'\"><strong>{{tools.lang({\'en\':\'Private\',\'nl\':\'Particulieren\',\'fr\':\'Particuliers\'})}}</strong></span> <span class=coloredParent ng-repeat=\"entry in listItem.entries\"><span class=colored ng-style=\"{\'background-color\':activitiesService.getColour(entry)}\" ng-if=\"entry.cat==\'AC\'\"><span ng-hide=\"parameters.ACT[entry.frm.substr(0,3)].field3==\'1\' && entry.quotationtitle\">{{activitiesService.formulaOut(entry)}} </span><span ng-show=\"parameters.ACT[entry.frm.substr(0,3)].field3==\'1\' && entry.quotationtitle\">{{entry.quotationtitle}} </span>{{entry.planningquantity}} </span><span class=colored ng-if=\"entry.cat==\'ME\'\">Rest. {{tools.short(parameters.RES[entry.dsh.substr(0,3)])+\' \'+tools.label(parameters.DSH[entry.dsh])+\' \'+tools.amountOut(entry.planningquantity)}} </span><span class=colored ng-if=\"entry.cat==\'HS\'\">{{tools.lang({\'en\':\'Acc. \',\'nl\':\'Acc. \',\'fr\':\'Heb. \'})+tools.short(parameters.HTL[entry.hsc.substr(0,3)])+\' \'+tools.amountOut(entry.planningquantity)+\' \'+tools.label(parameters.HSC[entry.hsc])}} {{tools.amountOut(entry.personquantity)}}&nbsp;{{tools.lang({\'en\':\'Pers.\',\'nl\':\'Pers.\',\'fr\':\'Pers.\'})}} </span><span class=colored ng-if=\"entry.cat==\'PR\'\">{{tools.label(parameters.PRD[entry.prd])+\' \'+tools.amountOut(entry.planningquantity)+\' x \'+tools.amountOut(entry.personquantity)+\'€\'}} </span><span>{{entry.comment}}</span></span></button></div></div></div></div></div></div><div class=\"content__item c-table-view\" ng-show=\"model.displayListMode && !webservice.calling\"><div class=c-table-view__item ng-repeat=\"line in model.lines\"><h4 class=c-table-view__title>{{ tools.lang({\'en\':\'Week from \',\'nl\':\'Week van \',\'fr\':\'Semaine du \'}) + line[\'w0\'].day + tools.lang({\'en\': \' to \',\'nl\': \' tot \',\'fr\': \' au \'}) + line[\'w6\'].day }}</h4><div class=c-table-view__item__content ng-repeat=\"day in days\" ng-show=\"filterListItems(getDayListItems(line[\'w\'+day.id].slts)).length>0\"><div ng-repeat=\"slt in tools.toArray(line[\'w\'+day.id].slts)\" ng-show=\"filterListItems(slt.listItems).length>0\"><h4 class=c-table-view__title>{{tools.lang(day)}} {{line[\'w\'+day.id].day}} - {{tools.label(parameters.SLT[slt.slt])}}</h4><div class=table-responsive-wrapper><table class=\"table table-hover\"><thead><tr><th><span class=th__content>{{tools.lang({\'en\': \'Name\',\'nl\': \'Naam\',\'fr\': \'Nom\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\': \'Products\',\'nl\': \'Producten\',\'fr\': \'Produits\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\': \'Comment\',\'nl\': \'Opmerking\',\'fr\': \'Remarque\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\': \'Visit origin\',\'nl\': \'Bezoekherkomst\',\'fr\': \'Origine de la visite\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\': \'Creation date\',\'nl\': \'Aanmaakdatum\',\'fr\': \'Date de cr\\u00E9ation\'})}}</span></th></tr></thead><tbody><tr ng-repeat=\"listItem in filterListItems(slt.listItems) | orderBy:\'name\'\" ng-class=\"{\'color-error\':listItem.colorClass===\'\',\'{{\'color-\'+listItem.colorClass}}\':listItem.colorClass!==\'\'}\"><td ng-click=clickListItem(listItem)><span ng-hide=\"listItem.id==\'P\'\">{{listItem.name}}</span> <span ng-show=\"listItem.id==\'P\'\">{{tools.lang({\'en\':\'Private\',\'nl\':\'Particulieren\',\'fr\':\'Particuliers\'})}}</span></td><td ng-click=clickListItem(listItem)><div class=coloredParent ng-repeat=\"entry in listItem.entries | orderBy:\'cat\'\">{{getLabelCategory(entry.cat)+\' \\u2014 \'+tools.amountOut(entry.planningquantity)}} x <span class=colored ng-style=\"{\'background-color\':activitiesService.getColour(entry)}\" ng-if=\"entry.cat==\'AC\'\"><span ng-hide=\"parameters.ACT[entry.frm.substr(0,3)].field3==\'1\' && entry.quotationtitle\">{{activitiesService.formulaOut(entry)}} </span><span ng-show=\"parameters.ACT[entry.frm.substr(0,3)].field3==\'1\' && entry.quotationtitle\">{{entry.quotationtitle}} </span></span><span class=colored ng-if=\"entry.cat==\'ME\'\">{{tools.label(parameters.RES[entry.dsh.substr(0,3)])+\' \'+tools.label(parameters.DSH[entry.dsh])}} </span><span class=colored ng-if=\"entry.cat==\'HS\'\">{{tools.label(parameters.HTL[entry.hsc.substr(0,3)])+\' \'+tools.label(parameters.HSC[entry.hsc])}} {{tools.amountOut(entry.personquantity)}}&nbsp;{{tools.lang({\'en\':\'Pers.\',\'nl\':\'Pers.\',\'fr\':\'Pers.\'})}} </span><span class=colored ng-if=\"entry.cat==\'PR\'\">{{tools.label(parameters.PRD[entry.prd])+\' \'+tools.amountOut(entry.personquantity)+\'€\'}}</span></div></td><td ng-click=clickListItem(listItem)><div class=coloredParent ng-repeat=\"entry in listItem.entries | orderBy:\'cat\'\">{{entry.comment}}</div></td><td ng-click=clickListItem(listItem)><span ng-hide=\"listItem.id==\'P\'\">{{tools.label(parameters.VIS[model.visits[listItem.id].vis])}}</span> <span ng-show=\"listItem.id==\'P\'\">\\</span></td><td ng-click=clickListItem(listItem)><span ng-hide=\"listItem.id==\'P\'\">{{model.visits[listItem.id].created}}</span> <span ng-show=\"listItem.id==\'P\'\">\\</span></td></tr></tbody></table></div></div></div></div></div></div><div class=page__actions><button type=button class=\"btn btn-default\" ng-click=increaseWeeks(-4);>-4</button> <button type=button class=\"btn btn-default\" ng-click=increaseWeeks(-1);><span class=material-icons>chevron_left</span></button> <button type=button class=\"btn btn-default\" style=\"width: auto\" ng-click=nextFourWeeks();>{{tools.lang({\'en\':\'Week\',\'nl\':\'Week\',\'fr\':\'Semaine\'})}}</button> <button type=button class=\"btn btn-default\" ng-click=increaseWeeks(1);><span class=material-icons>chevron_right</span></button> <button type=button class=\"btn btn-default\" ng-click=increaseWeeks(4);>+4</button></div></main></div>");
$templateCache.put("app/modules/b2b/acceptAssignModal.html","<div class=modal-header><h3 class=modal-title>{{contacts[visit.owningcontact].name+\' \'+tools.lang({\'en\':\'Accepted\',\'nl\':\'Geaccepteerd\',\'fr\':\'Accept\\u00E9\'})}}</h3></div><div class=modal-body><form class=form-horizontal><div class=\"form-group clearfix\"><div class=\"col-xs-offset-2 col-xs-10\"><div class=checkbox><label><input type=checkbox ng-model=model.sendMail ng-value=true ng-change=hasSelectedMail();> {{tools.lang({\'en\':\'Send mail to inform group about this\',\'nl\':\'Verstuur mail om de groep hiervan op de hoogte te brengen\',\'fr\':\'Envoye mail au groupe pour informé de cette nouvelle situation\'})}}</label></div></div></div><div ng-hide=readonly><div class=form-group><label for=fromMail class=\"col-sm-2 control-label\">From</label><div class=col-sm-10><select class=form-control ng-model=fromMail ng-options=\"fromMailElement for fromMailElement in fromMailOptions\" ng-readonly=readonly></select></div></div><div class=form-group><label for=recipient class=\"col-sm-2 control-label\">To</label><div class=col-sm-8><input type=text id=recipient class=form-control ng-model=recipient readonly></div><button type=button class=\"btn btn-default\" ng-hide=showCc ng-click=\"showCc=true\">Cc</button> <button type=button class=\"btn btn-default\" ng-hide=showBcc ng-click=\"showBcc=true\">Bcc</button></div><div class=form-group ng-show=\"showCc && !readonly\"><label for=cc class=\"col-sm-2 control-label\">Cc</label><div class=col-sm-10><button class=\"btn btn-default\" ng-repeat=\"adress in (readonly?tools.toArray(cc):cc)\"><span>{{adress}}&nbsp;</span> <span class=\"glyphicon glyphicon-remove\" ng-click=deleteMail(adress,cc)></span></button><div class=input-group><input type=email id=cc class=form-control ng-model=addCc ng-enter=\"addMail(addCc,\'Cc\',cc,true)\"><div class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=\"addMail(addCc,\'Cc\',cc,true)\"><span class=\"glyphicon glyphicon-plus\"></span></button></div></div></div><label></label></div><div class=form-group ng-show=\"showCc && readonly\"><label for=cc class=\"col-sm-2 control-label\">Cc</label><div class=col-sm-10><input type=text id=cc class=form-control ng-model=cc ng-readonly=readonly></div></div><div class=form-group ng-show=\"showBcc && !readonly\"><label for=bcc class=\"col-sm-2 control-label\">Bcc</label><div class=col-sm-10><button class=\"btn btn-default\" ng-repeat=\"adress in (readonly?tools.toArray(bcc):bcc)\"><span>{{adress}}&nbsp;</span> <span class=\"glyphicon glyphicon-remove\" ng-click=deleteMail(adress,bcc)></span></button><div class=input-group><input type=email id=bcc class=form-control ng-model=addBcc ng-enter=\"addMail(addBcc,\'Bcc\',bcc,true)\"><div class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=\"addMail(addBcc,\'Bcc\',bcc,true)\"><span class=\"glyphicon glyphicon-plus\"></span></button></div></div></div><label></label></div><div class=form-group ng-show=\"showBcc && readonly\"><label for=bcc class=\"col-sm-2 control-label\">Bcc</label><div class=col-sm-10><input type=text id=bcc class=form-control ng-model=bcc ng-readonly=readonly></div></div><div class=form-group><label for=subject class=\"col-sm-2 control-label\">Subject</label><div class=col-sm-10><input type=text id=subject class=form-control ng-model=subject ng-readonly=readonly></div></div><textarea ng-bind-html=renderHtml(model.body) ng-model=model.body></textarea><div ng-bind-html=renderHtml(operationsManagerInfo) ng-show=\"model.operationsmanager!==model.quotationmanager\"></div><div ng-bind-html=renderHtml(quotationManagerInfo)></div></div></form></div><div class=modal-footer><button class=\"btn btn-primary\" type=button ng-click=ok()>Ok</button> <button class=\"btn btn-warning\" type=button ng-click=cancel()>Cancel</button></div>");
$templateCache.put("app/modules/b2b/assignModal.html","<div class=modal-header><h3 class=modal-title>{{contacts[visit.owningcontact].name+\' \'+tools.lang({\'en\':\'assign\',\'nl\':\'toewijzen\',\'fr\':\'assigner\'})}}</h3></div><div class=modal-body><form class=form-horizontal><div class=\"form-group clearfix\"><label for=operations class=\"col-sm-3 control-label\">{{tools.lang({\'en\':\'Operations Manager\',\'nl\':\'Uitvoerings verantwoordelijke\',\'fr\':\'Responsable Dossier\'})}}</label><div class=col-sm-9><select id=operations class=form-control ng-model=model.operationsmanager ng-options=\"user.id as user.name for user in tools.filterUserOnRight(model,\'OPEM\') | orderBy:\'id\'\" ng-change=selectedOperationsManager();></select></div></div><div class=\"form-group clearfix\"><label for=invoices class=\"col-sm-3 control-label\">{{tools.lang({\'en\':\'Invoices Manager\',\'nl\':\'Facturatie verantwoordelijke\',\'fr\':\'Responsable Facturation\'})}}</label><div class=col-sm-9><select id=invoices class=form-control ng-model=model.invoicesmanager ng-options=\"user.id as user.name for user in tools.filterUserOnRight(model,\'INVM\') | orderBy:\'id\'\" ng-change=selectedInvoicesManager();></select></div></div></form></div><div class=modal-footer><button class=\"btn btn-primary\" type=button ng-click=ok()>Ok</button> <button class=\"btn btn-warning\" type=button ng-click=cancel()>Cancel</button></div>");
$templateCache.put("app/modules/bar/bar.html","<section ng-controller=BarBarController class=\"page-bar row\"><aside class=\"page__sidebar col-sm-12 col-md-3\"><section class=page__heading><div class=row><div class=col-sm-12><h1>{{tools.lang({\'en\':\'Bar\',\'nl\':\'Bar\',\'fr\':\'Bar\'})}}</h1></div></div></section><section class=page__filters><div class=filters__item ng-repeat=\"con in parameters.notDelArrayCON | orderBy:\'id\'\"><span ng-repeat=\"bar in consumptionFilter(con) | orderBy:\'id\'\"><button class=\"btn btn-default\" ng-click=addToOrderStd(bar)>{{tools.label(bar)+\' \'+tools.amountOut(tools.amountIn(bar.field1))}} &euro;</button></span></div></section></aside><main role=main class=\"page__content col-md-9\"><section class=\"panel panel-default\"><div class=\"panel__heading panel-heading\"><h3 class=panel__title>{{tools.lang({\'en\':\'New command\',\'nl\':\'New command\',\'fr\':\'Nouvelle commande\'})}}</h3></div><section class=panel__content><form class=form-horizontal><div class=\"form-group clearfix\"><div class=\"col-sm-offset-2 col-sm-5\"><input type=text class=form-control ng-model=model.freeLine.name></div><div class=col-sm-5><input create class=bar ng-click=addToOrderFree()></div></div><div class=\"form-group clearfix\" ng-repeat=\"orderStd in tools.toArray(model.orderStd)\"><label for=orderStdQuantity{{orderStd.id}} class=\"col-sm-2 control-label\">{{tools.label(parameters.BAR[orderStd.consumption])}}</label><div class=col-sm-5><div class=input-group><input type=number id=orderStdQuantity{{orderStd.id}} class=form-control min=0 max=9999 ng-model=orderStd.number> <span class=input-group-addon>{{tools.amountOut(orderStd.number*tools.amountIn(parameters.BAR[orderStd.consumption].field1))}}€</span></div></div><div class=col-sm-5><div class=input-group><span class=input-group-btn><button class=\"btn btn-default\" type=button ng-repeat=\"incrementButton in model.incrementButtons\" ng-click=\"orderStd.number=orderStd.number+incrementButton;\">+{{incrementButton}}</button> <button class=\"btn btn-danger\" type=button ng-click=removeFromOrderStd(orderStd)><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></div></div><div class=\"form-group clearfix\" ng-repeat=\"orderFree in tools.toArray(model.orderFree)\"><label for=orderFreeQuantity{{orderFree.id}} class=\"col-sm-2 control-label\">{{orderFree.name}}</label><div class=col-sm-5><div class=input-group><input type=text id=orderStdQuantity{{orderFree.id}} class=form-control ng-model=orderFree.amount> <span class=input-group-addon>€</span></div></div><div class=col-sm-5><button class=\"btn btn-danger\" type=button ng-click=removeFromOrderFree(orderFree)><span class=\"glyphicon glyphicon-trash\"></span></button></div></div><div class=\"form-group total\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Total\',\'nl\':\'Totaal\',\'fr\':\'Total\'})}}</label><div class=col-sm-10><p class=form-control-static><b>{{calculateOrderSum(model.orderStd,model.orderFree)}} &euro;</b></p></div></div><div class=\"form-group clearfix\"><div class=col-sm-12><button class=\"btn btn-success btn-100\" ng-click=createOrderMovement();>{{tools.lang({\'en\':\'Settle Now\',\'nl\':\'Nu Afrekenen\',\'fr\':\'R\\u00E9gler Maintenant\'})}}</button></div></div><div class=\"form-group clearfix\"><div class=col-sm-8><input type=text class=form-control ng-model=model.newtab.name></div><div class=col-sm-4><button class=\"btn btn-primary btn-100\" ng-click=createTab()>{{tools.lang({\'en\':\'New\\nTab\',\'nl\':\'Nieuwe\\nKerfstok\',\'fr\':\'Nouveau\\nCompte\'})}}</button></div></div></form></section></section><ul class=list-group><li class=list-group-item ng-repeat=\"movement in tools.greaterEqual(tools.match(tools.join(tools.match(model.accounts,{\'user\':user.id,\'accounttype\':\'USR\'}),\'movements\',model),{\'origin\':\'BAR\'}),\'created\',model.sinceValue) | orderBy:\'created\':true\">{{tools.amountOut(movement.amount)}}€ {{movement.comment+\' \'+tools.doneBy(movement.created,null)}}</li></ul><div ng-repeat=\"tab in tools.toArray(model.tabs)\"><div class=row><div class=col-sm-6><h4>{{tab.name}} <span class=price>{{ calculateOrderSum(tools.join(tab,\'tabstdlines\',model),join(tab,\'tabfreelines\',model)) }} <span class=currency>€</span></span></h4></div><div class=\"col-sm-6 text-right\"><button class=\"btn btn-primary\" ng-click=addToTab(tab)>{{tools.lang({\'en\':\'Add to tab\',\'nl\':\'Toevoegen aan Kerfstok\',\'fr\':\'Ajouter sur ce compte\'})}}</button> <button class=\"btn btn-success\" ng-click=settleTab(tab)>{{tools.lang({\'en\':\'Settle Tab\',\'nl\':\'Afrekenen Kerfstok\',\'fr\':\'R\\u00E9gler ce compte\'})}}</button></div></div><ul class=list-group><li class=list-group-item ng-repeat=\"tabstdline in tools.join(tab,\'tabstdlines\',model)\">{{tabstdline.number+\' \'+tools.label(parameters.BAR[tabstdline.consumption])+\' \'+tools.amountOut(tabstdline.number*tools.amountIn(parameters.BAR[tabstdline.consumption].field1))}}€</li><li class=list-group-item ng-repeat=\"orderFree in tools.join(tab,\'tabfreelines\',model)\">{{tabfreeline.name+\' \'+tools.amountOut(tabfreeline.amount)}}€</li></ul></div></main></section>");
$templateCache.put("app/modules/emails/emailsScheduling.html","<div ng-controller=EmailsSchedulingController></div>");
$templateCache.put("app/modules/emails/marketingEmails.html","<div ng-controller=EmailsMarketingEmailsController class=\"page page-marketing-emails page--content\"><div class=row><form><div class=\"form-group clearfix\"><label class=\"col-md-2 control-label\" ng-click=\"model.startdateOpened=!model.startdateOpened\">{{tools.lang({\'en\':\'From\',\'nl\':\'Van\',\'fr\':\'De\'})}}</label><div class=col-md-4><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.startdate is-open=model.startdateOpened datepicker-options=model.dateOptions ng-click=\"model.startdateOpened=!model.startdateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.startdateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><label class=\"col-md-2 control-label\" ng-click=\"model.enddateOpened=!model.enddateOpened\">{{tools.lang({\'en\':\'To\',\'nl\':\'Tot\',\'fr\':\'À\'})}}</label><div class=col-md-4><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.enddate is-open=model.enddateOpened datepicker-options=model.dateOptions ng-click=\"model.enddateOpened=!model.enddateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.enddateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"form-group clearfix\"><label class=\"col-xs-2 control-label\">{{tools.lang({\'en\':\'Language\',\'nl\':\'Taal\',\'fr\':\'Langue\'})}}</label><div class=col-xs-10><div class=btn-group><button type=button class=\"btn btn-default\" ng-click=\"model.lang=\'any\';load();\" ng-class=\"{\'active\':model.lang==\'any\'}\">{{tools.lang({\'en\':\'--Any--\',\'nl\':\'--Alle--\',\'fr\':\'--Tout--\'})}}</button> <button type=button class=\"btn btn-default\" ng-repeat=\"lang in config.langs\" ng-click=\"model.lang=lang;load();\" ng-class=\"{\'active\':model.lang==lang}\">{{lang}}</button></div></div></div><div class=\"form-group clearfix\"><div class=\"col-xs-offset-2 col-xs-10\"><div class=checkbox><label><input type=checkbox ng-model=model.agreestomarketing ng-false-value=\"\'0\'\" ng-true-value=\"\'1\'\" ng-change=load()> {{tools.lang({\'en\':\'Agrees to receiving offers\',\'nl\':\'Akkoord om aanbiedingen te ontvangen\',\'fr\':\'D\\u0027accord pour recevoir des offres\'})}}</label></div></div></div></form><form action={{model.action}} name=export autocomplete=off method=post target=_blank><div class=\"form-group clearfix\"><div class=\"col-sm-offset-2 col-sm-10\"><input type=hidden name=params value={{getExportWsParams()}}> <button type=submit class=\"btn btn-default\">{{tools.lang({\'en\':\'Export\',\'nl\':\'Export\',\'fr\':\'Export\'})}}</button></div></div></form></div><br><p class=bg-danger ng-show=\"model.agreestomarketing!=\'1\'\">{{tools.lang({\'en\':\'WARNING: some people explicitly requested to not receive offers, so only send practical information\',\'nl\':\'OPGELET: sommige mensen hebben expliciet gevraagd om geen aanbiedingen te ontvangen, dus enkel praktische informatie verzenden\',\'fr\':\'ATTENTION: certaines personnes ont explicitement demand\\u00E9 de ne pas recevoir des offres, alors envoyez uniquement des informations pratiques\'})}}</p><p class=bg-danger ng-show=\"tools.dateFromJava(model.startdate)<tools.today()\">{{tools.lang({\'en\':\'WARNING: privacy law prohibits sending commercial emails after the visit\',\'nl\':\'OPGELET: privacy wetgeving verbiedt om commerci\\u00EBle emails te sturen na het bezoek\',\'fr\':\'ATTENTION: la loi sur la protection de la vie priv\\u00E9e interdit envoyer des emails commerciaux apres la visite\'})}}</p><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><thead><th><span class=th__content>{{tools.lang({\'en\':\'Name\',\'nl\':\'Naam\',\'fr\':\'Nom\'})}}</span></th><th>{{tools.lang({\'en\':\'Email\',\'nl\':\'Email\',\'fr\':\'Email\'})}}</th><th ng-show=\"model.lang==\'any\'\">{{tools.lang({\'en\':\'Lang\',\'nl\':\'Taal\',\'fr\':\'Lang\'})}}</th><th ng-show=\"tools.dateFromJava(model.startdate)!=tools.dateFromJava(model.enddate)\">{{tools.lang({\'en\':\'Arrival - Departure\',\'nl\':\'Aankomst - Vertrek\',\'fr\':\'Arriv\\u00E9e - D\\u00E9part\'})}}</th><th>{{tools.lang({\'en\':\'Date of birth\',\'nl\':\'Geboortedatum\',\'fr\':\'Date de naissance\'})}}</th></thead><tbody><tr ng-repeat=\"visit in model.visits\"><td>{{model.contacts[visit.owningcontact].name}}</td><td>{{model.contacts[visit.owningcontact].email}}</td><td ng-show=\"model.lang==\'any\'\">{{model.contacts[visit.owningcontact].lang}}</td><td ng-show=\"tools.dateFromJava(model.startdate)!=tools.dateFromJava(model.enddate)\">{{tools.dateFromJava(visit.startdate)}} <span ng-show=\"tools.dateFromJava(visit.startdate)!=tools.dateFromJava(visit.enddate)\">- {{tools.dateFromJava(visit.enddate)}}</span></td><td><span ng-show=\"visit.dateofbirth!=\'1000-01-01\'\">{{visit.dateofbirth}}</span></td></tr></tbody></table></div></div>");
$templateCache.put("app/modules/contacts/contactComponent.html","<section class=page__filters ng-show=\"!model[contactName+\'Contact\'].dummy\"><form class=form-horizontal><div class=\"panel panel-default\" ng-show=\"model.task!==\'r\' || model[contactName+\'Contact\'].id!=\'0\'\"><div class=\"form-group clearfix\" ng-show=\"model.task!==\'r\'\"><div class=col-xs-12><label ng-show=\"contactWording!==\'\' && model.task!=\'r\'\" class=control-label><div class=\"form-group clearfix\"><div class=col-xs-8>{{contactWording}}</div><div class=\"col-xs-4 text-right\"><button ng-show=\"model[contactName+\'Contact\'].editing && (model.task===\'c\' || model.task===\'t\' || contactName===\'communication\') && model[contactName+\'Contact\'].id!==\'0\' && model[\'existing\'+contactName.charAt(0).toUpperCase()+contactName.slice(1)+\'Contact\'].id==\'0\'\" class=\"btn btn-danger\" delete ng-click=deleteContact()></button> <button ng-show=\"model.task===\'u\' && model[contactName+\'Contact\'].id==\'0\'\" type=button class=\"btn btn-default\" ng-click=cancelContactEdit();>{{tools.lang({\'en\':\'Cancel\',\'nl\':\'Annuleer\',\'fr\':\'Annuler\'})}}</button></div></div></label><div class=\"form-group clearfix\" ng-show=\"model[contactName+\'Contact\'].id==\'0\'\"><div ng-class=\"{\'col-xs-10 col-lg-11\':config.get(\'showQuickSell\'),\'col-xs-12\':!config.get(\'showQuickSell\')}\"><div outdoor-search-contacts parent-model=model selected-name=contactName search-term=model.searchTerm task=\"\'c\'\" on-create-contact=\"selectContact(\'new\',false)\" on-create-company=\"selectContact(\'new\',true)\" on-update-selection=\"selectContact(\'existing\')\" search-companies=\"contactName===\'owning\'\" search-contacts=true search-visits=false></div></div><div class=\"col-xs-2 col-lg-1 text-right\" ng-show=\"config.get(\'showQuickSell\')\"><button class=\"btn btn-default\" ng-click=selectAnonymousContact()><span class=\"glyphicon glyphicon-flash\"></span></button></div></div></div></div><div ng-show=\"model[contactName+\'Contact\'].id!=\'0\'\"><div class=panel-heading ng-show=\"!model[contactName+\'Contact\'].editing\"><div class=row><div class=col-xs-8 ng-click=\"model[contactName+\'Contact\'].isOpen=tools.xor(model[contactName+\'Contact\'].created,model[contactName+\'Contact\'].isOpen);\"><h3 class=panel__title>{{contactsService.getName(model[contactName+\'Contact\'])}} <span class=glyphicon ng-show=\"model[contactName+\'Contact\'].created\" ng-class=\"{\'glyphicon-chevron-up\': model[contactName+\'Contact\'].isOpen, \'glyphicon-chevron-down\': !model[contactName+\'Contact\'].isOpen}\"></span></h3></div><div class=\"col-xs-4 text-right\"><button edit ng-show=contactIsEditable ng-click=startContactEdit()></button> <button delete ng-show=contactIsChangeable class=\"btn btn-danger\" ng-click=deleteContact()></button> <button retrieve ng-show=contactRetrieve ng-click=\"contactRetrieve(model[contactName+\'Contact\'].id)\"></button></div></div></div><div uib-collapse=\"!model[contactName+\'Contact\'].isOpen\"><div class=\"form-group clearfix\" ng-show=\"model[contactName+\'Contact\'].editing\"><div ng-show=\"model[contactName+\'Contact\'].iscompany==\'0\'\"><label class=\"col-md-2 control-label\" for=contactFirstname{{contactName}}>{{tools.lang({\'en\':\'First name\',\'nl\':\'Voornaam\',\'fr\':\'Pr\\u00E9nom\'})}}</label><div class=col-md-4><input type=text autocomplete=off class=form-control id=contactFirstname{{contactName}} ng-readonly=\"contactReadonly || (!model[contactName+\'Contact\'].hasNoInvoicesOrMovements && model[contactName+\'Contact\'].iscompany==\'1\')\" ng-model=\"model[contactName+\'Contact\'].firstname\" placeholder=\"{{tools.lang({\'en\':\'First name\',\'nl\':\'Voornaam\',\'fr\':\'Pr\\u00E9nom\'})}}\"></div></div><div class=clearfix><label class=\"col-md-2 control-label\" for=contactName{{contactName}}><span ng-show=\"model[contactName+\'Contact\'].iscompany==\'0\'\">{{tools.lang({\'en\':\'Name\',\'nl\':\'Naam\',\'fr\':\'Nom\'})}} </span><span ng-show=\"model[contactName+\'Contact\'].iscompany==\'1\'\">{{tools.lang({\'en\':\'Company name\',\'nl\':\'Bedrijfsnaam\',\'fr\':\'Nom de l\\u0027entreprise\'})}}</span></label><div ng-class=\"{\'col-md-4\':model[contactName+\'Contact\'].iscompany==\'0\',\'col-md-10\':model[contactName+\'Contact\'].iscompany==\'1\'}\"><input type=text autocomplete=off class=form-control id=contactName{{contactName}} ng-readonly=\"(model.task!=\'c\' && model.task!=\'t\' && !(model.contact.hasNoInvoicesOrMovements || model.backupContacts[contactName].vatnumber==\'\' || user.hasRight(\'ACCRED\'))) || model.task==\'r\' || contactReadonly || !model[contactName+\'Contact\'].editing\" ng-model=\"model[contactName+\'Contact\'].name\" placeholder=\"{{model[contactName+\'Contact\'].iscompany==\'0\'?tools.lang({\'en\':\'Name\',\'nl\':\'Naam\',\'fr\':\'Nom\'}):tools.lang({\'en\':\'Company name\',\'nl\':\'Bedrijfsnaam\',\'fr\':\'Nom de l\\u0027entreprise\'})}}\"></div></div></div><div class=\"form-group clearfix\"><label class=col-md-2 class=control-label>{{tools.lang({\'en\':\'Language\',\'nl\':\'Taal\',\'fr\':\'Langue\'})}}</label><div class=col-md-4><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"lang in config.langs\" ng-show=\"(model.task!=\'r\' && model[contactName+\'Contact\'].editing) || model[contactName+\'Contact\'].lang==lang\" ng-click=\"model[contactName+\'Contact\'].lang=lang\" ng-class=\"{\'active\':model[contactName+\'Contact\'].lang==lang}\" ng-disabled=\"model.task==\'r\' || !model[contactName+\'Contact\'].editing\">{{lang}}</button></div></div><label ng-hide=\"model[contactName+\'Contact\'].advancedAttributes || model.task==\'r\'\" class=\"col-md-2 control-label\" for=contactPostalcodeA{{contactName}}>{{tools.lang({\'en\':\'Country and postal code\',\'nl\':\'Land en postcode\',\'fr\':\'Pays et code postal\'})}}</label><div ng-hide=\"model[contactName+\'Contact\'].advancedAttributes || model.task==\'r\'\" class=col-md-4><div class=input-group style=\"width: 100%\" ng-show=\"model.task!=\'r\'\"><select id=contactCountryA{{contactName}} class=\"input-group-addon form-control\" style=\"width: 40%\" ng-model=\"model[contactName+\'Contact\'].country\" ng-change=setContactGsmAndCountry() ng-disabled=\"model.task==\'r\' || !model[contactName+\'Contact\'].editing\"><option ng-repeat=\"countryCallingCode in tools.toArray(parameters.countryCallingCodes) | orderBy:\'countryCallingCode\'\" ng-value=countryCallingCode.id>{{tools.label(countryCallingCode)+\' (\'+countryCallingCode.id+\')\'}}</option></select><input type=text autocomplete=off id=contactPostalcodeA{{contactName}} class=form-control style=\"width: 60%\" ng-readonly=\"model.task==\'r\' || !model[contactName+\'Contact\'].editing\" ng-model=\"model[contactName+\'Contact\'].postalcode\" placeholder=\"{{tools.lang({\'en\':\'Postalcode\',\'nl\':\'Postcode\',\'fr\':\'Code postal\'})}}\"></div><input ng-show=\"model.task==\'r\'\" type=text autocomplete=off class=form-control ng-value=\"model[contactName+\'Contact\'].country+\'-\'+model[contactName+\'Contact\'].postalcode\" ng-readonly=true></div></div><div class=\"form-group clearfix\" ng-show=\"model.task!=\'r\' || model[contactName+\'Contact\'].gsm!=\'\' || model[contactName+\'Contact\'].email!=\'\'\"><label for=contactGsm{{contactName}} class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'GSM\',\'nl\':\'GSM\',\'fr\':\'GSM\'})}}</label><div class=col-md-4><div class=input-group style=\"width: 100%\" ng-show=\"model.task!=\'r\'\"><select id=contactGsm{{contactName}} class=\"input-group-addon form-control\" style=\"width: 40%\" ng-model=\"model[contactName+\'Contact\'].countryCallingCode\" ng-change=setContactGsmAndCountry() ng-disabled=\"model.task==\'r\' || !model[contactName+\'Contact\'].editing\"><option ng-repeat=\"countryCallingCode in tools.toArray(parameters.countryCallingCodes) | orderBy:\'countryCallingCode\'\" ng-value=countryCallingCode.countryCallingCode>{{\'+\'+countryCallingCode.countryCallingCode+\' (\'+countryCallingCode.id+\')\'}}</option></select><input type=text autocomplete=off class=form-control style=\"width: 60%\" ng-model=\"model[contactName+\'Contact\'].number\" ng-change=setContactGsmAndCountry() ng-readonly=\"model.task==\'r\' || !model[contactName+\'Contact\'].editing\" placeholder=\"{{tools.lang({\'en\':\'Phonenumber\',\'nl\':\'Telefoonnummer\',\'fr\':\'Numéro de téléphone\'})}}\"></div><input ng-show=\"model.task==\'r\'\" type=text autocomplete=off class=form-control ng-value=\"model[contactName+\'Contact\'].prettyGsm\" ng-readonly=true></div><label for=contactEmail{{contactName}} class=\"col-md-2 control-label\">Email</label><div class=col-md-4><input type=text autocomplete=off id=contactEmail{{contactName}} class=form-control ng-readonly=\"model.task==\'r\' || !model[contactName+\'Contact\'].editing\" ng-model=\"model[contactName+\'Contact\'].email\" placeholder=Email></div></div><div class=\"form-group clearfix\" ng-show=\"model[contactName+\'Contact\'].iscompany==\'0\' && (model.task!=\'r\' || model[contactName+\'Contact\'].sal!=\'\') && model.view!=\'createForEmp\'\"><label class=\"control-label col-md-2\">{{tools.lang({\'en\':\'Salutation\',\'nl\':\'Aanspreking\',\'fr\':\'Salutation\'})}}</label><div class=col-md-10><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"par in tools.addElement(parameters.notDelSAL,empty) | orderBy:\'id\'\" ng-show=\"(model.task!=\'r\' && model[contactName+\'Contact\'].editing) || model[contactName+\'Contact\'].sal==par.id\" ng-click=\"model[contactName+\'Contact\'].sal=par.id\" ng-class=\"{\'active\':model[contactName+\'Contact\'].sal==par.id}\" ng-disabled=\"model.task==\'r\' || !model[contactName+\'Contact\'].editing\"><span ng-show=\"par.id==\'\'\">{{tools.label(par)}}</span> <span ng-hide=\"par.id==\'\'\">{{par[\'labelen\']+\'/\'+par[\'labelnl\']+\'/\'+par[\'labelfr\']+(par.field1==\'1\'?(\' \'+tools.lang({\'en\':\'first name\',\'nl\':\'voornaam\',\'fr\':\'prenom\'})):\'\')+(par.field2==\'1\'?(\' \'+tools.lang({\'en\':\'last name\',\'nl\':\'achternaam\',\'fr\':\'nom de famille\'})):\'\')}}</span></button></div></div></div><div class=\"form-group clearfix\" ng-show=\"model.task!=\'r\' && model[contactName+\'Contact\'].editing\"><div class=col-md-12><div class=checkbox><label><input type=checkbox ng-model=\"model[contactName+\'Contact\'].advancedAttributes\"> {{tools.lang({\'en\':\'More fields for\',\'nl\':\'Meer velden voor\',\'fr\':\'Plus de champs pour\'})+\' \'+contactWording}}</label></div></div></div><div uib-collapse=\"!(model[contactName+\'Contact\'].advancedAttributes || model.task==\'r\')\"><div class=\"form-group clearfix\" ng-show=\"model[contactName+\'Contact\'].iscompany==\'0\' && (model.task!=\'r\' || model[contactName+\'Contact\'].sal!=\'\') && model.view==\'createForEmp\'\"><label class=\"control-label col-md-2\">{{tools.lang({\'en\':\'Salutation\',\'nl\':\'Aanspreking\',\'fr\':\'Salutation\'})}}</label><div class=col-md-10><div class=btn-group><button type=button class=btn ng-repeat=\"par in tools.addElement(parameters.notDelSAL,empty) | orderBy:\'id\'\" ng-show=\"(model.task!=\'r\' && model[contactName+\'Contact\'].editing) || model[contactName+\'Contact\'].sal==par.id\" ng-click=\"model[contactName+\'Contact\'].sal=par.id\" ng-class=\"{\'active\':model[contactName+\'Contact\'].sal==par.id,\'btn-default\':par.id!==empty.id,\'btn-warning\':par.id===empty.id}\" ng-disabled=\"model.task==\'r\' || !model[contactName+\'Contact\'].editing\"><span ng-show=\"par.id===empty.id && model[contactName+\'Contact\'].sal===\'\'\"><div class=\"glyphicon glyphicon-warning-sign\"></div>{{tools.label(par)}} </span><span ng-hide=\"par.id==\'\'\">{{par[\'labelen\']+\'/\'+par[\'labelnl\']+\'/\'+par[\'labelfr\']+(par.field1==\'1\'?(\' \'+tools.lang({\'en\':\'first name\',\'nl\':\'voornaam\',\'fr\':\'prenom\'})):\'\')+(par.field2==\'1\'?(\' \'+tools.lang({\'en\':\'last name\',\'nl\':\'achternaam\',\'fr\':\'nom de famille\'})):\'\')}}</span></button></div></div></div><div ng-show=\"model.task!=\'r\' || model[contactName+\'Contact\'].address1!=\'\' || model[contactName+\'Contact\'].address2!=\'\'\"><div class=\"form-group clearfix\"><label for=contactAddress1{{contactName}} class=\"control-label col-md-2\">{{tools.lang({\'en\':\'Address\',\'nl\':\'Adres\',\'fr\':\'Adresse\'})}}</label><div class=col-md-10><input type=text autocomplete=off id=contactAddress1{{contactName}} class=form-control ng-readonly=\"model.task==\'r\' || !model[contactName+\'Contact\'].editing\" ng-model=\"model[contactName+\'Contact\'].address1\" placeholder=\"{{tools.lang({\'en\':\'Address line 1\',\'nl\':\'Adres lijn 1\',\'fr\':\'Adresse ligne 1\'})}}\"></div></div><div class=\"form-group clearfix\"><label class=\"col-md-2 control-label\" for=contactPostalcodeB{{contactName}}>{{tools.lang({\'en\':\'Country and postal code\',\'nl\':\'Land en postcode\',\'fr\':\'Pays et code postal\'})}}</label><div class=col-md-4><div class=input-group style=\"width: 100%\" ng-show=\"model.task!=\'r\'\"><select id=contactCountryB{{contactName}} class=\"input-group-addon form-control\" style=\"width: 40%\" ng-model=\"model[contactName+\'Contact\'].country\" ng-change=setContactGsmAndCountry() ng-disabled=\"model.task==\'r\' || !model[contactName+\'Contact\'].editing\"><option ng-repeat=\"countryCallingCode in tools.toArray(parameters.countryCallingCodes) | orderBy:\'countryCallingCode\'\" ng-value=countryCallingCode.id>{{tools.label(countryCallingCode)+\' (\'+countryCallingCode.id+\')\'}}</option></select><input type=text autocomplete=off id=contactPostalcodeB{{contactName}} class=form-control style=\"width: 60%\" ng-readonly=\"model.task==\'r\' || !model[contactName+\'Contact\'].editing\" ng-model=\"model[contactName+\'Contact\'].postalcode\" placeholder=\"{{tools.lang({\'en\':\'Postalcode\',\'nl\':\'Postcode\',\'fr\':\'Code postal\'})}}\"></div><input ng-show=\"model.task==\'r\'\" type=text autocomplete=off class=form-control ng-value=\"model[contactName+\'Contact\'].country+\'-\'+model[contactName+\'Contact\'].postalcode\" ng-readonly=true></div><label for=contactaddress2{{contactName}} class=\"control-label col-md-2\">{{tools.lang({\'en\':\'City\',\'nl\':\'Stad\',\'fr\':\'Ville\'})}}</label><div class=\"col-md-4 mt16\"><input type=text autocomplete=off class=form-control ng-readonly=\"model.task==\'r\' || !model[contactName+\'Contact\'].editing\" ng-model=\"model[contactName+\'Contact\'].address2\" id=contactaddress2{{contactName}} placeholder=\"{{tools.lang({\'en\':\'City\',\'nl\':\'Stad\',\'fr\':\'Ville\'})}}\"></div></div></div></div><div class=\"form-group clearfix\" ng-show=\"(model[contactName+\'Contact\'].advancedAttributes || model[contactName+\'Contact\'].iscompany==\'1\' || model.view==\'createQuotation\') && contactName!=\'communication\'\"><div class=col-md-6><div class=checkbox><label><input type=checkbox ng-model=\"model[contactName+\'Contact\'].iscompany\" ng-false-value=\"\'0\'\" ng-true-value=\"\'1\'\" ng-disabled=\"!model[contactName+\'Contact\'].hasNoInvoicesOrMovements || !model[contactName+\'Contact\'].editing\" ng-change=changeIscompany()> {{tools.lang({\'en\':\'Is company\',\'nl\':\'Is vennootschap\',\'fr\':\'Est entreprise\'})}}</label></div></div><div ng-show=\"model[contactName+\'Contact\'].iscompany==\'1\'\"><label for=contactVatnumber{{contactName}} class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'VAT nr\',\'nl\':\'BTW nr\',\'fr\':\'Nr TVA\'})}}</label><div class=col-md-4><input type=text autocomplete=off id=contactVatnumber{{contactName}} class=form-control ng-readonly=\"(model.task!=\'c\' && model.task!=\'t\' && !(model.contact.hasNoInvoicesOrMovements || model.backupContacts[contactName].vatnumber==\'\')) || model.task==\'r\' || !model[contactName+\'Contact\'].editing\" ng-model=\"model[contactName+\'Contact\'].vatnumber\" placeholder=\"{{tools.lang({\'en\':\'VAT nr\',\'nl\':\'BTW nr\',\'fr\':\'Nr TVA\'})}}\"></div></div></div><div class=\"form-group clearfix\" ng-show=\"model.task==\'u\' && (model.retrieveContact.editing || tools.xor(model.owningContact.editing,(model.communicationContact.editing || (model.communicationContact.id==\'0\' && model.existingCommunicationContact.id!==\'0\'))))\"><div class=\"col-md-offset-2 col-md-10\"><div ng-show=!webservice.calling><button type=submit class=\"btn btn-primary\" ng-click=updateContact();>{{tools.lang({\'en\':\'Confirm\',\'nl\':\'Bevestig\',\'fr\':\'Confirmer\'})}}</button> <button type=button class=\"btn btn-default\" ng-click=cancelContactEdit();>{{tools.lang({\'en\':\'Cancel\',\'nl\':\'Annuleer\',\'fr\':\'Annuler\'})}}</button></div><div ng-show=webservice.calling>Loading...</div></div></div></div></div></div></form></section>");
$templateCache.put("app/modules/contacts/reservationsComponent.html","<h3 class=title><span ng-show=\"$ctrl.task==\'future\'\">{{$ctrl.tools.lang({\'en\':\'Reservations: \',\'nl\':\'Reservaties: \',\'fr\':\'R\\u00E9servations: \'})}}</span> <span ng-show=\"$ctrl.task==\'past\'\">{{$ctrl.tools.lang({\'en\':\'Past reservations: \',\'nl\':\'Reservaties in het verleden: \',\'fr\':\'R\\u00E9servations pass\\u00E9es: \'})}}</span> {{$ctrl.tools.getLength($ctrl.getReservations())}}</h3><div class=\"row equal\"><div class=\"col-lg-4 col-md-6 col-xs-12\" style=display:flex ng-repeat=\"visit in $ctrl.getReservations() | orderBy:\'startdateISO\':true\"><div class=\"panel panel-default panel--template\" style=width:100%><div class=panel__heading><button retrieve ng-click=$ctrl.visitRetrieve(visit.id);></button><h3 class=panel__title>{{$ctrl.contactsService.getName($ctrl.contacts[visit.owningcontact])+\' - \' +\'V\'+visit.id}}</h3></div><div class=panel-body style=\"min-height: 150px\"><div class=form-group><div class=col-xs-12><span ng-class=\"{\'color color-error\':$ctrl.parameters.STV[visit.stat].field2===\'\',\'{{\'color color-\'+$ctrl.parameters.STV[visit.stat].field2}}\':$ctrl.parameters.STV[visit.stat].field2!==\'\'}\">{{$ctrl.tools.label($ctrl.parameters.STV[visit.stat])}}</span></div><div class=col-xs-12>{{(visit.startdateISO!==visit.enddateISO?(visit.startdateISO+\' - \'):\'\')+visit.enddateISO}}</div><div ng-show=\"visit.communicationcontact!=\'0\'\" class=col-xs-12><button retrieve ng-click=$ctrl.contactRetrieve(visit.communicationcontact);></button>&nbsp;{{$ctrl.contactsService.getName($ctrl.contacts[visit.communicationcontact])}}</div><ul class=\"col-xs-offset-1 col-xs-11\"><li ng-show=\"$ctrl.tools.amountOut(visit.turnover)!=\'0\'\">{{$ctrl.tools.amountOut(visit.turnover)+\'€\'}}</li><li ng-show=\"visit.comment!=\'\'\"><div style=\"overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical\">{{visit.comment}}</div></li></ul></div></div><div class=panel-footer><p><i>{{$ctrl.tools.lang({\'en\':\'Created\',\'nl\':\'Aangemaakt\',\'fr\':\'Cr\\u00E9\\u00E9\'})}} {{$ctrl.tools.doneBy(visit.created,visit.creator_name)}}</i></p><p></p></div></div></div></div>");
$templateCache.put("app/modules/contacts/retrieve.html","<div ng-controller=ContactsRetrieveController class=\"page page--content page-with-sidebar\"><div class=content__noresult ng-show=\"!webservice.calling && !tools.getLength(model.contacts)>0\"><div class=\"alert alert-info\" role=alert><p>{{tools.lang({\'en\':\'Client not found\',\'nl\':\'Klant niet gevonden\',\'fr\':\'Client non trouver\'})}}</p></div></div><div class=\"content__item page__loader\" ng-show=webservice.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div><div class=main ng-show=\"!webservice.calling && tools.getLength(model.contacts)>0\"><div outdoor-contact model=model contact-name=retrieve contact-wording=\"\" contact-readonly=false contact-is-editable=true contact-is-changeable=false contact-retrieve=false></div><div class=\"panel panel-default\" ng-show=\"model.task==\'r\' && tools.getLength(model.contactcreditcards)>0\"><div class=row ng-repeat=\"creditcard in model.contactcreditcards\"><div class=\"col-xs-4 text-right\">{{creditcard.brand+\' \'+tools.substr(creditcard.expirydateISO,0,7)}}</div><div class=col-xs-8><span ng-show=\"creditcard.obfuscated==\'0\'\"><span ng-show=creditcard.showNumber>{{tools.substr(creditcard.cardnumber,0,4)+\' \'+tools.substr(creditcard.cardnumber,4,4)+\' \'+tools.substr(creditcard.cardnumber,8,4)+\' \'+tools.substr(creditcard.cardnumber,12,4)}}</span> <span ng-show=!creditcard.showNumber>&#x2022&#x2022&#x2022&#x2022 &#x2022&#x2022&#x2022&#x2022 &#x2022&#x2022&#x2022&#x2022 &#x2022&#x2022&#x2022&#x2022</span> <button class=\"btn btn-default\" ng-show=userCanViewCreditcardnumbers() ng-click=copyToClipboard(creditcard.cardnumber)><span class=\"glyphicon glyphicon-copy\"></span></button> <button class=\"btn btn-default\" ng-disabled=\"creditcard.showNumber || !userCanViewCreditcardnumbers()\" ng-click=\"tempShow(creditcard,\'showNumber\')\"><span class=\"glyphicon glyphicon-eye-open\"></span></button> &nbsp; <span ng-show=creditcard.showCvc>{{creditcard.cvc}}</span> <span ng-show=!creditcard.showCvc>&#x2022&#x2022&#x2022</span> <button class=\"btn btn-default\" ng-show=userCanViewCreditcardnumbers() ng-click=copyToClipboard(creditcard.cvc)><span class=\"glyphicon glyphicon-copy\"></span></button> <button class=\"btn btn-default\" ng-disabled=\"creditcard.showCvc || !userCanViewCreditcardnumbers()\" ng-click=\"tempShow(creditcard,\'showCvc\')\"><span class=\"glyphicon glyphicon-eye-open\"></span></button> </span><span ng-show=\"creditcard.obfuscated==\'1\'\">{{tools.substr(creditcard.cardnumber,0,4)+\' \'+tools.substr(creditcard.cardnumber,4,4)+\' \'+tools.substr(creditcard.cardnumber,8,4)+\' \'+tools.substr(creditcard.cardnumber,12,4)}}</span></div></div></div><reservations-component task=\"\'future\'\" contacts=model.contacts visits=model.visits visit-retrieve=visitRetrieve contact-retrieve=contactRetrieve></reservations-component><reservations-component task=\"\'past\'\" contacts=model.contacts visits=model.visits visit-retrieve=visitRetrieve contact-retrieve=contactRetrieve></reservations-component></div><div class=sidebar ng-show=\"!webservice.calling && tools.getLength(model.contacts)>0\"><ul class=list-group style=\"padding: 0 10px 0 20px\"><li class=list-group-item><form class=form-horizontal style=\"padding: 0 20px 0 20px\"><div class=\"form-group clearfix\"><div class=\"col-sm-12 col-md-7\"><label for=ccnumber class=\"control-label required\">{{tools.lang({\'en\':\'Credit card number\',\'nl\':\'Creditcardnummer\',\'fr\':\'Num\\u00E9ro de carte de cr\\u00E9dit\'})}}</label><div class=form-group><input id=ccnumber autocomplete=cc-number ng-required=true type=text class=\"form-control required\" ng-model=model.contactcreditcard.unencryptedCardnumber ng-keyup=formatCreditCard($event) ng-mouseleave=formatCreditCard($event) ng-readonly=model.retrieveContact.editing></div></div><div class=\"col-sm-12 col-md-5\"><label for=cccvc class=\"control-label required\">{{tools.lang({\'en\':\'Verification code\',\'nl\':\'Verificatiecode\',\'fr\':\'Code de sécurité\'})}}</label><div class=form-group><div class=input-group><input id=cccvc autocomplete=cc-csc required type=text class=\"form-control required\" ng-model=model.contactcreditcard.unencryptedCvc ng-readonly=model.retrieveContact.editing> <span class=input-group-addon style=\"border: 1px solid #b8c1cb !important; border-left: 0 !important\"><i class=\"glyphicon glyphicon-info-sign\" tooltip-placement=bottom tooltip-popup-delay=250 tooltip-class=info tooltip-append-to-body=true uib-tooltip=\"{{tools.lang({\n                      \'en\':\'3-digit security code usually located on the back of your card. The security code for American Express cards is 4 digits and is located on the front of your card.\',\n                      \'nl\':\'Veiligheidscode van 3 cijfers, bevindt zich normaal gezien aan de achterkant van uw kaart. De veiligheidscode voor American Express kaarten bestaat uit 4 cijfers en bevindt zich aan de voorkant van uw kaart.\',\n                      \'fr\':\'Code de sécurité à 3 chiffres généralement situé au verso de votre carte. Le code de sécurité pour les cartes American Express se compose de 4 chiffre et est situé à l\\u0027avant de votre carte.\'})}}\"></i></span></div></div></div><div class=col-xs-12><label for=ccexpmonth class=\"control-label required\">{{tools.lang({\'en\':\'Expiration date\',\'nl\':\'Vervaldatum\',\'fr\':\'Date d\\u0027expiration\'})}}</label><div class=form-group><div class=row style=\"display: flex; align-items: center\"><div class=col-xs-6><select class=form-control id=ccexpmonth ng-model=model.contactcreditcard.expirymonth ng-disabled=model.retrieveContact.editing ng-options=\"monthId as monthId for monthId in [\'01\',\'02\',\'03\',\'04\',\'05\',\'06\',\'07\',\'08\',\'09\',\'10\',\'11\',\'12\']\"><option value=\"\" selected disabled hidden>{{tools.lang({\'en\':\'Month\',\'nl\':\'Maand\',\'fr\':\'Mois\'})}}</option></select></div><div class=col-xs-1>/</div><div class=col-xs-6><select class=form-control id=ccexpyear ng-model=model.contactcreditcard.expiryyear ng-disabled=model.retrieveContact.editing ng-options=\"yearId as yearId for yearId in getCreditcardYears()\"><option value=\"\" selected disabled hidden>{{tools.lang({\'en\':\'Year\',\'nl\':\'Jaar\',\'fr\':\'Année\'})}}</option></select></div></div></div></div></div><div class=\"form-group clearfix\"><button class=\"btn btn-primary btn-block\" ng-disabled=model.retrieveContact.editing ng-click=addContactcreditcard()>{{tools.lang({\'en\':\'Add\',\'nl\':\'Voeg toe\',\'fr\':\'Ajoutez\'})}}</button></div></form></li></ul><ul class=list-group style=\"padding: 0 10px 0 20px\" ng-show=\"!contactHasAccountingExternalids() && !model.retrieveContact.editing\"><li class=list-group-item><form class=form-horizontal style=\"padding: 0 20px 0 20px\"><div class=\"form-group clearfix\"><div class=col-xs-12><label for=outdoorSearchContacts class=\"control-label required\">{{tools.lang({\'en\':\'Merge\',\'nl\':\'Samenvoegen\',\'fr\':\'Fusionner\'})}}</label><div ng-show=\"model.mergeContact.id==\'0\'\" id=outdoorSearchContacts outdoor-search-contacts parent-model=model selected-name=\"\'merge\'\" search-term=model.searchTerm task=\"\'s\'\" search-companies=\"model.retrieveContact.iscompany==\'1\'\" search-contacts=\"model.retrieveContact.iscompany==\'0\'\" search-visits=false></div><div ng-hide=\"model.mergeContact.id==\'0\'\" class=\"form-group clearfix\"><div class=col-xs-8><h3 class=panel__title>{{contactsService.getName(model.mergeContact)}}</h3></div><div class=\"col-xs-4 text-right\"><button delete class=\"btn btn-danger\" ng-click=resetMergeContact()></button> <button retrieve ng-click=contactRetrieve(model.mergeContact.id)></button></div></div></div></div><div class=\"form-group clearfix\"><button class=\"btn btn-primary btn-block\" ng-disabled=model.retrieveContact.editing ng-click=mergeContacts()>{{tools.lang({\'en\':\'Merge\',\'nl\':\'Samenvoegen\',\'fr\':\'Fusionner\'})}}</button></div></form></li></ul></div></div>");
$templateCache.put("app/modules/contacts/searchContactsComponent.html","<div ng-class=\"{\'{{\'search-wrapper\'+getCustomClass()}}\':true}\" uib-dropdown is-open=isOpen><span style=\"cursor: pointer\" class=material-icons ng-click=search(true)>search</span> <input type=text focus-bool=focus class=\"form-control search__input input input--search\" ng-model=searchTerm ng-enter=search(true); ng-change=setIsOpen() placeholder=\"{{tools.lang({\'en\':\'Search\',\'nl\':\'Zoeken\',\'fr\':\'Chercher\'})}}\" ng-focus=\"focus=true;\" ng-blur=\"focus=false\"><div class=local__loader ng-show=calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div><nav ng-show=isOpen><ul style=\"display: block; padding: 15px; width: 100% ; heigth:auto;max-height: 350px;overflow:hidden auto;overflow-y: scroll;box-shadow: rgb(36 36 53 / 10%) 0px 18px 88px -4px, rgb(36 36 53 / 10%) 0px 12px 28px -6px; border-radius:15px\" uib-dropdown-menu><li ng-repeat=\"options in tools.toArray(model.searchOptions) | orderBy:\'first\'\" ng-show={{options.searchModel}}><h4>{{tools.lang(options.titleWording)}}</h4><a ng-show=\"task===\'c\'\" ng-click=options.onClickNew()><b>{{tools.lang(options.newWording)}}</b> </a><a ng-repeat=\"searchResult in tools.toArray(model[options.searchResultName]) | orderBy:\'1*sort\'\" ng-click=onSelection(searchResult,options.table)><span ng-if=\"options.id==\'contacts\'\"><b>{{(searchResult.firstname!=\'\'?searchResult.firstname+\' \':\'\')+searchResult.name}}</b><br><p>{{searchResult.email}}</p></span><span ng-if=\"options.id==\'companies\'\"><b>{{searchResult.name}}</b><br><p>{{[searchResult.address1,searchResult.postalcode,searchResult.address2,searchResult.vatnumber].join(\' \')}}</p></span><span ng-if=\"options.id==\'visits\'\"><b>{{(searchResult.firstname!=\'\'?searchResult.firstname+\' \':\'\')+searchResult.name}}</b><br><span>{{(searchResult.startdateISO!==searchResult.enddateISO?(searchResult.startdateISO+\' - \'):\'\')+searchResult.enddateISO+\' | \'+tools.label(parameters.STV[searchResult.stat])}}</span> </span></a><input ng-show=\"tools.getLength(model[options.searchResultName])>0 && model[options.limit]==tools.getLength(model[options.searchResultName])\" class=\"btn btn-default btn-sm\" type=button value=\"{{tools.lang({\'en\':\'More\',\'nl\':\'Meer\',\'fr\':\'Plus\'})}}\" ng-click=addSearchResults(options.limit,options.searchModel)><div ng-hide=\"tools.getLength(model[options.searchResultName])>0\" class=\"alert alert-info\" role=alert><p>{{tools.lang(options.notFoundWording)}}</p></div></li></ul></nav></div>");
$templateCache.put("app/modules/exact/login.html","<div ng-controller=ExactLoginController class=\"page page-exact-login page--tables\"><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\': \'Exact login\', \'nl\': \'Exact login\', \'fr\': \'Exact login\'})}}</h1></section><div class=content><div class=\"content__item c-table-view\" ng-hide=webservice.calling><div class=c-table-view__item><div class=table-responsive-wrapper><table><tr><td>Host:</td><td>{{model.exactVars.host}}</td></tr><tr><td>Client id:</td><td>{{model.exactVars.clientId}}</td></tr><tr><td>Callback:</td><td>{{model.exactVars.redirectUri}}</td></tr></table></div><div><input type=button ng-show=canLogin(); value=Login ng-click=login();> <span ng-hide=canLogin();>Cannot login. Please configure the connect variables.</span></div><div class=table-responsive-wrapper><table><tr><td>Access token:</td><td><div>{{model.exactVars.accesstoken}}</div></td></tr><tr><td>Refresh token:</td><td><div>{{model.exactVars.refreshtoken}}</div></td></tr><tr><td>Expires:</td><td><div>{{model.exactVars.expires}}</div></td></tr><tr><td>Division:</td><td><div>{{model.exactVars.division}}</div></td></tr></table></div><div><input type=button ng-show=canRefreshToken(); value=\"Refresh Token\" ng-click=refreshToken();> <span ng-hide=canRefreshToken();>Cannot refresh. Please login first.</span></div><div><input type=button value=\"Post Webhooks\" ng-click=postWebhooks();></div><div><input type=button value=testa ng-click=\"test(\'a\');\"> <input type=button value=testb ng-click=\"test(\'b\');\"> <input type=button value=testc ng-click=\"test(\'c\');\"> <input type=button value=testd ng-click=\"test(\'d\');\"> <input type=button value=teste ng-click=\"test(\'e\');\"> <input type=button value=testf ng-click=\"test(\'f\');\"> <input type=button value=testg ng-click=\"test(\'g\');\"></div><div><input type=text ng-model=guid> <input type=button value=get ng-click=get();></div></div></div><div class=\"content__item page__loader\" ng-show=webservice.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div></div></main></div>");
$templateCache.put("app/modules/hotels/checkinModal.html","<div class=modal-body><form class=form-horizontal><div class=\"form-group clearfix\"><div class=col-sm-12><div class=checkbox><label><input type=checkbox ng-model=model.selectAll ng-change=selectAll()> {{tools.lang({\'en\':\'-- All --\',\'nl\':\'-- Alle --\',\'fr\':\'-- Tout --\'})}}</label></div></div><hr><div class=col-sm-12 ng-repeat=\"hotelspaceassignment in model.hotelspaceassignments\">{{hotelspace=model.hotelspaces[hotelspaceassignment.assignedspace];\'\';}}<div class=checkbox><label><input type=checkbox ng-model=hotelspaceassignment.selected> <b ng-style=\"{\'color\':hotelspace.state==\'Inspected\'?\'#2dc973\':\'#f0ad4e\'}\">{{hotelspace.spacenumber}}</b> ({{tools.label(parameters.HSC[hotelspace.hsc])}})</label></div></div></div></form></div><div class=modal-footer><button class=\"btn btn-warning\" type=button ng-click=cancel()>Cancel</button> <button class=\"btn btn-primary\" type=button ng-click=checkin() ng-disabled=checkinDisabled()>{{model.visit.isCheckin?\'Checkin\':\'Checkout\'}}</button></div>");
$templateCache.put("app/modules/hotels/combinations.html","<div ng-controller=HotelsCombinationsController class=\"page page-hotel-combinations page--tables\"><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\':\'Hotel combinations\',\'nl\':\'Hotel combinations\',\'fr\':\'Hotel combinations\'})}}</h1><div class=header__actions><div class=\"form-group inline-flex\"><label class=control-label>{{tools.lang({\'en\':\'Filter\',\'nl\':\'Filter\',\'fr\':\'Filter\'})}}:</label><select ng-model=model.filter ng-change=filterChanged() ng-options=\"row.id as tools.label(row) for row in parameters.notDelArrayHTL\"></select></div></div></section><div class=content><div class=\"content__item c-table-view\" ng-hide=webservice.calling><div class=c-table-view__item ng-show=\"model.combination!==\'\' && model.filter!==\'\'\"><div class=table-responsive-wrapper><table class=table><thead><tr><th colspan=2><span class=th__content></span></th><th class=\"table__col col--sticky\" ng-repeat=\"param2Row in model.params2\"><span class=th__content>{{tools.label(param2Row)}}</span></th></tr></thead><tr ng-repeat=\"param1Row in model.params1\" class=row ng-class=\"{\'last\':$last}\" ng-class-even=\"\'even\'\" ng-class-odd=\"\'odd\'\"><td class=\"table__col col--sticky\">{{tools.label(param1Row)}}</td><td ng-repeat=\"param2Row in model.params2\" ng-class=\"{\'hasCombination\':model.structuredCombinations[param1Row.id][param2Row.id]}\" style=height:51px;min-width:60px ng-mouseenter=enterCell(param1Row.id,param2Row.id) ng-mouseleave=leaveCell()><input class=\"btn btn-warning\" cancel ng-click=deleteCombination(param1Row.id,param2Row.id); ng-show=showButton(param1Row.id,param2Row.id,false)> <input create ng-click=createCombination(param1Row.id,param2Row.id); ng-show=showButton(param1Row.id,param2Row.id,true)></td></tr></table></div></div></div><div class=\"content__item page__loader\" ng-show=webservice.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div></div></main></div>");
$templateCache.put("app/modules/hotels/lobby.html","<div ng-controller=HotelsLobbyController class=\"page page--dashboard\" ng-init=load();><aside id=filters class=\"page__sidebar sidebar\"><div class=sidebar__header><h4 class=title>{{tools.lang({\'en\': \'Filters\', \'nl\': \'Filters\', \'fr\': \'Filtres\'})}}</h4><button class=\"btn btn-default btn-rounded\"><span class=material-icons ng-click=\"toggleFilters(\'filters\')\">close</span></button></div><div class=sidebar__content><form class=form-horizontal><div class=\"form-group clearfix\"><label class=\"col-sm-12 control-label\" ng-click=\"model.dateOpened=!model.dateOpened\">{{tools.lang({\'en\':\'Date\',\'nl\':\'Datum\',\'fr\':\'Date\'})}}</label><div class=col-sm-12><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.date is-open=model.dateOpened ng-click=\"model.dateOpened=!model.dateOpened\" ng-change=load();> <span class=input-group-btn><button ng-model=model.date type=button class=\"btn btn-default\" ng-click=\"model.dateOpened=!model.dateOpened\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-12 control-label\">{{tools.lang({\'en\':\'Hotel\',\'nl\':\'Hotel\',\'fr\':\'Hotel\'})}}</label><div class=col-sm-12><div class=btn-group ng-repeat=\"htl in parameters.notDelArrayHTL\"><button ng-class=\"{\'active\':model.htl == htl.id}\" class=\"btn btn-default btn-width-auto\" ng-click=\"model.htl=htl.id;load();\">{{tools.label(htl)}}</button></div></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-12 control-label\">{{tools.lang({\'en\':\'In / Out options\',\'nl\':\'In / Out opties\',\'fr\':\'Option In / Out\'})}}</label><div class=col-sm-12><div class=btn-group><button type=button class=\"btn btn-default\" ng-click=\"model.filters.showCheckin = !model.filters.showCheckin;calculateFilteredVisits();calculateFilteredHotelspaceassignments();\" ng-class=\"{\'active\':model.filters.showCheckin}\">{{tools.lang({\'en\':\'Check-in\',\'nl\':\'Check-in\',\'fr\':\'Check-in\'})}}</button> <button type=button class=\"btn btn-default\" ng-click=\"model.filters.showCheckout = !model.filters.showCheckout;calculateFilteredVisits();calculateFilteredHotelspaceassignments();\" ng-class=\"{\'active\':model.filters.showCheckout}\">{{tools.lang({\'en\':\'Check-out\',\'nl\':\'Check-out\',\'fr\':\'Check-out\'})}}</button></div></div><div class=col-sm-6><div class=btn-group><button type=button class=\"btn btn-default\" ng-click=\"model.filters.showCheckedin = !model.filters.showCheckedin;calculateFilteredVisits();calculateFilteredHotelspaceassignments();\" ng-class=\"{\'active\':model.filters.showCheckedin}\">{{tools.lang({\'en\':\'Checked-in\',\'nl\':\'Checked-in\',\'fr\':\'Checked-in\'})}}</button></div></div><div class=col-sm-6><div class=btn-group><button type=button class=\"btn btn-default\" ng-click=\"model.filters.showCheckedout = !model.filters.showCheckedout;calculateFilteredVisits();calculateFilteredHotelspaceassignments();\" ng-class=\"{\'active\':model.filters.showCheckedout}\">{{tools.lang({\'en\':\'Checked-out\',\'nl\':\'Checked-out\',\'fr\':\'Checked-out\'})}}</button></div></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Ordering\',\'nl\':\'Volgorde\',\'fr\':\'Classement\'})}}</label><div class=col-sm-10><select class=form-control ng-model=model.sorting.propertyName ng-options=\"row.id as tools.label(row) for row in tools.toArray(model.sortingProperties) | orderBy:\'label\'+user.lang\"></select></div></div></form></div></aside><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.label(parameters.HTL[model.htl])}}&nbsp;</h1><button class=\"btn btn-default\" ng-click=\"model.loading=true;model.syncSpaces=true;load();\" ng-disabled=webservice.calling><span class=\"glyphicon glyphicon glyphicon-refresh\"></span></button>&nbsp; <i>{{tools.dateOutLong(tools.dateFromJava(model.date))}}</i><div class=header__actions><div class=\"page__actions hidden-xs hidden-sm\"><span ng-show=\"model.view==\'tiles\'\"><span style=\"padding: 8px 8px\"><span class=\"glyphicon glyphicon-filter\"></span> {{tools.lang({\'en\': \'Rooms\',\'nl\':\'Kamers\',\'fr\': \'Chambre\'})}} </span><input ng-show=model.filters.spacenumberIsActive type=text name=spacenumber class=form-control ng-model=model.filters.spacenumber ng-change=calculateFilteredVisits();calculateFilteredHotelspaceassignments();> </span><button ng-show=\"model.view===\'tiles\'\" type=button class=\"btn btn-default\" ng-click=\"model.view=\'list\';model.filters.spacenumberIsActive=false;model.filters.spacenumber=model.filters.spacenumberIsActive?model.filters.spacenumber:\'\';calculateFilteredVisits();calculateFilteredHotelspaceassignments();\"><span class=\"glyphicon glyphicon-th-list\"></span></button> <button ng-show=\"model.view===\'list\'\" type=button class=\"btn btn-default\" ng-click=\"model.view=\'tiles\';model.filters.spacenumberIsActive=true;model.filters.spacenumber=model.filters.spacenumberIsActive?model.filters.spacenumber:\'\';calculateFilteredVisits();calculateFilteredHotelspaceassignments();\"><span class=\"glyphicon glyphicon-th-large\"></span></button> <button type=button class=\"btn btn-default\" ng-click=increaseDays(-1);><span class=material-icons>chevron_left</span></button> <button type=button class=\"btn btn-default\" style=\"width: auto\" ng-click=setToday()>{{tools.lang({\'en\':\'Today\',\'nl\':\'Vandaag\',\'fr\':\'Aujourd\\u0027hui\'})}}</button> <button type=button class=\"btn btn-default\" ng-click=increaseDays(1);><span class=material-icons>chevron_right</span></button></div><button class=\"btn btn-default btn-filters\" ng-click=\"toggleFilters(\'filters\')\"><i class=material-icons>filter_list</i> <span class=\"btn__text hidden-xs hidden-sm\">{{tools.lang({\'en\': \'Filters\',\'nl\': \'Filters\',\'fr\': \'Filtres\'})}}</span></button></div></section><div class=\"content__item page__loader\" ng-show=model.loading><div class=lds-ring><div></div><div></div><div></div><div></div></div></div><div class=content ng-hide=model.loading><div class=row><!-- In/out events --><div class=\"col-lg-12 col-xl-8\"><div class=\"content__item c-table-view\"><div class=c-table-view__item><div style=\"display: flex; justify-content: space-between; align-items: center\"><h4 class=c-table-view__title><span ng-show=model.filters.showCheckin>{{tools.lang({\'en\':\'Check-in\',\'nl\':\'Check-in\',\'fr\':\'Check-in\'})}}&nbsp;{{model.counts.checkedin+\'/\'+model.counts.checkins}}&nbsp;<span class=\"glyphicon glyphicon-bed\"></span>&nbsp;{{model.counts.checkinClients}}&nbsp;<i class=\"fa fa-male\"></i></span> <span ng-show=\"model.filters.showCheckin && model.filters.showCheckout\">/&nbsp;</span> <span ng-show=model.filters.showCheckout>{{tools.lang({\'en\':\'Check-out \',\'nl\':\'Check-out \',\'fr\':\'Check-out \'})}}&nbsp;{{model.counts.checkedout+\'/\'+model.counts.checkouts}}&nbsp;<span class=\"glyphicon glyphicon-bed\"></span>&nbsp;{{model.counts.checkoutClients}}&nbsp;<i class=\"fa fa-male\"></i></span></h4></div><div class=c-table-view__item__content ng-show=\"model.view===\'list\'\"><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\" style=\"width: 100%\"><thead><tr><th><span class=th__content ng-click=\"sortBy(\'hrs\')\">{{tools.lang({\'en\': \'Arrival/departure\',\'nl\': \'Aankomst/vertrek\',\'fr\': \'Arrivée/depart\'})}} <span class=sortorder ng-show=\"model.sorting.propertyName === \'hrs\'\" ng-class=\"{reverse: model.sorting.reverse}\"></span> </span></th><th><span class=th__content ng-click=\"sortBy(\'ticketnr\')\">{{tools.lang({\'en\': \'Ticket\',\'nl\': \'Ticket\',\'fr\': \'Ticket\'})}} <span class=sortorder ng-show=\"model.sorting.propertyName === \'ticketnr\'\" ng-class=\"{reverse: model.sorting.reverse}\"></span></span></th><th><span class=th__content ng-click=\"sortBy(\'clientName\')\">{{tools.lang({\'en\': \'Name\',\'nl\': \'Naam\',\'fr\': \'Nom\'})}} <span class=sortorder ng-show=\"model.sorting.propertyName === \'clientName\'\" ng-class=\"{reverse: model.sorting.reverse}\"></span></span></th><th colspan=2><span class=th__content>{{tools.lang({\'en\': \'Rooms\',\'nl\':\'Kamers\',\'fr\': \'Chambre\'})}} <span class=\"glyphicon glyphicon-filter\" ng-click=\"model.filters.spacenumberIsActive=!model.filters.spacenumberIsActive;model.filters.spacenumber=model.filters.spacenumberIsActive?model.filters.spacenumber:\'\';calculateFilteredVisits();calculateFilteredHotelspaceassignments();\"></span> <input ng-show=model.filters.spacenumberIsActive type=text name=spacenumber class=form-control ng-model=model.filters.spacenumber ng-change=calculateFilteredVisits();calculateFilteredHotelspaceassignments();></span></th><th><span class=th__content></span></th></tr></thead><tbody><tr ng-repeat=\"visit in model.filteredVisits | orderBy:model.sorting.propertyName:model.sorting.reverse\" ng-class=\"{\'zero-participant\': inOutEvent.quantity == 0}\" ng-hide=\"visit.hrs===null\"><td style=\"text-align: left !important\"><div class=arrivalDepartureList ng-class=\"{\'arrival\':visit.isCheckin, \'departure\':!visit.isCheckin}\">{{tools.hourOut(visit.hrs)}}</div></td><td ng-click=visitRetrieve(visit.id) style=\"text-align: left !important\">{{activitiesService.ticketOut(visit.ticketnr)}}</td><td ng-click=visitRetrieve(visit.id) style=\"text-align: left !important\">{{visit.clientName}}</td><td ng-click=visitRetrieve(visit.id) style=\"text-align: right !important\"><div ng-repeat=\"hotelreservationcategory in visit.hotelreservationcategories\">{{hotelreservationcategory.roomquantity+\' x \'+tools.label(parameters.HSC[hotelreservationcategory.requestedhsc])+\' (\'+tools.amountIn(hotelreservationcategory.adultcount)}} <span title=\"{{tools.lang({\'en\':\'Adults\',\'nl\':\'Volwassenen\',\'fr\':\'Adultes\'})}}\" data-toggle=tooltip data-placement=top tooltip><i class=\"fa fa-male\"></i> </span>{{tools.amountIn(hotelreservationcategory.childcount)}} <span title=\"{{tools.lang({\'en\':\'Children\',\'nl\':\'Kinderen\',\'fr\':\'Enfants\'})}}\" data-toggle=tooltip data-placement=top tooltip><i class=\"fa fa-child\"></i> </span>)</div></td><td ng-click=visitRetrieve(visit.id) style=\"text-align: left !important\"><div ng-repeat=\"hotelreservationcategory in visit.hotelreservationcategories\"><span ng-repeat=\"hotelspace in hotelreservationcategory.hotelspaces | orderBy:\'spacenumber\'\" ng-style=\"{\'color\':hotelspace.state==\'Inspected\'?\'#2dc973\':\'#f0ad4e\'}\">{{hotelspace.spacenumber}} &nbsp;</span></div></td><td style=\"text-align: left !important\">{{firsthotelreservationcategory=tools.first(visit.hotelreservationcategories);\"\";}} <span ng-show=\"parameters.HTL[firsthotelreservationcategory.htl].field9==\'1\'\"><button type=button class=\"btn btn-default\" ng-click=\"tools.redirect(buildHref(\'rfid\',\'retrieveVisit\',visit.id,0))\"><span class=\"glyphicon glyphicon-credit-card\"></span></button> &nbsp;&nbsp;&nbsp; </span><span ng-show=visit.isCheckin><button type=button class=\"btn btn-default\" ng-disabled=visitIsCheckedin(visit) ng-click=visitCheckin(visit)><span class=glyphicon ng-class=\"{\'glyphicon-import\':!visitIsCheckedin(visit),\'glyphicon-ok\':visitIsCheckedin(visit)}\"></span></button> &nbsp;&nbsp;&nbsp; </span><span ng-show=!visit.isCheckin><button type=button class=\"btn btn-default\" ng-disabled=visitIsCheckedout(visit) ng-click=visitCheckout(visit)><span class=glyphicon ng-class=\"{\'glyphicon-export\':!visitIsCheckedout(visit),\'glyphicon-ok\':visitIsCheckedout(visit)}\"></span></button> &nbsp;&nbsp;&nbsp; </span><a class=\"btn btn-default\" ng-href=\"{{\'https://app.mews\'+(firsthotelreservationcategory.htl!=\'CON\'?\'\':\'-demo\')+\'.com/Commander/Reservation/GroupDetail/\'+firsthotelreservationcategory.externalid}}\" target=_blank>MEWS</a> &nbsp;&nbsp;&nbsp; <button refresh ng-disabled=webservice.calling ng-click=syncHotelreservationcategory(firsthotelreservationcategory);></button></td></tr></tbody></table><div ng-show=\"tools.getLength(model.filteredVisits)==0\" class=\"alert alert-warning text-center mt-1\">{{tools.lang({\'en\':\'Nothing to show\',\'nl\':\'Niets te zien\',\'fr\':\"Rien à montrer\"})}}</div></div></div></div></div></div><div class=\"col-lg-4 col-md-6 col-xs-12\" ng-show=\"model.view===\'tiles\'\" style=display:flex ng-repeat=\"hotelspaceassignment in model.filteredHotelspaceassignments | orderBy:model.sorting.propertyName:model.sorting.reverse\">{{hotelreservationcategory=hotelspaceassignment.hotelreservationcategory;visit=hotelspaceassignment.visits[hotelreservationcategory.visit];hotelspace=hotelspaceassignment.hotelspace;\"\";}}<div class=\"panel panel-default panel--template\" style=width:100%><div class=\"panel__heading form-group\"><div class=col-md-1><button retrieve ng-click=visitRetrieve(visit.id);></button></div><div class=col-md-8><h3 class=panel__title>{{visit.clientName+\' - \' +hotelspace.spacenumber}}</h3></div><div class=col-md-3 style=\"text-align: right\"><a class=\"btn btn-default\" ng-href=\"{{\'https://app.mews\'+(hotelreservationcategory.htl!=\'CON\'?\'\':\'-demo\')+\'.com/Commander/Reservation/GroupDetail/\'+hotelreservationcategory.externalid}}\" target=_blank>MEWS</a> <button refresh ng-disabled=webservice.calling ng-click=syncHotelreservationcategory(hotelreservationcategory);></button></div></div><div class=panel-body style=\"min-height: 150px\"><div class=form-group><div class=col-xs-12><span ng-show=hotelspaceassignment.isCheckin style=\"padding: 5px 10px;border-radius: 5px\" ng-style=\"{\'color\':hotelspaceassignmentStates[hotelspaceassignment.state][\'checkin\'].color,\'background-color\':hotelspaceassignmentStates[hotelspaceassignment.state][\'checkin\'].backgroundcolor}\">{{tools.label(hotelspaceassignmentStates[hotelspaceassignment.state][\'checkin\'])}} </span><span ng-show=hotelspaceassignment.isCheckout style=\"padding: 5px 10px;border-radius: 5px\" ng-style=\"{\'color\':hotelspaceassignmentStates[hotelspaceassignment.state][\'checkout\'].color,\'background-color\':hotelspaceassignmentStates[hotelspaceassignment.state][\'checkout\'].backgroundcolor}\">{{tools.label(hotelspaceassignmentStates[hotelspaceassignment.state][\'checkout\'])}}</span></div><div class=col-xs-12>{{(hotelreservationcategory.startdateISO!==hotelreservationcategory.enddateISO?(hotelreservationcategory.startdateISO+\' \'+hotelreservationcategory.starthrs+\' - \'):\'\')+hotelreservationcategory.enddateISO+\' \'+hotelreservationcategory.checkoutHrs}}</div><div class=col-xs-12>{{tools.amountIn(hotelreservationcategory.adultcount)}} <span title=\"{{tools.lang({\'en\':\'Adults\',\'nl\':\'Volwassenen\',\'fr\':\'Adultes\'})}}\" data-toggle=tooltip data-placement=top tooltip><i class=\"fa fa-male\"></i> </span>{{tools.amountIn(hotelreservationcategory.childcount)}} <span title=\"{{tools.lang({\'en\':\'Children\',\'nl\':\'Kinderen\',\'fr\':\'Enfants\'})}}\" data-toggle=tooltip data-placement=top tooltip><i class=\"fa fa-child\"></i></span></div><div class=col-xs-12 ng-repeat=\"visitrelation in hotelspaceassignment.visitrelations\">{{childVisit=hotelspaceassignment.visits[visitrelation.visitb];\"\";}} <button retrieve ng-click=visitRetrieve(childVisit.id);></button>&nbsp;{{childVisit.clientName}}</div><ul class=\"col-xs-offset-1 col-xs-11\"><li ng-show=\"visit.comment!=\'\' || hotelspaceassignment.comment!=\'\'\"><div style=\"overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical\">{{visit.comment+\' \'+hotelspaceassignment.comment}}</div></li></ul><div class=col-xs-12>{{\'V\'+visit.id+\' / \'+tools.label(parameters.HRA[hotelreservationcategory.hra])+\' / \'+tools.short(parameters.HSC[hotelreservationcategory.requestedhsc])+\' \'+hotelspace.spacenumber}} <span style=\"padding: 5px 10px;border-radius: 5px\" ng-style=\"{\'color\':hotelspaceStates[hotelspace.state].color,\'background-color\':hotelspaceStates[hotelspace.state].backgroundcolor}\">{{tools.label(hotelspaceStates[hotelspace.state])}}</span></div></div></div><div class=panel-footer><span ng-if=hotelspaceassignment.isCheckin><button type=button class=\"btn btn-default\" ng-disabled=hotelspaceassignment.isCheckedin ng-click=checkin([hotelspaceassignment.id])><span class=glyphicon ng-class=\"{\'glyphicon-import\':!hotelspaceassignment.isCheckedin,\'glyphicon-ok\':hotelspaceassignment.isCheckedin}\"></span></button> &nbsp;&nbsp;&nbsp; </span><span ng-if=hotelspaceassignment.isCheckout><button type=button class=\"btn btn-default\" ng-disabled=hotelspaceassignment.isCheckedout ng-click=checkout([hotelspaceassignment.id])><span class=glyphicon ng-class=\"{\'glyphicon-export\':!hotelspaceassignment.isCheckedout,\'glyphicon-ok\':hotelspaceassignment.isCheckedout}\"></span></button> &nbsp;&nbsp;&nbsp;</span></div></div></div><!-- Activity Feed --><div class=\"col-lg-12 col-xl-4\"><div class=\"content__item c-table-view\"><div class=c-table-view__item><div class=\"panel-heading h5\" style=\"display: flex; justify-content: space-between; align-items: center\"><h2 class=panel-title>{{tools.lang({\'en\':\'Activity feed\',\'nl\':\'Gewijzigde reservaties\',\'fr\':\"Fil d\'activité\"})}}</h2></div><div class=panel-body><!-- <div class=\"pre-scrollable loadOnScroll\"> --><div ng-show=\"tools.toArray(model.activityFeed).length == 0\" class=\"alert alert-warning text-center mt-1\">{{tools.lang({\'en\':\'Nothing to show\',\'nl\':\'Niets te zien\',\'fr\':\"Rien à montrer\"})}}</div><div ng-repeat=\"event in model.activityFeed | orderBy:\'actiondate\':true\" class=activityFeed__wrapper><div class=activityFeed__content ng-class=\"{\'reservation\': event.action == \'created\', \'modification of booking\': event.action == \'updated\', \'cancellation\': event.action == \'deleted\'}\"><div ng-click=visitRetrieve(event.visit)><div class=row><div class=col-xs-9><div class=\"text-size-large text-muted\">{{tools.timestampOut(event.actiondate)}}</div></div></div><div class=row><div class=col-xs-9><span class=font-size-larger>{{event.startdate + \' - \' + event.enddate+\', \'+event.contactfirstname+\' \'+event.contactname}}</span></div></div></div></div><hr class=\"m-t-10 m-b-10\"></div></div><!-- </div> --></div></div></div></div></div><div class=\"page__actions hidden-md hidden-lg hidden-xl\"><button type=button class=\"btn btn-default\" ng-click=increaseDays(-1);><span class=material-icons>chevron_left</span></button> <button type=button class=\"btn btn-default\" style=\"width: auto\" ng-click=setToday()>{{tools.lang({\'en\':\'Today\',\'nl\':\'Vandaag\',\'fr\':\'Aujourd\\u0027hui\'})}}</button> <button type=button class=\"btn btn-default\" ng-click=increaseDays(1);><span class=material-icons>chevron_right</span></button></div></main></div>");
$templateCache.put("app/modules/hotels/mewsMessages.html","<div ng-controller=MewsMessagesController class=\"page page-hotel-mews-messages page--content\"><form class=form-horizontal><div class=\"form-group clearfix\"><div class=col-sm-12><span ng-hide=webservice.calling><input refresh ng-click=load();> <button type=button class=\"btn btn-default\" ng-click=relaunchAll()>Relaunch all</button> </span><span ng-show=webservice.calling>Loading...</span></div></div></form><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\" ng-show=\"tools.getLength(model.mewsmessages)>0\"><thead><tr><th>Hotel</th><th><span class=th__content>{{tools.lang({\'en\':\'Code\',\'nl\':\'Code\',\'fr\':\'Code\'})}}</span></th><th>{{tools.lang({\'en\':\'Error\',\'nl\':\'Error\',\'fr\':\'Error\'})}}</th><th><span class=th__content></span></th></tr></thead><tbody><tr ng-repeat=\"mewsmessage in tools.toArray(model.mewsmessages) | orderBy:\'updated\'\"><td>{{getMewsmessageHotelid(mewsmessage)}}</td><td>{{getMewsmessageEvent(mewsmessage)}}</td><td><span style=\"white-space: pre-line\" ng-show=\"$first || errorwording.show\" ng-repeat=\"errorwording in mewsmessage.errorArray\">{{errorwording.error}}<span ng-show=\"$index==tools.getLength(tools.match(mewsmessage.errorArray,{\'show\':true}))-1 && !$last\">...</span><br></span>{{tools.lang({\'en\':\'Show:\',\'nl\':\'Toon:\',\'fr\':\'Montrer:\'})}} <button ng-show=\"tools.getLength(tools.match(mewsmessage.errorArray,{\'show\':true}))>1\" type=button class=\"btn btn-default\" ng-click=hideAll(mewsmessage)>---</button> <button ng-show=\"tools.getLength(tools.match(mewsmessage.errorArray,{\'show\':true}))>1\" type=button class=\"btn btn-default\" ng-click=\"mewsmessage.errorArray[tools.getLength(tools.match(mewsmessage.errorArray,{\'show\':true}))-1].show=false\">-</button> <button ng-show=\"tools.getLength(mewsmessage.errorArray)>tools.getLength(tools.match(mewsmessage.errorArray,{\'show\':true}))\" type=button class=\"btn btn-default\" ng-click=\"mewsmessage.errorArray[tools.getLength(tools.match(mewsmessage.errorArray,{\'show\':true}))].show=true\">+</button> <button ng-show=\"tools.getLength(mewsmessage.errorArray)>tools.getLength(tools.match(mewsmessage.errorArray,{\'show\':true}))\" type=button class=\"btn btn-default\" ng-click=showAll(mewsmessage)>+++</button></td><td><button refresh ng-click=retryMewsmessage(mewsmessage)></button> <button delete class=\"btn btn-danger\" ng-click=deleteMewsmessage(mewsmessage)></button></td></tr></tbody></table></div></div>");
$templateCache.put("app/modules/hotels/mewsTest.html","<div ng-controller=HotelsMewsTestController><div><input type=button value=testa ng-click=\"test(\'a\');\"> <input type=button value=testb ng-click=\"test(\'b\');\"> <input type=button value=testc ng-click=\"test(\'c\');\"> <input type=button value=testd ng-click=\"test(\'d\');\"> <input type=button value=teste ng-click=\"test(\'e\');\"> <input type=button value=testf ng-click=\"test(\'f\');\"> <input type=button value=testg ng-click=\"test(\'g\');\"></div></div>");
$templateCache.put("app/modules/hotels/timeline.html","<div ng-controller=HotelsTimelineController class=\"page page--dashboard\"><aside id=filters class=\"page__sidebar sidebar\"><div class=sidebar__header><h4 class=title>{{tools.lang({\'en\': \'Filters\', \'nl\': \'Filters\', \'fr\': \'Filtres\'})}}</h4><button class=\"btn btn-default btn-rounded\"><span class=material-icons ng-click=\"toggleFilters(\'filters\')\">close</span></button></div><div class=sidebar__content><form class=form-horizontal><div class=\"form-group clearfix\"><label class=\"col-xs-2 control-label\" ng-click=\"model.startdateOpened=!model.startdateOpened\">{{tools.lang({\'en\':\'From\',\'nl\':\'Vanaf\',\'fr\':\'De\'})}}</label><div class=col-xs-4><p class=input-group><span class=input-group-btn uib-datepicker-popup ng-model=model.startdate is-open=model.startdateOpened datepicker-options=model.dateOptions><button type=button class=\"btn btn-default\" ng-click=\"model.startdateOpened=!model.startdateOpened\"><i class=\"glyphicon glyphicon-calendar\"></i></button> </span><input type=text class=form-control ng-model=model.startdate ng-click=\"model.startdateOpened=!model.startdateOpened\"></p></div></div><div class=\"form-group clearfix\"><label class=\"col-xs-2 control-label\" ng-click=\"model.enddateOpened=!model.enddateOpened\">{{tools.lang({\'en\':\'To\',\'nl\':\'Tot\',\'fr\':\'À\'})}}</label><div class=col-xs-4><p class=input-group><span class=input-group-btn uib-datepicker-popup ng-model=model.enddate is-open=model.enddateOpened datepicker-options=model.dateOptions><button type=button class=\"btn btn-default\" ng-click=\"model.enddateOpened=!model.enddateOpened\"><i class=\"glyphicon glyphicon-calendar\"></i></button> </span><input type=text class=form-control ng-model=model.enddate ng-click=\"model.enddateOpened=!model.enddateOpened\"></p></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-12 control-label\">{{tools.lang({\'en\':\'Hotel\',\'nl\':\'Hotel\',\'fr\':\'Hotel\'})}}</label><div class=col-sm-12><div class=btn-group ng-repeat=\"htl in parameters.notDelArrayHTL\"><button ng-class=\"{\'active\':model.htl == htl.id}\" class=\"btn btn-default btn-width-auto\" ng-click=\"model.htl=htl.id;load();\">{{tools.label(htl)}}</button></div></div></div></form></div></aside><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.label(parameters.HTL[model.htl])}}&nbsp;</h1><button class=\"btn btn-default\" ng-click=\"model.loading=true;model.syncSpaces=true;load();\" ng-disabled=webservice.calling><span class=\"glyphicon glyphicon glyphicon-refresh\"></span></button>&nbsp; <i>{{tools.dateOutLong(tools.dateFromJava(model.startdate))}} - {{tools.dateOutLong(tools.dateFromJava(model.enddate))}}</i><div class=header__actions><div class=\"page__actions hidden-xs hidden-sm\"><button type=button class=\"btn btn-default\" ng-click=increaseDates(-28);><span class=material-icons style=\"margin-right: -15px\">chevron_left</span> <span class=material-icons>chevron_left</span></button> <button type=button class=\"btn btn-default\" ng-click=increaseDates(-7);><span class=material-icons>chevron_left</span></button> <button type=button class=\"btn btn-default\" style=\"width: auto\" ng-click=todayDate()>{{tools.lang({\'en\':\'Today\',\'nl\':\'Vandaag\',\'fr\':\'Aujourd\\u0027hui\'})}}</button> <button type=button class=\"btn btn-default\" ng-click=increaseDates(7);><span class=material-icons>chevron_right</span></button> <button type=button class=\"btn btn-default\" ng-click=increaseDates(28);><span class=material-icons style=\"margin-right: -15px\">chevron_right</span> <span class=material-icons>chevron_right</span></button></div><button class=\"btn btn-default btn-filters\" ng-click=\"toggleFilters(\'filters\')\"><i class=material-icons>filter_list</i> <span class=\"btn__text hidden-xs hidden-sm\">{{tools.lang({\'en\': \'Filters\',\'nl\': \'Filters\',\'fr\': \'Filtres\'})}}</span></button></div></section><div class=\"content__item page__loader\" ng-show=model.loading><div class=lds-ring><div></div><div></div><div></div><div></div></div></div><div class=content ng-hide=model.loading><div class=\"content__item c-table-view\"><div class=c-table-view__item><div class=c-timeline__scroller ng-style=\"{\'--timeline-days\':model.sequenceDays.length,\'height\':model.windowHeight}\"><table class=c-timeline__table><thead><!-- Month row --><tr class=month-header><th class=col--sticky-1><div class=th__content></div></th><th class=col--sticky-2><div class=th__content></div></th><!-- One <th> per month, spanning its days --><th ng-repeat=\"(monthKey, month) in model.lines.months\" ng-attr-colspan={{month.dates.length}}><div class=th__content>{{tools.lang(month)}} {{month.year}}</div></th></tr><!-- Day row --><tr class=day-header><th class=col--sticky-1><div class=th__content></div></th><th class=col--sticky-2><div class=th__content></div></th><th ng-repeat=\"d in model.lines.dates\" ng-class=\"{\'th--weekend\':d.date.getDay()===0 || d.date.getDay()===6,\'is-today\':dayIndex(tools.today())===$index}\"><div class=th__content>{{d.date | date:\'EEE\'}} {{d.date.getDate()}}</div></th></tr></thead><tbody><!-- One row per hotelspace --><tr ng-repeat=\"space in model.orderedHotelspaces\"><td class=col--sticky-1 ng-if=\"$first || model.orderedHotelspaces[$index-1].hsc!==space.hsc\" ng-attr-rowspan=\"{{tools.getLength(tools.match(model.hotelspaces,{\'hsc\':space.hsc}))}}\" ng-style=\"{\'--rows\':tools.getLength(tools.match(model.hotelspaces,{\'hsc\':space.hsc}))}\"><div class=c-timeline__vertical-label><span>{{space.hscLabel}}</span></div></td><td class=col--sticky-2><div>{{space.spacenumber}}</div></td><!-- Grid cells (just for lines/background) --><td ng-repeat=\"d in model.lines.dates\"></td><td class=overlay-cell ng-attr-colspan={{tools.getLength(model.lines.dates)}}><!-- Overlay event grid --><div class=events-row><div class=event ng-repeat=\"evt in space.loadElements\" ng-class=\"{\n                             \'event--booking\': !!evt.visit,\n                             \'event--available\': !evt.visit\n                           }\" ng-style=\"{\n                             gridColumnStart: (1 + dayIndex(evt.startTime)),\n                             gridColumnEnd: \'span \' + daysSpanDays(evt.startTime, evt.endTime),\n                             \'margin-left\':(startHourInDay(evt.startTime) * pxPerHour) + \'px\',\n                             \'width\':(getHrsDiff(evt.startTime, evt.endTime) * pxPerHour) + \'px\'\n                            }\">{{!evt.visit?\'+\':contactsService.getName(model.contacts[evt.visit.owningcontact])}}</div></div></td></tr></tbody></table></div></div></div></div><div class=\"page__actions hidden-md hidden-lg hidden-xl\"><button type=button class=\"btn btn-default\" ng-click=increaseDays(-28);><span class=material-icons>chevron_left</span><span class=material-icons>chevron_left</span></button> <button type=button class=\"btn btn-default\" ng-click=increaseDays(-7);><span class=material-icons>chevron_left</span></button> <button type=button class=\"btn btn-default\" style=\"width: auto\" ng-click=setToday()>{{tools.lang({\'en\':\'Today\',\'nl\':\'Vandaag\',\'fr\':\'Aujourd\\u0027hui\'})}}</button> <button type=button class=\"btn btn-default\" ng-click=increaseDays(7);><span class=material-icons>chevron_right</span></button> <button type=button class=\"btn btn-default\" ng-click=increaseDays(28);><span class=material-icons>chevron_right</span><span class=material-icons>chevron_right</span></button></div></main></div>");
$templateCache.put("app/modules/marketing/campaignOverview.html","<div ng-controller=campaignOverviewController class=\"page page-campaigns-overview page--tables\"><aside id=filters class=\"page__sidebar sidebar\"><div class=sidebar__header><h4 class=title>{{tools.lang({\'en\': \'Filters\', \'nl\': \'Filters\', \'fr\': \'Filtres\'})}}</h4><button class=\"btn btn-default btn-rounded\"><span class=material-icons ng-click=\"toggleFilters(\'filters\')\">close</span></button></div><div class=sidebar__content><form class=form-horizontal><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\" ng-click=\"model.startdateOpened=!model.startdateOpened\">{{tools.lang({\'en\':\'Start\',\'nl\':\'Start\',\'fr\':\'D\\u00E9but\'})}}</label><div class=col-sm-4><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.startdate is-open=model.startdateOpened datepicker-options=model.dateOptions ng-click=\"model.startdateOpened=!model.startdateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.startdateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><label class=\"col-sm-2 control-label\" ng-click=\"model.enddateOpened=!model.enddateOpened\">{{tools.lang({\'en\':\'End\',\'nl\':\'Einde\',\'fr\':\'Fin\'})}}</label><div class=col-sm-4><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.enddate is-open=model.enddateOpened datepicker-options=model.dateOptions ng-click=\"model.enddateOpened=!model.enddateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.enddateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-12 control-label\">{{tools.lang({\'en\':\'Promo\',\'nl\':\'Promo\',\'fr\':\'Promo\'})}}</label><div class=col-sm-12><select class=form-control ng-model=model.proId ng-change=filterCampaigns() ng-options=\"pro.id as tools.label(pro) for pro in tools.addElement(parameters.notDelPRO,any)| orderBy:\'label\'+user.lang\"></select></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-12 control-label\">{{tools.lang({\'en\':\'Activity\',\'nl\':\'Activity\',\'fr\':\'Activité\'})}}</label><div class=col-sm-12><select class=form-control ng-model=model.actId ng-change=filterCampaigns() ng-options=\"act.id as tools.label(act) for act in tools.addElement(parameters.notDelACT,any)| orderBy:\'label\'+user.lang\"></select></div></div></form></div><div class=sidebar__footer><button type=submit class=\"btn btn-primary\" ng-click=\"load(); toggleFilters(\'filters\');\">{{tools.lang({\'en\': \'Done\', \'nl\': \'Done\', \'fr\': \'Appliquer\'})}}</button></div></aside><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\': \'Campaign overview\', \'nl\': \'Campaign overview\', \'fr\': \'Résultats des campagnes\'})}}</h1><div class=header__actions><button class=\"btn btn-default btn-filters\" ng-click=\"toggleFilters(\'filters\')\"><i class=material-icons>filter_list</i> <span class=\"btn__text hidden-xs hidden-sm\">{{tools.lang({ \'en\': \'Filters\', \'nl\': \'Filters\', \'fr\': \'Filtres\' })}}</span></button> <a ng-href=\"#!/{{buildHref(\'settings\',\'campaigns\')}}\" class=\"btn btn-success\">{{tools.lang({\'en\':\'Create campaign\',\'nl\':\'Create campaign\',\'fr\':\'Créer une campagne\'})}}</a></div></section><div class=content><div class=\"content__item c-table-view\" ng-hide=webservice.calling><div class=c-table-view__item ng-show=\"tools.toArray(model.filteredCampaigns).length>0\"><div class=table-responsive-wrapper><h4 class=c-table-view__title><strong><span ng-show=\"model.proId!=\'\'\"><strong>{{tools.lang({\'en\':\'Campaign\',\'nl\':\'Campaign\',\'fr\':\"Campagne\"})}}&nbsp;:&#160;</strong>{{tools.label(parameters.PRO[model.proId])}},</span> {{tools.dateOut(tools.dateFromJava(model.startdate))}} - {{tools.dateOut(tools.dateFromJava(model.enddate))}}</strong></h4><table class=\"table table-striped\"><thead><tr><th ng-show=\"model.proId==\'\'\"><span class=th__content>{{tools.lang({\'en\':\'Campaign\',\'nl\':\'Campaign\',\'fr\':\"Campagne\"})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Activity\',\'nl\':\'Activity\',\'fr\':\"Activité\"})}}</span></th><th><span class=\"th__content text-right\">{{tools.lang({\'en\':\'Ticket sales\',\'nl\':\'Ticket sales\',\'fr\':\"Tickets vendus\"})}}</span></th><th><span class=\"th__content text-right\">{{tools.lang({\'en\':\'Total\',\'nl\':\'Total\',\'fr\':\"Total\"})}}</span></th></tr></thead><tbody><!--DATA--><tr ng-repeat=\"campaign in model.filteredCampaigns | orderBy:\'pro\':true\"><td ng-show=\"model.proId==\'\'\">{{tools.label(parameters.PRO[campaign.pro])}}</td><td ng-show=\"campaign.act!=\'\'\">{{tools.label(parameters.ACT[campaign.act])}}</td><td class=text-right ng-show=\"campaign.totalquantity!=\'\'\">{{tools.amountOut(campaign.totalquantity)}}</td><td class=text-right ng-show=\"campaign.totalnettopay!=\'\'\">{{tools.amountOut(campaign.totalnettopay)}}&euro;</td></tr></tbody></table></div></div></div><div class=content__noresult ng-hide=\"tools.toArray(model.filteredCampaigns).length>0 || webservice.calling\"><div class=\"alert alert-info\" role=alert><p>{{tools.lang({\'en\':\'No result - Change filters\',\'nl\':\'No result - Change filters\',\'fr\':\'Aucun résultat - Affinez votre recherche\'})}}</p></div></div><div class=\"content__item page__loader\" ng-show=webservice.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div></div></main></div>");
$templateCache.put("app/modules/marketing/editTemplate.html","<div ng-controller=MarketingEditTemplateController class=\"page page--content page-edit-template editTemplate\"><div ng-show=model.template.editing><form class=form-horizontal><div ng-include=\"\'app/modules/marketing/editTemplateHeader.html\'\"></div><div class=\"form-group clearfix\"><div class=col-sm-offset-2><button class=\"btn btn-primary\" ng-click=updateTemplate();>{{tools.lang({\'en\':\'Update\',\'nl\':\'Wijzig\',\'fr\':\'Modifier\'})}}</button> <button class=\"btn btn-default\" ng-click=cancelUpdateTemplate();>{{tools.lang({\'en\':\'Cancel\',\'nl\':\'Annuleer\',\'fr\':\'Annuler\'})}}</button></div></div></form></div><div ng-hide=model.template.editing><form><div id=editColumn class=col-md-3 ng-style=\"{\'overflow\': \'auto\',\'max-height\': model.windowHeight}\"><div ng-show=\"model.selected==null\"><div class=well><h3 class=panel-title><button edit ng-click=startUpdateTemplate()></button> {{model.template.name}} <button delete class=\"btn btn-danger\" ng-click=deleteTemplate()></button></h3></div><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>{{tools.lang({\'en\':\'New elements\',\'nl\':\'Nieuwe elementen\',\'fr\':\'New elements\'})}}</h3></div><div class=panel-body><ul class=list-group style=\"width: 100%\"><li class=\"list-group-item list-group-item-info\" style=\"text-align: center\" dnd-draggable=\"{\'table\':\'templatetexts\',\'new\':true}\" dnd-effect-allowed=copy dnd-type=\"\'templateelement\'\"><span class=\"glyphicon glyphicon-font\"></span> {{tools.lang({\'en\':\'Text\',\'nl\':\'Tekst\',\'fr\':\'Text\'})}}</li><li class=\"list-group-item list-group-item-info\" style=\"text-align: center\" dnd-draggable=\"{\'table\':\'templateimages\',\'new\':true}\" dnd-type=\"\'templateelement\'\" dnd-effect-allowed=copy><span class=\"glyphicon glyphicon-picture\"></span> {{tools.lang({\'en\':\'Image\',\'nl\':\'Afbeelding\',\'fr\':\'Image\'})}}</li><li class=\"list-group-item list-group-item-info\" style=\"text-align: center\" dnd-draggable=\"{\'table\':\'templatespacings\',\'new\':true}\" dnd-type=\"\'templateelement\'\" dnd-effect-allowed=copy><span class=\"glyphicon glyphicon-option-vertical\"></span> {{tools.lang({\'en\':\'Spacing\',\'nl\':\'Witruimte\',\'fr\':\'Spacing\'})}}</li></ul></div></div><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>{{tools.lang({\'en\':\'Trash\',\'nl\':\'Trash\',\'fr\':\'Trash\'})}}</h3></div><div class=panel-body style=\"text-align: center; padding:0px\"><ul dnd-list=[] dnd-effect-allowed=move dnd-allowed-types=\"[\'templateelement\',\'templatesection\']\" dnd-drop=delete(item,type) style=\"list-style-type: none; list-style-position: inside; padding:0px; margin:0px\"><li><div style=\"padding:20px 0px\"><span class=\"glyphicon glyphicon-trash\" style=\"font-size: 80px\"></span></div></li></ul></div></div><div>{{tools.lang({\'en\':\'Drag to move\',\'nl\':\'Sleep om te verplaatsen\',\'fr\':\'Drag to move\'})}}</div><div>{{tools.lang({\'en\':\'Ctrl + drag to copy\',\'nl\':\'Ctrl + sleep om te kopi\\u00EBren\',\'fr\':\'Ctrl + drag to copy\'})}}</div></div><div ng-hide=\"model.selected==null\"><div ng-show=\"model.selected.table==\'templatesections\'\" class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>{{tools.lang({\'en\':\'Section\',\'nl\':\'Sectie\',\'fr\':\'Section\'})}} <button class=\"btn btn-success\" update ng-click=select(null);></button> <button delete class=\"btn btn-danger\" ng-click=\"delete(model.selected,\'templatesection\');select(null);\"></button></h3></div><div class=panel-body><div class=\"form-group clearfix\"><label for=templatesectionBackground>{{tools.lang({\'en\':\'Background colour\',\'nl\':\'Achtergrondkleur\',\'fr\':\'Background colour\'})}}</label><div class=input-group><input type=text class=form-control id=templatesectionBackground-input ng-model=model.selected.background placeholder=\"{{tools.lang({\'en\':\'Background colour\',\'nl\':\'Achtergrondkleur\',\'fr\':\'Background colour\'})}}\" ng-change=\"updateTemplatesectionBackground(model.selected,\'text\')\"> <span class=input-group-btn style=width:25%><input type=color class=form-control id=templatesectionBackground ng-model=model.selected.backgroundColor ng-change=\"updateTemplatesectionBackground(model.selected,\'hex\')\"></span></div></div><div class=\"form-group clearfix\"><label>{{tools.lang({\'en\':\'Background width\',\'nl\':\'Achtergrond breedte\',\'fr\':\'Background width\'})}}</label><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"tly in parameters.notDelArrayTLY\" ng-click=\"model.selected.tly=tly.id;updateTemplatesection(model.selected)\" ng-class=\"{\'active\':model.selected.tly==tly.id}\">{{tools.label(tly)}}</button></div></div><div class=\"form-group clearfix\"><label for=templatesectionBottomspacing>{{tools.lang({\'en\':\'Bottom spacing\',\'nl\':\'Ruimte onderaan\',\'fr\':\'Bottom spacing\'})}}</label><input type=text class=form-control id=templatesectionBottomspacing ng-model=model.selected.bottomspacing placeholder=\"{{tools.lang({\'en\':\'Bottom spacing\',\'nl\':\'Ruimte onderaan\',\'fr\':\'Bottom spacing\'})}}\"></div><div class=\"form-group clearfix\"><label><input type=checkbox ng-model=model.selected.pagebreak ng-false-value=\"\'0\'\" ng-true-value=\"\'1\'\" ng-change=updateTemplatesection(model.selected)> {{tools.lang({\'en\':\'PDF page break after\',\'nl\':\'PDF nieuwe pagina hierna\',\'fr\':\'PDF page break apres\'})}}</label></div><div class=\"form-group clearfix\"><label for=templatesectionBorder>{{tools.lang({\'en\':\'Border\',\'nl\':\'Border\',\'fr\':\'Border\'})}}</label><input type=text class=form-control id=templatesectionBorder ng-model=model.selected.border placeholder=\"{{tools.lang({\'en\':\'Border\',\'nl\':\'Border\',\'fr\':\'Border\'})}}\"></div><div class=\"form-group clearfix\"><label><input type=checkbox ng-model=model.selected.editable ng-false-value=\"\'0\'\" ng-true-value=\"\'1\'\" ng-change=updateTemplatesection(model.selected)> {{tools.lang({\'en\':\'Editable in confirmation\',\'nl\':\'Wijzigbaar in bevestiging\',\'fr\':\'Editable in confirmation\'})}}</label></div></div></div><div ng-show=\"model.selected.table==\'templatetexts\' && model.selected.placeholder==\'\'\" class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>{{tools.lang({\'en\':\'Text\',\'nl\':\'Tekst\',\'fr\':\'Text\'})}} <button class=\"btn btn-success\" update ng-click=select(null);></button> <button delete class=\"btn btn-danger\" ng-click=\"delete(model.selected,\'templateelement\');select(null);\"></button></h3></div><div class=panel-body><div class=\"form-group clearfix\"><label>{{tools.lang({\'en\':\'Style\',\'nl\':\'Stijl\',\'fr\':\'Style\'})}}</label><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"tts in parameters.notDelArrayTTS\" ng-click=\"model.selected.tts=tts.id;updateTemplatetext(model.selected)\" ng-class=\"{\'active\':model.selected.tts==tts.id}\">{{tools.label(tts)}}</button></div></div><div class=\"form-group clearfix\"><label>{{tools.lang({\'en\':\'Align\',\'nl\':\'Uitlijnen\',\'fr\':\'Align\'})}}</label><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"align in [\'left\',\'center\',\'right\',\'justify\']\" ng-click=\"model.selected.align=align;updateTemplatetext(model.selected)\" ng-class=\"{\'active\':model.selected.align==align}\"><span class=glyphicon ng-class=\"\'glyphicon-align-\'+align\"></span></button></div></div><div class=\"form-group clearfix\" ng-hide=\"tools.getLength(tools.lessInt(model.templatesections[model.selected.templatesection].gridcolumns[model.selected.gridcolumn].templateelements,\'sort\',model.selected.sort))>0\"><label for=templatetexttopspacing>{{tools.lang({\'en\':\'Spacing top\',\'nl\':\'Witruimte boven\',\'fr\':\'Espace en haut\'})}}</label><input type=text class=form-control id=templatetexttopspacing ng-model=model.selected.spacingtop placeholder=\"{{tools.lang({\'en\':\'Spacing top\',\'nl\':\'Witruimte boven\',\'fr\':\'Espace en haut\'})}}\"></div><div class=\"form-group clearfix\"><label for=templatetextbottomspacing>{{tools.lang({\'en\':\'Spacing bottom\',\'nl\':\'Witruimte onder\',\'fr\':\'Espace en bas\'})}}</label><input type=text class=form-control id=templatetextbottomspacing ng-model=model.selected.spacingbottom placeholder=\"{{tools.lang({\'en\':\'Spacing bottom\',\'nl\':\'Witruimte onder\',\'fr\':\'Espace en bas\'})}}\"></div><div class=\"form-group clearfix\" ng-show=\"tools.getLength(model.placeholders)>0\"><label for=templatetextplaceholders>{{tools.lang({\'en\':\'Placeholders\',\'nl\':\'Placeholders\',\'fr\':\'Placeholders\'})}}</label><div class=btn-group><button class=\"btn btn-default\" ng-click=\"tools.copyToClipboard(\'%\'+placeholder+\'%\')\" ng-repeat=\"placeholder in model.placeholders\">{{placeholder}} <span class=\"glyphicon glyphicon-copy\"></span></button></div></div><div class=\"form-group clearfix\" ng-show=\"model.template.purpose==\'FBUTTON\'\"><label for=pricePlaceholder>{{tools.lang({\'en\':\'Price code placeholder\',\'nl\':\'Prijs code placeholder\',\'fr\':\'Placeholder Code prix\'})}} <button class=\"btn btn-default\" ng-click=\"tools.copyToClipboard(\'%P=\'+model.pricePlaceholder.pricekey+\'%€\')\" ng-show=\"model.pricePlaceholder.pricekey!=\'\'\"><span class=\"glyphicon glyphicon-copy\"></span></button></label><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"cat in pricekeyCategories\" ng-click=updatePricePlaceholderPriceCat(cat.id); ng-class=\"{\'active\':model.pricePlaceholder.priceCat==cat.id}\">{{tools.label(cat)}}</button></div><div ng-show=\"model.pricePlaceholder.priceCat==\'AC\'\"><select class=form-control ng-model=model.pricePlaceholder.priceAct ng-change=updatePricePlaceholderPriceAct(); ng-options=\"row.id as tools.label(row) for row in tools.addElement(parameters.combinationFilter(parameters.notDelACT,\'VISACTA\',\'PUB\'),zero) | orderBy:\'id\'\"></select><select class=form-control ng-model=model.pricePlaceholder.priceFrm ng-change=updatePricePlaceholderPricekeyActivity(); ng-options=\"row.id as tools.label(row) for row in tools.addElement(activityFilter(parameters.notDelFRM,\'id\',model.pricePlaceholder.priceAct),zero) | orderBy:\'id\'\"></select><select class=form-control ng-model=model.pricePlaceholder.priceUnt ng-change=updatePricePlaceholderPricekeyActivity(); ng-options=\"row.id as tools.label(row) for row in tools.addElement(activityFilter(parameters.notDelUNT,\'id\',model.pricePlaceholder.priceAct),zero) | orderBy:\'id\'\"></select></div><div ng-show=\"model.pricePlaceholder.priceCat==\'ME\'\"><select class=form-control ng-model=model.pricePlaceholder.priceRes ng-change=updatePricePlaceholderPriceRes(); ng-options=\"row.id as tools.label(row) for row in tools.addElement(parameters.notDelArrayRES,zero) | orderBy:\'id\'\"></select><select class=form-control ng-model=model.pricePlaceholder.priceDshCat ng-change=updatePricePlaceholderPriceDshCat(); ng-options=\"dshCat as dshCat for dshCat in getDishCategories()\"></select><select class=form-control ng-model=model.pricePlaceholder.priceDsh ng-change=updatePricePlaceholderPricekeyMeal(); ng-options=\"row.id as tools.label(row) for row in tools.addElement(getDishes(),zero) | orderBy:\'id\'\"></select></div><div ng-show=\"model.pricePlaceholder.priceCat==\'HS\'\"><select class=form-control ng-model=model.pricePlaceholder.priceHtl ng-change=updatePricePlaceholderPriceHtl(); ng-options=\"row.id as tools.label(row) for row in tools.addElement(parameters.notDelArrayHTL,zero) | orderBy:\'id\'\"></select><select class=form-control ng-model=model.pricePlaceholder.priceHsc ng-change=updatePricePlaceholderPricekeyHotelstay(); ng-options=\"hsc.id as tools.label(hsc) for hsc in tools.addElement(getHotelspaces(),zero)\"></select><select class=form-control ng-model=model.pricePlaceholder.priceHra ng-change=updatePricePlaceholderPricekeyHotelstay(); ng-options=\"hra.id as tools.label(hra) for hra in tools.addElement(getHotelrates(),zero) | orderBy:\'label\'+user.lang\"></select><select class=form-control ng-model=model.pricePlaceholder.priceCityTax ng-change=updatePricePlaceholderPricekeyHotelstay(); ng-options=\"row.id as tools.label(row) for row in cityTaxCategories | orderBy:\'id\'\"></select></div><div ng-show=\"model.pricePlaceholder.priceCat==\'PR\'\"><select class=form-control ng-model=model.pricePlaceholder.pricePrd ng-change=updatePricePlaceholderPricePrd(); ng-options=\"row.id as tools.label(row) for row in tools.addElement(parameters.notDelArrayPRD,zero) | orderBy:\'id\'\"></select></div></div><div class=\"form-group clearfix\" ng-show=userIsDeveloper><label><input type=checkbox ng-model=model.selected.placeholderIsHtml ng-change=\"model.selected.placeholder=getPlaceholder();updateTemplatetext(model.selected);\"> {{tools.lang({\'en\':\'Is html\',\'nl\':\'Is html\',\'fr\':\'Est html\'})}}</label></div></div></div><div ng-show=\"model.selected.table==\'templateimages\'\" class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>{{tools.lang({\'en\':\'Image\',\'nl\':\'Afbeelding\',\'fr\':\'Image\'})}} <button class=\"btn btn-success\" update ng-click=select(null);></button> <button delete class=\"btn btn-danger\" ng-click=\"delete(model.selected,\'templateelement\');select(null);\"></button></h3></div><div class=panel-body><div class=\"form-group clearfix\"><label>{{tools.lang({\'en\':\'File\',\'nl\':\'Bestand\',\'fr\':\'File\'})}}</label><div ngf-drop=upload($file,$invalidFiles) ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" ngf-max-size=1MB class=\"panel panel-default\" ngf-drag-over-class=\"\'panel-success dragover\'\"><div class=panel-body><span class=\"glyphicon glyphicon-picture\"></span> {{tools.lang({\'en\':\'Drop file here or\',\'nl\':\'Sleep bestand naar hier of\',\'fr\':\'Drop file here or\'})}}<div class=\"btn btn-default\" ngf-select=upload($file,$invalidFiles) ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" ngf-max-size=1MB>{{tools.lang({\'en\':\'Select\',\'nl\':\'Selecteer\',\'fr\':\'Select\'})}}</div></div></div></div><div class=\"form-group clearfix\"><label for=templateimageZoomwidth>{{tools.lang({\'en\':\'Width\',\'nl\':\'Breedte\',\'fr\':\'Width\'})}}</label><div class=btn-group><input type=number class=form-control id=templateimageZoomwidth ng-model=model.selected.zoomwidth placeholder=\"{{tools.lang({\'en\':\'Width\',\'nl\':\'Breedte\',\'fr\':\'Width\'})}}\" ng-change=updateTemplateimageWidth(model.selected)></div></div><div class=\"form-group clearfix\"><label>{{tools.lang({\'en\':\'Align\',\'nl\':\'Uitlijnen\',\'fr\':\'Align\'})}}</label><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"align in [\'left\',\'center\',\'right\']\" ng-click=\"model.selected.align=align;updateTemplateimage(model.selected)\" ng-class=\"{\'active\':model.selected.align==align}\"><span class=glyphicon ng-class=\"\'glyphicon-align-\'+align\"></span></button></div></div><div class=\"form-group clearfix\"><label>{{tools.lang({\'en\':\'Link\',\'nl\':\'Link\',\'fr\':\'Lien\'})}}</label><div class=btn-group><input type=text class=form-control id=templateimageLinken ng-model=model.selected.linken placeholder=en> <input type=text class=form-control id=templateimageLinknl ng-model=model.selected.linknl placeholder=nl> <input type=text class=form-control id=templateimageLinkfr ng-model=model.selected.linkfr placeholder=fr></div></div><div class=\"form-group clearfix\"><label>{{tools.lang({\'en\':\'Link text\',\'nl\':\'Link tekst\',\'fr\':\'Texte du lien\'})}}</label><div class=btn-group><input type=text class=form-control id=templateimageLinktexten ng-model=model.selected.linktexten placeholder=en> <input type=text class=form-control id=templateimageLinktextnl ng-model=model.selected.linktextnl placeholder=nl> <input type=text class=form-control id=templateimageLinktextfr ng-model=model.selected.linktextfr placeholder=fr></div></div></div></div><div ng-show=\"model.selected.table==\'templatetexts\' && model.selected.placeholder!=\'\'\" class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>{{tools.lang({\'en\':\'Placeholder\',\'nl\':\'Placeholder\',\'fr\':\'Placeholder\'})}} <button class=\"btn btn-success\" update ng-click=select(null);></button> <button delete class=\"btn btn-danger\" ng-click=\"delete(model.selected,\'templateelement\');select(null);\"></button></h3></div></div><div ng-show=\"model.selected.table==\'templatespacings\'\" class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>{{tools.lang({\'en\':\'Spacing\',\'nl\':\'Witruimte\',\'fr\':\'Spacing\'})}} <button class=\"btn btn-success\" update ng-click=select(null);></button> <button delete class=\"btn btn-danger\" ng-click=\"delete(model.selected,\'templateelement\');select(null);\"></button></h3></div><div class=panel-body><div class=\"form-group clearfix\"><label for=templatespacingHeight>{{tools.lang({\'en\':\'Height\',\'nl\':\'Hoogte\',\'fr\':\'Height\'})}}</label><div class=btn-group><input type=number class=form-control id=templatespacingHeight ng-model=model.selected.height placeholder=\"{{tools.lang({\'en\':\'Height\',\'nl\':\'Hoogte\',\'fr\':\'Height\'})}}\"></div></div></div></div><div><button class=\"btn btn-default\" ng-click=select(null);>{{tools.lang({\'en\':\'Deselect\',\'nl\':\'Deselecteer\',\'fr\':\'Deselectionner\'})}}</button></div></div></div><div class=col-md-9 ng-style=\"{\'overflow\': \'auto\',\'max-height\': model.windowHeight}\"><ul class=\"template-list-group droppable\" style=\"list-style-type: none; list-style-position: inside; padding:15px 0;margin:0px\" click-outside=select(null); outside-if-not=editColumn dnd-list=model.template.templatesectionsArray dnd-allowed-types=\"[\'templatesection\']\" dnd-drop=dropTemplatesection(dropEffect,item,index)><li ng-class=\"{\'template-section\':model.selected==null || model.selected.table===\'templatesections\' || tgcPickerIsOpen($index,\'above\') || tgcPickerIsOpen($index,\'bottom\')}\" ng-repeat=\"templatesection in model.template.templatesectionsArray\" ng-style=\"isSelected(templatesection,\'templatesections\')?{\'outline\':\'1px solid #337ab7\',\'position\':\'relative\',\'z-index\':1}:{}\" dnd-draggable=templatesection dnd-effect-allowed=copyMove dnd-type=\"\'templatesection\'\" dnd-selected=\"select(templatesection,\'templatesections\');\"><div ng-style=\"{\'background-color\':(templatesection.tly==\'AFU\' || model.template.background==\'AFU\')?\'#\'+(templatesection.tly==\'AFU\'?templatesection.background:model.template.background):\'transparent\'}\"><table style=\"width:594px;margin:0 auto;border-collapse: separate !important\" ng-style=\"{\'background-color\':(templatesection.tly==\'BCE\' || (templatesection.tly!=\'AFU\' && model.template.tly==\'BCE\'))?\'#\'+(templatesection.tly==\'BCE\'?templatesection.background:model.template.background):\'transparent\',\'padding-bottom\':templatesection.bottomspacing+\'px\'}\"><tbody><td ng-repeat=\"gridcolumn in templatesection.gridcolumns\" ng-style=\"{\'width\':gridcolumn.width,\'background-color\':(templatesection.tly==\'CCO\')?\'#\'+templatesection.background:\'transparent\',\'border\':templatesection.border}\"><ul style=\"list-style-type: none; list-style-position: inside; padding:0px;margin:0px\" dnd-list=gridcolumn.templateelements dnd-allowed-types=\"[\'templateelement\']\" dnd-drop=dropTemplateelement(dropEffect,templatesection,$index,item,index)><li ng-repeat=\"templateelement in gridcolumn.templateelements\" dnd-draggable=templateelement dnd-effect-allowed=copyMove dnd-type=\"\'templateelement\'\" dnd-selected=select(templateelement); dnd-disable-if=\"templateelement.table==model.selected.table && templateelement.id==model.selected.id\"><div ng-show=\"templateelement.table==\'templatetexts\' && templateelement.placeholder==\'\'\" style=padding-left:20px;padding-right:20px ng-style=\"{\'padding-top\':getTemplatetextSpacingtop(templateelement,$first),\'padding-bottom\':getTemplatetextSpacingbottom(templateelement,$last)}\">{{tts=parameters.TTS[templateelement.tts];\"\";}}<div ng-show=\"isSelected(templateelement) || templateelement[\'body\'+user.lang]==\'\'\" ng-repeat=\"lang in config.langs\" ng-style=\"!isSelected(templateelement)?{\'position\': \'relative\'}:{}\"><div ng-if=!isSelected(templateelement) ng-click=select(templateelement); style=\"position: absolute; top: 0; left: 0; right: 0; bottom: 0; cursor: pointer\"></div><textarea class=\"form-control templatetext\" ng-style=\"isSelected(templateelement)?{\'min-width\': \'200px\'}:{}\" ng-show=\"isSelected(templateelement) || lang==user.lang\" ng-model=\"templateelement[\'body\'+lang]\" ng-disabled=!isSelected(templateelement) placeholder=\"{{isSelected(templateelement)?lang:tools.lang({\'en\':\'Text\',\'nl\':\'Tekst\',\'fr\':\'Text\'})}}\">\n                            </textarea></div><div ng-if=\"!isSelected(templateelement) && templateelement[\'body\'+user.lang]!==\'\' && templateelement[\'trustedBody\'+user.lang]===false\" style=white-space:pre-line ng-style=\"{\'font-style\':tts.field4,\'font-weight\':tts.field3,\'font-size\':tts.field2,\'color\':\'#\'+tts.field5,\'text-align\':templateelement.align}\">{{templateelement[\'body\'+user.lang]}}</div><div ng-if=\"!isSelected(templateelement) && templateelement[\'body\'+user.lang]!==\'\' && templateelement[\'trustedBody\'+user.lang]!==false\" style=white-space:pre-line ng-style=\"{\'font-style\':tts.field4,\'font-weight\':tts.field3,\'font-size\':tts.field2,\'color\':\'#\'+tts.field5,\'text-align\':templateelement.align}\" ng-bind-html=\"templateelement[\'trustedBody\'+user.lang]\"></div></div><div ng-show=\"templateelement.table==\'templateimages\'\"><div ng-style=\"isSelected(templateelement)?{\'outline\':\'1px solid #337ab7\'}:{}\"><div ng-show=\"templateelement.width==\'0\'\" class=\"panel panel-default\"><div class=panel-body><span class=\"glyphicon glyphicon-picture\"></span></div></div><div ng-hide=\"templateelement.width==\'0\'\" ng-style=\"{\'text-align\':templateelement.align}\" style=\"position: relative\"><img ng-src=\"{{templateelement.table==\'templateimages\'?config.get(\'imageService\')+\'?id=\'+templateelement.id+\'&updated=\'+tools.substr(templateelement.updated,0,10)+\'_\'+tools.substr(templateelement.updated,11,8):\'\'}}\" width=\"{{templatesService.templateimageWidth(templateelement,gridcolumn.width)+\'px\'}}\"><div ng-style=\"{\'height\':(templateelement.height*(templatesService.templateimageWidth(templateelement,gridcolumn.width)/templateelement.width)/2+7)+\'px\'}\" style=\"width: 100%;position: absolute;left: 0;bottom: 0\">{{templateelement[\'linktext\'+user.lang]}}</div></div></div></div><div ng-show=\"templateelement.table==\'templatetexts\' && templateelement.placeholder!=\'\'\" ng-style=\"isSelected(templateelement)?{\'outline\':\'1px solid #337ab7\'}:{}\"><p ng-style=\"{\'font\':tts.field4+\' \'+tts.field3+\' \'+tts.field2+\' \'+tts.field1,\'color\':tts.field5,\'text-align\':templateelement.align}\">{{templateelement[\'body\'+user.lang]}}</p></div><div ng-show=\"templateelement.table==\'templatespacings\'\" ng-style=\"isSelected(templateelement)?{\'outline\':\'1px solid #337ab7\',\'height\':templateelement.height}:{\'height\':templateelement.height}\">&nbsp;</div></li><li ng-show=\"tools.getLength(gridcolumn.templateelements)==0\" ng-click=\"selectTemplatesection(templatesection,\'templatesections\');\"><div class=well>{{tools.lang({\'en\':\'Drag here\',\'nl\':\'Sleep naar hier\',\'fr\':\'Drag here\'})}}</div></li></ul></td></tbody></table></div><button ng-show=\"model.selected==null || model.selected.table===\'templatesections\' || tgcPickerIsOpen($index,\'above\')\" ng-style=\"tgcPickerIsOpen($index,\'above\')?{\'opacity\':1,\'visibility\':\'visible\',\'z-index\':11}:{}\" class=\"add-btn add-btn--top\" type=button ng-click=\"tgcPickerIsOpen($index,\'above\')?closeTgcPicker:openTgcPicker($index,\'above\',$event);\" uib-popover-template=\"\'tgcPicker.popover.html\'\" popover-is-open=\"tgcPickerIsOpen($index,\'above\')\" popover-placement=auto popover-trigger=\"\'outsideClick\'\" popover-class=tgc-popover><span ng-show=\"tgcPickerIsOpen($index,\'above\')\" class=\"glyphicon glyphicon-remove\"></span> <span ng-hide=\"tgcPickerIsOpen($index,\'above\')\" class=\"glyphicon glyphicon-plus\"></span></button> <button ng-show=\"model.selected==null || model.selected.table===\'templatesections\' || tgcPickerIsOpen($index,\'bottom\')\" ng-style=\"tgcPickerIsOpen($index,\'bottom\')?{\'opacity\':1,\'visibility\':\'visible\',\'z-index\':11}:{}\" class=\"add-btn add-btn--bottom\" type=button ng-click=\"tgcPickerIsOpen($index,\'bottom\')?closeTgcPicker:openTgcPicker($index,\'bottom\',$event);\" uib-popover-template=\"\'tgcPicker.popover.html\'\" popover-is-open=\"tgcPickerIsOpen($index,\'bottom\')\" popover-placement=auto popover-trigger=\"\'outsideClick\'\" popover-class=tgc-popover><span ng-show=\"tgcPickerIsOpen($index,\'bottom\')\" class=\"glyphicon glyphicon-remove\"></span> <span ng-hide=\"tgcPickerIsOpen($index,\'bottom\')\" class=\"glyphicon glyphicon-plus\"></span></button></li><li style=\"text-align: center;padding: 10px\"><div style=\"text-align: center\"><button class=\"btn btn-primary\" type=button ng-click=\"(model.tgcPicker.open && model.tgcPicker.index<0)?closeTgcPicker:openTgcPicker(tools.getLength(model.templatesections)-1,\'bottom\',$event);\" uib-popover-template=\"\'tgcPicker.popover.html\'\" popover-is-open=\"model.tgcPicker.open && model.tgcPicker.index<0\" popover-placement=top popover-append-to-body=true popover-trigger=\"\'outsideClick\'\" popover-class=tgc-popover>{{tools.lang({\'en\':\'Add section\',\'nl\':\'Sectie toevoegen\',\'fr\':\'Ajouter section\'})}}&nbsp; <span ng-show=\"model.tgcPicker.open && model.tgcPicker.index<0\" class=\"glyphicon glyphicon-remove\"></span> <span ng-hide=\"model.tgcPicker.open && model.tgcPicker.index<0\" class=\"glyphicon glyphicon-plus\"></span></button></div></li></ul><script type=text/ng-template id=tgcPicker.popover.html><div class=\"tgc-picker\" ng-click=\"$event.stopPropagation()\">\n            <div class=\"row tgc-picker__grid\">\n              <div class=\"col-md-4\" ng-repeat=\"tgc in tools.toArray(parameters.notDelTGC)\">\n                <button class=\"btn btn-default tgc-card\" ng-click=\"pickTgc(tgc.id)\">\n                  <div class=\"row\">\n                    <div class=\"mock-column\" ng-repeat=\"column in [tgc.field1,tgc.field2,tgc.field3,tgc.field4,tgc.field5,tgc.field6] track by $index\" ng-show=\"column!=\'0\'\" ng-style=\"{\'width\':(column/594*100)+\'%\'}\">\n                      <div class=\"mock-box\"></div>\n                    </div>\n                  </div>\n                </button>\n              </div>\n            </div>\n          </div></script></div></form></div></div>");
$templateCache.put("app/modules/marketing/editTemplateHeader.html","<div ng-controller=MarketingEditTemplateHeaderController><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Type\',\'nl\':\'Type\',\'fr\':\'Type\'})}}</label><div class=col-sm-10><div class=btn-group><button type=button class=\"btn btn-default\" ng-click=\"model.template.templatetype=\'main\';\" ng-class=\"{\'active\':model.template.templatetype==\'main\'}\">{{tools.lang({\'en\':\'Main\',\'nl\':\'Hoofd\',\'fr\':\'Principal\'})}}</button> <button type=button class=\"btn btn-default\" ng-click=\"model.template.templatetype=\'scheduled\';model.template.purpose=\'SCHEDULED\';\" ng-class=\"{\'active\':model.template.templatetype==\'scheduled\'}\">{{tools.lang({\'en\':\'Scheduled\',\'nl\':\'Gepland\',\'fr\':\'Programm\\u00E9\'})}}</button> <button type=button class=\"btn btn-default\" ng-click=\"model.template.templatetype=\'component\';\" ng-class=\"{\'active\':model.template.templatetype==\'component\'}\">{{tools.lang({\'en\':\'Component\',\'nl\':\'Component\',\'fr\':\'Composant\'})}}</button></div></div></div><div class=\"form-group clearfix\" ng-show=\"model.template.templatetype!==\'scheduled\'\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Main purpose\',\'nl\':\'Hoofddoel\',\'fr\':\'But principal\'})}}</label><div class=col-sm-10><select class=form-control ng-model=model.template.mainPurpose ng-change=\"model.template.purpose=model.template.templatetype==\'main\' && tools.getLength(model.template.mainPurpose.templatetypes[model.template.templatetype].purposes)==1?tools.first(model.template.mainPurpose.templatetypes[model.template.templatetype].purposes):(model.template.templatetype!==\'main\'?model.template.mainPurpose.id:\'\');\" ng-options=\"mainPurpose as tools.label(mainPurpose) for mainPurpose in model.structuredPurposes[model.template.templatetype] | orderBy:\'label\'+user.lang\"></select></div></div><div class=\"form-group clearfix\" ng-show=\"tools.getLength(model.template.mainPurpose.templatetypes[model.template.templatetype].joinedPurposes)>1 && model.templatetype!==\'scheduled\'\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Purpose\',\'nl\':\'Doel\',\'fr\':\'But\'})}}</label><div class=col-sm-10><select class=form-control ng-model=model.template.purpose ng-options=\"purpose.id as tools.label(purpose) for purpose in tools.toArray(model.template.mainPurpose.templatetypes[model.template.templatetype].joinedPurposes) | orderBy:\'label\'+user.lang\"></select></div></div><div ng-show=\"tools.getLength(model.purposes[model.template.purpose][model.template.templatetype].categories)>0\"><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Category\',\'nl\':\'Categorie\',\'fr\':\'Category\'})}}</label><div class=col-sm-10><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"category in tools.toArray(model.purposes[model.template.purpose][model.template.templatetype].categories) | orderBy:\'id\'\" ng-click=\"model.template.param1=category.id;\" ng-class=\"{\'active\':model.template.param1==category.id}\">{{tools.label(category)}}</button></div></div></div><div ng-show=\"model.purposes[model.template.purpose][model.template.templatetype].categories[model.template.param1].type==\'param\' && model.template.param1!=\'\'\"><div class=\"form-group clearfix\">{{paramCategory=model.template.param1;paramCategoryParams=model.purposes[model.template.purpose][model.template.templatetype].categories[paramCategory];parentParamTbl=paramCategoryParams.paramTbl;\"\";}}<label class=\"col-sm-2 control-label\">{{tools.label(paramCategoryParams)}}</label><div class=col-sm-10><select class=form-control ng-model=model.template.prm ng-options=\"prm.id as tools.label(prm) for prm in tools.toArray(tools.addMatchingElement(parameters[parentParamTbl],parameters[\'notDel\'+parentParamTbl],{\'id\':model.template.prm})) | orderBy: tools.lang({\'en\':\'labelen\',\'nl\':\'labelnl\',\'fr\':\'labelfr\'})\" ng-change=\"model.template.param2=model.template.prm;\"></select></div>{{parentParam=model.template.prm;all.id=parentParam;param2=paramCategoryParams.param2;childParamTbl=param2.paramTbl;\"\";}} <span ng-show=\"param2 && parentParam!=\'\'\"><label class=\"col-sm-2 control-label\">{{tools.label(param2)}}</label><div class=col-sm-10><select class=form-control ng-model=model.template.param2 ng-options=\"prm.id as tools.label(prm) for prm in tools.addElement(templatesService.filterParams(childParamTbl,\'id\',parentParam,model.template.param2),all) | orderBy: tools.lang({\'en\':\'labelen\',\'nl\':\'labelnl\',\'fr\':\'labelfr\'})\"></select></div></span><!-- \n        {{childParam=model.param2;param3=paramCategoryParams.param3;unitParamTbl=param3.paramTbl;\"\";}}\n        <span ng-show=\"param3 && parentParam!=\'\'\">\n          <label class=\"col-sm-2 control-label\">\n            {{tools.label(param3)}}\n          </label>\n          <div class=\"col-sm-10\">\n            <select class=\"form-control\" ng-model=\"model.param3\"\n              ng-options=\"prm.id as tools.label(prm) for prm in tools.addElement(templatesService.filterParams(unitParamTbl,\'id\',parentParam,model.param3),parentAll) | orderBy: tools.lang({\'en\':\'labelen\',\'nl\':\'labelnl\',\'fr\':\'labelfr\'})\"\n              ng-change=\"filterTemplates();\">\n            </select>\n          </div>\n        </span>\n  --></div></div></div><div ng-show=\"model.template.templatetype==\'scheduled\'\"><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Date type\',\'nl\':\'Datum type\',\'fr\':\'Type date\'})}}</label><div class=col-sm-10><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"datetablefield in datetablefields\" ng-click=\"model.template.datetablefield=datetablefield.id;\" ng-class=\"{\'active\':model.template.datetablefield==datetablefield.id}\">{{tools.label(datetablefield)}}</button></div></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Date offset\',\'nl\':\'Datum offset\',\'fr\':\'Offset date\'})}}</label><div class=col-sm-10><input type=text class=form-control ng-model=model.template.dateoffset placeholder=\"{{tools.lang({\'en\':\'Date offset\',\'nl\':\'Datum offset\',\'fr\':\'Offset date\'})}}\"></div></div></div><div ng-show=\"model.template.templatetype==\'main\' || model.template.templatetype==\'scheduled\'\"><div class=\"form-group clearfix\"><label for=subjecten class=\"col-sm-2 control-label\">Subject EN</label><div class=col-sm-10><input type=text autocomplete=off id=subjecten class=form-control ng-model=model.template.subjecten placeholder=\"Subject EN\"></div></div><div class=\"form-group clearfix\"><label for=subjectnl class=\"col-sm-2 control-label\">Subject NL</label><div class=col-sm-10><input type=text autocomplete=off id=subjectnl class=form-control ng-model=model.template.subjectnl placeholder=\"Subject NL\"></div></div><div class=\"form-group clearfix\"><label for=subjectfr class=\"col-sm-2 control-label\">Subject FR</label><div class=col-sm-10><input type=text autocomplete=off id=subjectfr class=form-control ng-model=model.template.subjectfr placeholder=\"Subject FR\"></div></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\" for=templateBackground><div>{{tools.lang({\'en\':\'Background colour\',\'nl\':\'Achtergrondkleur\',\'fr\':\'Background colour\'})}}</div></label><div class=col-sm-10><div class=input-group><input type=text class=form-control id=templateBackground-input ng-model=model.template.background placeholder=\"{{tools.lang({\'en\':\'Background colour\',\'nl\':\'Achtergrondkleur\',\'fr\':\'Background colour\'})}}\" ng-change=\"templatesService.setElementBackground(model.template,\'text\')\"> <span class=input-group-btn style=width:25%><input type=color class=form-control id=templateBackground ng-model=model.template.backgroundColor ng-change=\"templatesService.setElementBackground(model.template,\'hex\')\"></span></div></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Background width\',\'nl\':\'Achtergrond breedte\',\'fr\':\'Background width\'})}}</label><div class=col-sm-10><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"tly in tools.match(parameters.notDelArrayTLY,{\'field1\':\'1\'})\" ng-click=\"model.template.tly=tly.id;\" ng-class=\"{\'active\':model.template.tly==tly.id}\">{{tools.label(tly)}}</button></div></div></div><restrictions-component ng-show=\"model.template.templatetype==\'scheduled\'\" foreigntable=templates get-parent=getParent() model=$parent.model get-editing=getEditing() get-behaviour-filter=getBehaviourFilter()></restrictions-component></div>");
$templateCache.put("app/modules/marketing/listTemplates.html","<div ng-controller=MarketingListTemplatesController class=\"page page-templates page--content\"><main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\':\'Templates\',\'nl\':\'Templates\',\'fr\':\'Templates\'})}}</h1><div class=header__actions><div class=form-group><div class=\"col-xs-12 text-right\"><button class=\"btn btn-success\" ng-click=\"init();model.task=\'c\';\">{{tools.lang({\'en\':\'Create a new template\',\'nl\':\'Maak een nieuwe template\',\'fr\':\'Cr&#233;er un nouveau template\'})}}</button></div></div></div></section><section class=page__filters ng-if=!webservice.calling><div ng-show=\"model.task==\'l\'\"><form class=form-horizontal><section class=filters__item><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Main purpose\',\'nl\':\'Hoofddoel\',\'fr\':\'But principal\'})}}</label><div class=col-sm-10><select class=form-control ng-model=model.mainPurposeId ng-change=\"selectFilter(\'mainPurposeId\',model.mainPurposeId);\" ng-options=\"mainPurpose.id as tools.label(mainPurpose) for mainPurpose in model.structuredPurposes[\'mainPurposes\'] | orderBy:\'label\'+user.lang\"></select></div></div></section><section class=filters__item ng-show=\"tools.getLength(model.mainPurpose.templatetypes)>1\"><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Type\',\'nl\':\'Type\',\'fr\':\'Type\'})}}</label><div class=col-sm-10><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"templatetype in tools.toArray(model.mainPurpose.templatetypes) | orderBy:\'label\'+user.lang\" ng-click=\"selectFilter(\'templatetype\',templatetype.id)\" ng-class=\"{\'active\':model.templatetype==templatetype.id}\">{{tools.label(templatetype)}}</button></div></div></div></section><section class=filters__item ng-show=\"tools.getLength(model.mainPurpose.templatetypes[model.templatetype].joinedPurposes)>1 && model.templatetype!==\'scheduled\'\"><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Purpose\',\'nl\':\'Doel\',\'fr\':\'But\'})}}</label><div class=col-sm-10><select class=form-control ng-model=model.purpose ng-change=\"selectFilter(\'purpose\',model.purpose);\" ng-options=\"purpose.id as tools.label(purpose) for purpose in tools.addElement(tools.toArray(model.mainPurpose.templatetypes[model.templatetype].joinedPurposes),all) | orderBy:\'label\'+user.lang\"></select></div></div></section><section class=filters__item ng-show=\"tools.getLength(model.purposes[model.purpose][model.templatetype].categories)>1\"><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Category\',\'nl\':\'Categorie\',\'fr\':\'Category\'})}}</label><div class=col-sm-10><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"category in tools.addElement(tools.toArray(model.purposes[model.purpose][model.templatetype].categories),all) | orderBy:\'id\'\" ng-click=\"selectFilter(\'param1\',category.id)\" ng-class=\"{\'active\':model.param1==category.id}\">{{tools.label(category)}}</button></div></div></div></section><section class=filters__item ng-show=\"model.purposes[model.purpose][model.templatetype].categories[model.param1].type==\'param\' && model.param1!=\'\'\"><div class=\"form-group clearfix\">{{paramCategory=model.param1;paramCategoryParams=model.purposes[model.purpose][model.templatetype].categories[paramCategory];parentParamTbl=paramCategoryParams.paramTbl;\"\";}}<label class=\"col-sm-2 control-label\">{{tools.label(paramCategoryParams)}}</label><div class=col-sm-10><select class=form-control ng-model=model.prm ng-options=\"prm.id as tools.label(prm) for prm in tools.addElement(tools.toArray(tools.addMatchingElement(parameters[parentParamTbl],parameters[\'notDel\'+parentParamTbl],{\'id\':model.prm})),all) | orderBy: tools.lang({\'en\':\'labelen\',\'nl\':\'labelnl\',\'fr\':\'labelfr\'})\" ng-change=\"selectFilter(\'param2\',model.prm);\"></select></div>{{parentParam=model.prm;parentAll=tools.clone(all);parentAll.id=parentParam;param2=paramCategoryParams.param2;childParamTbl=param2.paramTbl;\"\";}} <span ng-show=\"param2 && parentParam!=\'\'\"><label class=\"col-sm-2 control-label\">{{tools.label(param2)}}</label><div class=col-sm-10><select class=form-control ng-model=model.param2 ng-options=\"prm.id as tools.label(prm) for prm in tools.addElement(templatesService.filterParams(childParamTbl,\'id\',parentParam,model.param2),parentAll) | orderBy: tools.lang({\'en\':\'labelen\',\'nl\':\'labelnl\',\'fr\':\'labelfr\'})\" ng-change=\"selectFilter(\'param2\',model.param2);\"></select></div></span><!-- \n              {{childParam=model.param2;param3=paramCategoryParams.param3;unitParamTbl=param3.paramTbl;\"\";}}\n              <span ng-show=\"param3 && parentParam!=\'\'\">\n                <label class=\"col-sm-2 control-label\">\n                  {{tools.label(param3)}}\n                </label>\n                <div class=\"col-sm-10\">\n                  <select class=\"form-control\" ng-model=\"model.param3\"\n                    ng-options=\"prm.id as tools.label(prm) for prm in tools.addElement(templatesService.filterParams(unitParamTbl,\'id\',parentParam,model.param3),parentAll) | orderBy: tools.lang({\'en\':\'labelen\',\'nl\':\'labelnl\',\'fr\':\'labelfr\'})\"\n                    ng-change=\"filterTemplates();\">\n                  </select>\n                </div>\n              </span>\n --></div></section><section ng-show=\"model.templatetype==\'scheduled\'\"><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Date type\',\'nl\':\'Datum type\',\'fr\':\'Type date\'})}}</label><div class=col-sm-10><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"datetablefield in datetablefields\" ng-click=\"selectFilter(\'datetablefield\',datetablefield.id)\" ng-class=\"{\'active\':model.datetablefield==datetablefield.id}\">{{tools.label(datetablefield)}}</button></div></div></div></section></form></div></section><div ng-show=\"model.task==\'c\'\"><form class=form-horizontal><div ng-include=\"\'app/modules/marketing/editTemplateHeader.html\'\"></div><div class=\"form-group clearfix\"><div class=\"col-sm-offset-2 col-sm-10\"><button class=\"btn btn-success\" ng-click=create();>{{tools.lang({\'en\':\'Create\',\'nl\':\'Aanmaken\',\'fr\':\'Creer\'})}}</button> <button class=\"btn btn-default\" ng-click=\"modelstore.removeRecord(\'templates\',\'-1\',model);model.task=\'l\';\">{{tools.lang({\'en\':\'Cancel\',\'nl\':\'Annuleer\',\'fr\':\'Annuler\'})}}</button></div></div></form></div><div class=\"row equal\" ng-show=\"!webservice.calling && tools.getLength(model.filteredTemplates)>0 && model.task==\'l\'\"><div ng-class=\"{\'col-md-6\':model.purpose!==\'FBUTTON\',\'col-md-3\':model.purpose===\'FBUTTON\'}\" class=col-sm-12 ng-repeat=\"template in model.filteredTemplates\"><div class=\"panel panel-default panel--template\" style=width:100%><div class=\"panel__heading form-group\"><div class=col-md-1><button retrieve ng-click=\"tools.redirect(buildHref(\'marketing\',\'editTemplate\',template.id));\"></button></div><div class=col-md-8><h3 class=panel__title><span class=\"color color-success\" ng-show=templateIsActive(template)>{{tools.lang({\'en\':\'Actif\',\'nl\':\'Actief\',\'fr\':\'Active\'})}}</span> {{templatesService.getTemplateName(template,model.purposes)}}</h3></div><div class=col-md-3 style=\"text-align: right\"><button delete class=\"btn btn-danger\" ng-click=delete(template)></button> <button class=\"btn btn-default\" ng-click=duplicate(template)><span class=\"glyphicon glyphicon-duplicate\"></span></button></div></div><div class=panel-body ng-style=\"model.extendPreview[template.id]?{}:{\'max-height\':\'350px\'}\" style=\"overflow: hidden\"><div id=template{{template.id}} class=mail ng-bind-html=template.trustedRendered></div><div ng-style=\"model.extendPreview[template.id]?{\'bottom\':\'0px\'}:{\'top\':\'200px\',\'background-image\':\'linear-gradient(to bottom, rgba(255, 255, 255, 0),rgba(255, 255, 255, 1))\'}\" style=\"width: 100%;height: 150px;position: absolute;left: 0\" ng-click=\"model.extendPreview[template.id]=!model.extendPreview[template.id]\"><span style=\"top: 115px !important;font-size: 25px;left: 50%\" ng-show=model.extendPreview[template.id] class=\"glyphicon glyphicon-chevron-up\"></span> <span style=\"top: 120px !important;font-size: 25px;left: 50%\" ng-hide=model.extendPreview[template.id] class=\"glyphicon glyphicon-chevron-down\"></span></div></div></div></div></div><div class=content><div class=content__noresult><div class=\"alert alert-info\" role=alert ng-show=\"!webservice.calling && tools.getLength(model.filteredTemplates)==0 && model.task==\'l\'\"><p>{{tools.lang({\'en\':\'No result - Change filters\',\'nl\':\'Geen resultaat - Verander filters\',\'fr\':\'Aucun résultat - Changer les filtres\'})}}</p></div></div><div class=\"content__item page__loader\" ng-show=webservice.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div></div></main></div>");
$templateCache.put("app/modules/marketing/toolsConfiguration.html","<section ng-controller=MarketingToolsConfigurationController class=\"page page-meals-agenda page--tables\"><main role=main class=page__content><div class=container><div class=\"panel panel-default\"><div class=panel-heading><h1>{{tools.lang({ \'en\': \'Marketing tools\', \'nl\': \'Marketingtools\', \'fr\': \'Outils marketing\' })}}</h1></div><div class=panel-body><select class=\"form-control mb-2\" ng-if=\"options.length > 1\" ng-model=selectedOption ng-options=\"option as tools.lang({ \'en\': option.labelen, \'nl\': option.labelnl, \'fr\': option.labelfr }) for option in options\"></select><iframe width=600 height=920 ng-src=\"{{ checkResource(selectedOption.field1) }}\" frameborder=0 style=border:0 allowfullscreen></iframe></div></div></div></main></section>");
$templateCache.put("app/modules/meals/agenda.html","<div ng-controller=MealsAgendaController class=\"page page-meals-agenda page--tables\"><aside id=filters class=\"page__sidebar sidebar\"><div class=sidebar__header><h4 class=title>{{tools.lang({\'en\':\'Filters\',\'nl\':\'Filters\',\'fr\':\'Filtres\'})}}</h4><button class=\"btn btn-default btn-rounded\"><span class=material-icons ng-click=\"toggleFilters(\'filters\')\">close</span></button></div><div class=sidebar__content><form class=form-horizontal><div class=\"form-group clearfix\"><label class=\"col-sm-12 control-label\">{{tools.lang({\'en\':\'Restaurant\',\'nl\':\'Restaurant\',\'fr\':\'Restaurant\'})}}</label><div class=col-sm-12><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"res in parameters.notDelArrayRES | orderBy:\'id\'\" ng-click=selectRes(res.id) ng-class=\"{\'active\':model.ress.indexOf(res.id)>=0}\">{{tools.short(res)}}</button></div></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-12 control-label\">{{tools.lang({\'en\':\'Selected\',\'nl\':\'Geselecteerd\',\'fr\':\'S\\u00E9lectionn\\u00E9\'})}}</label><div class=col-sm-12><p class=form-control-static ng-hide=\"tools.getLength(model.ress)>0\">{{tools.lang({\'en\':\'All restaurants\',\'nl\':\'Alle restaurants\',\'fr\':\'Tous les restaurants\'})}}</p><div ng-show=\"tools.getLength(model.ress)>0\"><div class=btn-group><button type=button class=\"btn btn-default active\" ng-repeat=\"res in model.ress | orderBy:\'toString()\'\" ng-click=selectRes(res)><span class=\"material-icons color-primary\">close</span> <span class=btn__text>{{tools.short(parameters.RES[res])}}</span></button></div><button type=button class=\"btn btn-primary\" style=\"margin-top: 16px\" ng-click=\"model.ress=[];load()\">{{tools.lang({\'en\':\'All restaurants\',\'nl\':\'Alle restaurants\',\'fr\':\'Tous les restaurants\'})}}</button></div></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-12 control-label\" ng-click=\"model.startdateOpened=!model.startdateOpened\">{{tools.lang({\'en\':\'Start\',\'nl\':\'Start\',\'fr\':\'D\\u00E9but\'})}}</label><div class=col-sm-12><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.startdate is-open=model.startdateOpened datepicker-options=model.dateOptions ng-click=\"model.startdateOpened=!model.startdateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.startdateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><label class=\"col-sm-12 control-label\" ng-click=\"model.enddateOpened=!model.enddateOpened\">{{tools.lang({\'en\':\'End\',\'nl\':\'Einde\',\'fr\':\'Fin\'})}}</label><div class=col-sm-12><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.enddate is-open=model.enddateOpened datepicker-options=model.dateOptions ng-click=\"model.enddateOpened=!model.enddateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.enddateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-12 control-label\">{{tools.lang({\'en\':\'From\',\'nl\':\'Van\',\'fr\':\'De\'})}}</label><div class=col-sm-12><select class=form-control ng-model=model.startHrs ng-options=\"hrs.id as tools.label(hrs) for hrs in tools.addElement(parameters.notDelHRS,any)\"></select></div><label class=\"col-sm-12 control-label\">{{tools.lang({\'en\':\'To\',\'nl\':\'Tot\',\'fr\':\'À\'})}}</label><div class=col-sm-12><select class=form-control ng-model=model.endHrs ng-options=\"hrs.id as tools.label(hrs) for hrs in tools.addElement(parameters.notDelHRS,any)\"></select><div class=btn-group></div></div></div><div class=\"form-group clearfix\"><div class=col-sm-12><div class=col-sm-12><div class=\"form-group clearfix\"><label>{{tools.lang({\'en\':\'Name\',\'nl\':\'Naam\',\'fr\':\'Nom\'})}} :</label><input type=text class=form-control ng-model=model.filters.name></div><div class=\"form-group clearfix\"><label>{{tools.lang({\'en\':\'Creation date of visit\',\'nl\':\'Aanmaakdatum van het bezoek\',\'fr\':\'Date de cr\\u00E9ation de la visite\'})}} :</label><div class=\"form-group clearfix\"><label class=\"col-sm-12 control-label\" ng-click=\"model.filters.creationDate.startdateOpened=!model.filters.creationDate.startdateOpened\">{{tools.lang({\'en\':\'Start\',\'nl\':\'Start\',\'fr\':\'D\\u00E9but\'})}}</label><div class=col-sm-12><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.filters.creationDate.startdate is-open=model.filters.creationDate.startdateOpened datepicker-options=model.dateOptions ng-click=\"model.filters.creationDate.startdateOpened=!model.filters.creationDate.startdateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.filters.creationDate.startdateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><label class=\"col-sm-12 control-label\" ng-click=\"model.filters.creationDate.enddateOpened=!model.filters.creationDate.enddateOpened\">{{tools.lang({\'en\':\'End\',\'nl\':\'Einde\',\'fr\':\'Fin\'})}}</label><div class=col-sm-12><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.filters.creationDate.enddate is-open=model.filters.creationDate.enddateOpened datepicker-options=model.dateOptions ng-click=\"model.filters.creationDate.enddateOpened=!model.filters.creationDate.enddateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.filters.creationDate.enddateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div><div class=\"form-group clearfix\"><label>{{tools.lang({\'en\':\'Origin of the visit\',\'nl\':\'Oorsprong van het bezoek\',\'fr\':\'Origine de la visite\'})}}</label><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"vis in parameters.notDelArrayVIS | orderBy:\'tools.label(vis)\'\" ng-click=\"vis.selected =! vis.selected\" ng-class=\"{\'active\':vis.selected}\">{{tools.label(vis)}}</button></div><button type=button class=\"btn btn-default\" ng-click=resetVisitOrigins()>{{tools.lang({\'en\':\'All origins\',\'nl\':\'Alle origins\',\'fr\':\'Toutes les origines\'})}}</button></div><div class=\"form-group clearfix\"><label>{{tools.lang({\'en\':\'Dish category\',\'nl\':\'Gerecht categorie\',\'fr\':\'Cat\\u00E9gorie de plat\'})}}</label><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"dishCategory in model.filters.dishCategories | orderBy:\'dishCategory.name\'\" ng-click=\"dishCategory.selected =! dishCategory.selected\" ng-class=\"{\'active\':dishCategory.selected}\">{{dishCategory.name}}</button></div><button type=button class=\"btn btn-default\" ng-click=resetDishCategories()>{{tools.lang({\'en\':\'All categories\',\'nl\':\'Alle categorie\\u00EBn\',\'fr\':\'Toutes les cat\\u00E9gories\'})}}</button></div><div class=\"form-group clearfix\"><label><input type=checkbox ng-model=model.showZero> {{tools.lang({\'en\':\'Show zero participants\',\'nl\':\'Toon nul deelnemers\',\'fr\':\'Montrer zero participants\'})}}</label></div><div class=\"form-group clearfix\"><label><input type=checkbox ng-model=model.showTotals> {{tools.lang({\'en\':\'Show totals\',\'nl\':\'Toon totalen\',\'fr\':\'Montrer total\'})}}</label></div></div></div></div></form></div><div class=sidebar__footer><button type=submit class=\"btn btn-primary\" ng-click=\"load(); toggleFilters(\'filters\');\">{{tools.lang({\'en\':\'Done\',\'nl\':\'Done\',\'fr\':\'Appliquer\'})}}</button></div></aside><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\':\'Meals list\',\'nl\':\'Overzicht maaltijden\',\'fr\':\'Liste des repas\'})}}</h1><div class=header__actions><div class=\"page__actions hidden-xs hidden-sm\"><button type=button class=\"btn btn-default\" ng-click=increaseDates(-7);><span class=material-icons style=\"margin-right: -15px\">chevron_left</span> <span class=material-icons>chevron_left</span></button> <button type=button class=\"btn btn-default\" ng-click=increaseDates(-1);><span class=material-icons>chevron_left</span></button> <button type=button class=\"btn btn-default\" style=\"width: auto\" ng-click=todayDate()>{{tools.lang({\'en\':\'Today\',\'nl\':\'Vandaag\',\'fr\':\'Aujourd\\u0027hui\'})}}</button> <button type=button class=\"btn btn-default\" ng-click=increaseDates(1);><span class=material-icons>chevron_right</span></button> <button type=button class=\"btn btn-default\" ng-click=increaseDates(7);><span class=material-icons style=\"margin-right: -15px\">chevron_right</span> <span class=material-icons>chevron_right</span></button></div><button class=\"btn btn-default btn-filters\" ng-click=\"toggleFilters(\'filters\')\"><i class=material-icons>filter_list</i> <span class=\"btn__text hidden-xs hidden-sm\">{{tools.lang({\'en\':\'Filters\',\'nl\':\'Filters\',\'fr\':\'Filtres\'})}}</span></button> <button class=\"btn btn-success btn-filters\" onclick=window.print()><i class=material-icons>print</i> <span class=\"btn__text hidden-xs hidden-sm hidden-md hidden-lg\">{{tools.lang({\'en\':\'Print\',\'nl\':\'Print\',\'fr\':\'Imprimer\'})}}</span></button></div></section><div class=content><div class=\"content__item c-table-view\" ng-hide=webservice.calling><div class=c-table-view__item ng-repeat=\"date in model.dates | orderBy:\'id\':false\"><div class=c-table-view__item__content><h4 class=c-table-view__title>{{date.id+\' \'+tools.dateToWeekday(date.id)+\' \'+tools.label(parameters.SLT[slt.id])}}</h4><div class=\"table-responsive-wrapper table--fixed-height\"><table class=\"table table-striped table-hover\"><thead><tr><th ng-show=model.showResLabel><span class=th__content>{{tools.lang({\'en\':\'Restaurant\',\'nl\':\'Restaurant\',\'fr\':\'Restaurant\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Hour\',\'nl\':\'Uur\',\'fr\':\'Heure\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Name\',\'nl\':\'Naam\',\'fr\':\'Nom\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Dishes\',\'nl\':\'Gerechten\',\'fr\':\'Plats\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Comment\',\'nl\':\'Opmerking\',\'fr\':\'Remarque\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Delivery\',\'nl\':\'Levering\',\'fr\':\'Livraison\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Accomodations\',\'nl\':\'Verblijfplaatsen\',\'fr\':\'Logements\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Payment\',\'nl\':\'Payment\',\'fr\':\'Paiement\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Status\',\'nl\':\'Status\',\'fr\':\'Statut\'})}}</span></th></tr></thead><tbody><tr ng-repeat=\"meal in getMeals(date.meals) | orderBy:\'hrs\'\"><td ng-click=visitRetrieve(meal.visit) ng-show=model.showResLabel>{{tools.label(parameters.RES[meal.res])}}</td><td ng-click=visitRetrieve(meal.visit)>{{tools.label(parameters.HRS[meal.hrs])}}</td><td ng-click=visitRetrieve(meal.visit)>{{contactsService.getName(model.contacts[model.visits[meal.visit].owningcontact])}}</td><td ng-click=visitRetrieve(meal.visit)><div ng-repeat=\"dish in tools.join(meal,\'dishes\',model)\" ng-show=dish.isIncluded>{{tools.amountOut(model.items[dish.item].planningquantity)}} <span ng-hide=\"parameters.DSH[dish.dsh].field1==\'1\'\">{{tools.label(parameters.DSH[dish.dsh])}} </span><span ng-show=\"parameters.DSH[dish.dsh].field1==\'1\'\">{{dish.quotationtitle}} </span>{{\'(\'+tools.amountOut(model.items[dish.item].nettopay/model.items[dish.item].quantity)+\'€ p.p.)\'}}</div></td><td><span ng-hide=meal.editing>{{meal.comment}} <input edit ng-click=editComment(meal) class=\"btn btn-rounded hidden-print\"> </span><span ng-show=meal.editing><form><input type=text class=form-control ng-model=meal.comment> <input class=\"btn btn-success\" update ng-click=updateComment(meal)> <input class=\"btn btn-warning\" cancel ng-click=cancelComment(meal)></form></span></td><td ng-click=visitRetrieve(meal.visit)><span ng-show=\"meal.delivery==\'1\'\">{{model.visits[meal.visit].address1+\' \'+model.visits[meal.visit].postalcode+\' \'+model.visits[meal.visit].address2}}</span></td><td ng-click=visitRetrieve(meal.visit)><span ng-repeat=\"htl in meal.accomodations\">{{tools.short(parameters.HTL[htl])}}</span></td><td ng-click=visitRetrieve(meal.visit)>{{tools.label(parameters.STV[this.tools.expandDigits(model.visits[meal.visit].stat,4)])}}</td><td><div ng-show=\"meal.stat==1000\"><button type=button class=\"btn btn-success\" ng-click=\"updateMealStat(meal,\'4000\')\"><span class=btn__text>{{tools.lang({\'en\':\'Done\',\'nl\':\'Done\',\'fr\':\'Valider\'})}}</span></button></div><div ng-hide=\"meal.stat==1000\">{{tools.label(parameters.STM[this.tools.expandDigits(meal.stat,4)])}} <button type=button class=\"btn btn-warning\" ng-click=\"updateMealStat(meal,\'1000\')\"><span class=btn__text>{{tools.lang({\'en\':\'Reset\',\'nl\':\'Reset\',\'fr\':\'Réinitialiser\'})}}</span></button></div></td></tr></tbody></table></div><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><thead><tr><th><span class=th__content>{{tools.lang({\'en\':\'Totals\',\'nl\':\'Totalen\',\'fr\':\'Totaux\'})}}</span></th><th ng-repeat=\"dishCategory in model.filters.dishCategories\" ng-show=\"hasAtLeastOneCorrespondingDish(dishCategory.name, getMeals(date.meals)) || dishCategory.selected\"><span class=th__content>{{dishCategory.name}}</span></th></tr></thead><tbody><tr><td><strong>{{tools.sum(tools.inverseJoin(tools.join(date.meals,\'dishes\',model),\'items\',\'item\',model),\'planningquantity\')}} {{getFormattedTotalQuantityForSelectedDishCategories(getMeals(date.meals))}}</strong></td><td ng-repeat=\"dishCategory in model.filters.dishCategories\" ng-show=\"hasAtLeastOneCorrespondingDish(dishCategory.name, getMeals(date.meals)) || dishCategory.selected\">{{getSumOfDishesForCategory(dishCategory.name,getMeals(date.meals))}}</td></tr></tbody></table></div></div><div class=c-table-view__item__content ng-show=model.showTotals><h4>{{tools.lang({\'en\':\'List of totals for dishes for\',\'nl\':\'Overzicht totalen per gerecht voor\',\'fr\':\'Liste des totaux par plat pour\'})+\' \'+tools.dateToWeekday(date.id)+\' \'+date.id+\' \'+tools.label(parameters.SLT[slt.id])}}</h4><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><thead><tr><th><span class=th__content>{{tools.lang({\'en\':\'Quantity\',\'nl\':\'Quantity\',\'fr\':\'Quantité\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Dish\',\'nl\':\'Gerecht\',\'fr\':\'Plat\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Category\',\'nl\':\'Categorie\',\'fr\':\'Cat\\u00E9gorie\'})}}</span></th></tr></thead><tbody><tr ng-repeat=\"dsh in tools.toArray(date.dishQuantitySums) | orderBy:\'toPrepare\':true\"><td>{{dsh.planningquantity}}</td><td><div ng-hide=\"parameters.DSH[dsh.id].field1==\'1\'\">{{tools.label(parameters.DSH[dsh.id])}}</div><div ng-show=\"parameters.DSH[dsh.id].field1==\'1\'\"><span ng-repeat=\"dish in dsh.dishes\">{{dish.quotationtitle}}</span></div></td><td>{{dsh.category}}</td></tr></tbody></table></div></div></div><div class=c-table-view__item ng-show=\"model.showTotals && model.startdate<model.enddate\"><div class=c-table-view__item__content><h4 class=c-table-view__title>{{tools.lang({\'en\':\'List of totals for dishes from\',\'nl\':\'Overzicht totalen per gerecht vanaf\',\'fr\':\'Liste des totaux par plat de\'})+\' \'+tools.dateFromJava(model.startdate)+tools.lang({\'en\':\' till \',\'nl\':\' tot \',\'fr\':\' à \'})+tools.dateFromJava(model.enddate)+\' \'+tools.label(parameters.SLT[slt.id])}}</h4><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><thead><tr><th><span class=th__content>{{tools.lang({\'en\':\'Quantity\',\'nl\':\'Quantity\',\'fr\':\'Quantité\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Dish\',\'nl\':\'Gerecht\',\'fr\':\'Plat\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Category\',\'nl\':\'Categorie\',\'fr\':\'Cat\\u00E9gorie\'})}}</span></th></tr></thead><tbody><tr ng-repeat=\"dsh in model.dishQuantitySums | orderBy:\'toPrepare\':true\"><td>{{dsh.planningquantity}}</td><td><div ng-hide=\"parameters.DSH[dsh.id].field1==\'1\'\">{{tools.label(parameters.DSH[dsh.id])}}</div><div ng-show=\"parameters.DSH[dsh.id].field1==\'1\'\"><span ng-repeat=\"dish in dsh.dishes\">{{dish.quotationtitle}}</span></div></td><td>{{dsh.category}}</td></tr></tbody></table></div></div></div><div class=c-table-view__item ng-repeat=\"hrsList in tools.toArray(model.hrsLists) | orderBy:\'date\'\"><h4 class=c-table-view__title>{{hrsList.date+\' \'+tools.dateToWeekday(hrsList.date)}}</h4><ul class=table-legend><li class=table-legend__item><span class=\"item__circle color-success\"></span> <span class=item__text>{{tools.lang({\'en\':\'Paid\',\'nl\':\'Betaald\',\'fr\':\'Pay\\u00E9\'})}}</span></li><li class=table-legend__item><span class=\"item__circle color-info\"></span> <span class=item__text>{{tools.lang({\'en\':\'Confirmed\',\'nl\':\'Bevestigd\',\'fr\':\'Confirm\\u00E9\'})}}</span></li><li class=table-legend__item><span class=\"item__circle color-default\"></span> <span class=item__text>{{tools.lang({\'en\':\'Uncertain\',\'nl\':\'Onzeker\',\'fr\':\'Incertain\'})}}</span></li></ul><div class=table-responsive-wrapper ng-style=\"{\'overflow\': \'auto\',\'max-height\': model.windowHeight}\"><table class=\"table table-striped table-hover\" style=\"width: 100%; border-collapse: collapse\"><thead style=\"position: sticky;top: 0;left: 0;z-index: 999\"><tr style=\"position: sticky;top: 0;left: 0;z-index: 999;width: 100%\"><th class=\"table__col col--hours\" style=\"position: sticky;top: 0;left: 0;z-index: 999;width: 80px\"><span class=th__content></span></th><th colspan={{model.structuredVisits[hrsList.date].maxUntLoads[unt.id].maxLoad}} ng-repeat=\"unt in getUntList()\" ng-style=\"{\'width\':(model.structuredVisits[hrsList.date].maxUntLoads[unt.id].maxLoad/model.sumLoads[hrsList.date]*100)+\'%\'}\" style=\"position: sticky;top: 0;left: 0;z-index: 999\"><span class=th__content>{{tools.short(tools.first(tools.match(parameters.RES,{\'field1\':unt.id.substr(0,3)})))}}<br>{{tools.label(unt)}}</span></th></tr></thead><tbody><tr ng-repeat=\"hrs in model.structuredVisits[hrsList.date].hrss\" style=width:100%><td class=\"table__col col--hours col--sticky\" style=width:80px>{{hrs.hrs}}</td><td ng-repeat-start=\"loadElement in hrs.loadElements\" ng-show=loadElement.first colspan={{loadElement.colspan}} rowspan={{loadElement.rowspan}} ng-style=\"{\'width\':(loadElement.colspan/model.sumLoads[hrsList.date]*100)+\'%\'}\" style=\"padding: 1px\" ng-mouseenter=\"hover=true;\" ng-mouseleave=\"hover=false\" class=hidden-print>{{visit=loadElement.visit;\"\";}} <button ng-if=!loadElement.addReservation type=button ng-click=\"visit.id!==\'0\'?visitRetrieve(visit.id):\'\';\" class=\"btn btn-100\" style=\"text-align: left;height: 100%; width:100%;justify-content: flex-start; align-items: flex-start; overflow-wrap: break-word;white-space: normal;font-size: 12px\" uib-tooltip-html=loadElement.trustedInfo tooltip-placement=\"auto bottom\" tooltip-popup-delay=750 tooltip-class=info ng-class=\"{\n                        \'btn-success\':loadElement.stat>=3000 && loadElement.stat<9000,\n                        \'btn-info\':loadElement.stat>=2000 && loadElement.stat<3000,\n                        \'btn-danger\':loadElement.stat>=9000,\n                        \'btn-default\':loadElement.stat<2000\n                      }\" ng-bind-html=loadElement.trustedInfo></button> <button ng-if=\"loadElement.addReservation && loadElement.isStartHour && hover\" class=\"btn btn-default hidden-print\" style=\"height: 100%; text-align: center; width:100%\" ng-click=addReservation(loadElement.unt,hrsList.date,hrs.hrs)><span class=material-icons>add</span></button></td><td ng-repeat-end ng-show=loadElement.first colspan={{loadElement.colspan}} rowspan={{loadElement.rowspan}} ng-style=\"{\'width\':(loadElement.colspan/model.sumLoads[hrsList.date]*100)+\'%\',\'border-style\':\'solid\',\'border-width\':loadElement.addReservation?\'0 0 1px 0\':\'1px\',\'border-color\':loadElement.addReservation?\'#dfe5e8\':(loadElement.stat<2000?\'black\':(loadElement.stat<3000?\'lightblue\':(loadElement.stat<9000?\'lightgreen\':\'red\')))}\" style=\"padding: 1px 15px\" class=visible-print><div ng-if=!loadElement.addReservation style=\"text-align: left;height: 100%; width:100%;justify-content: flex-start; align-items: flex-start; overflow-wrap: break-word;white-space: normal;font-size: 12px\" ng-bind-html=loadElement.trustedInfo></div></td></tr></tbody></table></div></div></div><div class=\"content__item page__loader\" ng-show=webservice.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div></div><div class=\"page__actions hidden-md hidden-lg hidden-xl\"><button type=button class=\"btn btn-default\" ng-click=increaseDates(-7);><span class=material-icons style=\"margin-right: -15px\">chevron_left</span> <span class=material-icons>chevron_left</span></button> <button type=button class=\"btn btn-default\" ng-click=increaseDates(-1);><span class=material-icons>chevron_left</span></button> <button type=button class=\"btn btn-default\" style=\"width: auto\" ng-click=todayDate()>{{tools.lang({\'en\':\'Today\',\'nl\':\'Vandaag\',\'fr\':\'Aujourd\\u0027hui\'})}}</button> <button type=button class=\"btn btn-default\" ng-click=increaseDates(1);><span class=material-icons>chevron_right</span></button> <button type=button class=\"btn btn-default\" ng-click=increaseDates(7);><span class=material-icons style=\"margin-right: -15px\">chevron_right</span> <span class=material-icons>chevron_right</span></button></div></main></div>");
$templateCache.put("app/modules/meals/takeAway.html","<div ng-controller=MealsTakeAwayController class=\"page page--tables\"><aside id=filters class=\"page__sidebar sidebar\"><div class=sidebar__header><h4 class=title>{{tools.lang({\'en\':\'Filters\',\'nl\':\'Filters\',\'fr\':\'Filtres\'})}}</h4><button class=\"btn btn-default btn-rounded\"><span class=material-icons ng-click=\"toggleFilters(\'filters\')\">close</span></button></div><div class=sidebar__content><form class=form-horizontal><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Restaurant\',\'nl\':\'Restaurant\',\'fr\':\'Restaurant\'})}}</label><div class=col-sm-10><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"res in parameters.notDelArrayRES | orderBy:\'id\'\" ng-click=selectRes(res.id) ng-class=\"{\'active\':model.ress.indexOf(res.id)>=0}\">{{tools.short(res)}}</button></div></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Selected\',\'nl\':\'Geselecteerd\',\'fr\':\'S\\u00E9lectionn\\u00E9\'})}}</label><div class=col-sm-10><p class=form-control-static ng-hide=\"tools.getLength(model.ress)>0\">{{tools.lang({\'en\':\'All restaurants\',\'nl\':\'Alle restaurants\',\'fr\':\'Toutes les restaurants\'})}}</p><div ng-show=\"tools.getLength(model.ress)>0\"><div class=btn-group><button type=button class=\"btn btn-default active\" ng-repeat=\"res in model.ress | orderBy:\'toString()\'\" ng-click=selectRes(res)><span class=\"material-icons color-primary\">close</span> <span class=btn__text>{{tools.short(parameters.RES[res])}}</span></button></div><button type=button class=\"btn btn-primary mt-1\" ng-click=\"model.ress=[];\">{{tools.lang({\'en\':\'All restaurants\',\'nl\':\'Alle restaurants\',\'fr\':\'Toutes les restaurants\'})}}</button></div></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Preperation Area\',\'nl\':\'Bereidingsplaats\',\'fr\':\'Zone de preparation\'})}}</label><div class=col-sm-10><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"pra in parameters.notDelArrayPRA | orderBy:\'id\'\" ng-click=selectArea(pra.id) ng-class=\"{\'active\':model.areas.indexOf(pra.id)>=0}\">{{tools.short(pra)}}</button></div></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Selected\',\'nl\':\'Geselecteerd\',\'fr\':\'S\\u00E9lectionn\\u00E9\'})}}</label><div class=col-sm-10><p class=form-control-static ng-hide=\"tools.getLength(model.areas)>0\">{{tools.lang({\'en\':\'All areas\',\'nl\':\'Alle plaatsen\',\'fr\':\'Toutes les zones\'})}}</p><div ng-show=\"tools.getLength(model.areas)>0\"><div class=btn-group><button type=button class=\"btn btn-default active\" ng-repeat=\"pra in model.areas | orderBy:\'toString()\'\" ng-click=selectArea(pra)>{{tools.short(parameters.PRA[pra])}}</button></div><button type=button class=\"btn btn-default\" ng-click=\"model.areas=[];\">{{tools.lang({\'en\':\'All areas\',\'nl\':\'Alle plaatsen\',\'fr\':\'Toutes les zones\'})}}</button></div></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\" ng-click=\"model.startdateOpened=!model.startdateOpened\">{{tools.lang({\'en\':\'Start\',\'nl\':\'Start\',\'fr\':\'D\\u00E9but\'})}}</label><div class=col-sm-4><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.startdate is-open=model.startdateOpened datepicker-options=model.dateOptions ng-click=\"model.startdateOpened=!model.startdateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.startdateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><label class=\"col-sm-2 control-label\" ng-click=\"model.enddateOpened=!model.enddateOpened\">{{tools.lang({\'en\':\'End\',\'nl\':\'Einde\',\'fr\':\'Fin\'})}}</label><div class=col-sm-4><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.enddate is-open=model.enddateOpened datepicker-options=model.dateOptions ng-click=\"model.enddateOpened=!model.enddateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.enddateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'From\',\'nl\':\'Van\',\'fr\':\'de\'})}}</label><div class=col-sm-4><select class=form-control ng-model=model.startHrs ng-options=\"hrs.id as tools.label(hrs) for hrs in tools.addElement(parameters.notDelHRS,any)\"></select></div><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'To\',\'nl\':\'Tot\',\'fr\':\'a\'})}}</label><div class=col-sm-4><select class=form-control ng-model=model.endHrs ng-options=\"hrs.id as tools.label(hrs) for hrs in tools.addElement(parameters.notDelHRS,any)\"></select><div class=btn-group></div></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Filter\',\'nl\':\'Filter\',\'fr\':\'Filtre\'})}}</label><div class=col-sm-4><input type=text class=form-control ng-model=model.filter></div><label class=col-sm-3 style=\"margin-top: 16px\"><input type=checkbox ng-model=model.showZero> {{tools.lang({\'en\':\'Show zero participants\',\'nl\':\'Toon nul deelnemers\',\'fr\':\'Montrer zero participants\'})}}</label></div></form></div><div class=sidebar__footer><button type=submit class=\"btn btn-primary\" ng-click=\"load(); toggleFilters(\'filters\');\">{{tools.lang({\'en\':\'Done\',\'nl\':\'Done\',\'fr\':\'Appliquer\'})}}</button></div></aside><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\':\'Take Away\',\'nl\':\'Take Away\',\'fr\':\'Take Away\'})}}</h1><div class=header__actions><div class=\"page__actions hidden-xs hidden-sm\"><button type=button class=\"btn btn-default\" ng-click=increaseDates(-1);><span class=material-icons>chevron_left</span></button> <span class=h5>{{tools.lang({\'en\':\'Day\',\'nl\':\'Day\',\'fr\':\'Jour\'})}}</span> <button type=button class=\"btn btn-default\" ng-click=increaseDates(1);><span class=material-icons>chevron_right</span></button></div><button class=\"btn btn-default btn-filters\" ng-click=\"toggleFilters(\'filters\')\"><i class=material-icons>filter_list</i> <span class=\"btn__text hidden-xs hidden-sm\">{{tools.lang({\'en\':\'Filters\',\'nl\':\'Filters\',\'fr\':\'Filtres\'})}}</span></button> <button class=\"btn btn-primary\" ng-click=\"tools.redirect(buildHref(\'activities\',\'createForTakeAway\'))\">{{tools.lang({\'en\':\'Add\',\'nl\':\'Reservatie\',\'fr\':\'Créer\'})}}</button></div></section><div class=content><div class=\"content__item c-table-view\" ng-hide=webservice.calling><div class=c-table-view__item ng-repeat=\"date in model.dates | orderBy:\'id\':false\"><h4 class=c-table-view__title>{{date.id+\' \'+tools.dateToWeekday(date.id)+\' \'+tools.label(parameters.SLT[slt.id])}}</h4><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><thead><tr><th ng-show=model.showResLabel><span class=th__content>{{tools.lang({\'en\':\'Restaurant\',\'nl\':\'Restaurant\',\'fr\':\'Restaurant\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Hour\',\'nl\':\'Uur\',\'fr\':\'Heure\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Name\',\'nl\':\'Naam\',\'fr\':\'Nom\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'# Dishes\',\'nl\':\'# Gerechten\',\'fr\':\'# Plats\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Comment\',\'nl\':\'Opmerking\',\'fr\':\'Remarque\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Delivery\',\'nl\':\'Levering\',\'fr\':\'Livraison\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Payment\',\'nl\':\'Payment\',\'fr\':\'Paiement\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Status\',\'nl\':\'Status\',\'fr\':\'Statut\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Print\',\'nl\':\'Print\',\'fr\':\'Imprimer\'})}}</span></th></tr></thead><tbody><tr ng-show=\"model.filter==\'\'\"><td colspan={{(model.showResLabel)?3:4}}></td><td><b>{{tools.sum(tools.inverseJoin(tools.join(date.meals,\'dishes\',model),\'items\',\'item\',model),\'planningquantity\')}}</b></td><td></td><td><input refresh ng-disabled=webservice.calling ng-click=load();></td><td colspan=2></td><td><form ng-show=\"overallStat(date.meals)==1000\" action={{model.action}} name=meals autocomplete=off method=post target=_blank><input type=hidden name=params value={{getMealsWsParams(date.meals)}}> <button type=submit class=\"btn btn-default\"><span class=material-icons>print</span> <span class=btn__text>{{tools.lang({\'en\':\'All tickets\',\'nl\':\'Alles tickets\',\'fr\':\'Tous les tickets\'})}}</span></button></form></td></tr><tr ng-repeat=\"meal in getMeals(date.meals) | orderBy:\'hrs\'\"><td ng-click=visitRetrieve(meal.visit) ng-show=model.showResLabel>{{tools.label(parameters.RES[meal.res])}}</td><td ng-click=visitRetrieve(meal.visit)>{{tools.label(parameters.HRS[meal.hrs])}}</td><td ng-click=visitRetrieve(meal.visit)>{{contactsService.getName(model.contacts[model.visits[meal.visit].owningcontact])}}</td><td><div ng-hide=meal.editing ng-repeat=\"dish in tools.join(meal,\'dishes\',model)\">{{tools.amountOut(model.items[dish.item].planningquantity)}} <span ng-hide=\"parameters.DSH[dish.dsh].field1==\'1\'\">{{tools.label(parameters.DSH[dish.dsh])}} </span><span ng-show=\"parameters.DSH[dish.dsh].field1==\'1\'\">{{dish.quotationtitle}}</span></div></td><td><span ng-hide=meal.editing>{{meal.comment}} <input class=\"btn btn-rounded btn btn-default\" edit ng-click=editComment(meal)> </span><span ng-show=meal.editing><form><input type=text class=form-control ng-model=meal.comment> <input class=\"btn btn-success\" update ng-click=updateComment(meal)> <input class=\"btn btn-warning\" cancel ng-click=cancelComment(meal)></form></span></td><td ng-click=visitRetrieve(meal.visit)><span ng-show=\"meal.delivery==\'1\'\">{{model.visits[meal.visit].address1+\' \'+model.visits[meal.visit].postalcode+\' \'+model.visits[meal.visit].address2}}</span></td><td ng-click=visitRetrieve(meal.visit)>{{tools.label(parameters.STV[this.tools.expandDigits(model.visits[meal.visit].stat,4)])}}</td><td><div ng-show=\"overallStat(tools.join(meal,\'dishes\',model))==1000\"><button type=button class=\"btn btn-success\" ng-click=\"updateDishStat(tools.join(meal,\'dishes\',model),\'4000\')\"><span class=btn__text>{{tools.lang({\'en\':\'Done\',\'nl\':\'Done\',\'fr\':\'Valider\'})}}</span></button></div><div ng-hide=\"overallStat(tools.join(meal,\'dishes\',model))==1000\">{{tools.label(parameters.STD[this.tools.expandDigits(overallStat(tools.join(meal,\'dishes\',model)),4)])}} <button type=button class=\"btn btn-warning\" ng-click=\"updateDishStat(tools.join(meal,\'dishes\',model),\'1000\')\"><span class=btn__text>{{tools.lang({\'en\':\'Reset\',\'nl\':\'Reset\',\'fr\':\'Réinitialiser\'})}}</span></button></div></td><td><form ng-show=\"meal.stat==1000\" action={{model.action}} name=meals autocomplete=off method=post target=_blank><input type=hidden name=params value={{getMealsWsParams(meal)}}> <button type=submit class=\"btn btn-default\"><span class=material-icons>print</span></button></form><form ng-hide=\"meal.stat==1000\" action={{model.action}} name=proforma autocomplete=off method=post target=_blank><input type=hidden name=params value={{getProformaWsParams(meal)}}> <button type=submit class=\"btn btn-success\" update></button></form></td></tr></tbody></table></div><h4 class=c-table-view__title>{{tools.lang({\'en\':\'List of totals for Dishes for\',\'nl\':\'Overzicht totalen per Gerecht voor\',\'fr\':\'Liste des totales par Plat pour\'})+\' \'+date.id+\' \'+tools.dateToWeekday(date.id)+\' \'+tools.label(parameters.SLT[slt.id])}}</h4><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><thead><tr><th ng-show=\"model.areas.length==0\"><span class=th__content>{{tools.label({\"labelen\":\"Preparation Area\",\"labelnl\":\"Bereidingsplaats\",\"labelfr\":\"Zone de preparation\"})}}</span></th><th><span class=th__content>{{\'#\'}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Dish\',\'nl\':\'Gerecht\',\'fr\':\'Plat\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'To prepare\',\'nl\':\'Nog te bereiden\',\'fr\':\'À préparer\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Status\',\'nl\':\'Status\',\'fr\':\'Statut\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Print\',\'nl\':\'Print\',\'fr\':\'Imprimer\'})}}</span></th></tr></thead><tbody><tr ng-repeat=\"dsh in tools.toArray(date.dshs) | orderBy:\'toPrepare\':true\"><td ng-show=\"model.areas.length==0\"><span ng-repeat=\"pra in parameters.DSH[dsh.id].field3.split(\'***\')\">{{tools.label(parameters.PRA[pra])}}</span></td><td>{{dsh.planningquantity}}</td><td><div ng-hide=\"parameters.DSH[dsh.id].field1==\'1\'\">{{tools.label(parameters.DSH[dsh.id])}}</div><div ng-show=\"parameters.DSH[dsh.id].field1==\'1\'\"><span ng-repeat=\"dish in dsh.dishes\">{{dish.quotationtitle}}</span></div></td><td>{{dsh.toPrepare}}</td><td><div ng-show=\"overallStat(dsh.dishes)==1000\"><button type=button class=\"btn btn-success\" ng-click=\"updateDishStat(dsh.dishes,\'4000\')\"><span class=btn__text>{{tools.lang({\'en\':\'Done\',\'nl\':\'Done\',\'fr\':\'Valider\'})}}</span></button></div><div ng-hide=\"overallStat(dsh.dishes)==1000\">{{tools.label(parameters.STD[this.tools.expandDigits(overallStat(dsh.dishes),4)])}} <button type=button class=\"btn btn-warning\" ng-click=\"updateDishStat(dsh.dishes,\'1000\')\"><span class=btn__text>{{tools.lang({\'en\':\'Reset\',\'nl\':\'Reset\',\'fr\':\'Réinitialiser\'})}}</span></button></div></td><td><form action={{model.action}} name=dishes autocomplete=off method=post target=_blank><input type=hidden name=params value={{getDshsWsParams(date.dshs)}}> <button type=submit class=\"btn btn-default\"><span class=material-icons>print</span></button></form></td></tr></tbody></table></div></div></div></div><div class=page__actions><button type=button class=\"btn btn-default\" ng-click=increaseDates(-1);><span class=material-icons>chevron_left</span></button> <span class=h5>{{tools.lang({\'en\':\'Day\',\'nl\':\'Day\',\'fr\':\'Jour\'})}}</span> <button type=button class=\"btn btn-default\" ng-click=increaseDates(1);><span class=material-icons>chevron_right</span></button></div></main></div>");
$templateCache.put("app/modules/meals/updates.html","<div ng-controller=MealsUpdatesController class=\"page page-meals-updates page--content\"><form class=form-horizontal><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Restaurant\',\'nl\':\'Restaurant\',\'fr\':\'Restaurant\'})}}</label><div class=col-sm-10><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"res in parameters.notDelArrayRES | orderBy:\'id\'\" ng-click=selectRes(res.id) ng-class=\"{\'active\':model.ress.indexOf(res.id)>=0}\">{{tools.short(res)}}</button></div></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Selected\',\'nl\':\'Geselecteerd\',\'fr\':\'S\\u00E9lectionn\\u00E9\'})}}</label><div class=col-sm-10><p class=form-control-static ng-hide=\"tools.getLength(model.ress)>0\">{{tools.lang({\'en\':\'All restaurants\',\'nl\':\'Alle restaurants\',\'fr\':\'Toutes les restaurants\'})}}</p><div ng-show=\"tools.getLength(model.ress)>0\"><div class=btn-group><button type=button class=\"btn btn-default active\" ng-repeat=\"res in model.ress | orderBy:\'toString()\'\" ng-click=selectRes(res)><span class=\"material-icons color-primary\">close</span> <span class=btn__text>{{tools.short(parameters.RES[res])}}</span></button></div><button type=button class=\"btn btn-primary mt-1\" ng-click=\"model.ress=[];\">{{tools.lang({\'en\':\'All restaurants\',\'nl\':\'Alle restaurants\',\'fr\':\'Toutes les restaurants\'})}}</button></div></div></div><div class=\"form-group clearfix\"><div class=\"col-sm-offset-2 col-sm-10\"><span ng-hide=webservice.calling><button type=submit class=\"btn btn-primary\" ng-click=load();>{{tools.lang({\'en\':\'Show\',\'nl\':\'Tonen\',\'fr\':\'Montrer\'})}}</button> </span><span ng-show=webservice.calling>Loading...</span></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Filter\',\'nl\':\'Filter\',\'fr\':\'Filtre\'})}}</label><div class=col-sm-4><input type=text class=form-control ng-model=model.filter></div><label class=col-sm-6><input type=checkbox ng-model=model.showZero> {{tools.lang({\'en\':\'Show zero participants\',\'nl\':\'Toon nul deelnemers\',\'fr\':\'Montrer zero participants\'})}}</label></div></form><div ng-repeat=\"date in model.dates | orderBy:\'id\':false\"><h4>{{date.id+\' \'+tools.dateToWeekday(date.id)+\' \'+tools.label(parameters.SLT[slt.id])}}</h4><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><thead><tr><th><span class=th__content></span></th><th ng-show=model.showResLabel>{{tools.lang({\'en\':\'Restaurant\',\'nl\':\'Restaurant\',\'fr\':\'Restaurant\'})}}</th><th><span class=th__content>{{tools.lang({\'en\':\'Hour\',\'nl\':\'Uur\',\'fr\':\'Heure\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Name\',\'nl\':\'Naam\',\'fr\':\'Nom\'})}}</span></th><th><span class=th__content></span></th><th><span class=th__content>{{tools.lang({\'en\':\'Status\',\'nl\':\'Status\',\'fr\':\'Statut\'})}}</span></th><th>{{tools.lang({\'en\':\'Updated\',\'nl\':\'Update\',\'fr\':\'Update\'})}}</th><th><span class=th__content></span></th></tr></thead><tbody><tr ng-show=\"model.filter==\'\'\"><td colspan=4></td><td><b>{{tools.sum(tools.inverseJoin(tools.join(date.meals,\'dishes\',model),\'items\',\'item\',model),\'planningquantity\')}}</b></td><td colspan=3></td></tr><tr ng-repeat=\"meal in getMeals(date.meals) | orderBy:\'mea\'\"><td><input retrieve ng-click=visitRetrieve(meal.visit)></td><td ng-show=model.showResLabel>{{tools.label(parameters.RES[meal.res])}}</td><td>{{tools.label(parameters.HRS[meal.hrs])}}</td><td>{{model.visits[meal.visit].name}}</td><td><div ng-repeat=\"dish in tools.join(meal,\'dishes\',model)\">{{tools.amountOut(model.items[dish.item].planningquantity)}} <span ng-hide=\"parameters.DSH[dish.dsh].field1==\'1\'\">{{tools.label(parameters.DSH[dish.dsh])}} </span><span ng-show=\"parameters.DSH[dish.dsh].field1==\'1\'\">{{dish.quotationtitle}}</span></div></td><td>{{tools.label(parameters.STV[this.tools.expandDigits(model.visits[meal.visit].stat,4)])}}</td><td>{{tools.doneBy(getMaxUpdated(meal).updated,getMaxUpdated(meal).updater_name)}}</td><td><button type=button class=\"btn btn-default\" ng-click=updateChecked(meal)>{{tools.lang({\'en\':\'Checked\',\'nl\':\'Checked\',\'fr\':\'Checked\'})}}</button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/modules/paramtables/combinationList.html","<div ng-controller=ParamtablesCombinationListController class=\"page page-paramtables-combinationlist page--content\"><div><span>{{tools.lang({\'en\':\'Combination\',\'nl\':\'Combinatie\',\'fr\':\'Combination\'})}}:</span><select ng-model=model.combination ng-change=changeCombination() ng-options=\"comb.id as tools.label(comb) for comb in tools.toArray(model.combinations)\"></select></div><div ng-show=model.combination><div ng-show=model.filter1Table><span>{{tools.lang({\'en\':\'Filter\',\'nl\':\'Filter\',\'fr\':\'Filter\'})+\' \'+tools.label(model.parameters[model.filter1Table])}}:</span><select ng-model=model.filter1 ng-change=buildValues(); ng-options=\"par.id as tools.label(par) for par in tools.toArray(parameters[\'notDel\'+model.filter1Table])\"></select></div><div ng-show=model.hasId3><span>{{tools.label(model.parameters[model.paramNameZ])}}:</span><select ng-model=model.id3 ng-change=buildValues(); ng-options=\"par.id as tools.label(par) for par in tools.toArray(parameters[\'notDel\'+model.paramNameZ])\"></select></div><div class=table-responsive-wrapper><table class=table style=\"border-collapse: separate; border-spacing: 0\" ng-show=\"(!model.filter1Table || model.filter1!=\'\') && (!model.hasId3 || model.id3!=\'\')\"><thead><tr><th style=\"position: sticky;z-index: 2;top: -16px;left: -16px;background-color:#f6f6f7\"><span class=th__content></span></th><th style=\"position: sticky;z-index: 1;top: -16px;background-color:#f6f6f7\" ng-repeat=\"paramxRow in model.paramsx\" ng-show=\"!(model.paramNameX==model.paramNameZ && model.hasId3 && model.id3==paramxRow.id)\">{{tools.label(paramxRow)}}</th></tr></thead><tbody><tr ng-repeat=\"paramyRow in model.paramsy\" ng-class=\"{\'last\':$last}\" ng-class-even=\"\'even\'\" ng-class-odd=\"\'odd\'\" ng-show=\"!(model.paramNameY==model.paramNameZ && model.hasId3 && model.id3==paramyRow.id)\"><td style=\"position: sticky;z-index: 1;left: -16px\">{{paramyRow.id+\" \"+tools.label(paramyRow)}}</td><td ng-repeat=\"paramxRow in model.paramsx\" ng-class=\"{\'hasCombination\':model.isBoolean && model.values[paramyRow.id][paramxRow.id]}\" style=height:51px;min-width:60px ng-mouseenter=enterCell(paramyRow.id,paramxRow.id) ng-mouseleave=leaveCell() ng-click=startNonBooleanEdit(paramyRow.id,paramxRow.id);><span ng-if=\"model.isBoolean && (model.paramNameY!=model.paramNameX || paramyRow.id!=paramxRow.id) && model.hover==paramyRow.id+paramxRow.id\"><input class=\"btn btn-warning\" cancel ng-click=deleteCombination(paramyRow.id,paramxRow.id); ng-show=showButton(paramyRow.id,paramxRow.id,false)> <input create ng-click=replaceCombination(paramyRow.id,paramxRow.id); ng-show=showButton(paramyRow.id,paramxRow.id,true)> </span><span ng-if=\"!model.isBoolean && (model.paramNameY!=model.paramNameX || paramyRow.id!=paramxRow.id)\"><span ng-if=\"!(isEditing(paramyRow.id,paramxRow.id) && model.selectedCell==paramyRow.id+paramxRow.id)\">{{model.values[paramyRow.id][paramxRow.id]}}</span> <input ng-if=\"isEditing(paramyRow.id,paramxRow.id) && model.selectedCell==paramyRow.id+paramxRow.id\" ng-model=model.editingValue ng-enter=\"updateNonBoolean(paramyRow.id,paramxRow.id);model.editing1=null;model.editing2=null;\"></span></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/modules/paramtables/paramList.html","<div ng-controller=ParamtablesParamListController class=\"page page-paramtables-paramlist page--content\"><div class=\"form-group clearfix\"><div class=col-sm-12><label class=label-controler>{{tools.lang({\'en\':\'Parameter table\',\'nl\':\'Parameter tabel\',\'fr\':\'Table param\\u00E8tres\'})}}:</label><select ng-model=model.tbl ng-change=changeTbl(); ng-options=\"tbl.id as tools.label(tbl) for tbl in tools.toArray(model.paramheaders) | orderBy:orderTbl\"></select></div><div class=col-sm-12><label class=label-controler>{{tools.lang({\'en\':\'Filter\',\'nl\':\'Filter\',\'fr\':\'Filtrer\'})}}:</label><select ng-model=model.filter ng-change=changeFilter();calculateRows(); ng-options=\"key as value for (key,value) in model.filterFields\"></select><input ng-show=\"model.filter!=\'none\'\" type=text class=form-control ng-model=model.filterValue ng-change=calculateRows();></div><div class=col-sm-12>&nbsp;<div class=checkbox><label style=font-weight:normal><input type=checkbox ng-model=model.showDeleted ng-change=calculateRows()> {{tools.lang({\'en\':\'Show deleted\',\'nl\':\'Toon verwijderde\',\'fr\':\'Voir supprimés\'})}}</label></div></div></div><ul uib-pagination boundary-links=true total-items=model.totalItems items-per-page=model.itemsPerPage ng-model=model.page class=pagination-sm previous-text=&lsaquo; next-text=&rsaquo; first-text=&laquo; last-text=&raquo;></ul><div class=table-responsive-wrapper><table class=table><thead><tr><th><span class=th__content></span></th><th>{{tools.lang({\'en\':\'Argument\',\'nl\':\'Argument\',\'fr\':\'Argument\'})}}</th><th ng-show=model.showDeleted>Del</th><th>En name</th><th>Nl naam</th><th>Nom Fr</th><th ng-show=model.header.short>En short</th><th ng-show=model.header.short>Nl kort</th><th ng-show=model.header.short>Fr court</th><th ng-show=model.header.field1>{{model.header.field1}}</th><th ng-show=model.header.field2>{{model.header.field2}}</th><th ng-show=model.header.field3>{{model.header.field3}}</th><th ng-show=model.header.field4>{{model.header.field4}}</th><th ng-show=model.header.field5>{{model.header.field5}}</th><th ng-show=model.header.field6>{{model.header.field6}}</th><th ng-show=model.header.field7>{{model.header.field7}}</th><th ng-show=model.header.field8>{{model.header.field8}}</th><th ng-show=model.header.field9>{{model.header.field9}}</th><th ng-show=model.header.field10>{{model.header.field10}}</th><th ng-show=model.header.field11>{{model.header.field11}}</th><th ng-show=model.header.field12>{{model.header.field12}}</th><th ng-show=model.header.field13>{{model.header.field13}}</th><th ng-show=model.header.field14>{{model.header.field14}}</th><th ng-show=model.header.field15>{{model.header.field15}}</th><th ng-show=model.header.field16>{{model.header.field16}}</th><th class=right></th></tr></thead><tbody><tr ng-repeat=\"paramRow in tools.startFrom(model.rows,(model.page-1)*model.itemsPerPage) | limitTo:model.itemsPerPage | orderBy:\'id\'\" ng-class=\"{\'last\':$last}\" ng-class-even=\"\'even\'\" ng-class-odd=\"\'odd\'\"><td><input ng-hide=paramRow.editing edit ng-click=edit(paramRow)></td><td>{{paramRow.id}}</td><td ng-show=model.showDeleted><span editable editing={{paramRow.editing}} retrieving={{paramRow.del}}><input type=text size=1 ng-model=paramRow.del></span></td><td><span editable editing={{paramRow.editing}} retrieving={{paramRow.labelen}}><input type=text size=8 ng-model=paramRow.labelen></span></td><td><span editable editing={{paramRow.editing}} retrieving={{paramRow.labelnl}}><input type=text size=8 ng-model=paramRow.labelnl></span></td><td><span editable editing={{paramRow.editing}} retrieving={{paramRow.labelfr}}><input type=text size=8 ng-model=paramRow.labelfr></span></td><td ng-show=model.header.short><span editable editing={{paramRow.editing}} retrieving={{paramRow.shorten}}><input type=text size=8 ng-model=paramRow.shorten></span></td><td ng-show=model.header.short><span editable editing={{paramRow.editing}} retrieving={{paramRow.shortnl}}><input type=text size=8 ng-model=paramRow.shortnl></span></td><td ng-show=model.header.short><span editable editing={{paramRow.editing}} retrieving={{paramRow.shortfr}}><input type=text size=8 ng-model=paramRow.shortfr></span></td><td ng-show=model.header.field1><span editable editing={{paramRow.editing}} retrieving={{paramRow.field1}}><input type=text size=8 ng-model=paramRow.field1></span></td><td ng-show=model.header.field2><span editable editing={{paramRow.editing}} retrieving={{paramRow.field2}}><input type=text size=8 ng-model=paramRow.field2></span></td><td ng-show=model.header.field3><span editable editing={{paramRow.editing}} retrieving={{paramRow.field3}}><input type=text size=8 ng-model=paramRow.field3></span></td><td ng-show=model.header.field4><span editable editing={{paramRow.editing}} retrieving={{paramRow.field4}}><input type=text size=8 ng-model=paramRow.field4></span></td><td ng-show=model.header.field5><span editable editing={{paramRow.editing}} retrieving={{paramRow.field5}}><input type=text size=8 ng-model=paramRow.field5></span></td><td ng-show=model.header.field6><span editable editing={{paramRow.editing}} retrieving={{paramRow.field6}}><input type=text size=8 ng-model=paramRow.field6></span></td><td ng-show=model.header.field7><span editable editing={{paramRow.editing}} retrieving={{paramRow.field7}}><input type=text size=8 ng-model=paramRow.field7></span></td><td ng-show=model.header.field8><span editable editing={{paramRow.editing}} retrieving={{paramRow.field8}}><input type=text size=8 ng-model=paramRow.field8></span></td><td ng-show=model.header.field9><span editable editing={{paramRow.editing}} retrieving={{paramRow.field9}}><input type=text size=8 ng-model=paramRow.field9></span></td><td ng-show=model.header.field10><span editable editing={{paramRow.editing}} retrieving={{paramRow.field10}}><input type=text size=8 ng-model=paramRow.field10></span></td><td ng-show=model.header.field11><span editable editing={{paramRow.editing}} retrieving={{paramRow.field11}}><input type=text size=8 ng-model=paramRow.field11></span></td><td ng-show=model.header.field12><span editable editing={{paramRow.editing}} retrieving={{paramRow.field12}}><input type=text size=8 ng-model=paramRow.field12></span></td><td ng-show=model.header.field13><span editable editing={{paramRow.editing}} retrieving={{paramRow.field13}}><input type=text size=8 ng-model=paramRow.field13></span></td><td ng-show=model.header.field14><span editable editing={{paramRow.editing}} retrieving={{paramRow.field14}}><input type=text size=8 ng-model=paramRow.field14></span></td><td ng-show=model.header.field15><span editable editing={{paramRow.editing}} retrieving={{paramRow.field15}}><input type=text size=8 ng-model=paramRow.field15></span></td><td ng-show=model.header.field16><span editable editing={{paramRow.editing}} retrieving={{paramRow.field16}}><input type=text size=8 ng-model=paramRow.field16></span></td><td><span ng-show=paramRow.editing><input class=\"btn btn-success\" update ng-click=paramUpdate(paramRow);> <input class=\"btn btn-warning\" cancel ng-click=calculateRows();></span></td></tr><tr ng-show=\"model.rows.length > 0\"><th><span class=th__content></span></th><th>{{tools.lang({\'en\':\'Argument\',\'nl\':\'Argument\',\'fr\':\'Argument\'})}}</th><th ng-show=model.showDeleted></th><th>En name</th><th>Nl naam</th><th>Nom Fr</th><th ng-show=model.header.short>En short</th><th ng-show=model.header.short>Nl kort</th><th ng-show=model.header.short>Fr court</th><th ng-show=model.header.field1>{{model.header.field1}}</th><th ng-show=model.header.field2>{{model.header.field2}}</th><th ng-show=model.header.field3>{{model.header.field3}}</th><th ng-show=model.header.field4>{{model.header.field4}}</th><th ng-show=model.header.field5>{{model.header.field5}}</th><th ng-show=model.header.field6>{{model.header.field6}}</th><th ng-show=model.header.field7>{{model.header.field7}}</th><th ng-show=model.header.field8>{{model.header.field8}}</th><th ng-show=model.header.field9>{{model.header.field9}}</th><th ng-show=model.header.field10>{{model.header.field10}}</th><th ng-show=model.header.field11>{{model.header.field11}}</th><th ng-show=model.header.field12>{{model.header.field12}}</th><th ng-show=model.header.field13>{{model.header.field13}}</th><th ng-show=model.header.field14>{{model.header.field14}}</th><th ng-show=model.header.field15>{{model.header.field15}}</th><th ng-show=model.header.field16>{{model.header.field16}}</th><th class=right></th></tr><tr ng-show=\"tbl!=\'\'\"><td></td><td><input type=text size=8 ng-model=model.param.id></td><td ng-show=model.showDeleted></td><td><input type=text size=8 ng-model=model.param.labelen></td><td><input type=text size=8 ng-model=model.param.labelnl></td><td><input type=text size=8 ng-model=model.param.labelfr></td><td ng-show=model.header.short><input type=text size=8 ng-model=model.param.shorten></td><td ng-show=model.header.short><input type=text size=8 ng-model=model.param.shortnl></td><td ng-show=model.header.short><input type=text size=8 ng-model=model.param.shortfr></td><td ng-show=model.header.field1><input type=text size=8 ng-model=model.param.field1></td><td ng-show=model.header.field2><input type=text size=8 ng-model=model.param.field2></td><td ng-show=model.header.field3><input type=text size=8 ng-model=model.param.field3></td><td ng-show=model.header.field4><input type=text size=8 ng-model=model.param.field4></td><td ng-show=model.header.field5><input type=text size=8 ng-model=model.param.field5></td><td ng-show=model.header.field6><input type=text size=8 ng-model=model.param.field6></td><td ng-show=model.header.field7><input type=text size=8 ng-model=model.param.field7></td><td ng-show=model.header.field8><input type=text size=8 ng-model=model.param.field8></td><td ng-show=model.header.field9><input type=text size=8 ng-model=model.param.field9></td><td ng-show=model.header.field10><input type=text size=8 ng-model=model.param.field10></td><td ng-show=model.header.field11><input type=text size=8 ng-model=model.param.field11></td><td ng-show=model.header.field12><input type=text size=8 ng-model=model.param.field12></td><td ng-show=model.header.field13><input type=text size=8 ng-model=model.param.field13></td><td ng-show=model.header.field14><input type=text size=8 ng-model=model.param.field14></td><td ng-show=model.header.field15><input type=text size=8 ng-model=model.param.field15></td><td ng-show=model.header.field16><input type=text size=8 ng-model=model.param.field16></td><td><input create ng-click=paramCreate();></td></tr></tbody></table></div></div>");
$templateCache.put("app/modules/quotations/createQuotation.html","<div ng-controller=QuotationsCreateQuotationController class=\"page page-activities-create-for-b2b page--content\"><div ng-include=\"\'app/modules/activities/createForEmp.html\'\"></div></div>");
$templateCache.put("app/modules/quotations/listInvoicesManagers.html","<div ng-controller=InvoicesListManagersController class=\"page page--content page-quotations-list-invoices-managers\"><form class=form-horizontal><div class=\"form-group clearfix\"><div class=\"col-sm-6 col-sm-offset-2\"></div></div><div class=\"form-group clearfix\"><label class=\"col-xs-12 col-sm-2 control-label\">{{tools.lang({\'en\':\'Show\',\'nl\':\'Toon\',\'fr\':\'Montrer\'})}}</label><div class=col-sm-6><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"par in model.filterModes | orderBy:\'id\'\" ng-click=\"model.filterMode=par.id;load();\" ng-class=\"{\'active\':model.filterMode==par.id}\">{{tools.label(par)}}</button></div></div><div class=col-sm-4><input refresh ng-disabled=webservice.calling ng-click=load();> <span ng-show=webservice.calling>loading...</span> <button type=button class=\"btn btn-default\" ng-disabled=webservice.calling ng-click=recalculateMismatch();>{{tools.lang({\'en\':\'Recalculate mismatch index\',\'nl\':\'Herbereken mismatch index\',\'fr\':\'Recalculer mismatch index\'})}}</button></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\" ng-click=\"model.enddateOpened=!model.enddateOpened\">{{tools.lang({\'en\':\'Until\',\'nl\':\'Tot\',\'fr\':\'\\u00C0\'})}}</label><div class=col-sm-4><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.enddate is-open=model.enddateOpened datepicker-options=model.dateOptions ng-click=\"model.enddateOpened=!model.enddateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.enddateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"form-group clearfix\"><label class=\"col-xs-2 control-label\">{{tools.lang({\'en\':\'Segment\',\'nl\':\'Segment\',\'fr\':\'Segment\'})}}</label><div class=col-xs-10><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"segment in [\'B2B\',\'B2C\']\" ng-click=\"model.segment=segment;load();\" ng-class=\"{\'active\':model.segment==segment}\">{{segment}}</button></div></div></div><div class=\"form-group clearfix\"><label class=\"col-xs-2 control-label\">{{tools.lang({\'en\':\'Division\',\'nl\':\'Afdeling\',\'fr\':\'Division\'})}}</label><div class=col-xs-10><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"dvs in tools.match(parameters.notDelArrayDVS,{\'field5\':\'1\'}) | orderBy:\'label\'+user.lang\" ng-click=\"model.dvs=dvs.id;load();\" ng-class=\"{\'active\':model.dvs==dvs.id}\">{{tools.short(dvs)}}</button></div></div></div><div class=\"form-group clearfix\" ng-show=\"model.segment==\'B2B\'\"><label for=invoicesmanager class=\"col-xs-12 col-sm-2 control-label\">{{tools.lang({\'en\':\'Assigned to\',\'nl\':\'Toegewezen aan\',\'fr\':\'Attribu\\u00E9 à\'})}}</label><div class=\"col-xs-6 col-sm-2\"><button class=\"btn btn-default btn-100\" ng-click=\"model.invoicesmanager=user.id;load();\" ng-class=\"{\'active\':model.invoicesmanager==user.id}\">{{user.name}}</button></div><div class=\"col-xs-6 col-sm-6\"><select id=invoicesmanager class=form-control ng-model=model.invoicesmanager ng-options=\"user.id as user.name for user in tools.addElement(tools.addElement(tools.filterUserOnRight(model,\'INVM\'),anyUser),nonUser) | orderBy:\'id\'\" ng-change=load();></select></div></div></form><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\" ng-hide=webservice.calling><thead><tr><th><span class=th__content></span></th><th><span class=th__content>{{tools.lang({\'en\':\'Group\',\'nl\':\'Groep\',\'fr\':\'Groupe\'})}} - {{tools.lang({\'en\':\'Contact\',\'nl\':\'Contact\',\'fr\':\'Contact\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Language\',\'nl\':\'Taal\',\'fr\':\'Langue\'})}}</span></th><th ng-show=\"model.invoicesmanager==\'\' && model.segment==\'B2B\'\">{{tools.lang({\'en\':\'Invoices manager\',\'nl\':\'Facturatie verantwoordelijke\',\'fr\':\'Responsable facturation\'})}}</th><th ng-show=\"model.segment==\'B2B\'\">{{tools.lang({\'en\':\'Sales manager\',\'nl\':\'Verkoper\',\'fr\':\'Vendeur\'})}} -<br>{{tools.lang({\'en\':\'Operations manager\',\'nl\':\'Uitvoerings verantwoordelijke\',\'fr\':\'Responsable dossier\'})}}</th><th ng-show=\"model.segment==\'B2C\'\">{{tools.lang({\'en\':\'Accommodation\',\'nl\':\'Accommodation\',\'fr\':\'Logement\'})}}</th><th><span class=th__content><button class=\"btn btn-default\" ng-class=\"{\'active\':model.ordering==\'startdate\'}\" ng-click=\"changeOrdering(\'startdate\')\">{{tools.lang({\'en\':\'Visit\',\'nl\':\'Bezoek\',\'fr\':\'Visite\'})}} <span ng-show=\"model.ordering==\'startdate\'\"><span ng-show=model.reverse class=\"glyphicon glyphicon-chevron-up\"></span> <span ng-hide=model.reverse class=\"glyphicon glyphicon-chevron-down\"></span></span></button></span></th><th>{{tools.lang({\'en\':\'Non-facturated amount\',\'nl\':\'Ongefactureerd bedrag\',\'fr\':\'Montant non-facture\'})}}</th><th>{{tools.lang({\'en\':\'Unpayed invoiced amount\',\'nl\':\'Onbetaald gefactureerd bedrag\',\'fr\':\'Montant factur\\u00E9 impay\\u00E9\'})}}</th><th>{{tools.lang({\'en\':\'Payed amount\',\'nl\':\'Betaald bedrag\',\'fr\':\'Montant pay\\u00E9\'})}}</th><th>{{tools.lang({\'en\':\'Total\',\'nl\':\'Totaal\',\'fr\':\'Total\'})}}</th></tr></thead><tbody><tr ng-repeat=\"visit in tools.toArray(model.visits) | orderBy:model.ordering:model.reverse\" ng-class=\"{\'warning\':tools.getLength(tools.greater(visit.messages,\'created\',visit.created))==0}\"><td><input retrieve ng-click=visitRetrieve(visit.id);></td><td>{{contactsService.getName(model.contacts[visit.owningcontact])}} <span ng-show=\"model.contacts[visit.owningcontact].iscompany==\'1\'\">- {{contactsService.getName(model.contacts[visit.communicationcontact])}}</span></td><td>{{model.contacts[visit.owningcontact].lang}}</td><td ng-show=\"model.invoicesmanager==\'\' && model.segment==\'B2B\'\">{{model.users[visit.invoicesmanager!=\'0\'?visit.invoicesmanager:visit.creator].name}}</td><td ng-show=\"model.segment==\'B2B\'\">{{model.users[(visit.quotationmanager!=\'0\')?visit.quotationmanager:visit.creator].name}} <span ng-show=\"visit.operationsmanager!=\'0\'\">-<br>{{model.users[visit.operationsmanager].name}}</span></td><td ng-show=\"model.segment==\'B2C\'\"><span ng-repeat=\"htlId in getAccommodations(visit)\">{{tools.label(parameters.HTL[htlId])}}</span></td><td>{{tools.dateOut(tools.dateFromJava(visit.startdate))}} <span ng-show=\"tools.dateFromJava(visit.enddate)!=tools.dateFromJava(visit.startdate)\">- {{tools.dateOut(tools.dateFromJava(visit.enddate))}}</span></td><td>{{tools.amountOut(visit.uninvoicedAmount)+\'€\'}}</td><td>{{tools.amountOut(visit.unpaidInvoiceAmount)+\'€\'}}</td><td>{{tools.amountOut(visit.paidAmount)+\'€\'}}</td><td>{{tools.amountOut(visit.totalAmount)+\'€\'}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/modules/quotations/listOperationsManagers.html","<div ng-controller=OperationsListManagersController class=\"page page-quotations-list-operations-managers pages--tables\"><aside id=filters class=\"page__sidebar sidebar hidden-md hidden-lg\"><div class=sidebar__header><h4 class=title>{{tools.lang({\'en\': \'Filters\', \'nl\': \'Filters\', \'fr\': \'Filtres\'})}}</h4><button class=\"btn btn-default btn-rounded\"><span class=material-icons ng-click=\"toggleFilters(\'filters\')\">close</span></button></div><div class=sidebar__content><form class=form-horizontal><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\" ng-click=\"model.enddateOpened=!model.enddateOpened\">{{tools.lang({\'en\':\'From\',\'nl\':\'Vanaf\',\'fr\':\'Du\'})}}</label><div class=col-sm-4><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.startdate is-open=model.startdateOpened datepicker-options=model.dateOptions ng-click=\"model.startdateOpened=!model.startdateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.startdateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><label class=\"col-sm-2 control-label\" ng-click=\"model.enddateOpened=!model.enddateOpened\">{{tools.lang({\'en\':\'Until\',\'nl\':\'Tot\',\'fr\':\'\\u00C0\'})}}</label><div class=col-sm-4><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.enddate is-open=model.enddateOpened datepicker-options=model.dateOptions ng-click=\"model.enddateOpened=!model.enddateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.enddateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"form-group clearfix\"><label for=operationsmanager class=\"col-xs-12 col-sm-2 control-label\">{{tools.lang({\'en\':\'Assigned to\',\'nl\':\'Toegewezen aan\',\'fr\':\'Attribu\\u00E9 à\'})}}</label><div class=\"col-xs-4 col-sm-2\"><button class=\"btn btn-default btn-100\" ng-click=\"model.operationsmanager=user.id;load();\" ng-class=\"{\'active\':model.operationsmanager==user.id}\">{{user.name}}</button></div><div class=\"col-xs-6 col-sm-6\"><select id=operationsmanager class=\"form-control mt-1\" ng-model=model.operationsmanager ng-options=\"user.id as user.name for user in tools.addElement(model.users,anyUser) | orderBy:\'id\'\" ng-change=load();></select></div></div></form></div><div class=sidebar__footer><button type=submit class=\"btn btn-primary\" ng-click=\"load(); toggleFilters(\'filters\');\">{{tools.lang({\'en\': \'Done\', \'nl\': \'Done\', \'fr\': \'Appliquer\'})}}</button></div></aside><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\': \'Quotations list\', \'nl\': \'Quotations list\', \'fr\': \'Liste de devis\'})}}</h1><div class=header__actions><button class=\"btn btn-default btn-filters hidden-md hidden-lg\" ng-click=\"toggleFilters(\'filters\')\"><i class=material-icons>filter_list</i> <span class=\"btn__text hidden-xs hidden-sm\">{{tools.lang({ \'en\': \'Filters\', \'nl\': \'Filters\', \'fr\': \'Filtres\' })}}</span></button> <input refresh ng-disabled=webservice.calling ng-click=load();></div></section><div class=content><form class=\"table-filters hidden-xs hidden-sm\"><div class=\"table-filters__item form-group inline-flex\"><label class=control-label ng-click=\"model.startdateOpened=!model.startdateOpened\">{{tools.lang({\'en\':\'From\',\'nl\':\'Vanaf\',\'fr\':\'De\'})}}</label><div class=input-group><input type=text style=\"max-width: 120px\" class=form-control uib-datepicker-popup ng-model=model.startdate is-open=model.startdateOpened datepicker-options=model.dateOptions ng-click=\"model.startdateOpened=!model.startdateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.startdateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><label class=control-label ng-click=\"model.enddateOpened=!model.enddateOpened\">{{tools.lang({\'en\':\'Until\',\'nl\':\'Tot\',\'fr\':\'\\u00C0\'})}}</label><div class=input-group><input style=\"max-width: 120px\" type=text class=form-control uib-datepicker-popup ng-model=model.enddate is-open=model.enddateOpened datepicker-options=model.dateOptions ng-click=\"model.enddateOpened=!model.enddateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.enddateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"table-filters__item form-group inline-flex\"><label for=quotationmanager class=control-label>{{tools.lang({\'en\':\'Assigned to\',\'nl\':\'Toegewezen aan\',\'fr\':\'Attribu\\u00E9 à\'})}}</label><button class=\"btn btn-default btn-100\" ng-click=\"model.operationsmanager=user.id;load();\" ng-class=\"{\'active\':model.operationsmanager==user.id}\">{{user.name}}</button><select id=operationsmanager class=form-control ng-model=model.operationsmanager ng-options=\"user.id as user.name for user in tools.addElement(model.users,anyUser) | orderBy:\'id\'\" ng-change=load();></select></div><button type=submit ng-disabled=webservice.calling class=\"btn btn-primary mt-0 ml-2\" ng-click=\"load(); toggleFilters(\'filters\');\">{{tools.lang({\'en\': \'Done\', \'nl\': \'Done\', \'fr\': \'Appliquer\'})}}</button></form><div class=\"content__item c-table-view\" ng-hide=webservice.calling><div class=c-table-view__item><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\" ng-hide=webservice.calling><thead><tr><th><span class=th__content>{{tools.lang({\'en\':\'Accept assingment\',\'nl\':\'Accepteer Toewijzing\',\'fr\':\'Accepte atributtion\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Group\',\'nl\':\'Groep\',\'fr\':\'Groupe\'})}} - {{tools.lang({\'en\':\'Contact\',\'nl\':\'Contact\',\'fr\':\'Contact\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Language\',\'nl\':\'Taal\',\'fr\':\'Langue\'})}}</span></th><th ng-show=\"model.operationsmanager==\'\'\"><span class=th__content>{{tools.lang({\'en\':\'Operations manager\',\'nl\':\'Uitvoerings verantwoordelijke\',\'fr\':\'Responsable dossier\'})}}</span></th><th><span class=\"th__content no-flex\">{{tools.lang({\'en\':\'Sales manager\',\'nl\':\'Verkoper\',\'fr\':\'Vendeur\'})}} -<br>{{tools.lang({\'en\':\'Invoices manager\',\'nl\':\'Facturatie verantwoordelijke\',\'fr\':\'Responsable facturation\'})}}</span></th><th><span class=th__content><button class=\"btn btn-default\" ng-class=\"{\'active\':model.ordering==\'startdate\'}\" ng-click=\"changeOrdering(\'startdate\')\">{{tools.lang({\'en\':\'Visit\',\'nl\':\'Bezoek\',\'fr\':\'Visite\'})}} <span ng-show=\"model.ordering==\'startdate\'\"><span ng-show=model.reverse class=\"glyphicon glyphicon-chevron-up\"></span> <span ng-hide=model.reverse class=\"glyphicon glyphicon-chevron-down\"></span></span></button></span></th><th><span class=th__content>{{tools.lang({\'en\':\'Quantity\',\'nl\':\'Quantity\',\'fr\':\'Quantit\\u00E9\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'History\',\'nl\':\'Historiek\',\'fr\':\'Historique\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Comment for the client\',\'nl\':\'Opmerking voor de klant\',\'fr\':\'Remarque pour le client\'})}}</span></th></tr></thead><tbody><tr ng-repeat=\"visit in model.orderedVisits\" ng-class=\"{\'warning\':tools.getLength(tools.greater(visit.messages,\'created\',visit.created))==0}\"><td><input ng-show=\"visit.stat!=2200 && visit.stat!=4000 && model.operationsmanager!=\'\'\" class=\"btn btn-success\" update ng-click=accept(visit)> <button class=\"btn btn-default\" ng-click=reassign(visit);>{{tools.lang({\'en\':\'Reassign\',\'nl\':\'Toewijzen\',\'fr\':\'R\\u00E9attribuer\'})}}</button></td><td ng-click=visitRetrieve(visit.id);>{{model.contacts[visit.owningcontact].name}} - {{model.contacts[visit.communicationcontact].firstname+\' \'+model.contacts[visit.communicationcontact].name}}</td><td ng-click=visitRetrieve(visit.id);>{{model.contacts[visit.communicationcontact].lang}}</td><td ng-click=visitRetrieve(visit.id); ng-show=\"model.operationsmanager==\'\'\">{{model.users[visit.operationsmanager].name}}</td><td ng-click=visitRetrieve(visit.id);>{{model.users[visit.quotationmanager].name}} - {{model.users[visit.invoicesmanager].name}}</td><td ng-click=visitRetrieve(visit.id);>{{tools.dateOut(tools.dateFromJava(visit.startdate))}} <span ng-show=\"tools.dateFromJava(visit.enddate)!=tools.dateFromJava(visit.startdate)\">- {{tools.dateOut(tools.dateFromJava(visit.enddate))}}</span></td><td ng-click=visitRetrieve(visit.id);>{{getMaxPeople(visit)}}</td><td><div class=btn-toolbar><div class=btn-group><button ng-repeat=\"message in visit.messages\" class=\"btn btn-default\" ng-click=openMessage(visit,message) title=\"{{message.table==\'quotationnotes\'?message.body:\'\'}}\"><span ng-show=\"message.table==\'emails\'\" class=\"glyphicon glyphicon-envelope\"></span> <span ng-show=\"message.table==\'quotationnotes\'\" class=\"glyphicon glyphicon-comment\"></span></button></div><div class=btn-group><button create ng-click=startCreateQuotationnote(visit);></button></div></div></td><td ng-click=visitRetrieve(visit.id);><span ng-show=\"visit.quotationcomment.length>30\" title={{tools.substr(visit.quotationcomment,0,500)}} data-toggle=tooltip data-placement=left tooltip>{{tools.substr(visit.quotationcomment,0,30)}}... </span><span ng-hide=\"visit.quotationcomment.length>30\">{{visit.quotationcomment}}</span></td></tr></tbody></table></div></div></div><div class=\"content__item page__loader\" ng-show=webservice.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div></div></main></div>");
$templateCache.put("app/modules/quotations/listQuotations.html","<div ng-controller=QuotationsListQuotationsController class=\"page page-quotations-list-quotations pages--tables\"><aside id=filters class=\"page__sidebar sidebar hidden-md hidden-lg\"><div class=sidebar__header><h4 class=title>{{tools.lang({\'en\': \'Filters\', \'nl\': \'Filters\', \'fr\': \'Filtres\'})}}</h4><button class=\"btn btn-default btn-rounded\"><span class=material-icons ng-click=\"toggleFilters(\'filters\')\">close</span></button></div><div class=sidebar__content><form class=form-horizontal><div class=\"form-group clearfix\"><label class=\"col-xs-2 control-label\">{{tools.lang({\'en\':\'Status\',\'nl\':\'Status\',\'fr\':\'Statut\'})}}</label><div class=col-xs-10><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"par in model.stvs | orderBy:\'id\'\" ng-click=\"model.stv=par.id;load();\" ng-class=\"{\'active\':model.stv==par.id}\">{{tools.label(par)}}</button></div></div></div><div class=\"form-group clearfix\" ng-show=\"model.stv!=\'1210\'\"><div class=col-xs-2><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"par in model.dateModes\" ng-click=\"model.dateMode=par.id;load();\" ng-class=\"{\'active\':model.dateMode==par.id}\">{{tools.label(par)}}</button></div></div><label class=\"col-sm-2 control-label\" ng-click=\"model.startdateOpened=!model.startdateOpened\">{{tools.lang({\'en\':\'From\',\'nl\':\'Vanaf\',\'fr\':\'De\'})}}</label><div class=col-sm-4><p class=\"input-group mt-1\"><input type=text class=form-control uib-datepicker-popup ng-model=model.startdate is-open=model.startdateOpened datepicker-options=model.dateOptions ng-click=\"model.startdateOpened=!model.startdateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.startdateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><label class=\"col-sm-2 control-label\" ng-click=\"model.enddateOpened=!model.enddateOpened\">{{tools.lang({\'en\':\'Until\',\'nl\':\'Tot\',\'fr\':\'\\u00C0\'})}}</label><div class=col-sm-4><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.enddate is-open=model.enddateOpened datepicker-options=model.dateOptions ng-click=\"model.enddateOpened=!model.enddateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.enddateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"form-group clearfix\" ng-hide=\"model.stv!=\'1210\'\"><label class=\"col-sm-2 control-label\" ng-click=\"model.startdateQuotationStatusOpened=!model.startdateQuotationStatusOpened\">{{tools.lang({\'en\':\'From\',\'nl\':\'Vanaf\',\'fr\':\'De\'})}}</label><div class=col-sm-4><p class=\"input-group mt-1\"><input type=text class=form-control uib-datepicker-popup ng-model=model.startdateQuotationStatus is-open=model.startdateQuotationStatusOpened datepicker-options=model.dateOptions ng-click=\"model.startdateQuotationStatusOpened=!model.startdateQuotationStatusOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.startdateQuotationStatusOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"form-group clearfix\"><label for=quotationmanager class=\"col-xs-12 col-sm-2 control-label\">{{tools.lang({\'en\':\'Assigned to\',\'nl\':\'Toegewezen aan\',\'fr\':\'Attribu\\u00E9 à\'})}}</label><div class=\"col-xs-4 col-sm-2\"><button class=\"btn btn-default btn-100\" ng-click=\"model.quotationmanager=user.id;load();\" ng-class=\"{\'active\':model.quotationmanager==user.id}\">{{user.name}}</button></div><div class=\"col-xs-6 col-sm-6\"><select id=quotationmanager class=\"form-control mt-1\" ng-model=model.quotationmanager ng-options=\"user.id as user.name for user in tools.addElement(tools.filterUserOnRight(model,\'QUOT\'),anyUser) | orderBy:\'id\'\" ng-change=load();></select></div></div></form></div><div class=sidebar__footer><button type=submit class=\"btn btn-primary\" ng-click=\"load(); toggleFilters(\'filters\');\">{{tools.lang({\'en\': \'Done\', \'nl\': \'Done\', \'fr\': \'Appliquer\'})}}</button></div></aside><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\': \'Quotations list\', \'nl\': \'Quotations list\', \'fr\': \'Liste de devis\'})}}</h1><div class=header__actions><button class=\"btn btn-default btn-filters hidden-md hidden-lg\" ng-click=\"toggleFilters(\'filters\')\"><i class=material-icons>filter_list</i> <span class=\"btn__text hidden-xs hidden-sm\">{{tools.lang({ \'en\': \'Filters\', \'nl\': \'Filters\', \'fr\': \'Filtres\' })}}</span></button> <input refresh ng-disabled=webservice.calling ng-click=load();></div></section><div class=content><form class=\"table-filters hidden-xs hidden-sm\"><div class=\"table-filters__item form-group inline-flex\"><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"par in model.stvs | orderBy:\'id\'\" ng-click=\"model.stv=par.id;load();\" ng-class=\"{\'active\':model.stv==par.id}\">{{tools.label(par)}}</button></div></div><div class=\"table-filters__item form-group inline-flex\" ng-show=\"model.stv!=\'1210\'\"><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"par in model.dateModes\" ng-click=\"model.dateMode=par.id;load();\" ng-class=\"{\'active\':model.dateMode==par.id}\">{{tools.label(par)}}</button></div><label class=control-label ng-click=\"model.startdateOpened=!model.startdateOpened\">{{tools.lang({\'en\':\'From\',\'nl\':\'Vanaf\',\'fr\':\'De\'})}}</label><div class=input-group><input type=text style=\"max-width: 120px\" class=form-control uib-datepicker-popup ng-model=model.startdate is-open=model.startdateOpened datepicker-options=model.dateOptions ng-click=\"model.startdateOpened=!model.startdateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.startdateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><label class=control-label ng-click=\"model.enddateOpened=!model.enddateOpened\">{{tools.lang({\'en\':\'Until\',\'nl\':\'Tot\',\'fr\':\'\\u00C0\'})}}</label><div class=input-group><input style=\"max-width: 120px\" type=text class=form-control uib-datepicker-popup ng-model=model.enddate is-open=model.enddateOpened datepicker-options=model.dateOptions ng-click=\"model.enddateOpened=!model.enddateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.enddateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"table-filters__item form-group inline-flex\" ng-hide=\"model.stv!=\'1210\'\"><label class=control-label ng-click=\"model.startdateQuotationStatusOpened=!model.startdateQuotationStatusOpened\">{{tools.lang({\'en\':\'From\',\'nl\':\'Vanaf\',\'fr\':\'De\'})}}</label><div class=input-group><input type=text style=\"max-width: 120px\" class=form-control uib-datepicker-popup ng-model=model.startdateQuotationStatus is-open=model.startdateQuotationStatusOpened datepicker-options=model.dateOptions ng-click=\"model.startdateQuotationStatusOpened=!model.startdateQuotationStatusOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.startdateQuotationStatusOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"table-filters__item form-group inline-flex\"><label for=quotationmanager class=control-label>{{tools.lang({\'en\':\'Assigned to\',\'nl\':\'Toegewezen aan\',\'fr\':\'Attribu\\u00E9 à\'})}}</label><button class=\"btn btn-default btn-100\" ng-click=\"model.quotationmanager=user.id;load();\" ng-class=\"{\'active\':model.quotationmanager==user.id}\">{{user.name}}</button><select id=quotationmanager class=form-control ng-model=model.quotationmanager ng-options=\"user.id as user.name for user in tools.addElement(tools.filterUserOnRight(model,\'QUOT\'),anyUser) | orderBy:\'id\'\" ng-change=load();></select></div></form><div class=\"content__item c-table-view\" ng-hide=webservice.calling><div class=c-table-view__item><div class=table-responsive-wrapper><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\" ng-hide=webservice.calling><thead><tr><th><span class=th__content>{{tools.lang({\'en\':\'Status\',\'nl\':\'Status\',\'fr\':\'Statut\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Group\',\'nl\':\'Groep\',\'fr\':\'Groupe\'})}} - {{tools.lang({\'en\':\'Contact\',\'nl\':\'Contact\',\'fr\':\'Contact\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Language\',\'nl\':\'Taal\',\'fr\':\'Langue\'})}}</span></th><th ng-show=\"model.quotationmanager==\'\'\"><span class=th__content>{{tools.lang({\'en\':\'Manager\',\'nl\':\'Manager\',\'fr\':\'Manager\'})}}</span></th><th><span class=th__content><button class=\"btn btn-default\" ng-class=\"{\'active\':model.ordering==\'created\'}\" ng-click=\"changeOrdering(\'created\')\">{{tools.lang({\'en\':\'Created\',\'nl\':\'Aangemaakt\',\'fr\':\'Cr\\u00E9\\u00E9\'})}} <span ng-show=\"model.ordering==\'created\'\"><span ng-show=model.reverse class=\"glyphicon glyphicon-chevron-up\"></span> <span ng-hide=model.reverse class=\"glyphicon glyphicon-chevron-down\"></span></span></button></span></th><th><span class=th__content><button class=\"btn btn-default\" ng-class=\"{\'active\':model.ordering==\'startdate\'}\" ng-click=\"changeOrdering(\'startdate\')\">{{tools.lang({\'en\':\'Visit\',\'nl\':\'Bezoek\',\'fr\':\'Visite\'})}} <span ng-show=\"model.ordering==\'startdate\'\"><span ng-show=model.reverse class=\"glyphicon glyphicon-chevron-up\"></span> <span ng-hide=model.reverse class=\"glyphicon glyphicon-chevron-down\"></span></span></button></span></th><th><span class=th__content>{{tools.lang({\'en\':\'Quantity\',\'nl\':\'Quantity\',\'fr\':\'Quantit\\u00E9\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'History\',\'nl\':\'Historiek\',\'fr\':\'Historique\'})}}</span></th><th><span class=th__content><span class=text>{{tools.lang({\'en\':\'Comment of employee\',\'nl\':\'Opmerking voor medewerkers\',\'fr\':\"Remarque de l\'employ\\u00E9\"})}}</span></span></th><th><span class=th__content><span class=text>{{tools.lang({\'en\':\'Comment of the client\',\'nl\':\'Opmerking voor de klant\',\'fr\':\'Remarque du client\'})}}</span></span></th><th><span class=th__content>{{tools.lang({\'en\':\'Discount\',\'nl\':\'Discount\',\'fr\':\'Réduction\'})}}</span></th><th><span class=th__content></span></th></tr></thead><tbody><tr ng-repeat=\"visit in tools.toArray(model.visits) | orderBy:model.ordering:model.reverse\" ng-class=\"{\'warning\':tools.getLength(tools.greater(visit.messages,\'created\',visit.created))==0}\"><td><input ng-show=\"model.stv==\'1210\'\" class=\"btn btn-success\" update ng-click=assignSoldQuotation(visit)> <button class=\"btn btn-warning\" ng-show=\"visit.stat==2100 || visit.stat==2200 || visit.stat==9100\" ng-click=restore(visit);>{{tools.lang({\'en\':\'Restore\',\'nl\':\'Terugzetten\',\'fr\':\'Remettre\'})}}</button> <button class=\"btn btn-default\" disabled ng-show=\"visit.stat==3000\">{{tools.lang({\'en\':\'Has ticket\',\'nl\':\'Heeft ticket\',\'fr\':\'A un ticket\'})}}</button></td><td ng-click=visitRetrieve(visit.id);>{{model.contacts[visit.owningcontact].name}} - {{model.contacts[visit.communicationcontact].firstname+\' \'+model.contacts[visit.communicationcontact].name}}</td><td ng-click=visitRetrieve(visit.id);>{{model.contacts[visit.communicationcontact].lang}}</td><td ng-click=visitRetrieve(visit.id); ng-show=\"model.quotationmanager==\'\'\">{{model.users[visit.quotationmanager].name}}</td><td ng-click=visitRetrieve(visit.id);>{{tools.dateOut(visit.created)+\' \'+visit.creator_name}}</td><td ng-click=visitRetrieve(visit.id);>{{tools.dateOut(tools.dateFromJava(visit.startdate))}} <span ng-show=\"tools.dateFromJava(visit.enddate)!=tools.dateFromJava(visit.startdate)\">- {{tools.dateOut(tools.dateFromJava(visit.enddate))}}</span></td><td ng-click=visitRetrieve(visit.id);>{{getMaxPeople(visit)}}</td><td><div class=btn-toolbar><div class=btn-group><button ng-repeat=\"message in visit.messages\" class=\"btn btn-default\" ng-click=openMessage(visit,message) title=\"{{message.table==\'quotationnotes\'?message.body:\'\'}}\"><span ng-show=\"message.table==\'emails\'\" class=\"glyphicon glyphicon-envelope\"></span> <span ng-show=\"message.table==\'quotationnotes\'\" class=\"glyphicon glyphicon-comment\"></span></button></div><div class=btn-group><button create ng-click=startCreateQuotationnote(visit);></button></div></div></td><td ng-click=visitRetrieve(visit.id);><span ng-show=\"visit.quotationcomment.length>30\" title={{tools.substr(visit.quotationcomment,0,500)}} data-toggle=tooltip data-placement=left tooltip>{{tools.substr(visit.quotationcomment,0,30)}}... </span><span ng-hide=\"visit.quotationcomment.length>30\">{{visit.quotationcomment}}</span></td><td ng-click=visitRetrieve(visit.id);><span ng-show=\"visit.comment.length>30\" title={{tools.substr(visit.comment,0,500)}} data-toggle=tooltip data-placement=left tooltip>{{tools.substr(visit.comment,0,30)}}... </span><span ng-hide=\"visit.comment.length>30\">{{visit.comment}}</span></td><td ng-click=visitRetrieve(visit.id);><div ng-show=\"!visit.customDescription && visit.gross>0.0\"><span class=label ng-class=\"{\'label-success\':visit.reduction<=5.0,\'label-warning\':visit.reduction>5.0}\">{{tools.amountOut(visit.reduction)}}%</span></div><div ng-show=visit.customDescription><span class=\"label label-danger\">Custom</span></div></td><td><input ng-show=\"model.stv==\'1210\'\" class=\"btn btn-danger\" delete ng-click=cancel(visit)></td></tr></tbody></table></div></div></div></div><div class=\"content__item page__loader\" ng-show=webservice.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div></div></main></div>");
$templateCache.put("app/modules/quotations/soldOverview.html","<div ng-controller=QuotationsSoldOverviewController class=\"page page-quotations-sold-overview page--tables\"><aside id=filters class=\"page__sidebar sidebar\"><div class=sidebar__header><h4 class=title>{{tools.lang({\'en\': \'Filters\', \'nl\': \'Filters\', \'fr\': \'Filtres\'})}}</h4><button class=\"btn btn-default btn-rounded\"><span class=material-icons ng-click=\"toggleFilters(\'filters\')\">close</span></button></div><div class=sidebar__content><form class=form-horizontal><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\" ng-click=\"model.startdateOpened=!model.startdateOpened\">{{tools.lang({\'en\':\'Start\',\'nl\':\'Start\',\'fr\':\'D\\u00E9but\'})}}</label><div class=col-sm-4><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.startdate is-open=model.startdateOpened datepicker-options=model.dateOptions ng-click=\"model.startdateOpened=!model.startdateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.startdateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><label class=\"col-sm-2 control-label\" ng-click=\"model.enddateOpened=!model.enddateOpened\">{{tools.lang({\'en\':\'End\',\'nl\':\'Einde\',\'fr\':\'Fin\'})}}</label><div class=col-sm-4><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.enddate is-open=model.enddateOpened datepicker-options=model.dateOptions ng-click=\"model.enddateOpened=!model.enddateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.enddateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=col-sm-4><label><input type=checkbox ng-model=model.vatIncluded> {{tools.lang({\'en\':\'VAT included\',\'nl\':\'Inclusief BTW\',\'fr\':\'TVA Inclus\'})}}</label></div><div class=col-sm-4><label><input type=checkbox ng-model=model.groupMonths ng-change=clickedMonths()> {{tools.lang({\'en\':\'Group by month\',\'nl\':\'Groepeer per maand\',\'fr\':\'Grouper par mois\'})}}</label></div><div class=col-sm-4><label><input type=checkbox ng-model=model.groupDvss ng-change=clickedDvss()> {{tools.lang({\'en\':\'Group by division\',\'nl\':\'Groepeer per afdeling\',\'fr\':\'Grouper par division\'})}}</label></div></div></form></div><div class=sidebar__footer><button type=submit class=\"btn btn-primary\" ng-click=\"load(); toggleFilters(\'filters\');\">{{tools.lang({\'en\': \'Done\', \'nl\': \'Done\', \'fr\': \'Appliquer\'})}}</button></div></aside><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\': \'Sold overview\', \'nl\': \'Sold overview\', \'fr\': \'Résultats de vente\'})}}</h1><div class=header__actions><div class=\"page__actions hidden-xs hidden-sm\"><button type=button class=\"btn btn-default\" ng-click=increaseDates(-1);><span class=material-icons>chevron_left</span></button> <span class=h5>{{tools.lang({\'en\': \'Day\', \'nl\': \'Day\', \'fr\': \'Jour\'})}}</span> <button type=button class=\"btn btn-default\" ng-click=increaseDates(1);><span class=material-icons>chevron_right</span></button></div><button class=\"btn btn-default btn-filters\" ng-click=\"toggleFilters(\'filters\')\"><i class=material-icons>filter_list</i> <span class=\"btn__text hidden-xs hidden-sm\">{{tools.lang({ \'en\': \'Filters\', \'nl\': \'Filters\', \'fr\': \'Filtres\' })}}</span></button></div></section><div class=content><div class=\"content__item c-table-view\" ng-hide=webservice.calling><div class=c-table-view__item><h4 class=c-table-view__title>{{tools.lang({\'en\':\'Invoiced per account manager\',\'nl\':\'Gefactureerd per account manager\',\'fr\':\'Factur\\u00E9 par account manager\'})}}</h4><p>{{tools.lang({ \'en\': \'Selected according to the creation of the invoice. The amount excluding VAT does not take into account rounding off.\', \'nl\': \'Geselecteerd volgens aanmaak van de factuur. Het bedrag excl BTW houdt geen rekening met afrondingen\', \'fr\': \'Sélectionné en fonction de la création de la facture. Le montant hors TVA ne tient pas compte des arrondis.\' })}}</p><div class=table-responsive-wrapper><table class=\"table table-striped\"><thead><tr><th><span class=th__content>{{tools.lang({\'en\':\'Manager\',\'nl\':\'Manager\',\'fr\':\'Manager\'})}}</span></th><th><span class=th__content>{{tools.lang(model.showVatIncluded?{\'en\':\'Incl VAT\',\'nl\':\'Incl BTW\',\'fr\':\'Incl TVA\'}:{\'en\':\'Excl VAT\',\'nl\':\'Excl BTW\',\'fr\':\'Excl TVA\'})}}</span></th><th ng-show=model.showGroupMonths ng-repeat=\"month in model.months\"><span class=th__content>{{tools.substr(month,0,7)}}</span></th><th ng-show=model.showGroupDvss ng-repeat=\"dvs in parameters.notDelArrayDVS\"><span class=th__content>{{tools.label(dvs)}}</span></th></tr></thead><tbody><tr ng-repeat=\"line in model.quotationmanagerLines | orderBy:\'-excl\'\"><td>{{model.users[line.quotationmanager].name}}</td><td>{{tools.financialAmountOut(line.sumamount)}}</td><td ng-show=model.showGroupMonths ng-repeat=\"month in model.months\">{{tools.financialAmountOut(line[month])}}</td><td ng-show=model.showGroupDvss ng-repeat=\"dvs in parameters.notDelArrayDVS\">{{tools.financialAmountOut(line[dvs.id])}}</td></tr><tr><td><b>{{tools.lang({\'en\':\'Total\',\'nl\':\'Total\',\'fr\':\'Total\'})}}</b></td><td><b>{{tools.financialAmountOut(tools.sum(model.quotationmanagerLines,\'sumamount\'))}}</b></td><td ng-show=model.showGroupMonths ng-repeat=\"month in model.months\"><b>{{tools.financialAmountOut(tools.sum(model.quotationmanagerLines,month))}}</b></td><td ng-show=model.showGroupDvss ng-repeat=\"dvs in parameters.notDelArrayDVS\"><b>{{tools.financialAmountOut(tools.sum(model.quotationmanagerLines,dvs.id))}}</b></td></tr></tbody></table></div></div></div><div class=\"content__item page__loader\" ng-show=webservice.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div></div><div class=page__actions><button type=button class=\"btn btn-default\" ng-click=increaseDates(-1);><span class=material-icons>chevron_left</span></button> <span class=h5>{{tools.lang({\'en\': \'Day\', \'nl\': \'Day\', \'fr\': \'Jour\'})}}</span> <button type=button class=\"btn btn-default\" ng-click=increaseDates(1);><span class=material-icons>chevron_right</span></button></div></main></div>");
$templateCache.put("app/modules/partners/listVisits.html","<div ng-controller=PartnersInvoicesController><form class=form-horizontal><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\" ng-click=\"model.startdateOpened=!model.startdateOpened\">{{tools.lang({\'en\':\'From\',\'nl\':\'Vanaf\',\'fr\':\'De\'})}}</label><div class=col-sm-10><p class=input-group><input type=text autocomplete=off class=form-control uib-datepicker-popup ng-model=model.startdate is-open=model.startdateOpened datepicker-options=model.dateOptions ng-click=\"model.startdateOpened=!model.startdateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.startdateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\" ng-click=\"model.enddateOpened=!model.enddateOpened\">{{tools.lang({\'en\':\'Until\',\'nl\':\'Tot\',\'fr\':\'À\'})}}</label><div class=col-sm-10><p class=input-group><input type=text autocomplete=off class=form-control uib-datepicker-popup ng-model=model.enddate is-open=model.enddateOpened datepicker-options=model.dateOptions ng-click=\"model.enddateOpened=!model.enddateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.enddateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Method\',\'nl\':\'Middel\',\'fr\':\'Moyen\'})}}</label><div class=col-sm-10><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"mth in tools.exclude(parameters.notDelMTH,{\'id\':\'MIX\'}) | orderBy:\'id\'\" ng-click=\"model.mth=mth.id\" ng-class=\"{\'active\':model.mth==mth.id}\" ng-show=\"model.accounttype==\'USR\'\">{{tools.label(mth)}}</button></div></div></div><div class=\"form-group clearfix\"><div class=\"col-sm-offset-2 col-sm-10\"><span ng-hide=model.calling><button type=submit class=\"btn btn-primary\" ng-click=load();>{{tools.lang({\'en\':\'Show\',\'nl\':\'Tonen\',\'fr\':\'Montrer\'})}}</button> </span><span ng-show=model.calling>calling...</span></div></div></form><div ng-show=\"model.account!=null\"><h4 ng-show=\"model.account.accounttype==\'USR\'\">{{model.account.name}}</h4><ul class=list-group><li class=\"list-group-item row\" ng-show=showBalance()><div class=\"col-xs-6 text-right\">{{tools.lang({\'en\':\'Balance before\',\'nl\':\'Balans vóór\',\'fr\':\'Balance avant\'})+\' \'+tools.dateOut(model.startdateValue)}}</div><div class=col-xs-6>{{tools.amountOut(model.balance.amount+tools.sum(tools.less(tools.greaterEqual(tools.join(model.account,\'movements\',model),\'created\',model.balance.created),\'created\',model.startdateValue),\'amount\'))}}</div></li><li class=\"list-group-item row\" ng-repeat=\"movement in tools.toArray(tools.greaterEqual(model.movements,\'created\',model.startdateValue+\' 00:00:00\')) | orderBy:\'created\'\"><div class=\"col-xs-6 text-right\"><span ng-show=\"movement.origin==\'ACT\'\"><input retrieve ng-click=visitRetrieve(movement.visit)> {{model.visits[movement.visit].name}} </span><span ng-hide=\"movement.origin==\'ACT\'\">{{tools.label(parameters.ORI[movement.origin])}} </span>{{tools.dateOut(movement.created)}}</div><div class=col-xs-6>{{tools.amountOut(movement.amount)}}</div></li><li class=\"list-group-item row\" ng-show=showBalance()><div class=\"col-xs-6 text-right\">{{tools.lang({\'en\':\'Balance after\',\'nl\':\'Balans na\',\'fr\':\'Balance apres\'})+\' \'+tools.dateOut(model.enddateValue)}}</div><div class=col-xs-6>{{tools.amountOut(model.balance.amount+tools.sum(tools.less(tools.greaterEqual(tools.join(model.account,\'movements\',model),\'created\',model.balance.created),\'created\',model.enddateValue+\' 23:00:00\'),\'amount\'))}}</div></li></ul><div ng-show=\"model.account.accounttype==\'USR\'\"><h4>{{tools.lang({\'en\':\'Reductions\',\'nl\':\'Kortingen\',\'fr\':\'Reductions\'})}}</h4><ul class=list-group><li class=\"list-group-item row\" ng-repeat=\"visit in tools.inverseJoin(filterReductionItems(model.items),\'visits\',\'visit\',model)\"><div class=\"col-xs-6 text-right\"><input retrieve ng-click=visitRetrieve(visit.id)> {{visit.name}}</div><div class=col-xs-6><div ng-repeat=\"item in filterReductionItems(tools.join(visit,\'items\',model))\">{{tools.amountOut(item.reductionamount)+activitiesService.percentToSymbol(item.reductionpercent)}} <span ng-show=\"item.reductionpercent==\'1\'\">{{tools.amountOut(item.quantity*item.grossunitprice*item.reductionamount/100.0)+\'\\u20AC\'}}</span> {{tools.label(parameters.ITM[item.itm])}} <span ng-show=\"tools.substr(item.itm,0,3)==\'ACT\' && parameters.UNT[tools.first(tools.join(item,\'participants\',model)).unt].field3==\'1\'\">{{tools.label(parameters.UNT[tools.first(tools.join(item,\'participants\',model)).unt])}} </span><span ng-show=\"tools.substr(item.itm,0,3)==\'MEA\'\">{{tools.label(parameters.DSH[tools.first(tools.join(item,\'dishes\',model)).dsh])}} </span>{{tools.dateOut(item.updated)}}</div></div></li></ul></div></div></div>");
$templateCache.put("app/modules/prices/promotions.html","<div ng-controller=PricesPromotionsController class=\"page page-prices-promotions page--tables\"><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\':\'Promotions\',\'nl\':\'Promoties\',\'fr\':\'Promotions\'})}}</h1><div class=header__filters><div class=\"form-group clearfix\"><div class=col-md-12><div class=btn-group ng-hide=model.selectedPromotion.editing><div ng-dropdown-multiselect=\"\" options=model.activePromotions selected-model=model.selectedPromotionId extra-settings=multiselectPromotionSettings translation-texts=multiselectTranslations events={onItemSelect:selectPromotion}></div></div></div></div></div><div class=header__actions><button type=button class=\"btn btn-success\" ng-click=createPromotion();>{{tools.lang({\'en\':\'New discount\',\'nl\':\'Nieuwe korting\',\'fr\':\'Nouvelle promotion\'})}}</button></div></section><div class=content ng-if=\"model.selectedPromotion!==null\"><form class=form-horizontal><div class=\"form-group clearfix\" ng-hide=model.selectedPromotion.editing><div class=col-xs-12>{{tools.label(parameters.PRO[model.selectedPromotion.pro])}}: {{tools.amountOut(model.selectedPromotion.amount)}}{{model.selectedPromotion.percent==\'1\'?\'%\':\'€\'}} {{tools.label(model.promotionTypes[model.selectedPromotion.peritem])}}</div></div><div ng-show=model.selectedPromotion.editing class=\"form-group clearfix\"><label class=col-md-1>{{tools.lang({\'en\':\'Promotion\',\'nl\':\'Promotie\',\'fr\':\'Promotion\'})}}</label><div class=col-md-5><select class=form-control ng-model=model.selectedPromotion.pro ng-options=\"pro.id as tools.label(pro) for pro in tools.toArray(parameters.notDelPRO) | orderBy:\'label\'+user.lang\"></select></div><div class=col-md-2><div class=input-group><input class=form-control type=text ng-model=model.selectedPromotion.amount size=12> <span class=input-group-btn><button ng-show=\"model.selectedPromotion.peritem==\'2\'\" type=button class=\"btn btn-default\" ng-repeat=\"par in reductionModes\" ng-click=\"model.selectedPromotion.percent=par.id;\" ng-class=\"{\'active\':model.selectedPromotion.percent==par.id}\"><span class=glyphicon ng-class=[par.glyphicon]></span></button> <button class=\"btn btn-default form-control\" type=button ng-disabled=true ng-show=\"model.selectedPromotion.peritem!=\'2\'\">%</button></span></div></div><div class=col-md-4><select class=form-control ng-show=model.selectedPromotion.editing ng-model=model.selectedPromotion.peritem ng-options=\"peritem.id as tools.label(peritem) for peritem in tools.toArray(promotionTypes) | orderBy:\'sort\'\"></select></div></div><ul ng-class=\"{\'list-group\':model.selectedPromotion.editing}\"><restrictions-component foreigntable=promotions get-parent=getParent() model=model get-editing=getEditing() get-behaviour-filter=getBehaviourFilter()></restrictions-component><div class=form-group ng-show=model.selectedPromotion.editing><div class=col-md-11></div><div class=col-md-1><input class=\"btn btn-success\" update ng-click=replacePromotion(model.selectedPromotion)> <input class=\"btn btn-warning\" cancel ng-click=cancelPromotion(model.selectedPromotion)></div></div></ul><div class=\"form-group clearfix\" ng-hide=model.selectedPromotion.editing><div class=col-xs-12><input edit ng-click=editPromotion(model.selectedPromotion)> <input class=\"btn btn-danger\" delete ng-hide=model.selectedPromotion.editing ng-click=deletePromotion(model.selectedPromotion)></div></div></form></div></main></div>");
$templateCache.put("app/modules/reporting/bigcAccounting.html","<div ng-controller=ReportingBigcAccountingController class=\"page page-accounting-daily-income\"><aside id=filters class=\"page__sidebar sidebar\"><div class=sidebar__header><h4 class=title>{{tools.lang({\'en\': \'Filters\', \'nl\': \'Filters\', \'fr\': \'Filtres\'})}}</h4><button class=\"btn btn-default btn-rounded\"><span class=material-icons ng-click=\"toggleFilters(\'filters\')\">close</span></button></div><div class=sidebar__content><form class=form-horizontal><div class=\"form-group clearfix\"><label class=\"col-xs-2 control-label\" ng-click=\"model.startdateOpened=!model.startdateOpened\">{{tools.lang({\'en\':\'From\',\'nl\':\'Vanaf\',\'fr\':\'De\'})}}</label><div class=col-xs-4><p class=input-group><span class=input-group-btn uib-datepicker-popup ng-model=model.startdate is-open=model.startdateOpened datepicker-options=model.dateOptions ng-change=\"model.ISOStartdate=tools.dateFromJava(model.startdate)\"><button type=button class=\"btn btn-default\" ng-click=\"model.startdateOpened=!model.startdateOpened\"><i class=\"glyphicon glyphicon-calendar\"></i></button> </span><input type=text class=form-control ng-model=model.ISOStartdate ng-update=\"model.startdate=tools.dateToJava(model.ISOStartdate)\" ng-click=\"model.startdateOpened=!model.startdateOpened\"></p></div></div><div class=\"form-group clearfix\"><label class=\"col-xs-2 control-label\" ng-click=\"model.enddateOpened=!model.enddateOpened\">{{tools.lang({\'en\':\'To\',\'nl\':\'Tot\',\'fr\':\'À\'})}}</label><div class=col-xs-4><p class=input-group><span class=input-group-btn uib-datepicker-popup ng-model=model.enddate is-open=model.enddateOpened datepicker-options=model.dateOptions ng-change=\"model.ISOEnddate=tools.dateFromJava(model.enddate)\"><button type=button class=\"btn btn-default\" ng-click=\"model.enddateOpened=!model.enddateOpened\"><i class=\"glyphicon glyphicon-calendar\"></i></button> </span><input type=text class=form-control ng-model=model.ISOEnddate ng-update=\"model.enddate=tools.dateToJava(model.ISOEnddate)\" ng-click=\"model.enddateOpened=!model.enddateOpened\"></p></div></div><div class=\"form-group clearfix\"><div class=col-xs-12><div class=btn-group><button type=button class=\"btn btn-default\" ng-click=addWeeks(-1)>-</button> <button type=button class=\"btn btn-default\" ng-click=selectCurrentFinishedWeek()>{{tools.lang({\'en\':\'Week\',\'nl\':\'Week\',\'fr\':\'Semaine\'})}}</button> <button type=button class=\"btn btn-default\" ng-click=addWeeks(1)>+</button></div></div></div><div class=\"form-group clearfix\"><div class=col-xs-12><div class=btn-group><button type=button class=\"btn btn-default\" ng-click=addMonths(-1)>-</button> <button type=button class=\"btn btn-default\" ng-click=selectCurrentFinishedMonth()>{{tools.lang({\'en\':\'Month\',\'nl\':\'Maand\',\'fr\':\'Mois\'})}}</button> <button type=button class=\"btn btn-default\" ng-click=addMonths(1)>+</button></div></div></div></form></div><div class=sidebar__footer><button type=submit class=\"btn btn-primary\" ng-click=\"load(); toggleFilters(\'filters\');\">{{tools.lang({\'en\': \'Done\', \'nl\': \'Done\', \'fr\': \'Appliquer\'})}}</button></div></aside><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{model.ISOStartdate+\' - \'+model.ISOEnddate}}</h1><div class=header__actions><button class=\"btn btn-default btn-filters\" ng-click=\"toggleFilters(\'filters\')\"><i class=material-icons>filter_list</i> <span class=\"btn__text hidden-xs hidden-sm\">{{tools.lang({\'en\': \'Filters\',\'nl\': \'Filters\',\'fr\': \'Filtres\'})}}</span></button></div></section><div class=content ng-hide=webservice.calling><h1>B2C</h1><div class=\"content__item c-table-view\"><div class=c-table-view__item><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><thead><tr><th class=\"table__col col--sticky\"><span class=th__content>{{tools.lang({\'en\':\'Account\',\'nl\':\'Rekening\',\'fr\':\'Compte\'})}}</span></th><th colspan=2><span class=th__content></span></th><th><span class=th__content>{{tools.lang({\'en\':\'Invoiced\',\'nl\':\'Gefactureerd\',\'fr\':\'Factur\\u00E9\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Excl\',\'nl\':\'Excl\',\'fr\':\'Excl\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Vat\',\'nl\':\'Btw\',\'fr\':\'Tva\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Paid\',\'nl\':\'Betaald\',\'fr\':\'Pay\\u00E9\'})}}</span></th><th ng-repeat=\"mthId in model.mthIds\"><span class=th__content>{{tools.short(parameters.MTH[mthId])}}</span></th></tr></thead><tbody><tr><td class=\"table__col col--sticky\"></td><td colspan=2></td><td><b>{{tools.amountOut(model.totals.base+model.totals.vat)}}</b></td><td><b>{{tools.amountOut(model.totals.base)}}</b></td><td><b>{{tools.amountOut(model.totals.vat)}}</b></td><td><b>{{tools.amountOut(model.totals.paid)}}</b></td><td ng-repeat=\"mthId in model.mthIds\"><b>{{tools.amountOut(model.totals.mths[mthId])}}</b></td></tr><tr ng-repeat=\"line in model.b2cLines | orderBy:\'accountcode\'\"><td class=\"table__col col--sticky\">{{line.accountcode}}</td><td>{{line.vatpc}}%</td><td>{{tools.substr(tools.label(parameters.ITM[tools.substr(line.itm,0,8).trim()]),0,10)}}</td><td>{{tools.amountOut(line.base+line.vat)}}</td><td>{{tools.amountOut(line.base)}}</td><td>{{tools.amountOut(line.vat)}}</td><td>{{tools.amountOut(line.paid)}}</td><td ng-repeat=\"mthId in model.mthIds\">{{tools.amountOut(line.mths[mthId])}}</td></tr></tbody></table></div></div></div><h1>B2B</h1><div class=\"content__item c-table-view\" ng-hide=webservice.calling><div class=c-table-view__item><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><thead><tr><th class=\"table__col col--sticky\"><span class=th__content>{{tools.lang({\'en\':\'Name\',\'nl\':\'Naam\',\'fr\':\'Nom\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Invoice\',\'nl\':\'Factuur\',\'fr\':\'Facture\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Total\',\'nl\':\'Total\',\'fr\':\'Total\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Vat\',\'nl\':\'Btw\',\'fr\':\'Tva\'})}}</span></th><th colspan=2 ng-repeat=\"component in model.components | orderBy:\'code\'\"><span class=th__content>{{tools.substr(component.code,10)}}<br>{{tools.substr(component.code,8,2)-0}}%</span></th><th ng-repeat=\"method in model.methods | orderBy:\'mth\'\"><span class=th__content>{{tools.short(parameters.MTH[method.mth])}}</span></th></tr></thead><tbody><tr><td class=\"table__col col--sticky\"></td><td></td><td><b>{{tools.amountOut(model.totalItems)}}</b></td><td><b>{{tools.amountOut(model.totalVat)}}</b></td><td ng-repeat-start=\"component in model.components | orderBy:\'code\'\"><b>{{tools.amountOut(component.base)}}</b></td><td ng-repeat-end ng-class=\"{\'borderright\':$last}\"><b>{{tools.amountOut(component.vat)}}</b></td><td ng-repeat=\"method in model.methods | orderBy:\'mth\'\"><b>{{tools.amountOut(method.amount)}}</b></td></tr><tr ng-repeat=\"visit in tools.toArray(model.visits) | orderBy:\'created\'\"><td class=\"table__col col--sticky\"><button retrieve ng-click=visitRetrieve(visit.id);></button> {{model.contacts[visit.owningcontact].name}}</td><td><div ng-repeat=\"invoice in tools.toArray(tools.join(visit,\'invoices\',model))\">{{invoice.dvs+(model.accountingIntegration!=\'\'?invoice.exactnumber:invoice.id)+\' \'+tools.substr(invoice.created,0,10)}}</div></td><td>{{tools.amountOut(visit.totalItems)}}</td><td>{{tools.amountOut(visit.totalVat)}}</td><td ng-repeat-start=\"component in model.components | orderBy:\'code\'\">{{tools.amountOut(visit.components[component.code].base)}}</td><td ng-repeat-end>{{tools.amountOut(visit.components[component.code].vat)}}</td><td ng-repeat=\"method in model.methods | orderBy:\'mth\'\">{{tools.amountOut(visit.methods[method.mth])}}</td></tr></tbody></table></div></div></div><div class=\"content__item page__loader\" ng-show=webservice.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div></div></main></div>");
$templateCache.put("app/modules/reporting/visitorsReport.html","<div ng-controller=ReportingVisitorsReportController class=page--content><!-- Search Filters --><div class=\"panel panel-default\"><div class=panel-body><form class=form-inline><div class=form-group><label for=reportDate>Report Date:</label><input type=date id=reportDate class=form-control ng-model=model.date max=\"{{ today }}\" required></div><div class=form-group><label for=dateOffset>Comparison Offset (days):</label><div class=input-group><span class=input-group-addon ng-click=decrementOffset() ng-disabled=\"model.dateOffset <= 1\"><span class=\"glyphicon glyphicon-minus\"></span> </span><input type=number id=dateOffset class=\"form-control text-center\" ng-model=model.dateOffset min=1 max=1095 style=\"-moz-appearance: textfield\"> <span class=input-group-addon ng-click=incrementOffset() ng-disabled=\"model.dateOffset >= 1095\"><span class=\"glyphicon glyphicon-plus\"></span></span></div></div><div class=form-group><button type=button class=\"btn btn-sm\" ng-click=setOffset(364) ng-class=\"model.dateOffset === 364 ? \'btn-info\' : \'btn-default\'\">52 Weeks</button> <button type=button class=\"btn btn-sm\" ng-click=setOffset(365) ng-class=\"model.dateOffset === 365 ? \'btn-info\' : \'btn-default\'\">1 Year</button></div><div class=form-group><label for=graphDuration>Graph Duration (days):</label><div class=input-group><span class=input-group-addon ng-click=decrementGraphDuration() ng-disabled=\"model.graphDuration <= 7\"><span class=\"glyphicon glyphicon-minus\"></span> </span><input type=number id=graphDuration class=\"form-control text-center\" ng-model=model.graphDuration min=7 max=365 style=\"-moz-appearance: textfield\"> <span class=input-group-addon ng-click=incrementGraphDuration() ng-disabled=\"model.graphDuration >= 365\"><span class=\"glyphicon glyphicon-plus\"></span></span></div></div><button type=button class=\"btn btn-primary\" ng-click=load(); ng-disabled=\"model.loading || model.loadingTrend\"><span class=\"glyphicon glyphicon-refresh\"></span> Refresh</button></form></div></div><!-- Data Visualizations --><div class=row ng-show=\"model.visitorData || model.trendData\"><!-- Visitor Data Table --><div class=col-lg-6 ng-show=model.visitorData><div class=\"panel panel-default\"><div class=panel-body><div class=table-responsive><table class=\"table table-striped table-hover\"><thead><tr><th></th><th class=text-right>{{formatDate(model.date)}}</th><th class=text-right></th><th class=text-right>{{formatDate(model.date)}}</th><th class=text-right></th></tr><tr><th>TOTAL</th><th class=text-right>{{ model.visitorData.totals[0] | number }}</th><th class=text-right></th><th class=text-right>{{ model.visitorData.totals[1] | number }}</th><th class=text-right></th></tr></thead><tbody><tr ng-repeat=\"row in model.visitorData.table\"><td>{{ row[0] }}</td><td class=text-right><span ng-if=\"row[1] !== \'\'\">{{ parseNumber(row[1]) | number }}</span></td><td class=text-right><span ng-if=\"row[2] !== \'\'\">{{ parseNumber(row[2]) | number }}</span></td><td class=text-right><span ng-if=\"row[3] !== \'\'\">{{ parseNumber(row[3]) | number }}</span></td><td class=text-right><span ng-if=\"row[4] !== \'\'\">{{ parseNumber(row[4]) | number }}</span></td></tr></tbody></table></div></div></div></div><!-- Trend Graph --><div class=col-lg-6 ng-show=model.trendData><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>{{ model.graphDuration }}-Day Visitor Trend Comparison <span class=text-muted ng-if=\"model.trendData && model.trendData.length\">({{ formatDate(model.trendData[0][0]) }} - {{ formatDate(model.trendData[model.trendData.length-1][0]) }})</span></h3></div><div class=panel-body><div><canvas id=trendChart></canvas></div></div></div></div></div><!-- Loading Indicators --><div ng-show=\"model.loading || model.loadingTrend\" class=text-center><p>Loading data...</p></div><!-- No Data --><div ng-show=\"!model.loading && !model.loadingTrend && !model.visitorData && !model.trendData\" class=\"alert alert-info\"><span class=\"glyphicon glyphicon-info-sign\"></span> Select a date and click Refresh to load visitor data.</div></div>");
$templateCache.put("app/modules/rfid/encodeModal.html","<div class=modal-body>{{tools.lang({\'en\':\'Please take a keycard or bracelet and hold it near the encoder\',\'nl\':\'Gelieve een keycard of armband te nemen en hou het nabij de encoder\',\'fr\':\'Veuillez prendre une keycard ou un bracelet et approchez-le du scanner\'})}}</div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=cancel()>{{tools.lang({\'en\':\'Cancel\',\'nl\':\'Annuleer\',\'fr\':\"J\'ai compris\"})}}</button></div>");
$templateCache.put("app/modules/rfid/retrieveVisit.html","<div ng-controller=RfidRetrieveVisitController class=\"page page-rfid-retrieve-visit page--content\"><div class=row><div class=col-sm-6><h4><button type=button class=\"btn btn-default\" ng-click=visitRetrieve(model.visit.id);><span class=\"glyphicon glyphicon-search\"></span></button> {{contact=model.contacts[model.visit];contact.firstname+(contact.firstname!==\'\'?\' \':\'\')+contact.name}}</h4></div><div class=col-sm-6><button class=\"btn btn-default\" ng-click=createRfidcarrier(); ng-show=\"lobbyProxy.socket!==null\"><span class=\"glyphicon glyphicon-plus-sign\"></span> {{tools.lang({\'en\':\'Pass\',\'nl\':\'Pas\',\'fr\':\'Pass\'})}}</button></div></div><div class=row ng-show=\"lobbyProxy.socket===null\"><p class=\"form-control-static col-sm-4\">{{tools.lang({\'en\':\'outdoorlobbyproxy is not connected\',\'nl\':\'outdoorlobbyproxy is niet verbonden\',\'fr\':\'outdoorlobbyproxy n\\u0020est pas connect\\u00E9\'})}}</p><div class=col-sm-2><button class=\"btn btn-default\" ng-click=lobbyProxy.initWebsocket()>{{tools.lang({\'en\':\'Refresh\',\'nl\':\'Refresh\',\'fr\':\'Refresh\'})}}</button></div></div><div ng-show=\"tools.getLength(model.hotelreservationcategories)>0\"><div class=form-group ng-show=\"lobbyProxy.socket!==null\"><div class=col-sm-2><select class=form-control ng-model=model.hotelreservationcategoryId ng-change=onChangeHotelreservationcategory() ng-disabled=\"model.hotelreservationcategories.length<=1\" ng-options=\"hotelreservationcategory.id as tools.label(parameters.HSC[hotelreservationcategory.requestedhsc]) for hotelreservationcategory in model.hotelreservationcategories\"></select></div><div class=col-sm-2><select class=form-control ng-model=model.hotelspaceassignmentId><option ng-disabled=\"model.hotelspaces[hotelspaceassignment.assignedspace].state!=\'Inspected\'\" value={{hotelspaceassignment.id}} ng-repeat=\"hotelspaceassignment in model.hotelreservationcategories===null?[]:tools.join(model.hotelreservationcategories[model.hotelreservationcategoryId],\'hotelspaceassignments\',model)\">{{model.hotelspaces[hotelspaceassignment.assignedspace].spacenumber+(model.hotelspaces[hotelspaceassignment.assignedspace].state!=\'Inspected\'?\' - \'+model.hotelspaces[hotelspaceassignment.assignedspace].state:\'\')}}</option></select></div><div class=col-sm-2><!--         <button class=\"btn btn-default\" ng-click=\"syncSpaces();\">\n          <span class=\"glyphicon glyphicon glyphicon-refresh\"></span>\n        </button> --> <button class=\"btn btn-default\" ng-disabled=\"model.hotelspaceassignmentId==\'\'\" ng-click=createHotelRfidcarrier();><span class=\"glyphicon glyphicon-plus-sign\"></span> {{tools.lang({\'en\':\'Hotel room key\',\'nl\':\'Sleutel hotelkamer\',\'fr\':\'Cl\\u00E9 chambre d\\u0020hotel\'})}}</button></div></div></div><table class=\"table table-striped table-hover\" ng-show=\"tools.toArray(model.rfidcarriers).length>0\"><thead><tr><th><span class=th__content></span></th><th>{{tools.lang({\'en\':\'All\',\'nl\':\'Alle\',\'fr\':\'Tout les\'})}}<br>{{tools.lang({\'en\':\'activities\',\'nl\':\'activiteiten\',\'fr\':\'activit\\u00E9s\'})}}</th><th>{{tools.lang({\'en\':\'All\',\'nl\':\'Alle\',\'fr\':\'Tout les\'})}}<br>{{tools.lang({\'en\':\'credit\',\'nl\':\'krediet\',\'fr\':\'credits\'})}}</th><th>{{tools.lang({\'en\':\'Postpaid\',\'nl\':\'Postpaid\',\'fr\':\'Postpaid\'})}}</th><th><span class=th__content></span></th></tr></thead><tbody><tr ng-repeat=\"rfidcarrier in tools.toArray(model.rfidcarriers) | orderBy:sortRfidcarriers\" ng-class=\"{\'info\':rfidcarrier.id==model.lastScannedRfidcarrierId}\"><td><div ng-repeat=\"hotelspaceassignment in tools.inverseJoin(tools.join(rfidcarrier,\'rfidhotelspacerights\',model),\'hotelspaceassignments\',\'hotelspaceassignment\',model)\">{{tools.lang({\'en\':\'Room\',\'nl\':\'Kamer\',\'fr\':\'Chambre\'})+\' \'+model.hotelspaces[hotelspaceassignment.assignedspace].spacenumber}}</div><span ng-show=!rfidcarrier.rfidhotelspacerights>{{tools.lang({\'en\':\'Pass\',\'nl\':\'Pas\',\'fr\':\'Pass\'})}}</span></td><td><div class=checkbox><label><input type=checkbox ng-model=rfidcarrier.fullactivityaccess ng-false-value=\"\'0\'\" ng-true-value=\"\'1\'\" ng-change=updateRfidcarrier(rfidcarrier)></label></div></td><td><div class=checkbox><label><input type=checkbox ng-model=rfidcarrier.fullproductaccess ng-false-value=\"\'0\'\" ng-true-value=\"\'1\'\" ng-change=updateRfidcarrier(rfidcarrier)></label></div></td><td><div class=checkbox><label><input type=checkbox ng-model=rfidcarrier.allowpostpaid ng-false-value=\"\'0\'\" ng-true-value=\"\'1\'\" ng-change=updateRfidcarrier(rfidcarrier)></label></div></td><td><button delete ng-click=deleteRfidcarrier(rfidcarrier)></button></td></tr></tbody></table></div>");
$templateCache.put("app/modules/restrictions/restrictionsComponent.html","<div class=form-group ng-repeat=\"orgroup in $ctrl.orgroups\"><label class=col-md-1 ng-show=$ctrl.getEditing()>{{$ctrl.tools.lang({\'en\':\'Condition \',\'nl\':\'Voorwaarde \',\'fr\':\'Condition \'})+($index+1)}}</label><div class=col-md-11><li class=indent ng-class=\"{\'list-group-item\':$ctrl.getEditing()}\"><span ng-hide=$ctrl.getEditing() ng-repeat=\"restriction in orgroup.restrictions | orderBy:$ctrl.sort\"><span ng-show=\"restriction.negation==\'1\'\">{{$ctrl.tools.lang({\'en\':\'not\',\'nl\':\'Niet\',\'fr\':\'Ne pas\'})}}</span> {{$ctrl.tools.label($ctrl.parameters.restrictionBehaviours[restriction.behaviour])}} <span ng-repeat=\"param in $ctrl.parameters.restrictionBehaviours[restriction.behaviour].params\" ng-if=param>{{rstParam=\'param\'+($index+1);params=param.params;$ctrl.tools.label(params);}}: <span ng-if=!param.isArticleKey><span ng-show=\"params.type==\'number\' || params.type==\'text\'\">{{restriction[rstParam]}}</span> <span ng-show=\"params.type==\'param\'\">{{$ctrl.tools.label($ctrl.parameters[params.paramTbl][restriction[rstParam]])}}</span> <span ng-show=\"params.type==\'table\'\">{{$ctrl.tools.first($ctrl.tools.match($ctrl.parameters[params.table],{[params.field]:restriction[rstParam]}))[params.nameField]}}</span> </span><span ng-if=param.isArticleKey>{{articleType=restriction[rstParam][0];parentParam=restriction[rstParam][1];childParam=restriction[rstParam][2];unitParam=restriction[rstParam][3];$ctrl.tools.label($ctrl.articleTypes[articleType])}}: <span ng-if=\"articleType==\'AC\'\">{{childParam!==null?$ctrl.activitiesService.activityDescription({\'frm\':childParam},true):$ctrl.tools.label($ctrl.parameters.ACT[parentParam])}} </span><span ng-if=\"articleType==\'ME\'\">{{$ctrl.tools.label($ctrl.parameters.RES[parentParam])+(childParam!==null?\' \'+$ctrl.tools.label($ctrl.parameters.DSH[childParam]):\'\')}} </span><span ng-if=\"articleType==\'HS\'\">{{$ctrl.tools.label($ctrl.parameters.HTL[parentParam])+(childParam!==null?\' \'+$ctrl.tools.label($ctrl.parameters.HSC[childParam]):\'\')+(unitParam!==null?\' \'+tools.label(parameters.HRA[unitParam]):\'\')}} </span><span ng-if=\"articleType==\'PR\'\">{{$ctrl.tools.label($ctrl.parameters.PRD[parentParam])}} </span></span></span><span ng-hide=$last>- {{$ctrl.tools.lang({\'en\':\'or\',\'nl\':\'of\',\'fr\':\'ou\'})}} -</span></span><div class=form-group ng-show=$ctrl.getEditing() ng-repeat=\"restriction in orgroup.restrictions | orderBy:$ctrl.sort\"><div class=col-md-11><div class=\"form-group clearfix\"><div class=col-xs-8><select class=form-control ng-model=restriction.behaviour ng-change=$ctrl.onRestrictionChange(restriction) ng-options=\"behaviour.id as $ctrl.tools.label(behaviour) for behaviour in $ctrl.tools.match($ctrl.parameters.restrictionBehaviours,{[$ctrl.getBehaviourFilter()]:\'1\',\'del\':\'0\'}) | orderBy: $ctrl.tools.lang({\'en\':\'labelen\',\'nl\':\'labelnl\',\'fr\':\'labelfr\'})\"></select></div><div class=col-xs-4><div class=checkbox><label><input type=checkbox ng-model=restriction.negation ng-false-value=\"\'0\'\" ng-true-value=\"\'1\'\"> <span ng-class=\"{\'text-muted\':restriction.negation==\'1\'}\">{{$ctrl.tools.lang({\'en\':\'Not\',\'nl\':\'Niet\',\'fr\':\'Ne pas\'})}}</span></label></div></div></div><div class=\"form-group clearfix\" ng-show=$ctrl.getEditing()>{{restrictionParam=$ctrl.parameters.restrictionBehaviours[restriction.behaviour].params;\'\';}}<div ng-class=\"{\'col-xs-12\':!restrictionParam.param2,\'col-xs-6\':restrictionParam.param2}\" ng-repeat=\"param in restrictionParam\" ng-if=param><div class=\"form-group clearfix\">{{rstParam=\'param\'+($index+1);params=param.params;\'\';}} <span ng-if=!param.isArticleKey><label class=col-md-1>{{$ctrl.tools.label(params)}}:</label><div class=col-md-11><input class=form-control ng-show=\"params.type==\'number\' || params.type==\'text\'\" ng-model=restriction[rstParam] size=12><select class=form-control ng-show=\"params.type==\'param\'\" ng-model=restriction[rstParam] ng-options=\"prm.id as $ctrl.tools.label(prm) for prm in $ctrl.parameters[\'notDelArray\'+params.paramTbl] | orderBy:\'label\'+$ctrl.user.lang\"></select><select class=form-control ng-show=\"params.type==\'table\'\" ng-model=restriction[rstParam] ng-options=\"record[params.field] as record[params.nameField] for record in $ctrl.tools.toArray($ctrl.parameters[params.table]) | orderBy:params.nameField\"></select></div></span><div class=col-xs-12><div ng-if=param.isArticleKey class=\"form-group clearfix\"><div class=col-md-3><label>{{$ctrl.tools.lang({\'en\':\'Article type\',\'nl\':\'Artikeltype\',\'fr\':\'Type d\\u0027article\'})}}:</label><select class=form-control ng-disabled=!$ctrl.getEditing() ng-model=restriction[rstParam][0] ng-options=\"articleType.id as $ctrl.tools.label(articleType) for articleType in $ctrl.tools.toArray(params)\" ng-change=\"restriction[rstParam][1]=null;restriction[rstParam][2]=null;restriction[rstParam][3]=null;\"></select></div><span ng-show=\"restriction[rstParam][0]!==null\">{{articleType=restriction[rstParam][0];articleTypeParams=params[articleType];parentParamTbl=articleTypeParams.paramTbl;paramClass={\'col-md-3\':articleTypeParams.paramB && articleTypeParams.paramC,\'col-md-4\':articleTypeParams.paramB && !articleTypeParams.paramC,\'col-md-9\':!articleTypeParams.paramB && !articleTypeParams.paramC};\"\";}}<div ng-class=paramClass><label>{{$ctrl.tools.label(articleTypeParams)}}:</label><select class=form-control ng-disabled=!$ctrl.getEditing() ng-model=restriction[rstParam][1] ng-options=\"prm.id as $ctrl.tools.label(prm) for prm in $ctrl.tools.toArray($ctrl.tools.addMatchingElement($ctrl.parameters[parentParamTbl],$ctrl.parameters[\'notDel\'+parentParamTbl],{\'id\':restriction[rstParam][1]})) | orderBy: $ctrl.tools.lang({\'en\':\'labelen\',\'nl\':\'labelnl\',\'fr\':\'labelfr\'})\" ng-change=\"restriction[rstParam][2]=null;restriction[rstParam][3]=null;\"></select></div>{{parentParam=restriction[rstParam][1];paramB=articleTypeParams.paramB;childParamTbl=paramB.paramTbl;\"\";}}<div ng-class=paramClass ng-show=\"paramB && parentParam!=null\"><label>{{$ctrl.tools.label(paramB)}}:</label><select class=form-control ng-disabled=!$ctrl.getEditing() ng-model=restriction[rstParam][2] ng-options=\"prm.id as $ctrl.tools.label(prm) for prm in $ctrl.tools.addElement($ctrl.filterArticles(childParamTbl,\'id\',parentParam,restriction[rstParam][2]),$ctrl.any) | orderBy: $ctrl.tools.lang({\'en\':\'labelen\',\'nl\':\'labelnl\',\'fr\':\'labelfr\'})\" ng-change=\"restriction[rstParam][3]=null;\"></select></div>{{childParam=restriction[rstParam][2];paramC=articleTypeParams.paramC;unitParamTbl=paramC.paramTbl;\"\";}}<div ng-class=paramClass ng-show=\"paramC && parentParam!=null\"><label>{{$ctrl.tools.label(paramC)}}:</label><select class=form-control ng-disabled=!$ctrl.getEditing() ng-model=restriction[rstParam][3] ng-options=\"prm.id as $ctrl.tools.label(prm) for prm in $ctrl.tools.addElement($ctrl.filterArticles(unitParamTbl,\'id\',parentParam,restriction[rstParam][3]),$ctrl.any) | orderBy: $ctrl.tools.lang({\'en\':\'labelen\',\'nl\':\'labelnl\',\'fr\':\'labelfr\'})\"></select></div></span></div></div></div></div></div><div class=form-group><div class=col-xs-12><button type=button class=\"btn btn-default\" ng-click=$ctrl.createRestriction(orgroup.id);>{{$ctrl.tools.lang({\'en\':\'or\',\'nl\':\'of\',\'fr\':\'ou\'})}}</button></div></div></div><div class=col-md-1 ng-show=$ctrl.getEditing()><input class=\"btn btn-danger\" delete ng-click=$ctrl.deleteRestriction(restriction)></div></div></li></div></div><div class=form-group ng-show=$ctrl.getEditing()><div class=col-md-11><button type=button class=\"btn btn-default\" ng-click=$ctrl.createRestriction();><span class=\"glyphicon glyphicon-plus-sign\"></span>&nbsp;{{$ctrl.tools.lang({\'en\':\'Condition\',\'nl\':\'Voorwaarde\',\'fr\':\'Condition\'})}}</button></div></div>");
$templateCache.put("app/modules/rules/listRules.html","<div ng-controller=RulesListRulesController class=\"page page-rules-list-rules page--content\"><div class=col-sm-6><label class=label-control>{{tools.lang({\'en\':\'Choose\',\'nl\':\'Choose\',\'fr\':\'Sélectionner\'})}}</label><select ng-model=model.rut ng-options=\"par.id as tools.label(par) for par in tools.toArray(parameters.notDelRUT)\" ng-change=\"model.filter=\'\';loadRules();\"></select></div><div class=col-sm-6 ng-show=\"model.rut!=\'\' && parameters.RUT[model.rut].field5!=\'\'\"><label for=filters class=label-control>{{tools.lang({\'en\':\'Filters\',\'nl\':\'Filters\',\'fr\':\'Filtrer par :\'})}}</label><select id=filters ng-model=model.filter ng-change=orderRules(); ng-options=\"par.id as tools.label(par) for par in tools.addElement(parameters[\'notDel\'+parameters.RUT[model.rut].field5],any) | orderBy:\'label\'+user.lang\"></select></div><div class=col-sm-12 ng-show=!webservice.calling><div class=table-responsive-wrapper><table ng-show=model.rut class=table><thead><tr><td></td><td ng-show=\"parameters.RUT[model.rut].field1==\'1\' || parameters.notDelRUT[model.rut].field2==\'1\'\"></td><td ng-show=\"parameters.RUT[model.rut].field1==\'1\'\"></td><td ng-show=\"parameters.RUT[model.rut].field2==\'1\'\"></td><td ng-show=\"parameters.RUT[model.rut].field3==\'1\'\"></td><td>{{tools.lang({\'en\':\'Start\',\'nl\':\'Start\',\'fr\':\'Debut\'})}} YYYY-MM-DD</td><td>{{tools.lang({\'en\':\'End\',\'nl\':\'Einde\',\'fr\':\'Fin\'})}} YYYY-MM-DD</td><td><span ng-show=\"model.rut==\'CAP\' || model.rut==\'CPG\'\">{{tools.lang({\'en\':\'Capacity\',\'nl\':\'Capaciteit\',\'fr\':\'Capacité\'})}}</span> <span ng-show=\"model.rut==\'PRI\' || model.rut==\'MPR\' || model.rut==\'PPR\'\">{{tools.lang({\'en\':\'Price\',\'nl\':\'Prijs\',\'fr\':\'Prix\'})}}</span> <span ng-show=\"model.rut==\'SCH\' || model.rut==\'PSC\' || model.rut==\'RSC\' || model.rut==\'ISC\'\">{{tools.lang({\'en\':\'Schedule\',\'nl\':\'Weekschema\',\'fr\':\'Horaire\'})}}</span></td><td class=right></td></tr></thead><tbody ng-repeat=\"rules in orderedRules\"><tr ng-repeat=\"rule in rules\"><td><input edit ng-hide=rule.editing ng-click=editRule(rule)></td><td ng-show=\"parameters.RUT[model.rut].field1==\'1\' || parameters.RUT[model.rut].field2==\'1\'\"><span ng-show=\"parameters.RUT[model.rut].field1==\'1\'\">{{tools.label(parameters.ACT[tools.substr(rule.frm,0,3)])}}</span> <span ng-hide=\"parameters.RUT[model.rut].field1==\'1\'\">{{tools.label(parameters.ACT[tools.substr(rule.unt,0,3)])}}</span></td><td ng-show=\"parameters.RUT[model.rut].field1==\'1\'\">{{tools.label(parameters.FRM[rule.frm])}}</td><td ng-show=\"parameters.RUT[model.rut].field2==\'1\'\">{{tools.label(parameters.UNT[rule.unt])}}</td><td ng-show=\"parameters.RUT[model.rut].field3==\'1\'\">{{rule.free}} {{getFreeLabel(parameters[parameters.RUT[model.rut].field4][rule.free])}}</td><td><span editable editing={{rule.editing}} retrieving={{rule.startdate}}><input type=text ng-model=rule.startdate></span></td><td><span editable editing={{rule.editing}} retrieving={{rule.enddate}}><input type=text ng-model=rule.enddate></span></td><td><span ng-hide=rule.editing><span ng-show=\"rule.rut==\'CAP\' || rule.rut==\'CPG\'\">{{rule.result}}</span> <span ng-show=\"rule.rut==\'PRI\' || model.rut==\'MPR\' || model.rut==\'PPR\'\">{{tools.amountOut(rule.result)}} €</span> <span ng-show=\"rule.rut==\'SCH\' || model.rut==\'PSC\' || model.rut==\'RSC\' || model.rut==\'ISC\'\">{{model.weekschedules[rule.result].wording}}</span> <span ng-show=\"rule.rut==\'HOL\'\"><span ng-show=\"rule.result==\'0\'\">{{tools.lang({\'en\':\'No\',\'nl\':\'Nee\',\'fr\':\'Non\'})}}</span> <span ng-show=\"rule.result==\'1\'\">{{tools.lang({\'en\':\'Yes\',\'nl\':\'Ja\',\'fr\':\'Oui\'})}}</span> </span></span><span ng-show=rule.editing><input ng-show=\"rule.rut==\'CAP\' || rule.rut==\'CPG\'\" type=text ng-model=rule.result> <span ng-show=\"rule.rut==\'PRI\' || model.rut==\'MPR\' || model.rut==\'PPR\'\"><input type=text ng-model=rule.result> €</span><select ng-show=\"rule.rut==\'SCH\' || model.rut==\'PSC\' || model.rut==\'RSC\' || model.rut==\'ISC\'\" ng-model=rule.result ng-options=\"weekschedule.id as weekschedule.wording for weekschedule in tools.toArray(model.weekschedules) | orderBy:\'wording\'\"></select><input ng-show=\"rule.rut==\'HOL\'\" type=checkbox ng-model=rule.result ng-false-value=\"\'0\'\" ng-true-value=\"\'1\'\"></span></td><td><span ng-show=rule.editing><input class=\"btn btn-success\" update ng-click=updateRule(rule)> <input class=\"btn btn-warning\" cancel ng-click=restoreRule(rule)> <input class=\"btn btn-danger\" delete ng-click=deleteRule(rule)></span></td></tr></tbody><tbody><tr><td></td><td ng-show=\"parameters.RUT[model.rut].field1==\'1\' || parameters.RUT[model.rut].field2==\'1\'\"><div ng-dropdown-multiselect=\"\" options=model.actRuleOptionsArray selected-model=model.act extra-settings=model.ruleSettings translation-texts=model.translations events={onSelectionChanged:updateRuleAct}></div></td><td ng-show=\"parameters.RUT[model.rut].field1==\'1\'\"><div ng-dropdown-multiselect=\"\" options=model.frmRuleOptionsArray selected-model=model.frm extra-settings=model.ruleSettings translation-texts=model.translations events={onSelectionChanged:updateRuleFrm}></div></td><td ng-show=\"parameters.RUT[model.rut].field2==\'1\'\"><div ng-dropdown-multiselect=\"\" options=model.untRuleOptionsArray selected-model=model.unt extra-settings=model.ruleSettings translation-texts=model.translations events={onSelectionChanged:updateRuleUnt}></div></td><td ng-show=\"parameters.RUT[model.rut].field3==\'1\'\"><div ng-dropdown-multiselect=\"\" options=model.freeRuleOptionsArray selected-model=model.free extra-settings=model.ruleSettings translation-texts=model.translations events={onSelectionChanged:updateRuleFree}></div></td><td><input type=text ng-model=model.rule.startdate></td><td><input type=text ng-model=model.rule.enddate></td><td><input ng-show=\"model.rut==\'CAP\' || model.rut==\'CPG\'\" type=text ng-model=model.rule.result> <span ng-show=\"model.rut==\'PRI\' || model.rut==\'MPR\' || model.rut==\'PPR\'\"><input type=text ng-model=model.rule.result> €</span><select ng-show=\"model.rut==\'SCH\' || model.rut==\'PSC\' || model.rut==\'RSC\' || model.rut==\'ISC\'\" ng-model=model.rule.result ng-options=\"weekschedule.id as weekschedule.wording for weekschedule in tools.toArray(model.weekschedules) | orderBy:\'wording\'\"></select><input ng-show=\"model.rut==\'HOL\'\" type=checkbox ng-model=model.rule.result ng-false-value=\"\'0\'\" ng-true-value=\"\'1\'\"></td><td><input create ng-click=createRule()></td></tr></tbody></table></div></div><div class=\"content__item page__loader\" ng-show=webservice.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div></div>");
$templateCache.put("app/modules/rules/weekSchedules.html","<div ng-controller=RulesWeekSchedulesController class=\"page page-rules-week-schedules page--content\"><div><select ng-model=model.weekschedule ng-change=loadWeekscheduleentries() ng-options=\"weekschedule as weekschedule.wording for weekschedule in tools.toArray(model.weekschedules) | orderBy:\'wording\'\"></select><span ng-show=model.weekschedule><input edit ng-hide=model.weekschedule.editing ng-click=editWeekschedule()> <span ng-hide=model.weekschedule.editing>{{model.weekschedule.wording}}</span> <span ng-show=model.weekschedule.editing><input type=text ng-model=model.weekschedule.wording> </span><span ng-show=model.weekschedule.editing><input class=\"btn btn-warning\" cancel ng-click=restoreWeekschedule()> <input class=\"btn btn-success\" update ng-click=updateWeekschedule()> <input class=\"btn btn-danger\" delete ng-click=deleteWeekschedule()> </span></span>{{tools.lang({\'en\':\'New\',\'nl\':\'Nieuw\',\'fr\':\'Nouveau\'})}}: <input create ng-click=createWeekschedule()></div><form class=form-horizontal><div class=\"form-group clearfix\"><label class=col-sm-3>{{tools.lang({\'en\':\'Message when closed\',\'nl\':\'Bericht indien gesloten\',\'fr\':\'Message quand ferm\\u00E9\'})}}</label><div class=col-sm-3><input type=text autocomplete=off class=form-control ng-readonly=!model.weekschedule.editing ng-model=model.weekschedule.closedmessageen placeholder=English></div><div class=col-sm-3><input type=text autocomplete=off class=form-control ng-readonly=!model.weekschedule.editing ng-model=model.weekschedule.closedmessagenl placeholder=Nederlands></div><div class=col-sm-3><input type=text autocomplete=off class=form-control ng-readonly=!model.weekschedule.editing ng-model=model.weekschedule.closedmessagefr placeholder=Francais></div></div><div class=\"form-group clearfix\"><label class=col-sm-3>{{tools.lang({\'en\':\'Message priority\',\'nl\':\'Bericht prioriteit\',\'fr\':\'Message priorit\\u00E9\'})}}</label><div class=col-sm-3><input type=text autocomplete=off class=form-control ng-readonly=!model.weekschedule.editing ng-model=model.weekschedule.closedmessageprio></div><div class=col-sm-6><div class=checkbox><label><input type=checkbox ng-model=model.weekschedule.showavailablefrom ng-false-value=\"\'0\'\" ng-true-value=\"\'1\'\" ng-disabled=!model.weekschedule.editing> {{tools.lang({\'en\':\'Show \\\"Available from...\\\"\',\'nl\':\'Toon \\\"Beschikbaar vanaf...\\\"\',\'fr\':\'Montrer \\\"Disponible a partir de...\\\"\'})}}</label></div></div></div></form><div class=table-responsive-wrapper><table ng-show=model.weekschedule class=table style=\"border-collapse: separate; border-spacing: 0\"><thead><tr class=head style=width:100%><th style=\"position: sticky;z-index: 2;top: -16px;left: -16px;background-color:#f6f6f7;width: 5.5%\"><span class=th__content></span></th><th style=\"position: sticky;z-index: 1;top: -16px;background-color:#f6f6f7;width: 13.5%\" ng-repeat=\"day in tools.toArray(parameters.DAY)\"><button class=\"btn btn-default\" ng-click=toggleWeekscheduleDayentry(day.id) style=\"height: 100%; width:100%; overflow-wrap: break-word;white-space: normal\">{{tools.label(day)}}</button></th></tr></thead><tbody><tr ng-repeat=\"hrs in tools.toArray(parameters.HRS)\" ng-class=\"{\'last\':$last}\" ng-class-even=\"\'even\'\" ng-class-odd=\"\'odd\'\"><td style=\"position: sticky;z-index: 1;left: -16px;padding: 4px;height: 30px !important\" ng-click=toggleWeekscheduleHrsentry(hrs.id)><button class=\"btn btn-default\" ng-click=toggleWeekscheduleDayentry(day.id) style=\"height: 100%; width:95%;overflow-wrap: break-word;white-space: normal;padding: 0px 4px\">{{tools.label(hrs)}}</button></td><td ng-repeat=\"day in tools.toArray(parameters.DAY)\" ng-class=\"{\'hasCombination\':sortedWeekscheduleentries[day.id][hrs.id]==\'0\',\'orangeCombination\':sortedWeekscheduleentries[day.id][hrs.id]==\'1\'}\" style=\"padding: 4px;height: 30px !important; text-align: center;justify-content: space-around\" ng-mouseenter=\"model.hover=day.id+hrs.id\" ng-mouseleave=\"model.hover=\'\'\"><button class=btn ng-class=\"{\'btn-error\':sortedWeekscheduleentries[day.id][hrs.id]==\'1\',\'btn-warning\':sortedWeekscheduleentries[day.id][hrs.id]==\'0\',\'btn-success\':sortedWeekscheduleentries[day.id][hrs.id]==\'\'}\" ng-click=toggleWeekscheduleentry(day.id,hrs.id); ng-show=\"day.id+hrs.id==model.hover\" style=\"height: 90%; text-align: center; width:70%;padding: 0px 4px;font-size: 12px\"><span class=\"glyphicon glyphicon-pencil\"></span></button></td></tr></tbody></table></div></div>");
$templateCache.put("app/modules/settings/campaigns.html","<div ng-controller=SettingsCampaignsController class=\"page page-settings-campaigns page--content\"><div ng-repeat=\"campaign in model.campaigns\"><input edit ng-hide=campaign.editing ng-click=editCampaign(campaign)> code: <span editable editing={{campaign.editing}} retrieving=\"{{\' \'+campaign.code+\' \'}}\"><input type=text ng-model=campaign.code size=12> </span>suffix: <span editable editing={{campaign.editing}} retrieving=\"{{\' \'+campaign.suffix+\' \'}}\"><input type=text ng-model=campaign.suffix size=12> </span>name: <span editable editing={{campaign.editing}} retrieving=\"{{\' \'+campaign.description+\' \'}}\"><input type=text ng-model=campaign.description size=12> </span>start: <span editable editing={{campaign.editing}} retrieving=\"{{\' \'+campaign.startdate+\' \'}}\"><input type=text ng-model=campaign.startdate jqui-datepicker> </span>end: <span editable editing={{campaign.editing}} retrieving=\"{{\' \'+campaign.enddate+\' \'}}\"><input type=text ng-model=campaign.enddate jqui-datepicker> </span><input delete ng-hide=campaign.editing ng-click=deleteCampaign(campaign)> <span ng-show=campaign.editing><input class=\"btn btn-success\" update ng-click=replaceCampaign(campaign)> <input class=\"btn btn-warning\" cancel ng-click=cancelCampaign(campaign)></span></div><div>{{tools.lang({\'en\':\'Create campaign\',\'nl\':\'Campagne aanmaken\',\'fr\':\"Ajouter une campagne\"})}}: <input create ng-click=createCampaign();></div></div>");
$templateCache.put("app/modules/settings/consolidation.html","<div ng-controller=SettingsConsolidationController class=\"page page--content page-settings-consolidation\"><form class=form-horizontal><div class=\"form-group clearfix\"><label class=\"col-xs-12 col-lg-2 control-label\"><span>{{tools.lang({\'en\':\'Synchronise\',\'nl\':\'Syncrhoniseren\',\'fr\':\'Synchroniser\'})}}</span></label><div class=\"col-xs-6 col-lg-1\"><select class=form-control ng-model=model.syncMode ng-change=setDateOptions() ng-options=\"syncMode.id as tools.label(syncMode) for syncMode in syncModes\"></select></div><div class=\"col-xs-6 col-lg-2\"><p class=\"input-group mt-1\"><span class=input-group-btn uib-datepicker-popup ng-model=model.syncDate is-open=model.syncDateOpened datepicker-options=model.dateOptions ng-change=cleanSyncDate()><button type=button class=\"btn btn-default\" ng-click=\"model.syncDateOpened=!model.syncDateOpened\"><i class=\"glyphicon glyphicon-calendar\"></i></button> </span><input type=text class=form-control ng-model=model.cleanSyncDate ng-update=model.cleanSyncDateToDate() ng-click=\"model.syncDateOpened=!model.syncDateOpened\"></p></div><div class=\"col-xs-12 col-lg-7 mt-1\"><div ng-hide=\"webservice.calling || model.synchronising\"><button class=\"btn btn-primary\" ng-click=confirmSyncEntrylines(null);>{{tools.lang({\'en\':\'Synchronise\',\'nl\':\'Syncrhoniseren\',\'fr\':\'Synchroniser\'})}}</button></div><div class=page__loader ng-show=\"webservice.calling || model.synchronising\"><div class=lds-ring><div></div><div></div><div></div><div></div></div></div></div></div><div class=\"form-group clearfix\"><label for=approvedMonth class=\"col-xs-12 col-sm-2 control-label\"><span>{{tools.lang({\'en\':\'Approved until\',\'nl\':\'Goedgekeurd tot\',\'fr\':\'Confirm\\u00E9 jusqu\\u0027au\'})}}</span></label><div class=col-xs-10><input type=text autocomplete=off id=approvedMonth class=form-control placeholder=YYYY-MM ng-model=model.approvedMonth ng-change=updateApprovedMonth()></div></div><div class=\"form-group clearfix\"><label class=\"col-xs-12 col-sm-2 control-label\">{{tools.lang({\'en\':\'Report\',\'nl\':\'Rapport\',\'fr\':\'Rapport\'})}}</label><div class=col-sm-10><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"rpt in parameters.notDelArrayRPT\" ng-click=\"model.rpt=rpt.id;\" ng-class=\"{\'active\':model.rpt==rpt.id}\">{{tools.label(rpt)}}</button></div></div></div><div class=\"panel panel-default\"><uib-tabset active=\"model[\'ActiveTab\']\" class=\"mb-2 tabs\"><uib-tab index=0 heading=\"{{tools.lang({\'en\':\'Edit\',\'nl\':\'Bewerken\',\'fr\':\'Modifier\'})}}\" select=\"selectTab(\'edit\')\"></uib-tab><uib-tab index=1 heading=\"{{tools.lang({\'en\':\'Layout\',\'nl\':\'Opmaak\',\'fr\':\'Mise en page\'})}}\" select=\"selectTab(\'layout\')\"></uib-tab></uib-tabset><div ng-repeat=\"colrow in zeroOrOne\"><h4><span ng-show=\"colrow==\'0\'\">{{tools.lang({\'en\':\'Columns\',\'nl\':\'Kolommen\',\'fr\':\'Colonnes\'})}} </span><span ng-show=\"colrow==\'1\'\">{{tools.lang({\'en\':\'Rows\',\'nl\':\'Rijen\',\'fr\':\'Lignes\'})}} </span><button type=button class=\"btn btn-default\" ng-repeat=\"aggreg in zeroOrOne\" ng-click=createConsparam(colrow,aggreg)><span class=\"glyphicon glyphicon-plus-sign\"></span> {{tools.lang({\'en\':\'Add\',\'nl\':\'\',\'fr\':\'Ajouter\'})}} <span ng-show=\"aggreg==\'1\'\">{{tools.lang({\'en\':\'aggregate\',\'nl\':\'aggregaat\',\'fr\':\'\'})}}</span> <span ng-show=\"colrow==\'0\'\">{{tools.lang({\'en\':\'column\',\'nl\':\'kolom\',\'fr\':\'colonne\'})}}</span> <span ng-show=\"colrow==\'1\'\">{{tools.lang({\'en\':\'row\',\'nl\':\'rij\',\'fr\':\'ligne\'})}}</span> <span ng-show=\"aggreg==\'1\'\">{{tools.lang({\'en\':\'\',\'nl\':\'\',\'fr\':\'agr\\u00E9gat\'})}}</span> {{tools.lang({\'en\':\'\',\'nl\':\'toevoegen\',\'fr\':\'\'})}}</button></h4><ul class=list-group><li class=\"list-group-item row\" ng-repeat=\"consparam in tools.match(model.consparams,{\'colrow\':colrow}) | orderBy:\'sort\':false\"><div class=\"form-group clearfix\"><div class=col-sm-2 ng-show=\"colrow===\'0\'\"><input type=text class=form-control ng-model=consparam.parent ng-disabled=!consparam.editing placeholder=\"{{tools.lang({\'en\':\'Header\',\'nl\':\'Header\',\'fr\':\'Header\'})}}\"></div><div class=col-sm-2><input type=text class=form-control ng-model=consparam.label ng-disabled=!consparam.editing placeholder=\"{{tools.lang({\'en\':\'Label\',\'nl\':\'Label\',\'fr\':\'Label\'})}}\"></div><div ng-class=\"{\'col-sm-5\':colrow===\'0\' && model.activeTab==\'edit\',\'col-sm-6\':colrow===\'1\' && consparam.aggreg==\'1\' && model.activeTab==\'edit\',\'col-sm-7\':colrow===\'1\' && consparam.aggreg==\'0\' && model.activeTab==\'edit\',\'col-sm-3\':colrow===\'1\' && model.activeTab==\'layout\',\'col-sm-1\':colrow===\'0\' && model.activeTab==\'layout\'}\"><input type=text class=form-control ng-show=\"consparam.aggreg==\'0\' && model.activeTab==\'edit\'\" ng-model=consparam.regexpr ng-disabled=!consparam.editing placeholder=\"{{tools.lang({\'en\':\'Regular expression\',\'nl\':\'Regular expression\',\'fr\':\'Regular expression\'})}}\"> <span ng-show=\"consparam.aggreg==\'1\'\">{{tools.lang({\'en\':\'Aggregate\',\'nl\':\'Aggregaat\',\'fr\':\'Aggregat\'})}}</span></div><div class=col-sm-1 ng-show=\"colrow===\'1\' && consparam.aggreg==\'1\' && model.activeTab==\'edit\'\"><input type=text class=form-control ng-model=consparam.aglevel ng-disabled=!consparam.editing placeholder=\"{{tools.lang({\'en\':\'Level\',\'nl\':\'Level\',\'fr\':\'Level\'})}}\"></div><div class=col-sm-1 ng-show=\"model.activeTab==\'edit\'\"><div class=checkbox ng-show=\"consparam.aggreg==\'0\' || colrow===\'1\'\"><label><input type=checkbox ng-model=consparam.invert ng-disabled=\"!consparam.editing || consparam.agpercentage==\'0\'\" ng-false-value=\"\'0\'\" ng-true-value=\"\'1\'\"> {{tools.lang({\'en\':\'Inverse\',\'nl\':\'Inverse\',\'fr\':\'Inverse\'})}}</label></div><input type=text ng-show=\"colrow===\'0\' && consparam.aggreg==\'1\'\" class=form-control ng-model=consparam.aglevel ng-disabled=!consparam.editing placeholder=\"{{tools.lang({\'en\':\'Level\',\'nl\':\'Level\',\'fr\':\'Level\'})}}\"><div class=checkbox ng-show=\"colrow===\'1\' && consparam.aggreg==\'1\'\"><label><input type=checkbox ng-model=consparam.agpercentage ng-disabled=!consparam.editing ng-false-value=\"\'0\'\" ng-true-value=\"\'1\'\" ng-change=\"consparam.invert=consparam.agpercentage==\'0\'?\'0\':consparam.invert\"> {{tools.lang({\'en\':\'Percentage\',\'nl\':\'Percentage\',\'fr\':\'Percentage\'})}}</label></div></div><div class=col-sm-2 ng-show=\"model.activeTab==\'layout\'\"><div class=checkbox><label><input type=checkbox ng-model=consparam.colors ng-disabled=!consparam.editing ng-false-value=\"\'0\'\" ng-true-value=\"\'1\'\"> {{tools.lang({\'en\':\'Colors\',\'nl\':\'Kleuren\',\'fr\':\'Couleurs\'})}}</label></div></div><div class=col-sm-3 ng-show=\"model.activeTab==\'layout\'\"><div class=checkbox><label><input type=checkbox ng-model=consparam.bold ng-disabled=!consparam.editing ng-false-value=\"\'0\'\" ng-true-value=\"\'1\'\"> {{tools.lang({\'en\':\'Bold\',\'nl\':\'Vet\',\'fr\':\'Gras\'})}}</label></div></div><div class=col-sm-2><span ng-show=!consparam.editing><input arrowup ng-click=swapConsparam(consparam,-1)> <input arrowdown ng-click=swapConsparam(consparam,1)> <input edit ng-click=editConsparam(consparam)> </span><span ng-show=consparam.editing><input class=\"btn btn-success\" update ng-click=updateConsparam(consparam)> <input class=\"btn btn-warning\" cancel ng-click=cancelConsparam(consparam)> <input class=\"btn btn-danger\" delete ng-click=deleteConsparam(consparam)></span></div></div></li></ul></div></div></form></div>");
$templateCache.put("app/modules/settings/consolidationRights.html","<div ng-controller=SettingsConsolidationRightsController class=\"page page-settings-consolidation-rights page--content\"><div class=\"form-group clearfix\"><label class=\"col-xs-12 col-sm-2 control-label\">{{tools.lang({\'en\':\'Filter\',\'nl\':\'Filter\',\'fr\':\'Filter\'})}}</label><div class=col-sm-10><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"rpt in parameters.notDelArrayRPT\" ng-click=\"model.rpt=rpt.id;\" ng-class=\"{\'active\':model.rpt==rpt.id}\">{{tools.label(rpt)}}</button></div></div></div><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><thead><tr><th><span class=th__content></span></th><th ng-repeat=\"consparam in model.consparamArray\" ng-show=\"consparam.rpt===model.rpt\"><div>{{consparam.parent}}</div><div>{{consparam.label}}</div></th></tr></thead><tbody><tr ng-repeat=\"rgh in model.rghArray\"><td>{{tools.label(rgh)}}</td><td ng-repeat=\"consparam in model.consparamArray\" ng-show=\"consparam.rpt===model.rpt\" ng-class=\"{\'success\':model.cells[rgh.id][consparam.id].exists}\" ng-mouseenter=enterCell(rgh.id,consparam.id) ng-mouseleave=clearHover(rgh.id,consparam.id)><div ng-show=model.cells[rgh.id][consparam.id].hover><input create ng-click=create(rgh.id,consparam.id); ng-hide=model.cells[rgh.id][consparam.id].exists> <input class=\"btn btn-danger\" delete ng-click=delete(rgh.id,consparam.id); ng-show=model.cells[rgh.id][consparam.id].exists></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/modules/settings/editFormbutton.html","<div ng-controller=EditFormbuttonController class=\"page page--content page-edit-formbutton\"><form class=form-horizontal ng-show=!webservice.calling><div class=\"form-group clearfix\"><div class=\"col-sm-10 col-sm-offset-2\">{{tools.label(parameters.FFO[model.formbutton.fca.substr(0,2)])+\' \'+tools.label(parameters.FCA[model.formbutton.fca])}}</div></div><div class=\"form-group clearfix\"><label class=\"col-md-2 control-label\" for=startdate>{{tools.lang({\'en\':\'Start date\',\'nl\':\'Startdatum\',\'fr\':\'Date debut\'})}}</label><div class=col-md-4><p class=input-group ng-click=\"model.startdateOpened=!model.startdateOpened\"><input id=startdate type=text autocomplete=off class=form-control uib-datepicker-popup ng-model=model.formbutton.startdate is-open=model.startdateOpened datepicker-options=dateOptions> <span class=input-group-btn><button type=button class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><label class=\"col-md-2 control-label\" for=enddate>{{tools.lang({\'en\':\'End date\',\'nl\':\'Einddatum\',\'fr\':\'Date fin\'})}}</label><div class=col-md-4><p class=input-group ng-click=\"model.enddateOpened=!model.enddateOpened\"><input id=enddate type=text autocomplete=off class=form-control uib-datepicker-popup ng-model=model.formbutton.enddate is-open=model.enddateOpened datepicker-options=dateOptions> <span class=input-group-btn><button type=button class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"form-group clearfix\"><label class=\"col-md-2 control-label\" for=pricecode>{{tools.lang({\'en\':\'Price code\',\'nl\':\'Prijs code\',\'fr\':\'Code prix\'})}}</label><div class=col-md-2><div class=btn-group id=pricecode><button type=button class=\"btn btn-default\" ng-repeat=\"cat in pricekeyCategories\" ng-click=updateFormbuttonPriceCat(cat.id); ng-class=\"{\'active\':model.formbutton.priceCat==cat.id}\">{{tools.label(cat)}}</button></div></div><div ng-show=\"model.formbutton.priceCat==\'AC\'\"><div class=col-md-2><select class=form-control ng-model=model.formbutton.priceAct ng-change=updateFormbuttonPriceAct(); ng-options=\"row.id as tools.label(row) for row in tools.addElement(parameters.combinationFilter(parameters.notDelACT,\'VISACTA\',\'PUB\'),zero) | orderBy:\'label\'+user.lang\"></select></div><div class=col-md-2><select class=form-control ng-model=model.formbutton.priceFrm ng-change=updateFormbuttonPricekeyActivity(); ng-options=\"row.id as tools.label(row) for row in tools.addElement(activitiesService.activityFilter(parameters.notDelFRM,\'id\',model.formbutton.priceAct),zero) | orderBy:\'label\'+user.lang\"></select></div><div class=col-md-2><select class=form-control ng-model=model.formbutton.priceUnt ng-change=updateFormbuttonPricekeyActivity(); ng-options=\"row.id as tools.label(row) for row in tools.addElement(activitiesService.activityFilter(parameters.notDelUNT,\'id\',model.formbutton.priceAct),zero) | orderBy:\'label\'+user.lang\"></select></div></div><div ng-show=\"model.formbutton.priceCat==\'ME\'\"><div class=col-md-2><select class=form-control ng-model=model.formbutton.priceRes ng-change=updateFormbuttonPriceRes(); ng-options=\"row.id as tools.label(row) for row in tools.addElement(parameters.notDelArrayRES,zero) | orderBy:\'label\'+user.lang\"></select></div><div class=col-md-2><select class=form-control ng-model=model.formbutton.priceDshCat ng-change=updateFormbuttonPriceDshCat(); ng-options=\"dshCat as dshCat for dshCat in getDishCategories()\"></select></div><div class=col-md-2><select class=form-control ng-model=model.formbutton.priceDsh ng-change=updateFormbuttonPricekeyMeal(); ng-options=\"row.id as tools.label(row) for row in tools.addElement(getDishes(),zero) | orderBy:\'label\'+user.lang\"></select></div></div><div ng-show=\"model.formbutton.priceCat==\'HS\'\"><div class=col-md-2><select class=form-control ng-model=model.formbutton.priceHtl ng-change=updateFormbuttonPriceHtl(); ng-options=\"row.id as tools.label(row) for row in tools.addElement(parameters.notDelArrayHTL,zero) | orderBy:\'label\'+user.lang\"></select></div><div class=col-md-2><select class=form-control ng-model=model.formbutton.priceHsc ng-change=updateFormbuttonPricekeyHotelstay(); ng-options=\"hsc.id as tools.label(hsc) for hsc in tools.addElement(getHotelspaces(),zero) | orderBy:\'label\'+user.lang\"></select></div><div class=col-md-2><select class=form-control ng-model=model.formbutton.priceHra ng-change=updateFormbuttonPricekeyHotelstay(); ng-options=\"hra.id as tools.label(hra) for hra in tools.addElement(getHotelrates(),zero) | orderBy:\'label\'+user.lang\"></select></div><div class=col-md-2><select class=form-control ng-model=model.formbutton.priceCityTax ng-change=updateFormbuttonPricekeyHotelstay(); ng-options=\"row.id as tools.label(row) for row in cityTaxCategories | orderBy:\'label\'+user.lang\"></select></div></div></div><div class=\"form-group clearfix\"><div class=\"col-xs-10 col-xs-offset-2\"><div class=checkbox><label><input id=clearbasket type=checkbox ng-false-value=\"\'0\'\" ng-true-value=\"\'1\'\" ng-model=model.formbutton.clearbasket ng-change=\"updateFormbutton(\'clearbasket\');\"> {{tools.lang({\'en\':\'Ignore previous buttons (included in pack)\',\'nl\':\'Negeer vorige knoppen (inbegrepen in pack)\',\'fr\':\'Ignorer boutons precedentes (inclus dans pack)\'})}}</label></div></div></div><div class=\"form-group clearfix\"><div class=\"col-xs-10 col-xs-offset-2\"><div class=checkbox><label><input id=singlequantity type=checkbox ng-false-value=\"\'0\'\" ng-true-value=\"\'1\'\" ng-model=model.formbutton.singlequantity ng-change=\"updateFormbutton(\'singlequantity\');\"> {{tools.lang({\'en\':\'Is a pack\',\'nl\':\'Is een pack\',\'fr\':\'Est un pack\'})}}</label></div></div></div><div class=\"form-group clearfix\" ng-show=\"model.formbutton.singlequantity===\'1\'\"><label class=col-md-2 for=minpackquantity>{{tools.lang({\'en\':\'Minimum packs quantity\',\'nl\':\'Minimum hoeveelheid packs\',\'fr\':\'Quantit\\u00E9 minimale paquets\'})}}</label><div class=col-md-4><div class=input-group><div class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=\"model.formbutton.minpackquantity=tools.amountIn(model.formbutton.minpackquantity)-1;updateFormbutton(\'minpackquantity\');\">-</button></div><input id=minpackquantity type=text autocomplete=off style=\"padding: 6px 12px\" ng-model=model.formbutton.minpackquantity readonly><div class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=\"model.formbutton.minpackquantity=tools.amountIn(model.formbutton.minpackquantity)+1;updateFormbutton(\'minpackquantity\');\">+</button></div></div></div></div><div class=\"form-group clearfix\" ng-show=\"hasPeopleQuantityMultiplier() && !hasArticleType(\'HS\')\"><label class=col-md-2 ng-repeat-start=\"peopleMultiplier in peopleMultipliers\" for={{peopleMultiplier.id}}>{{tools.label(peopleMultiplier)}}</label><div class=col-md-2><select class=form-control ng-model=model.formbutton[peopleMultiplier.behaviour] ng-options=\"row.id as tools.label(row) for row in tools.toArray(occupantcountbehaviourOptions)\" ng-change=updateFormbutton(peopleMultiplier.id);></select></div><div class=col-md-2 ng-repeat-end><div class=input-group><div class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=\"model.formbutton[peopleMultiplier.count]=tools.amountIn(model.formbutton[peopleMultiplier.count])-1;updateFormbutton(peopleMultiplier.id);\">-</button></div><input id={{peopleMultiplier.id}} type=text autocomplete=off style=\"padding: 6px 12px\" ng-model=model.formbutton[peopleMultiplier.count] readonly><div class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=\"model.formbutton[peopleMultiplier.count]=tools.amountIn(model.formbutton[peopleMultiplier.count])+1;updateFormbutton(peopleMultiplier.id);\">+</button></div></div></div></div><div class=\"form-group clearfix\" ng-show=\"model.formbutton.singlequantity===\'1\'\"><div class=col-md-3 ng-repeat=\"formbuttonLabel in formbuttonLabels\" for={{formbuttonLabel.id}}><input id={{formbuttonLabel.id}} type=text autocomplete=off class=form-control ng-model=model.formbutton[formbuttonLabel.id] placeholder={{formbuttonLabel.placeholder}}></div><div class=col-md-3><button class=\"btn btn-default\" ng-click=\"updateFormbutton(\'labelen\');\"><span class=\"glyphicon glyphicon-ok\"></span>&nbsp; {{tools.lang({\'en\':\'Save\',\'nl\':\'Opslaan\',\'fr\':\'Enregistrer\'})}}</button></div></div><div class=\"form-group clearfix\"><div class=\"col-xs-4 col-xs-offset-2\"><div class=checkbox><label><input id=hasfixeddate type=checkbox ng-false-value=\"\'0\'\" ng-true-value=\"\'1\'\" ng-model=model.formbutton.hasfixeddate ng-change=\"updateFormbutton(\'hasfixeddate\');\"> {{tools.lang({\'en\':\'Has a fixed date\',\'nl\':\'Heeft een vaste datum\',\'fr\':\'A une date fixe\'})}}</label></div></div></div><div class=\"form-group clearfix\" ng-show=\"model.formbutton.hasfixeddate==\'1\'\"><label class=\"col-md-2 control-label\" for=fixedstartdate>{{tools.lang({\'en\':\'Fixed start date\',\'nl\':\'Vaste startdatum\',\'fr\':\'Date d\\u00E9but fixe\'})}}</label><div class=col-md-4><p class=input-group ng-click=\"model.fixedstartdateOpened=!model.fixedstartdateOpened\"><input id=fixedstartdate type=text autocomplete=off class=form-control uib-datepicker-popup ng-model=model.formbutton.fixedstartdate is-open=model.fixedstartdateOpened datepicker-options=dateOptions> <span class=input-group-btn><button type=button class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><label class=\"col-md-2 control-label\" for=fixedenddate>{{tools.lang({\'en\':\'Fixed end date\',\'nl\':\'Vaste einddatum\',\'fr\':\'Date fin fixe\'})}}</label><div class=col-md-4><p class=input-group ng-click=\"model.fixedenddateOpened=!model.fixedenddateOpened\"><input id=fixedenddate type=text autocomplete=off class=form-control uib-datepicker-popup ng-model=model.formbutton.fixedenddate is-open=model.fixedenddateOpened datepicker-options=dateOptions> <span class=input-group-btn><button type=button class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"form-group clearfix\"><label class=\"col-md-2 control-label\" for=dayduration>{{tools.lang({\'en\':\'Only visible if this number of days\',\'nl\':\'Enkel zichtbaar indien dit aantal dagen\',\'fr\':\'Seulement visible si ce nombre de jours\'})}}</label><div class=col-md-4><select id=dayduration class=form-control ng-model=model.formbutton.dayduration ng-change=\"updateFormbutton(\'dayduration\');\" ng-options=\"row.id as tools.label(row) for row in model.daydurations | orderBy:\'order\'\"></select></div><span ng-show=\"tools.getLength(filteredFin(model.formbutton))>1\"><label class=\"col-md-2 control-label\" for=fixeddateinterval>{{tools.lang({\'en\':\'Only visible if this interval\',\'nl\':\'Enkel zichtbaar indien dit interval\',\'fr\':\'Seulement visible si ce interval\'})}}</label><div class=col-md-4><select id=fixeddateinterval class=form-control ng-model=model.formbutton.fixeddateinterval ng-change=\"updateFormbutton(\'fixeddateinterval\');\" ng-options=\"row.id as tools.label(row) for row in tools.addElement(filteredFin(model.formbutton),always) | orderBy:\'field3\'\"></select></div></span></div><div class=\"panel panel-default\"><div class=panel-heading><h4 class=panel-title ng-init=\"links.open=false\" ng-click=\"links.open=!links.open\" data-toggle=collapse data-target=#collapseUrls>{{tools.lang({\'en\':\'Links\',\'nl\':\'Links\',\'fr\':\'Liens\'})}} <span ng-show=links.open class=\"glyphicon glyphicon-chevron-up\"></span> <span ng-hide=links.open class=\"glyphicon glyphicon-chevron-down\"></span></h4></div><div class=panel-body uib-collapse=!links.open><div class=\"form-group clearfix\"><label class=\"col-md-2 control-label\" for=sellingMethod>{{tools.lang({\'en\':\'Selling mode\',\'nl\':\'Verkoop methode\',\'fr\':\'Methode de vente\'})}}</label><div class=col-md-10><div class=btn-group id=sellingMethod><button type=button class=btn ng-repeat=\"sellingMethod in sellingMethodOptions\" ng-click=\"model.sellingMethod=sellingMethod.id;\" ng-class=\"{\'active\':model.sellingMethod==sellingMethod.id,\'btn-warning\':sellingMethod.isKioskMode && sellingMethod.isSpecific,\'btn-default\':!sellingMethod.isKioskMode || !sellingMethod.isSpecific}\" uib-tooltip={{getSellingMethodTooltip(sellingMethod)}} tooltip-placement=bottom tooltip-popup-delay=250 tooltip-class=info tooltip-append-to-body=true>{{tools.label(sellingMethod)}}&nbsp;<span class=\"glyphicon glyphicon-warning-sign\" ng-show=\"sellingMethod.isKioskMode && sellingMethod.isSpecific\"></span></button></div></div></div><div class=\"form-group clearfix\" ng-repeat-start=\"option in personalizationOptions\"><label class=control-label ng-class=\"{\'col-md-10 col-md-offset-2\':option.type===\'checkbox\',\'col-md-2\':option.type!==\'checkbox\'}\" for={{option.id}}><span ng-hide=\"option.type===\'checkbox\'\">{{tools.label(option)}}</span> <input ng-show=\"option.type===\'checkbox\'\" type=checkbox ng-model=model[option.id]> <span ng-show=\"option.type===\'checkbox\'\">{{tools.label(option)}}</span></label><div class=col-md-10 id={{option.id}} ng-show=\"option.type!==\'checkbox\'\"><div class=btn-group ng-show=\"option.type===\'stateParamFields\'\"><button type=button class=\"btn btn-default\" ng-repeat=\"stateParamField in option.stateParamFields\" ng-click=addStateParamField(stateParamField,option); ng-class=\"{\'active\':model.stateParamFields[option.id][stateParamField.id]!==undefined}\">{{tools.label(stateParamField)}}</button></div><select class=form-control ng-show=\"option.type==\'param\'\" ng-model=model[option.id] ng-options=\"prm.id as tools.label(prm) for prm in tools.addElement(parameters[\'notDelArray\'+option.paramTbl],empty) | orderBy:\'label\'+user.lang\"></select><select class=form-control ng-show=\"option.type==\'table\'\" ng-model=model[option.id] ng-options=\"record[option.field] as record[option.nameField] for record in tools.addElement(parameters[option.table],empty) | orderBy:option.nameField\"></select></div></div><div class=\"form-group clearfix\" ng-repeat-end ng-show=\"option.type===\'stateParamFields\'\" ng-repeat=\"stateParam in model.stateParamFields[option.id]\"><label class=\"col-md-2 control-label\" ng-class=\"{\'col-md-offset-2\':stateParam.type===\'checkbox\'}\" for={{stateParam.id}}><span ng-hide=\"stateParam.type===\'checkbox\'\">{{tools.label(stateParam)}}</span> <input ng-show=\"stateParam.type===\'checkbox\'\" type=checkbox ng-model=model.stateParamFields[option.id][stateParam.id].value> <span ng-show=\"stateParam.type===\'checkbox\'\">{{tools.label(stateParam)}}</span></label><div class=col-md-10 id={{stateParam.id}} ng-show=\"stateParam.type!==\'checkbox\'\"><input class=form-control ng-show=\"stateParam.type==\'number\' || stateParam.type==\'text\'\" ng-model=model.stateParamFields[option.id][stateParam.id].value size=12><select class=form-control ng-show=\"stateParam.type==\'param\'\" ng-model=model.stateParamFields[option.id][stateParam.id].value ng-options=\"prm.id as tools.label(prm) for prm in tools.addElement(parameters[\'notDelArray\'+stateParam.paramTbl],empty) | orderBy:\'label\'+user.lang\"></select><select class=form-control ng-show=\"stateParam.type==\'table\'\" ng-model=model.stateParamFields[option.id][stateParam.id].value ng-options=\"record[stateParam.field] as record[stateParam.nameField] for record in tools.addElement(parameters[stateParam.table],empty) | orderBy:stateParam.nameField\"></select></div></div><div class=\"form-group clearfix\" ng-repeat=\"lang in parameters.languages\"><div class=col-xs-12><div class=input-group><span class=input-group-btn><button class=\"btn btn-default\" ngclipboard data-clipboard-target=\"#{{\'copyLink\'+lang}}\"><span class=\"glyphicon glyphicon-copy\"></span>&nbsp; {{tools.lang({\'en\':\'Copy to clipboard\',\'nl\':\'Kopieer\',\'fr\':\'Copier\'})}}</button> </span><input type=text ng-attr-id=\"{{\'copyLink\'+lang}}\" ng-value=getLink(lang) readonly></div></div></div></div></div><div class=\"panel panel-default\"><div class=panel-heading><h4 class=panel-title id=rawhtml ng-init=\"formbuttonDescription.open=false\" ng-click=\"formbuttonDescription.open=!formbuttonDescription.open\" data-toggle=collapse data-target=#collapseFormbuttonDescription>{{tools.lang({\'en\':\'Description (html)\',\'nl\':\'Omschrijving (html)\',\'fr\':\'Description (html)\'})}} <span ng-show=formbuttonDescription.open class=\"glyphicon glyphicon-chevron-up\"></span> <span ng-hide=formbuttonDescription.open class=\"glyphicon glyphicon-chevron-down\"></span></h4></div><div class=panel-body uib-collapse=!formbuttonDescription.open><div class=\"form-group clearfix\"><div class=col-md-10><textarea class=form-control ng-model=model.formbutton.rawhtmlen placeholder=English></textarea><textarea class=form-control ng-model=model.formbutton.rawhtmlnl placeholder=Nederlands></textarea><textarea class=form-control ng-model=model.formbutton.rawhtmlfr placeholder=Francais></textarea></div><div class=col-md-2><button class=\"btn btn-success\" ng-click=\"updateFormbutton(\'rawhtml\');\"><span class=\"glyphicon glyphicon-ok\"></span>&nbsp; {{tools.lang({\'en\':\'Save\',\'nl\':\'Opslaan\',\'fr\':\'Enregistrer\'})}}</button></div></div></div></div><div class=\"panel panel-default\" ng-show=\"model.formbutton.singlequantity==\'1\'\"><div class=panel-heading><h4 class=panel-title id=quantitylabel ng-init=\"quantityLabel.open=false\" ng-click=\"quantityLabel.open=!quantityLabel.open\">{{tools.lang({\'en\':\'Pack quantity label\',\'nl\':\'Pack hoeveelheid label\',\'fr\':\'Libell\\u00E9 de la quantit\\u00E9 du pack\'})}} <span ng-show=quantityLabel.open class=\"glyphicon glyphicon-chevron-up\"></span> <span ng-hide=quantityLabel.open class=\"glyphicon glyphicon-chevron-down\"></span></h4></div><div class=panel-body uib-collapse=!quantityLabel.open><div class=\"form-group clearfix\"><div class=col-md-3><input type=text autocomplete=off class=form-control ng-model=model.formbutton.quantitylabelen placeholder=English></div><div class=col-md-3><input type=text autocomplete=off class=form-control ng-model=model.formbutton.quantitylabelnl placeholder=Nederlands></div><div class=col-md-3><input type=text autocomplete=off class=form-control ng-model=model.formbutton.quantitylabelfr placeholder=Francais></div><div class=col-md-3><button class=\"btn btn-success\" ng-click=\"updateFormbutton(\'quantitylabel\');\"><span class=\"glyphicon glyphicon-ok\"></span>&nbsp; {{tools.lang({\'en\':\'Save\',\'nl\':\'Opslaan\',\'fr\':\'Enregistrer\'})}}</button></div></div></div></div></form><main ng-show=\"tools.getLength(tools.join(model.formbutton,\'formbuttoncomponents\',model))>0 && !webservice.calling\" class=content style=\"min-width: 100%\"><div class=table-responsive-wrapper><table class=\"table table-create\" style=\"margin-bottom: 15px;border-radius: 3px;box-shadow: 0 1px 3px rgba(0,0,0,0.15);background-color: #fff\"><thead ng-show=!model.editingFormbuttoncomponent><th colspan=2></th><th>{{tools.lang({\'en\':\'Label\',\'nl\':\'Label\',\'fr\':\'Libell\\u00E9\'})}}</th><th ng-show=showRepetition()>{{tools.lang({\'en\':\'Repetition\',\'nl\':\'Herhaling\',\'fr\':\'R\\u00E9p\\u00E9tition\'})}}</th><th ng-show=showFormbuttonOffset(formbuttoncomponent)><div>{{tools.lang({\'en\':\'Start\',\'nl\':\'Start\',\'fr\':\'Jour\'})}}</div><div>{{tools.lang({\'en\':\'day\',\'nl\':\'dag\',\'fr\':\'de d\\u00E9but\'})}}</div></th><th><div>{{tools.lang({\'en\':\'Start\',\'nl\':\'Start-\',\'fr\':\'Heure de\'})}}</div><div>{{tools.lang({\'en\':\'time\',\'nl\':\'uur\',\'fr\':\'d\\u00E9but\'})}}</div></th><th ng-show=\"hasArticleType(\'HS\')\"><div>{{tools.lang({\'en\':\'Hotel\',\'nl\':\'Hotel\',\'fr\':\'Hotel\'})}}</div><div>{{tools.lang({\'en\':\'rate\',\'nl\':\'rate\',\'fr\':\'rate\'})}}</div></th><th ng-show=\"hasArticleType(\'HS\')\"><div>{{tools.lang({\'en\':\'Adult\',\'nl\':\'Volw.\',\'fr\':\'Adulte\'})}}</div></th><th ng-show=\"hasArticleType(\'HS\')\"><div>{{tools.lang({\'en\':\'Child\',\'nl\':\'Kind\',\'fr\':\'Enfant\'})}}</div></th><th ng-show=\"hasArticleType(\'AC\')\"><div>{{tools.lang({\'en\':\'Show\',\'nl\':\'Toon\',\'fr\':\'Montrer\'})}}</div><div>{{tools.lang({\'en\':\'heatmap\',\'nl\':\'heatmap\',\'fr\':\'heatmap\'})}}</div></th><th ng-show=\"model.formbutton.singlequantity===\'1\'\"><div>{{tools.lang({\'en\':\'Quantity\',\'nl\':\'Aantal\',\'fr\':\'Multiplicateur\'})}}</div><div>{{tools.lang({\'en\':\'multiplier\',\'nl\':\'vermenigv.\',\'fr\':\'quantit\\u00E9\'})}}</div></th><th ng-show=\"model.formbutton.singlequantity===\'1\' && tools.getLength(tools.exclude(model.formbuttoncomponents,{\'pricing\':\'DEFAULT\'}))>0\"><div>{{tools.lang({\'en\':\'Unitprice\',\'nl\':\'Eenheidsprijs\',\'fr\':\'Prix unitaire\'})}}</div><div>{{\'/ \'+tools.lang({\'en\':\'Reduction\',\'nl\':\'Korting\',\'fr\':\'R\\u00E9duction\'})}}</div></th><th></th></thead><tbody><tr id=\"{{\'formbuttoncomponent_\'+formbuttoncomponent.id}}\" ng-repeat-start=\"formbuttoncomponent in tools.join(model.formbutton,\'formbuttoncomponents\',model) | orderBy:sort\"><td><div><button class=\"btn btn-default\" ng-click=\"updateSort(\'formbuttoncomponents\',formbuttoncomponent,\'left\')\" ng-disabled=\"isMin(\'formbuttoncomponents\',formbuttoncomponent) || model.editingFormbuttoncomponent\"><span class=\"glyphicon glyphicon-arrow-up\"></span></button> <button class=\"btn btn-default\" ng-click=\"updateSort(\'formbuttoncomponents\',formbuttoncomponent,\'right\')\" ng-disabled=\"isMax(\'formbuttoncomponents\',formbuttoncomponent) || model.editingFormbuttoncomponent\"><span class=\"glyphicon glyphicon-arrow-down\"></span></button></div></td><td><b>{{getFormbuttoncomponentName(formbuttoncomponent)}}</b></td><td><div ng-hide=formbuttoncomponent.editing>{{tools.label(formbuttoncomponent)}}</div></td><td ng-show=showRepetition()><div ng-hide=\"formbuttoncomponent.editing || !(formbuttoncomponent.param1===\'AC\' || formbuttoncomponent.param1===\'ME\')\">{{tools.label(repetitionOptions[formbuttoncomponent.repetition])}}</div></td><td ng-show=showFormbuttonOffset(formbuttoncomponent)><div ng-show=\"formbuttoncomponent.param1==\'AC\' || formbuttoncomponent.param1==\'ME\'\"><div ng-hide=formbuttoncomponent.editing>{{tools.label(offsetOptions[formbuttoncomponent.repetition][formbuttoncomponent.dayoffset])}}</div></div></td><td><div ng-show=\"formbuttoncomponent.param1==\'AC\' || formbuttoncomponent.param1==\'ME\' || formbuttoncomponent.param1==\'HS\'\"><div ng-hide=formbuttoncomponent.editing>{{tools.hourOut(formbuttoncomponent.hrs)}}</div></div></td><td ng-show=\"hasArticleType(\'HS\')\"><div ng-hide=\"formbuttoncomponent.editing || formbuttoncomponent.param1!=\'HS\'\">{{tools.label(parameters.HRA[formbuttoncomponent.param3])}}</div></td><td ng-show=\"hasArticleType(\'HS\')\"><div ng-hide=\"formbuttoncomponent.editing || formbuttoncomponent.param1!=\'HS\'\"><span ng-hide=\"formbuttoncomponent.adultcountbehaviour==\'FIXED\'\">{{tools.label(occupantcountbehaviourOptions[formbuttoncomponent.adultcountbehaviour])}} </span><span ng-show=\"formbuttoncomponent.adultcountbehaviour==\'FIXED\'\">{{formbuttoncomponent.adultcount}}</span></div></td><td ng-show=\"hasArticleType(\'HS\')\"><div ng-hide=\"formbuttoncomponent.editing || formbuttoncomponent.param1!=\'HS\'\"><span ng-hide=\"formbuttoncomponent.childcountbehaviour==\'FIXED\'\">{{tools.label(occupantcountbehaviourOptions[formbuttoncomponent.childcountbehaviour])}} </span><span ng-show=\"formbuttoncomponent.childcountbehaviour==\'FIXED\'\">{{formbuttoncomponent.childcount}}</span></div></td><td ng-show=\"hasArticleType(\'AC\')\"><div ng-hide=\"formbuttoncomponent.editing || formbuttoncomponent.param1!=\'AC\'\"><span ng-show=\"formbuttoncomponent.heatmap==\'0\'\">{{tools.lang({\'en\':\'no\',\'nl\':\'nee\',\'fr\':\'non\'})}}</span> <span ng-show=\"formbuttoncomponent.heatmap==\'1\'\">{{tools.lang({\'en\':\'yes\',\'nl\':\'ja\',\'fr\':\'oui\'})}}</span></div></td><td ng-show=\"model.formbutton.singlequantity===\'1\'\"><div ng-hide=formbuttoncomponent.editing>{{tools.label(quantitymultiplierOptions[formbuttoncomponent.quantitymultiplier])}} <span ng-hide=\"formbuttoncomponent.quantity==1\">{{\'\\u00D7 \'+formbuttoncomponent.quantity}}</span></div></td><td ng-show=\"model.formbutton.singlequantity===\'1\' && tools.getLength(tools.exclude(model.formbuttoncomponents,{\'pricing\':\'DEFAULT\'}))>0\"><div ng-hide=\"formbuttoncomponent.editing || formbuttoncomponent.pricing==\'DEFAULT\'\">{{tools.amountOut(formbuttoncomponent.unitprice)}}{{formbuttoncomponent.pricing==\'COMPONENT\'?\' €\':\'%\'}}</div></td><td><div style=\"text-align: right\"><span ng-show=formbuttoncomponent.editing><button update class=\"btn btn-success\" ng-click=updateFormbuttoncomponent(formbuttoncomponent)></button> <button cancel class=\"btn btn-warning\" ng-click=cancelFormbuttoncomponent(formbuttoncomponent)></button> </span><span ng-show=!model.editingFormbuttoncomponent><button edit class=\"btn btn-default\" ng-click=editFormbuttoncomponent(formbuttoncomponent)></button> <button delete class=\"btn btn-danger\" ng-click=deleteFormbuttoncomponent(formbuttoncomponent)></button></span></div></td></tr><tr ng-repeat-end ng-show=formbuttoncomponent.editing><td colspan=\"{{12-(hasArticleType(\'HS\')?0:3)-(hasArticleType(\'AC\')?0:1)-(showFormbuttonOffset(formbuttoncomponent)?0:1)-(model.formbutton.singlequantity===\'1\'?0:1)-(model.formbutton.singlequantity===\'1\' && model.formbutton.pricing==\'COMPONENT\'?1:0)}}\"><div class=\"form-group clearfix\"><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Label\',\'nl\':\'Label\',\'fr\':\'Libell\\u00E9\'})}}</label><div class=col-md-3><input type=text autocomplete=off class=form-control ng-model=formbuttoncomponent.labelen placeholder=English></div><div class=col-md-3><input type=text autocomplete=off class=form-control ng-model=formbuttoncomponent.labelnl placeholder=Nederlands></div><div class=col-md-3><input type=text autocomplete=off class=form-control ng-model=formbuttoncomponent.labelfr placeholder=Francais></div></div><div class=\"form-group clearfix\" ng-show=\"showRepetition() && (formbuttoncomponent.param1===\'AC\' || formbuttoncomponent.param1===\'ME\')\"><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Repetition\',\'nl\':\'Herhaling\',\'fr\':\'R\\u00E9p\\u00E9tition\'})}}</label><div class=col-md-4><select class=form-control ng-model=formbuttoncomponent.repetition ng-options=\"row.id as tools.label(row) for row in tools.toArray(repetitionOptions)\"></select></div></div><div class=\"form-group clearfix\" ng-show=\"model.formbutton.singlequantity===\'1\'\"><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Price\',\'nl\':\'Prijs\',\'fr\':\'Prix\'})}}</label><div class=col-md-4><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"pricingOption in pricingOptions\" ng-click=\"formbuttoncomponent.pricing=pricingOption.id;\" ng-class=\"{\'active\':formbuttoncomponent.pricing==pricingOption.id}\">{{tools.label(pricingOption)}}</button></div></div></div><div class=\"form-group clearfix\" ng-show=\"formbuttoncomponent.param2===\'VOU\' && model.formbutton.singlequantity!==\'1\'\"><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':getFormbuttoncomponentName(formbuttoncomponent)+\' price\',\'nl\':\'Prijs \'+getFormbuttoncomponentName(formbuttoncomponent),\'fr\':\'Prix \'+getFormbuttoncomponentName(formbuttoncomponent)})}}</label><div class=col-md-4><input type=text autocomplete=off class=form-control ng-model=formbuttoncomponent.quantity></div></div><div class=\"form-group clearfix\" ng-show=\"model.formbutton.singlequantity===\'1\'\"><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Quantity multiplier\',\'nl\':\'Aantal vermenigvuldiging\',\'fr\':\'Multiplicateur quantit\\u00E9\'})}}</label><div class=col-md-2><select class=form-control ng-model=formbuttoncomponent.quantitymultiplier ng-options=\"row.id as tools.label(row) for row in tools.toArray(quantitymultiplierOptions)\"></select></div><div class=col-md-2><input type=text autocomplete=off class=form-control ng-model=formbuttoncomponent.quantity></div><span ng-show=\"formbuttoncomponent.pricing!==\'DEFAULT\'\"><label class=\"col-md-2 control-label\">{{formbuttoncomponent.pricing===\'COMPONENT\'?tools.lang({\'en\':\'Unit price\',\'nl\':\'Eenheidsprijs\',\'fr\':\'Prix unitaire\'}):tools.lang({\'en\':\'Reduction amount\',\'nl\':\'Reductie bedrag\',\'fr\':\'Montant de r\\u00E9duction\'})}}</label><div class=col-md-4><div class=input-group><input type=text autocomplete=off class=form-control ng-model=formbuttoncomponent.unitprice><div class=input-group-btn><button class=\"btn btn-default\" type=button disabled>{{formbuttoncomponent.pricing===\'COMPONENT\'?\'€\':\'%\'}}</button></div></div></div></span></div><div class=\"form-group clearfix\" ng-show=\"formbuttoncomponent.param1==\'AC\' || formbuttoncomponent.param1==\'ME\' || formbuttoncomponent.param1==\'HS\'\"><span ng-show=\"showFormbuttonOffset(formbuttoncomponent) && (formbuttoncomponent.param1==\'AC\' || formbuttoncomponent.param1==\'ME\') && tools.getLength(offsetOptions[formbuttoncomponent.repetition])>0\"><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Start day\',\'nl\':\'Startdag\',\'fr\':\'Jour de d\\u00E9but\'})}}</label><div class=col-md-4><select class=form-control ng-model=formbuttoncomponent.dayoffset ng-options=\"row.id as tools.label(row) for row in offsetOptions[formbuttoncomponent.repetition] | orderBy:\'order\'\"></select></div></span><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Start time\',\'nl\':\'Startuur\',\'fr\':\'Heure de d\\u00E9but\'})}}</label><div class=col-md-4><select class=form-control ng-model=formbuttoncomponent.hrs ng-options=\"row.id as tools.label(row) for row in (formbuttoncomponent.repetition!==\'ONCE\' && (formbuttoncomponent.param1===\'AC\' || formbuttoncomponent.param1===\'ME\'))?parameters.notDelArrayHRS:tools.addElement(parameters.notDelHRS,customerChoice) | orderBy:\'id\'\"></select></div></div><div class=\"form-group clearfix\" ng-show=\"formbuttoncomponent.param1==\'HS\'\"><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Hotel rate\',\'nl\':\'Hotel rate\',\'fr\':\'Hotel rate\'})}}</label><div class=col-md-4><select class=form-control ng-model=formbuttoncomponent.param3 ng-options=\"row.id as tools.label(row) for row in tools.addElement(filteredHra(formbuttoncomponent),predateSelectorChoice) | orderBy:\'id\'\"></select></div></div><div class=\"form-group clearfix\" ng-show=\"formbuttoncomponent.param1==\'AC\'\"><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Unit\',\'nl\':\'Eenheid\',\'fr\':\'Unité\'})}}</label><div class=col-md-4><select class=form-control ng-model=formbuttoncomponent.param3 ng-options=\"row.id as tools.label(row) for row in tools.addElement(activitiesService.activityFilter(parameters.notDelUNT,\'id\',formbuttoncomponent.act),defaultChoice) | orderBy:\'id\'\"></select></div></div><div class=\"form-group clearfix\" ng-show=\"formbuttoncomponent.param1==\'HS\'\"><label class=\"col-md-2 control-label\" ng-repeat-start=\"peopleMultiplier in peopleMultipliers\">{{tools.label(peopleMultiplier)}}</label><div ng-class=\"{\'col-md-2\':formbuttoncomponent[peopleMultiplier.behaviour]==\'FIXED\',\'col-md-4\':formbuttoncomponent[peopleMultiplier.behaviour]!=\'FIXED\'}\"><select class=form-control ng-model=formbuttoncomponent[peopleMultiplier.behaviour] ng-options=\"row.id as tools.label(row) for row in tools.toArray(occupantcountbehaviourOptions)\"></select></div><div class=col-md-2 ng-show=\"formbuttoncomponent[peopleMultiplier.behaviour]==\'FIXED\'\" ng-repeat-end><input type=text autocomplete=off class=form-control ng-model=formbuttoncomponent[peopleMultiplier.count]></div></div><div class=\"form-group clearfix\" ng-show=\"formbuttoncomponent.param1==\'AC\'\"><div class=\"col-md-10 col-md-offset-2\"><div class=checkbox ng-show=formbuttoncomponent.editing><label><input type=checkbox ng-false-value=\"\'0\'\" ng-true-value=\"\'1\'\" ng-model=formbuttoncomponent.heatmap> {{tools.lang({\'en\':\'Show heatmap\',\'nl\':\'Toon heatmap\',\'fr\':\'Montrer heatmap\'})}}</label></div></div></div></td></tr><tr ng-show=\"model.formbutton.singlequantity===\'1\' && tools.getLength(tools.exclude(model.formbuttoncomponents,{\'pricing\':\'DEFAULT\'}))>0 && tools.getLength(tools.match(model.formbuttoncomponents,{\'pricing\':\'REDUCTION\'}))<=0\"><td class=summary colspan=\"{{10-(hasArticleType(\'HS\')?0:3)-(hasArticleType(\'AC\')?0:1)-(showFormbuttonOffset(formbuttoncomponent)?0:1)}}\"></td><td colspan=2><b>{{model.formbutton.minpackquantity>1?tools.lang({\'en\':\'From \',\'nl\':\'Vanaf \',\'fr\':\'A partir de \'}):\'\'}}{{calculatePackPrice()}} € {{plusCityTax()}}</b></td></tr></tbody></table></div></main><form class=form-horizontal ng-show=!webservice.calling><div class=\"panel panel-default\"><div class=panel-body><div class=\"form-group clearfix\"><div class=col-sm-3><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"cat in componentCategories\" ng-click=\"model.formbuttoncomponent.param1=cat.id;model.formbuttoncomponent.param2=\'\';\" ng-class=\"{\'active\':model.formbuttoncomponent.param1==cat.id}\">{{tools.label(cat)}}</button></div></div><div ng-show=\"model.formbuttoncomponent.param1==\'AC\'\"><div class=col-sm-4><select class=form-control ng-model=model.formbuttoncomponent.act ng-change=\"model.formbuttoncomponent.param2=\'\'\" ng-options=\"row.id as tools.label(row) for row in tools.toArray(parameters.combinationFilter(parameters.notDelACT,\'VISACTA\',\'PUB\')) | orderBy:\'label\'+user.lang\"></select></div><div class=col-sm-4><select class=form-control ng-model=model.formbuttoncomponent.param2 ng-options=\"row.id as tools.label(row) for row in model.formbutton.singlequantity===\'1\'?activitiesService.activityFilter(parameters.notDelFRM,\'id\',model.formbuttoncomponent.act):tools.addElement(activitiesService.activityFilter(parameters.notDelFRM,\'id\',model.formbuttoncomponent.act),customerChoice) | orderBy:\'label\'+user.lang\"></select></div></div><div ng-show=\"model.formbuttoncomponent.param1==\'ME\'\"><div class=col-sm-4><select class=form-control ng-model=model.formbuttoncomponent.res ng-change=\"model.formbuttoncomponent.param2=\'\'\" ng-options=\"row.id as tools.label(row) for row in tools.toArray(parameters.notDelRES) | orderBy:\'label\'+user.lang\"></select></div><div class=col-sm-4><select class=form-control ng-model=model.formbuttoncomponent.param2 ng-options=\"row.id as tools.label(row) for row in activitiesService.activityFilter(parameters.notDelDSH,\'id\',model.formbuttoncomponent.res) | orderBy:\'label\'+user.lang\"></select></div></div><div ng-show=\"model.formbuttoncomponent.param1==\'PR\'\"><div class=col-sm-4><select class=form-control ng-model=model.formbuttoncomponent.param2 ng-options=\"row.id as tools.lang(row) for row in getProducts() | orderBy:user.lang\"></select></div></div><div ng-show=\"model.formbuttoncomponent.param1==\'HS\'\"><div class=col-sm-4><select class=form-control ng-model=model.formbuttoncomponent.htl ng-change=\"model.formbuttoncomponent.param2=\'\'\" ng-options=\"row.id as tools.label(row) for row in tools.toArray(parameters.notDelHTL) | orderBy:\'label\'+user.lang\"></select></div><div class=col-sm-4><select class=form-control ng-model=model.formbuttoncomponent.param2 ng-options=\"row.id as tools.label(row) for row in tools.match(activitiesService.activityFilter(parameters.notDelHSC,\'id\',model.formbuttoncomponent.htl),{\'field6\':\'1\'}) | orderBy:\'label\'+user.lang\"></select></div></div><div class=col-xs-1><button class=\"btn btn-default\" ng-click=createFormbuttoncomponent(); ng-disabled=model.editingFormbuttoncomponent><span class=\"glyphicon glyphicon-plus-sign\"></span>&nbsp; {{tools.lang({\'en\':\'Add\',\'nl\':\'Toevoegen\',\'fr\':\'Ajout\'})}}</button></div></div></div></div></form><form class=form-horizontal ng-show=!webservice.calling><div class=\"form-group clearfix\"><div class=\"col-md-3 col-sm-6\"><h3>{{tools.lang({\'en\':\'Button appearance\',\'nl\':\'Knop uiterlijk\',\'fr\':\'Apparence du bouton\'})}}</h3><div class=\"row equal\"><div class=col-xs-12 style=display:flex><div class=\"panel panel-default\" style=width:100%><div class=panel-heading><button class=\"btn btn-default\" ng-click=\"tools.redirect(buildHref(\'marketing\',\'editTemplate\',model.formbutton.template));\"><span class=\"glyphicon glyphicon-search\"></span>&nbsp; {{tools.lang({\'en\':\'Button appearance\',\'nl\':\'Knop uitzicht\',\'fr\':\'Bouton apparence\'})}}</button></div><div class=\"panel-body site\" ng-class=\"[\'site-\'+model.formbutton.fca.substr(0,2)]\"><button class=funnel-card><div ng-bind-html=model.templates[model.formbutton.template].trustedRendered></div></button></div></div></div></div></div><div class=\"col-md-9 col-sm-6\"><div class=form-group><label class=\"col-md-3 control-label\" ng-show=\"tools.getLength(getFormbuttonrelations())>0\"><h3>{{tools.lang({\'en\':\'Submenu options\',\'nl\':\'Submenu opties\',\'fr\':\'Submenu options\'})}}</h3></label><div class=col-md-9 style=\"margin-top: 20px\"><button class=\"btn btn-default\" ng-click=createFormbuttonrelation();><span class=\"glyphicon glyphicon-plus-sign\"></span>&nbsp; {{tools.lang({\'en\':\'Add submenu option\',\'nl\':\'Submenu optie toevoegen\',\'fr\':\'Add submenu option\'})}}</button></div></div><div class=\"row equal\"><div class=\"col-md-4 col-xs-12\" style=display:flex ng-repeat=\"formbuttonrelation in getFormbuttonrelations() | orderBy:sort\">{{formbutton=model.formbuttons[formbuttonrelation.child];\"\";}}<div class=\"panel panel-default\" style=width:100%><div class=\"panel-heading form-horizontal\"><div class=form-group style=\"margin-bottom: 0px\"><div class=col-xs-8>{{tools.dateFromJava(formbutton.startdate)+\' \'+tools.lang({\'en\':\'to\',\'nl\':\'tot\',\'fr\':\'a\'})+\' \'+tools.dateFromJava(formbutton.enddate)}}</div><div class=col-xs-4 style=\"text-align: right\">{{formbutton.id}}</div></div><div class=form-group style=\"margin-bottom: 0px\"><div class=col-md-8><button class=\"btn btn-default\" ng-click=\"tools.redirect(buildHref(\'settings\',\'editFormbutton\',formbutton.id));\"><span class=\"glyphicon glyphicon-search\"></span> {{tools.lang({\'en\':\'Details\',\'nl\':\'Details\',\'fr\':\'Details\'})}}</button> <button class=\"btn btn-default\" ng-click=\"tools.redirect(buildHref(\'marketing\',\'editTemplate\',formbutton.template));\"><span class=\"glyphicon glyphicon-search\"></span> {{tools.lang({\'en\':\'Appearance\',\'nl\':\'Uiterlijk\',\'fr\':\'Apparence\'})}}</button></div><div class=col-md-4 style=\"text-align: right\"><button class=\"btn btn-default\" ng-click=\"updateSort(\'formbuttonrelations\',formbuttonrelation,\'left\')\" ng-disabled=\"isMin(\'formbuttonrelations\',formbuttonrelation)\"><span class=\"glyphicon glyphicon-arrow-left\"></span></button> <button class=\"btn btn-default\" ng-click=\"updateSort(\'formbuttonrelations\',formbuttonrelation,\'right\')\" ng-disabled=\"isMax(\'formbuttonrelations\',formbuttonrelation)\"><span class=\"glyphicon glyphicon-arrow-right\"></span></button></div></div><div class=form-group style=\"margin-bottom: 0px\"><div class=col-xs-12 style=\"text-align: right\"><button delete class=\"btn btn-danger\" ng-click=deleteFormbuttonrelation(formbuttonrelation)></button></div></div></div><div class=\"panel-body site\" ng-class=\"[\'site-\'+formbutton.fca.substr(0,2)]\"><div ng-show=\"tools.numberIn(model.dayduration)===0 && (tools.getLength(model.daydurations)>1 || formbutton.fixeddateinterval!==\'\')\" style=\"margin-bottom: 10px\">{{dayduration=tools.numberIn(formbutton.dayduration);\"\";}} <span ng-show=\"dayduration===0 && formbutton.fixeddateinterval===\'\'\">{{tools.lang({\'en\':\'Always visible\',\'nl\':\'Altijd zichtbaar\',\'fr\':\'Toujours visible\'})}} </span><span ng-hide=\"dayduration===0 && formbutton.fixeddateinterval===\'\'\">{{tools.lang({\'en\':\'Only visible for revervations\',\'nl\':\'Alleen zichtbaar voor reserveringen\',\'fr\':\'Seulement visible pour les r\\u00E9servations\'})}} <span ng-show=\"dayduration!==0\">{{tools.lang({\'en\':\'of \',\'nl\':\'van \',\'fr\':\'de \'})+dayduration+tools.lang({\'en\':\' day\',\'nl\':\' dag\',\'fr\':\' jour\'})+(dayduration>1?tools.lang({\'en\':\'s / \',\'nl\':\'en / \',\'fr\':\'s / \'})+(dayduration-1)+tools.lang({\'en\':\' night\',\'nl\':\' nacht\',\'fr\':\' nuit\'})+(dayduration>2?tools.lang({\'en\':\'s\',\'nl\':\'en\',\'fr\':\'s\'}):\'\'):\'\')}} </span><span ng-show=\"dayduration!==0 && formbutton.fixeddateinterval!==\'\'\">{{tools.lang({\'en\':\'and\',\'nl\':\'en\',\'fr\':\'et\'})}} </span><span ng-show=\"formbutton.fixeddateinterval!==\'\'\">{{tools.lang({\'en\':\'with predate selector like \',\'nl\':\'met predate selector \',\'fr\':\'avec predate selector \'})+formbuttonsService.getFormbuttonPredateselector(formbutton)}}</span></span></div><button class=funnel-card><div ng-bind-html=model.templates[formbutton.template].trustedRendered></div></button></div></div></div></div></div></div></form><div class=\"content__item page__loader\" ng-show=webservice.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div></div>");
$templateCache.put("app/modules/settings/formbuttonList.html","<div ng-controller=SettingsFormbuttonListController class=\"page page-list-formbuttons page--content\"><aside id=filters class=\"page__sidebar sidebar hidden-md hidden-lg\"><div class=sidebar__header><h4 class=title>{{tools.lang({\'en\': \'Filters\', \'nl\': \'Filters\', \'fr\': \'Filtres\'})}}</h4><button class=\"btn btn-default btn-rounded\"><span class=material-icons ng-click=\"toggleFilters(\'filters\')\">close</span></button></div><div class=sidebar__content><form class=form-horizontal><div class=\"form-group clearfix\"><div class=col-md-2><label class=control-label>{{tools.lang({\'en\':\'Form\',\'nl\':\'Formulier\',\'fr\':\'Formulaire\'})}}</label></div><div class=col-md-10><div ng-dropdown-multiselect options=model.ffos selected-model=model.selectedFfo extra-settings=model.settings translation-texts=model.translations events={onItemSelect:selectFfo}></div></div></div><div class=\"form-group clearfix\" ng-show=\"tools.getLength(model.fcas)>1\"><div class=col-md-2><label class=control-label>{{tools.lang({\'en\':\'Form category\',\'nl\':\'Formulier categorie\',\'fr\':\'Category formulaire\'})}}</label></div><div class=col-md-10><div ng-dropdown-multiselect options=model.fcas selected-model=model.selectedFca extra-settings=model.settings translation-texts=model.translations events={onItemSelect:selectFca}></div></div></div><div class=\"form-group clearfix\" ng-show=\"tools.getLength(model.daydurations)>1\"><div class=col-md-2><label class=control-label>{{tools.lang({\'en\':\'Number of days\',\'nl\':\'Aantal dagen\',\'fr\':\'Nombre de jours\'})}}</label></div><div class=col-md-10><div ng-dropdown-multiselect options=model.daydurations selected-model=model.selectedDayduration extra-settings=model.settings translation-texts=translations events={onItemSelect:selectDayduration}></div></div></div><div class=\"form-group clearfix\"><div class=col-md-2><label class=control-label>{{tools.lang({\'en\':\'From\',\'nl\':\'Vanaf\',\'fr\':\'De\'})}}</label></div><div class=col-md-10><div class=input-group><input type=text autocomplete=off ng-click=\"model.dateOpened=!model.dateOpened\" class=form-control uib-datepicker-popup ng-model=model.date is-open=model.dateOpened datepicker-options=dateOptions> <span class=input-group-btn ng-click=\"model.dateOpened=!model.dateOpened\"><button type=button class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></form></div><div class=sidebar__footer><button type=submit class=\"btn btn-primary\" ng-click=\"toggleFilters(\'filters\');\">{{tools.lang({\'en\': \'Done\', \'nl\': \'Done\', \'fr\': \'Appliquer\'})}}</button></div></aside><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\': \'Form buttons\', \'nl\': \'Formulier knoppen\', \'fr\': \'Bouton formulaire\'})}}</h1><div class=header__actions><div class=form-group><div class=col-xs-12><button class=\"btn btn-default btn-filters hidden-md hidden-lg\" ng-click=\"toggleFilters(\'filters\')\"><i class=material-icons>filter_list</i> <span class=\"btn__text hidden-xs hidden-sm\">{{tools.lang({ \'en\': \'Filters\', \'nl\': \'Filters\', \'fr\': \'Filtres\' })}}</span></button></div></div><div class=form-group><div class=col-xs-12><div class=btn-group uib-dropdown dropdown-append-to-body auto-close=outsideClick ng-show=\"model.ffo!==\'\' && model.fca!==\'\'\"><button id=split-button type=button class=\"btn btn-success\" ng-click=createFormbutton()><span class=\"glyphicon glyphicon-plus-sign\"></span>&nbsp; {{tools.lang({\'en\':\'Button\',\'nl\':\'Knop\',\'fr\':\'Bouton\'})}}</button> <button type=button class=\"btn btn-success\" uib-dropdown-toggle><span class=caret></span></button><ul uib-dropdown-menu role=menu aria-labelledby=split-button><li class=\"form-group clearfix\"><div class=col-xs-12><label class=control-label>{{tools.lang({\'en\':\'Start date\',\'nl\':\'Startdatum\',\'fr\':\'Date debut\'})}}</label></div><div class=col-xs-12><div class=input-group><input type=text autocomplete=off ng-click=\"model.startdateOpened=!model.startdateOpened\" class=form-control uib-datepicker-popup ng-model=model.startdate is-open=model.startdateOpened datepicker-options=dateOptions> <span class=input-group-btn ng-click=\"model.startdateOpened=!model.startdateOpened\"><button type=button class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></li><li class=\"form-group clearfix\"><div class=col-xs-12><label class=control-label>{{tools.lang({\'en\':\'End date\',\'nl\':\'Einddatum\',\'fr\':\'Date fin\'})}}</label></div><div class=col-xs-12><div class=input-group><input type=text autocomplete=off ng-click=\"model.enddateOpened=!model.enddateOpened\" class=form-control uib-datepicker-popup ng-model=model.enddate is-open=model.enddateOpened datepicker-options=dateOptions> <span class=input-group-btn ng-click=\"model.enddateOpened=!model.enddateOpened\"><button type=button class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></li></ul></div></div></div></div></section><form class=\"table-filters hidden-xs hidden-sm\"><div class=\"table-filters__item form-group inline-flex\"><label class=control-label>{{tools.lang({\'en\':\'Form\',\'nl\':\'Formulier\',\'fr\':\'Formulaire\'})}}</label><div class=btn-group><div ng-dropdown-multiselect options=model.ffos selected-model=model.selectedFfo extra-settings=model.settings translation-texts=translations events={onItemSelect:selectFfo}></div></div></div><div class=\"table-filters__item form-group inline-flex\" ng-show=\"tools.getLength(model.fcas)>1\"><label class=control-label>{{tools.lang({\'en\':\'Form category\',\'nl\':\'Formulier categorie\',\'fr\':\'Category formulaire\'})}}</label><div class=btn-group><div ng-dropdown-multiselect disabled options=model.fcas selected-model=model.selectedFca extra-settings=model.settings translation-texts=translations events={onItemSelect:selectFca}></div></div></div><div class=\"table-filters__item form-group inline-flex\" ng-show=\"tools.getLength(model.daydurations)>1\"><label class=control-label>{{tools.lang({\'en\':\'Number of days\',\'nl\':\'Aantal dagen\',\'fr\':\'Nombre de jours\'})}}</label><div class=btn-group><div ng-dropdown-multiselect disabled options=model.daydurations selected-model=model.selectedDayduration extra-settings=model.settings translation-texts=translations events={onItemSelect:selectDayduration}></div></div></div><div class=\"table-filters__item form-group inline-flex\"><label class=control-label>{{tools.lang({\'en\':\'From\',\'nl\':\'Vanaf\',\'fr\':\'De\'})}}</label><div class=input-group><input type=text autocomplete=off ng-click=\"model.dateOpened=!model.dateOpened\" class=form-control uib-datepicker-popup ng-model=model.date is-open=model.dateOpened datepicker-options=dateOptions> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.dateOpened=!model.dateOpened\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></form><div class=\"row equal\" ng-show=\"!webservice.calling && tools.getLength(getFilteredFormbuttons(model.fca))>0\"><div ng-class=\"parameters.FCA[model.fca].field4!==\'\'?parameters.FCA[model.fca].field4:\'col-sm-6 col-md-3\'\" style=display:flex ng-repeat=\"formbutton in getFilteredFormbuttons(model.fca) | orderBy:sort\"><div class=\"panel panel-default\" style=width:100%><div class=\"panel-heading form-horizontal\"><div class=form-group style=\"margin-bottom: 0px\"><div class=col-xs-8>{{tools.dateFromJava(formbutton.startdate)+\' \'+tools.lang({\'en\':\'to\',\'nl\':\'tot\',\'fr\':\'a\'})+\' \'+tools.dateFromJava(formbutton.enddate)}}</div><div class=col-xs-4 style=\"text-align: right\">{{formbutton.id}}</div></div><div class=form-group style=\"margin-bottom: 0px\"><div class=col-md-8><button class=\"btn btn-default\" ng-click=\"tools.redirect(buildHref(\'settings\',\'editFormbutton\',formbutton.id));\"><span class=\"glyphicon glyphicon-search\"></span> {{tools.lang({\'en\':\'Details\',\'nl\':\'Details\',\'fr\':\'Details\'})}}</button> <button class=\"btn btn-default\" ng-click=\"tools.redirect(buildHref(\'marketing\',\'editTemplate\',formbutton.template));\"><span class=\"glyphicon glyphicon-search\"></span> {{tools.lang({\'en\':\'Appearance\',\'nl\':\'Uiterlijk\',\'fr\':\'Apparence\'})}}</button></div><div class=col-md-4 style=\"text-align: right\"><button class=\"btn btn-default\" ng-click=\"updateSort(formbutton,\'left\')\" ng-disabled=isMin(formbutton)><span class=\"glyphicon glyphicon-arrow-left\"></span></button> <button class=\"btn btn-default\" ng-click=\"updateSort(formbutton,\'right\')\" ng-disabled=isMax(formbutton)><span class=\"glyphicon glyphicon-arrow-right\"></span></button></div></div><div class=form-group style=\"margin-bottom: 0px\"><div class=col-xs-12 style=\"text-align: right\"><button delete class=\"btn btn-danger\" ng-click=deleteFormbutton(formbutton)></button> <button class=\"btn btn-default\" ng-click=duplicate(formbutton)><span class=\"glyphicon glyphicon-duplicate\"></span></button></div></div></div><div class=\"panel-body site\" ng-class=\"[\'site-\'+formbutton.fca.substr(0,2)]\"><div ng-show=\"tools.numberIn(model.dayduration)===0 && (tools.getLength(model.daydurations)>1 || formbutton.fixeddateinterval!==\'\')\" style=\"margin-bottom: 10px\">{{dayduration=tools.numberIn(formbutton.dayduration);\"\";}} <span ng-show=\"dayduration===0 && formbutton.fixeddateinterval===\'\'\">{{tools.lang({\'en\':\'Always visible\',\'nl\':\'Altijd zichtbaar\',\'fr\':\'Toujours visible\'})}} </span><span ng-hide=\"dayduration===0 && formbutton.fixeddateinterval===\'\'\">{{tools.lang({\'en\':\'Only visible for revervations\',\'nl\':\'Alleen zichtbaar voor reserveringen\',\'fr\':\'Seulement visible pour les r\\u00E9servations\'})}} <span ng-show=\"dayduration!==0\">{{tools.lang({\'en\':\'of \',\'nl\':\'van \',\'fr\':\'de \'})+dayduration+tools.lang({\'en\':\' day\',\'nl\':\' dag\',\'fr\':\' jour\'})+(dayduration>1?tools.lang({\'en\':\'s / \',\'nl\':\'en / \',\'fr\':\'s / \'})+(dayduration-1)+tools.lang({\'en\':\' night\',\'nl\':\' nacht\',\'fr\':\' nuit\'})+(dayduration>2?tools.lang({\'en\':\'s\',\'nl\':\'en\',\'fr\':\'s\'}):\'\'):\'\')}} </span><span ng-show=\"dayduration!==0 && formbutton.fixeddateinterval!==\'\'\">{{tools.lang({\'en\':\'and\',\'nl\':\'en\',\'fr\':\'et\'})}} </span><span ng-show=\"formbutton.fixeddateinterval!==\'\'\">{{tools.lang({\'en\':\'with predate selector like \',\'nl\':\'met predate selector \',\'fr\':\'avec predate selector \'})+getFormbuttonPredateselector(formbutton)}}</span></span></div><button class=funnel-card><div ng-bind-html=model.templates[formbutton.template].trustedRendered></div></button></div></div></div></div><div class=content><div class=content__noresult><div class=\"alert alert-info\" role=alert ng-show=\"!webservice.calling && tools.getLength(getFilteredFormbuttons(model.fca))===0\"><p ng-show=\"model.fca!==\'\' || tools.getLength(model.fcas)===0\">{{tools.lang({\'en\':\'No result - Change filters\',\'nl\':\'Geen resultaat - Verander filters\',\'fr\':\'Aucun résultat - Changer les filtres\'})}}</p><p ng-show=\"model.fca===\'\' && model.ffo!==\'\' && tools.getLength(model.fcas)>0\">{{tools.lang({\'en\':\'Please add category filter\',\'nl\':\'Voeg category filter toe\',\'fr\':\'Ajouter un filtre sur les cat\\u00E9gories\'})}}</p></div></div><div class=\"content__item page__loader\" ng-show=webservice.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div></div></main></div>");
$templateCache.put("app/modules/settings/formbuttonsModal.html","<div class=modal-body><form class=form-horizontal><button class=\"btn btn-danger pull-right\" ng-click=$uibModalInstance.dismiss(); style=\"height:10px;padding:13px 10px\">×</button><uib-tabset active=activeFca class=\"mb-2 tabs\"><uib-tab index=fca.id heading={{tools.label(fca)}} select=\"selectTab(\'edit\')\" ng-repeat=\"fca in getSubmenuFilteredFca() | orderBy:\'label\'+user.lang\"></uib-tab></uib-tabset><div class=\"row equal\"><div class=\"col-md-6 col-xs-12\" ng-repeat=\"formbutton in getSubmenuFormbuttons(activeFca) | orderBy:sort\"><div class=\"panel-body site\" ng-class=\"[\'site-\'+formbutton.fca.substr(0,2)]\" ng-click=$uibModalInstance.close(formbutton);><div ng-show=\"tools.numberIn(formbutton.dayduration)>0 || formbutton.fixeddateinterval!==\'\'\" style=\"margin-bottom: 10px\">{{dayduration=tools.numberIn(formbutton.dayduration);\"\";}} {{tools.lang({\'en\':\'Only visible for revervations\',\'nl\':\'Alleen zichtbaar voor reserveringen\',\'fr\':\'Seulement visible pour les r\\u00E9servations\'})}} <span ng-show=\"dayduration!==0\">{{tools.lang({\'en\':\'of \',\'nl\':\'van \',\'fr\':\'de \'})+dayduration+tools.lang({\'en\':\' day\',\'nl\':\' dag\',\'fr\':\' jour\'})+(dayduration>1?tools.lang({\'en\':\'s / \',\'nl\':\'en / \',\'fr\':\'s / \'})+(dayduration-1)+tools.lang({\'en\':\' night\',\'nl\':\' nacht\',\'fr\':\' nuit\'})+(dayduration>2?tools.lang({\'en\':\'s\',\'nl\':\'en\',\'fr\':\'s\'}):\'\'):\'\')}} </span><span ng-show=\"dayduration!==0 && formbutton.fixeddateinterval!==\'\'\">{{tools.lang({\'en\':\'and\',\'nl\':\'en\',\'fr\':\'et\'})}} </span><span ng-show=\"formbutton.fixeddateinterval!==\'\'\">{{tools.lang({\'en\':\'with predate selector like \',\'nl\':\'met predate selector \',\'fr\':\'avec predate selector \'})+getFormbuttonPredateselector(formbutton)}}</span></div><button class=funnel-card><div ng-bind-html=model.templates[formbutton.template].trustedRendered></div></button></div></div></div></form></div>");
$templateCache.put("app/modules/settings/listRules.html","<div ng-controller=SettingsListRulesController class=\"page page-settings-list-rules page--content\"><form><div class=row><div class=col-md-6><div class=pull-right><div class=\"form-group clearfix\"><div class=btn-group><button class=\"btn btn-default\" ng-repeat=\"category in model.categories\" ng-class=\"{\'active\':model.category.id==category.id}\" ng-click=setCategory(category);>{{tools.lang(category)}}</button></div></div><div class=\"form-group clearfix\"><div class=btn-group><button class=\"btn btn-default\" ng-repeat=\"subcategory in model.category.subcategories\" ng-show=\"tools.getLength(model.category.subcategories)>1\" ng-class=\"{\'active\':model.subcategory.id==subcategory.id}\" ng-click=setSubcategory(subcategory);>{{tools.lang(subcategory)}}</button></div></div></div></div></div><div class=row><div class=col-md-6><div class=\"form-group clearfix\" ng-repeat=\"tbl in model.subcategory.tbls\"><div class=btn-group><button class=\"btn btn-default\" ng-repeat=\"param in filterParameters($index,tbl)\" ng-class=\"{\'active\':model.params[$parent.$index]==param.id}\" ng-click=setParam($parent.$index,param)><span ng-hide=\"tools.short(param)==\'\'\">{{tools.short(param)}}</span> <span ng-show=\"tools.short(param)==\'\'\">{{tools.label(param)}}</span></button></div><span ng-hide=\"tools.short(parameters[tbl][model.params[$index]])==\'\'\">{{tools.label(parameters[tbl][model.params[$index]])}}</span></div></div><div class=col-md-6 ng-show=model.category.groups><ul class=list-group><li class=list-group-item ng-repeat=\"rulegroup in tools.match(model.rulegroups,{\'publish\':\'1\'})\" ng-class=\"{\'list-group-item-info\':model.rulegroup.id==rulegroup.id}\"><div class=btn-group><button ng-repeat=\"rulemember in tools.join(rulegroup,\'rulemembers\',model)\" class=\"btn btn-default\" ng-class=\"{\'active\':rulemember.param==model.param}\" ng-click=selectRulemember(rulemember.param);>{{paramsToLabel(paramToParams(rulemember.param))}}</button></div><button ng-show=\"model.rulegroup!=null && model.rulegroup.id!=rulegroup.id\" class=\"btn btn-default\" ng-click=addToRulegroup(rulegroup)><span class=\"glyphicon glyphicon-plus-sign\"></span> {{tools.lang({\'en\':\'Add\',\'nl\':\'\',\'fr\':\'Ajouter\'})+\' \'+paramsToLabel(model.params)+\' \'+tools.lang({\'en\':\'to this group\',\'nl\':\'aan deze groep toevoegen\',\'fr\':\'\\u00E0 ce groupe\'})}}</button> <span ng-show=\"model.rulegroup!=null && model.rulegroup.id==rulegroup.id\"><button ng-show=\"tools.getLength(tools.join(rulegroup,\'rulemembers\',model))==1\" class=\"btn btn-default\" ng-click=togglePublishRulegroup()><span class=\"glyphicon glyphicon-trash\"></span> {{tools.lang({\'en\':\'Delete group\',\'nl\':\'Groep wissen\',\'fr\':\'Effacer groupe\'})}}</button> <button ng-show=\"tools.getLength(tools.join(rulegroup,\'rulemembers\',model))>1\" class=\"btn btn-default\" ng-click=removeFromRulegroup()><span class=\"glyphicon glyphicon-trash\"></span> {{tools.lang({\'en\':\'Remove\',\'nl\':\'\',\'fr\':\'Supprimer\'})+\' \'+paramsToLabel(model.params)+\' \'+tools.lang({\'en\':\'from this group\',\'nl\':\'uit deze groep verwijderen\',\'fr\':\'de ce groupe\'})}}</button></span></li><li class=list-group-item ng-show=\"model.rulegroup!=null && model.rulegroup.publish==\'0\'\"><button type=button class=\"btn btn-default\" ng-click=togglePublishRulegroup();><span class=\"glyphicon glyphicon-plus-sign\"></span> {{tools.lang({\'en\':\'New group with\',\'nl\':\'Nieuwe groep met\',\'fr\':\'Nouveau groupe avec\'})+\' \'+paramsToLabel(model.params)}}</button></li></ul></div></div><div ng-show=\"model.rulegroup!=null\"><div class=\"form-group clearfix\"><div style=float:left;display:inline-block><input type=hidden uib-datepicker-popup ng-model=model.startdate is-open=model.startdateOpened datepicker-options=model.dateOptions> <button class=\"btn btn-default\" ng-click=\"model.startdateOpened=!model.startdateOpened\"><i class=\"glyphicon glyphicon-calendar\"></i> {{tools.dateFromJava(model.startdate)}}</button></div><div style=float:right;display:inline-block><input type=hidden uib-datepicker-popup ng-model=model.enddate is-open=model.enddateOpened datepicker-options=model.dateOptions> <button class=\"btn btn-default\" ng-click=\"model.enddateOpened=!model.enddateOpened\"><i class=\"glyphicon glyphicon-calendar\"></i> {{tools.dateFromJava(model.enddate)}}</button></div><div style=overflow:auto;width:auto><button ng-repeat=\"ruleinterval in getIntervals()\" class=\"btn btn-default\" ng-style=\"{\'width\':getIntervalWidth(ruleinterval)+\'%\'}\">{{getIntervalWidth(ruleinterval)}}</button></div></div><div class=\"form-group clearfix\" ng-show=\"model.ruleinterval==null\"><button class=\"btn btn-default\" ng-click=initCreateRuleinterval()><i class=\"glyphicon glyphicon-plus-sign\"></i> {{tools.lang({\'en\':\'Add interval\',\'nl\':\'Interval toevoegen\',\'fr\':\'Ajouter intervalle\'})}}</button></div>TODO: put this in a modal<div ng-show=\"model.ruleinterval!=null\"><div class=\"form-group clearfix\"><label class=\"col-md-2 control-label\" ng-click=\"model.ruleinterval.startdateOpened=!model.ruleinterval.startdateOpened\">{{tools.lang({\'en\':\'From\',\'nl\':\'Van\',\'fr\':\'De\'})}}</label><div class=col-md-4><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.ruleinterval.startdate is-open=model.ruleinterval.startdateOpened datepicker-options=model.dateOptions ng-click=\"model.ruleinterval.startdateOpened=!model.ruleinterval.startdateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.ruleinterval.startdateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><label class=\"col-md-2 control-label\" ng-click=\"model.ruleinterval.enddateOpened=!model.ruleinterval.enddateOpened\">{{tools.lang({\'en\':\'To\',\'nl\':\'Tot\',\'fr\':\'À\'})}}</label><div class=col-md-4><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.ruleinterval.enddate is-open=model.ruleinterval.enddateOpened datepicker-options=model.dateOptions ng-click=\"model.ruleinterval.enddateOpened=!model.ruleinterval.enddateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.ruleinterval.enddateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"form-group clearfix\" ng-show=model.category.schedules><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Week schedule\',\'nl\':\'Weekschema\',\'fr\':\'Horaire\'})}}</label><div class=col-md-10><select class=form-control ng-model=model.ruleinterval.result ng-options=\"weekschedule.id as weekschedule.wording for weekschedule in model.weekschedules\"></select></div></div></div></div></form></div>");
$templateCache.put("app/modules/settings/packets.html","<div ng-controller=SettingsPacketsController class=\"page page-packets page--content\"><form class=form-horizontal><div ng-repeat=\"packet in tools.toArray(model.packets) | orderBy:\'id\'\" style=\"margin-bottom: 20px\"><div><div ng-hide=packet.editing><h3><button edit ng-hide=packet.editing ng-click=editPacket(packet);></button> {{tools.lang({\'en\':packet.label1, \'nl\':packet.label2, \'fr\':packet.label3})}} <span style=\"font-weight: normal;font-size: 14px\"><span ng-show=\"packet.company==\'1\'\">{{tools.lang({\'en\':\'For companies\',\'nl\':\'Voor bedrijven\',\'fr\':\'Pour entreprises\'})}}</span> <span ng-show=\"packet.company==\'1\'\">{{tools.lang({\'en\':\'For private\',\'nl\':\'Voor particulieren\',\'fr\':\'Pour priv\\u00E9\'})}}</span> id={{packet.id}}</span></h3></div><div ng-show=packet.editing><label>en:</label><input type=text ng-model=packet.label1><label>nl:</label><input type=text ng-model=packet.label2><label>fr:</label><input type=text ng-model=packet.label3><label><input type=checkbox ng-model=packet.company ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\"> {{tools.lang({\'en\':\'For companies\',\'nl\':\'Voor bedrijven\',\'fr\':\'Pour entreprises\'})}}</label><label><input type=checkbox ng-model=packet.private ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\"> {{tools.lang({\'en\':\'For private\',\'nl\':\'Voor particulieren\',\'fr\':\'Pour priv\\u00E9\'})}}</label></div></div><ul class=list-group><li class=list-group-item ng-repeat=\"packetcomponent in tools.join(packet,\'packetcomponents\',model) | orderBy: [\'day\',\'hrs\']\"><select ng-disabled=!packet.editing ng-model=packetcomponent.param1 ng-style=\"{\'background\':packet.editing?\'transparent\':\'rgb(235, 235, 228)\'}\"><option value=ACT>{{tools.lang({\'en\':\'Activity\',\'nl\':\'Activiteit\',\'fr\':\'Activit\\u00E9\'})}}</option><option value=MEA>{{tools.lang({\'en\':\'Meal\',\'nl\':\'Maaltijd\',\'fr\':\'Repas\'})}}</option><option value=HTL>{{tools.lang({\'en\':\'Accommodation\',\'nl\':\'Accommodatie\',\'fr\':\'H\\u00E9bergement\'})}}</option><option value=PRD>{{tools.lang({\'en\':\'Product\',\'nl\':\'Product\',\'fr\':\'Produit\'})}}</option></select><span ng-show=\"packetcomponent.param1==\'ACT\'\"><select ng-disabled=!packet.editing ng-model=packetcomponent.type ng-change=\"packetcomponent.param2=\'\'\" ng-options=\"act.id as tools.label(act) for act in parameters.notDelArrayACT | orderBy:\'id\'\" ng-style=\"{\'background\':packet.editing?\'transparent\':\'rgb(235, 235, 228)\'}\"></select><select ng-disabled=!packet.editing ng-model=packetcomponent.param2 ng-options=\"frm.id as tools.label(frm) for frm in activitiesService.activityFilter(parameters.notDelFRM,\'id\',packetcomponent.type) | orderBy:\'id\'\" ng-style=\"{\'background\':packet.editing?\'transparent\':\'rgb(235, 235, 228)\'}\"></select></span><span ng-show=\"packetcomponent.param1==\'MEA\'\"><select ng-disabled=!packet.editing ng-model=packetcomponent.type ng-change=\"packetcomponent.param2=\'\'\" ng-options=\"row.id as tools.label(row) for row in parameters.notDelArrayRES | orderBy:\'id\'\" ng-style=\"{\'background\':packet.editing?\'transparent\':\'rgb(235, 235, 228)\'}\"></select><select ng-disabled=!packet.editing ng-model=packetcomponent.param2 ng-options=\"dsh.id as tools.label(dsh) for dsh in activitiesService.activityFilter(parameters.notDelDSH,\'id\',packetcomponent.type) | orderBy:\'id\'\" ng-style=\"{\'background\':packet.editing?\'transparent\':\'rgb(235, 235, 228)\'}\"></select></span><span ng-show=\"packetcomponent.param1==\'HTL\'\"><select ng-disabled=!packet.editing ng-model=packetcomponent.type ng-change=\"packetcomponent.param2=\'\'\" ng-options=\"row.id as tools.label(row) for row in parameters.notDelArrayHTL | orderBy:\'id\'\" ng-style=\"{\'background\':packet.editing?\'transparent\':\'rgb(235, 235, 228)\'}\"></select><select ng-disabled=!packet.editing ng-model=packetcomponent.param2 ng-options=\"row.id as tools.label(row) for row in hotelsService.getAllRoomsForHotel(packetcomponent.type) | orderBy:\'id\'\" ng-style=\"{\'background\':packet.editing?\'transparent\':\'rgb(235, 235, 228)\'}\"></select><span>{{tools.lang({\'en\':\'length\',\'nl\':\'duur\',\'fr\':\'dur\\u00E9e\'})}}</span> <input type=text size=1 ng-disabled=!packet.editing ng-model=packetcomponent.attr1> <span>{{tools.lang({\'en\':\'Rate\',\'nl\':\'Prijs\',\'fr\':\'Prix\'})}}</span><select ng-disabled=!packet.editing ng-model=packetcomponent.attr2 ng-options=\"row.id as tools.label(row) for row in hotelsService.getAvailableRatesForHotel(packetcomponent.type) | orderBy:\'id\'\" ng-style=\"{\'background\':packet.editing?\'transparent\':\'rgb(235, 235, 228)\'}\"></select></span><span ng-show=\"packetcomponent.param1==\'PRD\'\"><select ng-disabled=!packet.editing ng-model=packetcomponent.param2 ng-options=\"row.id as tools.label(row) for row in parameters.notDelArrayPRD | orderBy:\'id\'\" ng-style=\"{\'background\':packet.editing?\'transparent\':\'rgb(235, 235, 228)\'}\"></select><span ng-show=\"packetcomponent.param2==\'VOU\'\">{{tools.lang({\'en\':\'value\',\'nl\':\'waarde\',\'fr\':\'valeur\'})}}</span> <input ng-show=\"packetcomponent.param2==\'VOU\'\" type=text size=1 ng-disabled=!packet.editing ng-model=packetcomponent.attr1> </span><span ng-show=\"packetcomponent.param1!==\'PRD\'\">{{tools.lang({\'en\':\'day\',\'nl\':\'dag\',\'fr\':\'jour\'})}}</span> <input ng-show=\"packetcomponent.param1!==\'PRD\'\" type=text size=1 ng-disabled=!packet.editing ng-model=packetcomponent.day><select ng-show=\"packetcomponent.param1!==\'PRD\'\" ng-model=packetcomponent.hrs ng-options=\"row.id as tools.label(row) for row in parameters.notDelArrayHRS | orderBy:\'id\'\" ng-disabled=!packet.editing ng-style=\"{\'background\':packet.editing?\'transparent\':\'rgb(235, 235, 228)\'}\"></select><button delete class=\"btn btn-danger\" ng-show=packet.editing ng-click=deletePacketcomponent(packetcomponent);></button></li><li class=list-group-item ng-show=packet.editing><button class=\"btn btn-default\" ng-click=createPacketcomponent(packet);><span class=\"glyphicon glyphicon-plus-sign\"></span> {{tools.lang({\'en\':\'Add new packet component\',\'nl\':\'Voeg een nieuwe pakket component toe\',\'fr\':\'Ajouter un nouveau composant au paquet\'})}}</button></li></ul><div ng-show=packet.editing><button class=\"btn btn-primary\" ng-click=updatePacket(packet)><span class=\"glyphicon glyphicon-ok\"></span> {{tools.lang({\'en\':\'Update\',\'nl\':\'Update\',\'fr\':\'Update\'})}}</button> <button class=\"btn btn-default\" ng-click=cancelPacket(packet)><span class=\"glyphicon glyphicon-remove\"></span> {{tools.lang({\'en\':\'Cancel\',\'nl\':\'Annuleer\',\'fr\':\'Annuler\'})}}</button> <button class=\"btn btn-default\" ng-click=deletePacket(packet)><span class=\"glyphicon glyphicon-trash\"></span> {{tools.lang({\'en\':\'Delete\',\'nl\':\'Verwijder\',\'fr\':\'Supprimer\'})}}</button></div></div><button class=\"btn btn-default\" ng-click=createPacket()><span class=\"glyphicon glyphicon-plus\"></span> {{tools.lang({\'en\':\'Create new packet\',\'nl\':\'Nieuw pakket aanmaken\',\'fr\':\'Créer nouveau paquet\'})}}</button></form></div>");
$templateCache.put("app/modules/test/test.html","<div ng-controller=TestTestController><div><button class=\"btn btn-default\" ng-click=\"test(\'a\')\">Test a</button> <button class=\"btn btn-default\" ng-click=\"test(\'b\')\">Test b</button> <button class=\"btn btn-default\" ng-click=\"test(\'c\')\">Test c</button> <button class=\"btn btn-default\" ng-click=\"test(\'d\')\">Test d</button> <button class=\"btn btn-default\" ng-click=\"test(\'e\')\">Test e</button></div><div><input type=text ng-model=model.syncField> <button class=\"btn btn-default\" ng-click=\"sync(\'a\')\">sync a</button> <button class=\"btn btn-default\" ng-click=\"sync(\'b\')\">sync b</button><!-- \n    <button class=\"btn btn-default\" ng-click=\"sync(\'c\')\">sync c</button>\n    <button class=\"btn btn-default\" ng-click=\"sync(\'d\')\">sync d</button>\n    <button class=\"btn btn-default\" ng-click=\"sync(\'e\')\">sync e</button> --></div><div><!--     <button class=\"btn btn-default\" ng-click=\"migrate(\'a\')\">migrate a</button>\n    <button class=\"btn btn-default\" ng-click=\"migrate(\'b\')\">migrate b</button>\n    <button class=\"btn btn-default\" ng-click=\"migrate(\'c\')\">migrate c</button>\n    <button class=\"btn btn-default\" ng-click=\"migrate(\'d\')\">migrate d</button> --> <button class=\"btn btn-default\" ng-click=\"migrate(\'e\')\">putExactentryId</button></div><div><label>{{\'VisitId:\'}}</label><input type=text ng-model=model.visitId></div></div>");
$templateCache.put("app/modules/users/employeeCommunications.html","<div ng-controller=UsersEmployeeCommunicationsController class=page--content><div ng-show=\"model.task==\'l\'\"><ul class=list-group><li class=list-group-item ng-repeat=\"employeecommunication in tools.toArray(model.employeecommunications) | orderBy:\'created\':true\"><h4><input edit ng-click=startUpdate(employeecommunication)> {{employeecommunication.subject}} <input class=\"btn btn-danger\" delete ng-click=delete(employeecommunication);></h4><p style=\"white-space: pre-line\">{{employeecommunication.body}}</p><p align=right><small><em>{{tools.lang({\'en\':\'Created:\',\'nl\':\'Aangemaakt:\',\'fr\':\'Cre\\u00E9:\'})+\' \'+tools.shortDoneBy(employeecommunication.created,employeecommunication.creator_name)}}</em></small></p><p align=right><small><em>{{tools.lang({\'en\':\'Expiry :\',\'nl\':\'Expiry :\',\'fr\':\'Expiry :\'})+\' \'+tools.dateOut(tools.dateFromJava(employeecommunication.expiry))}}</em></small></p></li></ul><button type=button class=\"btn btn-primary\" ng-click=startCreate();>{{tools.lang({\'en\':\'Create new communication\',\'nl\':\'Nieuwe communicatie maken\',\'fr\':\'Cr\\u00E9er nouvelle communication\'})}}</button></div><div ng-show=\"model.task==\'c\' || model.task==\'u\'\"><form class=form-horizontal><div class=\"form-group clearfix\"><label for=subject class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Subject\',\'nl\':\'Titel\',\'fr\':\'Sujet\'})}}</label><div class=col-sm-10><input type=text class=form-control id=subject placeholder=\"{{tools.lang({\'en\':\'Subject\',\'nl\':\'Titel\',\'fr\':\'Sujet\'})}}\" ng-model=model.employeecommunication.subject></div></div><div class=\"form-group clearfix\"><label for=body class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Body\',\'nl\':\'Body\',\'fr\':\'Body\'})}}</label><div class=col-sm-10><textarea class=form-control id=body ng-model=model.employeecommunication.body></textarea></div></div><div class=\"form-group clearfix\"><label for=expiry class=\"col-sm-2 control-label\" ng-click=\"model.expiryOpened=!model.expiryOpened\">{{tools.lang({\'en\':\'Expiry\',\'nl\':\'Vervalt\',\'fr\':\'Expiry\'})}}</label><div class=col-sm-10><input type=text class=form-control uib-datepicker-popup ng-model=model.employeecommunication.expiry is-open=model.expiryOpened datepicker-options=model.dateOptions ng-click=\"model.expiryOpened=!model.expiryOpened\"></div></div></form><button type=button class=\"btn btn-primary\" ng-click=update(); ng-show=\"model.task==\'u\'\">{{tools.lang({\'en\':\'Update\',\'nl\':\'Update\',\'fr\':\'Update\'})}}</button> <button type=button class=\"btn btn-primary\" ng-click=create() ng-show=\"model.task==\'c\'\">{{tools.lang({\'en\':\'Create\',\'nl\':\'Create\',\'fr\':\'Create\'})}}</button> <button type=button class=\"btn btn-default\" ng-click=cancel();>{{tools.lang({\'en\':\'Cancel\',\'nl\':\'Cancel\',\'fr\':\'Cancel\'})}}</button></div></div>");
$templateCache.put("app/modules/users/home.html","<div ng-controller=UsersHomeController class=page--content><div class=\"panel panel-default\" ng-repeat=\"employeecommunication in tools.toArray(model.employeecommunications) | orderBy:\'created\':true\"><div class=panel-heading><h4 class=panel-title>{{employeecommunication.subject}}</h4></div><div class=panel-body><span style=\"white-space: pre-line\">{{employeecommunication.body}}</span><p align=right><small><em>{{tools.shortDoneBy(employeecommunication.created,employeecommunication.creator_name)}}</em></small></p></div></div></div>");
$templateCache.put("app/modules/users/menuList.html","<div ng-controller=UsersMenuListController class=\"page page-users-menu-list page--content\"><div ng-show=\"model.task==\'l\'\"><div><select ng-model=model.role ng-options=\"rol.id as tools.label(rol) for rol in tools.toArray(parameters.ROL) | orderBy:\'id\'\"></select></div><div><input type=button value=\"{{tools.lang({\'en\':\'New menuitem\',\'nl\':\'Nieuw menu item\',\'fr\':\'Nouvelle menuitem\'})}}\" ng-click=newMenuitem();></div><div class=nav><ul class=nav1><li ng-repeat=\"parentRow in tools.match(model.menuitems,{\'parent\':\'0\',\'role\':model.role}) | orderBy:\'sort\'\"><span class=\"navitem navheader\"><input edit ng-click=editMenuitem(parentRow);> {{tools.label(parentRow)}} <input class=\"btn btn-danger\" delete ng-click=deleteMenuitem(parentRow)> <input arrowup ng-hide=$first ng-click=\"sort(parentRow,\'up\')\"> <input arrowdown ng-hide=$last ng-click=\"sort(parentRow,\'down\')\"></span><ul class=nav2><li ng-repeat=\"childRow in tools.match(model.menuitems,{\'parent\':parentRow.id,\'role\':model.role}) | orderBy:\'sort\'\" ng-class=\"{\'last\':$last}\"><span class=navitem><input edit ng-click=editMenuitem(childRow);> {{tools.label(childRow)}} <input class=\"btn btn-danger\" delete ng-click=deleteMenuitem(childRow)> <input arrowup ng-hide=$first ng-click=\"sort(childRow,\'up\')\"> <input arrowdown ng-hide=$last ng-click=\"sort(childRow,\'down\')\"></span></li></ul></li></ul></div></div><div ng-hide=\"model.task==\'l\'\"><div class=table-responsive-wrapper><table><tr><td></td><td>{{tools.label(parameters.ROL[model.role])}}</td></tr><tr><td>English label:</td><td><input type=text ng-model=model.menuitem.labelen></td></tr><tr><td>Nederlands label:</td><td><input type=text ng-model=model.menuitem.labelnl></td></tr><tr><td>Label Fran&ccedil;ais:</td><td><input type=text ng-model=model.menuitem.labelfr></td></tr><tr><td>{{tools.lang({\'en\':\'Parent\',\'nl\':\'Hoofd\',\'fr\':\'Racine\'})}}:</td><td><select ng-model=model.menuitem.parent ng-options=\"parent.id as tools.label(parent) for parent in model.parents | orderBy:\'sort\'\"></select></td></tr><tr><td>{{tools.lang({\'en\':\'View\',\'nl\':\'Scherm\',\'fr\':\'Ecran\'})}}:</td><td><select ng-model=model.menuitem.view ng-options=\"viewRow for viewRow in tools.toArray(model.views) | orderBy:\'name\'\" ng-change=calculateSettings();></select></td></tr><tr ng-if=model.menuitem.showSettings ng-repeat=\"(key,value) in model.menuitem.settings\"><td>{{tools.lang({\'en\':\'Parameter (Optional)\',\'nl\':\'Parameter (Optioneel)\',\'fr\':\'Paramètre (Optionnel)\'})}}: {{tools.label(model.menuitem.stateSettings[key])}}</td><td><input class=form-control ng-show=\"model.menuitem.stateSettings[key].type==\'number\' || model.menuitem.stateSettings[key].type==\'text\'\" ng-model=model.menuitem.settings[key] size=12><select class=form-control ng-show=\"model.menuitem.stateSettings[key].type==\'param\'\" ng-model=model.menuitem.settings[key] ng-options=\"prm.id as tools.label(prm) for prm in parameters[\'notDelArray\'+model.menuitem.stateSettings[key].paramTbl] | orderBy:\'label\'+user.lang\"></select><select ng-show=\"model.menuitem.stateSettings[key].type==\'paramArray\'\" class=form-control multiple ng-model=model.menuitem.settings[key] ng-options=\"prm.id as tools.label(prm) for prm in tools.match(parameters[\'notDelArray\'+model.menuitem.stateSettings[key].paramTbl],model.menuitem.stateSettings[key].paramFilter) | orderBy:\'label\'+user.lang\"></select></td></tr><tr><td>{{tools.lang({\'en\':\'Hidden\',\'nl\':\'Verstopt\',\'fr\':\'Cach\\u00E9\'})}}</td><td><input type=checkbox ng-model=model.menuitem.hidden ng-false-value=\"\'0\'\" ng-true-value=\"\'1\'\"></td></tr></table></div><input create ng-show=\"model.task==\'c\'\" ng-click=replaceMenuitem();> <input update ng-show=\"model.task==\'u\'\" ng-click=replaceMenuitem();> <input class=\"btn btn-warning\" cancel ng-click=\"model.task=\'l\';\"></div></div>");
$templateCache.put("app/modules/users/passwordReset.html","<div ng-controller=UsersPasswordResetController><h3>{{tools.lang({\'en\':\'New password\',\'nl\':\'Nieuw paswoord\',\'fr\':\'Mot de passe nouveau\'})}}</h3><form><div class=\"form-group clearfix\"><input type=password ng-model=model.password autocomplete=off placeholder=\"{{tools.lang({\'en\':\'Password\',\'nl\':\'Paswoord\',\'fr\':\'Mot de passe\'})}}\"></div><div class=\"form-group clearfix\"><input type=password ng-model=model.confirmPassword autocomplete=off placeholder=\"{{tools.lang({\'en\':\'Confirm password\',\'nl\':\'Bevestig paswoord\',\'fr\':\'Confirme mot de passe\'})}}\"> <span ng-show=\"model.password!=model.confirmPassword\">{{tools.lang({\'en\':\'Passwords do not match\',\'nl\':\'Paswoorden zijn niet identiek\',\'fr\':\'Les passwords ne sont pas egales\'})}}</span></div><div class=\"form-group clearfix\"><button ng-click=passwordReset()>{{tools.lang({\'en\':\'Update password\',\'nl\':\'Update paswoord\',\'fr\':\'Update password\'})}}</button></div></form><a href=\"#/{{buildHref(\'home\')}}\">{{tools.lang({\'en\':\'Return to login\',\'nl\':\'Terug naar login\',\'fr\':\'Retour \\u00E0 login\'})}}</a><br></div>");
$templateCache.put("app/modules/users/userList.html","<div ng-controller=UsersUserListController ng-class=\"{\'page--content\':model.task!==\'l\',\'page--tables\':model.task===\'l\'}\" class=\"page page-users-user-list\"><main role=main class=page__content ng-show=\"model.task==\'l\'\"><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\':\'Users\',\'nl\':\'Gebruikers\',\'fr\':\'Utilisateurs\'})}}</h1><div class=header__actions><div class=\"page__actions hidden-xs hidden-sm\"><ul uib-pagination boundary-links=true boundary-link-numbers=true max-size=model.maxSize total-items=model.totalItems rotate=true force-ellipses=true items-per-page=model.itemsPerPage ng-model=model.page class=pagination-sm previous-text=&lsaquo; next-text=&rsaquo; first-text=&laquo; last-text=&raquo; ng-show=\"model.totalItems>model.itemsPerPage\"></ul></div><button type=button class=\"btn btn-primary\" ng-click=newUser();>{{tools.lang({\'en\':\'New user\',\'nl\':\'Nieuwe gebruiker\',\'fr\':\'Nouvel utilisateur\'})}}</button></div></section><div class=content><div class=\"content__item c-table-view\"><div class=c-table-view__item><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><thead><tr><th><span class=th__content></span></th><th><div class=th__content style=width:100%>{{sortIndex=getSortIndex(\'email\');\"\"}} <span ng-click=\"sortBy(\'email\',$event)\">{{tools.lang({\'en\':\'Email\',\'nl\':\'Email\',\'fr\':\'Email\'})}} </span><span class=sortorder ng-show=\"sortIndex>=0\" ng-class=\"{reverse: model.sortings[sortIndex].reverse}\" ng-click=\"sortBy(\'email\',$event)\"></span> <span ng-show=\"tools.getLength(model.sortings)>1 && sortIndex>=0\">{{sortIndex+1}}</span> <span class=\"glyphicon glyphicon-filter\" ng-click=\"addFilter(\'email\')\"></span><div class=\"search-wrapper wrapper--xl\" style=width:100%;border-radius:4px ng-show=\"model.filters[\'email\']\"><span style=\"cursor: pointer\" class=material-icons ng-click=filterUsers()>search</span> <input type=text name=email class=form-control ng-model=\"model.filters[\'email\'].pattern\" ng-enter=filterUsers()></div></div></th><th><div class=th__content style=width:100%>{{sortIndex=getSortIndex(\'name\');\"\"}} <span ng-click=\"sortBy(\'name\',$event)\">{{tools.lang({\'en\':\'Name\',\'nl\':\'Naam\',\'fr\':\'Nom\'})}} </span><span class=sortorder ng-show=\"sortIndex>=0\" ng-class=\"{reverse: model.sortings[sortIndex].reverse}\" ng-click=\"sortBy(\'name\',$event)\"></span> <span ng-show=\"tools.getLength(model.sortings)>1 && sortIndex>=0\">{{sortIndex+1}}</span> <span class=\"glyphicon glyphicon-filter\" ng-click=\"addFilter(\'name\')\"></span><div class=\"search-wrapper wrapper--xl\" style=width:100%;border-radius:4px ng-show=\"model.filters[\'name\']\"><span style=\"cursor: pointer\" class=material-icons ng-click=filterUsers()>search</span> <input type=text name=name class=form-control ng-model=\"model.filters[\'name\'].pattern\" ng-enter=filterUsers()></div></div></th><th><div class=th__content style=width:100%>{{sortIndex=getSortIndex(\'dvs\');\"\"}} <span ng-click=\"sortBy(\'dvs\',$event)\">{{tools.lang({\'en\':\'Division\',\'nl\':\'Bedrijf\',\'fr\':\'Division\'})}} </span><span class=sortorder ng-show=\"sortIndex>=0\" ng-class=\"{reverse: model.sortings[sortIndex].reverse}\" ng-click=\"sortBy(\'dvs\',$event)\"></span> <span ng-show=\"tools.getLength(model.sortings)>1 && sortIndex>=0\">{{sortIndex+1}}</span> <span class=\"glyphicon glyphicon-filter\" ng-click=\"addFilter(\'dvs\')\"></span><div style=width:100% ng-show=\"model.filters[\'dvs\']\"><select ng-model=\"model.filters[\'dvs\'].pattern\" ng-change=filterUsers(); ng-options=\"dvs.id as tools.short(dvs) for dvs in tools.addElement(tools.addElement(parameters.notDelArrayDVS,none),any) | orderBy:\'id\'\"></select></div></div></th><th><div class=th__content style=width:100%>{{sortIndex=getSortIndex(\'role\');\"\"}} <span ng-click=\"sortBy(\'role\',$event)\">{{tools.lang({\'en\':\'Role\',\'nl\':\'Rol\',\'fr\':\'Role\'})}} </span><span class=sortorder ng-show=\"sortIndex>=0\" ng-class=\"{reverse: model.sortings[sortIndex].reverse}\" ng-click=\"sortBy(\'role\',$event)\"></span> <span ng-show=\"tools.getLength(model.sortings)>1 && sortIndex>=0\">{{sortIndex+1}}</span> <span class=\"glyphicon glyphicon-filter\" ng-click=\"addFilter(\'role\')\"></span><div style=width:100% ng-show=\"model.filters[\'role\']\"><select ng-model=\"model.filters[\'role\'].pattern\" ng-change=filterUsers(); ng-options=\"rol.id as tools.label(rol) for rol in tools.addElement(parameters.notDelArrayROL,any) | orderBy:\'id\'\"></select></div></div></th><th><div class=th__content><span ng-show=\"model.filters[\'active\']\"><input type=checkbox ng-model=\"model.filters[\'active\'].pattern\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" ng-change=filterUsers()> </span>{{tools.lang({\'en\':\'Active\',\'nl\':\'Actief\',\'fr\':\'Actif\'})}} <span class=\"glyphicon glyphicon-filter\" ng-click=\"addFilter(\'active\',null,\'1\');filterUsers();\"></span></div></th><th><div class=th__content><span ng-show=\"model.filters[\'deleted\']\"><input type=checkbox ng-model=\"model.filters[\'deleted\'].pattern\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" ng-change=filterUsers()> </span><span class=\"glyphicon glyphicon-trash\"></span> <span class=\"glyphicon glyphicon-filter\" ng-click=\"addFilter(\'deleted\',null,\'0\');filterUsers();\"></span></div></th></tr></thead><tbody><tr ng-repeat=\"userRow in tools.startFrom(model.orderedUsers,(model.page-1)*model.itemsPerPage) | limitTo:model.itemsPerPage\" ng-class=\"{\'last\':$last}\" ng-class-even=\"\'even\'\" ng-class-odd=\"\'odd\'\"><td><input edit ng-click=editUser(userRow)>&nbsp;</td><td>{{userRow.email}}</td><td>{{userRow.name}}</td><td>{{tools.short(parameters.DVS[userRow.dvs])}}</td><td>{{tools.label(parameters.ROL[userRow.role])}}</td><td><input type=checkbox ng-model=userRow.active ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" ng-change=replaceUser(userRow) ng-disabled=\"user.id===userRow.id\"></td><td><button ng-class=\"{\'btn-danger\':userRow.deleted===\'0\'}\" ng-style=\"{\'padding\':userRow.deleted!==\'0\'?\'8px 5px\':\'\'}\" class=\"btn btn-default\" ng-click=deleteUser(userRow)><span ng-show=\"userRow.deleted===\'0\'\" class=\"glyphicon glyphicon-trash\"></span> <span ng-show=\"userRow.deleted!==\'0\'\" class=material-icons>restore_from_trash</span></button></td></tr></tbody></table></div></div></div></div></main><div ng-show=\"model.task!=\'l\'\"><form class=form-horizontal><div class=\"form-group clearfix\"><label for=userProfilepicture class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Profilepicture\',\'nl\':\'Profielfoto\',\'fr\':\'Photo de profil\'})}}</label><div class=col-sm-10><!-- \n           <div ng-show=\"model.user.templateimage==\'0\'\" ngf-drop=\"upload($file,$invalidFiles)\" ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" ngf-max-size=\"1MB\"\n               class=\"panel panel-default\" ngf-drag-over-class=\"\'panel-success dragover\'\">\n            <div class=\"panel-body\">\n              <span class=\"glyphicon glyphicon-picture\"></span>\n              {{tools.lang({\'en\':\'Drop file here or\',\'nl\':\'Sleep bestand naar hier of\',\'fr\':\'Drop file here or\'})}}\n              <div class=\"btn btn-default\" ngf-select=\"upload($file,$invalidFiles)\" ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" ngf-max-size=\"1MB\">\n                {{tools.lang({\'en\':\'Select\',\'nl\':\'Selecteer\',\'fr\':\'Select\'})}}\n              </div>\n            </div>\n          </div>\n --><div ng-show=\"model.user.templateimage==\'0\'\" class=\"panel panel-default\"><div class=panel-body><span class=\"glyphicon glyphicon-picture\"></span></div></div><div ng-hide=\"model.user.templateimage==\'0\'\"><img id=userProfilepicture ng-src=\"{{user.templateimage!==\'0\'?config.get(\'imageService\')+\'?id=\'+model.user.templateimage:\'\'}}\" width={{model.templateimages[model.user.templateimage].width}}></div></div></div><div class=\"form-group clearfix\"><label for=userEmail class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Email\',\'nl\':\'Email\',\'fr\':\'Email\'})}}</label><div class=col-sm-10><input type=text id=userEmail class=form-control ng-model=model.user.email placeholder=\"{{tools.lang({\'en\':\'Email\',\'nl\':\'Email\',\'fr\':\'Email\'})}}\"></div></div><div class=\"form-group clearfix\"><label for=userName class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Name\',\'nl\':\'Naam\',\'fr\':\'Nom\'})}}</label><div class=col-sm-10><input type=text id=userName class=form-control ng-model=model.user.name placeholder=\"{{tools.lang({\'en\':\'Name\',\'nl\':\'Naam\',\'fr\':\'Nom\'})}}\"></div></div><!--\n      <div class=\"form-group clearfix\">\n        <label for=\"userShort\" class=\"col-sm-2 control-label\">\n          {{tools.lang({\'en\':\'Short name\',\'nl\':\'Korte naam\',\'fr\':\'Nom court\'})}}\n        </label>\n        <div class=\"col-sm-10\">\n          <input type=\"text\" id=\"userShort\" class=\"form-control\" ng-model=\"model.user.short\"\n                 placeholder=\"{{tools.lang({\'en\':\'Short name\',\'nl\':\'Korte naam\',\'fr\':\'Nom court\'})}}\" />\n        </div>\n      </div>\n --><div class=\"form-group clearfix\"><label for=userGsm class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Gsm\',\'nl\':\'Gsm\',\'fr\':\'Gsm\'})}}</label><div class=col-sm-10><input type=text id=userGsm class=form-control ng-model=model.user.gsm placeholder=\"{{tools.lang({\'en\':\'GSM\',\'nl\':\'GSM\',\'fr\':\'GSM\'})}}\"></div></div><div class=\"form-group clearfix\"><label for=userDepartment class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Department\',\'nl\':\'Departement\',\'fr\':\'Departement\'})}}</label><div class=col-sm-10><input type=text id=userDepartment class=form-control ng-model=model.user.department placeholder=\"{{tools.lang({\'en\':\'Department\',\'nl\':\'Departement\',\'fr\':\'Departement\'})}}\"></div></div><div class=\"form-group clearfix\"><label for=userDvs class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Division\',\'nl\':\'Bedrijf\',\'fr\':\'Division\'})}}</label><div class=col-sm-10><select ng-model=model.user.dvs class=form-control id=userDvs ng-options=\"dvs.id as tools.short(dvs) for dvs in tools.addElement(parameters.notDelArrayDVS,any) | orderBy:\'id\'\"></select></div></div><span ng-show=\"user.role===\'EMPADM\' || user.id===model.user.id\"><div class=\"form-group clearfix\"><label for=userPassword class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'New Password\',\'nl\':\'Nieuw Paswoord\',\'fr\':\'Nouveau Password\'})}}</label><div class=col-sm-10><input type=password id=userPassword class=form-control ng-model=model.user.password placeholder=\"{{tools.lang({\'en\':\'New Password\',\'nl\':\'Nieuw Paswoord\',\'fr\':\'Nouveau Password\'})}}\"></div></div><div class=\"form-group clearfix\"><label for=userConfirmPassword class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Confirm Password\',\'nl\':\'Paswoord Bevestigen\',\'fr\':\'Confirmer Password\'})}}</label><div class=col-sm-10><input type=password id=userConfirmPassword class=form-control ng-model=model.user.confirmPassword placeholder=\"{{tools.lang({\'en\':\'Confirm Password\',\'nl\':\'Paswoord Bevestigen\',\'fr\':\'Confirmer Password\'})}}\"></div></div></span><div class=\"form-group clearfix\"><label for=userRole class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Role\',\'nl\':\'Rol\',\'fr\':\'Role\'})}}</label><div class=col-sm-10><select ng-model=model.user.role class=form-control id=userRole ng-options=\"rol.id as tools.label(rol) for rol in tools.toArray(parameters.ROL) | orderBy:\'id\'\"></select></div></div><div class=\"form-group clearfix\"><label for=userLang class=\"col-sm-2 control-label\">{{tools.lang({\'en\':\'Language\',\'nl\':\'Taal\',\'fr\':\'Langue\'})}}</label><div class=col-sm-10><select ng-model=model.user.lang class=form-control id=userLang><option value=en>English</option><option value=nl>Nederlands</option><option value=fr>Frans</option></select></div></div><div class=\"form-group clearfix\"><div class=\"col-sm-offset-2 col-sm-10\"><div class=checkbox><label><input type=checkbox id=userActive ng-model=model.user.active ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" ng-change=\"model.passwordReset=model.user.active\" ng-disabled=\"user.id===model.user.id\"> {{tools.lang({\'en\':\'Active\',\'nl\':\'Actief\',\'fr\':\'Actif\'})}}</label></div><div class=checkbox ng-hide=\"user.id===model.user.id\"><label><input type=checkbox id=passwordReset ng-model=model.passwordReset ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" ng-disabled=\"model.user.active!==\'1\'\"> <span ng-show=\"model.task===\'c\'\">{{tools.lang({\'en\':\'Send activation mail\',\'nl\':\'Zend activatie mail\',\'fr\':\'Envoyer mail d\\u0027activation\'})}} </span><span ng-hide=\"model.task===\'c\'\">{{tools.lang({\'en\':\'Password reset\',\'nl\':\'Paswoord reset\',\'fr\':\'Réinitialiser le mot de passe\'})}}</span></label></div></div></div><div class=\"form-group clearfix\"><div class=\"col-sm-offset-2 col-sm-10\"><button type=submit class=\"btn btn-primary\" ng-click=replaceUser(model.user);><span ng-show=\"model.task==\'c\'\">{{tools.lang({\'en\':\'Create\',\'nl\':\'Aanmaken\',\'fr\':\'Cr\\u00E9er\'})}}</span> <span ng-show=\"model.task==\'u\'\">{{tools.lang({\'en\':\'Confirm\',\'nl\':\'Bevestig\',\'fr\':\'Conirmer\'})}}</span></button> <button type=button class=\"btn btn-default\" ng-click=\"model.task=\'l\';\">{{tools.lang({\'en\':\'Return\',\'nl\':\'Terug\',\'fr\':\'Retour\'})}}</button></div></div></form><div ng-show=\"model.task==\'u\'\"><h4>{{tools.lang({\'en\':\'Special rights\',\'nl\':\'Speciale rechten\',\'fr\':\'Droits speciaux\'})}}</h4><ul class=list-group><li class=list-group-item ng-repeat=\"rightRow in tools.join(model.user,\'rights\',model) | orderBy:\'id\'\">{{tools.label(parameters.RGH[rightRow.rgh])}} <input class=\"btn btn-danger\" delete ng-click=deleteRight(rightRow);></li><li class=list-group-item><form class=form><div class=\"form-group clearfix\"><select class=form-control ng-options=\"rgh.id as tools.label(rgh) for rgh in parameters.notDelArrayRGH | orderBy:\'id\'\" ng-model=model.right.rgh ng-change=createRight(model.right.rgh);></select></div></form></li></ul></div></div></div>");
$templateCache.put("app/modules/visits/addArticleModal.html","<div class=modal-body><form class=form-horizontal><div class=\"form-group clearfix\"><div class=col-xs-12><label for=outdoorSearchVisits class=\"control-label required\">{{tools.lang({\'en\':\'Add to:\',\'nl\':\'Voeg toe aan:\',\'fr\':\'Ajouter à:\'})}}</label><div class=checkbox ng-show=\"model.transferVisit.id==\'0\'\"><label><input type=checkbox ng-model=model.toExistingVisit ng-change=\"selectTransferType(\'existing\',model.toExistingVisit);\"> {{tools.lang({\'en\':\'Existing visit\',\'nl\':\'Bestaande reservatie\',\'fr\':\'Reservation existante\'})}}</label></div><div ng-show=\"model.transferVisit.id==\'0\' && model.toExistingVisit\" id=outdoorSearchVisits outdoor-search-contacts parent-model=model selected-name=\"\'transfer\'\" search-term=model.searchTerm task=\"\'s\'\" on-create-visit=\"selectVisit(\'new\')\" on-update-selection=\"selectVisit(\'existing\')\" search-companies=false search-contacts=false search-visits=true></div><label class=\"control-label required\" ng-show=\"model.transferVisit.id==\'0\' || model.transferMode==\'new\'\">{{tools.lang({\'en\':\'New visit\',\'nl\':\'Nieuwe reservatie\',\'fr\':\'Nouvelle réservation\'})}}</label><div class=checkbox ng-show=\"model.transferVisit.id==\'0\'\"><label><input type=checkbox ng-model=model.toCompany ng-change=\"selectTransferType(\'company\',model.toCompany);\"> {{tools.lang({\'en\':\'Company\',\'nl\':\'Bedrijf\',\'fr\':\'Entreprise\'})}}</label></div><div class=checkbox ng-show=\"model.transferVisit.id==\'0\'\"><label><input type=checkbox ng-model=model.toContact ng-change=\"selectTransferType(\'contact\',model.toContact);\"> {{tools.lang({\'en\':\'Customer\',\'nl\':\'Klant\',\'fr\':\'Client\'})}}</label></div><div ng-show=\"model.transferVisit.id!=\'0\'\" class=\"form-group clearfix\">{{visit=model.transferVisit;\'\';}}<div class=col-xs-8><span ng-show=\"model.transferMode==\'existing\'\"><b>{{(visit.firstname!=\'\'?visit.firstname+\' \':\'\')+visit.name}}</b><br><span>{{(visit.startdateISO!==visit.enddateISO?(tools.dateFromJava(visit.startdate)+\' - \'):\'\')+tools.dateFromJava(visit.enddate)+\' | \'+tools.label(parameters.STV[visit.stat])}}</span></span></div><div class=\"col-xs-4 text-right\"><button delete class=\"btn btn-danger\" ng-click=resetTransferVisit()></button></div></div><span ng-show=\"tools.numberIn(model.transferVisit.id)<0\"><!-- owningContact --><div outdoor-contact model=model contact-name=owning contact-wording=\"tools.lang({\'en\':\'Client *\',\'nl\':\'Klant *\',\'fr\':\'Client *\'})\" on-update=\"model.visit.owningcontact=model.owningContact.id;\" contact-is-editable=false contact-is-changeable=true contact-retrieve=contactRetrieve></div><!-- communicationContact --><div outdoor-contact model=model contact-name=communication contact-wording=\"tools.lang({\'en\':\'Contact\',\'nl\':\'Contactpersoon\',\'fr\':\'Contact\'})\" on-update=\"model.visit.communicationcontact=model.communicationContact.id;\" contact-is-editable=false contact-is-changeable=true contact-retrieve=contactRetrieve></div></span></div></div></form></div><div class=modal-footer><button class=\"btn btn-primary\" type=button ng-click=ok()>OK</button> <button class=\"btn btn-warning\" type=button ng-click=cancel()>Cancel</button></div>");
$templateCache.put("app/modules/visits/addPacketModal.html","<div class=modal-body><uib-tabset active=activeTabIndex><uib-tab index=0><uib-tab-heading>{{tools.lang({\'en\':\'Public form\',\'nl\':\'Publiek formulier\',\'fr\':\'Formulaire publique\'})}}</uib-tab-heading><br><!--       <p ng-hide=\"isCreated()\">\n        {{tools.lang({\'en\':\'First create the visit before adding a public form packet\',\'nl\':\'Eerst het bezoek aanmaken voor toevoegen van een publiek formulier packet\',\'fr\':\'Cr\\u00E9ez d\\u0027abord la visite avant d\\u0027ajouter un paquet d\\u0027un formulaire public\'})}}\n      </p>\n --><form class=form-horizontal><div class=form-group><label class=\"col-xs-2 control-label\" ng-click=\"startdateOpened=!startdateOpened;\">{{tools.lang({\'en\':\'Form\',\'nl\':\'Formulier\',\'fr\':\'Formulaire\'})}}</label><div class=col-xs-10><select class=form-control ng-model=model.ffoId ng-options=\"ffo.id as tools.label(ffo) for ffo in tools.addElement(model.filteredFfos,selectFfo) | orderBy:\'label\'+user.lang\"></select></div></div></form></uib-tab><uib-tab index=1><uib-tab-heading>{{tools.lang({\'en\':\'Old packets\',\'nl\':\'Oude pakketten\',\'fr\':\'Paquets vieux\'})}}</uib-tab-heading><form class=form-horizontal><div class=form-group><label class=\"col-xs-2 control-label\" ng-click=\"startdateOpened=!startdateOpened;\">{{tools.lang({\'en\':\'Startdate\',\'nl\':\'Begin datum\',\'fr\':\'Date de debut\'})}}</label><div class=col-xs-4><p class=input-group><input type=text autocomplete=off class=form-control uib-datepicker-popup ng-model=startdate is-open=startdateOpened datepicker-options=startdateOptions ng-click=\"startdateOpened=!startdateOpened;\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"startdateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><label class=\"col-xs-2 control-label\">{{tools.lang({\'en\':\'Participants\',\'nl\':\'Deelnemers\',\'fr\':\'Participants\'})}}</label><div class=col-xs-4><div class=input-group><div class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=\"model.participantcount=tools.amountIn(model.participantcount)-1;\">-</button></div><input type=text autocomplete=off class=form-control ng-model=model.participantcount><div class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=\"model.participantcount=tools.amountIn(model.participantcount)+1;\">+</button></div></div></div></div><div ng-repeat=\"packet in packets\"><div class=glyphicon ng-click=\"packet.expanded=!packet.expanded\" ng-class=\"{\'glyphicon-chevron-down\':!packet.expanded,\'glyphicon-chevron-up\':packet.expanded}\"></div><span>{{tools.lang({\'en\':packet.label1,\'nl\':packet.label2,\'fr\':packet.label3})}}</span><label ng-hide=\"packet.voucherValue===false\">{{tools.lang({\'en\':\'Voucher value\',\'nl\':\'Waarde cadeaubon\',\'fr\':\'Valeur cheque-cadeau\'})}} <input type=text autocomplete=off class=form-control ng-model=packet.voucherValue></label><button type=button class=\"btn btn-default\" ng-click=select(packet);><span class=glyphicon ng-class=\"\'glyphicon-plus\'\"></span></button><div ng-show=packet.expanded ng-repeat=\"packetcomponent in getPacketcomponents(packet) | orderBy:[\'day\',\'hrs\']\"><span ng-show=\"packetcomponent.param1==\'ACT\'\">{{tools.label(parameters.ACT[tools.substr(packetcomponent.param2,0,3)])+ \'&nbsp\' + tools.label(parameters.FRM[packetcomponent.param2])}} </span><span ng-show=\"packetcomponent.param1==\'MEA\'\">{{tools.label(parameters.RES[tools.substr(packetcomponent.param2,0,3)])+ \'&nbsp\' + tools.label(parameters.DSH[packetcomponent.param2])}} </span><span ng-show=\"packetcomponent.param1==\'HTL\'\">{{tools.label(parameters.HTL[tools.substr(packetcomponent.param2,0,3)])+ \'&nbsp\' + tools.label(parameters.HSC[packetcomponent.param2])}} </span><span ng-show=\"packetcomponent.param1==\'PRD\'\">{{tools.label(parameters.PRD[tools.substr(packetcomponent.param2,0,3)])}} </span><span ng-show=\"packetcomponent.param1!==\'PRD\'\">{{tools.lang({\'en\':\' day \',\'nl\':\' dag \',\'fr\':\' jour \'}) + packetcomponent.day + tools.lang({\'en\':\' at \',\'nl\':\' om \',\'fr\':\' u00E0 \'}) + packetcomponent.hrs}}</span></div></div></form></uib-tab></uib-tabset></div><div class=modal-footer><button class=\"btn btn-warning\" type=button ng-click=cancel()>Cancel</button> <button ng-show=\"activeTabIndex===0 && model.ffoId!==\'\'\" class=\"btn btn-primary\" ng-click=navigateToFfo(model.ffoId)>{{tools.lang({\'en\':\'Navigate\',\'nl\':\'Navigeer\',\'fr\':\'Naviguer\'})}}</button></div>");
$templateCache.put("app/modules/visits/finishAddPacketModal.html","<div class=modal-body><form class=form-horizontal><div class=form-group><label class=\"col-xs-2 control-label\" ng-click=\"startdateOpened=!startdateOpened;\">{{tools.lang({\'en\':\'Startdate\',\'nl\':\'Begin datum\',\'fr\':\'Date de debut\'})}}</label><div class=col-xs-4><p class=input-group><input type=text autocomplete=off class=form-control uib-datepicker-popup ng-model=startdate is-open=startdateOpened datepicker-options=startdateOptions ng-click=\"startdateOpened=!startdateOpened;\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"startdateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><label class=\"col-xs-2 control-label\" ng-click=\"startdateOpened=!startdateOpened;\">{{tools.lang({\'en\':\'Enddate\',\'nl\':\'Vertrek datum\',\'fr\':\'Date de d\\u00E9part\'})}}</label><div class=col-xs-4><p class=input-group><input type=text autocomplete=off class=form-control uib-datepicker-popup ng-model=enddate is-open=enddateOpened datepicker-options=enddateOptions ng-click=\"enddateOpened=!enddateOpened;\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"enddateOpened=true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div ng-repeat=\"cgr in cgrs\"><label class=\"col-xs-2 control-label\">{{tools.label(cgr)}}</label><div class=col-xs-4><div class=input-group><div class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=\"cgr.quantity=tools.amountIn(cgr.quantity)-1;\">-</button></div><input type=text autocomplete=off class=form-control ng-model=cgr.quantity><div class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=\"cgr.quantity=tools.amountIn(cgr.quantity)+1;\">+</button></div></div></div></div></div></form></div><div class=modal-footer><button class=\"btn btn-primary\" type=button ng-click=ok()>OK</button> <button class=\"btn btn-warning\" type=button ng-click=cancel()>Cancel</button></div>");
$templateCache.put("app/modules/visits/massEditVisitElementsModal.html","<div class=modal-body><form class=form-horizontal><uib-tabset active=model.mode class=\"mb-2 tabs\"><uib-tab index=mode.id heading={{tools.lang(mode)}} ng-show=\"mode.id!==\'duplicate\' || user.hasRight(\'QUOT\')\" select=selectTab(mode.id) disable=modeIsDisabled(mode.id) ng-repeat=\"mode in tools.toArray(model.modes) | orderBy:\'sort\'\"></uib-tab></uib-tabset><span ng-show=\"model.mode==\'transfer\' || model.mode==\'duplicate\'\"><div class=\"form-group clearfix\"><div class=col-xs-12><label for=outdoorSearchVisits class=\"control-label required\">{{tools.lang(model.modes[model.mode])+\' \'+tools.lang({\'en\':\'to:\',\'nl\':\'naar:\',\'fr\':\'vers:\'})}}</label><div class=checkbox ng-show=\"model.transferVisit.id==\'0\'\"><label><input type=checkbox ng-model=model.toExistingVisit ng-change=\"selectTransferType(\'existing\',model.toExistingVisit);\"> {{tools.lang({\'en\':\'Existing visit\',\'nl\':\'Bestaande reservatie\',\'fr\':\'Reservation existante\'})}}</label></div><div ng-show=\"model.transferVisit.id==\'0\' && model.toExistingVisit\" id=outdoorSearchVisits outdoor-search-contacts parent-model=model selected-name=\"\'transfer\'\" search-term=model.searchTerm task=\"\'s\'\" on-create-visit=\"selectVisit(\'new\')\" on-update-selection=\"selectVisit(\'existing\')\" search-companies=false search-contacts=false search-visits=true></div><label class=\"control-label required\" ng-show=\"model.transferVisit.id==\'0\' || model.transferMode==\'new\'\">{{tools.lang({\'en\':\'New visit\',\'nl\':\'Nieuwe reservatie\',\'fr\':\'Nouvelle réservation\'})}}</label><div class=checkbox ng-show=\"model.transferVisit.id==\'0\'\"><label><input type=checkbox ng-model=model.toCompany ng-change=\"selectTransferType(\'company\',model.toCompany);\"> {{tools.lang({\'en\':\'Company\',\'nl\':\'Bedrijf\',\'fr\':\'Entreprise\'})}}</label></div><div class=checkbox ng-show=\"model.transferVisit.id==\'0\'\"><label><input type=checkbox ng-model=model.toContact ng-change=\"selectTransferType(\'contact\',model.toContact);\"> {{tools.lang({\'en\':\'Customer\',\'nl\':\'Klant\',\'fr\':\'Client\'})}}</label></div><div ng-show=\"model.transferVisit.id!=\'0\'\" class=\"form-group clearfix\">{{visit=model.transferVisit;\'\';}}<div class=col-xs-8><span ng-show=\"model.transferMode==\'existing\'\"><b>{{(visit.firstname!=\'\'?visit.firstname+\' \':\'\')+visit.name}}</b><br><span>{{(visit.startdateISO!==visit.enddateISO?(tools.dateFromJava(visit.startdate)+\' - \'):\'\')+tools.dateFromJava(visit.enddate)+\' | \'+tools.label(parameters.STV[visit.stat])}}</span></span></div><div class=\"col-xs-4 text-right\"><button delete class=\"btn btn-danger\" ng-click=resetTransferVisit()></button></div></div></div></div><div class=\"form-group clearfix\" ng-if=\"model.transferVisit.id!=\'0\'\"><div ng-include=\"\'app/modules/activities/edit.html\'\"></div><div class=col-xs-12 ng-show=\"tools.getLength(tools.join(model.transferVisit,\'movements\',model))>0 && model.mode==\'transfer\'\"><div class=checkbox><label><input type=checkbox ng-model=model.editMovements> {{tools.lang({\'en\':\'Adjust movements\',\'nl\':\'Betalingen aanpassen\',\'fr\':\'Ajuster les paiements\'})}}</label></div></div></div><ul class=list-group ng-show=model.editMovements><li class=list-group-item ng-repeat=\"movement in tools.join(model.transferVisit,\'movements\',model) | orderBy:created\"><form class=form-horizontal><div class=\"form-group clearfix\"><div class=col-xs-12>{{tools.amountOut(movement.oldAmount)+\'€\'}} <span ng-show=model.accounts[movement.account]>{{tools.label(parameters.MTH[model.accounts[movement.account].method])}} </span>{{tools.doneBy(movement.created,movement.creator_name)}}</div></div><div class=\"form-group clearfix\"><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Amount\',\'nl\':\'Bedrag\',\'fr\':\'Montant\'})}}</label><div class=col-md-10><input type=text class=form-control ng-model=movement.amount></div></div><div class=\"form-group clearfix\"><label class=\"col-md-2 control-label\">{{tools.lang({\'en\':\'Extra info\',\'nl\':\'Extra info\',\'fr\':\'Extra info\'})}}</label><div class=col-md-10><textarea class=form-control ng-model=movement.comment placeholder=\"{{tools.lang({\'en\':\'Extra info\',\'nl\':\'Extra info\',\'fr\':\'Extra info\'})}}\"></textarea></div></div></form></li></ul></span><span ng-show=\"model.mode==\'edit\' || (model.mode==\'duplicate\' && model.transferVisit.id!=\'0\')\"><div class=content__noresult ng-show=\"!tools.getLength(model.selectedVisitElementsWithDate)>0 && !tools.getLength(model.hotelreservationcategoriesForEditEnddate)>0 && !tools.getLength(model.hotelreservationcategoriesForEditEnddate)>0 && !(tools.getLength(tools.exclude(model.selectedVisitElementsWithDate,{\'hasQuantity\':false}))+tools.getLength(tools.exclude(model.products,{\'hasQuantity\':false})))>0 && !tools.getLength(model.participants)>0 && !tools.getLength(model.products)>0\"><div class=\"alert alert-info\" role=alert><p>{{tools.lang({\'en\':\'No articles selected to edit\',\'nl\':\'Geen artikels geselecteerd om te bewerken\',\'fr\':\'Pas d\\u0027articles s\\u00E9lectionn\\u00E9s \\u00E0 modifier\'})}}</p></div></div><div class=\"form-group clearfix\" ng-show=\"tools.getLength(model.selectedVisitElementsWithDate)>0\"><div class=col-sm-5><div class=checkbox><label><input type=checkbox ng-model=model.editStartdate> {{tools.lang({\'en\':\'Update startdate\',\'nl\':\'Update startdatum\',\'fr\':\'Mettre \\u00E0 jour date de d\\u00E9but\'})}}</label></div><div class=col-sm-offset-2><i>{{tools.lang({\'en\':\'Selection startdate: \',\'nl\':\'Selectie startdatum: \',\'fr\':\'Date de d\\u00E9but selection: \'})}}</i><div>{{tools.dateOut(tools.dateFromJava(model.oldStartdate))}}</div></div></div><label class=\"col-sm-3 control-label\">{{tools.lang({\'en\':\'New startdate\',\'nl\':\'Nieuwe startdatum\',\'fr\':\'Nouveau date de d\\u00E9but\'})}}</label><div class=col-sm-4><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.startdate is-open=model.editStartdateOpened datepicker-options=model.startdateOptions ng-click=\"model.editStartdateOpened=!model.editStartdateOpened\" ng-disabled=!model.editStartdate> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.editStartdateOpened=true\" ng-disabled=!model.editStartdate><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><label class=\"col-sm-3 control-label\">{{tools.lang({\'en\':\'Mode\',\'nl\':\'Mode\',\'fr\':\'Mode\'})}} <i class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=model.startdateModeInfo tooltip-placement=bottom tooltip-popup-delay=250 tooltip-class=info></i></label><div class=col-sm-4><div class=btn-group><md-button type=button class=\"btn btn-default\" ng-repeat=\"offsetMode in model.offsetModes | orderBy:\'id\'\" ng-click=\"model.startdateOffsetMode=offsetMode.id;onUpdateStartdate()\" ng-class=\"{\'active\':model.startdateOffsetMode==offsetMode.id && model.editStartdate}\" ng-disabled=!model.editStartdate>{{tools.lang(offsetMode)}}</md-button></div></div></div><div class=\"form-group clearfix\" ng-show=\"tools.getLength(model.hotelreservationcategoriesForEditEnddate)>0\"><div class=col-sm-12><div class=checkbox><label><input type=checkbox ng-model=model.keepNightCount ng-disabled=model.editEnddate> {{tools.lang({\'en\':\'Keep same number of nights for hotelreservations\',\'nl\':\'Behoud aantal overnachtingen per hotelreservatie\',\'fr\':\'Garder les m\\u00EAmes nombres des nuits par reservation\'})}}</label></div></div></div><div class=\"form-group clearfix\" ng-show=\"tools.getLength(model.hotelreservationcategoriesForEditEnddate)>0\"><div class=col-sm-5><div class=checkbox><label><input type=checkbox ng-model=model.editEnddate ng-change=\"model.keepNightCount=!model.editEnddate\"> {{tools.lang({\'en\':\'Update departure date hotel reservations\',\'nl\':\'Update vertrekdatum hotelreservaties\',\'fr\':\'Mettre \\u00E0 jour la date de d\\u00E9part des r\\u00E9servations d\\u0027h\\u00F4tel\'})}}</label></div><div class=col-sm-offset-2><i>{{tools.lang({\'en\':\'Selection latest departure date: \',\'nl\':\'Selectie laatste vertrekdatum: \',\'fr\':\'Derni\\u00E8re date de d\\u00E9part: \'})}}</i><br><div>{{tools.dateOut(tools.dateFromJava(model.oldEnddate))}}</div></div></div><label class=\"col-sm-3 control-label\">{{tools.lang({\'en\':\'New enddate\',\'nl\':\'Nieuwe einddatum\',\'fr\':\'Nouveau date de fin\'})}}</label><div class=col-sm-4><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.enddate is-open=model.editEnddateOpened datepicker-options=model.enddateOptions ng-click=\"model.editEnddateOpened=!model.editEnddateOpened\" ng-disabled=!model.editEnddate> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.editEnddateOpened=true\" ng-disabled=!model.editEnddate><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><label class=\"col-sm-3 control-label\">{{tools.lang({\'en\':\'Mode\',\'nl\':\'Mode\',\'fr\':\'Mode\'})}} <i class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=model.enddateModeInfo tooltip-placement=bottom tooltip-popup-delay=250 tooltip-class=info></i></label><div class=col-sm-4><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"offsetMode in model.offsetModes | orderBy:\'id\'\" ng-click=\"model.enddateOffsetMode=offsetMode.id\" ng-class=\"{\'active\':model.enddateOffsetMode==offsetMode.id && model.editEnddate}\" ng-disabled=!model.editEnddate>{{tools.lang(offsetMode)}}</button></div></div></div><div class=\"form-group clearfix\" ng-show=\"(tools.getLength(tools.exclude(model.selectedVisitElementsWithDate,{\'hasQuantity\':false}))+tools.getLength(tools.exclude(model.products,{\'hasQuantity\':false})))>0 && model.mode==\'edit\'\"><div class=col-sm-12><div class=checkbox><label><input type=checkbox ng-model=model.setSelectedElementsToZero ng-disabled=\"model.editParticipantcount || model.editDishcount || model.editRoomcount || model.editChildcount || model.editAdultcount || model.editProductcount || model.setVouchersToUsedAmount\"> {{tools.lang({\'en\':\'Set quantity for selected articles to zero\',\'nl\':\'Zet voor de geselecteerde artikelen het aantal op nul\',\'fr\':\'Mettre la quantit\\u00E9 pour les articles s\\u00E9lectionn\\u00E9s \\u00E0 zero\'})}}</label></div></div></div><div class=\"form-group clearfix\" ng-show=\"tools.getLength(model.participants)>0\"><div class=col-sm-5><div class=checkbox><label><input type=checkbox ng-model=model.editParticipantcount ng-change=\"model.setSelectedElementsToZero=false\"> {{tools.lang({\'en\':\'Adjust participant quantity for the selected activities\',\'nl\':\'Pas het aantal personen voor de geselecteerde activiteiten aan\',\'fr\':\'Mettre \\u00E0 jour la quantit\\u00E9 des personnes pour les activit\\u00E9s s\\u00E9lectionn\\u00E9s\'})}}</label></div></div><label class=\"col-sm-3 control-label\">{{tools.lang({\'en\':\'Quantity\',\'nl\':\'Aantal\',\'fr\':\'Quantit\\u00E9\'})}}</label><div class=col-sm-4><input type=text class=form-control ng-model=model.participantcount ng-disabled=!model.editParticipantcount></div><label class=\"col-sm-3 control-label\">{{tools.lang({\'en\':\'Mode\',\'nl\':\'Mode\',\'fr\':\'Mode\'})}} <i class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=model.quantityModeInfo tooltip-placement=bottom tooltip-popup-delay=250 tooltip-class=info></i></label><div class=col-sm-4><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"offsetMode in model.offsetModes | orderBy:\'id\'\" ng-click=\"model.participantcountOffsetMode=offsetMode.id\" ng-class=\"{\'active\':model.participantcountOffsetMode==offsetMode.id && model.editParticipantcount}\" ng-disabled=!model.editParticipantcount>{{tools.lang(offsetMode)}}</button></div></div></div><div class=\"form-group clearfix\" ng-show=\"tools.getLength(model.dishes)>0\"><div class=col-sm-5><div class=checkbox><label><input type=checkbox ng-model=model.editDishcount ng-change=\"model.setSelectedElementsToZero=false\"> {{tools.lang({\'en\':\'Adjust participant quantity for the selected meals\',\'nl\':\'Pas het aantal personen voor de geselecteerde maaltijden aan\',\'fr\':\'Mettre \\u00E0 jour la quantit\\u00E9 des personnes pour les repas s\\u00E9lectionn\\u00E9s\'})}}</label></div></div><label class=\"col-sm-3 control-label\">{{tools.lang({\'en\':\'Quantity\',\'nl\':\'Aantal\',\'fr\':\'Quantit\\u00E9\'})}}</label><div class=col-sm-4><input type=text class=form-control ng-model=model.dishcount ng-disabled=!model.editDishcount></div><label class=\"col-sm-3 control-label\">{{tools.lang({\'en\':\'Mode\',\'nl\':\'Mode\',\'fr\':\'Mode\'})}} <i class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=model.quantityModeInfo tooltip-placement=bottom tooltip-popup-delay=250 tooltip-class=info></i></label><div class=col-sm-4><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"offsetMode in model.offsetModes | orderBy:\'id\'\" ng-click=\"model.dishcountOffsetMode=offsetMode.id\" ng-class=\"{\'active\':model.dishcountOffsetMode==offsetMode.id && model.editDishcount}\" ng-disabled=!model.editDishcount>{{tools.lang(offsetMode)}}</button></div></div></div><div class=\"form-group clearfix\" ng-show=\"tools.getLength(model.hotelreservationcategoriesForEditRoomcount)>0\"><div class=col-sm-5><div class=checkbox><label><input type=checkbox ng-model=model.editRoomcount ng-change=\"model.setSelectedElementsToZero=false\"> {{tools.lang({\'en\':\'Adjust room quantity for the selected hotel reservations\',\'nl\':\'Pas het aantal kamers voor de geselecteerde hotelreservaties aan\',\'fr\':\'Mettre \\u00E0 jour la quantit\\u00E9 des chambres pour les r\\u00E9servations d\\u0027h\\u00F4tel s\\u00E9lectionn\\u00E9s\'})}}</label></div></div><label class=\"col-sm-3 control-label\">{{tools.lang({\'en\':\'Quantity\',\'nl\':\'Aantal\',\'fr\':\'Quantit\\u00E9\'})}}</label><div class=col-sm-4><input type=text class=form-control ng-model=model.roomcount ng-disabled=!model.editRoomcount></div><label class=\"col-sm-3 control-label\">{{tools.lang({\'en\':\'Mode\',\'nl\':\'Mode\',\'fr\':\'Mode\'})}} <i class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=model.quantityModeInfo tooltip-placement=bottom tooltip-popup-delay=250 tooltip-class=info></i></label><div class=col-sm-4><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"offsetMode in model.offsetModes | orderBy:\'id\'\" ng-click=\"model.roomcountOffsetMode=offsetMode.id\" ng-class=\"{\'active\':model.roomcountOffsetMode==offsetMode.id && model.editRoomcount}\" ng-disabled=!model.editRoomcount>{{tools.lang(offsetMode)}}</button></div></div></div><div class=\"form-group clearfix\" ng-show=\"tools.getLength(model.hotelreservationcategoriesForEditAdultcount)>0\"><div class=col-sm-5><div class=checkbox><label><input type=checkbox ng-model=model.editAdultcount ng-change=\"model.setSelectedElementsToZero=false\"> {{tools.lang({\'en\':\'Adjust adult quantity for the selected hotel reservations\',\'nl\':\'Pas het aantal volwassenen voor de geselecteerde hotelreservaties aan\',\'fr\':\'Mettre \\u00E0 jour la quantit\\u00E9 des adultes pour les r\\u00E9servations d\\u0027h\\u00F4tel s\\u00E9lectionn\\u00E9s\'})}}</label></div></div><label class=\"col-sm-3 control-label\">{{tools.lang({\'en\':\'Quantity\',\'nl\':\'Aantal\',\'fr\':\'Quantit\\u00E9\'})}}</label><div class=col-sm-4><input type=text class=form-control ng-model=model.adultcount ng-disabled=!model.editAdultcount></div><label class=\"col-sm-3 control-label\">{{tools.lang({\'en\':\'Mode\',\'nl\':\'Mode\',\'fr\':\'Mode\'})}} <i class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=model.quantityModeInfo tooltip-placement=bottom tooltip-popup-delay=250 tooltip-class=info></i></label><div class=col-sm-4><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"offsetMode in model.offsetModes | orderBy:\'id\'\" ng-click=\"model.adultcountOffsetMode=offsetMode.id\" ng-class=\"{\'active\':model.adultcountOffsetMode==offsetMode.id && model.editAdultcount}\" ng-disabled=!model.editAdultcount>{{tools.lang(offsetMode)}}</button></div></div></div><div class=\"form-group clearfix\" ng-show=\"tools.getLength(model.hotelreservationcategoriesForEditChildcount)>0\"><div class=col-sm-5><div class=checkbox><label><input type=checkbox ng-model=model.editChildcount ng-change=\"model.setSelectedElementsToZero=false\"> {{tools.lang({\'en\':\'Adjust child quantity for the selected hotel reservations\',\'nl\':\'Pas het aantal kinderen voor de geselecteerde hotelreservaties aan\',\'fr\':\'Mettre \\u00E0 jour la quantit\\u00E9 des enfants pour les r\\u00E9servations d\\u0027h\\u00F4tel s\\u00E9lectionn\\u00E9s\'})}}</label></div></div><label class=\"col-sm-3 control-label\">{{tools.lang({\'en\':\'Quantity\',\'nl\':\'Aantal\',\'fr\':\'Quantit\\u00E9\'})}}</label><div class=col-sm-4><input type=text class=form-control ng-model=model.childcount ng-disabled=!model.editChildcount></div><label class=\"col-sm-3 control-label\">{{tools.lang({\'en\':\'Mode\',\'nl\':\'Mode\',\'fr\':\'Mode\'})}} <i class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=model.quantityModeInfo tooltip-placement=bottom tooltip-popup-delay=250 tooltip-class=info></i></label><div class=col-sm-4><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"offsetMode in model.offsetModes | orderBy:\'id\'\" ng-click=\"model.childcountOffsetMode=offsetMode.id\" ng-class=\"{\'active\':model.childcountOffsetMode==offsetMode.id && model.editChildcount}\" ng-disabled=!model.editChildcount>{{tools.lang(offsetMode)}}</button></div></div></div><div class=\"form-group clearfix\" ng-show=\"tools.getLength(model.products)>0\"><div class=col-sm-5><div class=checkbox><label><input type=checkbox ng-model=model.editProductcount ng-change=\"model.setSelectedElementsToZero=false;model.setVouchersToUsedAmount=false;\"> {{tools.lang({\'en\':\'Adjust product quantity for the selected products\',\'nl\':\'Pas het aantal voor de geselecteerde producten aan\',\'fr\':\'Mettre \\u00E0 jour la quantit\\u00E9 pour les produits s\\u00E9lectionn\\u00E9s\'})}}</label></div></div><label class=\"col-sm-3 control-label\">{{tools.lang({\'en\':\'Quantity\',\'nl\':\'Aantal\',\'fr\':\'Quantit\\u00E9\'})}}</label><div class=col-sm-4><input type=text class=form-control ng-model=model.productcount ng-disabled=!model.editProductcount></div><label class=\"col-sm-3 control-label\">{{tools.lang({\'en\':\'Mode\',\'nl\':\'Mode\',\'fr\':\'Mode\'})}} <i class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=model.quantityModeInfo tooltip-placement=bottom tooltip-popup-delay=250 tooltip-class=info></i></label><div class=col-sm-4><div class=btn-group><button type=button class=\"btn btn-default\" ng-repeat=\"offsetMode in model.offsetModes | orderBy:\'id\'\" ng-click=\"model.productcountOffsetMode=offsetMode.id\" ng-class=\"{\'active\':model.productcountOffsetMode==offsetMode.id && model.editProductcount}\" ng-disabled=!model.editProductcount>{{tools.lang(offsetMode)}}</button></div></div></div><div class=\"form-group clearfix\" ng-show=\"(tools.getLength(tools.exclude(tools.match(model.products,{\'prd\':\'VOU\'}),{\'hasQuantity\':false})))>0 && model.mode==\'edit\'\"><div class=col-sm-12><div class=checkbox><label><input type=checkbox ng-model=model.setVouchersToUsedAmount ng-disabled=\"model.editProductcount || model.setSelectedElementsToZero\"> {{tools.lang({\'en\':\'Invalidate remaining voucher balance\',\'nl\':\'Maak resterend vouchersaldo ongeldig\',\'fr\':\'Rendre le solde restant du voucher invalide\'})}}</label></div></div></div></span></form></div><div class=modal-footer><button class=\"btn btn-primary\" type=button ng-click=ok()>OK</button> <button class=\"btn btn-warning\" type=button ng-click=cancel()>Cancel</button></div>");
$templateCache.put("app/modules/vouchers/voucherList.html","<section ng-controller=VouchersVoucherListController class=\"page page-voucher-list page--tables\"><aside id=filters class=\"page__sidebar sidebar\"><div class=sidebar__header><h4 class=title>{{tools.lang({\'en\':\'Filters\',\'nl\':\'Filters\',\'fr\':\'Filtres\'})}}</h4><button class=\"btn btn-default btn-rounded\"><span class=material-icons ng-click=\"toggleFilters(\'filters\')\">close</span></button></div><div class=sidebar__content><form class=form-horizontal><div class=\"form-group clearfix\"><label class=\"col-sm-12 control-label\">{{tools.lang({\'en\':\'From\',\'nl\':\'Van\',\'fr\':\'De\'})}}</label><div class=col-sm-12><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.startdate is-open=model.startdateOpened datepicker-options=model.dateOptions ng-click=\"model.startdateOpened=!model.startdateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.startdateOpened=true\" style=\"margin-top: 0 !important\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"form-group clearfix\"><label class=\"col-sm-12 control-label\">{{tools.lang({\'en\':\'To\',\'nl\':\'Tot\',\'fr\':\'À\'})}}</label><div class=col-sm-12><p class=input-group><input type=text class=form-control uib-datepicker-popup ng-model=model.enddate is-open=model.enddateOpened datepicker-options=model.dateOptions ng-click=\"model.enddateOpened=!model.enddateOpened\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"model.enddateOpened=true\" style=\"margin-top: 0 !important\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><!--         <div class=\"form-group clearfix\">\n          <label class=\"col-sm-12 control-label\">\n            {{tools.lang({\'en\':\'Search on\',\'nl\':\'Zoeken op\',\'fr\':\'Chercher sur\'})}}\n          </label>\n          <div class=\"col-sm-12\">\n            <select class=\"form-control\" ng-model=\"model.searchMode\"\n                    ng-options=\"row.id as tools.lang(row) for row in model.searchModes\"\n                    ng-change=\"model.search=\'\'\">\n            </select>\n            <input type=\"text\" class=\"form-control\" ng-model=\"model.search\" ng-enter=\"load();\" placeholder=\"{{tools.lang({\'en\':\'Search\',\'nl\':\'Search\',\'fr\':\'Chercher\'})}}\" ng-hide=\"model.searchMode===\'none\'\"/>\n          </div>\n        </div> --><div class=\"form-group clearfix\"><label class=\"col-sm-12 control-label\">{{tools.lang({\'en\':\'Origin\',\'nl\':\'Origine\',\'fr\':\'Origine\'})}}</label><div class=col-sm-12><div class=btn-group><button type=button class=\"btn btn-default\" style=\"flex: 0 1 0; margin: 0 !important\" ng-repeat=\"vis in parameters.notDelArrayVIS | orderBy:\'id\'\" ng-click=selectOrigin(vis.id) ng-class=\"{\'active\':model.origins.indexOf(vis.id)>=0}\">{{tools.label(vis)}}</button></div></div></div><div class=\"form-group clearfix col-sm-12 col-md-2\"><label class=\"col-sm-12 control-label\">{{tools.lang({\'en\':\'Selected\',\'nl\':\'Geselecteerd\',\'fr\':\'S\\u00E9lectionn\\u00E9\'})}}</label><div class=col-sm-12><p class=form-control-static ng-hide=\"tools.getLength(model.origins)>0\">{{tools.lang({\'en\':\'All origins\',\'nl\':\'Alle origines\',\'fr\':\'Tous les origines\'})}}</p><div ng-show=\"tools.getLength(model.origins)>0\"><div class=btn-group><button type=button class=\"btn btn-default active\" ng-repeat=\"vis in model.origins | orderBy:\'toString()\'\" ng-click=selectOrigin(vis)>{{tools.label(parameters.VIS[vis])}}</button></div><button type=button class=\"btn btn-primary\" style=\"margin-top: 16px\" ng-click=\"model.origins=[];load()\">{{tools.lang({\'en\':\'All origins\',\'nl\':\'Alle origines\',\'fr\':\'Tous les origines\'})}}</button></div></div></div></form></div><div class=sidebar__footer><button type=submit class=\"btn btn-primary\" ng-click=\"load(); toggleFilters(\'filters\');\">{{tools.lang({\'en\':\'Done\',\'nl\':\'Done\',\'fr\':\'Appliquer\'})}}</button></div></aside><main role=main class=page__content><section class=\"content__header header\"><h1 class=header__title>{{tools.lang({\'en\':\'Voucher\',\'nl\':\'Geschenkbon\',\'fr\':\'Ch&#232;que cadeau\'})}}</h1><div class=header__actions><div class=\"page__actions hidden-xs hidden-sm\"><ul uib-pagination boundary-links=true boundary-link-numbers=true max-size=model.maxSize total-items=model.totalItems rotate=true force-ellipses=true items-per-page=model.itemsPerPage ng-change=setVoucherAmountCounts() ng-model=model.page class=pagination-sm previous-text=&lsaquo; next-text=&rsaquo; first-text=&laquo; last-text=&raquo; ng-show=\"model.totalItems>model.itemsPerPage\"></ul></div><input refresh ng-hide=model.loading ng-click=load();> <button class=\"btn btn-default btn-filters\" ng-click=\"toggleFilters(\'filters\')\"><i class=material-icons>filter_list</i> <span class=\"btn__text hidden-xs hidden-sm\">{{tools.lang({\'en\':\'Filters\',\'nl\':\'Filters\',\'fr\':\'Filtres\'})}}</span></button></div></section><div class=content><div class=content__noresult ng-show=\"!webservice.calling && !tools.getLength(model.visits)>0\"><div class=\"alert alert-info\" role=alert><p>{{tools.lang({\'en\':\'No results - Change filters\',\'nl\':\'Geen resultaten - Verander filters\',\'fr\':\'Aucun résultat - Affinez votre recherche\'})}}</p></div></div><div class=\"content__item c-table-view\" ng-hide=\"webservice.calling || tools.getLength(model.visits)==0\"><div class=c-table-view__item><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><thead><tr><th><div class=th__content style=width:100%>{{sortIndex=getSortIndex(\'clientName\');\"\"}} <span ng-click=\"sortBy(\'clientName\',$event)\">{{tools.lang({\'en\':\'Name\',\'nl\':\'Naam\',\'fr\':\'Nom\'})}} </span><span class=sortorder ng-show=\"sortIndex>=0\" ng-class=\"{reverse: model.sortings[sortIndex].reverse}\" ng-click=\"sortBy(\'clientName\',$event)\"></span> <span ng-show=\"tools.getLength(model.sortings)>1 && sortIndex>=0\">{{sortIndex+1}}</span> <span class=\"glyphicon glyphicon-filter\" ng-click=\"addFilter(\'clientName\')\"></span><div class=\"search-wrapper wrapper--xl\" style=width:100% ng-show=\"model.filters[\'clientName\']\"><span style=\"cursor: pointer\" class=material-icons ng-click=filterVisits()>search</span> <input type=text name=clientName class=form-control ng-model=\"model.filters[\'clientName\'].pattern\" ng-enter=filterVisits()></div></div></th><th ng-click=\"sortBy(\'created\',$event)\">{{sortIndex=getSortIndex(\'created\');\"\"}} <span class=th__content>{{tools.lang({\'en\':\'Created\',\'nl\':\'Aangemaakt\',\'fr\':\'Cr\\u00E9\\u00E9\'})}} <span class=sortorder ng-show=\"sortIndex>=0\" ng-class=\"{reverse: model.sortings[sortIndex].reverse}\"></span> <span ng-show=\"tools.getLength(model.sortings)>1 && sortIndex>=0\">{{sortIndex+1}}</span></span></th><th ng-show=\"tools.getLength(model.origins)!==1\" ng-click=\"sortBy(\'vis\',$event)\"><span class=th__content>{{sortIndex=getSortIndex(\'vis\');\"\"}} {{tools.lang({\'en\':\'Origin\',\'nl\':\'Origine\',\'fr\':\'Origine\'})}} <span class=sortorder ng-show=\"sortIndex>=0\" ng-class=\"{reverse: model.sortings[sortIndex].reverse}\"></span> <span ng-show=\"tools.getLength(model.sortings)>1 && sortIndex>=0\">{{sortIndex+1}}</span></span></th><th><span class=th__content>{{tools.lang({\'en\':\'Used\',\'nl\':\'Gebruikt\',\'fr\':\'Utilsé\'})}}</span></th><th><div class=th__content style=width:100%>{{tools.lang({\'en\':\'Amount\',\'nl\':\'Bedrag\',\'fr\':\'Montant\'})}} <span class=\"glyphicon glyphicon-filter\" ng-click=\"addFilter(\'amounts\',tools.amountIn)\"></span><div class=\"search-wrapper wrapper--xl\" style=width:100% ng-show=\"model.filters[\'amounts\']\"><span style=\"cursor: pointer\" class=material-icons ng-click=filterVisits()>search</span> <input type=text name=amounts class=form-control ng-model=\"model.filters[\'amounts\'].pattern\" ng-enter=filterVisits()></div></div></th><th><span class=th__content>{{tools.lang({\'en\':\'Status\',\'nl\':\'Status\',\'fr\':\'Statut\'})}}</span></th><th><div class=th__content style=width:100%>ID <span class=\"glyphicon glyphicon-filter\" ng-click=\"addFilter(\'voucherIds\',tools.voucheridOut)\"></span><br><div class=\"search-wrapper wrapper--xl\" style=width:100% ng-show=\"model.filters[\'voucherIds\']\"><span style=\"cursor: pointer\" class=material-icons ng-click=filterVisits()>search</span> <input type=text name=voucherIds class=form-control ng-model=\"model.filters[\'voucherIds\'].pattern\" ng-enter=filterVisits()></div></div></th><th><div class=th__content style=width:100%>{{tools.lang({\'en\':\'Comment\',\'nl\':\'Opmerking\',\'fr\':\'Remarque\'})}} <span class=\"glyphicon glyphicon-filter\" ng-click=\"addFilter(\'comment\')\"></span><div class=\"search-wrapper wrapper--xl\" style=width:100% ng-show=\"model.filters[\'comment\']\"><span style=\"cursor: pointer\" class=material-icons ng-click=filterVisits()>search</span> <input type=text name=amounts class=form-control ng-model=\"model.filters[\'comment\'].pattern\" ng-enter=filterVisits()></div></div></th><th><span class=th__content>{{tools.lang({\'en\':\'Export\',\'nl\':\'Export\',\'fr\':\'Export\'})}}</span></th></tr></thead><tbody><tr ng-repeat=\"visit in tools.startFrom(model.orderedVisits,(model.page-1)*model.itemsPerPage) | limitTo:model.itemsPerPage\"><td ng-click=visitRetrieve(visit.id);>{{visit.clientName}}</td><td ng-click=visitRetrieve(visit.id);>{{tools.doneBy(visit.created,visit.creator_name)}}</td><td ng-click=visitRetrieve(visit.id); ng-show=\"tools.getLength(model.origins)!==1\">{{tools.label(parameters.VIS[visit.vis])}}</td><td ng-click=visitRetrieve(visit.id);><span ng-repeat=\"amountCount in getVoucherAmountCounts(visit)\">{{amountCount.used+\'/\'+amountCount.count}}<br></span></td><td ng-click=visitRetrieve(visit.id);><span ng-repeat=\"amountCount in getVoucherAmountCounts(visit)\">{{tools.amountOut(amountCount.amount)}}<br></span></td><td ng-click=visitRetrieve(visit.id);>{{tools.label(activitiesService.convertStat(visit.stat,null))}}</td><td><span class=ellipsis title={{visit.voucherIds}} data-toggle=tooltip data-placement=top tooltip>{{visit.voucherIds}}</span></td><td><span ng-hide=visit.editing><span class=\"comment ellipsis\" title={{visit.comment}} data-toggle=tooltip data-placement=top tooltip>{{visit.comment}}</span> <input edit class=\"btn btn-default btn-rounded\" ng-click=editComment(visit)> </span><span ng-show=visit.editing><form><input type=text class=form-control ng-model=visit.comment> <input class=\"btn btn-success\" update ng-click=updateComment(visit)> <input class=\"btn btn-warning\" cancel ng-click=cancelComment(visit)></form></span></td><td><form action={{model.action}} name=vouchers autocomplete=off method=post target=_blank><input type=hidden name=params value={{getVouchersWsParams(visit)}}> <input download></form></td></tr></tbody></table></div></div></div><div class=\"content__item page__loader\" ng-show=webservice.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div></div><div class=\"page__actions hidden-md hidden-lg hidden-xl\" ng-show=\"model.totalItems>model.itemsPerPage\"><ul uib-pagination boundary-links=true boundary-link-numbers=true max-size=model.maxSize total-items=model.totalItems rotate=true force-ellipses=true items-per-page=model.itemsPerPage ng-model=model.page class=pagination-sm previous-text=&lsaquo; next-text=&rsaquo; first-text=&laquo; last-text=&raquo;></ul></div></main></section>");
$templateCache.put("app/modules/hotels/splitBill/contactModal.html","<div class=modal-body id=modal-body><div outdoor-contact model=model contact-name=owning contact-wording=\"tools.lang({\'en\':\'Client\',\'nl\':\'Klant\',\'fr\':\'Client\'})\" on-update=\"\" contact-is-editable=false contact-is-changeable=true contact-retrieve=contactRetrieve></div><div outdoor-contact model=model contact-name=communication contact-wording=\"tools.lang({\'en\':\'Contact\',\'nl\':\'Contactpersoon\',\'fr\':\'Contact\'})\" on-update=\"\" contact-is-editable=false contact-is-changeable=true contact-retrieve=contactRetrieve></div></div><div class=modal-footer><button class=\"btn btn-primary\" type=button ng-click=ok()>Ok</button> <button class=\"btn btn-warning\" type=button ng-click=cancel()>{{tools.lang({\'en\':\'Cancel\',\'nl\':\'Annuleer\',\'fr\':\'Annuler\'})}}</button></div>");
$templateCache.put("app/modules/hotels/splitBill/itemsComponent.html","<ul class=list-group dnd-list=\"\" dnd-effect-allowed=move dnd-drop=$ctrl.drop(item) dnd-allowed-types=\"[\'visitElement\']\"><li class=list-group-item ng-class=\"{\'list-group-item-success\':visitElement.selected}\" ng-repeat=\"visitElement in $ctrl.getVisitElements() | orderBy:$ctrl.getVisitElementCompareString\" dnd-draggable=visitElement dnd-type=\"\'visitElement\'\" dnd-effect-allowed=move dnd-selected=$ctrl.selectVisitElement(event,visitElement)><div class=row><div class=col-xs-10><div class=row ng-repeat=\"accountingItem in $ctrl.splitBillService.getVisitElementItems(visitElement,$ctrl.model) | orderBy:$ctrl.getItemCompareString\"><div class=col-xs-8><span class=pull-left ng-show=$first>{{$ctrl.accountingService.getItemDescriptionDatetime(accountingItem,$ctrl.model)}}</span> <span class=pull-right>{{$ctrl.accountingService.getItemDescriptionWording(accountingItem,$ctrl.model)}}</span></div><div class=col-xs-4>{{accountingItem.quantity+\'x \'+$ctrl.tools.amountOut(accountingItem.nettopay==0.0?0.0:$ctrl.tools.round(accountingItem.nettopay/accountingItem.quantity,2))+\'\\u20AC = \'}} <strong>{{$ctrl.tools.amountOut(accountingItem.nettopay)+\'\\u20AC\'}}</strong></div></div></div><div class=col-xs-2><button type=button class=\"btn btn-default\" ng-click=$ctrl.splitVisitElementInItemsComponent(visitElement)><span class=\"glyphicon glyphicon-resize-full\"></span> &nbsp;{{$ctrl.tools.lang({\'en\':\'split\',\'nl\':\'splits\',\'fr\':\'split\'})}}</button></div></div></li><li class=list-group-item ng-show=\"$ctrl.getVisitElements().length===0\"><div class=row><div class=col-xs-12>{{$ctrl.tools.lang({\'en\':\'Drop element here\',\'nl\':\'Plaats hier een element\',\'fr\':\'D\\u00E9posez un \\u00E9l\\u00E9ment ici\'})}} <span ng-show=\"$ctrl.visit===undefined || $ctrl.visit===null\">{{$ctrl.tools.lang({\'en\':\' or \',\'nl\':\' of \',\'fr\':\' ou \'})}} <button type=button class=\"btn btn-default\" ng-click=\"$ctrl.drop({\'visit\':$ctrl.model.visit.id})\">{{$ctrl.tools.lang({\'en\':\'link\',\'nl\':\'koppel\',\'fr\':\'liez\'})}}</button> {{$ctrl.tools.lang({\'en\':\' visitor\',\'nl\':\' een bezoeker\',\'fr\':\' un visiteur\'})}}</span></div></div></li></ul>");
$templateCache.put("app/modules/hotels/splitBill/splitBill.html","<section ng-controller=HotelsSplitBillController class=\"page page--content\"><div class=row><div class=col-sm-6><div class=\"panel panel-default\"><div class=panel-body><h4>{{contactsService.getName(model.contacts[model.visit.owningcontact])}} <button retrieve ng-click=visitRetrieve(model.visit.id);></button></h4><split-bill-items-component visit=model.visit hotelspaceassignment=\"\" model=model transfer-items=transferItems split-visit-element=splitVisitElement></split-bill-items-component></div></div></div><div class=col-sm-6><div class=\"panel panel-default\"><div class=panel-body><ul class=list-group dnd-list=\"\" dnd-effect-allowed=move dnd-drop=\"updateHotelspaceassignmentVisit(item,{\'assignedspace\':\'0\'})\" dnd-allowed-types=\"[\'visitrelation\']\"><li class=list-group-item dnd-type=\"\'visitrelation\'\" dnd-effect-allowed=move dnd-disable-if=true><h4>{{tools.lang({\'en\':\'Create seperate bill\',\'nl\':\'Maak een aparte factuur aan\',\'fr\':\'Cr\\u00E9er une facture s\\u00E9par\\u00E9e\'})}}</h4><split-bill-items-component visit=\"\" hotelspaceassignment=\"\" model=model transfer-items=transferItems></split-bill-items-component></li></ul></div></div><div class=\"panel panel-default\" ng-repeat=\"hotelspace in model.hotelspaces\">{{visitrelations=tools.match(model.visitrelations,{\'hotelspace\':hotelspace.id});hotelspaceassignment=tools.getLength(tools.match(model.hotelspaceassignments,{\'assignedspace\':hotelspace.id}))>0?tools.first(tools.match(model.hotelspaceassignments,{\'assignedspace\':hotelspace.id})):dummyHotelspaceassignment;isLinkedRoom=!hotelspaceassignment.isDummy;\"\";}}<div class=panel-body><p ng-show=!isLinkedRoom>{{tools.lang({\'en\':\'This bill is not linked to an existing space in this visit.\',\'nl\':\'Deze factuur is niet gekoppeld aan een bestaande ruimte tijdens dit bezoek.\',\'fr\':\"Cette facture n\'est pas li\\u00E9e à un espace existant lors de cette visite.\"})}}</p><ul class=list-group dnd-list=visitrelations dnd-effect-allowed=move dnd-drop=updateHotelspaceassignmentVisit(item,hotelspaceassignment) dnd-allowed-types=\"[\'visitrelation\',\'visitElement\']\" dnd-dragover=onDragOver(index,external,type,hotelspace)><li class=list-group-item ng-class=\"{\'list-group-item-success\':visitrelation.selected}\" ng-repeat=\"visitrelation in (tools.getLength(visitrelations)>0?visitrelations:tools.addElement(visitrelations,dummyVisitrelation))\" dnd-draggable=visitrelation dnd-type=\"\'visitrelation\'\" dnd-effect-allowed=move dnd-selected=selectVisitrelation(event,visitrelation) dnd-disable-if=visitrelation.isDummy>{{childVisit=model.visits[visitrelation.visitb];\"\";}}<h4>{{getChildHeading(childVisit,hotelspace)}} <button retrieve ng-if=\"childVisit!==null\" ng-click=visitRetrieve(childVisit.id);></button> <button class=\"btn btn-danger\" delete ng-if=\"childVisit!==null && visitrelation.isDeletable\" ng-click=deleteVisitrelation(visitrelation);></button></h4><split-bill-items-component visit=childVisit hotelspaceassignment=hotelspaceassignment model=model transfer-items=transferItems split-visit-element=splitVisitElement></split-bill-items-component></li><li class=list-group-item ng-show=\"hotelspace.showCreateVisitrelation && isLinkedRoom && tools.getLength(visitrelations)>0\"><h4>{{tools.lang({\'en\':\'Create extra bill for \',\'nl\':\'Maak extra factuur voor \',\'fr\':\'+ Cr\\u00E9er une facture suppl\\u00E9mentaire pour \'})+parameters.HSC[hotelspace.hsc].field5+\' \'+hotelspace.spacenumber}}</h4><split-bill-items-component visit=\"\" hotelspaceassignment=hotelspaceassignment model=model transfer-items=transferItems></split-bill-items-component></li></ul></div></div><div class=\"panel panel-default\" ng-repeat=\"visitrelation in tools.match(model.visitrelations,{\'hotelspace\':\'0\'})\">{{childVisit=model.visits[visitrelation.visitb];\"\";}}<div class=panel-body><ul class=list-group dnd-list=visitrelations dnd-effect-allowed=move dnd-drop=\"updateHotelspaceassignmentVisit(item,{\'assignedspace\':\'0\'})\" dnd-allowed-types=\"[\'visitrelation\']\"><li class=list-group-item ng-class=\"{\'list-group-item-success\':visitrelation.selected}\" dnd-draggable=visitrelation dnd-type=\"\'visitrelation\'\" dnd-effect-allowed=move dnd-selected=selectVisitrelation(event,visitrelation) dnd-disable-if=visitrelation.isDummy><h4>{{getChildHeading(childVisit);}} <button retrieve ng-click=visitRetrieve(childVisit.id);></button> <button class=\"btn btn-danger\" delete ng-if=\"childVisit!==null && visitrelation.isDeletable\" ng-click=deleteVisitrelation(visitrelation);></button></h4><split-bill-items-component visit=childVisit hotelspaceassignment=\"\" model=model transfer-items=transferItems split-visit-element=splitVisitElement></split-bill-items-component></li></ul></div></div></div></div></section>");
$templateCache.put("app/modules/hotels/splitBill/splitModal.html","<div class=modal-body id=modal-body><div class=\"panel panel-default\" ng-show=\"tools.getLength(tools.match(items,{\'pricecalc\':accountingService.ITEM_PRICECALC_REVERSE}))===0\"><div class=panel-heading>{{tools.lang({\'en\':\'Split on quantity\',\'nl\':\'Hoeveelheid opsplitsen\',\'fr\':\'Diviser par quantit\\u00E9\'})}}</div><div class=panel-body><div class=row ng-repeat=\"item in items\"><div class=col-xs-6>{{accountingService.getItemDescriptionWording(item,model)}}</div><div class=col-xs-3>#{{item.quantity-splitDistributionQuantity[item.id]}}</div><div class=col-xs-3><input type=text autocomplete=off class=form-control ng-model=splitDistributionQuantity[item.id]></div></div><br><div class=pull-right><button class=\"btn btn-primary\" type=button ng-click=\"split(\'quantity\')\">{{tools.lang({\'en\':\'Split on quantity\',\'nl\':\'Hoeveelheid opsplitsen\',\'fr\':\'Diviser par quantit\\u00E9\'})}}</button></div></div></div><div class=\"panel panel-default\"><div class=panel-heading>{{tools.lang({\'en\':\'Split on price\',\'nl\':\'Prijs opsplitsen\',\'fr\':\'Diviser par prix\'})}}</div><div class=panel-body><div class=row ng-repeat=\"item in items\"><div class=col-xs-6>{{accountingService.getItemDescriptionWording(item,model)}}</div><div class=col-xs-3>{{item.nettopay-splitDistributionNettopay[item.id]}} €</div><div class=col-xs-3><input type=text autocomplete=off class=form-control ng-model=splitDistributionNettopay[item.id]></div></div><br><div class=pull-right><button class=\"btn btn-primary\" type=button ng-click=\"split(\'nettopay\')\">{{tools.lang({\'en\':\'Split on price\',\'nl\':\'Prijs opsplitsen\',\'fr\':\'Diviser par prix\'})}}</button></div></div></div></div><div class=modal-footer><button class=\"btn btn-warning\" type=button ng-click=cancel()>{{tools.lang({\'en\':\'Cancel\',\'nl\':\'Annuleer\',\'fr\':\'Annuler\'})}}</button></div>");
$templateCache.put("app/modules/accountingIntegration/adfinity/errors.html","<div ng-controller=AccountingIntegrationAdfinityErrorsController id=AccountingIntegrationAdfinityErrors class=\"page page-accountin-invoices page--tables\"><main role=main class=page__content><section class=\"content__header header\" id=header><h1 class=header__title>{{tools.lang({\'en\':\'Errors\',\'nl\':\'Fouten\',\'fr\':\'Erreurs\'})}}</h1><div class=header__actions><input refresh ng-hide=model.loading ng-click=load();></div></section><div class=content><div class=\"content__item c-table-view\" ng-hide=\"webservice.calling || (tools.getLength(getErroneousInvoices())==0 && tools.getLength(model.movements)==0 && tools.getLength(model.exactentries)==0 && tools.getLength(model.exactmatchsets)==0 && tools.getLength(model.exactmessages)==0 && tools.getLength(model.intercompanies)==0)\"><div class=c-table-view__item><div class=c-table-view__item__content id=invoices><h4 class=c-table-view__title>{{tools.lang({\'en\':\'Invoices\',\'nl\':\'Facturen\',\'fr\':\'Factures\'})}}</h4><div class=table-responsive-wrapper ng-show=\"tools.getLength(getErroneousInvoices())>0\"><table class=\"table table-striped table-hover\"><thead><tr><th><span class=th__content></span></th><th><span class=th__content>{{tools.lang({\'en\':\'Name\',\'nl\':\'Naam\',\'fr\':\'Nom\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Origin\',\'nl\':\'Oorsprong\',\'fr\':\'Cause\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Created\',\'nl\':\'Aangemaakt\',\'fr\':\'Cr\\u00E9\\u00E9\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Amount\',\'nl\':\'Bedrag\',\'fr\':\'Montant\'})}}</span></th><th colspan=2><span class=th__content>{{tools.lang({\'en\':\'Error\',\'nl\':\'Fout\',\'fr\':\'Erreur\'})}}</span></th></tr></thead><tbody><tr ng-repeat=\"invoice in getErroneousInvoices() | orderBy:\'created\'\"><td><form action={{model.action}} id=\"{{\'invoices_\'+$index}}\" autocomplete=off method=post target=_blank class=form-horizontal><input type=hidden name=params value={{getInvoiceWsParams(invoice)}}> <button type=submit class=\"btn btn-default\"><span class=\"glyphicon glyphicon-print\"></span></button> <button ng-show=\"invoice.visit!=0\" retrieve ng-click=visitRetrieve(model.visits[invoice.visit].id);></button></form></td><td><span ng-show=\"invoice.visit!=\'0\'\">{{visitsService.getName(model.contacts[model.visits[invoice.visit].owningcontact],model.visits[invoice.visit])}}</span> <span ng-show=\"invoice.visit==\'0\'\">{{tools.label(parameters.DVS[invoice.dvs])}}</span></td><td>{{invoice.inv}}</td><td>{{tools.dateOut(invoice.created)}}</td><td>{{tools.amountOut(invoice.amount)}}</td><td style=\"white-space: pre-line\">{{invoice.errorwording.replaceAll(\'\\\\n\',\'\\n\')}}</td><td><button refresh ng-click=retryInvoice(invoice)></button></td></tr></tbody></table></div><form class=form-horizontal><div class=\"form-group clearfix\"><label class=\"col-md-2 control-label\" id=resetInvoice>{{tools.lang({\'en\':\'Invoice ID\',\'nl\':\'Factuur ID\',\'fr\':\'ID facture\'})}}</label><div class=col-md-2><div class=input-group><input type=text autocomplete=off class=form-control ng-model=model.invoiceId placeholder=123456><div class=input-group-btn><button class=\"btn btn-default\" ng-click=resetInvoice(model.invoiceId)>{{tools.lang({\'en\':\'Credit\',\'nl\':\'Crediteer\',\'fr\':\'Créditer\'})}}</button></div></div></div><label ng-hide=\"errorMessage===null\" class=\"col-md-2 control-label\"><p>{{tools.lang({\'en\':\'Error: \',\'nl\':\'Fout: \',\'fr\':\'Erreur : \'})}}{{errorMessage}}</p></label></div></form></div><div class=c-table-view__item__content id=movements ng-show=\"tools.getLength(model.movements)>0\"><h4 class=c-table-view__title>{{tools.lang({\'en\':\'Payments\',\'nl\':\'Betalingen\',\'fr\':\'Paiements\'})}}</h4><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><thead><tr><th><span class=th__content></span></th><th><span class=th__content>{{tools.lang({\'en\':\'Name\',\'nl\':\'Naam\',\'fr\':\'Nom\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Created\',\'nl\':\'Aangemaakt\',\'fr\':\'Cr\\u00E9\\u00E9\'})}}</span></th><th colspan=2><span class=th__content>{{tools.lang({\'en\':\'Amount\',\'nl\':\'Bedrag\',\'fr\':\'Montant\'})}}</span></th></tr></thead><tbody><tr ng-repeat=\"movement in tools.toArray(model.movements) | orderBy:\'created\'\" id=\"{{\'movements_\'+$index}}\"><td><button retrieve ng-click=visitRetrieve(model.visits[movement.visit].id);></button></td><td>{{visitsService.getName(model.contacts[model.visits[movement.visit].owningcontact],model.visits[movement.visit])}}</td><td>{{tools.dateOut(movement.created)}}</td><td>{{tools.amountOut(movement.amount)}}</td><td><button class=\"btn btn-default\" ng-click=retryMovements(movement)>{{tools.lang({\'en\':\'Retry date \',\'nl\':\'Opnieuw datum \',\'fr\':\'R\\u00E9essayer date \'})+\' \'+tools.dateOut(movement.created)}}</button></td></tr></tbody></table></div></div><div class=c-table-view__item__content><h4 class=c-table-view__title>{{tools.lang({\'en\':\'General entries\',\'nl\':\'Algemene operaties\',\'fr\':\'Operations diversives\'})}}</h4><div class=table-responsive-wrapper ng-show=\"tools.getLength(getErroneousExactentries())>0\"><table class=\"table table-striped table-hover\"><thead><tr><th><span class=th__content style=\"justify-content: center\"><input type=checkbox id=exactentries ng-model=model.selectedAllExactentries checkbox-all child-list=getErroneousExactentries() property=selected></span></th><th><span class=th__content>{{tools.lang({\'en\':\'Date\',\'nl\':\'Datum\',\'fr\':\'Date\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Division\',\'nl\':\'Afdeling\',\'fr\':\'Division\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Payment method\',\'nl\':\'Betaalmethode\',\'fr\':\'Moyen de paiement\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Error\',\'nl\':\'Fout\',\'fr\':\'Erreur\'})}}</span></th><th><span class=th__content><span ng-show=\"tools.getLength(tools.match(model.exactentries,{\'selected\':true}))>0\">{{tools.lang({\'en\':\'Selection\',\'nl\':\'Selectie\',\'fr\':\'S\\u00E9lection\'})}}&nbsp; <button refresh class=\"btn btn-default\" ng-click=retrySelectedExactentries()></button></span></span></th></tr></thead><tbody><tr ng-repeat=\"exactentry in getErroneousExactentries() | orderBy:\'date\'\" id=\"{{\'exactentries_\'+$index}}\"><td class=text-center><input type=checkbox ng-model=exactentry.selected></td><td>{{tools.dateOut(exactentry.date)}}</td><td>{{tools.label(parameters.DVS[exactentry.dvs])}}</td><td><span ng-show=\"exactentry.mth==\'TERMINAL\'\">{{tools.lang({\'en\':\'Terminal\',\'nl\':\'Terminal\',\'fr\':\'Terminal\'})}}</span> <span ng-hide=\"exactentry.mth==\'TERMINAL\'\">{{tools.label(parameters.MTH[exactentry.mth])}}</span> <span ng-hide=\"exactentry.res==\'\'\">{{tools.label(parameters.RES[exactentry.res])}}</span></td><td style=\"white-space: pre-line\">{{exactentry.errorwording.replaceAll(\'\\\\n\',\'\\n\')}}</td><td><button refresh ng-click=retryExactentry(exactentry)></button></td></tr></tbody></table></div><form class=form-horizontal><div class=\"form-group clearfix\"><label class=\"col-md-2 control-label\" id=resetExactentry>{{tools.lang({\'en\':\'General Entry ID\',\'nl\':\'Algemene operatie ID\',\'fr\':\'ID Operation diverse\'})}}</label><div class=col-md-2><div class=input-group><input type=text autocomplete=off class=form-control ng-model=model.exactentryId placeholder=ENT123456><div class=input-group-btn><button class=\"btn btn-default\" ng-click=resetExactentry(model.exactentryId)>{{tools.lang({\'en\':\'Credit\',\'nl\':\'Crediteer\',\'fr\':\'Créditer\'})}}</button></div></div></div><label ng-hide=\"errorMessage===null\" class=\"col-md-2 control-label\"><p>{{tools.lang({\'en\':\'Error: \',\'nl\':\'Fout: \',\'fr\':\'Erreur : \'})}}{{errorMessage}}</p></label></div></form></div><div class=c-table-view__item__content id=exactmatchsets ng-show=\"tools.getLength(model.exactmatchsets)>0\"><h4 class=c-table-view__title>{{tools.lang({\'en\':\'Reconciliation\',\'nl\':\'Afpunten\',\'fr\':\'Lettrage\'})}}</h4><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><thead><tr><th><span class=th__content style=\"justify-content: center\"><input type=checkbox id=exactmatchsets_selector ng-model=model.selectedAllExactmatchsets checkbox-all child-list=model.exactmatchsets property=selected></span></th><th><span class=th__content>{{tools.lang({\'en\':\'Name\',\'nl\':\'Naam\',\'fr\':\'Nom\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Error\',\'nl\':\'Fout\',\'fr\':\'Erreur\'})}}</span></th><th><span class=th__content><span ng-show=\"tools.getLength(tools.match(model.exactmatchsets,{\'selected\':true}))>0\">{{tools.lang({\'en\':\'Selection\',\'nl\':\'Selectie\',\'fr\':\'S\\u00E9lection\'})}}&nbsp; <button delete class=\"btn btn-danger\" ng-click=ignoreSelectedExactmatchsets()></button> <button refresh class=\"btn btn-default\" ng-click=retrySelectedExactmatchsets()></button></span></span></th></tr></thead><tbody><tr ng-repeat=\"exactmatchset in tools.toArray(model.exactmatchsets) | orderBy:\'updated\'\"><td class=text-center><input type=checkbox id=\"{{\'exactmatchsets_\'+$index}}\" ng-model=exactmatchset.selected> <button retrieve ng-show=\"exactmatchset.visit!==\'0\'\" ng-click=visitRetrieve(model.visits[exactmatchset.visit].id);></button></td><td>{{visitsService.getName(model.contacts[model.visits[exactmatchset.visit].owningcontact],model.visits[exactmatchset.visit])}}</td><td style=\"white-space: pre-line\">{{exactmatchset.errorwording.replaceAll(\'\\\\n\',\'\\n\')}}</td><td><button delete class=\"btn btn-danger\" ng-click=ignoreExactmatchset(exactmatchset)></button> <button refresh class=\"btn btn-default\" ng-click=retryExactmatchset(exactmatchset)></button></td></tr></tbody></table></div></div><div class=c-table-view__item__content ng-show=\"tools.getLength(model.exactmessages)>0\"><h4 class=c-table-view__title>Bank&nbsp; <button refresh ng-click=retryExactmessages()></button></h4><div class=table-responsive-wrapper><table class=\"table table-striped table-hover\"><thead><tr><th><span class=th__content style=\"justify-content: center\"><input type=checkbox id=exactmessages ng-model=model.selectedAllExactmessages checkbox-all child-list=model.exactmessages property=selected></span></th><th><span class=th__content>{{tools.lang({\'en\':\'Code\',\'nl\':\'Code\',\'fr\':\'Code\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Topic\',\'nl\':\'Topic\',\'fr\':\'Topic\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Division\',\'nl\':\'Afdeling\',\'fr\':\'Division\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Error\',\'nl\':\'Fout\',\'fr\':\'Erreur\'})}}</span></th><th><span class=th__content><span ng-show=\"tools.getLength(tools.match(model.exactmessages,{\'selected\':true}))>0\">{{tools.lang({\'en\':\'Selection\',\'nl\':\'Selectie\',\'fr\':\'S\\u00E9lection\'})}}&nbsp; <button refresh ng-click=retrySelectedExactmessages()></button> <button delete class=\"btn btn-danger\" ng-click=deleteSelectedExactmessages()></button></span></span></th></tr></thead><tbody><tr ng-repeat=\"exactmessage in tools.toArray(model.exactmessages) | orderBy:\'updated\'\" id=\"{{\'exactmessages_\'+$index}}\"><td class=text-center><input type=checkbox id=\"{{\'exactmessages_\'+$index}}\" ng-model=exactmessage.selected> <button retrieve ng-show=\"exactmatchset.visit!==\'0\'\" ng-click=visitRetrieve(model.visits[exactmatchset.visit].id);></button></td><td>{{getExactmessageExactid(exactmessage)}}</td><td>{{getExactmessageTopic(exactmessage)}}</td><td>{{getExactmessageDivision(exactmessage)}}</td><td style=\"white-space: pre-line\">{{exactmessage.errorwording.replaceAll(\'\\\\n\',\'\\n\')}}</td><td><button refresh ng-click=retryExactmessage(exactmessage)></button> <button delete class=\"btn btn-danger\" ng-click=deleteExactmessage(exactmessage)></button></td></tr></tbody></table></div></div><div class=c-table-view__item__content id=intercompanies><h4 class=c-table-view__title>Intercompany</h4><div class=table-responsive-wrapper ng-show=\"tools.getLength(getErroneousIntercompanies())>0\"><table class=\"table table-striped table-hover\"><thead><tr><th><span class=th__content>{{tools.lang({\'en\':\'Date\',\'nl\':\'Datum\',\'fr\':\'Date\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Buyer\',\'nl\':\'Koper\',\'fr\':\'Acheteur\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Supplier\',\'nl\':\'Leverancier\',\'fr\':\'Fournisseur\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Step\',\'nl\':\'Stap\',\'fr\':\'Etape\'})}}</span></th><th><span class=th__content>{{tools.lang({\'en\':\'Error\',\'nl\':\'Fout\',\'fr\':\'Erreur\'})}}</span></th><th><span class=th__content><button refresh ng-click=retryIntercompanies()></button></span></th></tr></thead><tbody><tr ng-repeat=\"intercompany in getErroneousIntercompanies() | orderBy:\'invoicedate\'\" id=\"{{\'intercompanies_\'+$index}}\"><td>{{intercompany.invoicedate}}</td><td>{{tools.label(parameters.DVS[intercompany.customerdvs])}}</td><td>{{tools.label(parameters.DVS[intercompany.supplierdvs])}}</td><td>{{getIntercompanyErrorStep(intercompany)}}</td><td style=\"white-space: pre-line\">{{intercompany.errorwording.replaceAll(\'\\\\n\',\'\\n\')}}</td><td><button refresh ng-click=retryIntercompany(intercompany)></button></td></tr></tbody></table></div><form class=form-horizontal><div class=\"form-group clearfix\"><label class=\"col-md-2 control-label\" id=resetIntercompany>{{tools.lang({\'en\':\'Intercompany ID\',\'nl\':\'Intercompany ID\',\'fr\':\'ID Intercompany\'})}}</label><div class=col-md-2><div class=input-group><input type=text autocomplete=off class=form-control ng-model=model.intercompanyId placeholder=IC123456><div class=input-group-btn><button class=\"btn btn-default\" ng-click=resetIntercompany(model.intercompanyId)>{{tools.lang({\'en\':\'Credit\',\'nl\':\'Crediteer\',\'fr\':\'Créditer\'})}}</button></div></div></div><label ng-hide=\"errorMessage===null\" class=\"col-md-2 control-label\"><p>{{tools.lang({\'en\':\'Error: \',\'nl\':\'Fout: \',\'fr\':\'Erreur : \'})}}{{errorMessage}}</p></label></div></form></div></div></div><div class=\"content__item page__loader\" ng-show=webservice.calling><div class=lds-ring><div></div><div></div><div></div><div></div></div></div><div class=content__noresult ng-show=\"!webservice.calling && tools.getLength(getErroneousInvoices())==0 && tools.getLength(model.movements)==0 && tools.getLength(model.exactentries)==0 && tools.getLength(model.exactmatchsets)==0 && tools.getLength(model.exactmessages)==0 && tools.getLength(model.intercompanies)==0\"><div ng-show=\"errorMessage===null\" class=\"alert alert-info\" role=alert><p>{{tools.lang({\'en\':\'No errors. Everything is sent to Exact\',\'nl\':\'Geen fouten. Alles is verstuurd naar Exact\',\'fr\':\'Aucune erreur. Tout est envoy\\u00E9 vers Exact.\'})}}</p></div><div ng-hide=\"errorMessage===null\" class=\"alert alert-danger\" role=alert><p>{{errorMessage}}</p></div></div></div></main></div>");}]);